/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
(function (global, factory) {
  /* global define, require, module */

  /* AMD */ if (typeof define === "function" && define.amd)
    define(["protobufjs/minimal"], factory);
  /* CommonJS */ else if (
    typeof require === "function" &&
    typeof module === "object" &&
    module &&
    module.exports
  )
    module.exports = factory(require("protobufjs/minimal"));
})(this, function ($protobuf) {
  "use strict";

  // Common aliases
  var $Reader = $protobuf.Reader,
    $Writer = $protobuf.Writer,
    $util = $protobuf.util;

  // Exported root namespace
  var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

  $root.stronachgroup = (function () {
    /**
     * Namespace stronachgroup.
     * @exports stronachgroup
     * @namespace
     */
    var stronachgroup = {};

    stronachgroup.first = (function () {
      /**
       * Namespace first.
       * @memberof stronachgroup
       * @namespace
       */
      var first = {};

      first.extensions = (function () {
        /**
         * Namespace extensions.
         * @memberof stronachgroup.first
         * @namespace
         */
        var extensions = {};

        extensions.TopicOptions = (function () {
          /**
           * Properties of a TopicOptions.
           * @memberof stronachgroup.first.extensions
           * @interface ITopicOptions
           * @property {string|null} [topicName] TopicOptions topicName
           * @property {stronachgroup.first.extensions.TopicKeyType|null} [keyType] TopicOptions keyType
           * @property {string|null} [keyDescription] TopicOptions keyDescription
           * @property {boolean|null} [partitioned] TopicOptions partitioned
           * @property {stronachgroup.first.extensions.TopicCompressionType|null} [compressionType] TopicOptions compressionType
           * @property {stronachgroup.first.extensions.TopicCleanupPolicy|null} [cleanupPolicy] TopicOptions cleanupPolicy
           * @property {number|Long|null} [deleteRetentionMs] TopicOptions deleteRetentionMs
           * @property {number|Long|null} [retentionBytes] TopicOptions retentionBytes
           * @property {number|Long|null} [retentionMs] TopicOptions retentionMs
           * @property {boolean|null} [singletonOnAllNamespaces] TopicOptions singletonOnAllNamespaces
           * @property {boolean|null} [protobufDeserializerUseDeprecatedFormat] TopicOptions protobufDeserializerUseDeprecatedFormat
           * @property {string|null} [topicPrefix] TopicOptions topicPrefix
           * @property {number|null} [minimumPartitions] TopicOptions minimumPartitions
           */

          /**
           * Constructs a new TopicOptions.
           * @memberof stronachgroup.first.extensions
           * @classdesc Represents a TopicOptions.
           * @implements ITopicOptions
           * @constructor
           * @param {stronachgroup.first.extensions.ITopicOptions=} [properties] Properties to set
           */
          function TopicOptions(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TopicOptions topicName.
           * @member {string} topicName
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.topicName = "";

          /**
           * TopicOptions keyType.
           * @member {stronachgroup.first.extensions.TopicKeyType} keyType
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.keyType = 0;

          /**
           * TopicOptions keyDescription.
           * @member {string} keyDescription
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.keyDescription = "";

          /**
           * TopicOptions partitioned.
           * @member {boolean} partitioned
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.partitioned = false;

          /**
           * TopicOptions compressionType.
           * @member {stronachgroup.first.extensions.TopicCompressionType} compressionType
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.compressionType = 0;

          /**
           * TopicOptions cleanupPolicy.
           * @member {stronachgroup.first.extensions.TopicCleanupPolicy} cleanupPolicy
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.cleanupPolicy = 0;

          /**
           * TopicOptions deleteRetentionMs.
           * @member {number|Long} deleteRetentionMs
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.deleteRetentionMs = $util.Long
            ? $util.Long.fromBits(0, 0, false)
            : 0;

          /**
           * TopicOptions retentionBytes.
           * @member {number|Long} retentionBytes
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.retentionBytes = $util.Long
            ? $util.Long.fromBits(0, 0, false)
            : 0;

          /**
           * TopicOptions retentionMs.
           * @member {number|Long} retentionMs
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.retentionMs = $util.Long
            ? $util.Long.fromBits(0, 0, false)
            : 0;

          /**
           * TopicOptions singletonOnAllNamespaces.
           * @member {boolean} singletonOnAllNamespaces
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.singletonOnAllNamespaces = false;

          /**
           * TopicOptions protobufDeserializerUseDeprecatedFormat.
           * @member {boolean} protobufDeserializerUseDeprecatedFormat
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.protobufDeserializerUseDeprecatedFormat = false;

          /**
           * TopicOptions topicPrefix.
           * @member {string} topicPrefix
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.topicPrefix = "";

          /**
           * TopicOptions minimumPartitions.
           * @member {number} minimumPartitions
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           */
          TopicOptions.prototype.minimumPartitions = 0;

          /**
           * Creates a new TopicOptions instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @static
           * @param {stronachgroup.first.extensions.ITopicOptions=} [properties] Properties to set
           * @returns {stronachgroup.first.extensions.TopicOptions} TopicOptions instance
           */
          TopicOptions.create = function create(properties) {
            return new TopicOptions(properties);
          };

          /**
           * Encodes the specified TopicOptions message. Does not implicitly {@link stronachgroup.first.extensions.TopicOptions.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @static
           * @param {stronachgroup.first.extensions.ITopicOptions} message TopicOptions message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TopicOptions.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.topicName != null &&
              Object.hasOwnProperty.call(message, "topicName")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.topicName);
            if (
              message.keyType != null &&
              Object.hasOwnProperty.call(message, "keyType")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.keyType);
            if (
              message.keyDescription != null &&
              Object.hasOwnProperty.call(message, "keyDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.keyDescription);
            if (
              message.partitioned != null &&
              Object.hasOwnProperty.call(message, "partitioned")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.partitioned);
            if (
              message.compressionType != null &&
              Object.hasOwnProperty.call(message, "compressionType")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.compressionType);
            if (
              message.cleanupPolicy != null &&
              Object.hasOwnProperty.call(message, "cleanupPolicy")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.cleanupPolicy);
            if (
              message.deleteRetentionMs != null &&
              Object.hasOwnProperty.call(message, "deleteRetentionMs")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int64(message.deleteRetentionMs);
            if (
              message.retentionBytes != null &&
              Object.hasOwnProperty.call(message, "retentionBytes")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int64(message.retentionBytes);
            if (
              message.retentionMs != null &&
              Object.hasOwnProperty.call(message, "retentionMs")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int64(message.retentionMs);
            if (
              message.singletonOnAllNamespaces != null &&
              Object.hasOwnProperty.call(message, "singletonOnAllNamespaces")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .bool(message.singletonOnAllNamespaces);
            if (
              message.protobufDeserializerUseDeprecatedFormat != null &&
              Object.hasOwnProperty.call(
                message,
                "protobufDeserializerUseDeprecatedFormat"
              )
            )
              writer
                .uint32(/* id 12, wireType 0 =*/ 96)
                .bool(message.protobufDeserializerUseDeprecatedFormat);
            if (
              message.topicPrefix != null &&
              Object.hasOwnProperty.call(message, "topicPrefix")
            )
              writer
                .uint32(/* id 13, wireType 2 =*/ 106)
                .string(message.topicPrefix);
            if (
              message.minimumPartitions != null &&
              Object.hasOwnProperty.call(message, "minimumPartitions")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.minimumPartitions);
            return writer;
          };

          /**
           * Decodes a TopicOptions message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.extensions.TopicOptions} TopicOptions
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TopicOptions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.extensions.TopicOptions();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.topicName = reader.string();
                  break;
                case 2:
                  message.keyType = reader.int32();
                  break;
                case 3:
                  message.keyDescription = reader.string();
                  break;
                case 4:
                  message.partitioned = reader.bool();
                  break;
                case 6:
                  message.compressionType = reader.int32();
                  break;
                case 7:
                  message.cleanupPolicy = reader.int32();
                  break;
                case 8:
                  message.deleteRetentionMs = reader.int64();
                  break;
                case 9:
                  message.retentionBytes = reader.int64();
                  break;
                case 10:
                  message.retentionMs = reader.int64();
                  break;
                case 11:
                  message.singletonOnAllNamespaces = reader.bool();
                  break;
                case 12:
                  message.protobufDeserializerUseDeprecatedFormat =
                    reader.bool();
                  break;
                case 13:
                  message.topicPrefix = reader.string();
                  break;
                case 14:
                  message.minimumPartitions = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TopicOptions message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.extensions.TopicOptions} TopicOptions
           */
          TopicOptions.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.extensions.TopicOptions
            )
              return object;
            var message =
              new $root.stronachgroup.first.extensions.TopicOptions();
            if (object.topicName != null)
              message.topicName = String(object.topicName);
            switch (object.keyType) {
              case "TOPIC_KEY_TYPE_NONE":
              case 0:
                message.keyType = 0;
                break;
              case "TOPIC_KEY_TYPE_STRING":
              case 1:
                message.keyType = 1;
                break;
              case "TOPIC_KEY_TYPE_INT32":
              case 2:
                message.keyType = 2;
                break;
              case "TOPIC_KEY_TYPE_UINT32":
              case 3:
                message.keyType = 3;
                break;
              case "TOPIC_KEY_TYPE_INT64":
              case 4:
                message.keyType = 4;
                break;
              case "TOPIC_KEY_TYPE_UINT64":
              case 5:
                message.keyType = 5;
                break;
            }
            if (object.keyDescription != null)
              message.keyDescription = String(object.keyDescription);
            if (object.partitioned != null)
              message.partitioned = Boolean(object.partitioned);
            switch (object.compressionType) {
              case "TOPIC_COMPRESSION_TYPE_UNSPECIFIED":
              case 0:
                message.compressionType = 0;
                break;
              case "TOPIC_COMPRESSION_TYPE_PRODUCER":
              case 1:
                message.compressionType = 1;
                break;
              case "TOPIC_COMPRESSION_TYPE_GZIP":
              case 2:
                message.compressionType = 2;
                break;
              case "TOPIC_COMPRESSION_TYPE_SNAPPY":
              case 3:
                message.compressionType = 3;
                break;
              case "TOPIC_COMPRESSION_TYPE_LZ4":
              case 4:
                message.compressionType = 4;
                break;
              case "TOPIC_COMPRESSION_TYPE_ZSTD":
              case 5:
                message.compressionType = 5;
                break;
            }
            switch (object.cleanupPolicy) {
              case "TOPIC_CLEANUP_POLICY_UNSPECIFIED":
              case 0:
                message.cleanupPolicy = 0;
                break;
              case "TOPIC_CLEANUP_POLICY_DELETE":
              case 1:
                message.cleanupPolicy = 1;
                break;
              case "TOPIC_CLEANUP_POLICY_COMPACT":
              case 2:
                message.cleanupPolicy = 2;
                break;
              case "TOPIC_CLEANUP_POLICY_COMPACT_DELETE":
              case 3:
                message.cleanupPolicy = 3;
                break;
            }
            if (object.deleteRetentionMs != null)
              if ($util.Long)
                (message.deleteRetentionMs = $util.Long.fromValue(
                  object.deleteRetentionMs
                )).unsigned = false;
              else if (typeof object.deleteRetentionMs === "string")
                message.deleteRetentionMs = parseInt(
                  object.deleteRetentionMs,
                  10
                );
              else if (typeof object.deleteRetentionMs === "number")
                message.deleteRetentionMs = object.deleteRetentionMs;
              else if (typeof object.deleteRetentionMs === "object")
                message.deleteRetentionMs = new $util.LongBits(
                  object.deleteRetentionMs.low >>> 0,
                  object.deleteRetentionMs.high >>> 0
                ).toNumber();
            if (object.retentionBytes != null)
              if ($util.Long)
                (message.retentionBytes = $util.Long.fromValue(
                  object.retentionBytes
                )).unsigned = false;
              else if (typeof object.retentionBytes === "string")
                message.retentionBytes = parseInt(object.retentionBytes, 10);
              else if (typeof object.retentionBytes === "number")
                message.retentionBytes = object.retentionBytes;
              else if (typeof object.retentionBytes === "object")
                message.retentionBytes = new $util.LongBits(
                  object.retentionBytes.low >>> 0,
                  object.retentionBytes.high >>> 0
                ).toNumber();
            if (object.retentionMs != null)
              if ($util.Long)
                (message.retentionMs = $util.Long.fromValue(
                  object.retentionMs
                )).unsigned = false;
              else if (typeof object.retentionMs === "string")
                message.retentionMs = parseInt(object.retentionMs, 10);
              else if (typeof object.retentionMs === "number")
                message.retentionMs = object.retentionMs;
              else if (typeof object.retentionMs === "object")
                message.retentionMs = new $util.LongBits(
                  object.retentionMs.low >>> 0,
                  object.retentionMs.high >>> 0
                ).toNumber();
            if (object.singletonOnAllNamespaces != null)
              message.singletonOnAllNamespaces = Boolean(
                object.singletonOnAllNamespaces
              );
            if (object.protobufDeserializerUseDeprecatedFormat != null)
              message.protobufDeserializerUseDeprecatedFormat = Boolean(
                object.protobufDeserializerUseDeprecatedFormat
              );
            if (object.topicPrefix != null)
              message.topicPrefix = String(object.topicPrefix);
            if (object.minimumPartitions != null)
              message.minimumPartitions = object.minimumPartitions | 0;
            return message;
          };

          /**
           * Creates a plain object from a TopicOptions message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @static
           * @param {stronachgroup.first.extensions.TopicOptions} message TopicOptions
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TopicOptions.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.topicName = "";
              object.keyType =
                options.enums === String ? "TOPIC_KEY_TYPE_NONE" : 0;
              object.keyDescription = "";
              object.partitioned = false;
              object.compressionType =
                options.enums === String
                  ? "TOPIC_COMPRESSION_TYPE_UNSPECIFIED"
                  : 0;
              object.cleanupPolicy =
                options.enums === String
                  ? "TOPIC_CLEANUP_POLICY_UNSPECIFIED"
                  : 0;
              if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.deleteRetentionMs =
                  options.longs === String
                    ? long.toString()
                    : options.longs === Number
                    ? long.toNumber()
                    : long;
              } else
                object.deleteRetentionMs = options.longs === String ? "0" : 0;
              if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.retentionBytes =
                  options.longs === String
                    ? long.toString()
                    : options.longs === Number
                    ? long.toNumber()
                    : long;
              } else object.retentionBytes = options.longs === String ? "0" : 0;
              if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.retentionMs =
                  options.longs === String
                    ? long.toString()
                    : options.longs === Number
                    ? long.toNumber()
                    : long;
              } else object.retentionMs = options.longs === String ? "0" : 0;
              object.singletonOnAllNamespaces = false;
              object.protobufDeserializerUseDeprecatedFormat = false;
              object.topicPrefix = "";
              object.minimumPartitions = 0;
            }
            if (
              message.topicName != null &&
              message.hasOwnProperty("topicName")
            )
              object.topicName = message.topicName;
            if (message.keyType != null && message.hasOwnProperty("keyType"))
              object.keyType =
                options.enums === String
                  ? $root.stronachgroup.first.extensions.TopicKeyType[
                      message.keyType
                    ]
                  : message.keyType;
            if (
              message.keyDescription != null &&
              message.hasOwnProperty("keyDescription")
            )
              object.keyDescription = message.keyDescription;
            if (
              message.partitioned != null &&
              message.hasOwnProperty("partitioned")
            )
              object.partitioned = message.partitioned;
            if (
              message.compressionType != null &&
              message.hasOwnProperty("compressionType")
            )
              object.compressionType =
                options.enums === String
                  ? $root.stronachgroup.first.extensions.TopicCompressionType[
                      message.compressionType
                    ]
                  : message.compressionType;
            if (
              message.cleanupPolicy != null &&
              message.hasOwnProperty("cleanupPolicy")
            )
              object.cleanupPolicy =
                options.enums === String
                  ? $root.stronachgroup.first.extensions.TopicCleanupPolicy[
                      message.cleanupPolicy
                    ]
                  : message.cleanupPolicy;
            if (
              message.deleteRetentionMs != null &&
              message.hasOwnProperty("deleteRetentionMs")
            )
              if (typeof message.deleteRetentionMs === "number")
                object.deleteRetentionMs =
                  options.longs === String
                    ? String(message.deleteRetentionMs)
                    : message.deleteRetentionMs;
              else
                object.deleteRetentionMs =
                  options.longs === String
                    ? $util.Long.prototype.toString.call(
                        message.deleteRetentionMs
                      )
                    : options.longs === Number
                    ? new $util.LongBits(
                        message.deleteRetentionMs.low >>> 0,
                        message.deleteRetentionMs.high >>> 0
                      ).toNumber()
                    : message.deleteRetentionMs;
            if (
              message.retentionBytes != null &&
              message.hasOwnProperty("retentionBytes")
            )
              if (typeof message.retentionBytes === "number")
                object.retentionBytes =
                  options.longs === String
                    ? String(message.retentionBytes)
                    : message.retentionBytes;
              else
                object.retentionBytes =
                  options.longs === String
                    ? $util.Long.prototype.toString.call(message.retentionBytes)
                    : options.longs === Number
                    ? new $util.LongBits(
                        message.retentionBytes.low >>> 0,
                        message.retentionBytes.high >>> 0
                      ).toNumber()
                    : message.retentionBytes;
            if (
              message.retentionMs != null &&
              message.hasOwnProperty("retentionMs")
            )
              if (typeof message.retentionMs === "number")
                object.retentionMs =
                  options.longs === String
                    ? String(message.retentionMs)
                    : message.retentionMs;
              else
                object.retentionMs =
                  options.longs === String
                    ? $util.Long.prototype.toString.call(message.retentionMs)
                    : options.longs === Number
                    ? new $util.LongBits(
                        message.retentionMs.low >>> 0,
                        message.retentionMs.high >>> 0
                      ).toNumber()
                    : message.retentionMs;
            if (
              message.singletonOnAllNamespaces != null &&
              message.hasOwnProperty("singletonOnAllNamespaces")
            )
              object.singletonOnAllNamespaces =
                message.singletonOnAllNamespaces;
            if (
              message.protobufDeserializerUseDeprecatedFormat != null &&
              message.hasOwnProperty("protobufDeserializerUseDeprecatedFormat")
            )
              object.protobufDeserializerUseDeprecatedFormat =
                message.protobufDeserializerUseDeprecatedFormat;
            if (
              message.topicPrefix != null &&
              message.hasOwnProperty("topicPrefix")
            )
              object.topicPrefix = message.topicPrefix;
            if (
              message.minimumPartitions != null &&
              message.hasOwnProperty("minimumPartitions")
            )
              object.minimumPartitions = message.minimumPartitions;
            return object;
          };

          /**
           * Converts this TopicOptions to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.extensions.TopicOptions
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TopicOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TopicOptions;
        })();

        /**
         * TopicCompressionType enum.
         * @name stronachgroup.first.extensions.TopicCompressionType
         * @enum {string}
         * @property {number} TOPIC_COMPRESSION_TYPE_UNSPECIFIED=0 TOPIC_COMPRESSION_TYPE_UNSPECIFIED value
         * @property {number} TOPIC_COMPRESSION_TYPE_PRODUCER=1 TOPIC_COMPRESSION_TYPE_PRODUCER value
         * @property {number} TOPIC_COMPRESSION_TYPE_GZIP=2 TOPIC_COMPRESSION_TYPE_GZIP value
         * @property {number} TOPIC_COMPRESSION_TYPE_SNAPPY=3 TOPIC_COMPRESSION_TYPE_SNAPPY value
         * @property {number} TOPIC_COMPRESSION_TYPE_LZ4=4 TOPIC_COMPRESSION_TYPE_LZ4 value
         * @property {number} TOPIC_COMPRESSION_TYPE_ZSTD=5 TOPIC_COMPRESSION_TYPE_ZSTD value
         */
        extensions.TopicCompressionType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TOPIC_COMPRESSION_TYPE_UNSPECIFIED")] = 0;
          values[(valuesById[1] = "TOPIC_COMPRESSION_TYPE_PRODUCER")] = 1;
          values[(valuesById[2] = "TOPIC_COMPRESSION_TYPE_GZIP")] = 2;
          values[(valuesById[3] = "TOPIC_COMPRESSION_TYPE_SNAPPY")] = 3;
          values[(valuesById[4] = "TOPIC_COMPRESSION_TYPE_LZ4")] = 4;
          values[(valuesById[5] = "TOPIC_COMPRESSION_TYPE_ZSTD")] = 5;
          return values;
        })();

        /**
         * TopicCleanupPolicy enum.
         * @name stronachgroup.first.extensions.TopicCleanupPolicy
         * @enum {string}
         * @property {number} TOPIC_CLEANUP_POLICY_UNSPECIFIED=0 TOPIC_CLEANUP_POLICY_UNSPECIFIED value
         * @property {number} TOPIC_CLEANUP_POLICY_DELETE=1 TOPIC_CLEANUP_POLICY_DELETE value
         * @property {number} TOPIC_CLEANUP_POLICY_COMPACT=2 TOPIC_CLEANUP_POLICY_COMPACT value
         * @property {number} TOPIC_CLEANUP_POLICY_COMPACT_DELETE=3 TOPIC_CLEANUP_POLICY_COMPACT_DELETE value
         */
        extensions.TopicCleanupPolicy = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TOPIC_CLEANUP_POLICY_UNSPECIFIED")] = 0;
          values[(valuesById[1] = "TOPIC_CLEANUP_POLICY_DELETE")] = 1;
          values[(valuesById[2] = "TOPIC_CLEANUP_POLICY_COMPACT")] = 2;
          values[(valuesById[3] = "TOPIC_CLEANUP_POLICY_COMPACT_DELETE")] = 3;
          return values;
        })();

        /**
         * TopicKeyType enum.
         * @name stronachgroup.first.extensions.TopicKeyType
         * @enum {string}
         * @property {number} TOPIC_KEY_TYPE_NONE=0 TOPIC_KEY_TYPE_NONE value
         * @property {number} TOPIC_KEY_TYPE_STRING=1 TOPIC_KEY_TYPE_STRING value
         * @property {number} TOPIC_KEY_TYPE_INT32=2 TOPIC_KEY_TYPE_INT32 value
         * @property {number} TOPIC_KEY_TYPE_UINT32=3 TOPIC_KEY_TYPE_UINT32 value
         * @property {number} TOPIC_KEY_TYPE_INT64=4 TOPIC_KEY_TYPE_INT64 value
         * @property {number} TOPIC_KEY_TYPE_UINT64=5 TOPIC_KEY_TYPE_UINT64 value
         */
        extensions.TopicKeyType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TOPIC_KEY_TYPE_NONE")] = 0;
          values[(valuesById[1] = "TOPIC_KEY_TYPE_STRING")] = 1;
          values[(valuesById[2] = "TOPIC_KEY_TYPE_INT32")] = 2;
          values[(valuesById[3] = "TOPIC_KEY_TYPE_UINT32")] = 3;
          values[(valuesById[4] = "TOPIC_KEY_TYPE_INT64")] = 4;
          values[(valuesById[5] = "TOPIC_KEY_TYPE_UINT64")] = 5;
          return values;
        })();

        /**
         * Audience enum.
         * @name stronachgroup.first.extensions.Audience
         * @enum {string}
         * @property {number} AUDIENCE_UNSPECIFIED=0 AUDIENCE_UNSPECIFIED value
         * @property {number} AUDIENCE_PUBLIC=1 AUDIENCE_PUBLIC value
         * @property {number} AUDIENCE_PARTNER=2 AUDIENCE_PARTNER value
         * @property {number} AUDIENCE_INTERNAL=3 AUDIENCE_INTERNAL value
         */
        extensions.Audience = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "AUDIENCE_UNSPECIFIED")] = 0;
          values[(valuesById[1] = "AUDIENCE_PUBLIC")] = 1;
          values[(valuesById[2] = "AUDIENCE_PARTNER")] = 2;
          values[(valuesById[3] = "AUDIENCE_INTERNAL")] = 3;
          return values;
        })();

        return extensions;
      })();

      first.racehorse360 = (function () {
        /**
         * Namespace racehorse360.
         * @memberof stronachgroup.first
         * @namespace
         */
        var racehorse360 = {};

        racehorse360.ApplicationFeatureFlagService = (function () {
          /**
           * Constructs a new ApplicationFeatureFlagService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an ApplicationFeatureFlagService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function ApplicationFeatureFlagService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (ApplicationFeatureFlagService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = ApplicationFeatureFlagService;

          /**
           * Creates new ApplicationFeatureFlagService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlagService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {ApplicationFeatureFlagService} RPC service. Useful where requests and/or responses are streamed.
           */
          ApplicationFeatureFlagService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.ApplicationFeatureFlagService#pullApplicationFeatureFlags}.
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlagService
           * @typedef PullApplicationFeatureFlagsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse} [response] PullApplicationFeatureFlagsResponse
           */

          /**
           * Calls PullApplicationFeatureFlags.
           * @function pullApplicationFeatureFlags
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlagService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsRequest} request PullApplicationFeatureFlagsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.ApplicationFeatureFlagService.PullApplicationFeatureFlagsCallback} callback Node-style callback called with the error, if any, and PullApplicationFeatureFlagsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (ApplicationFeatureFlagService.prototype.pullApplicationFeatureFlags =
              function pullApplicationFeatureFlags(request, callback) {
                return this.rpcCall(
                  pullApplicationFeatureFlags,
                  $root.stronachgroup.first.racehorse360
                    .PullApplicationFeatureFlagsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullApplicationFeatureFlagsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullApplicationFeatureFlags" }
          );

          /**
           * Calls PullApplicationFeatureFlags.
           * @function pullApplicationFeatureFlags
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlagService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsRequest} request PullApplicationFeatureFlagsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse>} Promise
           * @variation 2
           */

          return ApplicationFeatureFlagService;
        })();

        racehorse360.EmptyResponse = (function () {
          /**
           * Properties of an EmptyResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEmptyResponse
           */

          /**
           * Constructs a new EmptyResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EmptyResponse.
           * @implements IEmptyResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEmptyResponse=} [properties] Properties to set
           */
          function EmptyResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new EmptyResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IEmptyResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EmptyResponse} EmptyResponse instance
           */
          EmptyResponse.create = function create(properties) {
            return new EmptyResponse(properties);
          };

          /**
           * Encodes the specified EmptyResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.EmptyResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IEmptyResponse} message EmptyResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EmptyResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes an EmptyResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EmptyResponse} EmptyResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EmptyResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EmptyResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EmptyResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EmptyResponse} EmptyResponse
           */
          EmptyResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EmptyResponse
            )
              return object;
            return new $root.stronachgroup.first.racehorse360.EmptyResponse();
          };

          /**
           * Creates a plain object from an EmptyResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @static
           * @param {stronachgroup.first.racehorse360.EmptyResponse} message EmptyResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EmptyResponse.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this EmptyResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EmptyResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EmptyResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EmptyResponse;
        })();

        racehorse360.EmptyRequest = (function () {
          /**
           * Properties of an EmptyRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEmptyRequest
           */

          /**
           * Constructs a new EmptyRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EmptyRequest.
           * @implements IEmptyRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEmptyRequest=} [properties] Properties to set
           */
          function EmptyRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new EmptyRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEmptyRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EmptyRequest} EmptyRequest instance
           */
          EmptyRequest.create = function create(properties) {
            return new EmptyRequest(properties);
          };

          /**
           * Encodes the specified EmptyRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EmptyRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEmptyRequest} message EmptyRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EmptyRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes an EmptyRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EmptyRequest} EmptyRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EmptyRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EmptyRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EmptyRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EmptyRequest} EmptyRequest
           */
          EmptyRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EmptyRequest
            )
              return object;
            return new $root.stronachgroup.first.racehorse360.EmptyRequest();
          };

          /**
           * Creates a plain object from an EmptyRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EmptyRequest} message EmptyRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EmptyRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this EmptyRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EmptyRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EmptyRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EmptyRequest;
        })();

        racehorse360.PagingOptions = (function () {
          /**
           * Properties of a PagingOptions.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPagingOptions
           * @property {number|null} [maxResults] PagingOptions maxResults
           * @property {number|null} [offset] PagingOptions offset
           * @property {string|null} [pageToken] PagingOptions pageToken
           * @property {boolean|null} [includeSummary] PagingOptions includeSummary
           */

          /**
           * Constructs a new PagingOptions.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PagingOptions.
           * @implements IPagingOptions
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPagingOptions=} [properties] Properties to set
           */
          function PagingOptions(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PagingOptions maxResults.
           * @member {number} maxResults
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @instance
           */
          PagingOptions.prototype.maxResults = 0;

          /**
           * PagingOptions offset.
           * @member {number} offset
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @instance
           */
          PagingOptions.prototype.offset = 0;

          /**
           * PagingOptions pageToken.
           * @member {string} pageToken
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @instance
           */
          PagingOptions.prototype.pageToken = "";

          /**
           * PagingOptions includeSummary.
           * @member {boolean} includeSummary
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @instance
           */
          PagingOptions.prototype.includeSummary = false;

          /**
           * Creates a new PagingOptions instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @static
           * @param {stronachgroup.first.racehorse360.IPagingOptions=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PagingOptions} PagingOptions instance
           */
          PagingOptions.create = function create(properties) {
            return new PagingOptions(properties);
          };

          /**
           * Encodes the specified PagingOptions message. Does not implicitly {@link stronachgroup.first.racehorse360.PagingOptions.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @static
           * @param {stronachgroup.first.racehorse360.IPagingOptions} message PagingOptions message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PagingOptions.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.maxResults != null &&
              Object.hasOwnProperty.call(message, "maxResults")
            )
              writer
                .uint32(/* id 1, wireType 0 =*/ 8)
                .int32(message.maxResults);
            if (
              message.offset != null &&
              Object.hasOwnProperty.call(message, "offset")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.offset);
            if (
              message.pageToken != null &&
              Object.hasOwnProperty.call(message, "pageToken")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.pageToken);
            if (
              message.includeSummary != null &&
              Object.hasOwnProperty.call(message, "includeSummary")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.includeSummary);
            return writer;
          };

          /**
           * Decodes a PagingOptions message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PagingOptions} PagingOptions
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PagingOptions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PagingOptions();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.maxResults = reader.int32();
                  break;
                case 2:
                  message.offset = reader.int32();
                  break;
                case 3:
                  message.pageToken = reader.string();
                  break;
                case 4:
                  message.includeSummary = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PagingOptions message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PagingOptions} PagingOptions
           */
          PagingOptions.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PagingOptions
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PagingOptions();
            if (object.maxResults != null)
              message.maxResults = object.maxResults | 0;
            if (object.offset != null) message.offset = object.offset | 0;
            if (object.pageToken != null)
              message.pageToken = String(object.pageToken);
            if (object.includeSummary != null)
              message.includeSummary = Boolean(object.includeSummary);
            return message;
          };

          /**
           * Creates a plain object from a PagingOptions message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @static
           * @param {stronachgroup.first.racehorse360.PagingOptions} message PagingOptions
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PagingOptions.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.maxResults = 0;
              object.offset = 0;
              object.pageToken = "";
              object.includeSummary = false;
            }
            if (
              message.maxResults != null &&
              message.hasOwnProperty("maxResults")
            )
              object.maxResults = message.maxResults;
            if (message.offset != null && message.hasOwnProperty("offset"))
              object.offset = message.offset;
            if (
              message.pageToken != null &&
              message.hasOwnProperty("pageToken")
            )
              object.pageToken = message.pageToken;
            if (
              message.includeSummary != null &&
              message.hasOwnProperty("includeSummary")
            )
              object.includeSummary = message.includeSummary;
            return object;
          };

          /**
           * Converts this PagingOptions to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PagingOptions
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PagingOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PagingOptions;
        })();

        racehorse360.PagingInfo = (function () {
          /**
           * Properties of a PagingInfo.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPagingInfo
           * @property {string|null} [nextPageToken] PagingInfo nextPageToken
           * @property {number|null} [totalResults] PagingInfo totalResults
           */

          /**
           * Constructs a new PagingInfo.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PagingInfo.
           * @implements IPagingInfo
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPagingInfo=} [properties] Properties to set
           */
          function PagingInfo(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PagingInfo nextPageToken.
           * @member {string} nextPageToken
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @instance
           */
          PagingInfo.prototype.nextPageToken = "";

          /**
           * PagingInfo totalResults.
           * @member {number} totalResults
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @instance
           */
          PagingInfo.prototype.totalResults = 0;

          /**
           * Creates a new PagingInfo instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IPagingInfo=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PagingInfo} PagingInfo instance
           */
          PagingInfo.create = function create(properties) {
            return new PagingInfo(properties);
          };

          /**
           * Encodes the specified PagingInfo message. Does not implicitly {@link stronachgroup.first.racehorse360.PagingInfo.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IPagingInfo} message PagingInfo message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PagingInfo.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.nextPageToken != null &&
              Object.hasOwnProperty.call(message, "nextPageToken")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.nextPageToken);
            if (
              message.totalResults != null &&
              Object.hasOwnProperty.call(message, "totalResults")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.totalResults);
            return writer;
          };

          /**
           * Decodes a PagingInfo message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PagingInfo} PagingInfo
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PagingInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.PagingInfo();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.nextPageToken = reader.string();
                  break;
                case 2:
                  message.totalResults = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PagingInfo message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PagingInfo} PagingInfo
           */
          PagingInfo.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PagingInfo
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PagingInfo();
            if (object.nextPageToken != null)
              message.nextPageToken = String(object.nextPageToken);
            if (object.totalResults != null)
              message.totalResults = object.totalResults | 0;
            return message;
          };

          /**
           * Creates a plain object from a PagingInfo message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @static
           * @param {stronachgroup.first.racehorse360.PagingInfo} message PagingInfo
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PagingInfo.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.nextPageToken = "";
              object.totalResults = 0;
            }
            if (
              message.nextPageToken != null &&
              message.hasOwnProperty("nextPageToken")
            )
              object.nextPageToken = message.nextPageToken;
            if (
              message.totalResults != null &&
              message.hasOwnProperty("totalResults")
            )
              object.totalResults = message.totalResults;
            return object;
          };

          /**
           * Converts this PagingInfo to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PagingInfo
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PagingInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PagingInfo;
        })();

        racehorse360.GetOptions = (function () {
          /**
           * Properties of a GetOptions.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetOptions
           * @property {Array.<string>|null} [select] GetOptions select
           * @property {Array.<string>|null} [orderBy] GetOptions orderBy
           */

          /**
           * Constructs a new GetOptions.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetOptions.
           * @implements IGetOptions
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetOptions=} [properties] Properties to set
           */
          function GetOptions(properties) {
            this.select = [];
            this.orderBy = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetOptions select.
           * @member {Array.<string>} select
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @instance
           */
          GetOptions.prototype.select = $util.emptyArray;

          /**
           * GetOptions orderBy.
           * @member {Array.<string>} orderBy
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @instance
           */
          GetOptions.prototype.orderBy = $util.emptyArray;

          /**
           * Creates a new GetOptions instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @static
           * @param {stronachgroup.first.racehorse360.IGetOptions=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetOptions} GetOptions instance
           */
          GetOptions.create = function create(properties) {
            return new GetOptions(properties);
          };

          /**
           * Encodes the specified GetOptions message. Does not implicitly {@link stronachgroup.first.racehorse360.GetOptions.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @static
           * @param {stronachgroup.first.racehorse360.IGetOptions} message GetOptions message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetOptions.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.select != null && message.select.length)
              for (var i = 0; i < message.select.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.select[i]);
            if (message.orderBy != null && message.orderBy.length)
              for (var i = 0; i < message.orderBy.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.orderBy[i]);
            return writer;
          };

          /**
           * Decodes a GetOptions message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetOptions} GetOptions
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetOptions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.GetOptions();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.select && message.select.length))
                    message.select = [];
                  message.select.push(reader.string());
                  break;
                case 2:
                  if (!(message.orderBy && message.orderBy.length))
                    message.orderBy = [];
                  message.orderBy.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetOptions message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetOptions} GetOptions
           */
          GetOptions.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetOptions
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetOptions();
            if (object.select) {
              if (!Array.isArray(object.select))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetOptions.select: array expected"
                );
              message.select = [];
              for (var i = 0; i < object.select.length; ++i)
                message.select[i] = String(object.select[i]);
            }
            if (object.orderBy) {
              if (!Array.isArray(object.orderBy))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetOptions.orderBy: array expected"
                );
              message.orderBy = [];
              for (var i = 0; i < object.orderBy.length; ++i)
                message.orderBy[i] = String(object.orderBy[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a GetOptions message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @static
           * @param {stronachgroup.first.racehorse360.GetOptions} message GetOptions
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetOptions.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.select = [];
              object.orderBy = [];
            }
            if (message.select && message.select.length) {
              object.select = [];
              for (var j = 0; j < message.select.length; ++j)
                object.select[j] = message.select[j];
            }
            if (message.orderBy && message.orderBy.length) {
              object.orderBy = [];
              for (var j = 0; j < message.orderBy.length; ++j)
                object.orderBy[j] = message.orderBy[j];
            }
            return object;
          };

          /**
           * Converts this GetOptions to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetOptions
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetOptions;
        })();

        racehorse360.StringMatch = (function () {
          /**
           * Properties of a StringMatch.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStringMatch
           * @property {string|null} [exact] StringMatch exact
           * @property {string|null} [startsWith] StringMatch startsWith
           * @property {string|null} [contains] StringMatch contains
           * @property {string|null} [similar] StringMatch similar
           * @property {string|null} [similarOrContains] StringMatch similarOrContains
           */

          /**
           * Constructs a new StringMatch.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StringMatch.
           * @implements IStringMatch
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStringMatch=} [properties] Properties to set
           */
          function StringMatch(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StringMatch exact.
           * @member {string} exact
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          StringMatch.prototype.exact = "";

          /**
           * StringMatch startsWith.
           * @member {string} startsWith
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          StringMatch.prototype.startsWith = "";

          /**
           * StringMatch contains.
           * @member {string} contains
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          StringMatch.prototype.contains = "";

          /**
           * StringMatch similar.
           * @member {string} similar
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          StringMatch.prototype.similar = "";

          /**
           * StringMatch similarOrContains.
           * @member {string} similarOrContains
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          StringMatch.prototype.similarOrContains = "";

          // OneOf field names bound to virtual getters and setters
          var $oneOfFields;

          /**
           * StringMatch matchType.
           * @member {"exact"|"startsWith"|"contains"|"similar"|"similarOrContains"|undefined} matchType
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           */
          Object.defineProperty(StringMatch.prototype, "matchType", {
            get: $util.oneOfGetter(
              ($oneOfFields = [
                "exact",
                "startsWith",
                "contains",
                "similar",
                "similarOrContains"
              ])
            ),
            set: $util.oneOfSetter($oneOfFields)
          });

          /**
           * Creates a new StringMatch instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @static
           * @param {stronachgroup.first.racehorse360.IStringMatch=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StringMatch} StringMatch instance
           */
          StringMatch.create = function create(properties) {
            return new StringMatch(properties);
          };

          /**
           * Encodes the specified StringMatch message. Does not implicitly {@link stronachgroup.first.racehorse360.StringMatch.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @static
           * @param {stronachgroup.first.racehorse360.IStringMatch} message StringMatch message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StringMatch.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.exact != null &&
              Object.hasOwnProperty.call(message, "exact")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.exact);
            if (
              message.startsWith != null &&
              Object.hasOwnProperty.call(message, "startsWith")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.startsWith);
            if (
              message.contains != null &&
              Object.hasOwnProperty.call(message, "contains")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.contains);
            if (
              message.similar != null &&
              Object.hasOwnProperty.call(message, "similar")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.similar);
            if (
              message.similarOrContains != null &&
              Object.hasOwnProperty.call(message, "similarOrContains")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.similarOrContains);
            return writer;
          };

          /**
           * Decodes a StringMatch message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StringMatch} StringMatch
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StringMatch.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StringMatch();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.exact = reader.string();
                  break;
                case 2:
                  message.startsWith = reader.string();
                  break;
                case 3:
                  message.contains = reader.string();
                  break;
                case 4:
                  message.similar = reader.string();
                  break;
                case 5:
                  message.similarOrContains = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StringMatch message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StringMatch} StringMatch
           */
          StringMatch.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StringMatch
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StringMatch();
            if (object.exact != null) message.exact = String(object.exact);
            if (object.startsWith != null)
              message.startsWith = String(object.startsWith);
            if (object.contains != null)
              message.contains = String(object.contains);
            if (object.similar != null)
              message.similar = String(object.similar);
            if (object.similarOrContains != null)
              message.similarOrContains = String(object.similarOrContains);
            return message;
          };

          /**
           * Creates a plain object from a StringMatch message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @static
           * @param {stronachgroup.first.racehorse360.StringMatch} message StringMatch
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StringMatch.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exact != null && message.hasOwnProperty("exact")) {
              object.exact = message.exact;
              if (options.oneofs) object.matchType = "exact";
            }
            if (
              message.startsWith != null &&
              message.hasOwnProperty("startsWith")
            ) {
              object.startsWith = message.startsWith;
              if (options.oneofs) object.matchType = "startsWith";
            }
            if (
              message.contains != null &&
              message.hasOwnProperty("contains")
            ) {
              object.contains = message.contains;
              if (options.oneofs) object.matchType = "contains";
            }
            if (message.similar != null && message.hasOwnProperty("similar")) {
              object.similar = message.similar;
              if (options.oneofs) object.matchType = "similar";
            }
            if (
              message.similarOrContains != null &&
              message.hasOwnProperty("similarOrContains")
            ) {
              object.similarOrContains = message.similarOrContains;
              if (options.oneofs) object.matchType = "similarOrContains";
            }
            return object;
          };

          /**
           * Converts this StringMatch to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StringMatch
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StringMatch.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StringMatch;
        })();

        racehorse360.DateMatch = (function () {
          /**
           * Properties of a DateMatch.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDateMatch
           * @property {string|null} [exact] DateMatch exact
           * @property {stronachgroup.first.racehorse360.DateMatch.IDateRange|null} [range] DateMatch range
           */

          /**
           * Constructs a new DateMatch.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DateMatch.
           * @implements IDateMatch
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDateMatch=} [properties] Properties to set
           */
          function DateMatch(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DateMatch exact.
           * @member {string} exact
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @instance
           */
          DateMatch.prototype.exact = "";

          /**
           * DateMatch range.
           * @member {stronachgroup.first.racehorse360.DateMatch.IDateRange|null|undefined} range
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @instance
           */
          DateMatch.prototype.range = null;

          // OneOf field names bound to virtual getters and setters
          var $oneOfFields;

          /**
           * DateMatch matchType.
           * @member {"exact"|"range"|undefined} matchType
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @instance
           */
          Object.defineProperty(DateMatch.prototype, "matchType", {
            get: $util.oneOfGetter(($oneOfFields = ["exact", "range"])),
            set: $util.oneOfSetter($oneOfFields)
          });

          /**
           * Creates a new DateMatch instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @static
           * @param {stronachgroup.first.racehorse360.IDateMatch=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DateMatch} DateMatch instance
           */
          DateMatch.create = function create(properties) {
            return new DateMatch(properties);
          };

          /**
           * Encodes the specified DateMatch message. Does not implicitly {@link stronachgroup.first.racehorse360.DateMatch.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @static
           * @param {stronachgroup.first.racehorse360.IDateMatch} message DateMatch message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DateMatch.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.exact != null &&
              Object.hasOwnProperty.call(message, "exact")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.exact);
            if (
              message.range != null &&
              Object.hasOwnProperty.call(message, "range")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.DateRange.encode(
                message.range,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a DateMatch message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DateMatch} DateMatch
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DateMatch.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.DateMatch();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.exact = reader.string();
                  break;
                case 2:
                  message.range =
                    $root.stronachgroup.first.racehorse360.DateMatch.DateRange.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DateMatch message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DateMatch} DateMatch
           */
          DateMatch.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.DateMatch
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DateMatch();
            if (object.exact != null) message.exact = String(object.exact);
            if (object.range != null) {
              if (typeof object.range !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.DateMatch.range: object expected"
                );
              message.range =
                $root.stronachgroup.first.racehorse360.DateMatch.DateRange.fromObject(
                  object.range
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a DateMatch message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @static
           * @param {stronachgroup.first.racehorse360.DateMatch} message DateMatch
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DateMatch.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exact != null && message.hasOwnProperty("exact")) {
              object.exact = message.exact;
              if (options.oneofs) object.matchType = "exact";
            }
            if (message.range != null && message.hasOwnProperty("range")) {
              object.range =
                $root.stronachgroup.first.racehorse360.DateMatch.DateRange.toObject(
                  message.range,
                  options
                );
              if (options.oneofs) object.matchType = "range";
            }
            return object;
          };

          /**
           * Converts this DateMatch to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DateMatch
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DateMatch.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          DateMatch.DateRange = (function () {
            /**
             * Properties of a DateRange.
             * @memberof stronachgroup.first.racehorse360.DateMatch
             * @interface IDateRange
             * @property {stronachgroup.first.racehorse360.DateMatch.DateRange.IRelativeDateRange|null} [relative] DateRange relative
             * @property {stronachgroup.first.racehorse360.DateMatch.DateRange.IAbsoluteDateRange|null} [absolute] DateRange absolute
             */

            /**
             * Constructs a new DateRange.
             * @memberof stronachgroup.first.racehorse360.DateMatch
             * @classdesc Represents a DateRange.
             * @implements IDateRange
             * @constructor
             * @param {stronachgroup.first.racehorse360.DateMatch.IDateRange=} [properties] Properties to set
             */
            function DateRange(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * DateRange relative.
             * @member {stronachgroup.first.racehorse360.DateMatch.DateRange.IRelativeDateRange|null|undefined} relative
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @instance
             */
            DateRange.prototype.relative = null;

            /**
             * DateRange absolute.
             * @member {stronachgroup.first.racehorse360.DateMatch.DateRange.IAbsoluteDateRange|null|undefined} absolute
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @instance
             */
            DateRange.prototype.absolute = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * DateRange rangeType.
             * @member {"relative"|"absolute"|undefined} rangeType
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @instance
             */
            Object.defineProperty(DateRange.prototype, "rangeType", {
              get: $util.oneOfGetter(($oneOfFields = ["relative", "absolute"])),
              set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new DateRange instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @static
             * @param {stronachgroup.first.racehorse360.DateMatch.IDateRange=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange} DateRange instance
             */
            DateRange.create = function create(properties) {
              return new DateRange(properties);
            };

            /**
             * Encodes the specified DateRange message. Does not implicitly {@link stronachgroup.first.racehorse360.DateMatch.DateRange.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @static
             * @param {stronachgroup.first.racehorse360.DateMatch.IDateRange} message DateRange message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DateRange.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.relative != null &&
                Object.hasOwnProperty.call(message, "relative")
              )
                $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.encode(
                  message.relative,
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
              if (
                message.absolute != null &&
                Object.hasOwnProperty.call(message, "absolute")
              )
                $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.encode(
                  message.absolute,
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
              return writer;
            };

            /**
             * Decodes a DateRange message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange} DateRange
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DateRange.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.stronachgroup.first.racehorse360.DateMatch.DateRange();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.relative =
                      $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 2:
                    message.absolute =
                      $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a DateRange message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange} DateRange
             */
            DateRange.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360.DateMatch.DateRange
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.DateMatch.DateRange();
              if (object.relative != null) {
                if (typeof object.relative !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.DateMatch.DateRange.relative: object expected"
                  );
                message.relative =
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.fromObject(
                    object.relative
                  );
              }
              if (object.absolute != null) {
                if (typeof object.absolute !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.DateMatch.DateRange.absolute: object expected"
                  );
                message.absolute =
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.fromObject(
                    object.absolute
                  );
              }
              return message;
            };

            /**
             * Creates a plain object from a DateRange message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @static
             * @param {stronachgroup.first.racehorse360.DateMatch.DateRange} message DateRange
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DateRange.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (
                message.relative != null &&
                message.hasOwnProperty("relative")
              ) {
                object.relative =
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.toObject(
                    message.relative,
                    options
                  );
                if (options.oneofs) object.rangeType = "relative";
              }
              if (
                message.absolute != null &&
                message.hasOwnProperty("absolute")
              ) {
                object.absolute =
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.toObject(
                    message.absolute,
                    options
                  );
                if (options.oneofs) object.rangeType = "absolute";
              }
              return object;
            };

            /**
             * Converts this DateRange to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DateRange.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            DateRange.RelativeDateRange = (function () {
              /**
               * Properties of a RelativeDateRange.
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
               * @interface IRelativeDateRange
               * @property {google.protobuf.IInt32Value|null} [startDate] RelativeDateRange startDate
               * @property {google.protobuf.IInt32Value|null} [endDate] RelativeDateRange endDate
               * @property {string|null} [timezone] RelativeDateRange timezone
               */

              /**
               * Constructs a new RelativeDateRange.
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
               * @classdesc Represents a RelativeDateRange.
               * @implements IRelativeDateRange
               * @constructor
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IRelativeDateRange=} [properties] Properties to set
               */
              function RelativeDateRange(properties) {
                if (properties)
                  for (
                    var keys = Object.keys(properties), i = 0;
                    i < keys.length;
                    ++i
                  )
                    if (properties[keys[i]] != null)
                      this[keys[i]] = properties[keys[i]];
              }

              /**
               * RelativeDateRange startDate.
               * @member {google.protobuf.IInt32Value|null|undefined} startDate
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @instance
               */
              RelativeDateRange.prototype.startDate = null;

              /**
               * RelativeDateRange endDate.
               * @member {google.protobuf.IInt32Value|null|undefined} endDate
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @instance
               */
              RelativeDateRange.prototype.endDate = null;

              /**
               * RelativeDateRange timezone.
               * @member {string} timezone
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @instance
               */
              RelativeDateRange.prototype.timezone = "";

              /**
               * Creates a new RelativeDateRange instance using the specified properties.
               * @function create
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IRelativeDateRange=} [properties] Properties to set
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange} RelativeDateRange instance
               */
              RelativeDateRange.create = function create(properties) {
                return new RelativeDateRange(properties);
              };

              /**
               * Encodes the specified RelativeDateRange message. Does not implicitly {@link stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.verify|verify} messages.
               * @function encode
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IRelativeDateRange} message RelativeDateRange message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */
              RelativeDateRange.encode = function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.startDate != null &&
                  Object.hasOwnProperty.call(message, "startDate")
                )
                  $root.google.protobuf.Int32Value.encode(
                    message.startDate,
                    writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                  ).ldelim();
                if (
                  message.endDate != null &&
                  Object.hasOwnProperty.call(message, "endDate")
                )
                  $root.google.protobuf.Int32Value.encode(
                    message.endDate,
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  ).ldelim();
                if (
                  message.timezone != null &&
                  Object.hasOwnProperty.call(message, "timezone")
                )
                  writer
                    .uint32(/* id 3, wireType 2 =*/ 26)
                    .string(message.timezone);
                return writer;
              };

              /**
               * Decodes a RelativeDateRange message from the specified reader or buffer.
               * @function decode
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange} RelativeDateRange
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */
              RelativeDateRange.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.startDate =
                        $root.google.protobuf.Int32Value.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    case 2:
                      message.endDate = $root.google.protobuf.Int32Value.decode(
                        reader,
                        reader.uint32()
                      );
                      break;
                    case 3:
                      message.timezone = reader.string();
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

              /**
               * Creates a RelativeDateRange message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange} RelativeDateRange
               */
              RelativeDateRange.fromObject = function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange
                    .RelativeDateRange
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange();
                if (object.startDate != null) {
                  if (typeof object.startDate !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.startDate: object expected"
                    );
                  message.startDate =
                    $root.google.protobuf.Int32Value.fromObject(
                      object.startDate
                    );
                }
                if (object.endDate != null) {
                  if (typeof object.endDate !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange.endDate: object expected"
                    );
                  message.endDate = $root.google.protobuf.Int32Value.fromObject(
                    object.endDate
                  );
                }
                if (object.timezone != null)
                  message.timezone = String(object.timezone);
                return message;
              };

              /**
               * Creates a plain object from a RelativeDateRange message. Also converts values to other types if specified.
               * @function toObject
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange} message RelativeDateRange
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */
              RelativeDateRange.toObject = function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) {
                  object.startDate = null;
                  object.endDate = null;
                  object.timezone = "";
                }
                if (
                  message.startDate != null &&
                  message.hasOwnProperty("startDate")
                )
                  object.startDate = $root.google.protobuf.Int32Value.toObject(
                    message.startDate,
                    options
                  );
                if (
                  message.endDate != null &&
                  message.hasOwnProperty("endDate")
                )
                  object.endDate = $root.google.protobuf.Int32Value.toObject(
                    message.endDate,
                    options
                  );
                if (
                  message.timezone != null &&
                  message.hasOwnProperty("timezone")
                )
                  object.timezone = message.timezone;
                return object;
              };

              /**
               * Converts this RelativeDateRange to JSON.
               * @function toJSON
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.RelativeDateRange
               * @instance
               * @returns {Object.<string,*>} JSON object
               */
              RelativeDateRange.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

              return RelativeDateRange;
            })();

            DateRange.AbsoluteDateRange = (function () {
              /**
               * Properties of an AbsoluteDateRange.
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
               * @interface IAbsoluteDateRange
               * @property {string|null} [onOrAfter] AbsoluteDateRange onOrAfter
               * @property {string|null} [before] AbsoluteDateRange before
               * @property {google.protobuf.IBoolValue|null} [includeTime] AbsoluteDateRange includeTime
               */

              /**
               * Constructs a new AbsoluteDateRange.
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange
               * @classdesc Represents an AbsoluteDateRange.
               * @implements IAbsoluteDateRange
               * @constructor
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IAbsoluteDateRange=} [properties] Properties to set
               */
              function AbsoluteDateRange(properties) {
                if (properties)
                  for (
                    var keys = Object.keys(properties), i = 0;
                    i < keys.length;
                    ++i
                  )
                    if (properties[keys[i]] != null)
                      this[keys[i]] = properties[keys[i]];
              }

              /**
               * AbsoluteDateRange onOrAfter.
               * @member {string} onOrAfter
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @instance
               */
              AbsoluteDateRange.prototype.onOrAfter = "";

              /**
               * AbsoluteDateRange before.
               * @member {string} before
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @instance
               */
              AbsoluteDateRange.prototype.before = "";

              /**
               * AbsoluteDateRange includeTime.
               * @member {google.protobuf.IBoolValue|null|undefined} includeTime
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @instance
               */
              AbsoluteDateRange.prototype.includeTime = null;

              /**
               * Creates a new AbsoluteDateRange instance using the specified properties.
               * @function create
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IAbsoluteDateRange=} [properties] Properties to set
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange} AbsoluteDateRange instance
               */
              AbsoluteDateRange.create = function create(properties) {
                return new AbsoluteDateRange(properties);
              };

              /**
               * Encodes the specified AbsoluteDateRange message. Does not implicitly {@link stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.verify|verify} messages.
               * @function encode
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.IAbsoluteDateRange} message AbsoluteDateRange message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */
              AbsoluteDateRange.encode = function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.onOrAfter != null &&
                  Object.hasOwnProperty.call(message, "onOrAfter")
                )
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(message.onOrAfter);
                if (
                  message.before != null &&
                  Object.hasOwnProperty.call(message, "before")
                )
                  writer
                    .uint32(/* id 2, wireType 2 =*/ 18)
                    .string(message.before);
                if (
                  message.includeTime != null &&
                  Object.hasOwnProperty.call(message, "includeTime")
                )
                  $root.google.protobuf.BoolValue.encode(
                    message.includeTime,
                    writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                  ).ldelim();
                return writer;
              };

              /**
               * Decodes an AbsoluteDateRange message from the specified reader or buffer.
               * @function decode
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange} AbsoluteDateRange
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */
              AbsoluteDateRange.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.onOrAfter = reader.string();
                      break;
                    case 2:
                      message.before = reader.string();
                      break;
                    case 3:
                      message.includeTime =
                        $root.google.protobuf.BoolValue.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

              /**
               * Creates an AbsoluteDateRange message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange} AbsoluteDateRange
               */
              AbsoluteDateRange.fromObject = function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360.DateMatch.DateRange
                    .AbsoluteDateRange
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange();
                if (object.onOrAfter != null)
                  message.onOrAfter = String(object.onOrAfter);
                if (object.before != null)
                  message.before = String(object.before);
                if (object.includeTime != null) {
                  if (typeof object.includeTime !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange.includeTime: object expected"
                    );
                  message.includeTime =
                    $root.google.protobuf.BoolValue.fromObject(
                      object.includeTime
                    );
                }
                return message;
              };

              /**
               * Creates a plain object from an AbsoluteDateRange message. Also converts values to other types if specified.
               * @function toObject
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @static
               * @param {stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange} message AbsoluteDateRange
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */
              AbsoluteDateRange.toObject = function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) {
                  object.onOrAfter = "";
                  object.before = "";
                  object.includeTime = null;
                }
                if (
                  message.onOrAfter != null &&
                  message.hasOwnProperty("onOrAfter")
                )
                  object.onOrAfter = message.onOrAfter;
                if (message.before != null && message.hasOwnProperty("before"))
                  object.before = message.before;
                if (
                  message.includeTime != null &&
                  message.hasOwnProperty("includeTime")
                )
                  object.includeTime = $root.google.protobuf.BoolValue.toObject(
                    message.includeTime,
                    options
                  );
                return object;
              };

              /**
               * Converts this AbsoluteDateRange to JSON.
               * @function toJSON
               * @memberof stronachgroup.first.racehorse360.DateMatch.DateRange.AbsoluteDateRange
               * @instance
               * @returns {Object.<string,*>} JSON object
               */
              AbsoluteDateRange.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

              return AbsoluteDateRange;
            })();

            return DateRange;
          })();

          return DateMatch;
        })();

        racehorse360.Coordinates = (function () {
          /**
           * Properties of a Coordinates.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICoordinates
           * @property {number|null} [latitude] Coordinates latitude
           * @property {number|null} [longitude] Coordinates longitude
           */

          /**
           * Constructs a new Coordinates.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Coordinates.
           * @implements ICoordinates
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICoordinates=} [properties] Properties to set
           */
          function Coordinates(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Coordinates latitude.
           * @member {number} latitude
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @instance
           */
          Coordinates.prototype.latitude = 0;

          /**
           * Coordinates longitude.
           * @member {number} longitude
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @instance
           */
          Coordinates.prototype.longitude = 0;

          /**
           * Creates a new Coordinates instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @static
           * @param {stronachgroup.first.racehorse360.ICoordinates=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Coordinates} Coordinates instance
           */
          Coordinates.create = function create(properties) {
            return new Coordinates(properties);
          };

          /**
           * Encodes the specified Coordinates message. Does not implicitly {@link stronachgroup.first.racehorse360.Coordinates.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @static
           * @param {stronachgroup.first.racehorse360.ICoordinates} message Coordinates message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Coordinates.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.latitude != null &&
              Object.hasOwnProperty.call(message, "latitude")
            )
              writer.uint32(/* id 1, wireType 5 =*/ 13).float(message.latitude);
            if (
              message.longitude != null &&
              Object.hasOwnProperty.call(message, "longitude")
            )
              writer
                .uint32(/* id 2, wireType 5 =*/ 21)
                .float(message.longitude);
            return writer;
          };

          /**
           * Decodes a Coordinates message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Coordinates} Coordinates
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Coordinates.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.Coordinates();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.latitude = reader.float();
                  break;
                case 2:
                  message.longitude = reader.float();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Coordinates message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Coordinates} Coordinates
           */
          Coordinates.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.Coordinates
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.Coordinates();
            if (object.latitude != null)
              message.latitude = Number(object.latitude);
            if (object.longitude != null)
              message.longitude = Number(object.longitude);
            return message;
          };

          /**
           * Creates a plain object from a Coordinates message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @static
           * @param {stronachgroup.first.racehorse360.Coordinates} message Coordinates
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Coordinates.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.latitude = 0;
              object.longitude = 0;
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
              object.latitude =
                options.json && !isFinite(message.latitude)
                  ? String(message.latitude)
                  : message.latitude;
            if (
              message.longitude != null &&
              message.hasOwnProperty("longitude")
            )
              object.longitude =
                options.json && !isFinite(message.longitude)
                  ? String(message.longitude)
                  : message.longitude;
            return object;
          };

          /**
           * Converts this Coordinates to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Coordinates
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Coordinates.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Coordinates;
        })();

        racehorse360.Barn = (function () {
          /**
           * Properties of a Barn.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBarn
           * @property {string|null} [id] Barn id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] Barn facility
           * @property {string|null} [name] Barn name
           */

          /**
           * Constructs a new Barn.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Barn.
           * @implements IBarn
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBarn=} [properties] Properties to set
           */
          function Barn(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Barn id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Barn
           * @instance
           */
          Barn.prototype.id = "";

          /**
           * Barn facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.Barn
           * @instance
           */
          Barn.prototype.facility = null;

          /**
           * Barn name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Barn
           * @instance
           */
          Barn.prototype.name = "";

          /**
           * Creates a new Barn instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Barn
           * @static
           * @param {stronachgroup.first.racehorse360.IBarn=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Barn} Barn instance
           */
          Barn.create = function create(properties) {
            return new Barn(properties);
          };

          /**
           * Encodes the specified Barn message. Does not implicitly {@link stronachgroup.first.racehorse360.Barn.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Barn
           * @static
           * @param {stronachgroup.first.racehorse360.IBarn} message Barn message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Barn.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
            return writer;
          };

          /**
           * Decodes a Barn message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Barn
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Barn} Barn
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Barn.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Barn();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.name = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Barn message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Barn
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Barn} Barn
           */
          Barn.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Barn)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Barn();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Barn.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.name != null) message.name = String(object.name);
            return message;
          };

          /**
           * Creates a plain object from a Barn message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Barn
           * @static
           * @param {stronachgroup.first.racehorse360.Barn} message Barn
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Barn.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            return object;
          };

          /**
           * Converts this Barn to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Barn
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Barn.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Barn;
        })();

        racehorse360.BarnFilter = (function () {
          /**
           * Properties of a BarnFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBarnFilter
           * @property {Array.<string>|null} [ids] BarnFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [name] BarnFilter name
           * @property {string|null} [facilityId] BarnFilter facilityId
           */

          /**
           * Constructs a new BarnFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a BarnFilter.
           * @implements IBarnFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBarnFilter=} [properties] Properties to set
           */
          function BarnFilter(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * BarnFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @instance
           */
          BarnFilter.prototype.ids = $util.emptyArray;

          /**
           * BarnFilter name.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} name
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @instance
           */
          BarnFilter.prototype.name = null;

          /**
           * BarnFilter facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @instance
           */
          BarnFilter.prototype.facilityId = "";

          /**
           * Creates a new BarnFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IBarnFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.BarnFilter} BarnFilter instance
           */
          BarnFilter.create = function create(properties) {
            return new BarnFilter(properties);
          };

          /**
           * Encodes the specified BarnFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.BarnFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IBarnFilter} message BarnFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          BarnFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.name,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.facilityId);
            return writer;
          };

          /**
           * Decodes a BarnFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.BarnFilter} BarnFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          BarnFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.BarnFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.name =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.facilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a BarnFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.BarnFilter} BarnFilter
           */
          BarnFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.BarnFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.BarnFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BarnFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.name != null) {
              if (typeof object.name !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BarnFilter.name: object expected"
                );
              message.name =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.name
                );
            }
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            return message;
          };

          /**
           * Creates a plain object from a BarnFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @static
           * @param {stronachgroup.first.racehorse360.BarnFilter} message BarnFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          BarnFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.name = null;
              object.facilityId = "";
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
              object.name =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.name,
                  options
                );
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            return object;
          };

          /**
           * Converts this BarnFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.BarnFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          BarnFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return BarnFilter;
        })();

        racehorse360.GetBarnRequest = (function () {
          /**
           * Properties of a GetBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetBarnRequest
           * @property {string|null} [id] GetBarnRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetBarnRequest getOptions
           */

          /**
           * Constructs a new GetBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetBarnRequest.
           * @implements IGetBarnRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetBarnRequest=} [properties] Properties to set
           */
          function GetBarnRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetBarnRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @instance
           */
          GetBarnRequest.prototype.id = "";

          /**
           * GetBarnRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @instance
           */
          GetBarnRequest.prototype.getOptions = null;

          /**
           * Creates a new GetBarnRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetBarnRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetBarnRequest} GetBarnRequest instance
           */
          GetBarnRequest.create = function create(properties) {
            return new GetBarnRequest(properties);
          };

          /**
           * Encodes the specified GetBarnRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetBarnRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetBarnRequest} message GetBarnRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetBarnRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetBarnRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetBarnRequest} GetBarnRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetBarnRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetBarnRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetBarnRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetBarnRequest} GetBarnRequest
           */
          GetBarnRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetBarnRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetBarnRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetBarnRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetBarnRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetBarnRequest} message GetBarnRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetBarnRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetBarnRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetBarnRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetBarnRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetBarnRequest;
        })();

        racehorse360.ListBarnsRequest = (function () {
          /**
           * Properties of a ListBarnsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListBarnsRequest
           * @property {stronachgroup.first.racehorse360.IBarnFilter|null} [query] ListBarnsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListBarnsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListBarnsRequest pagingOptions
           */

          /**
           * Constructs a new ListBarnsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListBarnsRequest.
           * @implements IListBarnsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListBarnsRequest=} [properties] Properties to set
           */
          function ListBarnsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListBarnsRequest query.
           * @member {stronachgroup.first.racehorse360.IBarnFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @instance
           */
          ListBarnsRequest.prototype.query = null;

          /**
           * ListBarnsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @instance
           */
          ListBarnsRequest.prototype.getOptions = null;

          /**
           * ListBarnsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @instance
           */
          ListBarnsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListBarnsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListBarnsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListBarnsRequest} ListBarnsRequest instance
           */
          ListBarnsRequest.create = function create(properties) {
            return new ListBarnsRequest(properties);
          };

          /**
           * Encodes the specified ListBarnsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListBarnsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListBarnsRequest} message ListBarnsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListBarnsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.BarnFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListBarnsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListBarnsRequest} ListBarnsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListBarnsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListBarnsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.BarnFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListBarnsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListBarnsRequest} ListBarnsRequest
           */
          ListBarnsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListBarnsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListBarnsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListBarnsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.BarnFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListBarnsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListBarnsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListBarnsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListBarnsRequest} message ListBarnsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListBarnsRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.BarnFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListBarnsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListBarnsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListBarnsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListBarnsRequest;
        })();

        racehorse360.ListBarnsResponse = (function () {
          /**
           * Properties of a ListBarnsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListBarnsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IBarn>|null} [barns] ListBarnsResponse barns
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListBarnsResponse pagingInfo
           */

          /**
           * Constructs a new ListBarnsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListBarnsResponse.
           * @implements IListBarnsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListBarnsResponse=} [properties] Properties to set
           */
          function ListBarnsResponse(properties) {
            this.barns = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListBarnsResponse barns.
           * @member {Array.<stronachgroup.first.racehorse360.IBarn>} barns
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @instance
           */
          ListBarnsResponse.prototype.barns = $util.emptyArray;

          /**
           * ListBarnsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @instance
           */
          ListBarnsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListBarnsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListBarnsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListBarnsResponse} ListBarnsResponse instance
           */
          ListBarnsResponse.create = function create(properties) {
            return new ListBarnsResponse(properties);
          };

          /**
           * Encodes the specified ListBarnsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListBarnsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListBarnsResponse} message ListBarnsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListBarnsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.barns != null && message.barns.length)
              for (var i = 0; i < message.barns.length; ++i)
                $root.stronachgroup.first.racehorse360.Barn.encode(
                  message.barns[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListBarnsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListBarnsResponse} ListBarnsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListBarnsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListBarnsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.barns && message.barns.length))
                    message.barns = [];
                  message.barns.push(
                    $root.stronachgroup.first.racehorse360.Barn.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListBarnsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListBarnsResponse} ListBarnsResponse
           */
          ListBarnsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListBarnsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListBarnsResponse();
            if (object.barns) {
              if (!Array.isArray(object.barns))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListBarnsResponse.barns: array expected"
                );
              message.barns = [];
              for (var i = 0; i < object.barns.length; ++i) {
                if (typeof object.barns[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListBarnsResponse.barns: object expected"
                  );
                message.barns[i] =
                  $root.stronachgroup.first.racehorse360.Barn.fromObject(
                    object.barns[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListBarnsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListBarnsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListBarnsResponse} message ListBarnsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListBarnsResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.barns = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.barns && message.barns.length) {
              object.barns = [];
              for (var j = 0; j < message.barns.length; ++j)
                object.barns[j] =
                  $root.stronachgroup.first.racehorse360.Barn.toObject(
                    message.barns[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListBarnsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListBarnsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListBarnsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListBarnsResponse;
        })();

        racehorse360.Facility = (function () {
          /**
           * Properties of a Facility.
           * @memberof stronachgroup.first.racehorse360
           * @interface IFacility
           * @property {string|null} [id] Facility id
           * @property {string|null} [name] Facility name
           * @property {string|null} [code] Facility code
           * @property {string|null} [backgroundColor] Facility backgroundColor
           * @property {string|null} [foregroundColor] Facility foregroundColor
           * @property {string|null} [strokeColor] Facility strokeColor
           * @property {stronachgroup.first.racehorse360.FacilityType|null} [type] Facility type
           * @property {string|null} [country] Facility country
           * @property {boolean|null} [isTrackFacility] Facility isTrackFacility
           * @property {Array.<stronachgroup.first.racehorse360.IFacility>|null} [trainingFacilities] Facility trainingFacilities
           * @property {boolean|null} [active] Facility active
           * @property {number|null} [latitude] Facility latitude
           * @property {number|null} [longitude] Facility longitude
           * @property {string|null} [timezone] Facility timezone
           * @property {number|null} [workoutRequiredDaysOff] Facility workoutRequiredDaysOff
           * @property {stronachgroup.first.racehorse360.IRegion|null} [region] Facility region
           * @property {number|null} [shutOffHours] Facility shutOffHours
           * @property {number|null} [shutOffPeriodInHours] Facility shutOffPeriodInHours
           * @property {stronachgroup.first.racehorse360.FacilityScope|null} [scope] Facility scope
           * @property {string|null} [shortName] Facility shortName
           */

          /**
           * Constructs a new Facility.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Facility.
           * @implements IFacility
           * @constructor
           * @param {stronachgroup.first.racehorse360.IFacility=} [properties] Properties to set
           */
          function Facility(properties) {
            this.trainingFacilities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Facility id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.id = "";

          /**
           * Facility name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.name = "";

          /**
           * Facility code.
           * @member {string} code
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.code = "";

          /**
           * Facility backgroundColor.
           * @member {string} backgroundColor
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.backgroundColor = "";

          /**
           * Facility foregroundColor.
           * @member {string} foregroundColor
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.foregroundColor = "";

          /**
           * Facility strokeColor.
           * @member {string} strokeColor
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.strokeColor = "";

          /**
           * Facility type.
           * @member {stronachgroup.first.racehorse360.FacilityType} type
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.type = 0;

          /**
           * Facility country.
           * @member {string} country
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.country = "";

          /**
           * Facility isTrackFacility.
           * @member {boolean} isTrackFacility
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.isTrackFacility = false;

          /**
           * Facility trainingFacilities.
           * @member {Array.<stronachgroup.first.racehorse360.IFacility>} trainingFacilities
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.trainingFacilities = $util.emptyArray;

          /**
           * Facility active.
           * @member {boolean} active
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.active = false;

          /**
           * Facility latitude.
           * @member {number} latitude
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.latitude = 0;

          /**
           * Facility longitude.
           * @member {number} longitude
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.longitude = 0;

          /**
           * Facility timezone.
           * @member {string} timezone
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.timezone = "";

          /**
           * Facility workoutRequiredDaysOff.
           * @member {number} workoutRequiredDaysOff
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.workoutRequiredDaysOff = 0;

          /**
           * Facility region.
           * @member {stronachgroup.first.racehorse360.IRegion|null|undefined} region
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.region = null;

          /**
           * Facility shutOffHours.
           * @member {number} shutOffHours
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.shutOffHours = 0;

          /**
           * Facility shutOffPeriodInHours.
           * @member {number} shutOffPeriodInHours
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.shutOffPeriodInHours = 0;

          /**
           * Facility scope.
           * @member {stronachgroup.first.racehorse360.FacilityScope} scope
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.scope = 0;

          /**
           * Facility shortName.
           * @member {string} shortName
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           */
          Facility.prototype.shortName = "";

          /**
           * Creates a new Facility instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Facility
           * @static
           * @param {stronachgroup.first.racehorse360.IFacility=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Facility} Facility instance
           */
          Facility.create = function create(properties) {
            return new Facility(properties);
          };

          /**
           * Encodes the specified Facility message. Does not implicitly {@link stronachgroup.first.racehorse360.Facility.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Facility
           * @static
           * @param {stronachgroup.first.racehorse360.IFacility} message Facility message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Facility.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            if (
              message.code != null &&
              Object.hasOwnProperty.call(message, "code")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.code);
            if (
              message.backgroundColor != null &&
              Object.hasOwnProperty.call(message, "backgroundColor")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.backgroundColor);
            if (
              message.foregroundColor != null &&
              Object.hasOwnProperty.call(message, "foregroundColor")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.foregroundColor);
            if (
              message.strokeColor != null &&
              Object.hasOwnProperty.call(message, "strokeColor")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.strokeColor);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.type);
            if (
              message.country != null &&
              Object.hasOwnProperty.call(message, "country")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.country);
            if (
              message.isTrackFacility != null &&
              Object.hasOwnProperty.call(message, "isTrackFacility")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .bool(message.isTrackFacility);
            if (
              message.trainingFacilities != null &&
              message.trainingFacilities.length
            )
              for (var i = 0; i < message.trainingFacilities.length; ++i)
                $root.stronachgroup.first.racehorse360.Facility.encode(
                  message.trainingFacilities[i],
                  writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
                ).ldelim();
            if (
              message.active != null &&
              Object.hasOwnProperty.call(message, "active")
            )
              writer.uint32(/* id 100, wireType 0 =*/ 800).bool(message.active);
            if (
              message.latitude != null &&
              Object.hasOwnProperty.call(message, "latitude")
            )
              writer
                .uint32(/* id 101, wireType 5 =*/ 813)
                .float(message.latitude);
            if (
              message.longitude != null &&
              Object.hasOwnProperty.call(message, "longitude")
            )
              writer
                .uint32(/* id 102, wireType 5 =*/ 821)
                .float(message.longitude);
            if (
              message.timezone != null &&
              Object.hasOwnProperty.call(message, "timezone")
            )
              writer
                .uint32(/* id 105, wireType 2 =*/ 842)
                .string(message.timezone);
            if (
              message.workoutRequiredDaysOff != null &&
              Object.hasOwnProperty.call(message, "workoutRequiredDaysOff")
            )
              writer
                .uint32(/* id 106, wireType 0 =*/ 848)
                .int32(message.workoutRequiredDaysOff);
            if (
              message.region != null &&
              Object.hasOwnProperty.call(message, "region")
            )
              $root.stronachgroup.first.racehorse360.Region.encode(
                message.region,
                writer.uint32(/* id 107, wireType 2 =*/ 858).fork()
              ).ldelim();
            if (
              message.shutOffHours != null &&
              Object.hasOwnProperty.call(message, "shutOffHours")
            )
              writer
                .uint32(/* id 108, wireType 0 =*/ 864)
                .int32(message.shutOffHours);
            if (
              message.shutOffPeriodInHours != null &&
              Object.hasOwnProperty.call(message, "shutOffPeriodInHours")
            )
              writer
                .uint32(/* id 109, wireType 0 =*/ 872)
                .int32(message.shutOffPeriodInHours);
            if (
              message.scope != null &&
              Object.hasOwnProperty.call(message, "scope")
            )
              writer.uint32(/* id 110, wireType 0 =*/ 880).int32(message.scope);
            if (
              message.shortName != null &&
              Object.hasOwnProperty.call(message, "shortName")
            )
              writer
                .uint32(/* id 111, wireType 2 =*/ 890)
                .string(message.shortName);
            return writer;
          };

          /**
           * Decodes a Facility message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Facility
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Facility} Facility
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Facility.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Facility();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                case 3:
                  message.code = reader.string();
                  break;
                case 4:
                  message.backgroundColor = reader.string();
                  break;
                case 5:
                  message.foregroundColor = reader.string();
                  break;
                case 6:
                  message.strokeColor = reader.string();
                  break;
                case 7:
                  message.type = reader.int32();
                  break;
                case 8:
                  message.country = reader.string();
                  break;
                case 9:
                  message.isTrackFacility = reader.bool();
                  break;
                case 10:
                  if (
                    !(
                      message.trainingFacilities &&
                      message.trainingFacilities.length
                    )
                  )
                    message.trainingFacilities = [];
                  message.trainingFacilities.push(
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.active = reader.bool();
                  break;
                case 101:
                  message.latitude = reader.float();
                  break;
                case 102:
                  message.longitude = reader.float();
                  break;
                case 105:
                  message.timezone = reader.string();
                  break;
                case 106:
                  message.workoutRequiredDaysOff = reader.int32();
                  break;
                case 107:
                  message.region =
                    $root.stronachgroup.first.racehorse360.Region.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 108:
                  message.shutOffHours = reader.int32();
                  break;
                case 109:
                  message.shutOffPeriodInHours = reader.int32();
                  break;
                case 110:
                  message.scope = reader.int32();
                  break;
                case 111:
                  message.shortName = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Facility message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Facility
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Facility} Facility
           */
          Facility.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Facility
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Facility();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            if (object.code != null) message.code = String(object.code);
            if (object.backgroundColor != null)
              message.backgroundColor = String(object.backgroundColor);
            if (object.foregroundColor != null)
              message.foregroundColor = String(object.foregroundColor);
            if (object.strokeColor != null)
              message.strokeColor = String(object.strokeColor);
            switch (object.type) {
              case "FACILITY_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "FACILITY_TYPE_TRAINING_CENTER":
              case 1:
                message.type = 1;
                break;
              case "FACILITY_TYPE_TRACK":
              case 2:
                message.type = 2;
                break;
            }
            if (object.country != null)
              message.country = String(object.country);
            if (object.isTrackFacility != null)
              message.isTrackFacility = Boolean(object.isTrackFacility);
            if (object.trainingFacilities) {
              if (!Array.isArray(object.trainingFacilities))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Facility.trainingFacilities: array expected"
                );
              message.trainingFacilities = [];
              for (var i = 0; i < object.trainingFacilities.length; ++i) {
                if (typeof object.trainingFacilities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.Facility.trainingFacilities: object expected"
                  );
                message.trainingFacilities[i] =
                  $root.stronachgroup.first.racehorse360.Facility.fromObject(
                    object.trainingFacilities[i]
                  );
              }
            }
            if (object.active != null) message.active = Boolean(object.active);
            if (object.latitude != null)
              message.latitude = Number(object.latitude);
            if (object.longitude != null)
              message.longitude = Number(object.longitude);
            if (object.timezone != null)
              message.timezone = String(object.timezone);
            if (object.workoutRequiredDaysOff != null)
              message.workoutRequiredDaysOff =
                object.workoutRequiredDaysOff | 0;
            if (object.region != null) {
              if (typeof object.region !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Facility.region: object expected"
                );
              message.region =
                $root.stronachgroup.first.racehorse360.Region.fromObject(
                  object.region
                );
            }
            if (object.shutOffHours != null)
              message.shutOffHours = object.shutOffHours | 0;
            if (object.shutOffPeriodInHours != null)
              message.shutOffPeriodInHours = object.shutOffPeriodInHours | 0;
            switch (object.scope) {
              case "FACILITY_SCOPE_INVALID":
              case 0:
                message.scope = 0;
                break;
              case "FACILITY_SCOPE_TSG":
              case 1:
                message.scope = 1;
                break;
              case "FACILITY_SCOPE_DEL_MAR":
              case 2:
                message.scope = 2;
                break;
              case "FACILITY_SCOPE_OTHER":
              case 3:
                message.scope = 3;
                break;
            }
            if (object.shortName != null)
              message.shortName = String(object.shortName);
            return message;
          };

          /**
           * Creates a plain object from a Facility message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Facility
           * @static
           * @param {stronachgroup.first.racehorse360.Facility} message Facility
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Facility.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.trainingFacilities = [];
            if (options.defaults) {
              object.id = "";
              object.name = "";
              object.code = "";
              object.backgroundColor = "";
              object.foregroundColor = "";
              object.strokeColor = "";
              object.type =
                options.enums === String ? "FACILITY_TYPE_INVALID" : 0;
              object.country = "";
              object.isTrackFacility = false;
              object.active = false;
              object.latitude = 0;
              object.longitude = 0;
              object.timezone = "";
              object.workoutRequiredDaysOff = 0;
              object.region = null;
              object.shutOffHours = 0;
              object.shutOffPeriodInHours = 0;
              object.scope =
                options.enums === String ? "FACILITY_SCOPE_INVALID" : 0;
              object.shortName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.code != null && message.hasOwnProperty("code"))
              object.code = message.code;
            if (
              message.backgroundColor != null &&
              message.hasOwnProperty("backgroundColor")
            )
              object.backgroundColor = message.backgroundColor;
            if (
              message.foregroundColor != null &&
              message.hasOwnProperty("foregroundColor")
            )
              object.foregroundColor = message.foregroundColor;
            if (
              message.strokeColor != null &&
              message.hasOwnProperty("strokeColor")
            )
              object.strokeColor = message.strokeColor;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.FacilityType[
                      message.type
                    ]
                  : message.type;
            if (message.country != null && message.hasOwnProperty("country"))
              object.country = message.country;
            if (
              message.isTrackFacility != null &&
              message.hasOwnProperty("isTrackFacility")
            )
              object.isTrackFacility = message.isTrackFacility;
            if (
              message.trainingFacilities &&
              message.trainingFacilities.length
            ) {
              object.trainingFacilities = [];
              for (var j = 0; j < message.trainingFacilities.length; ++j)
                object.trainingFacilities[j] =
                  $root.stronachgroup.first.racehorse360.Facility.toObject(
                    message.trainingFacilities[j],
                    options
                  );
            }
            if (message.active != null && message.hasOwnProperty("active"))
              object.active = message.active;
            if (message.latitude != null && message.hasOwnProperty("latitude"))
              object.latitude =
                options.json && !isFinite(message.latitude)
                  ? String(message.latitude)
                  : message.latitude;
            if (
              message.longitude != null &&
              message.hasOwnProperty("longitude")
            )
              object.longitude =
                options.json && !isFinite(message.longitude)
                  ? String(message.longitude)
                  : message.longitude;
            if (message.timezone != null && message.hasOwnProperty("timezone"))
              object.timezone = message.timezone;
            if (
              message.workoutRequiredDaysOff != null &&
              message.hasOwnProperty("workoutRequiredDaysOff")
            )
              object.workoutRequiredDaysOff = message.workoutRequiredDaysOff;
            if (message.region != null && message.hasOwnProperty("region"))
              object.region =
                $root.stronachgroup.first.racehorse360.Region.toObject(
                  message.region,
                  options
                );
            if (
              message.shutOffHours != null &&
              message.hasOwnProperty("shutOffHours")
            )
              object.shutOffHours = message.shutOffHours;
            if (
              message.shutOffPeriodInHours != null &&
              message.hasOwnProperty("shutOffPeriodInHours")
            )
              object.shutOffPeriodInHours = message.shutOffPeriodInHours;
            if (message.scope != null && message.hasOwnProperty("scope"))
              object.scope =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.FacilityScope[
                      message.scope
                    ]
                  : message.scope;
            if (
              message.shortName != null &&
              message.hasOwnProperty("shortName")
            )
              object.shortName = message.shortName;
            return object;
          };

          /**
           * Converts this Facility to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Facility
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Facility.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Facility;
        })();

        racehorse360.FacilityFilter = (function () {
          /**
           * Properties of a FacilityFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IFacilityFilter
           * @property {Array.<string>|null} [ids] FacilityFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [name] FacilityFilter name
           * @property {string|null} [code] FacilityFilter code
           * @property {google.protobuf.IBoolValue|null} [isActive] FacilityFilter isActive
           * @property {google.protobuf.IBoolValue|null} [isTrack] FacilityFilter isTrack
           */

          /**
           * Constructs a new FacilityFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FacilityFilter.
           * @implements IFacilityFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IFacilityFilter=} [properties] Properties to set
           */
          function FacilityFilter(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FacilityFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           */
          FacilityFilter.prototype.ids = $util.emptyArray;

          /**
           * FacilityFilter name.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} name
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           */
          FacilityFilter.prototype.name = null;

          /**
           * FacilityFilter code.
           * @member {string} code
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           */
          FacilityFilter.prototype.code = "";

          /**
           * FacilityFilter isActive.
           * @member {google.protobuf.IBoolValue|null|undefined} isActive
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           */
          FacilityFilter.prototype.isActive = null;

          /**
           * FacilityFilter isTrack.
           * @member {google.protobuf.IBoolValue|null|undefined} isTrack
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           */
          FacilityFilter.prototype.isTrack = null;

          /**
           * Creates a new FacilityFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.FacilityFilter} FacilityFilter instance
           */
          FacilityFilter.create = function create(properties) {
            return new FacilityFilter(properties);
          };

          /**
           * Encodes the specified FacilityFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.FacilityFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityFilter} message FacilityFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FacilityFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.name,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.code != null &&
              Object.hasOwnProperty.call(message, "code")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.code);
            if (
              message.isActive != null &&
              Object.hasOwnProperty.call(message, "isActive")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isActive,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.isTrack != null &&
              Object.hasOwnProperty.call(message, "isTrack")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isTrack,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a FacilityFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.FacilityFilter} FacilityFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FacilityFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.FacilityFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.name =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.code = reader.string();
                  break;
                case 4:
                  message.isActive = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 5:
                  message.isTrack = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FacilityFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.FacilityFilter} FacilityFilter
           */
          FacilityFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.FacilityFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.FacilityFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.name != null) {
              if (typeof object.name !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityFilter.name: object expected"
                );
              message.name =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.name
                );
            }
            if (object.code != null) message.code = String(object.code);
            if (object.isActive != null) {
              if (typeof object.isActive !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityFilter.isActive: object expected"
                );
              message.isActive = $root.google.protobuf.BoolValue.fromObject(
                object.isActive
              );
            }
            if (object.isTrack != null) {
              if (typeof object.isTrack !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityFilter.isTrack: object expected"
                );
              message.isTrack = $root.google.protobuf.BoolValue.fromObject(
                object.isTrack
              );
            }
            return message;
          };

          /**
           * Creates a plain object from a FacilityFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.FacilityFilter} message FacilityFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FacilityFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.name = null;
              object.code = "";
              object.isActive = null;
              object.isTrack = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
              object.name =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.name,
                  options
                );
            if (message.code != null && message.hasOwnProperty("code"))
              object.code = message.code;
            if (message.isActive != null && message.hasOwnProperty("isActive"))
              object.isActive = $root.google.protobuf.BoolValue.toObject(
                message.isActive,
                options
              );
            if (message.isTrack != null && message.hasOwnProperty("isTrack"))
              object.isTrack = $root.google.protobuf.BoolValue.toObject(
                message.isTrack,
                options
              );
            return object;
          };

          /**
           * Converts this FacilityFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.FacilityFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FacilityFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FacilityFilter;
        })();

        racehorse360.GetFacilityRequest = (function () {
          /**
           * Properties of a GetFacilityRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetFacilityRequest
           * @property {string|null} [id] GetFacilityRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetFacilityRequest getOptions
           */

          /**
           * Constructs a new GetFacilityRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetFacilityRequest.
           * @implements IGetFacilityRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetFacilityRequest=} [properties] Properties to set
           */
          function GetFacilityRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetFacilityRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @instance
           */
          GetFacilityRequest.prototype.id = "";

          /**
           * GetFacilityRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @instance
           */
          GetFacilityRequest.prototype.getOptions = null;

          /**
           * Creates a new GetFacilityRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetFacilityRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetFacilityRequest} GetFacilityRequest instance
           */
          GetFacilityRequest.create = function create(properties) {
            return new GetFacilityRequest(properties);
          };

          /**
           * Encodes the specified GetFacilityRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetFacilityRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetFacilityRequest} message GetFacilityRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetFacilityRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetFacilityRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetFacilityRequest} GetFacilityRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetFacilityRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetFacilityRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetFacilityRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetFacilityRequest} GetFacilityRequest
           */
          GetFacilityRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetFacilityRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetFacilityRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetFacilityRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetFacilityRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetFacilityRequest} message GetFacilityRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetFacilityRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetFacilityRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetFacilityRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetFacilityRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetFacilityRequest;
        })();

        racehorse360.ListFacilitiesRequest = (function () {
          /**
           * Properties of a ListFacilitiesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListFacilitiesRequest
           * @property {stronachgroup.first.racehorse360.IFacilityFilter|null} [query] ListFacilitiesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListFacilitiesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListFacilitiesRequest pagingOptions
           */

          /**
           * Constructs a new ListFacilitiesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListFacilitiesRequest.
           * @implements IListFacilitiesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListFacilitiesRequest=} [properties] Properties to set
           */
          function ListFacilitiesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListFacilitiesRequest query.
           * @member {stronachgroup.first.racehorse360.IFacilityFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @instance
           */
          ListFacilitiesRequest.prototype.query = null;

          /**
           * ListFacilitiesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @instance
           */
          ListFacilitiesRequest.prototype.getOptions = null;

          /**
           * ListFacilitiesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @instance
           */
          ListFacilitiesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListFacilitiesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListFacilitiesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesRequest} ListFacilitiesRequest instance
           */
          ListFacilitiesRequest.create = function create(properties) {
            return new ListFacilitiesRequest(properties);
          };

          /**
           * Encodes the specified ListFacilitiesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListFacilitiesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListFacilitiesRequest} message ListFacilitiesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListFacilitiesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.FacilityFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListFacilitiesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesRequest} ListFacilitiesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListFacilitiesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListFacilitiesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.FacilityFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListFacilitiesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesRequest} ListFacilitiesRequest
           */
          ListFacilitiesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListFacilitiesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListFacilitiesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListFacilitiesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.FacilityFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListFacilitiesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListFacilitiesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListFacilitiesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListFacilitiesRequest} message ListFacilitiesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListFacilitiesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.FacilityFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListFacilitiesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListFacilitiesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListFacilitiesRequest;
        })();

        racehorse360.ListFacilitiesResponse = (function () {
          /**
           * Properties of a ListFacilitiesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListFacilitiesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IFacility>|null} [facilities] ListFacilitiesResponse facilities
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListFacilitiesResponse pagingInfo
           */

          /**
           * Constructs a new ListFacilitiesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListFacilitiesResponse.
           * @implements IListFacilitiesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListFacilitiesResponse=} [properties] Properties to set
           */
          function ListFacilitiesResponse(properties) {
            this.facilities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListFacilitiesResponse facilities.
           * @member {Array.<stronachgroup.first.racehorse360.IFacility>} facilities
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @instance
           */
          ListFacilitiesResponse.prototype.facilities = $util.emptyArray;

          /**
           * ListFacilitiesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @instance
           */
          ListFacilitiesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListFacilitiesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListFacilitiesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesResponse} ListFacilitiesResponse instance
           */
          ListFacilitiesResponse.create = function create(properties) {
            return new ListFacilitiesResponse(properties);
          };

          /**
           * Encodes the specified ListFacilitiesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListFacilitiesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListFacilitiesResponse} message ListFacilitiesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListFacilitiesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.facilities != null && message.facilities.length)
              for (var i = 0; i < message.facilities.length; ++i)
                $root.stronachgroup.first.racehorse360.Facility.encode(
                  message.facilities[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListFacilitiesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesResponse} ListFacilitiesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListFacilitiesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListFacilitiesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilities && message.facilities.length))
                    message.facilities = [];
                  message.facilities.push(
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListFacilitiesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListFacilitiesResponse} ListFacilitiesResponse
           */
          ListFacilitiesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListFacilitiesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListFacilitiesResponse();
            if (object.facilities) {
              if (!Array.isArray(object.facilities))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListFacilitiesResponse.facilities: array expected"
                );
              message.facilities = [];
              for (var i = 0; i < object.facilities.length; ++i) {
                if (typeof object.facilities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListFacilitiesResponse.facilities: object expected"
                  );
                message.facilities[i] =
                  $root.stronachgroup.first.racehorse360.Facility.fromObject(
                    object.facilities[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListFacilitiesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListFacilitiesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListFacilitiesResponse} message ListFacilitiesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListFacilitiesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilities = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.facilities && message.facilities.length) {
              object.facilities = [];
              for (var j = 0; j < message.facilities.length; ++j)
                object.facilities[j] =
                  $root.stronachgroup.first.racehorse360.Facility.toObject(
                    message.facilities[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListFacilitiesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListFacilitiesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListFacilitiesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListFacilitiesResponse;
        })();

        racehorse360.EditFacilityInfoRequest = (function () {
          /**
           * Properties of an EditFacilityInfoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditFacilityInfoRequest
           * @property {string|null} [id] EditFacilityInfoRequest id
           * @property {google.protobuf.IStringValue|null} [backgroundColor] EditFacilityInfoRequest backgroundColor
           * @property {google.protobuf.IStringValue|null} [foregroundColor] EditFacilityInfoRequest foregroundColor
           * @property {google.protobuf.IStringValue|null} [strokeColor] EditFacilityInfoRequest strokeColor
           * @property {google.protobuf.IFloatValue|null} [latitude] EditFacilityInfoRequest latitude
           * @property {google.protobuf.IFloatValue|null} [longitude] EditFacilityInfoRequest longitude
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditFacilityInfoRequest getOptions
           */

          /**
           * Constructs a new EditFacilityInfoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditFacilityInfoRequest.
           * @implements IEditFacilityInfoRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditFacilityInfoRequest=} [properties] Properties to set
           */
          function EditFacilityInfoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditFacilityInfoRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.id = "";

          /**
           * EditFacilityInfoRequest backgroundColor.
           * @member {google.protobuf.IStringValue|null|undefined} backgroundColor
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.backgroundColor = null;

          /**
           * EditFacilityInfoRequest foregroundColor.
           * @member {google.protobuf.IStringValue|null|undefined} foregroundColor
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.foregroundColor = null;

          /**
           * EditFacilityInfoRequest strokeColor.
           * @member {google.protobuf.IStringValue|null|undefined} strokeColor
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.strokeColor = null;

          /**
           * EditFacilityInfoRequest latitude.
           * @member {google.protobuf.IFloatValue|null|undefined} latitude
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.latitude = null;

          /**
           * EditFacilityInfoRequest longitude.
           * @member {google.protobuf.IFloatValue|null|undefined} longitude
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.longitude = null;

          /**
           * EditFacilityInfoRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           */
          EditFacilityInfoRequest.prototype.getOptions = null;

          /**
           * Creates a new EditFacilityInfoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditFacilityInfoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditFacilityInfoRequest} EditFacilityInfoRequest instance
           */
          EditFacilityInfoRequest.create = function create(properties) {
            return new EditFacilityInfoRequest(properties);
          };

          /**
           * Encodes the specified EditFacilityInfoRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditFacilityInfoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditFacilityInfoRequest} message EditFacilityInfoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditFacilityInfoRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.backgroundColor != null &&
              Object.hasOwnProperty.call(message, "backgroundColor")
            )
              $root.google.protobuf.StringValue.encode(
                message.backgroundColor,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.foregroundColor != null &&
              Object.hasOwnProperty.call(message, "foregroundColor")
            )
              $root.google.protobuf.StringValue.encode(
                message.foregroundColor,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.strokeColor != null &&
              Object.hasOwnProperty.call(message, "strokeColor")
            )
              $root.google.protobuf.StringValue.encode(
                message.strokeColor,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.latitude != null &&
              Object.hasOwnProperty.call(message, "latitude")
            )
              $root.google.protobuf.FloatValue.encode(
                message.latitude,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.longitude != null &&
              Object.hasOwnProperty.call(message, "longitude")
            )
              $root.google.protobuf.FloatValue.encode(
                message.longitude,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditFacilityInfoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditFacilityInfoRequest} EditFacilityInfoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditFacilityInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditFacilityInfoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.backgroundColor =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.foregroundColor =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.strokeColor =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.latitude = $root.google.protobuf.FloatValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 6:
                  message.longitude = $root.google.protobuf.FloatValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditFacilityInfoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditFacilityInfoRequest} EditFacilityInfoRequest
           */
          EditFacilityInfoRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EditFacilityInfoRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditFacilityInfoRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.backgroundColor != null) {
              if (typeof object.backgroundColor !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.backgroundColor: object expected"
                );
              message.backgroundColor =
                $root.google.protobuf.StringValue.fromObject(
                  object.backgroundColor
                );
            }
            if (object.foregroundColor != null) {
              if (typeof object.foregroundColor !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.foregroundColor: object expected"
                );
              message.foregroundColor =
                $root.google.protobuf.StringValue.fromObject(
                  object.foregroundColor
                );
            }
            if (object.strokeColor != null) {
              if (typeof object.strokeColor !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.strokeColor: object expected"
                );
              message.strokeColor =
                $root.google.protobuf.StringValue.fromObject(
                  object.strokeColor
                );
            }
            if (object.latitude != null) {
              if (typeof object.latitude !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.latitude: object expected"
                );
              message.latitude = $root.google.protobuf.FloatValue.fromObject(
                object.latitude
              );
            }
            if (object.longitude != null) {
              if (typeof object.longitude !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.longitude: object expected"
                );
              message.longitude = $root.google.protobuf.FloatValue.fromObject(
                object.longitude
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditFacilityInfoRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditFacilityInfoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditFacilityInfoRequest} message EditFacilityInfoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditFacilityInfoRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.backgroundColor = null;
              object.foregroundColor = null;
              object.strokeColor = null;
              object.latitude = null;
              object.longitude = null;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.backgroundColor != null &&
              message.hasOwnProperty("backgroundColor")
            )
              object.backgroundColor =
                $root.google.protobuf.StringValue.toObject(
                  message.backgroundColor,
                  options
                );
            if (
              message.foregroundColor != null &&
              message.hasOwnProperty("foregroundColor")
            )
              object.foregroundColor =
                $root.google.protobuf.StringValue.toObject(
                  message.foregroundColor,
                  options
                );
            if (
              message.strokeColor != null &&
              message.hasOwnProperty("strokeColor")
            )
              object.strokeColor = $root.google.protobuf.StringValue.toObject(
                message.strokeColor,
                options
              );
            if (message.latitude != null && message.hasOwnProperty("latitude"))
              object.latitude = $root.google.protobuf.FloatValue.toObject(
                message.latitude,
                options
              );
            if (
              message.longitude != null &&
              message.hasOwnProperty("longitude")
            )
              object.longitude = $root.google.protobuf.FloatValue.toObject(
                message.longitude,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditFacilityInfoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditFacilityInfoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditFacilityInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EditFacilityInfoRequest;
        })();

        racehorse360.Horse = (function () {
          /**
           * Properties of a Horse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorse
           * @property {string|null} [id] Horse id
           * @property {string|null} [name] Horse name
           * @property {string|null} [birthday] Horse birthday
           * @property {string|null} [registrationNumber] Horse registrationNumber
           * @property {string|null} [registrationStatus] Horse registrationStatus
           * @property {string|null} [damName] Horse damName
           * @property {string|null} [sireName] Horse sireName
           * @property {number|null} [breedType] Horse breedType
           * @property {stronachgroup.first.racehorse360.HorseGender|null} [gender] Horse gender
           * @property {string|null} [certificateIssuedDate] Horse certificateIssuedDate
           * @property {number|null} [breedingYear] Horse breedingYear
           * @property {string|null} [color] Horse color
           * @property {string|null} [lastRaceDate] Horse lastRaceDate
           * @property {stronachgroup.first.racehorse360.IFacility|null} [lastRaceFacility] Horse lastRaceFacility
           * @property {string|null} [lastWorkoutDate] Horse lastWorkoutDate
           * @property {stronachgroup.first.racehorse360.IFacility|null} [lastWorkoutFacility] Horse lastWorkoutFacility
           * @property {string|null} [lastWorkDate] Horse lastWorkDate
           * @property {string|null} [lastExamDate] Horse lastExamDate
           * @property {number|null} [highSpeedFurlongs] Horse highSpeedFurlongs
           * @property {string|null} [chipNumber] Horse chipNumber
           * @property {string|null} [tattoo] Horse tattoo
           * @property {string|null} [stateEligible] Horse stateEligible
           * @property {stronachgroup.first.racehorse360.HorseStateEligibility|null} [stateEligibleCode] Horse stateEligibleCode
           * @property {string|null} [stateBred] Horse stateBred
           * @property {string|null} [cogginsDate] Horse cogginsDate
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] Horse trainer
           * @property {stronachgroup.first.racehorse360.IFacility|null} [currentFacility] Horse currentFacility
           * @property {stronachgroup.first.racehorse360.HealthWatchStatus|null} [healthWatchStatus] Horse healthWatchStatus
           * @property {string|null} [colorDescription] Horse colorDescription
           * @property {stronachgroup.first.racehorse360.IBarn|null} [barn] Horse barn
           * @property {stronachgroup.first.racehorse360.IHorseWarningMessage|null} [warningMessage] Horse warningMessage
           * @property {string|null} [preferredConditionNote] Horse preferredConditionNote
           * @property {boolean|null} [areLastRacePreferredConditionsSelected] Horse areLastRacePreferredConditionsSelected
           * @property {string|null} [dateOfDeath] Horse dateOfDeath
           * @property {number|null} [riskFactorsCount] Horse riskFactorsCount
           * @property {number|null} [riskFactorScore] Horse riskFactorScore
           * @property {Array.<string>|null} [riskFactorShortDescriptions] Horse riskFactorShortDescriptions
           * @property {stronachgroup.first.racehorse360.IHorseLastExamNote|null} [lastExamNote] Horse lastExamNote
           * @property {number|null} [completedExamsWithNoteCount] Horse completedExamsWithNoteCount
           * @property {number|null} [totalVetListsCount] Horse totalVetListsCount
           * @property {number|null} [activeVetListsCount] Horse activeVetListsCount
           * @property {stronachgroup.first.racehorse360.IHorseFlagOnTrack|null} [flagOnTrack] Horse flagOnTrack
           * @property {boolean|null} [hasActualFlagOnTrack] Horse hasActualFlagOnTrack
           * @property {Array.<stronachgroup.first.racehorse360.IHorseLastPastPerformance>|null} [lastFivePastPerformances] Horse lastFivePastPerformances
           * @property {Array.<stronachgroup.first.racehorse360.IHorseLastPastPerformance>|null} [lastTenPastPerformances] Horse lastTenPastPerformances
           * @property {Array.<stronachgroup.first.racehorse360.IHorseWorkout>|null} [lastFourWorkouts] Horse lastFourWorkouts
           * @property {stronachgroup.first.racehorse360.IHorseLifetime|null} [lifetime] Horse lifetime
           * @property {stronachgroup.first.racehorse360.IBreeder|null} [breeder] Horse breeder
           * @property {stronachgroup.first.racehorse360.IOwner|null} [owner] Horse owner
           * @property {string|null} [stallNumber] Horse stallNumber
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [lastExamResult] Horse lastExamResult
           * @property {string|null} [lastRaceType] Horse lastRaceType
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [lastRaceCourseType] Horse lastRaceCourseType
           * @property {number|null} [lastRaceDistance] Horse lastRaceDistance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [lastRaceDistanceUnit] Horse lastRaceDistanceUnit
           */

          /**
           * Constructs a new Horse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Horse.
           * @implements IHorse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorse=} [properties] Properties to set
           */
          function Horse(properties) {
            this.riskFactorShortDescriptions = [];
            this.lastFivePastPerformances = [];
            this.lastTenPastPerformances = [];
            this.lastFourWorkouts = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Horse id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.id = "";

          /**
           * Horse name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.name = "";

          /**
           * Horse birthday.
           * @member {string} birthday
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.birthday = "";

          /**
           * Horse registrationNumber.
           * @member {string} registrationNumber
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.registrationNumber = "";

          /**
           * Horse registrationStatus.
           * @member {string} registrationStatus
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.registrationStatus = "";

          /**
           * Horse damName.
           * @member {string} damName
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.damName = "";

          /**
           * Horse sireName.
           * @member {string} sireName
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.sireName = "";

          /**
           * Horse breedType.
           * @member {number} breedType
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.breedType = 0;

          /**
           * Horse gender.
           * @member {stronachgroup.first.racehorse360.HorseGender} gender
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.gender = 0;

          /**
           * Horse certificateIssuedDate.
           * @member {string} certificateIssuedDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.certificateIssuedDate = "";

          /**
           * Horse breedingYear.
           * @member {number} breedingYear
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.breedingYear = 0;

          /**
           * Horse color.
           * @member {string} color
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.color = "";

          /**
           * Horse lastRaceDate.
           * @member {string} lastRaceDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceDate = "";

          /**
           * Horse lastRaceFacility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} lastRaceFacility
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceFacility = null;

          /**
           * Horse lastWorkoutDate.
           * @member {string} lastWorkoutDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastWorkoutDate = "";

          /**
           * Horse lastWorkoutFacility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} lastWorkoutFacility
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastWorkoutFacility = null;

          /**
           * Horse lastWorkDate.
           * @member {string} lastWorkDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastWorkDate = "";

          /**
           * Horse lastExamDate.
           * @member {string} lastExamDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastExamDate = "";

          /**
           * Horse highSpeedFurlongs.
           * @member {number} highSpeedFurlongs
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.highSpeedFurlongs = 0;

          /**
           * Horse chipNumber.
           * @member {string} chipNumber
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.chipNumber = "";

          /**
           * Horse tattoo.
           * @member {string} tattoo
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.tattoo = "";

          /**
           * Horse stateEligible.
           * @member {string} stateEligible
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.stateEligible = "";

          /**
           * Horse stateEligibleCode.
           * @member {stronachgroup.first.racehorse360.HorseStateEligibility} stateEligibleCode
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.stateEligibleCode = 0;

          /**
           * Horse stateBred.
           * @member {string} stateBred
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.stateBred = "";

          /**
           * Horse cogginsDate.
           * @member {string} cogginsDate
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.cogginsDate = "";

          /**
           * Horse trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.trainer = null;

          /**
           * Horse currentFacility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} currentFacility
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.currentFacility = null;

          /**
           * Horse healthWatchStatus.
           * @member {stronachgroup.first.racehorse360.HealthWatchStatus} healthWatchStatus
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.healthWatchStatus = 0;

          /**
           * Horse colorDescription.
           * @member {string} colorDescription
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.colorDescription = "";

          /**
           * Horse barn.
           * @member {stronachgroup.first.racehorse360.IBarn|null|undefined} barn
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.barn = null;

          /**
           * Horse warningMessage.
           * @member {stronachgroup.first.racehorse360.IHorseWarningMessage|null|undefined} warningMessage
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.warningMessage = null;

          /**
           * Horse preferredConditionNote.
           * @member {string} preferredConditionNote
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.preferredConditionNote = "";

          /**
           * Horse areLastRacePreferredConditionsSelected.
           * @member {boolean} areLastRacePreferredConditionsSelected
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.areLastRacePreferredConditionsSelected = false;

          /**
           * Horse dateOfDeath.
           * @member {string} dateOfDeath
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.dateOfDeath = "";

          /**
           * Horse riskFactorsCount.
           * @member {number} riskFactorsCount
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.riskFactorsCount = 0;

          /**
           * Horse riskFactorScore.
           * @member {number} riskFactorScore
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.riskFactorScore = 0;

          /**
           * Horse riskFactorShortDescriptions.
           * @member {Array.<string>} riskFactorShortDescriptions
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.riskFactorShortDescriptions = $util.emptyArray;

          /**
           * Horse lastExamNote.
           * @member {stronachgroup.first.racehorse360.IHorseLastExamNote|null|undefined} lastExamNote
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastExamNote = null;

          /**
           * Horse completedExamsWithNoteCount.
           * @member {number} completedExamsWithNoteCount
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.completedExamsWithNoteCount = 0;

          /**
           * Horse totalVetListsCount.
           * @member {number} totalVetListsCount
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.totalVetListsCount = 0;

          /**
           * Horse activeVetListsCount.
           * @member {number} activeVetListsCount
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.activeVetListsCount = 0;

          /**
           * Horse flagOnTrack.
           * @member {stronachgroup.first.racehorse360.IHorseFlagOnTrack|null|undefined} flagOnTrack
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.flagOnTrack = null;

          /**
           * Horse hasActualFlagOnTrack.
           * @member {boolean} hasActualFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.hasActualFlagOnTrack = false;

          /**
           * Horse lastFivePastPerformances.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseLastPastPerformance>} lastFivePastPerformances
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastFivePastPerformances = $util.emptyArray;

          /**
           * Horse lastTenPastPerformances.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseLastPastPerformance>} lastTenPastPerformances
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastTenPastPerformances = $util.emptyArray;

          /**
           * Horse lastFourWorkouts.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseWorkout>} lastFourWorkouts
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastFourWorkouts = $util.emptyArray;

          /**
           * Horse lifetime.
           * @member {stronachgroup.first.racehorse360.IHorseLifetime|null|undefined} lifetime
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lifetime = null;

          /**
           * Horse breeder.
           * @member {stronachgroup.first.racehorse360.IBreeder|null|undefined} breeder
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.breeder = null;

          /**
           * Horse owner.
           * @member {stronachgroup.first.racehorse360.IOwner|null|undefined} owner
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.owner = null;

          /**
           * Horse stallNumber.
           * @member {string} stallNumber
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.stallNumber = "";

          /**
           * Horse lastExamResult.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} lastExamResult
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastExamResult = 0;

          /**
           * Horse lastRaceType.
           * @member {string} lastRaceType
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceType = "";

          /**
           * Horse lastRaceCourseType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} lastRaceCourseType
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceCourseType = 0;

          /**
           * Horse lastRaceDistance.
           * @member {number} lastRaceDistance
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceDistance = 0;

          /**
           * Horse lastRaceDistanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} lastRaceDistanceUnit
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           */
          Horse.prototype.lastRaceDistanceUnit = 0;

          /**
           * Creates a new Horse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Horse
           * @static
           * @param {stronachgroup.first.racehorse360.IHorse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Horse} Horse instance
           */
          Horse.create = function create(properties) {
            return new Horse(properties);
          };

          /**
           * Encodes the specified Horse message. Does not implicitly {@link stronachgroup.first.racehorse360.Horse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Horse
           * @static
           * @param {stronachgroup.first.racehorse360.IHorse} message Horse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Horse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            if (
              message.birthday != null &&
              Object.hasOwnProperty.call(message, "birthday")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.birthday);
            if (
              message.registrationNumber != null &&
              Object.hasOwnProperty.call(message, "registrationNumber")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.registrationNumber);
            if (
              message.registrationStatus != null &&
              Object.hasOwnProperty.call(message, "registrationStatus")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.registrationStatus);
            if (
              message.damName != null &&
              Object.hasOwnProperty.call(message, "damName")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.damName);
            if (
              message.sireName != null &&
              Object.hasOwnProperty.call(message, "sireName")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.sireName);
            if (
              message.breedType != null &&
              Object.hasOwnProperty.call(message, "breedType")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.breedType);
            if (
              message.gender != null &&
              Object.hasOwnProperty.call(message, "gender")
            )
              writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.gender);
            if (
              message.certificateIssuedDate != null &&
              Object.hasOwnProperty.call(message, "certificateIssuedDate")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.certificateIssuedDate);
            if (
              message.breedingYear != null &&
              Object.hasOwnProperty.call(message, "breedingYear")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.breedingYear);
            if (
              message.color != null &&
              Object.hasOwnProperty.call(message, "color")
            )
              writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.color);
            if (
              message.lastRaceDate != null &&
              Object.hasOwnProperty.call(message, "lastRaceDate")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.lastRaceDate);
            if (
              message.lastRaceFacility != null &&
              Object.hasOwnProperty.call(message, "lastRaceFacility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.lastRaceFacility,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            if (
              message.lastWorkoutDate != null &&
              Object.hasOwnProperty.call(message, "lastWorkoutDate")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.lastWorkoutDate);
            if (
              message.lastWorkoutFacility != null &&
              Object.hasOwnProperty.call(message, "lastWorkoutFacility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.lastWorkoutFacility,
                writer.uint32(/* id 18, wireType 2 =*/ 146).fork()
              ).ldelim();
            if (
              message.lastWorkDate != null &&
              Object.hasOwnProperty.call(message, "lastWorkDate")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.lastWorkDate);
            if (
              message.lastExamDate != null &&
              Object.hasOwnProperty.call(message, "lastExamDate")
            )
              writer
                .uint32(/* id 21, wireType 2 =*/ 170)
                .string(message.lastExamDate);
            if (
              message.highSpeedFurlongs != null &&
              Object.hasOwnProperty.call(message, "highSpeedFurlongs")
            )
              writer
                .uint32(/* id 22, wireType 0 =*/ 176)
                .int32(message.highSpeedFurlongs);
            if (
              message.chipNumber != null &&
              Object.hasOwnProperty.call(message, "chipNumber")
            )
              writer
                .uint32(/* id 23, wireType 2 =*/ 186)
                .string(message.chipNumber);
            if (
              message.tattoo != null &&
              Object.hasOwnProperty.call(message, "tattoo")
            )
              writer
                .uint32(/* id 24, wireType 2 =*/ 194)
                .string(message.tattoo);
            if (
              message.stateEligible != null &&
              Object.hasOwnProperty.call(message, "stateEligible")
            )
              writer
                .uint32(/* id 25, wireType 2 =*/ 202)
                .string(message.stateEligible);
            if (
              message.stateEligibleCode != null &&
              Object.hasOwnProperty.call(message, "stateEligibleCode")
            )
              writer
                .uint32(/* id 26, wireType 0 =*/ 208)
                .int32(message.stateEligibleCode);
            if (
              message.stateBred != null &&
              Object.hasOwnProperty.call(message, "stateBred")
            )
              writer
                .uint32(/* id 27, wireType 2 =*/ 218)
                .string(message.stateBred);
            if (
              message.cogginsDate != null &&
              Object.hasOwnProperty.call(message, "cogginsDate")
            )
              writer
                .uint32(/* id 28, wireType 2 =*/ 226)
                .string(message.cogginsDate);
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 29, wireType 2 =*/ 234).fork()
              ).ldelim();
            if (
              message.currentFacility != null &&
              Object.hasOwnProperty.call(message, "currentFacility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.currentFacility,
                writer.uint32(/* id 31, wireType 2 =*/ 250).fork()
              ).ldelim();
            if (
              message.healthWatchStatus != null &&
              Object.hasOwnProperty.call(message, "healthWatchStatus")
            )
              writer
                .uint32(/* id 32, wireType 0 =*/ 256)
                .int32(message.healthWatchStatus);
            if (
              message.colorDescription != null &&
              Object.hasOwnProperty.call(message, "colorDescription")
            )
              writer
                .uint32(/* id 33, wireType 2 =*/ 266)
                .string(message.colorDescription);
            if (
              message.barn != null &&
              Object.hasOwnProperty.call(message, "barn")
            )
              $root.stronachgroup.first.racehorse360.Barn.encode(
                message.barn,
                writer.uint32(/* id 36, wireType 2 =*/ 290).fork()
              ).ldelim();
            if (
              message.warningMessage != null &&
              Object.hasOwnProperty.call(message, "warningMessage")
            )
              $root.stronachgroup.first.racehorse360.HorseWarningMessage.encode(
                message.warningMessage,
                writer.uint32(/* id 37, wireType 2 =*/ 298).fork()
              ).ldelim();
            if (
              message.preferredConditionNote != null &&
              Object.hasOwnProperty.call(message, "preferredConditionNote")
            )
              writer
                .uint32(/* id 38, wireType 2 =*/ 306)
                .string(message.preferredConditionNote);
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              Object.hasOwnProperty.call(
                message,
                "areLastRacePreferredConditionsSelected"
              )
            )
              writer
                .uint32(/* id 39, wireType 0 =*/ 312)
                .bool(message.areLastRacePreferredConditionsSelected);
            if (
              message.dateOfDeath != null &&
              Object.hasOwnProperty.call(message, "dateOfDeath")
            )
              writer
                .uint32(/* id 40, wireType 2 =*/ 322)
                .string(message.dateOfDeath);
            if (
              message.riskFactorsCount != null &&
              Object.hasOwnProperty.call(message, "riskFactorsCount")
            )
              writer
                .uint32(/* id 42, wireType 0 =*/ 336)
                .int32(message.riskFactorsCount);
            if (
              message.riskFactorScore != null &&
              Object.hasOwnProperty.call(message, "riskFactorScore")
            )
              writer
                .uint32(/* id 43, wireType 0 =*/ 344)
                .int32(message.riskFactorScore);
            if (
              message.riskFactorShortDescriptions != null &&
              message.riskFactorShortDescriptions.length
            )
              for (
                var i = 0;
                i < message.riskFactorShortDescriptions.length;
                ++i
              )
                writer
                  .uint32(/* id 44, wireType 2 =*/ 354)
                  .string(message.riskFactorShortDescriptions[i]);
            if (
              message.lastExamNote != null &&
              Object.hasOwnProperty.call(message, "lastExamNote")
            )
              $root.stronachgroup.first.racehorse360.HorseLastExamNote.encode(
                message.lastExamNote,
                writer.uint32(/* id 45, wireType 2 =*/ 362).fork()
              ).ldelim();
            if (
              message.completedExamsWithNoteCount != null &&
              Object.hasOwnProperty.call(message, "completedExamsWithNoteCount")
            )
              writer
                .uint32(/* id 46, wireType 0 =*/ 368)
                .int32(message.completedExamsWithNoteCount);
            if (
              message.totalVetListsCount != null &&
              Object.hasOwnProperty.call(message, "totalVetListsCount")
            )
              writer
                .uint32(/* id 47, wireType 0 =*/ 376)
                .int32(message.totalVetListsCount);
            if (
              message.activeVetListsCount != null &&
              Object.hasOwnProperty.call(message, "activeVetListsCount")
            )
              writer
                .uint32(/* id 48, wireType 0 =*/ 384)
                .int32(message.activeVetListsCount);
            if (
              message.flagOnTrack != null &&
              Object.hasOwnProperty.call(message, "flagOnTrack")
            )
              $root.stronachgroup.first.racehorse360.HorseFlagOnTrack.encode(
                message.flagOnTrack,
                writer.uint32(/* id 49, wireType 2 =*/ 394).fork()
              ).ldelim();
            if (
              message.hasActualFlagOnTrack != null &&
              Object.hasOwnProperty.call(message, "hasActualFlagOnTrack")
            )
              writer
                .uint32(/* id 50, wireType 0 =*/ 400)
                .bool(message.hasActualFlagOnTrack);
            if (
              message.lastFivePastPerformances != null &&
              message.lastFivePastPerformances.length
            )
              for (var i = 0; i < message.lastFivePastPerformances.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.encode(
                  message.lastFivePastPerformances[i],
                  writer.uint32(/* id 51, wireType 2 =*/ 410).fork()
                ).ldelim();
            if (
              message.lastTenPastPerformances != null &&
              message.lastTenPastPerformances.length
            )
              for (var i = 0; i < message.lastTenPastPerformances.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.encode(
                  message.lastTenPastPerformances[i],
                  writer.uint32(/* id 52, wireType 2 =*/ 418).fork()
                ).ldelim();
            if (
              message.lastFourWorkouts != null &&
              message.lastFourWorkouts.length
            )
              for (var i = 0; i < message.lastFourWorkouts.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseWorkout.encode(
                  message.lastFourWorkouts[i],
                  writer.uint32(/* id 53, wireType 2 =*/ 426).fork()
                ).ldelim();
            if (
              message.lifetime != null &&
              Object.hasOwnProperty.call(message, "lifetime")
            )
              $root.stronachgroup.first.racehorse360.HorseLifetime.encode(
                message.lifetime,
                writer.uint32(/* id 54, wireType 2 =*/ 434).fork()
              ).ldelim();
            if (
              message.breeder != null &&
              Object.hasOwnProperty.call(message, "breeder")
            )
              $root.stronachgroup.first.racehorse360.Breeder.encode(
                message.breeder,
                writer.uint32(/* id 55, wireType 2 =*/ 442).fork()
              ).ldelim();
            if (
              message.owner != null &&
              Object.hasOwnProperty.call(message, "owner")
            )
              $root.stronachgroup.first.racehorse360.Owner.encode(
                message.owner,
                writer.uint32(/* id 57, wireType 2 =*/ 458).fork()
              ).ldelim();
            if (
              message.stallNumber != null &&
              Object.hasOwnProperty.call(message, "stallNumber")
            )
              writer
                .uint32(/* id 59, wireType 2 =*/ 474)
                .string(message.stallNumber);
            if (
              message.lastExamResult != null &&
              Object.hasOwnProperty.call(message, "lastExamResult")
            )
              writer
                .uint32(/* id 60, wireType 0 =*/ 480)
                .int32(message.lastExamResult);
            if (
              message.lastRaceType != null &&
              Object.hasOwnProperty.call(message, "lastRaceType")
            )
              writer
                .uint32(/* id 61, wireType 2 =*/ 490)
                .string(message.lastRaceType);
            if (
              message.lastRaceCourseType != null &&
              Object.hasOwnProperty.call(message, "lastRaceCourseType")
            )
              writer
                .uint32(/* id 62, wireType 0 =*/ 496)
                .int32(message.lastRaceCourseType);
            if (
              message.lastRaceDistance != null &&
              Object.hasOwnProperty.call(message, "lastRaceDistance")
            )
              writer
                .uint32(/* id 63, wireType 0 =*/ 504)
                .int32(message.lastRaceDistance);
            if (
              message.lastRaceDistanceUnit != null &&
              Object.hasOwnProperty.call(message, "lastRaceDistanceUnit")
            )
              writer
                .uint32(/* id 64, wireType 0 =*/ 512)
                .int32(message.lastRaceDistanceUnit);
            return writer;
          };

          /**
           * Decodes a Horse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Horse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Horse} Horse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Horse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Horse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                case 3:
                  message.birthday = reader.string();
                  break;
                case 4:
                  message.registrationNumber = reader.string();
                  break;
                case 5:
                  message.registrationStatus = reader.string();
                  break;
                case 6:
                  message.damName = reader.string();
                  break;
                case 7:
                  message.sireName = reader.string();
                  break;
                case 8:
                  message.breedType = reader.int32();
                  break;
                case 9:
                  message.gender = reader.int32();
                  break;
                case 10:
                  message.certificateIssuedDate = reader.string();
                  break;
                case 11:
                  message.breedingYear = reader.int32();
                  break;
                case 12:
                  message.color = reader.string();
                  break;
                case 14:
                  message.lastRaceDate = reader.string();
                  break;
                case 15:
                  message.lastRaceFacility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 17:
                  message.lastWorkoutDate = reader.string();
                  break;
                case 18:
                  message.lastWorkoutFacility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 19:
                  message.lastWorkDate = reader.string();
                  break;
                case 21:
                  message.lastExamDate = reader.string();
                  break;
                case 22:
                  message.highSpeedFurlongs = reader.int32();
                  break;
                case 23:
                  message.chipNumber = reader.string();
                  break;
                case 24:
                  message.tattoo = reader.string();
                  break;
                case 25:
                  message.stateEligible = reader.string();
                  break;
                case 26:
                  message.stateEligibleCode = reader.int32();
                  break;
                case 27:
                  message.stateBred = reader.string();
                  break;
                case 28:
                  message.cogginsDate = reader.string();
                  break;
                case 29:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 31:
                  message.currentFacility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 32:
                  message.healthWatchStatus = reader.int32();
                  break;
                case 33:
                  message.colorDescription = reader.string();
                  break;
                case 36:
                  message.barn =
                    $root.stronachgroup.first.racehorse360.Barn.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 37:
                  message.warningMessage =
                    $root.stronachgroup.first.racehorse360.HorseWarningMessage.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 38:
                  message.preferredConditionNote = reader.string();
                  break;
                case 39:
                  message.areLastRacePreferredConditionsSelected =
                    reader.bool();
                  break;
                case 40:
                  message.dateOfDeath = reader.string();
                  break;
                case 42:
                  message.riskFactorsCount = reader.int32();
                  break;
                case 43:
                  message.riskFactorScore = reader.int32();
                  break;
                case 44:
                  if (
                    !(
                      message.riskFactorShortDescriptions &&
                      message.riskFactorShortDescriptions.length
                    )
                  )
                    message.riskFactorShortDescriptions = [];
                  message.riskFactorShortDescriptions.push(reader.string());
                  break;
                case 45:
                  message.lastExamNote =
                    $root.stronachgroup.first.racehorse360.HorseLastExamNote.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 46:
                  message.completedExamsWithNoteCount = reader.int32();
                  break;
                case 47:
                  message.totalVetListsCount = reader.int32();
                  break;
                case 48:
                  message.activeVetListsCount = reader.int32();
                  break;
                case 49:
                  message.flagOnTrack =
                    $root.stronachgroup.first.racehorse360.HorseFlagOnTrack.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 50:
                  message.hasActualFlagOnTrack = reader.bool();
                  break;
                case 51:
                  if (
                    !(
                      message.lastFivePastPerformances &&
                      message.lastFivePastPerformances.length
                    )
                  )
                    message.lastFivePastPerformances = [];
                  message.lastFivePastPerformances.push(
                    $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 52:
                  if (
                    !(
                      message.lastTenPastPerformances &&
                      message.lastTenPastPerformances.length
                    )
                  )
                    message.lastTenPastPerformances = [];
                  message.lastTenPastPerformances.push(
                    $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 53:
                  if (
                    !(
                      message.lastFourWorkouts &&
                      message.lastFourWorkouts.length
                    )
                  )
                    message.lastFourWorkouts = [];
                  message.lastFourWorkouts.push(
                    $root.stronachgroup.first.racehorse360.HorseWorkout.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 54:
                  message.lifetime =
                    $root.stronachgroup.first.racehorse360.HorseLifetime.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 55:
                  message.breeder =
                    $root.stronachgroup.first.racehorse360.Breeder.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 57:
                  message.owner =
                    $root.stronachgroup.first.racehorse360.Owner.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 59:
                  message.stallNumber = reader.string();
                  break;
                case 60:
                  message.lastExamResult = reader.int32();
                  break;
                case 61:
                  message.lastRaceType = reader.string();
                  break;
                case 62:
                  message.lastRaceCourseType = reader.int32();
                  break;
                case 63:
                  message.lastRaceDistance = reader.int32();
                  break;
                case 64:
                  message.lastRaceDistanceUnit = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Horse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Horse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Horse} Horse
           */
          Horse.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Horse)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Horse();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            if (object.birthday != null)
              message.birthday = String(object.birthday);
            if (object.registrationNumber != null)
              message.registrationNumber = String(object.registrationNumber);
            if (object.registrationStatus != null)
              message.registrationStatus = String(object.registrationStatus);
            if (object.damName != null)
              message.damName = String(object.damName);
            if (object.sireName != null)
              message.sireName = String(object.sireName);
            if (object.breedType != null)
              message.breedType = object.breedType | 0;
            switch (object.gender) {
              case "HORSE_GENDER_INVALID":
              case 0:
                message.gender = 0;
                break;
              case "HORSE_GENDER_FILLY":
              case 1:
                message.gender = 1;
                break;
              case "HORSE_GENDER_COLT":
              case 2:
                message.gender = 2;
                break;
              case "HORSE_GENDER_GELDING":
              case 3:
                message.gender = 3;
                break;
              case "HORSE_GENDER_MARE":
              case 4:
                message.gender = 4;
                break;
              case "HORSE_GENDER_HORSE":
              case 5:
                message.gender = 5;
                break;
              case "HORSE_GENDER_SPAYED_MARE":
              case 6:
                message.gender = 6;
                break;
              case "HORSE_GENDER_RIDGLING":
              case 7:
                message.gender = 7;
                break;
            }
            if (object.certificateIssuedDate != null)
              message.certificateIssuedDate = String(
                object.certificateIssuedDate
              );
            if (object.breedingYear != null)
              message.breedingYear = object.breedingYear | 0;
            if (object.color != null) message.color = String(object.color);
            if (object.lastRaceDate != null)
              message.lastRaceDate = String(object.lastRaceDate);
            if (object.lastRaceFacility != null) {
              if (typeof object.lastRaceFacility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastRaceFacility: object expected"
                );
              message.lastRaceFacility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.lastRaceFacility
                );
            }
            if (object.lastWorkoutDate != null)
              message.lastWorkoutDate = String(object.lastWorkoutDate);
            if (object.lastWorkoutFacility != null) {
              if (typeof object.lastWorkoutFacility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastWorkoutFacility: object expected"
                );
              message.lastWorkoutFacility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.lastWorkoutFacility
                );
            }
            if (object.lastWorkDate != null)
              message.lastWorkDate = String(object.lastWorkDate);
            if (object.lastExamDate != null)
              message.lastExamDate = String(object.lastExamDate);
            if (object.highSpeedFurlongs != null)
              message.highSpeedFurlongs = object.highSpeedFurlongs | 0;
            if (object.chipNumber != null)
              message.chipNumber = String(object.chipNumber);
            if (object.tattoo != null) message.tattoo = String(object.tattoo);
            if (object.stateEligible != null)
              message.stateEligible = String(object.stateEligible);
            switch (object.stateEligibleCode) {
              case "HORSE_STATE_ELIGIBILITY_INVALID":
              case 0:
                message.stateEligibleCode = 0;
                break;
              case "HORSE_STATE_ELIGIBILITY_CALIFORNIA":
              case 1:
                message.stateEligibleCode = 1;
                break;
              case "HORSE_STATE_ELIGIBILITY_FLORIDA":
              case 2:
                message.stateEligibleCode = 2;
                break;
              case "HORSE_STATE_ELIGIBILITY_MARYLAND":
              case 3:
                message.stateEligibleCode = 3;
                break;
              case "HORSE_STATE_ELIGIBILITY_NONE":
              case 4:
                message.stateEligibleCode = 4;
                break;
            }
            if (object.stateBred != null)
              message.stateBred = String(object.stateBred);
            if (object.cogginsDate != null)
              message.cogginsDate = String(object.cogginsDate);
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.currentFacility != null) {
              if (typeof object.currentFacility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.currentFacility: object expected"
                );
              message.currentFacility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.currentFacility
                );
            }
            switch (object.healthWatchStatus) {
              case "HEALTH_WATCH_STATUS_INVALID":
              case 0:
                message.healthWatchStatus = 0;
                break;
              case "HEALTH_WATCH_STATUS_GREEN":
              case 1:
                message.healthWatchStatus = 1;
                break;
              case "HEALTH_WATCH_STATUS_YELLOW":
              case 2:
                message.healthWatchStatus = 2;
                break;
              case "HEALTH_WATCH_STATUS_RED":
              case 3:
                message.healthWatchStatus = 3;
                break;
            }
            if (object.colorDescription != null)
              message.colorDescription = String(object.colorDescription);
            if (object.barn != null) {
              if (typeof object.barn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.barn: object expected"
                );
              message.barn =
                $root.stronachgroup.first.racehorse360.Barn.fromObject(
                  object.barn
                );
            }
            if (object.warningMessage != null) {
              if (typeof object.warningMessage !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.warningMessage: object expected"
                );
              message.warningMessage =
                $root.stronachgroup.first.racehorse360.HorseWarningMessage.fromObject(
                  object.warningMessage
                );
            }
            if (object.preferredConditionNote != null)
              message.preferredConditionNote = String(
                object.preferredConditionNote
              );
            if (object.areLastRacePreferredConditionsSelected != null)
              message.areLastRacePreferredConditionsSelected = Boolean(
                object.areLastRacePreferredConditionsSelected
              );
            if (object.dateOfDeath != null)
              message.dateOfDeath = String(object.dateOfDeath);
            if (object.riskFactorsCount != null)
              message.riskFactorsCount = object.riskFactorsCount | 0;
            if (object.riskFactorScore != null)
              message.riskFactorScore = object.riskFactorScore | 0;
            if (object.riskFactorShortDescriptions) {
              if (!Array.isArray(object.riskFactorShortDescriptions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.riskFactorShortDescriptions: array expected"
                );
              message.riskFactorShortDescriptions = [];
              for (
                var i = 0;
                i < object.riskFactorShortDescriptions.length;
                ++i
              )
                message.riskFactorShortDescriptions[i] = String(
                  object.riskFactorShortDescriptions[i]
                );
            }
            if (object.lastExamNote != null) {
              if (typeof object.lastExamNote !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastExamNote: object expected"
                );
              message.lastExamNote =
                $root.stronachgroup.first.racehorse360.HorseLastExamNote.fromObject(
                  object.lastExamNote
                );
            }
            if (object.completedExamsWithNoteCount != null)
              message.completedExamsWithNoteCount =
                object.completedExamsWithNoteCount | 0;
            if (object.totalVetListsCount != null)
              message.totalVetListsCount = object.totalVetListsCount | 0;
            if (object.activeVetListsCount != null)
              message.activeVetListsCount = object.activeVetListsCount | 0;
            if (object.flagOnTrack != null) {
              if (typeof object.flagOnTrack !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.flagOnTrack: object expected"
                );
              message.flagOnTrack =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrack.fromObject(
                  object.flagOnTrack
                );
            }
            if (object.hasActualFlagOnTrack != null)
              message.hasActualFlagOnTrack = Boolean(
                object.hasActualFlagOnTrack
              );
            if (object.lastFivePastPerformances) {
              if (!Array.isArray(object.lastFivePastPerformances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastFivePastPerformances: array expected"
                );
              message.lastFivePastPerformances = [];
              for (var i = 0; i < object.lastFivePastPerformances.length; ++i) {
                if (typeof object.lastFivePastPerformances[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.Horse.lastFivePastPerformances: object expected"
                  );
                message.lastFivePastPerformances[i] =
                  $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.fromObject(
                    object.lastFivePastPerformances[i]
                  );
              }
            }
            if (object.lastTenPastPerformances) {
              if (!Array.isArray(object.lastTenPastPerformances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastTenPastPerformances: array expected"
                );
              message.lastTenPastPerformances = [];
              for (var i = 0; i < object.lastTenPastPerformances.length; ++i) {
                if (typeof object.lastTenPastPerformances[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.Horse.lastTenPastPerformances: object expected"
                  );
                message.lastTenPastPerformances[i] =
                  $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.fromObject(
                    object.lastTenPastPerformances[i]
                  );
              }
            }
            if (object.lastFourWorkouts) {
              if (!Array.isArray(object.lastFourWorkouts))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lastFourWorkouts: array expected"
                );
              message.lastFourWorkouts = [];
              for (var i = 0; i < object.lastFourWorkouts.length; ++i) {
                if (typeof object.lastFourWorkouts[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.Horse.lastFourWorkouts: object expected"
                  );
                message.lastFourWorkouts[i] =
                  $root.stronachgroup.first.racehorse360.HorseWorkout.fromObject(
                    object.lastFourWorkouts[i]
                  );
              }
            }
            if (object.lifetime != null) {
              if (typeof object.lifetime !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.lifetime: object expected"
                );
              message.lifetime =
                $root.stronachgroup.first.racehorse360.HorseLifetime.fromObject(
                  object.lifetime
                );
            }
            if (object.breeder != null) {
              if (typeof object.breeder !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.breeder: object expected"
                );
              message.breeder =
                $root.stronachgroup.first.racehorse360.Breeder.fromObject(
                  object.breeder
                );
            }
            if (object.owner != null) {
              if (typeof object.owner !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Horse.owner: object expected"
                );
              message.owner =
                $root.stronachgroup.first.racehorse360.Owner.fromObject(
                  object.owner
                );
            }
            if (object.stallNumber != null)
              message.stallNumber = String(object.stallNumber);
            switch (object.lastExamResult) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.lastExamResult = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.lastExamResult = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.lastExamResult = 2;
                break;
            }
            if (object.lastRaceType != null)
              message.lastRaceType = String(object.lastRaceType);
            switch (object.lastRaceCourseType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.lastRaceCourseType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.lastRaceCourseType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.lastRaceCourseType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.lastRaceCourseType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.lastRaceCourseType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.lastRaceCourseType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.lastRaceCourseType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.lastRaceCourseType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.lastRaceCourseType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.lastRaceCourseType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.lastRaceCourseType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.lastRaceCourseType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.lastRaceCourseType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.lastRaceCourseType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.lastRaceCourseType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.lastRaceCourseType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.lastRaceCourseType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.lastRaceCourseType = 17;
                break;
            }
            if (object.lastRaceDistance != null)
              message.lastRaceDistance = object.lastRaceDistance | 0;
            switch (object.lastRaceDistanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.lastRaceDistanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.lastRaceDistanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.lastRaceDistanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.lastRaceDistanceUnit = 3;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a Horse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Horse
           * @static
           * @param {stronachgroup.first.racehorse360.Horse} message Horse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Horse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.riskFactorShortDescriptions = [];
              object.lastFivePastPerformances = [];
              object.lastTenPastPerformances = [];
              object.lastFourWorkouts = [];
            }
            if (options.defaults) {
              object.id = "";
              object.name = "";
              object.birthday = "";
              object.registrationNumber = "";
              object.registrationStatus = "";
              object.damName = "";
              object.sireName = "";
              object.breedType = 0;
              object.gender =
                options.enums === String ? "HORSE_GENDER_INVALID" : 0;
              object.certificateIssuedDate = "";
              object.breedingYear = 0;
              object.color = "";
              object.lastRaceDate = "";
              object.lastRaceFacility = null;
              object.lastWorkoutDate = "";
              object.lastWorkoutFacility = null;
              object.lastWorkDate = "";
              object.lastExamDate = "";
              object.highSpeedFurlongs = 0;
              object.chipNumber = "";
              object.tattoo = "";
              object.stateEligible = "";
              object.stateEligibleCode =
                options.enums === String
                  ? "HORSE_STATE_ELIGIBILITY_INVALID"
                  : 0;
              object.stateBred = "";
              object.cogginsDate = "";
              object.trainer = null;
              object.currentFacility = null;
              object.healthWatchStatus =
                options.enums === String ? "HEALTH_WATCH_STATUS_INVALID" : 0;
              object.colorDescription = "";
              object.barn = null;
              object.warningMessage = null;
              object.preferredConditionNote = "";
              object.areLastRacePreferredConditionsSelected = false;
              object.dateOfDeath = "";
              object.riskFactorsCount = 0;
              object.riskFactorScore = 0;
              object.lastExamNote = null;
              object.completedExamsWithNoteCount = 0;
              object.totalVetListsCount = 0;
              object.activeVetListsCount = 0;
              object.flagOnTrack = null;
              object.hasActualFlagOnTrack = false;
              object.lifetime = null;
              object.breeder = null;
              object.owner = null;
              object.stallNumber = "";
              object.lastExamResult =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
              object.lastRaceType = "";
              object.lastRaceCourseType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.lastRaceDistance = 0;
              object.lastRaceDistanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.birthday != null && message.hasOwnProperty("birthday"))
              object.birthday = message.birthday;
            if (
              message.registrationNumber != null &&
              message.hasOwnProperty("registrationNumber")
            )
              object.registrationNumber = message.registrationNumber;
            if (
              message.registrationStatus != null &&
              message.hasOwnProperty("registrationStatus")
            )
              object.registrationStatus = message.registrationStatus;
            if (message.damName != null && message.hasOwnProperty("damName"))
              object.damName = message.damName;
            if (message.sireName != null && message.hasOwnProperty("sireName"))
              object.sireName = message.sireName;
            if (
              message.breedType != null &&
              message.hasOwnProperty("breedType")
            )
              object.breedType = message.breedType;
            if (message.gender != null && message.hasOwnProperty("gender"))
              object.gender =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseGender[
                      message.gender
                    ]
                  : message.gender;
            if (
              message.certificateIssuedDate != null &&
              message.hasOwnProperty("certificateIssuedDate")
            )
              object.certificateIssuedDate = message.certificateIssuedDate;
            if (
              message.breedingYear != null &&
              message.hasOwnProperty("breedingYear")
            )
              object.breedingYear = message.breedingYear;
            if (message.color != null && message.hasOwnProperty("color"))
              object.color = message.color;
            if (
              message.lastRaceDate != null &&
              message.hasOwnProperty("lastRaceDate")
            )
              object.lastRaceDate = message.lastRaceDate;
            if (
              message.lastRaceFacility != null &&
              message.hasOwnProperty("lastRaceFacility")
            )
              object.lastRaceFacility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.lastRaceFacility,
                  options
                );
            if (
              message.lastWorkoutDate != null &&
              message.hasOwnProperty("lastWorkoutDate")
            )
              object.lastWorkoutDate = message.lastWorkoutDate;
            if (
              message.lastWorkoutFacility != null &&
              message.hasOwnProperty("lastWorkoutFacility")
            )
              object.lastWorkoutFacility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.lastWorkoutFacility,
                  options
                );
            if (
              message.lastWorkDate != null &&
              message.hasOwnProperty("lastWorkDate")
            )
              object.lastWorkDate = message.lastWorkDate;
            if (
              message.lastExamDate != null &&
              message.hasOwnProperty("lastExamDate")
            )
              object.lastExamDate = message.lastExamDate;
            if (
              message.highSpeedFurlongs != null &&
              message.hasOwnProperty("highSpeedFurlongs")
            )
              object.highSpeedFurlongs = message.highSpeedFurlongs;
            if (
              message.chipNumber != null &&
              message.hasOwnProperty("chipNumber")
            )
              object.chipNumber = message.chipNumber;
            if (message.tattoo != null && message.hasOwnProperty("tattoo"))
              object.tattoo = message.tattoo;
            if (
              message.stateEligible != null &&
              message.hasOwnProperty("stateEligible")
            )
              object.stateEligible = message.stateEligible;
            if (
              message.stateEligibleCode != null &&
              message.hasOwnProperty("stateEligibleCode")
            )
              object.stateEligibleCode =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .HorseStateEligibility[message.stateEligibleCode]
                  : message.stateEligibleCode;
            if (
              message.stateBred != null &&
              message.hasOwnProperty("stateBred")
            )
              object.stateBred = message.stateBred;
            if (
              message.cogginsDate != null &&
              message.hasOwnProperty("cogginsDate")
            )
              object.cogginsDate = message.cogginsDate;
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (
              message.currentFacility != null &&
              message.hasOwnProperty("currentFacility")
            )
              object.currentFacility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.currentFacility,
                  options
                );
            if (
              message.healthWatchStatus != null &&
              message.hasOwnProperty("healthWatchStatus")
            )
              object.healthWatchStatus =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HealthWatchStatus[
                      message.healthWatchStatus
                    ]
                  : message.healthWatchStatus;
            if (
              message.colorDescription != null &&
              message.hasOwnProperty("colorDescription")
            )
              object.colorDescription = message.colorDescription;
            if (message.barn != null && message.hasOwnProperty("barn"))
              object.barn =
                $root.stronachgroup.first.racehorse360.Barn.toObject(
                  message.barn,
                  options
                );
            if (
              message.warningMessage != null &&
              message.hasOwnProperty("warningMessage")
            )
              object.warningMessage =
                $root.stronachgroup.first.racehorse360.HorseWarningMessage.toObject(
                  message.warningMessage,
                  options
                );
            if (
              message.preferredConditionNote != null &&
              message.hasOwnProperty("preferredConditionNote")
            )
              object.preferredConditionNote = message.preferredConditionNote;
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              message.hasOwnProperty("areLastRacePreferredConditionsSelected")
            )
              object.areLastRacePreferredConditionsSelected =
                message.areLastRacePreferredConditionsSelected;
            if (
              message.dateOfDeath != null &&
              message.hasOwnProperty("dateOfDeath")
            )
              object.dateOfDeath = message.dateOfDeath;
            if (
              message.riskFactorsCount != null &&
              message.hasOwnProperty("riskFactorsCount")
            )
              object.riskFactorsCount = message.riskFactorsCount;
            if (
              message.riskFactorScore != null &&
              message.hasOwnProperty("riskFactorScore")
            )
              object.riskFactorScore = message.riskFactorScore;
            if (
              message.riskFactorShortDescriptions &&
              message.riskFactorShortDescriptions.length
            ) {
              object.riskFactorShortDescriptions = [];
              for (
                var j = 0;
                j < message.riskFactorShortDescriptions.length;
                ++j
              )
                object.riskFactorShortDescriptions[j] =
                  message.riskFactorShortDescriptions[j];
            }
            if (
              message.lastExamNote != null &&
              message.hasOwnProperty("lastExamNote")
            )
              object.lastExamNote =
                $root.stronachgroup.first.racehorse360.HorseLastExamNote.toObject(
                  message.lastExamNote,
                  options
                );
            if (
              message.completedExamsWithNoteCount != null &&
              message.hasOwnProperty("completedExamsWithNoteCount")
            )
              object.completedExamsWithNoteCount =
                message.completedExamsWithNoteCount;
            if (
              message.totalVetListsCount != null &&
              message.hasOwnProperty("totalVetListsCount")
            )
              object.totalVetListsCount = message.totalVetListsCount;
            if (
              message.activeVetListsCount != null &&
              message.hasOwnProperty("activeVetListsCount")
            )
              object.activeVetListsCount = message.activeVetListsCount;
            if (
              message.flagOnTrack != null &&
              message.hasOwnProperty("flagOnTrack")
            )
              object.flagOnTrack =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrack.toObject(
                  message.flagOnTrack,
                  options
                );
            if (
              message.hasActualFlagOnTrack != null &&
              message.hasOwnProperty("hasActualFlagOnTrack")
            )
              object.hasActualFlagOnTrack = message.hasActualFlagOnTrack;
            if (
              message.lastFivePastPerformances &&
              message.lastFivePastPerformances.length
            ) {
              object.lastFivePastPerformances = [];
              for (var j = 0; j < message.lastFivePastPerformances.length; ++j)
                object.lastFivePastPerformances[j] =
                  $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.toObject(
                    message.lastFivePastPerformances[j],
                    options
                  );
            }
            if (
              message.lastTenPastPerformances &&
              message.lastTenPastPerformances.length
            ) {
              object.lastTenPastPerformances = [];
              for (var j = 0; j < message.lastTenPastPerformances.length; ++j)
                object.lastTenPastPerformances[j] =
                  $root.stronachgroup.first.racehorse360.HorseLastPastPerformance.toObject(
                    message.lastTenPastPerformances[j],
                    options
                  );
            }
            if (message.lastFourWorkouts && message.lastFourWorkouts.length) {
              object.lastFourWorkouts = [];
              for (var j = 0; j < message.lastFourWorkouts.length; ++j)
                object.lastFourWorkouts[j] =
                  $root.stronachgroup.first.racehorse360.HorseWorkout.toObject(
                    message.lastFourWorkouts[j],
                    options
                  );
            }
            if (message.lifetime != null && message.hasOwnProperty("lifetime"))
              object.lifetime =
                $root.stronachgroup.first.racehorse360.HorseLifetime.toObject(
                  message.lifetime,
                  options
                );
            if (message.breeder != null && message.hasOwnProperty("breeder"))
              object.breeder =
                $root.stronachgroup.first.racehorse360.Breeder.toObject(
                  message.breeder,
                  options
                );
            if (message.owner != null && message.hasOwnProperty("owner"))
              object.owner =
                $root.stronachgroup.first.racehorse360.Owner.toObject(
                  message.owner,
                  options
                );
            if (
              message.stallNumber != null &&
              message.hasOwnProperty("stallNumber")
            )
              object.stallNumber = message.stallNumber;
            if (
              message.lastExamResult != null &&
              message.hasOwnProperty("lastExamResult")
            )
              object.lastExamResult =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.lastExamResult
                    ]
                  : message.lastExamResult;
            if (
              message.lastRaceType != null &&
              message.hasOwnProperty("lastRaceType")
            )
              object.lastRaceType = message.lastRaceType;
            if (
              message.lastRaceCourseType != null &&
              message.hasOwnProperty("lastRaceCourseType")
            )
              object.lastRaceCourseType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.lastRaceCourseType
                    ]
                  : message.lastRaceCourseType;
            if (
              message.lastRaceDistance != null &&
              message.hasOwnProperty("lastRaceDistance")
            )
              object.lastRaceDistance = message.lastRaceDistance;
            if (
              message.lastRaceDistanceUnit != null &&
              message.hasOwnProperty("lastRaceDistanceUnit")
            )
              object.lastRaceDistanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.lastRaceDistanceUnit
                    ]
                  : message.lastRaceDistanceUnit;
            return object;
          };

          /**
           * Converts this Horse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Horse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Horse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Horse;
        })();

        racehorse360.Breeder = (function () {
          /**
           * Properties of a Breeder.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBreeder
           * @property {string|null} [id] Breeder id
           * @property {string|null} [name] Breeder name
           */

          /**
           * Constructs a new Breeder.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Breeder.
           * @implements IBreeder
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBreeder=} [properties] Properties to set
           */
          function Breeder(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Breeder id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @instance
           */
          Breeder.prototype.id = "";

          /**
           * Breeder name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @instance
           */
          Breeder.prototype.name = "";

          /**
           * Creates a new Breeder instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @static
           * @param {stronachgroup.first.racehorse360.IBreeder=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Breeder} Breeder instance
           */
          Breeder.create = function create(properties) {
            return new Breeder(properties);
          };

          /**
           * Encodes the specified Breeder message. Does not implicitly {@link stronachgroup.first.racehorse360.Breeder.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @static
           * @param {stronachgroup.first.racehorse360.IBreeder} message Breeder message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Breeder.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            return writer;
          };

          /**
           * Decodes a Breeder message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Breeder} Breeder
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Breeder.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Breeder();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Breeder message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Breeder} Breeder
           */
          Breeder.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Breeder
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Breeder();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            return message;
          };

          /**
           * Creates a plain object from a Breeder message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @static
           * @param {stronachgroup.first.racehorse360.Breeder} message Breeder
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Breeder.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            return object;
          };

          /**
           * Converts this Breeder to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Breeder
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Breeder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Breeder;
        })();

        racehorse360.HorseLifetime = (function () {
          /**
           * Properties of a HorseLifetime.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseLifetime
           * @property {number|null} [starts] HorseLifetime starts
           * @property {number|null} [wins] HorseLifetime wins
           * @property {number|null} [place] HorseLifetime place
           * @property {number|null} [show] HorseLifetime show
           */

          /**
           * Constructs a new HorseLifetime.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseLifetime.
           * @implements IHorseLifetime
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseLifetime=} [properties] Properties to set
           */
          function HorseLifetime(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseLifetime starts.
           * @member {number} starts
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @instance
           */
          HorseLifetime.prototype.starts = 0;

          /**
           * HorseLifetime wins.
           * @member {number} wins
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @instance
           */
          HorseLifetime.prototype.wins = 0;

          /**
           * HorseLifetime place.
           * @member {number} place
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @instance
           */
          HorseLifetime.prototype.place = 0;

          /**
           * HorseLifetime show.
           * @member {number} show
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @instance
           */
          HorseLifetime.prototype.show = 0;

          /**
           * Creates a new HorseLifetime instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLifetime=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseLifetime} HorseLifetime instance
           */
          HorseLifetime.create = function create(properties) {
            return new HorseLifetime(properties);
          };

          /**
           * Encodes the specified HorseLifetime message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseLifetime.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLifetime} message HorseLifetime message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseLifetime.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.starts != null &&
              Object.hasOwnProperty.call(message, "starts")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.starts);
            if (
              message.wins != null &&
              Object.hasOwnProperty.call(message, "wins")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.wins);
            if (
              message.place != null &&
              Object.hasOwnProperty.call(message, "place")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.place);
            if (
              message.show != null &&
              Object.hasOwnProperty.call(message, "show")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.show);
            return writer;
          };

          /**
           * Decodes a HorseLifetime message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseLifetime} HorseLifetime
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseLifetime.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseLifetime();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.starts = reader.int32();
                  break;
                case 2:
                  message.wins = reader.int32();
                  break;
                case 3:
                  message.place = reader.int32();
                  break;
                case 4:
                  message.show = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseLifetime message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseLifetime} HorseLifetime
           */
          HorseLifetime.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseLifetime
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseLifetime();
            if (object.starts != null) message.starts = object.starts | 0;
            if (object.wins != null) message.wins = object.wins | 0;
            if (object.place != null) message.place = object.place | 0;
            if (object.show != null) message.show = object.show | 0;
            return message;
          };

          /**
           * Creates a plain object from a HorseLifetime message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @static
           * @param {stronachgroup.first.racehorse360.HorseLifetime} message HorseLifetime
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseLifetime.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.starts = 0;
              object.wins = 0;
              object.place = 0;
              object.show = 0;
            }
            if (message.starts != null && message.hasOwnProperty("starts"))
              object.starts = message.starts;
            if (message.wins != null && message.hasOwnProperty("wins"))
              object.wins = message.wins;
            if (message.place != null && message.hasOwnProperty("place"))
              object.place = message.place;
            if (message.show != null && message.hasOwnProperty("show"))
              object.show = message.show;
            return object;
          };

          /**
           * Converts this HorseLifetime to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseLifetime
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseLifetime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseLifetime;
        })();

        racehorse360.HorseLastPastPerformance = (function () {
          /**
           * Properties of a HorseLastPastPerformance.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseLastPastPerformance
           * @property {string|null} [id] HorseLastPastPerformance id
           * @property {string|null} [date] HorseLastPastPerformance date
           * @property {number|null} [raceNumber] HorseLastPastPerformance raceNumber
           * @property {string|null} [track] HorseLastPastPerformance track
           * @property {string|null} [country] HorseLastPastPerformance country
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseType] HorseLastPastPerformance courseType
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [scheduledCourseType] HorseLastPastPerformance scheduledCourseType
           * @property {number|null} [temporaryRailDistance] HorseLastPastPerformance temporaryRailDistance
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] HorseLastPastPerformance trackCondition
           * @property {number|null} [raceDistance] HorseLastPastPerformance raceDistance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [raceDistanceUnit] HorseLastPastPerformance raceDistanceUnit
           * @property {string|null} [raceType] HorseLastPastPerformance raceType
           * @property {string|null} [raceName] HorseLastPastPerformance raceName
           * @property {string|null} [raceConditions] HorseLastPastPerformance raceConditions
           * @property {number|null} [racePurse] HorseLastPastPerformance racePurse
           * @property {number|null} [raceMaxClaimingPrice] HorseLastPastPerformance raceMaxClaimingPrice
           * @property {number|null} [raceMinClaimingPrice] HorseLastPastPerformance raceMinClaimingPrice
           * @property {number|null} [positionAtPointOfCall_1] HorseLastPastPerformance positionAtPointOfCall_1
           * @property {number|null} [lengthBehindAtPointOfCall_1] HorseLastPastPerformance lengthBehindAtPointOfCall_1
           * @property {number|null} [lengthAheadAtPointOfCall_1] HorseLastPastPerformance lengthAheadAtPointOfCall_1
           * @property {number|null} [positionAtPointOfCall_2] HorseLastPastPerformance positionAtPointOfCall_2
           * @property {number|null} [lengthBehindAtPointOfCall_2] HorseLastPastPerformance lengthBehindAtPointOfCall_2
           * @property {number|null} [lengthAheadAtPointOfCall_2] HorseLastPastPerformance lengthAheadAtPointOfCall_2
           * @property {number|null} [positionAtPointOfCall_3] HorseLastPastPerformance positionAtPointOfCall_3
           * @property {number|null} [lengthBehindAtPointOfCall_3] HorseLastPastPerformance lengthBehindAtPointOfCall_3
           * @property {number|null} [lengthAheadAtPointOfCall_3] HorseLastPastPerformance lengthAheadAtPointOfCall_3
           * @property {number|null} [positionAtPointOfCall_4] HorseLastPastPerformance positionAtPointOfCall_4
           * @property {number|null} [lengthBehindAtPointOfCall_4] HorseLastPastPerformance lengthBehindAtPointOfCall_4
           * @property {number|null} [lengthAheadAtPointOfCall_4] HorseLastPastPerformance lengthAheadAtPointOfCall_4
           * @property {number|null} [positionAtPointOfCall_5] HorseLastPastPerformance positionAtPointOfCall_5
           * @property {number|null} [lengthBehindAtPointOfCall_5] HorseLastPastPerformance lengthBehindAtPointOfCall_5
           * @property {number|null} [lengthAheadAtPointOfCall_5] HorseLastPastPerformance lengthAheadAtPointOfCall_5
           * @property {number|null} [positionAtFinish] HorseLastPastPerformance positionAtFinish
           * @property {number|null} [lengthBehindAtFinish] HorseLastPastPerformance lengthBehindAtFinish
           * @property {number|null} [lengthAheadAtFinish] HorseLastPastPerformance lengthAheadAtFinish
           * @property {string|null} [jockeyFirstName] HorseLastPastPerformance jockeyFirstName
           * @property {string|null} [jockeyLastName] HorseLastPastPerformance jockeyLastName
           * @property {google.protobuf.IBoolValue|null} [isPostTimeFavorite] HorseLastPastPerformance isPostTimeFavorite
           * @property {number|null} [odds] HorseLastPastPerformance odds
           * @property {google.protobuf.IBoolValue|null} [isTroubledTrip] HorseLastPastPerformance isTroubledTrip
           * @property {string|null} [shortComment] HorseLastPastPerformance shortComment
           * @property {number|null} [fieldSize] HorseLastPastPerformance fieldSize
           * @property {google.protobuf.IBoolValue|null} [isClaimed] HorseLastPastPerformance isClaimed
           * @property {string|null} [ownerFirstName] HorseLastPastPerformance ownerFirstName
           * @property {string|null} [ownerLastName] HorseLastPastPerformance ownerLastName
           * @property {string|null} [newOwnerFirstName] HorseLastPastPerformance newOwnerFirstName
           * @property {string|null} [newOwnerLastName] HorseLastPastPerformance newOwnerLastName
           * @property {string|null} [newTrainerFirstName] HorseLastPastPerformance newTrainerFirstName
           * @property {string|null} [newTrainerLastName] HorseLastPastPerformance newTrainerLastName
           * @property {number|null} [claimedPriceUsa] HorseLastPastPerformance claimedPriceUsa
           * @property {string|null} [comment] HorseLastPastPerformance comment
           */

          /**
           * Constructs a new HorseLastPastPerformance.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseLastPastPerformance.
           * @implements IHorseLastPastPerformance
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseLastPastPerformance=} [properties] Properties to set
           */
          function HorseLastPastPerformance(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseLastPastPerformance id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.id = "";

          /**
           * HorseLastPastPerformance date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.date = "";

          /**
           * HorseLastPastPerformance raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceNumber = 0;

          /**
           * HorseLastPastPerformance track.
           * @member {string} track
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.track = "";

          /**
           * HorseLastPastPerformance country.
           * @member {string} country
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.country = "";

          /**
           * HorseLastPastPerformance courseType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseType
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.courseType = 0;

          /**
           * HorseLastPastPerformance scheduledCourseType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} scheduledCourseType
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.scheduledCourseType = 0;

          /**
           * HorseLastPastPerformance temporaryRailDistance.
           * @member {number} temporaryRailDistance
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.temporaryRailDistance = 0;

          /**
           * HorseLastPastPerformance trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.trackCondition = 0;

          /**
           * HorseLastPastPerformance raceDistance.
           * @member {number} raceDistance
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceDistance = 0;

          /**
           * HorseLastPastPerformance raceDistanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} raceDistanceUnit
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceDistanceUnit = 0;

          /**
           * HorseLastPastPerformance raceType.
           * @member {string} raceType
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceType = "";

          /**
           * HorseLastPastPerformance raceName.
           * @member {string} raceName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceName = "";

          /**
           * HorseLastPastPerformance raceConditions.
           * @member {string} raceConditions
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceConditions = "";

          /**
           * HorseLastPastPerformance racePurse.
           * @member {number} racePurse
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.racePurse = 0;

          /**
           * HorseLastPastPerformance raceMaxClaimingPrice.
           * @member {number} raceMaxClaimingPrice
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceMaxClaimingPrice = 0;

          /**
           * HorseLastPastPerformance raceMinClaimingPrice.
           * @member {number} raceMinClaimingPrice
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.raceMinClaimingPrice = 0;

          /**
           * HorseLastPastPerformance positionAtPointOfCall_1.
           * @member {number} positionAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtPointOfCall_1 = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtPointOfCall_1.
           * @member {number} lengthBehindAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtPointOfCall_1 = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtPointOfCall_1.
           * @member {number} lengthAheadAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtPointOfCall_1 = 0;

          /**
           * HorseLastPastPerformance positionAtPointOfCall_2.
           * @member {number} positionAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtPointOfCall_2 = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtPointOfCall_2.
           * @member {number} lengthBehindAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtPointOfCall_2 = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtPointOfCall_2.
           * @member {number} lengthAheadAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtPointOfCall_2 = 0;

          /**
           * HorseLastPastPerformance positionAtPointOfCall_3.
           * @member {number} positionAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtPointOfCall_3 = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtPointOfCall_3.
           * @member {number} lengthBehindAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtPointOfCall_3 = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtPointOfCall_3.
           * @member {number} lengthAheadAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtPointOfCall_3 = 0;

          /**
           * HorseLastPastPerformance positionAtPointOfCall_4.
           * @member {number} positionAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtPointOfCall_4 = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtPointOfCall_4.
           * @member {number} lengthBehindAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtPointOfCall_4 = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtPointOfCall_4.
           * @member {number} lengthAheadAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtPointOfCall_4 = 0;

          /**
           * HorseLastPastPerformance positionAtPointOfCall_5.
           * @member {number} positionAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtPointOfCall_5 = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtPointOfCall_5.
           * @member {number} lengthBehindAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtPointOfCall_5 = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtPointOfCall_5.
           * @member {number} lengthAheadAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtPointOfCall_5 = 0;

          /**
           * HorseLastPastPerformance positionAtFinish.
           * @member {number} positionAtFinish
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.positionAtFinish = 0;

          /**
           * HorseLastPastPerformance lengthBehindAtFinish.
           * @member {number} lengthBehindAtFinish
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthBehindAtFinish = 0;

          /**
           * HorseLastPastPerformance lengthAheadAtFinish.
           * @member {number} lengthAheadAtFinish
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.lengthAheadAtFinish = 0;

          /**
           * HorseLastPastPerformance jockeyFirstName.
           * @member {string} jockeyFirstName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.jockeyFirstName = "";

          /**
           * HorseLastPastPerformance jockeyLastName.
           * @member {string} jockeyLastName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.jockeyLastName = "";

          /**
           * HorseLastPastPerformance isPostTimeFavorite.
           * @member {google.protobuf.IBoolValue|null|undefined} isPostTimeFavorite
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.isPostTimeFavorite = null;

          /**
           * HorseLastPastPerformance odds.
           * @member {number} odds
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.odds = 0;

          /**
           * HorseLastPastPerformance isTroubledTrip.
           * @member {google.protobuf.IBoolValue|null|undefined} isTroubledTrip
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.isTroubledTrip = null;

          /**
           * HorseLastPastPerformance shortComment.
           * @member {string} shortComment
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.shortComment = "";

          /**
           * HorseLastPastPerformance fieldSize.
           * @member {number} fieldSize
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.fieldSize = 0;

          /**
           * HorseLastPastPerformance isClaimed.
           * @member {google.protobuf.IBoolValue|null|undefined} isClaimed
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.isClaimed = null;

          /**
           * HorseLastPastPerformance ownerFirstName.
           * @member {string} ownerFirstName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.ownerFirstName = "";

          /**
           * HorseLastPastPerformance ownerLastName.
           * @member {string} ownerLastName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.ownerLastName = "";

          /**
           * HorseLastPastPerformance newOwnerFirstName.
           * @member {string} newOwnerFirstName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.newOwnerFirstName = "";

          /**
           * HorseLastPastPerformance newOwnerLastName.
           * @member {string} newOwnerLastName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.newOwnerLastName = "";

          /**
           * HorseLastPastPerformance newTrainerFirstName.
           * @member {string} newTrainerFirstName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.newTrainerFirstName = "";

          /**
           * HorseLastPastPerformance newTrainerLastName.
           * @member {string} newTrainerLastName
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.newTrainerLastName = "";

          /**
           * HorseLastPastPerformance claimedPriceUsa.
           * @member {number} claimedPriceUsa
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.claimedPriceUsa = 0;

          /**
           * HorseLastPastPerformance comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           */
          HorseLastPastPerformance.prototype.comment = "";

          /**
           * Creates a new HorseLastPastPerformance instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLastPastPerformance=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseLastPastPerformance} HorseLastPastPerformance instance
           */
          HorseLastPastPerformance.create = function create(properties) {
            return new HorseLastPastPerformance(properties);
          };

          /**
           * Encodes the specified HorseLastPastPerformance message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseLastPastPerformance.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLastPastPerformance} message HorseLastPastPerformance message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseLastPastPerformance.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.date);
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.raceNumber);
            if (
              message.track != null &&
              Object.hasOwnProperty.call(message, "track")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.track);
            if (
              message.country != null &&
              Object.hasOwnProperty.call(message, "country")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.country);
            if (
              message.courseType != null &&
              Object.hasOwnProperty.call(message, "courseType")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.courseType);
            if (
              message.scheduledCourseType != null &&
              Object.hasOwnProperty.call(message, "scheduledCourseType")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.scheduledCourseType);
            if (
              message.temporaryRailDistance != null &&
              Object.hasOwnProperty.call(message, "temporaryRailDistance")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.temporaryRailDistance);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.trackCondition);
            if (
              message.raceDistance != null &&
              Object.hasOwnProperty.call(message, "raceDistance")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.raceDistance);
            if (
              message.raceDistanceUnit != null &&
              Object.hasOwnProperty.call(message, "raceDistanceUnit")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.raceDistanceUnit);
            if (
              message.raceType != null &&
              Object.hasOwnProperty.call(message, "raceType")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.raceType);
            if (
              message.raceName != null &&
              Object.hasOwnProperty.call(message, "raceName")
            )
              writer
                .uint32(/* id 13, wireType 2 =*/ 106)
                .string(message.raceName);
            if (
              message.raceConditions != null &&
              Object.hasOwnProperty.call(message, "raceConditions")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.raceConditions);
            if (
              message.racePurse != null &&
              Object.hasOwnProperty.call(message, "racePurse")
            )
              writer
                .uint32(/* id 15, wireType 5 =*/ 125)
                .float(message.racePurse);
            if (
              message.raceMaxClaimingPrice != null &&
              Object.hasOwnProperty.call(message, "raceMaxClaimingPrice")
            )
              writer
                .uint32(/* id 16, wireType 5 =*/ 133)
                .float(message.raceMaxClaimingPrice);
            if (
              message.raceMinClaimingPrice != null &&
              Object.hasOwnProperty.call(message, "raceMinClaimingPrice")
            )
              writer
                .uint32(/* id 17, wireType 5 =*/ 141)
                .float(message.raceMinClaimingPrice);
            if (
              message.positionAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_1")
            )
              writer
                .uint32(/* id 18, wireType 0 =*/ 144)
                .int32(message.positionAtPointOfCall_1);
            if (
              message.lengthBehindAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_1")
            )
              writer
                .uint32(/* id 19, wireType 0 =*/ 152)
                .int32(message.lengthBehindAtPointOfCall_1);
            if (
              message.lengthAheadAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_1")
            )
              writer
                .uint32(/* id 20, wireType 0 =*/ 160)
                .int32(message.lengthAheadAtPointOfCall_1);
            if (
              message.positionAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_2")
            )
              writer
                .uint32(/* id 21, wireType 0 =*/ 168)
                .int32(message.positionAtPointOfCall_2);
            if (
              message.lengthBehindAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_2")
            )
              writer
                .uint32(/* id 22, wireType 0 =*/ 176)
                .int32(message.lengthBehindAtPointOfCall_2);
            if (
              message.lengthAheadAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_2")
            )
              writer
                .uint32(/* id 23, wireType 0 =*/ 184)
                .int32(message.lengthAheadAtPointOfCall_2);
            if (
              message.positionAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_3")
            )
              writer
                .uint32(/* id 24, wireType 0 =*/ 192)
                .int32(message.positionAtPointOfCall_3);
            if (
              message.lengthBehindAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_3")
            )
              writer
                .uint32(/* id 25, wireType 0 =*/ 200)
                .int32(message.lengthBehindAtPointOfCall_3);
            if (
              message.lengthAheadAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_3")
            )
              writer
                .uint32(/* id 26, wireType 0 =*/ 208)
                .int32(message.lengthAheadAtPointOfCall_3);
            if (
              message.positionAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_4")
            )
              writer
                .uint32(/* id 27, wireType 0 =*/ 216)
                .int32(message.positionAtPointOfCall_4);
            if (
              message.lengthBehindAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_4")
            )
              writer
                .uint32(/* id 28, wireType 0 =*/ 224)
                .int32(message.lengthBehindAtPointOfCall_4);
            if (
              message.lengthAheadAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_4")
            )
              writer
                .uint32(/* id 29, wireType 0 =*/ 232)
                .int32(message.lengthAheadAtPointOfCall_4);
            if (
              message.positionAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_5")
            )
              writer
                .uint32(/* id 30, wireType 0 =*/ 240)
                .int32(message.positionAtPointOfCall_5);
            if (
              message.lengthBehindAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_5")
            )
              writer
                .uint32(/* id 31, wireType 0 =*/ 248)
                .int32(message.lengthBehindAtPointOfCall_5);
            if (
              message.lengthAheadAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_5")
            )
              writer
                .uint32(/* id 32, wireType 0 =*/ 256)
                .int32(message.lengthAheadAtPointOfCall_5);
            if (
              message.positionAtFinish != null &&
              Object.hasOwnProperty.call(message, "positionAtFinish")
            )
              writer
                .uint32(/* id 33, wireType 0 =*/ 264)
                .int32(message.positionAtFinish);
            if (
              message.lengthBehindAtFinish != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtFinish")
            )
              writer
                .uint32(/* id 34, wireType 0 =*/ 272)
                .int32(message.lengthBehindAtFinish);
            if (
              message.lengthAheadAtFinish != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtFinish")
            )
              writer
                .uint32(/* id 35, wireType 0 =*/ 280)
                .int32(message.lengthAheadAtFinish);
            if (
              message.jockeyFirstName != null &&
              Object.hasOwnProperty.call(message, "jockeyFirstName")
            )
              writer
                .uint32(/* id 36, wireType 2 =*/ 290)
                .string(message.jockeyFirstName);
            if (
              message.jockeyLastName != null &&
              Object.hasOwnProperty.call(message, "jockeyLastName")
            )
              writer
                .uint32(/* id 37, wireType 2 =*/ 298)
                .string(message.jockeyLastName);
            if (
              message.isPostTimeFavorite != null &&
              Object.hasOwnProperty.call(message, "isPostTimeFavorite")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isPostTimeFavorite,
                writer.uint32(/* id 38, wireType 2 =*/ 306).fork()
              ).ldelim();
            if (
              message.odds != null &&
              Object.hasOwnProperty.call(message, "odds")
            )
              writer.uint32(/* id 39, wireType 0 =*/ 312).int32(message.odds);
            if (
              message.isTroubledTrip != null &&
              Object.hasOwnProperty.call(message, "isTroubledTrip")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isTroubledTrip,
                writer.uint32(/* id 40, wireType 2 =*/ 322).fork()
              ).ldelim();
            if (
              message.shortComment != null &&
              Object.hasOwnProperty.call(message, "shortComment")
            )
              writer
                .uint32(/* id 41, wireType 2 =*/ 330)
                .string(message.shortComment);
            if (
              message.fieldSize != null &&
              Object.hasOwnProperty.call(message, "fieldSize")
            )
              writer
                .uint32(/* id 42, wireType 0 =*/ 336)
                .int32(message.fieldSize);
            if (
              message.isClaimed != null &&
              Object.hasOwnProperty.call(message, "isClaimed")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isClaimed,
                writer.uint32(/* id 43, wireType 2 =*/ 346).fork()
              ).ldelim();
            if (
              message.ownerFirstName != null &&
              Object.hasOwnProperty.call(message, "ownerFirstName")
            )
              writer
                .uint32(/* id 44, wireType 2 =*/ 354)
                .string(message.ownerFirstName);
            if (
              message.ownerLastName != null &&
              Object.hasOwnProperty.call(message, "ownerLastName")
            )
              writer
                .uint32(/* id 45, wireType 2 =*/ 362)
                .string(message.ownerLastName);
            if (
              message.newOwnerFirstName != null &&
              Object.hasOwnProperty.call(message, "newOwnerFirstName")
            )
              writer
                .uint32(/* id 46, wireType 2 =*/ 370)
                .string(message.newOwnerFirstName);
            if (
              message.newOwnerLastName != null &&
              Object.hasOwnProperty.call(message, "newOwnerLastName")
            )
              writer
                .uint32(/* id 47, wireType 2 =*/ 378)
                .string(message.newOwnerLastName);
            if (
              message.newTrainerFirstName != null &&
              Object.hasOwnProperty.call(message, "newTrainerFirstName")
            )
              writer
                .uint32(/* id 48, wireType 2 =*/ 386)
                .string(message.newTrainerFirstName);
            if (
              message.newTrainerLastName != null &&
              Object.hasOwnProperty.call(message, "newTrainerLastName")
            )
              writer
                .uint32(/* id 49, wireType 2 =*/ 394)
                .string(message.newTrainerLastName);
            if (
              message.claimedPriceUsa != null &&
              Object.hasOwnProperty.call(message, "claimedPriceUsa")
            )
              writer
                .uint32(/* id 50, wireType 5 =*/ 405)
                .float(message.claimedPriceUsa);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer
                .uint32(/* id 51, wireType 2 =*/ 410)
                .string(message.comment);
            return writer;
          };

          /**
           * Decodes a HorseLastPastPerformance message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseLastPastPerformance} HorseLastPastPerformance
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseLastPastPerformance.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseLastPastPerformance();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.date = reader.string();
                  break;
                case 3:
                  message.raceNumber = reader.int32();
                  break;
                case 4:
                  message.track = reader.string();
                  break;
                case 5:
                  message.country = reader.string();
                  break;
                case 6:
                  message.courseType = reader.int32();
                  break;
                case 7:
                  message.scheduledCourseType = reader.int32();
                  break;
                case 8:
                  message.temporaryRailDistance = reader.int32();
                  break;
                case 9:
                  message.trackCondition = reader.int32();
                  break;
                case 10:
                  message.raceDistance = reader.int32();
                  break;
                case 11:
                  message.raceDistanceUnit = reader.int32();
                  break;
                case 12:
                  message.raceType = reader.string();
                  break;
                case 13:
                  message.raceName = reader.string();
                  break;
                case 14:
                  message.raceConditions = reader.string();
                  break;
                case 15:
                  message.racePurse = reader.float();
                  break;
                case 16:
                  message.raceMaxClaimingPrice = reader.float();
                  break;
                case 17:
                  message.raceMinClaimingPrice = reader.float();
                  break;
                case 18:
                  message.positionAtPointOfCall_1 = reader.int32();
                  break;
                case 19:
                  message.lengthBehindAtPointOfCall_1 = reader.int32();
                  break;
                case 20:
                  message.lengthAheadAtPointOfCall_1 = reader.int32();
                  break;
                case 21:
                  message.positionAtPointOfCall_2 = reader.int32();
                  break;
                case 22:
                  message.lengthBehindAtPointOfCall_2 = reader.int32();
                  break;
                case 23:
                  message.lengthAheadAtPointOfCall_2 = reader.int32();
                  break;
                case 24:
                  message.positionAtPointOfCall_3 = reader.int32();
                  break;
                case 25:
                  message.lengthBehindAtPointOfCall_3 = reader.int32();
                  break;
                case 26:
                  message.lengthAheadAtPointOfCall_3 = reader.int32();
                  break;
                case 27:
                  message.positionAtPointOfCall_4 = reader.int32();
                  break;
                case 28:
                  message.lengthBehindAtPointOfCall_4 = reader.int32();
                  break;
                case 29:
                  message.lengthAheadAtPointOfCall_4 = reader.int32();
                  break;
                case 30:
                  message.positionAtPointOfCall_5 = reader.int32();
                  break;
                case 31:
                  message.lengthBehindAtPointOfCall_5 = reader.int32();
                  break;
                case 32:
                  message.lengthAheadAtPointOfCall_5 = reader.int32();
                  break;
                case 33:
                  message.positionAtFinish = reader.int32();
                  break;
                case 34:
                  message.lengthBehindAtFinish = reader.int32();
                  break;
                case 35:
                  message.lengthAheadAtFinish = reader.int32();
                  break;
                case 36:
                  message.jockeyFirstName = reader.string();
                  break;
                case 37:
                  message.jockeyLastName = reader.string();
                  break;
                case 38:
                  message.isPostTimeFavorite =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 39:
                  message.odds = reader.int32();
                  break;
                case 40:
                  message.isTroubledTrip =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 41:
                  message.shortComment = reader.string();
                  break;
                case 42:
                  message.fieldSize = reader.int32();
                  break;
                case 43:
                  message.isClaimed = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 44:
                  message.ownerFirstName = reader.string();
                  break;
                case 45:
                  message.ownerLastName = reader.string();
                  break;
                case 46:
                  message.newOwnerFirstName = reader.string();
                  break;
                case 47:
                  message.newOwnerLastName = reader.string();
                  break;
                case 48:
                  message.newTrainerFirstName = reader.string();
                  break;
                case 49:
                  message.newTrainerLastName = reader.string();
                  break;
                case 50:
                  message.claimedPriceUsa = reader.float();
                  break;
                case 51:
                  message.comment = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseLastPastPerformance message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseLastPastPerformance} HorseLastPastPerformance
           */
          HorseLastPastPerformance.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseLastPastPerformance
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseLastPastPerformance();
            if (object.id != null) message.id = String(object.id);
            if (object.date != null) message.date = String(object.date);
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.track != null) message.track = String(object.track);
            if (object.country != null)
              message.country = String(object.country);
            switch (object.courseType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseType = 17;
                break;
            }
            switch (object.scheduledCourseType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.scheduledCourseType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.scheduledCourseType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.scheduledCourseType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.scheduledCourseType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.scheduledCourseType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.scheduledCourseType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.scheduledCourseType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.scheduledCourseType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.scheduledCourseType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.scheduledCourseType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.scheduledCourseType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.scheduledCourseType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.scheduledCourseType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.scheduledCourseType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.scheduledCourseType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.scheduledCourseType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.scheduledCourseType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.scheduledCourseType = 17;
                break;
            }
            if (object.temporaryRailDistance != null)
              message.temporaryRailDistance = object.temporaryRailDistance | 0;
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.raceDistance != null)
              message.raceDistance = object.raceDistance | 0;
            switch (object.raceDistanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.raceDistanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.raceDistanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.raceDistanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.raceDistanceUnit = 3;
                break;
            }
            if (object.raceType != null)
              message.raceType = String(object.raceType);
            if (object.raceName != null)
              message.raceName = String(object.raceName);
            if (object.raceConditions != null)
              message.raceConditions = String(object.raceConditions);
            if (object.racePurse != null)
              message.racePurse = Number(object.racePurse);
            if (object.raceMaxClaimingPrice != null)
              message.raceMaxClaimingPrice = Number(
                object.raceMaxClaimingPrice
              );
            if (object.raceMinClaimingPrice != null)
              message.raceMinClaimingPrice = Number(
                object.raceMinClaimingPrice
              );
            if (object.positionAtPointOfCall_1 != null)
              message.positionAtPointOfCall_1 =
                object.positionAtPointOfCall_1 | 0;
            if (object.lengthBehindAtPointOfCall_1 != null)
              message.lengthBehindAtPointOfCall_1 =
                object.lengthBehindAtPointOfCall_1 | 0;
            if (object.lengthAheadAtPointOfCall_1 != null)
              message.lengthAheadAtPointOfCall_1 =
                object.lengthAheadAtPointOfCall_1 | 0;
            if (object.positionAtPointOfCall_2 != null)
              message.positionAtPointOfCall_2 =
                object.positionAtPointOfCall_2 | 0;
            if (object.lengthBehindAtPointOfCall_2 != null)
              message.lengthBehindAtPointOfCall_2 =
                object.lengthBehindAtPointOfCall_2 | 0;
            if (object.lengthAheadAtPointOfCall_2 != null)
              message.lengthAheadAtPointOfCall_2 =
                object.lengthAheadAtPointOfCall_2 | 0;
            if (object.positionAtPointOfCall_3 != null)
              message.positionAtPointOfCall_3 =
                object.positionAtPointOfCall_3 | 0;
            if (object.lengthBehindAtPointOfCall_3 != null)
              message.lengthBehindAtPointOfCall_3 =
                object.lengthBehindAtPointOfCall_3 | 0;
            if (object.lengthAheadAtPointOfCall_3 != null)
              message.lengthAheadAtPointOfCall_3 =
                object.lengthAheadAtPointOfCall_3 | 0;
            if (object.positionAtPointOfCall_4 != null)
              message.positionAtPointOfCall_4 =
                object.positionAtPointOfCall_4 | 0;
            if (object.lengthBehindAtPointOfCall_4 != null)
              message.lengthBehindAtPointOfCall_4 =
                object.lengthBehindAtPointOfCall_4 | 0;
            if (object.lengthAheadAtPointOfCall_4 != null)
              message.lengthAheadAtPointOfCall_4 =
                object.lengthAheadAtPointOfCall_4 | 0;
            if (object.positionAtPointOfCall_5 != null)
              message.positionAtPointOfCall_5 =
                object.positionAtPointOfCall_5 | 0;
            if (object.lengthBehindAtPointOfCall_5 != null)
              message.lengthBehindAtPointOfCall_5 =
                object.lengthBehindAtPointOfCall_5 | 0;
            if (object.lengthAheadAtPointOfCall_5 != null)
              message.lengthAheadAtPointOfCall_5 =
                object.lengthAheadAtPointOfCall_5 | 0;
            if (object.positionAtFinish != null)
              message.positionAtFinish = object.positionAtFinish | 0;
            if (object.lengthBehindAtFinish != null)
              message.lengthBehindAtFinish = object.lengthBehindAtFinish | 0;
            if (object.lengthAheadAtFinish != null)
              message.lengthAheadAtFinish = object.lengthAheadAtFinish | 0;
            if (object.jockeyFirstName != null)
              message.jockeyFirstName = String(object.jockeyFirstName);
            if (object.jockeyLastName != null)
              message.jockeyLastName = String(object.jockeyLastName);
            if (object.isPostTimeFavorite != null) {
              if (typeof object.isPostTimeFavorite !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseLastPastPerformance.isPostTimeFavorite: object expected"
                );
              message.isPostTimeFavorite =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isPostTimeFavorite
                );
            }
            if (object.odds != null) message.odds = object.odds | 0;
            if (object.isTroubledTrip != null) {
              if (typeof object.isTroubledTrip !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseLastPastPerformance.isTroubledTrip: object expected"
                );
              message.isTroubledTrip =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isTroubledTrip
                );
            }
            if (object.shortComment != null)
              message.shortComment = String(object.shortComment);
            if (object.fieldSize != null)
              message.fieldSize = object.fieldSize | 0;
            if (object.isClaimed != null) {
              if (typeof object.isClaimed !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseLastPastPerformance.isClaimed: object expected"
                );
              message.isClaimed = $root.google.protobuf.BoolValue.fromObject(
                object.isClaimed
              );
            }
            if (object.ownerFirstName != null)
              message.ownerFirstName = String(object.ownerFirstName);
            if (object.ownerLastName != null)
              message.ownerLastName = String(object.ownerLastName);
            if (object.newOwnerFirstName != null)
              message.newOwnerFirstName = String(object.newOwnerFirstName);
            if (object.newOwnerLastName != null)
              message.newOwnerLastName = String(object.newOwnerLastName);
            if (object.newTrainerFirstName != null)
              message.newTrainerFirstName = String(object.newTrainerFirstName);
            if (object.newTrainerLastName != null)
              message.newTrainerLastName = String(object.newTrainerLastName);
            if (object.claimedPriceUsa != null)
              message.claimedPriceUsa = Number(object.claimedPriceUsa);
            if (object.comment != null)
              message.comment = String(object.comment);
            return message;
          };

          /**
           * Creates a plain object from a HorseLastPastPerformance message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @static
           * @param {stronachgroup.first.racehorse360.HorseLastPastPerformance} message HorseLastPastPerformance
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseLastPastPerformance.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.date = "";
              object.raceNumber = 0;
              object.track = "";
              object.country = "";
              object.courseType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.scheduledCourseType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.temporaryRailDistance = 0;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.raceDistance = 0;
              object.raceDistanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
              object.raceType = "";
              object.raceName = "";
              object.raceConditions = "";
              object.racePurse = 0;
              object.raceMaxClaimingPrice = 0;
              object.raceMinClaimingPrice = 0;
              object.positionAtPointOfCall_1 = 0;
              object.lengthBehindAtPointOfCall_1 = 0;
              object.lengthAheadAtPointOfCall_1 = 0;
              object.positionAtPointOfCall_2 = 0;
              object.lengthBehindAtPointOfCall_2 = 0;
              object.lengthAheadAtPointOfCall_2 = 0;
              object.positionAtPointOfCall_3 = 0;
              object.lengthBehindAtPointOfCall_3 = 0;
              object.lengthAheadAtPointOfCall_3 = 0;
              object.positionAtPointOfCall_4 = 0;
              object.lengthBehindAtPointOfCall_4 = 0;
              object.lengthAheadAtPointOfCall_4 = 0;
              object.positionAtPointOfCall_5 = 0;
              object.lengthBehindAtPointOfCall_5 = 0;
              object.lengthAheadAtPointOfCall_5 = 0;
              object.positionAtFinish = 0;
              object.lengthBehindAtFinish = 0;
              object.lengthAheadAtFinish = 0;
              object.jockeyFirstName = "";
              object.jockeyLastName = "";
              object.isPostTimeFavorite = null;
              object.odds = 0;
              object.isTroubledTrip = null;
              object.shortComment = "";
              object.fieldSize = 0;
              object.isClaimed = null;
              object.ownerFirstName = "";
              object.ownerLastName = "";
              object.newOwnerFirstName = "";
              object.newOwnerLastName = "";
              object.newTrainerFirstName = "";
              object.newTrainerLastName = "";
              object.claimedPriceUsa = 0;
              object.comment = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (message.track != null && message.hasOwnProperty("track"))
              object.track = message.track;
            if (message.country != null && message.hasOwnProperty("country"))
              object.country = message.country;
            if (
              message.courseType != null &&
              message.hasOwnProperty("courseType")
            )
              object.courseType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseType
                    ]
                  : message.courseType;
            if (
              message.scheduledCourseType != null &&
              message.hasOwnProperty("scheduledCourseType")
            )
              object.scheduledCourseType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.scheduledCourseType
                    ]
                  : message.scheduledCourseType;
            if (
              message.temporaryRailDistance != null &&
              message.hasOwnProperty("temporaryRailDistance")
            )
              object.temporaryRailDistance = message.temporaryRailDistance;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (
              message.raceDistance != null &&
              message.hasOwnProperty("raceDistance")
            )
              object.raceDistance = message.raceDistance;
            if (
              message.raceDistanceUnit != null &&
              message.hasOwnProperty("raceDistanceUnit")
            )
              object.raceDistanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.raceDistanceUnit
                    ]
                  : message.raceDistanceUnit;
            if (message.raceType != null && message.hasOwnProperty("raceType"))
              object.raceType = message.raceType;
            if (message.raceName != null && message.hasOwnProperty("raceName"))
              object.raceName = message.raceName;
            if (
              message.raceConditions != null &&
              message.hasOwnProperty("raceConditions")
            )
              object.raceConditions = message.raceConditions;
            if (
              message.racePurse != null &&
              message.hasOwnProperty("racePurse")
            )
              object.racePurse =
                options.json && !isFinite(message.racePurse)
                  ? String(message.racePurse)
                  : message.racePurse;
            if (
              message.raceMaxClaimingPrice != null &&
              message.hasOwnProperty("raceMaxClaimingPrice")
            )
              object.raceMaxClaimingPrice =
                options.json && !isFinite(message.raceMaxClaimingPrice)
                  ? String(message.raceMaxClaimingPrice)
                  : message.raceMaxClaimingPrice;
            if (
              message.raceMinClaimingPrice != null &&
              message.hasOwnProperty("raceMinClaimingPrice")
            )
              object.raceMinClaimingPrice =
                options.json && !isFinite(message.raceMinClaimingPrice)
                  ? String(message.raceMinClaimingPrice)
                  : message.raceMinClaimingPrice;
            if (
              message.positionAtPointOfCall_1 != null &&
              message.hasOwnProperty("positionAtPointOfCall_1")
            )
              object.positionAtPointOfCall_1 = message.positionAtPointOfCall_1;
            if (
              message.lengthBehindAtPointOfCall_1 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_1")
            )
              object.lengthBehindAtPointOfCall_1 =
                message.lengthBehindAtPointOfCall_1;
            if (
              message.lengthAheadAtPointOfCall_1 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_1")
            )
              object.lengthAheadAtPointOfCall_1 =
                message.lengthAheadAtPointOfCall_1;
            if (
              message.positionAtPointOfCall_2 != null &&
              message.hasOwnProperty("positionAtPointOfCall_2")
            )
              object.positionAtPointOfCall_2 = message.positionAtPointOfCall_2;
            if (
              message.lengthBehindAtPointOfCall_2 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_2")
            )
              object.lengthBehindAtPointOfCall_2 =
                message.lengthBehindAtPointOfCall_2;
            if (
              message.lengthAheadAtPointOfCall_2 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_2")
            )
              object.lengthAheadAtPointOfCall_2 =
                message.lengthAheadAtPointOfCall_2;
            if (
              message.positionAtPointOfCall_3 != null &&
              message.hasOwnProperty("positionAtPointOfCall_3")
            )
              object.positionAtPointOfCall_3 = message.positionAtPointOfCall_3;
            if (
              message.lengthBehindAtPointOfCall_3 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_3")
            )
              object.lengthBehindAtPointOfCall_3 =
                message.lengthBehindAtPointOfCall_3;
            if (
              message.lengthAheadAtPointOfCall_3 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_3")
            )
              object.lengthAheadAtPointOfCall_3 =
                message.lengthAheadAtPointOfCall_3;
            if (
              message.positionAtPointOfCall_4 != null &&
              message.hasOwnProperty("positionAtPointOfCall_4")
            )
              object.positionAtPointOfCall_4 = message.positionAtPointOfCall_4;
            if (
              message.lengthBehindAtPointOfCall_4 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_4")
            )
              object.lengthBehindAtPointOfCall_4 =
                message.lengthBehindAtPointOfCall_4;
            if (
              message.lengthAheadAtPointOfCall_4 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_4")
            )
              object.lengthAheadAtPointOfCall_4 =
                message.lengthAheadAtPointOfCall_4;
            if (
              message.positionAtPointOfCall_5 != null &&
              message.hasOwnProperty("positionAtPointOfCall_5")
            )
              object.positionAtPointOfCall_5 = message.positionAtPointOfCall_5;
            if (
              message.lengthBehindAtPointOfCall_5 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_5")
            )
              object.lengthBehindAtPointOfCall_5 =
                message.lengthBehindAtPointOfCall_5;
            if (
              message.lengthAheadAtPointOfCall_5 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_5")
            )
              object.lengthAheadAtPointOfCall_5 =
                message.lengthAheadAtPointOfCall_5;
            if (
              message.positionAtFinish != null &&
              message.hasOwnProperty("positionAtFinish")
            )
              object.positionAtFinish = message.positionAtFinish;
            if (
              message.lengthBehindAtFinish != null &&
              message.hasOwnProperty("lengthBehindAtFinish")
            )
              object.lengthBehindAtFinish = message.lengthBehindAtFinish;
            if (
              message.lengthAheadAtFinish != null &&
              message.hasOwnProperty("lengthAheadAtFinish")
            )
              object.lengthAheadAtFinish = message.lengthAheadAtFinish;
            if (
              message.jockeyFirstName != null &&
              message.hasOwnProperty("jockeyFirstName")
            )
              object.jockeyFirstName = message.jockeyFirstName;
            if (
              message.jockeyLastName != null &&
              message.hasOwnProperty("jockeyLastName")
            )
              object.jockeyLastName = message.jockeyLastName;
            if (
              message.isPostTimeFavorite != null &&
              message.hasOwnProperty("isPostTimeFavorite")
            )
              object.isPostTimeFavorite =
                $root.google.protobuf.BoolValue.toObject(
                  message.isPostTimeFavorite,
                  options
                );
            if (message.odds != null && message.hasOwnProperty("odds"))
              object.odds = message.odds;
            if (
              message.isTroubledTrip != null &&
              message.hasOwnProperty("isTroubledTrip")
            )
              object.isTroubledTrip = $root.google.protobuf.BoolValue.toObject(
                message.isTroubledTrip,
                options
              );
            if (
              message.shortComment != null &&
              message.hasOwnProperty("shortComment")
            )
              object.shortComment = message.shortComment;
            if (
              message.fieldSize != null &&
              message.hasOwnProperty("fieldSize")
            )
              object.fieldSize = message.fieldSize;
            if (
              message.isClaimed != null &&
              message.hasOwnProperty("isClaimed")
            )
              object.isClaimed = $root.google.protobuf.BoolValue.toObject(
                message.isClaimed,
                options
              );
            if (
              message.ownerFirstName != null &&
              message.hasOwnProperty("ownerFirstName")
            )
              object.ownerFirstName = message.ownerFirstName;
            if (
              message.ownerLastName != null &&
              message.hasOwnProperty("ownerLastName")
            )
              object.ownerLastName = message.ownerLastName;
            if (
              message.newOwnerFirstName != null &&
              message.hasOwnProperty("newOwnerFirstName")
            )
              object.newOwnerFirstName = message.newOwnerFirstName;
            if (
              message.newOwnerLastName != null &&
              message.hasOwnProperty("newOwnerLastName")
            )
              object.newOwnerLastName = message.newOwnerLastName;
            if (
              message.newTrainerFirstName != null &&
              message.hasOwnProperty("newTrainerFirstName")
            )
              object.newTrainerFirstName = message.newTrainerFirstName;
            if (
              message.newTrainerLastName != null &&
              message.hasOwnProperty("newTrainerLastName")
            )
              object.newTrainerLastName = message.newTrainerLastName;
            if (
              message.claimedPriceUsa != null &&
              message.hasOwnProperty("claimedPriceUsa")
            )
              object.claimedPriceUsa =
                options.json && !isFinite(message.claimedPriceUsa)
                  ? String(message.claimedPriceUsa)
                  : message.claimedPriceUsa;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            return object;
          };

          /**
           * Converts this HorseLastPastPerformance to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseLastPastPerformance
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseLastPastPerformance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseLastPastPerformance;
        })();

        racehorse360.HorseWorkout = (function () {
          /**
           * Properties of a HorseWorkout.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseWorkout
           * @property {string|null} [id] HorseWorkout id
           * @property {string|null} [date] HorseWorkout date
           * @property {string|null} [track] HorseWorkout track
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseSurface] HorseWorkout courseSurface
           * @property {number|null} [distance] HorseWorkout distance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [distanceUnit] HorseWorkout distanceUnit
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] HorseWorkout trackCondition
           * @property {number|null} [timing] HorseWorkout timing
           * @property {stronachgroup.first.racehorse360.WorkoutType|null} [workoutType] HorseWorkout workoutType
           * @property {boolean|null} [gateIndicator] HorseWorkout gateIndicator
           * @property {boolean|null} [dogIndicator] HorseWorkout dogIndicator
           * @property {number|null} [ranking] HorseWorkout ranking
           * @property {number|null} [numberInRankingGroup] HorseWorkout numberInRankingGroup
           * @property {string|null} [comment] HorseWorkout comment
           */

          /**
           * Constructs a new HorseWorkout.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseWorkout.
           * @implements IHorseWorkout
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseWorkout=} [properties] Properties to set
           */
          function HorseWorkout(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseWorkout id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.id = "";

          /**
           * HorseWorkout date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.date = "";

          /**
           * HorseWorkout track.
           * @member {string} track
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.track = "";

          /**
           * HorseWorkout courseSurface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseSurface
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.courseSurface = 0;

          /**
           * HorseWorkout distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.distance = 0;

          /**
           * HorseWorkout distanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} distanceUnit
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.distanceUnit = 0;

          /**
           * HorseWorkout trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.trackCondition = 0;

          /**
           * HorseWorkout timing.
           * @member {number} timing
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.timing = 0;

          /**
           * HorseWorkout workoutType.
           * @member {stronachgroup.first.racehorse360.WorkoutType} workoutType
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.workoutType = 0;

          /**
           * HorseWorkout gateIndicator.
           * @member {boolean} gateIndicator
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.gateIndicator = false;

          /**
           * HorseWorkout dogIndicator.
           * @member {boolean} dogIndicator
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.dogIndicator = false;

          /**
           * HorseWorkout ranking.
           * @member {number} ranking
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.ranking = 0;

          /**
           * HorseWorkout numberInRankingGroup.
           * @member {number} numberInRankingGroup
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.numberInRankingGroup = 0;

          /**
           * HorseWorkout comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           */
          HorseWorkout.prototype.comment = "";

          /**
           * Creates a new HorseWorkout instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWorkout=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseWorkout} HorseWorkout instance
           */
          HorseWorkout.create = function create(properties) {
            return new HorseWorkout(properties);
          };

          /**
           * Encodes the specified HorseWorkout message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseWorkout.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWorkout} message HorseWorkout message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseWorkout.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.date);
            if (
              message.track != null &&
              Object.hasOwnProperty.call(message, "track")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.track);
            if (
              message.courseSurface != null &&
              Object.hasOwnProperty.call(message, "courseSurface")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.courseSurface);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.distance);
            if (
              message.distanceUnit != null &&
              Object.hasOwnProperty.call(message, "distanceUnit")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.distanceUnit);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.trackCondition);
            if (
              message.timing != null &&
              Object.hasOwnProperty.call(message, "timing")
            )
              writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.timing);
            if (
              message.workoutType != null &&
              Object.hasOwnProperty.call(message, "workoutType")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.workoutType);
            if (
              message.gateIndicator != null &&
              Object.hasOwnProperty.call(message, "gateIndicator")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .bool(message.gateIndicator);
            if (
              message.dogIndicator != null &&
              Object.hasOwnProperty.call(message, "dogIndicator")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .bool(message.dogIndicator);
            if (
              message.ranking != null &&
              Object.hasOwnProperty.call(message, "ranking")
            )
              writer.uint32(/* id 12, wireType 0 =*/ 96).int32(message.ranking);
            if (
              message.numberInRankingGroup != null &&
              Object.hasOwnProperty.call(message, "numberInRankingGroup")
            )
              writer
                .uint32(/* id 13, wireType 0 =*/ 104)
                .int32(message.numberInRankingGroup);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.comment);
            return writer;
          };

          /**
           * Decodes a HorseWorkout message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseWorkout} HorseWorkout
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseWorkout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseWorkout();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.date = reader.string();
                  break;
                case 3:
                  message.track = reader.string();
                  break;
                case 4:
                  message.courseSurface = reader.int32();
                  break;
                case 5:
                  message.distance = reader.int32();
                  break;
                case 6:
                  message.distanceUnit = reader.int32();
                  break;
                case 7:
                  message.trackCondition = reader.int32();
                  break;
                case 8:
                  message.timing = reader.int32();
                  break;
                case 9:
                  message.workoutType = reader.int32();
                  break;
                case 10:
                  message.gateIndicator = reader.bool();
                  break;
                case 11:
                  message.dogIndicator = reader.bool();
                  break;
                case 12:
                  message.ranking = reader.int32();
                  break;
                case 13:
                  message.numberInRankingGroup = reader.int32();
                  break;
                case 14:
                  message.comment = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseWorkout message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseWorkout} HorseWorkout
           */
          HorseWorkout.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseWorkout
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseWorkout();
            if (object.id != null) message.id = String(object.id);
            if (object.date != null) message.date = String(object.date);
            if (object.track != null) message.track = String(object.track);
            switch (object.courseSurface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseSurface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseSurface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseSurface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseSurface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseSurface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseSurface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseSurface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseSurface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseSurface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseSurface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseSurface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseSurface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseSurface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseSurface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseSurface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseSurface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseSurface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseSurface = 17;
                break;
            }
            if (object.distance != null) message.distance = object.distance | 0;
            switch (object.distanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.distanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.distanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.distanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.distanceUnit = 3;
                break;
            }
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.timing != null) message.timing = object.timing | 0;
            switch (object.workoutType) {
              case "WORKOUT_TYPE_INVALID":
              case 0:
                message.workoutType = 0;
                break;
              case "WORKOUT_TYPE_BREEZING":
              case 1:
                message.workoutType = 1;
                break;
              case "WORKOUT_TYPE_DRIVING":
              case 2:
                message.workoutType = 2;
                break;
              case "WORKOUT_TYPE_HANDILY":
              case 3:
                message.workoutType = 3;
                break;
            }
            if (object.gateIndicator != null)
              message.gateIndicator = Boolean(object.gateIndicator);
            if (object.dogIndicator != null)
              message.dogIndicator = Boolean(object.dogIndicator);
            if (object.ranking != null) message.ranking = object.ranking | 0;
            if (object.numberInRankingGroup != null)
              message.numberInRankingGroup = object.numberInRankingGroup | 0;
            if (object.comment != null)
              message.comment = String(object.comment);
            return message;
          };

          /**
           * Creates a plain object from a HorseWorkout message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @static
           * @param {stronachgroup.first.racehorse360.HorseWorkout} message HorseWorkout
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseWorkout.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.date = "";
              object.track = "";
              object.courseSurface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.distance = 0;
              object.distanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.timing = 0;
              object.workoutType =
                options.enums === String ? "WORKOUT_TYPE_INVALID" : 0;
              object.gateIndicator = false;
              object.dogIndicator = false;
              object.ranking = 0;
              object.numberInRankingGroup = 0;
              object.comment = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (message.track != null && message.hasOwnProperty("track"))
              object.track = message.track;
            if (
              message.courseSurface != null &&
              message.hasOwnProperty("courseSurface")
            )
              object.courseSurface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseSurface
                    ]
                  : message.courseSurface;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.distanceUnit != null &&
              message.hasOwnProperty("distanceUnit")
            )
              object.distanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.distanceUnit
                    ]
                  : message.distanceUnit;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (message.timing != null && message.hasOwnProperty("timing"))
              object.timing = message.timing;
            if (
              message.workoutType != null &&
              message.hasOwnProperty("workoutType")
            )
              object.workoutType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkoutType[
                      message.workoutType
                    ]
                  : message.workoutType;
            if (
              message.gateIndicator != null &&
              message.hasOwnProperty("gateIndicator")
            )
              object.gateIndicator = message.gateIndicator;
            if (
              message.dogIndicator != null &&
              message.hasOwnProperty("dogIndicator")
            )
              object.dogIndicator = message.dogIndicator;
            if (message.ranking != null && message.hasOwnProperty("ranking"))
              object.ranking = message.ranking;
            if (
              message.numberInRankingGroup != null &&
              message.hasOwnProperty("numberInRankingGroup")
            )
              object.numberInRankingGroup = message.numberInRankingGroup;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            return object;
          };

          /**
           * Converts this HorseWorkout to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseWorkout
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseWorkout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseWorkout;
        })();

        racehorse360.HorseLastExamNote = (function () {
          /**
           * Properties of a HorseLastExamNote.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseLastExamNote
           * @property {string|null} [note] HorseLastExamNote note
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseLastExamNote createdBy
           * @property {string|null} [createdOn] HorseLastExamNote createdOn
           */

          /**
           * Constructs a new HorseLastExamNote.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseLastExamNote.
           * @implements IHorseLastExamNote
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseLastExamNote=} [properties] Properties to set
           */
          function HorseLastExamNote(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseLastExamNote note.
           * @member {string} note
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @instance
           */
          HorseLastExamNote.prototype.note = "";

          /**
           * HorseLastExamNote createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @instance
           */
          HorseLastExamNote.prototype.createdBy = null;

          /**
           * HorseLastExamNote createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @instance
           */
          HorseLastExamNote.prototype.createdOn = "";

          /**
           * Creates a new HorseLastExamNote instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLastExamNote=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseLastExamNote} HorseLastExamNote instance
           */
          HorseLastExamNote.create = function create(properties) {
            return new HorseLastExamNote(properties);
          };

          /**
           * Encodes the specified HorseLastExamNote message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseLastExamNote.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseLastExamNote} message HorseLastExamNote message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseLastExamNote.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.note);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.createdOn);
            return writer;
          };

          /**
           * Decodes a HorseLastExamNote message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseLastExamNote} HorseLastExamNote
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseLastExamNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseLastExamNote();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.note = reader.string();
                  break;
                case 2:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.createdOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseLastExamNote message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseLastExamNote} HorseLastExamNote
           */
          HorseLastExamNote.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseLastExamNote
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseLastExamNote();
            if (object.note != null) message.note = String(object.note);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseLastExamNote.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            return message;
          };

          /**
           * Creates a plain object from a HorseLastExamNote message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.HorseLastExamNote} message HorseLastExamNote
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseLastExamNote.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.note = "";
              object.createdBy = null;
              object.createdOn = "";
            }
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = message.note;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            return object;
          };

          /**
           * Converts this HorseLastExamNote to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseLastExamNote
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseLastExamNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseLastExamNote;
        })();

        racehorse360.HorseFilter = (function () {
          /**
           * Properties of a HorseFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseFilter
           * @property {Array.<string>|null} [ids] HorseFilter ids
           * @property {Array.<string>|null} [trainerIds] HorseFilter trainerIds
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [name] HorseFilter name
           * @property {string|null} [birthday] HorseFilter birthday
           * @property {boolean|null} [includeDeceasedHorses] HorseFilter includeDeceasedHorses
           * @property {Array.<string>|null} [facilityIds] HorseFilter facilityIds
           * @property {Array.<string>|null} [preferredRaceTypeIds] HorseFilter preferredRaceTypeIds
           * @property {Array.<string>|null} [preferredRaceDistanceIds] HorseFilter preferredRaceDistanceIds
           * @property {Array.<stronachgroup.first.racehorse360.CourseSurface>|null} [preferredSurfaces] HorseFilter preferredSurfaces
           * @property {Array.<stronachgroup.first.racehorse360.HorseGender>|null} [horseGenders] HorseFilter horseGenders
           * @property {stronachgroup.first.racehorse360.HorseAge|null} [horseAge] HorseFilter horseAge
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseOrTrainerName] HorseFilter horseOrTrainerName
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [registrationNumber] HorseFilter registrationNumber
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [chipNumber] HorseFilter chipNumber
           */

          /**
           * Constructs a new HorseFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseFilter.
           * @implements IHorseFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseFilter=} [properties] Properties to set
           */
          function HorseFilter(properties) {
            this.ids = [];
            this.trainerIds = [];
            this.facilityIds = [];
            this.preferredRaceTypeIds = [];
            this.preferredRaceDistanceIds = [];
            this.preferredSurfaces = [];
            this.horseGenders = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * HorseFilter name.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} name
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.name = null;

          /**
           * HorseFilter birthday.
           * @member {string} birthday
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.birthday = "";

          /**
           * HorseFilter includeDeceasedHorses.
           * @member {boolean} includeDeceasedHorses
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.includeDeceasedHorses = false;

          /**
           * HorseFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * HorseFilter preferredRaceTypeIds.
           * @member {Array.<string>} preferredRaceTypeIds
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.preferredRaceTypeIds = $util.emptyArray;

          /**
           * HorseFilter preferredRaceDistanceIds.
           * @member {Array.<string>} preferredRaceDistanceIds
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.preferredRaceDistanceIds = $util.emptyArray;

          /**
           * HorseFilter preferredSurfaces.
           * @member {Array.<stronachgroup.first.racehorse360.CourseSurface>} preferredSurfaces
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.preferredSurfaces = $util.emptyArray;

          /**
           * HorseFilter horseGenders.
           * @member {Array.<stronachgroup.first.racehorse360.HorseGender>} horseGenders
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.horseGenders = $util.emptyArray;

          /**
           * HorseFilter horseAge.
           * @member {stronachgroup.first.racehorse360.HorseAge} horseAge
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.horseAge = 0;

          /**
           * HorseFilter horseOrTrainerName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseOrTrainerName
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.horseOrTrainerName = null;

          /**
           * HorseFilter registrationNumber.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} registrationNumber
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.registrationNumber = null;

          /**
           * HorseFilter chipNumber.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} chipNumber
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           */
          HorseFilter.prototype.chipNumber = null;

          /**
           * Creates a new HorseFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseFilter} HorseFilter instance
           */
          HorseFilter.create = function create(properties) {
            return new HorseFilter(properties);
          };

          /**
           * Encodes the specified HorseFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFilter} message HorseFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.trainerIds[i]);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.name,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.birthday != null &&
              Object.hasOwnProperty.call(message, "birthday")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.birthday);
            if (
              message.includeDeceasedHorses != null &&
              Object.hasOwnProperty.call(message, "includeDeceasedHorses")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .bool(message.includeDeceasedHorses);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.facilityIds[i]);
            if (
              message.preferredRaceTypeIds != null &&
              message.preferredRaceTypeIds.length
            )
              for (var i = 0; i < message.preferredRaceTypeIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.preferredRaceTypeIds[i]);
            if (
              message.preferredRaceDistanceIds != null &&
              message.preferredRaceDistanceIds.length
            )
              for (var i = 0; i < message.preferredRaceDistanceIds.length; ++i)
                writer
                  .uint32(/* id 8, wireType 2 =*/ 66)
                  .string(message.preferredRaceDistanceIds[i]);
            if (
              message.preferredSurfaces != null &&
              message.preferredSurfaces.length
            ) {
              writer.uint32(/* id 9, wireType 2 =*/ 74).fork();
              for (var i = 0; i < message.preferredSurfaces.length; ++i)
                writer.int32(message.preferredSurfaces[i]);
              writer.ldelim();
            }
            if (message.horseGenders != null && message.horseGenders.length) {
              writer.uint32(/* id 10, wireType 2 =*/ 82).fork();
              for (var i = 0; i < message.horseGenders.length; ++i)
                writer.int32(message.horseGenders[i]);
              writer.ldelim();
            }
            if (
              message.horseAge != null &&
              Object.hasOwnProperty.call(message, "horseAge")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.horseAge);
            if (
              message.horseOrTrainerName != null &&
              Object.hasOwnProperty.call(message, "horseOrTrainerName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseOrTrainerName,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.registrationNumber != null &&
              Object.hasOwnProperty.call(message, "registrationNumber")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.registrationNumber,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.chipNumber != null &&
              Object.hasOwnProperty.call(message, "chipNumber")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.chipNumber,
                writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseFilter} HorseFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 3:
                  message.name =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.birthday = reader.string();
                  break;
                case 5:
                  message.includeDeceasedHorses = reader.bool();
                  break;
                case 6:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 7:
                  if (
                    !(
                      message.preferredRaceTypeIds &&
                      message.preferredRaceTypeIds.length
                    )
                  )
                    message.preferredRaceTypeIds = [];
                  message.preferredRaceTypeIds.push(reader.string());
                  break;
                case 8:
                  if (
                    !(
                      message.preferredRaceDistanceIds &&
                      message.preferredRaceDistanceIds.length
                    )
                  )
                    message.preferredRaceDistanceIds = [];
                  message.preferredRaceDistanceIds.push(reader.string());
                  break;
                case 9:
                  if (
                    !(
                      message.preferredSurfaces &&
                      message.preferredSurfaces.length
                    )
                  )
                    message.preferredSurfaces = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.preferredSurfaces.push(reader.int32());
                  } else message.preferredSurfaces.push(reader.int32());
                  break;
                case 10:
                  if (!(message.horseGenders && message.horseGenders.length))
                    message.horseGenders = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.horseGenders.push(reader.int32());
                  } else message.horseGenders.push(reader.int32());
                  break;
                case 11:
                  message.horseAge = reader.int32();
                  break;
                case 12:
                  message.horseOrTrainerName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  message.registrationNumber =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.chipNumber =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseFilter} HorseFilter
           */
          HorseFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.name != null) {
              if (typeof object.name !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.name: object expected"
                );
              message.name =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.name
                );
            }
            if (object.birthday != null)
              message.birthday = String(object.birthday);
            if (object.includeDeceasedHorses != null)
              message.includeDeceasedHorses = Boolean(
                object.includeDeceasedHorses
              );
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.preferredRaceTypeIds) {
              if (!Array.isArray(object.preferredRaceTypeIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.preferredRaceTypeIds: array expected"
                );
              message.preferredRaceTypeIds = [];
              for (var i = 0; i < object.preferredRaceTypeIds.length; ++i)
                message.preferredRaceTypeIds[i] = String(
                  object.preferredRaceTypeIds[i]
                );
            }
            if (object.preferredRaceDistanceIds) {
              if (!Array.isArray(object.preferredRaceDistanceIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.preferredRaceDistanceIds: array expected"
                );
              message.preferredRaceDistanceIds = [];
              for (var i = 0; i < object.preferredRaceDistanceIds.length; ++i)
                message.preferredRaceDistanceIds[i] = String(
                  object.preferredRaceDistanceIds[i]
                );
            }
            if (object.preferredSurfaces) {
              if (!Array.isArray(object.preferredSurfaces))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.preferredSurfaces: array expected"
                );
              message.preferredSurfaces = [];
              for (var i = 0; i < object.preferredSurfaces.length; ++i)
                switch (object.preferredSurfaces[i]) {
                  default:
                  case "COURSE_SURFACE_INVALID":
                  case 0:
                    message.preferredSurfaces[i] = 0;
                    break;
                  case "COURSE_SURFACE_ALL_WEATHER_TRACK":
                  case 1:
                    message.preferredSurfaces[i] = 1;
                    break;
                  case "COURSE_SURFACE_TURF":
                  case 2:
                    message.preferredSurfaces[i] = 2;
                    break;
                  case "COURSE_SURFACE_STEEPLECHASE":
                  case 3:
                    message.preferredSurfaces[i] = 3;
                    break;
                  case "COURSE_SURFACE_INNER_TRACK":
                  case 4:
                    message.preferredSurfaces[i] = 4;
                    break;
                  case "COURSE_SURFACE_OUTER_TURF":
                  case 5:
                    message.preferredSurfaces[i] = 5;
                    break;
                  case "COURSE_SURFACE_WOOD_CHIPS":
                  case 6:
                    message.preferredSurfaces[i] = 6;
                    break;
                  case "COURSE_SURFACE_HUNT_ON_TURF":
                  case 7:
                    message.preferredSurfaces[i] = 7;
                    break;
                  case "COURSE_SURFACE_TIMBER":
                  case 8:
                    message.preferredSurfaces[i] = 8;
                    break;
                  case "COURSE_SURFACE_DIRT":
                  case 9:
                    message.preferredSurfaces[i] = 9;
                    break;
                  case "COURSE_SURFACE_TURF_TRAINING":
                  case 10:
                    message.preferredSurfaces[i] = 10;
                    break;
                  case "COURSE_SURFACE_JUMP":
                  case 11:
                    message.preferredSurfaces[i] = 11;
                    break;
                  case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
                  case 12:
                    message.preferredSurfaces[i] = 12;
                    break;
                  case "COURSE_SURFACE_HUNT":
                  case 13:
                    message.preferredSurfaces[i] = 13;
                    break;
                  case "COURSE_SURFACE_DOWNHILL_TURF":
                  case 14:
                    message.preferredSurfaces[i] = 14;
                    break;
                  case "COURSE_SURFACE_DIRT_TRAINING":
                  case 15:
                    message.preferredSurfaces[i] = 15;
                    break;
                  case "COURSE_SURFACE_INNER_TURF":
                  case 16:
                    message.preferredSurfaces[i] = 16;
                    break;
                  case "COURSE_SURFACE_HURDLE":
                  case 17:
                    message.preferredSurfaces[i] = 17;
                    break;
                }
            }
            if (object.horseGenders) {
              if (!Array.isArray(object.horseGenders))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.horseGenders: array expected"
                );
              message.horseGenders = [];
              for (var i = 0; i < object.horseGenders.length; ++i)
                switch (object.horseGenders[i]) {
                  default:
                  case "HORSE_GENDER_INVALID":
                  case 0:
                    message.horseGenders[i] = 0;
                    break;
                  case "HORSE_GENDER_FILLY":
                  case 1:
                    message.horseGenders[i] = 1;
                    break;
                  case "HORSE_GENDER_COLT":
                  case 2:
                    message.horseGenders[i] = 2;
                    break;
                  case "HORSE_GENDER_GELDING":
                  case 3:
                    message.horseGenders[i] = 3;
                    break;
                  case "HORSE_GENDER_MARE":
                  case 4:
                    message.horseGenders[i] = 4;
                    break;
                  case "HORSE_GENDER_HORSE":
                  case 5:
                    message.horseGenders[i] = 5;
                    break;
                  case "HORSE_GENDER_SPAYED_MARE":
                  case 6:
                    message.horseGenders[i] = 6;
                    break;
                  case "HORSE_GENDER_RIDGLING":
                  case 7:
                    message.horseGenders[i] = 7;
                    break;
                }
            }
            switch (object.horseAge) {
              case "HORSE_AGE_INVALID":
              case 0:
                message.horseAge = 0;
                break;
              case "HORSE_AGE_TWO":
              case 1:
                message.horseAge = 1;
                break;
              case "HORSE_AGE_THREE":
              case 2:
                message.horseAge = 2;
                break;
              case "HORSE_AGE_THREE_PLUS":
              case 3:
                message.horseAge = 3;
                break;
              case "HORSE_AGE_FOUR":
              case 4:
                message.horseAge = 4;
                break;
              case "HORSE_AGE_FOUR_PLUS":
              case 5:
                message.horseAge = 5;
                break;
            }
            if (object.horseOrTrainerName != null) {
              if (typeof object.horseOrTrainerName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.horseOrTrainerName: object expected"
                );
              message.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseOrTrainerName
                );
            }
            if (object.registrationNumber != null) {
              if (typeof object.registrationNumber !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.registrationNumber: object expected"
                );
              message.registrationNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.registrationNumber
                );
            }
            if (object.chipNumber != null) {
              if (typeof object.chipNumber !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFilter.chipNumber: object expected"
                );
              message.chipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.chipNumber
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseFilter} message HorseFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.trainerIds = [];
              object.facilityIds = [];
              object.preferredRaceTypeIds = [];
              object.preferredRaceDistanceIds = [];
              object.preferredSurfaces = [];
              object.horseGenders = [];
            }
            if (options.defaults) {
              object.name = null;
              object.birthday = "";
              object.includeDeceasedHorses = false;
              object.horseAge =
                options.enums === String ? "HORSE_AGE_INVALID" : 0;
              object.horseOrTrainerName = null;
              object.registrationNumber = null;
              object.chipNumber = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
              object.name =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.name,
                  options
                );
            if (message.birthday != null && message.hasOwnProperty("birthday"))
              object.birthday = message.birthday;
            if (
              message.includeDeceasedHorses != null &&
              message.hasOwnProperty("includeDeceasedHorses")
            )
              object.includeDeceasedHorses = message.includeDeceasedHorses;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.preferredRaceTypeIds &&
              message.preferredRaceTypeIds.length
            ) {
              object.preferredRaceTypeIds = [];
              for (var j = 0; j < message.preferredRaceTypeIds.length; ++j)
                object.preferredRaceTypeIds[j] =
                  message.preferredRaceTypeIds[j];
            }
            if (
              message.preferredRaceDistanceIds &&
              message.preferredRaceDistanceIds.length
            ) {
              object.preferredRaceDistanceIds = [];
              for (var j = 0; j < message.preferredRaceDistanceIds.length; ++j)
                object.preferredRaceDistanceIds[j] =
                  message.preferredRaceDistanceIds[j];
            }
            if (message.preferredSurfaces && message.preferredSurfaces.length) {
              object.preferredSurfaces = [];
              for (var j = 0; j < message.preferredSurfaces.length; ++j)
                object.preferredSurfaces[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.CourseSurface[
                        message.preferredSurfaces[j]
                      ]
                    : message.preferredSurfaces[j];
            }
            if (message.horseGenders && message.horseGenders.length) {
              object.horseGenders = [];
              for (var j = 0; j < message.horseGenders.length; ++j)
                object.horseGenders[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.HorseGender[
                        message.horseGenders[j]
                      ]
                    : message.horseGenders[j];
            }
            if (message.horseAge != null && message.hasOwnProperty("horseAge"))
              object.horseAge =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseAge[
                      message.horseAge
                    ]
                  : message.horseAge;
            if (
              message.horseOrTrainerName != null &&
              message.hasOwnProperty("horseOrTrainerName")
            )
              object.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseOrTrainerName,
                  options
                );
            if (
              message.registrationNumber != null &&
              message.hasOwnProperty("registrationNumber")
            )
              object.registrationNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.registrationNumber,
                  options
                );
            if (
              message.chipNumber != null &&
              message.hasOwnProperty("chipNumber")
            )
              object.chipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.chipNumber,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseFilter;
        })();

        racehorse360.GetHorseRequest = (function () {
          /**
           * Properties of a GetHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetHorseRequest
           * @property {string|null} [id] GetHorseRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetHorseRequest getOptions
           */

          /**
           * Constructs a new GetHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetHorseRequest.
           * @implements IGetHorseRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetHorseRequest=} [properties] Properties to set
           */
          function GetHorseRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetHorseRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @instance
           */
          GetHorseRequest.prototype.id = "";

          /**
           * GetHorseRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @instance
           */
          GetHorseRequest.prototype.getOptions = null;

          /**
           * Creates a new GetHorseRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetHorseRequest} GetHorseRequest instance
           */
          GetHorseRequest.create = function create(properties) {
            return new GetHorseRequest(properties);
          };

          /**
           * Encodes the specified GetHorseRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetHorseRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseRequest} message GetHorseRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetHorseRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetHorseRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetHorseRequest} GetHorseRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetHorseRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetHorseRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetHorseRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetHorseRequest} GetHorseRequest
           */
          GetHorseRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetHorseRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetHorseRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetHorseRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetHorseRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetHorseRequest} message GetHorseRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetHorseRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetHorseRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetHorseRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetHorseRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetHorseRequest;
        })();

        racehorse360.ListHorsesRequest = (function () {
          /**
           * Properties of a ListHorsesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorsesRequest
           * @property {stronachgroup.first.racehorse360.IHorseFilter|null} [query] ListHorsesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorsesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorsesRequest pagingOptions
           */

          /**
           * Constructs a new ListHorsesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorsesRequest.
           * @implements IListHorsesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorsesRequest=} [properties] Properties to set
           */
          function ListHorsesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorsesRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @instance
           */
          ListHorsesRequest.prototype.query = null;

          /**
           * ListHorsesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @instance
           */
          ListHorsesRequest.prototype.getOptions = null;

          /**
           * ListHorsesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @instance
           */
          ListHorsesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorsesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorsesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorsesRequest} ListHorsesRequest instance
           */
          ListHorsesRequest.create = function create(properties) {
            return new ListHorsesRequest(properties);
          };

          /**
           * Encodes the specified ListHorsesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorsesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorsesRequest} message ListHorsesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorsesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorsesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorsesRequest} ListHorsesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorsesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorsesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorsesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorsesRequest} ListHorsesRequest
           */
          ListHorsesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorsesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorsesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorsesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorsesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorsesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorsesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorsesRequest} message ListHorsesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorsesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorsesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorsesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorsesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorsesRequest;
        })();

        racehorse360.ListHorsesResponse = (function () {
          /**
           * Properties of a ListHorsesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorsesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorse>|null} [horses] ListHorsesResponse horses
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorsesResponse pagingInfo
           */

          /**
           * Constructs a new ListHorsesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorsesResponse.
           * @implements IListHorsesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorsesResponse=} [properties] Properties to set
           */
          function ListHorsesResponse(properties) {
            this.horses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorsesResponse horses.
           * @member {Array.<stronachgroup.first.racehorse360.IHorse>} horses
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @instance
           */
          ListHorsesResponse.prototype.horses = $util.emptyArray;

          /**
           * ListHorsesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @instance
           */
          ListHorsesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorsesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorsesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorsesResponse} ListHorsesResponse instance
           */
          ListHorsesResponse.create = function create(properties) {
            return new ListHorsesResponse(properties);
          };

          /**
           * Encodes the specified ListHorsesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorsesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorsesResponse} message ListHorsesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorsesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.horses != null && message.horses.length)
              for (var i = 0; i < message.horses.length; ++i)
                $root.stronachgroup.first.racehorse360.Horse.encode(
                  message.horses[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorsesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorsesResponse} ListHorsesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorsesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorsesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.horses && message.horses.length))
                    message.horses = [];
                  message.horses.push(
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorsesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorsesResponse} ListHorsesResponse
           */
          ListHorsesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorsesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorsesResponse();
            if (object.horses) {
              if (!Array.isArray(object.horses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorsesResponse.horses: array expected"
                );
              message.horses = [];
              for (var i = 0; i < object.horses.length; ++i) {
                if (typeof object.horses[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorsesResponse.horses: object expected"
                  );
                message.horses[i] =
                  $root.stronachgroup.first.racehorse360.Horse.fromObject(
                    object.horses[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorsesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorsesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorsesResponse} message ListHorsesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorsesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horses = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horses && message.horses.length) {
              object.horses = [];
              for (var j = 0; j < message.horses.length; ++j)
                object.horses[j] =
                  $root.stronachgroup.first.racehorse360.Horse.toObject(
                    message.horses[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorsesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorsesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorsesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorsesResponse;
        })();

        racehorse360.PullHorsesCountByFacilitySummaryRequest = (function () {
          /**
           * Properties of a PullHorsesCountByFacilitySummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesCountByFacilitySummaryRequest
           * @property {Array.<string>|null} [facilityIds] PullHorsesCountByFacilitySummaryRequest facilityIds
           */

          /**
           * Constructs a new PullHorsesCountByFacilitySummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesCountByFacilitySummaryRequest.
           * @implements IPullHorsesCountByFacilitySummaryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryRequest=} [properties] Properties to set
           */
          function PullHorsesCountByFacilitySummaryRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesCountByFacilitySummaryRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @instance
           */
          PullHorsesCountByFacilitySummaryRequest.prototype.facilityIds =
            $util.emptyArray;

          /**
           * Creates a new PullHorsesCountByFacilitySummaryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} PullHorsesCountByFacilitySummaryRequest instance
           */
          PullHorsesCountByFacilitySummaryRequest.create = function create(
            properties
          ) {
            return new PullHorsesCountByFacilitySummaryRequest(properties);
          };

          /**
           * Encodes the specified PullHorsesCountByFacilitySummaryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryRequest} message PullHorsesCountByFacilitySummaryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesCountByFacilitySummaryRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            return writer;
          };

          /**
           * Decodes a PullHorsesCountByFacilitySummaryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} PullHorsesCountByFacilitySummaryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesCountByFacilitySummaryRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesCountByFacilitySummaryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} PullHorsesCountByFacilitySummaryRequest
           */
          PullHorsesCountByFacilitySummaryRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullHorsesCountByFacilitySummaryRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest();
              if (object.facilityIds) {
                if (!Array.isArray(object.facilityIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest.facilityIds: array expected"
                  );
                message.facilityIds = [];
                for (var i = 0; i < object.facilityIds.length; ++i)
                  message.facilityIds[i] = String(object.facilityIds[i]);
              }
              return message;
            };

          /**
           * Creates a plain object from a PullHorsesCountByFacilitySummaryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest} message PullHorsesCountByFacilitySummaryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesCountByFacilitySummaryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            return object;
          };

          /**
           * Converts this PullHorsesCountByFacilitySummaryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesCountByFacilitySummaryRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorsesCountByFacilitySummaryRequest;
        })();

        racehorse360.HorsesCountByFacilitySummary = (function () {
          /**
           * Properties of a HorsesCountByFacilitySummary.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorsesCountByFacilitySummary
           * @property {string|null} [facilityId] HorsesCountByFacilitySummary facilityId
           * @property {string|null} [facilityName] HorsesCountByFacilitySummary facilityName
           * @property {number|null} [horsesCount] HorsesCountByFacilitySummary horsesCount
           */

          /**
           * Constructs a new HorsesCountByFacilitySummary.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorsesCountByFacilitySummary.
           * @implements IHorsesCountByFacilitySummary
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorsesCountByFacilitySummary=} [properties] Properties to set
           */
          function HorsesCountByFacilitySummary(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorsesCountByFacilitySummary facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @instance
           */
          HorsesCountByFacilitySummary.prototype.facilityId = "";

          /**
           * HorsesCountByFacilitySummary facilityName.
           * @member {string} facilityName
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @instance
           */
          HorsesCountByFacilitySummary.prototype.facilityName = "";

          /**
           * HorsesCountByFacilitySummary horsesCount.
           * @member {number} horsesCount
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @instance
           */
          HorsesCountByFacilitySummary.prototype.horsesCount = 0;

          /**
           * Creates a new HorsesCountByFacilitySummary instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesCountByFacilitySummary=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorsesCountByFacilitySummary} HorsesCountByFacilitySummary instance
           */
          HorsesCountByFacilitySummary.create = function create(properties) {
            return new HorsesCountByFacilitySummary(properties);
          };

          /**
           * Encodes the specified HorsesCountByFacilitySummary message. Does not implicitly {@link stronachgroup.first.racehorse360.HorsesCountByFacilitySummary.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesCountByFacilitySummary} message HorsesCountByFacilitySummary message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorsesCountByFacilitySummary.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.facilityName != null &&
              Object.hasOwnProperty.call(message, "facilityName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityName);
            if (
              message.horsesCount != null &&
              Object.hasOwnProperty.call(message, "horsesCount")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.horsesCount);
            return writer;
          };

          /**
           * Decodes a HorsesCountByFacilitySummary message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorsesCountByFacilitySummary} HorsesCountByFacilitySummary
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorsesCountByFacilitySummary.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.facilityName = reader.string();
                  break;
                case 3:
                  message.horsesCount = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorsesCountByFacilitySummary message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorsesCountByFacilitySummary} HorsesCountByFacilitySummary
           */
          HorsesCountByFacilitySummary.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .HorsesCountByFacilitySummary
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.facilityName != null)
              message.facilityName = String(object.facilityName);
            if (object.horsesCount != null)
              message.horsesCount = object.horsesCount | 0;
            return message;
          };

          /**
           * Creates a plain object from a HorsesCountByFacilitySummary message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @static
           * @param {stronachgroup.first.racehorse360.HorsesCountByFacilitySummary} message HorsesCountByFacilitySummary
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorsesCountByFacilitySummary.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.facilityName = "";
              object.horsesCount = 0;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.facilityName != null &&
              message.hasOwnProperty("facilityName")
            )
              object.facilityName = message.facilityName;
            if (
              message.horsesCount != null &&
              message.hasOwnProperty("horsesCount")
            )
              object.horsesCount = message.horsesCount;
            return object;
          };

          /**
           * Converts this HorsesCountByFacilitySummary to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorsesCountByFacilitySummary
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorsesCountByFacilitySummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorsesCountByFacilitySummary;
        })();

        racehorse360.PullHorsesCountByFacilitySummaryResponse = (function () {
          /**
           * Properties of a PullHorsesCountByFacilitySummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesCountByFacilitySummaryResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorsesCountByFacilitySummary>|null} [horsesCountByFacilitySummary] PullHorsesCountByFacilitySummaryResponse horsesCountByFacilitySummary
           * @property {number|null} [totalCount] PullHorsesCountByFacilitySummaryResponse totalCount
           * @property {number|null} [totalCountAtRequestedFacilities] PullHorsesCountByFacilitySummaryResponse totalCountAtRequestedFacilities
           */

          /**
           * Constructs a new PullHorsesCountByFacilitySummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesCountByFacilitySummaryResponse.
           * @implements IPullHorsesCountByFacilitySummaryResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryResponse=} [properties] Properties to set
           */
          function PullHorsesCountByFacilitySummaryResponse(properties) {
            this.horsesCountByFacilitySummary = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesCountByFacilitySummaryResponse horsesCountByFacilitySummary.
           * @member {Array.<stronachgroup.first.racehorse360.IHorsesCountByFacilitySummary>} horsesCountByFacilitySummary
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @instance
           */
          PullHorsesCountByFacilitySummaryResponse.prototype.horsesCountByFacilitySummary =
            $util.emptyArray;

          /**
           * PullHorsesCountByFacilitySummaryResponse totalCount.
           * @member {number} totalCount
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @instance
           */
          PullHorsesCountByFacilitySummaryResponse.prototype.totalCount = 0;

          /**
           * PullHorsesCountByFacilitySummaryResponse totalCountAtRequestedFacilities.
           * @member {number} totalCountAtRequestedFacilities
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @instance
           */
          PullHorsesCountByFacilitySummaryResponse.prototype.totalCountAtRequestedFacilities = 0;

          /**
           * Creates a new PullHorsesCountByFacilitySummaryResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse} PullHorsesCountByFacilitySummaryResponse instance
           */
          PullHorsesCountByFacilitySummaryResponse.create = function create(
            properties
          ) {
            return new PullHorsesCountByFacilitySummaryResponse(properties);
          };

          /**
           * Encodes the specified PullHorsesCountByFacilitySummaryResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryResponse} message PullHorsesCountByFacilitySummaryResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesCountByFacilitySummaryResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horsesCountByFacilitySummary != null &&
              message.horsesCountByFacilitySummary.length
            )
              for (
                var i = 0;
                i < message.horsesCountByFacilitySummary.length;
                ++i
              )
                $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary.encode(
                  message.horsesCountByFacilitySummary[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.totalCount != null &&
              Object.hasOwnProperty.call(message, "totalCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.totalCount);
            if (
              message.totalCountAtRequestedFacilities != null &&
              Object.hasOwnProperty.call(
                message,
                "totalCountAtRequestedFacilities"
              )
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.totalCountAtRequestedFacilities);
            return writer;
          };

          /**
           * Decodes a PullHorsesCountByFacilitySummaryResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse} PullHorsesCountByFacilitySummaryResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesCountByFacilitySummaryResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horsesCountByFacilitySummary &&
                      message.horsesCountByFacilitySummary.length
                    )
                  )
                    message.horsesCountByFacilitySummary = [];
                  message.horsesCountByFacilitySummary.push(
                    $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 2:
                  message.totalCount = reader.int32();
                  break;
                case 3:
                  message.totalCountAtRequestedFacilities = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesCountByFacilitySummaryResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse} PullHorsesCountByFacilitySummaryResponse
           */
          PullHorsesCountByFacilitySummaryResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullHorsesCountByFacilitySummaryResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse();
              if (object.horsesCountByFacilitySummary) {
                if (!Array.isArray(object.horsesCountByFacilitySummary))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse.horsesCountByFacilitySummary: array expected"
                  );
                message.horsesCountByFacilitySummary = [];
                for (
                  var i = 0;
                  i < object.horsesCountByFacilitySummary.length;
                  ++i
                ) {
                  if (
                    typeof object.horsesCountByFacilitySummary[i] !== "object"
                  )
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse.horsesCountByFacilitySummary: object expected"
                    );
                  message.horsesCountByFacilitySummary[i] =
                    $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary.fromObject(
                      object.horsesCountByFacilitySummary[i]
                    );
                }
              }
              if (object.totalCount != null)
                message.totalCount = object.totalCount | 0;
              if (object.totalCountAtRequestedFacilities != null)
                message.totalCountAtRequestedFacilities =
                  object.totalCountAtRequestedFacilities | 0;
              return message;
            };

          /**
           * Creates a plain object from a PullHorsesCountByFacilitySummaryResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse} message PullHorsesCountByFacilitySummaryResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesCountByFacilitySummaryResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horsesCountByFacilitySummary = [];
            if (options.defaults) {
              object.totalCount = 0;
              object.totalCountAtRequestedFacilities = 0;
            }
            if (
              message.horsesCountByFacilitySummary &&
              message.horsesCountByFacilitySummary.length
            ) {
              object.horsesCountByFacilitySummary = [];
              for (
                var j = 0;
                j < message.horsesCountByFacilitySummary.length;
                ++j
              )
                object.horsesCountByFacilitySummary[j] =
                  $root.stronachgroup.first.racehorse360.HorsesCountByFacilitySummary.toObject(
                    message.horsesCountByFacilitySummary[j],
                    options
                  );
            }
            if (
              message.totalCount != null &&
              message.hasOwnProperty("totalCount")
            )
              object.totalCount = message.totalCount;
            if (
              message.totalCountAtRequestedFacilities != null &&
              message.hasOwnProperty("totalCountAtRequestedFacilities")
            )
              object.totalCountAtRequestedFacilities =
                message.totalCountAtRequestedFacilities;
            return object;
          };

          /**
           * Converts this PullHorsesCountByFacilitySummaryResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesCountByFacilitySummaryResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorsesCountByFacilitySummaryResponse;
        })();

        racehorse360.AssignPreferredConditionsHorseRequest = (function () {
          /**
           * Properties of an AssignPreferredConditionsHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignPreferredConditionsHorseRequest
           * @property {string|null} [id] AssignPreferredConditionsHorseRequest id
           * @property {Array.<string>|null} [raceDistanceIds] AssignPreferredConditionsHorseRequest raceDistanceIds
           * @property {Array.<string>|null} [raceTypeIds] AssignPreferredConditionsHorseRequest raceTypeIds
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] AssignPreferredConditionsHorseRequest surface
           * @property {google.protobuf.IStringValue|null} [conditionNote] AssignPreferredConditionsHorseRequest conditionNote
           * @property {boolean|null} [areLastRacePreferredConditionsSelected] AssignPreferredConditionsHorseRequest areLastRacePreferredConditionsSelected
           * @property {Array.<string>|null} [claimingPriceIds] AssignPreferredConditionsHorseRequest claimingPriceIds
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignPreferredConditionsHorseRequest getOptions
           */

          /**
           * Constructs a new AssignPreferredConditionsHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignPreferredConditionsHorseRequest.
           * @implements IAssignPreferredConditionsHorseRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignPreferredConditionsHorseRequest=} [properties] Properties to set
           */
          function AssignPreferredConditionsHorseRequest(properties) {
            this.raceDistanceIds = [];
            this.raceTypeIds = [];
            this.claimingPriceIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignPreferredConditionsHorseRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.id = "";

          /**
           * AssignPreferredConditionsHorseRequest raceDistanceIds.
           * @member {Array.<string>} raceDistanceIds
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.raceDistanceIds =
            $util.emptyArray;

          /**
           * AssignPreferredConditionsHorseRequest raceTypeIds.
           * @member {Array.<string>} raceTypeIds
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.raceTypeIds =
            $util.emptyArray;

          /**
           * AssignPreferredConditionsHorseRequest surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.surface = 0;

          /**
           * AssignPreferredConditionsHorseRequest conditionNote.
           * @member {google.protobuf.IStringValue|null|undefined} conditionNote
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.conditionNote = null;

          /**
           * AssignPreferredConditionsHorseRequest areLastRacePreferredConditionsSelected.
           * @member {boolean} areLastRacePreferredConditionsSelected
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.areLastRacePreferredConditionsSelected = false;

          /**
           * AssignPreferredConditionsHorseRequest claimingPriceIds.
           * @member {Array.<string>} claimingPriceIds
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.claimingPriceIds =
            $util.emptyArray;

          /**
           * AssignPreferredConditionsHorseRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           */
          AssignPreferredConditionsHorseRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignPreferredConditionsHorseRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignPreferredConditionsHorseRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} AssignPreferredConditionsHorseRequest instance
           */
          AssignPreferredConditionsHorseRequest.create = function create(
            properties
          ) {
            return new AssignPreferredConditionsHorseRequest(properties);
          };

          /**
           * Encodes the specified AssignPreferredConditionsHorseRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignPreferredConditionsHorseRequest} message AssignPreferredConditionsHorseRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignPreferredConditionsHorseRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.raceDistanceIds != null &&
              message.raceDistanceIds.length
            )
              for (var i = 0; i < message.raceDistanceIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.raceDistanceIds[i]);
            if (message.raceTypeIds != null && message.raceTypeIds.length)
              for (var i = 0; i < message.raceTypeIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.raceTypeIds[i]);
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.surface);
            if (
              message.conditionNote != null &&
              Object.hasOwnProperty.call(message, "conditionNote")
            )
              $root.google.protobuf.StringValue.encode(
                message.conditionNote,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              Object.hasOwnProperty.call(
                message,
                "areLastRacePreferredConditionsSelected"
              )
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .bool(message.areLastRacePreferredConditionsSelected);
            if (
              message.claimingPriceIds != null &&
              message.claimingPriceIds.length
            )
              for (var i = 0; i < message.claimingPriceIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.claimingPriceIds[i]);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignPreferredConditionsHorseRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} AssignPreferredConditionsHorseRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignPreferredConditionsHorseRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  if (
                    !(message.raceDistanceIds && message.raceDistanceIds.length)
                  )
                    message.raceDistanceIds = [];
                  message.raceDistanceIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.raceTypeIds && message.raceTypeIds.length))
                    message.raceTypeIds = [];
                  message.raceTypeIds.push(reader.string());
                  break;
                case 4:
                  message.surface = reader.int32();
                  break;
                case 5:
                  message.conditionNote =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.areLastRacePreferredConditionsSelected =
                    reader.bool();
                  break;
                case 7:
                  if (
                    !(
                      message.claimingPriceIds &&
                      message.claimingPriceIds.length
                    )
                  )
                    message.claimingPriceIds = [];
                  message.claimingPriceIds.push(reader.string());
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignPreferredConditionsHorseRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} AssignPreferredConditionsHorseRequest
           */
          AssignPreferredConditionsHorseRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .AssignPreferredConditionsHorseRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.raceDistanceIds) {
                if (!Array.isArray(object.raceDistanceIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.raceDistanceIds: array expected"
                  );
                message.raceDistanceIds = [];
                for (var i = 0; i < object.raceDistanceIds.length; ++i)
                  message.raceDistanceIds[i] = String(
                    object.raceDistanceIds[i]
                  );
              }
              if (object.raceTypeIds) {
                if (!Array.isArray(object.raceTypeIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.raceTypeIds: array expected"
                  );
                message.raceTypeIds = [];
                for (var i = 0; i < object.raceTypeIds.length; ++i)
                  message.raceTypeIds[i] = String(object.raceTypeIds[i]);
              }
              switch (object.surface) {
                case "COURSE_SURFACE_INVALID":
                case 0:
                  message.surface = 0;
                  break;
                case "COURSE_SURFACE_ALL_WEATHER_TRACK":
                case 1:
                  message.surface = 1;
                  break;
                case "COURSE_SURFACE_TURF":
                case 2:
                  message.surface = 2;
                  break;
                case "COURSE_SURFACE_STEEPLECHASE":
                case 3:
                  message.surface = 3;
                  break;
                case "COURSE_SURFACE_INNER_TRACK":
                case 4:
                  message.surface = 4;
                  break;
                case "COURSE_SURFACE_OUTER_TURF":
                case 5:
                  message.surface = 5;
                  break;
                case "COURSE_SURFACE_WOOD_CHIPS":
                case 6:
                  message.surface = 6;
                  break;
                case "COURSE_SURFACE_HUNT_ON_TURF":
                case 7:
                  message.surface = 7;
                  break;
                case "COURSE_SURFACE_TIMBER":
                case 8:
                  message.surface = 8;
                  break;
                case "COURSE_SURFACE_DIRT":
                case 9:
                  message.surface = 9;
                  break;
                case "COURSE_SURFACE_TURF_TRAINING":
                case 10:
                  message.surface = 10;
                  break;
                case "COURSE_SURFACE_JUMP":
                case 11:
                  message.surface = 11;
                  break;
                case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
                case 12:
                  message.surface = 12;
                  break;
                case "COURSE_SURFACE_HUNT":
                case 13:
                  message.surface = 13;
                  break;
                case "COURSE_SURFACE_DOWNHILL_TURF":
                case 14:
                  message.surface = 14;
                  break;
                case "COURSE_SURFACE_DIRT_TRAINING":
                case 15:
                  message.surface = 15;
                  break;
                case "COURSE_SURFACE_INNER_TURF":
                case 16:
                  message.surface = 16;
                  break;
                case "COURSE_SURFACE_HURDLE":
                case 17:
                  message.surface = 17;
                  break;
              }
              if (object.conditionNote != null) {
                if (typeof object.conditionNote !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.conditionNote: object expected"
                  );
                message.conditionNote =
                  $root.google.protobuf.StringValue.fromObject(
                    object.conditionNote
                  );
              }
              if (object.areLastRacePreferredConditionsSelected != null)
                message.areLastRacePreferredConditionsSelected = Boolean(
                  object.areLastRacePreferredConditionsSelected
                );
              if (object.claimingPriceIds) {
                if (!Array.isArray(object.claimingPriceIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.claimingPriceIds: array expected"
                  );
                message.claimingPriceIds = [];
                for (var i = 0; i < object.claimingPriceIds.length; ++i)
                  message.claimingPriceIds[i] = String(
                    object.claimingPriceIds[i]
                  );
              }
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from an AssignPreferredConditionsHorseRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest} message AssignPreferredConditionsHorseRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignPreferredConditionsHorseRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.raceDistanceIds = [];
              object.raceTypeIds = [];
              object.claimingPriceIds = [];
            }
            if (options.defaults) {
              object.id = "";
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.conditionNote = null;
              object.areLastRacePreferredConditionsSelected = false;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.raceDistanceIds && message.raceDistanceIds.length) {
              object.raceDistanceIds = [];
              for (var j = 0; j < message.raceDistanceIds.length; ++j)
                object.raceDistanceIds[j] = message.raceDistanceIds[j];
            }
            if (message.raceTypeIds && message.raceTypeIds.length) {
              object.raceTypeIds = [];
              for (var j = 0; j < message.raceTypeIds.length; ++j)
                object.raceTypeIds[j] = message.raceTypeIds[j];
            }
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (
              message.conditionNote != null &&
              message.hasOwnProperty("conditionNote")
            )
              object.conditionNote = $root.google.protobuf.StringValue.toObject(
                message.conditionNote,
                options
              );
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              message.hasOwnProperty("areLastRacePreferredConditionsSelected")
            )
              object.areLastRacePreferredConditionsSelected =
                message.areLastRacePreferredConditionsSelected;
            if (message.claimingPriceIds && message.claimingPriceIds.length) {
              object.claimingPriceIds = [];
              for (var j = 0; j < message.claimingPriceIds.length; ++j)
                object.claimingPriceIds[j] = message.claimingPriceIds[j];
            }
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignPreferredConditionsHorseRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignPreferredConditionsHorseRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignPreferredConditionsHorseRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return AssignPreferredConditionsHorseRequest;
        })();

        racehorse360.ResetPreferredConditionsHorseRequest = (function () {
          /**
           * Properties of a ResetPreferredConditionsHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetPreferredConditionsHorseRequest
           * @property {string|null} [id] ResetPreferredConditionsHorseRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetPreferredConditionsHorseRequest getOptions
           */

          /**
           * Constructs a new ResetPreferredConditionsHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetPreferredConditionsHorseRequest.
           * @implements IResetPreferredConditionsHorseRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetPreferredConditionsHorseRequest=} [properties] Properties to set
           */
          function ResetPreferredConditionsHorseRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetPreferredConditionsHorseRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @instance
           */
          ResetPreferredConditionsHorseRequest.prototype.id = "";

          /**
           * ResetPreferredConditionsHorseRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @instance
           */
          ResetPreferredConditionsHorseRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetPreferredConditionsHorseRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetPreferredConditionsHorseRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} ResetPreferredConditionsHorseRequest instance
           */
          ResetPreferredConditionsHorseRequest.create = function create(
            properties
          ) {
            return new ResetPreferredConditionsHorseRequest(properties);
          };

          /**
           * Encodes the specified ResetPreferredConditionsHorseRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetPreferredConditionsHorseRequest} message ResetPreferredConditionsHorseRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetPreferredConditionsHorseRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetPreferredConditionsHorseRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} ResetPreferredConditionsHorseRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetPreferredConditionsHorseRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetPreferredConditionsHorseRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} ResetPreferredConditionsHorseRequest
           */
          ResetPreferredConditionsHorseRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ResetPreferredConditionsHorseRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ResetPreferredConditionsHorseRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest} message ResetPreferredConditionsHorseRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetPreferredConditionsHorseRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetPreferredConditionsHorseRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetPreferredConditionsHorseRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetPreferredConditionsHorseRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ResetPreferredConditionsHorseRequest;
        })();

        racehorse360.EditHorseHealthWatchStatusRequest = (function () {
          /**
           * Properties of an EditHorseHealthWatchStatusRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditHorseHealthWatchStatusRequest
           * @property {string|null} [horseId] EditHorseHealthWatchStatusRequest horseId
           * @property {stronachgroup.first.racehorse360.HealthWatchStatus|null} [healthWatchStatus] EditHorseHealthWatchStatusRequest healthWatchStatus
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditHorseHealthWatchStatusRequest getOptions
           */

          /**
           * Constructs a new EditHorseHealthWatchStatusRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditHorseHealthWatchStatusRequest.
           * @implements IEditHorseHealthWatchStatusRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditHorseHealthWatchStatusRequest=} [properties] Properties to set
           */
          function EditHorseHealthWatchStatusRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditHorseHealthWatchStatusRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @instance
           */
          EditHorseHealthWatchStatusRequest.prototype.horseId = "";

          /**
           * EditHorseHealthWatchStatusRequest healthWatchStatus.
           * @member {stronachgroup.first.racehorse360.HealthWatchStatus} healthWatchStatus
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @instance
           */
          EditHorseHealthWatchStatusRequest.prototype.healthWatchStatus = 0;

          /**
           * EditHorseHealthWatchStatusRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @instance
           */
          EditHorseHealthWatchStatusRequest.prototype.getOptions = null;

          /**
           * Creates a new EditHorseHealthWatchStatusRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseHealthWatchStatusRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} EditHorseHealthWatchStatusRequest instance
           */
          EditHorseHealthWatchStatusRequest.create = function create(
            properties
          ) {
            return new EditHorseHealthWatchStatusRequest(properties);
          };

          /**
           * Encodes the specified EditHorseHealthWatchStatusRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseHealthWatchStatusRequest} message EditHorseHealthWatchStatusRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditHorseHealthWatchStatusRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.healthWatchStatus != null &&
              Object.hasOwnProperty.call(message, "healthWatchStatus")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.healthWatchStatus);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditHorseHealthWatchStatusRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} EditHorseHealthWatchStatusRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditHorseHealthWatchStatusRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.healthWatchStatus = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditHorseHealthWatchStatusRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} EditHorseHealthWatchStatusRequest
           */
          EditHorseHealthWatchStatusRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .EditHorseHealthWatchStatusRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            switch (object.healthWatchStatus) {
              case "HEALTH_WATCH_STATUS_INVALID":
              case 0:
                message.healthWatchStatus = 0;
                break;
              case "HEALTH_WATCH_STATUS_GREEN":
              case 1:
                message.healthWatchStatus = 1;
                break;
              case "HEALTH_WATCH_STATUS_YELLOW":
              case 2:
                message.healthWatchStatus = 2;
                break;
              case "HEALTH_WATCH_STATUS_RED":
              case 3:
                message.healthWatchStatus = 3;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditHorseHealthWatchStatusRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest} message EditHorseHealthWatchStatusRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditHorseHealthWatchStatusRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.healthWatchStatus =
                options.enums === String ? "HEALTH_WATCH_STATUS_INVALID" : 0;
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.healthWatchStatus != null &&
              message.hasOwnProperty("healthWatchStatus")
            )
              object.healthWatchStatus =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HealthWatchStatus[
                      message.healthWatchStatus
                    ]
                  : message.healthWatchStatus;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditHorseHealthWatchStatusRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditHorseHealthWatchStatusRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditHorseHealthWatchStatusRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return EditHorseHealthWatchStatusRequest;
        })();

        racehorse360.HorseWarningMessage = (function () {
          /**
           * Properties of a HorseWarningMessage.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseWarningMessage
           * @property {string|null} [body] HorseWarningMessage body
           * @property {string|null} [updatedOn] HorseWarningMessage updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseWarningMessage updatedBy
           */

          /**
           * Constructs a new HorseWarningMessage.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseWarningMessage.
           * @implements IHorseWarningMessage
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseWarningMessage=} [properties] Properties to set
           */
          function HorseWarningMessage(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseWarningMessage body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @instance
           */
          HorseWarningMessage.prototype.body = "";

          /**
           * HorseWarningMessage updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @instance
           */
          HorseWarningMessage.prototype.updatedOn = "";

          /**
           * HorseWarningMessage updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @instance
           */
          HorseWarningMessage.prototype.updatedBy = null;

          /**
           * Creates a new HorseWarningMessage instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWarningMessage=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseWarningMessage} HorseWarningMessage instance
           */
          HorseWarningMessage.create = function create(properties) {
            return new HorseWarningMessage(properties);
          };

          /**
           * Encodes the specified HorseWarningMessage message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseWarningMessage.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWarningMessage} message HorseWarningMessage message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseWarningMessage.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.body);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.updatedOn);
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseWarningMessage message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseWarningMessage} HorseWarningMessage
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseWarningMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseWarningMessage();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.body = reader.string();
                  break;
                case 2:
                  message.updatedOn = reader.string();
                  break;
                case 3:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseWarningMessage message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseWarningMessage} HorseWarningMessage
           */
          HorseWarningMessage.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseWarningMessage
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseWarningMessage();
            if (object.body != null) message.body = String(object.body);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseWarningMessage.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseWarningMessage message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.HorseWarningMessage} message HorseWarningMessage
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseWarningMessage.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.body = "";
              object.updatedOn = "";
              object.updatedBy = null;
            }
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseWarningMessage to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseWarningMessage
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseWarningMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseWarningMessage;
        })();

        racehorse360.SetHorseWarningMessageRequest = (function () {
          /**
           * Properties of a SetHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetHorseWarningMessageRequest
           * @property {string|null} [horseId] SetHorseWarningMessageRequest horseId
           * @property {string|null} [body] SetHorseWarningMessageRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetHorseWarningMessageRequest getOptions
           */

          /**
           * Constructs a new SetHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetHorseWarningMessageRequest.
           * @implements ISetHorseWarningMessageRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetHorseWarningMessageRequest=} [properties] Properties to set
           */
          function SetHorseWarningMessageRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetHorseWarningMessageRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @instance
           */
          SetHorseWarningMessageRequest.prototype.horseId = "";

          /**
           * SetHorseWarningMessageRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @instance
           */
          SetHorseWarningMessageRequest.prototype.body = "";

          /**
           * SetHorseWarningMessageRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @instance
           */
          SetHorseWarningMessageRequest.prototype.getOptions = null;

          /**
           * Creates a new SetHorseWarningMessageRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetHorseWarningMessageRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} SetHorseWarningMessageRequest instance
           */
          SetHorseWarningMessageRequest.create = function create(properties) {
            return new SetHorseWarningMessageRequest(properties);
          };

          /**
           * Encodes the specified SetHorseWarningMessageRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetHorseWarningMessageRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetHorseWarningMessageRequest} message SetHorseWarningMessageRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetHorseWarningMessageRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetHorseWarningMessageRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} SetHorseWarningMessageRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetHorseWarningMessageRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetHorseWarningMessageRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} SetHorseWarningMessageRequest
           */
          SetHorseWarningMessageRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SetHorseWarningMessageRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetHorseWarningMessageRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetHorseWarningMessageRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SetHorseWarningMessageRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetHorseWarningMessageRequest} message SetHorseWarningMessageRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetHorseWarningMessageRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetHorseWarningMessageRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetHorseWarningMessageRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetHorseWarningMessageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetHorseWarningMessageRequest;
        })();

        racehorse360.ResetHorseWarningMessageRequest = (function () {
          /**
           * Properties of a ResetHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetHorseWarningMessageRequest
           * @property {string|null} [horseId] ResetHorseWarningMessageRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetHorseWarningMessageRequest getOptions
           */

          /**
           * Constructs a new ResetHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetHorseWarningMessageRequest.
           * @implements IResetHorseWarningMessageRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetHorseWarningMessageRequest=} [properties] Properties to set
           */
          function ResetHorseWarningMessageRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetHorseWarningMessageRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @instance
           */
          ResetHorseWarningMessageRequest.prototype.horseId = "";

          /**
           * ResetHorseWarningMessageRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @instance
           */
          ResetHorseWarningMessageRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetHorseWarningMessageRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetHorseWarningMessageRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} ResetHorseWarningMessageRequest instance
           */
          ResetHorseWarningMessageRequest.create = function create(properties) {
            return new ResetHorseWarningMessageRequest(properties);
          };

          /**
           * Encodes the specified ResetHorseWarningMessageRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetHorseWarningMessageRequest} message ResetHorseWarningMessageRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetHorseWarningMessageRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetHorseWarningMessageRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} ResetHorseWarningMessageRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetHorseWarningMessageRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetHorseWarningMessageRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} ResetHorseWarningMessageRequest
           */
          ResetHorseWarningMessageRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ResetHorseWarningMessageRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ResetHorseWarningMessageRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest} message ResetHorseWarningMessageRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetHorseWarningMessageRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetHorseWarningMessageRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetHorseWarningMessageRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetHorseWarningMessageRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ResetHorseWarningMessageRequest;
        })();

        racehorse360.RelevantHorseWarningMessage = (function () {
          /**
           * Properties of a RelevantHorseWarningMessage.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRelevantHorseWarningMessage
           * @property {string|null} [body] RelevantHorseWarningMessage body
           * @property {string|null} [updatedOn] RelevantHorseWarningMessage updatedOn
           * @property {string|null} [updatedByFirstName] RelevantHorseWarningMessage updatedByFirstName
           * @property {string|null} [updatedByLastName] RelevantHorseWarningMessage updatedByLastName
           */

          /**
           * Constructs a new RelevantHorseWarningMessage.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RelevantHorseWarningMessage.
           * @implements IRelevantHorseWarningMessage
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRelevantHorseWarningMessage=} [properties] Properties to set
           */
          function RelevantHorseWarningMessage(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RelevantHorseWarningMessage body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @instance
           */
          RelevantHorseWarningMessage.prototype.body = "";

          /**
           * RelevantHorseWarningMessage updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @instance
           */
          RelevantHorseWarningMessage.prototype.updatedOn = "";

          /**
           * RelevantHorseWarningMessage updatedByFirstName.
           * @member {string} updatedByFirstName
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @instance
           */
          RelevantHorseWarningMessage.prototype.updatedByFirstName = "";

          /**
           * RelevantHorseWarningMessage updatedByLastName.
           * @member {string} updatedByLastName
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @instance
           */
          RelevantHorseWarningMessage.prototype.updatedByLastName = "";

          /**
           * Creates a new RelevantHorseWarningMessage instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.IRelevantHorseWarningMessage=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RelevantHorseWarningMessage} RelevantHorseWarningMessage instance
           */
          RelevantHorseWarningMessage.create = function create(properties) {
            return new RelevantHorseWarningMessage(properties);
          };

          /**
           * Encodes the specified RelevantHorseWarningMessage message. Does not implicitly {@link stronachgroup.first.racehorse360.RelevantHorseWarningMessage.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.IRelevantHorseWarningMessage} message RelevantHorseWarningMessage message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RelevantHorseWarningMessage.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.body);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.updatedOn);
            if (
              message.updatedByFirstName != null &&
              Object.hasOwnProperty.call(message, "updatedByFirstName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.updatedByFirstName);
            if (
              message.updatedByLastName != null &&
              Object.hasOwnProperty.call(message, "updatedByLastName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.updatedByLastName);
            return writer;
          };

          /**
           * Decodes a RelevantHorseWarningMessage message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RelevantHorseWarningMessage} RelevantHorseWarningMessage
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RelevantHorseWarningMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.body = reader.string();
                  break;
                case 2:
                  message.updatedOn = reader.string();
                  break;
                case 3:
                  message.updatedByFirstName = reader.string();
                  break;
                case 4:
                  message.updatedByLastName = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RelevantHorseWarningMessage message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RelevantHorseWarningMessage} RelevantHorseWarningMessage
           */
          RelevantHorseWarningMessage.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage();
            if (object.body != null) message.body = String(object.body);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.updatedByFirstName != null)
              message.updatedByFirstName = String(object.updatedByFirstName);
            if (object.updatedByLastName != null)
              message.updatedByLastName = String(object.updatedByLastName);
            return message;
          };

          /**
           * Creates a plain object from a RelevantHorseWarningMessage message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @static
           * @param {stronachgroup.first.racehorse360.RelevantHorseWarningMessage} message RelevantHorseWarningMessage
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RelevantHorseWarningMessage.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.body = "";
              object.updatedOn = "";
              object.updatedByFirstName = "";
              object.updatedByLastName = "";
            }
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.updatedByFirstName != null &&
              message.hasOwnProperty("updatedByFirstName")
            )
              object.updatedByFirstName = message.updatedByFirstName;
            if (
              message.updatedByLastName != null &&
              message.hasOwnProperty("updatedByLastName")
            )
              object.updatedByLastName = message.updatedByLastName;
            return object;
          };

          /**
           * Converts this RelevantHorseWarningMessage to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RelevantHorseWarningMessage
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RelevantHorseWarningMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RelevantHorseWarningMessage;
        })();

        racehorse360.PullRelevantHorseWarningMessageRequest = (function () {
          /**
           * Properties of a PullRelevantHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRelevantHorseWarningMessageRequest
           * @property {string|null} [horseId] PullRelevantHorseWarningMessageRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] PullRelevantHorseWarningMessageRequest getOptions
           */

          /**
           * Constructs a new PullRelevantHorseWarningMessageRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRelevantHorseWarningMessageRequest.
           * @implements IPullRelevantHorseWarningMessageRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageRequest=} [properties] Properties to set
           */
          function PullRelevantHorseWarningMessageRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRelevantHorseWarningMessageRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @instance
           */
          PullRelevantHorseWarningMessageRequest.prototype.horseId = "";

          /**
           * PullRelevantHorseWarningMessageRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @instance
           */
          PullRelevantHorseWarningMessageRequest.prototype.getOptions = null;

          /**
           * Creates a new PullRelevantHorseWarningMessageRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} PullRelevantHorseWarningMessageRequest instance
           */
          PullRelevantHorseWarningMessageRequest.create = function create(
            properties
          ) {
            return new PullRelevantHorseWarningMessageRequest(properties);
          };

          /**
           * Encodes the specified PullRelevantHorseWarningMessageRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageRequest} message PullRelevantHorseWarningMessageRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRelevantHorseWarningMessageRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRelevantHorseWarningMessageRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} PullRelevantHorseWarningMessageRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRelevantHorseWarningMessageRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRelevantHorseWarningMessageRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} PullRelevantHorseWarningMessageRequest
           */
          PullRelevantHorseWarningMessageRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullRelevantHorseWarningMessageRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest();
              if (object.horseId != null)
                message.horseId = String(object.horseId);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a PullRelevantHorseWarningMessageRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest} message PullRelevantHorseWarningMessageRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRelevantHorseWarningMessageRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullRelevantHorseWarningMessageRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRelevantHorseWarningMessageRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRelevantHorseWarningMessageRequest;
        })();

        racehorse360.PullRelevantHorseWarningMessageResponse = (function () {
          /**
           * Properties of a PullRelevantHorseWarningMessageResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRelevantHorseWarningMessageResponse
           * @property {stronachgroup.first.racehorse360.IRelevantHorseWarningMessage|null} [relevantHorseWarningMessage] PullRelevantHorseWarningMessageResponse relevantHorseWarningMessage
           */

          /**
           * Constructs a new PullRelevantHorseWarningMessageResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRelevantHorseWarningMessageResponse.
           * @implements IPullRelevantHorseWarningMessageResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageResponse=} [properties] Properties to set
           */
          function PullRelevantHorseWarningMessageResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRelevantHorseWarningMessageResponse relevantHorseWarningMessage.
           * @member {stronachgroup.first.racehorse360.IRelevantHorseWarningMessage|null|undefined} relevantHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @instance
           */
          PullRelevantHorseWarningMessageResponse.prototype.relevantHorseWarningMessage =
            null;

          /**
           * Creates a new PullRelevantHorseWarningMessageResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse} PullRelevantHorseWarningMessageResponse instance
           */
          PullRelevantHorseWarningMessageResponse.create = function create(
            properties
          ) {
            return new PullRelevantHorseWarningMessageResponse(properties);
          };

          /**
           * Encodes the specified PullRelevantHorseWarningMessageResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageResponse} message PullRelevantHorseWarningMessageResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRelevantHorseWarningMessageResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.relevantHorseWarningMessage != null &&
              Object.hasOwnProperty.call(message, "relevantHorseWarningMessage")
            )
              $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage.encode(
                message.relevantHorseWarningMessage,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRelevantHorseWarningMessageResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse} PullRelevantHorseWarningMessageResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRelevantHorseWarningMessageResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.relevantHorseWarningMessage =
                    $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRelevantHorseWarningMessageResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse} PullRelevantHorseWarningMessageResponse
           */
          PullRelevantHorseWarningMessageResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullRelevantHorseWarningMessageResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse();
              if (object.relevantHorseWarningMessage != null) {
                if (typeof object.relevantHorseWarningMessage !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse.relevantHorseWarningMessage: object expected"
                  );
                message.relevantHorseWarningMessage =
                  $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage.fromObject(
                    object.relevantHorseWarningMessage
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a PullRelevantHorseWarningMessageResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse} message PullRelevantHorseWarningMessageResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRelevantHorseWarningMessageResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.relevantHorseWarningMessage = null;
            if (
              message.relevantHorseWarningMessage != null &&
              message.hasOwnProperty("relevantHorseWarningMessage")
            )
              object.relevantHorseWarningMessage =
                $root.stronachgroup.first.racehorse360.RelevantHorseWarningMessage.toObject(
                  message.relevantHorseWarningMessage,
                  options
                );
            return object;
          };

          /**
           * Converts this PullRelevantHorseWarningMessageResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRelevantHorseWarningMessageResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRelevantHorseWarningMessageResponse;
        })();

        racehorse360.SetHorseFlagOnTrackRequest = (function () {
          /**
           * Properties of a SetHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetHorseFlagOnTrackRequest
           * @property {string|null} [horseId] SetHorseFlagOnTrackRequest horseId
           * @property {string|null} [body] SetHorseFlagOnTrackRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetHorseFlagOnTrackRequest getOptions
           */

          /**
           * Constructs a new SetHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetHorseFlagOnTrackRequest.
           * @implements ISetHorseFlagOnTrackRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetHorseFlagOnTrackRequest=} [properties] Properties to set
           */
          function SetHorseFlagOnTrackRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetHorseFlagOnTrackRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @instance
           */
          SetHorseFlagOnTrackRequest.prototype.horseId = "";

          /**
           * SetHorseFlagOnTrackRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @instance
           */
          SetHorseFlagOnTrackRequest.prototype.body = "";

          /**
           * SetHorseFlagOnTrackRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @instance
           */
          SetHorseFlagOnTrackRequest.prototype.getOptions = null;

          /**
           * Creates a new SetHorseFlagOnTrackRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetHorseFlagOnTrackRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} SetHorseFlagOnTrackRequest instance
           */
          SetHorseFlagOnTrackRequest.create = function create(properties) {
            return new SetHorseFlagOnTrackRequest(properties);
          };

          /**
           * Encodes the specified SetHorseFlagOnTrackRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetHorseFlagOnTrackRequest} message SetHorseFlagOnTrackRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetHorseFlagOnTrackRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetHorseFlagOnTrackRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} SetHorseFlagOnTrackRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetHorseFlagOnTrackRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetHorseFlagOnTrackRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} SetHorseFlagOnTrackRequest
           */
          SetHorseFlagOnTrackRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SetHorseFlagOnTrackRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest} message SetHorseFlagOnTrackRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetHorseFlagOnTrackRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetHorseFlagOnTrackRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetHorseFlagOnTrackRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetHorseFlagOnTrackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetHorseFlagOnTrackRequest;
        })();

        racehorse360.EditHorseFlagOnTrackRequest = (function () {
          /**
           * Properties of an EditHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditHorseFlagOnTrackRequest
           * @property {string|null} [horseId] EditHorseFlagOnTrackRequest horseId
           * @property {string|null} [body] EditHorseFlagOnTrackRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditHorseFlagOnTrackRequest getOptions
           */

          /**
           * Constructs a new EditHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditHorseFlagOnTrackRequest.
           * @implements IEditHorseFlagOnTrackRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditHorseFlagOnTrackRequest=} [properties] Properties to set
           */
          function EditHorseFlagOnTrackRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditHorseFlagOnTrackRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @instance
           */
          EditHorseFlagOnTrackRequest.prototype.horseId = "";

          /**
           * EditHorseFlagOnTrackRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @instance
           */
          EditHorseFlagOnTrackRequest.prototype.body = "";

          /**
           * EditHorseFlagOnTrackRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @instance
           */
          EditHorseFlagOnTrackRequest.prototype.getOptions = null;

          /**
           * Creates a new EditHorseFlagOnTrackRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseFlagOnTrackRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} EditHorseFlagOnTrackRequest instance
           */
          EditHorseFlagOnTrackRequest.create = function create(properties) {
            return new EditHorseFlagOnTrackRequest(properties);
          };

          /**
           * Encodes the specified EditHorseFlagOnTrackRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseFlagOnTrackRequest} message EditHorseFlagOnTrackRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditHorseFlagOnTrackRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditHorseFlagOnTrackRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} EditHorseFlagOnTrackRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditHorseFlagOnTrackRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditHorseFlagOnTrackRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} EditHorseFlagOnTrackRequest
           */
          EditHorseFlagOnTrackRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditHorseFlagOnTrackRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest} message EditHorseFlagOnTrackRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditHorseFlagOnTrackRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditHorseFlagOnTrackRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditHorseFlagOnTrackRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditHorseFlagOnTrackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EditHorseFlagOnTrackRequest;
        })();

        racehorse360.ResetHorseFlagOnTrackRequest = (function () {
          /**
           * Properties of a ResetHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetHorseFlagOnTrackRequest
           * @property {string|null} [horseId] ResetHorseFlagOnTrackRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetHorseFlagOnTrackRequest getOptions
           */

          /**
           * Constructs a new ResetHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetHorseFlagOnTrackRequest.
           * @implements IResetHorseFlagOnTrackRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetHorseFlagOnTrackRequest=} [properties] Properties to set
           */
          function ResetHorseFlagOnTrackRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetHorseFlagOnTrackRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @instance
           */
          ResetHorseFlagOnTrackRequest.prototype.horseId = "";

          /**
           * ResetHorseFlagOnTrackRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @instance
           */
          ResetHorseFlagOnTrackRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetHorseFlagOnTrackRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetHorseFlagOnTrackRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} ResetHorseFlagOnTrackRequest instance
           */
          ResetHorseFlagOnTrackRequest.create = function create(properties) {
            return new ResetHorseFlagOnTrackRequest(properties);
          };

          /**
           * Encodes the specified ResetHorseFlagOnTrackRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetHorseFlagOnTrackRequest} message ResetHorseFlagOnTrackRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetHorseFlagOnTrackRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetHorseFlagOnTrackRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} ResetHorseFlagOnTrackRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetHorseFlagOnTrackRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetHorseFlagOnTrackRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} ResetHorseFlagOnTrackRequest
           */
          ResetHorseFlagOnTrackRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ResetHorseFlagOnTrackRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ResetHorseFlagOnTrackRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest} message ResetHorseFlagOnTrackRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetHorseFlagOnTrackRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetHorseFlagOnTrackRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetHorseFlagOnTrackRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetHorseFlagOnTrackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ResetHorseFlagOnTrackRequest;
        })();

        racehorse360.HorsePreferredConditions = (function () {
          /**
           * Properties of a HorsePreferredConditions.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorsePreferredConditions
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] HorsePreferredConditions surface
           * @property {Array.<stronachgroup.first.racehorse360.IRaceDistance>|null} [raceDistances] HorsePreferredConditions raceDistances
           * @property {Array.<stronachgroup.first.racehorse360.IRaceType>|null} [raceTypes] HorsePreferredConditions raceTypes
           * @property {Array.<stronachgroup.first.racehorse360.IClaimingPrice>|null} [claimingPrices] HorsePreferredConditions claimingPrices
           */

          /**
           * Constructs a new HorsePreferredConditions.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorsePreferredConditions.
           * @implements IHorsePreferredConditions
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorsePreferredConditions=} [properties] Properties to set
           */
          function HorsePreferredConditions(properties) {
            this.raceDistances = [];
            this.raceTypes = [];
            this.claimingPrices = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorsePreferredConditions surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @instance
           */
          HorsePreferredConditions.prototype.surface = 0;

          /**
           * HorsePreferredConditions raceDistances.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceDistance>} raceDistances
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @instance
           */
          HorsePreferredConditions.prototype.raceDistances = $util.emptyArray;

          /**
           * HorsePreferredConditions raceTypes.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceType>} raceTypes
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @instance
           */
          HorsePreferredConditions.prototype.raceTypes = $util.emptyArray;

          /**
           * HorsePreferredConditions claimingPrices.
           * @member {Array.<stronachgroup.first.racehorse360.IClaimingPrice>} claimingPrices
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @instance
           */
          HorsePreferredConditions.prototype.claimingPrices = $util.emptyArray;

          /**
           * Creates a new HorsePreferredConditions instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsePreferredConditions=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorsePreferredConditions} HorsePreferredConditions instance
           */
          HorsePreferredConditions.create = function create(properties) {
            return new HorsePreferredConditions(properties);
          };

          /**
           * Encodes the specified HorsePreferredConditions message. Does not implicitly {@link stronachgroup.first.racehorse360.HorsePreferredConditions.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsePreferredConditions} message HorsePreferredConditions message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorsePreferredConditions.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.surface);
            if (message.raceDistances != null && message.raceDistances.length)
              for (var i = 0; i < message.raceDistances.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceDistance.encode(
                  message.raceDistances[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (message.raceTypes != null && message.raceTypes.length)
              for (var i = 0; i < message.raceTypes.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceType.encode(
                  message.raceTypes[i],
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
            if (message.claimingPrices != null && message.claimingPrices.length)
              for (var i = 0; i < message.claimingPrices.length; ++i)
                $root.stronachgroup.first.racehorse360.ClaimingPrice.encode(
                  message.claimingPrices[i],
                  writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorsePreferredConditions message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorsePreferredConditions} HorsePreferredConditions
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorsePreferredConditions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorsePreferredConditions();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.surface = reader.int32();
                  break;
                case 2:
                  if (!(message.raceDistances && message.raceDistances.length))
                    message.raceDistances = [];
                  message.raceDistances.push(
                    $root.stronachgroup.first.racehorse360.RaceDistance.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 3:
                  if (!(message.raceTypes && message.raceTypes.length))
                    message.raceTypes = [];
                  message.raceTypes.push(
                    $root.stronachgroup.first.racehorse360.RaceType.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 4:
                  if (
                    !(message.claimingPrices && message.claimingPrices.length)
                  )
                    message.claimingPrices = [];
                  message.claimingPrices.push(
                    $root.stronachgroup.first.racehorse360.ClaimingPrice.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorsePreferredConditions message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorsePreferredConditions} HorsePreferredConditions
           */
          HorsePreferredConditions.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorsePreferredConditions
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorsePreferredConditions();
            switch (object.surface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.surface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.surface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.surface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.surface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.surface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.surface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.surface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.surface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.surface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.surface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.surface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.surface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.surface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.surface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.surface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.surface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.surface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.surface = 17;
                break;
            }
            if (object.raceDistances) {
              if (!Array.isArray(object.raceDistances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorsePreferredConditions.raceDistances: array expected"
                );
              message.raceDistances = [];
              for (var i = 0; i < object.raceDistances.length; ++i) {
                if (typeof object.raceDistances[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorsePreferredConditions.raceDistances: object expected"
                  );
                message.raceDistances[i] =
                  $root.stronachgroup.first.racehorse360.RaceDistance.fromObject(
                    object.raceDistances[i]
                  );
              }
            }
            if (object.raceTypes) {
              if (!Array.isArray(object.raceTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorsePreferredConditions.raceTypes: array expected"
                );
              message.raceTypes = [];
              for (var i = 0; i < object.raceTypes.length; ++i) {
                if (typeof object.raceTypes[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorsePreferredConditions.raceTypes: object expected"
                  );
                message.raceTypes[i] =
                  $root.stronachgroup.first.racehorse360.RaceType.fromObject(
                    object.raceTypes[i]
                  );
              }
            }
            if (object.claimingPrices) {
              if (!Array.isArray(object.claimingPrices))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorsePreferredConditions.claimingPrices: array expected"
                );
              message.claimingPrices = [];
              for (var i = 0; i < object.claimingPrices.length; ++i) {
                if (typeof object.claimingPrices[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorsePreferredConditions.claimingPrices: object expected"
                  );
                message.claimingPrices[i] =
                  $root.stronachgroup.first.racehorse360.ClaimingPrice.fromObject(
                    object.claimingPrices[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a HorsePreferredConditions message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.HorsePreferredConditions} message HorsePreferredConditions
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorsePreferredConditions.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.raceDistances = [];
              object.raceTypes = [];
              object.claimingPrices = [];
            }
            if (options.defaults)
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (message.raceDistances && message.raceDistances.length) {
              object.raceDistances = [];
              for (var j = 0; j < message.raceDistances.length; ++j)
                object.raceDistances[j] =
                  $root.stronachgroup.first.racehorse360.RaceDistance.toObject(
                    message.raceDistances[j],
                    options
                  );
            }
            if (message.raceTypes && message.raceTypes.length) {
              object.raceTypes = [];
              for (var j = 0; j < message.raceTypes.length; ++j)
                object.raceTypes[j] =
                  $root.stronachgroup.first.racehorse360.RaceType.toObject(
                    message.raceTypes[j],
                    options
                  );
            }
            if (message.claimingPrices && message.claimingPrices.length) {
              object.claimingPrices = [];
              for (var j = 0; j < message.claimingPrices.length; ++j)
                object.claimingPrices[j] =
                  $root.stronachgroup.first.racehorse360.ClaimingPrice.toObject(
                    message.claimingPrices[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this HorsePreferredConditions to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorsePreferredConditions
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorsePreferredConditions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorsePreferredConditions;
        })();

        racehorse360.PullHorsePreferredConditionsRequest = (function () {
          /**
           * Properties of a PullHorsePreferredConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsePreferredConditionsRequest
           * @property {string|null} [id] PullHorsePreferredConditionsRequest id
           */

          /**
           * Constructs a new PullHorsePreferredConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsePreferredConditionsRequest.
           * @implements IPullHorsePreferredConditionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsRequest=} [properties] Properties to set
           */
          function PullHorsePreferredConditionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsePreferredConditionsRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @instance
           */
          PullHorsePreferredConditionsRequest.prototype.id = "";

          /**
           * Creates a new PullHorsePreferredConditionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} PullHorsePreferredConditionsRequest instance
           */
          PullHorsePreferredConditionsRequest.create = function create(
            properties
          ) {
            return new PullHorsePreferredConditionsRequest(properties);
          };

          /**
           * Encodes the specified PullHorsePreferredConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsRequest} message PullHorsePreferredConditionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsePreferredConditionsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a PullHorsePreferredConditionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} PullHorsePreferredConditionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsePreferredConditionsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsePreferredConditionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} PullHorsePreferredConditionsRequest
           */
          PullHorsePreferredConditionsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorsePreferredConditionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a PullHorsePreferredConditionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest} message PullHorsePreferredConditionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsePreferredConditionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this PullHorsePreferredConditionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsePreferredConditionsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorsePreferredConditionsRequest;
        })();

        racehorse360.PullHorsePreferredConditionsResponse = (function () {
          /**
           * Properties of a PullHorsePreferredConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsePreferredConditionsResponse
           * @property {stronachgroup.first.racehorse360.IHorsePreferredConditions|null} [preferredConditions] PullHorsePreferredConditionsResponse preferredConditions
           * @property {boolean|null} [areLastRacePreferredConditions] PullHorsePreferredConditionsResponse areLastRacePreferredConditions
           * @property {stronachgroup.first.racehorse360.IHorsePreferredConditions|null} [lastRacePreferredConditions] PullHorsePreferredConditionsResponse lastRacePreferredConditions
           * @property {string|null} [conditionNote] PullHorsePreferredConditionsResponse conditionNote
           */

          /**
           * Constructs a new PullHorsePreferredConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsePreferredConditionsResponse.
           * @implements IPullHorsePreferredConditionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsResponse=} [properties] Properties to set
           */
          function PullHorsePreferredConditionsResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsePreferredConditionsResponse preferredConditions.
           * @member {stronachgroup.first.racehorse360.IHorsePreferredConditions|null|undefined} preferredConditions
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @instance
           */
          PullHorsePreferredConditionsResponse.prototype.preferredConditions =
            null;

          /**
           * PullHorsePreferredConditionsResponse areLastRacePreferredConditions.
           * @member {boolean} areLastRacePreferredConditions
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @instance
           */
          PullHorsePreferredConditionsResponse.prototype.areLastRacePreferredConditions = false;

          /**
           * PullHorsePreferredConditionsResponse lastRacePreferredConditions.
           * @member {stronachgroup.first.racehorse360.IHorsePreferredConditions|null|undefined} lastRacePreferredConditions
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @instance
           */
          PullHorsePreferredConditionsResponse.prototype.lastRacePreferredConditions =
            null;

          /**
           * PullHorsePreferredConditionsResponse conditionNote.
           * @member {string} conditionNote
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @instance
           */
          PullHorsePreferredConditionsResponse.prototype.conditionNote = "";

          /**
           * Creates a new PullHorsePreferredConditionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse} PullHorsePreferredConditionsResponse instance
           */
          PullHorsePreferredConditionsResponse.create = function create(
            properties
          ) {
            return new PullHorsePreferredConditionsResponse(properties);
          };

          /**
           * Encodes the specified PullHorsePreferredConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsResponse} message PullHorsePreferredConditionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsePreferredConditionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.preferredConditions != null &&
              Object.hasOwnProperty.call(message, "preferredConditions")
            )
              $root.stronachgroup.first.racehorse360.HorsePreferredConditions.encode(
                message.preferredConditions,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.areLastRacePreferredConditions != null &&
              Object.hasOwnProperty.call(
                message,
                "areLastRacePreferredConditions"
              )
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .bool(message.areLastRacePreferredConditions);
            if (
              message.lastRacePreferredConditions != null &&
              Object.hasOwnProperty.call(message, "lastRacePreferredConditions")
            )
              $root.stronachgroup.first.racehorse360.HorsePreferredConditions.encode(
                message.lastRacePreferredConditions,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.conditionNote != null &&
              Object.hasOwnProperty.call(message, "conditionNote")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.conditionNote);
            return writer;
          };

          /**
           * Decodes a PullHorsePreferredConditionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse} PullHorsePreferredConditionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsePreferredConditionsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.preferredConditions =
                    $root.stronachgroup.first.racehorse360.HorsePreferredConditions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.areLastRacePreferredConditions = reader.bool();
                  break;
                case 3:
                  message.lastRacePreferredConditions =
                    $root.stronachgroup.first.racehorse360.HorsePreferredConditions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.conditionNote = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsePreferredConditionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse} PullHorsePreferredConditionsResponse
           */
          PullHorsePreferredConditionsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorsePreferredConditionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse();
            if (object.preferredConditions != null) {
              if (typeof object.preferredConditions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse.preferredConditions: object expected"
                );
              message.preferredConditions =
                $root.stronachgroup.first.racehorse360.HorsePreferredConditions.fromObject(
                  object.preferredConditions
                );
            }
            if (object.areLastRacePreferredConditions != null)
              message.areLastRacePreferredConditions = Boolean(
                object.areLastRacePreferredConditions
              );
            if (object.lastRacePreferredConditions != null) {
              if (typeof object.lastRacePreferredConditions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse.lastRacePreferredConditions: object expected"
                );
              message.lastRacePreferredConditions =
                $root.stronachgroup.first.racehorse360.HorsePreferredConditions.fromObject(
                  object.lastRacePreferredConditions
                );
            }
            if (object.conditionNote != null)
              message.conditionNote = String(object.conditionNote);
            return message;
          };

          /**
           * Creates a plain object from a PullHorsePreferredConditionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse} message PullHorsePreferredConditionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsePreferredConditionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.preferredConditions = null;
              object.areLastRacePreferredConditions = false;
              object.lastRacePreferredConditions = null;
              object.conditionNote = "";
            }
            if (
              message.preferredConditions != null &&
              message.hasOwnProperty("preferredConditions")
            )
              object.preferredConditions =
                $root.stronachgroup.first.racehorse360.HorsePreferredConditions.toObject(
                  message.preferredConditions,
                  options
                );
            if (
              message.areLastRacePreferredConditions != null &&
              message.hasOwnProperty("areLastRacePreferredConditions")
            )
              object.areLastRacePreferredConditions =
                message.areLastRacePreferredConditions;
            if (
              message.lastRacePreferredConditions != null &&
              message.hasOwnProperty("lastRacePreferredConditions")
            )
              object.lastRacePreferredConditions =
                $root.stronachgroup.first.racehorse360.HorsePreferredConditions.toObject(
                  message.lastRacePreferredConditions,
                  options
                );
            if (
              message.conditionNote != null &&
              message.hasOwnProperty("conditionNote")
            )
              object.conditionNote = message.conditionNote;
            return object;
          };

          /**
           * Converts this PullHorsePreferredConditionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsePreferredConditionsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorsePreferredConditionsResponse;
        })();

        racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest =
          (function () {
            /**
             * Properties of a PullTrainerHorsesWithMatchingRacesCountRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullTrainerHorsesWithMatchingRacesCountRequest
             * @property {Array.<string>|null} [horseFacilityIds] PullTrainerHorsesWithMatchingRacesCountRequest horseFacilityIds
             */

            /**
             * Constructs a new PullTrainerHorsesWithMatchingRacesCountRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullTrainerHorsesWithMatchingRacesCountRequest.
             * @implements IPullTrainerHorsesWithMatchingRacesCountRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountRequest=} [properties] Properties to set
             */
            function PullTrainerHorsesWithMatchingRacesCountRequest(
              properties
            ) {
              this.horseFacilityIds = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullTrainerHorsesWithMatchingRacesCountRequest horseFacilityIds.
             * @member {Array.<string>} horseFacilityIds
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @instance
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.prototype.horseFacilityIds =
              $util.emptyArray;

            /**
             * Creates a new PullTrainerHorsesWithMatchingRacesCountRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} PullTrainerHorsesWithMatchingRacesCountRequest instance
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.create =
              function create(properties) {
                return new PullTrainerHorsesWithMatchingRacesCountRequest(
                  properties
                );
              };

            /**
             * Encodes the specified PullTrainerHorsesWithMatchingRacesCountRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountRequest} message PullTrainerHorsesWithMatchingRacesCountRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.horseFacilityIds != null &&
                  message.horseFacilityIds.length
                )
                  for (var i = 0; i < message.horseFacilityIds.length; ++i)
                    writer
                      .uint32(/* id 1, wireType 2 =*/ 10)
                      .string(message.horseFacilityIds[i]);
                return writer;
              };

            /**
             * Decodes a PullTrainerHorsesWithMatchingRacesCountRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} PullTrainerHorsesWithMatchingRacesCountRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (
                        !(
                          message.horseFacilityIds &&
                          message.horseFacilityIds.length
                        )
                      )
                        message.horseFacilityIds = [];
                      message.horseFacilityIds.push(reader.string());
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullTrainerHorsesWithMatchingRacesCountRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} PullTrainerHorsesWithMatchingRacesCountRequest
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullTrainerHorsesWithMatchingRacesCountRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest();
                if (object.horseFacilityIds) {
                  if (!Array.isArray(object.horseFacilityIds))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest.horseFacilityIds: array expected"
                    );
                  message.horseFacilityIds = [];
                  for (var i = 0; i < object.horseFacilityIds.length; ++i)
                    message.horseFacilityIds[i] = String(
                      object.horseFacilityIds[i]
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from a PullTrainerHorsesWithMatchingRacesCountRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @static
             * @param {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest} message PullTrainerHorsesWithMatchingRacesCountRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults)
                  object.horseFacilityIds = [];
                if (
                  message.horseFacilityIds &&
                  message.horseFacilityIds.length
                ) {
                  object.horseFacilityIds = [];
                  for (var j = 0; j < message.horseFacilityIds.length; ++j)
                    object.horseFacilityIds[j] = message.horseFacilityIds[j];
                }
                return object;
              };

            /**
             * Converts this PullTrainerHorsesWithMatchingRacesCountRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullTrainerHorsesWithMatchingRacesCountRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullTrainerHorsesWithMatchingRacesCountRequest;
          })();

        racehorse360.HorseWithMatchingRacesCount = (function () {
          /**
           * Properties of a HorseWithMatchingRacesCount.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseWithMatchingRacesCount
           * @property {string|null} [id] HorseWithMatchingRacesCount id
           * @property {string|null} [horseName] HorseWithMatchingRacesCount horseName
           * @property {number|null} [matchingRacesCount] HorseWithMatchingRacesCount matchingRacesCount
           * @property {boolean|null} [areLastRacePreferredConditionsSelected] HorseWithMatchingRacesCount areLastRacePreferredConditionsSelected
           */

          /**
           * Constructs a new HorseWithMatchingRacesCount.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseWithMatchingRacesCount.
           * @implements IHorseWithMatchingRacesCount
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseWithMatchingRacesCount=} [properties] Properties to set
           */
          function HorseWithMatchingRacesCount(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseWithMatchingRacesCount id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @instance
           */
          HorseWithMatchingRacesCount.prototype.id = "";

          /**
           * HorseWithMatchingRacesCount horseName.
           * @member {string} horseName
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @instance
           */
          HorseWithMatchingRacesCount.prototype.horseName = "";

          /**
           * HorseWithMatchingRacesCount matchingRacesCount.
           * @member {number} matchingRacesCount
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @instance
           */
          HorseWithMatchingRacesCount.prototype.matchingRacesCount = 0;

          /**
           * HorseWithMatchingRacesCount areLastRacePreferredConditionsSelected.
           * @member {boolean} areLastRacePreferredConditionsSelected
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @instance
           */
          HorseWithMatchingRacesCount.prototype.areLastRacePreferredConditionsSelected = false;

          /**
           * Creates a new HorseWithMatchingRacesCount instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWithMatchingRacesCount=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseWithMatchingRacesCount} HorseWithMatchingRacesCount instance
           */
          HorseWithMatchingRacesCount.create = function create(properties) {
            return new HorseWithMatchingRacesCount(properties);
          };

          /**
           * Encodes the specified HorseWithMatchingRacesCount message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseWithMatchingRacesCount.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseWithMatchingRacesCount} message HorseWithMatchingRacesCount message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseWithMatchingRacesCount.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseName != null &&
              Object.hasOwnProperty.call(message, "horseName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseName);
            if (
              message.matchingRacesCount != null &&
              Object.hasOwnProperty.call(message, "matchingRacesCount")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.matchingRacesCount);
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              Object.hasOwnProperty.call(
                message,
                "areLastRacePreferredConditionsSelected"
              )
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.areLastRacePreferredConditionsSelected);
            return writer;
          };

          /**
           * Decodes a HorseWithMatchingRacesCount message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseWithMatchingRacesCount} HorseWithMatchingRacesCount
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseWithMatchingRacesCount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseName = reader.string();
                  break;
                case 3:
                  message.matchingRacesCount = reader.int32();
                  break;
                case 4:
                  message.areLastRacePreferredConditionsSelected =
                    reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseWithMatchingRacesCount message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseWithMatchingRacesCount} HorseWithMatchingRacesCount
           */
          HorseWithMatchingRacesCount.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount();
            if (object.id != null) message.id = String(object.id);
            if (object.horseName != null)
              message.horseName = String(object.horseName);
            if (object.matchingRacesCount != null)
              message.matchingRacesCount = object.matchingRacesCount | 0;
            if (object.areLastRacePreferredConditionsSelected != null)
              message.areLastRacePreferredConditionsSelected = Boolean(
                object.areLastRacePreferredConditionsSelected
              );
            return message;
          };

          /**
           * Creates a plain object from a HorseWithMatchingRacesCount message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @static
           * @param {stronachgroup.first.racehorse360.HorseWithMatchingRacesCount} message HorseWithMatchingRacesCount
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseWithMatchingRacesCount.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseName = "";
              object.matchingRacesCount = 0;
              object.areLastRacePreferredConditionsSelected = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseName != null &&
              message.hasOwnProperty("horseName")
            )
              object.horseName = message.horseName;
            if (
              message.matchingRacesCount != null &&
              message.hasOwnProperty("matchingRacesCount")
            )
              object.matchingRacesCount = message.matchingRacesCount;
            if (
              message.areLastRacePreferredConditionsSelected != null &&
              message.hasOwnProperty("areLastRacePreferredConditionsSelected")
            )
              object.areLastRacePreferredConditionsSelected =
                message.areLastRacePreferredConditionsSelected;
            return object;
          };

          /**
           * Converts this HorseWithMatchingRacesCount to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseWithMatchingRacesCount
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseWithMatchingRacesCount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseWithMatchingRacesCount;
        })();

        racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse =
          (function () {
            /**
             * Properties of a PullTrainerHorsesWithMatchingRacesCountResponse.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullTrainerHorsesWithMatchingRacesCountResponse
             * @property {Array.<stronachgroup.first.racehorse360.IHorseWithMatchingRacesCount>|null} [horsesWithMatchingRacesCount] PullTrainerHorsesWithMatchingRacesCountResponse horsesWithMatchingRacesCount
             */

            /**
             * Constructs a new PullTrainerHorsesWithMatchingRacesCountResponse.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullTrainerHorsesWithMatchingRacesCountResponse.
             * @implements IPullTrainerHorsesWithMatchingRacesCountResponse
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountResponse=} [properties] Properties to set
             */
            function PullTrainerHorsesWithMatchingRacesCountResponse(
              properties
            ) {
              this.horsesWithMatchingRacesCount = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullTrainerHorsesWithMatchingRacesCountResponse horsesWithMatchingRacesCount.
             * @member {Array.<stronachgroup.first.racehorse360.IHorseWithMatchingRacesCount>} horsesWithMatchingRacesCount
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @instance
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.prototype.horsesWithMatchingRacesCount =
              $util.emptyArray;

            /**
             * Creates a new PullTrainerHorsesWithMatchingRacesCountResponse instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountResponse=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse} PullTrainerHorsesWithMatchingRacesCountResponse instance
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.create =
              function create(properties) {
                return new PullTrainerHorsesWithMatchingRacesCountResponse(
                  properties
                );
              };

            /**
             * Encodes the specified PullTrainerHorsesWithMatchingRacesCountResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountResponse} message PullTrainerHorsesWithMatchingRacesCountResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.horsesWithMatchingRacesCount != null &&
                  message.horsesWithMatchingRacesCount.length
                )
                  for (
                    var i = 0;
                    i < message.horsesWithMatchingRacesCount.length;
                    ++i
                  )
                    $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount.encode(
                      message.horsesWithMatchingRacesCount[i],
                      writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                    ).ldelim();
                return writer;
              };

            /**
             * Decodes a PullTrainerHorsesWithMatchingRacesCountResponse message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse} PullTrainerHorsesWithMatchingRacesCountResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (
                        !(
                          message.horsesWithMatchingRacesCount &&
                          message.horsesWithMatchingRacesCount.length
                        )
                      )
                        message.horsesWithMatchingRacesCount = [];
                      message.horsesWithMatchingRacesCount.push(
                        $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount.decode(
                          reader,
                          reader.uint32()
                        )
                      );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullTrainerHorsesWithMatchingRacesCountResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse} PullTrainerHorsesWithMatchingRacesCountResponse
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullTrainerHorsesWithMatchingRacesCountResponse
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse();
                if (object.horsesWithMatchingRacesCount) {
                  if (!Array.isArray(object.horsesWithMatchingRacesCount))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse.horsesWithMatchingRacesCount: array expected"
                    );
                  message.horsesWithMatchingRacesCount = [];
                  for (
                    var i = 0;
                    i < object.horsesWithMatchingRacesCount.length;
                    ++i
                  ) {
                    if (
                      typeof object.horsesWithMatchingRacesCount[i] !== "object"
                    )
                      throw TypeError(
                        ".stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse.horsesWithMatchingRacesCount: object expected"
                      );
                    message.horsesWithMatchingRacesCount[i] =
                      $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount.fromObject(
                        object.horsesWithMatchingRacesCount[i]
                      );
                  }
                }
                return message;
              };

            /**
             * Creates a plain object from a PullTrainerHorsesWithMatchingRacesCountResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @static
             * @param {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse} message PullTrainerHorsesWithMatchingRacesCountResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults)
                  object.horsesWithMatchingRacesCount = [];
                if (
                  message.horsesWithMatchingRacesCount &&
                  message.horsesWithMatchingRacesCount.length
                ) {
                  object.horsesWithMatchingRacesCount = [];
                  for (
                    var j = 0;
                    j < message.horsesWithMatchingRacesCount.length;
                    ++j
                  )
                    object.horsesWithMatchingRacesCount[j] =
                      $root.stronachgroup.first.racehorse360.HorseWithMatchingRacesCount.toObject(
                        message.horsesWithMatchingRacesCount[j],
                        options
                      );
                }
                return object;
              };

            /**
             * Converts this PullTrainerHorsesWithMatchingRacesCountResponse to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullTrainerHorsesWithMatchingRacesCountResponse.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullTrainerHorsesWithMatchingRacesCountResponse;
          })();

        racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest =
          (function () {
            /**
             * Properties of a PullHorsesCountGroupedByPreferredConditionsRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullHorsesCountGroupedByPreferredConditionsRequest
             * @property {google.protobuf.IBoolValue|null} [areLastRacePreferredConditions] PullHorsesCountGroupedByPreferredConditionsRequest areLastRacePreferredConditions
             * @property {number|null} [minDaysSinceLastRace] PullHorsesCountGroupedByPreferredConditionsRequest minDaysSinceLastRace
             * @property {number|null} [maxDaysSinceLastRace] PullHorsesCountGroupedByPreferredConditionsRequest maxDaysSinceLastRace
             * @property {stronachgroup.first.racehorse360.RaceConditionGender|null} [selectedHorseGender] PullHorsesCountGroupedByPreferredConditionsRequest selectedHorseGender
             * @property {Array.<stronachgroup.first.racehorse360.RaceConditionAge>|null} [selectedHorseAges] PullHorsesCountGroupedByPreferredConditionsRequest selectedHorseAges
             * @property {stronachgroup.first.racehorse360.CourseSurface|null} [selectedCourseSurface] PullHorsesCountGroupedByPreferredConditionsRequest selectedCourseSurface
             * @property {Array.<string>|null} [selectedRaceDistanceIds] PullHorsesCountGroupedByPreferredConditionsRequest selectedRaceDistanceIds
             * @property {Array.<string>|null} [selectedRaceTypeIds] PullHorsesCountGroupedByPreferredConditionsRequest selectedRaceTypeIds
             * @property {Array.<string>|null} [selectedClaimingPriceIds] PullHorsesCountGroupedByPreferredConditionsRequest selectedClaimingPriceIds
             */

            /**
             * Constructs a new PullHorsesCountGroupedByPreferredConditionsRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullHorsesCountGroupedByPreferredConditionsRequest.
             * @implements IPullHorsesCountGroupedByPreferredConditionsRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsRequest=} [properties] Properties to set
             */
            function PullHorsesCountGroupedByPreferredConditionsRequest(
              properties
            ) {
              this.selectedHorseAges = [];
              this.selectedRaceDistanceIds = [];
              this.selectedRaceTypeIds = [];
              this.selectedClaimingPriceIds = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest areLastRacePreferredConditions.
             * @member {google.protobuf.IBoolValue|null|undefined} areLastRacePreferredConditions
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.areLastRacePreferredConditions =
              null;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest minDaysSinceLastRace.
             * @member {number} minDaysSinceLastRace
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.minDaysSinceLastRace = 0;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest maxDaysSinceLastRace.
             * @member {number} maxDaysSinceLastRace
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.maxDaysSinceLastRace = 0;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedHorseGender.
             * @member {stronachgroup.first.racehorse360.RaceConditionGender} selectedHorseGender
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedHorseGender = 0;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedHorseAges.
             * @member {Array.<stronachgroup.first.racehorse360.RaceConditionAge>} selectedHorseAges
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedHorseAges =
              $util.emptyArray;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedCourseSurface.
             * @member {stronachgroup.first.racehorse360.CourseSurface} selectedCourseSurface
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedCourseSurface = 0;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedRaceDistanceIds.
             * @member {Array.<string>} selectedRaceDistanceIds
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedRaceDistanceIds =
              $util.emptyArray;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedRaceTypeIds.
             * @member {Array.<string>} selectedRaceTypeIds
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedRaceTypeIds =
              $util.emptyArray;

            /**
             * PullHorsesCountGroupedByPreferredConditionsRequest selectedClaimingPriceIds.
             * @member {Array.<string>} selectedClaimingPriceIds
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.selectedClaimingPriceIds =
              $util.emptyArray;

            /**
             * Creates a new PullHorsesCountGroupedByPreferredConditionsRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} PullHorsesCountGroupedByPreferredConditionsRequest instance
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.create =
              function create(properties) {
                return new PullHorsesCountGroupedByPreferredConditionsRequest(
                  properties
                );
              };

            /**
             * Encodes the specified PullHorsesCountGroupedByPreferredConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsRequest} message PullHorsesCountGroupedByPreferredConditionsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.areLastRacePreferredConditions != null &&
                  Object.hasOwnProperty.call(
                    message,
                    "areLastRacePreferredConditions"
                  )
                )
                  $root.google.protobuf.BoolValue.encode(
                    message.areLastRacePreferredConditions,
                    writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                  ).ldelim();
                if (
                  message.minDaysSinceLastRace != null &&
                  Object.hasOwnProperty.call(message, "minDaysSinceLastRace")
                )
                  writer
                    .uint32(/* id 2, wireType 0 =*/ 16)
                    .int32(message.minDaysSinceLastRace);
                if (
                  message.maxDaysSinceLastRace != null &&
                  Object.hasOwnProperty.call(message, "maxDaysSinceLastRace")
                )
                  writer
                    .uint32(/* id 3, wireType 0 =*/ 24)
                    .int32(message.maxDaysSinceLastRace);
                if (
                  message.selectedHorseGender != null &&
                  Object.hasOwnProperty.call(message, "selectedHorseGender")
                )
                  writer
                    .uint32(/* id 4, wireType 0 =*/ 32)
                    .int32(message.selectedHorseGender);
                if (
                  message.selectedHorseAges != null &&
                  message.selectedHorseAges.length
                ) {
                  writer.uint32(/* id 5, wireType 2 =*/ 42).fork();
                  for (var i = 0; i < message.selectedHorseAges.length; ++i)
                    writer.int32(message.selectedHorseAges[i]);
                  writer.ldelim();
                }
                if (
                  message.selectedCourseSurface != null &&
                  Object.hasOwnProperty.call(message, "selectedCourseSurface")
                )
                  writer
                    .uint32(/* id 6, wireType 0 =*/ 48)
                    .int32(message.selectedCourseSurface);
                if (
                  message.selectedRaceDistanceIds != null &&
                  message.selectedRaceDistanceIds.length
                )
                  for (
                    var i = 0;
                    i < message.selectedRaceDistanceIds.length;
                    ++i
                  )
                    writer
                      .uint32(/* id 7, wireType 2 =*/ 58)
                      .string(message.selectedRaceDistanceIds[i]);
                if (
                  message.selectedRaceTypeIds != null &&
                  message.selectedRaceTypeIds.length
                )
                  for (var i = 0; i < message.selectedRaceTypeIds.length; ++i)
                    writer
                      .uint32(/* id 8, wireType 2 =*/ 66)
                      .string(message.selectedRaceTypeIds[i]);
                if (
                  message.selectedClaimingPriceIds != null &&
                  message.selectedClaimingPriceIds.length
                )
                  for (
                    var i = 0;
                    i < message.selectedClaimingPriceIds.length;
                    ++i
                  )
                    writer
                      .uint32(/* id 9, wireType 2 =*/ 74)
                      .string(message.selectedClaimingPriceIds[i]);
                return writer;
              };

            /**
             * Decodes a PullHorsesCountGroupedByPreferredConditionsRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} PullHorsesCountGroupedByPreferredConditionsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.areLastRacePreferredConditions =
                        $root.google.protobuf.BoolValue.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    case 2:
                      message.minDaysSinceLastRace = reader.int32();
                      break;
                    case 3:
                      message.maxDaysSinceLastRace = reader.int32();
                      break;
                    case 4:
                      message.selectedHorseGender = reader.int32();
                      break;
                    case 5:
                      if (
                        !(
                          message.selectedHorseAges &&
                          message.selectedHorseAges.length
                        )
                      )
                        message.selectedHorseAges = [];
                      if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                          message.selectedHorseAges.push(reader.int32());
                      } else message.selectedHorseAges.push(reader.int32());
                      break;
                    case 6:
                      message.selectedCourseSurface = reader.int32();
                      break;
                    case 7:
                      if (
                        !(
                          message.selectedRaceDistanceIds &&
                          message.selectedRaceDistanceIds.length
                        )
                      )
                        message.selectedRaceDistanceIds = [];
                      message.selectedRaceDistanceIds.push(reader.string());
                      break;
                    case 8:
                      if (
                        !(
                          message.selectedRaceTypeIds &&
                          message.selectedRaceTypeIds.length
                        )
                      )
                        message.selectedRaceTypeIds = [];
                      message.selectedRaceTypeIds.push(reader.string());
                      break;
                    case 9:
                      if (
                        !(
                          message.selectedClaimingPriceIds &&
                          message.selectedClaimingPriceIds.length
                        )
                      )
                        message.selectedClaimingPriceIds = [];
                      message.selectedClaimingPriceIds.push(reader.string());
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullHorsesCountGroupedByPreferredConditionsRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} PullHorsesCountGroupedByPreferredConditionsRequest
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountGroupedByPreferredConditionsRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest();
                if (object.areLastRacePreferredConditions != null) {
                  if (typeof object.areLastRacePreferredConditions !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.areLastRacePreferredConditions: object expected"
                    );
                  message.areLastRacePreferredConditions =
                    $root.google.protobuf.BoolValue.fromObject(
                      object.areLastRacePreferredConditions
                    );
                }
                if (object.minDaysSinceLastRace != null)
                  message.minDaysSinceLastRace =
                    object.minDaysSinceLastRace | 0;
                if (object.maxDaysSinceLastRace != null)
                  message.maxDaysSinceLastRace =
                    object.maxDaysSinceLastRace | 0;
                switch (object.selectedHorseGender) {
                  case "RACE_CONDITION_GENDER_INVALID":
                  case 0:
                    message.selectedHorseGender = 0;
                    break;
                  case "RACE_CONDITION_GENDER_FILLIES":
                  case 1:
                    message.selectedHorseGender = 1;
                    break;
                  case "RACE_CONDITION_GENDER_FILLIES_AND_MARES":
                  case 2:
                    message.selectedHorseGender = 2;
                    break;
                  case "RACE_CONDITION_GENDER_OPEN":
                  case 3:
                    message.selectedHorseGender = 3;
                    break;
                  case "RACE_CONDITION_GENDER_COLTS_AND_GELDINGS":
                  case 4:
                    message.selectedHorseGender = 4;
                    break;
                }
                if (object.selectedHorseAges) {
                  if (!Array.isArray(object.selectedHorseAges))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.selectedHorseAges: array expected"
                    );
                  message.selectedHorseAges = [];
                  for (var i = 0; i < object.selectedHorseAges.length; ++i)
                    switch (object.selectedHorseAges[i]) {
                      default:
                      case "RACE_CONDITION_AGE_INVALID":
                      case 0:
                        message.selectedHorseAges[i] = 0;
                        break;
                      case "RACE_CONDITION_AGE_TWO":
                      case 1:
                        message.selectedHorseAges[i] = 1;
                        break;
                      case "RACE_CONDITION_AGE_THREE":
                      case 2:
                        message.selectedHorseAges[i] = 2;
                        break;
                      case "RACE_CONDITION_AGE_THREE_PLUS":
                      case 3:
                        message.selectedHorseAges[i] = 3;
                        break;
                      case "RACE_CONDITION_AGE_FOUR_PLUS":
                      case 4:
                        message.selectedHorseAges[i] = 4;
                        break;
                      case "RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS":
                      case 5:
                        message.selectedHorseAges[i] = 5;
                        break;
                      case "RACE_CONDITION_AGE_FOUR":
                      case 6:
                        message.selectedHorseAges[i] = 6;
                        break;
                      case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE":
                      case 7:
                        message.selectedHorseAges[i] = 7;
                        break;
                      case "RACE_CONDITION_AGE_FOUR_OR_FIVE":
                      case 8:
                        message.selectedHorseAges[i] = 8;
                        break;
                      case "RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX":
                      case 9:
                        message.selectedHorseAges[i] = 9;
                        break;
                      case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX":
                      case 10:
                        message.selectedHorseAges[i] = 10;
                        break;
                    }
                }
                switch (object.selectedCourseSurface) {
                  case "COURSE_SURFACE_INVALID":
                  case 0:
                    message.selectedCourseSurface = 0;
                    break;
                  case "COURSE_SURFACE_ALL_WEATHER_TRACK":
                  case 1:
                    message.selectedCourseSurface = 1;
                    break;
                  case "COURSE_SURFACE_TURF":
                  case 2:
                    message.selectedCourseSurface = 2;
                    break;
                  case "COURSE_SURFACE_STEEPLECHASE":
                  case 3:
                    message.selectedCourseSurface = 3;
                    break;
                  case "COURSE_SURFACE_INNER_TRACK":
                  case 4:
                    message.selectedCourseSurface = 4;
                    break;
                  case "COURSE_SURFACE_OUTER_TURF":
                  case 5:
                    message.selectedCourseSurface = 5;
                    break;
                  case "COURSE_SURFACE_WOOD_CHIPS":
                  case 6:
                    message.selectedCourseSurface = 6;
                    break;
                  case "COURSE_SURFACE_HUNT_ON_TURF":
                  case 7:
                    message.selectedCourseSurface = 7;
                    break;
                  case "COURSE_SURFACE_TIMBER":
                  case 8:
                    message.selectedCourseSurface = 8;
                    break;
                  case "COURSE_SURFACE_DIRT":
                  case 9:
                    message.selectedCourseSurface = 9;
                    break;
                  case "COURSE_SURFACE_TURF_TRAINING":
                  case 10:
                    message.selectedCourseSurface = 10;
                    break;
                  case "COURSE_SURFACE_JUMP":
                  case 11:
                    message.selectedCourseSurface = 11;
                    break;
                  case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
                  case 12:
                    message.selectedCourseSurface = 12;
                    break;
                  case "COURSE_SURFACE_HUNT":
                  case 13:
                    message.selectedCourseSurface = 13;
                    break;
                  case "COURSE_SURFACE_DOWNHILL_TURF":
                  case 14:
                    message.selectedCourseSurface = 14;
                    break;
                  case "COURSE_SURFACE_DIRT_TRAINING":
                  case 15:
                    message.selectedCourseSurface = 15;
                    break;
                  case "COURSE_SURFACE_INNER_TURF":
                  case 16:
                    message.selectedCourseSurface = 16;
                    break;
                  case "COURSE_SURFACE_HURDLE":
                  case 17:
                    message.selectedCourseSurface = 17;
                    break;
                }
                if (object.selectedRaceDistanceIds) {
                  if (!Array.isArray(object.selectedRaceDistanceIds))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.selectedRaceDistanceIds: array expected"
                    );
                  message.selectedRaceDistanceIds = [];
                  for (
                    var i = 0;
                    i < object.selectedRaceDistanceIds.length;
                    ++i
                  )
                    message.selectedRaceDistanceIds[i] = String(
                      object.selectedRaceDistanceIds[i]
                    );
                }
                if (object.selectedRaceTypeIds) {
                  if (!Array.isArray(object.selectedRaceTypeIds))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.selectedRaceTypeIds: array expected"
                    );
                  message.selectedRaceTypeIds = [];
                  for (var i = 0; i < object.selectedRaceTypeIds.length; ++i)
                    message.selectedRaceTypeIds[i] = String(
                      object.selectedRaceTypeIds[i]
                    );
                }
                if (object.selectedClaimingPriceIds) {
                  if (!Array.isArray(object.selectedClaimingPriceIds))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest.selectedClaimingPriceIds: array expected"
                    );
                  message.selectedClaimingPriceIds = [];
                  for (
                    var i = 0;
                    i < object.selectedClaimingPriceIds.length;
                    ++i
                  )
                    message.selectedClaimingPriceIds[i] = String(
                      object.selectedClaimingPriceIds[i]
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from a PullHorsesCountGroupedByPreferredConditionsRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest} message PullHorsesCountGroupedByPreferredConditionsRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                  object.selectedHorseAges = [];
                  object.selectedRaceDistanceIds = [];
                  object.selectedRaceTypeIds = [];
                  object.selectedClaimingPriceIds = [];
                }
                if (options.defaults) {
                  object.areLastRacePreferredConditions = null;
                  object.minDaysSinceLastRace = 0;
                  object.maxDaysSinceLastRace = 0;
                  object.selectedHorseGender =
                    options.enums === String
                      ? "RACE_CONDITION_GENDER_INVALID"
                      : 0;
                  object.selectedCourseSurface =
                    options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
                }
                if (
                  message.areLastRacePreferredConditions != null &&
                  message.hasOwnProperty("areLastRacePreferredConditions")
                )
                  object.areLastRacePreferredConditions =
                    $root.google.protobuf.BoolValue.toObject(
                      message.areLastRacePreferredConditions,
                      options
                    );
                if (
                  message.minDaysSinceLastRace != null &&
                  message.hasOwnProperty("minDaysSinceLastRace")
                )
                  object.minDaysSinceLastRace = message.minDaysSinceLastRace;
                if (
                  message.maxDaysSinceLastRace != null &&
                  message.hasOwnProperty("maxDaysSinceLastRace")
                )
                  object.maxDaysSinceLastRace = message.maxDaysSinceLastRace;
                if (
                  message.selectedHorseGender != null &&
                  message.hasOwnProperty("selectedHorseGender")
                )
                  object.selectedHorseGender =
                    options.enums === String
                      ? $root.stronachgroup.first.racehorse360
                          .RaceConditionGender[message.selectedHorseGender]
                      : message.selectedHorseGender;
                if (
                  message.selectedHorseAges &&
                  message.selectedHorseAges.length
                ) {
                  object.selectedHorseAges = [];
                  for (var j = 0; j < message.selectedHorseAges.length; ++j)
                    object.selectedHorseAges[j] =
                      options.enums === String
                        ? $root.stronachgroup.first.racehorse360
                            .RaceConditionAge[message.selectedHorseAges[j]]
                        : message.selectedHorseAges[j];
                }
                if (
                  message.selectedCourseSurface != null &&
                  message.hasOwnProperty("selectedCourseSurface")
                )
                  object.selectedCourseSurface =
                    options.enums === String
                      ? $root.stronachgroup.first.racehorse360.CourseSurface[
                          message.selectedCourseSurface
                        ]
                      : message.selectedCourseSurface;
                if (
                  message.selectedRaceDistanceIds &&
                  message.selectedRaceDistanceIds.length
                ) {
                  object.selectedRaceDistanceIds = [];
                  for (
                    var j = 0;
                    j < message.selectedRaceDistanceIds.length;
                    ++j
                  )
                    object.selectedRaceDistanceIds[j] =
                      message.selectedRaceDistanceIds[j];
                }
                if (
                  message.selectedRaceTypeIds &&
                  message.selectedRaceTypeIds.length
                ) {
                  object.selectedRaceTypeIds = [];
                  for (var j = 0; j < message.selectedRaceTypeIds.length; ++j)
                    object.selectedRaceTypeIds[j] =
                      message.selectedRaceTypeIds[j];
                }
                if (
                  message.selectedClaimingPriceIds &&
                  message.selectedClaimingPriceIds.length
                ) {
                  object.selectedClaimingPriceIds = [];
                  for (
                    var j = 0;
                    j < message.selectedClaimingPriceIds.length;
                    ++j
                  )
                    object.selectedClaimingPriceIds[j] =
                      message.selectedClaimingPriceIds[j];
                }
                return object;
              };

            /**
             * Converts this PullHorsesCountGroupedByPreferredConditionsRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullHorsesCountGroupedByPreferredConditionsRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullHorsesCountGroupedByPreferredConditionsRequest;
          })();

        racehorse360.HorsesCountGroupedByPreferredCondition = (function () {
          /**
           * Properties of a HorsesCountGroupedByPreferredCondition.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorsesCountGroupedByPreferredCondition
           * @property {number|null} [count] HorsesCountGroupedByPreferredCondition count
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] HorsesCountGroupedByPreferredCondition surface
           * @property {string|null} [distance] HorsesCountGroupedByPreferredCondition distance
           * @property {string|null} [raceType] HorsesCountGroupedByPreferredCondition raceType
           * @property {string|null} [claimingPrice] HorsesCountGroupedByPreferredCondition claimingPrice
           * @property {string|null} [gender] HorsesCountGroupedByPreferredCondition gender
           * @property {string|null} [age] HorsesCountGroupedByPreferredCondition age
           * @property {number|null} [stateBred] HorsesCountGroupedByPreferredCondition stateBred
           * @property {Array.<string>|null} [horseIds] HorsesCountGroupedByPreferredCondition horseIds
           * @property {number|null} [distanceInFurlongs] HorsesCountGroupedByPreferredCondition distanceInFurlongs
           */

          /**
           * Constructs a new HorsesCountGroupedByPreferredCondition.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorsesCountGroupedByPreferredCondition.
           * @implements IHorsesCountGroupedByPreferredCondition
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorsesCountGroupedByPreferredCondition=} [properties] Properties to set
           */
          function HorsesCountGroupedByPreferredCondition(properties) {
            this.horseIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorsesCountGroupedByPreferredCondition count.
           * @member {number} count
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.count = 0;

          /**
           * HorsesCountGroupedByPreferredCondition surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.surface = 0;

          /**
           * HorsesCountGroupedByPreferredCondition distance.
           * @member {string} distance
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.distance = "";

          /**
           * HorsesCountGroupedByPreferredCondition raceType.
           * @member {string} raceType
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.raceType = "";

          /**
           * HorsesCountGroupedByPreferredCondition claimingPrice.
           * @member {string} claimingPrice
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.claimingPrice = "";

          /**
           * HorsesCountGroupedByPreferredCondition gender.
           * @member {string} gender
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.gender = "";

          /**
           * HorsesCountGroupedByPreferredCondition age.
           * @member {string} age
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.age = "";

          /**
           * HorsesCountGroupedByPreferredCondition stateBred.
           * @member {number} stateBred
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.stateBred = 0;

          /**
           * HorsesCountGroupedByPreferredCondition horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.horseIds =
            $util.emptyArray;

          /**
           * HorsesCountGroupedByPreferredCondition distanceInFurlongs.
           * @member {number} distanceInFurlongs
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           */
          HorsesCountGroupedByPreferredCondition.prototype.distanceInFurlongs = 0;

          /**
           * Creates a new HorsesCountGroupedByPreferredCondition instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesCountGroupedByPreferredCondition=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition} HorsesCountGroupedByPreferredCondition instance
           */
          HorsesCountGroupedByPreferredCondition.create = function create(
            properties
          ) {
            return new HorsesCountGroupedByPreferredCondition(properties);
          };

          /**
           * Encodes the specified HorsesCountGroupedByPreferredCondition message. Does not implicitly {@link stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesCountGroupedByPreferredCondition} message HorsesCountGroupedByPreferredCondition message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorsesCountGroupedByPreferredCondition.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.count != null &&
              Object.hasOwnProperty.call(message, "count")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.count);
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.surface);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.distance);
            if (
              message.raceType != null &&
              Object.hasOwnProperty.call(message, "raceType")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.raceType);
            if (
              message.claimingPrice != null &&
              Object.hasOwnProperty.call(message, "claimingPrice")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.claimingPrice);
            if (
              message.gender != null &&
              Object.hasOwnProperty.call(message, "gender")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.gender);
            if (
              message.age != null &&
              Object.hasOwnProperty.call(message, "age")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.age);
            if (
              message.stateBred != null &&
              Object.hasOwnProperty.call(message, "stateBred")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.stateBred);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 9, wireType 2 =*/ 74)
                  .string(message.horseIds[i]);
            if (
              message.distanceInFurlongs != null &&
              Object.hasOwnProperty.call(message, "distanceInFurlongs")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.distanceInFurlongs);
            return writer;
          };

          /**
           * Decodes a HorsesCountGroupedByPreferredCondition message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition} HorsesCountGroupedByPreferredCondition
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorsesCountGroupedByPreferredCondition.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.count = reader.int32();
                  break;
                case 2:
                  message.surface = reader.int32();
                  break;
                case 3:
                  message.distance = reader.string();
                  break;
                case 4:
                  message.raceType = reader.string();
                  break;
                case 5:
                  message.claimingPrice = reader.string();
                  break;
                case 6:
                  message.gender = reader.string();
                  break;
                case 7:
                  message.age = reader.string();
                  break;
                case 8:
                  message.stateBred = reader.int32();
                  break;
                case 9:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 10:
                  message.distanceInFurlongs = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorsesCountGroupedByPreferredCondition message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition} HorsesCountGroupedByPreferredCondition
           */
          HorsesCountGroupedByPreferredCondition.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .HorsesCountGroupedByPreferredCondition
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition();
              if (object.count != null) message.count = object.count | 0;
              switch (object.surface) {
                case "COURSE_SURFACE_INVALID":
                case 0:
                  message.surface = 0;
                  break;
                case "COURSE_SURFACE_ALL_WEATHER_TRACK":
                case 1:
                  message.surface = 1;
                  break;
                case "COURSE_SURFACE_TURF":
                case 2:
                  message.surface = 2;
                  break;
                case "COURSE_SURFACE_STEEPLECHASE":
                case 3:
                  message.surface = 3;
                  break;
                case "COURSE_SURFACE_INNER_TRACK":
                case 4:
                  message.surface = 4;
                  break;
                case "COURSE_SURFACE_OUTER_TURF":
                case 5:
                  message.surface = 5;
                  break;
                case "COURSE_SURFACE_WOOD_CHIPS":
                case 6:
                  message.surface = 6;
                  break;
                case "COURSE_SURFACE_HUNT_ON_TURF":
                case 7:
                  message.surface = 7;
                  break;
                case "COURSE_SURFACE_TIMBER":
                case 8:
                  message.surface = 8;
                  break;
                case "COURSE_SURFACE_DIRT":
                case 9:
                  message.surface = 9;
                  break;
                case "COURSE_SURFACE_TURF_TRAINING":
                case 10:
                  message.surface = 10;
                  break;
                case "COURSE_SURFACE_JUMP":
                case 11:
                  message.surface = 11;
                  break;
                case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
                case 12:
                  message.surface = 12;
                  break;
                case "COURSE_SURFACE_HUNT":
                case 13:
                  message.surface = 13;
                  break;
                case "COURSE_SURFACE_DOWNHILL_TURF":
                case 14:
                  message.surface = 14;
                  break;
                case "COURSE_SURFACE_DIRT_TRAINING":
                case 15:
                  message.surface = 15;
                  break;
                case "COURSE_SURFACE_INNER_TURF":
                case 16:
                  message.surface = 16;
                  break;
                case "COURSE_SURFACE_HURDLE":
                case 17:
                  message.surface = 17;
                  break;
              }
              if (object.distance != null)
                message.distance = String(object.distance);
              if (object.raceType != null)
                message.raceType = String(object.raceType);
              if (object.claimingPrice != null)
                message.claimingPrice = String(object.claimingPrice);
              if (object.gender != null) message.gender = String(object.gender);
              if (object.age != null) message.age = String(object.age);
              if (object.stateBred != null)
                message.stateBred = object.stateBred | 0;
              if (object.horseIds) {
                if (!Array.isArray(object.horseIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.horseIds: array expected"
                  );
                message.horseIds = [];
                for (var i = 0; i < object.horseIds.length; ++i)
                  message.horseIds[i] = String(object.horseIds[i]);
              }
              if (object.distanceInFurlongs != null)
                message.distanceInFurlongs = object.distanceInFurlongs | 0;
              return message;
            };

          /**
           * Creates a plain object from a HorsesCountGroupedByPreferredCondition message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @static
           * @param {stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition} message HorsesCountGroupedByPreferredCondition
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorsesCountGroupedByPreferredCondition.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horseIds = [];
            if (options.defaults) {
              object.count = 0;
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.distance = "";
              object.raceType = "";
              object.claimingPrice = "";
              object.gender = "";
              object.age = "";
              object.stateBred = 0;
              object.distanceInFurlongs = 0;
            }
            if (message.count != null && message.hasOwnProperty("count"))
              object.count = message.count;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (message.raceType != null && message.hasOwnProperty("raceType"))
              object.raceType = message.raceType;
            if (
              message.claimingPrice != null &&
              message.hasOwnProperty("claimingPrice")
            )
              object.claimingPrice = message.claimingPrice;
            if (message.gender != null && message.hasOwnProperty("gender"))
              object.gender = message.gender;
            if (message.age != null && message.hasOwnProperty("age"))
              object.age = message.age;
            if (
              message.stateBred != null &&
              message.hasOwnProperty("stateBred")
            )
              object.stateBred = message.stateBred;
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (
              message.distanceInFurlongs != null &&
              message.hasOwnProperty("distanceInFurlongs")
            )
              object.distanceInFurlongs = message.distanceInFurlongs;
            return object;
          };

          /**
           * Converts this HorsesCountGroupedByPreferredCondition to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorsesCountGroupedByPreferredCondition.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return HorsesCountGroupedByPreferredCondition;
        })();

        racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse =
          (function () {
            /**
             * Properties of a PullHorsesCountGroupedByPreferredConditionsResponse.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullHorsesCountGroupedByPreferredConditionsResponse
             * @property {Array.<stronachgroup.first.racehorse360.IHorsesCountGroupedByPreferredCondition>|null} [horsesCountGroupedByPreferredConditions] PullHorsesCountGroupedByPreferredConditionsResponse horsesCountGroupedByPreferredConditions
             * @property {number|null} [totalUniqueHorsesCount] PullHorsesCountGroupedByPreferredConditionsResponse totalUniqueHorsesCount
             */

            /**
             * Constructs a new PullHorsesCountGroupedByPreferredConditionsResponse.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullHorsesCountGroupedByPreferredConditionsResponse.
             * @implements IPullHorsesCountGroupedByPreferredConditionsResponse
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsResponse=} [properties] Properties to set
             */
            function PullHorsesCountGroupedByPreferredConditionsResponse(
              properties
            ) {
              this.horsesCountGroupedByPreferredConditions = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullHorsesCountGroupedByPreferredConditionsResponse horsesCountGroupedByPreferredConditions.
             * @member {Array.<stronachgroup.first.racehorse360.IHorsesCountGroupedByPreferredCondition>} horsesCountGroupedByPreferredConditions
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.prototype.horsesCountGroupedByPreferredConditions =
              $util.emptyArray;

            /**
             * PullHorsesCountGroupedByPreferredConditionsResponse totalUniqueHorsesCount.
             * @member {number} totalUniqueHorsesCount
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @instance
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.prototype.totalUniqueHorsesCount = 0;

            /**
             * Creates a new PullHorsesCountGroupedByPreferredConditionsResponse instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsResponse=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse} PullHorsesCountGroupedByPreferredConditionsResponse instance
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.create =
              function create(properties) {
                return new PullHorsesCountGroupedByPreferredConditionsResponse(
                  properties
                );
              };

            /**
             * Encodes the specified PullHorsesCountGroupedByPreferredConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsResponse} message PullHorsesCountGroupedByPreferredConditionsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.horsesCountGroupedByPreferredConditions != null &&
                  message.horsesCountGroupedByPreferredConditions.length
                )
                  for (
                    var i = 0;
                    i < message.horsesCountGroupedByPreferredConditions.length;
                    ++i
                  )
                    $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.encode(
                      message.horsesCountGroupedByPreferredConditions[i],
                      writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                    ).ldelim();
                if (
                  message.totalUniqueHorsesCount != null &&
                  Object.hasOwnProperty.call(message, "totalUniqueHorsesCount")
                )
                  writer
                    .uint32(/* id 2, wireType 0 =*/ 16)
                    .int32(message.totalUniqueHorsesCount);
                return writer;
              };

            /**
             * Decodes a PullHorsesCountGroupedByPreferredConditionsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse} PullHorsesCountGroupedByPreferredConditionsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (
                        !(
                          message.horsesCountGroupedByPreferredConditions &&
                          message.horsesCountGroupedByPreferredConditions.length
                        )
                      )
                        message.horsesCountGroupedByPreferredConditions = [];
                      message.horsesCountGroupedByPreferredConditions.push(
                        $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.decode(
                          reader,
                          reader.uint32()
                        )
                      );
                      break;
                    case 2:
                      message.totalUniqueHorsesCount = reader.int32();
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullHorsesCountGroupedByPreferredConditionsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse} PullHorsesCountGroupedByPreferredConditionsResponse
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountGroupedByPreferredConditionsResponse
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse();
                if (object.horsesCountGroupedByPreferredConditions) {
                  if (
                    !Array.isArray(
                      object.horsesCountGroupedByPreferredConditions
                    )
                  )
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse.horsesCountGroupedByPreferredConditions: array expected"
                    );
                  message.horsesCountGroupedByPreferredConditions = [];
                  for (
                    var i = 0;
                    i < object.horsesCountGroupedByPreferredConditions.length;
                    ++i
                  ) {
                    if (
                      typeof object.horsesCountGroupedByPreferredConditions[
                        i
                      ] !== "object"
                    )
                      throw TypeError(
                        ".stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse.horsesCountGroupedByPreferredConditions: object expected"
                      );
                    message.horsesCountGroupedByPreferredConditions[i] =
                      $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.fromObject(
                        object.horsesCountGroupedByPreferredConditions[i]
                      );
                  }
                }
                if (object.totalUniqueHorsesCount != null)
                  message.totalUniqueHorsesCount =
                    object.totalUniqueHorsesCount | 0;
                return message;
              };

            /**
             * Creates a plain object from a PullHorsesCountGroupedByPreferredConditionsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse} message PullHorsesCountGroupedByPreferredConditionsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults)
                  object.horsesCountGroupedByPreferredConditions = [];
                if (options.defaults) object.totalUniqueHorsesCount = 0;
                if (
                  message.horsesCountGroupedByPreferredConditions &&
                  message.horsesCountGroupedByPreferredConditions.length
                ) {
                  object.horsesCountGroupedByPreferredConditions = [];
                  for (
                    var j = 0;
                    j < message.horsesCountGroupedByPreferredConditions.length;
                    ++j
                  )
                    object.horsesCountGroupedByPreferredConditions[j] =
                      $root.stronachgroup.first.racehorse360.HorsesCountGroupedByPreferredCondition.toObject(
                        message.horsesCountGroupedByPreferredConditions[j],
                        options
                      );
                }
                if (
                  message.totalUniqueHorsesCount != null &&
                  message.hasOwnProperty("totalUniqueHorsesCount")
                )
                  object.totalUniqueHorsesCount =
                    message.totalUniqueHorsesCount;
                return object;
              };

            /**
             * Converts this PullHorsesCountGroupedByPreferredConditionsResponse to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullHorsesCountGroupedByPreferredConditionsResponse.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullHorsesCountGroupedByPreferredConditionsResponse;
          })();

        racehorse360.HorseAggregatedComment = (function () {
          /**
           * Properties of a HorseAggregatedComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseAggregatedComment
           * @property {string|null} [id] HorseAggregatedComment id
           * @property {stronachgroup.first.racehorse360.CommentSourceKind|null} [commentSourceKind] HorseAggregatedComment commentSourceKind
           * @property {stronachgroup.first.racehorse360.EventType|null} [eventType] HorseAggregatedComment eventType
           * @property {string|null} [eventDate] HorseAggregatedComment eventDate
           * @property {string|null} [body] HorseAggregatedComment body
           * @property {stronachgroup.first.racehorse360.HorseAggregatedCommentIconType|null} [horseAggregatedCommentIconType] HorseAggregatedComment horseAggregatedCommentIconType
           * @property {boolean|null} [isRead] HorseAggregatedComment isRead
           * @property {string|null} [commenterFirstName] HorseAggregatedComment commenterFirstName
           * @property {string|null} [commenterLastName] HorseAggregatedComment commenterLastName
           * @property {string|null} [commenterId] HorseAggregatedComment commenterId
           * @property {string|null} [warningMessage] HorseAggregatedComment warningMessage
           * @property {string|null} [createdOn] HorseAggregatedComment createdOn
           * @property {string|null} [updatedOn] HorseAggregatedComment updatedOn
           */

          /**
           * Constructs a new HorseAggregatedComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseAggregatedComment.
           * @implements IHorseAggregatedComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedComment=} [properties] Properties to set
           */
          function HorseAggregatedComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseAggregatedComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.id = "";

          /**
           * HorseAggregatedComment commentSourceKind.
           * @member {stronachgroup.first.racehorse360.CommentSourceKind} commentSourceKind
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.commentSourceKind = 0;

          /**
           * HorseAggregatedComment eventType.
           * @member {stronachgroup.first.racehorse360.EventType} eventType
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.eventType = 0;

          /**
           * HorseAggregatedComment eventDate.
           * @member {string} eventDate
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.eventDate = "";

          /**
           * HorseAggregatedComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.body = "";

          /**
           * HorseAggregatedComment horseAggregatedCommentIconType.
           * @member {stronachgroup.first.racehorse360.HorseAggregatedCommentIconType} horseAggregatedCommentIconType
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.horseAggregatedCommentIconType = 0;

          /**
           * HorseAggregatedComment isRead.
           * @member {boolean} isRead
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.isRead = false;

          /**
           * HorseAggregatedComment commenterFirstName.
           * @member {string} commenterFirstName
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.commenterFirstName = "";

          /**
           * HorseAggregatedComment commenterLastName.
           * @member {string} commenterLastName
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.commenterLastName = "";

          /**
           * HorseAggregatedComment commenterId.
           * @member {string} commenterId
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.commenterId = "";

          /**
           * HorseAggregatedComment warningMessage.
           * @member {string} warningMessage
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.warningMessage = "";

          /**
           * HorseAggregatedComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.createdOn = "";

          /**
           * HorseAggregatedComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           */
          HorseAggregatedComment.prototype.updatedOn = "";

          /**
           * Creates a new HorseAggregatedComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedComment} HorseAggregatedComment instance
           */
          HorseAggregatedComment.create = function create(properties) {
            return new HorseAggregatedComment(properties);
          };

          /**
           * Encodes the specified HorseAggregatedComment message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseAggregatedComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedComment} message HorseAggregatedComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseAggregatedComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.commentSourceKind != null &&
              Object.hasOwnProperty.call(message, "commentSourceKind")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.commentSourceKind);
            if (
              message.eventType != null &&
              Object.hasOwnProperty.call(message, "eventType")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.eventType);
            if (
              message.eventDate != null &&
              Object.hasOwnProperty.call(message, "eventDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.eventDate);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.body);
            if (
              message.horseAggregatedCommentIconType != null &&
              Object.hasOwnProperty.call(
                message,
                "horseAggregatedCommentIconType"
              )
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.horseAggregatedCommentIconType);
            if (
              message.isRead != null &&
              Object.hasOwnProperty.call(message, "isRead")
            )
              writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.isRead);
            if (
              message.commenterFirstName != null &&
              Object.hasOwnProperty.call(message, "commenterFirstName")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.commenterFirstName);
            if (
              message.commenterLastName != null &&
              Object.hasOwnProperty.call(message, "commenterLastName")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.commenterLastName);
            if (
              message.commenterId != null &&
              Object.hasOwnProperty.call(message, "commenterId")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.commenterId);
            if (
              message.warningMessage != null &&
              Object.hasOwnProperty.call(message, "warningMessage")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.warningMessage);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            return writer;
          };

          /**
           * Decodes a HorseAggregatedComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedComment} HorseAggregatedComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseAggregatedComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseAggregatedComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.commentSourceKind = reader.int32();
                  break;
                case 3:
                  message.eventType = reader.int32();
                  break;
                case 4:
                  message.eventDate = reader.string();
                  break;
                case 5:
                  message.body = reader.string();
                  break;
                case 6:
                  message.horseAggregatedCommentIconType = reader.int32();
                  break;
                case 7:
                  message.isRead = reader.bool();
                  break;
                case 8:
                  message.commenterFirstName = reader.string();
                  break;
                case 9:
                  message.commenterLastName = reader.string();
                  break;
                case 10:
                  message.commenterId = reader.string();
                  break;
                case 11:
                  message.warningMessage = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseAggregatedComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedComment} HorseAggregatedComment
           */
          HorseAggregatedComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseAggregatedComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseAggregatedComment();
            if (object.id != null) message.id = String(object.id);
            switch (object.commentSourceKind) {
              case "COMMENT_SOURCE_KIND_INVALID":
              case 0:
                message.commentSourceKind = 0;
                break;
              case "COMMENT_SOURCE_KIND_HORSE_GENERAL_VET_COMMENT":
              case 1:
                message.commentSourceKind = 1;
                break;
              case "COMMENT_SOURCE_KIND_HORSE_EXAM_COMMENT":
              case 2:
                message.commentSourceKind = 2;
                break;
              case "COMMENT_SOURCE_KIND_WORKOUT_REQUEST_COMMENT":
              case 3:
                message.commentSourceKind = 3;
                break;
              case "COMMENT_SOURCE_KIND_HORSE_FLAG_ON_TRACK":
              case 4:
                message.commentSourceKind = 4;
                break;
            }
            switch (object.eventType) {
              case "EVENT_TYPE_INVALID":
              case 0:
                message.eventType = 0;
                break;
              case "EVENT_TYPE_WORKOUT_REQUEST":
              case 1:
                message.eventType = 1;
                break;
              case "EVENT_TYPE_HORSE_EXAM":
              case 2:
                message.eventType = 2;
                break;
              case "EVENT_TYPE_HORSE_GENERAL_VET_COMMENT":
              case 3:
                message.eventType = 3;
                break;
              case "EVENT_TYPE_HORSE_FLAG_ON_TRACK":
              case 4:
                message.eventType = 4;
                break;
            }
            if (object.eventDate != null)
              message.eventDate = String(object.eventDate);
            if (object.body != null) message.body = String(object.body);
            switch (object.horseAggregatedCommentIconType) {
              case "HORSE_AGGREGATED_COMMENT_ICON_TYPE_INVALID":
              case 0:
                message.horseAggregatedCommentIconType = 0;
                break;
              case "HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL":
              case 1:
                message.horseAggregatedCommentIconType = 1;
                break;
              case "HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN":
              case 2:
                message.horseAggregatedCommentIconType = 2;
                break;
              case "HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER":
              case 3:
                message.horseAggregatedCommentIconType = 3;
                break;
            }
            if (object.isRead != null) message.isRead = Boolean(object.isRead);
            if (object.commenterFirstName != null)
              message.commenterFirstName = String(object.commenterFirstName);
            if (object.commenterLastName != null)
              message.commenterLastName = String(object.commenterLastName);
            if (object.commenterId != null)
              message.commenterId = String(object.commenterId);
            if (object.warningMessage != null)
              message.warningMessage = String(object.warningMessage);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            return message;
          };

          /**
           * Creates a plain object from a HorseAggregatedComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @static
           * @param {stronachgroup.first.racehorse360.HorseAggregatedComment} message HorseAggregatedComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseAggregatedComment.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.commentSourceKind =
                options.enums === String ? "COMMENT_SOURCE_KIND_INVALID" : 0;
              object.eventType =
                options.enums === String ? "EVENT_TYPE_INVALID" : 0;
              object.eventDate = "";
              object.body = "";
              object.horseAggregatedCommentIconType =
                options.enums === String
                  ? "HORSE_AGGREGATED_COMMENT_ICON_TYPE_INVALID"
                  : 0;
              object.isRead = false;
              object.commenterFirstName = "";
              object.commenterLastName = "";
              object.commenterId = "";
              object.warningMessage = "";
              object.createdOn = "";
              object.updatedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.commentSourceKind != null &&
              message.hasOwnProperty("commentSourceKind")
            )
              object.commentSourceKind =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CommentSourceKind[
                      message.commentSourceKind
                    ]
                  : message.commentSourceKind;
            if (
              message.eventType != null &&
              message.hasOwnProperty("eventType")
            )
              object.eventType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.EventType[
                      message.eventType
                    ]
                  : message.eventType;
            if (
              message.eventDate != null &&
              message.hasOwnProperty("eventDate")
            )
              object.eventDate = message.eventDate;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.horseAggregatedCommentIconType != null &&
              message.hasOwnProperty("horseAggregatedCommentIconType")
            )
              object.horseAggregatedCommentIconType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .HorseAggregatedCommentIconType[
                      message.horseAggregatedCommentIconType
                    ]
                  : message.horseAggregatedCommentIconType;
            if (message.isRead != null && message.hasOwnProperty("isRead"))
              object.isRead = message.isRead;
            if (
              message.commenterFirstName != null &&
              message.hasOwnProperty("commenterFirstName")
            )
              object.commenterFirstName = message.commenterFirstName;
            if (
              message.commenterLastName != null &&
              message.hasOwnProperty("commenterLastName")
            )
              object.commenterLastName = message.commenterLastName;
            if (
              message.commenterId != null &&
              message.hasOwnProperty("commenterId")
            )
              object.commenterId = message.commenterId;
            if (
              message.warningMessage != null &&
              message.hasOwnProperty("warningMessage")
            )
              object.warningMessage = message.warningMessage;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            return object;
          };

          /**
           * Converts this HorseAggregatedComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseAggregatedComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseAggregatedComment;
        })();

        racehorse360.HorseAggregatedCommentFilter = (function () {
          /**
           * Properties of a HorseAggregatedCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseAggregatedCommentFilter
           * @property {string|null} [horseId] HorseAggregatedCommentFilter horseId
           */

          /**
           * Constructs a new HorseAggregatedCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseAggregatedCommentFilter.
           * @implements IHorseAggregatedCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedCommentFilter=} [properties] Properties to set
           */
          function HorseAggregatedCommentFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseAggregatedCommentFilter horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @instance
           */
          HorseAggregatedCommentFilter.prototype.horseId = "";

          /**
           * Creates a new HorseAggregatedCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedCommentFilter} HorseAggregatedCommentFilter instance
           */
          HorseAggregatedCommentFilter.create = function create(properties) {
            return new HorseAggregatedCommentFilter(properties);
          };

          /**
           * Encodes the specified HorseAggregatedCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseAggregatedCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseAggregatedCommentFilter} message HorseAggregatedCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseAggregatedCommentFilter.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            return writer;
          };

          /**
           * Decodes a HorseAggregatedCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedCommentFilter} HorseAggregatedCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseAggregatedCommentFilter.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseAggregatedCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseAggregatedCommentFilter} HorseAggregatedCommentFilter
           */
          HorseAggregatedCommentFilter.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .HorseAggregatedCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            return message;
          };

          /**
           * Creates a plain object from a HorseAggregatedCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseAggregatedCommentFilter} message HorseAggregatedCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseAggregatedCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.horseId = "";
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            return object;
          };

          /**
           * Converts this HorseAggregatedCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseAggregatedCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseAggregatedCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseAggregatedCommentFilter;
        })();

        racehorse360.PullHorseAggregatedCommentsRequest = (function () {
          /**
           * Properties of a PullHorseAggregatedCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseAggregatedCommentsRequest
           * @property {stronachgroup.first.racehorse360.IHorseAggregatedCommentFilter|null} [query] PullHorseAggregatedCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] PullHorseAggregatedCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] PullHorseAggregatedCommentsRequest pagingOptions
           */

          /**
           * Constructs a new PullHorseAggregatedCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseAggregatedCommentsRequest.
           * @implements IPullHorseAggregatedCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsRequest=} [properties] Properties to set
           */
          function PullHorseAggregatedCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorseAggregatedCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseAggregatedCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @instance
           */
          PullHorseAggregatedCommentsRequest.prototype.query = null;

          /**
           * PullHorseAggregatedCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @instance
           */
          PullHorseAggregatedCommentsRequest.prototype.getOptions = null;

          /**
           * PullHorseAggregatedCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @instance
           */
          PullHorseAggregatedCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new PullHorseAggregatedCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} PullHorseAggregatedCommentsRequest instance
           */
          PullHorseAggregatedCommentsRequest.create = function create(
            properties
          ) {
            return new PullHorseAggregatedCommentsRequest(properties);
          };

          /**
           * Encodes the specified PullHorseAggregatedCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsRequest} message PullHorseAggregatedCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseAggregatedCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorseAggregatedCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} PullHorseAggregatedCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseAggregatedCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseAggregatedCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} PullHorseAggregatedCommentsRequest
           */
          PullHorseAggregatedCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorseAggregatedCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorseAggregatedCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest} message PullHorseAggregatedCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseAggregatedCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseAggregatedCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorseAggregatedCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseAggregatedCommentsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorseAggregatedCommentsRequest;
        })();

        racehorse360.PullHorseAggregatedCommentsResponse = (function () {
          /**
           * Properties of a PullHorseAggregatedCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseAggregatedCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseAggregatedComment>|null} [horseAggregatedComments] PullHorseAggregatedCommentsResponse horseAggregatedComments
           * @property {number|null} [unreadCount] PullHorseAggregatedCommentsResponse unreadCount
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] PullHorseAggregatedCommentsResponse pagingInfo
           */

          /**
           * Constructs a new PullHorseAggregatedCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseAggregatedCommentsResponse.
           * @implements IPullHorseAggregatedCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsResponse=} [properties] Properties to set
           */
          function PullHorseAggregatedCommentsResponse(properties) {
            this.horseAggregatedComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorseAggregatedCommentsResponse horseAggregatedComments.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseAggregatedComment>} horseAggregatedComments
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @instance
           */
          PullHorseAggregatedCommentsResponse.prototype.horseAggregatedComments =
            $util.emptyArray;

          /**
           * PullHorseAggregatedCommentsResponse unreadCount.
           * @member {number} unreadCount
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @instance
           */
          PullHorseAggregatedCommentsResponse.prototype.unreadCount = 0;

          /**
           * PullHorseAggregatedCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @instance
           */
          PullHorseAggregatedCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new PullHorseAggregatedCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse} PullHorseAggregatedCommentsResponse instance
           */
          PullHorseAggregatedCommentsResponse.create = function create(
            properties
          ) {
            return new PullHorseAggregatedCommentsResponse(properties);
          };

          /**
           * Encodes the specified PullHorseAggregatedCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsResponse} message PullHorseAggregatedCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseAggregatedCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseAggregatedComments != null &&
              message.horseAggregatedComments.length
            )
              for (var i = 0; i < message.horseAggregatedComments.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseAggregatedComment.encode(
                  message.horseAggregatedComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.unreadCount != null &&
              Object.hasOwnProperty.call(message, "unreadCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.unreadCount);
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorseAggregatedCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse} PullHorseAggregatedCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseAggregatedCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseAggregatedComments &&
                      message.horseAggregatedComments.length
                    )
                  )
                    message.horseAggregatedComments = [];
                  message.horseAggregatedComments.push(
                    $root.stronachgroup.first.racehorse360.HorseAggregatedComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 2:
                  message.unreadCount = reader.int32();
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseAggregatedCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse} PullHorseAggregatedCommentsResponse
           */
          PullHorseAggregatedCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorseAggregatedCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse();
            if (object.horseAggregatedComments) {
              if (!Array.isArray(object.horseAggregatedComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse.horseAggregatedComments: array expected"
                );
              message.horseAggregatedComments = [];
              for (var i = 0; i < object.horseAggregatedComments.length; ++i) {
                if (typeof object.horseAggregatedComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse.horseAggregatedComments: object expected"
                  );
                message.horseAggregatedComments[i] =
                  $root.stronachgroup.first.racehorse360.HorseAggregatedComment.fromObject(
                    object.horseAggregatedComments[i]
                  );
              }
            }
            if (object.unreadCount != null)
              message.unreadCount = object.unreadCount | 0;
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorseAggregatedCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse} message PullHorseAggregatedCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseAggregatedCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseAggregatedComments = [];
            if (options.defaults) {
              object.unreadCount = 0;
              object.pagingInfo = null;
            }
            if (
              message.horseAggregatedComments &&
              message.horseAggregatedComments.length
            ) {
              object.horseAggregatedComments = [];
              for (var j = 0; j < message.horseAggregatedComments.length; ++j)
                object.horseAggregatedComments[j] =
                  $root.stronachgroup.first.racehorse360.HorseAggregatedComment.toObject(
                    message.horseAggregatedComments[j],
                    options
                  );
            }
            if (
              message.unreadCount != null &&
              message.hasOwnProperty("unreadCount")
            )
              object.unreadCount = message.unreadCount;
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorseAggregatedCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseAggregatedCommentsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorseAggregatedCommentsResponse;
        })();

        racehorse360.MarkHorseAggregatedCommentsAsReadRequest = (function () {
          /**
           * Properties of a MarkHorseAggregatedCommentsAsReadRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMarkHorseAggregatedCommentsAsReadRequest
           * @property {Array.<string>|null} [workoutRequestCommentIds] MarkHorseAggregatedCommentsAsReadRequest workoutRequestCommentIds
           * @property {Array.<string>|null} [horseExamCommentIds] MarkHorseAggregatedCommentsAsReadRequest horseExamCommentIds
           * @property {string|null} [horseId] MarkHorseAggregatedCommentsAsReadRequest horseId
           * @property {boolean|null} [markAllAsRead] MarkHorseAggregatedCommentsAsReadRequest markAllAsRead
           */

          /**
           * Constructs a new MarkHorseAggregatedCommentsAsReadRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a MarkHorseAggregatedCommentsAsReadRequest.
           * @implements IMarkHorseAggregatedCommentsAsReadRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMarkHorseAggregatedCommentsAsReadRequest=} [properties] Properties to set
           */
          function MarkHorseAggregatedCommentsAsReadRequest(properties) {
            this.workoutRequestCommentIds = [];
            this.horseExamCommentIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * MarkHorseAggregatedCommentsAsReadRequest workoutRequestCommentIds.
           * @member {Array.<string>} workoutRequestCommentIds
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @instance
           */
          MarkHorseAggregatedCommentsAsReadRequest.prototype.workoutRequestCommentIds =
            $util.emptyArray;

          /**
           * MarkHorseAggregatedCommentsAsReadRequest horseExamCommentIds.
           * @member {Array.<string>} horseExamCommentIds
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @instance
           */
          MarkHorseAggregatedCommentsAsReadRequest.prototype.horseExamCommentIds =
            $util.emptyArray;

          /**
           * MarkHorseAggregatedCommentsAsReadRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @instance
           */
          MarkHorseAggregatedCommentsAsReadRequest.prototype.horseId = "";

          /**
           * MarkHorseAggregatedCommentsAsReadRequest markAllAsRead.
           * @member {boolean} markAllAsRead
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @instance
           */
          MarkHorseAggregatedCommentsAsReadRequest.prototype.markAllAsRead = false;

          /**
           * Creates a new MarkHorseAggregatedCommentsAsReadRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMarkHorseAggregatedCommentsAsReadRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} MarkHorseAggregatedCommentsAsReadRequest instance
           */
          MarkHorseAggregatedCommentsAsReadRequest.create = function create(
            properties
          ) {
            return new MarkHorseAggregatedCommentsAsReadRequest(properties);
          };

          /**
           * Encodes the specified MarkHorseAggregatedCommentsAsReadRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMarkHorseAggregatedCommentsAsReadRequest} message MarkHorseAggregatedCommentsAsReadRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          MarkHorseAggregatedCommentsAsReadRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.workoutRequestCommentIds != null &&
              message.workoutRequestCommentIds.length
            )
              for (var i = 0; i < message.workoutRequestCommentIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.workoutRequestCommentIds[i]);
            if (
              message.horseExamCommentIds != null &&
              message.horseExamCommentIds.length
            )
              for (var i = 0; i < message.horseExamCommentIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseExamCommentIds[i]);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.horseId);
            if (
              message.markAllAsRead != null &&
              Object.hasOwnProperty.call(message, "markAllAsRead")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.markAllAsRead);
            return writer;
          };

          /**
           * Decodes a MarkHorseAggregatedCommentsAsReadRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} MarkHorseAggregatedCommentsAsReadRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          MarkHorseAggregatedCommentsAsReadRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.workoutRequestCommentIds &&
                      message.workoutRequestCommentIds.length
                    )
                  )
                    message.workoutRequestCommentIds = [];
                  message.workoutRequestCommentIds.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.horseExamCommentIds &&
                      message.horseExamCommentIds.length
                    )
                  )
                    message.horseExamCommentIds = [];
                  message.horseExamCommentIds.push(reader.string());
                  break;
                case 3:
                  message.horseId = reader.string();
                  break;
                case 4:
                  message.markAllAsRead = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a MarkHorseAggregatedCommentsAsReadRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} MarkHorseAggregatedCommentsAsReadRequest
           */
          MarkHorseAggregatedCommentsAsReadRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .MarkHorseAggregatedCommentsAsReadRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest();
              if (object.workoutRequestCommentIds) {
                if (!Array.isArray(object.workoutRequestCommentIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest.workoutRequestCommentIds: array expected"
                  );
                message.workoutRequestCommentIds = [];
                for (var i = 0; i < object.workoutRequestCommentIds.length; ++i)
                  message.workoutRequestCommentIds[i] = String(
                    object.workoutRequestCommentIds[i]
                  );
              }
              if (object.horseExamCommentIds) {
                if (!Array.isArray(object.horseExamCommentIds))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest.horseExamCommentIds: array expected"
                  );
                message.horseExamCommentIds = [];
                for (var i = 0; i < object.horseExamCommentIds.length; ++i)
                  message.horseExamCommentIds[i] = String(
                    object.horseExamCommentIds[i]
                  );
              }
              if (object.horseId != null)
                message.horseId = String(object.horseId);
              if (object.markAllAsRead != null)
                message.markAllAsRead = Boolean(object.markAllAsRead);
              return message;
            };

          /**
           * Creates a plain object from a MarkHorseAggregatedCommentsAsReadRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest} message MarkHorseAggregatedCommentsAsReadRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          MarkHorseAggregatedCommentsAsReadRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.workoutRequestCommentIds = [];
              object.horseExamCommentIds = [];
            }
            if (options.defaults) {
              object.horseId = "";
              object.markAllAsRead = false;
            }
            if (
              message.workoutRequestCommentIds &&
              message.workoutRequestCommentIds.length
            ) {
              object.workoutRequestCommentIds = [];
              for (var j = 0; j < message.workoutRequestCommentIds.length; ++j)
                object.workoutRequestCommentIds[j] =
                  message.workoutRequestCommentIds[j];
            }
            if (
              message.horseExamCommentIds &&
              message.horseExamCommentIds.length
            ) {
              object.horseExamCommentIds = [];
              for (var j = 0; j < message.horseExamCommentIds.length; ++j)
                object.horseExamCommentIds[j] = message.horseExamCommentIds[j];
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.markAllAsRead != null &&
              message.hasOwnProperty("markAllAsRead")
            )
              object.markAllAsRead = message.markAllAsRead;
            return object;
          };

          /**
           * Converts this MarkHorseAggregatedCommentsAsReadRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.MarkHorseAggregatedCommentsAsReadRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          MarkHorseAggregatedCommentsAsReadRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return MarkHorseAggregatedCommentsAsReadRequest;
        })();

        racehorse360.AssignHorseToBarnRequest = (function () {
          /**
           * Properties of an AssignHorseToBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignHorseToBarnRequest
           * @property {string|null} [horseId] AssignHorseToBarnRequest horseId
           * @property {string|null} [barnId] AssignHorseToBarnRequest barnId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignHorseToBarnRequest getOptions
           */

          /**
           * Constructs a new AssignHorseToBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignHorseToBarnRequest.
           * @implements IAssignHorseToBarnRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignHorseToBarnRequest=} [properties] Properties to set
           */
          function AssignHorseToBarnRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignHorseToBarnRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @instance
           */
          AssignHorseToBarnRequest.prototype.horseId = "";

          /**
           * AssignHorseToBarnRequest barnId.
           * @member {string} barnId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @instance
           */
          AssignHorseToBarnRequest.prototype.barnId = "";

          /**
           * AssignHorseToBarnRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @instance
           */
          AssignHorseToBarnRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignHorseToBarnRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToBarnRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignHorseToBarnRequest} AssignHorseToBarnRequest instance
           */
          AssignHorseToBarnRequest.create = function create(properties) {
            return new AssignHorseToBarnRequest(properties);
          };

          /**
           * Encodes the specified AssignHorseToBarnRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignHorseToBarnRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToBarnRequest} message AssignHorseToBarnRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignHorseToBarnRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.barnId != null &&
              Object.hasOwnProperty.call(message, "barnId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.barnId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignHorseToBarnRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignHorseToBarnRequest} AssignHorseToBarnRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignHorseToBarnRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignHorseToBarnRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.barnId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignHorseToBarnRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignHorseToBarnRequest} AssignHorseToBarnRequest
           */
          AssignHorseToBarnRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AssignHorseToBarnRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AssignHorseToBarnRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.barnId != null) message.barnId = String(object.barnId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AssignHorseToBarnRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AssignHorseToBarnRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignHorseToBarnRequest} message AssignHorseToBarnRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignHorseToBarnRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.barnId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.barnId != null && message.hasOwnProperty("barnId"))
              object.barnId = message.barnId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignHorseToBarnRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignHorseToBarnRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignHorseToBarnRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AssignHorseToBarnRequest;
        })();

        racehorse360.UnassignHorseFromBarnRequest = (function () {
          /**
           * Properties of an UnassignHorseFromBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUnassignHorseFromBarnRequest
           * @property {string|null} [horseId] UnassignHorseFromBarnRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UnassignHorseFromBarnRequest getOptions
           */

          /**
           * Constructs a new UnassignHorseFromBarnRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UnassignHorseFromBarnRequest.
           * @implements IUnassignHorseFromBarnRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromBarnRequest=} [properties] Properties to set
           */
          function UnassignHorseFromBarnRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnassignHorseFromBarnRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @instance
           */
          UnassignHorseFromBarnRequest.prototype.horseId = "";

          /**
           * UnassignHorseFromBarnRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @instance
           */
          UnassignHorseFromBarnRequest.prototype.getOptions = null;

          /**
           * Creates a new UnassignHorseFromBarnRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromBarnRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} UnassignHorseFromBarnRequest instance
           */
          UnassignHorseFromBarnRequest.create = function create(properties) {
            return new UnassignHorseFromBarnRequest(properties);
          };

          /**
           * Encodes the specified UnassignHorseFromBarnRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromBarnRequest} message UnassignHorseFromBarnRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnassignHorseFromBarnRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UnassignHorseFromBarnRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} UnassignHorseFromBarnRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnassignHorseFromBarnRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnassignHorseFromBarnRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} UnassignHorseFromBarnRequest
           */
          UnassignHorseFromBarnRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UnassignHorseFromBarnRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UnassignHorseFromBarnRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest} message UnassignHorseFromBarnRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnassignHorseFromBarnRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UnassignHorseFromBarnRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromBarnRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnassignHorseFromBarnRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UnassignHorseFromBarnRequest;
        })();

        racehorse360.AssignHorseToFacilityRequest = (function () {
          /**
           * Properties of an AssignHorseToFacilityRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignHorseToFacilityRequest
           * @property {string|null} [horseId] AssignHorseToFacilityRequest horseId
           * @property {string|null} [facilityId] AssignHorseToFacilityRequest facilityId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignHorseToFacilityRequest getOptions
           */

          /**
           * Constructs a new AssignHorseToFacilityRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignHorseToFacilityRequest.
           * @implements IAssignHorseToFacilityRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignHorseToFacilityRequest=} [properties] Properties to set
           */
          function AssignHorseToFacilityRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignHorseToFacilityRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @instance
           */
          AssignHorseToFacilityRequest.prototype.horseId = "";

          /**
           * AssignHorseToFacilityRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @instance
           */
          AssignHorseToFacilityRequest.prototype.facilityId = "";

          /**
           * AssignHorseToFacilityRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @instance
           */
          AssignHorseToFacilityRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignHorseToFacilityRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToFacilityRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} AssignHorseToFacilityRequest instance
           */
          AssignHorseToFacilityRequest.create = function create(properties) {
            return new AssignHorseToFacilityRequest(properties);
          };

          /**
           * Encodes the specified AssignHorseToFacilityRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignHorseToFacilityRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToFacilityRequest} message AssignHorseToFacilityRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignHorseToFacilityRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignHorseToFacilityRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} AssignHorseToFacilityRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignHorseToFacilityRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.facilityId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignHorseToFacilityRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} AssignHorseToFacilityRequest
           */
          AssignHorseToFacilityRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .AssignHorseToFacilityRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AssignHorseToFacilityRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AssignHorseToFacilityRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AssignHorseToFacilityRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignHorseToFacilityRequest} message AssignHorseToFacilityRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignHorseToFacilityRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.facilityId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignHorseToFacilityRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignHorseToFacilityRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignHorseToFacilityRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AssignHorseToFacilityRequest;
        })();

        racehorse360.AssignHorseToStallRequest = (function () {
          /**
           * Properties of an AssignHorseToStallRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignHorseToStallRequest
           * @property {string|null} [horseId] AssignHorseToStallRequest horseId
           * @property {string|null} [stallNumber] AssignHorseToStallRequest stallNumber
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignHorseToStallRequest getOptions
           */

          /**
           * Constructs a new AssignHorseToStallRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignHorseToStallRequest.
           * @implements IAssignHorseToStallRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignHorseToStallRequest=} [properties] Properties to set
           */
          function AssignHorseToStallRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignHorseToStallRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @instance
           */
          AssignHorseToStallRequest.prototype.horseId = "";

          /**
           * AssignHorseToStallRequest stallNumber.
           * @member {string} stallNumber
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @instance
           */
          AssignHorseToStallRequest.prototype.stallNumber = "";

          /**
           * AssignHorseToStallRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @instance
           */
          AssignHorseToStallRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignHorseToStallRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToStallRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignHorseToStallRequest} AssignHorseToStallRequest instance
           */
          AssignHorseToStallRequest.create = function create(properties) {
            return new AssignHorseToStallRequest(properties);
          };

          /**
           * Encodes the specified AssignHorseToStallRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignHorseToStallRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToStallRequest} message AssignHorseToStallRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignHorseToStallRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.stallNumber != null &&
              Object.hasOwnProperty.call(message, "stallNumber")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.stallNumber);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignHorseToStallRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignHorseToStallRequest} AssignHorseToStallRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignHorseToStallRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignHorseToStallRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.stallNumber = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignHorseToStallRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignHorseToStallRequest} AssignHorseToStallRequest
           */
          AssignHorseToStallRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AssignHorseToStallRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AssignHorseToStallRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.stallNumber != null)
              message.stallNumber = String(object.stallNumber);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AssignHorseToStallRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AssignHorseToStallRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignHorseToStallRequest} message AssignHorseToStallRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignHorseToStallRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.stallNumber = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.stallNumber != null &&
              message.hasOwnProperty("stallNumber")
            )
              object.stallNumber = message.stallNumber;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignHorseToStallRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignHorseToStallRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignHorseToStallRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AssignHorseToStallRequest;
        })();

        racehorse360.UnassignHorseFromStallRequest = (function () {
          /**
           * Properties of an UnassignHorseFromStallRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUnassignHorseFromStallRequest
           * @property {string|null} [horseId] UnassignHorseFromStallRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UnassignHorseFromStallRequest getOptions
           */

          /**
           * Constructs a new UnassignHorseFromStallRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UnassignHorseFromStallRequest.
           * @implements IUnassignHorseFromStallRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromStallRequest=} [properties] Properties to set
           */
          function UnassignHorseFromStallRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnassignHorseFromStallRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @instance
           */
          UnassignHorseFromStallRequest.prototype.horseId = "";

          /**
           * UnassignHorseFromStallRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @instance
           */
          UnassignHorseFromStallRequest.prototype.getOptions = null;

          /**
           * Creates a new UnassignHorseFromStallRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromStallRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} UnassignHorseFromStallRequest instance
           */
          UnassignHorseFromStallRequest.create = function create(properties) {
            return new UnassignHorseFromStallRequest(properties);
          };

          /**
           * Encodes the specified UnassignHorseFromStallRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignHorseFromStallRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromStallRequest} message UnassignHorseFromStallRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnassignHorseFromStallRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UnassignHorseFromStallRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} UnassignHorseFromStallRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnassignHorseFromStallRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnassignHorseFromStallRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} UnassignHorseFromStallRequest
           */
          UnassignHorseFromStallRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UnassignHorseFromStallRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UnassignHorseFromStallRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UnassignHorseFromStallRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UnassignHorseFromStallRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UnassignHorseFromStallRequest} message UnassignHorseFromStallRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnassignHorseFromStallRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UnassignHorseFromStallRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromStallRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnassignHorseFromStallRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UnassignHorseFromStallRequest;
        })();

        racehorse360.AssignHorseToTrainerRequest = (function () {
          /**
           * Properties of an AssignHorseToTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignHorseToTrainerRequest
           * @property {string|null} [horseId] AssignHorseToTrainerRequest horseId
           * @property {string|null} [trainerId] AssignHorseToTrainerRequest trainerId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignHorseToTrainerRequest getOptions
           */

          /**
           * Constructs a new AssignHorseToTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignHorseToTrainerRequest.
           * @implements IAssignHorseToTrainerRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignHorseToTrainerRequest=} [properties] Properties to set
           */
          function AssignHorseToTrainerRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignHorseToTrainerRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @instance
           */
          AssignHorseToTrainerRequest.prototype.horseId = "";

          /**
           * AssignHorseToTrainerRequest trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @instance
           */
          AssignHorseToTrainerRequest.prototype.trainerId = "";

          /**
           * AssignHorseToTrainerRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @instance
           */
          AssignHorseToTrainerRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignHorseToTrainerRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToTrainerRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} AssignHorseToTrainerRequest instance
           */
          AssignHorseToTrainerRequest.create = function create(properties) {
            return new AssignHorseToTrainerRequest(properties);
          };

          /**
           * Encodes the specified AssignHorseToTrainerRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignHorseToTrainerRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignHorseToTrainerRequest} message AssignHorseToTrainerRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignHorseToTrainerRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.trainerId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignHorseToTrainerRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} AssignHorseToTrainerRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignHorseToTrainerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.trainerId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignHorseToTrainerRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} AssignHorseToTrainerRequest
           */
          AssignHorseToTrainerRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AssignHorseToTrainerRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AssignHorseToTrainerRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AssignHorseToTrainerRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignHorseToTrainerRequest} message AssignHorseToTrainerRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignHorseToTrainerRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.trainerId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignHorseToTrainerRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignHorseToTrainerRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignHorseToTrainerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AssignHorseToTrainerRequest;
        })();

        racehorse360.UnassignHorseFromTrainerRequest = (function () {
          /**
           * Properties of an UnassignHorseFromTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUnassignHorseFromTrainerRequest
           * @property {string|null} [horseId] UnassignHorseFromTrainerRequest horseId
           */

          /**
           * Constructs a new UnassignHorseFromTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UnassignHorseFromTrainerRequest.
           * @implements IUnassignHorseFromTrainerRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromTrainerRequest=} [properties] Properties to set
           */
          function UnassignHorseFromTrainerRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnassignHorseFromTrainerRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @instance
           */
          UnassignHorseFromTrainerRequest.prototype.horseId = "";

          /**
           * Creates a new UnassignHorseFromTrainerRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromTrainerRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} UnassignHorseFromTrainerRequest instance
           */
          UnassignHorseFromTrainerRequest.create = function create(properties) {
            return new UnassignHorseFromTrainerRequest(properties);
          };

          /**
           * Encodes the specified UnassignHorseFromTrainerRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromTrainerRequest} message UnassignHorseFromTrainerRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnassignHorseFromTrainerRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            return writer;
          };

          /**
           * Decodes an UnassignHorseFromTrainerRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} UnassignHorseFromTrainerRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnassignHorseFromTrainerRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnassignHorseFromTrainerRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} UnassignHorseFromTrainerRequest
           */
          UnassignHorseFromTrainerRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UnassignHorseFromTrainerRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            return message;
          };

          /**
           * Creates a plain object from an UnassignHorseFromTrainerRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest} message UnassignHorseFromTrainerRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnassignHorseFromTrainerRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.horseId = "";
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            return object;
          };

          /**
           * Converts this UnassignHorseFromTrainerRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UnassignHorseFromTrainerRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnassignHorseFromTrainerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UnassignHorseFromTrainerRequest;
        })();

        racehorse360.HorseShortInfo = (function () {
          /**
           * Properties of a HorseShortInfo.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseShortInfo
           * @property {string|null} [id] HorseShortInfo id
           * @property {string|null} [horseName] HorseShortInfo horseName
           * @property {string|null} [horseRegistrationNumber] HorseShortInfo horseRegistrationNumber
           * @property {string|null} [horseBirthday] HorseShortInfo horseBirthday
           * @property {string|null} [trainerName] HorseShortInfo trainerName
           * @property {string|null} [currentFacilityId] HorseShortInfo currentFacilityId
           * @property {string|null} [horseChipNumber] HorseShortInfo horseChipNumber
           * @property {string|null} [ownerName] HorseShortInfo ownerName
           * @property {string|null} [breederName] HorseShortInfo breederName
           */

          /**
           * Constructs a new HorseShortInfo.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseShortInfo.
           * @implements IHorseShortInfo
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseShortInfo=} [properties] Properties to set
           */
          function HorseShortInfo(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseShortInfo id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.id = "";

          /**
           * HorseShortInfo horseName.
           * @member {string} horseName
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.horseName = "";

          /**
           * HorseShortInfo horseRegistrationNumber.
           * @member {string} horseRegistrationNumber
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.horseRegistrationNumber = "";

          /**
           * HorseShortInfo horseBirthday.
           * @member {string} horseBirthday
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.horseBirthday = "";

          /**
           * HorseShortInfo trainerName.
           * @member {string} trainerName
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.trainerName = "";

          /**
           * HorseShortInfo currentFacilityId.
           * @member {string} currentFacilityId
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.currentFacilityId = "";

          /**
           * HorseShortInfo horseChipNumber.
           * @member {string} horseChipNumber
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.horseChipNumber = "";

          /**
           * HorseShortInfo ownerName.
           * @member {string} ownerName
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.ownerName = "";

          /**
           * HorseShortInfo breederName.
           * @member {string} breederName
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           */
          HorseShortInfo.prototype.breederName = "";

          /**
           * Creates a new HorseShortInfo instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseShortInfo=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseShortInfo} HorseShortInfo instance
           */
          HorseShortInfo.create = function create(properties) {
            return new HorseShortInfo(properties);
          };

          /**
           * Encodes the specified HorseShortInfo message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseShortInfo.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseShortInfo} message HorseShortInfo message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseShortInfo.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseName != null &&
              Object.hasOwnProperty.call(message, "horseName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseName);
            if (
              message.horseRegistrationNumber != null &&
              Object.hasOwnProperty.call(message, "horseRegistrationNumber")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.horseRegistrationNumber);
            if (
              message.horseBirthday != null &&
              Object.hasOwnProperty.call(message, "horseBirthday")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.horseBirthday);
            if (
              message.trainerName != null &&
              Object.hasOwnProperty.call(message, "trainerName")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.trainerName);
            if (
              message.currentFacilityId != null &&
              Object.hasOwnProperty.call(message, "currentFacilityId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.currentFacilityId);
            if (
              message.horseChipNumber != null &&
              Object.hasOwnProperty.call(message, "horseChipNumber")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.horseChipNumber);
            if (
              message.ownerName != null &&
              Object.hasOwnProperty.call(message, "ownerName")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.ownerName);
            if (
              message.breederName != null &&
              Object.hasOwnProperty.call(message, "breederName")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.breederName);
            return writer;
          };

          /**
           * Decodes a HorseShortInfo message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseShortInfo} HorseShortInfo
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseShortInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseShortInfo();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseName = reader.string();
                  break;
                case 3:
                  message.horseRegistrationNumber = reader.string();
                  break;
                case 4:
                  message.horseBirthday = reader.string();
                  break;
                case 5:
                  message.trainerName = reader.string();
                  break;
                case 6:
                  message.currentFacilityId = reader.string();
                  break;
                case 7:
                  message.horseChipNumber = reader.string();
                  break;
                case 8:
                  message.ownerName = reader.string();
                  break;
                case 9:
                  message.breederName = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseShortInfo message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseShortInfo} HorseShortInfo
           */
          HorseShortInfo.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseShortInfo
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseShortInfo();
            if (object.id != null) message.id = String(object.id);
            if (object.horseName != null)
              message.horseName = String(object.horseName);
            if (object.horseRegistrationNumber != null)
              message.horseRegistrationNumber = String(
                object.horseRegistrationNumber
              );
            if (object.horseBirthday != null)
              message.horseBirthday = String(object.horseBirthday);
            if (object.trainerName != null)
              message.trainerName = String(object.trainerName);
            if (object.currentFacilityId != null)
              message.currentFacilityId = String(object.currentFacilityId);
            if (object.horseChipNumber != null)
              message.horseChipNumber = String(object.horseChipNumber);
            if (object.ownerName != null)
              message.ownerName = String(object.ownerName);
            if (object.breederName != null)
              message.breederName = String(object.breederName);
            return message;
          };

          /**
           * Creates a plain object from a HorseShortInfo message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @static
           * @param {stronachgroup.first.racehorse360.HorseShortInfo} message HorseShortInfo
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseShortInfo.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseName = "";
              object.horseRegistrationNumber = "";
              object.horseBirthday = "";
              object.trainerName = "";
              object.currentFacilityId = "";
              object.horseChipNumber = "";
              object.ownerName = "";
              object.breederName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseName != null &&
              message.hasOwnProperty("horseName")
            )
              object.horseName = message.horseName;
            if (
              message.horseRegistrationNumber != null &&
              message.hasOwnProperty("horseRegistrationNumber")
            )
              object.horseRegistrationNumber = message.horseRegistrationNumber;
            if (
              message.horseBirthday != null &&
              message.hasOwnProperty("horseBirthday")
            )
              object.horseBirthday = message.horseBirthday;
            if (
              message.trainerName != null &&
              message.hasOwnProperty("trainerName")
            )
              object.trainerName = message.trainerName;
            if (
              message.currentFacilityId != null &&
              message.hasOwnProperty("currentFacilityId")
            )
              object.currentFacilityId = message.currentFacilityId;
            if (
              message.horseChipNumber != null &&
              message.hasOwnProperty("horseChipNumber")
            )
              object.horseChipNumber = message.horseChipNumber;
            if (
              message.ownerName != null &&
              message.hasOwnProperty("ownerName")
            )
              object.ownerName = message.ownerName;
            if (
              message.breederName != null &&
              message.hasOwnProperty("breederName")
            )
              object.breederName = message.breederName;
            return object;
          };

          /**
           * Converts this HorseShortInfo to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseShortInfo
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseShortInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseShortInfo;
        })();

        racehorse360.HorsesShortInfoFilter = (function () {
          /**
           * Properties of a HorsesShortInfoFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorsesShortInfoFilter
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [filterString] HorsesShortInfoFilter filterString
           * @property {boolean|null} [exclude_12yoHorses] HorsesShortInfoFilter exclude_12yoHorses
           * @property {Array.<string>|null} [filterBy] HorsesShortInfoFilter filterBy
           */

          /**
           * Constructs a new HorsesShortInfoFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorsesShortInfoFilter.
           * @implements IHorsesShortInfoFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorsesShortInfoFilter=} [properties] Properties to set
           */
          function HorsesShortInfoFilter(properties) {
            this.filterBy = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorsesShortInfoFilter filterString.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} filterString
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @instance
           */
          HorsesShortInfoFilter.prototype.filterString = null;

          /**
           * HorsesShortInfoFilter exclude_12yoHorses.
           * @member {boolean} exclude_12yoHorses
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @instance
           */
          HorsesShortInfoFilter.prototype.exclude_12yoHorses = false;

          /**
           * HorsesShortInfoFilter filterBy.
           * @member {Array.<string>} filterBy
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @instance
           */
          HorsesShortInfoFilter.prototype.filterBy = $util.emptyArray;

          /**
           * Creates a new HorsesShortInfoFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesShortInfoFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorsesShortInfoFilter} HorsesShortInfoFilter instance
           */
          HorsesShortInfoFilter.create = function create(properties) {
            return new HorsesShortInfoFilter(properties);
          };

          /**
           * Encodes the specified HorsesShortInfoFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorsesShortInfoFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorsesShortInfoFilter} message HorsesShortInfoFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorsesShortInfoFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.filterString != null &&
              Object.hasOwnProperty.call(message, "filterString")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.filterString,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.exclude_12yoHorses != null &&
              Object.hasOwnProperty.call(message, "exclude_12yoHorses")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .bool(message.exclude_12yoHorses);
            if (message.filterBy != null && message.filterBy.length)
              for (var i = 0; i < message.filterBy.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.filterBy[i]);
            return writer;
          };

          /**
           * Decodes a HorsesShortInfoFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorsesShortInfoFilter} HorsesShortInfoFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorsesShortInfoFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.filterString =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.exclude_12yoHorses = reader.bool();
                  break;
                case 3:
                  if (!(message.filterBy && message.filterBy.length))
                    message.filterBy = [];
                  message.filterBy.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorsesShortInfoFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorsesShortInfoFilter} HorsesShortInfoFilter
           */
          HorsesShortInfoFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter();
            if (object.filterString != null) {
              if (typeof object.filterString !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorsesShortInfoFilter.filterString: object expected"
                );
              message.filterString =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.filterString
                );
            }
            if (object.exclude_12yoHorses != null)
              message.exclude_12yoHorses = Boolean(object.exclude_12yoHorses);
            if (object.filterBy) {
              if (!Array.isArray(object.filterBy))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorsesShortInfoFilter.filterBy: array expected"
                );
              message.filterBy = [];
              for (var i = 0; i < object.filterBy.length; ++i)
                message.filterBy[i] = String(object.filterBy[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorsesShortInfoFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorsesShortInfoFilter} message HorsesShortInfoFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorsesShortInfoFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.filterBy = [];
            if (options.defaults) {
              object.filterString = null;
              object.exclude_12yoHorses = false;
            }
            if (
              message.filterString != null &&
              message.hasOwnProperty("filterString")
            )
              object.filterString =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.filterString,
                  options
                );
            if (
              message.exclude_12yoHorses != null &&
              message.hasOwnProperty("exclude_12yoHorses")
            )
              object.exclude_12yoHorses = message.exclude_12yoHorses;
            if (message.filterBy && message.filterBy.length) {
              object.filterBy = [];
              for (var j = 0; j < message.filterBy.length; ++j)
                object.filterBy[j] = message.filterBy[j];
            }
            return object;
          };

          /**
           * Converts this HorsesShortInfoFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorsesShortInfoFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorsesShortInfoFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorsesShortInfoFilter;
        })();

        racehorse360.PullHorsesShortInfoRequest = (function () {
          /**
           * Properties of a PullHorsesShortInfoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesShortInfoRequest
           * @property {stronachgroup.first.racehorse360.IHorsesShortInfoFilter|null} [query] PullHorsesShortInfoRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] PullHorsesShortInfoRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] PullHorsesShortInfoRequest pagingOptions
           */

          /**
           * Constructs a new PullHorsesShortInfoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesShortInfoRequest.
           * @implements IPullHorsesShortInfoRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoRequest=} [properties] Properties to set
           */
          function PullHorsesShortInfoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesShortInfoRequest query.
           * @member {stronachgroup.first.racehorse360.IHorsesShortInfoFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @instance
           */
          PullHorsesShortInfoRequest.prototype.query = null;

          /**
           * PullHorsesShortInfoRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @instance
           */
          PullHorsesShortInfoRequest.prototype.getOptions = null;

          /**
           * PullHorsesShortInfoRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @instance
           */
          PullHorsesShortInfoRequest.prototype.pagingOptions = null;

          /**
           * Creates a new PullHorsesShortInfoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} PullHorsesShortInfoRequest instance
           */
          PullHorsesShortInfoRequest.create = function create(properties) {
            return new PullHorsesShortInfoRequest(properties);
          };

          /**
           * Encodes the specified PullHorsesShortInfoRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesShortInfoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoRequest} message PullHorsesShortInfoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesShortInfoRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorsesShortInfoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} PullHorsesShortInfoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesShortInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesShortInfoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} PullHorsesShortInfoRequest
           */
          PullHorsesShortInfoRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesShortInfoRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesShortInfoRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesShortInfoRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesShortInfoRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesShortInfoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesShortInfoRequest} message PullHorsesShortInfoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesShortInfoRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorsesShortInfoFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorsesShortInfoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesShortInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorsesShortInfoRequest;
        })();

        racehorse360.PullHorsesShortInfoResponse = (function () {
          /**
           * Properties of a PullHorsesShortInfoResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesShortInfoResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseShortInfo>|null} [horsesShortInfo] PullHorsesShortInfoResponse horsesShortInfo
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] PullHorsesShortInfoResponse pagingInfo
           */

          /**
           * Constructs a new PullHorsesShortInfoResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesShortInfoResponse.
           * @implements IPullHorsesShortInfoResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoResponse=} [properties] Properties to set
           */
          function PullHorsesShortInfoResponse(properties) {
            this.horsesShortInfo = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesShortInfoResponse horsesShortInfo.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseShortInfo>} horsesShortInfo
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @instance
           */
          PullHorsesShortInfoResponse.prototype.horsesShortInfo =
            $util.emptyArray;

          /**
           * PullHorsesShortInfoResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @instance
           */
          PullHorsesShortInfoResponse.prototype.pagingInfo = null;

          /**
           * Creates a new PullHorsesShortInfoResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoResponse} PullHorsesShortInfoResponse instance
           */
          PullHorsesShortInfoResponse.create = function create(properties) {
            return new PullHorsesShortInfoResponse(properties);
          };

          /**
           * Encodes the specified PullHorsesShortInfoResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesShortInfoResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoResponse} message PullHorsesShortInfoResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesShortInfoResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horsesShortInfo != null &&
              message.horsesShortInfo.length
            )
              for (var i = 0; i < message.horsesShortInfo.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseShortInfo.encode(
                  message.horsesShortInfo[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorsesShortInfoResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoResponse} PullHorsesShortInfoResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesShortInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.horsesShortInfo && message.horsesShortInfo.length)
                  )
                    message.horsesShortInfo = [];
                  message.horsesShortInfo.push(
                    $root.stronachgroup.first.racehorse360.HorseShortInfo.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesShortInfoResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesShortInfoResponse} PullHorsesShortInfoResponse
           */
          PullHorsesShortInfoResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesShortInfoResponse();
            if (object.horsesShortInfo) {
              if (!Array.isArray(object.horsesShortInfo))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesShortInfoResponse.horsesShortInfo: array expected"
                );
              message.horsesShortInfo = [];
              for (var i = 0; i < object.horsesShortInfo.length; ++i) {
                if (typeof object.horsesShortInfo[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorsesShortInfoResponse.horsesShortInfo: object expected"
                  );
                message.horsesShortInfo[i] =
                  $root.stronachgroup.first.racehorse360.HorseShortInfo.fromObject(
                    object.horsesShortInfo[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesShortInfoResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesShortInfoResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesShortInfoResponse} message PullHorsesShortInfoResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesShortInfoResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horsesShortInfo = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horsesShortInfo && message.horsesShortInfo.length) {
              object.horsesShortInfo = [];
              for (var j = 0; j < message.horsesShortInfo.length; ++j)
                object.horsesShortInfo[j] =
                  $root.stronachgroup.first.racehorse360.HorseShortInfo.toObject(
                    message.horsesShortInfo[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorsesShortInfoResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesShortInfoResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesShortInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorsesShortInfoResponse;
        })();

        racehorse360.PullHorsesOrTrainersRequest = (function () {
          /**
           * Properties of a PullHorsesOrTrainersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesOrTrainersRequest
           * @property {stronachgroup.first.racehorse360.IHorseOrTrainerFilter|null} [query] PullHorsesOrTrainersRequest query
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] PullHorsesOrTrainersRequest pagingOptions
           */

          /**
           * Constructs a new PullHorsesOrTrainersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesOrTrainersRequest.
           * @implements IPullHorsesOrTrainersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersRequest=} [properties] Properties to set
           */
          function PullHorsesOrTrainersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesOrTrainersRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseOrTrainerFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @instance
           */
          PullHorsesOrTrainersRequest.prototype.query = null;

          /**
           * PullHorsesOrTrainersRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @instance
           */
          PullHorsesOrTrainersRequest.prototype.pagingOptions = null;

          /**
           * Creates a new PullHorsesOrTrainersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} PullHorsesOrTrainersRequest instance
           */
          PullHorsesOrTrainersRequest.create = function create(properties) {
            return new PullHorsesOrTrainersRequest(properties);
          };

          /**
           * Encodes the specified PullHorsesOrTrainersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersRequest} message PullHorsesOrTrainersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesOrTrainersRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorsesOrTrainersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} PullHorsesOrTrainersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesOrTrainersRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesOrTrainersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} PullHorsesOrTrainersRequest
           */
          PullHorsesOrTrainersRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter.fromObject(
                  object.query
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesOrTrainersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest} message PullHorsesOrTrainersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesOrTrainersRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorsesOrTrainersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesOrTrainersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorsesOrTrainersRequest;
        })();

        racehorse360.HorseOrTrainerFilter = (function () {
          /**
           * Properties of a HorseOrTrainerFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseOrTrainerFilter
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseOrTrainerName] HorseOrTrainerFilter horseOrTrainerName
           * @property {Array.<string>|null} [facilityIds] HorseOrTrainerFilter facilityIds
           */

          /**
           * Constructs a new HorseOrTrainerFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseOrTrainerFilter.
           * @implements IHorseOrTrainerFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainerFilter=} [properties] Properties to set
           */
          function HorseOrTrainerFilter(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseOrTrainerFilter horseOrTrainerName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseOrTrainerName
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @instance
           */
          HorseOrTrainerFilter.prototype.horseOrTrainerName = null;

          /**
           * HorseOrTrainerFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @instance
           */
          HorseOrTrainerFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * Creates a new HorseOrTrainerFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainerFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainerFilter} HorseOrTrainerFilter instance
           */
          HorseOrTrainerFilter.create = function create(properties) {
            return new HorseOrTrainerFilter(properties);
          };

          /**
           * Encodes the specified HorseOrTrainerFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseOrTrainerFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainerFilter} message HorseOrTrainerFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseOrTrainerFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseOrTrainerName != null &&
              Object.hasOwnProperty.call(message, "horseOrTrainerName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseOrTrainerName,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.facilityIds[i]);
            return writer;
          };

          /**
           * Decodes a HorseOrTrainerFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainerFilter} HorseOrTrainerFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseOrTrainerFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseOrTrainerName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseOrTrainerFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainerFilter} HorseOrTrainerFilter
           */
          HorseOrTrainerFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseOrTrainerFilter();
            if (object.horseOrTrainerName != null) {
              if (typeof object.horseOrTrainerName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOrTrainerFilter.horseOrTrainerName: object expected"
                );
              message.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseOrTrainerName
                );
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOrTrainerFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseOrTrainerFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseOrTrainerFilter} message HorseOrTrainerFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseOrTrainerFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.horseOrTrainerName = null;
            if (
              message.horseOrTrainerName != null &&
              message.hasOwnProperty("horseOrTrainerName")
            )
              object.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseOrTrainerName,
                  options
                );
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            return object;
          };

          /**
           * Converts this HorseOrTrainerFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainerFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseOrTrainerFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseOrTrainerFilter;
        })();

        racehorse360.PullHorsesOrTrainersResponse = (function () {
          /**
           * Properties of a PullHorsesOrTrainersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesOrTrainersResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseOrTrainer>|null} [horsesOrTrainers] PullHorsesOrTrainersResponse horsesOrTrainers
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] PullHorsesOrTrainersResponse pagingInfo
           */

          /**
           * Constructs a new PullHorsesOrTrainersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesOrTrainersResponse.
           * @implements IPullHorsesOrTrainersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersResponse=} [properties] Properties to set
           */
          function PullHorsesOrTrainersResponse(properties) {
            this.horsesOrTrainers = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesOrTrainersResponse horsesOrTrainers.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseOrTrainer>} horsesOrTrainers
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @instance
           */
          PullHorsesOrTrainersResponse.prototype.horsesOrTrainers =
            $util.emptyArray;

          /**
           * PullHorsesOrTrainersResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @instance
           */
          PullHorsesOrTrainersResponse.prototype.pagingInfo = null;

          /**
           * Creates a new PullHorsesOrTrainersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse} PullHorsesOrTrainersResponse instance
           */
          PullHorsesOrTrainersResponse.create = function create(properties) {
            return new PullHorsesOrTrainersResponse(properties);
          };

          /**
           * Encodes the specified PullHorsesOrTrainersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersResponse} message PullHorsesOrTrainersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesOrTrainersResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horsesOrTrainers != null &&
              message.horsesOrTrainers.length
            )
              for (var i = 0; i < message.horsesOrTrainers.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseOrTrainer.encode(
                  message.horsesOrTrainers[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorsesOrTrainersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse} PullHorsesOrTrainersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesOrTrainersResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horsesOrTrainers &&
                      message.horsesOrTrainers.length
                    )
                  )
                    message.horsesOrTrainers = [];
                  message.horsesOrTrainers.push(
                    $root.stronachgroup.first.racehorse360.HorseOrTrainer.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesOrTrainersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse} PullHorsesOrTrainersResponse
           */
          PullHorsesOrTrainersResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorsesOrTrainersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse();
            if (object.horsesOrTrainers) {
              if (!Array.isArray(object.horsesOrTrainers))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse.horsesOrTrainers: array expected"
                );
              message.horsesOrTrainers = [];
              for (var i = 0; i < object.horsesOrTrainers.length; ++i) {
                if (typeof object.horsesOrTrainers[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse.horsesOrTrainers: object expected"
                  );
                message.horsesOrTrainers[i] =
                  $root.stronachgroup.first.racehorse360.HorseOrTrainer.fromObject(
                    object.horsesOrTrainers[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesOrTrainersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse} message PullHorsesOrTrainersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesOrTrainersResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horsesOrTrainers = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horsesOrTrainers && message.horsesOrTrainers.length) {
              object.horsesOrTrainers = [];
              for (var j = 0; j < message.horsesOrTrainers.length; ++j)
                object.horsesOrTrainers[j] =
                  $root.stronachgroup.first.racehorse360.HorseOrTrainer.toObject(
                    message.horsesOrTrainers[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorsesOrTrainersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesOrTrainersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorsesOrTrainersResponse;
        })();

        racehorse360.HorseOrTrainer = (function () {
          /**
           * Properties of a HorseOrTrainer.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseOrTrainer
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] HorseOrTrainer trainer
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] HorseOrTrainer horse
           */

          /**
           * Constructs a new HorseOrTrainer.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseOrTrainer.
           * @implements IHorseOrTrainer
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainer=} [properties] Properties to set
           */
          function HorseOrTrainer(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseOrTrainer trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @instance
           */
          HorseOrTrainer.prototype.trainer = null;

          /**
           * HorseOrTrainer horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @instance
           */
          HorseOrTrainer.prototype.horse = null;

          // OneOf field names bound to virtual getters and setters
          var $oneOfFields;

          /**
           * HorseOrTrainer entity.
           * @member {"trainer"|"horse"|undefined} entity
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @instance
           */
          Object.defineProperty(HorseOrTrainer.prototype, "entity", {
            get: $util.oneOfGetter(($oneOfFields = ["trainer", "horse"])),
            set: $util.oneOfSetter($oneOfFields)
          });

          /**
           * Creates a new HorseOrTrainer instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainer=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainer} HorseOrTrainer instance
           */
          HorseOrTrainer.create = function create(properties) {
            return new HorseOrTrainer(properties);
          };

          /**
           * Encodes the specified HorseOrTrainer message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseOrTrainer.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOrTrainer} message HorseOrTrainer message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseOrTrainer.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseOrTrainer message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainer} HorseOrTrainer
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseOrTrainer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseOrTrainer();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseOrTrainer message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseOrTrainer} HorseOrTrainer
           */
          HorseOrTrainer.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseOrTrainer
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseOrTrainer();
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOrTrainer.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOrTrainer.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseOrTrainer message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @static
           * @param {stronachgroup.first.racehorse360.HorseOrTrainer} message HorseOrTrainer
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseOrTrainer.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.trainer != null && message.hasOwnProperty("trainer")) {
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
              if (options.oneofs) object.entity = "trainer";
            }
            if (message.horse != null && message.hasOwnProperty("horse")) {
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
              if (options.oneofs) object.entity = "horse";
            }
            return object;
          };

          /**
           * Converts this HorseOrTrainer to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseOrTrainer
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseOrTrainer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseOrTrainer;
        })();

        racehorse360.HorseRisk = (function () {
          /**
           * Properties of a HorseRisk.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseRisk
           * @property {string|null} [id] HorseRisk id
           * @property {stronachgroup.first.racehorse360.IRiskFactor|null} [riskFactor] HorseRisk riskFactor
           * @property {string|null} [identifiedOn] HorseRisk identifiedOn
           * @property {string|null} [expiredOn] HorseRisk expiredOn
           */

          /**
           * Constructs a new HorseRisk.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseRisk.
           * @implements IHorseRisk
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseRisk=} [properties] Properties to set
           */
          function HorseRisk(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseRisk id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @instance
           */
          HorseRisk.prototype.id = "";

          /**
           * HorseRisk riskFactor.
           * @member {stronachgroup.first.racehorse360.IRiskFactor|null|undefined} riskFactor
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @instance
           */
          HorseRisk.prototype.riskFactor = null;

          /**
           * HorseRisk identifiedOn.
           * @member {string} identifiedOn
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @instance
           */
          HorseRisk.prototype.identifiedOn = "";

          /**
           * HorseRisk expiredOn.
           * @member {string} expiredOn
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @instance
           */
          HorseRisk.prototype.expiredOn = "";

          /**
           * Creates a new HorseRisk instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseRisk=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseRisk} HorseRisk instance
           */
          HorseRisk.create = function create(properties) {
            return new HorseRisk(properties);
          };

          /**
           * Encodes the specified HorseRisk message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseRisk.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseRisk} message HorseRisk message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseRisk.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.riskFactor != null &&
              Object.hasOwnProperty.call(message, "riskFactor")
            )
              $root.stronachgroup.first.racehorse360.RiskFactor.encode(
                message.riskFactor,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.identifiedOn != null &&
              Object.hasOwnProperty.call(message, "identifiedOn")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.identifiedOn);
            if (
              message.expiredOn != null &&
              Object.hasOwnProperty.call(message, "expiredOn")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.expiredOn);
            return writer;
          };

          /**
           * Decodes a HorseRisk message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseRisk} HorseRisk
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseRisk.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.HorseRisk();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.riskFactor =
                    $root.stronachgroup.first.racehorse360.RiskFactor.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.identifiedOn = reader.string();
                  break;
                case 4:
                  message.expiredOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseRisk message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseRisk} HorseRisk
           */
          HorseRisk.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.HorseRisk
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseRisk();
            if (object.id != null) message.id = String(object.id);
            if (object.riskFactor != null) {
              if (typeof object.riskFactor !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseRisk.riskFactor: object expected"
                );
              message.riskFactor =
                $root.stronachgroup.first.racehorse360.RiskFactor.fromObject(
                  object.riskFactor
                );
            }
            if (object.identifiedOn != null)
              message.identifiedOn = String(object.identifiedOn);
            if (object.expiredOn != null)
              message.expiredOn = String(object.expiredOn);
            return message;
          };

          /**
           * Creates a plain object from a HorseRisk message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @static
           * @param {stronachgroup.first.racehorse360.HorseRisk} message HorseRisk
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseRisk.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.riskFactor = null;
              object.identifiedOn = "";
              object.expiredOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.riskFactor != null &&
              message.hasOwnProperty("riskFactor")
            )
              object.riskFactor =
                $root.stronachgroup.first.racehorse360.RiskFactor.toObject(
                  message.riskFactor,
                  options
                );
            if (
              message.identifiedOn != null &&
              message.hasOwnProperty("identifiedOn")
            )
              object.identifiedOn = message.identifiedOn;
            if (
              message.expiredOn != null &&
              message.hasOwnProperty("expiredOn")
            )
              object.expiredOn = message.expiredOn;
            return object;
          };

          /**
           * Converts this HorseRisk to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseRisk
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseRisk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseRisk;
        })();

        racehorse360.ListHorseRisksRequest = (function () {
          /**
           * Properties of a ListHorseRisksRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseRisksRequest
           * @property {stronachgroup.first.racehorse360.IHorseRiskFilter|null} [query] ListHorseRisksRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseRisksRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseRisksRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseRisksRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseRisksRequest.
           * @implements IListHorseRisksRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseRisksRequest=} [properties] Properties to set
           */
          function ListHorseRisksRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseRisksRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseRiskFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @instance
           */
          ListHorseRisksRequest.prototype.query = null;

          /**
           * ListHorseRisksRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @instance
           */
          ListHorseRisksRequest.prototype.getOptions = null;

          /**
           * ListHorseRisksRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @instance
           */
          ListHorseRisksRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseRisksRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseRisksRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksRequest} ListHorseRisksRequest instance
           */
          ListHorseRisksRequest.create = function create(properties) {
            return new ListHorseRisksRequest(properties);
          };

          /**
           * Encodes the specified ListHorseRisksRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseRisksRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseRisksRequest} message ListHorseRisksRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseRisksRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseRiskFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseRisksRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksRequest} ListHorseRisksRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseRisksRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseRisksRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseRiskFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseRisksRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksRequest} ListHorseRisksRequest
           */
          ListHorseRisksRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseRisksRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseRisksRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseRisksRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseRiskFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseRisksRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseRisksRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseRisksRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseRisksRequest} message ListHorseRisksRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseRisksRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseRiskFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseRisksRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseRisksRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseRisksRequest;
        })();

        racehorse360.ListHorseRisksResponse = (function () {
          /**
           * Properties of a ListHorseRisksResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseRisksResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseRisk>|null} [horseRisks] ListHorseRisksResponse horseRisks
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseRisksResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseRisksResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseRisksResponse.
           * @implements IListHorseRisksResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseRisksResponse=} [properties] Properties to set
           */
          function ListHorseRisksResponse(properties) {
            this.horseRisks = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseRisksResponse horseRisks.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseRisk>} horseRisks
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @instance
           */
          ListHorseRisksResponse.prototype.horseRisks = $util.emptyArray;

          /**
           * ListHorseRisksResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @instance
           */
          ListHorseRisksResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseRisksResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseRisksResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksResponse} ListHorseRisksResponse instance
           */
          ListHorseRisksResponse.create = function create(properties) {
            return new ListHorseRisksResponse(properties);
          };

          /**
           * Encodes the specified ListHorseRisksResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseRisksResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseRisksResponse} message ListHorseRisksResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseRisksResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.horseRisks != null && message.horseRisks.length)
              for (var i = 0; i < message.horseRisks.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseRisk.encode(
                  message.horseRisks[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseRisksResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksResponse} ListHorseRisksResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseRisksResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseRisksResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.horseRisks && message.horseRisks.length))
                    message.horseRisks = [];
                  message.horseRisks.push(
                    $root.stronachgroup.first.racehorse360.HorseRisk.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseRisksResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseRisksResponse} ListHorseRisksResponse
           */
          ListHorseRisksResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseRisksResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseRisksResponse();
            if (object.horseRisks) {
              if (!Array.isArray(object.horseRisks))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseRisksResponse.horseRisks: array expected"
                );
              message.horseRisks = [];
              for (var i = 0; i < object.horseRisks.length; ++i) {
                if (typeof object.horseRisks[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseRisksResponse.horseRisks: object expected"
                  );
                message.horseRisks[i] =
                  $root.stronachgroup.first.racehorse360.HorseRisk.fromObject(
                    object.horseRisks[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseRisksResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseRisksResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseRisksResponse} message ListHorseRisksResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseRisksResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horseRisks = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horseRisks && message.horseRisks.length) {
              object.horseRisks = [];
              for (var j = 0; j < message.horseRisks.length; ++j)
                object.horseRisks[j] =
                  $root.stronachgroup.first.racehorse360.HorseRisk.toObject(
                    message.horseRisks[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseRisksResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseRisksResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseRisksResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseRisksResponse;
        })();

        racehorse360.HorseRiskFilter = (function () {
          /**
           * Properties of a HorseRiskFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseRiskFilter
           * @property {Array.<string>|null} [ids] HorseRiskFilter ids
           * @property {Array.<string>|null} [horseIds] HorseRiskFilter horseIds
           * @property {Array.<string>|null} [riskFactorIds] HorseRiskFilter riskFactorIds
           */

          /**
           * Constructs a new HorseRiskFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseRiskFilter.
           * @implements IHorseRiskFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseRiskFilter=} [properties] Properties to set
           */
          function HorseRiskFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.riskFactorIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseRiskFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @instance
           */
          HorseRiskFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseRiskFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @instance
           */
          HorseRiskFilter.prototype.horseIds = $util.emptyArray;

          /**
           * HorseRiskFilter riskFactorIds.
           * @member {Array.<string>} riskFactorIds
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @instance
           */
          HorseRiskFilter.prototype.riskFactorIds = $util.emptyArray;

          /**
           * Creates a new HorseRiskFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseRiskFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseRiskFilter} HorseRiskFilter instance
           */
          HorseRiskFilter.create = function create(properties) {
            return new HorseRiskFilter(properties);
          };

          /**
           * Encodes the specified HorseRiskFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseRiskFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseRiskFilter} message HorseRiskFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseRiskFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseIds[i]);
            if (message.riskFactorIds != null && message.riskFactorIds.length)
              for (var i = 0; i < message.riskFactorIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.riskFactorIds[i]);
            return writer;
          };

          /**
           * Decodes a HorseRiskFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseRiskFilter} HorseRiskFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseRiskFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseRiskFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.riskFactorIds && message.riskFactorIds.length))
                    message.riskFactorIds = [];
                  message.riskFactorIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseRiskFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseRiskFilter} HorseRiskFilter
           */
          HorseRiskFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseRiskFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseRiskFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseRiskFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseRiskFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.riskFactorIds) {
              if (!Array.isArray(object.riskFactorIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseRiskFilter.riskFactorIds: array expected"
                );
              message.riskFactorIds = [];
              for (var i = 0; i < object.riskFactorIds.length; ++i)
                message.riskFactorIds[i] = String(object.riskFactorIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseRiskFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseRiskFilter} message HorseRiskFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseRiskFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.riskFactorIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.riskFactorIds && message.riskFactorIds.length) {
              object.riskFactorIds = [];
              for (var j = 0; j < message.riskFactorIds.length; ++j)
                object.riskFactorIds[j] = message.riskFactorIds[j];
            }
            return object;
          };

          /**
           * Converts this HorseRiskFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseRiskFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseRiskFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseRiskFilter;
        })();

        racehorse360.CreateHorseRiskRequest = (function () {
          /**
           * Properties of a CreateHorseRiskRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateHorseRiskRequest
           * @property {string|null} [horseId] CreateHorseRiskRequest horseId
           * @property {string|null} [title] CreateHorseRiskRequest title
           * @property {string|null} [description] CreateHorseRiskRequest description
           * @property {number|null} [score] CreateHorseRiskRequest score
           * @property {string|null} [expirationDate] CreateHorseRiskRequest expirationDate
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateHorseRiskRequest getOptions
           */

          /**
           * Constructs a new CreateHorseRiskRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateHorseRiskRequest.
           * @implements ICreateHorseRiskRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateHorseRiskRequest=} [properties] Properties to set
           */
          function CreateHorseRiskRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateHorseRiskRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.horseId = "";

          /**
           * CreateHorseRiskRequest title.
           * @member {string} title
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.title = "";

          /**
           * CreateHorseRiskRequest description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.description = "";

          /**
           * CreateHorseRiskRequest score.
           * @member {number} score
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.score = 0;

          /**
           * CreateHorseRiskRequest expirationDate.
           * @member {string} expirationDate
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.expirationDate = "";

          /**
           * CreateHorseRiskRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           */
          CreateHorseRiskRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateHorseRiskRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseRiskRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateHorseRiskRequest} CreateHorseRiskRequest instance
           */
          CreateHorseRiskRequest.create = function create(properties) {
            return new CreateHorseRiskRequest(properties);
          };

          /**
           * Encodes the specified CreateHorseRiskRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateHorseRiskRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseRiskRequest} message CreateHorseRiskRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateHorseRiskRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.title != null &&
              Object.hasOwnProperty.call(message, "title")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.title);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.description);
            if (
              message.score != null &&
              Object.hasOwnProperty.call(message, "score")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.score);
            if (
              message.expirationDate != null &&
              Object.hasOwnProperty.call(message, "expirationDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.expirationDate);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateHorseRiskRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateHorseRiskRequest} CreateHorseRiskRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateHorseRiskRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateHorseRiskRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 2:
                  message.title = reader.string();
                  break;
                case 3:
                  message.description = reader.string();
                  break;
                case 4:
                  message.score = reader.int32();
                  break;
                case 5:
                  message.expirationDate = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateHorseRiskRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateHorseRiskRequest} CreateHorseRiskRequest
           */
          CreateHorseRiskRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateHorseRiskRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateHorseRiskRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.title != null) message.title = String(object.title);
            if (object.description != null)
              message.description = String(object.description);
            if (object.score != null) message.score = object.score | 0;
            if (object.expirationDate != null)
              message.expirationDate = String(object.expirationDate);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseRiskRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateHorseRiskRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateHorseRiskRequest} message CreateHorseRiskRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateHorseRiskRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.title = "";
              object.description = "";
              object.score = 0;
              object.expirationDate = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.title != null && message.hasOwnProperty("title"))
              object.title = message.title;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.score != null && message.hasOwnProperty("score"))
              object.score = message.score;
            if (
              message.expirationDate != null &&
              message.hasOwnProperty("expirationDate")
            )
              object.expirationDate = message.expirationDate;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateHorseRiskRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateHorseRiskRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateHorseRiskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateHorseRiskRequest;
        })();

        racehorse360.DeleteHorseRiskRequest = (function () {
          /**
           * Properties of a DeleteHorseRiskRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseRiskRequest
           * @property {string|null} [id] DeleteHorseRiskRequest id
           */

          /**
           * Constructs a new DeleteHorseRiskRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseRiskRequest.
           * @implements IDeleteHorseRiskRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseRiskRequest=} [properties] Properties to set
           */
          function DeleteHorseRiskRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseRiskRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @instance
           */
          DeleteHorseRiskRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseRiskRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseRiskRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseRiskRequest} DeleteHorseRiskRequest instance
           */
          DeleteHorseRiskRequest.create = function create(properties) {
            return new DeleteHorseRiskRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseRiskRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseRiskRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseRiskRequest} message DeleteHorseRiskRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseRiskRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseRiskRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseRiskRequest} DeleteHorseRiskRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseRiskRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseRiskRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseRiskRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseRiskRequest} DeleteHorseRiskRequest
           */
          DeleteHorseRiskRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteHorseRiskRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseRiskRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseRiskRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseRiskRequest} message DeleteHorseRiskRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseRiskRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseRiskRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseRiskRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseRiskRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteHorseRiskRequest;
        })();

        racehorse360.RiskFactor = (function () {
          /**
           * Properties of a RiskFactor.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRiskFactor
           * @property {string|null} [id] RiskFactor id
           * @property {string|null} [description] RiskFactor description
           * @property {string|null} [shortDescription] RiskFactor shortDescription
           * @property {string|null} [detailedDescription] RiskFactor detailedDescription
           * @property {number|null} [score] RiskFactor score
           * @property {boolean|null} [isManual] RiskFactor isManual
           * @property {string|null} [expirationDate] RiskFactor expirationDate
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] RiskFactor createdBy
           */

          /**
           * Constructs a new RiskFactor.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RiskFactor.
           * @implements IRiskFactor
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRiskFactor=} [properties] Properties to set
           */
          function RiskFactor(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RiskFactor id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.id = "";

          /**
           * RiskFactor description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.description = "";

          /**
           * RiskFactor shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.shortDescription = "";

          /**
           * RiskFactor detailedDescription.
           * @member {string} detailedDescription
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.detailedDescription = "";

          /**
           * RiskFactor score.
           * @member {number} score
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.score = 0;

          /**
           * RiskFactor isManual.
           * @member {boolean} isManual
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.isManual = false;

          /**
           * RiskFactor expirationDate.
           * @member {string} expirationDate
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.expirationDate = "";

          /**
           * RiskFactor createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           */
          RiskFactor.prototype.createdBy = null;

          /**
           * Creates a new RiskFactor instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @static
           * @param {stronachgroup.first.racehorse360.IRiskFactor=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RiskFactor} RiskFactor instance
           */
          RiskFactor.create = function create(properties) {
            return new RiskFactor(properties);
          };

          /**
           * Encodes the specified RiskFactor message. Does not implicitly {@link stronachgroup.first.racehorse360.RiskFactor.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @static
           * @param {stronachgroup.first.racehorse360.IRiskFactor} message RiskFactor message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RiskFactor.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            if (
              message.detailedDescription != null &&
              Object.hasOwnProperty.call(message, "detailedDescription")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.detailedDescription);
            if (
              message.score != null &&
              Object.hasOwnProperty.call(message, "score")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.score);
            if (
              message.isManual != null &&
              Object.hasOwnProperty.call(message, "isManual")
            )
              writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.isManual);
            if (
              message.expirationDate != null &&
              Object.hasOwnProperty.call(message, "expirationDate")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.expirationDate);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1001, wireType 2 =*/ 8010).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RiskFactor message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RiskFactor} RiskFactor
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RiskFactor.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.RiskFactor();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                case 4:
                  message.detailedDescription = reader.string();
                  break;
                case 5:
                  message.score = reader.int32();
                  break;
                case 6:
                  message.isManual = reader.bool();
                  break;
                case 7:
                  message.expirationDate = reader.string();
                  break;
                case 1001:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RiskFactor message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RiskFactor} RiskFactor
           */
          RiskFactor.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RiskFactor
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RiskFactor();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            if (object.detailedDescription != null)
              message.detailedDescription = String(object.detailedDescription);
            if (object.score != null) message.score = object.score | 0;
            if (object.isManual != null)
              message.isManual = Boolean(object.isManual);
            if (object.expirationDate != null)
              message.expirationDate = String(object.expirationDate);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RiskFactor.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RiskFactor message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @static
           * @param {stronachgroup.first.racehorse360.RiskFactor} message RiskFactor
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RiskFactor.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
              object.detailedDescription = "";
              object.score = 0;
              object.isManual = false;
              object.expirationDate = "";
              object.createdBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            if (
              message.detailedDescription != null &&
              message.hasOwnProperty("detailedDescription")
            )
              object.detailedDescription = message.detailedDescription;
            if (message.score != null && message.hasOwnProperty("score"))
              object.score = message.score;
            if (message.isManual != null && message.hasOwnProperty("isManual"))
              object.isManual = message.isManual;
            if (
              message.expirationDate != null &&
              message.hasOwnProperty("expirationDate")
            )
              object.expirationDate = message.expirationDate;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            return object;
          };

          /**
           * Converts this RiskFactor to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RiskFactor
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RiskFactor.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RiskFactor;
        })();

        racehorse360.ListRiskFactorsRequest = (function () {
          /**
           * Properties of a ListRiskFactorsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRiskFactorsRequest
           * @property {stronachgroup.first.racehorse360.IRiskFactorFilter|null} [query] ListRiskFactorsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRiskFactorsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRiskFactorsRequest pagingOptions
           */

          /**
           * Constructs a new ListRiskFactorsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRiskFactorsRequest.
           * @implements IListRiskFactorsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsRequest=} [properties] Properties to set
           */
          function ListRiskFactorsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRiskFactorsRequest query.
           * @member {stronachgroup.first.racehorse360.IRiskFactorFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @instance
           */
          ListRiskFactorsRequest.prototype.query = null;

          /**
           * ListRiskFactorsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @instance
           */
          ListRiskFactorsRequest.prototype.getOptions = null;

          /**
           * ListRiskFactorsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @instance
           */
          ListRiskFactorsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRiskFactorsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsRequest} ListRiskFactorsRequest instance
           */
          ListRiskFactorsRequest.create = function create(properties) {
            return new ListRiskFactorsRequest(properties);
          };

          /**
           * Encodes the specified ListRiskFactorsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRiskFactorsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsRequest} message ListRiskFactorsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRiskFactorsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RiskFactorFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRiskFactorsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsRequest} ListRiskFactorsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRiskFactorsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRiskFactorsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RiskFactorFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRiskFactorsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsRequest} ListRiskFactorsRequest
           */
          ListRiskFactorsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRiskFactorsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRiskFactorsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRiskFactorsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RiskFactorFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRiskFactorsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRiskFactorsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRiskFactorsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRiskFactorsRequest} message ListRiskFactorsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRiskFactorsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RiskFactorFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRiskFactorsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRiskFactorsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRiskFactorsRequest;
        })();

        racehorse360.ListRiskFactorsResponse = (function () {
          /**
           * Properties of a ListRiskFactorsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRiskFactorsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRiskFactor>|null} [riskFactors] ListRiskFactorsResponse riskFactors
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRiskFactorsResponse pagingInfo
           */

          /**
           * Constructs a new ListRiskFactorsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRiskFactorsResponse.
           * @implements IListRiskFactorsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsResponse=} [properties] Properties to set
           */
          function ListRiskFactorsResponse(properties) {
            this.riskFactors = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRiskFactorsResponse riskFactors.
           * @member {Array.<stronachgroup.first.racehorse360.IRiskFactor>} riskFactors
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @instance
           */
          ListRiskFactorsResponse.prototype.riskFactors = $util.emptyArray;

          /**
           * ListRiskFactorsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @instance
           */
          ListRiskFactorsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRiskFactorsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsResponse} ListRiskFactorsResponse instance
           */
          ListRiskFactorsResponse.create = function create(properties) {
            return new ListRiskFactorsResponse(properties);
          };

          /**
           * Encodes the specified ListRiskFactorsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRiskFactorsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsResponse} message ListRiskFactorsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRiskFactorsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.riskFactors != null && message.riskFactors.length)
              for (var i = 0; i < message.riskFactors.length; ++i)
                $root.stronachgroup.first.racehorse360.RiskFactor.encode(
                  message.riskFactors[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRiskFactorsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsResponse} ListRiskFactorsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRiskFactorsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRiskFactorsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.riskFactors && message.riskFactors.length))
                    message.riskFactors = [];
                  message.riskFactors.push(
                    $root.stronachgroup.first.racehorse360.RiskFactor.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRiskFactorsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRiskFactorsResponse} ListRiskFactorsResponse
           */
          ListRiskFactorsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRiskFactorsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRiskFactorsResponse();
            if (object.riskFactors) {
              if (!Array.isArray(object.riskFactors))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRiskFactorsResponse.riskFactors: array expected"
                );
              message.riskFactors = [];
              for (var i = 0; i < object.riskFactors.length; ++i) {
                if (typeof object.riskFactors[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRiskFactorsResponse.riskFactors: object expected"
                  );
                message.riskFactors[i] =
                  $root.stronachgroup.first.racehorse360.RiskFactor.fromObject(
                    object.riskFactors[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRiskFactorsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRiskFactorsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRiskFactorsResponse} message ListRiskFactorsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRiskFactorsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.riskFactors = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.riskFactors && message.riskFactors.length) {
              object.riskFactors = [];
              for (var j = 0; j < message.riskFactors.length; ++j)
                object.riskFactors[j] =
                  $root.stronachgroup.first.racehorse360.RiskFactor.toObject(
                    message.riskFactors[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRiskFactorsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRiskFactorsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRiskFactorsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRiskFactorsResponse;
        })();

        racehorse360.RiskFactorFilter = (function () {
          /**
           * Properties of a RiskFactorFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRiskFactorFilter
           * @property {Array.<string>|null} [ids] RiskFactorFilter ids
           */

          /**
           * Constructs a new RiskFactorFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RiskFactorFilter.
           * @implements IRiskFactorFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRiskFactorFilter=} [properties] Properties to set
           */
          function RiskFactorFilter(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RiskFactorFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @instance
           */
          RiskFactorFilter.prototype.ids = $util.emptyArray;

          /**
           * Creates a new RiskFactorFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRiskFactorFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RiskFactorFilter} RiskFactorFilter instance
           */
          RiskFactorFilter.create = function create(properties) {
            return new RiskFactorFilter(properties);
          };

          /**
           * Encodes the specified RiskFactorFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RiskFactorFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRiskFactorFilter} message RiskFactorFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RiskFactorFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            return writer;
          };

          /**
           * Decodes a RiskFactorFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RiskFactorFilter} RiskFactorFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RiskFactorFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RiskFactorFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RiskFactorFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RiskFactorFilter} RiskFactorFilter
           */
          RiskFactorFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RiskFactorFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RiskFactorFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RiskFactorFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a RiskFactorFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RiskFactorFilter} message RiskFactorFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RiskFactorFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            return object;
          };

          /**
           * Converts this RiskFactorFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RiskFactorFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RiskFactorFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RiskFactorFilter;
        })();

        racehorse360.HorseNotepadComment = (function () {
          /**
           * Properties of a HorseNotepadComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseNotepadComment
           * @property {string|null} [id] HorseNotepadComment id
           * @property {string|null} [horseId] HorseNotepadComment horseId
           * @property {string|null} [note] HorseNotepadComment note
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseNotepadComment createdBy
           */

          /**
           * Constructs a new HorseNotepadComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseNotepadComment.
           * @implements IHorseNotepadComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseNotepadComment=} [properties] Properties to set
           */
          function HorseNotepadComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseNotepadComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @instance
           */
          HorseNotepadComment.prototype.id = "";

          /**
           * HorseNotepadComment horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @instance
           */
          HorseNotepadComment.prototype.horseId = "";

          /**
           * HorseNotepadComment note.
           * @member {string} note
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @instance
           */
          HorseNotepadComment.prototype.note = "";

          /**
           * HorseNotepadComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @instance
           */
          HorseNotepadComment.prototype.createdBy = null;

          /**
           * Creates a new HorseNotepadComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseNotepadComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseNotepadComment} HorseNotepadComment instance
           */
          HorseNotepadComment.create = function create(properties) {
            return new HorseNotepadComment(properties);
          };

          /**
           * Encodes the specified HorseNotepadComment message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseNotepadComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseNotepadComment} message HorseNotepadComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseNotepadComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horseId);
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.note);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1001, wireType 2 =*/ 8010).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseNotepadComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseNotepadComment} HorseNotepadComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseNotepadComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseNotepadComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseId = reader.string();
                  break;
                case 3:
                  message.note = reader.string();
                  break;
                case 1001:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseNotepadComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseNotepadComment} HorseNotepadComment
           */
          HorseNotepadComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseNotepadComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseNotepadComment();
            if (object.id != null) message.id = String(object.id);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.note != null) message.note = String(object.note);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseNotepadComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseNotepadComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @static
           * @param {stronachgroup.first.racehorse360.HorseNotepadComment} message HorseNotepadComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseNotepadComment.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseId = "";
              object.note = "";
              object.createdBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = message.note;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseNotepadComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseNotepadComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseNotepadComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseNotepadComment;
        })();

        racehorse360.ListHorseNotepadCommentsRequest = (function () {
          /**
           * Properties of a ListHorseNotepadCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseNotepadCommentsRequest
           * @property {stronachgroup.first.racehorse360.IHorseNotepadCommentFilter|null} [query] ListHorseNotepadCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseNotepadCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseNotepadCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseNotepadCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseNotepadCommentsRequest.
           * @implements IListHorseNotepadCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsRequest=} [properties] Properties to set
           */
          function ListHorseNotepadCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseNotepadCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseNotepadCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @instance
           */
          ListHorseNotepadCommentsRequest.prototype.query = null;

          /**
           * ListHorseNotepadCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @instance
           */
          ListHorseNotepadCommentsRequest.prototype.getOptions = null;

          /**
           * ListHorseNotepadCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @instance
           */
          ListHorseNotepadCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseNotepadCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} ListHorseNotepadCommentsRequest instance
           */
          ListHorseNotepadCommentsRequest.create = function create(properties) {
            return new ListHorseNotepadCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseNotepadCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsRequest} message ListHorseNotepadCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseNotepadCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseNotepadCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} ListHorseNotepadCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseNotepadCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseNotepadCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} ListHorseNotepadCommentsRequest
           */
          ListHorseNotepadCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseNotepadCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseNotepadCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest} message ListHorseNotepadCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseNotepadCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseNotepadCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseNotepadCommentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseNotepadCommentsRequest;
        })();

        racehorse360.ListHorseNotepadCommentsResponse = (function () {
          /**
           * Properties of a ListHorseNotepadCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseNotepadCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseNotepadComment>|null} [horseNotepadComments] ListHorseNotepadCommentsResponse horseNotepadComments
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseNotepadCommentsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseNotepadCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseNotepadCommentsResponse.
           * @implements IListHorseNotepadCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsResponse=} [properties] Properties to set
           */
          function ListHorseNotepadCommentsResponse(properties) {
            this.horseNotepadComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseNotepadCommentsResponse horseNotepadComments.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseNotepadComment>} horseNotepadComments
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @instance
           */
          ListHorseNotepadCommentsResponse.prototype.horseNotepadComments =
            $util.emptyArray;

          /**
           * ListHorseNotepadCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @instance
           */
          ListHorseNotepadCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseNotepadCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse} ListHorseNotepadCommentsResponse instance
           */
          ListHorseNotepadCommentsResponse.create = function create(
            properties
          ) {
            return new ListHorseNotepadCommentsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseNotepadCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsResponse} message ListHorseNotepadCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseNotepadCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseNotepadComments != null &&
              message.horseNotepadComments.length
            )
              for (var i = 0; i < message.horseNotepadComments.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseNotepadComment.encode(
                  message.horseNotepadComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseNotepadCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse} ListHorseNotepadCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseNotepadCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseNotepadComments &&
                      message.horseNotepadComments.length
                    )
                  )
                    message.horseNotepadComments = [];
                  message.horseNotepadComments.push(
                    $root.stronachgroup.first.racehorse360.HorseNotepadComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseNotepadCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse} ListHorseNotepadCommentsResponse
           */
          ListHorseNotepadCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseNotepadCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse();
            if (object.horseNotepadComments) {
              if (!Array.isArray(object.horseNotepadComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse.horseNotepadComments: array expected"
                );
              message.horseNotepadComments = [];
              for (var i = 0; i < object.horseNotepadComments.length; ++i) {
                if (typeof object.horseNotepadComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse.horseNotepadComments: object expected"
                  );
                message.horseNotepadComments[i] =
                  $root.stronachgroup.first.racehorse360.HorseNotepadComment.fromObject(
                    object.horseNotepadComments[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseNotepadCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse} message ListHorseNotepadCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseNotepadCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseNotepadComments = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.horseNotepadComments &&
              message.horseNotepadComments.length
            ) {
              object.horseNotepadComments = [];
              for (var j = 0; j < message.horseNotepadComments.length; ++j)
                object.horseNotepadComments[j] =
                  $root.stronachgroup.first.racehorse360.HorseNotepadComment.toObject(
                    message.horseNotepadComments[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseNotepadCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseNotepadCommentsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListHorseNotepadCommentsResponse;
        })();

        racehorse360.HorseNotepadCommentFilter = (function () {
          /**
           * Properties of a HorseNotepadCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseNotepadCommentFilter
           * @property {string|null} [horseId] HorseNotepadCommentFilter horseId
           */

          /**
           * Constructs a new HorseNotepadCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseNotepadCommentFilter.
           * @implements IHorseNotepadCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseNotepadCommentFilter=} [properties] Properties to set
           */
          function HorseNotepadCommentFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseNotepadCommentFilter horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @instance
           */
          HorseNotepadCommentFilter.prototype.horseId = "";

          /**
           * Creates a new HorseNotepadCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseNotepadCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseNotepadCommentFilter} HorseNotepadCommentFilter instance
           */
          HorseNotepadCommentFilter.create = function create(properties) {
            return new HorseNotepadCommentFilter(properties);
          };

          /**
           * Encodes the specified HorseNotepadCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseNotepadCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseNotepadCommentFilter} message HorseNotepadCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseNotepadCommentFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            return writer;
          };

          /**
           * Decodes a HorseNotepadCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseNotepadCommentFilter} HorseNotepadCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseNotepadCommentFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseNotepadCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseNotepadCommentFilter} HorseNotepadCommentFilter
           */
          HorseNotepadCommentFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseNotepadCommentFilter();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            return message;
          };

          /**
           * Creates a plain object from a HorseNotepadCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseNotepadCommentFilter} message HorseNotepadCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseNotepadCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.horseId = "";
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            return object;
          };

          /**
           * Converts this HorseNotepadCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseNotepadCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseNotepadCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseNotepadCommentFilter;
        })();

        racehorse360.CreateHorseNotepadCommentRequest = (function () {
          /**
           * Properties of a CreateHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateHorseNotepadCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseNotepadComment|null} [horseNotepadComment] CreateHorseNotepadCommentRequest horseNotepadComment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateHorseNotepadCommentRequest getOptions
           */

          /**
           * Constructs a new CreateHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateHorseNotepadCommentRequest.
           * @implements ICreateHorseNotepadCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateHorseNotepadCommentRequest=} [properties] Properties to set
           */
          function CreateHorseNotepadCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateHorseNotepadCommentRequest horseNotepadComment.
           * @member {stronachgroup.first.racehorse360.IHorseNotepadComment|null|undefined} horseNotepadComment
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @instance
           */
          CreateHorseNotepadCommentRequest.prototype.horseNotepadComment = null;

          /**
           * CreateHorseNotepadCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @instance
           */
          CreateHorseNotepadCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateHorseNotepadCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseNotepadCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} CreateHorseNotepadCommentRequest instance
           */
          CreateHorseNotepadCommentRequest.create = function create(
            properties
          ) {
            return new CreateHorseNotepadCommentRequest(properties);
          };

          /**
           * Encodes the specified CreateHorseNotepadCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseNotepadCommentRequest} message CreateHorseNotepadCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateHorseNotepadCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseNotepadComment != null &&
              Object.hasOwnProperty.call(message, "horseNotepadComment")
            )
              $root.stronachgroup.first.racehorse360.HorseNotepadComment.encode(
                message.horseNotepadComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateHorseNotepadCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} CreateHorseNotepadCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateHorseNotepadCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseNotepadComment =
                    $root.stronachgroup.first.racehorse360.HorseNotepadComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateHorseNotepadCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} CreateHorseNotepadCommentRequest
           */
          CreateHorseNotepadCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateHorseNotepadCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest();
            if (object.horseNotepadComment != null) {
              if (typeof object.horseNotepadComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest.horseNotepadComment: object expected"
                );
              message.horseNotepadComment =
                $root.stronachgroup.first.racehorse360.HorseNotepadComment.fromObject(
                  object.horseNotepadComment
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateHorseNotepadCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest} message CreateHorseNotepadCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateHorseNotepadCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseNotepadComment = null;
              object.getOptions = null;
            }
            if (
              message.horseNotepadComment != null &&
              message.hasOwnProperty("horseNotepadComment")
            )
              object.horseNotepadComment =
                $root.stronachgroup.first.racehorse360.HorseNotepadComment.toObject(
                  message.horseNotepadComment,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateHorseNotepadCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateHorseNotepadCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateHorseNotepadCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return CreateHorseNotepadCommentRequest;
        })();

        racehorse360.DeleteHorseNotepadCommentRequest = (function () {
          /**
           * Properties of a DeleteHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseNotepadCommentRequest
           * @property {string|null} [id] DeleteHorseNotepadCommentRequest id
           */

          /**
           * Constructs a new DeleteHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseNotepadCommentRequest.
           * @implements IDeleteHorseNotepadCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseNotepadCommentRequest=} [properties] Properties to set
           */
          function DeleteHorseNotepadCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseNotepadCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @instance
           */
          DeleteHorseNotepadCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseNotepadCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseNotepadCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} DeleteHorseNotepadCommentRequest instance
           */
          DeleteHorseNotepadCommentRequest.create = function create(
            properties
          ) {
            return new DeleteHorseNotepadCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseNotepadCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseNotepadCommentRequest} message DeleteHorseNotepadCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseNotepadCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseNotepadCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} DeleteHorseNotepadCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseNotepadCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseNotepadCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} DeleteHorseNotepadCommentRequest
           */
          DeleteHorseNotepadCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteHorseNotepadCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseNotepadCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest} message DeleteHorseNotepadCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseNotepadCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseNotepadCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseNotepadCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseNotepadCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return DeleteHorseNotepadCommentRequest;
        })();

        racehorse360.UpdateHorseNotepadCommentRequest = (function () {
          /**
           * Properties of an UpdateHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateHorseNotepadCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseNotepadComment|null} [horseNotepadComment] UpdateHorseNotepadCommentRequest horseNotepadComment
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateHorseNotepadCommentRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateHorseNotepadCommentRequest getOptions
           */

          /**
           * Constructs a new UpdateHorseNotepadCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateHorseNotepadCommentRequest.
           * @implements IUpdateHorseNotepadCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateHorseNotepadCommentRequest=} [properties] Properties to set
           */
          function UpdateHorseNotepadCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateHorseNotepadCommentRequest horseNotepadComment.
           * @member {stronachgroup.first.racehorse360.IHorseNotepadComment|null|undefined} horseNotepadComment
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @instance
           */
          UpdateHorseNotepadCommentRequest.prototype.horseNotepadComment = null;

          /**
           * UpdateHorseNotepadCommentRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @instance
           */
          UpdateHorseNotepadCommentRequest.prototype.updateMask = null;

          /**
           * UpdateHorseNotepadCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @instance
           */
          UpdateHorseNotepadCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateHorseNotepadCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseNotepadCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} UpdateHorseNotepadCommentRequest instance
           */
          UpdateHorseNotepadCommentRequest.create = function create(
            properties
          ) {
            return new UpdateHorseNotepadCommentRequest(properties);
          };

          /**
           * Encodes the specified UpdateHorseNotepadCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseNotepadCommentRequest} message UpdateHorseNotepadCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateHorseNotepadCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseNotepadComment != null &&
              Object.hasOwnProperty.call(message, "horseNotepadComment")
            )
              $root.stronachgroup.first.racehorse360.HorseNotepadComment.encode(
                message.horseNotepadComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateHorseNotepadCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} UpdateHorseNotepadCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateHorseNotepadCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseNotepadComment =
                    $root.stronachgroup.first.racehorse360.HorseNotepadComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateHorseNotepadCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} UpdateHorseNotepadCommentRequest
           */
          UpdateHorseNotepadCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateHorseNotepadCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest();
            if (object.horseNotepadComment != null) {
              if (typeof object.horseNotepadComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest.horseNotepadComment: object expected"
                );
              message.horseNotepadComment =
                $root.stronachgroup.first.racehorse360.HorseNotepadComment.fromObject(
                  object.horseNotepadComment
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateHorseNotepadCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest} message UpdateHorseNotepadCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateHorseNotepadCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseNotepadComment = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.horseNotepadComment != null &&
              message.hasOwnProperty("horseNotepadComment")
            )
              object.horseNotepadComment =
                $root.stronachgroup.first.racehorse360.HorseNotepadComment.toObject(
                  message.horseNotepadComment,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateHorseNotepadCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateHorseNotepadCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateHorseNotepadCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UpdateHorseNotepadCommentRequest;
        })();

        racehorse360.HorseFlagOnTrack = (function () {
          /**
           * Properties of a HorseFlagOnTrack.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseFlagOnTrack
           * @property {string|null} [id] HorseFlagOnTrack id
           * @property {stronachgroup.first.racehorse360.IHorseFlagOnTrackComment|null} [flagOnTrackComment] HorseFlagOnTrack flagOnTrackComment
           * @property {string|null} [createdOn] HorseFlagOnTrack createdOn
           * @property {string|null} [updatedOn] HorseFlagOnTrack updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseFlagOnTrack createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseFlagOnTrack updatedBy
           */

          /**
           * Constructs a new HorseFlagOnTrack.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseFlagOnTrack.
           * @implements IHorseFlagOnTrack
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrack=} [properties] Properties to set
           */
          function HorseFlagOnTrack(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseFlagOnTrack id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.id = "";

          /**
           * HorseFlagOnTrack flagOnTrackComment.
           * @member {stronachgroup.first.racehorse360.IHorseFlagOnTrackComment|null|undefined} flagOnTrackComment
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.flagOnTrackComment = null;

          /**
           * HorseFlagOnTrack createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.createdOn = "";

          /**
           * HorseFlagOnTrack updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.updatedOn = "";

          /**
           * HorseFlagOnTrack createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.createdBy = null;

          /**
           * HorseFlagOnTrack updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           */
          HorseFlagOnTrack.prototype.updatedBy = null;

          /**
           * Creates a new HorseFlagOnTrack instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrack=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrack} HorseFlagOnTrack instance
           */
          HorseFlagOnTrack.create = function create(properties) {
            return new HorseFlagOnTrack(properties);
          };

          /**
           * Encodes the specified HorseFlagOnTrack message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseFlagOnTrack.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrack} message HorseFlagOnTrack message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseFlagOnTrack.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.flagOnTrackComment != null &&
              Object.hasOwnProperty.call(message, "flagOnTrackComment")
            )
              $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.encode(
                message.flagOnTrackComment,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseFlagOnTrack message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrack} HorseFlagOnTrack
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseFlagOnTrack.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseFlagOnTrack();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.flagOnTrackComment =
                    $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseFlagOnTrack message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrack} HorseFlagOnTrack
           */
          HorseFlagOnTrack.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseFlagOnTrack
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseFlagOnTrack();
            if (object.id != null) message.id = String(object.id);
            if (object.flagOnTrackComment != null) {
              if (typeof object.flagOnTrackComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFlagOnTrack.flagOnTrackComment: object expected"
                );
              message.flagOnTrackComment =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.fromObject(
                  object.flagOnTrackComment
                );
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFlagOnTrack.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFlagOnTrack.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseFlagOnTrack message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @static
           * @param {stronachgroup.first.racehorse360.HorseFlagOnTrack} message HorseFlagOnTrack
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseFlagOnTrack.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.flagOnTrackComment = null;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.flagOnTrackComment != null &&
              message.hasOwnProperty("flagOnTrackComment")
            )
              object.flagOnTrackComment =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.toObject(
                  message.flagOnTrackComment,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseFlagOnTrack to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrack
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseFlagOnTrack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseFlagOnTrack;
        })();

        racehorse360.DeleteHorseFlagOnTrackRequest = (function () {
          /**
           * Properties of a DeleteHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseFlagOnTrackRequest
           * @property {string|null} [id] DeleteHorseFlagOnTrackRequest id
           */

          /**
           * Constructs a new DeleteHorseFlagOnTrackRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseFlagOnTrackRequest.
           * @implements IDeleteHorseFlagOnTrackRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackRequest=} [properties] Properties to set
           */
          function DeleteHorseFlagOnTrackRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseFlagOnTrackRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @instance
           */
          DeleteHorseFlagOnTrackRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseFlagOnTrackRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} DeleteHorseFlagOnTrackRequest instance
           */
          DeleteHorseFlagOnTrackRequest.create = function create(properties) {
            return new DeleteHorseFlagOnTrackRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseFlagOnTrackRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackRequest} message DeleteHorseFlagOnTrackRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseFlagOnTrackRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseFlagOnTrackRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} DeleteHorseFlagOnTrackRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseFlagOnTrackRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseFlagOnTrackRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} DeleteHorseFlagOnTrackRequest
           */
          DeleteHorseFlagOnTrackRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteHorseFlagOnTrackRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseFlagOnTrackRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest} message DeleteHorseFlagOnTrackRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseFlagOnTrackRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseFlagOnTrackRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseFlagOnTrackRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteHorseFlagOnTrackRequest;
        })();

        racehorse360.HorseFlagOnTrackComment = (function () {
          /**
           * Properties of a HorseFlagOnTrackComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseFlagOnTrackComment
           * @property {string|null} [id] HorseFlagOnTrackComment id
           * @property {string|null} [body] HorseFlagOnTrackComment body
           * @property {string|null} [createdOn] HorseFlagOnTrackComment createdOn
           * @property {string|null} [updatedOn] HorseFlagOnTrackComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseFlagOnTrackComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseFlagOnTrackComment updatedBy
           */

          /**
           * Constructs a new HorseFlagOnTrackComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseFlagOnTrackComment.
           * @implements IHorseFlagOnTrackComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackComment=} [properties] Properties to set
           */
          function HorseFlagOnTrackComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseFlagOnTrackComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.id = "";

          /**
           * HorseFlagOnTrackComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.body = "";

          /**
           * HorseFlagOnTrackComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.createdOn = "";

          /**
           * HorseFlagOnTrackComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.updatedOn = "";

          /**
           * HorseFlagOnTrackComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.createdBy = null;

          /**
           * HorseFlagOnTrackComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           */
          HorseFlagOnTrackComment.prototype.updatedBy = null;

          /**
           * Creates a new HorseFlagOnTrackComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackComment} HorseFlagOnTrackComment instance
           */
          HorseFlagOnTrackComment.create = function create(properties) {
            return new HorseFlagOnTrackComment(properties);
          };

          /**
           * Encodes the specified HorseFlagOnTrackComment message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseFlagOnTrackComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackComment} message HorseFlagOnTrackComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseFlagOnTrackComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseFlagOnTrackComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackComment} HorseFlagOnTrackComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseFlagOnTrackComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseFlagOnTrackComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackComment} HorseFlagOnTrackComment
           */
          HorseFlagOnTrackComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFlagOnTrackComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseFlagOnTrackComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseFlagOnTrackComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @static
           * @param {stronachgroup.first.racehorse360.HorseFlagOnTrackComment} message HorseFlagOnTrackComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseFlagOnTrackComment.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseFlagOnTrackComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseFlagOnTrackComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseFlagOnTrackComment;
        })();

        racehorse360.GetHorseFlagOnTrackCommentRequest = (function () {
          /**
           * Properties of a GetHorseFlagOnTrackCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetHorseFlagOnTrackCommentRequest
           * @property {string|null} [id] GetHorseFlagOnTrackCommentRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetHorseFlagOnTrackCommentRequest getOptions
           */

          /**
           * Constructs a new GetHorseFlagOnTrackCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetHorseFlagOnTrackCommentRequest.
           * @implements IGetHorseFlagOnTrackCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetHorseFlagOnTrackCommentRequest=} [properties] Properties to set
           */
          function GetHorseFlagOnTrackCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetHorseFlagOnTrackCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @instance
           */
          GetHorseFlagOnTrackCommentRequest.prototype.id = "";

          /**
           * GetHorseFlagOnTrackCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @instance
           */
          GetHorseFlagOnTrackCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new GetHorseFlagOnTrackCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseFlagOnTrackCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} GetHorseFlagOnTrackCommentRequest instance
           */
          GetHorseFlagOnTrackCommentRequest.create = function create(
            properties
          ) {
            return new GetHorseFlagOnTrackCommentRequest(properties);
          };

          /**
           * Encodes the specified GetHorseFlagOnTrackCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseFlagOnTrackCommentRequest} message GetHorseFlagOnTrackCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetHorseFlagOnTrackCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetHorseFlagOnTrackCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} GetHorseFlagOnTrackCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetHorseFlagOnTrackCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetHorseFlagOnTrackCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} GetHorseFlagOnTrackCommentRequest
           */
          GetHorseFlagOnTrackCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .GetHorseFlagOnTrackCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetHorseFlagOnTrackCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest} message GetHorseFlagOnTrackCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetHorseFlagOnTrackCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetHorseFlagOnTrackCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetHorseFlagOnTrackCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetHorseFlagOnTrackCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return GetHorseFlagOnTrackCommentRequest;
        })();

        racehorse360.ListHorseFlagOnTrackCommentsRequest = (function () {
          /**
           * Properties of a ListHorseFlagOnTrackCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseFlagOnTrackCommentsRequest
           * @property {stronachgroup.first.racehorse360.IHorseFlagOnTrackCommentFilter|null} [query] ListHorseFlagOnTrackCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseFlagOnTrackCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseFlagOnTrackCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseFlagOnTrackCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseFlagOnTrackCommentsRequest.
           * @implements IListHorseFlagOnTrackCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsRequest=} [properties] Properties to set
           */
          function ListHorseFlagOnTrackCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseFlagOnTrackCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseFlagOnTrackCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @instance
           */
          ListHorseFlagOnTrackCommentsRequest.prototype.query = null;

          /**
           * ListHorseFlagOnTrackCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @instance
           */
          ListHorseFlagOnTrackCommentsRequest.prototype.getOptions = null;

          /**
           * ListHorseFlagOnTrackCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @instance
           */
          ListHorseFlagOnTrackCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseFlagOnTrackCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} ListHorseFlagOnTrackCommentsRequest instance
           */
          ListHorseFlagOnTrackCommentsRequest.create = function create(
            properties
          ) {
            return new ListHorseFlagOnTrackCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseFlagOnTrackCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsRequest} message ListHorseFlagOnTrackCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseFlagOnTrackCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseFlagOnTrackCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} ListHorseFlagOnTrackCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseFlagOnTrackCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseFlagOnTrackCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} ListHorseFlagOnTrackCommentsRequest
           */
          ListHorseFlagOnTrackCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseFlagOnTrackCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseFlagOnTrackCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest} message ListHorseFlagOnTrackCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseFlagOnTrackCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseFlagOnTrackCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseFlagOnTrackCommentsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListHorseFlagOnTrackCommentsRequest;
        })();

        racehorse360.DeleteHorseFlagOnTrackCommentRequest = (function () {
          /**
           * Properties of a DeleteHorseFlagOnTrackCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseFlagOnTrackCommentRequest
           * @property {string|null} [id] DeleteHorseFlagOnTrackCommentRequest id
           */

          /**
           * Constructs a new DeleteHorseFlagOnTrackCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseFlagOnTrackCommentRequest.
           * @implements IDeleteHorseFlagOnTrackCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackCommentRequest=} [properties] Properties to set
           */
          function DeleteHorseFlagOnTrackCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseFlagOnTrackCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @instance
           */
          DeleteHorseFlagOnTrackCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseFlagOnTrackCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} DeleteHorseFlagOnTrackCommentRequest instance
           */
          DeleteHorseFlagOnTrackCommentRequest.create = function create(
            properties
          ) {
            return new DeleteHorseFlagOnTrackCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseFlagOnTrackCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackCommentRequest} message DeleteHorseFlagOnTrackCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseFlagOnTrackCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseFlagOnTrackCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} DeleteHorseFlagOnTrackCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseFlagOnTrackCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseFlagOnTrackCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} DeleteHorseFlagOnTrackCommentRequest
           */
          DeleteHorseFlagOnTrackCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteHorseFlagOnTrackCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseFlagOnTrackCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest} message DeleteHorseFlagOnTrackCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseFlagOnTrackCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseFlagOnTrackCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseFlagOnTrackCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseFlagOnTrackCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return DeleteHorseFlagOnTrackCommentRequest;
        })();

        racehorse360.ListHorseFlagOnTrackCommentsResponse = (function () {
          /**
           * Properties of a ListHorseFlagOnTrackCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseFlagOnTrackCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseFlagOnTrackComment>|null} [horseFlagOnTrackComments] ListHorseFlagOnTrackCommentsResponse horseFlagOnTrackComments
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseFlagOnTrackCommentsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseFlagOnTrackCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseFlagOnTrackCommentsResponse.
           * @implements IListHorseFlagOnTrackCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsResponse=} [properties] Properties to set
           */
          function ListHorseFlagOnTrackCommentsResponse(properties) {
            this.horseFlagOnTrackComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseFlagOnTrackCommentsResponse horseFlagOnTrackComments.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseFlagOnTrackComment>} horseFlagOnTrackComments
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @instance
           */
          ListHorseFlagOnTrackCommentsResponse.prototype.horseFlagOnTrackComments =
            $util.emptyArray;

          /**
           * ListHorseFlagOnTrackCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @instance
           */
          ListHorseFlagOnTrackCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseFlagOnTrackCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse} ListHorseFlagOnTrackCommentsResponse instance
           */
          ListHorseFlagOnTrackCommentsResponse.create = function create(
            properties
          ) {
            return new ListHorseFlagOnTrackCommentsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseFlagOnTrackCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsResponse} message ListHorseFlagOnTrackCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseFlagOnTrackCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseFlagOnTrackComments != null &&
              message.horseFlagOnTrackComments.length
            )
              for (var i = 0; i < message.horseFlagOnTrackComments.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.encode(
                  message.horseFlagOnTrackComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseFlagOnTrackCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse} ListHorseFlagOnTrackCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseFlagOnTrackCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseFlagOnTrackComments &&
                      message.horseFlagOnTrackComments.length
                    )
                  )
                    message.horseFlagOnTrackComments = [];
                  message.horseFlagOnTrackComments.push(
                    $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseFlagOnTrackCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse} ListHorseFlagOnTrackCommentsResponse
           */
          ListHorseFlagOnTrackCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseFlagOnTrackCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse();
            if (object.horseFlagOnTrackComments) {
              if (!Array.isArray(object.horseFlagOnTrackComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse.horseFlagOnTrackComments: array expected"
                );
              message.horseFlagOnTrackComments = [];
              for (var i = 0; i < object.horseFlagOnTrackComments.length; ++i) {
                if (typeof object.horseFlagOnTrackComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse.horseFlagOnTrackComments: object expected"
                  );
                message.horseFlagOnTrackComments[i] =
                  $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.fromObject(
                    object.horseFlagOnTrackComments[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseFlagOnTrackCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse} message ListHorseFlagOnTrackCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseFlagOnTrackCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseFlagOnTrackComments = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.horseFlagOnTrackComments &&
              message.horseFlagOnTrackComments.length
            ) {
              object.horseFlagOnTrackComments = [];
              for (var j = 0; j < message.horseFlagOnTrackComments.length; ++j)
                object.horseFlagOnTrackComments[j] =
                  $root.stronachgroup.first.racehorse360.HorseFlagOnTrackComment.toObject(
                    message.horseFlagOnTrackComments[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseFlagOnTrackCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseFlagOnTrackCommentsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListHorseFlagOnTrackCommentsResponse;
        })();

        racehorse360.HorseFlagOnTrackCommentFilter = (function () {
          /**
           * Properties of a HorseFlagOnTrackCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseFlagOnTrackCommentFilter
           * @property {string|null} [horseId] HorseFlagOnTrackCommentFilter horseId
           */

          /**
           * Constructs a new HorseFlagOnTrackCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseFlagOnTrackCommentFilter.
           * @implements IHorseFlagOnTrackCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackCommentFilter=} [properties] Properties to set
           */
          function HorseFlagOnTrackCommentFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseFlagOnTrackCommentFilter horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @instance
           */
          HorseFlagOnTrackCommentFilter.prototype.horseId = "";

          /**
           * Creates a new HorseFlagOnTrackCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter} HorseFlagOnTrackCommentFilter instance
           */
          HorseFlagOnTrackCommentFilter.create = function create(properties) {
            return new HorseFlagOnTrackCommentFilter(properties);
          };

          /**
           * Encodes the specified HorseFlagOnTrackCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseFlagOnTrackCommentFilter} message HorseFlagOnTrackCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseFlagOnTrackCommentFilter.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            return writer;
          };

          /**
           * Decodes a HorseFlagOnTrackCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter} HorseFlagOnTrackCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseFlagOnTrackCommentFilter.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseFlagOnTrackCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter} HorseFlagOnTrackCommentFilter
           */
          HorseFlagOnTrackCommentFilter.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .HorseFlagOnTrackCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            return message;
          };

          /**
           * Creates a plain object from a HorseFlagOnTrackCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter} message HorseFlagOnTrackCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseFlagOnTrackCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.horseId = "";
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            return object;
          };

          /**
           * Converts this HorseFlagOnTrackCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseFlagOnTrackCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseFlagOnTrackCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseFlagOnTrackCommentFilter;
        })();

        racehorse360.Vaccination = (function () {
          /**
           * Properties of a Vaccination.
           * @memberof stronachgroup.first.racehorse360
           * @interface IVaccination
           * @property {string|null} [id] Vaccination id
           * @property {string|null} [horseId] Vaccination horseId
           * @property {string|null} [expirationDate] Vaccination expirationDate
           * @property {string|null} [createdOn] Vaccination createdOn
           * @property {string|null} [updatedOn] Vaccination updatedOn
           */

          /**
           * Constructs a new Vaccination.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Vaccination.
           * @implements IVaccination
           * @constructor
           * @param {stronachgroup.first.racehorse360.IVaccination=} [properties] Properties to set
           */
          function Vaccination(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Vaccination id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           */
          Vaccination.prototype.id = "";

          /**
           * Vaccination horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           */
          Vaccination.prototype.horseId = "";

          /**
           * Vaccination expirationDate.
           * @member {string} expirationDate
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           */
          Vaccination.prototype.expirationDate = "";

          /**
           * Vaccination createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           */
          Vaccination.prototype.createdOn = "";

          /**
           * Vaccination updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           */
          Vaccination.prototype.updatedOn = "";

          /**
           * Creates a new Vaccination instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccination=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Vaccination} Vaccination instance
           */
          Vaccination.create = function create(properties) {
            return new Vaccination(properties);
          };

          /**
           * Encodes the specified Vaccination message. Does not implicitly {@link stronachgroup.first.racehorse360.Vaccination.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccination} message Vaccination message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Vaccination.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horseId);
            if (
              message.expirationDate != null &&
              Object.hasOwnProperty.call(message, "expirationDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.expirationDate);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            return writer;
          };

          /**
           * Decodes a Vaccination message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Vaccination} Vaccination
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Vaccination.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.Vaccination();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseId = reader.string();
                  break;
                case 3:
                  message.expirationDate = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Vaccination message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Vaccination} Vaccination
           */
          Vaccination.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.Vaccination
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.Vaccination();
            if (object.id != null) message.id = String(object.id);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.expirationDate != null)
              message.expirationDate = String(object.expirationDate);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            return message;
          };

          /**
           * Creates a plain object from a Vaccination message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @static
           * @param {stronachgroup.first.racehorse360.Vaccination} message Vaccination
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Vaccination.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseId = "";
              object.expirationDate = "";
              object.createdOn = "";
              object.updatedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.expirationDate != null &&
              message.hasOwnProperty("expirationDate")
            )
              object.expirationDate = message.expirationDate;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            return object;
          };

          /**
           * Converts this Vaccination to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Vaccination
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Vaccination.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Vaccination;
        })();

        racehorse360.ListVaccinationsRequest = (function () {
          /**
           * Properties of a ListVaccinationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListVaccinationsRequest
           * @property {stronachgroup.first.racehorse360.IVaccinationFilter|null} [query] ListVaccinationsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListVaccinationsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListVaccinationsRequest pagingOptions
           */

          /**
           * Constructs a new ListVaccinationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListVaccinationsRequest.
           * @implements IListVaccinationsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListVaccinationsRequest=} [properties] Properties to set
           */
          function ListVaccinationsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListVaccinationsRequest query.
           * @member {stronachgroup.first.racehorse360.IVaccinationFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @instance
           */
          ListVaccinationsRequest.prototype.query = null;

          /**
           * ListVaccinationsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @instance
           */
          ListVaccinationsRequest.prototype.getOptions = null;

          /**
           * ListVaccinationsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @instance
           */
          ListVaccinationsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListVaccinationsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsRequest} ListVaccinationsRequest instance
           */
          ListVaccinationsRequest.create = function create(properties) {
            return new ListVaccinationsRequest(properties);
          };

          /**
           * Encodes the specified ListVaccinationsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListVaccinationsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationsRequest} message ListVaccinationsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListVaccinationsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.VaccinationFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListVaccinationsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsRequest} ListVaccinationsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListVaccinationsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListVaccinationsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.VaccinationFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListVaccinationsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsRequest} ListVaccinationsRequest
           */
          ListVaccinationsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListVaccinationsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListVaccinationsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.VaccinationFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListVaccinationsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListVaccinationsRequest} message ListVaccinationsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListVaccinationsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.VaccinationFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListVaccinationsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListVaccinationsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListVaccinationsRequest;
        })();

        racehorse360.GetVaccinationRequest = (function () {
          /**
           * Properties of a GetVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetVaccinationRequest
           * @property {string|null} [id] GetVaccinationRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetVaccinationRequest getOptions
           */

          /**
           * Constructs a new GetVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetVaccinationRequest.
           * @implements IGetVaccinationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetVaccinationRequest=} [properties] Properties to set
           */
          function GetVaccinationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetVaccinationRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @instance
           */
          GetVaccinationRequest.prototype.id = "";

          /**
           * GetVaccinationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @instance
           */
          GetVaccinationRequest.prototype.getOptions = null;

          /**
           * Creates a new GetVaccinationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetVaccinationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetVaccinationRequest} GetVaccinationRequest instance
           */
          GetVaccinationRequest.create = function create(properties) {
            return new GetVaccinationRequest(properties);
          };

          /**
           * Encodes the specified GetVaccinationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetVaccinationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetVaccinationRequest} message GetVaccinationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetVaccinationRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetVaccinationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetVaccinationRequest} GetVaccinationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetVaccinationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetVaccinationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetVaccinationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetVaccinationRequest} GetVaccinationRequest
           */
          GetVaccinationRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetVaccinationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetVaccinationRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetVaccinationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetVaccinationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetVaccinationRequest} message GetVaccinationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetVaccinationRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetVaccinationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetVaccinationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetVaccinationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetVaccinationRequest;
        })();

        racehorse360.ListVaccinationsResponse = (function () {
          /**
           * Properties of a ListVaccinationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListVaccinationsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IVaccination>|null} [vaccinations] ListVaccinationsResponse vaccinations
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListVaccinationsResponse pagingInfo
           */

          /**
           * Constructs a new ListVaccinationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListVaccinationsResponse.
           * @implements IListVaccinationsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListVaccinationsResponse=} [properties] Properties to set
           */
          function ListVaccinationsResponse(properties) {
            this.vaccinations = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListVaccinationsResponse vaccinations.
           * @member {Array.<stronachgroup.first.racehorse360.IVaccination>} vaccinations
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @instance
           */
          ListVaccinationsResponse.prototype.vaccinations = $util.emptyArray;

          /**
           * ListVaccinationsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @instance
           */
          ListVaccinationsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListVaccinationsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsResponse} ListVaccinationsResponse instance
           */
          ListVaccinationsResponse.create = function create(properties) {
            return new ListVaccinationsResponse(properties);
          };

          /**
           * Encodes the specified ListVaccinationsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListVaccinationsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationsResponse} message ListVaccinationsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListVaccinationsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.vaccinations != null && message.vaccinations.length)
              for (var i = 0; i < message.vaccinations.length; ++i)
                $root.stronachgroup.first.racehorse360.Vaccination.encode(
                  message.vaccinations[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListVaccinationsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsResponse} ListVaccinationsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListVaccinationsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListVaccinationsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.vaccinations && message.vaccinations.length))
                    message.vaccinations = [];
                  message.vaccinations.push(
                    $root.stronachgroup.first.racehorse360.Vaccination.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListVaccinationsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListVaccinationsResponse} ListVaccinationsResponse
           */
          ListVaccinationsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListVaccinationsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListVaccinationsResponse();
            if (object.vaccinations) {
              if (!Array.isArray(object.vaccinations))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationsResponse.vaccinations: array expected"
                );
              message.vaccinations = [];
              for (var i = 0; i < object.vaccinations.length; ++i) {
                if (typeof object.vaccinations[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListVaccinationsResponse.vaccinations: object expected"
                  );
                message.vaccinations[i] =
                  $root.stronachgroup.first.racehorse360.Vaccination.fromObject(
                    object.vaccinations[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListVaccinationsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListVaccinationsResponse} message ListVaccinationsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListVaccinationsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.vaccinations = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.vaccinations && message.vaccinations.length) {
              object.vaccinations = [];
              for (var j = 0; j < message.vaccinations.length; ++j)
                object.vaccinations[j] =
                  $root.stronachgroup.first.racehorse360.Vaccination.toObject(
                    message.vaccinations[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListVaccinationsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListVaccinationsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListVaccinationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListVaccinationsResponse;
        })();

        racehorse360.VaccinationFilter = (function () {
          /**
           * Properties of a VaccinationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IVaccinationFilter
           * @property {Array.<string>|null} [ids] VaccinationFilter ids
           * @property {Array.<string>|null} [horseIds] VaccinationFilter horseIds
           */

          /**
           * Constructs a new VaccinationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a VaccinationFilter.
           * @implements IVaccinationFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IVaccinationFilter=} [properties] Properties to set
           */
          function VaccinationFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * VaccinationFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @instance
           */
          VaccinationFilter.prototype.ids = $util.emptyArray;

          /**
           * VaccinationFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @instance
           */
          VaccinationFilter.prototype.horseIds = $util.emptyArray;

          /**
           * Creates a new VaccinationFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.VaccinationFilter} VaccinationFilter instance
           */
          VaccinationFilter.create = function create(properties) {
            return new VaccinationFilter(properties);
          };

          /**
           * Encodes the specified VaccinationFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.VaccinationFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationFilter} message VaccinationFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          VaccinationFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseIds[i]);
            return writer;
          };

          /**
           * Decodes a VaccinationFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.VaccinationFilter} VaccinationFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          VaccinationFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.VaccinationFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a VaccinationFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.VaccinationFilter} VaccinationFilter
           */
          VaccinationFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.VaccinationFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.VaccinationFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a VaccinationFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.VaccinationFilter} message VaccinationFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          VaccinationFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            return object;
          };

          /**
           * Converts this VaccinationFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.VaccinationFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          VaccinationFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return VaccinationFilter;
        })();

        racehorse360.CreateVaccinationRequest = (function () {
          /**
           * Properties of a CreateVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateVaccinationRequest
           * @property {stronachgroup.first.racehorse360.IVaccination|null} [vaccination] CreateVaccinationRequest vaccination
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateVaccinationRequest getOptions
           */

          /**
           * Constructs a new CreateVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateVaccinationRequest.
           * @implements ICreateVaccinationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationRequest=} [properties] Properties to set
           */
          function CreateVaccinationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateVaccinationRequest vaccination.
           * @member {stronachgroup.first.racehorse360.IVaccination|null|undefined} vaccination
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @instance
           */
          CreateVaccinationRequest.prototype.vaccination = null;

          /**
           * CreateVaccinationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @instance
           */
          CreateVaccinationRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateVaccinationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationRequest} CreateVaccinationRequest instance
           */
          CreateVaccinationRequest.create = function create(properties) {
            return new CreateVaccinationRequest(properties);
          };

          /**
           * Encodes the specified CreateVaccinationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateVaccinationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationRequest} message CreateVaccinationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateVaccinationRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.vaccination != null &&
              Object.hasOwnProperty.call(message, "vaccination")
            )
              $root.stronachgroup.first.racehorse360.Vaccination.encode(
                message.vaccination,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateVaccinationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationRequest} CreateVaccinationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateVaccinationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateVaccinationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.vaccination =
                    $root.stronachgroup.first.racehorse360.Vaccination.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateVaccinationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationRequest} CreateVaccinationRequest
           */
          CreateVaccinationRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateVaccinationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateVaccinationRequest();
            if (object.vaccination != null) {
              if (typeof object.vaccination !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateVaccinationRequest.vaccination: object expected"
                );
              message.vaccination =
                $root.stronachgroup.first.racehorse360.Vaccination.fromObject(
                  object.vaccination
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateVaccinationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateVaccinationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateVaccinationRequest} message CreateVaccinationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateVaccinationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.vaccination = null;
              object.getOptions = null;
            }
            if (
              message.vaccination != null &&
              message.hasOwnProperty("vaccination")
            )
              object.vaccination =
                $root.stronachgroup.first.racehorse360.Vaccination.toObject(
                  message.vaccination,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateVaccinationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateVaccinationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateVaccinationRequest;
        })();

        racehorse360.DeleteVaccinationRequest = (function () {
          /**
           * Properties of a DeleteVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteVaccinationRequest
           * @property {string|null} [id] DeleteVaccinationRequest id
           */

          /**
           * Constructs a new DeleteVaccinationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteVaccinationRequest.
           * @implements IDeleteVaccinationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationRequest=} [properties] Properties to set
           */
          function DeleteVaccinationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteVaccinationRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @instance
           */
          DeleteVaccinationRequest.prototype.id = "";

          /**
           * Creates a new DeleteVaccinationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationRequest} DeleteVaccinationRequest instance
           */
          DeleteVaccinationRequest.create = function create(properties) {
            return new DeleteVaccinationRequest(properties);
          };

          /**
           * Encodes the specified DeleteVaccinationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteVaccinationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationRequest} message DeleteVaccinationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteVaccinationRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteVaccinationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationRequest} DeleteVaccinationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteVaccinationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteVaccinationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteVaccinationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationRequest} DeleteVaccinationRequest
           */
          DeleteVaccinationRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteVaccinationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteVaccinationRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteVaccinationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteVaccinationRequest} message DeleteVaccinationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteVaccinationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteVaccinationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteVaccinationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteVaccinationRequest;
        })();

        racehorse360.VaccinationComment = (function () {
          /**
           * Properties of a VaccinationComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IVaccinationComment
           * @property {string|null} [id] VaccinationComment id
           * @property {string|null} [vaccinationId] VaccinationComment vaccinationId
           * @property {string|null} [body] VaccinationComment body
           * @property {string|null} [createdOn] VaccinationComment createdOn
           * @property {string|null} [updatedOn] VaccinationComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] VaccinationComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] VaccinationComment updatedBy
           */

          /**
           * Constructs a new VaccinationComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a VaccinationComment.
           * @implements IVaccinationComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IVaccinationComment=} [properties] Properties to set
           */
          function VaccinationComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * VaccinationComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.id = "";

          /**
           * VaccinationComment vaccinationId.
           * @member {string} vaccinationId
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.vaccinationId = "";

          /**
           * VaccinationComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.body = "";

          /**
           * VaccinationComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.createdOn = "";

          /**
           * VaccinationComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.updatedOn = "";

          /**
           * VaccinationComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.createdBy = null;

          /**
           * VaccinationComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           */
          VaccinationComment.prototype.updatedBy = null;

          /**
           * Creates a new VaccinationComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.VaccinationComment} VaccinationComment instance
           */
          VaccinationComment.create = function create(properties) {
            return new VaccinationComment(properties);
          };

          /**
           * Encodes the specified VaccinationComment message. Does not implicitly {@link stronachgroup.first.racehorse360.VaccinationComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationComment} message VaccinationComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          VaccinationComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.vaccinationId != null &&
              Object.hasOwnProperty.call(message, "vaccinationId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.vaccinationId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.body);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a VaccinationComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.VaccinationComment} VaccinationComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          VaccinationComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.VaccinationComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.vaccinationId = reader.string();
                  break;
                case 3:
                  message.body = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a VaccinationComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.VaccinationComment} VaccinationComment
           */
          VaccinationComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.VaccinationComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.VaccinationComment();
            if (object.id != null) message.id = String(object.id);
            if (object.vaccinationId != null)
              message.vaccinationId = String(object.vaccinationId);
            if (object.body != null) message.body = String(object.body);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a VaccinationComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @static
           * @param {stronachgroup.first.racehorse360.VaccinationComment} message VaccinationComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          VaccinationComment.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.vaccinationId = "";
              object.body = "";
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.vaccinationId != null &&
              message.hasOwnProperty("vaccinationId")
            )
              object.vaccinationId = message.vaccinationId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this VaccinationComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.VaccinationComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          VaccinationComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return VaccinationComment;
        })();

        racehorse360.ListVaccinationCommentsRequest = (function () {
          /**
           * Properties of a ListVaccinationCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListVaccinationCommentsRequest
           * @property {stronachgroup.first.racehorse360.IVaccinationCommentFilter|null} [query] ListVaccinationCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListVaccinationCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListVaccinationCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListVaccinationCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListVaccinationCommentsRequest.
           * @implements IListVaccinationCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsRequest=} [properties] Properties to set
           */
          function ListVaccinationCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListVaccinationCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IVaccinationCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @instance
           */
          ListVaccinationCommentsRequest.prototype.query = null;

          /**
           * ListVaccinationCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @instance
           */
          ListVaccinationCommentsRequest.prototype.getOptions = null;

          /**
           * ListVaccinationCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @instance
           */
          ListVaccinationCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListVaccinationCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} ListVaccinationCommentsRequest instance
           */
          ListVaccinationCommentsRequest.create = function create(properties) {
            return new ListVaccinationCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListVaccinationCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListVaccinationCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsRequest} message ListVaccinationCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListVaccinationCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.VaccinationCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListVaccinationCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} ListVaccinationCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListVaccinationCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.VaccinationCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListVaccinationCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} ListVaccinationCommentsRequest
           */
          ListVaccinationCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListVaccinationCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.VaccinationCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListVaccinationCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} message ListVaccinationCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListVaccinationCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.VaccinationCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListVaccinationCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListVaccinationCommentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListVaccinationCommentsRequest;
        })();

        racehorse360.ListVaccinationCommentsResponse = (function () {
          /**
           * Properties of a ListVaccinationCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListVaccinationCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IVaccinationComment>|null} [vaccinationComments] ListVaccinationCommentsResponse vaccinationComments
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListVaccinationCommentsResponse pagingInfo
           */

          /**
           * Constructs a new ListVaccinationCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListVaccinationCommentsResponse.
           * @implements IListVaccinationCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsResponse=} [properties] Properties to set
           */
          function ListVaccinationCommentsResponse(properties) {
            this.vaccinationComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListVaccinationCommentsResponse vaccinationComments.
           * @member {Array.<stronachgroup.first.racehorse360.IVaccinationComment>} vaccinationComments
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @instance
           */
          ListVaccinationCommentsResponse.prototype.vaccinationComments =
            $util.emptyArray;

          /**
           * ListVaccinationCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @instance
           */
          ListVaccinationCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListVaccinationCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsResponse} ListVaccinationCommentsResponse instance
           */
          ListVaccinationCommentsResponse.create = function create(properties) {
            return new ListVaccinationCommentsResponse(properties);
          };

          /**
           * Encodes the specified ListVaccinationCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListVaccinationCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsResponse} message ListVaccinationCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListVaccinationCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.vaccinationComments != null &&
              message.vaccinationComments.length
            )
              for (var i = 0; i < message.vaccinationComments.length; ++i)
                $root.stronachgroup.first.racehorse360.VaccinationComment.encode(
                  message.vaccinationComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListVaccinationCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsResponse} ListVaccinationCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListVaccinationCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.vaccinationComments &&
                      message.vaccinationComments.length
                    )
                  )
                    message.vaccinationComments = [];
                  message.vaccinationComments.push(
                    $root.stronachgroup.first.racehorse360.VaccinationComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListVaccinationCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListVaccinationCommentsResponse} ListVaccinationCommentsResponse
           */
          ListVaccinationCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListVaccinationCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse();
            if (object.vaccinationComments) {
              if (!Array.isArray(object.vaccinationComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationCommentsResponse.vaccinationComments: array expected"
                );
              message.vaccinationComments = [];
              for (var i = 0; i < object.vaccinationComments.length; ++i) {
                if (typeof object.vaccinationComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListVaccinationCommentsResponse.vaccinationComments: object expected"
                  );
                message.vaccinationComments[i] =
                  $root.stronachgroup.first.racehorse360.VaccinationComment.fromObject(
                    object.vaccinationComments[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListVaccinationCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListVaccinationCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListVaccinationCommentsResponse} message ListVaccinationCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListVaccinationCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.vaccinationComments = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.vaccinationComments &&
              message.vaccinationComments.length
            ) {
              object.vaccinationComments = [];
              for (var j = 0; j < message.vaccinationComments.length; ++j)
                object.vaccinationComments[j] =
                  $root.stronachgroup.first.racehorse360.VaccinationComment.toObject(
                    message.vaccinationComments[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListVaccinationCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListVaccinationCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListVaccinationCommentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListVaccinationCommentsResponse;
        })();

        racehorse360.VaccinationCommentFilter = (function () {
          /**
           * Properties of a VaccinationCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IVaccinationCommentFilter
           * @property {Array.<string>|null} [ids] VaccinationCommentFilter ids
           * @property {Array.<string>|null} [vaccinationIds] VaccinationCommentFilter vaccinationIds
           */

          /**
           * Constructs a new VaccinationCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a VaccinationCommentFilter.
           * @implements IVaccinationCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IVaccinationCommentFilter=} [properties] Properties to set
           */
          function VaccinationCommentFilter(properties) {
            this.ids = [];
            this.vaccinationIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * VaccinationCommentFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @instance
           */
          VaccinationCommentFilter.prototype.ids = $util.emptyArray;

          /**
           * VaccinationCommentFilter vaccinationIds.
           * @member {Array.<string>} vaccinationIds
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @instance
           */
          VaccinationCommentFilter.prototype.vaccinationIds = $util.emptyArray;

          /**
           * Creates a new VaccinationCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.VaccinationCommentFilter} VaccinationCommentFilter instance
           */
          VaccinationCommentFilter.create = function create(properties) {
            return new VaccinationCommentFilter(properties);
          };

          /**
           * Encodes the specified VaccinationCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.VaccinationCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVaccinationCommentFilter} message VaccinationCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          VaccinationCommentFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.vaccinationIds != null && message.vaccinationIds.length)
              for (var i = 0; i < message.vaccinationIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.vaccinationIds[i]);
            return writer;
          };

          /**
           * Decodes a VaccinationCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.VaccinationCommentFilter} VaccinationCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          VaccinationCommentFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.VaccinationCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(message.vaccinationIds && message.vaccinationIds.length)
                  )
                    message.vaccinationIds = [];
                  message.vaccinationIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a VaccinationCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.VaccinationCommentFilter} VaccinationCommentFilter
           */
          VaccinationCommentFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.VaccinationCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.VaccinationCommentFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationCommentFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.vaccinationIds) {
              if (!Array.isArray(object.vaccinationIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VaccinationCommentFilter.vaccinationIds: array expected"
                );
              message.vaccinationIds = [];
              for (var i = 0; i < object.vaccinationIds.length; ++i)
                message.vaccinationIds[i] = String(object.vaccinationIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a VaccinationCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.VaccinationCommentFilter} message VaccinationCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          VaccinationCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.vaccinationIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.vaccinationIds && message.vaccinationIds.length) {
              object.vaccinationIds = [];
              for (var j = 0; j < message.vaccinationIds.length; ++j)
                object.vaccinationIds[j] = message.vaccinationIds[j];
            }
            return object;
          };

          /**
           * Converts this VaccinationCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.VaccinationCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          VaccinationCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return VaccinationCommentFilter;
        })();

        racehorse360.CreateVaccinationCommentRequest = (function () {
          /**
           * Properties of a CreateVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateVaccinationCommentRequest
           * @property {stronachgroup.first.racehorse360.IVaccinationComment|null} [vaccinationComment] CreateVaccinationCommentRequest vaccinationComment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateVaccinationCommentRequest getOptions
           */

          /**
           * Constructs a new CreateVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateVaccinationCommentRequest.
           * @implements ICreateVaccinationCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationCommentRequest=} [properties] Properties to set
           */
          function CreateVaccinationCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateVaccinationCommentRequest vaccinationComment.
           * @member {stronachgroup.first.racehorse360.IVaccinationComment|null|undefined} vaccinationComment
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @instance
           */
          CreateVaccinationCommentRequest.prototype.vaccinationComment = null;

          /**
           * CreateVaccinationCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @instance
           */
          CreateVaccinationCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateVaccinationCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} CreateVaccinationCommentRequest instance
           */
          CreateVaccinationCommentRequest.create = function create(properties) {
            return new CreateVaccinationCommentRequest(properties);
          };

          /**
           * Encodes the specified CreateVaccinationCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateVaccinationCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationCommentRequest} message CreateVaccinationCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateVaccinationCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.vaccinationComment != null &&
              Object.hasOwnProperty.call(message, "vaccinationComment")
            )
              $root.stronachgroup.first.racehorse360.VaccinationComment.encode(
                message.vaccinationComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateVaccinationCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} CreateVaccinationCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateVaccinationCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.vaccinationComment =
                    $root.stronachgroup.first.racehorse360.VaccinationComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateVaccinationCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} CreateVaccinationCommentRequest
           */
          CreateVaccinationCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateVaccinationCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest();
            if (object.vaccinationComment != null) {
              if (typeof object.vaccinationComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateVaccinationCommentRequest.vaccinationComment: object expected"
                );
              message.vaccinationComment =
                $root.stronachgroup.first.racehorse360.VaccinationComment.fromObject(
                  object.vaccinationComment
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateVaccinationCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateVaccinationCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} message CreateVaccinationCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateVaccinationCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.vaccinationComment = null;
              object.getOptions = null;
            }
            if (
              message.vaccinationComment != null &&
              message.hasOwnProperty("vaccinationComment")
            )
              object.vaccinationComment =
                $root.stronachgroup.first.racehorse360.VaccinationComment.toObject(
                  message.vaccinationComment,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateVaccinationCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateVaccinationCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateVaccinationCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateVaccinationCommentRequest;
        })();

        racehorse360.DeleteVaccinationCommentRequest = (function () {
          /**
           * Properties of a DeleteVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteVaccinationCommentRequest
           * @property {string|null} [id] DeleteVaccinationCommentRequest id
           */

          /**
           * Constructs a new DeleteVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteVaccinationCommentRequest.
           * @implements IDeleteVaccinationCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationCommentRequest=} [properties] Properties to set
           */
          function DeleteVaccinationCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteVaccinationCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @instance
           */
          DeleteVaccinationCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteVaccinationCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} DeleteVaccinationCommentRequest instance
           */
          DeleteVaccinationCommentRequest.create = function create(properties) {
            return new DeleteVaccinationCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteVaccinationCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationCommentRequest} message DeleteVaccinationCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteVaccinationCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteVaccinationCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} DeleteVaccinationCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteVaccinationCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteVaccinationCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} DeleteVaccinationCommentRequest
           */
          DeleteVaccinationCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteVaccinationCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteVaccinationCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} message DeleteVaccinationCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteVaccinationCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteVaccinationCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteVaccinationCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteVaccinationCommentRequest;
        })();

        racehorse360.UpdateVaccinationCommentRequest = (function () {
          /**
           * Properties of an UpdateVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateVaccinationCommentRequest
           * @property {stronachgroup.first.racehorse360.IVaccinationComment|null} [vaccinationComment] UpdateVaccinationCommentRequest vaccinationComment
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateVaccinationCommentRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateVaccinationCommentRequest getOptions
           */

          /**
           * Constructs a new UpdateVaccinationCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateVaccinationCommentRequest.
           * @implements IUpdateVaccinationCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateVaccinationCommentRequest=} [properties] Properties to set
           */
          function UpdateVaccinationCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateVaccinationCommentRequest vaccinationComment.
           * @member {stronachgroup.first.racehorse360.IVaccinationComment|null|undefined} vaccinationComment
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @instance
           */
          UpdateVaccinationCommentRequest.prototype.vaccinationComment = null;

          /**
           * UpdateVaccinationCommentRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @instance
           */
          UpdateVaccinationCommentRequest.prototype.updateMask = null;

          /**
           * UpdateVaccinationCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @instance
           */
          UpdateVaccinationCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateVaccinationCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateVaccinationCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} UpdateVaccinationCommentRequest instance
           */
          UpdateVaccinationCommentRequest.create = function create(properties) {
            return new UpdateVaccinationCommentRequest(properties);
          };

          /**
           * Encodes the specified UpdateVaccinationCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateVaccinationCommentRequest} message UpdateVaccinationCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateVaccinationCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.vaccinationComment != null &&
              Object.hasOwnProperty.call(message, "vaccinationComment")
            )
              $root.stronachgroup.first.racehorse360.VaccinationComment.encode(
                message.vaccinationComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateVaccinationCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} UpdateVaccinationCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateVaccinationCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.vaccinationComment =
                    $root.stronachgroup.first.racehorse360.VaccinationComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateVaccinationCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} UpdateVaccinationCommentRequest
           */
          UpdateVaccinationCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateVaccinationCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest();
            if (object.vaccinationComment != null) {
              if (typeof object.vaccinationComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest.vaccinationComment: object expected"
                );
              message.vaccinationComment =
                $root.stronachgroup.first.racehorse360.VaccinationComment.fromObject(
                  object.vaccinationComment
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateVaccinationCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} message UpdateVaccinationCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateVaccinationCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.vaccinationComment = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.vaccinationComment != null &&
              message.hasOwnProperty("vaccinationComment")
            )
              object.vaccinationComment =
                $root.stronachgroup.first.racehorse360.VaccinationComment.toObject(
                  message.vaccinationComment,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateVaccinationCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateVaccinationCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateVaccinationCommentRequest;
        })();

        racehorse360.Injection = (function () {
          /**
           * Properties of an Injection.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInjection
           * @property {string|null} [id] Injection id
           * @property {string|null} [medicineId] Injection medicineId
           * @property {string|null} [vaccinationId] Injection vaccinationId
           * @property {string|null} [injectionDate] Injection injectionDate
           * @property {string|null} [customExpirationDate] Injection customExpirationDate
           * @property {stronachgroup.first.racehorse360.InjectionDataSource|null} [dataSource] Injection dataSource
           * @property {string|null} [comment] Injection comment
           * @property {string|null} [manufacturer] Injection manufacturer
           * @property {stronachgroup.first.racehorse360.IVaccination|null} [vaccination] Injection vaccination
           * @property {stronachgroup.first.racehorse360.IMedicine|null} [medicine] Injection medicine
           * @property {string|null} [createdOn] Injection createdOn
           * @property {string|null} [updatedOn] Injection updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] Injection createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] Injection updatedBy
           */

          /**
           * Constructs a new Injection.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an Injection.
           * @implements IInjection
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInjection=} [properties] Properties to set
           */
          function Injection(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Injection id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.id = "";

          /**
           * Injection medicineId.
           * @member {string} medicineId
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.medicineId = "";

          /**
           * Injection vaccinationId.
           * @member {string} vaccinationId
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.vaccinationId = "";

          /**
           * Injection injectionDate.
           * @member {string} injectionDate
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.injectionDate = "";

          /**
           * Injection customExpirationDate.
           * @member {string} customExpirationDate
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.customExpirationDate = "";

          /**
           * Injection dataSource.
           * @member {stronachgroup.first.racehorse360.InjectionDataSource} dataSource
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.dataSource = 0;

          /**
           * Injection comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.comment = "";

          /**
           * Injection manufacturer.
           * @member {string} manufacturer
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.manufacturer = "";

          /**
           * Injection vaccination.
           * @member {stronachgroup.first.racehorse360.IVaccination|null|undefined} vaccination
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.vaccination = null;

          /**
           * Injection medicine.
           * @member {stronachgroup.first.racehorse360.IMedicine|null|undefined} medicine
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.medicine = null;

          /**
           * Injection createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.createdOn = "";

          /**
           * Injection updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.updatedOn = "";

          /**
           * Injection createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.createdBy = null;

          /**
           * Injection updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           */
          Injection.prototype.updatedBy = null;

          /**
           * Creates a new Injection instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Injection
           * @static
           * @param {stronachgroup.first.racehorse360.IInjection=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Injection} Injection instance
           */
          Injection.create = function create(properties) {
            return new Injection(properties);
          };

          /**
           * Encodes the specified Injection message. Does not implicitly {@link stronachgroup.first.racehorse360.Injection.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Injection
           * @static
           * @param {stronachgroup.first.racehorse360.IInjection} message Injection message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Injection.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.medicineId != null &&
              Object.hasOwnProperty.call(message, "medicineId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.medicineId);
            if (
              message.vaccinationId != null &&
              Object.hasOwnProperty.call(message, "vaccinationId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.vaccinationId);
            if (
              message.injectionDate != null &&
              Object.hasOwnProperty.call(message, "injectionDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.injectionDate);
            if (
              message.customExpirationDate != null &&
              Object.hasOwnProperty.call(message, "customExpirationDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.customExpirationDate);
            if (
              message.dataSource != null &&
              Object.hasOwnProperty.call(message, "dataSource")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.dataSource);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.comment);
            if (
              message.manufacturer != null &&
              Object.hasOwnProperty.call(message, "manufacturer")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.manufacturer);
            if (
              message.vaccination != null &&
              Object.hasOwnProperty.call(message, "vaccination")
            )
              $root.stronachgroup.first.racehorse360.Vaccination.encode(
                message.vaccination,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.medicine != null &&
              Object.hasOwnProperty.call(message, "medicine")
            )
              $root.stronachgroup.first.racehorse360.Medicine.encode(
                message.medicine,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an Injection message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Injection
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Injection} Injection
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Injection.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Injection();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.medicineId = reader.string();
                  break;
                case 3:
                  message.vaccinationId = reader.string();
                  break;
                case 4:
                  message.injectionDate = reader.string();
                  break;
                case 5:
                  message.customExpirationDate = reader.string();
                  break;
                case 6:
                  message.dataSource = reader.int32();
                  break;
                case 7:
                  message.comment = reader.string();
                  break;
                case 8:
                  message.manufacturer = reader.string();
                  break;
                case 9:
                  message.vaccination =
                    $root.stronachgroup.first.racehorse360.Vaccination.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.medicine =
                    $root.stronachgroup.first.racehorse360.Medicine.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an Injection message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Injection
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Injection} Injection
           */
          Injection.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Injection
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.Injection();
            if (object.id != null) message.id = String(object.id);
            if (object.medicineId != null)
              message.medicineId = String(object.medicineId);
            if (object.vaccinationId != null)
              message.vaccinationId = String(object.vaccinationId);
            if (object.injectionDate != null)
              message.injectionDate = String(object.injectionDate);
            if (object.customExpirationDate != null)
              message.customExpirationDate = String(
                object.customExpirationDate
              );
            switch (object.dataSource) {
              case "INJECTION_DATA_SOURCE_INVALID":
              case 0:
                message.dataSource = 0;
                break;
              case "INJECTION_DATA_SOURCE_RH360":
              case 1:
                message.dataSource = 1;
                break;
              case "INJECTION_DATA_SOURCE_INCOMPASS":
              case 2:
                message.dataSource = 2;
                break;
            }
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.manufacturer != null)
              message.manufacturer = String(object.manufacturer);
            if (object.vaccination != null) {
              if (typeof object.vaccination !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Injection.vaccination: object expected"
                );
              message.vaccination =
                $root.stronachgroup.first.racehorse360.Vaccination.fromObject(
                  object.vaccination
                );
            }
            if (object.medicine != null) {
              if (typeof object.medicine !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Injection.medicine: object expected"
                );
              message.medicine =
                $root.stronachgroup.first.racehorse360.Medicine.fromObject(
                  object.medicine
                );
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Injection.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Injection.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an Injection message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Injection
           * @static
           * @param {stronachgroup.first.racehorse360.Injection} message Injection
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Injection.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.medicineId = "";
              object.vaccinationId = "";
              object.injectionDate = "";
              object.customExpirationDate = "";
              object.dataSource =
                options.enums === String ? "INJECTION_DATA_SOURCE_INVALID" : 0;
              object.comment = "";
              object.manufacturer = "";
              object.vaccination = null;
              object.medicine = null;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.medicineId != null &&
              message.hasOwnProperty("medicineId")
            )
              object.medicineId = message.medicineId;
            if (
              message.vaccinationId != null &&
              message.hasOwnProperty("vaccinationId")
            )
              object.vaccinationId = message.vaccinationId;
            if (
              message.injectionDate != null &&
              message.hasOwnProperty("injectionDate")
            )
              object.injectionDate = message.injectionDate;
            if (
              message.customExpirationDate != null &&
              message.hasOwnProperty("customExpirationDate")
            )
              object.customExpirationDate = message.customExpirationDate;
            if (
              message.dataSource != null &&
              message.hasOwnProperty("dataSource")
            )
              object.dataSource =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.InjectionDataSource[
                      message.dataSource
                    ]
                  : message.dataSource;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.manufacturer != null &&
              message.hasOwnProperty("manufacturer")
            )
              object.manufacturer = message.manufacturer;
            if (
              message.vaccination != null &&
              message.hasOwnProperty("vaccination")
            )
              object.vaccination =
                $root.stronachgroup.first.racehorse360.Vaccination.toObject(
                  message.vaccination,
                  options
                );
            if (message.medicine != null && message.hasOwnProperty("medicine"))
              object.medicine =
                $root.stronachgroup.first.racehorse360.Medicine.toObject(
                  message.medicine,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this Injection to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Injection
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Injection.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Injection;
        })();

        racehorse360.AddVaccineInjectionRequest = (function () {
          /**
           * Properties of an AddVaccineInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAddVaccineInjectionRequest
           * @property {stronachgroup.first.racehorse360.IInjection|null} [injection] AddVaccineInjectionRequest injection
           * @property {string|null} [horseId] AddVaccineInjectionRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AddVaccineInjectionRequest getOptions
           */

          /**
           * Constructs a new AddVaccineInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AddVaccineInjectionRequest.
           * @implements IAddVaccineInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAddVaccineInjectionRequest=} [properties] Properties to set
           */
          function AddVaccineInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AddVaccineInjectionRequest injection.
           * @member {stronachgroup.first.racehorse360.IInjection|null|undefined} injection
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @instance
           */
          AddVaccineInjectionRequest.prototype.injection = null;

          /**
           * AddVaccineInjectionRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @instance
           */
          AddVaccineInjectionRequest.prototype.horseId = "";

          /**
           * AddVaccineInjectionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @instance
           */
          AddVaccineInjectionRequest.prototype.getOptions = null;

          /**
           * Creates a new AddVaccineInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAddVaccineInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AddVaccineInjectionRequest} AddVaccineInjectionRequest instance
           */
          AddVaccineInjectionRequest.create = function create(properties) {
            return new AddVaccineInjectionRequest(properties);
          };

          /**
           * Encodes the specified AddVaccineInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AddVaccineInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAddVaccineInjectionRequest} message AddVaccineInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AddVaccineInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.injection != null &&
              Object.hasOwnProperty.call(message, "injection")
            )
              $root.stronachgroup.first.racehorse360.Injection.encode(
                message.injection,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AddVaccineInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AddVaccineInjectionRequest} AddVaccineInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AddVaccineInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AddVaccineInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.injection =
                    $root.stronachgroup.first.racehorse360.Injection.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AddVaccineInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AddVaccineInjectionRequest} AddVaccineInjectionRequest
           */
          AddVaccineInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AddVaccineInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AddVaccineInjectionRequest();
            if (object.injection != null) {
              if (typeof object.injection !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AddVaccineInjectionRequest.injection: object expected"
                );
              message.injection =
                $root.stronachgroup.first.racehorse360.Injection.fromObject(
                  object.injection
                );
            }
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AddVaccineInjectionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AddVaccineInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AddVaccineInjectionRequest} message AddVaccineInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AddVaccineInjectionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.injection = null;
              object.horseId = "";
              object.getOptions = null;
            }
            if (
              message.injection != null &&
              message.hasOwnProperty("injection")
            )
              object.injection =
                $root.stronachgroup.first.racehorse360.Injection.toObject(
                  message.injection,
                  options
                );
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AddVaccineInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AddVaccineInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AddVaccineInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AddVaccineInjectionRequest;
        })();

        racehorse360.AddBoosterInjectionRequest = (function () {
          /**
           * Properties of an AddBoosterInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAddBoosterInjectionRequest
           * @property {stronachgroup.first.racehorse360.IInjection|null} [injection] AddBoosterInjectionRequest injection
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AddBoosterInjectionRequest getOptions
           */

          /**
           * Constructs a new AddBoosterInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AddBoosterInjectionRequest.
           * @implements IAddBoosterInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAddBoosterInjectionRequest=} [properties] Properties to set
           */
          function AddBoosterInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AddBoosterInjectionRequest injection.
           * @member {stronachgroup.first.racehorse360.IInjection|null|undefined} injection
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @instance
           */
          AddBoosterInjectionRequest.prototype.injection = null;

          /**
           * AddBoosterInjectionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @instance
           */
          AddBoosterInjectionRequest.prototype.getOptions = null;

          /**
           * Creates a new AddBoosterInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAddBoosterInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AddBoosterInjectionRequest} AddBoosterInjectionRequest instance
           */
          AddBoosterInjectionRequest.create = function create(properties) {
            return new AddBoosterInjectionRequest(properties);
          };

          /**
           * Encodes the specified AddBoosterInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AddBoosterInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAddBoosterInjectionRequest} message AddBoosterInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AddBoosterInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.injection != null &&
              Object.hasOwnProperty.call(message, "injection")
            )
              $root.stronachgroup.first.racehorse360.Injection.encode(
                message.injection,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AddBoosterInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AddBoosterInjectionRequest} AddBoosterInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AddBoosterInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AddBoosterInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.injection =
                    $root.stronachgroup.first.racehorse360.Injection.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AddBoosterInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AddBoosterInjectionRequest} AddBoosterInjectionRequest
           */
          AddBoosterInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AddBoosterInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AddBoosterInjectionRequest();
            if (object.injection != null) {
              if (typeof object.injection !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AddBoosterInjectionRequest.injection: object expected"
                );
              message.injection =
                $root.stronachgroup.first.racehorse360.Injection.fromObject(
                  object.injection
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AddBoosterInjectionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AddBoosterInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AddBoosterInjectionRequest} message AddBoosterInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AddBoosterInjectionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.injection = null;
              object.getOptions = null;
            }
            if (
              message.injection != null &&
              message.hasOwnProperty("injection")
            )
              object.injection =
                $root.stronachgroup.first.racehorse360.Injection.toObject(
                  message.injection,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AddBoosterInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AddBoosterInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AddBoosterInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AddBoosterInjectionRequest;
        })();

        racehorse360.CreateInjectionRequest = (function () {
          /**
           * Properties of a CreateInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateInjectionRequest
           * @property {stronachgroup.first.racehorse360.IInjection|null} [injection] CreateInjectionRequest injection
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateInjectionRequest getOptions
           */

          /**
           * Constructs a new CreateInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateInjectionRequest.
           * @implements ICreateInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateInjectionRequest=} [properties] Properties to set
           */
          function CreateInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateInjectionRequest injection.
           * @member {stronachgroup.first.racehorse360.IInjection|null|undefined} injection
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @instance
           */
          CreateInjectionRequest.prototype.injection = null;

          /**
           * CreateInjectionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @instance
           */
          CreateInjectionRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateInjectionRequest} CreateInjectionRequest instance
           */
          CreateInjectionRequest.create = function create(properties) {
            return new CreateInjectionRequest(properties);
          };

          /**
           * Encodes the specified CreateInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateInjectionRequest} message CreateInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.injection != null &&
              Object.hasOwnProperty.call(message, "injection")
            )
              $root.stronachgroup.first.racehorse360.Injection.encode(
                message.injection,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateInjectionRequest} CreateInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.injection =
                    $root.stronachgroup.first.racehorse360.Injection.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateInjectionRequest} CreateInjectionRequest
           */
          CreateInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateInjectionRequest();
            if (object.injection != null) {
              if (typeof object.injection !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateInjectionRequest.injection: object expected"
                );
              message.injection =
                $root.stronachgroup.first.racehorse360.Injection.fromObject(
                  object.injection
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateInjectionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateInjectionRequest} message CreateInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateInjectionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.injection = null;
              object.getOptions = null;
            }
            if (
              message.injection != null &&
              message.hasOwnProperty("injection")
            )
              object.injection =
                $root.stronachgroup.first.racehorse360.Injection.toObject(
                  message.injection,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateInjectionRequest;
        })();

        racehorse360.DeleteInjectionRequest = (function () {
          /**
           * Properties of a DeleteInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteInjectionRequest
           * @property {string|null} [id] DeleteInjectionRequest id
           */

          /**
           * Constructs a new DeleteInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteInjectionRequest.
           * @implements IDeleteInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteInjectionRequest=} [properties] Properties to set
           */
          function DeleteInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteInjectionRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @instance
           */
          DeleteInjectionRequest.prototype.id = "";

          /**
           * Creates a new DeleteInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteInjectionRequest} DeleteInjectionRequest instance
           */
          DeleteInjectionRequest.create = function create(properties) {
            return new DeleteInjectionRequest(properties);
          };

          /**
           * Encodes the specified DeleteInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteInjectionRequest} message DeleteInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteInjectionRequest} DeleteInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteInjectionRequest} DeleteInjectionRequest
           */
          DeleteInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteInjectionRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteInjectionRequest} message DeleteInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteInjectionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteInjectionRequest;
        })();

        racehorse360.UpdateInjectionRequest = (function () {
          /**
           * Properties of an UpdateInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateInjectionRequest
           * @property {stronachgroup.first.racehorse360.IInjection|null} [injection] UpdateInjectionRequest injection
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateInjectionRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateInjectionRequest getOptions
           */

          /**
           * Constructs a new UpdateInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateInjectionRequest.
           * @implements IUpdateInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateInjectionRequest=} [properties] Properties to set
           */
          function UpdateInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateInjectionRequest injection.
           * @member {stronachgroup.first.racehorse360.IInjection|null|undefined} injection
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @instance
           */
          UpdateInjectionRequest.prototype.injection = null;

          /**
           * UpdateInjectionRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @instance
           */
          UpdateInjectionRequest.prototype.updateMask = null;

          /**
           * UpdateInjectionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @instance
           */
          UpdateInjectionRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateInjectionRequest} UpdateInjectionRequest instance
           */
          UpdateInjectionRequest.create = function create(properties) {
            return new UpdateInjectionRequest(properties);
          };

          /**
           * Encodes the specified UpdateInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateInjectionRequest} message UpdateInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.injection != null &&
              Object.hasOwnProperty.call(message, "injection")
            )
              $root.stronachgroup.first.racehorse360.Injection.encode(
                message.injection,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateInjectionRequest} UpdateInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.injection =
                    $root.stronachgroup.first.racehorse360.Injection.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateInjectionRequest} UpdateInjectionRequest
           */
          UpdateInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpdateInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateInjectionRequest();
            if (object.injection != null) {
              if (typeof object.injection !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateInjectionRequest.injection: object expected"
                );
              message.injection =
                $root.stronachgroup.first.racehorse360.Injection.fromObject(
                  object.injection
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateInjectionRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateInjectionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateInjectionRequest} message UpdateInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateInjectionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.injection = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.injection != null &&
              message.hasOwnProperty("injection")
            )
              object.injection =
                $root.stronachgroup.first.racehorse360.Injection.toObject(
                  message.injection,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateInjectionRequest;
        })();

        racehorse360.ListInjectionsRequest = (function () {
          /**
           * Properties of a ListInjectionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListInjectionsRequest
           * @property {stronachgroup.first.racehorse360.IInjectionFilter|null} [query] ListInjectionsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListInjectionsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListInjectionsRequest pagingOptions
           */

          /**
           * Constructs a new ListInjectionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListInjectionsRequest.
           * @implements IListInjectionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListInjectionsRequest=} [properties] Properties to set
           */
          function ListInjectionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListInjectionsRequest query.
           * @member {stronachgroup.first.racehorse360.IInjectionFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @instance
           */
          ListInjectionsRequest.prototype.query = null;

          /**
           * ListInjectionsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @instance
           */
          ListInjectionsRequest.prototype.getOptions = null;

          /**
           * ListInjectionsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @instance
           */
          ListInjectionsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListInjectionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListInjectionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListInjectionsRequest} ListInjectionsRequest instance
           */
          ListInjectionsRequest.create = function create(properties) {
            return new ListInjectionsRequest(properties);
          };

          /**
           * Encodes the specified ListInjectionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListInjectionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListInjectionsRequest} message ListInjectionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListInjectionsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.InjectionFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListInjectionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListInjectionsRequest} ListInjectionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListInjectionsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListInjectionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.InjectionFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListInjectionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListInjectionsRequest} ListInjectionsRequest
           */
          ListInjectionsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListInjectionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListInjectionsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListInjectionsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.InjectionFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListInjectionsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListInjectionsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListInjectionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListInjectionsRequest} message ListInjectionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListInjectionsRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.InjectionFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListInjectionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListInjectionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListInjectionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListInjectionsRequest;
        })();

        racehorse360.GetInjectionRequest = (function () {
          /**
           * Properties of a GetInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetInjectionRequest
           * @property {string|null} [id] GetInjectionRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetInjectionRequest getOptions
           */

          /**
           * Constructs a new GetInjectionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetInjectionRequest.
           * @implements IGetInjectionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetInjectionRequest=} [properties] Properties to set
           */
          function GetInjectionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetInjectionRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @instance
           */
          GetInjectionRequest.prototype.id = "";

          /**
           * GetInjectionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @instance
           */
          GetInjectionRequest.prototype.getOptions = null;

          /**
           * Creates a new GetInjectionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetInjectionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetInjectionRequest} GetInjectionRequest instance
           */
          GetInjectionRequest.create = function create(properties) {
            return new GetInjectionRequest(properties);
          };

          /**
           * Encodes the specified GetInjectionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetInjectionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetInjectionRequest} message GetInjectionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetInjectionRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetInjectionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetInjectionRequest} GetInjectionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetInjectionRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetInjectionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetInjectionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetInjectionRequest} GetInjectionRequest
           */
          GetInjectionRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetInjectionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetInjectionRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetInjectionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetInjectionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetInjectionRequest} message GetInjectionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetInjectionRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetInjectionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetInjectionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetInjectionRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetInjectionRequest;
        })();

        racehorse360.ListInjectionsResponse = (function () {
          /**
           * Properties of a ListInjectionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListInjectionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IInjection>|null} [injections] ListInjectionsResponse injections
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListInjectionsResponse pagingInfo
           */

          /**
           * Constructs a new ListInjectionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListInjectionsResponse.
           * @implements IListInjectionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListInjectionsResponse=} [properties] Properties to set
           */
          function ListInjectionsResponse(properties) {
            this.injections = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListInjectionsResponse injections.
           * @member {Array.<stronachgroup.first.racehorse360.IInjection>} injections
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @instance
           */
          ListInjectionsResponse.prototype.injections = $util.emptyArray;

          /**
           * ListInjectionsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @instance
           */
          ListInjectionsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListInjectionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListInjectionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListInjectionsResponse} ListInjectionsResponse instance
           */
          ListInjectionsResponse.create = function create(properties) {
            return new ListInjectionsResponse(properties);
          };

          /**
           * Encodes the specified ListInjectionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListInjectionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListInjectionsResponse} message ListInjectionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListInjectionsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.injections != null && message.injections.length)
              for (var i = 0; i < message.injections.length; ++i)
                $root.stronachgroup.first.racehorse360.Injection.encode(
                  message.injections[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListInjectionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListInjectionsResponse} ListInjectionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListInjectionsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListInjectionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.injections && message.injections.length))
                    message.injections = [];
                  message.injections.push(
                    $root.stronachgroup.first.racehorse360.Injection.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListInjectionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListInjectionsResponse} ListInjectionsResponse
           */
          ListInjectionsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListInjectionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListInjectionsResponse();
            if (object.injections) {
              if (!Array.isArray(object.injections))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListInjectionsResponse.injections: array expected"
                );
              message.injections = [];
              for (var i = 0; i < object.injections.length; ++i) {
                if (typeof object.injections[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListInjectionsResponse.injections: object expected"
                  );
                message.injections[i] =
                  $root.stronachgroup.first.racehorse360.Injection.fromObject(
                    object.injections[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListInjectionsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListInjectionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListInjectionsResponse} message ListInjectionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListInjectionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.injections = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.injections && message.injections.length) {
              object.injections = [];
              for (var j = 0; j < message.injections.length; ++j)
                object.injections[j] =
                  $root.stronachgroup.first.racehorse360.Injection.toObject(
                    message.injections[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListInjectionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListInjectionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListInjectionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListInjectionsResponse;
        })();

        racehorse360.InjectionFilter = (function () {
          /**
           * Properties of an InjectionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInjectionFilter
           * @property {Array.<string>|null} [ids] InjectionFilter ids
           * @property {Array.<string>|null} [vaccinationIds] InjectionFilter vaccinationIds
           * @property {Array.<string>|null} [horseIds] InjectionFilter horseIds
           * @property {Array.<stronachgroup.first.racehorse360.MedicineType>|null} [medicineTypes] InjectionFilter medicineTypes
           */

          /**
           * Constructs a new InjectionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an InjectionFilter.
           * @implements IInjectionFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInjectionFilter=} [properties] Properties to set
           */
          function InjectionFilter(properties) {
            this.ids = [];
            this.vaccinationIds = [];
            this.horseIds = [];
            this.medicineTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * InjectionFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @instance
           */
          InjectionFilter.prototype.ids = $util.emptyArray;

          /**
           * InjectionFilter vaccinationIds.
           * @member {Array.<string>} vaccinationIds
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @instance
           */
          InjectionFilter.prototype.vaccinationIds = $util.emptyArray;

          /**
           * InjectionFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @instance
           */
          InjectionFilter.prototype.horseIds = $util.emptyArray;

          /**
           * InjectionFilter medicineTypes.
           * @member {Array.<stronachgroup.first.racehorse360.MedicineType>} medicineTypes
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @instance
           */
          InjectionFilter.prototype.medicineTypes = $util.emptyArray;

          /**
           * Creates a new InjectionFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IInjectionFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.InjectionFilter} InjectionFilter instance
           */
          InjectionFilter.create = function create(properties) {
            return new InjectionFilter(properties);
          };

          /**
           * Encodes the specified InjectionFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.InjectionFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IInjectionFilter} message InjectionFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          InjectionFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.vaccinationIds != null && message.vaccinationIds.length)
              for (var i = 0; i < message.vaccinationIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.vaccinationIds[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.horseIds[i]);
            if (message.medicineTypes != null && message.medicineTypes.length) {
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
              for (var i = 0; i < message.medicineTypes.length; ++i)
                writer.int32(message.medicineTypes[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes an InjectionFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.InjectionFilter} InjectionFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          InjectionFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.InjectionFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(message.vaccinationIds && message.vaccinationIds.length)
                  )
                    message.vaccinationIds = [];
                  message.vaccinationIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 4:
                  if (!(message.medicineTypes && message.medicineTypes.length))
                    message.medicineTypes = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.medicineTypes.push(reader.int32());
                  } else message.medicineTypes.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an InjectionFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.InjectionFilter} InjectionFilter
           */
          InjectionFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.InjectionFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.InjectionFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InjectionFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.vaccinationIds) {
              if (!Array.isArray(object.vaccinationIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InjectionFilter.vaccinationIds: array expected"
                );
              message.vaccinationIds = [];
              for (var i = 0; i < object.vaccinationIds.length; ++i)
                message.vaccinationIds[i] = String(object.vaccinationIds[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InjectionFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.medicineTypes) {
              if (!Array.isArray(object.medicineTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InjectionFilter.medicineTypes: array expected"
                );
              message.medicineTypes = [];
              for (var i = 0; i < object.medicineTypes.length; ++i)
                switch (object.medicineTypes[i]) {
                  default:
                  case "MEDICINE_TYPE_INVALID":
                  case 0:
                    message.medicineTypes[i] = 0;
                    break;
                  case "MEDICINE_TYPE_VACCINE":
                  case 1:
                    message.medicineTypes[i] = 1;
                    break;
                  case "MEDICINE_TYPE_BOOSTER":
                  case 2:
                    message.medicineTypes[i] = 2;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from an InjectionFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.InjectionFilter} message InjectionFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          InjectionFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.vaccinationIds = [];
              object.horseIds = [];
              object.medicineTypes = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.vaccinationIds && message.vaccinationIds.length) {
              object.vaccinationIds = [];
              for (var j = 0; j < message.vaccinationIds.length; ++j)
                object.vaccinationIds[j] = message.vaccinationIds[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.medicineTypes && message.medicineTypes.length) {
              object.medicineTypes = [];
              for (var j = 0; j < message.medicineTypes.length; ++j)
                object.medicineTypes[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.MedicineType[
                        message.medicineTypes[j]
                      ]
                    : message.medicineTypes[j];
            }
            return object;
          };

          /**
           * Converts this InjectionFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.InjectionFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          InjectionFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return InjectionFilter;
        })();

        racehorse360.Medicine = (function () {
          /**
           * Properties of a Medicine.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMedicine
           * @property {string|null} [id] Medicine id
           * @property {string|null} [name] Medicine name
           * @property {stronachgroup.first.racehorse360.MedicineType|null} [type] Medicine type
           * @property {number|null} [expiredInDays] Medicine expiredInDays
           */

          /**
           * Constructs a new Medicine.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Medicine.
           * @implements IMedicine
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMedicine=} [properties] Properties to set
           */
          function Medicine(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Medicine id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @instance
           */
          Medicine.prototype.id = "";

          /**
           * Medicine name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @instance
           */
          Medicine.prototype.name = "";

          /**
           * Medicine type.
           * @member {stronachgroup.first.racehorse360.MedicineType} type
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @instance
           */
          Medicine.prototype.type = 0;

          /**
           * Medicine expiredInDays.
           * @member {number} expiredInDays
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @instance
           */
          Medicine.prototype.expiredInDays = 0;

          /**
           * Creates a new Medicine instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @static
           * @param {stronachgroup.first.racehorse360.IMedicine=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Medicine} Medicine instance
           */
          Medicine.create = function create(properties) {
            return new Medicine(properties);
          };

          /**
           * Encodes the specified Medicine message. Does not implicitly {@link stronachgroup.first.racehorse360.Medicine.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @static
           * @param {stronachgroup.first.racehorse360.IMedicine} message Medicine message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Medicine.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.type);
            if (
              message.expiredInDays != null &&
              Object.hasOwnProperty.call(message, "expiredInDays")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.expiredInDays);
            return writer;
          };

          /**
           * Decodes a Medicine message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Medicine} Medicine
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Medicine.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Medicine();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                case 3:
                  message.type = reader.int32();
                  break;
                case 4:
                  message.expiredInDays = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Medicine message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Medicine} Medicine
           */
          Medicine.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Medicine
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Medicine();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            switch (object.type) {
              case "MEDICINE_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "MEDICINE_TYPE_VACCINE":
              case 1:
                message.type = 1;
                break;
              case "MEDICINE_TYPE_BOOSTER":
              case 2:
                message.type = 2;
                break;
            }
            if (object.expiredInDays != null)
              message.expiredInDays = object.expiredInDays | 0;
            return message;
          };

          /**
           * Creates a plain object from a Medicine message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @static
           * @param {stronachgroup.first.racehorse360.Medicine} message Medicine
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Medicine.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
              object.type =
                options.enums === String ? "MEDICINE_TYPE_INVALID" : 0;
              object.expiredInDays = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.MedicineType[
                      message.type
                    ]
                  : message.type;
            if (
              message.expiredInDays != null &&
              message.hasOwnProperty("expiredInDays")
            )
              object.expiredInDays = message.expiredInDays;
            return object;
          };

          /**
           * Converts this Medicine to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Medicine
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Medicine.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Medicine;
        })();

        racehorse360.ListMedicinesRequest = (function () {
          /**
           * Properties of a ListMedicinesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListMedicinesRequest
           * @property {stronachgroup.first.racehorse360.IMedicineFilter|null} [query] ListMedicinesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListMedicinesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListMedicinesRequest pagingOptions
           */

          /**
           * Constructs a new ListMedicinesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListMedicinesRequest.
           * @implements IListMedicinesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListMedicinesRequest=} [properties] Properties to set
           */
          function ListMedicinesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListMedicinesRequest query.
           * @member {stronachgroup.first.racehorse360.IMedicineFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @instance
           */
          ListMedicinesRequest.prototype.query = null;

          /**
           * ListMedicinesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @instance
           */
          ListMedicinesRequest.prototype.getOptions = null;

          /**
           * ListMedicinesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @instance
           */
          ListMedicinesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListMedicinesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListMedicinesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListMedicinesRequest} ListMedicinesRequest instance
           */
          ListMedicinesRequest.create = function create(properties) {
            return new ListMedicinesRequest(properties);
          };

          /**
           * Encodes the specified ListMedicinesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListMedicinesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListMedicinesRequest} message ListMedicinesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListMedicinesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.MedicineFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListMedicinesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListMedicinesRequest} ListMedicinesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListMedicinesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListMedicinesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.MedicineFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListMedicinesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListMedicinesRequest} ListMedicinesRequest
           */
          ListMedicinesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListMedicinesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListMedicinesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListMedicinesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.MedicineFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListMedicinesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListMedicinesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListMedicinesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListMedicinesRequest} message ListMedicinesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListMedicinesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.MedicineFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListMedicinesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListMedicinesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListMedicinesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListMedicinesRequest;
        })();

        racehorse360.ListMedicinesResponse = (function () {
          /**
           * Properties of a ListMedicinesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListMedicinesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IMedicine>|null} [medicines] ListMedicinesResponse medicines
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListMedicinesResponse pagingInfo
           */

          /**
           * Constructs a new ListMedicinesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListMedicinesResponse.
           * @implements IListMedicinesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListMedicinesResponse=} [properties] Properties to set
           */
          function ListMedicinesResponse(properties) {
            this.medicines = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListMedicinesResponse medicines.
           * @member {Array.<stronachgroup.first.racehorse360.IMedicine>} medicines
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @instance
           */
          ListMedicinesResponse.prototype.medicines = $util.emptyArray;

          /**
           * ListMedicinesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @instance
           */
          ListMedicinesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListMedicinesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListMedicinesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListMedicinesResponse} ListMedicinesResponse instance
           */
          ListMedicinesResponse.create = function create(properties) {
            return new ListMedicinesResponse(properties);
          };

          /**
           * Encodes the specified ListMedicinesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListMedicinesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListMedicinesResponse} message ListMedicinesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListMedicinesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.medicines != null && message.medicines.length)
              for (var i = 0; i < message.medicines.length; ++i)
                $root.stronachgroup.first.racehorse360.Medicine.encode(
                  message.medicines[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListMedicinesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListMedicinesResponse} ListMedicinesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListMedicinesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListMedicinesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.medicines && message.medicines.length))
                    message.medicines = [];
                  message.medicines.push(
                    $root.stronachgroup.first.racehorse360.Medicine.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListMedicinesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListMedicinesResponse} ListMedicinesResponse
           */
          ListMedicinesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListMedicinesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListMedicinesResponse();
            if (object.medicines) {
              if (!Array.isArray(object.medicines))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListMedicinesResponse.medicines: array expected"
                );
              message.medicines = [];
              for (var i = 0; i < object.medicines.length; ++i) {
                if (typeof object.medicines[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListMedicinesResponse.medicines: object expected"
                  );
                message.medicines[i] =
                  $root.stronachgroup.first.racehorse360.Medicine.fromObject(
                    object.medicines[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListMedicinesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListMedicinesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListMedicinesResponse} message ListMedicinesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListMedicinesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.medicines = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.medicines && message.medicines.length) {
              object.medicines = [];
              for (var j = 0; j < message.medicines.length; ++j)
                object.medicines[j] =
                  $root.stronachgroup.first.racehorse360.Medicine.toObject(
                    message.medicines[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListMedicinesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListMedicinesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListMedicinesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListMedicinesResponse;
        })();

        racehorse360.MedicineFilter = (function () {
          /**
           * Properties of a MedicineFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMedicineFilter
           * @property {Array.<string>|null} [ids] MedicineFilter ids
           * @property {Array.<stronachgroup.first.racehorse360.MedicineType>|null} [medicineTypes] MedicineFilter medicineTypes
           */

          /**
           * Constructs a new MedicineFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a MedicineFilter.
           * @implements IMedicineFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMedicineFilter=} [properties] Properties to set
           */
          function MedicineFilter(properties) {
            this.ids = [];
            this.medicineTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * MedicineFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @instance
           */
          MedicineFilter.prototype.ids = $util.emptyArray;

          /**
           * MedicineFilter medicineTypes.
           * @member {Array.<stronachgroup.first.racehorse360.MedicineType>} medicineTypes
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @instance
           */
          MedicineFilter.prototype.medicineTypes = $util.emptyArray;

          /**
           * Creates a new MedicineFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IMedicineFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.MedicineFilter} MedicineFilter instance
           */
          MedicineFilter.create = function create(properties) {
            return new MedicineFilter(properties);
          };

          /**
           * Encodes the specified MedicineFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.MedicineFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IMedicineFilter} message MedicineFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          MedicineFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.medicineTypes != null && message.medicineTypes.length) {
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork();
              for (var i = 0; i < message.medicineTypes.length; ++i)
                writer.int32(message.medicineTypes[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes a MedicineFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.MedicineFilter} MedicineFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          MedicineFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.MedicineFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.medicineTypes && message.medicineTypes.length))
                    message.medicineTypes = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.medicineTypes.push(reader.int32());
                  } else message.medicineTypes.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a MedicineFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.MedicineFilter} MedicineFilter
           */
          MedicineFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.MedicineFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.MedicineFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.MedicineFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.medicineTypes) {
              if (!Array.isArray(object.medicineTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.MedicineFilter.medicineTypes: array expected"
                );
              message.medicineTypes = [];
              for (var i = 0; i < object.medicineTypes.length; ++i)
                switch (object.medicineTypes[i]) {
                  default:
                  case "MEDICINE_TYPE_INVALID":
                  case 0:
                    message.medicineTypes[i] = 0;
                    break;
                  case "MEDICINE_TYPE_VACCINE":
                  case 1:
                    message.medicineTypes[i] = 1;
                    break;
                  case "MEDICINE_TYPE_BOOSTER":
                  case 2:
                    message.medicineTypes[i] = 2;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from a MedicineFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @static
           * @param {stronachgroup.first.racehorse360.MedicineFilter} message MedicineFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          MedicineFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.medicineTypes = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.medicineTypes && message.medicineTypes.length) {
              object.medicineTypes = [];
              for (var j = 0; j < message.medicineTypes.length; ++j)
                object.medicineTypes[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.MedicineType[
                        message.medicineTypes[j]
                      ]
                    : message.medicineTypes[j];
            }
            return object;
          };

          /**
           * Converts this MedicineFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.MedicineFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          MedicineFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return MedicineFilter;
        })();

        racehorse360.Owner = (function () {
          /**
           * Properties of an Owner.
           * @memberof stronachgroup.first.racehorse360
           * @interface IOwner
           * @property {string|null} [id] Owner id
           * @property {string|null} [firstName] Owner firstName
           * @property {string|null} [middleName] Owner middleName
           * @property {string|null} [lastName] Owner lastName
           * @property {number|null} [ownerNumber] Owner ownerNumber
           * @property {string|null} [type] Owner type
           * @property {string|null} [fullName] Owner fullName
           */

          /**
           * Constructs a new Owner.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an Owner.
           * @implements IOwner
           * @constructor
           * @param {stronachgroup.first.racehorse360.IOwner=} [properties] Properties to set
           */
          function Owner(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Owner id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.id = "";

          /**
           * Owner firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.firstName = "";

          /**
           * Owner middleName.
           * @member {string} middleName
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.middleName = "";

          /**
           * Owner lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.lastName = "";

          /**
           * Owner ownerNumber.
           * @member {number} ownerNumber
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.ownerNumber = 0;

          /**
           * Owner type.
           * @member {string} type
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.type = "";

          /**
           * Owner fullName.
           * @member {string} fullName
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           */
          Owner.prototype.fullName = "";

          /**
           * Creates a new Owner instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Owner
           * @static
           * @param {stronachgroup.first.racehorse360.IOwner=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Owner} Owner instance
           */
          Owner.create = function create(properties) {
            return new Owner(properties);
          };

          /**
           * Encodes the specified Owner message. Does not implicitly {@link stronachgroup.first.racehorse360.Owner.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Owner
           * @static
           * @param {stronachgroup.first.racehorse360.IOwner} message Owner message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Owner.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstName);
            if (
              message.middleName != null &&
              Object.hasOwnProperty.call(message, "middleName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.middleName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.lastName);
            if (
              message.ownerNumber != null &&
              Object.hasOwnProperty.call(message, "ownerNumber")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.ownerNumber);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.type);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.fullName);
            return writer;
          };

          /**
           * Decodes an Owner message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Owner
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Owner} Owner
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Owner.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Owner();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.firstName = reader.string();
                  break;
                case 3:
                  message.middleName = reader.string();
                  break;
                case 4:
                  message.lastName = reader.string();
                  break;
                case 5:
                  message.ownerNumber = reader.int32();
                  break;
                case 7:
                  message.type = reader.string();
                  break;
                case 8:
                  message.fullName = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an Owner message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Owner
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Owner} Owner
           */
          Owner.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Owner)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Owner();
            if (object.id != null) message.id = String(object.id);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.middleName != null)
              message.middleName = String(object.middleName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.ownerNumber != null)
              message.ownerNumber = object.ownerNumber | 0;
            if (object.type != null) message.type = String(object.type);
            if (object.fullName != null)
              message.fullName = String(object.fullName);
            return message;
          };

          /**
           * Creates a plain object from an Owner message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Owner
           * @static
           * @param {stronachgroup.first.racehorse360.Owner} message Owner
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Owner.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.firstName = "";
              object.middleName = "";
              object.lastName = "";
              object.ownerNumber = 0;
              object.type = "";
              object.fullName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (
              message.middleName != null &&
              message.hasOwnProperty("middleName")
            )
              object.middleName = message.middleName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.ownerNumber != null &&
              message.hasOwnProperty("ownerNumber")
            )
              object.ownerNumber = message.ownerNumber;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type = message.type;
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName = message.fullName;
            return object;
          };

          /**
           * Converts this Owner to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Owner
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Owner.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Owner;
        })();

        racehorse360.Race = (function () {
          /**
           * Properties of a Race.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRace
           * @property {string|null} [id] Race id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] Race facility
           * @property {string|null} [raceDate] Race raceDate
           * @property {number|null} [raceNumber] Race raceNumber
           * @property {boolean|null} [isNightRace] Race isNightRace
           * @property {boolean|null} [isTrackSealed] Race isTrackSealed
           * @property {number|null} [distance] Race distance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [distanceUnit] Race distanceUnit
           * @property {number|null} [fraction_1] Race fraction_1
           * @property {number|null} [fraction_2] Race fraction_2
           * @property {number|null} [fraction_3] Race fraction_3
           * @property {number|null} [fraction_4] Race fraction_4
           * @property {number|null} [fraction_5] Race fraction_5
           * @property {number|null} [numberOfRunners] Race numberOfRunners
           * @property {number|null} [maximumClaimPrice] Race maximumClaimPrice
           * @property {number|null} [minimumClaimPrice] Race minimumClaimPrice
           * @property {number|null} [purseForeign] Race purseForeign
           * @property {number|null} [purseUsa] Race purseUsa
           * @property {string|null} [aboutDistanceIndicator] Race aboutDistanceIndicator
           * @property {string|null} [ageRestriction] Race ageRestriction
           * @property {string|null} [genderRestriction] Race genderRestriction
           * @property {string|null} [raceConditions] Race raceConditions
           * @property {string|null} [raceName] Race raceName
           * @property {string|null} [raceNameAbbreviated] Race raceNameAbbreviated
           * @property {string|null} [raceType] Race raceType
           * @property {string|null} [surface] Race surface
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseType] Race courseType
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] Race trackCondition
           * @property {number|null} [winningTime] Race winningTime
           * @property {boolean|null} [isOfficial] Race isOfficial
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [scheduledSurfaceType] Race scheduledSurfaceType
           * @property {number|null} [temporaryRailDistance] Race temporaryRailDistance
           */

          /**
           * Constructs a new Race.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Race.
           * @implements IRace
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRace=} [properties] Properties to set
           */
          function Race(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Race id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.id = "";

          /**
           * Race facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.facility = null;

          /**
           * Race raceDate.
           * @member {string} raceDate
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceDate = "";

          /**
           * Race raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceNumber = 0;

          /**
           * Race isNightRace.
           * @member {boolean} isNightRace
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.isNightRace = false;

          /**
           * Race isTrackSealed.
           * @member {boolean} isTrackSealed
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.isTrackSealed = false;

          /**
           * Race distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.distance = 0;

          /**
           * Race distanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} distanceUnit
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.distanceUnit = 0;

          /**
           * Race fraction_1.
           * @member {number} fraction_1
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.fraction_1 = 0;

          /**
           * Race fraction_2.
           * @member {number} fraction_2
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.fraction_2 = 0;

          /**
           * Race fraction_3.
           * @member {number} fraction_3
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.fraction_3 = 0;

          /**
           * Race fraction_4.
           * @member {number} fraction_4
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.fraction_4 = 0;

          /**
           * Race fraction_5.
           * @member {number} fraction_5
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.fraction_5 = 0;

          /**
           * Race numberOfRunners.
           * @member {number} numberOfRunners
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.numberOfRunners = 0;

          /**
           * Race maximumClaimPrice.
           * @member {number} maximumClaimPrice
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.maximumClaimPrice = 0;

          /**
           * Race minimumClaimPrice.
           * @member {number} minimumClaimPrice
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.minimumClaimPrice = 0;

          /**
           * Race purseForeign.
           * @member {number} purseForeign
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.purseForeign = 0;

          /**
           * Race purseUsa.
           * @member {number} purseUsa
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.purseUsa = 0;

          /**
           * Race aboutDistanceIndicator.
           * @member {string} aboutDistanceIndicator
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.aboutDistanceIndicator = "";

          /**
           * Race ageRestriction.
           * @member {string} ageRestriction
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.ageRestriction = "";

          /**
           * Race genderRestriction.
           * @member {string} genderRestriction
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.genderRestriction = "";

          /**
           * Race raceConditions.
           * @member {string} raceConditions
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceConditions = "";

          /**
           * Race raceName.
           * @member {string} raceName
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceName = "";

          /**
           * Race raceNameAbbreviated.
           * @member {string} raceNameAbbreviated
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceNameAbbreviated = "";

          /**
           * Race raceType.
           * @member {string} raceType
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.raceType = "";

          /**
           * Race surface.
           * @member {string} surface
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.surface = "";

          /**
           * Race courseType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseType
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.courseType = 0;

          /**
           * Race trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.trackCondition = 0;

          /**
           * Race winningTime.
           * @member {number} winningTime
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.winningTime = 0;

          /**
           * Race isOfficial.
           * @member {boolean} isOfficial
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.isOfficial = false;

          /**
           * Race scheduledSurfaceType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} scheduledSurfaceType
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.scheduledSurfaceType = 0;

          /**
           * Race temporaryRailDistance.
           * @member {number} temporaryRailDistance
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           */
          Race.prototype.temporaryRailDistance = 0;

          /**
           * Creates a new Race instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Race
           * @static
           * @param {stronachgroup.first.racehorse360.IRace=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Race} Race instance
           */
          Race.create = function create(properties) {
            return new Race(properties);
          };

          /**
           * Encodes the specified Race message. Does not implicitly {@link stronachgroup.first.racehorse360.Race.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Race
           * @static
           * @param {stronachgroup.first.racehorse360.IRace} message Race message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Race.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.raceDate);
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.raceNumber);
            if (
              message.isNightRace != null &&
              Object.hasOwnProperty.call(message, "isNightRace")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .bool(message.isNightRace);
            if (
              message.isTrackSealed != null &&
              Object.hasOwnProperty.call(message, "isTrackSealed")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .bool(message.isTrackSealed);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.distance);
            if (
              message.distanceUnit != null &&
              Object.hasOwnProperty.call(message, "distanceUnit")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.distanceUnit);
            if (
              message.fraction_1 != null &&
              Object.hasOwnProperty.call(message, "fraction_1")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.fraction_1);
            if (
              message.fraction_2 != null &&
              Object.hasOwnProperty.call(message, "fraction_2")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.fraction_2);
            if (
              message.fraction_3 != null &&
              Object.hasOwnProperty.call(message, "fraction_3")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.fraction_3);
            if (
              message.fraction_4 != null &&
              Object.hasOwnProperty.call(message, "fraction_4")
            )
              writer
                .uint32(/* id 12, wireType 0 =*/ 96)
                .int32(message.fraction_4);
            if (
              message.fraction_5 != null &&
              Object.hasOwnProperty.call(message, "fraction_5")
            )
              writer
                .uint32(/* id 13, wireType 0 =*/ 104)
                .int32(message.fraction_5);
            if (
              message.numberOfRunners != null &&
              Object.hasOwnProperty.call(message, "numberOfRunners")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.numberOfRunners);
            if (
              message.maximumClaimPrice != null &&
              Object.hasOwnProperty.call(message, "maximumClaimPrice")
            )
              writer
                .uint32(/* id 15, wireType 5 =*/ 125)
                .float(message.maximumClaimPrice);
            if (
              message.minimumClaimPrice != null &&
              Object.hasOwnProperty.call(message, "minimumClaimPrice")
            )
              writer
                .uint32(/* id 16, wireType 5 =*/ 133)
                .float(message.minimumClaimPrice);
            if (
              message.purseForeign != null &&
              Object.hasOwnProperty.call(message, "purseForeign")
            )
              writer
                .uint32(/* id 17, wireType 5 =*/ 141)
                .float(message.purseForeign);
            if (
              message.purseUsa != null &&
              Object.hasOwnProperty.call(message, "purseUsa")
            )
              writer
                .uint32(/* id 18, wireType 5 =*/ 149)
                .float(message.purseUsa);
            if (
              message.aboutDistanceIndicator != null &&
              Object.hasOwnProperty.call(message, "aboutDistanceIndicator")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.aboutDistanceIndicator);
            if (
              message.ageRestriction != null &&
              Object.hasOwnProperty.call(message, "ageRestriction")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.ageRestriction);
            if (
              message.genderRestriction != null &&
              Object.hasOwnProperty.call(message, "genderRestriction")
            )
              writer
                .uint32(/* id 21, wireType 2 =*/ 170)
                .string(message.genderRestriction);
            if (
              message.raceConditions != null &&
              Object.hasOwnProperty.call(message, "raceConditions")
            )
              writer
                .uint32(/* id 22, wireType 2 =*/ 178)
                .string(message.raceConditions);
            if (
              message.raceName != null &&
              Object.hasOwnProperty.call(message, "raceName")
            )
              writer
                .uint32(/* id 23, wireType 2 =*/ 186)
                .string(message.raceName);
            if (
              message.raceNameAbbreviated != null &&
              Object.hasOwnProperty.call(message, "raceNameAbbreviated")
            )
              writer
                .uint32(/* id 24, wireType 2 =*/ 194)
                .string(message.raceNameAbbreviated);
            if (
              message.raceType != null &&
              Object.hasOwnProperty.call(message, "raceType")
            )
              writer
                .uint32(/* id 25, wireType 2 =*/ 202)
                .string(message.raceType);
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer
                .uint32(/* id 26, wireType 2 =*/ 210)
                .string(message.surface);
            if (
              message.courseType != null &&
              Object.hasOwnProperty.call(message, "courseType")
            )
              writer
                .uint32(/* id 27, wireType 0 =*/ 216)
                .int32(message.courseType);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 28, wireType 0 =*/ 224)
                .int32(message.trackCondition);
            if (
              message.winningTime != null &&
              Object.hasOwnProperty.call(message, "winningTime")
            )
              writer
                .uint32(/* id 29, wireType 0 =*/ 232)
                .int32(message.winningTime);
            if (
              message.isOfficial != null &&
              Object.hasOwnProperty.call(message, "isOfficial")
            )
              writer
                .uint32(/* id 30, wireType 0 =*/ 240)
                .bool(message.isOfficial);
            if (
              message.scheduledSurfaceType != null &&
              Object.hasOwnProperty.call(message, "scheduledSurfaceType")
            )
              writer
                .uint32(/* id 31, wireType 0 =*/ 248)
                .int32(message.scheduledSurfaceType);
            if (
              message.temporaryRailDistance != null &&
              Object.hasOwnProperty.call(message, "temporaryRailDistance")
            )
              writer
                .uint32(/* id 32, wireType 0 =*/ 256)
                .int32(message.temporaryRailDistance);
            return writer;
          };

          /**
           * Decodes a Race message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Race
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Race} Race
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Race.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Race();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.raceDate = reader.string();
                  break;
                case 4:
                  message.raceNumber = reader.int32();
                  break;
                case 5:
                  message.isNightRace = reader.bool();
                  break;
                case 6:
                  message.isTrackSealed = reader.bool();
                  break;
                case 7:
                  message.distance = reader.int32();
                  break;
                case 8:
                  message.distanceUnit = reader.int32();
                  break;
                case 9:
                  message.fraction_1 = reader.int32();
                  break;
                case 10:
                  message.fraction_2 = reader.int32();
                  break;
                case 11:
                  message.fraction_3 = reader.int32();
                  break;
                case 12:
                  message.fraction_4 = reader.int32();
                  break;
                case 13:
                  message.fraction_5 = reader.int32();
                  break;
                case 14:
                  message.numberOfRunners = reader.int32();
                  break;
                case 15:
                  message.maximumClaimPrice = reader.float();
                  break;
                case 16:
                  message.minimumClaimPrice = reader.float();
                  break;
                case 17:
                  message.purseForeign = reader.float();
                  break;
                case 18:
                  message.purseUsa = reader.float();
                  break;
                case 19:
                  message.aboutDistanceIndicator = reader.string();
                  break;
                case 20:
                  message.ageRestriction = reader.string();
                  break;
                case 21:
                  message.genderRestriction = reader.string();
                  break;
                case 22:
                  message.raceConditions = reader.string();
                  break;
                case 23:
                  message.raceName = reader.string();
                  break;
                case 24:
                  message.raceNameAbbreviated = reader.string();
                  break;
                case 25:
                  message.raceType = reader.string();
                  break;
                case 26:
                  message.surface = reader.string();
                  break;
                case 27:
                  message.courseType = reader.int32();
                  break;
                case 28:
                  message.trackCondition = reader.int32();
                  break;
                case 29:
                  message.winningTime = reader.int32();
                  break;
                case 30:
                  message.isOfficial = reader.bool();
                  break;
                case 31:
                  message.scheduledSurfaceType = reader.int32();
                  break;
                case 32:
                  message.temporaryRailDistance = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Race message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Race
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Race} Race
           */
          Race.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Race)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Race();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Race.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.raceDate != null)
              message.raceDate = String(object.raceDate);
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.isNightRace != null)
              message.isNightRace = Boolean(object.isNightRace);
            if (object.isTrackSealed != null)
              message.isTrackSealed = Boolean(object.isTrackSealed);
            if (object.distance != null) message.distance = object.distance | 0;
            switch (object.distanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.distanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.distanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.distanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.distanceUnit = 3;
                break;
            }
            if (object.fraction_1 != null)
              message.fraction_1 = object.fraction_1 | 0;
            if (object.fraction_2 != null)
              message.fraction_2 = object.fraction_2 | 0;
            if (object.fraction_3 != null)
              message.fraction_3 = object.fraction_3 | 0;
            if (object.fraction_4 != null)
              message.fraction_4 = object.fraction_4 | 0;
            if (object.fraction_5 != null)
              message.fraction_5 = object.fraction_5 | 0;
            if (object.numberOfRunners != null)
              message.numberOfRunners = object.numberOfRunners | 0;
            if (object.maximumClaimPrice != null)
              message.maximumClaimPrice = Number(object.maximumClaimPrice);
            if (object.minimumClaimPrice != null)
              message.minimumClaimPrice = Number(object.minimumClaimPrice);
            if (object.purseForeign != null)
              message.purseForeign = Number(object.purseForeign);
            if (object.purseUsa != null)
              message.purseUsa = Number(object.purseUsa);
            if (object.aboutDistanceIndicator != null)
              message.aboutDistanceIndicator = String(
                object.aboutDistanceIndicator
              );
            if (object.ageRestriction != null)
              message.ageRestriction = String(object.ageRestriction);
            if (object.genderRestriction != null)
              message.genderRestriction = String(object.genderRestriction);
            if (object.raceConditions != null)
              message.raceConditions = String(object.raceConditions);
            if (object.raceName != null)
              message.raceName = String(object.raceName);
            if (object.raceNameAbbreviated != null)
              message.raceNameAbbreviated = String(object.raceNameAbbreviated);
            if (object.raceType != null)
              message.raceType = String(object.raceType);
            if (object.surface != null)
              message.surface = String(object.surface);
            switch (object.courseType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseType = 17;
                break;
            }
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.winningTime != null)
              message.winningTime = object.winningTime | 0;
            if (object.isOfficial != null)
              message.isOfficial = Boolean(object.isOfficial);
            switch (object.scheduledSurfaceType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.scheduledSurfaceType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.scheduledSurfaceType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.scheduledSurfaceType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.scheduledSurfaceType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.scheduledSurfaceType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.scheduledSurfaceType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.scheduledSurfaceType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.scheduledSurfaceType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.scheduledSurfaceType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.scheduledSurfaceType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.scheduledSurfaceType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.scheduledSurfaceType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.scheduledSurfaceType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.scheduledSurfaceType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.scheduledSurfaceType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.scheduledSurfaceType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.scheduledSurfaceType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.scheduledSurfaceType = 17;
                break;
            }
            if (object.temporaryRailDistance != null)
              message.temporaryRailDistance = object.temporaryRailDistance | 0;
            return message;
          };

          /**
           * Creates a plain object from a Race message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Race
           * @static
           * @param {stronachgroup.first.racehorse360.Race} message Race
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Race.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.raceDate = "";
              object.raceNumber = 0;
              object.isNightRace = false;
              object.isTrackSealed = false;
              object.distance = 0;
              object.distanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
              object.fraction_1 = 0;
              object.fraction_2 = 0;
              object.fraction_3 = 0;
              object.fraction_4 = 0;
              object.fraction_5 = 0;
              object.numberOfRunners = 0;
              object.maximumClaimPrice = 0;
              object.minimumClaimPrice = 0;
              object.purseForeign = 0;
              object.purseUsa = 0;
              object.aboutDistanceIndicator = "";
              object.ageRestriction = "";
              object.genderRestriction = "";
              object.raceConditions = "";
              object.raceName = "";
              object.raceNameAbbreviated = "";
              object.raceType = "";
              object.surface = "";
              object.courseType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.winningTime = 0;
              object.isOfficial = false;
              object.scheduledSurfaceType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.temporaryRailDistance = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate = message.raceDate;
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (
              message.isNightRace != null &&
              message.hasOwnProperty("isNightRace")
            )
              object.isNightRace = message.isNightRace;
            if (
              message.isTrackSealed != null &&
              message.hasOwnProperty("isTrackSealed")
            )
              object.isTrackSealed = message.isTrackSealed;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.distanceUnit != null &&
              message.hasOwnProperty("distanceUnit")
            )
              object.distanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.distanceUnit
                    ]
                  : message.distanceUnit;
            if (
              message.fraction_1 != null &&
              message.hasOwnProperty("fraction_1")
            )
              object.fraction_1 = message.fraction_1;
            if (
              message.fraction_2 != null &&
              message.hasOwnProperty("fraction_2")
            )
              object.fraction_2 = message.fraction_2;
            if (
              message.fraction_3 != null &&
              message.hasOwnProperty("fraction_3")
            )
              object.fraction_3 = message.fraction_3;
            if (
              message.fraction_4 != null &&
              message.hasOwnProperty("fraction_4")
            )
              object.fraction_4 = message.fraction_4;
            if (
              message.fraction_5 != null &&
              message.hasOwnProperty("fraction_5")
            )
              object.fraction_5 = message.fraction_5;
            if (
              message.numberOfRunners != null &&
              message.hasOwnProperty("numberOfRunners")
            )
              object.numberOfRunners = message.numberOfRunners;
            if (
              message.maximumClaimPrice != null &&
              message.hasOwnProperty("maximumClaimPrice")
            )
              object.maximumClaimPrice =
                options.json && !isFinite(message.maximumClaimPrice)
                  ? String(message.maximumClaimPrice)
                  : message.maximumClaimPrice;
            if (
              message.minimumClaimPrice != null &&
              message.hasOwnProperty("minimumClaimPrice")
            )
              object.minimumClaimPrice =
                options.json && !isFinite(message.minimumClaimPrice)
                  ? String(message.minimumClaimPrice)
                  : message.minimumClaimPrice;
            if (
              message.purseForeign != null &&
              message.hasOwnProperty("purseForeign")
            )
              object.purseForeign =
                options.json && !isFinite(message.purseForeign)
                  ? String(message.purseForeign)
                  : message.purseForeign;
            if (message.purseUsa != null && message.hasOwnProperty("purseUsa"))
              object.purseUsa =
                options.json && !isFinite(message.purseUsa)
                  ? String(message.purseUsa)
                  : message.purseUsa;
            if (
              message.aboutDistanceIndicator != null &&
              message.hasOwnProperty("aboutDistanceIndicator")
            )
              object.aboutDistanceIndicator = message.aboutDistanceIndicator;
            if (
              message.ageRestriction != null &&
              message.hasOwnProperty("ageRestriction")
            )
              object.ageRestriction = message.ageRestriction;
            if (
              message.genderRestriction != null &&
              message.hasOwnProperty("genderRestriction")
            )
              object.genderRestriction = message.genderRestriction;
            if (
              message.raceConditions != null &&
              message.hasOwnProperty("raceConditions")
            )
              object.raceConditions = message.raceConditions;
            if (message.raceName != null && message.hasOwnProperty("raceName"))
              object.raceName = message.raceName;
            if (
              message.raceNameAbbreviated != null &&
              message.hasOwnProperty("raceNameAbbreviated")
            )
              object.raceNameAbbreviated = message.raceNameAbbreviated;
            if (message.raceType != null && message.hasOwnProperty("raceType"))
              object.raceType = message.raceType;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface = message.surface;
            if (
              message.courseType != null &&
              message.hasOwnProperty("courseType")
            )
              object.courseType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseType
                    ]
                  : message.courseType;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (
              message.winningTime != null &&
              message.hasOwnProperty("winningTime")
            )
              object.winningTime = message.winningTime;
            if (
              message.isOfficial != null &&
              message.hasOwnProperty("isOfficial")
            )
              object.isOfficial = message.isOfficial;
            if (
              message.scheduledSurfaceType != null &&
              message.hasOwnProperty("scheduledSurfaceType")
            )
              object.scheduledSurfaceType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.scheduledSurfaceType
                    ]
                  : message.scheduledSurfaceType;
            if (
              message.temporaryRailDistance != null &&
              message.hasOwnProperty("temporaryRailDistance")
            )
              object.temporaryRailDistance = message.temporaryRailDistance;
            return object;
          };

          /**
           * Converts this Race to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Race
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Race.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Race;
        })();

        racehorse360.RaceFilter = (function () {
          /**
           * Properties of a RaceFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceFilter
           * @property {Array.<string>|null} [ids] RaceFilter ids
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [raceDate] RaceFilter raceDate
           * @property {number|null} [raceNumber] RaceFilter raceNumber
           * @property {string|null} [facilityId] RaceFilter facilityId
           */

          /**
           * Constructs a new RaceFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceFilter.
           * @implements IRaceFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceFilter=} [properties] Properties to set
           */
          function RaceFilter(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @instance
           */
          RaceFilter.prototype.ids = $util.emptyArray;

          /**
           * RaceFilter raceDate.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} raceDate
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @instance
           */
          RaceFilter.prototype.raceDate = null;

          /**
           * RaceFilter raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @instance
           */
          RaceFilter.prototype.raceNumber = 0;

          /**
           * RaceFilter facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @instance
           */
          RaceFilter.prototype.facilityId = "";

          /**
           * Creates a new RaceFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceFilter} RaceFilter instance
           */
          RaceFilter.create = function create(properties) {
            return new RaceFilter(properties);
          };

          /**
           * Encodes the specified RaceFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceFilter} message RaceFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.raceDate,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.raceNumber);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.facilityId);
            return writer;
          };

          /**
           * Decodes a RaceFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceFilter} RaceFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.RaceFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.raceDate =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.raceNumber = reader.int32();
                  break;
                case 4:
                  message.facilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceFilter} RaceFilter
           */
          RaceFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.raceDate != null) {
              if (typeof object.raceDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceFilter.raceDate: object expected"
                );
              message.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.raceDate
                );
            }
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            return message;
          };

          /**
           * Creates a plain object from a RaceFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RaceFilter} message RaceFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.raceDate = null;
              object.raceNumber = 0;
              object.facilityId = "";
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.raceDate,
                  options
                );
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            return object;
          };

          /**
           * Converts this RaceFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceFilter;
        })();

        racehorse360.ListRacesRequest = (function () {
          /**
           * Properties of a ListRacesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRacesRequest
           * @property {stronachgroup.first.racehorse360.IRaceFilter|null} [query] ListRacesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRacesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRacesRequest pagingOptions
           */

          /**
           * Constructs a new ListRacesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRacesRequest.
           * @implements IListRacesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRacesRequest=} [properties] Properties to set
           */
          function ListRacesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRacesRequest query.
           * @member {stronachgroup.first.racehorse360.IRaceFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @instance
           */
          ListRacesRequest.prototype.query = null;

          /**
           * ListRacesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @instance
           */
          ListRacesRequest.prototype.getOptions = null;

          /**
           * ListRacesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @instance
           */
          ListRacesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRacesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRacesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRacesRequest} ListRacesRequest instance
           */
          ListRacesRequest.create = function create(properties) {
            return new ListRacesRequest(properties);
          };

          /**
           * Encodes the specified ListRacesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRacesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRacesRequest} message ListRacesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRacesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RaceFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRacesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRacesRequest} ListRacesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRacesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRacesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RaceFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRacesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRacesRequest} ListRacesRequest
           */
          ListRacesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRacesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRacesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRacesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RaceFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRacesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRacesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRacesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRacesRequest} message ListRacesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRacesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RaceFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRacesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRacesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRacesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRacesRequest;
        })();

        racehorse360.ListRacesResponse = (function () {
          /**
           * Properties of a ListRacesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRacesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRace>|null} [races] ListRacesResponse races
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRacesResponse pagingInfo
           */

          /**
           * Constructs a new ListRacesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRacesResponse.
           * @implements IListRacesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRacesResponse=} [properties] Properties to set
           */
          function ListRacesResponse(properties) {
            this.races = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRacesResponse races.
           * @member {Array.<stronachgroup.first.racehorse360.IRace>} races
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @instance
           */
          ListRacesResponse.prototype.races = $util.emptyArray;

          /**
           * ListRacesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @instance
           */
          ListRacesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRacesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRacesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRacesResponse} ListRacesResponse instance
           */
          ListRacesResponse.create = function create(properties) {
            return new ListRacesResponse(properties);
          };

          /**
           * Encodes the specified ListRacesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRacesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRacesResponse} message ListRacesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRacesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.races != null && message.races.length)
              for (var i = 0; i < message.races.length; ++i)
                $root.stronachgroup.first.racehorse360.Race.encode(
                  message.races[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRacesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRacesResponse} ListRacesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRacesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRacesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.races && message.races.length))
                    message.races = [];
                  message.races.push(
                    $root.stronachgroup.first.racehorse360.Race.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRacesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRacesResponse} ListRacesResponse
           */
          ListRacesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRacesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRacesResponse();
            if (object.races) {
              if (!Array.isArray(object.races))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRacesResponse.races: array expected"
                );
              message.races = [];
              for (var i = 0; i < object.races.length; ++i) {
                if (typeof object.races[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRacesResponse.races: object expected"
                  );
                message.races[i] =
                  $root.stronachgroup.first.racehorse360.Race.fromObject(
                    object.races[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRacesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRacesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRacesResponse} message ListRacesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRacesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.races = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.races && message.races.length) {
              object.races = [];
              for (var j = 0; j < message.races.length; ++j)
                object.races[j] =
                  $root.stronachgroup.first.racehorse360.Race.toObject(
                    message.races[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRacesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRacesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRacesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRacesResponse;
        })();

        racehorse360.RaceHistory = (function () {
          /**
           * Properties of a RaceHistory.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceHistory
           * @property {string|null} [id] RaceHistory id
           * @property {stronachgroup.first.racehorse360.IRace|null} [race] RaceHistory race
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] RaceHistory facility
           * @property {string|null} [date] RaceHistory date
           * @property {number|null} [raceNumber] RaceHistory raceNumber
           * @property {boolean|null} [isNightRace] RaceHistory isNightRace
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] RaceHistory horse
           * @property {number|null} [earnings] RaceHistory earnings
           * @property {number|null} [lengthBehindAtFinish] RaceHistory lengthBehindAtFinish
           * @property {number|null} [lengthBehindAtPointOfCall_1] RaceHistory lengthBehindAtPointOfCall_1
           * @property {number|null} [lengthBehindAtPointOfCall_2] RaceHistory lengthBehindAtPointOfCall_2
           * @property {number|null} [lengthBehindAtPointOfCall_3] RaceHistory lengthBehindAtPointOfCall_3
           * @property {number|null} [lengthBehindAtPointOfCall_4] RaceHistory lengthBehindAtPointOfCall_4
           * @property {number|null} [lengthBehindAtPointOfCall_5] RaceHistory lengthBehindAtPointOfCall_5
           * @property {number|null} [lengthAheadAtFinish] RaceHistory lengthAheadAtFinish
           * @property {number|null} [lengthAheadAtPointOfCall_1] RaceHistory lengthAheadAtPointOfCall_1
           * @property {number|null} [lengthAheadAtPointOfCall_2] RaceHistory lengthAheadAtPointOfCall_2
           * @property {number|null} [lengthAheadAtPointOfCall_3] RaceHistory lengthAheadAtPointOfCall_3
           * @property {number|null} [lengthAheadAtPointOfCall_4] RaceHistory lengthAheadAtPointOfCall_4
           * @property {number|null} [lengthAheadAtPointOfCall_5] RaceHistory lengthAheadAtPointOfCall_5
           * @property {number|null} [officialPosition] RaceHistory officialPosition
           * @property {number|null} [postPosition] RaceHistory postPosition
           * @property {number|null} [positionAtFinish] RaceHistory positionAtFinish
           * @property {number|null} [positionAtStart] RaceHistory positionAtStart
           * @property {number|null} [positionAtPointOfCall_1] RaceHistory positionAtPointOfCall_1
           * @property {number|null} [positionAtPointOfCall_2] RaceHistory positionAtPointOfCall_2
           * @property {number|null} [positionAtPointOfCall_3] RaceHistory positionAtPointOfCall_3
           * @property {number|null} [positionAtPointOfCall_4] RaceHistory positionAtPointOfCall_4
           * @property {number|null} [positionAtPointOfCall_5] RaceHistory positionAtPointOfCall_5
           * @property {string|null} [medication] RaceHistory medication
           * @property {string|null} [comment] RaceHistory comment
           * @property {string|null} [shortComment] RaceHistory shortComment
           * @property {boolean|null} [isScratched] RaceHistory isScratched
           * @property {string|null} [scratchReason] RaceHistory scratchReason
           * @property {stronachgroup.first.racehorse360.IJockey|null} [jockey] RaceHistory jockey
           * @property {number|null} [weightCarried] RaceHistory weightCarried
           * @property {string|null} [equipment] RaceHistory equipment
           * @property {number|null} [odds] RaceHistory odds
           * @property {stronachgroup.first.racehorse360.IOwner|null} [owner] RaceHistory owner
           * @property {stronachgroup.first.racehorse360.IOwner|null} [newOwner] RaceHistory newOwner
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [newTrainer] RaceHistory newTrainer
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] RaceHistory trainer
           * @property {google.protobuf.IBoolValue|null} [isVoid] RaceHistory isVoid
           * @property {string|null} [voidReason] RaceHistory voidReason
           * @property {google.protobuf.IBoolValue|null} [isPostTimeFavorite] RaceHistory isPostTimeFavorite
           * @property {google.protobuf.IBoolValue|null} [isTroubledTrip] RaceHistory isTroubledTrip
           * @property {boolean|null} [isClaimed] RaceHistory isClaimed
           * @property {number|null} [claimedPriceUsa] RaceHistory claimedPriceUsa
           */

          /**
           * Constructs a new RaceHistory.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceHistory.
           * @implements IRaceHistory
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceHistory=} [properties] Properties to set
           */
          function RaceHistory(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceHistory id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.id = "";

          /**
           * RaceHistory race.
           * @member {stronachgroup.first.racehorse360.IRace|null|undefined} race
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.race = null;

          /**
           * RaceHistory facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.facility = null;

          /**
           * RaceHistory date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.date = "";

          /**
           * RaceHistory raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.raceNumber = 0;

          /**
           * RaceHistory isNightRace.
           * @member {boolean} isNightRace
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isNightRace = false;

          /**
           * RaceHistory horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.horse = null;

          /**
           * RaceHistory earnings.
           * @member {number} earnings
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.earnings = 0;

          /**
           * RaceHistory lengthBehindAtFinish.
           * @member {number} lengthBehindAtFinish
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtFinish = 0;

          /**
           * RaceHistory lengthBehindAtPointOfCall_1.
           * @member {number} lengthBehindAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtPointOfCall_1 = 0;

          /**
           * RaceHistory lengthBehindAtPointOfCall_2.
           * @member {number} lengthBehindAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtPointOfCall_2 = 0;

          /**
           * RaceHistory lengthBehindAtPointOfCall_3.
           * @member {number} lengthBehindAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtPointOfCall_3 = 0;

          /**
           * RaceHistory lengthBehindAtPointOfCall_4.
           * @member {number} lengthBehindAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtPointOfCall_4 = 0;

          /**
           * RaceHistory lengthBehindAtPointOfCall_5.
           * @member {number} lengthBehindAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthBehindAtPointOfCall_5 = 0;

          /**
           * RaceHistory lengthAheadAtFinish.
           * @member {number} lengthAheadAtFinish
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtFinish = 0;

          /**
           * RaceHistory lengthAheadAtPointOfCall_1.
           * @member {number} lengthAheadAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtPointOfCall_1 = 0;

          /**
           * RaceHistory lengthAheadAtPointOfCall_2.
           * @member {number} lengthAheadAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtPointOfCall_2 = 0;

          /**
           * RaceHistory lengthAheadAtPointOfCall_3.
           * @member {number} lengthAheadAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtPointOfCall_3 = 0;

          /**
           * RaceHistory lengthAheadAtPointOfCall_4.
           * @member {number} lengthAheadAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtPointOfCall_4 = 0;

          /**
           * RaceHistory lengthAheadAtPointOfCall_5.
           * @member {number} lengthAheadAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.lengthAheadAtPointOfCall_5 = 0;

          /**
           * RaceHistory officialPosition.
           * @member {number} officialPosition
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.officialPosition = 0;

          /**
           * RaceHistory postPosition.
           * @member {number} postPosition
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.postPosition = 0;

          /**
           * RaceHistory positionAtFinish.
           * @member {number} positionAtFinish
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtFinish = 0;

          /**
           * RaceHistory positionAtStart.
           * @member {number} positionAtStart
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtStart = 0;

          /**
           * RaceHistory positionAtPointOfCall_1.
           * @member {number} positionAtPointOfCall_1
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtPointOfCall_1 = 0;

          /**
           * RaceHistory positionAtPointOfCall_2.
           * @member {number} positionAtPointOfCall_2
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtPointOfCall_2 = 0;

          /**
           * RaceHistory positionAtPointOfCall_3.
           * @member {number} positionAtPointOfCall_3
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtPointOfCall_3 = 0;

          /**
           * RaceHistory positionAtPointOfCall_4.
           * @member {number} positionAtPointOfCall_4
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtPointOfCall_4 = 0;

          /**
           * RaceHistory positionAtPointOfCall_5.
           * @member {number} positionAtPointOfCall_5
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.positionAtPointOfCall_5 = 0;

          /**
           * RaceHistory medication.
           * @member {string} medication
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.medication = "";

          /**
           * RaceHistory comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.comment = "";

          /**
           * RaceHistory shortComment.
           * @member {string} shortComment
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.shortComment = "";

          /**
           * RaceHistory isScratched.
           * @member {boolean} isScratched
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isScratched = false;

          /**
           * RaceHistory scratchReason.
           * @member {string} scratchReason
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.scratchReason = "";

          /**
           * RaceHistory jockey.
           * @member {stronachgroup.first.racehorse360.IJockey|null|undefined} jockey
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.jockey = null;

          /**
           * RaceHistory weightCarried.
           * @member {number} weightCarried
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.weightCarried = 0;

          /**
           * RaceHistory equipment.
           * @member {string} equipment
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.equipment = "";

          /**
           * RaceHistory odds.
           * @member {number} odds
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.odds = 0;

          /**
           * RaceHistory owner.
           * @member {stronachgroup.first.racehorse360.IOwner|null|undefined} owner
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.owner = null;

          /**
           * RaceHistory newOwner.
           * @member {stronachgroup.first.racehorse360.IOwner|null|undefined} newOwner
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.newOwner = null;

          /**
           * RaceHistory newTrainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} newTrainer
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.newTrainer = null;

          /**
           * RaceHistory trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.trainer = null;

          /**
           * RaceHistory isVoid.
           * @member {google.protobuf.IBoolValue|null|undefined} isVoid
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isVoid = null;

          /**
           * RaceHistory voidReason.
           * @member {string} voidReason
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.voidReason = "";

          /**
           * RaceHistory isPostTimeFavorite.
           * @member {google.protobuf.IBoolValue|null|undefined} isPostTimeFavorite
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isPostTimeFavorite = null;

          /**
           * RaceHistory isTroubledTrip.
           * @member {google.protobuf.IBoolValue|null|undefined} isTroubledTrip
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isTroubledTrip = null;

          /**
           * RaceHistory isClaimed.
           * @member {boolean} isClaimed
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.isClaimed = false;

          /**
           * RaceHistory claimedPriceUsa.
           * @member {number} claimedPriceUsa
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           */
          RaceHistory.prototype.claimedPriceUsa = 0;

          /**
           * Creates a new RaceHistory instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceHistory=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceHistory} RaceHistory instance
           */
          RaceHistory.create = function create(properties) {
            return new RaceHistory(properties);
          };

          /**
           * Encodes the specified RaceHistory message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceHistory.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceHistory} message RaceHistory message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceHistory.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.race != null &&
              Object.hasOwnProperty.call(message, "race")
            )
              $root.stronachgroup.first.racehorse360.Race.encode(
                message.race,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.date);
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.raceNumber);
            if (
              message.isNightRace != null &&
              Object.hasOwnProperty.call(message, "isNightRace")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .bool(message.isNightRace);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.earnings != null &&
              Object.hasOwnProperty.call(message, "earnings")
            )
              writer.uint32(/* id 8, wireType 5 =*/ 69).float(message.earnings);
            if (
              message.lengthBehindAtFinish != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtFinish")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.lengthBehindAtFinish);
            if (
              message.lengthBehindAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_1")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.lengthBehindAtPointOfCall_1);
            if (
              message.lengthBehindAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_2")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.lengthBehindAtPointOfCall_2);
            if (
              message.lengthBehindAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_3")
            )
              writer
                .uint32(/* id 12, wireType 0 =*/ 96)
                .int32(message.lengthBehindAtPointOfCall_3);
            if (
              message.lengthBehindAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_4")
            )
              writer
                .uint32(/* id 13, wireType 0 =*/ 104)
                .int32(message.lengthBehindAtPointOfCall_4);
            if (
              message.lengthBehindAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "lengthBehindAtPointOfCall_5")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.lengthBehindAtPointOfCall_5);
            if (
              message.lengthAheadAtFinish != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtFinish")
            )
              writer
                .uint32(/* id 15, wireType 0 =*/ 120)
                .int32(message.lengthAheadAtFinish);
            if (
              message.lengthAheadAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_1")
            )
              writer
                .uint32(/* id 16, wireType 0 =*/ 128)
                .int32(message.lengthAheadAtPointOfCall_1);
            if (
              message.lengthAheadAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_2")
            )
              writer
                .uint32(/* id 17, wireType 0 =*/ 136)
                .int32(message.lengthAheadAtPointOfCall_2);
            if (
              message.lengthAheadAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_3")
            )
              writer
                .uint32(/* id 18, wireType 0 =*/ 144)
                .int32(message.lengthAheadAtPointOfCall_3);
            if (
              message.lengthAheadAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_4")
            )
              writer
                .uint32(/* id 19, wireType 0 =*/ 152)
                .int32(message.lengthAheadAtPointOfCall_4);
            if (
              message.lengthAheadAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "lengthAheadAtPointOfCall_5")
            )
              writer
                .uint32(/* id 20, wireType 0 =*/ 160)
                .int32(message.lengthAheadAtPointOfCall_5);
            if (
              message.officialPosition != null &&
              Object.hasOwnProperty.call(message, "officialPosition")
            )
              writer
                .uint32(/* id 21, wireType 0 =*/ 168)
                .int32(message.officialPosition);
            if (
              message.postPosition != null &&
              Object.hasOwnProperty.call(message, "postPosition")
            )
              writer
                .uint32(/* id 22, wireType 0 =*/ 176)
                .int32(message.postPosition);
            if (
              message.positionAtFinish != null &&
              Object.hasOwnProperty.call(message, "positionAtFinish")
            )
              writer
                .uint32(/* id 23, wireType 0 =*/ 184)
                .int32(message.positionAtFinish);
            if (
              message.positionAtStart != null &&
              Object.hasOwnProperty.call(message, "positionAtStart")
            )
              writer
                .uint32(/* id 24, wireType 0 =*/ 192)
                .int32(message.positionAtStart);
            if (
              message.positionAtPointOfCall_1 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_1")
            )
              writer
                .uint32(/* id 25, wireType 0 =*/ 200)
                .int32(message.positionAtPointOfCall_1);
            if (
              message.positionAtPointOfCall_2 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_2")
            )
              writer
                .uint32(/* id 26, wireType 0 =*/ 208)
                .int32(message.positionAtPointOfCall_2);
            if (
              message.positionAtPointOfCall_3 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_3")
            )
              writer
                .uint32(/* id 27, wireType 0 =*/ 216)
                .int32(message.positionAtPointOfCall_3);
            if (
              message.positionAtPointOfCall_4 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_4")
            )
              writer
                .uint32(/* id 28, wireType 0 =*/ 224)
                .int32(message.positionAtPointOfCall_4);
            if (
              message.positionAtPointOfCall_5 != null &&
              Object.hasOwnProperty.call(message, "positionAtPointOfCall_5")
            )
              writer
                .uint32(/* id 29, wireType 0 =*/ 232)
                .int32(message.positionAtPointOfCall_5);
            if (
              message.medication != null &&
              Object.hasOwnProperty.call(message, "medication")
            )
              writer
                .uint32(/* id 30, wireType 2 =*/ 242)
                .string(message.medication);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer
                .uint32(/* id 31, wireType 2 =*/ 250)
                .string(message.comment);
            if (
              message.shortComment != null &&
              Object.hasOwnProperty.call(message, "shortComment")
            )
              writer
                .uint32(/* id 32, wireType 2 =*/ 258)
                .string(message.shortComment);
            if (
              message.isScratched != null &&
              Object.hasOwnProperty.call(message, "isScratched")
            )
              writer
                .uint32(/* id 33, wireType 0 =*/ 264)
                .bool(message.isScratched);
            if (
              message.scratchReason != null &&
              Object.hasOwnProperty.call(message, "scratchReason")
            )
              writer
                .uint32(/* id 34, wireType 2 =*/ 274)
                .string(message.scratchReason);
            if (
              message.jockey != null &&
              Object.hasOwnProperty.call(message, "jockey")
            )
              $root.stronachgroup.first.racehorse360.Jockey.encode(
                message.jockey,
                writer.uint32(/* id 35, wireType 2 =*/ 282).fork()
              ).ldelim();
            if (
              message.weightCarried != null &&
              Object.hasOwnProperty.call(message, "weightCarried")
            )
              writer
                .uint32(/* id 36, wireType 0 =*/ 288)
                .int32(message.weightCarried);
            if (
              message.equipment != null &&
              Object.hasOwnProperty.call(message, "equipment")
            )
              writer
                .uint32(/* id 37, wireType 2 =*/ 298)
                .string(message.equipment);
            if (
              message.odds != null &&
              Object.hasOwnProperty.call(message, "odds")
            )
              writer.uint32(/* id 38, wireType 0 =*/ 304).int32(message.odds);
            if (
              message.owner != null &&
              Object.hasOwnProperty.call(message, "owner")
            )
              $root.stronachgroup.first.racehorse360.Owner.encode(
                message.owner,
                writer.uint32(/* id 39, wireType 2 =*/ 314).fork()
              ).ldelim();
            if (
              message.newOwner != null &&
              Object.hasOwnProperty.call(message, "newOwner")
            )
              $root.stronachgroup.first.racehorse360.Owner.encode(
                message.newOwner,
                writer.uint32(/* id 40, wireType 2 =*/ 322).fork()
              ).ldelim();
            if (
              message.newTrainer != null &&
              Object.hasOwnProperty.call(message, "newTrainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.newTrainer,
                writer.uint32(/* id 41, wireType 2 =*/ 330).fork()
              ).ldelim();
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 42, wireType 2 =*/ 338).fork()
              ).ldelim();
            if (
              message.isVoid != null &&
              Object.hasOwnProperty.call(message, "isVoid")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isVoid,
                writer.uint32(/* id 43, wireType 2 =*/ 346).fork()
              ).ldelim();
            if (
              message.voidReason != null &&
              Object.hasOwnProperty.call(message, "voidReason")
            )
              writer
                .uint32(/* id 44, wireType 2 =*/ 354)
                .string(message.voidReason);
            if (
              message.isPostTimeFavorite != null &&
              Object.hasOwnProperty.call(message, "isPostTimeFavorite")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isPostTimeFavorite,
                writer.uint32(/* id 45, wireType 2 =*/ 362).fork()
              ).ldelim();
            if (
              message.isTroubledTrip != null &&
              Object.hasOwnProperty.call(message, "isTroubledTrip")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isTroubledTrip,
                writer.uint32(/* id 46, wireType 2 =*/ 370).fork()
              ).ldelim();
            if (
              message.isClaimed != null &&
              Object.hasOwnProperty.call(message, "isClaimed")
            )
              writer
                .uint32(/* id 47, wireType 0 =*/ 376)
                .bool(message.isClaimed);
            if (
              message.claimedPriceUsa != null &&
              Object.hasOwnProperty.call(message, "claimedPriceUsa")
            )
              writer
                .uint32(/* id 48, wireType 5 =*/ 389)
                .float(message.claimedPriceUsa);
            return writer;
          };

          /**
           * Decodes a RaceHistory message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceHistory} RaceHistory
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceHistory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceHistory();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.race =
                    $root.stronachgroup.first.racehorse360.Race.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.date = reader.string();
                  break;
                case 5:
                  message.raceNumber = reader.int32();
                  break;
                case 6:
                  message.isNightRace = reader.bool();
                  break;
                case 7:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.earnings = reader.float();
                  break;
                case 9:
                  message.lengthBehindAtFinish = reader.int32();
                  break;
                case 10:
                  message.lengthBehindAtPointOfCall_1 = reader.int32();
                  break;
                case 11:
                  message.lengthBehindAtPointOfCall_2 = reader.int32();
                  break;
                case 12:
                  message.lengthBehindAtPointOfCall_3 = reader.int32();
                  break;
                case 13:
                  message.lengthBehindAtPointOfCall_4 = reader.int32();
                  break;
                case 14:
                  message.lengthBehindAtPointOfCall_5 = reader.int32();
                  break;
                case 15:
                  message.lengthAheadAtFinish = reader.int32();
                  break;
                case 16:
                  message.lengthAheadAtPointOfCall_1 = reader.int32();
                  break;
                case 17:
                  message.lengthAheadAtPointOfCall_2 = reader.int32();
                  break;
                case 18:
                  message.lengthAheadAtPointOfCall_3 = reader.int32();
                  break;
                case 19:
                  message.lengthAheadAtPointOfCall_4 = reader.int32();
                  break;
                case 20:
                  message.lengthAheadAtPointOfCall_5 = reader.int32();
                  break;
                case 21:
                  message.officialPosition = reader.int32();
                  break;
                case 22:
                  message.postPosition = reader.int32();
                  break;
                case 23:
                  message.positionAtFinish = reader.int32();
                  break;
                case 24:
                  message.positionAtStart = reader.int32();
                  break;
                case 25:
                  message.positionAtPointOfCall_1 = reader.int32();
                  break;
                case 26:
                  message.positionAtPointOfCall_2 = reader.int32();
                  break;
                case 27:
                  message.positionAtPointOfCall_3 = reader.int32();
                  break;
                case 28:
                  message.positionAtPointOfCall_4 = reader.int32();
                  break;
                case 29:
                  message.positionAtPointOfCall_5 = reader.int32();
                  break;
                case 30:
                  message.medication = reader.string();
                  break;
                case 31:
                  message.comment = reader.string();
                  break;
                case 32:
                  message.shortComment = reader.string();
                  break;
                case 33:
                  message.isScratched = reader.bool();
                  break;
                case 34:
                  message.scratchReason = reader.string();
                  break;
                case 35:
                  message.jockey =
                    $root.stronachgroup.first.racehorse360.Jockey.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 36:
                  message.weightCarried = reader.int32();
                  break;
                case 37:
                  message.equipment = reader.string();
                  break;
                case 38:
                  message.odds = reader.int32();
                  break;
                case 39:
                  message.owner =
                    $root.stronachgroup.first.racehorse360.Owner.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 40:
                  message.newOwner =
                    $root.stronachgroup.first.racehorse360.Owner.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 41:
                  message.newTrainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 42:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 43:
                  message.isVoid = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 44:
                  message.voidReason = reader.string();
                  break;
                case 45:
                  message.isPostTimeFavorite =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 46:
                  message.isTroubledTrip =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 47:
                  message.isClaimed = reader.bool();
                  break;
                case 48:
                  message.claimedPriceUsa = reader.float();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceHistory message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceHistory} RaceHistory
           */
          RaceHistory.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceHistory
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceHistory();
            if (object.id != null) message.id = String(object.id);
            if (object.race != null) {
              if (typeof object.race !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.race: object expected"
                );
              message.race =
                $root.stronachgroup.first.racehorse360.Race.fromObject(
                  object.race
                );
            }
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.date != null) message.date = String(object.date);
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.isNightRace != null)
              message.isNightRace = Boolean(object.isNightRace);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.earnings != null)
              message.earnings = Number(object.earnings);
            if (object.lengthBehindAtFinish != null)
              message.lengthBehindAtFinish = object.lengthBehindAtFinish | 0;
            if (object.lengthBehindAtPointOfCall_1 != null)
              message.lengthBehindAtPointOfCall_1 =
                object.lengthBehindAtPointOfCall_1 | 0;
            if (object.lengthBehindAtPointOfCall_2 != null)
              message.lengthBehindAtPointOfCall_2 =
                object.lengthBehindAtPointOfCall_2 | 0;
            if (object.lengthBehindAtPointOfCall_3 != null)
              message.lengthBehindAtPointOfCall_3 =
                object.lengthBehindAtPointOfCall_3 | 0;
            if (object.lengthBehindAtPointOfCall_4 != null)
              message.lengthBehindAtPointOfCall_4 =
                object.lengthBehindAtPointOfCall_4 | 0;
            if (object.lengthBehindAtPointOfCall_5 != null)
              message.lengthBehindAtPointOfCall_5 =
                object.lengthBehindAtPointOfCall_5 | 0;
            if (object.lengthAheadAtFinish != null)
              message.lengthAheadAtFinish = object.lengthAheadAtFinish | 0;
            if (object.lengthAheadAtPointOfCall_1 != null)
              message.lengthAheadAtPointOfCall_1 =
                object.lengthAheadAtPointOfCall_1 | 0;
            if (object.lengthAheadAtPointOfCall_2 != null)
              message.lengthAheadAtPointOfCall_2 =
                object.lengthAheadAtPointOfCall_2 | 0;
            if (object.lengthAheadAtPointOfCall_3 != null)
              message.lengthAheadAtPointOfCall_3 =
                object.lengthAheadAtPointOfCall_3 | 0;
            if (object.lengthAheadAtPointOfCall_4 != null)
              message.lengthAheadAtPointOfCall_4 =
                object.lengthAheadAtPointOfCall_4 | 0;
            if (object.lengthAheadAtPointOfCall_5 != null)
              message.lengthAheadAtPointOfCall_5 =
                object.lengthAheadAtPointOfCall_5 | 0;
            if (object.officialPosition != null)
              message.officialPosition = object.officialPosition | 0;
            if (object.postPosition != null)
              message.postPosition = object.postPosition | 0;
            if (object.positionAtFinish != null)
              message.positionAtFinish = object.positionAtFinish | 0;
            if (object.positionAtStart != null)
              message.positionAtStart = object.positionAtStart | 0;
            if (object.positionAtPointOfCall_1 != null)
              message.positionAtPointOfCall_1 =
                object.positionAtPointOfCall_1 | 0;
            if (object.positionAtPointOfCall_2 != null)
              message.positionAtPointOfCall_2 =
                object.positionAtPointOfCall_2 | 0;
            if (object.positionAtPointOfCall_3 != null)
              message.positionAtPointOfCall_3 =
                object.positionAtPointOfCall_3 | 0;
            if (object.positionAtPointOfCall_4 != null)
              message.positionAtPointOfCall_4 =
                object.positionAtPointOfCall_4 | 0;
            if (object.positionAtPointOfCall_5 != null)
              message.positionAtPointOfCall_5 =
                object.positionAtPointOfCall_5 | 0;
            if (object.medication != null)
              message.medication = String(object.medication);
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.shortComment != null)
              message.shortComment = String(object.shortComment);
            if (object.isScratched != null)
              message.isScratched = Boolean(object.isScratched);
            if (object.scratchReason != null)
              message.scratchReason = String(object.scratchReason);
            if (object.jockey != null) {
              if (typeof object.jockey !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.jockey: object expected"
                );
              message.jockey =
                $root.stronachgroup.first.racehorse360.Jockey.fromObject(
                  object.jockey
                );
            }
            if (object.weightCarried != null)
              message.weightCarried = object.weightCarried | 0;
            if (object.equipment != null)
              message.equipment = String(object.equipment);
            if (object.odds != null) message.odds = object.odds | 0;
            if (object.owner != null) {
              if (typeof object.owner !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.owner: object expected"
                );
              message.owner =
                $root.stronachgroup.first.racehorse360.Owner.fromObject(
                  object.owner
                );
            }
            if (object.newOwner != null) {
              if (typeof object.newOwner !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.newOwner: object expected"
                );
              message.newOwner =
                $root.stronachgroup.first.racehorse360.Owner.fromObject(
                  object.newOwner
                );
            }
            if (object.newTrainer != null) {
              if (typeof object.newTrainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.newTrainer: object expected"
                );
              message.newTrainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.newTrainer
                );
            }
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.isVoid != null) {
              if (typeof object.isVoid !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.isVoid: object expected"
                );
              message.isVoid = $root.google.protobuf.BoolValue.fromObject(
                object.isVoid
              );
            }
            if (object.voidReason != null)
              message.voidReason = String(object.voidReason);
            if (object.isPostTimeFavorite != null) {
              if (typeof object.isPostTimeFavorite !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.isPostTimeFavorite: object expected"
                );
              message.isPostTimeFavorite =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isPostTimeFavorite
                );
            }
            if (object.isTroubledTrip != null) {
              if (typeof object.isTroubledTrip !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistory.isTroubledTrip: object expected"
                );
              message.isTroubledTrip =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isTroubledTrip
                );
            }
            if (object.isClaimed != null)
              message.isClaimed = Boolean(object.isClaimed);
            if (object.claimedPriceUsa != null)
              message.claimedPriceUsa = Number(object.claimedPriceUsa);
            return message;
          };

          /**
           * Creates a plain object from a RaceHistory message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @static
           * @param {stronachgroup.first.racehorse360.RaceHistory} message RaceHistory
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceHistory.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.race = null;
              object.facility = null;
              object.date = "";
              object.raceNumber = 0;
              object.isNightRace = false;
              object.horse = null;
              object.earnings = 0;
              object.lengthBehindAtFinish = 0;
              object.lengthBehindAtPointOfCall_1 = 0;
              object.lengthBehindAtPointOfCall_2 = 0;
              object.lengthBehindAtPointOfCall_3 = 0;
              object.lengthBehindAtPointOfCall_4 = 0;
              object.lengthBehindAtPointOfCall_5 = 0;
              object.lengthAheadAtFinish = 0;
              object.lengthAheadAtPointOfCall_1 = 0;
              object.lengthAheadAtPointOfCall_2 = 0;
              object.lengthAheadAtPointOfCall_3 = 0;
              object.lengthAheadAtPointOfCall_4 = 0;
              object.lengthAheadAtPointOfCall_5 = 0;
              object.officialPosition = 0;
              object.postPosition = 0;
              object.positionAtFinish = 0;
              object.positionAtStart = 0;
              object.positionAtPointOfCall_1 = 0;
              object.positionAtPointOfCall_2 = 0;
              object.positionAtPointOfCall_3 = 0;
              object.positionAtPointOfCall_4 = 0;
              object.positionAtPointOfCall_5 = 0;
              object.medication = "";
              object.comment = "";
              object.shortComment = "";
              object.isScratched = false;
              object.scratchReason = "";
              object.jockey = null;
              object.weightCarried = 0;
              object.equipment = "";
              object.odds = 0;
              object.owner = null;
              object.newOwner = null;
              object.newTrainer = null;
              object.trainer = null;
              object.isVoid = null;
              object.voidReason = "";
              object.isPostTimeFavorite = null;
              object.isTroubledTrip = null;
              object.isClaimed = false;
              object.claimedPriceUsa = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.race != null && message.hasOwnProperty("race"))
              object.race =
                $root.stronachgroup.first.racehorse360.Race.toObject(
                  message.race,
                  options
                );
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (
              message.isNightRace != null &&
              message.hasOwnProperty("isNightRace")
            )
              object.isNightRace = message.isNightRace;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.earnings != null && message.hasOwnProperty("earnings"))
              object.earnings =
                options.json && !isFinite(message.earnings)
                  ? String(message.earnings)
                  : message.earnings;
            if (
              message.lengthBehindAtFinish != null &&
              message.hasOwnProperty("lengthBehindAtFinish")
            )
              object.lengthBehindAtFinish = message.lengthBehindAtFinish;
            if (
              message.lengthBehindAtPointOfCall_1 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_1")
            )
              object.lengthBehindAtPointOfCall_1 =
                message.lengthBehindAtPointOfCall_1;
            if (
              message.lengthBehindAtPointOfCall_2 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_2")
            )
              object.lengthBehindAtPointOfCall_2 =
                message.lengthBehindAtPointOfCall_2;
            if (
              message.lengthBehindAtPointOfCall_3 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_3")
            )
              object.lengthBehindAtPointOfCall_3 =
                message.lengthBehindAtPointOfCall_3;
            if (
              message.lengthBehindAtPointOfCall_4 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_4")
            )
              object.lengthBehindAtPointOfCall_4 =
                message.lengthBehindAtPointOfCall_4;
            if (
              message.lengthBehindAtPointOfCall_5 != null &&
              message.hasOwnProperty("lengthBehindAtPointOfCall_5")
            )
              object.lengthBehindAtPointOfCall_5 =
                message.lengthBehindAtPointOfCall_5;
            if (
              message.lengthAheadAtFinish != null &&
              message.hasOwnProperty("lengthAheadAtFinish")
            )
              object.lengthAheadAtFinish = message.lengthAheadAtFinish;
            if (
              message.lengthAheadAtPointOfCall_1 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_1")
            )
              object.lengthAheadAtPointOfCall_1 =
                message.lengthAheadAtPointOfCall_1;
            if (
              message.lengthAheadAtPointOfCall_2 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_2")
            )
              object.lengthAheadAtPointOfCall_2 =
                message.lengthAheadAtPointOfCall_2;
            if (
              message.lengthAheadAtPointOfCall_3 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_3")
            )
              object.lengthAheadAtPointOfCall_3 =
                message.lengthAheadAtPointOfCall_3;
            if (
              message.lengthAheadAtPointOfCall_4 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_4")
            )
              object.lengthAheadAtPointOfCall_4 =
                message.lengthAheadAtPointOfCall_4;
            if (
              message.lengthAheadAtPointOfCall_5 != null &&
              message.hasOwnProperty("lengthAheadAtPointOfCall_5")
            )
              object.lengthAheadAtPointOfCall_5 =
                message.lengthAheadAtPointOfCall_5;
            if (
              message.officialPosition != null &&
              message.hasOwnProperty("officialPosition")
            )
              object.officialPosition = message.officialPosition;
            if (
              message.postPosition != null &&
              message.hasOwnProperty("postPosition")
            )
              object.postPosition = message.postPosition;
            if (
              message.positionAtFinish != null &&
              message.hasOwnProperty("positionAtFinish")
            )
              object.positionAtFinish = message.positionAtFinish;
            if (
              message.positionAtStart != null &&
              message.hasOwnProperty("positionAtStart")
            )
              object.positionAtStart = message.positionAtStart;
            if (
              message.positionAtPointOfCall_1 != null &&
              message.hasOwnProperty("positionAtPointOfCall_1")
            )
              object.positionAtPointOfCall_1 = message.positionAtPointOfCall_1;
            if (
              message.positionAtPointOfCall_2 != null &&
              message.hasOwnProperty("positionAtPointOfCall_2")
            )
              object.positionAtPointOfCall_2 = message.positionAtPointOfCall_2;
            if (
              message.positionAtPointOfCall_3 != null &&
              message.hasOwnProperty("positionAtPointOfCall_3")
            )
              object.positionAtPointOfCall_3 = message.positionAtPointOfCall_3;
            if (
              message.positionAtPointOfCall_4 != null &&
              message.hasOwnProperty("positionAtPointOfCall_4")
            )
              object.positionAtPointOfCall_4 = message.positionAtPointOfCall_4;
            if (
              message.positionAtPointOfCall_5 != null &&
              message.hasOwnProperty("positionAtPointOfCall_5")
            )
              object.positionAtPointOfCall_5 = message.positionAtPointOfCall_5;
            if (
              message.medication != null &&
              message.hasOwnProperty("medication")
            )
              object.medication = message.medication;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.shortComment != null &&
              message.hasOwnProperty("shortComment")
            )
              object.shortComment = message.shortComment;
            if (
              message.isScratched != null &&
              message.hasOwnProperty("isScratched")
            )
              object.isScratched = message.isScratched;
            if (
              message.scratchReason != null &&
              message.hasOwnProperty("scratchReason")
            )
              object.scratchReason = message.scratchReason;
            if (message.jockey != null && message.hasOwnProperty("jockey"))
              object.jockey =
                $root.stronachgroup.first.racehorse360.Jockey.toObject(
                  message.jockey,
                  options
                );
            if (
              message.weightCarried != null &&
              message.hasOwnProperty("weightCarried")
            )
              object.weightCarried = message.weightCarried;
            if (
              message.equipment != null &&
              message.hasOwnProperty("equipment")
            )
              object.equipment = message.equipment;
            if (message.odds != null && message.hasOwnProperty("odds"))
              object.odds = message.odds;
            if (message.owner != null && message.hasOwnProperty("owner"))
              object.owner =
                $root.stronachgroup.first.racehorse360.Owner.toObject(
                  message.owner,
                  options
                );
            if (message.newOwner != null && message.hasOwnProperty("newOwner"))
              object.newOwner =
                $root.stronachgroup.first.racehorse360.Owner.toObject(
                  message.newOwner,
                  options
                );
            if (
              message.newTrainer != null &&
              message.hasOwnProperty("newTrainer")
            )
              object.newTrainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.newTrainer,
                  options
                );
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (message.isVoid != null && message.hasOwnProperty("isVoid"))
              object.isVoid = $root.google.protobuf.BoolValue.toObject(
                message.isVoid,
                options
              );
            if (
              message.voidReason != null &&
              message.hasOwnProperty("voidReason")
            )
              object.voidReason = message.voidReason;
            if (
              message.isPostTimeFavorite != null &&
              message.hasOwnProperty("isPostTimeFavorite")
            )
              object.isPostTimeFavorite =
                $root.google.protobuf.BoolValue.toObject(
                  message.isPostTimeFavorite,
                  options
                );
            if (
              message.isTroubledTrip != null &&
              message.hasOwnProperty("isTroubledTrip")
            )
              object.isTroubledTrip = $root.google.protobuf.BoolValue.toObject(
                message.isTroubledTrip,
                options
              );
            if (
              message.isClaimed != null &&
              message.hasOwnProperty("isClaimed")
            )
              object.isClaimed = message.isClaimed;
            if (
              message.claimedPriceUsa != null &&
              message.hasOwnProperty("claimedPriceUsa")
            )
              object.claimedPriceUsa =
                options.json && !isFinite(message.claimedPriceUsa)
                  ? String(message.claimedPriceUsa)
                  : message.claimedPriceUsa;
            return object;
          };

          /**
           * Converts this RaceHistory to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceHistory
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceHistory;
        })();

        racehorse360.RaceHistoryFilter = (function () {
          /**
           * Properties of a RaceHistoryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceHistoryFilter
           * @property {Array.<string>|null} [ids] RaceHistoryFilter ids
           * @property {string|null} [horse] RaceHistoryFilter horse
           * @property {google.protobuf.IBoolValue|null} [isScratched] RaceHistoryFilter isScratched
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [date] RaceHistoryFilter date
           * @property {Array.<string>|null} [horseIds] RaceHistoryFilter horseIds
           * @property {Array.<string>|null} [trainerIds] RaceHistoryFilter trainerIds
           * @property {Array.<string>|null} [raceIds] RaceHistoryFilter raceIds
           * @property {google.protobuf.IBoolValue|null} [didFinishRace] RaceHistoryFilter didFinishRace
           * @property {google.protobuf.IBoolValue|null} [isRaceOfficial] RaceHistoryFilter isRaceOfficial
           * @property {Array.<string>|null} [horseFacilityIds] RaceHistoryFilter horseFacilityIds
           */

          /**
           * Constructs a new RaceHistoryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceHistoryFilter.
           * @implements IRaceHistoryFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceHistoryFilter=} [properties] Properties to set
           */
          function RaceHistoryFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.trainerIds = [];
            this.raceIds = [];
            this.horseFacilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceHistoryFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.ids = $util.emptyArray;

          /**
           * RaceHistoryFilter horse.
           * @member {string} horse
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.horse = "";

          /**
           * RaceHistoryFilter isScratched.
           * @member {google.protobuf.IBoolValue|null|undefined} isScratched
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.isScratched = null;

          /**
           * RaceHistoryFilter date.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} date
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.date = null;

          /**
           * RaceHistoryFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.horseIds = $util.emptyArray;

          /**
           * RaceHistoryFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * RaceHistoryFilter raceIds.
           * @member {Array.<string>} raceIds
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.raceIds = $util.emptyArray;

          /**
           * RaceHistoryFilter didFinishRace.
           * @member {google.protobuf.IBoolValue|null|undefined} didFinishRace
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.didFinishRace = null;

          /**
           * RaceHistoryFilter isRaceOfficial.
           * @member {google.protobuf.IBoolValue|null|undefined} isRaceOfficial
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.isRaceOfficial = null;

          /**
           * RaceHistoryFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           */
          RaceHistoryFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * Creates a new RaceHistoryFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceHistoryFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceHistoryFilter} RaceHistoryFilter instance
           */
          RaceHistoryFilter.create = function create(properties) {
            return new RaceHistoryFilter(properties);
          };

          /**
           * Encodes the specified RaceHistoryFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceHistoryFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceHistoryFilter} message RaceHistoryFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceHistoryFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horse);
            if (
              message.isScratched != null &&
              Object.hasOwnProperty.call(message, "isScratched")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isScratched,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.date,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.horseIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 8, wireType 2 =*/ 66)
                  .string(message.trainerIds[i]);
            if (message.raceIds != null && message.raceIds.length)
              for (var i = 0; i < message.raceIds.length; ++i)
                writer
                  .uint32(/* id 9, wireType 2 =*/ 74)
                  .string(message.raceIds[i]);
            if (
              message.didFinishRace != null &&
              Object.hasOwnProperty.call(message, "didFinishRace")
            )
              $root.google.protobuf.BoolValue.encode(
                message.didFinishRace,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.isRaceOfficial != null &&
              Object.hasOwnProperty.call(message, "isRaceOfficial")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isRaceOfficial,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 12, wireType 2 =*/ 98)
                  .string(message.horseFacilityIds[i]);
            return writer;
          };

          /**
           * Decodes a RaceHistoryFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceHistoryFilter} RaceHistoryFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceHistoryFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceHistoryFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.horse = reader.string();
                  break;
                case 5:
                  message.isScratched = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 6:
                  message.date =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 7:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 8:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 9:
                  if (!(message.raceIds && message.raceIds.length))
                    message.raceIds = [];
                  message.raceIds.push(reader.string());
                  break;
                case 10:
                  message.didFinishRace =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.isRaceOfficial =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceHistoryFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceHistoryFilter} RaceHistoryFilter
           */
          RaceHistoryFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceHistoryFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceHistoryFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horse != null) message.horse = String(object.horse);
            if (object.isScratched != null) {
              if (typeof object.isScratched !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.isScratched: object expected"
                );
              message.isScratched = $root.google.protobuf.BoolValue.fromObject(
                object.isScratched
              );
            }
            if (object.date != null) {
              if (typeof object.date !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.date: object expected"
                );
              message.date =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.date
                );
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.raceIds) {
              if (!Array.isArray(object.raceIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.raceIds: array expected"
                );
              message.raceIds = [];
              for (var i = 0; i < object.raceIds.length; ++i)
                message.raceIds[i] = String(object.raceIds[i]);
            }
            if (object.didFinishRace != null) {
              if (typeof object.didFinishRace !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.didFinishRace: object expected"
                );
              message.didFinishRace =
                $root.google.protobuf.BoolValue.fromObject(
                  object.didFinishRace
                );
            }
            if (object.isRaceOfficial != null) {
              if (typeof object.isRaceOfficial !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.isRaceOfficial: object expected"
                );
              message.isRaceOfficial =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isRaceOfficial
                );
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceHistoryFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RaceHistoryFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RaceHistoryFilter} message RaceHistoryFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceHistoryFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.trainerIds = [];
              object.raceIds = [];
              object.horseFacilityIds = [];
            }
            if (options.defaults) {
              object.horse = "";
              object.isScratched = null;
              object.date = null;
              object.didFinishRace = null;
              object.isRaceOfficial = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse = message.horse;
            if (
              message.isScratched != null &&
              message.hasOwnProperty("isScratched")
            )
              object.isScratched = $root.google.protobuf.BoolValue.toObject(
                message.isScratched,
                options
              );
            if (message.date != null && message.hasOwnProperty("date"))
              object.date =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.date,
                  options
                );
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.raceIds && message.raceIds.length) {
              object.raceIds = [];
              for (var j = 0; j < message.raceIds.length; ++j)
                object.raceIds[j] = message.raceIds[j];
            }
            if (
              message.didFinishRace != null &&
              message.hasOwnProperty("didFinishRace")
            )
              object.didFinishRace = $root.google.protobuf.BoolValue.toObject(
                message.didFinishRace,
                options
              );
            if (
              message.isRaceOfficial != null &&
              message.hasOwnProperty("isRaceOfficial")
            )
              object.isRaceOfficial = $root.google.protobuf.BoolValue.toObject(
                message.isRaceOfficial,
                options
              );
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            return object;
          };

          /**
           * Converts this RaceHistoryFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceHistoryFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceHistoryFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceHistoryFilter;
        })();

        racehorse360.ListRaceHistoriesRequest = (function () {
          /**
           * Properties of a ListRaceHistoriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRaceHistoriesRequest
           * @property {stronachgroup.first.racehorse360.IRaceHistoryFilter|null} [query] ListRaceHistoriesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRaceHistoriesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRaceHistoriesRequest pagingOptions
           */

          /**
           * Constructs a new ListRaceHistoriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRaceHistoriesRequest.
           * @implements IListRaceHistoriesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesRequest=} [properties] Properties to set
           */
          function ListRaceHistoriesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRaceHistoriesRequest query.
           * @member {stronachgroup.first.racehorse360.IRaceHistoryFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @instance
           */
          ListRaceHistoriesRequest.prototype.query = null;

          /**
           * ListRaceHistoriesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @instance
           */
          ListRaceHistoriesRequest.prototype.getOptions = null;

          /**
           * ListRaceHistoriesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @instance
           */
          ListRaceHistoriesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRaceHistoriesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesRequest} ListRaceHistoriesRequest instance
           */
          ListRaceHistoriesRequest.create = function create(properties) {
            return new ListRaceHistoriesRequest(properties);
          };

          /**
           * Encodes the specified ListRaceHistoriesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRaceHistoriesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesRequest} message ListRaceHistoriesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRaceHistoriesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RaceHistoryFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRaceHistoriesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesRequest} ListRaceHistoriesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRaceHistoriesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRaceHistoriesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RaceHistoryFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRaceHistoriesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesRequest} ListRaceHistoriesRequest
           */
          ListRaceHistoriesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRaceHistoriesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRaceHistoriesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceHistoriesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RaceHistoryFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceHistoriesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceHistoriesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRaceHistoriesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRaceHistoriesRequest} message ListRaceHistoriesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRaceHistoriesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RaceHistoryFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRaceHistoriesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRaceHistoriesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRaceHistoriesRequest;
        })();

        racehorse360.ListRaceHistoriesResponse = (function () {
          /**
           * Properties of a ListRaceHistoriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRaceHistoriesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRaceHistory>|null} [raceHistories] ListRaceHistoriesResponse raceHistories
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRaceHistoriesResponse pagingInfo
           */

          /**
           * Constructs a new ListRaceHistoriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRaceHistoriesResponse.
           * @implements IListRaceHistoriesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesResponse=} [properties] Properties to set
           */
          function ListRaceHistoriesResponse(properties) {
            this.raceHistories = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRaceHistoriesResponse raceHistories.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceHistory>} raceHistories
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @instance
           */
          ListRaceHistoriesResponse.prototype.raceHistories = $util.emptyArray;

          /**
           * ListRaceHistoriesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @instance
           */
          ListRaceHistoriesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRaceHistoriesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesResponse} ListRaceHistoriesResponse instance
           */
          ListRaceHistoriesResponse.create = function create(properties) {
            return new ListRaceHistoriesResponse(properties);
          };

          /**
           * Encodes the specified ListRaceHistoriesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRaceHistoriesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesResponse} message ListRaceHistoriesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRaceHistoriesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.raceHistories != null && message.raceHistories.length)
              for (var i = 0; i < message.raceHistories.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceHistory.encode(
                  message.raceHistories[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRaceHistoriesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesResponse} ListRaceHistoriesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRaceHistoriesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRaceHistoriesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.raceHistories && message.raceHistories.length))
                    message.raceHistories = [];
                  message.raceHistories.push(
                    $root.stronachgroup.first.racehorse360.RaceHistory.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRaceHistoriesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRaceHistoriesResponse} ListRaceHistoriesResponse
           */
          ListRaceHistoriesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRaceHistoriesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRaceHistoriesResponse();
            if (object.raceHistories) {
              if (!Array.isArray(object.raceHistories))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceHistoriesResponse.raceHistories: array expected"
                );
              message.raceHistories = [];
              for (var i = 0; i < object.raceHistories.length; ++i) {
                if (typeof object.raceHistories[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRaceHistoriesResponse.raceHistories: object expected"
                  );
                message.raceHistories[i] =
                  $root.stronachgroup.first.racehorse360.RaceHistory.fromObject(
                    object.raceHistories[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceHistoriesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRaceHistoriesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRaceHistoriesResponse} message ListRaceHistoriesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRaceHistoriesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.raceHistories = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.raceHistories && message.raceHistories.length) {
              object.raceHistories = [];
              for (var j = 0; j < message.raceHistories.length; ++j)
                object.raceHistories[j] =
                  $root.stronachgroup.first.racehorse360.RaceHistory.toObject(
                    message.raceHistories[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRaceHistoriesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRaceHistoriesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRaceHistoriesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRaceHistoriesResponse;
        })();

        racehorse360.Role = (function () {
          /**
           * Properties of a Role.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRole
           * @property {string|null} [id] Role id
           * @property {string|null} [name] Role name
           * @property {stronachgroup.first.racehorse360.RoleType|null} [roleType] Role roleType
           */

          /**
           * Constructs a new Role.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Role.
           * @implements IRole
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRole=} [properties] Properties to set
           */
          function Role(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Role id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Role
           * @instance
           */
          Role.prototype.id = "";

          /**
           * Role name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Role
           * @instance
           */
          Role.prototype.name = "";

          /**
           * Role roleType.
           * @member {stronachgroup.first.racehorse360.RoleType} roleType
           * @memberof stronachgroup.first.racehorse360.Role
           * @instance
           */
          Role.prototype.roleType = 0;

          /**
           * Creates a new Role instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Role
           * @static
           * @param {stronachgroup.first.racehorse360.IRole=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Role} Role instance
           */
          Role.create = function create(properties) {
            return new Role(properties);
          };

          /**
           * Encodes the specified Role message. Does not implicitly {@link stronachgroup.first.racehorse360.Role.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Role
           * @static
           * @param {stronachgroup.first.racehorse360.IRole} message Role message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Role.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            if (
              message.roleType != null &&
              Object.hasOwnProperty.call(message, "roleType")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.roleType);
            return writer;
          };

          /**
           * Decodes a Role message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Role
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Role} Role
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Role.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Role();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                case 5:
                  message.roleType = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Role message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Role
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Role} Role
           */
          Role.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Role)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Role();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            switch (object.roleType) {
              case "ROLE_TYPE_INVALID":
              case 0:
                message.roleType = 0;
                break;
              case "ROLE_TYPE_NORMAL":
              case 1:
                message.roleType = 1;
                break;
              case "ROLE_TYPE_FACILITY":
              case 2:
                message.roleType = 2;
                break;
              case "ROLE_TYPE_TRAINER":
              case 3:
                message.roleType = 3;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a Role message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Role
           * @static
           * @param {stronachgroup.first.racehorse360.Role} message Role
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Role.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
              object.roleType =
                options.enums === String ? "ROLE_TYPE_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.roleType != null && message.hasOwnProperty("roleType"))
              object.roleType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.RoleType[
                      message.roleType
                    ]
                  : message.roleType;
            return object;
          };

          /**
           * Converts this Role to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Role
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Role.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Role;
        })();

        racehorse360.RoleFilter = (function () {
          /**
           * Properties of a RoleFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRoleFilter
           * @property {Array.<string>|null} [ids] RoleFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [name] RoleFilter name
           * @property {google.protobuf.IBoolValue|null} [isUserRequestable] RoleFilter isUserRequestable
           */

          /**
           * Constructs a new RoleFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RoleFilter.
           * @implements IRoleFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRoleFilter=} [properties] Properties to set
           */
          function RoleFilter(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RoleFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @instance
           */
          RoleFilter.prototype.ids = $util.emptyArray;

          /**
           * RoleFilter name.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} name
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @instance
           */
          RoleFilter.prototype.name = null;

          /**
           * RoleFilter isUserRequestable.
           * @member {google.protobuf.IBoolValue|null|undefined} isUserRequestable
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @instance
           */
          RoleFilter.prototype.isUserRequestable = null;

          /**
           * Creates a new RoleFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRoleFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RoleFilter} RoleFilter instance
           */
          RoleFilter.create = function create(properties) {
            return new RoleFilter(properties);
          };

          /**
           * Encodes the specified RoleFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RoleFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRoleFilter} message RoleFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RoleFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.name,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.isUserRequestable != null &&
              Object.hasOwnProperty.call(message, "isUserRequestable")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isUserRequestable,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RoleFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RoleFilter} RoleFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RoleFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.RoleFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.name =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.isUserRequestable =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RoleFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RoleFilter} RoleFilter
           */
          RoleFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RoleFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RoleFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RoleFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.name != null) {
              if (typeof object.name !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RoleFilter.name: object expected"
                );
              message.name =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.name
                );
            }
            if (object.isUserRequestable != null) {
              if (typeof object.isUserRequestable !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RoleFilter.isUserRequestable: object expected"
                );
              message.isUserRequestable =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isUserRequestable
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RoleFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RoleFilter} message RoleFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RoleFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.name = null;
              object.isUserRequestable = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
              object.name =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.name,
                  options
                );
            if (
              message.isUserRequestable != null &&
              message.hasOwnProperty("isUserRequestable")
            )
              object.isUserRequestable =
                $root.google.protobuf.BoolValue.toObject(
                  message.isUserRequestable,
                  options
                );
            return object;
          };

          /**
           * Converts this RoleFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RoleFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RoleFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RoleFilter;
        })();

        racehorse360.ListRolesRequest = (function () {
          /**
           * Properties of a ListRolesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRolesRequest
           * @property {stronachgroup.first.racehorse360.IRoleFilter|null} [query] ListRolesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRolesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRolesRequest pagingOptions
           */

          /**
           * Constructs a new ListRolesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRolesRequest.
           * @implements IListRolesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRolesRequest=} [properties] Properties to set
           */
          function ListRolesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRolesRequest query.
           * @member {stronachgroup.first.racehorse360.IRoleFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @instance
           */
          ListRolesRequest.prototype.query = null;

          /**
           * ListRolesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @instance
           */
          ListRolesRequest.prototype.getOptions = null;

          /**
           * ListRolesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @instance
           */
          ListRolesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRolesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRolesRequest} ListRolesRequest instance
           */
          ListRolesRequest.create = function create(properties) {
            return new ListRolesRequest(properties);
          };

          /**
           * Encodes the specified ListRolesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRolesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolesRequest} message ListRolesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRolesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RoleFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRolesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRolesRequest} ListRolesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRolesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRolesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RoleFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRolesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRolesRequest} ListRolesRequest
           */
          ListRolesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRolesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRolesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RoleFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRolesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRolesRequest} message ListRolesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRolesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RoleFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRolesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRolesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRolesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRolesRequest;
        })();

        racehorse360.ListRolesResponse = (function () {
          /**
           * Properties of a ListRolesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRolesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRole>|null} [roles] ListRolesResponse roles
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRolesResponse pagingInfo
           */

          /**
           * Constructs a new ListRolesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRolesResponse.
           * @implements IListRolesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRolesResponse=} [properties] Properties to set
           */
          function ListRolesResponse(properties) {
            this.roles = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRolesResponse roles.
           * @member {Array.<stronachgroup.first.racehorse360.IRole>} roles
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @instance
           */
          ListRolesResponse.prototype.roles = $util.emptyArray;

          /**
           * ListRolesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @instance
           */
          ListRolesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRolesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRolesResponse} ListRolesResponse instance
           */
          ListRolesResponse.create = function create(properties) {
            return new ListRolesResponse(properties);
          };

          /**
           * Encodes the specified ListRolesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRolesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolesResponse} message ListRolesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRolesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.roles != null && message.roles.length)
              for (var i = 0; i < message.roles.length; ++i)
                $root.stronachgroup.first.racehorse360.Role.encode(
                  message.roles[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRolesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRolesResponse} ListRolesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRolesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRolesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.roles && message.roles.length))
                    message.roles = [];
                  message.roles.push(
                    $root.stronachgroup.first.racehorse360.Role.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRolesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRolesResponse} ListRolesResponse
           */
          ListRolesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRolesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRolesResponse();
            if (object.roles) {
              if (!Array.isArray(object.roles))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolesResponse.roles: array expected"
                );
              message.roles = [];
              for (var i = 0; i < object.roles.length; ++i) {
                if (typeof object.roles[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRolesResponse.roles: object expected"
                  );
                message.roles[i] =
                  $root.stronachgroup.first.racehorse360.Role.fromObject(
                    object.roles[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRolesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRolesResponse} message ListRolesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRolesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.roles = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.roles && message.roles.length) {
              object.roles = [];
              for (var j = 0; j < message.roles.length; ++j)
                object.roles[j] =
                  $root.stronachgroup.first.racehorse360.Role.toObject(
                    message.roles[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRolesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRolesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRolesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRolesResponse;
        })();

        racehorse360.RolePermission = (function () {
          /**
           * Properties of a RolePermission.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRolePermission
           * @property {string|null} [id] RolePermission id
           * @property {stronachgroup.first.racehorse360.IRole|null} [role] RolePermission role
           * @property {string|null} [permission] RolePermission permission
           */

          /**
           * Constructs a new RolePermission.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RolePermission.
           * @implements IRolePermission
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRolePermission=} [properties] Properties to set
           */
          function RolePermission(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RolePermission id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @instance
           */
          RolePermission.prototype.id = "";

          /**
           * RolePermission role.
           * @member {stronachgroup.first.racehorse360.IRole|null|undefined} role
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @instance
           */
          RolePermission.prototype.role = null;

          /**
           * RolePermission permission.
           * @member {string} permission
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @instance
           */
          RolePermission.prototype.permission = "";

          /**
           * Creates a new RolePermission instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @static
           * @param {stronachgroup.first.racehorse360.IRolePermission=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RolePermission} RolePermission instance
           */
          RolePermission.create = function create(properties) {
            return new RolePermission(properties);
          };

          /**
           * Encodes the specified RolePermission message. Does not implicitly {@link stronachgroup.first.racehorse360.RolePermission.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @static
           * @param {stronachgroup.first.racehorse360.IRolePermission} message RolePermission message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RolePermission.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.role != null &&
              Object.hasOwnProperty.call(message, "role")
            )
              $root.stronachgroup.first.racehorse360.Role.encode(
                message.role,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.permission != null &&
              Object.hasOwnProperty.call(message, "permission")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.permission);
            return writer;
          };

          /**
           * Decodes a RolePermission message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RolePermission} RolePermission
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RolePermission.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RolePermission();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.role =
                    $root.stronachgroup.first.racehorse360.Role.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.permission = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RolePermission message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RolePermission} RolePermission
           */
          RolePermission.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RolePermission
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RolePermission();
            if (object.id != null) message.id = String(object.id);
            if (object.role != null) {
              if (typeof object.role !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RolePermission.role: object expected"
                );
              message.role =
                $root.stronachgroup.first.racehorse360.Role.fromObject(
                  object.role
                );
            }
            if (object.permission != null)
              message.permission = String(object.permission);
            return message;
          };

          /**
           * Creates a plain object from a RolePermission message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @static
           * @param {stronachgroup.first.racehorse360.RolePermission} message RolePermission
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RolePermission.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.role = null;
              object.permission = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.role != null && message.hasOwnProperty("role"))
              object.role =
                $root.stronachgroup.first.racehorse360.Role.toObject(
                  message.role,
                  options
                );
            if (
              message.permission != null &&
              message.hasOwnProperty("permission")
            )
              object.permission = message.permission;
            return object;
          };

          /**
           * Converts this RolePermission to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RolePermission
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RolePermission.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RolePermission;
        })();

        racehorse360.RolePermissionFilter = (function () {
          /**
           * Properties of a RolePermissionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRolePermissionFilter
           * @property {Array.<string>|null} [ids] RolePermissionFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [premission] RolePermissionFilter premission
           * @property {Array.<string>|null} [roleIds] RolePermissionFilter roleIds
           */

          /**
           * Constructs a new RolePermissionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RolePermissionFilter.
           * @implements IRolePermissionFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRolePermissionFilter=} [properties] Properties to set
           */
          function RolePermissionFilter(properties) {
            this.ids = [];
            this.roleIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RolePermissionFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @instance
           */
          RolePermissionFilter.prototype.ids = $util.emptyArray;

          /**
           * RolePermissionFilter premission.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} premission
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @instance
           */
          RolePermissionFilter.prototype.premission = null;

          /**
           * RolePermissionFilter roleIds.
           * @member {Array.<string>} roleIds
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @instance
           */
          RolePermissionFilter.prototype.roleIds = $util.emptyArray;

          /**
           * Creates a new RolePermissionFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRolePermissionFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RolePermissionFilter} RolePermissionFilter instance
           */
          RolePermissionFilter.create = function create(properties) {
            return new RolePermissionFilter(properties);
          };

          /**
           * Encodes the specified RolePermissionFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RolePermissionFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRolePermissionFilter} message RolePermissionFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RolePermissionFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.premission != null &&
              Object.hasOwnProperty.call(message, "premission")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.premission,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (message.roleIds != null && message.roleIds.length)
              for (var i = 0; i < message.roleIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.roleIds[i]);
            return writer;
          };

          /**
           * Decodes a RolePermissionFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RolePermissionFilter} RolePermissionFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RolePermissionFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RolePermissionFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.premission =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  if (!(message.roleIds && message.roleIds.length))
                    message.roleIds = [];
                  message.roleIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RolePermissionFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RolePermissionFilter} RolePermissionFilter
           */
          RolePermissionFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RolePermissionFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RolePermissionFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RolePermissionFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.premission != null) {
              if (typeof object.premission !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RolePermissionFilter.premission: object expected"
                );
              message.premission =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.premission
                );
            }
            if (object.roleIds) {
              if (!Array.isArray(object.roleIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RolePermissionFilter.roleIds: array expected"
                );
              message.roleIds = [];
              for (var i = 0; i < object.roleIds.length; ++i)
                message.roleIds[i] = String(object.roleIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a RolePermissionFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RolePermissionFilter} message RolePermissionFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RolePermissionFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.roleIds = [];
            }
            if (options.defaults) object.premission = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.premission != null &&
              message.hasOwnProperty("premission")
            )
              object.premission =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.premission,
                  options
                );
            if (message.roleIds && message.roleIds.length) {
              object.roleIds = [];
              for (var j = 0; j < message.roleIds.length; ++j)
                object.roleIds[j] = message.roleIds[j];
            }
            return object;
          };

          /**
           * Converts this RolePermissionFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RolePermissionFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RolePermissionFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RolePermissionFilter;
        })();

        racehorse360.ListRolePermissionsRequest = (function () {
          /**
           * Properties of a ListRolePermissionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRolePermissionsRequest
           * @property {stronachgroup.first.racehorse360.IRolePermissionFilter|null} [query] ListRolePermissionsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRolePermissionsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRolePermissionsRequest pagingOptions
           */

          /**
           * Constructs a new ListRolePermissionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRolePermissionsRequest.
           * @implements IListRolePermissionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsRequest=} [properties] Properties to set
           */
          function ListRolePermissionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRolePermissionsRequest query.
           * @member {stronachgroup.first.racehorse360.IRolePermissionFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @instance
           */
          ListRolePermissionsRequest.prototype.query = null;

          /**
           * ListRolePermissionsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @instance
           */
          ListRolePermissionsRequest.prototype.getOptions = null;

          /**
           * ListRolePermissionsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @instance
           */
          ListRolePermissionsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRolePermissionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsRequest} ListRolePermissionsRequest instance
           */
          ListRolePermissionsRequest.create = function create(properties) {
            return new ListRolePermissionsRequest(properties);
          };

          /**
           * Encodes the specified ListRolePermissionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRolePermissionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsRequest} message ListRolePermissionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRolePermissionsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RolePermissionFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRolePermissionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsRequest} ListRolePermissionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRolePermissionsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRolePermissionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RolePermissionFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRolePermissionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsRequest} ListRolePermissionsRequest
           */
          ListRolePermissionsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRolePermissionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRolePermissionsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolePermissionsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RolePermissionFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolePermissionsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolePermissionsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRolePermissionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRolePermissionsRequest} message ListRolePermissionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRolePermissionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RolePermissionFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRolePermissionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRolePermissionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRolePermissionsRequest;
        })();

        racehorse360.ListRolePermissionsResponse = (function () {
          /**
           * Properties of a ListRolePermissionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRolePermissionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRolePermission>|null} [rolePermissions] ListRolePermissionsResponse rolePermissions
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRolePermissionsResponse pagingInfo
           */

          /**
           * Constructs a new ListRolePermissionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRolePermissionsResponse.
           * @implements IListRolePermissionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsResponse=} [properties] Properties to set
           */
          function ListRolePermissionsResponse(properties) {
            this.rolePermissions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRolePermissionsResponse rolePermissions.
           * @member {Array.<stronachgroup.first.racehorse360.IRolePermission>} rolePermissions
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @instance
           */
          ListRolePermissionsResponse.prototype.rolePermissions =
            $util.emptyArray;

          /**
           * ListRolePermissionsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @instance
           */
          ListRolePermissionsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRolePermissionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsResponse} ListRolePermissionsResponse instance
           */
          ListRolePermissionsResponse.create = function create(properties) {
            return new ListRolePermissionsResponse(properties);
          };

          /**
           * Encodes the specified ListRolePermissionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRolePermissionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsResponse} message ListRolePermissionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRolePermissionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.rolePermissions != null &&
              message.rolePermissions.length
            )
              for (var i = 0; i < message.rolePermissions.length; ++i)
                $root.stronachgroup.first.racehorse360.RolePermission.encode(
                  message.rolePermissions[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRolePermissionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsResponse} ListRolePermissionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRolePermissionsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRolePermissionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.rolePermissions && message.rolePermissions.length)
                  )
                    message.rolePermissions = [];
                  message.rolePermissions.push(
                    $root.stronachgroup.first.racehorse360.RolePermission.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRolePermissionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRolePermissionsResponse} ListRolePermissionsResponse
           */
          ListRolePermissionsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRolePermissionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRolePermissionsResponse();
            if (object.rolePermissions) {
              if (!Array.isArray(object.rolePermissions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolePermissionsResponse.rolePermissions: array expected"
                );
              message.rolePermissions = [];
              for (var i = 0; i < object.rolePermissions.length; ++i) {
                if (typeof object.rolePermissions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRolePermissionsResponse.rolePermissions: object expected"
                  );
                message.rolePermissions[i] =
                  $root.stronachgroup.first.racehorse360.RolePermission.fromObject(
                    object.rolePermissions[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRolePermissionsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRolePermissionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRolePermissionsResponse} message ListRolePermissionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRolePermissionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.rolePermissions = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.rolePermissions && message.rolePermissions.length) {
              object.rolePermissions = [];
              for (var j = 0; j < message.rolePermissions.length; ++j)
                object.rolePermissions[j] =
                  $root.stronachgroup.first.racehorse360.RolePermission.toObject(
                    message.rolePermissions[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRolePermissionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRolePermissionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRolePermissionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRolePermissionsResponse;
        })();

        racehorse360.Trainer = (function () {
          /**
           * Properties of a Trainer.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrainer
           * @property {string|null} [id] Trainer id
           * @property {string|null} [firstName] Trainer firstName
           * @property {string|null} [lastName] Trainer lastName
           * @property {number|null} [trainerNumber] Trainer trainerNumber
           * @property {string|null} [type] Trainer type
           * @property {string|null} [middleName] Trainer middleName
           * @property {string|null} [fullName] Trainer fullName
           * @property {number|null} [horsesOnGround] Trainer horsesOnGround
           */

          /**
           * Constructs a new Trainer.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Trainer.
           * @implements ITrainer
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrainer=} [properties] Properties to set
           */
          function Trainer(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Trainer id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.id = "";

          /**
           * Trainer firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.firstName = "";

          /**
           * Trainer lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.lastName = "";

          /**
           * Trainer trainerNumber.
           * @member {number} trainerNumber
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.trainerNumber = 0;

          /**
           * Trainer type.
           * @member {string} type
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.type = "";

          /**
           * Trainer middleName.
           * @member {string} middleName
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.middleName = "";

          /**
           * Trainer fullName.
           * @member {string} fullName
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.fullName = "";

          /**
           * Trainer horsesOnGround.
           * @member {number} horsesOnGround
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           */
          Trainer.prototype.horsesOnGround = 0;

          /**
           * Creates a new Trainer instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @static
           * @param {stronachgroup.first.racehorse360.ITrainer=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Trainer} Trainer instance
           */
          Trainer.create = function create(properties) {
            return new Trainer(properties);
          };

          /**
           * Encodes the specified Trainer message. Does not implicitly {@link stronachgroup.first.racehorse360.Trainer.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @static
           * @param {stronachgroup.first.racehorse360.ITrainer} message Trainer message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Trainer.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.lastName);
            if (
              message.trainerNumber != null &&
              Object.hasOwnProperty.call(message, "trainerNumber")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.trainerNumber);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.type);
            if (
              message.middleName != null &&
              Object.hasOwnProperty.call(message, "middleName")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.middleName);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.fullName);
            if (
              message.horsesOnGround != null &&
              Object.hasOwnProperty.call(message, "horsesOnGround")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.horsesOnGround);
            return writer;
          };

          /**
           * Decodes a Trainer message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Trainer} Trainer
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Trainer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Trainer();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.firstName = reader.string();
                  break;
                case 4:
                  message.lastName = reader.string();
                  break;
                case 5:
                  message.trainerNumber = reader.int32();
                  break;
                case 7:
                  message.type = reader.string();
                  break;
                case 8:
                  message.middleName = reader.string();
                  break;
                case 9:
                  message.fullName = reader.string();
                  break;
                case 10:
                  message.horsesOnGround = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Trainer message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Trainer} Trainer
           */
          Trainer.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Trainer
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Trainer();
            if (object.id != null) message.id = String(object.id);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.trainerNumber != null)
              message.trainerNumber = object.trainerNumber | 0;
            if (object.type != null) message.type = String(object.type);
            if (object.middleName != null)
              message.middleName = String(object.middleName);
            if (object.fullName != null)
              message.fullName = String(object.fullName);
            if (object.horsesOnGround != null)
              message.horsesOnGround = object.horsesOnGround | 0;
            return message;
          };

          /**
           * Creates a plain object from a Trainer message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @static
           * @param {stronachgroup.first.racehorse360.Trainer} message Trainer
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Trainer.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.firstName = "";
              object.lastName = "";
              object.trainerNumber = 0;
              object.type = "";
              object.middleName = "";
              object.fullName = "";
              object.horsesOnGround = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.trainerNumber != null &&
              message.hasOwnProperty("trainerNumber")
            )
              object.trainerNumber = message.trainerNumber;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type = message.type;
            if (
              message.middleName != null &&
              message.hasOwnProperty("middleName")
            )
              object.middleName = message.middleName;
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName = message.fullName;
            if (
              message.horsesOnGround != null &&
              message.hasOwnProperty("horsesOnGround")
            )
              object.horsesOnGround = message.horsesOnGround;
            return object;
          };

          /**
           * Converts this Trainer to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Trainer
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Trainer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Trainer;
        })();

        racehorse360.TrainerFilter = (function () {
          /**
           * Properties of a TrainerFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrainerFilter
           * @property {Array.<string>|null} [ids] TrainerFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [firstName] TrainerFilter firstName
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [lastName] TrainerFilter lastName
           * @property {Array.<string>|null} [trainerTypes] TrainerFilter trainerTypes
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [fullName] TrainerFilter fullName
           * @property {stronachgroup.first.racehorse360.IHorseFilter|null} [horseSubFilter] TrainerFilter horseSubFilter
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestFilter|null} [workoutRequestSubFilter] TrainerFilter workoutRequestSubFilter
           * @property {stronachgroup.first.racehorse360.IHorseExamFilter|null} [horseExamSubFilter] TrainerFilter horseExamSubFilter
           */

          /**
           * Constructs a new TrainerFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrainerFilter.
           * @implements ITrainerFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrainerFilter=} [properties] Properties to set
           */
          function TrainerFilter(properties) {
            this.ids = [];
            this.trainerTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrainerFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.ids = $util.emptyArray;

          /**
           * TrainerFilter firstName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} firstName
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.firstName = null;

          /**
           * TrainerFilter lastName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} lastName
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.lastName = null;

          /**
           * TrainerFilter trainerTypes.
           * @member {Array.<string>} trainerTypes
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.trainerTypes = $util.emptyArray;

          /**
           * TrainerFilter fullName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} fullName
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.fullName = null;

          /**
           * TrainerFilter horseSubFilter.
           * @member {stronachgroup.first.racehorse360.IHorseFilter|null|undefined} horseSubFilter
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.horseSubFilter = null;

          /**
           * TrainerFilter workoutRequestSubFilter.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestFilter|null|undefined} workoutRequestSubFilter
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.workoutRequestSubFilter = null;

          /**
           * TrainerFilter horseExamSubFilter.
           * @member {stronachgroup.first.racehorse360.IHorseExamFilter|null|undefined} horseExamSubFilter
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           */
          TrainerFilter.prototype.horseExamSubFilter = null;

          /**
           * Creates a new TrainerFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ITrainerFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrainerFilter} TrainerFilter instance
           */
          TrainerFilter.create = function create(properties) {
            return new TrainerFilter(properties);
          };

          /**
           * Encodes the specified TrainerFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.TrainerFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ITrainerFilter} message TrainerFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrainerFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.firstName,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.lastName,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (message.trainerTypes != null && message.trainerTypes.length)
              for (var i = 0; i < message.trainerTypes.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.trainerTypes[i]);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.fullName,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.horseSubFilter != null &&
              Object.hasOwnProperty.call(message, "horseSubFilter")
            )
              $root.stronachgroup.first.racehorse360.HorseFilter.encode(
                message.horseSubFilter,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            if (
              message.workoutRequestSubFilter != null &&
              Object.hasOwnProperty.call(message, "workoutRequestSubFilter")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.encode(
                message.workoutRequestSubFilter,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.horseExamSubFilter != null &&
              Object.hasOwnProperty.call(message, "horseExamSubFilter")
            )
              $root.stronachgroup.first.racehorse360.HorseExamFilter.encode(
                message.horseExamSubFilter,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a TrainerFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrainerFilter} TrainerFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrainerFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrainerFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.firstName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.lastName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  if (!(message.trainerTypes && message.trainerTypes.length))
                    message.trainerTypes = [];
                  message.trainerTypes.push(reader.string());
                  break;
                case 5:
                  message.fullName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.horseSubFilter =
                    $root.stronachgroup.first.racehorse360.HorseFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 7:
                  message.workoutRequestSubFilter =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.horseExamSubFilter =
                    $root.stronachgroup.first.racehorse360.HorseExamFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrainerFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrainerFilter} TrainerFilter
           */
          TrainerFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrainerFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrainerFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.firstName != null) {
              if (typeof object.firstName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.firstName: object expected"
                );
              message.firstName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.firstName
                );
            }
            if (object.lastName != null) {
              if (typeof object.lastName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.lastName: object expected"
                );
              message.lastName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.lastName
                );
            }
            if (object.trainerTypes) {
              if (!Array.isArray(object.trainerTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.trainerTypes: array expected"
                );
              message.trainerTypes = [];
              for (var i = 0; i < object.trainerTypes.length; ++i)
                message.trainerTypes[i] = String(object.trainerTypes[i]);
            }
            if (object.fullName != null) {
              if (typeof object.fullName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.fullName: object expected"
                );
              message.fullName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.fullName
                );
            }
            if (object.horseSubFilter != null) {
              if (typeof object.horseSubFilter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.horseSubFilter: object expected"
                );
              message.horseSubFilter =
                $root.stronachgroup.first.racehorse360.HorseFilter.fromObject(
                  object.horseSubFilter
                );
            }
            if (object.workoutRequestSubFilter != null) {
              if (typeof object.workoutRequestSubFilter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.workoutRequestSubFilter: object expected"
                );
              message.workoutRequestSubFilter =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.fromObject(
                  object.workoutRequestSubFilter
                );
            }
            if (object.horseExamSubFilter != null) {
              if (typeof object.horseExamSubFilter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrainerFilter.horseExamSubFilter: object expected"
                );
              message.horseExamSubFilter =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.fromObject(
                  object.horseExamSubFilter
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a TrainerFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @static
           * @param {stronachgroup.first.racehorse360.TrainerFilter} message TrainerFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrainerFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.trainerTypes = [];
            }
            if (options.defaults) {
              object.firstName = null;
              object.lastName = null;
              object.fullName = null;
              object.horseSubFilter = null;
              object.workoutRequestSubFilter = null;
              object.horseExamSubFilter = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.firstName,
                  options
                );
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.lastName,
                  options
                );
            if (message.trainerTypes && message.trainerTypes.length) {
              object.trainerTypes = [];
              for (var j = 0; j < message.trainerTypes.length; ++j)
                object.trainerTypes[j] = message.trainerTypes[j];
            }
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.fullName,
                  options
                );
            if (
              message.horseSubFilter != null &&
              message.hasOwnProperty("horseSubFilter")
            )
              object.horseSubFilter =
                $root.stronachgroup.first.racehorse360.HorseFilter.toObject(
                  message.horseSubFilter,
                  options
                );
            if (
              message.workoutRequestSubFilter != null &&
              message.hasOwnProperty("workoutRequestSubFilter")
            )
              object.workoutRequestSubFilter =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.toObject(
                  message.workoutRequestSubFilter,
                  options
                );
            if (
              message.horseExamSubFilter != null &&
              message.hasOwnProperty("horseExamSubFilter")
            )
              object.horseExamSubFilter =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.toObject(
                  message.horseExamSubFilter,
                  options
                );
            return object;
          };

          /**
           * Converts this TrainerFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrainerFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrainerFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrainerFilter;
        })();

        racehorse360.GetTrainerRequest = (function () {
          /**
           * Properties of a GetTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetTrainerRequest
           * @property {string|null} [id] GetTrainerRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetTrainerRequest getOptions
           */

          /**
           * Constructs a new GetTrainerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetTrainerRequest.
           * @implements IGetTrainerRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetTrainerRequest=} [properties] Properties to set
           */
          function GetTrainerRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetTrainerRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @instance
           */
          GetTrainerRequest.prototype.id = "";

          /**
           * GetTrainerRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @instance
           */
          GetTrainerRequest.prototype.getOptions = null;

          /**
           * Creates a new GetTrainerRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetTrainerRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetTrainerRequest} GetTrainerRequest instance
           */
          GetTrainerRequest.create = function create(properties) {
            return new GetTrainerRequest(properties);
          };

          /**
           * Encodes the specified GetTrainerRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetTrainerRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetTrainerRequest} message GetTrainerRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetTrainerRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetTrainerRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetTrainerRequest} GetTrainerRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetTrainerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetTrainerRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetTrainerRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetTrainerRequest} GetTrainerRequest
           */
          GetTrainerRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetTrainerRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetTrainerRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetTrainerRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetTrainerRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetTrainerRequest} message GetTrainerRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetTrainerRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetTrainerRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetTrainerRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetTrainerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetTrainerRequest;
        })();

        racehorse360.ListTrainersRequest = (function () {
          /**
           * Properties of a ListTrainersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListTrainersRequest
           * @property {stronachgroup.first.racehorse360.ITrainerFilter|null} [query] ListTrainersRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListTrainersRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListTrainersRequest pagingOptions
           */

          /**
           * Constructs a new ListTrainersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListTrainersRequest.
           * @implements IListTrainersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListTrainersRequest=} [properties] Properties to set
           */
          function ListTrainersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListTrainersRequest query.
           * @member {stronachgroup.first.racehorse360.ITrainerFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @instance
           */
          ListTrainersRequest.prototype.query = null;

          /**
           * ListTrainersRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @instance
           */
          ListTrainersRequest.prototype.getOptions = null;

          /**
           * ListTrainersRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @instance
           */
          ListTrainersRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListTrainersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrainersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListTrainersRequest} ListTrainersRequest instance
           */
          ListTrainersRequest.create = function create(properties) {
            return new ListTrainersRequest(properties);
          };

          /**
           * Encodes the specified ListTrainersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListTrainersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrainersRequest} message ListTrainersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListTrainersRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.TrainerFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListTrainersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListTrainersRequest} ListTrainersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListTrainersRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListTrainersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.TrainerFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListTrainersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListTrainersRequest} ListTrainersRequest
           */
          ListTrainersRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListTrainersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListTrainersRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrainersRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.TrainerFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrainersRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrainersRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListTrainersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListTrainersRequest} message ListTrainersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListTrainersRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.TrainerFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListTrainersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListTrainersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListTrainersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListTrainersRequest;
        })();

        racehorse360.ListTrainersResponse = (function () {
          /**
           * Properties of a ListTrainersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListTrainersResponse
           * @property {Array.<stronachgroup.first.racehorse360.ITrainer>|null} [trainers] ListTrainersResponse trainers
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListTrainersResponse pagingInfo
           */

          /**
           * Constructs a new ListTrainersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListTrainersResponse.
           * @implements IListTrainersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListTrainersResponse=} [properties] Properties to set
           */
          function ListTrainersResponse(properties) {
            this.trainers = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListTrainersResponse trainers.
           * @member {Array.<stronachgroup.first.racehorse360.ITrainer>} trainers
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @instance
           */
          ListTrainersResponse.prototype.trainers = $util.emptyArray;

          /**
           * ListTrainersResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @instance
           */
          ListTrainersResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListTrainersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrainersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListTrainersResponse} ListTrainersResponse instance
           */
          ListTrainersResponse.create = function create(properties) {
            return new ListTrainersResponse(properties);
          };

          /**
           * Encodes the specified ListTrainersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListTrainersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrainersResponse} message ListTrainersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListTrainersResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.trainers != null && message.trainers.length)
              for (var i = 0; i < message.trainers.length; ++i)
                $root.stronachgroup.first.racehorse360.Trainer.encode(
                  message.trainers[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListTrainersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListTrainersResponse} ListTrainersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListTrainersResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListTrainersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.trainers && message.trainers.length))
                    message.trainers = [];
                  message.trainers.push(
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListTrainersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListTrainersResponse} ListTrainersResponse
           */
          ListTrainersResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListTrainersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListTrainersResponse();
            if (object.trainers) {
              if (!Array.isArray(object.trainers))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrainersResponse.trainers: array expected"
                );
              message.trainers = [];
              for (var i = 0; i < object.trainers.length; ++i) {
                if (typeof object.trainers[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListTrainersResponse.trainers: object expected"
                  );
                message.trainers[i] =
                  $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                    object.trainers[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrainersResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListTrainersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListTrainersResponse} message ListTrainersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListTrainersResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.trainers = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.trainers && message.trainers.length) {
              object.trainers = [];
              for (var j = 0; j < message.trainers.length; ++j)
                object.trainers[j] =
                  $root.stronachgroup.first.racehorse360.Trainer.toObject(
                    message.trainers[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListTrainersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListTrainersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListTrainersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListTrainersResponse;
        })();

        racehorse360.UpcomingRace = (function () {
          /**
           * Properties of an UpcomingRace.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRace
           * @property {string|null} [id] UpcomingRace id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] UpcomingRace facility
           * @property {string|null} [raceDate] UpcomingRace raceDate
           * @property {number|null} [raceNumber] UpcomingRace raceNumber
           * @property {boolean|null} [isNightRace] UpcomingRace isNightRace
           * @property {string|null} [aboutDistanceIndicator] UpcomingRace aboutDistanceIndicator
           * @property {string|null} [ageRestriction] UpcomingRace ageRestriction
           * @property {string|null} [breed] UpcomingRace breed
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseType] UpcomingRace courseType
           * @property {number|null} [distance] UpcomingRace distance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [distanceUnit] UpcomingRace distanceUnit
           * @property {string|null} [genderRestriction] UpcomingRace genderRestriction
           * @property {number|null} [maximumClaimPrice] UpcomingRace maximumClaimPrice
           * @property {number|null} [minimumClaimPrice] UpcomingRace minimumClaimPrice
           * @property {number|null} [purseUsa] UpcomingRace purseUsa
           * @property {string|null} [raceConditions] UpcomingRace raceConditions
           * @property {string|null} [raceName] UpcomingRace raceName
           * @property {string|null} [raceNameAbbreviated] UpcomingRace raceNameAbbreviated
           * @property {string|null} [raceType] UpcomingRace raceType
           * @property {string|null} [restrictionType] UpcomingRace restrictionType
           */

          /**
           * Constructs a new UpcomingRace.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRace.
           * @implements IUpcomingRace
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRace=} [properties] Properties to set
           */
          function UpcomingRace(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRace id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.id = "";

          /**
           * UpcomingRace facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.facility = null;

          /**
           * UpcomingRace raceDate.
           * @member {string} raceDate
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceDate = "";

          /**
           * UpcomingRace raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceNumber = 0;

          /**
           * UpcomingRace isNightRace.
           * @member {boolean} isNightRace
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.isNightRace = false;

          /**
           * UpcomingRace aboutDistanceIndicator.
           * @member {string} aboutDistanceIndicator
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.aboutDistanceIndicator = "";

          /**
           * UpcomingRace ageRestriction.
           * @member {string} ageRestriction
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.ageRestriction = "";

          /**
           * UpcomingRace breed.
           * @member {string} breed
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.breed = "";

          /**
           * UpcomingRace courseType.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseType
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.courseType = 0;

          /**
           * UpcomingRace distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.distance = 0;

          /**
           * UpcomingRace distanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} distanceUnit
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.distanceUnit = 0;

          /**
           * UpcomingRace genderRestriction.
           * @member {string} genderRestriction
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.genderRestriction = "";

          /**
           * UpcomingRace maximumClaimPrice.
           * @member {number} maximumClaimPrice
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.maximumClaimPrice = 0;

          /**
           * UpcomingRace minimumClaimPrice.
           * @member {number} minimumClaimPrice
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.minimumClaimPrice = 0;

          /**
           * UpcomingRace purseUsa.
           * @member {number} purseUsa
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.purseUsa = 0;

          /**
           * UpcomingRace raceConditions.
           * @member {string} raceConditions
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceConditions = "";

          /**
           * UpcomingRace raceName.
           * @member {string} raceName
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceName = "";

          /**
           * UpcomingRace raceNameAbbreviated.
           * @member {string} raceNameAbbreviated
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceNameAbbreviated = "";

          /**
           * UpcomingRace raceType.
           * @member {string} raceType
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.raceType = "";

          /**
           * UpcomingRace restrictionType.
           * @member {string} restrictionType
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           */
          UpcomingRace.prototype.restrictionType = "";

          /**
           * Creates a new UpcomingRace instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRace=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRace} UpcomingRace instance
           */
          UpcomingRace.create = function create(properties) {
            return new UpcomingRace(properties);
          };

          /**
           * Encodes the specified UpcomingRace message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRace.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRace} message UpcomingRace message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRace.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.raceDate);
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.raceNumber);
            if (
              message.isNightRace != null &&
              Object.hasOwnProperty.call(message, "isNightRace")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .bool(message.isNightRace);
            if (
              message.aboutDistanceIndicator != null &&
              Object.hasOwnProperty.call(message, "aboutDistanceIndicator")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.aboutDistanceIndicator);
            if (
              message.ageRestriction != null &&
              Object.hasOwnProperty.call(message, "ageRestriction")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.ageRestriction);
            if (
              message.breed != null &&
              Object.hasOwnProperty.call(message, "breed")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.breed);
            if (
              message.courseType != null &&
              Object.hasOwnProperty.call(message, "courseType")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.courseType);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.distance);
            if (
              message.distanceUnit != null &&
              Object.hasOwnProperty.call(message, "distanceUnit")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.distanceUnit);
            if (
              message.genderRestriction != null &&
              Object.hasOwnProperty.call(message, "genderRestriction")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.genderRestriction);
            if (
              message.maximumClaimPrice != null &&
              Object.hasOwnProperty.call(message, "maximumClaimPrice")
            )
              writer
                .uint32(/* id 13, wireType 5 =*/ 109)
                .float(message.maximumClaimPrice);
            if (
              message.minimumClaimPrice != null &&
              Object.hasOwnProperty.call(message, "minimumClaimPrice")
            )
              writer
                .uint32(/* id 14, wireType 5 =*/ 117)
                .float(message.minimumClaimPrice);
            if (
              message.purseUsa != null &&
              Object.hasOwnProperty.call(message, "purseUsa")
            )
              writer
                .uint32(/* id 15, wireType 5 =*/ 125)
                .float(message.purseUsa);
            if (
              message.raceConditions != null &&
              Object.hasOwnProperty.call(message, "raceConditions")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.raceConditions);
            if (
              message.raceName != null &&
              Object.hasOwnProperty.call(message, "raceName")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.raceName);
            if (
              message.raceNameAbbreviated != null &&
              Object.hasOwnProperty.call(message, "raceNameAbbreviated")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.raceNameAbbreviated);
            if (
              message.raceType != null &&
              Object.hasOwnProperty.call(message, "raceType")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.raceType);
            if (
              message.restrictionType != null &&
              Object.hasOwnProperty.call(message, "restrictionType")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.restrictionType);
            return writer;
          };

          /**
           * Decodes an UpcomingRace message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRace} UpcomingRace
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRace.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRace();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.raceDate = reader.string();
                  break;
                case 4:
                  message.raceNumber = reader.int32();
                  break;
                case 5:
                  message.isNightRace = reader.bool();
                  break;
                case 6:
                  message.aboutDistanceIndicator = reader.string();
                  break;
                case 7:
                  message.ageRestriction = reader.string();
                  break;
                case 8:
                  message.breed = reader.string();
                  break;
                case 9:
                  message.courseType = reader.int32();
                  break;
                case 10:
                  message.distance = reader.int32();
                  break;
                case 11:
                  message.distanceUnit = reader.int32();
                  break;
                case 12:
                  message.genderRestriction = reader.string();
                  break;
                case 13:
                  message.maximumClaimPrice = reader.float();
                  break;
                case 14:
                  message.minimumClaimPrice = reader.float();
                  break;
                case 15:
                  message.purseUsa = reader.float();
                  break;
                case 16:
                  message.raceConditions = reader.string();
                  break;
                case 17:
                  message.raceName = reader.string();
                  break;
                case 18:
                  message.raceNameAbbreviated = reader.string();
                  break;
                case 19:
                  message.raceType = reader.string();
                  break;
                case 20:
                  message.restrictionType = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRace message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRace} UpcomingRace
           */
          UpcomingRace.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRace
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRace();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRace.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.raceDate != null)
              message.raceDate = String(object.raceDate);
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.isNightRace != null)
              message.isNightRace = Boolean(object.isNightRace);
            if (object.aboutDistanceIndicator != null)
              message.aboutDistanceIndicator = String(
                object.aboutDistanceIndicator
              );
            if (object.ageRestriction != null)
              message.ageRestriction = String(object.ageRestriction);
            if (object.breed != null) message.breed = String(object.breed);
            switch (object.courseType) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseType = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseType = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseType = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseType = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseType = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseType = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseType = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseType = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseType = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseType = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseType = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseType = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseType = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseType = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseType = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseType = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseType = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseType = 17;
                break;
            }
            if (object.distance != null) message.distance = object.distance | 0;
            switch (object.distanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.distanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.distanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.distanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.distanceUnit = 3;
                break;
            }
            if (object.genderRestriction != null)
              message.genderRestriction = String(object.genderRestriction);
            if (object.maximumClaimPrice != null)
              message.maximumClaimPrice = Number(object.maximumClaimPrice);
            if (object.minimumClaimPrice != null)
              message.minimumClaimPrice = Number(object.minimumClaimPrice);
            if (object.purseUsa != null)
              message.purseUsa = Number(object.purseUsa);
            if (object.raceConditions != null)
              message.raceConditions = String(object.raceConditions);
            if (object.raceName != null)
              message.raceName = String(object.raceName);
            if (object.raceNameAbbreviated != null)
              message.raceNameAbbreviated = String(object.raceNameAbbreviated);
            if (object.raceType != null)
              message.raceType = String(object.raceType);
            if (object.restrictionType != null)
              message.restrictionType = String(object.restrictionType);
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRace message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRace} message UpcomingRace
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRace.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.raceDate = "";
              object.raceNumber = 0;
              object.isNightRace = false;
              object.aboutDistanceIndicator = "";
              object.ageRestriction = "";
              object.breed = "";
              object.courseType =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.distance = 0;
              object.distanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
              object.genderRestriction = "";
              object.maximumClaimPrice = 0;
              object.minimumClaimPrice = 0;
              object.purseUsa = 0;
              object.raceConditions = "";
              object.raceName = "";
              object.raceNameAbbreviated = "";
              object.raceType = "";
              object.restrictionType = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate = message.raceDate;
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (
              message.isNightRace != null &&
              message.hasOwnProperty("isNightRace")
            )
              object.isNightRace = message.isNightRace;
            if (
              message.aboutDistanceIndicator != null &&
              message.hasOwnProperty("aboutDistanceIndicator")
            )
              object.aboutDistanceIndicator = message.aboutDistanceIndicator;
            if (
              message.ageRestriction != null &&
              message.hasOwnProperty("ageRestriction")
            )
              object.ageRestriction = message.ageRestriction;
            if (message.breed != null && message.hasOwnProperty("breed"))
              object.breed = message.breed;
            if (
              message.courseType != null &&
              message.hasOwnProperty("courseType")
            )
              object.courseType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseType
                    ]
                  : message.courseType;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.distanceUnit != null &&
              message.hasOwnProperty("distanceUnit")
            )
              object.distanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.distanceUnit
                    ]
                  : message.distanceUnit;
            if (
              message.genderRestriction != null &&
              message.hasOwnProperty("genderRestriction")
            )
              object.genderRestriction = message.genderRestriction;
            if (
              message.maximumClaimPrice != null &&
              message.hasOwnProperty("maximumClaimPrice")
            )
              object.maximumClaimPrice =
                options.json && !isFinite(message.maximumClaimPrice)
                  ? String(message.maximumClaimPrice)
                  : message.maximumClaimPrice;
            if (
              message.minimumClaimPrice != null &&
              message.hasOwnProperty("minimumClaimPrice")
            )
              object.minimumClaimPrice =
                options.json && !isFinite(message.minimumClaimPrice)
                  ? String(message.minimumClaimPrice)
                  : message.minimumClaimPrice;
            if (message.purseUsa != null && message.hasOwnProperty("purseUsa"))
              object.purseUsa =
                options.json && !isFinite(message.purseUsa)
                  ? String(message.purseUsa)
                  : message.purseUsa;
            if (
              message.raceConditions != null &&
              message.hasOwnProperty("raceConditions")
            )
              object.raceConditions = message.raceConditions;
            if (message.raceName != null && message.hasOwnProperty("raceName"))
              object.raceName = message.raceName;
            if (
              message.raceNameAbbreviated != null &&
              message.hasOwnProperty("raceNameAbbreviated")
            )
              object.raceNameAbbreviated = message.raceNameAbbreviated;
            if (message.raceType != null && message.hasOwnProperty("raceType"))
              object.raceType = message.raceType;
            if (
              message.restrictionType != null &&
              message.hasOwnProperty("restrictionType")
            )
              object.restrictionType = message.restrictionType;
            return object;
          };

          /**
           * Converts this UpcomingRace to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRace
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRace;
        })();

        racehorse360.UpcomingRaceFilter = (function () {
          /**
           * Properties of an UpcomingRaceFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceFilter
           * @property {Array.<string>|null} [ids] UpcomingRaceFilter ids
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [raceDate] UpcomingRaceFilter raceDate
           * @property {Array.<string>|null} [facilityIds] UpcomingRaceFilter facilityIds
           * @property {Array.<number>|null} [raceNumbers] UpcomingRaceFilter raceNumbers
           */

          /**
           * Constructs a new UpcomingRaceFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceFilter.
           * @implements IUpcomingRaceFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceFilter=} [properties] Properties to set
           */
          function UpcomingRaceFilter(properties) {
            this.ids = [];
            this.facilityIds = [];
            this.raceNumbers = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @instance
           */
          UpcomingRaceFilter.prototype.ids = $util.emptyArray;

          /**
           * UpcomingRaceFilter raceDate.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} raceDate
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @instance
           */
          UpcomingRaceFilter.prototype.raceDate = null;

          /**
           * UpcomingRaceFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @instance
           */
          UpcomingRaceFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * UpcomingRaceFilter raceNumbers.
           * @member {Array.<number>} raceNumbers
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @instance
           */
          UpcomingRaceFilter.prototype.raceNumbers = $util.emptyArray;

          /**
           * Creates a new UpcomingRaceFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceFilter} UpcomingRaceFilter instance
           */
          UpcomingRaceFilter.create = function create(properties) {
            return new UpcomingRaceFilter(properties);
          };

          /**
           * Encodes the specified UpcomingRaceFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceFilter} message UpcomingRaceFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.raceDate,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.facilityIds[i]);
            if (message.raceNumbers != null && message.raceNumbers.length) {
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
              for (var i = 0; i < message.raceNumbers.length; ++i)
                writer.int32(message.raceNumbers[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes an UpcomingRaceFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceFilter} UpcomingRaceFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.raceDate =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 4:
                  if (!(message.raceNumbers && message.raceNumbers.length))
                    message.raceNumbers = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.raceNumbers.push(reader.int32());
                  } else message.raceNumbers.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceFilter} UpcomingRaceFilter
           */
          UpcomingRaceFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.raceDate != null) {
              if (typeof object.raceDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceFilter.raceDate: object expected"
                );
              message.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.raceDate
                );
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.raceNumbers) {
              if (!Array.isArray(object.raceNumbers))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceFilter.raceNumbers: array expected"
                );
              message.raceNumbers = [];
              for (var i = 0; i < object.raceNumbers.length; ++i)
                message.raceNumbers[i] = object.raceNumbers[i] | 0;
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceFilter} message UpcomingRaceFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.facilityIds = [];
              object.raceNumbers = [];
            }
            if (options.defaults) object.raceDate = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.raceDate,
                  options
                );
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.raceNumbers && message.raceNumbers.length) {
              object.raceNumbers = [];
              for (var j = 0; j < message.raceNumbers.length; ++j)
                object.raceNumbers[j] = message.raceNumbers[j];
            }
            return object;
          };

          /**
           * Converts this UpcomingRaceFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceFilter;
        })();

        racehorse360.ListUpcomingRacesRequest = (function () {
          /**
           * Properties of a ListUpcomingRacesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUpcomingRacesRequest
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceFilter|null} [query] ListUpcomingRacesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListUpcomingRacesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListUpcomingRacesRequest pagingOptions
           */

          /**
           * Constructs a new ListUpcomingRacesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUpcomingRacesRequest.
           * @implements IListUpcomingRacesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesRequest=} [properties] Properties to set
           */
          function ListUpcomingRacesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUpcomingRacesRequest query.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @instance
           */
          ListUpcomingRacesRequest.prototype.query = null;

          /**
           * ListUpcomingRacesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @instance
           */
          ListUpcomingRacesRequest.prototype.getOptions = null;

          /**
           * ListUpcomingRacesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @instance
           */
          ListUpcomingRacesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListUpcomingRacesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesRequest} ListUpcomingRacesRequest instance
           */
          ListUpcomingRacesRequest.create = function create(properties) {
            return new ListUpcomingRacesRequest(properties);
          };

          /**
           * Encodes the specified ListUpcomingRacesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUpcomingRacesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesRequest} message ListUpcomingRacesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUpcomingRacesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUpcomingRacesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesRequest} ListUpcomingRacesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUpcomingRacesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUpcomingRacesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUpcomingRacesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesRequest} ListUpcomingRacesRequest
           */
          ListUpcomingRacesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUpcomingRacesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUpcomingRacesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRacesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.UpcomingRaceFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRacesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRacesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUpcomingRacesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListUpcomingRacesRequest} message ListUpcomingRacesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUpcomingRacesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.UpcomingRaceFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUpcomingRacesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUpcomingRacesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUpcomingRacesRequest;
        })();

        racehorse360.ListUpcomingRacesResponse = (function () {
          /**
           * Properties of a ListUpcomingRacesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUpcomingRacesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUpcomingRace>|null} [upcomingRaces] ListUpcomingRacesResponse upcomingRaces
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListUpcomingRacesResponse pagingInfo
           */

          /**
           * Constructs a new ListUpcomingRacesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUpcomingRacesResponse.
           * @implements IListUpcomingRacesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesResponse=} [properties] Properties to set
           */
          function ListUpcomingRacesResponse(properties) {
            this.upcomingRaces = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUpcomingRacesResponse upcomingRaces.
           * @member {Array.<stronachgroup.first.racehorse360.IUpcomingRace>} upcomingRaces
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @instance
           */
          ListUpcomingRacesResponse.prototype.upcomingRaces = $util.emptyArray;

          /**
           * ListUpcomingRacesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @instance
           */
          ListUpcomingRacesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListUpcomingRacesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesResponse} ListUpcomingRacesResponse instance
           */
          ListUpcomingRacesResponse.create = function create(properties) {
            return new ListUpcomingRacesResponse(properties);
          };

          /**
           * Encodes the specified ListUpcomingRacesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUpcomingRacesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesResponse} message ListUpcomingRacesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUpcomingRacesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.upcomingRaces != null && message.upcomingRaces.length)
              for (var i = 0; i < message.upcomingRaces.length; ++i)
                $root.stronachgroup.first.racehorse360.UpcomingRace.encode(
                  message.upcomingRaces[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUpcomingRacesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesResponse} ListUpcomingRacesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUpcomingRacesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUpcomingRacesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.upcomingRaces && message.upcomingRaces.length))
                    message.upcomingRaces = [];
                  message.upcomingRaces.push(
                    $root.stronachgroup.first.racehorse360.UpcomingRace.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUpcomingRacesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRacesResponse} ListUpcomingRacesResponse
           */
          ListUpcomingRacesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUpcomingRacesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUpcomingRacesResponse();
            if (object.upcomingRaces) {
              if (!Array.isArray(object.upcomingRaces))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRacesResponse.upcomingRaces: array expected"
                );
              message.upcomingRaces = [];
              for (var i = 0; i < object.upcomingRaces.length; ++i) {
                if (typeof object.upcomingRaces[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListUpcomingRacesResponse.upcomingRaces: object expected"
                  );
                message.upcomingRaces[i] =
                  $root.stronachgroup.first.racehorse360.UpcomingRace.fromObject(
                    object.upcomingRaces[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRacesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUpcomingRacesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListUpcomingRacesResponse} message ListUpcomingRacesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUpcomingRacesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.upcomingRaces = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.upcomingRaces && message.upcomingRaces.length) {
              object.upcomingRaces = [];
              for (var j = 0; j < message.upcomingRaces.length; ++j)
                object.upcomingRaces[j] =
                  $root.stronachgroup.first.racehorse360.UpcomingRace.toObject(
                    message.upcomingRaces[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUpcomingRacesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRacesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUpcomingRacesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUpcomingRacesResponse;
        })();

        racehorse360.UpcomingRaceEntry = (function () {
          /**
           * Properties of an UpcomingRaceEntry.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntry
           * @property {string|null} [id] UpcomingRaceEntry id
           * @property {stronachgroup.first.racehorse360.IUpcomingRace|null} [upcomingRace] UpcomingRaceEntry upcomingRace
           * @property {string|null} [facilityId] UpcomingRaceEntry facilityId
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] UpcomingRaceEntry facility
           * @property {string|null} [raceDate] UpcomingRaceEntry raceDate
           * @property {number|null} [raceNumber] UpcomingRaceEntry raceNumber
           * @property {boolean|null} [isNightRace] UpcomingRaceEntry isNightRace
           * @property {string|null} [horseId] UpcomingRaceEntry horseId
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] UpcomingRaceEntry horse
           * @property {number|null} [racePosition] UpcomingRaceEntry racePosition
           * @property {stronachgroup.first.racehorse360.UpcomingRaceEntryStatus|null} [status] UpcomingRaceEntry status
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntryFlag|null} [flag] UpcomingRaceEntry flag
           * @property {boolean|null} [isFlagged] UpcomingRaceEntry isFlagged
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntryExamNote|null} [entryExamNote] UpcomingRaceEntry entryExamNote
           * @property {number|null} [highSpeedFurlongs] UpcomingRaceEntry highSpeedFurlongs
           * @property {number|null} [classChange] UpcomingRaceEntry classChange
           * @property {number|null} [claimChange] UpcomingRaceEntry claimChange
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntryEntryExam|null} [entryExam] UpcomingRaceEntry entryExam
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntryRaceDayExam|null} [raceDayExam] UpcomingRaceEntry raceDayExam
           */

          /**
           * Constructs a new UpcomingRaceEntry.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntry.
           * @implements IUpcomingRaceEntry
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntry=} [properties] Properties to set
           */
          function UpcomingRaceEntry(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntry id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.id = "";

          /**
           * UpcomingRaceEntry upcomingRace.
           * @member {stronachgroup.first.racehorse360.IUpcomingRace|null|undefined} upcomingRace
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.upcomingRace = null;

          /**
           * UpcomingRaceEntry facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.facilityId = "";

          /**
           * UpcomingRaceEntry facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.facility = null;

          /**
           * UpcomingRaceEntry raceDate.
           * @member {string} raceDate
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.raceDate = "";

          /**
           * UpcomingRaceEntry raceNumber.
           * @member {number} raceNumber
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.raceNumber = 0;

          /**
           * UpcomingRaceEntry isNightRace.
           * @member {boolean} isNightRace
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.isNightRace = false;

          /**
           * UpcomingRaceEntry horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.horseId = "";

          /**
           * UpcomingRaceEntry horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.horse = null;

          /**
           * UpcomingRaceEntry racePosition.
           * @member {number} racePosition
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.racePosition = 0;

          /**
           * UpcomingRaceEntry status.
           * @member {stronachgroup.first.racehorse360.UpcomingRaceEntryStatus} status
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.status = 0;

          /**
           * UpcomingRaceEntry flag.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntryFlag|null|undefined} flag
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.flag = null;

          /**
           * UpcomingRaceEntry isFlagged.
           * @member {boolean} isFlagged
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.isFlagged = false;

          /**
           * UpcomingRaceEntry entryExamNote.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntryExamNote|null|undefined} entryExamNote
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.entryExamNote = null;

          /**
           * UpcomingRaceEntry highSpeedFurlongs.
           * @member {number} highSpeedFurlongs
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.highSpeedFurlongs = 0;

          /**
           * UpcomingRaceEntry classChange.
           * @member {number} classChange
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.classChange = 0;

          /**
           * UpcomingRaceEntry claimChange.
           * @member {number} claimChange
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.claimChange = 0;

          /**
           * UpcomingRaceEntry entryExam.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntryEntryExam|null|undefined} entryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.entryExam = null;

          /**
           * UpcomingRaceEntry raceDayExam.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntryRaceDayExam|null|undefined} raceDayExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           */
          UpcomingRaceEntry.prototype.raceDayExam = null;

          /**
           * Creates a new UpcomingRaceEntry instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntry=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntry} UpcomingRaceEntry instance
           */
          UpcomingRaceEntry.create = function create(properties) {
            return new UpcomingRaceEntry(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntry message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntry.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntry} message UpcomingRaceEntry message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntry.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.upcomingRace != null &&
              Object.hasOwnProperty.call(message, "upcomingRace")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRace.encode(
                message.upcomingRace,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.facilityId);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.raceDate);
            if (
              message.raceNumber != null &&
              Object.hasOwnProperty.call(message, "raceNumber")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.raceNumber);
            if (
              message.isNightRace != null &&
              Object.hasOwnProperty.call(message, "isNightRace")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .bool(message.isNightRace);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.horseId);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.racePosition != null &&
              Object.hasOwnProperty.call(message, "racePosition")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.racePosition);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 12, wireType 0 =*/ 96).int32(message.status);
            if (
              message.flag != null &&
              Object.hasOwnProperty.call(message, "flag")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.encode(
                message.flag,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.isFlagged != null &&
              Object.hasOwnProperty.call(message, "isFlagged")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .bool(message.isFlagged);
            if (
              message.entryExamNote != null &&
              Object.hasOwnProperty.call(message, "entryExamNote")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.encode(
                message.entryExamNote,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            if (
              message.highSpeedFurlongs != null &&
              Object.hasOwnProperty.call(message, "highSpeedFurlongs")
            )
              writer
                .uint32(/* id 18, wireType 0 =*/ 144)
                .int32(message.highSpeedFurlongs);
            if (
              message.classChange != null &&
              Object.hasOwnProperty.call(message, "classChange")
            )
              writer
                .uint32(/* id 19, wireType 0 =*/ 152)
                .int32(message.classChange);
            if (
              message.claimChange != null &&
              Object.hasOwnProperty.call(message, "claimChange")
            )
              writer
                .uint32(/* id 20, wireType 5 =*/ 165)
                .float(message.claimChange);
            if (
              message.entryExam != null &&
              Object.hasOwnProperty.call(message, "entryExam")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.encode(
                message.entryExam,
                writer.uint32(/* id 21, wireType 2 =*/ 170).fork()
              ).ldelim();
            if (
              message.raceDayExam != null &&
              Object.hasOwnProperty.call(message, "raceDayExam")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.encode(
                message.raceDayExam,
                writer.uint32(/* id 22, wireType 2 =*/ 178).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntry message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntry} UpcomingRaceEntry
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntry();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 3:
                  message.upcomingRace =
                    $root.stronachgroup.first.racehorse360.UpcomingRace.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.facilityId = reader.string();
                  break;
                case 5:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.raceDate = reader.string();
                  break;
                case 7:
                  message.raceNumber = reader.int32();
                  break;
                case 8:
                  message.isNightRace = reader.bool();
                  break;
                case 9:
                  message.horseId = reader.string();
                  break;
                case 10:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.racePosition = reader.int32();
                  break;
                case 12:
                  message.status = reader.int32();
                  break;
                case 13:
                  message.flag =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.isFlagged = reader.bool();
                  break;
                case 15:
                  message.entryExamNote =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 18:
                  message.highSpeedFurlongs = reader.int32();
                  break;
                case 19:
                  message.classChange = reader.int32();
                  break;
                case 20:
                  message.claimChange = reader.float();
                  break;
                case 21:
                  message.entryExam =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 22:
                  message.raceDayExam =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntry message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntry} UpcomingRaceEntry
           */
          UpcomingRaceEntry.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntry
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntry();
            if (object.id != null) message.id = String(object.id);
            if (object.upcomingRace != null) {
              if (typeof object.upcomingRace !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.upcomingRace: object expected"
                );
              message.upcomingRace =
                $root.stronachgroup.first.racehorse360.UpcomingRace.fromObject(
                  object.upcomingRace
                );
            }
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.raceDate != null)
              message.raceDate = String(object.raceDate);
            if (object.raceNumber != null)
              message.raceNumber = object.raceNumber | 0;
            if (object.isNightRace != null)
              message.isNightRace = Boolean(object.isNightRace);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.racePosition != null)
              message.racePosition = object.racePosition | 0;
            switch (object.status) {
              case "UPCOMING_RACE_ENTRY_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED":
              case 1:
                message.status = 1;
                break;
              case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING":
              case 2:
                message.status = 2;
                break;
              case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED":
              case 3:
                message.status = 3;
                break;
              case "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING":
              case 4:
                message.status = 4;
                break;
              case "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED":
              case 5:
                message.status = 5;
                break;
            }
            if (object.flag != null) {
              if (typeof object.flag !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.flag: object expected"
                );
              message.flag =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.fromObject(
                  object.flag
                );
            }
            if (object.isFlagged != null)
              message.isFlagged = Boolean(object.isFlagged);
            if (object.entryExamNote != null) {
              if (typeof object.entryExamNote !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.entryExamNote: object expected"
                );
              message.entryExamNote =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.fromObject(
                  object.entryExamNote
                );
            }
            if (object.highSpeedFurlongs != null)
              message.highSpeedFurlongs = object.highSpeedFurlongs | 0;
            if (object.classChange != null)
              message.classChange = object.classChange | 0;
            if (object.claimChange != null)
              message.claimChange = Number(object.claimChange);
            if (object.entryExam != null) {
              if (typeof object.entryExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.entryExam: object expected"
                );
              message.entryExam =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.fromObject(
                  object.entryExam
                );
            }
            if (object.raceDayExam != null) {
              if (typeof object.raceDayExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntry.raceDayExam: object expected"
                );
              message.raceDayExam =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.fromObject(
                  object.raceDayExam
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntry message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} message UpcomingRaceEntry
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.upcomingRace = null;
              object.facilityId = "";
              object.facility = null;
              object.raceDate = "";
              object.raceNumber = 0;
              object.isNightRace = false;
              object.horseId = "";
              object.horse = null;
              object.racePosition = 0;
              object.status =
                options.enums === String
                  ? "UPCOMING_RACE_ENTRY_STATUS_INVALID"
                  : 0;
              object.flag = null;
              object.isFlagged = false;
              object.entryExamNote = null;
              object.highSpeedFurlongs = 0;
              object.classChange = 0;
              object.claimChange = 0;
              object.entryExam = null;
              object.raceDayExam = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.upcomingRace != null &&
              message.hasOwnProperty("upcomingRace")
            )
              object.upcomingRace =
                $root.stronachgroup.first.racehorse360.UpcomingRace.toObject(
                  message.upcomingRace,
                  options
                );
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate = message.raceDate;
            if (
              message.raceNumber != null &&
              message.hasOwnProperty("raceNumber")
            )
              object.raceNumber = message.raceNumber;
            if (
              message.isNightRace != null &&
              message.hasOwnProperty("isNightRace")
            )
              object.isNightRace = message.isNightRace;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (
              message.racePosition != null &&
              message.hasOwnProperty("racePosition")
            )
              object.racePosition = message.racePosition;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .UpcomingRaceEntryStatus[message.status]
                  : message.status;
            if (message.flag != null && message.hasOwnProperty("flag"))
              object.flag =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.toObject(
                  message.flag,
                  options
                );
            if (
              message.isFlagged != null &&
              message.hasOwnProperty("isFlagged")
            )
              object.isFlagged = message.isFlagged;
            if (
              message.entryExamNote != null &&
              message.hasOwnProperty("entryExamNote")
            )
              object.entryExamNote =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.toObject(
                  message.entryExamNote,
                  options
                );
            if (
              message.highSpeedFurlongs != null &&
              message.hasOwnProperty("highSpeedFurlongs")
            )
              object.highSpeedFurlongs = message.highSpeedFurlongs;
            if (
              message.classChange != null &&
              message.hasOwnProperty("classChange")
            )
              object.classChange = message.classChange;
            if (
              message.claimChange != null &&
              message.hasOwnProperty("claimChange")
            )
              object.claimChange =
                options.json && !isFinite(message.claimChange)
                  ? String(message.claimChange)
                  : message.claimChange;
            if (
              message.entryExam != null &&
              message.hasOwnProperty("entryExam")
            )
              object.entryExam =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.toObject(
                  message.entryExam,
                  options
                );
            if (
              message.raceDayExam != null &&
              message.hasOwnProperty("raceDayExam")
            )
              object.raceDayExam =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.toObject(
                  message.raceDayExam,
                  options
                );
            return object;
          };

          /**
           * Converts this UpcomingRaceEntry to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntry
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntry;
        })();

        racehorse360.UpcomingRaceEntryFlag = (function () {
          /**
           * Properties of an UpcomingRaceEntryFlag.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntryFlag
           * @property {string|null} [id] UpcomingRaceEntryFlag id
           * @property {stronachgroup.first.racehorse360.UpcomingRaceEntryFlagPriority|null} [priority] UpcomingRaceEntryFlag priority
           * @property {stronachgroup.first.racehorse360.IUser|null} [flaggedBy] UpcomingRaceEntryFlag flaggedBy
           * @property {string|null} [flaggedOn] UpcomingRaceEntryFlag flaggedOn
           */

          /**
           * Constructs a new UpcomingRaceEntryFlag.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryFlag.
           * @implements IUpcomingRaceEntryFlag
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFlag=} [properties] Properties to set
           */
          function UpcomingRaceEntryFlag(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntryFlag id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @instance
           */
          UpcomingRaceEntryFlag.prototype.id = "";

          /**
           * UpcomingRaceEntryFlag priority.
           * @member {stronachgroup.first.racehorse360.UpcomingRaceEntryFlagPriority} priority
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @instance
           */
          UpcomingRaceEntryFlag.prototype.priority = 0;

          /**
           * UpcomingRaceEntryFlag flaggedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} flaggedBy
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @instance
           */
          UpcomingRaceEntryFlag.prototype.flaggedBy = null;

          /**
           * UpcomingRaceEntryFlag flaggedOn.
           * @member {string} flaggedOn
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @instance
           */
          UpcomingRaceEntryFlag.prototype.flaggedOn = "";

          /**
           * Creates a new UpcomingRaceEntryFlag instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFlag=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFlag} UpcomingRaceEntryFlag instance
           */
          UpcomingRaceEntryFlag.create = function create(properties) {
            return new UpcomingRaceEntryFlag(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntryFlag message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFlag} message UpcomingRaceEntryFlag message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntryFlag.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.priority != null &&
              Object.hasOwnProperty.call(message, "priority")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.priority);
            if (
              message.flaggedBy != null &&
              Object.hasOwnProperty.call(message, "flaggedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.flaggedBy,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.flaggedOn != null &&
              Object.hasOwnProperty.call(message, "flaggedOn")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.flaggedOn);
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntryFlag message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFlag} UpcomingRaceEntryFlag
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntryFlag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 3:
                  message.priority = reader.int32();
                  break;
                case 4:
                  message.flaggedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.flaggedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntryFlag message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFlag} UpcomingRaceEntryFlag
           */
          UpcomingRaceEntryFlag.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFlag();
            if (object.id != null) message.id = String(object.id);
            switch (object.priority) {
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID":
              case 0:
                message.priority = 0;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_LOWER":
              case 1:
                message.priority = 1;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_MEDIUM":
              case 2:
                message.priority = 2;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_HIGHEST":
              case 3:
                message.priority = 3;
                break;
            }
            if (object.flaggedBy != null) {
              if (typeof object.flaggedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFlag.flaggedBy: object expected"
                );
              message.flaggedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.flaggedBy
                );
            }
            if (object.flaggedOn != null)
              message.flaggedOn = String(object.flaggedOn);
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntryFlag message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryFlag} message UpcomingRaceEntryFlag
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntryFlag.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.priority =
                options.enums === String
                  ? "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID"
                  : 0;
              object.flaggedBy = null;
              object.flaggedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.priority != null && message.hasOwnProperty("priority"))
              object.priority =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .UpcomingRaceEntryFlagPriority[message.priority]
                  : message.priority;
            if (
              message.flaggedBy != null &&
              message.hasOwnProperty("flaggedBy")
            )
              object.flaggedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.flaggedBy,
                  options
                );
            if (
              message.flaggedOn != null &&
              message.hasOwnProperty("flaggedOn")
            )
              object.flaggedOn = message.flaggedOn;
            return object;
          };

          /**
           * Converts this UpcomingRaceEntryFlag to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFlag
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntryFlag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntryFlag;
        })();

        racehorse360.UpcomingRaceEntryExamNote = (function () {
          /**
           * Properties of an UpcomingRaceEntryExamNote.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntryExamNote
           * @property {string|null} [id] UpcomingRaceEntryExamNote id
           * @property {string|null} [body] UpcomingRaceEntryExamNote body
           * @property {string|null} [notedOn] UpcomingRaceEntryExamNote notedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [notedBy] UpcomingRaceEntryExamNote notedBy
           */

          /**
           * Constructs a new UpcomingRaceEntryExamNote.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryExamNote.
           * @implements IUpcomingRaceEntryExamNote
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryExamNote=} [properties] Properties to set
           */
          function UpcomingRaceEntryExamNote(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntryExamNote id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @instance
           */
          UpcomingRaceEntryExamNote.prototype.id = "";

          /**
           * UpcomingRaceEntryExamNote body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @instance
           */
          UpcomingRaceEntryExamNote.prototype.body = "";

          /**
           * UpcomingRaceEntryExamNote notedOn.
           * @member {string} notedOn
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @instance
           */
          UpcomingRaceEntryExamNote.prototype.notedOn = "";

          /**
           * UpcomingRaceEntryExamNote notedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} notedBy
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @instance
           */
          UpcomingRaceEntryExamNote.prototype.notedBy = null;

          /**
           * Creates a new UpcomingRaceEntryExamNote instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryExamNote=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote} UpcomingRaceEntryExamNote instance
           */
          UpcomingRaceEntryExamNote.create = function create(properties) {
            return new UpcomingRaceEntryExamNote(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntryExamNote message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryExamNote} message UpcomingRaceEntryExamNote message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntryExamNote.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.notedOn != null &&
              Object.hasOwnProperty.call(message, "notedOn")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.notedOn);
            if (
              message.notedBy != null &&
              Object.hasOwnProperty.call(message, "notedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.notedBy,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntryExamNote message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote} UpcomingRaceEntryExamNote
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntryExamNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 3:
                  message.notedOn = reader.string();
                  break;
                case 4:
                  message.notedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntryExamNote message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote} UpcomingRaceEntryExamNote
           */
          UpcomingRaceEntryExamNote.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.notedOn != null)
              message.notedOn = String(object.notedOn);
            if (object.notedBy != null) {
              if (typeof object.notedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote.notedBy: object expected"
                );
              message.notedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.notedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntryExamNote message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote} message UpcomingRaceEntryExamNote
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntryExamNote.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.notedOn = "";
              object.notedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (message.notedOn != null && message.hasOwnProperty("notedOn"))
              object.notedOn = message.notedOn;
            if (message.notedBy != null && message.hasOwnProperty("notedBy"))
              object.notedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.notedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this UpcomingRaceEntryExamNote to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryExamNote
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntryExamNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntryExamNote;
        })();

        racehorse360.UpcomingRaceEntryEntryExam = (function () {
          /**
           * Properties of an UpcomingRaceEntryEntryExam.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntryEntryExam
           * @property {string|null} [id] UpcomingRaceEntryEntryExam id
           * @property {stronachgroup.first.racehorse360.HorseExamType|null} [type] UpcomingRaceEntryEntryExam type
           * @property {stronachgroup.first.racehorse360.HorseExamStatus|null} [status] UpcomingRaceEntryEntryExam status
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [result] UpcomingRaceEntryEntryExam result
           * @property {stronachgroup.first.racehorse360.IUser|null} [assignedUser] UpcomingRaceEntryEntryExam assignedUser
           * @property {string|null} [completedOn] UpcomingRaceEntryEntryExam completedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] UpcomingRaceEntryEntryExam updatedBy
           */

          /**
           * Constructs a new UpcomingRaceEntryEntryExam.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryEntryExam.
           * @implements IUpcomingRaceEntryEntryExam
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryEntryExam=} [properties] Properties to set
           */
          function UpcomingRaceEntryEntryExam(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntryEntryExam id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.id = "";

          /**
           * UpcomingRaceEntryEntryExam type.
           * @member {stronachgroup.first.racehorse360.HorseExamType} type
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.type = 0;

          /**
           * UpcomingRaceEntryEntryExam status.
           * @member {stronachgroup.first.racehorse360.HorseExamStatus} status
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.status = 0;

          /**
           * UpcomingRaceEntryEntryExam result.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} result
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.result = 0;

          /**
           * UpcomingRaceEntryEntryExam assignedUser.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} assignedUser
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.assignedUser = null;

          /**
           * UpcomingRaceEntryEntryExam completedOn.
           * @member {string} completedOn
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.completedOn = "";

          /**
           * UpcomingRaceEntryEntryExam updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           */
          UpcomingRaceEntryEntryExam.prototype.updatedBy = null;

          /**
           * Creates a new UpcomingRaceEntryEntryExam instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryEntryExam=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam} UpcomingRaceEntryEntryExam instance
           */
          UpcomingRaceEntryEntryExam.create = function create(properties) {
            return new UpcomingRaceEntryEntryExam(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntryEntryExam message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryEntryExam} message UpcomingRaceEntryEntryExam message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntryEntryExam.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.type);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.status);
            if (
              message.result != null &&
              Object.hasOwnProperty.call(message, "result")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.result);
            if (
              message.assignedUser != null &&
              Object.hasOwnProperty.call(message, "assignedUser")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.assignedUser,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.completedOn != null &&
              Object.hasOwnProperty.call(message, "completedOn")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.completedOn);
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntryEntryExam message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam} UpcomingRaceEntryEntryExam
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntryEntryExam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.type = reader.int32();
                  break;
                case 3:
                  message.status = reader.int32();
                  break;
                case 4:
                  message.result = reader.int32();
                  break;
                case 5:
                  message.assignedUser =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.completedOn = reader.string();
                  break;
                case 7:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntryEntryExam message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam} UpcomingRaceEntryEntryExam
           */
          UpcomingRaceEntryEntryExam.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam();
            if (object.id != null) message.id = String(object.id);
            switch (object.type) {
              case "HORSE_EXAM_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "HORSE_EXAM_TYPE_NORMAL":
              case 1:
                message.type = 1;
                break;
              case "HORSE_EXAM_TYPE_QUICK_PASS":
              case 2:
                message.type = 2;
                break;
              case "HORSE_EXAM_TYPE_FULL_EXAM":
              case 3:
                message.type = 3;
                break;
            }
            switch (object.status) {
              case "HORSE_EXAM_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "HORSE_EXAM_STATUS_REQUESTED":
              case 1:
                message.status = 1;
                break;
              case "HORSE_EXAM_STATUS_IN_PROGRESS":
              case 2:
                message.status = 2;
                break;
              case "HORSE_EXAM_STATUS_PENDING":
              case 3:
                message.status = 3;
                break;
              case "HORSE_EXAM_STATUS_COMPLETED":
              case 4:
                message.status = 4;
                break;
              case "HORSE_EXAM_STATUS_CANCELLED":
              case 5:
                message.status = 5;
                break;
              case "HORSE_EXAM_STATUS_ABANDONED":
              case 6:
                message.status = 6;
                break;
            }
            switch (object.result) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.result = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.result = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.result = 2;
                break;
            }
            if (object.assignedUser != null) {
              if (typeof object.assignedUser !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.assignedUser: object expected"
                );
              message.assignedUser =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.assignedUser
                );
            }
            if (object.completedOn != null)
              message.completedOn = String(object.completedOn);
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntryEntryExam message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam} message UpcomingRaceEntryEntryExam
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntryEntryExam.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.type =
                options.enums === String ? "HORSE_EXAM_TYPE_INVALID" : 0;
              object.status =
                options.enums === String ? "HORSE_EXAM_STATUS_INVALID" : 0;
              object.result =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
              object.assignedUser = null;
              object.completedOn = "";
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamType[
                      message.type
                    ]
                  : message.type;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamStatus[
                      message.status
                    ]
                  : message.status;
            if (message.result != null && message.hasOwnProperty("result"))
              object.result =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.result
                    ]
                  : message.result;
            if (
              message.assignedUser != null &&
              message.hasOwnProperty("assignedUser")
            )
              object.assignedUser =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.assignedUser,
                  options
                );
            if (
              message.completedOn != null &&
              message.hasOwnProperty("completedOn")
            )
              object.completedOn = message.completedOn;
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this UpcomingRaceEntryEntryExam to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryEntryExam
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntryEntryExam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntryEntryExam;
        })();

        racehorse360.UpcomingRaceEntryRaceDayExam = (function () {
          /**
           * Properties of an UpcomingRaceEntryRaceDayExam.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntryRaceDayExam
           * @property {string|null} [id] UpcomingRaceEntryRaceDayExam id
           * @property {stronachgroup.first.racehorse360.HorseExamType|null} [type] UpcomingRaceEntryRaceDayExam type
           * @property {stronachgroup.first.racehorse360.HorseExamStatus|null} [status] UpcomingRaceEntryRaceDayExam status
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [result] UpcomingRaceEntryRaceDayExam result
           * @property {stronachgroup.first.racehorse360.IUser|null} [assignedUser] UpcomingRaceEntryRaceDayExam assignedUser
           * @property {string|null} [completedOn] UpcomingRaceEntryRaceDayExam completedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] UpcomingRaceEntryRaceDayExam updatedBy
           * @property {stronachgroup.first.racehorse360.IHorseExamConclusion|null} [conclusion] UpcomingRaceEntryRaceDayExam conclusion
           */

          /**
           * Constructs a new UpcomingRaceEntryRaceDayExam.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryRaceDayExam.
           * @implements IUpcomingRaceEntryRaceDayExam
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryRaceDayExam=} [properties] Properties to set
           */
          function UpcomingRaceEntryRaceDayExam(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntryRaceDayExam id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.id = "";

          /**
           * UpcomingRaceEntryRaceDayExam type.
           * @member {stronachgroup.first.racehorse360.HorseExamType} type
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.type = 0;

          /**
           * UpcomingRaceEntryRaceDayExam status.
           * @member {stronachgroup.first.racehorse360.HorseExamStatus} status
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.status = 0;

          /**
           * UpcomingRaceEntryRaceDayExam result.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} result
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.result = 0;

          /**
           * UpcomingRaceEntryRaceDayExam assignedUser.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} assignedUser
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.assignedUser = null;

          /**
           * UpcomingRaceEntryRaceDayExam completedOn.
           * @member {string} completedOn
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.completedOn = "";

          /**
           * UpcomingRaceEntryRaceDayExam updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.updatedBy = null;

          /**
           * UpcomingRaceEntryRaceDayExam conclusion.
           * @member {stronachgroup.first.racehorse360.IHorseExamConclusion|null|undefined} conclusion
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           */
          UpcomingRaceEntryRaceDayExam.prototype.conclusion = null;

          /**
           * Creates a new UpcomingRaceEntryRaceDayExam instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryRaceDayExam=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam} UpcomingRaceEntryRaceDayExam instance
           */
          UpcomingRaceEntryRaceDayExam.create = function create(properties) {
            return new UpcomingRaceEntryRaceDayExam(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntryRaceDayExam message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryRaceDayExam} message UpcomingRaceEntryRaceDayExam message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntryRaceDayExam.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.type);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.status);
            if (
              message.result != null &&
              Object.hasOwnProperty.call(message, "result")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.result);
            if (
              message.assignedUser != null &&
              Object.hasOwnProperty.call(message, "assignedUser")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.assignedUser,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.completedOn != null &&
              Object.hasOwnProperty.call(message, "completedOn")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.completedOn);
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.conclusion != null &&
              Object.hasOwnProperty.call(message, "conclusion")
            )
              $root.stronachgroup.first.racehorse360.HorseExamConclusion.encode(
                message.conclusion,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntryRaceDayExam message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam} UpcomingRaceEntryRaceDayExam
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntryRaceDayExam.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.type = reader.int32();
                  break;
                case 3:
                  message.status = reader.int32();
                  break;
                case 4:
                  message.result = reader.int32();
                  break;
                case 5:
                  message.assignedUser =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.completedOn = reader.string();
                  break;
                case 7:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.conclusion =
                    $root.stronachgroup.first.racehorse360.HorseExamConclusion.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntryRaceDayExam message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam} UpcomingRaceEntryRaceDayExam
           */
          UpcomingRaceEntryRaceDayExam.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpcomingRaceEntryRaceDayExam
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam();
            if (object.id != null) message.id = String(object.id);
            switch (object.type) {
              case "HORSE_EXAM_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "HORSE_EXAM_TYPE_NORMAL":
              case 1:
                message.type = 1;
                break;
              case "HORSE_EXAM_TYPE_QUICK_PASS":
              case 2:
                message.type = 2;
                break;
              case "HORSE_EXAM_TYPE_FULL_EXAM":
              case 3:
                message.type = 3;
                break;
            }
            switch (object.status) {
              case "HORSE_EXAM_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "HORSE_EXAM_STATUS_REQUESTED":
              case 1:
                message.status = 1;
                break;
              case "HORSE_EXAM_STATUS_IN_PROGRESS":
              case 2:
                message.status = 2;
                break;
              case "HORSE_EXAM_STATUS_PENDING":
              case 3:
                message.status = 3;
                break;
              case "HORSE_EXAM_STATUS_COMPLETED":
              case 4:
                message.status = 4;
                break;
              case "HORSE_EXAM_STATUS_CANCELLED":
              case 5:
                message.status = 5;
                break;
              case "HORSE_EXAM_STATUS_ABANDONED":
              case 6:
                message.status = 6;
                break;
            }
            switch (object.result) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.result = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.result = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.result = 2;
                break;
            }
            if (object.assignedUser != null) {
              if (typeof object.assignedUser !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.assignedUser: object expected"
                );
              message.assignedUser =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.assignedUser
                );
            }
            if (object.completedOn != null)
              message.completedOn = String(object.completedOn);
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            if (object.conclusion != null) {
              if (typeof object.conclusion !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam.conclusion: object expected"
                );
              message.conclusion =
                $root.stronachgroup.first.racehorse360.HorseExamConclusion.fromObject(
                  object.conclusion
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntryRaceDayExam message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam} message UpcomingRaceEntryRaceDayExam
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntryRaceDayExam.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.type =
                options.enums === String ? "HORSE_EXAM_TYPE_INVALID" : 0;
              object.status =
                options.enums === String ? "HORSE_EXAM_STATUS_INVALID" : 0;
              object.result =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
              object.assignedUser = null;
              object.completedOn = "";
              object.updatedBy = null;
              object.conclusion = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamType[
                      message.type
                    ]
                  : message.type;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamStatus[
                      message.status
                    ]
                  : message.status;
            if (message.result != null && message.hasOwnProperty("result"))
              object.result =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.result
                    ]
                  : message.result;
            if (
              message.assignedUser != null &&
              message.hasOwnProperty("assignedUser")
            )
              object.assignedUser =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.assignedUser,
                  options
                );
            if (
              message.completedOn != null &&
              message.hasOwnProperty("completedOn")
            )
              object.completedOn = message.completedOn;
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            if (
              message.conclusion != null &&
              message.hasOwnProperty("conclusion")
            )
              object.conclusion =
                $root.stronachgroup.first.racehorse360.HorseExamConclusion.toObject(
                  message.conclusion,
                  options
                );
            return object;
          };

          /**
           * Converts this UpcomingRaceEntryRaceDayExam to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryRaceDayExam
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntryRaceDayExam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntryRaceDayExam;
        })();

        racehorse360.UpcomingRaceEntryFilter = (function () {
          /**
           * Properties of an UpcomingRaceEntryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpcomingRaceEntryFilter
           * @property {Array.<string>|null} [ids] UpcomingRaceEntryFilter ids
           * @property {Array.<string>|null} [horseIds] UpcomingRaceEntryFilter horseIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [raceDate] UpcomingRaceEntryFilter raceDate
           * @property {Array.<string>|null} [facilityIds] UpcomingRaceEntryFilter facilityIds
           * @property {Array.<number>|null} [raceNumbers] UpcomingRaceEntryFilter raceNumbers
           * @property {Array.<string>|null} [trainerIds] UpcomingRaceEntryFilter trainerIds
           * @property {Array.<string>|null} [horseFacilityIds] UpcomingRaceEntryFilter horseFacilityIds
           * @property {Array.<stronachgroup.first.racehorse360.UpcomingRaceEntryStatus>|null} [statuses] UpcomingRaceEntryFilter statuses
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [entryExamResult] UpcomingRaceEntryFilter entryExamResult
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseOrTrainerName] UpcomingRaceEntryFilter horseOrTrainerName
           * @property {string|null} [entryExamAssignedUserId] UpcomingRaceEntryFilter entryExamAssignedUserId
           * @property {string|null} [raceDayExamAssignedUserId] UpcomingRaceEntryFilter raceDayExamAssignedUserId
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseChipNumber] UpcomingRaceEntryFilter horseChipNumber
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [raceDayExamResult] UpcomingRaceEntryFilter raceDayExamResult
           */

          /**
           * Constructs a new UpcomingRaceEntryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryFilter.
           * @implements IUpcomingRaceEntryFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFilter=} [properties] Properties to set
           */
          function UpcomingRaceEntryFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.facilityIds = [];
            this.raceNumbers = [];
            this.trainerIds = [];
            this.horseFacilityIds = [];
            this.statuses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpcomingRaceEntryFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.ids = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.horseIds = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter raceDate.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} raceDate
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.raceDate = null;

          /**
           * UpcomingRaceEntryFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter raceNumbers.
           * @member {Array.<number>} raceNumbers
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.raceNumbers = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.UpcomingRaceEntryStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.statuses = $util.emptyArray;

          /**
           * UpcomingRaceEntryFilter entryExamResult.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} entryExamResult
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.entryExamResult = 0;

          /**
           * UpcomingRaceEntryFilter horseOrTrainerName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseOrTrainerName
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.horseOrTrainerName = null;

          /**
           * UpcomingRaceEntryFilter entryExamAssignedUserId.
           * @member {string} entryExamAssignedUserId
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.entryExamAssignedUserId = "";

          /**
           * UpcomingRaceEntryFilter raceDayExamAssignedUserId.
           * @member {string} raceDayExamAssignedUserId
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.raceDayExamAssignedUserId = "";

          /**
           * UpcomingRaceEntryFilter horseChipNumber.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseChipNumber
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.horseChipNumber = null;

          /**
           * UpcomingRaceEntryFilter raceDayExamResult.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} raceDayExamResult
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           */
          UpcomingRaceEntryFilter.prototype.raceDayExamResult = 0;

          /**
           * Creates a new UpcomingRaceEntryFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFilter} UpcomingRaceEntryFilter instance
           */
          UpcomingRaceEntryFilter.create = function create(properties) {
            return new UpcomingRaceEntryFilter(properties);
          };

          /**
           * Encodes the specified UpcomingRaceEntryFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUpcomingRaceEntryFilter} message UpcomingRaceEntryFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpcomingRaceEntryFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseIds[i]);
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.raceDate,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.facilityIds[i]);
            if (message.raceNumbers != null && message.raceNumbers.length) {
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork();
              for (var i = 0; i < message.raceNumbers.length; ++i)
                writer.int32(message.raceNumbers[i]);
              writer.ldelim();
            }
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.trainerIds[i]);
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.horseFacilityIds[i]);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            if (
              message.entryExamResult != null &&
              Object.hasOwnProperty.call(message, "entryExamResult")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.entryExamResult);
            if (
              message.horseOrTrainerName != null &&
              Object.hasOwnProperty.call(message, "horseOrTrainerName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseOrTrainerName,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.entryExamAssignedUserId != null &&
              Object.hasOwnProperty.call(message, "entryExamAssignedUserId")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.entryExamAssignedUserId);
            if (
              message.raceDayExamAssignedUserId != null &&
              Object.hasOwnProperty.call(message, "raceDayExamAssignedUserId")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.raceDayExamAssignedUserId);
            if (
              message.horseChipNumber != null &&
              Object.hasOwnProperty.call(message, "horseChipNumber")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseChipNumber,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.raceDayExamResult != null &&
              Object.hasOwnProperty.call(message, "raceDayExamResult")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.raceDayExamResult);
            return writer;
          };

          /**
           * Decodes an UpcomingRaceEntryFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFilter} UpcomingRaceEntryFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpcomingRaceEntryFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 3:
                  message.raceDate =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 5:
                  if (!(message.raceNumbers && message.raceNumbers.length))
                    message.raceNumbers = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.raceNumbers.push(reader.int32());
                  } else message.raceNumbers.push(reader.int32());
                  break;
                case 6:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 7:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                case 8:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                case 9:
                  message.entryExamResult = reader.int32();
                  break;
                case 10:
                  message.horseOrTrainerName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.entryExamAssignedUserId = reader.string();
                  break;
                case 12:
                  message.raceDayExamAssignedUserId = reader.string();
                  break;
                case 13:
                  message.horseChipNumber =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.raceDayExamResult = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpcomingRaceEntryFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpcomingRaceEntryFilter} UpcomingRaceEntryFilter
           */
          UpcomingRaceEntryFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.raceDate != null) {
              if (typeof object.raceDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.raceDate: object expected"
                );
              message.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.raceDate
                );
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.raceNumbers) {
              if (!Array.isArray(object.raceNumbers))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.raceNumbers: array expected"
                );
              message.raceNumbers = [];
              for (var i = 0; i < object.raceNumbers.length; ++i)
                message.raceNumbers[i] = object.raceNumbers[i] | 0;
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "UPCOMING_RACE_ENTRY_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                  case "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED":
                  case 3:
                    message.statuses[i] = 3;
                    break;
                  case "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING":
                  case 4:
                    message.statuses[i] = 4;
                    break;
                  case "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED":
                  case 5:
                    message.statuses[i] = 5;
                    break;
                }
            }
            switch (object.entryExamResult) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.entryExamResult = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.entryExamResult = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.entryExamResult = 2;
                break;
            }
            if (object.horseOrTrainerName != null) {
              if (typeof object.horseOrTrainerName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.horseOrTrainerName: object expected"
                );
              message.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseOrTrainerName
                );
            }
            if (object.entryExamAssignedUserId != null)
              message.entryExamAssignedUserId = String(
                object.entryExamAssignedUserId
              );
            if (object.raceDayExamAssignedUserId != null)
              message.raceDayExamAssignedUserId = String(
                object.raceDayExamAssignedUserId
              );
            if (object.horseChipNumber != null) {
              if (typeof object.horseChipNumber !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.horseChipNumber: object expected"
                );
              message.horseChipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseChipNumber
                );
            }
            switch (object.raceDayExamResult) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.raceDayExamResult = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.raceDayExamResult = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.raceDayExamResult = 2;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from an UpcomingRaceEntryFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryFilter} message UpcomingRaceEntryFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpcomingRaceEntryFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.facilityIds = [];
              object.raceNumbers = [];
              object.trainerIds = [];
              object.horseFacilityIds = [];
              object.statuses = [];
            }
            if (options.defaults) {
              object.raceDate = null;
              object.entryExamResult =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
              object.horseOrTrainerName = null;
              object.entryExamAssignedUserId = "";
              object.raceDayExamAssignedUserId = "";
              object.horseChipNumber = null;
              object.raceDayExamResult =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.raceDate,
                  options
                );
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.raceNumbers && message.raceNumbers.length) {
              object.raceNumbers = [];
              for (var j = 0; j < message.raceNumbers.length; ++j)
                object.raceNumbers[j] = message.raceNumbers[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .UpcomingRaceEntryStatus[message.statuses[j]]
                    : message.statuses[j];
            }
            if (
              message.entryExamResult != null &&
              message.hasOwnProperty("entryExamResult")
            )
              object.entryExamResult =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.entryExamResult
                    ]
                  : message.entryExamResult;
            if (
              message.horseOrTrainerName != null &&
              message.hasOwnProperty("horseOrTrainerName")
            )
              object.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseOrTrainerName,
                  options
                );
            if (
              message.entryExamAssignedUserId != null &&
              message.hasOwnProperty("entryExamAssignedUserId")
            )
              object.entryExamAssignedUserId = message.entryExamAssignedUserId;
            if (
              message.raceDayExamAssignedUserId != null &&
              message.hasOwnProperty("raceDayExamAssignedUserId")
            )
              object.raceDayExamAssignedUserId =
                message.raceDayExamAssignedUserId;
            if (
              message.horseChipNumber != null &&
              message.hasOwnProperty("horseChipNumber")
            )
              object.horseChipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseChipNumber,
                  options
                );
            if (
              message.raceDayExamResult != null &&
              message.hasOwnProperty("raceDayExamResult")
            )
              object.raceDayExamResult =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.raceDayExamResult
                    ]
                  : message.raceDayExamResult;
            return object;
          };

          /**
           * Converts this UpcomingRaceEntryFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpcomingRaceEntryFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpcomingRaceEntryFilter;
        })();

        racehorse360.ListUpcomingRaceEntriesRequest = (function () {
          /**
           * Properties of a ListUpcomingRaceEntriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUpcomingRaceEntriesRequest
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntryFilter|null} [query] ListUpcomingRaceEntriesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListUpcomingRaceEntriesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListUpcomingRaceEntriesRequest pagingOptions
           */

          /**
           * Constructs a new ListUpcomingRaceEntriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUpcomingRaceEntriesRequest.
           * @implements IListUpcomingRaceEntriesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesRequest=} [properties] Properties to set
           */
          function ListUpcomingRaceEntriesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUpcomingRaceEntriesRequest query.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntryFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @instance
           */
          ListUpcomingRaceEntriesRequest.prototype.query = null;

          /**
           * ListUpcomingRaceEntriesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @instance
           */
          ListUpcomingRaceEntriesRequest.prototype.getOptions = null;

          /**
           * ListUpcomingRaceEntriesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @instance
           */
          ListUpcomingRaceEntriesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListUpcomingRaceEntriesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} ListUpcomingRaceEntriesRequest instance
           */
          ListUpcomingRaceEntriesRequest.create = function create(properties) {
            return new ListUpcomingRaceEntriesRequest(properties);
          };

          /**
           * Encodes the specified ListUpcomingRaceEntriesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesRequest} message ListUpcomingRaceEntriesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUpcomingRaceEntriesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUpcomingRaceEntriesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} ListUpcomingRaceEntriesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUpcomingRaceEntriesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUpcomingRaceEntriesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} ListUpcomingRaceEntriesRequest
           */
          ListUpcomingRaceEntriesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListUpcomingRaceEntriesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUpcomingRaceEntriesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest} message ListUpcomingRaceEntriesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUpcomingRaceEntriesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntryFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUpcomingRaceEntriesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUpcomingRaceEntriesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUpcomingRaceEntriesRequest;
        })();

        racehorse360.ListUpcomingRaceEntriesResponse = (function () {
          /**
           * Properties of a ListUpcomingRaceEntriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUpcomingRaceEntriesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUpcomingRaceEntry>|null} [upcomingRaceEntries] ListUpcomingRaceEntriesResponse upcomingRaceEntries
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListUpcomingRaceEntriesResponse pagingInfo
           */

          /**
           * Constructs a new ListUpcomingRaceEntriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUpcomingRaceEntriesResponse.
           * @implements IListUpcomingRaceEntriesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesResponse=} [properties] Properties to set
           */
          function ListUpcomingRaceEntriesResponse(properties) {
            this.upcomingRaceEntries = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUpcomingRaceEntriesResponse upcomingRaceEntries.
           * @member {Array.<stronachgroup.first.racehorse360.IUpcomingRaceEntry>} upcomingRaceEntries
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @instance
           */
          ListUpcomingRaceEntriesResponse.prototype.upcomingRaceEntries =
            $util.emptyArray;

          /**
           * ListUpcomingRaceEntriesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @instance
           */
          ListUpcomingRaceEntriesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListUpcomingRaceEntriesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} ListUpcomingRaceEntriesResponse instance
           */
          ListUpcomingRaceEntriesResponse.create = function create(properties) {
            return new ListUpcomingRaceEntriesResponse(properties);
          };

          /**
           * Encodes the specified ListUpcomingRaceEntriesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesResponse} message ListUpcomingRaceEntriesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUpcomingRaceEntriesResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.upcomingRaceEntries != null &&
              message.upcomingRaceEntries.length
            )
              for (var i = 0; i < message.upcomingRaceEntries.length; ++i)
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.encode(
                  message.upcomingRaceEntries[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUpcomingRaceEntriesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} ListUpcomingRaceEntriesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUpcomingRaceEntriesResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.upcomingRaceEntries &&
                      message.upcomingRaceEntries.length
                    )
                  )
                    message.upcomingRaceEntries = [];
                  message.upcomingRaceEntries.push(
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUpcomingRaceEntriesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} ListUpcomingRaceEntriesResponse
           */
          ListUpcomingRaceEntriesResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListUpcomingRaceEntriesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse();
            if (object.upcomingRaceEntries) {
              if (!Array.isArray(object.upcomingRaceEntries))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.upcomingRaceEntries: array expected"
                );
              message.upcomingRaceEntries = [];
              for (var i = 0; i < object.upcomingRaceEntries.length; ++i) {
                if (typeof object.upcomingRaceEntries[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.upcomingRaceEntries: object expected"
                  );
                message.upcomingRaceEntries[i] =
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.fromObject(
                    object.upcomingRaceEntries[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUpcomingRaceEntriesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} message ListUpcomingRaceEntriesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUpcomingRaceEntriesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.upcomingRaceEntries = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.upcomingRaceEntries &&
              message.upcomingRaceEntries.length
            ) {
              object.upcomingRaceEntries = [];
              for (var j = 0; j < message.upcomingRaceEntries.length; ++j)
                object.upcomingRaceEntries[j] =
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.toObject(
                    message.upcomingRaceEntries[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUpcomingRaceEntriesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUpcomingRaceEntriesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUpcomingRaceEntriesResponse;
        })();

        racehorse360.GetUpcomingRaceEntryRequest = (function () {
          /**
           * Properties of a GetUpcomingRaceEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetUpcomingRaceEntryRequest
           * @property {string|null} [id] GetUpcomingRaceEntryRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetUpcomingRaceEntryRequest getOptions
           */

          /**
           * Constructs a new GetUpcomingRaceEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetUpcomingRaceEntryRequest.
           * @implements IGetUpcomingRaceEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetUpcomingRaceEntryRequest=} [properties] Properties to set
           */
          function GetUpcomingRaceEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUpcomingRaceEntryRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @instance
           */
          GetUpcomingRaceEntryRequest.prototype.id = "";

          /**
           * GetUpcomingRaceEntryRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @instance
           */
          GetUpcomingRaceEntryRequest.prototype.getOptions = null;

          /**
           * Creates a new GetUpcomingRaceEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUpcomingRaceEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} GetUpcomingRaceEntryRequest instance
           */
          GetUpcomingRaceEntryRequest.create = function create(properties) {
            return new GetUpcomingRaceEntryRequest(properties);
          };

          /**
           * Encodes the specified GetUpcomingRaceEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUpcomingRaceEntryRequest} message GetUpcomingRaceEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUpcomingRaceEntryRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetUpcomingRaceEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} GetUpcomingRaceEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUpcomingRaceEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUpcomingRaceEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} GetUpcomingRaceEntryRequest
           */
          GetUpcomingRaceEntryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetUpcomingRaceEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest} message GetUpcomingRaceEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUpcomingRaceEntryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetUpcomingRaceEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUpcomingRaceEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUpcomingRaceEntryRequest;
        })();

        racehorse360.RequireUpcomingRaceEntryExamRequest = (function () {
          /**
           * Properties of a RequireUpcomingRaceEntryExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRequireUpcomingRaceEntryExamRequest
           * @property {string|null} [id] RequireUpcomingRaceEntryExamRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RequireUpcomingRaceEntryExamRequest getOptions
           */

          /**
           * Constructs a new RequireUpcomingRaceEntryExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RequireUpcomingRaceEntryExamRequest.
           * @implements IRequireUpcomingRaceEntryExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRequireUpcomingRaceEntryExamRequest=} [properties] Properties to set
           */
          function RequireUpcomingRaceEntryExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RequireUpcomingRaceEntryExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @instance
           */
          RequireUpcomingRaceEntryExamRequest.prototype.id = "";

          /**
           * RequireUpcomingRaceEntryExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @instance
           */
          RequireUpcomingRaceEntryExamRequest.prototype.getOptions = null;

          /**
           * Creates a new RequireUpcomingRaceEntryExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRequireUpcomingRaceEntryExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} RequireUpcomingRaceEntryExamRequest instance
           */
          RequireUpcomingRaceEntryExamRequest.create = function create(
            properties
          ) {
            return new RequireUpcomingRaceEntryExamRequest(properties);
          };

          /**
           * Encodes the specified RequireUpcomingRaceEntryExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRequireUpcomingRaceEntryExamRequest} message RequireUpcomingRaceEntryExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RequireUpcomingRaceEntryExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RequireUpcomingRaceEntryExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} RequireUpcomingRaceEntryExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RequireUpcomingRaceEntryExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RequireUpcomingRaceEntryExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} RequireUpcomingRaceEntryExamRequest
           */
          RequireUpcomingRaceEntryExamRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .RequireUpcomingRaceEntryExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RequireUpcomingRaceEntryExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest} message RequireUpcomingRaceEntryExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RequireUpcomingRaceEntryExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this RequireUpcomingRaceEntryExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RequireUpcomingRaceEntryExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return RequireUpcomingRaceEntryExamRequest;
        })();

        racehorse360.BulkAssignUpcomingRaceEntryExamsRequest = (function () {
          /**
           * Properties of a BulkAssignUpcomingRaceEntryExamsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBulkAssignUpcomingRaceEntryExamsRequest
           * @property {Array.<string>|null} [ids] BulkAssignUpcomingRaceEntryExamsRequest ids
           * @property {string|null} [assignedVetId] BulkAssignUpcomingRaceEntryExamsRequest assignedVetId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] BulkAssignUpcomingRaceEntryExamsRequest getOptions
           */

          /**
           * Constructs a new BulkAssignUpcomingRaceEntryExamsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a BulkAssignUpcomingRaceEntryExamsRequest.
           * @implements IBulkAssignUpcomingRaceEntryExamsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBulkAssignUpcomingRaceEntryExamsRequest=} [properties] Properties to set
           */
          function BulkAssignUpcomingRaceEntryExamsRequest(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * BulkAssignUpcomingRaceEntryExamsRequest ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @instance
           */
          BulkAssignUpcomingRaceEntryExamsRequest.prototype.ids =
            $util.emptyArray;

          /**
           * BulkAssignUpcomingRaceEntryExamsRequest assignedVetId.
           * @member {string} assignedVetId
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @instance
           */
          BulkAssignUpcomingRaceEntryExamsRequest.prototype.assignedVetId = "";

          /**
           * BulkAssignUpcomingRaceEntryExamsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @instance
           */
          BulkAssignUpcomingRaceEntryExamsRequest.prototype.getOptions = null;

          /**
           * Creates a new BulkAssignUpcomingRaceEntryExamsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkAssignUpcomingRaceEntryExamsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} BulkAssignUpcomingRaceEntryExamsRequest instance
           */
          BulkAssignUpcomingRaceEntryExamsRequest.create = function create(
            properties
          ) {
            return new BulkAssignUpcomingRaceEntryExamsRequest(properties);
          };

          /**
           * Encodes the specified BulkAssignUpcomingRaceEntryExamsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkAssignUpcomingRaceEntryExamsRequest} message BulkAssignUpcomingRaceEntryExamsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          BulkAssignUpcomingRaceEntryExamsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.assignedVetId != null &&
              Object.hasOwnProperty.call(message, "assignedVetId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.assignedVetId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a BulkAssignUpcomingRaceEntryExamsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} BulkAssignUpcomingRaceEntryExamsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          BulkAssignUpcomingRaceEntryExamsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.assignedVetId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a BulkAssignUpcomingRaceEntryExamsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} BulkAssignUpcomingRaceEntryExamsRequest
           */
          BulkAssignUpcomingRaceEntryExamsRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .BulkAssignUpcomingRaceEntryExamsRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest();
              if (object.ids) {
                if (!Array.isArray(object.ids))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest.ids: array expected"
                  );
                message.ids = [];
                for (var i = 0; i < object.ids.length; ++i)
                  message.ids[i] = String(object.ids[i]);
              }
              if (object.assignedVetId != null)
                message.assignedVetId = String(object.assignedVetId);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a BulkAssignUpcomingRaceEntryExamsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest} message BulkAssignUpcomingRaceEntryExamsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          BulkAssignUpcomingRaceEntryExamsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.assignedVetId = "";
              object.getOptions = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.assignedVetId != null &&
              message.hasOwnProperty("assignedVetId")
            )
              object.assignedVetId = message.assignedVetId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this BulkAssignUpcomingRaceEntryExamsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          BulkAssignUpcomingRaceEntryExamsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return BulkAssignUpcomingRaceEntryExamsRequest;
        })();

        racehorse360.UnassignUpcomingRaceEntryExamRequest = (function () {
          /**
           * Properties of an UnassignUpcomingRaceEntryExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUnassignUpcomingRaceEntryExamRequest
           * @property {string|null} [id] UnassignUpcomingRaceEntryExamRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UnassignUpcomingRaceEntryExamRequest getOptions
           */

          /**
           * Constructs a new UnassignUpcomingRaceEntryExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UnassignUpcomingRaceEntryExamRequest.
           * @implements IUnassignUpcomingRaceEntryExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryExamRequest=} [properties] Properties to set
           */
          function UnassignUpcomingRaceEntryExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnassignUpcomingRaceEntryExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @instance
           */
          UnassignUpcomingRaceEntryExamRequest.prototype.id = "";

          /**
           * UnassignUpcomingRaceEntryExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @instance
           */
          UnassignUpcomingRaceEntryExamRequest.prototype.getOptions = null;

          /**
           * Creates a new UnassignUpcomingRaceEntryExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} UnassignUpcomingRaceEntryExamRequest instance
           */
          UnassignUpcomingRaceEntryExamRequest.create = function create(
            properties
          ) {
            return new UnassignUpcomingRaceEntryExamRequest(properties);
          };

          /**
           * Encodes the specified UnassignUpcomingRaceEntryExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryExamRequest} message UnassignUpcomingRaceEntryExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnassignUpcomingRaceEntryExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UnassignUpcomingRaceEntryExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} UnassignUpcomingRaceEntryExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnassignUpcomingRaceEntryExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnassignUpcomingRaceEntryExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} UnassignUpcomingRaceEntryExamRequest
           */
          UnassignUpcomingRaceEntryExamRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UnassignUpcomingRaceEntryExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UnassignUpcomingRaceEntryExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest} message UnassignUpcomingRaceEntryExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnassignUpcomingRaceEntryExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UnassignUpcomingRaceEntryExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnassignUpcomingRaceEntryExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UnassignUpcomingRaceEntryExamRequest;
        })();

        racehorse360.QuickPassUpcomingRaceEntryRequest = (function () {
          /**
           * Properties of a QuickPassUpcomingRaceEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IQuickPassUpcomingRaceEntryRequest
           * @property {string|null} [id] QuickPassUpcomingRaceEntryRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] QuickPassUpcomingRaceEntryRequest getOptions
           */

          /**
           * Constructs a new QuickPassUpcomingRaceEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a QuickPassUpcomingRaceEntryRequest.
           * @implements IQuickPassUpcomingRaceEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IQuickPassUpcomingRaceEntryRequest=} [properties] Properties to set
           */
          function QuickPassUpcomingRaceEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * QuickPassUpcomingRaceEntryRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @instance
           */
          QuickPassUpcomingRaceEntryRequest.prototype.id = "";

          /**
           * QuickPassUpcomingRaceEntryRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @instance
           */
          QuickPassUpcomingRaceEntryRequest.prototype.getOptions = null;

          /**
           * Creates a new QuickPassUpcomingRaceEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IQuickPassUpcomingRaceEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} QuickPassUpcomingRaceEntryRequest instance
           */
          QuickPassUpcomingRaceEntryRequest.create = function create(
            properties
          ) {
            return new QuickPassUpcomingRaceEntryRequest(properties);
          };

          /**
           * Encodes the specified QuickPassUpcomingRaceEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IQuickPassUpcomingRaceEntryRequest} message QuickPassUpcomingRaceEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          QuickPassUpcomingRaceEntryRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a QuickPassUpcomingRaceEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} QuickPassUpcomingRaceEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          QuickPassUpcomingRaceEntryRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a QuickPassUpcomingRaceEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} QuickPassUpcomingRaceEntryRequest
           */
          QuickPassUpcomingRaceEntryRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .QuickPassUpcomingRaceEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a QuickPassUpcomingRaceEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest} message QuickPassUpcomingRaceEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          QuickPassUpcomingRaceEntryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this QuickPassUpcomingRaceEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          QuickPassUpcomingRaceEntryRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return QuickPassUpcomingRaceEntryRequest;
        })();

        racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest =
          (function () {
            /**
             * Properties of a RevertQuickPassUpcomingRaceEntryExamRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IRevertQuickPassUpcomingRaceEntryExamRequest
             * @property {string|null} [id] RevertQuickPassUpcomingRaceEntryExamRequest id
             * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RevertQuickPassUpcomingRaceEntryExamRequest getOptions
             */

            /**
             * Constructs a new RevertQuickPassUpcomingRaceEntryExamRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a RevertQuickPassUpcomingRaceEntryExamRequest.
             * @implements IRevertQuickPassUpcomingRaceEntryExamRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IRevertQuickPassUpcomingRaceEntryExamRequest=} [properties] Properties to set
             */
            function RevertQuickPassUpcomingRaceEntryExamRequest(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * RevertQuickPassUpcomingRaceEntryExamRequest id.
             * @member {string} id
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @instance
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.prototype.id = "";

            /**
             * RevertQuickPassUpcomingRaceEntryExamRequest getOptions.
             * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @instance
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.prototype.getOptions =
              null;

            /**
             * Creates a new RevertQuickPassUpcomingRaceEntryExamRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IRevertQuickPassUpcomingRaceEntryExamRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} RevertQuickPassUpcomingRaceEntryExamRequest instance
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.create =
              function create(properties) {
                return new RevertQuickPassUpcomingRaceEntryExamRequest(
                  properties
                );
              };

            /**
             * Encodes the specified RevertQuickPassUpcomingRaceEntryExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IRevertQuickPassUpcomingRaceEntryExamRequest} message RevertQuickPassUpcomingRaceEntryExamRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.id != null &&
                  Object.hasOwnProperty.call(message, "id")
                )
                  writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
                if (
                  message.getOptions != null &&
                  Object.hasOwnProperty.call(message, "getOptions")
                )
                  $root.stronachgroup.first.racehorse360.GetOptions.encode(
                    message.getOptions,
                    writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
                  ).ldelim();
                return writer;
              };

            /**
             * Decodes a RevertQuickPassUpcomingRaceEntryExamRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} RevertQuickPassUpcomingRaceEntryExamRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.id = reader.string();
                      break;
                    case 100:
                      message.getOptions =
                        $root.stronachgroup.first.racehorse360.GetOptions.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a RevertQuickPassUpcomingRaceEntryExamRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} RevertQuickPassUpcomingRaceEntryExamRequest
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .RevertQuickPassUpcomingRaceEntryExamRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest();
                if (object.id != null) message.id = String(object.id);
                if (object.getOptions != null) {
                  if (typeof object.getOptions !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest.getOptions: object expected"
                    );
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                      object.getOptions
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from a RevertQuickPassUpcomingRaceEntryExamRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest} message RevertQuickPassUpcomingRaceEntryExamRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) {
                  object.id = "";
                  object.getOptions = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                  object.id = message.id;
                if (
                  message.getOptions != null &&
                  message.hasOwnProperty("getOptions")
                )
                  object.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                      message.getOptions,
                      options
                    );
                return object;
              };

            /**
             * Converts this RevertQuickPassUpcomingRaceEntryExamRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RevertQuickPassUpcomingRaceEntryExamRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return RevertQuickPassUpcomingRaceEntryExamRequest;
          })();

        racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest =
          (function () {
            /**
             * Properties of a BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @property {Array.<string>|null} [ids] BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest ids
             * @property {string|null} [assignedVetId] BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest assignedVetId
             * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest getOptions
             */

            /**
             * Constructs a new BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.
             * @implements IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest=} [properties] Properties to set
             */
            function BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest(
              properties
            ) {
              this.ids = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest ids.
             * @member {Array.<string>} ids
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @instance
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.prototype.ids =
              $util.emptyArray;

            /**
             * BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest assignedVetId.
             * @member {string} assignedVetId
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @instance
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.prototype.assignedVetId =
              "";

            /**
             * BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest getOptions.
             * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @instance
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.prototype.getOptions =
              null;

            /**
             * Creates a new BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest instance
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.create =
              function create(properties) {
                return new BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest(
                  properties
                );
              };

            /**
             * Encodes the specified BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} message BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (message.ids != null && message.ids.length)
                  for (var i = 0; i < message.ids.length; ++i)
                    writer
                      .uint32(/* id 1, wireType 2 =*/ 10)
                      .string(message.ids[i]);
                if (
                  message.assignedVetId != null &&
                  Object.hasOwnProperty.call(message, "assignedVetId")
                )
                  writer
                    .uint32(/* id 2, wireType 2 =*/ 18)
                    .string(message.assignedVetId);
                if (
                  message.getOptions != null &&
                  Object.hasOwnProperty.call(message, "getOptions")
                )
                  $root.stronachgroup.first.racehorse360.GetOptions.encode(
                    message.getOptions,
                    writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
                  ).ldelim();
                return writer;
              };

            /**
             * Decodes a BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (!(message.ids && message.ids.length))
                        message.ids = [];
                      message.ids.push(reader.string());
                      break;
                    case 2:
                      message.assignedVetId = reader.string();
                      break;
                    case 100:
                      message.getOptions =
                        $root.stronachgroup.first.racehorse360.GetOptions.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest();
                if (object.ids) {
                  if (!Array.isArray(object.ids))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.ids: array expected"
                    );
                  message.ids = [];
                  for (var i = 0; i < object.ids.length; ++i)
                    message.ids[i] = String(object.ids[i]);
                }
                if (object.assignedVetId != null)
                  message.assignedVetId = String(object.assignedVetId);
                if (object.getOptions != null) {
                  if (typeof object.getOptions !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.getOptions: object expected"
                    );
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                      object.getOptions
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from a BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @static
             * @param {stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} message BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults) object.ids = [];
                if (options.defaults) {
                  object.assignedVetId = "";
                  object.getOptions = null;
                }
                if (message.ids && message.ids.length) {
                  object.ids = [];
                  for (var j = 0; j < message.ids.length; ++j)
                    object.ids[j] = message.ids[j];
                }
                if (
                  message.assignedVetId != null &&
                  message.hasOwnProperty("assignedVetId")
                )
                  object.assignedVetId = message.assignedVetId;
                if (
                  message.getOptions != null &&
                  message.hasOwnProperty("getOptions")
                )
                  object.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                      message.getOptions,
                      options
                    );
                return object;
              };

            /**
             * Converts this BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest;
          })();

        racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest =
          (function () {
            /**
             * Properties of an UnassignUpcomingRaceEntryRaceDayExamRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IUnassignUpcomingRaceEntryRaceDayExamRequest
             * @property {string|null} [id] UnassignUpcomingRaceEntryRaceDayExamRequest id
             * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UnassignUpcomingRaceEntryRaceDayExamRequest getOptions
             */

            /**
             * Constructs a new UnassignUpcomingRaceEntryRaceDayExamRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents an UnassignUpcomingRaceEntryRaceDayExamRequest.
             * @implements IUnassignUpcomingRaceEntryRaceDayExamRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryRaceDayExamRequest=} [properties] Properties to set
             */
            function UnassignUpcomingRaceEntryRaceDayExamRequest(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * UnassignUpcomingRaceEntryRaceDayExamRequest id.
             * @member {string} id
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @instance
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.prototype.id = "";

            /**
             * UnassignUpcomingRaceEntryRaceDayExamRequest getOptions.
             * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @instance
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.prototype.getOptions =
              null;

            /**
             * Creates a new UnassignUpcomingRaceEntryRaceDayExamRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryRaceDayExamRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} UnassignUpcomingRaceEntryRaceDayExamRequest instance
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.create =
              function create(properties) {
                return new UnassignUpcomingRaceEntryRaceDayExamRequest(
                  properties
                );
              };

            /**
             * Encodes the specified UnassignUpcomingRaceEntryRaceDayExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryRaceDayExamRequest} message UnassignUpcomingRaceEntryRaceDayExamRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.id != null &&
                  Object.hasOwnProperty.call(message, "id")
                )
                  writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
                if (
                  message.getOptions != null &&
                  Object.hasOwnProperty.call(message, "getOptions")
                )
                  $root.stronachgroup.first.racehorse360.GetOptions.encode(
                    message.getOptions,
                    writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
                  ).ldelim();
                return writer;
              };

            /**
             * Decodes an UnassignUpcomingRaceEntryRaceDayExamRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} UnassignUpcomingRaceEntryRaceDayExamRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.id = reader.string();
                      break;
                    case 100:
                      message.getOptions =
                        $root.stronachgroup.first.racehorse360.GetOptions.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates an UnassignUpcomingRaceEntryRaceDayExamRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} UnassignUpcomingRaceEntryRaceDayExamRequest
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .UnassignUpcomingRaceEntryRaceDayExamRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest();
                if (object.id != null) message.id = String(object.id);
                if (object.getOptions != null) {
                  if (typeof object.getOptions !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest.getOptions: object expected"
                    );
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                      object.getOptions
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from an UnassignUpcomingRaceEntryRaceDayExamRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @static
             * @param {stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest} message UnassignUpcomingRaceEntryRaceDayExamRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) {
                  object.id = "";
                  object.getOptions = null;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                  object.id = message.id;
                if (
                  message.getOptions != null &&
                  message.hasOwnProperty("getOptions")
                )
                  object.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                      message.getOptions,
                      options
                    );
                return object;
              };

            /**
             * Converts this UnassignUpcomingRaceEntryRaceDayExamRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UnassignUpcomingRaceEntryRaceDayExamRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return UnassignUpcomingRaceEntryRaceDayExamRequest;
          })();

        racehorse360.SetUpcomingRaceEntryExamNoteRequest = (function () {
          /**
           * Properties of a SetUpcomingRaceEntryExamNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetUpcomingRaceEntryExamNoteRequest
           * @property {string|null} [id] SetUpcomingRaceEntryExamNoteRequest id
           * @property {string|null} [body] SetUpcomingRaceEntryExamNoteRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetUpcomingRaceEntryExamNoteRequest getOptions
           */

          /**
           * Constructs a new SetUpcomingRaceEntryExamNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetUpcomingRaceEntryExamNoteRequest.
           * @implements ISetUpcomingRaceEntryExamNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryExamNoteRequest=} [properties] Properties to set
           */
          function SetUpcomingRaceEntryExamNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetUpcomingRaceEntryExamNoteRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @instance
           */
          SetUpcomingRaceEntryExamNoteRequest.prototype.id = "";

          /**
           * SetUpcomingRaceEntryExamNoteRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @instance
           */
          SetUpcomingRaceEntryExamNoteRequest.prototype.body = "";

          /**
           * SetUpcomingRaceEntryExamNoteRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @instance
           */
          SetUpcomingRaceEntryExamNoteRequest.prototype.getOptions = null;

          /**
           * Creates a new SetUpcomingRaceEntryExamNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryExamNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} SetUpcomingRaceEntryExamNoteRequest instance
           */
          SetUpcomingRaceEntryExamNoteRequest.create = function create(
            properties
          ) {
            return new SetUpcomingRaceEntryExamNoteRequest(properties);
          };

          /**
           * Encodes the specified SetUpcomingRaceEntryExamNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryExamNoteRequest} message SetUpcomingRaceEntryExamNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetUpcomingRaceEntryExamNoteRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetUpcomingRaceEntryExamNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} SetUpcomingRaceEntryExamNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetUpcomingRaceEntryExamNoteRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetUpcomingRaceEntryExamNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} SetUpcomingRaceEntryExamNoteRequest
           */
          SetUpcomingRaceEntryExamNoteRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SetUpcomingRaceEntryExamNoteRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SetUpcomingRaceEntryExamNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest} message SetUpcomingRaceEntryExamNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetUpcomingRaceEntryExamNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetUpcomingRaceEntryExamNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetUpcomingRaceEntryExamNoteRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return SetUpcomingRaceEntryExamNoteRequest;
        })();

        racehorse360.ResetUpcomingRaceEntryExamNoteRequest = (function () {
          /**
           * Properties of a ResetUpcomingRaceEntryExamNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetUpcomingRaceEntryExamNoteRequest
           * @property {string|null} [id] ResetUpcomingRaceEntryExamNoteRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetUpcomingRaceEntryExamNoteRequest getOptions
           */

          /**
           * Constructs a new ResetUpcomingRaceEntryExamNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetUpcomingRaceEntryExamNoteRequest.
           * @implements IResetUpcomingRaceEntryExamNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryExamNoteRequest=} [properties] Properties to set
           */
          function ResetUpcomingRaceEntryExamNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetUpcomingRaceEntryExamNoteRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @instance
           */
          ResetUpcomingRaceEntryExamNoteRequest.prototype.id = "";

          /**
           * ResetUpcomingRaceEntryExamNoteRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @instance
           */
          ResetUpcomingRaceEntryExamNoteRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetUpcomingRaceEntryExamNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryExamNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} ResetUpcomingRaceEntryExamNoteRequest instance
           */
          ResetUpcomingRaceEntryExamNoteRequest.create = function create(
            properties
          ) {
            return new ResetUpcomingRaceEntryExamNoteRequest(properties);
          };

          /**
           * Encodes the specified ResetUpcomingRaceEntryExamNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryExamNoteRequest} message ResetUpcomingRaceEntryExamNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetUpcomingRaceEntryExamNoteRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetUpcomingRaceEntryExamNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} ResetUpcomingRaceEntryExamNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetUpcomingRaceEntryExamNoteRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetUpcomingRaceEntryExamNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} ResetUpcomingRaceEntryExamNoteRequest
           */
          ResetUpcomingRaceEntryExamNoteRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .ResetUpcomingRaceEntryExamNoteRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a ResetUpcomingRaceEntryExamNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest} message ResetUpcomingRaceEntryExamNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetUpcomingRaceEntryExamNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetUpcomingRaceEntryExamNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetUpcomingRaceEntryExamNoteRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ResetUpcomingRaceEntryExamNoteRequest;
        })();

        racehorse360.SetUpcomingRaceEntryFlagRequest = (function () {
          /**
           * Properties of a SetUpcomingRaceEntryFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetUpcomingRaceEntryFlagRequest
           * @property {string|null} [id] SetUpcomingRaceEntryFlagRequest id
           * @property {stronachgroup.first.racehorse360.UpcomingRaceEntryFlagPriority|null} [priority] SetUpcomingRaceEntryFlagRequest priority
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetUpcomingRaceEntryFlagRequest getOptions
           */

          /**
           * Constructs a new SetUpcomingRaceEntryFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetUpcomingRaceEntryFlagRequest.
           * @implements ISetUpcomingRaceEntryFlagRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryFlagRequest=} [properties] Properties to set
           */
          function SetUpcomingRaceEntryFlagRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetUpcomingRaceEntryFlagRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @instance
           */
          SetUpcomingRaceEntryFlagRequest.prototype.id = "";

          /**
           * SetUpcomingRaceEntryFlagRequest priority.
           * @member {stronachgroup.first.racehorse360.UpcomingRaceEntryFlagPriority} priority
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @instance
           */
          SetUpcomingRaceEntryFlagRequest.prototype.priority = 0;

          /**
           * SetUpcomingRaceEntryFlagRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @instance
           */
          SetUpcomingRaceEntryFlagRequest.prototype.getOptions = null;

          /**
           * Creates a new SetUpcomingRaceEntryFlagRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryFlagRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} SetUpcomingRaceEntryFlagRequest instance
           */
          SetUpcomingRaceEntryFlagRequest.create = function create(properties) {
            return new SetUpcomingRaceEntryFlagRequest(properties);
          };

          /**
           * Encodes the specified SetUpcomingRaceEntryFlagRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryFlagRequest} message SetUpcomingRaceEntryFlagRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetUpcomingRaceEntryFlagRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.priority != null &&
              Object.hasOwnProperty.call(message, "priority")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.priority);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetUpcomingRaceEntryFlagRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} SetUpcomingRaceEntryFlagRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetUpcomingRaceEntryFlagRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.priority = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetUpcomingRaceEntryFlagRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} SetUpcomingRaceEntryFlagRequest
           */
          SetUpcomingRaceEntryFlagRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SetUpcomingRaceEntryFlagRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest();
            if (object.id != null) message.id = String(object.id);
            switch (object.priority) {
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID":
              case 0:
                message.priority = 0;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_LOWER":
              case 1:
                message.priority = 1;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_MEDIUM":
              case 2:
                message.priority = 2;
                break;
              case "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_HIGHEST":
              case 3:
                message.priority = 3;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SetUpcomingRaceEntryFlagRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest} message SetUpcomingRaceEntryFlagRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetUpcomingRaceEntryFlagRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.priority =
                options.enums === String
                  ? "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID"
                  : 0;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.priority != null && message.hasOwnProperty("priority"))
              object.priority =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .UpcomingRaceEntryFlagPriority[message.priority]
                  : message.priority;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetUpcomingRaceEntryFlagRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetUpcomingRaceEntryFlagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetUpcomingRaceEntryFlagRequest;
        })();

        racehorse360.ResetUpcomingRaceEntryFlagRequest = (function () {
          /**
           * Properties of a ResetUpcomingRaceEntryFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetUpcomingRaceEntryFlagRequest
           * @property {string|null} [id] ResetUpcomingRaceEntryFlagRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetUpcomingRaceEntryFlagRequest getOptions
           */

          /**
           * Constructs a new ResetUpcomingRaceEntryFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetUpcomingRaceEntryFlagRequest.
           * @implements IResetUpcomingRaceEntryFlagRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryFlagRequest=} [properties] Properties to set
           */
          function ResetUpcomingRaceEntryFlagRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetUpcomingRaceEntryFlagRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @instance
           */
          ResetUpcomingRaceEntryFlagRequest.prototype.id = "";

          /**
           * ResetUpcomingRaceEntryFlagRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @instance
           */
          ResetUpcomingRaceEntryFlagRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetUpcomingRaceEntryFlagRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryFlagRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} ResetUpcomingRaceEntryFlagRequest instance
           */
          ResetUpcomingRaceEntryFlagRequest.create = function create(
            properties
          ) {
            return new ResetUpcomingRaceEntryFlagRequest(properties);
          };

          /**
           * Encodes the specified ResetUpcomingRaceEntryFlagRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryFlagRequest} message ResetUpcomingRaceEntryFlagRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetUpcomingRaceEntryFlagRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetUpcomingRaceEntryFlagRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} ResetUpcomingRaceEntryFlagRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetUpcomingRaceEntryFlagRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetUpcomingRaceEntryFlagRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} ResetUpcomingRaceEntryFlagRequest
           */
          ResetUpcomingRaceEntryFlagRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ResetUpcomingRaceEntryFlagRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ResetUpcomingRaceEntryFlagRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest} message ResetUpcomingRaceEntryFlagRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetUpcomingRaceEntryFlagRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetUpcomingRaceEntryFlagRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetUpcomingRaceEntryFlagRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ResetUpcomingRaceEntryFlagRequest;
        })();

        racehorse360.AuthUser = (function () {
          /**
           * Properties of an AuthUser.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAuthUser
           * @property {string|null} [id] AuthUser id
           * @property {string|null} [externalAuthId] AuthUser externalAuthId
           * @property {string|null} [email] AuthUser email
           * @property {string|null} [firstName] AuthUser firstName
           * @property {string|null} [lastName] AuthUser lastName
           * @property {Array.<stronachgroup.first.racehorse360.AuthUser.IAuthUserRole>|null} [roles] AuthUser roles
           * @property {Array.<stronachgroup.first.racehorse360.AuthUser.IAuthUserPermission>|null} [permissions] AuthUser permissions
           */

          /**
           * Constructs a new AuthUser.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AuthUser.
           * @implements IAuthUser
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAuthUser=} [properties] Properties to set
           */
          function AuthUser(properties) {
            this.roles = [];
            this.permissions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AuthUser id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.id = "";

          /**
           * AuthUser externalAuthId.
           * @member {string} externalAuthId
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.externalAuthId = "";

          /**
           * AuthUser email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.email = "";

          /**
           * AuthUser firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.firstName = "";

          /**
           * AuthUser lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.lastName = "";

          /**
           * AuthUser roles.
           * @member {Array.<stronachgroup.first.racehorse360.AuthUser.IAuthUserRole>} roles
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.roles = $util.emptyArray;

          /**
           * AuthUser permissions.
           * @member {Array.<stronachgroup.first.racehorse360.AuthUser.IAuthUserPermission>} permissions
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           */
          AuthUser.prototype.permissions = $util.emptyArray;

          /**
           * Creates a new AuthUser instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @static
           * @param {stronachgroup.first.racehorse360.IAuthUser=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AuthUser} AuthUser instance
           */
          AuthUser.create = function create(properties) {
            return new AuthUser(properties);
          };

          /**
           * Encodes the specified AuthUser message. Does not implicitly {@link stronachgroup.first.racehorse360.AuthUser.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @static
           * @param {stronachgroup.first.racehorse360.IAuthUser} message AuthUser message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AuthUser.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.externalAuthId != null &&
              Object.hasOwnProperty.call(message, "externalAuthId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.externalAuthId);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.email);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.lastName);
            if (message.roles != null && message.roles.length)
              for (var i = 0; i < message.roles.length; ++i)
                $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole.encode(
                  message.roles[i],
                  writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
                ).ldelim();
            if (message.permissions != null && message.permissions.length)
              for (var i = 0; i < message.permissions.length; ++i)
                $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission.encode(
                  message.permissions[i],
                  writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes an AuthUser message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AuthUser} AuthUser
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AuthUser.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.AuthUser();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.externalAuthId = reader.string();
                  break;
                case 3:
                  message.email = reader.string();
                  break;
                case 4:
                  message.firstName = reader.string();
                  break;
                case 5:
                  message.lastName = reader.string();
                  break;
                case 6:
                  if (!(message.roles && message.roles.length))
                    message.roles = [];
                  message.roles.push(
                    $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 7:
                  if (!(message.permissions && message.permissions.length))
                    message.permissions = [];
                  message.permissions.push(
                    $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AuthUser message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AuthUser} AuthUser
           */
          AuthUser.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.AuthUser
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.AuthUser();
            if (object.id != null) message.id = String(object.id);
            if (object.externalAuthId != null)
              message.externalAuthId = String(object.externalAuthId);
            if (object.email != null) message.email = String(object.email);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.roles) {
              if (!Array.isArray(object.roles))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AuthUser.roles: array expected"
                );
              message.roles = [];
              for (var i = 0; i < object.roles.length; ++i) {
                if (typeof object.roles[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AuthUser.roles: object expected"
                  );
                message.roles[i] =
                  $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole.fromObject(
                    object.roles[i]
                  );
              }
            }
            if (object.permissions) {
              if (!Array.isArray(object.permissions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.AuthUser.permissions: array expected"
                );
              message.permissions = [];
              for (var i = 0; i < object.permissions.length; ++i) {
                if (typeof object.permissions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AuthUser.permissions: object expected"
                  );
                message.permissions[i] =
                  $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission.fromObject(
                    object.permissions[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from an AuthUser message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @static
           * @param {stronachgroup.first.racehorse360.AuthUser} message AuthUser
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AuthUser.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.roles = [];
              object.permissions = [];
            }
            if (options.defaults) {
              object.id = "";
              object.externalAuthId = "";
              object.email = "";
              object.firstName = "";
              object.lastName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.externalAuthId != null &&
              message.hasOwnProperty("externalAuthId")
            )
              object.externalAuthId = message.externalAuthId;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (message.roles && message.roles.length) {
              object.roles = [];
              for (var j = 0; j < message.roles.length; ++j)
                object.roles[j] =
                  $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole.toObject(
                    message.roles[j],
                    options
                  );
            }
            if (message.permissions && message.permissions.length) {
              object.permissions = [];
              for (var j = 0; j < message.permissions.length; ++j)
                object.permissions[j] =
                  $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission.toObject(
                    message.permissions[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this AuthUser to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AuthUser
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AuthUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          AuthUser.AuthUserRole = (function () {
            /**
             * Properties of an AuthUserRole.
             * @memberof stronachgroup.first.racehorse360.AuthUser
             * @interface IAuthUserRole
             * @property {string|null} [id] AuthUserRole id
             * @property {string|null} [name] AuthUserRole name
             * @property {string|null} [facilityId] AuthUserRole facilityId
             * @property {string|null} [trainerId] AuthUserRole trainerId
             */

            /**
             * Constructs a new AuthUserRole.
             * @memberof stronachgroup.first.racehorse360.AuthUser
             * @classdesc Represents an AuthUserRole.
             * @implements IAuthUserRole
             * @constructor
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserRole=} [properties] Properties to set
             */
            function AuthUserRole(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * AuthUserRole id.
             * @member {string} id
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @instance
             */
            AuthUserRole.prototype.id = "";

            /**
             * AuthUserRole name.
             * @member {string} name
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @instance
             */
            AuthUserRole.prototype.name = "";

            /**
             * AuthUserRole facilityId.
             * @member {string} facilityId
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @instance
             */
            AuthUserRole.prototype.facilityId = "";

            /**
             * AuthUserRole trainerId.
             * @member {string} trainerId
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @instance
             */
            AuthUserRole.prototype.trainerId = "";

            /**
             * Creates a new AuthUserRole instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserRole=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserRole} AuthUserRole instance
             */
            AuthUserRole.create = function create(properties) {
              return new AuthUserRole(properties);
            };

            /**
             * Encodes the specified AuthUserRole message. Does not implicitly {@link stronachgroup.first.racehorse360.AuthUser.AuthUserRole.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserRole} message AuthUserRole message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthUserRole.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.id != null &&
                Object.hasOwnProperty.call(message, "id")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
              if (
                message.facilityId != null &&
                Object.hasOwnProperty.call(message, "facilityId")
              )
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.facilityId);
              if (
                message.trainerId != null &&
                Object.hasOwnProperty.call(message, "trainerId")
              )
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.trainerId);
              return writer;
            };

            /**
             * Decodes an AuthUserRole message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserRole} AuthUserRole
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthUserRole.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.id = reader.string();
                    break;
                  case 2:
                    message.name = reader.string();
                    break;
                  case 3:
                    message.facilityId = reader.string();
                    break;
                  case 4:
                    message.trainerId = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an AuthUserRole message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserRole} AuthUserRole
             */
            AuthUserRole.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.AuthUser.AuthUserRole();
              if (object.id != null) message.id = String(object.id);
              if (object.name != null) message.name = String(object.name);
              if (object.facilityId != null)
                message.facilityId = String(object.facilityId);
              if (object.trainerId != null)
                message.trainerId = String(object.trainerId);
              return message;
            };

            /**
             * Creates a plain object from an AuthUserRole message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.AuthUserRole} message AuthUserRole
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AuthUserRole.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.id = "";
                object.name = "";
                object.facilityId = "";
                object.trainerId = "";
              }
              if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (
                message.facilityId != null &&
                message.hasOwnProperty("facilityId")
              )
                object.facilityId = message.facilityId;
              if (
                message.trainerId != null &&
                message.hasOwnProperty("trainerId")
              )
                object.trainerId = message.trainerId;
              return object;
            };

            /**
             * Converts this AuthUserRole to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserRole
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AuthUserRole.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return AuthUserRole;
          })();

          AuthUser.AuthUserPermission = (function () {
            /**
             * Properties of an AuthUserPermission.
             * @memberof stronachgroup.first.racehorse360.AuthUser
             * @interface IAuthUserPermission
             * @property {string|null} [name] AuthUserPermission name
             * @property {string|null} [argument] AuthUserPermission argument
             */

            /**
             * Constructs a new AuthUserPermission.
             * @memberof stronachgroup.first.racehorse360.AuthUser
             * @classdesc Represents an AuthUserPermission.
             * @implements IAuthUserPermission
             * @constructor
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserPermission=} [properties] Properties to set
             */
            function AuthUserPermission(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * AuthUserPermission name.
             * @member {string} name
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @instance
             */
            AuthUserPermission.prototype.name = "";

            /**
             * AuthUserPermission argument.
             * @member {string} argument
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @instance
             */
            AuthUserPermission.prototype.argument = "";

            /**
             * Creates a new AuthUserPermission instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserPermission=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserPermission} AuthUserPermission instance
             */
            AuthUserPermission.create = function create(properties) {
              return new AuthUserPermission(properties);
            };

            /**
             * Encodes the specified AuthUserPermission message. Does not implicitly {@link stronachgroup.first.racehorse360.AuthUser.AuthUserPermission.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.IAuthUserPermission} message AuthUserPermission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuthUserPermission.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
              if (
                message.argument != null &&
                Object.hasOwnProperty.call(message, "argument")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.argument);
              return writer;
            };

            /**
             * Decodes an AuthUserPermission message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserPermission} AuthUserPermission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuthUserPermission.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.name = reader.string();
                    break;
                  case 2:
                    message.argument = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an AuthUserPermission message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.AuthUser.AuthUserPermission} AuthUserPermission
             */
            AuthUserPermission.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360.AuthUser
                  .AuthUserPermission
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.AuthUser.AuthUserPermission();
              if (object.name != null) message.name = String(object.name);
              if (object.argument != null)
                message.argument = String(object.argument);
              return message;
            };

            /**
             * Creates a plain object from an AuthUserPermission message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @static
             * @param {stronachgroup.first.racehorse360.AuthUser.AuthUserPermission} message AuthUserPermission
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AuthUserPermission.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.name = "";
                object.argument = "";
              }
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (
                message.argument != null &&
                message.hasOwnProperty("argument")
              )
                object.argument = message.argument;
              return object;
            };

            /**
             * Converts this AuthUserPermission to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.AuthUser.AuthUserPermission
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AuthUserPermission.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return AuthUserPermission;
          })();

          return AuthUser;
        })();

        racehorse360.User = (function () {
          /**
           * Properties of a User.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUser
           * @property {string|null} [id] User id
           * @property {string|null} [firstName] User firstName
           * @property {string|null} [lastName] User lastName
           * @property {string|null} [phoneNumber] User phoneNumber
           * @property {string|null} [licenseNumber] User licenseNumber
           * @property {string|null} [email] User email
           * @property {stronachgroup.first.racehorse360.IUserPreferences|null} [preferences] User preferences
           */

          /**
           * Constructs a new User.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a User.
           * @implements IUser
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUser=} [properties] Properties to set
           */
          function User(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * User id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.id = "";

          /**
           * User firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.firstName = "";

          /**
           * User lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.lastName = "";

          /**
           * User phoneNumber.
           * @member {string} phoneNumber
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.phoneNumber = "";

          /**
           * User licenseNumber.
           * @member {string} licenseNumber
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.licenseNumber = "";

          /**
           * User email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.email = "";

          /**
           * User preferences.
           * @member {stronachgroup.first.racehorse360.IUserPreferences|null|undefined} preferences
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           */
          User.prototype.preferences = null;

          /**
           * Creates a new User instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.User
           * @static
           * @param {stronachgroup.first.racehorse360.IUser=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.User} User instance
           */
          User.create = function create(properties) {
            return new User(properties);
          };

          /**
           * Encodes the specified User message. Does not implicitly {@link stronachgroup.first.racehorse360.User.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.User
           * @static
           * @param {stronachgroup.first.racehorse360.IUser} message User message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          User.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.lastName);
            if (
              message.phoneNumber != null &&
              Object.hasOwnProperty.call(message, "phoneNumber")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.phoneNumber);
            if (
              message.licenseNumber != null &&
              Object.hasOwnProperty.call(message, "licenseNumber")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.licenseNumber);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.email);
            if (
              message.preferences != null &&
              Object.hasOwnProperty.call(message, "preferences")
            )
              $root.stronachgroup.first.racehorse360.UserPreferences.encode(
                message.preferences,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a User message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.User
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.User} User
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          User.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.User();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.firstName = reader.string();
                  break;
                case 3:
                  message.lastName = reader.string();
                  break;
                case 6:
                  message.phoneNumber = reader.string();
                  break;
                case 7:
                  message.licenseNumber = reader.string();
                  break;
                case 8:
                  message.email = reader.string();
                  break;
                case 9:
                  message.preferences =
                    $root.stronachgroup.first.racehorse360.UserPreferences.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a User message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.User
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.User} User
           */
          User.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.User)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.User();
            if (object.id != null) message.id = String(object.id);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.phoneNumber != null)
              message.phoneNumber = String(object.phoneNumber);
            if (object.licenseNumber != null)
              message.licenseNumber = String(object.licenseNumber);
            if (object.email != null) message.email = String(object.email);
            if (object.preferences != null) {
              if (typeof object.preferences !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.User.preferences: object expected"
                );
              message.preferences =
                $root.stronachgroup.first.racehorse360.UserPreferences.fromObject(
                  object.preferences
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a User message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.User
           * @static
           * @param {stronachgroup.first.racehorse360.User} message User
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          User.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.firstName = "";
              object.lastName = "";
              object.phoneNumber = "";
              object.licenseNumber = "";
              object.email = "";
              object.preferences = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.phoneNumber != null &&
              message.hasOwnProperty("phoneNumber")
            )
              object.phoneNumber = message.phoneNumber;
            if (
              message.licenseNumber != null &&
              message.hasOwnProperty("licenseNumber")
            )
              object.licenseNumber = message.licenseNumber;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.preferences != null &&
              message.hasOwnProperty("preferences")
            )
              object.preferences =
                $root.stronachgroup.first.racehorse360.UserPreferences.toObject(
                  message.preferences,
                  options
                );
            return object;
          };

          /**
           * Converts this User to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.User
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return User;
        })();

        racehorse360.UserFilter = (function () {
          /**
           * Properties of a UserFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserFilter
           * @property {Array.<string>|null} [ids] UserFilter ids
           * @property {Array.<string>|null} [externalAuthIds] UserFilter externalAuthIds
           * @property {Array.<string>|null} [roleIds] UserFilter roleIds
           * @property {stronachgroup.first.racehorse360.RoleGroup|null} [roleGroup] UserFilter roleGroup
           * @property {Array.<string>|null} [facilityIds] UserFilter facilityIds
           * @property {Array.<stronachgroup.first.racehorse360.IRoleFacilityFilter>|null} [roleFacilities] UserFilter roleFacilities
           * @property {string|null} [email] UserFilter email
           * @property {string|null} [userInfo] UserFilter userInfo
           * @property {stronachgroup.first.racehorse360.IVetUsersFilter|null} [vetUsersFilter] UserFilter vetUsersFilter
           */

          /**
           * Constructs a new UserFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserFilter.
           * @implements IUserFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserFilter=} [properties] Properties to set
           */
          function UserFilter(properties) {
            this.ids = [];
            this.externalAuthIds = [];
            this.roleIds = [];
            this.facilityIds = [];
            this.roleFacilities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.ids = $util.emptyArray;

          /**
           * UserFilter externalAuthIds.
           * @member {Array.<string>} externalAuthIds
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.externalAuthIds = $util.emptyArray;

          /**
           * UserFilter roleIds.
           * @member {Array.<string>} roleIds
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.roleIds = $util.emptyArray;

          /**
           * UserFilter roleGroup.
           * @member {stronachgroup.first.racehorse360.RoleGroup} roleGroup
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.roleGroup = 0;

          /**
           * UserFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * UserFilter roleFacilities.
           * @member {Array.<stronachgroup.first.racehorse360.IRoleFacilityFilter>} roleFacilities
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.roleFacilities = $util.emptyArray;

          /**
           * UserFilter email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.email = "";

          /**
           * UserFilter userInfo.
           * @member {string} userInfo
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.userInfo = "";

          /**
           * UserFilter vetUsersFilter.
           * @member {stronachgroup.first.racehorse360.IVetUsersFilter|null|undefined} vetUsersFilter
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           */
          UserFilter.prototype.vetUsersFilter = null;

          /**
           * Creates a new UserFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserFilter} UserFilter instance
           */
          UserFilter.create = function create(properties) {
            return new UserFilter(properties);
          };

          /**
           * Encodes the specified UserFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.UserFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserFilter} message UserFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.externalAuthIds != null &&
              message.externalAuthIds.length
            )
              for (var i = 0; i < message.externalAuthIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.externalAuthIds[i]);
            if (message.roleIds != null && message.roleIds.length)
              for (var i = 0; i < message.roleIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.roleIds[i]);
            if (
              message.roleGroup != null &&
              Object.hasOwnProperty.call(message, "roleGroup")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.roleGroup);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.facilityIds[i]);
            if (message.roleFacilities != null && message.roleFacilities.length)
              for (var i = 0; i < message.roleFacilities.length; ++i)
                $root.stronachgroup.first.racehorse360.RoleFacilityFilter.encode(
                  message.roleFacilities[i],
                  writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
                ).ldelim();
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.email);
            if (
              message.userInfo != null &&
              Object.hasOwnProperty.call(message, "userInfo")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.userInfo);
            if (
              message.vetUsersFilter != null &&
              Object.hasOwnProperty.call(message, "vetUsersFilter")
            )
              $root.stronachgroup.first.racehorse360.VetUsersFilter.encode(
                message.vetUsersFilter,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a UserFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserFilter} UserFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.UserFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(message.externalAuthIds && message.externalAuthIds.length)
                  )
                    message.externalAuthIds = [];
                  message.externalAuthIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.roleIds && message.roleIds.length))
                    message.roleIds = [];
                  message.roleIds.push(reader.string());
                  break;
                case 4:
                  message.roleGroup = reader.int32();
                  break;
                case 5:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 6:
                  if (
                    !(message.roleFacilities && message.roleFacilities.length)
                  )
                    message.roleFacilities = [];
                  message.roleFacilities.push(
                    $root.stronachgroup.first.racehorse360.RoleFacilityFilter.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 7:
                  message.email = reader.string();
                  break;
                case 8:
                  message.userInfo = reader.string();
                  break;
                case 9:
                  message.vetUsersFilter =
                    $root.stronachgroup.first.racehorse360.VetUsersFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserFilter} UserFilter
           */
          UserFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UserFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UserFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.externalAuthIds) {
              if (!Array.isArray(object.externalAuthIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.externalAuthIds: array expected"
                );
              message.externalAuthIds = [];
              for (var i = 0; i < object.externalAuthIds.length; ++i)
                message.externalAuthIds[i] = String(object.externalAuthIds[i]);
            }
            if (object.roleIds) {
              if (!Array.isArray(object.roleIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.roleIds: array expected"
                );
              message.roleIds = [];
              for (var i = 0; i < object.roleIds.length; ++i)
                message.roleIds[i] = String(object.roleIds[i]);
            }
            switch (object.roleGroup) {
              case "ROLE_GROUP_INVALID":
              case 0:
                message.roleGroup = 0;
                break;
              case "ROLE_GROUP_TRAINERS":
              case 1:
                message.roleGroup = 1;
                break;
              case "ROLE_GROUP_VETERINARIANS":
              case 2:
                message.roleGroup = 2;
                break;
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.roleFacilities) {
              if (!Array.isArray(object.roleFacilities))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.roleFacilities: array expected"
                );
              message.roleFacilities = [];
              for (var i = 0; i < object.roleFacilities.length; ++i) {
                if (typeof object.roleFacilities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.UserFilter.roleFacilities: object expected"
                  );
                message.roleFacilities[i] =
                  $root.stronachgroup.first.racehorse360.RoleFacilityFilter.fromObject(
                    object.roleFacilities[i]
                  );
              }
            }
            if (object.email != null) message.email = String(object.email);
            if (object.userInfo != null)
              message.userInfo = String(object.userInfo);
            if (object.vetUsersFilter != null) {
              if (typeof object.vetUsersFilter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserFilter.vetUsersFilter: object expected"
                );
              message.vetUsersFilter =
                $root.stronachgroup.first.racehorse360.VetUsersFilter.fromObject(
                  object.vetUsersFilter
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a UserFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @static
           * @param {stronachgroup.first.racehorse360.UserFilter} message UserFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.externalAuthIds = [];
              object.roleIds = [];
              object.facilityIds = [];
              object.roleFacilities = [];
            }
            if (options.defaults) {
              object.roleGroup =
                options.enums === String ? "ROLE_GROUP_INVALID" : 0;
              object.email = "";
              object.userInfo = "";
              object.vetUsersFilter = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.externalAuthIds && message.externalAuthIds.length) {
              object.externalAuthIds = [];
              for (var j = 0; j < message.externalAuthIds.length; ++j)
                object.externalAuthIds[j] = message.externalAuthIds[j];
            }
            if (message.roleIds && message.roleIds.length) {
              object.roleIds = [];
              for (var j = 0; j < message.roleIds.length; ++j)
                object.roleIds[j] = message.roleIds[j];
            }
            if (
              message.roleGroup != null &&
              message.hasOwnProperty("roleGroup")
            )
              object.roleGroup =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.RoleGroup[
                      message.roleGroup
                    ]
                  : message.roleGroup;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.roleFacilities && message.roleFacilities.length) {
              object.roleFacilities = [];
              for (var j = 0; j < message.roleFacilities.length; ++j)
                object.roleFacilities[j] =
                  $root.stronachgroup.first.racehorse360.RoleFacilityFilter.toObject(
                    message.roleFacilities[j],
                    options
                  );
            }
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
              object.userInfo = message.userInfo;
            if (
              message.vetUsersFilter != null &&
              message.hasOwnProperty("vetUsersFilter")
            )
              object.vetUsersFilter =
                $root.stronachgroup.first.racehorse360.VetUsersFilter.toObject(
                  message.vetUsersFilter,
                  options
                );
            return object;
          };

          /**
           * Converts this UserFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserFilter;
        })();

        racehorse360.RoleFacilityFilter = (function () {
          /**
           * Properties of a RoleFacilityFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRoleFacilityFilter
           * @property {string|null} [roleId] RoleFacilityFilter roleId
           * @property {string|null} [facilityId] RoleFacilityFilter facilityId
           */

          /**
           * Constructs a new RoleFacilityFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RoleFacilityFilter.
           * @implements IRoleFacilityFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRoleFacilityFilter=} [properties] Properties to set
           */
          function RoleFacilityFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RoleFacilityFilter roleId.
           * @member {string} roleId
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @instance
           */
          RoleFacilityFilter.prototype.roleId = "";

          /**
           * RoleFacilityFilter facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @instance
           */
          RoleFacilityFilter.prototype.facilityId = "";

          /**
           * Creates a new RoleFacilityFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRoleFacilityFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RoleFacilityFilter} RoleFacilityFilter instance
           */
          RoleFacilityFilter.create = function create(properties) {
            return new RoleFacilityFilter(properties);
          };

          /**
           * Encodes the specified RoleFacilityFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RoleFacilityFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRoleFacilityFilter} message RoleFacilityFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RoleFacilityFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.roleId != null &&
              Object.hasOwnProperty.call(message, "roleId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.roleId);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityId);
            return writer;
          };

          /**
           * Decodes a RoleFacilityFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RoleFacilityFilter} RoleFacilityFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RoleFacilityFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RoleFacilityFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.roleId = reader.string();
                  break;
                case 2:
                  message.facilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RoleFacilityFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RoleFacilityFilter} RoleFacilityFilter
           */
          RoleFacilityFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RoleFacilityFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RoleFacilityFilter();
            if (object.roleId != null) message.roleId = String(object.roleId);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            return message;
          };

          /**
           * Creates a plain object from a RoleFacilityFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RoleFacilityFilter} message RoleFacilityFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RoleFacilityFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.roleId = "";
              object.facilityId = "";
            }
            if (message.roleId != null && message.hasOwnProperty("roleId"))
              object.roleId = message.roleId;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            return object;
          };

          /**
           * Converts this RoleFacilityFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RoleFacilityFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RoleFacilityFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RoleFacilityFilter;
        })();

        racehorse360.VetUsersFilter = (function () {
          /**
           * Properties of a VetUsersFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IVetUsersFilter
           * @property {Array.<string>|null} [facilityIds] VetUsersFilter facilityIds
           * @property {boolean|null} [includeMainTrackVets] VetUsersFilter includeMainTrackVets
           */

          /**
           * Constructs a new VetUsersFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a VetUsersFilter.
           * @implements IVetUsersFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IVetUsersFilter=} [properties] Properties to set
           */
          function VetUsersFilter(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * VetUsersFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @instance
           */
          VetUsersFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * VetUsersFilter includeMainTrackVets.
           * @member {boolean} includeMainTrackVets
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @instance
           */
          VetUsersFilter.prototype.includeMainTrackVets = false;

          /**
           * Creates a new VetUsersFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVetUsersFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.VetUsersFilter} VetUsersFilter instance
           */
          VetUsersFilter.create = function create(properties) {
            return new VetUsersFilter(properties);
          };

          /**
           * Encodes the specified VetUsersFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.VetUsersFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IVetUsersFilter} message VetUsersFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          VetUsersFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            if (
              message.includeMainTrackVets != null &&
              Object.hasOwnProperty.call(message, "includeMainTrackVets")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .bool(message.includeMainTrackVets);
            return writer;
          };

          /**
           * Decodes a VetUsersFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.VetUsersFilter} VetUsersFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          VetUsersFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.VetUsersFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 2:
                  message.includeMainTrackVets = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a VetUsersFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.VetUsersFilter} VetUsersFilter
           */
          VetUsersFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.VetUsersFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.VetUsersFilter();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.VetUsersFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.includeMainTrackVets != null)
              message.includeMainTrackVets = Boolean(
                object.includeMainTrackVets
              );
            return message;
          };

          /**
           * Creates a plain object from a VetUsersFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @static
           * @param {stronachgroup.first.racehorse360.VetUsersFilter} message VetUsersFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          VetUsersFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.includeMainTrackVets = false;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.includeMainTrackVets != null &&
              message.hasOwnProperty("includeMainTrackVets")
            )
              object.includeMainTrackVets = message.includeMainTrackVets;
            return object;
          };

          /**
           * Converts this VetUsersFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.VetUsersFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          VetUsersFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return VetUsersFilter;
        })();

        racehorse360.FindOrCreateUserRequest = (function () {
          /**
           * Properties of a FindOrCreateUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IFindOrCreateUserRequest
           * @property {string|null} [externalAuthId] FindOrCreateUserRequest externalAuthId
           * @property {string|null} [email] FindOrCreateUserRequest email
           * @property {string|null} [firstName] FindOrCreateUserRequest firstName
           * @property {string|null} [lastName] FindOrCreateUserRequest lastName
           * @property {boolean|null} [isDeveloper] FindOrCreateUserRequest isDeveloper
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] FindOrCreateUserRequest getOptions
           */

          /**
           * Constructs a new FindOrCreateUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FindOrCreateUserRequest.
           * @implements IFindOrCreateUserRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IFindOrCreateUserRequest=} [properties] Properties to set
           */
          function FindOrCreateUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FindOrCreateUserRequest externalAuthId.
           * @member {string} externalAuthId
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.externalAuthId = "";

          /**
           * FindOrCreateUserRequest email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.email = "";

          /**
           * FindOrCreateUserRequest firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.firstName = "";

          /**
           * FindOrCreateUserRequest lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.lastName = "";

          /**
           * FindOrCreateUserRequest isDeveloper.
           * @member {boolean} isDeveloper
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.isDeveloper = false;

          /**
           * FindOrCreateUserRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           */
          FindOrCreateUserRequest.prototype.getOptions = null;

          /**
           * Creates a new FindOrCreateUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IFindOrCreateUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.FindOrCreateUserRequest} FindOrCreateUserRequest instance
           */
          FindOrCreateUserRequest.create = function create(properties) {
            return new FindOrCreateUserRequest(properties);
          };

          /**
           * Encodes the specified FindOrCreateUserRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.FindOrCreateUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IFindOrCreateUserRequest} message FindOrCreateUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FindOrCreateUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.externalAuthId != null &&
              Object.hasOwnProperty.call(message, "externalAuthId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.externalAuthId);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.email);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.lastName);
            if (
              message.isDeveloper != null &&
              Object.hasOwnProperty.call(message, "isDeveloper")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .bool(message.isDeveloper);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a FindOrCreateUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.FindOrCreateUserRequest} FindOrCreateUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FindOrCreateUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.FindOrCreateUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.externalAuthId = reader.string();
                  break;
                case 2:
                  message.email = reader.string();
                  break;
                case 3:
                  message.firstName = reader.string();
                  break;
                case 4:
                  message.lastName = reader.string();
                  break;
                case 5:
                  message.isDeveloper = reader.bool();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FindOrCreateUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.FindOrCreateUserRequest} FindOrCreateUserRequest
           */
          FindOrCreateUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.FindOrCreateUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.FindOrCreateUserRequest();
            if (object.externalAuthId != null)
              message.externalAuthId = String(object.externalAuthId);
            if (object.email != null) message.email = String(object.email);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.isDeveloper != null)
              message.isDeveloper = Boolean(object.isDeveloper);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FindOrCreateUserRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a FindOrCreateUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.FindOrCreateUserRequest} message FindOrCreateUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FindOrCreateUserRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.externalAuthId = "";
              object.email = "";
              object.firstName = "";
              object.lastName = "";
              object.isDeveloper = false;
              object.getOptions = null;
            }
            if (
              message.externalAuthId != null &&
              message.hasOwnProperty("externalAuthId")
            )
              object.externalAuthId = message.externalAuthId;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.isDeveloper != null &&
              message.hasOwnProperty("isDeveloper")
            )
              object.isDeveloper = message.isDeveloper;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this FindOrCreateUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.FindOrCreateUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FindOrCreateUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FindOrCreateUserRequest;
        })();

        racehorse360.GrantDeveloperAccessRequest = (function () {
          /**
           * Properties of a GrantDeveloperAccessRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGrantDeveloperAccessRequest
           * @property {string|null} [id] GrantDeveloperAccessRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GrantDeveloperAccessRequest getOptions
           */

          /**
           * Constructs a new GrantDeveloperAccessRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GrantDeveloperAccessRequest.
           * @implements IGrantDeveloperAccessRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGrantDeveloperAccessRequest=} [properties] Properties to set
           */
          function GrantDeveloperAccessRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GrantDeveloperAccessRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @instance
           */
          GrantDeveloperAccessRequest.prototype.id = "";

          /**
           * GrantDeveloperAccessRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @instance
           */
          GrantDeveloperAccessRequest.prototype.getOptions = null;

          /**
           * Creates a new GrantDeveloperAccessRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGrantDeveloperAccessRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} GrantDeveloperAccessRequest instance
           */
          GrantDeveloperAccessRequest.create = function create(properties) {
            return new GrantDeveloperAccessRequest(properties);
          };

          /**
           * Encodes the specified GrantDeveloperAccessRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GrantDeveloperAccessRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGrantDeveloperAccessRequest} message GrantDeveloperAccessRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GrantDeveloperAccessRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GrantDeveloperAccessRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} GrantDeveloperAccessRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GrantDeveloperAccessRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GrantDeveloperAccessRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} GrantDeveloperAccessRequest
           */
          GrantDeveloperAccessRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GrantDeveloperAccessRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GrantDeveloperAccessRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GrantDeveloperAccessRequest} message GrantDeveloperAccessRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GrantDeveloperAccessRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GrantDeveloperAccessRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GrantDeveloperAccessRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GrantDeveloperAccessRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GrantDeveloperAccessRequest;
        })();

        racehorse360.AssignRoleRequest = (function () {
          /**
           * Properties of an AssignRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignRoleRequest
           * @property {string|null} [id] AssignRoleRequest id
           * @property {string|null} [roleId] AssignRoleRequest roleId
           * @property {string|null} [facilityId] AssignRoleRequest facilityId
           * @property {string|null} [trainerId] AssignRoleRequest trainerId
           */

          /**
           * Constructs a new AssignRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignRoleRequest.
           * @implements IAssignRoleRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignRoleRequest=} [properties] Properties to set
           */
          function AssignRoleRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignRoleRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @instance
           */
          AssignRoleRequest.prototype.id = "";

          /**
           * AssignRoleRequest roleId.
           * @member {string} roleId
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @instance
           */
          AssignRoleRequest.prototype.roleId = "";

          /**
           * AssignRoleRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @instance
           */
          AssignRoleRequest.prototype.facilityId = "";

          /**
           * AssignRoleRequest trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @instance
           */
          AssignRoleRequest.prototype.trainerId = "";

          /**
           * Creates a new AssignRoleRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignRoleRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignRoleRequest} AssignRoleRequest instance
           */
          AssignRoleRequest.create = function create(properties) {
            return new AssignRoleRequest(properties);
          };

          /**
           * Encodes the specified AssignRoleRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignRoleRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignRoleRequest} message AssignRoleRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignRoleRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.roleId != null &&
              Object.hasOwnProperty.call(message, "roleId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.roleId);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.facilityId);
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.trainerId);
            return writer;
          };

          /**
           * Decodes an AssignRoleRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignRoleRequest} AssignRoleRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignRoleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignRoleRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.roleId = reader.string();
                  break;
                case 3:
                  message.facilityId = reader.string();
                  break;
                case 4:
                  message.trainerId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignRoleRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignRoleRequest} AssignRoleRequest
           */
          AssignRoleRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.AssignRoleRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.AssignRoleRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.roleId != null) message.roleId = String(object.roleId);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            return message;
          };

          /**
           * Creates a plain object from an AssignRoleRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignRoleRequest} message AssignRoleRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignRoleRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.roleId = "";
              object.facilityId = "";
              object.trainerId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.roleId != null && message.hasOwnProperty("roleId"))
              object.roleId = message.roleId;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            return object;
          };

          /**
           * Converts this AssignRoleRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignRoleRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignRoleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AssignRoleRequest;
        })();

        racehorse360.RemoveRoleRequest = (function () {
          /**
           * Properties of a RemoveRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRemoveRoleRequest
           * @property {string|null} [id] RemoveRoleRequest id
           * @property {string|null} [roleId] RemoveRoleRequest roleId
           * @property {string|null} [facilityId] RemoveRoleRequest facilityId
           * @property {string|null} [trainerId] RemoveRoleRequest trainerId
           */

          /**
           * Constructs a new RemoveRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RemoveRoleRequest.
           * @implements IRemoveRoleRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRemoveRoleRequest=} [properties] Properties to set
           */
          function RemoveRoleRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RemoveRoleRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @instance
           */
          RemoveRoleRequest.prototype.id = "";

          /**
           * RemoveRoleRequest roleId.
           * @member {string} roleId
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @instance
           */
          RemoveRoleRequest.prototype.roleId = "";

          /**
           * RemoveRoleRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @instance
           */
          RemoveRoleRequest.prototype.facilityId = "";

          /**
           * RemoveRoleRequest trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @instance
           */
          RemoveRoleRequest.prototype.trainerId = "";

          /**
           * Creates a new RemoveRoleRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRemoveRoleRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RemoveRoleRequest} RemoveRoleRequest instance
           */
          RemoveRoleRequest.create = function create(properties) {
            return new RemoveRoleRequest(properties);
          };

          /**
           * Encodes the specified RemoveRoleRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RemoveRoleRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRemoveRoleRequest} message RemoveRoleRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RemoveRoleRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.roleId != null &&
              Object.hasOwnProperty.call(message, "roleId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.roleId);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.facilityId);
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.trainerId);
            return writer;
          };

          /**
           * Decodes a RemoveRoleRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RemoveRoleRequest} RemoveRoleRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RemoveRoleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RemoveRoleRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.roleId = reader.string();
                  break;
                case 3:
                  message.facilityId = reader.string();
                  break;
                case 4:
                  message.trainerId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RemoveRoleRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RemoveRoleRequest} RemoveRoleRequest
           */
          RemoveRoleRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RemoveRoleRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RemoveRoleRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.roleId != null) message.roleId = String(object.roleId);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            return message;
          };

          /**
           * Creates a plain object from a RemoveRoleRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RemoveRoleRequest} message RemoveRoleRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RemoveRoleRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.roleId = "";
              object.facilityId = "";
              object.trainerId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.roleId != null && message.hasOwnProperty("roleId"))
              object.roleId = message.roleId;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            return object;
          };

          /**
           * Converts this RemoveRoleRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RemoveRoleRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RemoveRoleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RemoveRoleRequest;
        })();

        racehorse360.GetUserRequest = (function () {
          /**
           * Properties of a GetUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetUserRequest
           * @property {string|null} [id] GetUserRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetUserRequest getOptions
           */

          /**
           * Constructs a new GetUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetUserRequest.
           * @implements IGetUserRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetUserRequest=} [properties] Properties to set
           */
          function GetUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUserRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @instance
           */
          GetUserRequest.prototype.id = "";

          /**
           * GetUserRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @instance
           */
          GetUserRequest.prototype.getOptions = null;

          /**
           * Creates a new GetUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetUserRequest} GetUserRequest instance
           */
          GetUserRequest.create = function create(properties) {
            return new GetUserRequest(properties);
          };

          /**
           * Encodes the specified GetUserRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUserRequest} message GetUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetUserRequest} GetUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetUserRequest} GetUserRequest
           */
          GetUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetUserRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetUserRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetUserRequest} message GetUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUserRequest;
        })();

        racehorse360.EditUserRequest = (function () {
          /**
           * Properties of an EditUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditUserRequest
           * @property {string|null} [id] EditUserRequest id
           * @property {string|null} [firstName] EditUserRequest firstName
           * @property {string|null} [lastName] EditUserRequest lastName
           * @property {string|null} [licenseNumber] EditUserRequest licenseNumber
           * @property {string|null} [phoneNumber] EditUserRequest phoneNumber
           * @property {string|null} [email] EditUserRequest email
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditUserRequest getOptions
           */

          /**
           * Constructs a new EditUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditUserRequest.
           * @implements IEditUserRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditUserRequest=} [properties] Properties to set
           */
          function EditUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditUserRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.id = "";

          /**
           * EditUserRequest firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.firstName = "";

          /**
           * EditUserRequest lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.lastName = "";

          /**
           * EditUserRequest licenseNumber.
           * @member {string} licenseNumber
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.licenseNumber = "";

          /**
           * EditUserRequest phoneNumber.
           * @member {string} phoneNumber
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.phoneNumber = "";

          /**
           * EditUserRequest email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.email = "";

          /**
           * EditUserRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           */
          EditUserRequest.prototype.getOptions = null;

          /**
           * Creates a new EditUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditUserRequest} EditUserRequest instance
           */
          EditUserRequest.create = function create(properties) {
            return new EditUserRequest(properties);
          };

          /**
           * Encodes the specified EditUserRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditUserRequest} message EditUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.lastName);
            if (
              message.licenseNumber != null &&
              Object.hasOwnProperty.call(message, "licenseNumber")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.licenseNumber);
            if (
              message.phoneNumber != null &&
              Object.hasOwnProperty.call(message, "phoneNumber")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.phoneNumber);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.email);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditUserRequest} EditUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.firstName = reader.string();
                  break;
                case 3:
                  message.lastName = reader.string();
                  break;
                case 4:
                  message.licenseNumber = reader.string();
                  break;
                case 5:
                  message.phoneNumber = reader.string();
                  break;
                case 6:
                  message.email = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditUserRequest} EditUserRequest
           */
          EditUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EditUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditUserRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.licenseNumber != null)
              message.licenseNumber = String(object.licenseNumber);
            if (object.phoneNumber != null)
              message.phoneNumber = String(object.phoneNumber);
            if (object.email != null) message.email = String(object.email);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditUserRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditUserRequest} message EditUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditUserRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.firstName = "";
              object.lastName = "";
              object.licenseNumber = "";
              object.phoneNumber = "";
              object.email = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.licenseNumber != null &&
              message.hasOwnProperty("licenseNumber")
            )
              object.licenseNumber = message.licenseNumber;
            if (
              message.phoneNumber != null &&
              message.hasOwnProperty("phoneNumber")
            )
              object.phoneNumber = message.phoneNumber;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EditUserRequest;
        })();

        racehorse360.DeleteUserRequest = (function () {
          /**
           * Properties of a DeleteUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteUserRequest
           * @property {string|null} [id] DeleteUserRequest id
           */

          /**
           * Constructs a new DeleteUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteUserRequest.
           * @implements IDeleteUserRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteUserRequest=} [properties] Properties to set
           */
          function DeleteUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteUserRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @instance
           */
          DeleteUserRequest.prototype.id = "";

          /**
           * Creates a new DeleteUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteUserRequest} DeleteUserRequest instance
           */
          DeleteUserRequest.create = function create(properties) {
            return new DeleteUserRequest(properties);
          };

          /**
           * Encodes the specified DeleteUserRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteUserRequest} message DeleteUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteUserRequest} DeleteUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteUserRequest} DeleteUserRequest
           */
          DeleteUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteUserRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteUserRequest} message DeleteUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteUserRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteUserRequest;
        })();

        racehorse360.ListUserRequest = (function () {
          /**
           * Properties of a ListUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserRequest
           * @property {stronachgroup.first.racehorse360.IUserFilter|null} [query] ListUserRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListUserRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListUserRequest pagingOptions
           */

          /**
           * Constructs a new ListUserRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserRequest.
           * @implements IListUserRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserRequest=} [properties] Properties to set
           */
          function ListUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserRequest query.
           * @member {stronachgroup.first.racehorse360.IUserFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @instance
           */
          ListUserRequest.prototype.query = null;

          /**
           * ListUserRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @instance
           */
          ListUserRequest.prototype.getOptions = null;

          /**
           * ListUserRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @instance
           */
          ListUserRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserRequest} ListUserRequest instance
           */
          ListUserRequest.create = function create(properties) {
            return new ListUserRequest(properties);
          };

          /**
           * Encodes the specified ListUserRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRequest} message ListUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.UserFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserRequest} ListUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.UserFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserRequest} ListUserRequest
           */
          ListUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.UserFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserRequest} message ListUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.UserFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserRequest;
        })();

        racehorse360.ListUserResponse = (function () {
          /**
           * Properties of a ListUserResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUser>|null} [users] ListUserResponse users
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListUserResponse pagingInfo
           */

          /**
           * Constructs a new ListUserResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserResponse.
           * @implements IListUserResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserResponse=} [properties] Properties to set
           */
          function ListUserResponse(properties) {
            this.users = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserResponse users.
           * @member {Array.<stronachgroup.first.racehorse360.IUser>} users
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @instance
           */
          ListUserResponse.prototype.users = $util.emptyArray;

          /**
           * ListUserResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @instance
           */
          ListUserResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListUserResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserResponse} ListUserResponse instance
           */
          ListUserResponse.create = function create(properties) {
            return new ListUserResponse(properties);
          };

          /**
           * Encodes the specified ListUserResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserResponse} message ListUserResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.users != null && message.users.length)
              for (var i = 0; i < message.users.length; ++i)
                $root.stronachgroup.first.racehorse360.User.encode(
                  message.users[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserResponse} ListUserResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.users && message.users.length))
                    message.users = [];
                  message.users.push(
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserResponse} ListUserResponse
           */
          ListUserResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUserResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserResponse();
            if (object.users) {
              if (!Array.isArray(object.users))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserResponse.users: array expected"
                );
              message.users = [];
              for (var i = 0; i < object.users.length; ++i) {
                if (typeof object.users[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListUserResponse.users: object expected"
                  );
                message.users[i] =
                  $root.stronachgroup.first.racehorse360.User.fromObject(
                    object.users[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserResponse} message ListUserResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.users = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.users && message.users.length) {
              object.users = [];
              for (var j = 0; j < message.users.length; ++j)
                object.users[j] =
                  $root.stronachgroup.first.racehorse360.User.toObject(
                    message.users[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserResponse;
        })();

        racehorse360.UserPreferences = (function () {
          /**
           * Properties of a UserPreferences.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserPreferences
           * @property {string|null} [id] UserPreferences id
           * @property {stronachgroup.first.racehorse360.HorseDetailPageDataColumn|null} [horseDetailPageDataColumn] UserPreferences horseDetailPageDataColumn
           */

          /**
           * Constructs a new UserPreferences.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserPreferences.
           * @implements IUserPreferences
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserPreferences=} [properties] Properties to set
           */
          function UserPreferences(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserPreferences id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @instance
           */
          UserPreferences.prototype.id = "";

          /**
           * UserPreferences horseDetailPageDataColumn.
           * @member {stronachgroup.first.racehorse360.HorseDetailPageDataColumn} horseDetailPageDataColumn
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @instance
           */
          UserPreferences.prototype.horseDetailPageDataColumn = 0;

          /**
           * Creates a new UserPreferences instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @static
           * @param {stronachgroup.first.racehorse360.IUserPreferences=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserPreferences} UserPreferences instance
           */
          UserPreferences.create = function create(properties) {
            return new UserPreferences(properties);
          };

          /**
           * Encodes the specified UserPreferences message. Does not implicitly {@link stronachgroup.first.racehorse360.UserPreferences.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @static
           * @param {stronachgroup.first.racehorse360.IUserPreferences} message UserPreferences message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserPreferences.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseDetailPageDataColumn != null &&
              Object.hasOwnProperty.call(message, "horseDetailPageDataColumn")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.horseDetailPageDataColumn);
            return writer;
          };

          /**
           * Decodes a UserPreferences message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserPreferences} UserPreferences
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserPreferences.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UserPreferences();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseDetailPageDataColumn = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserPreferences message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserPreferences} UserPreferences
           */
          UserPreferences.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UserPreferences
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UserPreferences();
            if (object.id != null) message.id = String(object.id);
            switch (object.horseDetailPageDataColumn) {
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_INVALID":
              case 0:
                message.horseDetailPageDataColumn = 0;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_LEVEL":
              case 1:
                message.horseDetailPageDataColumn = 1;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_HIGH_SPEED_FURLONGS":
              case 2:
                message.horseDetailPageDataColumn = 2;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTORS":
              case 3:
                message.horseDetailPageDataColumn = 3;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_VET_LIST":
              case 4:
                message.horseDetailPageDataColumn = 4;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_AGE_SEX_COLOR":
              case 5:
                message.horseDetailPageDataColumn = 5;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_BARN_STALL":
              case 6:
                message.horseDetailPageDataColumn = 6;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_RACE":
              case 7:
                message.horseDetailPageDataColumn = 7;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_WORK":
              case 8:
                message.horseDetailPageDataColumn = 8;
                break;
              case "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTOR_SCORE":
              case 9:
                message.horseDetailPageDataColumn = 9;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a UserPreferences message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @static
           * @param {stronachgroup.first.racehorse360.UserPreferences} message UserPreferences
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserPreferences.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseDetailPageDataColumn =
                options.enums === String
                  ? "HORSE_DETAIL_PAGE_DATA_COLUMN_INVALID"
                  : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseDetailPageDataColumn != null &&
              message.hasOwnProperty("horseDetailPageDataColumn")
            )
              object.horseDetailPageDataColumn =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .HorseDetailPageDataColumn[
                      message.horseDetailPageDataColumn
                    ]
                  : message.horseDetailPageDataColumn;
            return object;
          };

          /**
           * Converts this UserPreferences to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserPreferences
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserPreferences.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserPreferences;
        })();

        racehorse360.UpdateUserPreferencesRequest = (function () {
          /**
           * Properties of an UpdateUserPreferencesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateUserPreferencesRequest
           * @property {stronachgroup.first.racehorse360.IUserPreferences|null} [userPreferences] UpdateUserPreferencesRequest userPreferences
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateUserPreferencesRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateUserPreferencesRequest getOptions
           */

          /**
           * Constructs a new UpdateUserPreferencesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateUserPreferencesRequest.
           * @implements IUpdateUserPreferencesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateUserPreferencesRequest=} [properties] Properties to set
           */
          function UpdateUserPreferencesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateUserPreferencesRequest userPreferences.
           * @member {stronachgroup.first.racehorse360.IUserPreferences|null|undefined} userPreferences
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @instance
           */
          UpdateUserPreferencesRequest.prototype.userPreferences = null;

          /**
           * UpdateUserPreferencesRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @instance
           */
          UpdateUserPreferencesRequest.prototype.updateMask = null;

          /**
           * UpdateUserPreferencesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @instance
           */
          UpdateUserPreferencesRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateUserPreferencesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateUserPreferencesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} UpdateUserPreferencesRequest instance
           */
          UpdateUserPreferencesRequest.create = function create(properties) {
            return new UpdateUserPreferencesRequest(properties);
          };

          /**
           * Encodes the specified UpdateUserPreferencesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateUserPreferencesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateUserPreferencesRequest} message UpdateUserPreferencesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateUserPreferencesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.userPreferences != null &&
              Object.hasOwnProperty.call(message, "userPreferences")
            )
              $root.stronachgroup.first.racehorse360.UserPreferences.encode(
                message.userPreferences,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateUserPreferencesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} UpdateUserPreferencesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateUserPreferencesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.userPreferences =
                    $root.stronachgroup.first.racehorse360.UserPreferences.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateUserPreferencesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} UpdateUserPreferencesRequest
           */
          UpdateUserPreferencesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateUserPreferencesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest();
            if (object.userPreferences != null) {
              if (typeof object.userPreferences !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateUserPreferencesRequest.userPreferences: object expected"
                );
              message.userPreferences =
                $root.stronachgroup.first.racehorse360.UserPreferences.fromObject(
                  object.userPreferences
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateUserPreferencesRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateUserPreferencesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateUserPreferencesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateUserPreferencesRequest} message UpdateUserPreferencesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateUserPreferencesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.userPreferences = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.userPreferences != null &&
              message.hasOwnProperty("userPreferences")
            )
              object.userPreferences =
                $root.stronachgroup.first.racehorse360.UserPreferences.toObject(
                  message.userPreferences,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateUserPreferencesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateUserPreferencesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateUserPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateUserPreferencesRequest;
        })();

        racehorse360.UserRole = (function () {
          /**
           * Properties of a UserRole.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserRole
           * @property {string|null} [id] UserRole id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] UserRole facility
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] UserRole trainer
           * @property {stronachgroup.first.racehorse360.IRole|null} [role] UserRole role
           * @property {stronachgroup.first.racehorse360.IUser|null} [user] UserRole user
           */

          /**
           * Constructs a new UserRole.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserRole.
           * @implements IUserRole
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserRole=} [properties] Properties to set
           */
          function UserRole(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserRole id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           */
          UserRole.prototype.id = "";

          /**
           * UserRole facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           */
          UserRole.prototype.facility = null;

          /**
           * UserRole trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           */
          UserRole.prototype.trainer = null;

          /**
           * UserRole role.
           * @member {stronachgroup.first.racehorse360.IRole|null|undefined} role
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           */
          UserRole.prototype.role = null;

          /**
           * UserRole user.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} user
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           */
          UserRole.prototype.user = null;

          /**
           * Creates a new UserRole instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRole=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserRole} UserRole instance
           */
          UserRole.create = function create(properties) {
            return new UserRole(properties);
          };

          /**
           * Encodes the specified UserRole message. Does not implicitly {@link stronachgroup.first.racehorse360.UserRole.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRole} message UserRole message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserRole.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.role != null &&
              Object.hasOwnProperty.call(message, "role")
            )
              $root.stronachgroup.first.racehorse360.Role.encode(
                message.role,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.user != null &&
              Object.hasOwnProperty.call(message, "user")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.user,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a UserRole message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserRole} UserRole
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserRole.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.UserRole();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 3:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.role =
                    $root.stronachgroup.first.racehorse360.Role.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.user =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserRole message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserRole} UserRole
           */
          UserRole.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.UserRole
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.UserRole();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRole.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRole.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.role != null) {
              if (typeof object.role !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRole.role: object expected"
                );
              message.role =
                $root.stronachgroup.first.racehorse360.Role.fromObject(
                  object.role
                );
            }
            if (object.user != null) {
              if (typeof object.user !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRole.user: object expected"
                );
              message.user =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.user
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a UserRole message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @static
           * @param {stronachgroup.first.racehorse360.UserRole} message UserRole
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserRole.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.trainer = null;
              object.role = null;
              object.user = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (message.role != null && message.hasOwnProperty("role"))
              object.role =
                $root.stronachgroup.first.racehorse360.Role.toObject(
                  message.role,
                  options
                );
            if (message.user != null && message.hasOwnProperty("user"))
              object.user =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.user,
                  options
                );
            return object;
          };

          /**
           * Converts this UserRole to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserRole
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserRole;
        })();

        racehorse360.UserRoleFilter = (function () {
          /**
           * Properties of a UserRoleFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserRoleFilter
           * @property {Array.<string>|null} [ids] UserRoleFilter ids
           * @property {Array.<string>|null} [userIds] UserRoleFilter userIds
           * @property {Array.<string>|null} [roleIds] UserRoleFilter roleIds
           * @property {Array.<string>|null} [trainerIds] UserRoleFilter trainerIds
           */

          /**
           * Constructs a new UserRoleFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserRoleFilter.
           * @implements IUserRoleFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserRoleFilter=} [properties] Properties to set
           */
          function UserRoleFilter(properties) {
            this.ids = [];
            this.userIds = [];
            this.roleIds = [];
            this.trainerIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserRoleFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @instance
           */
          UserRoleFilter.prototype.ids = $util.emptyArray;

          /**
           * UserRoleFilter userIds.
           * @member {Array.<string>} userIds
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @instance
           */
          UserRoleFilter.prototype.userIds = $util.emptyArray;

          /**
           * UserRoleFilter roleIds.
           * @member {Array.<string>} roleIds
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @instance
           */
          UserRoleFilter.prototype.roleIds = $util.emptyArray;

          /**
           * UserRoleFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @instance
           */
          UserRoleFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * Creates a new UserRoleFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserRoleFilter} UserRoleFilter instance
           */
          UserRoleFilter.create = function create(properties) {
            return new UserRoleFilter(properties);
          };

          /**
           * Encodes the specified UserRoleFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.UserRoleFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleFilter} message UserRoleFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserRoleFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.userIds != null && message.userIds.length)
              for (var i = 0; i < message.userIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.userIds[i]);
            if (message.roleIds != null && message.roleIds.length)
              for (var i = 0; i < message.roleIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.roleIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.trainerIds[i]);
            return writer;
          };

          /**
           * Decodes a UserRoleFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserRoleFilter} UserRoleFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserRoleFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UserRoleFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.userIds && message.userIds.length))
                    message.userIds = [];
                  message.userIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.roleIds && message.roleIds.length))
                    message.roleIds = [];
                  message.roleIds.push(reader.string());
                  break;
                case 4:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserRoleFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserRoleFilter} UserRoleFilter
           */
          UserRoleFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UserRoleFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UserRoleFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.userIds) {
              if (!Array.isArray(object.userIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleFilter.userIds: array expected"
                );
              message.userIds = [];
              for (var i = 0; i < object.userIds.length; ++i)
                message.userIds[i] = String(object.userIds[i]);
            }
            if (object.roleIds) {
              if (!Array.isArray(object.roleIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleFilter.roleIds: array expected"
                );
              message.roleIds = [];
              for (var i = 0; i < object.roleIds.length; ++i)
                message.roleIds[i] = String(object.roleIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a UserRoleFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @static
           * @param {stronachgroup.first.racehorse360.UserRoleFilter} message UserRoleFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserRoleFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.userIds = [];
              object.roleIds = [];
              object.trainerIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.userIds && message.userIds.length) {
              object.userIds = [];
              for (var j = 0; j < message.userIds.length; ++j)
                object.userIds[j] = message.userIds[j];
            }
            if (message.roleIds && message.roleIds.length) {
              object.roleIds = [];
              for (var j = 0; j < message.roleIds.length; ++j)
                object.roleIds[j] = message.roleIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            return object;
          };

          /**
           * Converts this UserRoleFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserRoleFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserRoleFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserRoleFilter;
        })();

        racehorse360.ListUserRolesRequest = (function () {
          /**
           * Properties of a ListUserRolesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserRolesRequest
           * @property {stronachgroup.first.racehorse360.IUserRoleFilter|null} [query] ListUserRolesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListUserRolesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListUserRolesRequest pagingOptions
           */

          /**
           * Constructs a new ListUserRolesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserRolesRequest.
           * @implements IListUserRolesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserRolesRequest=} [properties] Properties to set
           */
          function ListUserRolesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserRolesRequest query.
           * @member {stronachgroup.first.racehorse360.IUserRoleFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @instance
           */
          ListUserRolesRequest.prototype.query = null;

          /**
           * ListUserRolesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @instance
           */
          ListUserRolesRequest.prototype.getOptions = null;

          /**
           * ListUserRolesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @instance
           */
          ListUserRolesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListUserRolesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRolesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserRolesRequest} ListUserRolesRequest instance
           */
          ListUserRolesRequest.create = function create(properties) {
            return new ListUserRolesRequest(properties);
          };

          /**
           * Encodes the specified ListUserRolesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserRolesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRolesRequest} message ListUserRolesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserRolesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.UserRoleFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserRolesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserRolesRequest} ListUserRolesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserRolesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserRolesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.UserRoleFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserRolesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserRolesRequest} ListUserRolesRequest
           */
          ListUserRolesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUserRolesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserRolesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRolesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.UserRoleFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRolesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRolesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserRolesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserRolesRequest} message ListUserRolesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserRolesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.UserRoleFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserRolesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserRolesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserRolesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserRolesRequest;
        })();

        racehorse360.ListUserRolesResponse = (function () {
          /**
           * Properties of a ListUserRolesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserRolesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUserRole>|null} [userRoles] ListUserRolesResponse userRoles
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListUserRolesResponse pagingInfo
           */

          /**
           * Constructs a new ListUserRolesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserRolesResponse.
           * @implements IListUserRolesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserRolesResponse=} [properties] Properties to set
           */
          function ListUserRolesResponse(properties) {
            this.userRoles = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserRolesResponse userRoles.
           * @member {Array.<stronachgroup.first.racehorse360.IUserRole>} userRoles
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @instance
           */
          ListUserRolesResponse.prototype.userRoles = $util.emptyArray;

          /**
           * ListUserRolesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @instance
           */
          ListUserRolesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListUserRolesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRolesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserRolesResponse} ListUserRolesResponse instance
           */
          ListUserRolesResponse.create = function create(properties) {
            return new ListUserRolesResponse(properties);
          };

          /**
           * Encodes the specified ListUserRolesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserRolesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRolesResponse} message ListUserRolesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserRolesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.userRoles != null && message.userRoles.length)
              for (var i = 0; i < message.userRoles.length; ++i)
                $root.stronachgroup.first.racehorse360.UserRole.encode(
                  message.userRoles[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserRolesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserRolesResponse} ListUserRolesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserRolesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserRolesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.userRoles && message.userRoles.length))
                    message.userRoles = [];
                  message.userRoles.push(
                    $root.stronachgroup.first.racehorse360.UserRole.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserRolesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserRolesResponse} ListUserRolesResponse
           */
          ListUserRolesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUserRolesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserRolesResponse();
            if (object.userRoles) {
              if (!Array.isArray(object.userRoles))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRolesResponse.userRoles: array expected"
                );
              message.userRoles = [];
              for (var i = 0; i < object.userRoles.length; ++i) {
                if (typeof object.userRoles[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListUserRolesResponse.userRoles: object expected"
                  );
                message.userRoles[i] =
                  $root.stronachgroup.first.racehorse360.UserRole.fromObject(
                    object.userRoles[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRolesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserRolesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserRolesResponse} message ListUserRolesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserRolesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.userRoles = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.userRoles && message.userRoles.length) {
              object.userRoles = [];
              for (var j = 0; j < message.userRoles.length; ++j)
                object.userRoles[j] =
                  $root.stronachgroup.first.racehorse360.UserRole.toObject(
                    message.userRoles[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserRolesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserRolesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserRolesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserRolesResponse;
        })();

        racehorse360.UserRoleRequest = (function () {
          /**
           * Properties of a UserRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserRoleRequest
           * @property {string|null} [id] UserRoleRequest id
           * @property {stronachgroup.first.racehorse360.IUser|null} [user] UserRoleRequest user
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] UserRoleRequest facility
           * @property {stronachgroup.first.racehorse360.IRole|null} [role] UserRoleRequest role
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] UserRoleRequest trainer
           * @property {string|null} [trainerName] UserRoleRequest trainerName
           * @property {stronachgroup.first.racehorse360.UserRoleRequestStatus|null} [userRoleRequestStatus] UserRoleRequest userRoleRequestStatus
           */

          /**
           * Constructs a new UserRoleRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserRoleRequest.
           * @implements IUserRoleRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserRoleRequest=} [properties] Properties to set
           */
          function UserRoleRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserRoleRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.id = "";

          /**
           * UserRoleRequest user.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} user
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.user = null;

          /**
           * UserRoleRequest facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.facility = null;

          /**
           * UserRoleRequest role.
           * @member {stronachgroup.first.racehorse360.IRole|null|undefined} role
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.role = null;

          /**
           * UserRoleRequest trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.trainer = null;

          /**
           * UserRoleRequest trainerName.
           * @member {string} trainerName
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.trainerName = "";

          /**
           * UserRoleRequest userRoleRequestStatus.
           * @member {stronachgroup.first.racehorse360.UserRoleRequestStatus} userRoleRequestStatus
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           */
          UserRoleRequest.prototype.userRoleRequestStatus = 0;

          /**
           * Creates a new UserRoleRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserRoleRequest} UserRoleRequest instance
           */
          UserRoleRequest.create = function create(properties) {
            return new UserRoleRequest(properties);
          };

          /**
           * Encodes the specified UserRoleRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UserRoleRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleRequest} message UserRoleRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserRoleRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.user != null &&
              Object.hasOwnProperty.call(message, "user")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.user,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.role != null &&
              Object.hasOwnProperty.call(message, "role")
            )
              $root.stronachgroup.first.racehorse360.Role.encode(
                message.role,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.trainerName != null &&
              Object.hasOwnProperty.call(message, "trainerName")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.trainerName);
            if (
              message.userRoleRequestStatus != null &&
              Object.hasOwnProperty.call(message, "userRoleRequestStatus")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.userRoleRequestStatus);
            return writer;
          };

          /**
           * Decodes a UserRoleRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserRoleRequest} UserRoleRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserRoleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UserRoleRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.user =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.role =
                    $root.stronachgroup.first.racehorse360.Role.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.trainerName = reader.string();
                  break;
                case 7:
                  message.userRoleRequestStatus = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserRoleRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserRoleRequest} UserRoleRequest
           */
          UserRoleRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UserRoleRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UserRoleRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.user != null) {
              if (typeof object.user !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequest.user: object expected"
                );
              message.user =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.user
                );
            }
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequest.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.role != null) {
              if (typeof object.role !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequest.role: object expected"
                );
              message.role =
                $root.stronachgroup.first.racehorse360.Role.fromObject(
                  object.role
                );
            }
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequest.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.trainerName != null)
              message.trainerName = String(object.trainerName);
            switch (object.userRoleRequestStatus) {
              case "USER_ROLE_REQUEST_STATUS_INVALID":
              case 0:
                message.userRoleRequestStatus = 0;
                break;
              case "USER_ROLE_REQUEST_STATUS_REQUESTED":
              case 1:
                message.userRoleRequestStatus = 1;
                break;
              case "USER_ROLE_REQUEST_STATUS_APPROVED":
              case 2:
                message.userRoleRequestStatus = 2;
                break;
              case "USER_ROLE_REQUEST_STATUS_REJECTED":
              case 3:
                message.userRoleRequestStatus = 3;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a UserRoleRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UserRoleRequest} message UserRoleRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserRoleRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.user = null;
              object.facility = null;
              object.role = null;
              object.trainer = null;
              object.trainerName = "";
              object.userRoleRequestStatus =
                options.enums === String
                  ? "USER_ROLE_REQUEST_STATUS_INVALID"
                  : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.user != null && message.hasOwnProperty("user"))
              object.user =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.user,
                  options
                );
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.role != null && message.hasOwnProperty("role"))
              object.role =
                $root.stronachgroup.first.racehorse360.Role.toObject(
                  message.role,
                  options
                );
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (
              message.trainerName != null &&
              message.hasOwnProperty("trainerName")
            )
              object.trainerName = message.trainerName;
            if (
              message.userRoleRequestStatus != null &&
              message.hasOwnProperty("userRoleRequestStatus")
            )
              object.userRoleRequestStatus =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .UserRoleRequestStatus[message.userRoleRequestStatus]
                  : message.userRoleRequestStatus;
            return object;
          };

          /**
           * Converts this UserRoleRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserRoleRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserRoleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserRoleRequest;
        })();

        racehorse360.CreateUserRoleRequestRequest = (function () {
          /**
           * Properties of a CreateUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateUserRoleRequestRequest
           * @property {string|null} [userId] CreateUserRoleRequestRequest userId
           * @property {string|null} [roleId] CreateUserRoleRequestRequest roleId
           * @property {string|null} [facilityId] CreateUserRoleRequestRequest facilityId
           * @property {string|null} [trainerName] CreateUserRoleRequestRequest trainerName
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateUserRoleRequestRequest getOptions
           */

          /**
           * Constructs a new CreateUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateUserRoleRequestRequest.
           * @implements ICreateUserRoleRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateUserRoleRequestRequest=} [properties] Properties to set
           */
          function CreateUserRoleRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateUserRoleRequestRequest userId.
           * @member {string} userId
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           */
          CreateUserRoleRequestRequest.prototype.userId = "";

          /**
           * CreateUserRoleRequestRequest roleId.
           * @member {string} roleId
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           */
          CreateUserRoleRequestRequest.prototype.roleId = "";

          /**
           * CreateUserRoleRequestRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           */
          CreateUserRoleRequestRequest.prototype.facilityId = "";

          /**
           * CreateUserRoleRequestRequest trainerName.
           * @member {string} trainerName
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           */
          CreateUserRoleRequestRequest.prototype.trainerName = "";

          /**
           * CreateUserRoleRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           */
          CreateUserRoleRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateUserRoleRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateUserRoleRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} CreateUserRoleRequestRequest instance
           */
          CreateUserRoleRequestRequest.create = function create(properties) {
            return new CreateUserRoleRequestRequest(properties);
          };

          /**
           * Encodes the specified CreateUserRoleRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateUserRoleRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateUserRoleRequestRequest} message CreateUserRoleRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateUserRoleRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.userId != null &&
              Object.hasOwnProperty.call(message, "userId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.userId);
            if (
              message.roleId != null &&
              Object.hasOwnProperty.call(message, "roleId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.roleId);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.facilityId);
            if (
              message.trainerName != null &&
              Object.hasOwnProperty.call(message, "trainerName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.trainerName);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateUserRoleRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} CreateUserRoleRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateUserRoleRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.userId = reader.string();
                  break;
                case 2:
                  message.roleId = reader.string();
                  break;
                case 3:
                  message.facilityId = reader.string();
                  break;
                case 4:
                  message.trainerName = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateUserRoleRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} CreateUserRoleRequestRequest
           */
          CreateUserRoleRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateUserRoleRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest();
            if (object.userId != null) message.userId = String(object.userId);
            if (object.roleId != null) message.roleId = String(object.roleId);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.trainerName != null)
              message.trainerName = String(object.trainerName);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateUserRoleRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateUserRoleRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateUserRoleRequestRequest} message CreateUserRoleRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateUserRoleRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.userId = "";
              object.roleId = "";
              object.facilityId = "";
              object.trainerName = "";
              object.getOptions = null;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
              object.userId = message.userId;
            if (message.roleId != null && message.hasOwnProperty("roleId"))
              object.roleId = message.roleId;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.trainerName != null &&
              message.hasOwnProperty("trainerName")
            )
              object.trainerName = message.trainerName;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateUserRoleRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateUserRoleRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateUserRoleRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateUserRoleRequestRequest;
        })();

        racehorse360.DeleteUserRoleRequestRequest = (function () {
          /**
           * Properties of a DeleteUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteUserRoleRequestRequest
           * @property {string|null} [id] DeleteUserRoleRequestRequest id
           */

          /**
           * Constructs a new DeleteUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteUserRoleRequestRequest.
           * @implements IDeleteUserRoleRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteUserRoleRequestRequest=} [properties] Properties to set
           */
          function DeleteUserRoleRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteUserRoleRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @instance
           */
          DeleteUserRoleRequestRequest.prototype.id = "";

          /**
           * Creates a new DeleteUserRoleRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteUserRoleRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} DeleteUserRoleRequestRequest instance
           */
          DeleteUserRoleRequestRequest.create = function create(properties) {
            return new DeleteUserRoleRequestRequest(properties);
          };

          /**
           * Encodes the specified DeleteUserRoleRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteUserRoleRequestRequest} message DeleteUserRoleRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteUserRoleRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteUserRoleRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} DeleteUserRoleRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteUserRoleRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteUserRoleRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} DeleteUserRoleRequestRequest
           */
          DeleteUserRoleRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteUserRoleRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteUserRoleRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest} message DeleteUserRoleRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteUserRoleRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteUserRoleRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteUserRoleRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteUserRoleRequestRequest;
        })();

        racehorse360.UserRoleRequestFilter = (function () {
          /**
           * Properties of a UserRoleRequestFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUserRoleRequestFilter
           * @property {Array.<string>|null} [ids] UserRoleRequestFilter ids
           * @property {Array.<string>|null} [userIds] UserRoleRequestFilter userIds
           * @property {string|null} [userInfo] UserRoleRequestFilter userInfo
           * @property {Array.<stronachgroup.first.racehorse360.UserRoleRequestStatus>|null} [userRoleRequestStatuses] UserRoleRequestFilter userRoleRequestStatuses
           */

          /**
           * Constructs a new UserRoleRequestFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserRoleRequestFilter.
           * @implements IUserRoleRequestFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUserRoleRequestFilter=} [properties] Properties to set
           */
          function UserRoleRequestFilter(properties) {
            this.ids = [];
            this.userIds = [];
            this.userRoleRequestStatuses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserRoleRequestFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @instance
           */
          UserRoleRequestFilter.prototype.ids = $util.emptyArray;

          /**
           * UserRoleRequestFilter userIds.
           * @member {Array.<string>} userIds
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @instance
           */
          UserRoleRequestFilter.prototype.userIds = $util.emptyArray;

          /**
           * UserRoleRequestFilter userInfo.
           * @member {string} userInfo
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @instance
           */
          UserRoleRequestFilter.prototype.userInfo = "";

          /**
           * UserRoleRequestFilter userRoleRequestStatuses.
           * @member {Array.<stronachgroup.first.racehorse360.UserRoleRequestStatus>} userRoleRequestStatuses
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @instance
           */
          UserRoleRequestFilter.prototype.userRoleRequestStatuses =
            $util.emptyArray;

          /**
           * Creates a new UserRoleRequestFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleRequestFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UserRoleRequestFilter} UserRoleRequestFilter instance
           */
          UserRoleRequestFilter.create = function create(properties) {
            return new UserRoleRequestFilter(properties);
          };

          /**
           * Encodes the specified UserRoleRequestFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.UserRoleRequestFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IUserRoleRequestFilter} message UserRoleRequestFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserRoleRequestFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.userIds != null && message.userIds.length)
              for (var i = 0; i < message.userIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.userIds[i]);
            if (
              message.userInfo != null &&
              Object.hasOwnProperty.call(message, "userInfo")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.userInfo);
            if (
              message.userRoleRequestStatuses != null &&
              message.userRoleRequestStatuses.length
            ) {
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
              for (var i = 0; i < message.userRoleRequestStatuses.length; ++i)
                writer.int32(message.userRoleRequestStatuses[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes a UserRoleRequestFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UserRoleRequestFilter} UserRoleRequestFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserRoleRequestFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UserRoleRequestFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.userIds && message.userIds.length))
                    message.userIds = [];
                  message.userIds.push(reader.string());
                  break;
                case 3:
                  message.userInfo = reader.string();
                  break;
                case 4:
                  if (
                    !(
                      message.userRoleRequestStatuses &&
                      message.userRoleRequestStatuses.length
                    )
                  )
                    message.userRoleRequestStatuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.userRoleRequestStatuses.push(reader.int32());
                  } else message.userRoleRequestStatuses.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserRoleRequestFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UserRoleRequestFilter} UserRoleRequestFilter
           */
          UserRoleRequestFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UserRoleRequestFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UserRoleRequestFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequestFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.userIds) {
              if (!Array.isArray(object.userIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequestFilter.userIds: array expected"
                );
              message.userIds = [];
              for (var i = 0; i < object.userIds.length; ++i)
                message.userIds[i] = String(object.userIds[i]);
            }
            if (object.userInfo != null)
              message.userInfo = String(object.userInfo);
            if (object.userRoleRequestStatuses) {
              if (!Array.isArray(object.userRoleRequestStatuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UserRoleRequestFilter.userRoleRequestStatuses: array expected"
                );
              message.userRoleRequestStatuses = [];
              for (var i = 0; i < object.userRoleRequestStatuses.length; ++i)
                switch (object.userRoleRequestStatuses[i]) {
                  default:
                  case "USER_ROLE_REQUEST_STATUS_INVALID":
                  case 0:
                    message.userRoleRequestStatuses[i] = 0;
                    break;
                  case "USER_ROLE_REQUEST_STATUS_REQUESTED":
                  case 1:
                    message.userRoleRequestStatuses[i] = 1;
                    break;
                  case "USER_ROLE_REQUEST_STATUS_APPROVED":
                  case 2:
                    message.userRoleRequestStatuses[i] = 2;
                    break;
                  case "USER_ROLE_REQUEST_STATUS_REJECTED":
                  case 3:
                    message.userRoleRequestStatuses[i] = 3;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from a UserRoleRequestFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.UserRoleRequestFilter} message UserRoleRequestFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserRoleRequestFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.userIds = [];
              object.userRoleRequestStatuses = [];
            }
            if (options.defaults) object.userInfo = "";
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.userIds && message.userIds.length) {
              object.userIds = [];
              for (var j = 0; j < message.userIds.length; ++j)
                object.userIds[j] = message.userIds[j];
            }
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
              object.userInfo = message.userInfo;
            if (
              message.userRoleRequestStatuses &&
              message.userRoleRequestStatuses.length
            ) {
              object.userRoleRequestStatuses = [];
              for (var j = 0; j < message.userRoleRequestStatuses.length; ++j)
                object.userRoleRequestStatuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .UserRoleRequestStatus[
                        message.userRoleRequestStatuses[j]
                      ]
                    : message.userRoleRequestStatuses[j];
            }
            return object;
          };

          /**
           * Converts this UserRoleRequestFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UserRoleRequestFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserRoleRequestFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserRoleRequestFilter;
        })();

        racehorse360.ListUserRoleRequestsRequest = (function () {
          /**
           * Properties of a ListUserRoleRequestsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserRoleRequestsRequest
           * @property {stronachgroup.first.racehorse360.IUserRoleRequestFilter|null} [query] ListUserRoleRequestsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListUserRoleRequestsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListUserRoleRequestsRequest pagingOptions
           */

          /**
           * Constructs a new ListUserRoleRequestsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserRoleRequestsRequest.
           * @implements IListUserRoleRequestsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsRequest=} [properties] Properties to set
           */
          function ListUserRoleRequestsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserRoleRequestsRequest query.
           * @member {stronachgroup.first.racehorse360.IUserRoleRequestFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @instance
           */
          ListUserRoleRequestsRequest.prototype.query = null;

          /**
           * ListUserRoleRequestsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @instance
           */
          ListUserRoleRequestsRequest.prototype.getOptions = null;

          /**
           * ListUserRoleRequestsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @instance
           */
          ListUserRoleRequestsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListUserRoleRequestsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} ListUserRoleRequestsRequest instance
           */
          ListUserRoleRequestsRequest.create = function create(properties) {
            return new ListUserRoleRequestsRequest(properties);
          };

          /**
           * Encodes the specified ListUserRoleRequestsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserRoleRequestsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsRequest} message ListUserRoleRequestsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserRoleRequestsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.UserRoleRequestFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserRoleRequestsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} ListUserRoleRequestsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserRoleRequestsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.UserRoleRequestFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserRoleRequestsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} ListUserRoleRequestsRequest
           */
          ListUserRoleRequestsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRoleRequestsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.UserRoleRequestFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRoleRequestsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRoleRequestsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserRoleRequestsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserRoleRequestsRequest} message ListUserRoleRequestsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserRoleRequestsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.UserRoleRequestFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserRoleRequestsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserRoleRequestsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserRoleRequestsRequest;
        })();

        racehorse360.ListUserRoleRequestsResponse = (function () {
          /**
           * Properties of a ListUserRoleRequestsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListUserRoleRequestsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUserRoleRequest>|null} [userRoleRequests] ListUserRoleRequestsResponse userRoleRequests
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListUserRoleRequestsResponse pagingInfo
           */

          /**
           * Constructs a new ListUserRoleRequestsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListUserRoleRequestsResponse.
           * @implements IListUserRoleRequestsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsResponse=} [properties] Properties to set
           */
          function ListUserRoleRequestsResponse(properties) {
            this.userRoleRequests = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListUserRoleRequestsResponse userRoleRequests.
           * @member {Array.<stronachgroup.first.racehorse360.IUserRoleRequest>} userRoleRequests
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @instance
           */
          ListUserRoleRequestsResponse.prototype.userRoleRequests =
            $util.emptyArray;

          /**
           * ListUserRoleRequestsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @instance
           */
          ListUserRoleRequestsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListUserRoleRequestsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsResponse} ListUserRoleRequestsResponse instance
           */
          ListUserRoleRequestsResponse.create = function create(properties) {
            return new ListUserRoleRequestsResponse(properties);
          };

          /**
           * Encodes the specified ListUserRoleRequestsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListUserRoleRequestsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsResponse} message ListUserRoleRequestsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListUserRoleRequestsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.userRoleRequests != null &&
              message.userRoleRequests.length
            )
              for (var i = 0; i < message.userRoleRequests.length; ++i)
                $root.stronachgroup.first.racehorse360.UserRoleRequest.encode(
                  message.userRoleRequests[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListUserRoleRequestsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsResponse} ListUserRoleRequestsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListUserRoleRequestsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.userRoleRequests &&
                      message.userRoleRequests.length
                    )
                  )
                    message.userRoleRequests = [];
                  message.userRoleRequests.push(
                    $root.stronachgroup.first.racehorse360.UserRoleRequest.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListUserRoleRequestsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListUserRoleRequestsResponse} ListUserRoleRequestsResponse
           */
          ListUserRoleRequestsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListUserRoleRequestsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse();
            if (object.userRoleRequests) {
              if (!Array.isArray(object.userRoleRequests))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRoleRequestsResponse.userRoleRequests: array expected"
                );
              message.userRoleRequests = [];
              for (var i = 0; i < object.userRoleRequests.length; ++i) {
                if (typeof object.userRoleRequests[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListUserRoleRequestsResponse.userRoleRequests: object expected"
                  );
                message.userRoleRequests[i] =
                  $root.stronachgroup.first.racehorse360.UserRoleRequest.fromObject(
                    object.userRoleRequests[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListUserRoleRequestsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListUserRoleRequestsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListUserRoleRequestsResponse} message ListUserRoleRequestsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListUserRoleRequestsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.userRoleRequests = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.userRoleRequests && message.userRoleRequests.length) {
              object.userRoleRequests = [];
              for (var j = 0; j < message.userRoleRequests.length; ++j)
                object.userRoleRequests[j] =
                  $root.stronachgroup.first.racehorse360.UserRoleRequest.toObject(
                    message.userRoleRequests[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListUserRoleRequestsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListUserRoleRequestsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListUserRoleRequestsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListUserRoleRequestsResponse;
        })();

        racehorse360.RejectUserRoleRequestRequest = (function () {
          /**
           * Properties of a RejectUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRejectUserRoleRequestRequest
           * @property {string|null} [id] RejectUserRoleRequestRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RejectUserRoleRequestRequest getOptions
           */

          /**
           * Constructs a new RejectUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RejectUserRoleRequestRequest.
           * @implements IRejectUserRoleRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRejectUserRoleRequestRequest=} [properties] Properties to set
           */
          function RejectUserRoleRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RejectUserRoleRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @instance
           */
          RejectUserRoleRequestRequest.prototype.id = "";

          /**
           * RejectUserRoleRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @instance
           */
          RejectUserRoleRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new RejectUserRoleRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRejectUserRoleRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} RejectUserRoleRequestRequest instance
           */
          RejectUserRoleRequestRequest.create = function create(properties) {
            return new RejectUserRoleRequestRequest(properties);
          };

          /**
           * Encodes the specified RejectUserRoleRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RejectUserRoleRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRejectUserRoleRequestRequest} message RejectUserRoleRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RejectUserRoleRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RejectUserRoleRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} RejectUserRoleRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RejectUserRoleRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RejectUserRoleRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} RejectUserRoleRequestRequest
           */
          RejectUserRoleRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .RejectUserRoleRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RejectUserRoleRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RejectUserRoleRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RejectUserRoleRequestRequest} message RejectUserRoleRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RejectUserRoleRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this RejectUserRoleRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RejectUserRoleRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RejectUserRoleRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RejectUserRoleRequestRequest;
        })();

        racehorse360.ApproveUserRoleRequestRequest = (function () {
          /**
           * Properties of an ApproveUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IApproveUserRoleRequestRequest
           * @property {string|null} [id] ApproveUserRoleRequestRequest id
           * @property {string|null} [trainerId] ApproveUserRoleRequestRequest trainerId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ApproveUserRoleRequestRequest getOptions
           */

          /**
           * Constructs a new ApproveUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an ApproveUserRoleRequestRequest.
           * @implements IApproveUserRoleRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IApproveUserRoleRequestRequest=} [properties] Properties to set
           */
          function ApproveUserRoleRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ApproveUserRoleRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @instance
           */
          ApproveUserRoleRequestRequest.prototype.id = "";

          /**
           * ApproveUserRoleRequestRequest trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @instance
           */
          ApproveUserRoleRequestRequest.prototype.trainerId = "";

          /**
           * ApproveUserRoleRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @instance
           */
          ApproveUserRoleRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new ApproveUserRoleRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IApproveUserRoleRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} ApproveUserRoleRequestRequest instance
           */
          ApproveUserRoleRequestRequest.create = function create(properties) {
            return new ApproveUserRoleRequestRequest(properties);
          };

          /**
           * Encodes the specified ApproveUserRoleRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IApproveUserRoleRequestRequest} message ApproveUserRoleRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ApproveUserRoleRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.trainerId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an ApproveUserRoleRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} ApproveUserRoleRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ApproveUserRoleRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.trainerId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an ApproveUserRoleRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} ApproveUserRoleRequestRequest
           */
          ApproveUserRoleRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ApproveUserRoleRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an ApproveUserRoleRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest} message ApproveUserRoleRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ApproveUserRoleRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.trainerId = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ApproveUserRoleRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ApproveUserRoleRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ApproveUserRoleRequestRequest;
        })();

        racehorse360.GetUserRoleRequestRequest = (function () {
          /**
           * Properties of a GetUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetUserRoleRequestRequest
           * @property {string|null} [id] GetUserRoleRequestRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetUserRoleRequestRequest getOptions
           */

          /**
           * Constructs a new GetUserRoleRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetUserRoleRequestRequest.
           * @implements IGetUserRoleRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetUserRoleRequestRequest=} [properties] Properties to set
           */
          function GetUserRoleRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUserRoleRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @instance
           */
          GetUserRoleRequestRequest.prototype.id = "";

          /**
           * GetUserRoleRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @instance
           */
          GetUserRoleRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new GetUserRoleRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUserRoleRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetUserRoleRequestRequest} GetUserRoleRequestRequest instance
           */
          GetUserRoleRequestRequest.create = function create(properties) {
            return new GetUserRoleRequestRequest(properties);
          };

          /**
           * Encodes the specified GetUserRoleRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetUserRoleRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetUserRoleRequestRequest} message GetUserRoleRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserRoleRequestRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetUserRoleRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetUserRoleRequestRequest} GetUserRoleRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserRoleRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetUserRoleRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserRoleRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetUserRoleRequestRequest} GetUserRoleRequestRequest
           */
          GetUserRoleRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetUserRoleRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetUserRoleRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetUserRoleRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetUserRoleRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetUserRoleRequestRequest} message GetUserRoleRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserRoleRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetUserRoleRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetUserRoleRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserRoleRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUserRoleRequestRequest;
        })();

        racehorse360.WorkOrderType = (function () {
          /**
           * Properties of a WorkOrderType.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrderType
           * @property {string|null} [id] WorkOrderType id
           * @property {string|null} [name] WorkOrderType name
           */

          /**
           * Constructs a new WorkOrderType.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderType.
           * @implements IWorkOrderType
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrderType=} [properties] Properties to set
           */
          function WorkOrderType(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkOrderType id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @instance
           */
          WorkOrderType.prototype.id = "";

          /**
           * WorkOrderType name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @instance
           */
          WorkOrderType.prototype.name = "";

          /**
           * Creates a new WorkOrderType instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderType=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrderType} WorkOrderType instance
           */
          WorkOrderType.create = function create(properties) {
            return new WorkOrderType(properties);
          };

          /**
           * Encodes the specified WorkOrderType message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrderType.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderType} message WorkOrderType message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrderType.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            return writer;
          };

          /**
           * Decodes a WorkOrderType message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrderType} WorkOrderType
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrderType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkOrderType();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrderType message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrderType} WorkOrderType
           */
          WorkOrderType.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkOrderType
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkOrderType();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            return message;
          };

          /**
           * Creates a plain object from a WorkOrderType message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrderType} message WorkOrderType
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrderType.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            return object;
          };

          /**
           * Converts this WorkOrderType to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrderType
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrderType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrderType;
        })();

        racehorse360.ListWorkOrderTypesRequest = (function () {
          /**
           * Properties of a ListWorkOrderTypesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrderTypesRequest
           * @property {stronachgroup.first.racehorse360.IWorkOrderTypeFilter|null} [query] ListWorkOrderTypesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkOrderTypesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkOrderTypesRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkOrderTypesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrderTypesRequest.
           * @implements IListWorkOrderTypesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesRequest=} [properties] Properties to set
           */
          function ListWorkOrderTypesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrderTypesRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkOrderTypeFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @instance
           */
          ListWorkOrderTypesRequest.prototype.query = null;

          /**
           * ListWorkOrderTypesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @instance
           */
          ListWorkOrderTypesRequest.prototype.getOptions = null;

          /**
           * ListWorkOrderTypesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @instance
           */
          ListWorkOrderTypesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkOrderTypesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} ListWorkOrderTypesRequest instance
           */
          ListWorkOrderTypesRequest.create = function create(properties) {
            return new ListWorkOrderTypesRequest(properties);
          };

          /**
           * Encodes the specified ListWorkOrderTypesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrderTypesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesRequest} message ListWorkOrderTypesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrderTypesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrderTypesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} ListWorkOrderTypesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrderTypesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrderTypesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} ListWorkOrderTypesRequest
           */
          ListWorkOrderTypesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderTypesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderTypesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderTypesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrderTypesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrderTypesRequest} message ListWorkOrderTypesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrderTypesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrderTypesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrderTypesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrderTypesRequest;
        })();

        racehorse360.ListWorkOrderTypesResponse = (function () {
          /**
           * Properties of a ListWorkOrderTypesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrderTypesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkOrderType>|null} [workOrderTypes] ListWorkOrderTypesResponse workOrderTypes
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkOrderTypesResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkOrderTypesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrderTypesResponse.
           * @implements IListWorkOrderTypesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesResponse=} [properties] Properties to set
           */
          function ListWorkOrderTypesResponse(properties) {
            this.workOrderTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrderTypesResponse workOrderTypes.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkOrderType>} workOrderTypes
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @instance
           */
          ListWorkOrderTypesResponse.prototype.workOrderTypes =
            $util.emptyArray;

          /**
           * ListWorkOrderTypesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @instance
           */
          ListWorkOrderTypesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkOrderTypesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesResponse} ListWorkOrderTypesResponse instance
           */
          ListWorkOrderTypesResponse.create = function create(properties) {
            return new ListWorkOrderTypesResponse(properties);
          };

          /**
           * Encodes the specified ListWorkOrderTypesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrderTypesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesResponse} message ListWorkOrderTypesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrderTypesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.workOrderTypes != null && message.workOrderTypes.length)
              for (var i = 0; i < message.workOrderTypes.length; ++i)
                $root.stronachgroup.first.racehorse360.WorkOrderType.encode(
                  message.workOrderTypes[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrderTypesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesResponse} ListWorkOrderTypesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrderTypesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.workOrderTypes && message.workOrderTypes.length)
                  )
                    message.workOrderTypes = [];
                  message.workOrderTypes.push(
                    $root.stronachgroup.first.racehorse360.WorkOrderType.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrderTypesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderTypesResponse} ListWorkOrderTypesResponse
           */
          ListWorkOrderTypesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse();
            if (object.workOrderTypes) {
              if (!Array.isArray(object.workOrderTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderTypesResponse.workOrderTypes: array expected"
                );
              message.workOrderTypes = [];
              for (var i = 0; i < object.workOrderTypes.length; ++i) {
                if (typeof object.workOrderTypes[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkOrderTypesResponse.workOrderTypes: object expected"
                  );
                message.workOrderTypes[i] =
                  $root.stronachgroup.first.racehorse360.WorkOrderType.fromObject(
                    object.workOrderTypes[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderTypesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrderTypesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrderTypesResponse} message ListWorkOrderTypesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrderTypesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.workOrderTypes = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.workOrderTypes && message.workOrderTypes.length) {
              object.workOrderTypes = [];
              for (var j = 0; j < message.workOrderTypes.length; ++j)
                object.workOrderTypes[j] =
                  $root.stronachgroup.first.racehorse360.WorkOrderType.toObject(
                    message.workOrderTypes[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrderTypesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderTypesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrderTypesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrderTypesResponse;
        })();

        racehorse360.WorkOrderTypeFilter = (function () {
          /**
           * Properties of a WorkOrderTypeFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrderTypeFilter
           */

          /**
           * Constructs a new WorkOrderTypeFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderTypeFilter.
           * @implements IWorkOrderTypeFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrderTypeFilter=} [properties] Properties to set
           */
          function WorkOrderTypeFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new WorkOrderTypeFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderTypeFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrderTypeFilter} WorkOrderTypeFilter instance
           */
          WorkOrderTypeFilter.create = function create(properties) {
            return new WorkOrderTypeFilter(properties);
          };

          /**
           * Encodes the specified WorkOrderTypeFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrderTypeFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderTypeFilter} message WorkOrderTypeFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrderTypeFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a WorkOrderTypeFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrderTypeFilter} WorkOrderTypeFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrderTypeFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrderTypeFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrderTypeFilter} WorkOrderTypeFilter
           */
          WorkOrderTypeFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter
            )
              return object;
            return new $root.stronachgroup.first.racehorse360.WorkOrderTypeFilter();
          };

          /**
           * Creates a plain object from a WorkOrderTypeFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrderTypeFilter} message WorkOrderTypeFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrderTypeFilter.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this WorkOrderTypeFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrderTypeFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrderTypeFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrderTypeFilter;
        })();

        racehorse360.WorkOrder = (function () {
          /**
           * Properties of a WorkOrder.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrder
           * @property {string|null} [id] WorkOrder id
           * @property {number|null} [customerFacingId] WorkOrder customerFacingId
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] WorkOrder createdBy
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] WorkOrder facility
           * @property {string|null} [createdOn] WorkOrder createdOn
           * @property {string|null} [closedOn] WorkOrder closedOn
           * @property {stronachgroup.first.racehorse360.IWorkOrderType|null} [workOrderType] WorkOrder workOrderType
           * @property {string|null} [description] WorkOrder description
           * @property {stronachgroup.first.racehorse360.IBarn|null} [barn] WorkOrder barn
           * @property {string|null} [stallNumber] WorkOrder stallNumber
           * @property {string|null} [fullName] WorkOrder fullName
           * @property {string|null} [phone] WorkOrder phone
           * @property {string|null} [email] WorkOrder email
           * @property {stronachgroup.first.racehorse360.WorkOrderStatus|null} [status] WorkOrder status
           * @property {stronachgroup.first.racehorse360.IUser|null} [assignedUser] WorkOrder assignedUser
           * @property {string|null} [assignedOn] WorkOrder assignedOn
           * @property {stronachgroup.first.racehorse360.WorkOrderReasonToClose|null} [reasonToClose] WorkOrder reasonToClose
           * @property {string|null} [completedOn] WorkOrder completedOn
           * @property {string|null} [canceledOn] WorkOrder canceledOn
           * @property {string|null} [statusUpdatedOn] WorkOrder statusUpdatedOn
           * @property {number|null} [minutesOpen] WorkOrder minutesOpen
           * @property {number|null} [minutesAssigned] WorkOrder minutesAssigned
           */

          /**
           * Constructs a new WorkOrder.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrder.
           * @implements IWorkOrder
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrder=} [properties] Properties to set
           */
          function WorkOrder(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkOrder id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.id = "";

          /**
           * WorkOrder customerFacingId.
           * @member {number} customerFacingId
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.customerFacingId = 0;

          /**
           * WorkOrder createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.createdBy = null;

          /**
           * WorkOrder facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.facility = null;

          /**
           * WorkOrder createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.createdOn = "";

          /**
           * WorkOrder closedOn.
           * @member {string} closedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.closedOn = "";

          /**
           * WorkOrder workOrderType.
           * @member {stronachgroup.first.racehorse360.IWorkOrderType|null|undefined} workOrderType
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.workOrderType = null;

          /**
           * WorkOrder description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.description = "";

          /**
           * WorkOrder barn.
           * @member {stronachgroup.first.racehorse360.IBarn|null|undefined} barn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.barn = null;

          /**
           * WorkOrder stallNumber.
           * @member {string} stallNumber
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.stallNumber = "";

          /**
           * WorkOrder fullName.
           * @member {string} fullName
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.fullName = "";

          /**
           * WorkOrder phone.
           * @member {string} phone
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.phone = "";

          /**
           * WorkOrder email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.email = "";

          /**
           * WorkOrder status.
           * @member {stronachgroup.first.racehorse360.WorkOrderStatus} status
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.status = 0;

          /**
           * WorkOrder assignedUser.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} assignedUser
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.assignedUser = null;

          /**
           * WorkOrder assignedOn.
           * @member {string} assignedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.assignedOn = "";

          /**
           * WorkOrder reasonToClose.
           * @member {stronachgroup.first.racehorse360.WorkOrderReasonToClose} reasonToClose
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.reasonToClose = 0;

          /**
           * WorkOrder completedOn.
           * @member {string} completedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.completedOn = "";

          /**
           * WorkOrder canceledOn.
           * @member {string} canceledOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.canceledOn = "";

          /**
           * WorkOrder statusUpdatedOn.
           * @member {string} statusUpdatedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.statusUpdatedOn = "";

          /**
           * WorkOrder minutesOpen.
           * @member {number} minutesOpen
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.minutesOpen = 0;

          /**
           * WorkOrder minutesAssigned.
           * @member {number} minutesAssigned
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           */
          WorkOrder.prototype.minutesAssigned = 0;

          /**
           * Creates a new WorkOrder instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrder=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrder} WorkOrder instance
           */
          WorkOrder.create = function create(properties) {
            return new WorkOrder(properties);
          };

          /**
           * Encodes the specified WorkOrder message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrder.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrder} message WorkOrder message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrder.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.customerFacingId != null &&
              Object.hasOwnProperty.call(message, "customerFacingId")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.customerFacingId);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.createdOn);
            if (
              message.closedOn != null &&
              Object.hasOwnProperty.call(message, "closedOn")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.closedOn);
            if (
              message.workOrderType != null &&
              Object.hasOwnProperty.call(message, "workOrderType")
            )
              $root.stronachgroup.first.racehorse360.WorkOrderType.encode(
                message.workOrderType,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.description);
            if (
              message.barn != null &&
              Object.hasOwnProperty.call(message, "barn")
            )
              $root.stronachgroup.first.racehorse360.Barn.encode(
                message.barn,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.stallNumber != null &&
              Object.hasOwnProperty.call(message, "stallNumber")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.stallNumber);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.fullName);
            if (
              message.phone != null &&
              Object.hasOwnProperty.call(message, "phone")
            )
              writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.phone);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.email);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 14, wireType 0 =*/ 112).int32(message.status);
            if (
              message.assignedUser != null &&
              Object.hasOwnProperty.call(message, "assignedUser")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.assignedUser,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            if (
              message.assignedOn != null &&
              Object.hasOwnProperty.call(message, "assignedOn")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.assignedOn);
            if (
              message.reasonToClose != null &&
              Object.hasOwnProperty.call(message, "reasonToClose")
            )
              writer
                .uint32(/* id 17, wireType 0 =*/ 136)
                .int32(message.reasonToClose);
            if (
              message.completedOn != null &&
              Object.hasOwnProperty.call(message, "completedOn")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.completedOn);
            if (
              message.canceledOn != null &&
              Object.hasOwnProperty.call(message, "canceledOn")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.canceledOn);
            if (
              message.statusUpdatedOn != null &&
              Object.hasOwnProperty.call(message, "statusUpdatedOn")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.statusUpdatedOn);
            if (
              message.minutesOpen != null &&
              Object.hasOwnProperty.call(message, "minutesOpen")
            )
              writer
                .uint32(/* id 21, wireType 0 =*/ 168)
                .int32(message.minutesOpen);
            if (
              message.minutesAssigned != null &&
              Object.hasOwnProperty.call(message, "minutesAssigned")
            )
              writer
                .uint32(/* id 22, wireType 0 =*/ 176)
                .int32(message.minutesAssigned);
            return writer;
          };

          /**
           * Decodes a WorkOrder message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrder} WorkOrder
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrder.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.WorkOrder();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.customerFacingId = reader.int32();
                  break;
                case 3:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.createdOn = reader.string();
                  break;
                case 6:
                  message.closedOn = reader.string();
                  break;
                case 7:
                  message.workOrderType =
                    $root.stronachgroup.first.racehorse360.WorkOrderType.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.description = reader.string();
                  break;
                case 9:
                  message.barn =
                    $root.stronachgroup.first.racehorse360.Barn.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.stallNumber = reader.string();
                  break;
                case 11:
                  message.fullName = reader.string();
                  break;
                case 12:
                  message.phone = reader.string();
                  break;
                case 13:
                  message.email = reader.string();
                  break;
                case 14:
                  message.status = reader.int32();
                  break;
                case 15:
                  message.assignedUser =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 16:
                  message.assignedOn = reader.string();
                  break;
                case 17:
                  message.reasonToClose = reader.int32();
                  break;
                case 18:
                  message.completedOn = reader.string();
                  break;
                case 19:
                  message.canceledOn = reader.string();
                  break;
                case 20:
                  message.statusUpdatedOn = reader.string();
                  break;
                case 21:
                  message.minutesOpen = reader.int32();
                  break;
                case 22:
                  message.minutesAssigned = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrder message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrder} WorkOrder
           */
          WorkOrder.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.WorkOrder
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkOrder();
            if (object.id != null) message.id = String(object.id);
            if (object.customerFacingId != null)
              message.customerFacingId = object.customerFacingId | 0;
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrder.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrder.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.closedOn != null)
              message.closedOn = String(object.closedOn);
            if (object.workOrderType != null) {
              if (typeof object.workOrderType !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrder.workOrderType: object expected"
                );
              message.workOrderType =
                $root.stronachgroup.first.racehorse360.WorkOrderType.fromObject(
                  object.workOrderType
                );
            }
            if (object.description != null)
              message.description = String(object.description);
            if (object.barn != null) {
              if (typeof object.barn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrder.barn: object expected"
                );
              message.barn =
                $root.stronachgroup.first.racehorse360.Barn.fromObject(
                  object.barn
                );
            }
            if (object.stallNumber != null)
              message.stallNumber = String(object.stallNumber);
            if (object.fullName != null)
              message.fullName = String(object.fullName);
            if (object.phone != null) message.phone = String(object.phone);
            if (object.email != null) message.email = String(object.email);
            switch (object.status) {
              case "WORK_ORDER_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "WORK_ORDER_STATUS_OPEN":
              case 1:
                message.status = 1;
                break;
              case "WORK_ORDER_STATUS_ASSIGNED":
              case 2:
                message.status = 2;
                break;
              case "WORK_ORDER_STATUS_COMPLETE":
              case 3:
                message.status = 3;
                break;
              case "WORK_ORDER_STATUS_CLOSED":
              case 4:
                message.status = 4;
                break;
              case "WORK_ORDER_STATUS_CANCELED":
              case 5:
                message.status = 5;
                break;
            }
            if (object.assignedUser != null) {
              if (typeof object.assignedUser !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrder.assignedUser: object expected"
                );
              message.assignedUser =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.assignedUser
                );
            }
            if (object.assignedOn != null)
              message.assignedOn = String(object.assignedOn);
            switch (object.reasonToClose) {
              case "WORK_ORDER_REASON_TO_CLOSE_INVALID":
              case 0:
                message.reasonToClose = 0;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_WORK_COMPLETED":
              case 1:
                message.reasonToClose = 1;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_DUPLICATE_WORK_ORDER":
              case 2:
                message.reasonToClose = 2;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_WILL_NOT_FIX_NON_ISSUE":
              case 3:
                message.reasonToClose = 3;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_OTHER":
              case 4:
                message.reasonToClose = 4;
                break;
            }
            if (object.completedOn != null)
              message.completedOn = String(object.completedOn);
            if (object.canceledOn != null)
              message.canceledOn = String(object.canceledOn);
            if (object.statusUpdatedOn != null)
              message.statusUpdatedOn = String(object.statusUpdatedOn);
            if (object.minutesOpen != null)
              message.minutesOpen = object.minutesOpen | 0;
            if (object.minutesAssigned != null)
              message.minutesAssigned = object.minutesAssigned | 0;
            return message;
          };

          /**
           * Creates a plain object from a WorkOrder message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrder} message WorkOrder
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrder.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.customerFacingId = 0;
              object.createdBy = null;
              object.facility = null;
              object.createdOn = "";
              object.closedOn = "";
              object.workOrderType = null;
              object.description = "";
              object.barn = null;
              object.stallNumber = "";
              object.fullName = "";
              object.phone = "";
              object.email = "";
              object.status =
                options.enums === String ? "WORK_ORDER_STATUS_INVALID" : 0;
              object.assignedUser = null;
              object.assignedOn = "";
              object.reasonToClose =
                options.enums === String
                  ? "WORK_ORDER_REASON_TO_CLOSE_INVALID"
                  : 0;
              object.completedOn = "";
              object.canceledOn = "";
              object.statusUpdatedOn = "";
              object.minutesOpen = 0;
              object.minutesAssigned = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.customerFacingId != null &&
              message.hasOwnProperty("customerFacingId")
            )
              object.customerFacingId = message.customerFacingId;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (message.closedOn != null && message.hasOwnProperty("closedOn"))
              object.closedOn = message.closedOn;
            if (
              message.workOrderType != null &&
              message.hasOwnProperty("workOrderType")
            )
              object.workOrderType =
                $root.stronachgroup.first.racehorse360.WorkOrderType.toObject(
                  message.workOrderType,
                  options
                );
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.barn != null && message.hasOwnProperty("barn"))
              object.barn =
                $root.stronachgroup.first.racehorse360.Barn.toObject(
                  message.barn,
                  options
                );
            if (
              message.stallNumber != null &&
              message.hasOwnProperty("stallNumber")
            )
              object.stallNumber = message.stallNumber;
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName = message.fullName;
            if (message.phone != null && message.hasOwnProperty("phone"))
              object.phone = message.phone;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkOrderStatus[
                      message.status
                    ]
                  : message.status;
            if (
              message.assignedUser != null &&
              message.hasOwnProperty("assignedUser")
            )
              object.assignedUser =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.assignedUser,
                  options
                );
            if (
              message.assignedOn != null &&
              message.hasOwnProperty("assignedOn")
            )
              object.assignedOn = message.assignedOn;
            if (
              message.reasonToClose != null &&
              message.hasOwnProperty("reasonToClose")
            )
              object.reasonToClose =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .WorkOrderReasonToClose[message.reasonToClose]
                  : message.reasonToClose;
            if (
              message.completedOn != null &&
              message.hasOwnProperty("completedOn")
            )
              object.completedOn = message.completedOn;
            if (
              message.canceledOn != null &&
              message.hasOwnProperty("canceledOn")
            )
              object.canceledOn = message.canceledOn;
            if (
              message.statusUpdatedOn != null &&
              message.hasOwnProperty("statusUpdatedOn")
            )
              object.statusUpdatedOn = message.statusUpdatedOn;
            if (
              message.minutesOpen != null &&
              message.hasOwnProperty("minutesOpen")
            )
              object.minutesOpen = message.minutesOpen;
            if (
              message.minutesAssigned != null &&
              message.hasOwnProperty("minutesAssigned")
            )
              object.minutesAssigned = message.minutesAssigned;
            return object;
          };

          /**
           * Converts this WorkOrder to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrder
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrder;
        })();

        racehorse360.WorkOrderFilter = (function () {
          /**
           * Properties of a WorkOrderFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrderFilter
           * @property {google.protobuf.IStringValue|null} [createdById] WorkOrderFilter createdById
           * @property {google.protobuf.IStringValue|null} [facilityId] WorkOrderFilter facilityId
           * @property {Array.<stronachgroup.first.racehorse360.WorkOrderStatus>|null} [workOrderStatuses] WorkOrderFilter workOrderStatuses
           * @property {Array.<string>|null} [assignedUserIds] WorkOrderFilter assignedUserIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [createdOn] WorkOrderFilter createdOn
           * @property {Array.<string>|null} [workOrderTypeIds] WorkOrderFilter workOrderTypeIds
           * @property {Array.<string>|null} [createdByIds] WorkOrderFilter createdByIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [assignedOn] WorkOrderFilter assignedOn
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [completedOn] WorkOrderFilter completedOn
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [canceledOn] WorkOrderFilter canceledOn
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [closedOn] WorkOrderFilter closedOn
           * @property {google.protobuf.IInt32Value|null} [minutesOpenFrom] WorkOrderFilter minutesOpenFrom
           * @property {google.protobuf.IInt32Value|null} [minutesOpenTo] WorkOrderFilter minutesOpenTo
           * @property {google.protobuf.IInt32Value|null} [minutesAssignedFrom] WorkOrderFilter minutesAssignedFrom
           * @property {google.protobuf.IInt32Value|null} [minutesAssignedTo] WorkOrderFilter minutesAssignedTo
           */

          /**
           * Constructs a new WorkOrderFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderFilter.
           * @implements IWorkOrderFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrderFilter=} [properties] Properties to set
           */
          function WorkOrderFilter(properties) {
            this.workOrderStatuses = [];
            this.assignedUserIds = [];
            this.workOrderTypeIds = [];
            this.createdByIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkOrderFilter createdById.
           * @member {google.protobuf.IStringValue|null|undefined} createdById
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.createdById = null;

          /**
           * WorkOrderFilter facilityId.
           * @member {google.protobuf.IStringValue|null|undefined} facilityId
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.facilityId = null;

          /**
           * WorkOrderFilter workOrderStatuses.
           * @member {Array.<stronachgroup.first.racehorse360.WorkOrderStatus>} workOrderStatuses
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.workOrderStatuses = $util.emptyArray;

          /**
           * WorkOrderFilter assignedUserIds.
           * @member {Array.<string>} assignedUserIds
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.assignedUserIds = $util.emptyArray;

          /**
           * WorkOrderFilter createdOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.createdOn = null;

          /**
           * WorkOrderFilter workOrderTypeIds.
           * @member {Array.<string>} workOrderTypeIds
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.workOrderTypeIds = $util.emptyArray;

          /**
           * WorkOrderFilter createdByIds.
           * @member {Array.<string>} createdByIds
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.createdByIds = $util.emptyArray;

          /**
           * WorkOrderFilter assignedOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} assignedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.assignedOn = null;

          /**
           * WorkOrderFilter completedOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} completedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.completedOn = null;

          /**
           * WorkOrderFilter canceledOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} canceledOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.canceledOn = null;

          /**
           * WorkOrderFilter closedOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} closedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.closedOn = null;

          /**
           * WorkOrderFilter minutesOpenFrom.
           * @member {google.protobuf.IInt32Value|null|undefined} minutesOpenFrom
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.minutesOpenFrom = null;

          /**
           * WorkOrderFilter minutesOpenTo.
           * @member {google.protobuf.IInt32Value|null|undefined} minutesOpenTo
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.minutesOpenTo = null;

          /**
           * WorkOrderFilter minutesAssignedFrom.
           * @member {google.protobuf.IInt32Value|null|undefined} minutesAssignedFrom
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.minutesAssignedFrom = null;

          /**
           * WorkOrderFilter minutesAssignedTo.
           * @member {google.protobuf.IInt32Value|null|undefined} minutesAssignedTo
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           */
          WorkOrderFilter.prototype.minutesAssignedTo = null;

          /**
           * Creates a new WorkOrderFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrderFilter} WorkOrderFilter instance
           */
          WorkOrderFilter.create = function create(properties) {
            return new WorkOrderFilter(properties);
          };

          /**
           * Encodes the specified WorkOrderFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrderFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderFilter} message WorkOrderFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrderFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.createdById != null &&
              Object.hasOwnProperty.call(message, "createdById")
            )
              $root.google.protobuf.StringValue.encode(
                message.createdById,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              $root.google.protobuf.StringValue.encode(
                message.facilityId,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.workOrderStatuses != null &&
              message.workOrderStatuses.length
            ) {
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork();
              for (var i = 0; i < message.workOrderStatuses.length; ++i)
                writer.int32(message.workOrderStatuses[i]);
              writer.ldelim();
            }
            if (
              message.assignedUserIds != null &&
              message.assignedUserIds.length
            )
              for (var i = 0; i < message.assignedUserIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.assignedUserIds[i]);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.createdOn,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.workOrderTypeIds != null &&
              message.workOrderTypeIds.length
            )
              for (var i = 0; i < message.workOrderTypeIds.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.workOrderTypeIds[i]);
            if (message.createdByIds != null && message.createdByIds.length)
              for (var i = 0; i < message.createdByIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.createdByIds[i]);
            if (
              message.assignedOn != null &&
              Object.hasOwnProperty.call(message, "assignedOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.assignedOn,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            if (
              message.completedOn != null &&
              Object.hasOwnProperty.call(message, "completedOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.completedOn,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.canceledOn != null &&
              Object.hasOwnProperty.call(message, "canceledOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.canceledOn,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.closedOn != null &&
              Object.hasOwnProperty.call(message, "closedOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.closedOn,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.minutesOpenFrom != null &&
              Object.hasOwnProperty.call(message, "minutesOpenFrom")
            )
              $root.google.protobuf.Int32Value.encode(
                message.minutesOpenFrom,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.minutesOpenTo != null &&
              Object.hasOwnProperty.call(message, "minutesOpenTo")
            )
              $root.google.protobuf.Int32Value.encode(
                message.minutesOpenTo,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.minutesAssignedFrom != null &&
              Object.hasOwnProperty.call(message, "minutesAssignedFrom")
            )
              $root.google.protobuf.Int32Value.encode(
                message.minutesAssignedFrom,
                writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
              ).ldelim();
            if (
              message.minutesAssignedTo != null &&
              Object.hasOwnProperty.call(message, "minutesAssignedTo")
            )
              $root.google.protobuf.Int32Value.encode(
                message.minutesAssignedTo,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkOrderFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrderFilter} WorkOrderFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrderFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkOrderFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.createdById =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.facilityId = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 3:
                  if (
                    !(
                      message.workOrderStatuses &&
                      message.workOrderStatuses.length
                    )
                  )
                    message.workOrderStatuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.workOrderStatuses.push(reader.int32());
                  } else message.workOrderStatuses.push(reader.int32());
                  break;
                case 4:
                  if (
                    !(message.assignedUserIds && message.assignedUserIds.length)
                  )
                    message.assignedUserIds = [];
                  message.assignedUserIds.push(reader.string());
                  break;
                case 5:
                  message.createdOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  if (
                    !(
                      message.workOrderTypeIds &&
                      message.workOrderTypeIds.length
                    )
                  )
                    message.workOrderTypeIds = [];
                  message.workOrderTypeIds.push(reader.string());
                  break;
                case 7:
                  if (!(message.createdByIds && message.createdByIds.length))
                    message.createdByIds = [];
                  message.createdByIds.push(reader.string());
                  break;
                case 8:
                  message.assignedOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 9:
                  message.completedOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.canceledOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.closedOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.minutesOpenFrom =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  message.minutesOpenTo =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.minutesAssignedFrom =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 15:
                  message.minutesAssignedTo =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrderFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrderFilter} WorkOrderFilter
           */
          WorkOrderFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkOrderFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkOrderFilter();
            if (object.createdById != null) {
              if (typeof object.createdById !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.createdById: object expected"
                );
              message.createdById =
                $root.google.protobuf.StringValue.fromObject(
                  object.createdById
                );
            }
            if (object.facilityId != null) {
              if (typeof object.facilityId !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.facilityId: object expected"
                );
              message.facilityId = $root.google.protobuf.StringValue.fromObject(
                object.facilityId
              );
            }
            if (object.workOrderStatuses) {
              if (!Array.isArray(object.workOrderStatuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.workOrderStatuses: array expected"
                );
              message.workOrderStatuses = [];
              for (var i = 0; i < object.workOrderStatuses.length; ++i)
                switch (object.workOrderStatuses[i]) {
                  default:
                  case "WORK_ORDER_STATUS_INVALID":
                  case 0:
                    message.workOrderStatuses[i] = 0;
                    break;
                  case "WORK_ORDER_STATUS_OPEN":
                  case 1:
                    message.workOrderStatuses[i] = 1;
                    break;
                  case "WORK_ORDER_STATUS_ASSIGNED":
                  case 2:
                    message.workOrderStatuses[i] = 2;
                    break;
                  case "WORK_ORDER_STATUS_COMPLETE":
                  case 3:
                    message.workOrderStatuses[i] = 3;
                    break;
                  case "WORK_ORDER_STATUS_CLOSED":
                  case 4:
                    message.workOrderStatuses[i] = 4;
                    break;
                  case "WORK_ORDER_STATUS_CANCELED":
                  case 5:
                    message.workOrderStatuses[i] = 5;
                    break;
                }
            }
            if (object.assignedUserIds) {
              if (!Array.isArray(object.assignedUserIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.assignedUserIds: array expected"
                );
              message.assignedUserIds = [];
              for (var i = 0; i < object.assignedUserIds.length; ++i)
                message.assignedUserIds[i] = String(object.assignedUserIds[i]);
            }
            if (object.createdOn != null) {
              if (typeof object.createdOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.createdOn: object expected"
                );
              message.createdOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.createdOn
                );
            }
            if (object.workOrderTypeIds) {
              if (!Array.isArray(object.workOrderTypeIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.workOrderTypeIds: array expected"
                );
              message.workOrderTypeIds = [];
              for (var i = 0; i < object.workOrderTypeIds.length; ++i)
                message.workOrderTypeIds[i] = String(
                  object.workOrderTypeIds[i]
                );
            }
            if (object.createdByIds) {
              if (!Array.isArray(object.createdByIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.createdByIds: array expected"
                );
              message.createdByIds = [];
              for (var i = 0; i < object.createdByIds.length; ++i)
                message.createdByIds[i] = String(object.createdByIds[i]);
            }
            if (object.assignedOn != null) {
              if (typeof object.assignedOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.assignedOn: object expected"
                );
              message.assignedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.assignedOn
                );
            }
            if (object.completedOn != null) {
              if (typeof object.completedOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.completedOn: object expected"
                );
              message.completedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.completedOn
                );
            }
            if (object.canceledOn != null) {
              if (typeof object.canceledOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.canceledOn: object expected"
                );
              message.canceledOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.canceledOn
                );
            }
            if (object.closedOn != null) {
              if (typeof object.closedOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.closedOn: object expected"
                );
              message.closedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.closedOn
                );
            }
            if (object.minutesOpenFrom != null) {
              if (typeof object.minutesOpenFrom !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.minutesOpenFrom: object expected"
                );
              message.minutesOpenFrom =
                $root.google.protobuf.Int32Value.fromObject(
                  object.minutesOpenFrom
                );
            }
            if (object.minutesOpenTo != null) {
              if (typeof object.minutesOpenTo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.minutesOpenTo: object expected"
                );
              message.minutesOpenTo =
                $root.google.protobuf.Int32Value.fromObject(
                  object.minutesOpenTo
                );
            }
            if (object.minutesAssignedFrom != null) {
              if (typeof object.minutesAssignedFrom !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.minutesAssignedFrom: object expected"
                );
              message.minutesAssignedFrom =
                $root.google.protobuf.Int32Value.fromObject(
                  object.minutesAssignedFrom
                );
            }
            if (object.minutesAssignedTo != null) {
              if (typeof object.minutesAssignedTo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderFilter.minutesAssignedTo: object expected"
                );
              message.minutesAssignedTo =
                $root.google.protobuf.Int32Value.fromObject(
                  object.minutesAssignedTo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkOrderFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrderFilter} message WorkOrderFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrderFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.workOrderStatuses = [];
              object.assignedUserIds = [];
              object.workOrderTypeIds = [];
              object.createdByIds = [];
            }
            if (options.defaults) {
              object.createdById = null;
              object.facilityId = null;
              object.createdOn = null;
              object.assignedOn = null;
              object.completedOn = null;
              object.canceledOn = null;
              object.closedOn = null;
              object.minutesOpenFrom = null;
              object.minutesOpenTo = null;
              object.minutesAssignedFrom = null;
              object.minutesAssignedTo = null;
            }
            if (
              message.createdById != null &&
              message.hasOwnProperty("createdById")
            )
              object.createdById = $root.google.protobuf.StringValue.toObject(
                message.createdById,
                options
              );
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = $root.google.protobuf.StringValue.toObject(
                message.facilityId,
                options
              );
            if (message.workOrderStatuses && message.workOrderStatuses.length) {
              object.workOrderStatuses = [];
              for (var j = 0; j < message.workOrderStatuses.length; ++j)
                object.workOrderStatuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.WorkOrderStatus[
                        message.workOrderStatuses[j]
                      ]
                    : message.workOrderStatuses[j];
            }
            if (message.assignedUserIds && message.assignedUserIds.length) {
              object.assignedUserIds = [];
              for (var j = 0; j < message.assignedUserIds.length; ++j)
                object.assignedUserIds[j] = message.assignedUserIds[j];
            }
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.createdOn,
                  options
                );
            if (message.workOrderTypeIds && message.workOrderTypeIds.length) {
              object.workOrderTypeIds = [];
              for (var j = 0; j < message.workOrderTypeIds.length; ++j)
                object.workOrderTypeIds[j] = message.workOrderTypeIds[j];
            }
            if (message.createdByIds && message.createdByIds.length) {
              object.createdByIds = [];
              for (var j = 0; j < message.createdByIds.length; ++j)
                object.createdByIds[j] = message.createdByIds[j];
            }
            if (
              message.assignedOn != null &&
              message.hasOwnProperty("assignedOn")
            )
              object.assignedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.assignedOn,
                  options
                );
            if (
              message.completedOn != null &&
              message.hasOwnProperty("completedOn")
            )
              object.completedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.completedOn,
                  options
                );
            if (
              message.canceledOn != null &&
              message.hasOwnProperty("canceledOn")
            )
              object.canceledOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.canceledOn,
                  options
                );
            if (message.closedOn != null && message.hasOwnProperty("closedOn"))
              object.closedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.closedOn,
                  options
                );
            if (
              message.minutesOpenFrom != null &&
              message.hasOwnProperty("minutesOpenFrom")
            )
              object.minutesOpenFrom =
                $root.google.protobuf.Int32Value.toObject(
                  message.minutesOpenFrom,
                  options
                );
            if (
              message.minutesOpenTo != null &&
              message.hasOwnProperty("minutesOpenTo")
            )
              object.minutesOpenTo = $root.google.protobuf.Int32Value.toObject(
                message.minutesOpenTo,
                options
              );
            if (
              message.minutesAssignedFrom != null &&
              message.hasOwnProperty("minutesAssignedFrom")
            )
              object.minutesAssignedFrom =
                $root.google.protobuf.Int32Value.toObject(
                  message.minutesAssignedFrom,
                  options
                );
            if (
              message.minutesAssignedTo != null &&
              message.hasOwnProperty("minutesAssignedTo")
            )
              object.minutesAssignedTo =
                $root.google.protobuf.Int32Value.toObject(
                  message.minutesAssignedTo,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkOrderFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrderFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrderFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrderFilter;
        })();

        racehorse360.CreateWorkOrderRequest = (function () {
          /**
           * Properties of a CreateWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateWorkOrderRequest
           * @property {string|null} [facilityId] CreateWorkOrderRequest facilityId
           * @property {string|null} [workOrderTypeId] CreateWorkOrderRequest workOrderTypeId
           * @property {string|null} [description] CreateWorkOrderRequest description
           * @property {string|null} [barnId] CreateWorkOrderRequest barnId
           * @property {string|null} [stallNumber] CreateWorkOrderRequest stallNumber
           * @property {string|null} [fullName] CreateWorkOrderRequest fullName
           * @property {string|null} [phone] CreateWorkOrderRequest phone
           * @property {string|null} [email] CreateWorkOrderRequest email
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateWorkOrderRequest getOptions
           */

          /**
           * Constructs a new CreateWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateWorkOrderRequest.
           * @implements ICreateWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderRequest=} [properties] Properties to set
           */
          function CreateWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateWorkOrderRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.facilityId = "";

          /**
           * CreateWorkOrderRequest workOrderTypeId.
           * @member {string} workOrderTypeId
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.workOrderTypeId = "";

          /**
           * CreateWorkOrderRequest description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.description = "";

          /**
           * CreateWorkOrderRequest barnId.
           * @member {string} barnId
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.barnId = "";

          /**
           * CreateWorkOrderRequest stallNumber.
           * @member {string} stallNumber
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.stallNumber = "";

          /**
           * CreateWorkOrderRequest fullName.
           * @member {string} fullName
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.fullName = "";

          /**
           * CreateWorkOrderRequest phone.
           * @member {string} phone
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.phone = "";

          /**
           * CreateWorkOrderRequest email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.email = "";

          /**
           * CreateWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           */
          CreateWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderRequest} CreateWorkOrderRequest instance
           */
          CreateWorkOrderRequest.create = function create(properties) {
            return new CreateWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified CreateWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderRequest} message CreateWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.workOrderTypeId != null &&
              Object.hasOwnProperty.call(message, "workOrderTypeId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.workOrderTypeId);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.description);
            if (
              message.barnId != null &&
              Object.hasOwnProperty.call(message, "barnId")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.barnId);
            if (
              message.stallNumber != null &&
              Object.hasOwnProperty.call(message, "stallNumber")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.stallNumber);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.fullName);
            if (
              message.phone != null &&
              Object.hasOwnProperty.call(message, "phone")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.phone);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.email);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderRequest} CreateWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.workOrderTypeId = reader.string();
                  break;
                case 3:
                  message.description = reader.string();
                  break;
                case 4:
                  message.barnId = reader.string();
                  break;
                case 5:
                  message.stallNumber = reader.string();
                  break;
                case 6:
                  message.fullName = reader.string();
                  break;
                case 7:
                  message.phone = reader.string();
                  break;
                case 8:
                  message.email = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderRequest} CreateWorkOrderRequest
           */
          CreateWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateWorkOrderRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.workOrderTypeId != null)
              message.workOrderTypeId = String(object.workOrderTypeId);
            if (object.description != null)
              message.description = String(object.description);
            if (object.barnId != null) message.barnId = String(object.barnId);
            if (object.stallNumber != null)
              message.stallNumber = String(object.stallNumber);
            if (object.fullName != null)
              message.fullName = String(object.fullName);
            if (object.phone != null) message.phone = String(object.phone);
            if (object.email != null) message.email = String(object.email);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateWorkOrderRequest} message CreateWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.workOrderTypeId = "";
              object.description = "";
              object.barnId = "";
              object.stallNumber = "";
              object.fullName = "";
              object.phone = "";
              object.email = "";
              object.getOptions = null;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.workOrderTypeId != null &&
              message.hasOwnProperty("workOrderTypeId")
            )
              object.workOrderTypeId = message.workOrderTypeId;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.barnId != null && message.hasOwnProperty("barnId"))
              object.barnId = message.barnId;
            if (
              message.stallNumber != null &&
              message.hasOwnProperty("stallNumber")
            )
              object.stallNumber = message.stallNumber;
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName = message.fullName;
            if (message.phone != null && message.hasOwnProperty("phone"))
              object.phone = message.phone;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateWorkOrderRequest;
        })();

        racehorse360.ListWorkOrdersRequest = (function () {
          /**
           * Properties of a ListWorkOrdersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrdersRequest
           * @property {stronachgroup.first.racehorse360.IWorkOrderFilter|null} [query] ListWorkOrdersRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkOrdersRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkOrdersRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkOrdersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrdersRequest.
           * @implements IListWorkOrdersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersRequest=} [properties] Properties to set
           */
          function ListWorkOrdersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrdersRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkOrderFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @instance
           */
          ListWorkOrdersRequest.prototype.query = null;

          /**
           * ListWorkOrdersRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @instance
           */
          ListWorkOrdersRequest.prototype.getOptions = null;

          /**
           * ListWorkOrdersRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @instance
           */
          ListWorkOrdersRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkOrdersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersRequest} ListWorkOrdersRequest instance
           */
          ListWorkOrdersRequest.create = function create(properties) {
            return new ListWorkOrdersRequest(properties);
          };

          /**
           * Encodes the specified ListWorkOrdersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrdersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersRequest} message ListWorkOrdersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrdersRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkOrderFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrdersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersRequest} ListWorkOrdersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrdersRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrdersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkOrderFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrdersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersRequest} ListWorkOrdersRequest
           */
          ListWorkOrdersRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrdersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrdersRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrdersRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkOrderFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrdersRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrdersRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrdersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrdersRequest} message ListWorkOrdersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrdersRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkOrderFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrdersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrdersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrdersRequest;
        })();

        racehorse360.DeleteWorkOrderRequest = (function () {
          /**
           * Properties of a DeleteWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteWorkOrderRequest
           * @property {string|null} [id] DeleteWorkOrderRequest id
           */

          /**
           * Constructs a new DeleteWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteWorkOrderRequest.
           * @implements IDeleteWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderRequest=} [properties] Properties to set
           */
          function DeleteWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @instance
           */
          DeleteWorkOrderRequest.prototype.id = "";

          /**
           * Creates a new DeleteWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderRequest} DeleteWorkOrderRequest instance
           */
          DeleteWorkOrderRequest.create = function create(properties) {
            return new DeleteWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified DeleteWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderRequest} message DeleteWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderRequest} DeleteWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderRequest} DeleteWorkOrderRequest
           */
          DeleteWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteWorkOrderRequest} message DeleteWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteWorkOrderRequest;
        })();

        racehorse360.ListWorkOrdersResponse = (function () {
          /**
           * Properties of a ListWorkOrdersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrdersResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkOrder>|null} [workOrders] ListWorkOrdersResponse workOrders
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkOrdersResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkOrdersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrdersResponse.
           * @implements IListWorkOrdersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersResponse=} [properties] Properties to set
           */
          function ListWorkOrdersResponse(properties) {
            this.workOrders = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrdersResponse workOrders.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkOrder>} workOrders
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @instance
           */
          ListWorkOrdersResponse.prototype.workOrders = $util.emptyArray;

          /**
           * ListWorkOrdersResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @instance
           */
          ListWorkOrdersResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkOrdersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersResponse} ListWorkOrdersResponse instance
           */
          ListWorkOrdersResponse.create = function create(properties) {
            return new ListWorkOrdersResponse(properties);
          };

          /**
           * Encodes the specified ListWorkOrdersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrdersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersResponse} message ListWorkOrdersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrdersResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.workOrders != null && message.workOrders.length)
              for (var i = 0; i < message.workOrders.length; ++i)
                $root.stronachgroup.first.racehorse360.WorkOrder.encode(
                  message.workOrders[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrdersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersResponse} ListWorkOrdersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrdersResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrdersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.workOrders && message.workOrders.length))
                    message.workOrders = [];
                  message.workOrders.push(
                    $root.stronachgroup.first.racehorse360.WorkOrder.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrdersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrdersResponse} ListWorkOrdersResponse
           */
          ListWorkOrdersResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrdersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrdersResponse();
            if (object.workOrders) {
              if (!Array.isArray(object.workOrders))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrdersResponse.workOrders: array expected"
                );
              message.workOrders = [];
              for (var i = 0; i < object.workOrders.length; ++i) {
                if (typeof object.workOrders[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkOrdersResponse.workOrders: object expected"
                  );
                message.workOrders[i] =
                  $root.stronachgroup.first.racehorse360.WorkOrder.fromObject(
                    object.workOrders[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrdersResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrdersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrdersResponse} message ListWorkOrdersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrdersResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.workOrders = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.workOrders && message.workOrders.length) {
              object.workOrders = [];
              for (var j = 0; j < message.workOrders.length; ++j)
                object.workOrders[j] =
                  $root.stronachgroup.first.racehorse360.WorkOrder.toObject(
                    message.workOrders[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrdersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrdersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrdersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrdersResponse;
        })();

        racehorse360.AssignMaintenanceUserToWorkOrderRequest = (function () {
          /**
           * Properties of an AssignMaintenanceUserToWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IAssignMaintenanceUserToWorkOrderRequest
           * @property {string|null} [id] AssignMaintenanceUserToWorkOrderRequest id
           * @property {google.protobuf.IStringValue|null} [userToAssignId] AssignMaintenanceUserToWorkOrderRequest userToAssignId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] AssignMaintenanceUserToWorkOrderRequest getOptions
           */

          /**
           * Constructs a new AssignMaintenanceUserToWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an AssignMaintenanceUserToWorkOrderRequest.
           * @implements IAssignMaintenanceUserToWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IAssignMaintenanceUserToWorkOrderRequest=} [properties] Properties to set
           */
          function AssignMaintenanceUserToWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AssignMaintenanceUserToWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @instance
           */
          AssignMaintenanceUserToWorkOrderRequest.prototype.id = "";

          /**
           * AssignMaintenanceUserToWorkOrderRequest userToAssignId.
           * @member {google.protobuf.IStringValue|null|undefined} userToAssignId
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @instance
           */
          AssignMaintenanceUserToWorkOrderRequest.prototype.userToAssignId =
            null;

          /**
           * AssignMaintenanceUserToWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @instance
           */
          AssignMaintenanceUserToWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new AssignMaintenanceUserToWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignMaintenanceUserToWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} AssignMaintenanceUserToWorkOrderRequest instance
           */
          AssignMaintenanceUserToWorkOrderRequest.create = function create(
            properties
          ) {
            return new AssignMaintenanceUserToWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified AssignMaintenanceUserToWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IAssignMaintenanceUserToWorkOrderRequest} message AssignMaintenanceUserToWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AssignMaintenanceUserToWorkOrderRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.userToAssignId != null &&
              Object.hasOwnProperty.call(message, "userToAssignId")
            )
              $root.google.protobuf.StringValue.encode(
                message.userToAssignId,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AssignMaintenanceUserToWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} AssignMaintenanceUserToWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AssignMaintenanceUserToWorkOrderRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.userToAssignId =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AssignMaintenanceUserToWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} AssignMaintenanceUserToWorkOrderRequest
           */
          AssignMaintenanceUserToWorkOrderRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .AssignMaintenanceUserToWorkOrderRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.userToAssignId != null) {
                if (typeof object.userToAssignId !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest.userToAssignId: object expected"
                  );
                message.userToAssignId =
                  $root.google.protobuf.StringValue.fromObject(
                    object.userToAssignId
                  );
              }
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from an AssignMaintenanceUserToWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest} message AssignMaintenanceUserToWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AssignMaintenanceUserToWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.userToAssignId = null;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.userToAssignId != null &&
              message.hasOwnProperty("userToAssignId")
            )
              object.userToAssignId =
                $root.google.protobuf.StringValue.toObject(
                  message.userToAssignId,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this AssignMaintenanceUserToWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AssignMaintenanceUserToWorkOrderRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return AssignMaintenanceUserToWorkOrderRequest;
        })();

        racehorse360.CloseWorkOrderRequest = (function () {
          /**
           * Properties of a CloseWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICloseWorkOrderRequest
           * @property {string|null} [id] CloseWorkOrderRequest id
           * @property {google.protobuf.IStringValue|null} [note] CloseWorkOrderRequest note
           * @property {stronachgroup.first.racehorse360.WorkOrderReasonToClose|null} [reasonToClose] CloseWorkOrderRequest reasonToClose
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CloseWorkOrderRequest getOptions
           */

          /**
           * Constructs a new CloseWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CloseWorkOrderRequest.
           * @implements ICloseWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICloseWorkOrderRequest=} [properties] Properties to set
           */
          function CloseWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CloseWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @instance
           */
          CloseWorkOrderRequest.prototype.id = "";

          /**
           * CloseWorkOrderRequest note.
           * @member {google.protobuf.IStringValue|null|undefined} note
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @instance
           */
          CloseWorkOrderRequest.prototype.note = null;

          /**
           * CloseWorkOrderRequest reasonToClose.
           * @member {stronachgroup.first.racehorse360.WorkOrderReasonToClose} reasonToClose
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @instance
           */
          CloseWorkOrderRequest.prototype.reasonToClose = 0;

          /**
           * CloseWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @instance
           */
          CloseWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new CloseWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICloseWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CloseWorkOrderRequest} CloseWorkOrderRequest instance
           */
          CloseWorkOrderRequest.create = function create(properties) {
            return new CloseWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified CloseWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CloseWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICloseWorkOrderRequest} message CloseWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CloseWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              $root.google.protobuf.StringValue.encode(
                message.note,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.reasonToClose != null &&
              Object.hasOwnProperty.call(message, "reasonToClose")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.reasonToClose);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CloseWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CloseWorkOrderRequest} CloseWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CloseWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CloseWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.note = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 3:
                  message.reasonToClose = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CloseWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CloseWorkOrderRequest} CloseWorkOrderRequest
           */
          CloseWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CloseWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CloseWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.note != null) {
              if (typeof object.note !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CloseWorkOrderRequest.note: object expected"
                );
              message.note = $root.google.protobuf.StringValue.fromObject(
                object.note
              );
            }
            switch (object.reasonToClose) {
              case "WORK_ORDER_REASON_TO_CLOSE_INVALID":
              case 0:
                message.reasonToClose = 0;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_WORK_COMPLETED":
              case 1:
                message.reasonToClose = 1;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_DUPLICATE_WORK_ORDER":
              case 2:
                message.reasonToClose = 2;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_WILL_NOT_FIX_NON_ISSUE":
              case 3:
                message.reasonToClose = 3;
                break;
              case "WORK_ORDER_REASON_TO_CLOSE_OTHER":
              case 4:
                message.reasonToClose = 4;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CloseWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CloseWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CloseWorkOrderRequest} message CloseWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CloseWorkOrderRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.note = null;
              object.reasonToClose =
                options.enums === String
                  ? "WORK_ORDER_REASON_TO_CLOSE_INVALID"
                  : 0;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = $root.google.protobuf.StringValue.toObject(
                message.note,
                options
              );
            if (
              message.reasonToClose != null &&
              message.hasOwnProperty("reasonToClose")
            )
              object.reasonToClose =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .WorkOrderReasonToClose[message.reasonToClose]
                  : message.reasonToClose;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CloseWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CloseWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CloseWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CloseWorkOrderRequest;
        })();

        racehorse360.MaintenanceUser = (function () {
          /**
           * Properties of a MaintenanceUser.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMaintenanceUser
           * @property {string|null} [id] MaintenanceUser id
           * @property {string|null} [firstName] MaintenanceUser firstName
           * @property {string|null} [lastName] MaintenanceUser lastName
           * @property {number|null} [workOrderAssignedCount] MaintenanceUser workOrderAssignedCount
           */

          /**
           * Constructs a new MaintenanceUser.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a MaintenanceUser.
           * @implements IMaintenanceUser
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMaintenanceUser=} [properties] Properties to set
           */
          function MaintenanceUser(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * MaintenanceUser id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @instance
           */
          MaintenanceUser.prototype.id = "";

          /**
           * MaintenanceUser firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @instance
           */
          MaintenanceUser.prototype.firstName = "";

          /**
           * MaintenanceUser lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @instance
           */
          MaintenanceUser.prototype.lastName = "";

          /**
           * MaintenanceUser workOrderAssignedCount.
           * @member {number} workOrderAssignedCount
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @instance
           */
          MaintenanceUser.prototype.workOrderAssignedCount = 0;

          /**
           * Creates a new MaintenanceUser instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @static
           * @param {stronachgroup.first.racehorse360.IMaintenanceUser=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.MaintenanceUser} MaintenanceUser instance
           */
          MaintenanceUser.create = function create(properties) {
            return new MaintenanceUser(properties);
          };

          /**
           * Encodes the specified MaintenanceUser message. Does not implicitly {@link stronachgroup.first.racehorse360.MaintenanceUser.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @static
           * @param {stronachgroup.first.racehorse360.IMaintenanceUser} message MaintenanceUser message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          MaintenanceUser.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.lastName);
            if (
              message.workOrderAssignedCount != null &&
              Object.hasOwnProperty.call(message, "workOrderAssignedCount")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.workOrderAssignedCount);
            return writer;
          };

          /**
           * Decodes a MaintenanceUser message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.MaintenanceUser} MaintenanceUser
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          MaintenanceUser.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.MaintenanceUser();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.firstName = reader.string();
                  break;
                case 3:
                  message.lastName = reader.string();
                  break;
                case 4:
                  message.workOrderAssignedCount = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a MaintenanceUser message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.MaintenanceUser} MaintenanceUser
           */
          MaintenanceUser.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.MaintenanceUser
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.MaintenanceUser();
            if (object.id != null) message.id = String(object.id);
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.workOrderAssignedCount != null)
              message.workOrderAssignedCount =
                object.workOrderAssignedCount | 0;
            return message;
          };

          /**
           * Creates a plain object from a MaintenanceUser message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @static
           * @param {stronachgroup.first.racehorse360.MaintenanceUser} message MaintenanceUser
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          MaintenanceUser.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.firstName = "";
              object.lastName = "";
              object.workOrderAssignedCount = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (
              message.workOrderAssignedCount != null &&
              message.hasOwnProperty("workOrderAssignedCount")
            )
              object.workOrderAssignedCount = message.workOrderAssignedCount;
            return object;
          };

          /**
           * Converts this MaintenanceUser to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.MaintenanceUser
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          MaintenanceUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return MaintenanceUser;
        })();

        racehorse360.PullMaintenanceUsersResponse = (function () {
          /**
           * Properties of a PullMaintenanceUsersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullMaintenanceUsersResponse
           * @property {Array.<stronachgroup.first.racehorse360.IMaintenanceUser>|null} [maintenanceUsers] PullMaintenanceUsersResponse maintenanceUsers
           */

          /**
           * Constructs a new PullMaintenanceUsersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullMaintenanceUsersResponse.
           * @implements IPullMaintenanceUsersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersResponse=} [properties] Properties to set
           */
          function PullMaintenanceUsersResponse(properties) {
            this.maintenanceUsers = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullMaintenanceUsersResponse maintenanceUsers.
           * @member {Array.<stronachgroup.first.racehorse360.IMaintenanceUser>} maintenanceUsers
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @instance
           */
          PullMaintenanceUsersResponse.prototype.maintenanceUsers =
            $util.emptyArray;

          /**
           * Creates a new PullMaintenanceUsersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersResponse} PullMaintenanceUsersResponse instance
           */
          PullMaintenanceUsersResponse.create = function create(properties) {
            return new PullMaintenanceUsersResponse(properties);
          };

          /**
           * Encodes the specified PullMaintenanceUsersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullMaintenanceUsersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersResponse} message PullMaintenanceUsersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullMaintenanceUsersResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.maintenanceUsers != null &&
              message.maintenanceUsers.length
            )
              for (var i = 0; i < message.maintenanceUsers.length; ++i)
                $root.stronachgroup.first.racehorse360.MaintenanceUser.encode(
                  message.maintenanceUsers[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullMaintenanceUsersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersResponse} PullMaintenanceUsersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullMaintenanceUsersResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.maintenanceUsers &&
                      message.maintenanceUsers.length
                    )
                  )
                    message.maintenanceUsers = [];
                  message.maintenanceUsers.push(
                    $root.stronachgroup.first.racehorse360.MaintenanceUser.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullMaintenanceUsersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersResponse} PullMaintenanceUsersResponse
           */
          PullMaintenanceUsersResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullMaintenanceUsersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse();
            if (object.maintenanceUsers) {
              if (!Array.isArray(object.maintenanceUsers))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullMaintenanceUsersResponse.maintenanceUsers: array expected"
                );
              message.maintenanceUsers = [];
              for (var i = 0; i < object.maintenanceUsers.length; ++i) {
                if (typeof object.maintenanceUsers[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullMaintenanceUsersResponse.maintenanceUsers: object expected"
                  );
                message.maintenanceUsers[i] =
                  $root.stronachgroup.first.racehorse360.MaintenanceUser.fromObject(
                    object.maintenanceUsers[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullMaintenanceUsersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullMaintenanceUsersResponse} message PullMaintenanceUsersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullMaintenanceUsersResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.maintenanceUsers = [];
            if (message.maintenanceUsers && message.maintenanceUsers.length) {
              object.maintenanceUsers = [];
              for (var j = 0; j < message.maintenanceUsers.length; ++j)
                object.maintenanceUsers[j] =
                  $root.stronachgroup.first.racehorse360.MaintenanceUser.toObject(
                    message.maintenanceUsers[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullMaintenanceUsersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullMaintenanceUsersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullMaintenanceUsersResponse;
        })();

        racehorse360.PullMaintenanceUsersRequest = (function () {
          /**
           * Properties of a PullMaintenanceUsersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullMaintenanceUsersRequest
           * @property {string|null} [facilityId] PullMaintenanceUsersRequest facilityId
           */

          /**
           * Constructs a new PullMaintenanceUsersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullMaintenanceUsersRequest.
           * @implements IPullMaintenanceUsersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersRequest=} [properties] Properties to set
           */
          function PullMaintenanceUsersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullMaintenanceUsersRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @instance
           */
          PullMaintenanceUsersRequest.prototype.facilityId = "";

          /**
           * Creates a new PullMaintenanceUsersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} PullMaintenanceUsersRequest instance
           */
          PullMaintenanceUsersRequest.create = function create(properties) {
            return new PullMaintenanceUsersRequest(properties);
          };

          /**
           * Encodes the specified PullMaintenanceUsersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullMaintenanceUsersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersRequest} message PullMaintenanceUsersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullMaintenanceUsersRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            return writer;
          };

          /**
           * Decodes a PullMaintenanceUsersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} PullMaintenanceUsersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullMaintenanceUsersRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullMaintenanceUsersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} PullMaintenanceUsersRequest
           */
          PullMaintenanceUsersRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            return message;
          };

          /**
           * Creates a plain object from a PullMaintenanceUsersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullMaintenanceUsersRequest} message PullMaintenanceUsersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullMaintenanceUsersRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.facilityId = "";
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            return object;
          };

          /**
           * Converts this PullMaintenanceUsersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullMaintenanceUsersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullMaintenanceUsersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullMaintenanceUsersRequest;
        })();

        racehorse360.PullWorkOrderReportersResponse = (function () {
          /**
           * Properties of a PullWorkOrderReportersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderReportersResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUser>|null} [users] PullWorkOrderReportersResponse users
           */

          /**
           * Constructs a new PullWorkOrderReportersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderReportersResponse.
           * @implements IPullWorkOrderReportersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersResponse=} [properties] Properties to set
           */
          function PullWorkOrderReportersResponse(properties) {
            this.users = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderReportersResponse users.
           * @member {Array.<stronachgroup.first.racehorse360.IUser>} users
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @instance
           */
          PullWorkOrderReportersResponse.prototype.users = $util.emptyArray;

          /**
           * Creates a new PullWorkOrderReportersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersResponse} PullWorkOrderReportersResponse instance
           */
          PullWorkOrderReportersResponse.create = function create(properties) {
            return new PullWorkOrderReportersResponse(properties);
          };

          /**
           * Encodes the specified PullWorkOrderReportersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderReportersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersResponse} message PullWorkOrderReportersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderReportersResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.users != null && message.users.length)
              for (var i = 0; i < message.users.length; ++i)
                $root.stronachgroup.first.racehorse360.User.encode(
                  message.users[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullWorkOrderReportersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersResponse} PullWorkOrderReportersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderReportersResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.users && message.users.length))
                    message.users = [];
                  message.users.push(
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderReportersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersResponse} PullWorkOrderReportersResponse
           */
          PullWorkOrderReportersResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkOrderReportersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse();
            if (object.users) {
              if (!Array.isArray(object.users))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWorkOrderReportersResponse.users: array expected"
                );
              message.users = [];
              for (var i = 0; i < object.users.length; ++i) {
                if (typeof object.users[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullWorkOrderReportersResponse.users: object expected"
                  );
                message.users[i] =
                  $root.stronachgroup.first.racehorse360.User.fromObject(
                    object.users[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderReportersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderReportersResponse} message PullWorkOrderReportersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderReportersResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.users = [];
            if (message.users && message.users.length) {
              object.users = [];
              for (var j = 0; j < message.users.length; ++j)
                object.users[j] =
                  $root.stronachgroup.first.racehorse360.User.toObject(
                    message.users[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullWorkOrderReportersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderReportersResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullWorkOrderReportersResponse;
        })();

        racehorse360.PullWorkOrderReportersRequest = (function () {
          /**
           * Properties of a PullWorkOrderReportersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderReportersRequest
           * @property {string|null} [facilityId] PullWorkOrderReportersRequest facilityId
           * @property {stronachgroup.first.racehorse360.WorkOrderStatus|null} [workOrderStatus] PullWorkOrderReportersRequest workOrderStatus
           */

          /**
           * Constructs a new PullWorkOrderReportersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderReportersRequest.
           * @implements IPullWorkOrderReportersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersRequest=} [properties] Properties to set
           */
          function PullWorkOrderReportersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderReportersRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @instance
           */
          PullWorkOrderReportersRequest.prototype.facilityId = "";

          /**
           * PullWorkOrderReportersRequest workOrderStatus.
           * @member {stronachgroup.first.racehorse360.WorkOrderStatus} workOrderStatus
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @instance
           */
          PullWorkOrderReportersRequest.prototype.workOrderStatus = 0;

          /**
           * Creates a new PullWorkOrderReportersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} PullWorkOrderReportersRequest instance
           */
          PullWorkOrderReportersRequest.create = function create(properties) {
            return new PullWorkOrderReportersRequest(properties);
          };

          /**
           * Encodes the specified PullWorkOrderReportersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderReportersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersRequest} message PullWorkOrderReportersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderReportersRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.workOrderStatus != null &&
              Object.hasOwnProperty.call(message, "workOrderStatus")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.workOrderStatus);
            return writer;
          };

          /**
           * Decodes a PullWorkOrderReportersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} PullWorkOrderReportersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderReportersRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.workOrderStatus = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderReportersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} PullWorkOrderReportersRequest
           */
          PullWorkOrderReportersRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkOrderReportersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            switch (object.workOrderStatus) {
              case "WORK_ORDER_STATUS_INVALID":
              case 0:
                message.workOrderStatus = 0;
                break;
              case "WORK_ORDER_STATUS_OPEN":
              case 1:
                message.workOrderStatus = 1;
                break;
              case "WORK_ORDER_STATUS_ASSIGNED":
              case 2:
                message.workOrderStatus = 2;
                break;
              case "WORK_ORDER_STATUS_COMPLETE":
              case 3:
                message.workOrderStatus = 3;
                break;
              case "WORK_ORDER_STATUS_CLOSED":
              case 4:
                message.workOrderStatus = 4;
                break;
              case "WORK_ORDER_STATUS_CANCELED":
              case 5:
                message.workOrderStatus = 5;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderReportersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderReportersRequest} message PullWorkOrderReportersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderReportersRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.workOrderStatus =
                options.enums === String ? "WORK_ORDER_STATUS_INVALID" : 0;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.workOrderStatus != null &&
              message.hasOwnProperty("workOrderStatus")
            )
              object.workOrderStatus =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkOrderStatus[
                      message.workOrderStatus
                    ]
                  : message.workOrderStatus;
            return object;
          };

          /**
           * Converts this PullWorkOrderReportersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderReportersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderReportersRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullWorkOrderReportersRequest;
        })();

        racehorse360.PullWorkOrderAssignedUsersResponse = (function () {
          /**
           * Properties of a PullWorkOrderAssignedUsersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderAssignedUsersResponse
           * @property {Array.<stronachgroup.first.racehorse360.IUser>|null} [users] PullWorkOrderAssignedUsersResponse users
           */

          /**
           * Constructs a new PullWorkOrderAssignedUsersResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderAssignedUsersResponse.
           * @implements IPullWorkOrderAssignedUsersResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersResponse=} [properties] Properties to set
           */
          function PullWorkOrderAssignedUsersResponse(properties) {
            this.users = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderAssignedUsersResponse users.
           * @member {Array.<stronachgroup.first.racehorse360.IUser>} users
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @instance
           */
          PullWorkOrderAssignedUsersResponse.prototype.users = $util.emptyArray;

          /**
           * Creates a new PullWorkOrderAssignedUsersResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse} PullWorkOrderAssignedUsersResponse instance
           */
          PullWorkOrderAssignedUsersResponse.create = function create(
            properties
          ) {
            return new PullWorkOrderAssignedUsersResponse(properties);
          };

          /**
           * Encodes the specified PullWorkOrderAssignedUsersResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersResponse} message PullWorkOrderAssignedUsersResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderAssignedUsersResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.users != null && message.users.length)
              for (var i = 0; i < message.users.length; ++i)
                $root.stronachgroup.first.racehorse360.User.encode(
                  message.users[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullWorkOrderAssignedUsersResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse} PullWorkOrderAssignedUsersResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderAssignedUsersResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.users && message.users.length))
                    message.users = [];
                  message.users.push(
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderAssignedUsersResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse} PullWorkOrderAssignedUsersResponse
           */
          PullWorkOrderAssignedUsersResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkOrderAssignedUsersResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse();
            if (object.users) {
              if (!Array.isArray(object.users))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse.users: array expected"
                );
              message.users = [];
              for (var i = 0; i < object.users.length; ++i) {
                if (typeof object.users[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse.users: object expected"
                  );
                message.users[i] =
                  $root.stronachgroup.first.racehorse360.User.fromObject(
                    object.users[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderAssignedUsersResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse} message PullWorkOrderAssignedUsersResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderAssignedUsersResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.users = [];
            if (message.users && message.users.length) {
              object.users = [];
              for (var j = 0; j < message.users.length; ++j)
                object.users[j] =
                  $root.stronachgroup.first.racehorse360.User.toObject(
                    message.users[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullWorkOrderAssignedUsersResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderAssignedUsersResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullWorkOrderAssignedUsersResponse;
        })();

        racehorse360.PullWorkOrderAssignedUsersRequest = (function () {
          /**
           * Properties of a PullWorkOrderAssignedUsersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderAssignedUsersRequest
           * @property {string|null} [facilityId] PullWorkOrderAssignedUsersRequest facilityId
           * @property {stronachgroup.first.racehorse360.WorkOrderStatus|null} [workOrderStatus] PullWorkOrderAssignedUsersRequest workOrderStatus
           */

          /**
           * Constructs a new PullWorkOrderAssignedUsersRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderAssignedUsersRequest.
           * @implements IPullWorkOrderAssignedUsersRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersRequest=} [properties] Properties to set
           */
          function PullWorkOrderAssignedUsersRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderAssignedUsersRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @instance
           */
          PullWorkOrderAssignedUsersRequest.prototype.facilityId = "";

          /**
           * PullWorkOrderAssignedUsersRequest workOrderStatus.
           * @member {stronachgroup.first.racehorse360.WorkOrderStatus} workOrderStatus
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @instance
           */
          PullWorkOrderAssignedUsersRequest.prototype.workOrderStatus = 0;

          /**
           * Creates a new PullWorkOrderAssignedUsersRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} PullWorkOrderAssignedUsersRequest instance
           */
          PullWorkOrderAssignedUsersRequest.create = function create(
            properties
          ) {
            return new PullWorkOrderAssignedUsersRequest(properties);
          };

          /**
           * Encodes the specified PullWorkOrderAssignedUsersRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersRequest} message PullWorkOrderAssignedUsersRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderAssignedUsersRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.workOrderStatus != null &&
              Object.hasOwnProperty.call(message, "workOrderStatus")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.workOrderStatus);
            return writer;
          };

          /**
           * Decodes a PullWorkOrderAssignedUsersRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} PullWorkOrderAssignedUsersRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderAssignedUsersRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.workOrderStatus = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderAssignedUsersRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} PullWorkOrderAssignedUsersRequest
           */
          PullWorkOrderAssignedUsersRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkOrderAssignedUsersRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            switch (object.workOrderStatus) {
              case "WORK_ORDER_STATUS_INVALID":
              case 0:
                message.workOrderStatus = 0;
                break;
              case "WORK_ORDER_STATUS_OPEN":
              case 1:
                message.workOrderStatus = 1;
                break;
              case "WORK_ORDER_STATUS_ASSIGNED":
              case 2:
                message.workOrderStatus = 2;
                break;
              case "WORK_ORDER_STATUS_COMPLETE":
              case 3:
                message.workOrderStatus = 3;
                break;
              case "WORK_ORDER_STATUS_CLOSED":
              case 4:
                message.workOrderStatus = 4;
                break;
              case "WORK_ORDER_STATUS_CANCELED":
              case 5:
                message.workOrderStatus = 5;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderAssignedUsersRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest} message PullWorkOrderAssignedUsersRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderAssignedUsersRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.workOrderStatus =
                options.enums === String ? "WORK_ORDER_STATUS_INVALID" : 0;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.workOrderStatus != null &&
              message.hasOwnProperty("workOrderStatus")
            )
              object.workOrderStatus =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkOrderStatus[
                      message.workOrderStatus
                    ]
                  : message.workOrderStatus;
            return object;
          };

          /**
           * Converts this PullWorkOrderAssignedUsersRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderAssignedUsersRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullWorkOrderAssignedUsersRequest;
        })();

        racehorse360.CompleteWorkOrderRequest = (function () {
          /**
           * Properties of a CompleteWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICompleteWorkOrderRequest
           * @property {string|null} [id] CompleteWorkOrderRequest id
           * @property {google.protobuf.IStringValue|null} [note] CompleteWorkOrderRequest note
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CompleteWorkOrderRequest getOptions
           */

          /**
           * Constructs a new CompleteWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CompleteWorkOrderRequest.
           * @implements ICompleteWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICompleteWorkOrderRequest=} [properties] Properties to set
           */
          function CompleteWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CompleteWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @instance
           */
          CompleteWorkOrderRequest.prototype.id = "";

          /**
           * CompleteWorkOrderRequest note.
           * @member {google.protobuf.IStringValue|null|undefined} note
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @instance
           */
          CompleteWorkOrderRequest.prototype.note = null;

          /**
           * CompleteWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @instance
           */
          CompleteWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new CompleteWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CompleteWorkOrderRequest} CompleteWorkOrderRequest instance
           */
          CompleteWorkOrderRequest.create = function create(properties) {
            return new CompleteWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified CompleteWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CompleteWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteWorkOrderRequest} message CompleteWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CompleteWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              $root.google.protobuf.StringValue.encode(
                message.note,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CompleteWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CompleteWorkOrderRequest} CompleteWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CompleteWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CompleteWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.note = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CompleteWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CompleteWorkOrderRequest} CompleteWorkOrderRequest
           */
          CompleteWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CompleteWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CompleteWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.note != null) {
              if (typeof object.note !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteWorkOrderRequest.note: object expected"
                );
              message.note = $root.google.protobuf.StringValue.fromObject(
                object.note
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CompleteWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CompleteWorkOrderRequest} message CompleteWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CompleteWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.note = null;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = $root.google.protobuf.StringValue.toObject(
                message.note,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CompleteWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CompleteWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CompleteWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CompleteWorkOrderRequest;
        })();

        racehorse360.ReopenWorkOrderRequest = (function () {
          /**
           * Properties of a ReopenWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IReopenWorkOrderRequest
           * @property {string|null} [id] ReopenWorkOrderRequest id
           * @property {google.protobuf.IStringValue|null} [userToAssignId] ReopenWorkOrderRequest userToAssignId
           * @property {google.protobuf.IStringValue|null} [note] ReopenWorkOrderRequest note
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ReopenWorkOrderRequest getOptions
           */

          /**
           * Constructs a new ReopenWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ReopenWorkOrderRequest.
           * @implements IReopenWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IReopenWorkOrderRequest=} [properties] Properties to set
           */
          function ReopenWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ReopenWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @instance
           */
          ReopenWorkOrderRequest.prototype.id = "";

          /**
           * ReopenWorkOrderRequest userToAssignId.
           * @member {google.protobuf.IStringValue|null|undefined} userToAssignId
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @instance
           */
          ReopenWorkOrderRequest.prototype.userToAssignId = null;

          /**
           * ReopenWorkOrderRequest note.
           * @member {google.protobuf.IStringValue|null|undefined} note
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @instance
           */
          ReopenWorkOrderRequest.prototype.note = null;

          /**
           * ReopenWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @instance
           */
          ReopenWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new ReopenWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IReopenWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ReopenWorkOrderRequest} ReopenWorkOrderRequest instance
           */
          ReopenWorkOrderRequest.create = function create(properties) {
            return new ReopenWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified ReopenWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ReopenWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IReopenWorkOrderRequest} message ReopenWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ReopenWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.userToAssignId != null &&
              Object.hasOwnProperty.call(message, "userToAssignId")
            )
              $root.google.protobuf.StringValue.encode(
                message.userToAssignId,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              $root.google.protobuf.StringValue.encode(
                message.note,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ReopenWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ReopenWorkOrderRequest} ReopenWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ReopenWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ReopenWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.userToAssignId =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.note = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ReopenWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ReopenWorkOrderRequest} ReopenWorkOrderRequest
           */
          ReopenWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ReopenWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ReopenWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.userToAssignId != null) {
              if (typeof object.userToAssignId !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ReopenWorkOrderRequest.userToAssignId: object expected"
                );
              message.userToAssignId =
                $root.google.protobuf.StringValue.fromObject(
                  object.userToAssignId
                );
            }
            if (object.note != null) {
              if (typeof object.note !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ReopenWorkOrderRequest.note: object expected"
                );
              message.note = $root.google.protobuf.StringValue.fromObject(
                object.note
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ReopenWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ReopenWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ReopenWorkOrderRequest} message ReopenWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ReopenWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.userToAssignId = null;
              object.note = null;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.userToAssignId != null &&
              message.hasOwnProperty("userToAssignId")
            )
              object.userToAssignId =
                $root.google.protobuf.StringValue.toObject(
                  message.userToAssignId,
                  options
                );
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = $root.google.protobuf.StringValue.toObject(
                message.note,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ReopenWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ReopenWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ReopenWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ReopenWorkOrderRequest;
        })();

        racehorse360.CancelWorkOrderRequest = (function () {
          /**
           * Properties of a CancelWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICancelWorkOrderRequest
           * @property {string|null} [id] CancelWorkOrderRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CancelWorkOrderRequest getOptions
           */

          /**
           * Constructs a new CancelWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CancelWorkOrderRequest.
           * @implements ICancelWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICancelWorkOrderRequest=} [properties] Properties to set
           */
          function CancelWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CancelWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @instance
           */
          CancelWorkOrderRequest.prototype.id = "";

          /**
           * CancelWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @instance
           */
          CancelWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new CancelWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CancelWorkOrderRequest} CancelWorkOrderRequest instance
           */
          CancelWorkOrderRequest.create = function create(properties) {
            return new CancelWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified CancelWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CancelWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelWorkOrderRequest} message CancelWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CancelWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CancelWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CancelWorkOrderRequest} CancelWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CancelWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CancelWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CancelWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CancelWorkOrderRequest} CancelWorkOrderRequest
           */
          CancelWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CancelWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CancelWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CancelWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CancelWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CancelWorkOrderRequest} message CancelWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CancelWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CancelWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CancelWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CancelWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CancelWorkOrderRequest;
        })();

        racehorse360.EditWorkOrderRequest = (function () {
          /**
           * Properties of an EditWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditWorkOrderRequest
           * @property {string|null} [id] EditWorkOrderRequest id
           * @property {string|null} [facilityId] EditWorkOrderRequest facilityId
           * @property {string|null} [workOrderTypeId] EditWorkOrderRequest workOrderTypeId
           * @property {string|null} [description] EditWorkOrderRequest description
           * @property {string|null} [barnId] EditWorkOrderRequest barnId
           * @property {string|null} [stallNumber] EditWorkOrderRequest stallNumber
           * @property {string|null} [fullName] EditWorkOrderRequest fullName
           * @property {string|null} [phone] EditWorkOrderRequest phone
           * @property {string|null} [email] EditWorkOrderRequest email
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditWorkOrderRequest getOptions
           */

          /**
           * Constructs a new EditWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditWorkOrderRequest.
           * @implements IEditWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditWorkOrderRequest=} [properties] Properties to set
           */
          function EditWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.id = "";

          /**
           * EditWorkOrderRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.facilityId = "";

          /**
           * EditWorkOrderRequest workOrderTypeId.
           * @member {string} workOrderTypeId
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.workOrderTypeId = "";

          /**
           * EditWorkOrderRequest description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.description = "";

          /**
           * EditWorkOrderRequest barnId.
           * @member {string} barnId
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.barnId = "";

          /**
           * EditWorkOrderRequest stallNumber.
           * @member {string} stallNumber
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.stallNumber = "";

          /**
           * EditWorkOrderRequest fullName.
           * @member {string} fullName
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.fullName = "";

          /**
           * EditWorkOrderRequest phone.
           * @member {string} phone
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.phone = "";

          /**
           * EditWorkOrderRequest email.
           * @member {string} email
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.email = "";

          /**
           * EditWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           */
          EditWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new EditWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditWorkOrderRequest} EditWorkOrderRequest instance
           */
          EditWorkOrderRequest.create = function create(properties) {
            return new EditWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified EditWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditWorkOrderRequest} message EditWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityId);
            if (
              message.workOrderTypeId != null &&
              Object.hasOwnProperty.call(message, "workOrderTypeId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.workOrderTypeId);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.description);
            if (
              message.barnId != null &&
              Object.hasOwnProperty.call(message, "barnId")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.barnId);
            if (
              message.stallNumber != null &&
              Object.hasOwnProperty.call(message, "stallNumber")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.stallNumber);
            if (
              message.fullName != null &&
              Object.hasOwnProperty.call(message, "fullName")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.fullName);
            if (
              message.phone != null &&
              Object.hasOwnProperty.call(message, "phone")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.phone);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.email);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditWorkOrderRequest} EditWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facilityId = reader.string();
                  break;
                case 3:
                  message.workOrderTypeId = reader.string();
                  break;
                case 4:
                  message.description = reader.string();
                  break;
                case 5:
                  message.barnId = reader.string();
                  break;
                case 6:
                  message.stallNumber = reader.string();
                  break;
                case 7:
                  message.fullName = reader.string();
                  break;
                case 8:
                  message.phone = reader.string();
                  break;
                case 9:
                  message.email = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditWorkOrderRequest} EditWorkOrderRequest
           */
          EditWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EditWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.workOrderTypeId != null)
              message.workOrderTypeId = String(object.workOrderTypeId);
            if (object.description != null)
              message.description = String(object.description);
            if (object.barnId != null) message.barnId = String(object.barnId);
            if (object.stallNumber != null)
              message.stallNumber = String(object.stallNumber);
            if (object.fullName != null)
              message.fullName = String(object.fullName);
            if (object.phone != null) message.phone = String(object.phone);
            if (object.email != null) message.email = String(object.email);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditWorkOrderRequest} message EditWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditWorkOrderRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facilityId = "";
              object.workOrderTypeId = "";
              object.description = "";
              object.barnId = "";
              object.stallNumber = "";
              object.fullName = "";
              object.phone = "";
              object.email = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.workOrderTypeId != null &&
              message.hasOwnProperty("workOrderTypeId")
            )
              object.workOrderTypeId = message.workOrderTypeId;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.barnId != null && message.hasOwnProperty("barnId"))
              object.barnId = message.barnId;
            if (
              message.stallNumber != null &&
              message.hasOwnProperty("stallNumber")
            )
              object.stallNumber = message.stallNumber;
            if (message.fullName != null && message.hasOwnProperty("fullName"))
              object.fullName = message.fullName;
            if (message.phone != null && message.hasOwnProperty("phone"))
              object.phone = message.phone;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EditWorkOrderRequest;
        })();

        racehorse360.SendBackWorkOrderRequest = (function () {
          /**
           * Properties of a SendBackWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISendBackWorkOrderRequest
           * @property {string|null} [id] SendBackWorkOrderRequest id
           * @property {google.protobuf.IStringValue|null} [userToAssignId] SendBackWorkOrderRequest userToAssignId
           * @property {google.protobuf.IStringValue|null} [note] SendBackWorkOrderRequest note
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SendBackWorkOrderRequest getOptions
           */

          /**
           * Constructs a new SendBackWorkOrderRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SendBackWorkOrderRequest.
           * @implements ISendBackWorkOrderRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISendBackWorkOrderRequest=} [properties] Properties to set
           */
          function SendBackWorkOrderRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SendBackWorkOrderRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @instance
           */
          SendBackWorkOrderRequest.prototype.id = "";

          /**
           * SendBackWorkOrderRequest userToAssignId.
           * @member {google.protobuf.IStringValue|null|undefined} userToAssignId
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @instance
           */
          SendBackWorkOrderRequest.prototype.userToAssignId = null;

          /**
           * SendBackWorkOrderRequest note.
           * @member {google.protobuf.IStringValue|null|undefined} note
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @instance
           */
          SendBackWorkOrderRequest.prototype.note = null;

          /**
           * SendBackWorkOrderRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @instance
           */
          SendBackWorkOrderRequest.prototype.getOptions = null;

          /**
           * Creates a new SendBackWorkOrderRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISendBackWorkOrderRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SendBackWorkOrderRequest} SendBackWorkOrderRequest instance
           */
          SendBackWorkOrderRequest.create = function create(properties) {
            return new SendBackWorkOrderRequest(properties);
          };

          /**
           * Encodes the specified SendBackWorkOrderRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SendBackWorkOrderRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISendBackWorkOrderRequest} message SendBackWorkOrderRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SendBackWorkOrderRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.userToAssignId != null &&
              Object.hasOwnProperty.call(message, "userToAssignId")
            )
              $root.google.protobuf.StringValue.encode(
                message.userToAssignId,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              $root.google.protobuf.StringValue.encode(
                message.note,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SendBackWorkOrderRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SendBackWorkOrderRequest} SendBackWorkOrderRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SendBackWorkOrderRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SendBackWorkOrderRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.userToAssignId =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.note = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SendBackWorkOrderRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SendBackWorkOrderRequest} SendBackWorkOrderRequest
           */
          SendBackWorkOrderRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.SendBackWorkOrderRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SendBackWorkOrderRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.userToAssignId != null) {
              if (typeof object.userToAssignId !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SendBackWorkOrderRequest.userToAssignId: object expected"
                );
              message.userToAssignId =
                $root.google.protobuf.StringValue.fromObject(
                  object.userToAssignId
                );
            }
            if (object.note != null) {
              if (typeof object.note !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SendBackWorkOrderRequest.note: object expected"
                );
              message.note = $root.google.protobuf.StringValue.fromObject(
                object.note
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SendBackWorkOrderRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SendBackWorkOrderRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SendBackWorkOrderRequest} message SendBackWorkOrderRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SendBackWorkOrderRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.userToAssignId = null;
              object.note = null;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.userToAssignId != null &&
              message.hasOwnProperty("userToAssignId")
            )
              object.userToAssignId =
                $root.google.protobuf.StringValue.toObject(
                  message.userToAssignId,
                  options
                );
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = $root.google.protobuf.StringValue.toObject(
                message.note,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SendBackWorkOrderRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SendBackWorkOrderRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SendBackWorkOrderRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SendBackWorkOrderRequest;
        })();

        racehorse360.WorkOrderNote = (function () {
          /**
           * Properties of a WorkOrderNote.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrderNote
           * @property {string|null} [id] WorkOrderNote id
           * @property {string|null} [description] WorkOrderNote description
           * @property {stronachgroup.first.racehorse360.IWorkOrder|null} [workOrder] WorkOrderNote workOrder
           * @property {boolean|null} [isManual] WorkOrderNote isManual
           * @property {string|null} [createdOn] WorkOrderNote createdOn
           * @property {string|null} [updatedOn] WorkOrderNote updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] WorkOrderNote createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] WorkOrderNote updatedBy
           */

          /**
           * Constructs a new WorkOrderNote.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderNote.
           * @implements IWorkOrderNote
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrderNote=} [properties] Properties to set
           */
          function WorkOrderNote(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkOrderNote id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.id = "";

          /**
           * WorkOrderNote description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.description = "";

          /**
           * WorkOrderNote workOrder.
           * @member {stronachgroup.first.racehorse360.IWorkOrder|null|undefined} workOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.workOrder = null;

          /**
           * WorkOrderNote isManual.
           * @member {boolean} isManual
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.isManual = false;

          /**
           * WorkOrderNote createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.createdOn = "";

          /**
           * WorkOrderNote updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.updatedOn = "";

          /**
           * WorkOrderNote createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.createdBy = null;

          /**
           * WorkOrderNote updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           */
          WorkOrderNote.prototype.updatedBy = null;

          /**
           * Creates a new WorkOrderNote instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderNote=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrderNote} WorkOrderNote instance
           */
          WorkOrderNote.create = function create(properties) {
            return new WorkOrderNote(properties);
          };

          /**
           * Encodes the specified WorkOrderNote message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrderNote.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderNote} message WorkOrderNote message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrderNote.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.workOrder != null &&
              Object.hasOwnProperty.call(message, "workOrder")
            )
              $root.stronachgroup.first.racehorse360.WorkOrder.encode(
                message.workOrder,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.isManual != null &&
              Object.hasOwnProperty.call(message, "isManual")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isManual);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkOrderNote message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrderNote} WorkOrderNote
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrderNote.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkOrderNote();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.workOrder =
                    $root.stronachgroup.first.racehorse360.WorkOrder.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.isManual = reader.bool();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrderNote message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrderNote} WorkOrderNote
           */
          WorkOrderNote.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkOrderNote
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkOrderNote();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.workOrder != null) {
              if (typeof object.workOrder !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderNote.workOrder: object expected"
                );
              message.workOrder =
                $root.stronachgroup.first.racehorse360.WorkOrder.fromObject(
                  object.workOrder
                );
            }
            if (object.isManual != null)
              message.isManual = Boolean(object.isManual);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderNote.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkOrderNote.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkOrderNote message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrderNote} message WorkOrderNote
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrderNote.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.workOrder = null;
              object.isManual = false;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.workOrder != null &&
              message.hasOwnProperty("workOrder")
            )
              object.workOrder =
                $root.stronachgroup.first.racehorse360.WorkOrder.toObject(
                  message.workOrder,
                  options
                );
            if (message.isManual != null && message.hasOwnProperty("isManual"))
              object.isManual = message.isManual;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkOrderNote to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrderNote
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrderNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrderNote;
        })();

        racehorse360.WorkOrderNoteFilter = (function () {
          /**
           * Properties of a WorkOrderNoteFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkOrderNoteFilter
           * @property {string|null} [workOrderId] WorkOrderNoteFilter workOrderId
           */

          /**
           * Constructs a new WorkOrderNoteFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderNoteFilter.
           * @implements IWorkOrderNoteFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkOrderNoteFilter=} [properties] Properties to set
           */
          function WorkOrderNoteFilter(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkOrderNoteFilter workOrderId.
           * @member {string} workOrderId
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @instance
           */
          WorkOrderNoteFilter.prototype.workOrderId = "";

          /**
           * Creates a new WorkOrderNoteFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderNoteFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkOrderNoteFilter} WorkOrderNoteFilter instance
           */
          WorkOrderNoteFilter.create = function create(properties) {
            return new WorkOrderNoteFilter(properties);
          };

          /**
           * Encodes the specified WorkOrderNoteFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkOrderNoteFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkOrderNoteFilter} message WorkOrderNoteFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkOrderNoteFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.workOrderId != null &&
              Object.hasOwnProperty.call(message, "workOrderId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.workOrderId);
            return writer;
          };

          /**
           * Decodes a WorkOrderNoteFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkOrderNoteFilter} WorkOrderNoteFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkOrderNoteFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.workOrderId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkOrderNoteFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkOrderNoteFilter} WorkOrderNoteFilter
           */
          WorkOrderNoteFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter();
            if (object.workOrderId != null)
              message.workOrderId = String(object.workOrderId);
            return message;
          };

          /**
           * Creates a plain object from a WorkOrderNoteFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkOrderNoteFilter} message WorkOrderNoteFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkOrderNoteFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.workOrderId = "";
            if (
              message.workOrderId != null &&
              message.hasOwnProperty("workOrderId")
            )
              object.workOrderId = message.workOrderId;
            return object;
          };

          /**
           * Converts this WorkOrderNoteFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkOrderNoteFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkOrderNoteFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkOrderNoteFilter;
        })();

        racehorse360.ListWorkOrderNotesRequest = (function () {
          /**
           * Properties of a ListWorkOrderNotesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrderNotesRequest
           * @property {stronachgroup.first.racehorse360.IWorkOrderNoteFilter|null} [query] ListWorkOrderNotesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkOrderNotesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkOrderNotesRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkOrderNotesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrderNotesRequest.
           * @implements IListWorkOrderNotesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesRequest=} [properties] Properties to set
           */
          function ListWorkOrderNotesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrderNotesRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkOrderNoteFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @instance
           */
          ListWorkOrderNotesRequest.prototype.query = null;

          /**
           * ListWorkOrderNotesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @instance
           */
          ListWorkOrderNotesRequest.prototype.getOptions = null;

          /**
           * ListWorkOrderNotesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @instance
           */
          ListWorkOrderNotesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkOrderNotesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} ListWorkOrderNotesRequest instance
           */
          ListWorkOrderNotesRequest.create = function create(properties) {
            return new ListWorkOrderNotesRequest(properties);
          };

          /**
           * Encodes the specified ListWorkOrderNotesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrderNotesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesRequest} message ListWorkOrderNotesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrderNotesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrderNotesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} ListWorkOrderNotesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrderNotesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrderNotesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} ListWorkOrderNotesRequest
           */
          ListWorkOrderNotesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderNotesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderNotesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderNotesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrderNotesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrderNotesRequest} message ListWorkOrderNotesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrderNotesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkOrderNoteFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrderNotesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrderNotesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrderNotesRequest;
        })();

        racehorse360.ListWorkOrderNotesResponse = (function () {
          /**
           * Properties of a ListWorkOrderNotesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkOrderNotesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkOrderNote>|null} [workOrderNotes] ListWorkOrderNotesResponse workOrderNotes
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkOrderNotesResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkOrderNotesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkOrderNotesResponse.
           * @implements IListWorkOrderNotesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesResponse=} [properties] Properties to set
           */
          function ListWorkOrderNotesResponse(properties) {
            this.workOrderNotes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkOrderNotesResponse workOrderNotes.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkOrderNote>} workOrderNotes
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @instance
           */
          ListWorkOrderNotesResponse.prototype.workOrderNotes =
            $util.emptyArray;

          /**
           * ListWorkOrderNotesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @instance
           */
          ListWorkOrderNotesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkOrderNotesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesResponse} ListWorkOrderNotesResponse instance
           */
          ListWorkOrderNotesResponse.create = function create(properties) {
            return new ListWorkOrderNotesResponse(properties);
          };

          /**
           * Encodes the specified ListWorkOrderNotesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkOrderNotesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesResponse} message ListWorkOrderNotesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkOrderNotesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.workOrderNotes != null && message.workOrderNotes.length)
              for (var i = 0; i < message.workOrderNotes.length; ++i)
                $root.stronachgroup.first.racehorse360.WorkOrderNote.encode(
                  message.workOrderNotes[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkOrderNotesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesResponse} ListWorkOrderNotesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkOrderNotesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.workOrderNotes && message.workOrderNotes.length)
                  )
                    message.workOrderNotes = [];
                  message.workOrderNotes.push(
                    $root.stronachgroup.first.racehorse360.WorkOrderNote.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkOrderNotesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkOrderNotesResponse} ListWorkOrderNotesResponse
           */
          ListWorkOrderNotesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse();
            if (object.workOrderNotes) {
              if (!Array.isArray(object.workOrderNotes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderNotesResponse.workOrderNotes: array expected"
                );
              message.workOrderNotes = [];
              for (var i = 0; i < object.workOrderNotes.length; ++i) {
                if (typeof object.workOrderNotes[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkOrderNotesResponse.workOrderNotes: object expected"
                  );
                message.workOrderNotes[i] =
                  $root.stronachgroup.first.racehorse360.WorkOrderNote.fromObject(
                    object.workOrderNotes[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkOrderNotesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkOrderNotesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkOrderNotesResponse} message ListWorkOrderNotesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkOrderNotesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.workOrderNotes = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.workOrderNotes && message.workOrderNotes.length) {
              object.workOrderNotes = [];
              for (var j = 0; j < message.workOrderNotes.length; ++j)
                object.workOrderNotes[j] =
                  $root.stronachgroup.first.racehorse360.WorkOrderNote.toObject(
                    message.workOrderNotes[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkOrderNotesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkOrderNotesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkOrderNotesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkOrderNotesResponse;
        })();

        racehorse360.PullWorkOrderSummaryResponse = (function () {
          /**
           * Properties of a PullWorkOrderSummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderSummaryResponse
           * @property {number|null} [openCount] PullWorkOrderSummaryResponse openCount
           * @property {number|null} [assignedCount] PullWorkOrderSummaryResponse assignedCount
           * @property {number|null} [completeCount] PullWorkOrderSummaryResponse completeCount
           * @property {number|null} [closedCount] PullWorkOrderSummaryResponse closedCount
           * @property {number|null} [canceledCount] PullWorkOrderSummaryResponse canceledCount
           */

          /**
           * Constructs a new PullWorkOrderSummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderSummaryResponse.
           * @implements IPullWorkOrderSummaryResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryResponse=} [properties] Properties to set
           */
          function PullWorkOrderSummaryResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderSummaryResponse openCount.
           * @member {number} openCount
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           */
          PullWorkOrderSummaryResponse.prototype.openCount = 0;

          /**
           * PullWorkOrderSummaryResponse assignedCount.
           * @member {number} assignedCount
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           */
          PullWorkOrderSummaryResponse.prototype.assignedCount = 0;

          /**
           * PullWorkOrderSummaryResponse completeCount.
           * @member {number} completeCount
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           */
          PullWorkOrderSummaryResponse.prototype.completeCount = 0;

          /**
           * PullWorkOrderSummaryResponse closedCount.
           * @member {number} closedCount
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           */
          PullWorkOrderSummaryResponse.prototype.closedCount = 0;

          /**
           * PullWorkOrderSummaryResponse canceledCount.
           * @member {number} canceledCount
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           */
          PullWorkOrderSummaryResponse.prototype.canceledCount = 0;

          /**
           * Creates a new PullWorkOrderSummaryResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse} PullWorkOrderSummaryResponse instance
           */
          PullWorkOrderSummaryResponse.create = function create(properties) {
            return new PullWorkOrderSummaryResponse(properties);
          };

          /**
           * Encodes the specified PullWorkOrderSummaryResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryResponse} message PullWorkOrderSummaryResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderSummaryResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.openCount != null &&
              Object.hasOwnProperty.call(message, "openCount")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.openCount);
            if (
              message.assignedCount != null &&
              Object.hasOwnProperty.call(message, "assignedCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.assignedCount);
            if (
              message.completeCount != null &&
              Object.hasOwnProperty.call(message, "completeCount")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.completeCount);
            if (
              message.closedCount != null &&
              Object.hasOwnProperty.call(message, "closedCount")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.closedCount);
            if (
              message.canceledCount != null &&
              Object.hasOwnProperty.call(message, "canceledCount")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.canceledCount);
            return writer;
          };

          /**
           * Decodes a PullWorkOrderSummaryResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse} PullWorkOrderSummaryResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderSummaryResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.openCount = reader.int32();
                  break;
                case 2:
                  message.assignedCount = reader.int32();
                  break;
                case 3:
                  message.completeCount = reader.int32();
                  break;
                case 4:
                  message.closedCount = reader.int32();
                  break;
                case 5:
                  message.canceledCount = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderSummaryResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse} PullWorkOrderSummaryResponse
           */
          PullWorkOrderSummaryResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkOrderSummaryResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse();
            if (object.openCount != null)
              message.openCount = object.openCount | 0;
            if (object.assignedCount != null)
              message.assignedCount = object.assignedCount | 0;
            if (object.completeCount != null)
              message.completeCount = object.completeCount | 0;
            if (object.closedCount != null)
              message.closedCount = object.closedCount | 0;
            if (object.canceledCount != null)
              message.canceledCount = object.canceledCount | 0;
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderSummaryResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse} message PullWorkOrderSummaryResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderSummaryResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.openCount = 0;
              object.assignedCount = 0;
              object.completeCount = 0;
              object.closedCount = 0;
              object.canceledCount = 0;
            }
            if (
              message.openCount != null &&
              message.hasOwnProperty("openCount")
            )
              object.openCount = message.openCount;
            if (
              message.assignedCount != null &&
              message.hasOwnProperty("assignedCount")
            )
              object.assignedCount = message.assignedCount;
            if (
              message.completeCount != null &&
              message.hasOwnProperty("completeCount")
            )
              object.completeCount = message.completeCount;
            if (
              message.closedCount != null &&
              message.hasOwnProperty("closedCount")
            )
              object.closedCount = message.closedCount;
            if (
              message.canceledCount != null &&
              message.hasOwnProperty("canceledCount")
            )
              object.canceledCount = message.canceledCount;
            return object;
          };

          /**
           * Converts this PullWorkOrderSummaryResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderSummaryResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullWorkOrderSummaryResponse;
        })();

        racehorse360.PullWorkOrderSummaryRequest = (function () {
          /**
           * Properties of a PullWorkOrderSummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkOrderSummaryRequest
           * @property {string|null} [facilityId] PullWorkOrderSummaryRequest facilityId
           */

          /**
           * Constructs a new PullWorkOrderSummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkOrderSummaryRequest.
           * @implements IPullWorkOrderSummaryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryRequest=} [properties] Properties to set
           */
          function PullWorkOrderSummaryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkOrderSummaryRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @instance
           */
          PullWorkOrderSummaryRequest.prototype.facilityId = "";

          /**
           * Creates a new PullWorkOrderSummaryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} PullWorkOrderSummaryRequest instance
           */
          PullWorkOrderSummaryRequest.create = function create(properties) {
            return new PullWorkOrderSummaryRequest(properties);
          };

          /**
           * Encodes the specified PullWorkOrderSummaryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryRequest} message PullWorkOrderSummaryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkOrderSummaryRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            return writer;
          };

          /**
           * Decodes a PullWorkOrderSummaryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} PullWorkOrderSummaryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkOrderSummaryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkOrderSummaryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} PullWorkOrderSummaryRequest
           */
          PullWorkOrderSummaryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            return message;
          };

          /**
           * Creates a plain object from a PullWorkOrderSummaryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest} message PullWorkOrderSummaryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkOrderSummaryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.facilityId = "";
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            return object;
          };

          /**
           * Converts this PullWorkOrderSummaryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkOrderSummaryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullWorkOrderSummaryRequest;
        })();

        racehorse360.CreateWorkOrderNoteRequest = (function () {
          /**
           * Properties of a CreateWorkOrderNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateWorkOrderNoteRequest
           * @property {string|null} [workOrderId] CreateWorkOrderNoteRequest workOrderId
           * @property {string|null} [note] CreateWorkOrderNoteRequest note
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateWorkOrderNoteRequest getOptions
           */

          /**
           * Constructs a new CreateWorkOrderNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateWorkOrderNoteRequest.
           * @implements ICreateWorkOrderNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderNoteRequest=} [properties] Properties to set
           */
          function CreateWorkOrderNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateWorkOrderNoteRequest workOrderId.
           * @member {string} workOrderId
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @instance
           */
          CreateWorkOrderNoteRequest.prototype.workOrderId = "";

          /**
           * CreateWorkOrderNoteRequest note.
           * @member {string} note
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @instance
           */
          CreateWorkOrderNoteRequest.prototype.note = "";

          /**
           * CreateWorkOrderNoteRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @instance
           */
          CreateWorkOrderNoteRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateWorkOrderNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} CreateWorkOrderNoteRequest instance
           */
          CreateWorkOrderNoteRequest.create = function create(properties) {
            return new CreateWorkOrderNoteRequest(properties);
          };

          /**
           * Encodes the specified CreateWorkOrderNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderNoteRequest} message CreateWorkOrderNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateWorkOrderNoteRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.workOrderId != null &&
              Object.hasOwnProperty.call(message, "workOrderId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.workOrderId);
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.note);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateWorkOrderNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} CreateWorkOrderNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateWorkOrderNoteRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.workOrderId = reader.string();
                  break;
                case 2:
                  message.note = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateWorkOrderNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} CreateWorkOrderNoteRequest
           */
          CreateWorkOrderNoteRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest();
            if (object.workOrderId != null)
              message.workOrderId = String(object.workOrderId);
            if (object.note != null) message.note = String(object.note);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateWorkOrderNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest} message CreateWorkOrderNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateWorkOrderNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.workOrderId = "";
              object.note = "";
              object.getOptions = null;
            }
            if (
              message.workOrderId != null &&
              message.hasOwnProperty("workOrderId")
            )
              object.workOrderId = message.workOrderId;
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = message.note;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateWorkOrderNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateWorkOrderNoteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateWorkOrderNoteRequest;
        })();

        racehorse360.DeleteWorkOrderNoteRequest = (function () {
          /**
           * Properties of a DeleteWorkOrderNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteWorkOrderNoteRequest
           * @property {string|null} [id] DeleteWorkOrderNoteRequest id
           */

          /**
           * Constructs a new DeleteWorkOrderNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteWorkOrderNoteRequest.
           * @implements IDeleteWorkOrderNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderNoteRequest=} [properties] Properties to set
           */
          function DeleteWorkOrderNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteWorkOrderNoteRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @instance
           */
          DeleteWorkOrderNoteRequest.prototype.id = "";

          /**
           * Creates a new DeleteWorkOrderNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} DeleteWorkOrderNoteRequest instance
           */
          DeleteWorkOrderNoteRequest.create = function create(properties) {
            return new DeleteWorkOrderNoteRequest(properties);
          };

          /**
           * Encodes the specified DeleteWorkOrderNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderNoteRequest} message DeleteWorkOrderNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteWorkOrderNoteRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteWorkOrderNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} DeleteWorkOrderNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteWorkOrderNoteRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteWorkOrderNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} DeleteWorkOrderNoteRequest
           */
          DeleteWorkOrderNoteRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteWorkOrderNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest} message DeleteWorkOrderNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteWorkOrderNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteWorkOrderNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteWorkOrderNoteRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteWorkOrderNoteRequest;
        })();

        racehorse360.Workout = (function () {
          /**
           * Properties of a Workout.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkout
           * @property {string|null} [id] Workout id
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] Workout horse
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] Workout facility
           * @property {string|null} [date] Workout date
           * @property {string|null} [comment] Workout comment
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseSurface] Workout courseSurface
           * @property {number|null} [distance] Workout distance
           * @property {stronachgroup.first.racehorse360.DistanceUnit|null} [distanceUnit] Workout distanceUnit
           * @property {number|null} [timing] Workout timing
           * @property {number|null} [ranking] Workout ranking
           * @property {number|null} [numberInRankingGroup] Workout numberInRankingGroup
           * @property {stronachgroup.first.racehorse360.WorkoutType|null} [workoutType] Workout workoutType
           * @property {boolean|null} [gateIndicator] Workout gateIndicator
           * @property {boolean|null} [dogIndicator] Workout dogIndicator
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] Workout trackCondition
           */

          /**
           * Constructs a new Workout.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Workout.
           * @implements IWorkout
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkout=} [properties] Properties to set
           */
          function Workout(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Workout id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.id = "";

          /**
           * Workout horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.horse = null;

          /**
           * Workout facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.facility = null;

          /**
           * Workout date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.date = "";

          /**
           * Workout comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.comment = "";

          /**
           * Workout courseSurface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseSurface
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.courseSurface = 0;

          /**
           * Workout distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.distance = 0;

          /**
           * Workout distanceUnit.
           * @member {stronachgroup.first.racehorse360.DistanceUnit} distanceUnit
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.distanceUnit = 0;

          /**
           * Workout timing.
           * @member {number} timing
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.timing = 0;

          /**
           * Workout ranking.
           * @member {number} ranking
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.ranking = 0;

          /**
           * Workout numberInRankingGroup.
           * @member {number} numberInRankingGroup
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.numberInRankingGroup = 0;

          /**
           * Workout workoutType.
           * @member {stronachgroup.first.racehorse360.WorkoutType} workoutType
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.workoutType = 0;

          /**
           * Workout gateIndicator.
           * @member {boolean} gateIndicator
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.gateIndicator = false;

          /**
           * Workout dogIndicator.
           * @member {boolean} dogIndicator
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.dogIndicator = false;

          /**
           * Workout trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           */
          Workout.prototype.trackCondition = 0;

          /**
           * Creates a new Workout instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Workout
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkout=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Workout} Workout instance
           */
          Workout.create = function create(properties) {
            return new Workout(properties);
          };

          /**
           * Encodes the specified Workout message. Does not implicitly {@link stronachgroup.first.racehorse360.Workout.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Workout
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkout} message Workout message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Workout.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.date);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.comment);
            if (
              message.courseSurface != null &&
              Object.hasOwnProperty.call(message, "courseSurface")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.courseSurface);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.distance);
            if (
              message.distanceUnit != null &&
              Object.hasOwnProperty.call(message, "distanceUnit")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.distanceUnit);
            if (
              message.timing != null &&
              Object.hasOwnProperty.call(message, "timing")
            )
              writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.timing);
            if (
              message.ranking != null &&
              Object.hasOwnProperty.call(message, "ranking")
            )
              writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.ranking);
            if (
              message.numberInRankingGroup != null &&
              Object.hasOwnProperty.call(message, "numberInRankingGroup")
            )
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.numberInRankingGroup);
            if (
              message.workoutType != null &&
              Object.hasOwnProperty.call(message, "workoutType")
            )
              writer
                .uint32(/* id 12, wireType 0 =*/ 96)
                .int32(message.workoutType);
            if (
              message.gateIndicator != null &&
              Object.hasOwnProperty.call(message, "gateIndicator")
            )
              writer
                .uint32(/* id 13, wireType 0 =*/ 104)
                .bool(message.gateIndicator);
            if (
              message.dogIndicator != null &&
              Object.hasOwnProperty.call(message, "dogIndicator")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .bool(message.dogIndicator);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 15, wireType 0 =*/ 120)
                .int32(message.trackCondition);
            return writer;
          };

          /**
           * Decodes a Workout message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Workout
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Workout} Workout
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Workout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Workout();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.date = reader.string();
                  break;
                case 5:
                  message.comment = reader.string();
                  break;
                case 6:
                  message.courseSurface = reader.int32();
                  break;
                case 7:
                  message.distance = reader.int32();
                  break;
                case 8:
                  message.distanceUnit = reader.int32();
                  break;
                case 9:
                  message.timing = reader.int32();
                  break;
                case 10:
                  message.ranking = reader.int32();
                  break;
                case 11:
                  message.numberInRankingGroup = reader.int32();
                  break;
                case 12:
                  message.workoutType = reader.int32();
                  break;
                case 13:
                  message.gateIndicator = reader.bool();
                  break;
                case 14:
                  message.dogIndicator = reader.bool();
                  break;
                case 15:
                  message.trackCondition = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Workout message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Workout
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Workout} Workout
           */
          Workout.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.Workout
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Workout();
            if (object.id != null) message.id = String(object.id);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Workout.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Workout.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.date != null) message.date = String(object.date);
            if (object.comment != null)
              message.comment = String(object.comment);
            switch (object.courseSurface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseSurface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseSurface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseSurface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseSurface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseSurface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseSurface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseSurface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseSurface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseSurface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseSurface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseSurface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseSurface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseSurface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseSurface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseSurface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseSurface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseSurface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseSurface = 17;
                break;
            }
            if (object.distance != null) message.distance = object.distance | 0;
            switch (object.distanceUnit) {
              case "DISTANCE_UNIT_INVALID":
              case 0:
                message.distanceUnit = 0;
                break;
              case "DISTANCE_UNIT_FURLONG":
              case 1:
                message.distanceUnit = 1;
                break;
              case "DISTANCE_UNIT_METER":
              case 2:
                message.distanceUnit = 2;
                break;
              case "DISTANCE_UNIT_YARD":
              case 3:
                message.distanceUnit = 3;
                break;
            }
            if (object.timing != null) message.timing = object.timing | 0;
            if (object.ranking != null) message.ranking = object.ranking | 0;
            if (object.numberInRankingGroup != null)
              message.numberInRankingGroup = object.numberInRankingGroup | 0;
            switch (object.workoutType) {
              case "WORKOUT_TYPE_INVALID":
              case 0:
                message.workoutType = 0;
                break;
              case "WORKOUT_TYPE_BREEZING":
              case 1:
                message.workoutType = 1;
                break;
              case "WORKOUT_TYPE_DRIVING":
              case 2:
                message.workoutType = 2;
                break;
              case "WORKOUT_TYPE_HANDILY":
              case 3:
                message.workoutType = 3;
                break;
            }
            if (object.gateIndicator != null)
              message.gateIndicator = Boolean(object.gateIndicator);
            if (object.dogIndicator != null)
              message.dogIndicator = Boolean(object.dogIndicator);
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a Workout message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Workout
           * @static
           * @param {stronachgroup.first.racehorse360.Workout} message Workout
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Workout.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horse = null;
              object.facility = null;
              object.date = "";
              object.comment = "";
              object.courseSurface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.distance = 0;
              object.distanceUnit =
                options.enums === String ? "DISTANCE_UNIT_INVALID" : 0;
              object.timing = 0;
              object.ranking = 0;
              object.numberInRankingGroup = 0;
              object.workoutType =
                options.enums === String ? "WORKOUT_TYPE_INVALID" : 0;
              object.gateIndicator = false;
              object.dogIndicator = false;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.courseSurface != null &&
              message.hasOwnProperty("courseSurface")
            )
              object.courseSurface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseSurface
                    ]
                  : message.courseSurface;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.distanceUnit != null &&
              message.hasOwnProperty("distanceUnit")
            )
              object.distanceUnit =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.DistanceUnit[
                      message.distanceUnit
                    ]
                  : message.distanceUnit;
            if (message.timing != null && message.hasOwnProperty("timing"))
              object.timing = message.timing;
            if (message.ranking != null && message.hasOwnProperty("ranking"))
              object.ranking = message.ranking;
            if (
              message.numberInRankingGroup != null &&
              message.hasOwnProperty("numberInRankingGroup")
            )
              object.numberInRankingGroup = message.numberInRankingGroup;
            if (
              message.workoutType != null &&
              message.hasOwnProperty("workoutType")
            )
              object.workoutType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkoutType[
                      message.workoutType
                    ]
                  : message.workoutType;
            if (
              message.gateIndicator != null &&
              message.hasOwnProperty("gateIndicator")
            )
              object.gateIndicator = message.gateIndicator;
            if (
              message.dogIndicator != null &&
              message.hasOwnProperty("dogIndicator")
            )
              object.dogIndicator = message.dogIndicator;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            return object;
          };

          /**
           * Converts this Workout to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Workout
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Workout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Workout;
        })();

        racehorse360.WorkoutFilter = (function () {
          /**
           * Properties of a WorkoutFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutFilter
           * @property {Array.<string>|null} [ids] WorkoutFilter ids
           * @property {Array.<string>|null} [horseIds] WorkoutFilter horseIds
           * @property {Array.<string>|null} [facilityIds] WorkoutFilter facilityIds
           * @property {Array.<string>|null} [trainerIds] WorkoutFilter trainerIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [date] WorkoutFilter date
           * @property {Array.<string>|null} [horseFacilityIds] WorkoutFilter horseFacilityIds
           */

          /**
           * Constructs a new WorkoutFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutFilter.
           * @implements IWorkoutFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutFilter=} [properties] Properties to set
           */
          function WorkoutFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.facilityIds = [];
            this.trainerIds = [];
            this.horseFacilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.ids = $util.emptyArray;

          /**
           * WorkoutFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.horseIds = $util.emptyArray;

          /**
           * WorkoutFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * WorkoutFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * WorkoutFilter date.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} date
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.date = null;

          /**
           * WorkoutFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           */
          WorkoutFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * Creates a new WorkoutFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutFilter} WorkoutFilter instance
           */
          WorkoutFilter.create = function create(properties) {
            return new WorkoutFilter(properties);
          };

          /**
           * Encodes the specified WorkoutFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutFilter} message WorkoutFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.horseIds[i]);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.facilityIds[i]);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.date,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.trainerIds[i]);
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 8, wireType 2 =*/ 66)
                  .string(message.horseFacilityIds[i]);
            return writer;
          };

          /**
           * Decodes a WorkoutFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutFilter} WorkoutFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 4:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 5:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 7:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 6:
                  message.date =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutFilter} WorkoutFilter
           */
          WorkoutFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.date != null) {
              if (typeof object.date !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.date: object expected"
                );
              message.date =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.date
                );
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutFilter} message WorkoutFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.facilityIds = [];
              object.trainerIds = [];
              object.horseFacilityIds = [];
            }
            if (options.defaults) object.date = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.date != null && message.hasOwnProperty("date"))
              object.date =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.date,
                  options
                );
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            return object;
          };

          /**
           * Converts this WorkoutFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutFilter;
        })();

        racehorse360.ListWorkoutsRequest = (function () {
          /**
           * Properties of a ListWorkoutsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutsRequest
           * @property {stronachgroup.first.racehorse360.IWorkoutFilter|null} [query] ListWorkoutsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkoutsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkoutsRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkoutsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutsRequest.
           * @implements IListWorkoutsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutsRequest=} [properties] Properties to set
           */
          function ListWorkoutsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutsRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkoutFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @instance
           */
          ListWorkoutsRequest.prototype.query = null;

          /**
           * ListWorkoutsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @instance
           */
          ListWorkoutsRequest.prototype.getOptions = null;

          /**
           * ListWorkoutsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @instance
           */
          ListWorkoutsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkoutsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsRequest} ListWorkoutsRequest instance
           */
          ListWorkoutsRequest.create = function create(properties) {
            return new ListWorkoutsRequest(properties);
          };

          /**
           * Encodes the specified ListWorkoutsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutsRequest} message ListWorkoutsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkoutFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsRequest} ListWorkoutsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkoutFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsRequest} ListWorkoutsRequest
           */
          ListWorkoutsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkoutsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkoutFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutsRequest} message ListWorkoutsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutsRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkoutFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkoutsRequest;
        })();

        racehorse360.ListWorkoutsResponse = (function () {
          /**
           * Properties of a ListWorkoutsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkout>|null} [workouts] ListWorkoutsResponse workouts
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkoutsResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkoutsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutsResponse.
           * @implements IListWorkoutsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutsResponse=} [properties] Properties to set
           */
          function ListWorkoutsResponse(properties) {
            this.workouts = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutsResponse workouts.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkout>} workouts
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @instance
           */
          ListWorkoutsResponse.prototype.workouts = $util.emptyArray;

          /**
           * ListWorkoutsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @instance
           */
          ListWorkoutsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkoutsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsResponse} ListWorkoutsResponse instance
           */
          ListWorkoutsResponse.create = function create(properties) {
            return new ListWorkoutsResponse(properties);
          };

          /**
           * Encodes the specified ListWorkoutsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutsResponse} message ListWorkoutsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.workouts != null && message.workouts.length)
              for (var i = 0; i < message.workouts.length; ++i)
                $root.stronachgroup.first.racehorse360.Workout.encode(
                  message.workouts[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsResponse} ListWorkoutsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.workouts && message.workouts.length))
                    message.workouts = [];
                  message.workouts.push(
                    $root.stronachgroup.first.racehorse360.Workout.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutsResponse} ListWorkoutsResponse
           */
          ListWorkoutsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkoutsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutsResponse();
            if (object.workouts) {
              if (!Array.isArray(object.workouts))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutsResponse.workouts: array expected"
                );
              message.workouts = [];
              for (var i = 0; i < object.workouts.length; ++i) {
                if (typeof object.workouts[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutsResponse.workouts: object expected"
                  );
                message.workouts[i] =
                  $root.stronachgroup.first.racehorse360.Workout.fromObject(
                    object.workouts[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutsResponse} message ListWorkoutsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutsResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.workouts = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.workouts && message.workouts.length) {
              object.workouts = [];
              for (var j = 0; j < message.workouts.length; ++j)
                object.workouts[j] =
                  $root.stronachgroup.first.racehorse360.Workout.toObject(
                    message.workouts[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkoutsResponse;
        })();

        racehorse360.WorkoutRequest = (function () {
          /**
           * Properties of a WorkoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequest
           * @property {string|null} [id] WorkoutRequest id
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] WorkoutRequest horse
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] WorkoutRequest facility
           * @property {string|null} [date] WorkoutRequest date
           * @property {stronachgroup.first.racehorse360.WorkoutRequestStatus|null} [status] WorkoutRequest status
           * @property {stronachgroup.first.racehorse360.IHorseExam|null} [workoutExam] WorkoutRequest workoutExam
           * @property {boolean|null} [hasComment] WorkoutRequest hasComment
           * @property {number|null} [highSpeedFurlongs] WorkoutRequest highSpeedFurlongs
           * @property {boolean|null} [isFlagged] WorkoutRequest isFlagged
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestFlag|null} [flag] WorkoutRequest flag
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestExamReasonNote|null} [examReasonNote] WorkoutRequest examReasonNote
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment|null} [rejectionNote] WorkoutRequest rejectionNote
           * @property {number|null} [pastWorkoutRequestsCount] WorkoutRequest pastWorkoutRequestsCount
           * @property {boolean|null} [hasRacingSecretaryComment] WorkoutRequest hasRacingSecretaryComment
           * @property {string|null} [createdOn] WorkoutRequest createdOn
           * @property {string|null} [updatedOn] WorkoutRequest updatedOn
           */

          /**
           * Constructs a new WorkoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequest.
           * @implements IWorkoutRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequest=} [properties] Properties to set
           */
          function WorkoutRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.id = "";

          /**
           * WorkoutRequest horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.horse = null;

          /**
           * WorkoutRequest facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.facility = null;

          /**
           * WorkoutRequest date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.date = "";

          /**
           * WorkoutRequest status.
           * @member {stronachgroup.first.racehorse360.WorkoutRequestStatus} status
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.status = 0;

          /**
           * WorkoutRequest workoutExam.
           * @member {stronachgroup.first.racehorse360.IHorseExam|null|undefined} workoutExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.workoutExam = null;

          /**
           * WorkoutRequest hasComment.
           * @member {boolean} hasComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.hasComment = false;

          /**
           * WorkoutRequest highSpeedFurlongs.
           * @member {number} highSpeedFurlongs
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.highSpeedFurlongs = 0;

          /**
           * WorkoutRequest isFlagged.
           * @member {boolean} isFlagged
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.isFlagged = false;

          /**
           * WorkoutRequest flag.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestFlag|null|undefined} flag
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.flag = null;

          /**
           * WorkoutRequest examReasonNote.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestExamReasonNote|null|undefined} examReasonNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.examReasonNote = null;

          /**
           * WorkoutRequest rejectionNote.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment|null|undefined} rejectionNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.rejectionNote = null;

          /**
           * WorkoutRequest pastWorkoutRequestsCount.
           * @member {number} pastWorkoutRequestsCount
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.pastWorkoutRequestsCount = 0;

          /**
           * WorkoutRequest hasRacingSecretaryComment.
           * @member {boolean} hasRacingSecretaryComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.hasRacingSecretaryComment = false;

          /**
           * WorkoutRequest createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.createdOn = "";

          /**
           * WorkoutRequest updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           */
          WorkoutRequest.prototype.updatedOn = "";

          /**
           * Creates a new WorkoutRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequest} WorkoutRequest instance
           */
          WorkoutRequest.create = function create(properties) {
            return new WorkoutRequest(properties);
          };

          /**
           * Encodes the specified WorkoutRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequest} message WorkoutRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.date);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.status);
            if (
              message.workoutExam != null &&
              Object.hasOwnProperty.call(message, "workoutExam")
            )
              $root.stronachgroup.first.racehorse360.HorseExam.encode(
                message.workoutExam,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.hasComment != null &&
              Object.hasOwnProperty.call(message, "hasComment")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .bool(message.hasComment);
            if (
              message.highSpeedFurlongs != null &&
              Object.hasOwnProperty.call(message, "highSpeedFurlongs")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .int32(message.highSpeedFurlongs);
            if (
              message.isFlagged != null &&
              Object.hasOwnProperty.call(message, "isFlagged")
            )
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .bool(message.isFlagged);
            if (
              message.flag != null &&
              Object.hasOwnProperty.call(message, "flag")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestFlag.encode(
                message.flag,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.examReasonNote != null &&
              Object.hasOwnProperty.call(message, "examReasonNote")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.encode(
                message.examReasonNote,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.rejectionNote != null &&
              Object.hasOwnProperty.call(message, "rejectionNote")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.encode(
                message.rejectionNote,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.pastWorkoutRequestsCount != null &&
              Object.hasOwnProperty.call(message, "pastWorkoutRequestsCount")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.pastWorkoutRequestsCount);
            if (
              message.hasRacingSecretaryComment != null &&
              Object.hasOwnProperty.call(message, "hasRacingSecretaryComment")
            )
              writer
                .uint32(/* id 15, wireType 0 =*/ 120)
                .bool(message.hasRacingSecretaryComment);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            return writer;
          };

          /**
           * Decodes a WorkoutRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequest} WorkoutRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.date = reader.string();
                  break;
                case 5:
                  message.status = reader.int32();
                  break;
                case 7:
                  message.workoutExam =
                    $root.stronachgroup.first.racehorse360.HorseExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.hasComment = reader.bool();
                  break;
                case 9:
                  message.highSpeedFurlongs = reader.int32();
                  break;
                case 10:
                  message.isFlagged = reader.bool();
                  break;
                case 11:
                  message.flag =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestFlag.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.examReasonNote =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  message.rejectionNote =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.pastWorkoutRequestsCount = reader.int32();
                  break;
                case 15:
                  message.hasRacingSecretaryComment = reader.bool();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequest} WorkoutRequest
           */
          WorkoutRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.date != null) message.date = String(object.date);
            switch (object.status) {
              case "WORKOUT_REQUEST_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "WORKOUT_REQUEST_STATUS_REQUESTED":
              case 1:
                message.status = 1;
                break;
              case "WORKOUT_REQUEST_STATUS_EXAM_PENDING":
              case 2:
                message.status = 2;
                break;
              case "WORKOUT_REQUEST_STATUS_APPROVED":
              case 3:
                message.status = 3;
                break;
              case "WORKOUT_REQUEST_STATUS_DENIED":
              case 4:
                message.status = 4;
                break;
              case "WORKOUT_REQUEST_STATUS_CANCELLED":
              case 5:
                message.status = 5;
                break;
              case "WORKOUT_REQUEST_STATUS_REJECTED":
              case 6:
                message.status = 6;
                break;
            }
            if (object.workoutExam != null) {
              if (typeof object.workoutExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.workoutExam: object expected"
                );
              message.workoutExam =
                $root.stronachgroup.first.racehorse360.HorseExam.fromObject(
                  object.workoutExam
                );
            }
            if (object.hasComment != null)
              message.hasComment = Boolean(object.hasComment);
            if (object.highSpeedFurlongs != null)
              message.highSpeedFurlongs = object.highSpeedFurlongs | 0;
            if (object.isFlagged != null)
              message.isFlagged = Boolean(object.isFlagged);
            if (object.flag != null) {
              if (typeof object.flag !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.flag: object expected"
                );
              message.flag =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFlag.fromObject(
                  object.flag
                );
            }
            if (object.examReasonNote != null) {
              if (typeof object.examReasonNote !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.examReasonNote: object expected"
                );
              message.examReasonNote =
                $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.fromObject(
                  object.examReasonNote
                );
            }
            if (object.rejectionNote != null) {
              if (typeof object.rejectionNote !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequest.rejectionNote: object expected"
                );
              message.rejectionNote =
                $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.fromObject(
                  object.rejectionNote
                );
            }
            if (object.pastWorkoutRequestsCount != null)
              message.pastWorkoutRequestsCount =
                object.pastWorkoutRequestsCount | 0;
            if (object.hasRacingSecretaryComment != null)
              message.hasRacingSecretaryComment = Boolean(
                object.hasRacingSecretaryComment
              );
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} message WorkoutRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horse = null;
              object.facility = null;
              object.date = "";
              object.status =
                options.enums === String ? "WORKOUT_REQUEST_STATUS_INVALID" : 0;
              object.workoutExam = null;
              object.hasComment = false;
              object.highSpeedFurlongs = 0;
              object.isFlagged = false;
              object.flag = null;
              object.examReasonNote = null;
              object.rejectionNote = null;
              object.pastWorkoutRequestsCount = 0;
              object.hasRacingSecretaryComment = false;
              object.createdOn = "";
              object.updatedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.WorkoutRequestStatus[
                      message.status
                    ]
                  : message.status;
            if (
              message.workoutExam != null &&
              message.hasOwnProperty("workoutExam")
            )
              object.workoutExam =
                $root.stronachgroup.first.racehorse360.HorseExam.toObject(
                  message.workoutExam,
                  options
                );
            if (
              message.hasComment != null &&
              message.hasOwnProperty("hasComment")
            )
              object.hasComment = message.hasComment;
            if (
              message.highSpeedFurlongs != null &&
              message.hasOwnProperty("highSpeedFurlongs")
            )
              object.highSpeedFurlongs = message.highSpeedFurlongs;
            if (
              message.isFlagged != null &&
              message.hasOwnProperty("isFlagged")
            )
              object.isFlagged = message.isFlagged;
            if (message.flag != null && message.hasOwnProperty("flag"))
              object.flag =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFlag.toObject(
                  message.flag,
                  options
                );
            if (
              message.examReasonNote != null &&
              message.hasOwnProperty("examReasonNote")
            )
              object.examReasonNote =
                $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.toObject(
                  message.examReasonNote,
                  options
                );
            if (
              message.rejectionNote != null &&
              message.hasOwnProperty("rejectionNote")
            )
              object.rejectionNote =
                $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.toObject(
                  message.rejectionNote,
                  options
                );
            if (
              message.pastWorkoutRequestsCount != null &&
              message.hasOwnProperty("pastWorkoutRequestsCount")
            )
              object.pastWorkoutRequestsCount =
                message.pastWorkoutRequestsCount;
            if (
              message.hasRacingSecretaryComment != null &&
              message.hasOwnProperty("hasRacingSecretaryComment")
            )
              object.hasRacingSecretaryComment =
                message.hasRacingSecretaryComment;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            return object;
          };

          /**
           * Converts this WorkoutRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequest;
        })();

        racehorse360.WorkoutRequestFlag = (function () {
          /**
           * Properties of a WorkoutRequestFlag.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestFlag
           * @property {string|null} [id] WorkoutRequestFlag id
           * @property {stronachgroup.first.racehorse360.WorkoutRequestFlagPriority|null} [priority] WorkoutRequestFlag priority
           * @property {stronachgroup.first.racehorse360.IUser|null} [flaggedBy] WorkoutRequestFlag flaggedBy
           * @property {string|null} [flaggedOn] WorkoutRequestFlag flaggedOn
           */

          /**
           * Constructs a new WorkoutRequestFlag.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestFlag.
           * @implements IWorkoutRequestFlag
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFlag=} [properties] Properties to set
           */
          function WorkoutRequestFlag(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestFlag id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @instance
           */
          WorkoutRequestFlag.prototype.id = "";

          /**
           * WorkoutRequestFlag priority.
           * @member {stronachgroup.first.racehorse360.WorkoutRequestFlagPriority} priority
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @instance
           */
          WorkoutRequestFlag.prototype.priority = 0;

          /**
           * WorkoutRequestFlag flaggedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} flaggedBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @instance
           */
          WorkoutRequestFlag.prototype.flaggedBy = null;

          /**
           * WorkoutRequestFlag flaggedOn.
           * @member {string} flaggedOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @instance
           */
          WorkoutRequestFlag.prototype.flaggedOn = "";

          /**
           * Creates a new WorkoutRequestFlag instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFlag=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFlag} WorkoutRequestFlag instance
           */
          WorkoutRequestFlag.create = function create(properties) {
            return new WorkoutRequestFlag(properties);
          };

          /**
           * Encodes the specified WorkoutRequestFlag message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestFlag.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFlag} message WorkoutRequestFlag message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestFlag.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.priority != null &&
              Object.hasOwnProperty.call(message, "priority")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.priority);
            if (
              message.flaggedBy != null &&
              Object.hasOwnProperty.call(message, "flaggedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.flaggedBy,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.flaggedOn != null &&
              Object.hasOwnProperty.call(message, "flaggedOn")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.flaggedOn);
            return writer;
          };

          /**
           * Decodes a WorkoutRequestFlag message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFlag} WorkoutRequestFlag
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestFlag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestFlag();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 3:
                  message.priority = reader.int32();
                  break;
                case 4:
                  message.flaggedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.flaggedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestFlag message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFlag} WorkoutRequestFlag
           */
          WorkoutRequestFlag.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutRequestFlag
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestFlag();
            if (object.id != null) message.id = String(object.id);
            switch (object.priority) {
              case "WORKOUT_REQUEST_FLAG_PRIORITY_INVALID":
              case 0:
                message.priority = 0;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_LOWER":
              case 1:
                message.priority = 1;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_MEDIUM":
              case 2:
                message.priority = 2;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_HIGHEST":
              case 3:
                message.priority = 3;
                break;
            }
            if (object.flaggedBy != null) {
              if (typeof object.flaggedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFlag.flaggedBy: object expected"
                );
              message.flaggedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.flaggedBy
                );
            }
            if (object.flaggedOn != null)
              message.flaggedOn = String(object.flaggedOn);
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestFlag message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestFlag} message WorkoutRequestFlag
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestFlag.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.priority =
                options.enums === String
                  ? "WORKOUT_REQUEST_FLAG_PRIORITY_INVALID"
                  : 0;
              object.flaggedBy = null;
              object.flaggedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.priority != null && message.hasOwnProperty("priority"))
              object.priority =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .WorkoutRequestFlagPriority[message.priority]
                  : message.priority;
            if (
              message.flaggedBy != null &&
              message.hasOwnProperty("flaggedBy")
            )
              object.flaggedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.flaggedBy,
                  options
                );
            if (
              message.flaggedOn != null &&
              message.hasOwnProperty("flaggedOn")
            )
              object.flaggedOn = message.flaggedOn;
            return object;
          };

          /**
           * Converts this WorkoutRequestFlag to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFlag
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestFlag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestFlag;
        })();

        racehorse360.WorkoutRequestExamReasonNote = (function () {
          /**
           * Properties of a WorkoutRequestExamReasonNote.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestExamReasonNote
           * @property {string|null} [id] WorkoutRequestExamReasonNote id
           * @property {string|null} [body] WorkoutRequestExamReasonNote body
           * @property {string|null} [notedOn] WorkoutRequestExamReasonNote notedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [notedBy] WorkoutRequestExamReasonNote notedBy
           */

          /**
           * Constructs a new WorkoutRequestExamReasonNote.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestExamReasonNote.
           * @implements IWorkoutRequestExamReasonNote
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestExamReasonNote=} [properties] Properties to set
           */
          function WorkoutRequestExamReasonNote(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestExamReasonNote id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @instance
           */
          WorkoutRequestExamReasonNote.prototype.id = "";

          /**
           * WorkoutRequestExamReasonNote body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @instance
           */
          WorkoutRequestExamReasonNote.prototype.body = "";

          /**
           * WorkoutRequestExamReasonNote notedOn.
           * @member {string} notedOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @instance
           */
          WorkoutRequestExamReasonNote.prototype.notedOn = "";

          /**
           * WorkoutRequestExamReasonNote notedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} notedBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @instance
           */
          WorkoutRequestExamReasonNote.prototype.notedBy = null;

          /**
           * Creates a new WorkoutRequestExamReasonNote instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestExamReasonNote=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote} WorkoutRequestExamReasonNote instance
           */
          WorkoutRequestExamReasonNote.create = function create(properties) {
            return new WorkoutRequestExamReasonNote(properties);
          };

          /**
           * Encodes the specified WorkoutRequestExamReasonNote message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestExamReasonNote} message WorkoutRequestExamReasonNote message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestExamReasonNote.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.notedOn != null &&
              Object.hasOwnProperty.call(message, "notedOn")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.notedOn);
            if (
              message.notedBy != null &&
              Object.hasOwnProperty.call(message, "notedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.notedBy,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkoutRequestExamReasonNote message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote} WorkoutRequestExamReasonNote
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestExamReasonNote.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 3:
                  message.notedOn = reader.string();
                  break;
                case 4:
                  message.notedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestExamReasonNote message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote} WorkoutRequestExamReasonNote
           */
          WorkoutRequestExamReasonNote.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .WorkoutRequestExamReasonNote
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.notedOn != null)
              message.notedOn = String(object.notedOn);
            if (object.notedBy != null) {
              if (typeof object.notedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote.notedBy: object expected"
                );
              message.notedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.notedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestExamReasonNote message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote} message WorkoutRequestExamReasonNote
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestExamReasonNote.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.notedOn = "";
              object.notedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (message.notedOn != null && message.hasOwnProperty("notedOn"))
              object.notedOn = message.notedOn;
            if (message.notedBy != null && message.hasOwnProperty("notedBy"))
              object.notedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.notedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkoutRequestExamReasonNote to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestExamReasonNote
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestExamReasonNote.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestExamReasonNote;
        })();

        racehorse360.WorkoutRequestFilter = (function () {
          /**
           * Properties of a WorkoutRequestFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestFilter
           * @property {Array.<string>|null} [ids] WorkoutRequestFilter ids
           * @property {Array.<stronachgroup.first.racehorse360.WorkoutRequestStatus>|null} [statuses] WorkoutRequestFilter statuses
           * @property {Array.<string>|null} [horseIds] WorkoutRequestFilter horseIds
           * @property {Array.<string>|null} [facilityIds] WorkoutRequestFilter facilityIds
           * @property {Array.<string>|null} [trainerIds] WorkoutRequestFilter trainerIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [date] WorkoutRequestFilter date
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseOrTrainerName] WorkoutRequestFilter horseOrTrainerName
           * @property {Array.<string>|null} [horseFacilityIds] WorkoutRequestFilter horseFacilityIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [decisionDate] WorkoutRequestFilter decisionDate
           * @property {stronachgroup.first.racehorse360.IHorseExamFilter|null} [horseExamSubFilter] WorkoutRequestFilter horseExamSubFilter
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseChipNumber] WorkoutRequestFilter horseChipNumber
           */

          /**
           * Constructs a new WorkoutRequestFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestFilter.
           * @implements IWorkoutRequestFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFilter=} [properties] Properties to set
           */
          function WorkoutRequestFilter(properties) {
            this.ids = [];
            this.statuses = [];
            this.horseIds = [];
            this.facilityIds = [];
            this.trainerIds = [];
            this.horseFacilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.ids = $util.emptyArray;

          /**
           * WorkoutRequestFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.WorkoutRequestStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.statuses = $util.emptyArray;

          /**
           * WorkoutRequestFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.horseIds = $util.emptyArray;

          /**
           * WorkoutRequestFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * WorkoutRequestFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * WorkoutRequestFilter date.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} date
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.date = null;

          /**
           * WorkoutRequestFilter horseOrTrainerName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseOrTrainerName
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.horseOrTrainerName = null;

          /**
           * WorkoutRequestFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * WorkoutRequestFilter decisionDate.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} decisionDate
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.decisionDate = null;

          /**
           * WorkoutRequestFilter horseExamSubFilter.
           * @member {stronachgroup.first.racehorse360.IHorseExamFilter|null|undefined} horseExamSubFilter
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.horseExamSubFilter = null;

          /**
           * WorkoutRequestFilter horseChipNumber.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseChipNumber
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           */
          WorkoutRequestFilter.prototype.horseChipNumber = null;

          /**
           * Creates a new WorkoutRequestFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFilter} WorkoutRequestFilter instance
           */
          WorkoutRequestFilter.create = function create(properties) {
            return new WorkoutRequestFilter(properties);
          };

          /**
           * Encodes the specified WorkoutRequestFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestFilter} message WorkoutRequestFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.horseIds[i]);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.facilityIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.trainerIds[i]);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.date,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            if (
              message.horseOrTrainerName != null &&
              Object.hasOwnProperty.call(message, "horseOrTrainerName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseOrTrainerName,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 10, wireType 2 =*/ 82)
                  .string(message.horseFacilityIds[i]);
            if (
              message.decisionDate != null &&
              Object.hasOwnProperty.call(message, "decisionDate")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.decisionDate,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.horseExamSubFilter != null &&
              Object.hasOwnProperty.call(message, "horseExamSubFilter")
            )
              $root.stronachgroup.first.racehorse360.HorseExamFilter.encode(
                message.horseExamSubFilter,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.horseChipNumber != null &&
              Object.hasOwnProperty.call(message, "horseChipNumber")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseChipNumber,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkoutRequestFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFilter} WorkoutRequestFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 4:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                case 5:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 6:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 7:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 8:
                  message.date =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 9:
                  message.horseOrTrainerName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                case 11:
                  message.decisionDate =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.horseExamSubFilter =
                    $root.stronachgroup.first.racehorse360.HorseExamFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  message.horseChipNumber =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestFilter} WorkoutRequestFilter
           */
          WorkoutRequestFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutRequestFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "WORKOUT_REQUEST_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "WORKOUT_REQUEST_STATUS_REQUESTED":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "WORKOUT_REQUEST_STATUS_EXAM_PENDING":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                  case "WORKOUT_REQUEST_STATUS_APPROVED":
                  case 3:
                    message.statuses[i] = 3;
                    break;
                  case "WORKOUT_REQUEST_STATUS_DENIED":
                  case 4:
                    message.statuses[i] = 4;
                    break;
                  case "WORKOUT_REQUEST_STATUS_CANCELLED":
                  case 5:
                    message.statuses[i] = 5;
                    break;
                  case "WORKOUT_REQUEST_STATUS_REJECTED":
                  case 6:
                    message.statuses[i] = 6;
                    break;
                }
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.date != null) {
              if (typeof object.date !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.date: object expected"
                );
              message.date =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.date
                );
            }
            if (object.horseOrTrainerName != null) {
              if (typeof object.horseOrTrainerName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.horseOrTrainerName: object expected"
                );
              message.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseOrTrainerName
                );
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            if (object.decisionDate != null) {
              if (typeof object.decisionDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.decisionDate: object expected"
                );
              message.decisionDate =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.decisionDate
                );
            }
            if (object.horseExamSubFilter != null) {
              if (typeof object.horseExamSubFilter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.horseExamSubFilter: object expected"
                );
              message.horseExamSubFilter =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.fromObject(
                  object.horseExamSubFilter
                );
            }
            if (object.horseChipNumber != null) {
              if (typeof object.horseChipNumber !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestFilter.horseChipNumber: object expected"
                );
              message.horseChipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseChipNumber
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestFilter} message WorkoutRequestFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.statuses = [];
              object.horseIds = [];
              object.facilityIds = [];
              object.trainerIds = [];
              object.horseFacilityIds = [];
            }
            if (options.defaults) {
              object.date = null;
              object.horseOrTrainerName = null;
              object.decisionDate = null;
              object.horseExamSubFilter = null;
              object.horseChipNumber = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .WorkoutRequestStatus[message.statuses[j]]
                    : message.statuses[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.date != null && message.hasOwnProperty("date"))
              object.date =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.date,
                  options
                );
            if (
              message.horseOrTrainerName != null &&
              message.hasOwnProperty("horseOrTrainerName")
            )
              object.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseOrTrainerName,
                  options
                );
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            if (
              message.decisionDate != null &&
              message.hasOwnProperty("decisionDate")
            )
              object.decisionDate =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.decisionDate,
                  options
                );
            if (
              message.horseExamSubFilter != null &&
              message.hasOwnProperty("horseExamSubFilter")
            )
              object.horseExamSubFilter =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.toObject(
                  message.horseExamSubFilter,
                  options
                );
            if (
              message.horseChipNumber != null &&
              message.hasOwnProperty("horseChipNumber")
            )
              object.horseChipNumber =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseChipNumber,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkoutRequestFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestFilter;
        })();

        racehorse360.ListWorkoutRequestsResponse = (function () {
          /**
           * Properties of a ListWorkoutRequestsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutRequestsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkoutRequest>|null} [workoutRequests] ListWorkoutRequestsResponse workoutRequests
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkoutRequestsResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkoutRequestsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutRequestsResponse.
           * @implements IListWorkoutRequestsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsResponse=} [properties] Properties to set
           */
          function ListWorkoutRequestsResponse(properties) {
            this.workoutRequests = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutRequestsResponse workoutRequests.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkoutRequest>} workoutRequests
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @instance
           */
          ListWorkoutRequestsResponse.prototype.workoutRequests =
            $util.emptyArray;

          /**
           * ListWorkoutRequestsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @instance
           */
          ListWorkoutRequestsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkoutRequestsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} ListWorkoutRequestsResponse instance
           */
          ListWorkoutRequestsResponse.create = function create(properties) {
            return new ListWorkoutRequestsResponse(properties);
          };

          /**
           * Encodes the specified ListWorkoutRequestsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsResponse} message ListWorkoutRequestsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutRequestsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.workoutRequests != null &&
              message.workoutRequests.length
            )
              for (var i = 0; i < message.workoutRequests.length; ++i)
                $root.stronachgroup.first.racehorse360.WorkoutRequest.encode(
                  message.workoutRequests[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutRequestsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} ListWorkoutRequestsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutRequestsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.workoutRequests && message.workoutRequests.length)
                  )
                    message.workoutRequests = [];
                  message.workoutRequests.push(
                    $root.stronachgroup.first.racehorse360.WorkoutRequest.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutRequestsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} ListWorkoutRequestsResponse
           */
          ListWorkoutRequestsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse();
            if (object.workoutRequests) {
              if (!Array.isArray(object.workoutRequests))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.workoutRequests: array expected"
                );
              message.workoutRequests = [];
              for (var i = 0; i < object.workoutRequests.length; ++i) {
                if (typeof object.workoutRequests[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.workoutRequests: object expected"
                  );
                message.workoutRequests[i] =
                  $root.stronachgroup.first.racehorse360.WorkoutRequest.fromObject(
                    object.workoutRequests[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutRequestsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} message ListWorkoutRequestsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutRequestsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.workoutRequests = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.workoutRequests && message.workoutRequests.length) {
              object.workoutRequests = [];
              for (var j = 0; j < message.workoutRequests.length; ++j)
                object.workoutRequests[j] =
                  $root.stronachgroup.first.racehorse360.WorkoutRequest.toObject(
                    message.workoutRequests[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutRequestsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutRequestsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkoutRequestsResponse;
        })();

        racehorse360.GetWorkoutRequestRequest = (function () {
          /**
           * Properties of a GetWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetWorkoutRequestRequest
           * @property {string|null} [id] GetWorkoutRequestRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new GetWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetWorkoutRequestRequest.
           * @implements IGetWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRequest=} [properties] Properties to set
           */
          function GetWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @instance
           */
          GetWorkoutRequestRequest.prototype.id = "";

          /**
           * GetWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @instance
           */
          GetWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new GetWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRequest} GetWorkoutRequestRequest instance
           */
          GetWorkoutRequestRequest.create = function create(properties) {
            return new GetWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified GetWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRequest} message GetWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetWorkoutRequestRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRequest} GetWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRequest} GetWorkoutRequestRequest
           */
          GetWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetWorkoutRequestRequest} message GetWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetWorkoutRequestRequest;
        })();

        racehorse360.CreateWorkoutRequestRequest = (function () {
          /**
           * Properties of a CreateWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateWorkoutRequestRequest
           * @property {string|null} [facilityId] CreateWorkoutRequestRequest facilityId
           * @property {string|null} [horseId] CreateWorkoutRequestRequest horseId
           * @property {string|null} [date] CreateWorkoutRequestRequest date
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new CreateWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateWorkoutRequestRequest.
           * @implements ICreateWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestRequest=} [properties] Properties to set
           */
          function CreateWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateWorkoutRequestRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @instance
           */
          CreateWorkoutRequestRequest.prototype.facilityId = "";

          /**
           * CreateWorkoutRequestRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @instance
           */
          CreateWorkoutRequestRequest.prototype.horseId = "";

          /**
           * CreateWorkoutRequestRequest date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @instance
           */
          CreateWorkoutRequestRequest.prototype.date = "";

          /**
           * CreateWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @instance
           */
          CreateWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} CreateWorkoutRequestRequest instance
           */
          CreateWorkoutRequestRequest.create = function create(properties) {
            return new CreateWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified CreateWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestRequest} message CreateWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horseId);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.date);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} CreateWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.horseId = reader.string();
                  break;
                case 3:
                  message.date = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} CreateWorkoutRequestRequest
           */
          CreateWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.date != null) message.date = String(object.date);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} message CreateWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.horseId = "";
              object.date = "";
              object.getOptions = null;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateWorkoutRequestRequest;
        })();

        racehorse360.DeleteWorkoutRequestRequest = (function () {
          /**
           * Properties of a DeleteWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteWorkoutRequestRequest
           * @property {string|null} [id] DeleteWorkoutRequestRequest id
           */

          /**
           * Constructs a new DeleteWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteWorkoutRequestRequest.
           * @implements IDeleteWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestRequest=} [properties] Properties to set
           */
          function DeleteWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @instance
           */
          DeleteWorkoutRequestRequest.prototype.id = "";

          /**
           * Creates a new DeleteWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} DeleteWorkoutRequestRequest instance
           */
          DeleteWorkoutRequestRequest.create = function create(properties) {
            return new DeleteWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified DeleteWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestRequest} message DeleteWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} DeleteWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} DeleteWorkoutRequestRequest
           */
          DeleteWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} message DeleteWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteWorkoutRequestRequest;
        })();

        racehorse360.ListWorkoutRequestsRequest = (function () {
          /**
           * Properties of a ListWorkoutRequestsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutRequestsRequest
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestFilter|null} [query] ListWorkoutRequestsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkoutRequestsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkoutRequestsRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkoutRequestsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutRequestsRequest.
           * @implements IListWorkoutRequestsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsRequest=} [properties] Properties to set
           */
          function ListWorkoutRequestsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutRequestsRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @instance
           */
          ListWorkoutRequestsRequest.prototype.query = null;

          /**
           * ListWorkoutRequestsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @instance
           */
          ListWorkoutRequestsRequest.prototype.getOptions = null;

          /**
           * ListWorkoutRequestsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @instance
           */
          ListWorkoutRequestsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkoutRequestsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} ListWorkoutRequestsRequest instance
           */
          ListWorkoutRequestsRequest.create = function create(properties) {
            return new ListWorkoutRequestsRequest(properties);
          };

          /**
           * Encodes the specified ListWorkoutRequestsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsRequest} message ListWorkoutRequestsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutRequestsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutRequestsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} ListWorkoutRequestsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutRequestsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutRequestsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} ListWorkoutRequestsRequest
           */
          ListWorkoutRequestsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutRequestsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} message ListWorkoutRequestsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutRequestsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkoutRequestFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutRequestsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutRequestsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListWorkoutRequestsRequest;
        })();

        racehorse360.BulkQuickPassWorkoutRequestRequest = (function () {
          /**
           * Properties of a BulkQuickPassWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBulkQuickPassWorkoutRequestRequest
           * @property {Array.<string>|null} [ids] BulkQuickPassWorkoutRequestRequest ids
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] BulkQuickPassWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new BulkQuickPassWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a BulkQuickPassWorkoutRequestRequest.
           * @implements IBulkQuickPassWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBulkQuickPassWorkoutRequestRequest=} [properties] Properties to set
           */
          function BulkQuickPassWorkoutRequestRequest(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * BulkQuickPassWorkoutRequestRequest ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @instance
           */
          BulkQuickPassWorkoutRequestRequest.prototype.ids = $util.emptyArray;

          /**
           * BulkQuickPassWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @instance
           */
          BulkQuickPassWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new BulkQuickPassWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkQuickPassWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} BulkQuickPassWorkoutRequestRequest instance
           */
          BulkQuickPassWorkoutRequestRequest.create = function create(
            properties
          ) {
            return new BulkQuickPassWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified BulkQuickPassWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkQuickPassWorkoutRequestRequest} message BulkQuickPassWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          BulkQuickPassWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a BulkQuickPassWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} BulkQuickPassWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          BulkQuickPassWorkoutRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a BulkQuickPassWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} BulkQuickPassWorkoutRequestRequest
           */
          BulkQuickPassWorkoutRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .BulkQuickPassWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a BulkQuickPassWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} message BulkQuickPassWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          BulkQuickPassWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) object.getOptions = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this BulkQuickPassWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          BulkQuickPassWorkoutRequestRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return BulkQuickPassWorkoutRequestRequest;
        })();

        racehorse360.RevertQuickPassWorkoutRequestExamRequest = (function () {
          /**
           * Properties of a RevertQuickPassWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRevertQuickPassWorkoutRequestExamRequest
           * @property {string|null} [id] RevertQuickPassWorkoutRequestExamRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RevertQuickPassWorkoutRequestExamRequest getOptions
           */

          /**
           * Constructs a new RevertQuickPassWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RevertQuickPassWorkoutRequestExamRequest.
           * @implements IRevertQuickPassWorkoutRequestExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassWorkoutRequestExamRequest=} [properties] Properties to set
           */
          function RevertQuickPassWorkoutRequestExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RevertQuickPassWorkoutRequestExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @instance
           */
          RevertQuickPassWorkoutRequestExamRequest.prototype.id = "";

          /**
           * RevertQuickPassWorkoutRequestExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @instance
           */
          RevertQuickPassWorkoutRequestExamRequest.prototype.getOptions = null;

          /**
           * Creates a new RevertQuickPassWorkoutRequestExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassWorkoutRequestExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} RevertQuickPassWorkoutRequestExamRequest instance
           */
          RevertQuickPassWorkoutRequestExamRequest.create = function create(
            properties
          ) {
            return new RevertQuickPassWorkoutRequestExamRequest(properties);
          };

          /**
           * Encodes the specified RevertQuickPassWorkoutRequestExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassWorkoutRequestExamRequest} message RevertQuickPassWorkoutRequestExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RevertQuickPassWorkoutRequestExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RevertQuickPassWorkoutRequestExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} RevertQuickPassWorkoutRequestExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RevertQuickPassWorkoutRequestExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RevertQuickPassWorkoutRequestExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} RevertQuickPassWorkoutRequestExamRequest
           */
          RevertQuickPassWorkoutRequestExamRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .RevertQuickPassWorkoutRequestExamRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a RevertQuickPassWorkoutRequestExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} message RevertQuickPassWorkoutRequestExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RevertQuickPassWorkoutRequestExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this RevertQuickPassWorkoutRequestExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RevertQuickPassWorkoutRequestExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return RevertQuickPassWorkoutRequestExamRequest;
        })();

        racehorse360.BulkRequireWorkoutRequestExamRequest = (function () {
          /**
           * Properties of a BulkRequireWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBulkRequireWorkoutRequestExamRequest
           * @property {Array.<string>|null} [ids] BulkRequireWorkoutRequestExamRequest ids
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] BulkRequireWorkoutRequestExamRequest getOptions
           */

          /**
           * Constructs a new BulkRequireWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a BulkRequireWorkoutRequestExamRequest.
           * @implements IBulkRequireWorkoutRequestExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBulkRequireWorkoutRequestExamRequest=} [properties] Properties to set
           */
          function BulkRequireWorkoutRequestExamRequest(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * BulkRequireWorkoutRequestExamRequest ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @instance
           */
          BulkRequireWorkoutRequestExamRequest.prototype.ids = $util.emptyArray;

          /**
           * BulkRequireWorkoutRequestExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @instance
           */
          BulkRequireWorkoutRequestExamRequest.prototype.getOptions = null;

          /**
           * Creates a new BulkRequireWorkoutRequestExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkRequireWorkoutRequestExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} BulkRequireWorkoutRequestExamRequest instance
           */
          BulkRequireWorkoutRequestExamRequest.create = function create(
            properties
          ) {
            return new BulkRequireWorkoutRequestExamRequest(properties);
          };

          /**
           * Encodes the specified BulkRequireWorkoutRequestExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkRequireWorkoutRequestExamRequest} message BulkRequireWorkoutRequestExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          BulkRequireWorkoutRequestExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a BulkRequireWorkoutRequestExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} BulkRequireWorkoutRequestExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          BulkRequireWorkoutRequestExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a BulkRequireWorkoutRequestExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} BulkRequireWorkoutRequestExamRequest
           */
          BulkRequireWorkoutRequestExamRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .BulkRequireWorkoutRequestExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a BulkRequireWorkoutRequestExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} message BulkRequireWorkoutRequestExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          BulkRequireWorkoutRequestExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) object.getOptions = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this BulkRequireWorkoutRequestExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          BulkRequireWorkoutRequestExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return BulkRequireWorkoutRequestExamRequest;
        })();

        racehorse360.BulkAssignWorkoutRequestExamRequest = (function () {
          /**
           * Properties of a BulkAssignWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IBulkAssignWorkoutRequestExamRequest
           * @property {Array.<string>|null} [ids] BulkAssignWorkoutRequestExamRequest ids
           * @property {string|null} [assignedVetId] BulkAssignWorkoutRequestExamRequest assignedVetId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] BulkAssignWorkoutRequestExamRequest getOptions
           */

          /**
           * Constructs a new BulkAssignWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a BulkAssignWorkoutRequestExamRequest.
           * @implements IBulkAssignWorkoutRequestExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IBulkAssignWorkoutRequestExamRequest=} [properties] Properties to set
           */
          function BulkAssignWorkoutRequestExamRequest(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * BulkAssignWorkoutRequestExamRequest ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @instance
           */
          BulkAssignWorkoutRequestExamRequest.prototype.ids = $util.emptyArray;

          /**
           * BulkAssignWorkoutRequestExamRequest assignedVetId.
           * @member {string} assignedVetId
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @instance
           */
          BulkAssignWorkoutRequestExamRequest.prototype.assignedVetId = "";

          /**
           * BulkAssignWorkoutRequestExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @instance
           */
          BulkAssignWorkoutRequestExamRequest.prototype.getOptions = null;

          /**
           * Creates a new BulkAssignWorkoutRequestExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkAssignWorkoutRequestExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} BulkAssignWorkoutRequestExamRequest instance
           */
          BulkAssignWorkoutRequestExamRequest.create = function create(
            properties
          ) {
            return new BulkAssignWorkoutRequestExamRequest(properties);
          };

          /**
           * Encodes the specified BulkAssignWorkoutRequestExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IBulkAssignWorkoutRequestExamRequest} message BulkAssignWorkoutRequestExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          BulkAssignWorkoutRequestExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.assignedVetId != null &&
              Object.hasOwnProperty.call(message, "assignedVetId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.assignedVetId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a BulkAssignWorkoutRequestExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} BulkAssignWorkoutRequestExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          BulkAssignWorkoutRequestExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.assignedVetId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a BulkAssignWorkoutRequestExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} BulkAssignWorkoutRequestExamRequest
           */
          BulkAssignWorkoutRequestExamRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .BulkAssignWorkoutRequestExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.assignedVetId != null)
              message.assignedVetId = String(object.assignedVetId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a BulkAssignWorkoutRequestExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} message BulkAssignWorkoutRequestExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          BulkAssignWorkoutRequestExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) {
              object.assignedVetId = "";
              object.getOptions = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.assignedVetId != null &&
              message.hasOwnProperty("assignedVetId")
            )
              object.assignedVetId = message.assignedVetId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this BulkAssignWorkoutRequestExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          BulkAssignWorkoutRequestExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return BulkAssignWorkoutRequestExamRequest;
        })();

        racehorse360.UnassignWorkoutRequestExamRequest = (function () {
          /**
           * Properties of an UnassignWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUnassignWorkoutRequestExamRequest
           * @property {string|null} [id] UnassignWorkoutRequestExamRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UnassignWorkoutRequestExamRequest getOptions
           */

          /**
           * Constructs a new UnassignWorkoutRequestExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UnassignWorkoutRequestExamRequest.
           * @implements IUnassignWorkoutRequestExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUnassignWorkoutRequestExamRequest=} [properties] Properties to set
           */
          function UnassignWorkoutRequestExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnassignWorkoutRequestExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @instance
           */
          UnassignWorkoutRequestExamRequest.prototype.id = "";

          /**
           * UnassignWorkoutRequestExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @instance
           */
          UnassignWorkoutRequestExamRequest.prototype.getOptions = null;

          /**
           * Creates a new UnassignWorkoutRequestExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignWorkoutRequestExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} UnassignWorkoutRequestExamRequest instance
           */
          UnassignWorkoutRequestExamRequest.create = function create(
            properties
          ) {
            return new UnassignWorkoutRequestExamRequest(properties);
          };

          /**
           * Encodes the specified UnassignWorkoutRequestExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUnassignWorkoutRequestExamRequest} message UnassignWorkoutRequestExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnassignWorkoutRequestExamRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UnassignWorkoutRequestExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} UnassignWorkoutRequestExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnassignWorkoutRequestExamRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnassignWorkoutRequestExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} UnassignWorkoutRequestExamRequest
           */
          UnassignWorkoutRequestExamRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UnassignWorkoutRequestExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UnassignWorkoutRequestExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} message UnassignWorkoutRequestExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnassignWorkoutRequestExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UnassignWorkoutRequestExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnassignWorkoutRequestExamRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UnassignWorkoutRequestExamRequest;
        })();

        racehorse360.MoveFacilityWorkoutRequestRequest = (function () {
          /**
           * Properties of a MoveFacilityWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMoveFacilityWorkoutRequestRequest
           * @property {string|null} [id] MoveFacilityWorkoutRequestRequest id
           * @property {string|null} [facilityId] MoveFacilityWorkoutRequestRequest facilityId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] MoveFacilityWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new MoveFacilityWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a MoveFacilityWorkoutRequestRequest.
           * @implements IMoveFacilityWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMoveFacilityWorkoutRequestRequest=} [properties] Properties to set
           */
          function MoveFacilityWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * MoveFacilityWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @instance
           */
          MoveFacilityWorkoutRequestRequest.prototype.id = "";

          /**
           * MoveFacilityWorkoutRequestRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @instance
           */
          MoveFacilityWorkoutRequestRequest.prototype.facilityId = "";

          /**
           * MoveFacilityWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @instance
           */
          MoveFacilityWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new MoveFacilityWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMoveFacilityWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} MoveFacilityWorkoutRequestRequest instance
           */
          MoveFacilityWorkoutRequestRequest.create = function create(
            properties
          ) {
            return new MoveFacilityWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified MoveFacilityWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMoveFacilityWorkoutRequestRequest} message MoveFacilityWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          MoveFacilityWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a MoveFacilityWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} MoveFacilityWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          MoveFacilityWorkoutRequestRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facilityId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a MoveFacilityWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} MoveFacilityWorkoutRequestRequest
           */
          MoveFacilityWorkoutRequestRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .MoveFacilityWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a MoveFacilityWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} message MoveFacilityWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          MoveFacilityWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facilityId = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this MoveFacilityWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          MoveFacilityWorkoutRequestRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return MoveFacilityWorkoutRequestRequest;
        })();

        racehorse360.CancelWorkoutRequestRequest = (function () {
          /**
           * Properties of a CancelWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICancelWorkoutRequestRequest
           * @property {string|null} [id] CancelWorkoutRequestRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CancelWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new CancelWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CancelWorkoutRequestRequest.
           * @implements ICancelWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICancelWorkoutRequestRequest=} [properties] Properties to set
           */
          function CancelWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CancelWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @instance
           */
          CancelWorkoutRequestRequest.prototype.id = "";

          /**
           * CancelWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @instance
           */
          CancelWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new CancelWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} CancelWorkoutRequestRequest instance
           */
          CancelWorkoutRequestRequest.create = function create(properties) {
            return new CancelWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified CancelWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CancelWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelWorkoutRequestRequest} message CancelWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CancelWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CancelWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} CancelWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CancelWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CancelWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} CancelWorkoutRequestRequest
           */
          CancelWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CancelWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CancelWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} message CancelWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CancelWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CancelWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CancelWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CancelWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CancelWorkoutRequestRequest;
        })();

        racehorse360.RejectWorkoutRequestRequest = (function () {
          /**
           * Properties of a RejectWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRejectWorkoutRequestRequest
           * @property {string|null} [id] RejectWorkoutRequestRequest id
           * @property {string|null} [comment] RejectWorkoutRequestRequest comment
           * @property {boolean|null} [isImagingDiagnosticsRequired] RejectWorkoutRequestRequest isImagingDiagnosticsRequired
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RejectWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new RejectWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RejectWorkoutRequestRequest.
           * @implements IRejectWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRejectWorkoutRequestRequest=} [properties] Properties to set
           */
          function RejectWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RejectWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @instance
           */
          RejectWorkoutRequestRequest.prototype.id = "";

          /**
           * RejectWorkoutRequestRequest comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @instance
           */
          RejectWorkoutRequestRequest.prototype.comment = "";

          /**
           * RejectWorkoutRequestRequest isImagingDiagnosticsRequired.
           * @member {boolean} isImagingDiagnosticsRequired
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @instance
           */
          RejectWorkoutRequestRequest.prototype.isImagingDiagnosticsRequired = false;

          /**
           * RejectWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @instance
           */
          RejectWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new RejectWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRejectWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} RejectWorkoutRequestRequest instance
           */
          RejectWorkoutRequestRequest.create = function create(properties) {
            return new RejectWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified RejectWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RejectWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRejectWorkoutRequestRequest} message RejectWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RejectWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.comment);
            if (
              message.isImagingDiagnosticsRequired != null &&
              Object.hasOwnProperty.call(
                message,
                "isImagingDiagnosticsRequired"
              )
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .bool(message.isImagingDiagnosticsRequired);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RejectWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} RejectWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RejectWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.comment = reader.string();
                  break;
                case 3:
                  message.isImagingDiagnosticsRequired = reader.bool();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RejectWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} RejectWorkoutRequestRequest
           */
          RejectWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.isImagingDiagnosticsRequired != null)
              message.isImagingDiagnosticsRequired = Boolean(
                object.isImagingDiagnosticsRequired
              );
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RejectWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RejectWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} message RejectWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RejectWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.comment = "";
              object.isImagingDiagnosticsRequired = false;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.isImagingDiagnosticsRequired != null &&
              message.hasOwnProperty("isImagingDiagnosticsRequired")
            )
              object.isImagingDiagnosticsRequired =
                message.isImagingDiagnosticsRequired;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this RejectWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RejectWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RejectWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RejectWorkoutRequestRequest;
        })();

        racehorse360.RevertWorkoutRequestRequest = (function () {
          /**
           * Properties of a RevertWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRevertWorkoutRequestRequest
           * @property {string|null} [id] RevertWorkoutRequestRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] RevertWorkoutRequestRequest getOptions
           */

          /**
           * Constructs a new RevertWorkoutRequestRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RevertWorkoutRequestRequest.
           * @implements IRevertWorkoutRequestRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRevertWorkoutRequestRequest=} [properties] Properties to set
           */
          function RevertWorkoutRequestRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RevertWorkoutRequestRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @instance
           */
          RevertWorkoutRequestRequest.prototype.id = "";

          /**
           * RevertWorkoutRequestRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @instance
           */
          RevertWorkoutRequestRequest.prototype.getOptions = null;

          /**
           * Creates a new RevertWorkoutRequestRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRevertWorkoutRequestRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} RevertWorkoutRequestRequest instance
           */
          RevertWorkoutRequestRequest.create = function create(properties) {
            return new RevertWorkoutRequestRequest(properties);
          };

          /**
           * Encodes the specified RevertWorkoutRequestRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.RevertWorkoutRequestRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IRevertWorkoutRequestRequest} message RevertWorkoutRequestRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RevertWorkoutRequestRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a RevertWorkoutRequestRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} RevertWorkoutRequestRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RevertWorkoutRequestRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RevertWorkoutRequestRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} RevertWorkoutRequestRequest
           */
          RevertWorkoutRequestRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RevertWorkoutRequestRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a RevertWorkoutRequestRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @static
           * @param {stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} message RevertWorkoutRequestRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RevertWorkoutRequestRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this RevertWorkoutRequestRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RevertWorkoutRequestRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RevertWorkoutRequestRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RevertWorkoutRequestRequest;
        })();

        racehorse360.SetWorkoutRequestFlagRequest = (function () {
          /**
           * Properties of a SetWorkoutRequestFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetWorkoutRequestFlagRequest
           * @property {string|null} [id] SetWorkoutRequestFlagRequest id
           * @property {stronachgroup.first.racehorse360.WorkoutRequestFlagPriority|null} [priority] SetWorkoutRequestFlagRequest priority
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetWorkoutRequestFlagRequest getOptions
           */

          /**
           * Constructs a new SetWorkoutRequestFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetWorkoutRequestFlagRequest.
           * @implements ISetWorkoutRequestFlagRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestFlagRequest=} [properties] Properties to set
           */
          function SetWorkoutRequestFlagRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetWorkoutRequestFlagRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @instance
           */
          SetWorkoutRequestFlagRequest.prototype.id = "";

          /**
           * SetWorkoutRequestFlagRequest priority.
           * @member {stronachgroup.first.racehorse360.WorkoutRequestFlagPriority} priority
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @instance
           */
          SetWorkoutRequestFlagRequest.prototype.priority = 0;

          /**
           * SetWorkoutRequestFlagRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @instance
           */
          SetWorkoutRequestFlagRequest.prototype.getOptions = null;

          /**
           * Creates a new SetWorkoutRequestFlagRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestFlagRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} SetWorkoutRequestFlagRequest instance
           */
          SetWorkoutRequestFlagRequest.create = function create(properties) {
            return new SetWorkoutRequestFlagRequest(properties);
          };

          /**
           * Encodes the specified SetWorkoutRequestFlagRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestFlagRequest} message SetWorkoutRequestFlagRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetWorkoutRequestFlagRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.priority != null &&
              Object.hasOwnProperty.call(message, "priority")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.priority);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetWorkoutRequestFlagRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} SetWorkoutRequestFlagRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetWorkoutRequestFlagRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.priority = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetWorkoutRequestFlagRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} SetWorkoutRequestFlagRequest
           */
          SetWorkoutRequestFlagRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SetWorkoutRequestFlagRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest();
            if (object.id != null) message.id = String(object.id);
            switch (object.priority) {
              case "WORKOUT_REQUEST_FLAG_PRIORITY_INVALID":
              case 0:
                message.priority = 0;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_LOWER":
              case 1:
                message.priority = 1;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_MEDIUM":
              case 2:
                message.priority = 2;
                break;
              case "WORKOUT_REQUEST_FLAG_PRIORITY_HIGHEST":
              case 3:
                message.priority = 3;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SetWorkoutRequestFlagRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} message SetWorkoutRequestFlagRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetWorkoutRequestFlagRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.priority =
                options.enums === String
                  ? "WORKOUT_REQUEST_FLAG_PRIORITY_INVALID"
                  : 0;
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.priority != null && message.hasOwnProperty("priority"))
              object.priority =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .WorkoutRequestFlagPriority[message.priority]
                  : message.priority;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetWorkoutRequestFlagRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetWorkoutRequestFlagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetWorkoutRequestFlagRequest;
        })();

        racehorse360.ResetWorkoutRequestFlagRequest = (function () {
          /**
           * Properties of a ResetWorkoutRequestFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetWorkoutRequestFlagRequest
           * @property {string|null} [id] ResetWorkoutRequestFlagRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetWorkoutRequestFlagRequest getOptions
           */

          /**
           * Constructs a new ResetWorkoutRequestFlagRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetWorkoutRequestFlagRequest.
           * @implements IResetWorkoutRequestFlagRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestFlagRequest=} [properties] Properties to set
           */
          function ResetWorkoutRequestFlagRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetWorkoutRequestFlagRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @instance
           */
          ResetWorkoutRequestFlagRequest.prototype.id = "";

          /**
           * ResetWorkoutRequestFlagRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @instance
           */
          ResetWorkoutRequestFlagRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetWorkoutRequestFlagRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestFlagRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} ResetWorkoutRequestFlagRequest instance
           */
          ResetWorkoutRequestFlagRequest.create = function create(properties) {
            return new ResetWorkoutRequestFlagRequest(properties);
          };

          /**
           * Encodes the specified ResetWorkoutRequestFlagRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestFlagRequest} message ResetWorkoutRequestFlagRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetWorkoutRequestFlagRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetWorkoutRequestFlagRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} ResetWorkoutRequestFlagRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetWorkoutRequestFlagRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetWorkoutRequestFlagRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} ResetWorkoutRequestFlagRequest
           */
          ResetWorkoutRequestFlagRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ResetWorkoutRequestFlagRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ResetWorkoutRequestFlagRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} message ResetWorkoutRequestFlagRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetWorkoutRequestFlagRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetWorkoutRequestFlagRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetWorkoutRequestFlagRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ResetWorkoutRequestFlagRequest;
        })();

        racehorse360.SetWorkoutRequestExamReasonNoteRequest = (function () {
          /**
           * Properties of a SetWorkoutRequestExamReasonNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetWorkoutRequestExamReasonNoteRequest
           * @property {string|null} [id] SetWorkoutRequestExamReasonNoteRequest id
           * @property {string|null} [body] SetWorkoutRequestExamReasonNoteRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetWorkoutRequestExamReasonNoteRequest getOptions
           */

          /**
           * Constructs a new SetWorkoutRequestExamReasonNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetWorkoutRequestExamReasonNoteRequest.
           * @implements ISetWorkoutRequestExamReasonNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestExamReasonNoteRequest=} [properties] Properties to set
           */
          function SetWorkoutRequestExamReasonNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetWorkoutRequestExamReasonNoteRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @instance
           */
          SetWorkoutRequestExamReasonNoteRequest.prototype.id = "";

          /**
           * SetWorkoutRequestExamReasonNoteRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @instance
           */
          SetWorkoutRequestExamReasonNoteRequest.prototype.body = "";

          /**
           * SetWorkoutRequestExamReasonNoteRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @instance
           */
          SetWorkoutRequestExamReasonNoteRequest.prototype.getOptions = null;

          /**
           * Creates a new SetWorkoutRequestExamReasonNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestExamReasonNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} SetWorkoutRequestExamReasonNoteRequest instance
           */
          SetWorkoutRequestExamReasonNoteRequest.create = function create(
            properties
          ) {
            return new SetWorkoutRequestExamReasonNoteRequest(properties);
          };

          /**
           * Encodes the specified SetWorkoutRequestExamReasonNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestExamReasonNoteRequest} message SetWorkoutRequestExamReasonNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetWorkoutRequestExamReasonNoteRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetWorkoutRequestExamReasonNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} SetWorkoutRequestExamReasonNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetWorkoutRequestExamReasonNoteRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetWorkoutRequestExamReasonNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} SetWorkoutRequestExamReasonNoteRequest
           */
          SetWorkoutRequestExamReasonNoteRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .SetWorkoutRequestExamReasonNoteRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.body != null) message.body = String(object.body);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a SetWorkoutRequestExamReasonNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} message SetWorkoutRequestExamReasonNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetWorkoutRequestExamReasonNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetWorkoutRequestExamReasonNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetWorkoutRequestExamReasonNoteRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return SetWorkoutRequestExamReasonNoteRequest;
        })();

        racehorse360.ResetWorkoutRequestExamReasonNoteRequest = (function () {
          /**
           * Properties of a ResetWorkoutRequestExamReasonNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IResetWorkoutRequestExamReasonNoteRequest
           * @property {string|null} [id] ResetWorkoutRequestExamReasonNoteRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ResetWorkoutRequestExamReasonNoteRequest getOptions
           */

          /**
           * Constructs a new ResetWorkoutRequestExamReasonNoteRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ResetWorkoutRequestExamReasonNoteRequest.
           * @implements IResetWorkoutRequestExamReasonNoteRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestExamReasonNoteRequest=} [properties] Properties to set
           */
          function ResetWorkoutRequestExamReasonNoteRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ResetWorkoutRequestExamReasonNoteRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @instance
           */
          ResetWorkoutRequestExamReasonNoteRequest.prototype.id = "";

          /**
           * ResetWorkoutRequestExamReasonNoteRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @instance
           */
          ResetWorkoutRequestExamReasonNoteRequest.prototype.getOptions = null;

          /**
           * Creates a new ResetWorkoutRequestExamReasonNoteRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestExamReasonNoteRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} ResetWorkoutRequestExamReasonNoteRequest instance
           */
          ResetWorkoutRequestExamReasonNoteRequest.create = function create(
            properties
          ) {
            return new ResetWorkoutRequestExamReasonNoteRequest(properties);
          };

          /**
           * Encodes the specified ResetWorkoutRequestExamReasonNoteRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestExamReasonNoteRequest} message ResetWorkoutRequestExamReasonNoteRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ResetWorkoutRequestExamReasonNoteRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ResetWorkoutRequestExamReasonNoteRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} ResetWorkoutRequestExamReasonNoteRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ResetWorkoutRequestExamReasonNoteRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ResetWorkoutRequestExamReasonNoteRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} ResetWorkoutRequestExamReasonNoteRequest
           */
          ResetWorkoutRequestExamReasonNoteRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .ResetWorkoutRequestExamReasonNoteRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a ResetWorkoutRequestExamReasonNoteRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} message ResetWorkoutRequestExamReasonNoteRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ResetWorkoutRequestExamReasonNoteRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ResetWorkoutRequestExamReasonNoteRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ResetWorkoutRequestExamReasonNoteRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ResetWorkoutRequestExamReasonNoteRequest;
        })();

        racehorse360.PullWorkoutRequestReportRequest = (function () {
          /**
           * Properties of a PullWorkoutRequestReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkoutRequestReportRequest
           * @property {Array.<string>|null} [facilityIds] PullWorkoutRequestReportRequest facilityIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [dateRange] PullWorkoutRequestReportRequest dateRange
           */

          /**
           * Constructs a new PullWorkoutRequestReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkoutRequestReportRequest.
           * @implements IPullWorkoutRequestReportRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportRequest=} [properties] Properties to set
           */
          function PullWorkoutRequestReportRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkoutRequestReportRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @instance
           */
          PullWorkoutRequestReportRequest.prototype.facilityIds =
            $util.emptyArray;

          /**
           * PullWorkoutRequestReportRequest dateRange.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} dateRange
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @instance
           */
          PullWorkoutRequestReportRequest.prototype.dateRange = null;

          /**
           * Creates a new PullWorkoutRequestReportRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} PullWorkoutRequestReportRequest instance
           */
          PullWorkoutRequestReportRequest.create = function create(properties) {
            return new PullWorkoutRequestReportRequest(properties);
          };

          /**
           * Encodes the specified PullWorkoutRequestReportRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportRequest} message PullWorkoutRequestReportRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkoutRequestReportRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            if (
              message.dateRange != null &&
              Object.hasOwnProperty.call(message, "dateRange")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.dateRange,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullWorkoutRequestReportRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} PullWorkoutRequestReportRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkoutRequestReportRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 2:
                  message.dateRange =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkoutRequestReportRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} PullWorkoutRequestReportRequest
           */
          PullWorkoutRequestReportRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkoutRequestReportRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.dateRange != null) {
              if (typeof object.dateRange !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest.dateRange: object expected"
                );
              message.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.dateRange
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWorkoutRequestReportRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} message PullWorkoutRequestReportRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkoutRequestReportRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.dateRange = null;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.dateRange != null &&
              message.hasOwnProperty("dateRange")
            )
              object.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.dateRange,
                  options
                );
            return object;
          };

          /**
           * Converts this PullWorkoutRequestReportRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkoutRequestReportRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullWorkoutRequestReportRequest;
        })();

        racehorse360.PullWorkoutRequestReportResponse = (function () {
          /**
           * Properties of a PullWorkoutRequestReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWorkoutRequestReportResponse
           * @property {Uint8Array|null} [file] PullWorkoutRequestReportResponse file
           */

          /**
           * Constructs a new PullWorkoutRequestReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWorkoutRequestReportResponse.
           * @implements IPullWorkoutRequestReportResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportResponse=} [properties] Properties to set
           */
          function PullWorkoutRequestReportResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWorkoutRequestReportResponse file.
           * @member {Uint8Array} file
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @instance
           */
          PullWorkoutRequestReportResponse.prototype.file = $util.newBuffer([]);

          /**
           * Creates a new PullWorkoutRequestReportResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse} PullWorkoutRequestReportResponse instance
           */
          PullWorkoutRequestReportResponse.create = function create(
            properties
          ) {
            return new PullWorkoutRequestReportResponse(properties);
          };

          /**
           * Encodes the specified PullWorkoutRequestReportResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportResponse} message PullWorkoutRequestReportResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWorkoutRequestReportResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.file != null &&
              Object.hasOwnProperty.call(message, "file")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.file);
            return writer;
          };

          /**
           * Decodes a PullWorkoutRequestReportResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse} PullWorkoutRequestReportResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWorkoutRequestReportResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.file = reader.bytes();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWorkoutRequestReportResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse} PullWorkoutRequestReportResponse
           */
          PullWorkoutRequestReportResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWorkoutRequestReportResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse();
            if (object.file != null)
              if (typeof object.file === "string")
                $util.base64.decode(
                  object.file,
                  (message.file = $util.newBuffer(
                    $util.base64.length(object.file)
                  )),
                  0
                );
              else if (object.file.length) message.file = object.file;
            return message;
          };

          /**
           * Creates a plain object from a PullWorkoutRequestReportResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse} message PullWorkoutRequestReportResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWorkoutRequestReportResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults)
              if (options.bytes === String) object.file = "";
              else {
                object.file = [];
                if (options.bytes !== Array)
                  object.file = $util.newBuffer(object.file);
              }
            if (message.file != null && message.hasOwnProperty("file"))
              object.file =
                options.bytes === String
                  ? $util.base64.encode(message.file, 0, message.file.length)
                  : options.bytes === Array
                  ? Array.prototype.slice.call(message.file)
                  : message.file;
            return object;
          };

          /**
           * Converts this PullWorkoutRequestReportResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWorkoutRequestReportResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullWorkoutRequestReportResponse;
        })();

        racehorse360.PullWrongfulWorkoutReportRequest = (function () {
          /**
           * Properties of a PullWrongfulWorkoutReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWrongfulWorkoutReportRequest
           * @property {Array.<string>|null} [facilityIds] PullWrongfulWorkoutReportRequest facilityIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [dateRange] PullWrongfulWorkoutReportRequest dateRange
           */

          /**
           * Constructs a new PullWrongfulWorkoutReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWrongfulWorkoutReportRequest.
           * @implements IPullWrongfulWorkoutReportRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportRequest=} [properties] Properties to set
           */
          function PullWrongfulWorkoutReportRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWrongfulWorkoutReportRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @instance
           */
          PullWrongfulWorkoutReportRequest.prototype.facilityIds =
            $util.emptyArray;

          /**
           * PullWrongfulWorkoutReportRequest dateRange.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} dateRange
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @instance
           */
          PullWrongfulWorkoutReportRequest.prototype.dateRange = null;

          /**
           * Creates a new PullWrongfulWorkoutReportRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} PullWrongfulWorkoutReportRequest instance
           */
          PullWrongfulWorkoutReportRequest.create = function create(
            properties
          ) {
            return new PullWrongfulWorkoutReportRequest(properties);
          };

          /**
           * Encodes the specified PullWrongfulWorkoutReportRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportRequest} message PullWrongfulWorkoutReportRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWrongfulWorkoutReportRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            if (
              message.dateRange != null &&
              Object.hasOwnProperty.call(message, "dateRange")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.dateRange,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullWrongfulWorkoutReportRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} PullWrongfulWorkoutReportRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWrongfulWorkoutReportRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 2:
                  message.dateRange =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWrongfulWorkoutReportRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} PullWrongfulWorkoutReportRequest
           */
          PullWrongfulWorkoutReportRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWrongfulWorkoutReportRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.dateRange != null) {
              if (typeof object.dateRange !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest.dateRange: object expected"
                );
              message.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.dateRange
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullWrongfulWorkoutReportRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} message PullWrongfulWorkoutReportRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWrongfulWorkoutReportRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.dateRange = null;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.dateRange != null &&
              message.hasOwnProperty("dateRange")
            )
              object.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.dateRange,
                  options
                );
            return object;
          };

          /**
           * Converts this PullWrongfulWorkoutReportRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWrongfulWorkoutReportRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullWrongfulWorkoutReportRequest;
        })();

        racehorse360.PullWrongfulWorkoutReportResponse = (function () {
          /**
           * Properties of a PullWrongfulWorkoutReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullWrongfulWorkoutReportResponse
           * @property {Uint8Array|null} [file] PullWrongfulWorkoutReportResponse file
           */

          /**
           * Constructs a new PullWrongfulWorkoutReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullWrongfulWorkoutReportResponse.
           * @implements IPullWrongfulWorkoutReportResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportResponse=} [properties] Properties to set
           */
          function PullWrongfulWorkoutReportResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullWrongfulWorkoutReportResponse file.
           * @member {Uint8Array} file
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @instance
           */
          PullWrongfulWorkoutReportResponse.prototype.file = $util.newBuffer(
            []
          );

          /**
           * Creates a new PullWrongfulWorkoutReportResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse} PullWrongfulWorkoutReportResponse instance
           */
          PullWrongfulWorkoutReportResponse.create = function create(
            properties
          ) {
            return new PullWrongfulWorkoutReportResponse(properties);
          };

          /**
           * Encodes the specified PullWrongfulWorkoutReportResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportResponse} message PullWrongfulWorkoutReportResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullWrongfulWorkoutReportResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.file != null &&
              Object.hasOwnProperty.call(message, "file")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.file);
            return writer;
          };

          /**
           * Decodes a PullWrongfulWorkoutReportResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse} PullWrongfulWorkoutReportResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullWrongfulWorkoutReportResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.file = reader.bytes();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullWrongfulWorkoutReportResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse} PullWrongfulWorkoutReportResponse
           */
          PullWrongfulWorkoutReportResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullWrongfulWorkoutReportResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse();
            if (object.file != null)
              if (typeof object.file === "string")
                $util.base64.decode(
                  object.file,
                  (message.file = $util.newBuffer(
                    $util.base64.length(object.file)
                  )),
                  0
                );
              else if (object.file.length) message.file = object.file;
            return message;
          };

          /**
           * Creates a plain object from a PullWrongfulWorkoutReportResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse} message PullWrongfulWorkoutReportResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullWrongfulWorkoutReportResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults)
              if (options.bytes === String) object.file = "";
              else {
                object.file = [];
                if (options.bytes !== Array)
                  object.file = $util.newBuffer(object.file);
              }
            if (message.file != null && message.hasOwnProperty("file"))
              object.file =
                options.bytes === String
                  ? $util.base64.encode(message.file, 0, message.file.length)
                  : options.bytes === Array
                  ? Array.prototype.slice.call(message.file)
                  : message.file;
            return object;
          };

          /**
           * Converts this PullWrongfulWorkoutReportResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullWrongfulWorkoutReportResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullWrongfulWorkoutReportResponse;
        })();

        racehorse360.PullScheduledWorkoutReportRequest = (function () {
          /**
           * Properties of a PullScheduledWorkoutReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullScheduledWorkoutReportRequest
           * @property {Array.<string>|null} [facilityIds] PullScheduledWorkoutReportRequest facilityIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [dateRange] PullScheduledWorkoutReportRequest dateRange
           */

          /**
           * Constructs a new PullScheduledWorkoutReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullScheduledWorkoutReportRequest.
           * @implements IPullScheduledWorkoutReportRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportRequest=} [properties] Properties to set
           */
          function PullScheduledWorkoutReportRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullScheduledWorkoutReportRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @instance
           */
          PullScheduledWorkoutReportRequest.prototype.facilityIds =
            $util.emptyArray;

          /**
           * PullScheduledWorkoutReportRequest dateRange.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} dateRange
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @instance
           */
          PullScheduledWorkoutReportRequest.prototype.dateRange = null;

          /**
           * Creates a new PullScheduledWorkoutReportRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} PullScheduledWorkoutReportRequest instance
           */
          PullScheduledWorkoutReportRequest.create = function create(
            properties
          ) {
            return new PullScheduledWorkoutReportRequest(properties);
          };

          /**
           * Encodes the specified PullScheduledWorkoutReportRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportRequest} message PullScheduledWorkoutReportRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullScheduledWorkoutReportRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            if (
              message.dateRange != null &&
              Object.hasOwnProperty.call(message, "dateRange")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.dateRange,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullScheduledWorkoutReportRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} PullScheduledWorkoutReportRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullScheduledWorkoutReportRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 2:
                  message.dateRange =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullScheduledWorkoutReportRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} PullScheduledWorkoutReportRequest
           */
          PullScheduledWorkoutReportRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullScheduledWorkoutReportRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.dateRange != null) {
              if (typeof object.dateRange !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest.dateRange: object expected"
                );
              message.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.dateRange
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullScheduledWorkoutReportRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} message PullScheduledWorkoutReportRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullScheduledWorkoutReportRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.dateRange = null;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.dateRange != null &&
              message.hasOwnProperty("dateRange")
            )
              object.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.dateRange,
                  options
                );
            return object;
          };

          /**
           * Converts this PullScheduledWorkoutReportRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullScheduledWorkoutReportRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullScheduledWorkoutReportRequest;
        })();

        racehorse360.PullScheduledWorkoutReportResponse = (function () {
          /**
           * Properties of a PullScheduledWorkoutReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullScheduledWorkoutReportResponse
           * @property {Uint8Array|null} [file] PullScheduledWorkoutReportResponse file
           */

          /**
           * Constructs a new PullScheduledWorkoutReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullScheduledWorkoutReportResponse.
           * @implements IPullScheduledWorkoutReportResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportResponse=} [properties] Properties to set
           */
          function PullScheduledWorkoutReportResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullScheduledWorkoutReportResponse file.
           * @member {Uint8Array} file
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @instance
           */
          PullScheduledWorkoutReportResponse.prototype.file = $util.newBuffer(
            []
          );

          /**
           * Creates a new PullScheduledWorkoutReportResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse} PullScheduledWorkoutReportResponse instance
           */
          PullScheduledWorkoutReportResponse.create = function create(
            properties
          ) {
            return new PullScheduledWorkoutReportResponse(properties);
          };

          /**
           * Encodes the specified PullScheduledWorkoutReportResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportResponse} message PullScheduledWorkoutReportResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullScheduledWorkoutReportResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.file != null &&
              Object.hasOwnProperty.call(message, "file")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.file);
            return writer;
          };

          /**
           * Decodes a PullScheduledWorkoutReportResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse} PullScheduledWorkoutReportResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullScheduledWorkoutReportResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.file = reader.bytes();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullScheduledWorkoutReportResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse} PullScheduledWorkoutReportResponse
           */
          PullScheduledWorkoutReportResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullScheduledWorkoutReportResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse();
            if (object.file != null)
              if (typeof object.file === "string")
                $util.base64.decode(
                  object.file,
                  (message.file = $util.newBuffer(
                    $util.base64.length(object.file)
                  )),
                  0
                );
              else if (object.file.length) message.file = object.file;
            return message;
          };

          /**
           * Creates a plain object from a PullScheduledWorkoutReportResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse} message PullScheduledWorkoutReportResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullScheduledWorkoutReportResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults)
              if (options.bytes === String) object.file = "";
              else {
                object.file = [];
                if (options.bytes !== Array)
                  object.file = $util.newBuffer(object.file);
              }
            if (message.file != null && message.hasOwnProperty("file"))
              object.file =
                options.bytes === String
                  ? $util.base64.encode(message.file, 0, message.file.length)
                  : options.bytes === Array
                  ? Array.prototype.slice.call(message.file)
                  : message.file;
            return object;
          };

          /**
           * Converts this PullScheduledWorkoutReportResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullScheduledWorkoutReportResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullScheduledWorkoutReportResponse;
        })();

        racehorse360.WorkoutRequestComment = (function () {
          /**
           * Properties of a WorkoutRequestComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestComment
           * @property {string|null} [id] WorkoutRequestComment id
           * @property {stronachgroup.first.racehorse360.IWorkoutRequest|null} [workoutRequest] WorkoutRequestComment workoutRequest
           * @property {string|null} [body] WorkoutRequestComment body
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] WorkoutRequestComment trainer
           * @property {boolean|null} [isManual] WorkoutRequestComment isManual
           * @property {boolean|null} [isRead] WorkoutRequestComment isRead
           * @property {stronachgroup.first.racehorse360.WorkoutRequestCommentType|null} [commentType] WorkoutRequestComment commentType
           * @property {string|null} [createdOn] WorkoutRequestComment createdOn
           * @property {string|null} [updatedOn] WorkoutRequestComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] WorkoutRequestComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] WorkoutRequestComment updatedBy
           */

          /**
           * Constructs a new WorkoutRequestComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestComment.
           * @implements IWorkoutRequestComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestComment=} [properties] Properties to set
           */
          function WorkoutRequestComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.id = "";

          /**
           * WorkoutRequestComment workoutRequest.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequest|null|undefined} workoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.workoutRequest = null;

          /**
           * WorkoutRequestComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.body = "";

          /**
           * WorkoutRequestComment trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.trainer = null;

          /**
           * WorkoutRequestComment isManual.
           * @member {boolean} isManual
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.isManual = false;

          /**
           * WorkoutRequestComment isRead.
           * @member {boolean} isRead
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.isRead = false;

          /**
           * WorkoutRequestComment commentType.
           * @member {stronachgroup.first.racehorse360.WorkoutRequestCommentType} commentType
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.commentType = 0;

          /**
           * WorkoutRequestComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.createdOn = "";

          /**
           * WorkoutRequestComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.updatedOn = "";

          /**
           * WorkoutRequestComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.createdBy = null;

          /**
           * WorkoutRequestComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           */
          WorkoutRequestComment.prototype.updatedBy = null;

          /**
           * Creates a new WorkoutRequestComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestComment} WorkoutRequestComment instance
           */
          WorkoutRequestComment.create = function create(properties) {
            return new WorkoutRequestComment(properties);
          };

          /**
           * Encodes the specified WorkoutRequestComment message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestComment} message WorkoutRequestComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.workoutRequest != null &&
              Object.hasOwnProperty.call(message, "workoutRequest")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequest.encode(
                message.workoutRequest,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.body);
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.isManual != null &&
              Object.hasOwnProperty.call(message, "isManual")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.isManual);
            if (
              message.isRead != null &&
              Object.hasOwnProperty.call(message, "isRead")
            )
              writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.isRead);
            if (
              message.commentType != null &&
              Object.hasOwnProperty.call(message, "commentType")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.commentType);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkoutRequestComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestComment} WorkoutRequestComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.workoutRequest =
                    $root.stronachgroup.first.racehorse360.WorkoutRequest.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.body = reader.string();
                  break;
                case 4:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.isManual = reader.bool();
                  break;
                case 6:
                  message.isRead = reader.bool();
                  break;
                case 7:
                  message.commentType = reader.int32();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestComment} WorkoutRequestComment
           */
          WorkoutRequestComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutRequestComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestComment();
            if (object.id != null) message.id = String(object.id);
            if (object.workoutRequest != null) {
              if (typeof object.workoutRequest !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestComment.workoutRequest: object expected"
                );
              message.workoutRequest =
                $root.stronachgroup.first.racehorse360.WorkoutRequest.fromObject(
                  object.workoutRequest
                );
            }
            if (object.body != null) message.body = String(object.body);
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestComment.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.isManual != null)
              message.isManual = Boolean(object.isManual);
            if (object.isRead != null) message.isRead = Boolean(object.isRead);
            switch (object.commentType) {
              case "WORKOUT_REQUEST_COMMENT_TYPE_INVALID":
              case 0:
                message.commentType = 0;
                break;
              case "WORKOUT_REQUEST_COMMENT_TYPE_TRAINER_COMMUNICATION":
              case 1:
                message.commentType = 1;
                break;
              case "WORKOUT_REQUEST_COMMENT_TYPE_RACING_SECRETARY_COMMUNICATION":
              case 2:
                message.commentType = 2;
                break;
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestComment} message WorkoutRequestComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestComment.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.workoutRequest = null;
              object.body = "";
              object.trainer = null;
              object.isManual = false;
              object.isRead = false;
              object.commentType =
                options.enums === String
                  ? "WORKOUT_REQUEST_COMMENT_TYPE_INVALID"
                  : 0;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.workoutRequest != null &&
              message.hasOwnProperty("workoutRequest")
            )
              object.workoutRequest =
                $root.stronachgroup.first.racehorse360.WorkoutRequest.toObject(
                  message.workoutRequest,
                  options
                );
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (message.isManual != null && message.hasOwnProperty("isManual"))
              object.isManual = message.isManual;
            if (message.isRead != null && message.hasOwnProperty("isRead"))
              object.isRead = message.isRead;
            if (
              message.commentType != null &&
              message.hasOwnProperty("commentType")
            )
              object.commentType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .WorkoutRequestCommentType[message.commentType]
                  : message.commentType;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkoutRequestComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestComment;
        })();

        racehorse360.WorkoutRequestCommentFilter = (function () {
          /**
           * Properties of a WorkoutRequestCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestCommentFilter
           * @property {Array.<string>|null} [ids] WorkoutRequestCommentFilter ids
           * @property {Array.<string>|null} [workoutRequestIds] WorkoutRequestCommentFilter workoutRequestIds
           * @property {Array.<string>|null} [trainerIds] WorkoutRequestCommentFilter trainerIds
           * @property {Array.<string>|null} [horseIds] WorkoutRequestCommentFilter horseIds
           * @property {google.protobuf.IBoolValue|null} [excludeCancelled] WorkoutRequestCommentFilter excludeCancelled
           * @property {boolean|null} [isCreatedByTrainer] WorkoutRequestCommentFilter isCreatedByTrainer
           * @property {Array.<stronachgroup.first.racehorse360.WorkoutRequestCommentType>|null} [commentTypes] WorkoutRequestCommentFilter commentTypes
           */

          /**
           * Constructs a new WorkoutRequestCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestCommentFilter.
           * @implements IWorkoutRequestCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestCommentFilter=} [properties] Properties to set
           */
          function WorkoutRequestCommentFilter(properties) {
            this.ids = [];
            this.workoutRequestIds = [];
            this.trainerIds = [];
            this.horseIds = [];
            this.commentTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestCommentFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.ids = $util.emptyArray;

          /**
           * WorkoutRequestCommentFilter workoutRequestIds.
           * @member {Array.<string>} workoutRequestIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.workoutRequestIds =
            $util.emptyArray;

          /**
           * WorkoutRequestCommentFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * WorkoutRequestCommentFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.horseIds = $util.emptyArray;

          /**
           * WorkoutRequestCommentFilter excludeCancelled.
           * @member {google.protobuf.IBoolValue|null|undefined} excludeCancelled
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.excludeCancelled = null;

          /**
           * WorkoutRequestCommentFilter isCreatedByTrainer.
           * @member {boolean} isCreatedByTrainer
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.isCreatedByTrainer = false;

          /**
           * WorkoutRequestCommentFilter commentTypes.
           * @member {Array.<stronachgroup.first.racehorse360.WorkoutRequestCommentType>} commentTypes
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           */
          WorkoutRequestCommentFilter.prototype.commentTypes = $util.emptyArray;

          /**
           * Creates a new WorkoutRequestCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestCommentFilter} WorkoutRequestCommentFilter instance
           */
          WorkoutRequestCommentFilter.create = function create(properties) {
            return new WorkoutRequestCommentFilter(properties);
          };

          /**
           * Encodes the specified WorkoutRequestCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestCommentFilter} message WorkoutRequestCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestCommentFilter.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.workoutRequestIds != null &&
              message.workoutRequestIds.length
            )
              for (var i = 0; i < message.workoutRequestIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.workoutRequestIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.trainerIds[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.horseIds[i]);
            if (
              message.excludeCancelled != null &&
              Object.hasOwnProperty.call(message, "excludeCancelled")
            )
              $root.google.protobuf.BoolValue.encode(
                message.excludeCancelled,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.isCreatedByTrainer != null &&
              Object.hasOwnProperty.call(message, "isCreatedByTrainer")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .bool(message.isCreatedByTrainer);
            if (message.commentTypes != null && message.commentTypes.length) {
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork();
              for (var i = 0; i < message.commentTypes.length; ++i)
                writer.int32(message.commentTypes[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes a WorkoutRequestCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestCommentFilter} WorkoutRequestCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestCommentFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.workoutRequestIds &&
                      message.workoutRequestIds.length
                    )
                  )
                    message.workoutRequestIds = [];
                  message.workoutRequestIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 4:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 5:
                  message.excludeCancelled =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.isCreatedByTrainer = reader.bool();
                  break;
                case 7:
                  if (!(message.commentTypes && message.commentTypes.length))
                    message.commentTypes = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.commentTypes.push(reader.int32());
                  } else message.commentTypes.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestCommentFilter} WorkoutRequestCommentFilter
           */
          WorkoutRequestCommentFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.workoutRequestIds) {
              if (!Array.isArray(object.workoutRequestIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.workoutRequestIds: array expected"
                );
              message.workoutRequestIds = [];
              for (var i = 0; i < object.workoutRequestIds.length; ++i)
                message.workoutRequestIds[i] = String(
                  object.workoutRequestIds[i]
                );
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.excludeCancelled != null) {
              if (typeof object.excludeCancelled !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.excludeCancelled: object expected"
                );
              message.excludeCancelled =
                $root.google.protobuf.BoolValue.fromObject(
                  object.excludeCancelled
                );
            }
            if (object.isCreatedByTrainer != null)
              message.isCreatedByTrainer = Boolean(object.isCreatedByTrainer);
            if (object.commentTypes) {
              if (!Array.isArray(object.commentTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.commentTypes: array expected"
                );
              message.commentTypes = [];
              for (var i = 0; i < object.commentTypes.length; ++i)
                switch (object.commentTypes[i]) {
                  default:
                  case "WORKOUT_REQUEST_COMMENT_TYPE_INVALID":
                  case 0:
                    message.commentTypes[i] = 0;
                    break;
                  case "WORKOUT_REQUEST_COMMENT_TYPE_TRAINER_COMMUNICATION":
                  case 1:
                    message.commentTypes[i] = 1;
                    break;
                  case "WORKOUT_REQUEST_COMMENT_TYPE_RACING_SECRETARY_COMMUNICATION":
                  case 2:
                    message.commentTypes[i] = 2;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestCommentFilter} message WorkoutRequestCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.workoutRequestIds = [];
              object.trainerIds = [];
              object.horseIds = [];
              object.commentTypes = [];
            }
            if (options.defaults) {
              object.excludeCancelled = null;
              object.isCreatedByTrainer = false;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.workoutRequestIds && message.workoutRequestIds.length) {
              object.workoutRequestIds = [];
              for (var j = 0; j < message.workoutRequestIds.length; ++j)
                object.workoutRequestIds[j] = message.workoutRequestIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (
              message.excludeCancelled != null &&
              message.hasOwnProperty("excludeCancelled")
            )
              object.excludeCancelled =
                $root.google.protobuf.BoolValue.toObject(
                  message.excludeCancelled,
                  options
                );
            if (
              message.isCreatedByTrainer != null &&
              message.hasOwnProperty("isCreatedByTrainer")
            )
              object.isCreatedByTrainer = message.isCreatedByTrainer;
            if (message.commentTypes && message.commentTypes.length) {
              object.commentTypes = [];
              for (var j = 0; j < message.commentTypes.length; ++j)
                object.commentTypes[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .WorkoutRequestCommentType[message.commentTypes[j]]
                    : message.commentTypes[j];
            }
            return object;
          };

          /**
           * Converts this WorkoutRequestCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestCommentFilter;
        })();

        racehorse360.CreateWorkoutRequestCommentRequest = (function () {
          /**
           * Properties of a CreateWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateWorkoutRequestCommentRequest
           * @property {string|null} [workoutRequestId] CreateWorkoutRequestCommentRequest workoutRequestId
           * @property {string|null} [body] CreateWorkoutRequestCommentRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateWorkoutRequestCommentRequest getOptions
           */

          /**
           * Constructs a new CreateWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateWorkoutRequestCommentRequest.
           * @implements ICreateWorkoutRequestCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestCommentRequest=} [properties] Properties to set
           */
          function CreateWorkoutRequestCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateWorkoutRequestCommentRequest workoutRequestId.
           * @member {string} workoutRequestId
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @instance
           */
          CreateWorkoutRequestCommentRequest.prototype.workoutRequestId = "";

          /**
           * CreateWorkoutRequestCommentRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @instance
           */
          CreateWorkoutRequestCommentRequest.prototype.body = "";

          /**
           * CreateWorkoutRequestCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @instance
           */
          CreateWorkoutRequestCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateWorkoutRequestCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} CreateWorkoutRequestCommentRequest instance
           */
          CreateWorkoutRequestCommentRequest.create = function create(
            properties
          ) {
            return new CreateWorkoutRequestCommentRequest(properties);
          };

          /**
           * Encodes the specified CreateWorkoutRequestCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestCommentRequest} message CreateWorkoutRequestCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateWorkoutRequestCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.workoutRequestId != null &&
              Object.hasOwnProperty.call(message, "workoutRequestId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.workoutRequestId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateWorkoutRequestCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} CreateWorkoutRequestCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateWorkoutRequestCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.workoutRequestId = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateWorkoutRequestCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} CreateWorkoutRequestCommentRequest
           */
          CreateWorkoutRequestCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateWorkoutRequestCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest();
            if (object.workoutRequestId != null)
              message.workoutRequestId = String(object.workoutRequestId);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateWorkoutRequestCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} message CreateWorkoutRequestCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateWorkoutRequestCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.workoutRequestId = "";
              object.body = "";
              object.getOptions = null;
            }
            if (
              message.workoutRequestId != null &&
              message.hasOwnProperty("workoutRequestId")
            )
              object.workoutRequestId = message.workoutRequestId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateWorkoutRequestCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateWorkoutRequestCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return CreateWorkoutRequestCommentRequest;
        })();

        racehorse360.DeleteWorkoutRequestCommentRequest = (function () {
          /**
           * Properties of a DeleteWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteWorkoutRequestCommentRequest
           * @property {string|null} [id] DeleteWorkoutRequestCommentRequest id
           */

          /**
           * Constructs a new DeleteWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteWorkoutRequestCommentRequest.
           * @implements IDeleteWorkoutRequestCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestCommentRequest=} [properties] Properties to set
           */
          function DeleteWorkoutRequestCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteWorkoutRequestCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @instance
           */
          DeleteWorkoutRequestCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteWorkoutRequestCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} DeleteWorkoutRequestCommentRequest instance
           */
          DeleteWorkoutRequestCommentRequest.create = function create(
            properties
          ) {
            return new DeleteWorkoutRequestCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteWorkoutRequestCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestCommentRequest} message DeleteWorkoutRequestCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteWorkoutRequestCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteWorkoutRequestCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} DeleteWorkoutRequestCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteWorkoutRequestCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteWorkoutRequestCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} DeleteWorkoutRequestCommentRequest
           */
          DeleteWorkoutRequestCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteWorkoutRequestCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteWorkoutRequestCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} message DeleteWorkoutRequestCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteWorkoutRequestCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteWorkoutRequestCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteWorkoutRequestCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return DeleteWorkoutRequestCommentRequest;
        })();

        racehorse360.GetWorkoutRequestCommentRequest = (function () {
          /**
           * Properties of a GetWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetWorkoutRequestCommentRequest
           * @property {string|null} [id] GetWorkoutRequestCommentRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetWorkoutRequestCommentRequest getOptions
           */

          /**
           * Constructs a new GetWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetWorkoutRequestCommentRequest.
           * @implements IGetWorkoutRequestCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestCommentRequest=} [properties] Properties to set
           */
          function GetWorkoutRequestCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetWorkoutRequestCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @instance
           */
          GetWorkoutRequestCommentRequest.prototype.id = "";

          /**
           * GetWorkoutRequestCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @instance
           */
          GetWorkoutRequestCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new GetWorkoutRequestCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} GetWorkoutRequestCommentRequest instance
           */
          GetWorkoutRequestCommentRequest.create = function create(properties) {
            return new GetWorkoutRequestCommentRequest(properties);
          };

          /**
           * Encodes the specified GetWorkoutRequestCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestCommentRequest} message GetWorkoutRequestCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetWorkoutRequestCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetWorkoutRequestCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} GetWorkoutRequestCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetWorkoutRequestCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetWorkoutRequestCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} GetWorkoutRequestCommentRequest
           */
          GetWorkoutRequestCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .GetWorkoutRequestCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetWorkoutRequestCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} message GetWorkoutRequestCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetWorkoutRequestCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetWorkoutRequestCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetWorkoutRequestCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetWorkoutRequestCommentRequest;
        })();

        racehorse360.EditWorkoutRequestCommentRequest = (function () {
          /**
           * Properties of an EditWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditWorkoutRequestCommentRequest
           * @property {string|null} [id] EditWorkoutRequestCommentRequest id
           * @property {string|null} [body] EditWorkoutRequestCommentRequest body
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditWorkoutRequestCommentRequest getOptions
           */

          /**
           * Constructs a new EditWorkoutRequestCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditWorkoutRequestCommentRequest.
           * @implements IEditWorkoutRequestCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditWorkoutRequestCommentRequest=} [properties] Properties to set
           */
          function EditWorkoutRequestCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditWorkoutRequestCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @instance
           */
          EditWorkoutRequestCommentRequest.prototype.id = "";

          /**
           * EditWorkoutRequestCommentRequest body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @instance
           */
          EditWorkoutRequestCommentRequest.prototype.body = "";

          /**
           * EditWorkoutRequestCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @instance
           */
          EditWorkoutRequestCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new EditWorkoutRequestCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditWorkoutRequestCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} EditWorkoutRequestCommentRequest instance
           */
          EditWorkoutRequestCommentRequest.create = function create(
            properties
          ) {
            return new EditWorkoutRequestCommentRequest(properties);
          };

          /**
           * Encodes the specified EditWorkoutRequestCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditWorkoutRequestCommentRequest} message EditWorkoutRequestCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditWorkoutRequestCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditWorkoutRequestCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} EditWorkoutRequestCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditWorkoutRequestCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditWorkoutRequestCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} EditWorkoutRequestCommentRequest
           */
          EditWorkoutRequestCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .EditWorkoutRequestCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditWorkoutRequestCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} message EditWorkoutRequestCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditWorkoutRequestCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditWorkoutRequestCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditWorkoutRequestCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return EditWorkoutRequestCommentRequest;
        })();

        racehorse360.ListWorkoutRequestCommentsRequest = (function () {
          /**
           * Properties of a ListWorkoutRequestCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutRequestCommentsRequest
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestCommentFilter|null} [query] ListWorkoutRequestCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkoutRequestCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkoutRequestCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkoutRequestCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutRequestCommentsRequest.
           * @implements IListWorkoutRequestCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsRequest=} [properties] Properties to set
           */
          function ListWorkoutRequestCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutRequestCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @instance
           */
          ListWorkoutRequestCommentsRequest.prototype.query = null;

          /**
           * ListWorkoutRequestCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @instance
           */
          ListWorkoutRequestCommentsRequest.prototype.getOptions = null;

          /**
           * ListWorkoutRequestCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @instance
           */
          ListWorkoutRequestCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListWorkoutRequestCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} ListWorkoutRequestCommentsRequest instance
           */
          ListWorkoutRequestCommentsRequest.create = function create(
            properties
          ) {
            return new ListWorkoutRequestCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListWorkoutRequestCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsRequest} message ListWorkoutRequestCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutRequestCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutRequestCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} ListWorkoutRequestCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutRequestCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutRequestCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} ListWorkoutRequestCommentsRequest
           */
          ListWorkoutRequestCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListWorkoutRequestCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutRequestCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} message ListWorkoutRequestCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutRequestCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.WorkoutRequestCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutRequestCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutRequestCommentsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListWorkoutRequestCommentsRequest;
        })();

        racehorse360.ListWorkoutRequestCommentsResponse = (function () {
          /**
           * Properties of a ListWorkoutRequestCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutRequestCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IWorkoutRequestComment>|null} [workoutRequestComments] ListWorkoutRequestCommentsResponse workoutRequestComments
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkoutRequestCommentsResponse pagingInfo
           */

          /**
           * Constructs a new ListWorkoutRequestCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutRequestCommentsResponse.
           * @implements IListWorkoutRequestCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsResponse=} [properties] Properties to set
           */
          function ListWorkoutRequestCommentsResponse(properties) {
            this.workoutRequestComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutRequestCommentsResponse workoutRequestComments.
           * @member {Array.<stronachgroup.first.racehorse360.IWorkoutRequestComment>} workoutRequestComments
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @instance
           */
          ListWorkoutRequestCommentsResponse.prototype.workoutRequestComments =
            $util.emptyArray;

          /**
           * ListWorkoutRequestCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @instance
           */
          ListWorkoutRequestCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListWorkoutRequestCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse} ListWorkoutRequestCommentsResponse instance
           */
          ListWorkoutRequestCommentsResponse.create = function create(
            properties
          ) {
            return new ListWorkoutRequestCommentsResponse(properties);
          };

          /**
           * Encodes the specified ListWorkoutRequestCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsResponse} message ListWorkoutRequestCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutRequestCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.workoutRequestComments != null &&
              message.workoutRequestComments.length
            )
              for (var i = 0; i < message.workoutRequestComments.length; ++i)
                $root.stronachgroup.first.racehorse360.WorkoutRequestComment.encode(
                  message.workoutRequestComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutRequestCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse} ListWorkoutRequestCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutRequestCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.workoutRequestComments &&
                      message.workoutRequestComments.length
                    )
                  )
                    message.workoutRequestComments = [];
                  message.workoutRequestComments.push(
                    $root.stronachgroup.first.racehorse360.WorkoutRequestComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutRequestCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse} ListWorkoutRequestCommentsResponse
           */
          ListWorkoutRequestCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListWorkoutRequestCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse();
            if (object.workoutRequestComments) {
              if (!Array.isArray(object.workoutRequestComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse.workoutRequestComments: array expected"
                );
              message.workoutRequestComments = [];
              for (var i = 0; i < object.workoutRequestComments.length; ++i) {
                if (typeof object.workoutRequestComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse.workoutRequestComments: object expected"
                  );
                message.workoutRequestComments[i] =
                  $root.stronachgroup.first.racehorse360.WorkoutRequestComment.fromObject(
                    object.workoutRequestComments[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListWorkoutRequestCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse} message ListWorkoutRequestCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutRequestCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.workoutRequestComments = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.workoutRequestComments &&
              message.workoutRequestComments.length
            ) {
              object.workoutRequestComments = [];
              for (var j = 0; j < message.workoutRequestComments.length; ++j)
                object.workoutRequestComments[j] =
                  $root.stronachgroup.first.racehorse360.WorkoutRequestComment.toObject(
                    message.workoutRequestComments[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListWorkoutRequestCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutRequestCommentsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListWorkoutRequestCommentsResponse;
        })();

        racehorse360.WorkoutRequestRejectionComment = (function () {
          /**
           * Properties of a WorkoutRequestRejectionComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestRejectionComment
           * @property {string|null} [id] WorkoutRequestRejectionComment id
           * @property {string|null} [body] WorkoutRequestRejectionComment body
           * @property {boolean|null} [isImagingDiagnosticsRequired] WorkoutRequestRejectionComment isImagingDiagnosticsRequired
           * @property {string|null} [createdOn] WorkoutRequestRejectionComment createdOn
           * @property {string|null} [updatedOn] WorkoutRequestRejectionComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] WorkoutRequestRejectionComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] WorkoutRequestRejectionComment updatedBy
           */

          /**
           * Constructs a new WorkoutRequestRejectionComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestRejectionComment.
           * @implements IWorkoutRequestRejectionComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment=} [properties] Properties to set
           */
          function WorkoutRequestRejectionComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestRejectionComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.id = "";

          /**
           * WorkoutRequestRejectionComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.body = "";

          /**
           * WorkoutRequestRejectionComment isImagingDiagnosticsRequired.
           * @member {boolean} isImagingDiagnosticsRequired
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.isImagingDiagnosticsRequired = false;

          /**
           * WorkoutRequestRejectionComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.createdOn = "";

          /**
           * WorkoutRequestRejectionComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.updatedOn = "";

          /**
           * WorkoutRequestRejectionComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.createdBy = null;

          /**
           * WorkoutRequestRejectionComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           */
          WorkoutRequestRejectionComment.prototype.updatedBy = null;

          /**
           * Creates a new WorkoutRequestRejectionComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionComment} WorkoutRequestRejectionComment instance
           */
          WorkoutRequestRejectionComment.create = function create(properties) {
            return new WorkoutRequestRejectionComment(properties);
          };

          /**
           * Encodes the specified WorkoutRequestRejectionComment message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment} message WorkoutRequestRejectionComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestRejectionComment.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.body);
            if (
              message.isImagingDiagnosticsRequired != null &&
              Object.hasOwnProperty.call(
                message,
                "isImagingDiagnosticsRequired"
              )
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.isImagingDiagnosticsRequired);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a WorkoutRequestRejectionComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionComment} WorkoutRequestRejectionComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestRejectionComment.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 3:
                  message.body = reader.string();
                  break;
                case 4:
                  message.isImagingDiagnosticsRequired = reader.bool();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestRejectionComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionComment} WorkoutRequestRejectionComment
           */
          WorkoutRequestRejectionComment.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .WorkoutRequestRejectionComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.isImagingDiagnosticsRequired != null)
              message.isImagingDiagnosticsRequired = Boolean(
                object.isImagingDiagnosticsRequired
              );
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestRejectionComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestRejectionComment} message WorkoutRequestRejectionComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestRejectionComment.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.isImagingDiagnosticsRequired = false;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.isImagingDiagnosticsRequired != null &&
              message.hasOwnProperty("isImagingDiagnosticsRequired")
            )
              object.isImagingDiagnosticsRequired =
                message.isImagingDiagnosticsRequired;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this WorkoutRequestRejectionComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestRejectionComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WorkoutRequestRejectionComment;
        })();

        racehorse360.WorkoutRequestRejectionCommentFilter = (function () {
          /**
           * Properties of a WorkoutRequestRejectionCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWorkoutRequestRejectionCommentFilter
           * @property {Array.<string>|null} [ids] WorkoutRequestRejectionCommentFilter ids
           * @property {Array.<string>|null} [workoutRequestIds] WorkoutRequestRejectionCommentFilter workoutRequestIds
           */

          /**
           * Constructs a new WorkoutRequestRejectionCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestRejectionCommentFilter.
           * @implements IWorkoutRequestRejectionCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionCommentFilter=} [properties] Properties to set
           */
          function WorkoutRequestRejectionCommentFilter(properties) {
            this.ids = [];
            this.workoutRequestIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WorkoutRequestRejectionCommentFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @instance
           */
          WorkoutRequestRejectionCommentFilter.prototype.ids = $util.emptyArray;

          /**
           * WorkoutRequestRejectionCommentFilter workoutRequestIds.
           * @member {Array.<string>} workoutRequestIds
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @instance
           */
          WorkoutRequestRejectionCommentFilter.prototype.workoutRequestIds =
            $util.emptyArray;

          /**
           * Creates a new WorkoutRequestRejectionCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter} WorkoutRequestRejectionCommentFilter instance
           */
          WorkoutRequestRejectionCommentFilter.create = function create(
            properties
          ) {
            return new WorkoutRequestRejectionCommentFilter(properties);
          };

          /**
           * Encodes the specified WorkoutRequestRejectionCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IWorkoutRequestRejectionCommentFilter} message WorkoutRequestRejectionCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WorkoutRequestRejectionCommentFilter.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.workoutRequestIds != null &&
              message.workoutRequestIds.length
            )
              for (var i = 0; i < message.workoutRequestIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.workoutRequestIds[i]);
            return writer;
          };

          /**
           * Decodes a WorkoutRequestRejectionCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter} WorkoutRequestRejectionCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WorkoutRequestRejectionCommentFilter.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.workoutRequestIds &&
                      message.workoutRequestIds.length
                    )
                  )
                    message.workoutRequestIds = [];
                  message.workoutRequestIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WorkoutRequestRejectionCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter} WorkoutRequestRejectionCommentFilter
           */
          WorkoutRequestRejectionCommentFilter.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .WorkoutRequestRejectionCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.workoutRequestIds) {
              if (!Array.isArray(object.workoutRequestIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.workoutRequestIds: array expected"
                );
              message.workoutRequestIds = [];
              for (var i = 0; i < object.workoutRequestIds.length; ++i)
                message.workoutRequestIds[i] = String(
                  object.workoutRequestIds[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a WorkoutRequestRejectionCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter} message WorkoutRequestRejectionCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WorkoutRequestRejectionCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.workoutRequestIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.workoutRequestIds && message.workoutRequestIds.length) {
              object.workoutRequestIds = [];
              for (var j = 0; j < message.workoutRequestIds.length; ++j)
                object.workoutRequestIds[j] = message.workoutRequestIds[j];
            }
            return object;
          };

          /**
           * Converts this WorkoutRequestRejectionCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WorkoutRequestRejectionCommentFilter.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return WorkoutRequestRejectionCommentFilter;
        })();

        racehorse360.GetWorkoutRequestRejectionCommentRequest = (function () {
          /**
           * Properties of a GetWorkoutRequestRejectionCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetWorkoutRequestRejectionCommentRequest
           * @property {string|null} [id] GetWorkoutRequestRejectionCommentRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetWorkoutRequestRejectionCommentRequest getOptions
           */

          /**
           * Constructs a new GetWorkoutRequestRejectionCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetWorkoutRequestRejectionCommentRequest.
           * @implements IGetWorkoutRequestRejectionCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRejectionCommentRequest=} [properties] Properties to set
           */
          function GetWorkoutRequestRejectionCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetWorkoutRequestRejectionCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @instance
           */
          GetWorkoutRequestRejectionCommentRequest.prototype.id = "";

          /**
           * GetWorkoutRequestRejectionCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @instance
           */
          GetWorkoutRequestRejectionCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new GetWorkoutRequestRejectionCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRejectionCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} GetWorkoutRequestRejectionCommentRequest instance
           */
          GetWorkoutRequestRejectionCommentRequest.create = function create(
            properties
          ) {
            return new GetWorkoutRequestRejectionCommentRequest(properties);
          };

          /**
           * Encodes the specified GetWorkoutRequestRejectionCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRejectionCommentRequest} message GetWorkoutRequestRejectionCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetWorkoutRequestRejectionCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetWorkoutRequestRejectionCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} GetWorkoutRequestRejectionCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetWorkoutRequestRejectionCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetWorkoutRequestRejectionCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} GetWorkoutRequestRejectionCommentRequest
           */
          GetWorkoutRequestRejectionCommentRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .GetWorkoutRequestRejectionCommentRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a GetWorkoutRequestRejectionCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} message GetWorkoutRequestRejectionCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetWorkoutRequestRejectionCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetWorkoutRequestRejectionCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetWorkoutRequestRejectionCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return GetWorkoutRequestRejectionCommentRequest;
        })();

        racehorse360.ListWorkoutRequestRejectionCommentsRequest = (function () {
          /**
           * Properties of a ListWorkoutRequestRejectionCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListWorkoutRequestRejectionCommentsRequest
           * @property {stronachgroup.first.racehorse360.IWorkoutRequestRejectionCommentFilter|null} [query] ListWorkoutRequestRejectionCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListWorkoutRequestRejectionCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListWorkoutRequestRejectionCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListWorkoutRequestRejectionCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListWorkoutRequestRejectionCommentsRequest.
           * @implements IListWorkoutRequestRejectionCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsRequest=} [properties] Properties to set
           */
          function ListWorkoutRequestRejectionCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListWorkoutRequestRejectionCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequestRejectionCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @instance
           */
          ListWorkoutRequestRejectionCommentsRequest.prototype.query = null;

          /**
           * ListWorkoutRequestRejectionCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @instance
           */
          ListWorkoutRequestRejectionCommentsRequest.prototype.getOptions =
            null;

          /**
           * ListWorkoutRequestRejectionCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @instance
           */
          ListWorkoutRequestRejectionCommentsRequest.prototype.pagingOptions =
            null;

          /**
           * Creates a new ListWorkoutRequestRejectionCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} ListWorkoutRequestRejectionCommentsRequest instance
           */
          ListWorkoutRequestRejectionCommentsRequest.create = function create(
            properties
          ) {
            return new ListWorkoutRequestRejectionCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListWorkoutRequestRejectionCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsRequest} message ListWorkoutRequestRejectionCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListWorkoutRequestRejectionCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListWorkoutRequestRejectionCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} ListWorkoutRequestRejectionCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListWorkoutRequestRejectionCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListWorkoutRequestRejectionCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} ListWorkoutRequestRejectionCommentsRequest
           */
          ListWorkoutRequestRejectionCommentsRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .ListWorkoutRequestRejectionCommentsRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest();
              if (object.query != null) {
                if (typeof object.query !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest.query: object expected"
                  );
                message.query =
                  $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.fromObject(
                    object.query
                  );
              }
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              if (object.pagingOptions != null) {
                if (typeof object.pagingOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest.pagingOptions: object expected"
                  );
                message.pagingOptions =
                  $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                    object.pagingOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a ListWorkoutRequestRejectionCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} message ListWorkoutRequestRejectionCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListWorkoutRequestRejectionCommentsRequest.toObject =
            function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.query = null;
                object.getOptions = null;
                object.pagingOptions = null;
              }
              if (message.query != null && message.hasOwnProperty("query"))
                object.query =
                  $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionCommentFilter.toObject(
                    message.query,
                    options
                  );
              if (
                message.getOptions != null &&
                message.hasOwnProperty("getOptions")
              )
                object.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                    message.getOptions,
                    options
                  );
              if (
                message.pagingOptions != null &&
                message.hasOwnProperty("pagingOptions")
              )
                object.pagingOptions =
                  $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                    message.pagingOptions,
                    options
                  );
              return object;
            };

          /**
           * Converts this ListWorkoutRequestRejectionCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListWorkoutRequestRejectionCommentsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListWorkoutRequestRejectionCommentsRequest;
        })();

        racehorse360.ListWorkoutRequestRejectionCommentsResponse =
          (function () {
            /**
             * Properties of a ListWorkoutRequestRejectionCommentsResponse.
             * @memberof stronachgroup.first.racehorse360
             * @interface IListWorkoutRequestRejectionCommentsResponse
             * @property {Array.<stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment>|null} [workoutRequestRejectionComments] ListWorkoutRequestRejectionCommentsResponse workoutRequestRejectionComments
             * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListWorkoutRequestRejectionCommentsResponse pagingInfo
             */

            /**
             * Constructs a new ListWorkoutRequestRejectionCommentsResponse.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a ListWorkoutRequestRejectionCommentsResponse.
             * @implements IListWorkoutRequestRejectionCommentsResponse
             * @constructor
             * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsResponse=} [properties] Properties to set
             */
            function ListWorkoutRequestRejectionCommentsResponse(properties) {
              this.workoutRequestRejectionComments = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListWorkoutRequestRejectionCommentsResponse workoutRequestRejectionComments.
             * @member {Array.<stronachgroup.first.racehorse360.IWorkoutRequestRejectionComment>} workoutRequestRejectionComments
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @instance
             */
            ListWorkoutRequestRejectionCommentsResponse.prototype.workoutRequestRejectionComments =
              $util.emptyArray;

            /**
             * ListWorkoutRequestRejectionCommentsResponse pagingInfo.
             * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @instance
             */
            ListWorkoutRequestRejectionCommentsResponse.prototype.pagingInfo =
              null;

            /**
             * Creates a new ListWorkoutRequestRejectionCommentsResponse instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsResponse=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse} ListWorkoutRequestRejectionCommentsResponse instance
             */
            ListWorkoutRequestRejectionCommentsResponse.create =
              function create(properties) {
                return new ListWorkoutRequestRejectionCommentsResponse(
                  properties
                );
              };

            /**
             * Encodes the specified ListWorkoutRequestRejectionCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsResponse} message ListWorkoutRequestRejectionCommentsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListWorkoutRequestRejectionCommentsResponse.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.workoutRequestRejectionComments != null &&
                  message.workoutRequestRejectionComments.length
                )
                  for (
                    var i = 0;
                    i < message.workoutRequestRejectionComments.length;
                    ++i
                  )
                    $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.encode(
                      message.workoutRequestRejectionComments[i],
                      writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                    ).ldelim();
                if (
                  message.pagingInfo != null &&
                  Object.hasOwnProperty.call(message, "pagingInfo")
                )
                  $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                    message.pagingInfo,
                    writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
                  ).ldelim();
                return writer;
              };

            /**
             * Decodes a ListWorkoutRequestRejectionCommentsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse} ListWorkoutRequestRejectionCommentsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListWorkoutRequestRejectionCommentsResponse.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (
                        !(
                          message.workoutRequestRejectionComments &&
                          message.workoutRequestRejectionComments.length
                        )
                      )
                        message.workoutRequestRejectionComments = [];
                      message.workoutRequestRejectionComments.push(
                        $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.decode(
                          reader,
                          reader.uint32()
                        )
                      );
                      break;
                    case 100:
                      message.pagingInfo =
                        $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                          reader,
                          reader.uint32()
                        );
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a ListWorkoutRequestRejectionCommentsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse} ListWorkoutRequestRejectionCommentsResponse
             */
            ListWorkoutRequestRejectionCommentsResponse.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestRejectionCommentsResponse
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse();
                if (object.workoutRequestRejectionComments) {
                  if (!Array.isArray(object.workoutRequestRejectionComments))
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse.workoutRequestRejectionComments: array expected"
                    );
                  message.workoutRequestRejectionComments = [];
                  for (
                    var i = 0;
                    i < object.workoutRequestRejectionComments.length;
                    ++i
                  ) {
                    if (
                      typeof object.workoutRequestRejectionComments[i] !==
                      "object"
                    )
                      throw TypeError(
                        ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse.workoutRequestRejectionComments: object expected"
                      );
                    message.workoutRequestRejectionComments[i] =
                      $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.fromObject(
                        object.workoutRequestRejectionComments[i]
                      );
                  }
                }
                if (object.pagingInfo != null) {
                  if (typeof object.pagingInfo !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse.pagingInfo: object expected"
                    );
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                      object.pagingInfo
                    );
                }
                return message;
              };

            /**
             * Creates a plain object from a ListWorkoutRequestRejectionCommentsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @static
             * @param {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse} message ListWorkoutRequestRejectionCommentsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListWorkoutRequestRejectionCommentsResponse.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults)
                  object.workoutRequestRejectionComments = [];
                if (options.defaults) object.pagingInfo = null;
                if (
                  message.workoutRequestRejectionComments &&
                  message.workoutRequestRejectionComments.length
                ) {
                  object.workoutRequestRejectionComments = [];
                  for (
                    var j = 0;
                    j < message.workoutRequestRejectionComments.length;
                    ++j
                  )
                    object.workoutRequestRejectionComments[j] =
                      $root.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment.toObject(
                        message.workoutRequestRejectionComments[j],
                        options
                      );
                }
                if (
                  message.pagingInfo != null &&
                  message.hasOwnProperty("pagingInfo")
                )
                  object.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                      message.pagingInfo,
                      options
                    );
                return object;
              };

            /**
             * Converts this ListWorkoutRequestRejectionCommentsResponse to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListWorkoutRequestRejectionCommentsResponse.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return ListWorkoutRequestRejectionCommentsResponse;
          })();

        racehorse360.HorseExam = (function () {
          /**
           * Properties of a HorseExam.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExam
           * @property {string|null} [id] HorseExam id
           * @property {stronachgroup.first.racehorse360.HorseExamStatus|null} [status] HorseExam status
           * @property {stronachgroup.first.racehorse360.HorseExamType|null} [type] HorseExam type
           * @property {stronachgroup.first.racehorse360.HorseExamResult|null} [result] HorseExam result
           * @property {string|null} [completedDate] HorseExam completedDate
           * @property {string|null} [workoutRequestId] HorseExam workoutRequestId
           * @property {stronachgroup.first.racehorse360.IWorkoutRequest|null} [workoutRequest] HorseExam workoutRequest
           * @property {string|null} [upcomingRaceEntryId] HorseExam upcomingRaceEntryId
           * @property {stronachgroup.first.racehorse360.IUpcomingRaceEntry|null} [upcomingRaceEntry] HorseExam upcomingRaceEntry
           * @property {string|null} [assignedUserId] HorseExam assignedUserId
           * @property {stronachgroup.first.racehorse360.IUser|null} [assignedUser] HorseExam assignedUser
           * @property {string|null} [facilityId] HorseExam facilityId
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] HorseExam facility
           * @property {string|null} [horseId] HorseExam horseId
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] HorseExam horse
           * @property {string|null} [reasonId] HorseExam reasonId
           * @property {stronachgroup.first.racehorse360.IHorseExamReason|null} [reason] HorseExam reason
           * @property {string|null} [conclusionId] HorseExam conclusionId
           * @property {stronachgroup.first.racehorse360.IHorseExamConclusion|null} [conclusion] HorseExam conclusion
           * @property {number|null} [highSpeedFurlongs] HorseExam highSpeedFurlongs
           * @property {stronachgroup.first.racehorse360.HealthWatchStatus|null} [riskLevel] HorseExam riskLevel
           * @property {string|null} [note] HorseExam note
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamJog>|null} [jogs] HorseExam jogs
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetail>|null} [examDetails] HorseExam examDetails
           * @property {stronachgroup.first.racehorse360.IHorseExamComment|null} [commentToTrainer] HorseExam commentToTrainer
           * @property {boolean|null} [isWorkoutExam] HorseExam isWorkoutExam
           * @property {boolean|null} [isEntryExam] HorseExam isEntryExam
           * @property {boolean|null} [isRaceDayExam] HorseExam isRaceDayExam
           * @property {string|null} [sentToIncompassOn] HorseExam sentToIncompassOn
           * @property {string|null} [recompletedOn] HorseExam recompletedOn
           * @property {string|null} [createdOn] HorseExam createdOn
           * @property {string|null} [updatedOn] HorseExam updatedOn
           * @property {string|null} [createdById] HorseExam createdById
           * @property {string|null} [updatedById] HorseExam updatedById
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseExam createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseExam updatedBy
           */

          /**
           * Constructs a new HorseExam.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExam.
           * @implements IHorseExam
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExam=} [properties] Properties to set
           */
          function HorseExam(properties) {
            this.jogs = [];
            this.examDetails = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExam id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.id = "";

          /**
           * HorseExam status.
           * @member {stronachgroup.first.racehorse360.HorseExamStatus} status
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.status = 0;

          /**
           * HorseExam type.
           * @member {stronachgroup.first.racehorse360.HorseExamType} type
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.type = 0;

          /**
           * HorseExam result.
           * @member {stronachgroup.first.racehorse360.HorseExamResult} result
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.result = 0;

          /**
           * HorseExam completedDate.
           * @member {string} completedDate
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.completedDate = "";

          /**
           * HorseExam workoutRequestId.
           * @member {string} workoutRequestId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.workoutRequestId = "";

          /**
           * HorseExam workoutRequest.
           * @member {stronachgroup.first.racehorse360.IWorkoutRequest|null|undefined} workoutRequest
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.workoutRequest = null;

          /**
           * HorseExam upcomingRaceEntryId.
           * @member {string} upcomingRaceEntryId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.upcomingRaceEntryId = "";

          /**
           * HorseExam upcomingRaceEntry.
           * @member {stronachgroup.first.racehorse360.IUpcomingRaceEntry|null|undefined} upcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.upcomingRaceEntry = null;

          /**
           * HorseExam assignedUserId.
           * @member {string} assignedUserId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.assignedUserId = "";

          /**
           * HorseExam assignedUser.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} assignedUser
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.assignedUser = null;

          /**
           * HorseExam facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.facilityId = "";

          /**
           * HorseExam facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.facility = null;

          /**
           * HorseExam horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.horseId = "";

          /**
           * HorseExam horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.horse = null;

          /**
           * HorseExam reasonId.
           * @member {string} reasonId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.reasonId = "";

          /**
           * HorseExam reason.
           * @member {stronachgroup.first.racehorse360.IHorseExamReason|null|undefined} reason
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.reason = null;

          /**
           * HorseExam conclusionId.
           * @member {string} conclusionId
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.conclusionId = "";

          /**
           * HorseExam conclusion.
           * @member {stronachgroup.first.racehorse360.IHorseExamConclusion|null|undefined} conclusion
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.conclusion = null;

          /**
           * HorseExam highSpeedFurlongs.
           * @member {number} highSpeedFurlongs
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.highSpeedFurlongs = 0;

          /**
           * HorseExam riskLevel.
           * @member {stronachgroup.first.racehorse360.HealthWatchStatus} riskLevel
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.riskLevel = 0;

          /**
           * HorseExam note.
           * @member {string} note
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.note = "";

          /**
           * HorseExam jogs.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamJog>} jogs
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.jogs = $util.emptyArray;

          /**
           * HorseExam examDetails.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetail>} examDetails
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.examDetails = $util.emptyArray;

          /**
           * HorseExam commentToTrainer.
           * @member {stronachgroup.first.racehorse360.IHorseExamComment|null|undefined} commentToTrainer
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.commentToTrainer = null;

          /**
           * HorseExam isWorkoutExam.
           * @member {boolean} isWorkoutExam
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.isWorkoutExam = false;

          /**
           * HorseExam isEntryExam.
           * @member {boolean} isEntryExam
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.isEntryExam = false;

          /**
           * HorseExam isRaceDayExam.
           * @member {boolean} isRaceDayExam
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.isRaceDayExam = false;

          /**
           * HorseExam sentToIncompassOn.
           * @member {string} sentToIncompassOn
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.sentToIncompassOn = "";

          /**
           * HorseExam recompletedOn.
           * @member {string} recompletedOn
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.recompletedOn = "";

          /**
           * HorseExam createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.createdOn = "";

          /**
           * HorseExam updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.updatedOn = "";

          /**
           * HorseExam createdById.
           * @member {string} createdById
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.createdById = "";

          /**
           * HorseExam updatedById.
           * @member {string} updatedById
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.updatedById = "";

          /**
           * HorseExam createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.createdBy = null;

          /**
           * HorseExam updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           */
          HorseExam.prototype.updatedBy = null;

          /**
           * Creates a new HorseExam instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExam=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExam} HorseExam instance
           */
          HorseExam.create = function create(properties) {
            return new HorseExam(properties);
          };

          /**
           * Encodes the specified HorseExam message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExam.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExam} message HorseExam message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExam.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.status);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.type);
            if (
              message.result != null &&
              Object.hasOwnProperty.call(message, "result")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.result);
            if (
              message.completedDate != null &&
              Object.hasOwnProperty.call(message, "completedDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.completedDate);
            if (
              message.workoutRequestId != null &&
              Object.hasOwnProperty.call(message, "workoutRequestId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.workoutRequestId);
            if (
              message.workoutRequest != null &&
              Object.hasOwnProperty.call(message, "workoutRequest")
            )
              $root.stronachgroup.first.racehorse360.WorkoutRequest.encode(
                message.workoutRequest,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.upcomingRaceEntryId != null &&
              Object.hasOwnProperty.call(message, "upcomingRaceEntryId")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.upcomingRaceEntryId);
            if (
              message.upcomingRaceEntry != null &&
              Object.hasOwnProperty.call(message, "upcomingRaceEntry")
            )
              $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.encode(
                message.upcomingRaceEntry,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.assignedUserId != null &&
              Object.hasOwnProperty.call(message, "assignedUserId")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.assignedUserId);
            if (
              message.assignedUser != null &&
              Object.hasOwnProperty.call(message, "assignedUser")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.assignedUser,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.facilityId);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.horseId);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            if (
              message.reasonId != null &&
              Object.hasOwnProperty.call(message, "reasonId")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.reasonId);
            if (
              message.reason != null &&
              Object.hasOwnProperty.call(message, "reason")
            )
              $root.stronachgroup.first.racehorse360.HorseExamReason.encode(
                message.reason,
                writer.uint32(/* id 17, wireType 2 =*/ 138).fork()
              ).ldelim();
            if (
              message.conclusionId != null &&
              Object.hasOwnProperty.call(message, "conclusionId")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.conclusionId);
            if (
              message.conclusion != null &&
              Object.hasOwnProperty.call(message, "conclusion")
            )
              $root.stronachgroup.first.racehorse360.HorseExamConclusion.encode(
                message.conclusion,
                writer.uint32(/* id 19, wireType 2 =*/ 154).fork()
              ).ldelim();
            if (
              message.highSpeedFurlongs != null &&
              Object.hasOwnProperty.call(message, "highSpeedFurlongs")
            )
              writer
                .uint32(/* id 20, wireType 0 =*/ 160)
                .int32(message.highSpeedFurlongs);
            if (
              message.riskLevel != null &&
              Object.hasOwnProperty.call(message, "riskLevel")
            )
              writer
                .uint32(/* id 21, wireType 0 =*/ 168)
                .int32(message.riskLevel);
            if (
              message.note != null &&
              Object.hasOwnProperty.call(message, "note")
            )
              writer.uint32(/* id 22, wireType 2 =*/ 178).string(message.note);
            if (message.jogs != null && message.jogs.length)
              for (var i = 0; i < message.jogs.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamJog.encode(
                  message.jogs[i],
                  writer.uint32(/* id 23, wireType 2 =*/ 186).fork()
                ).ldelim();
            if (message.examDetails != null && message.examDetails.length)
              for (var i = 0; i < message.examDetails.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetail.encode(
                  message.examDetails[i],
                  writer.uint32(/* id 24, wireType 2 =*/ 194).fork()
                ).ldelim();
            if (
              message.commentToTrainer != null &&
              Object.hasOwnProperty.call(message, "commentToTrainer")
            )
              $root.stronachgroup.first.racehorse360.HorseExamComment.encode(
                message.commentToTrainer,
                writer.uint32(/* id 25, wireType 2 =*/ 202).fork()
              ).ldelim();
            if (
              message.isWorkoutExam != null &&
              Object.hasOwnProperty.call(message, "isWorkoutExam")
            )
              writer
                .uint32(/* id 26, wireType 0 =*/ 208)
                .bool(message.isWorkoutExam);
            if (
              message.isEntryExam != null &&
              Object.hasOwnProperty.call(message, "isEntryExam")
            )
              writer
                .uint32(/* id 27, wireType 0 =*/ 216)
                .bool(message.isEntryExam);
            if (
              message.isRaceDayExam != null &&
              Object.hasOwnProperty.call(message, "isRaceDayExam")
            )
              writer
                .uint32(/* id 28, wireType 0 =*/ 224)
                .bool(message.isRaceDayExam);
            if (
              message.sentToIncompassOn != null &&
              Object.hasOwnProperty.call(message, "sentToIncompassOn")
            )
              writer
                .uint32(/* id 30, wireType 2 =*/ 242)
                .string(message.sentToIncompassOn);
            if (
              message.recompletedOn != null &&
              Object.hasOwnProperty.call(message, "recompletedOn")
            )
              writer
                .uint32(/* id 31, wireType 2 =*/ 250)
                .string(message.recompletedOn);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdById != null &&
              Object.hasOwnProperty.call(message, "createdById")
            )
              writer
                .uint32(/* id 1004, wireType 2 =*/ 8034)
                .string(message.createdById);
            if (
              message.updatedById != null &&
              Object.hasOwnProperty.call(message, "updatedById")
            )
              writer
                .uint32(/* id 1005, wireType 2 =*/ 8042)
                .string(message.updatedById);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1006, wireType 2 =*/ 8050).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1007, wireType 2 =*/ 8058).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExam message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExam} HorseExam
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExam.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.HorseExam();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.status = reader.int32();
                  break;
                case 3:
                  message.type = reader.int32();
                  break;
                case 4:
                  message.result = reader.int32();
                  break;
                case 5:
                  message.completedDate = reader.string();
                  break;
                case 6:
                  message.workoutRequestId = reader.string();
                  break;
                case 7:
                  message.workoutRequest =
                    $root.stronachgroup.first.racehorse360.WorkoutRequest.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.upcomingRaceEntryId = reader.string();
                  break;
                case 9:
                  message.upcomingRaceEntry =
                    $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.assignedUserId = reader.string();
                  break;
                case 11:
                  message.assignedUser =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.facilityId = reader.string();
                  break;
                case 13:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.horseId = reader.string();
                  break;
                case 15:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 16:
                  message.reasonId = reader.string();
                  break;
                case 17:
                  message.reason =
                    $root.stronachgroup.first.racehorse360.HorseExamReason.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 18:
                  message.conclusionId = reader.string();
                  break;
                case 19:
                  message.conclusion =
                    $root.stronachgroup.first.racehorse360.HorseExamConclusion.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 20:
                  message.highSpeedFurlongs = reader.int32();
                  break;
                case 21:
                  message.riskLevel = reader.int32();
                  break;
                case 22:
                  message.note = reader.string();
                  break;
                case 23:
                  if (!(message.jogs && message.jogs.length)) message.jogs = [];
                  message.jogs.push(
                    $root.stronachgroup.first.racehorse360.HorseExamJog.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 24:
                  if (!(message.examDetails && message.examDetails.length))
                    message.examDetails = [];
                  message.examDetails.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetail.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 25:
                  message.commentToTrainer =
                    $root.stronachgroup.first.racehorse360.HorseExamComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 26:
                  message.isWorkoutExam = reader.bool();
                  break;
                case 27:
                  message.isEntryExam = reader.bool();
                  break;
                case 28:
                  message.isRaceDayExam = reader.bool();
                  break;
                case 30:
                  message.sentToIncompassOn = reader.string();
                  break;
                case 31:
                  message.recompletedOn = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1004:
                  message.createdById = reader.string();
                  break;
                case 1005:
                  message.updatedById = reader.string();
                  break;
                case 1006:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1007:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExam message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExam} HorseExam
           */
          HorseExam.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.HorseExam
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExam();
            if (object.id != null) message.id = String(object.id);
            switch (object.status) {
              case "HORSE_EXAM_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "HORSE_EXAM_STATUS_REQUESTED":
              case 1:
                message.status = 1;
                break;
              case "HORSE_EXAM_STATUS_IN_PROGRESS":
              case 2:
                message.status = 2;
                break;
              case "HORSE_EXAM_STATUS_PENDING":
              case 3:
                message.status = 3;
                break;
              case "HORSE_EXAM_STATUS_COMPLETED":
              case 4:
                message.status = 4;
                break;
              case "HORSE_EXAM_STATUS_CANCELLED":
              case 5:
                message.status = 5;
                break;
              case "HORSE_EXAM_STATUS_ABANDONED":
              case 6:
                message.status = 6;
                break;
            }
            switch (object.type) {
              case "HORSE_EXAM_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "HORSE_EXAM_TYPE_NORMAL":
              case 1:
                message.type = 1;
                break;
              case "HORSE_EXAM_TYPE_QUICK_PASS":
              case 2:
                message.type = 2;
                break;
              case "HORSE_EXAM_TYPE_FULL_EXAM":
              case 3:
                message.type = 3;
                break;
            }
            switch (object.result) {
              case "HORSE_EXAM_RESULT_INVALID":
              case 0:
                message.result = 0;
                break;
              case "HORSE_EXAM_RESULT_PASSED":
              case 1:
                message.result = 1;
                break;
              case "HORSE_EXAM_RESULT_FAILED":
              case 2:
                message.result = 2;
                break;
            }
            if (object.completedDate != null)
              message.completedDate = String(object.completedDate);
            if (object.workoutRequestId != null)
              message.workoutRequestId = String(object.workoutRequestId);
            if (object.workoutRequest != null) {
              if (typeof object.workoutRequest !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.workoutRequest: object expected"
                );
              message.workoutRequest =
                $root.stronachgroup.first.racehorse360.WorkoutRequest.fromObject(
                  object.workoutRequest
                );
            }
            if (object.upcomingRaceEntryId != null)
              message.upcomingRaceEntryId = String(object.upcomingRaceEntryId);
            if (object.upcomingRaceEntry != null) {
              if (typeof object.upcomingRaceEntry !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.upcomingRaceEntry: object expected"
                );
              message.upcomingRaceEntry =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.fromObject(
                  object.upcomingRaceEntry
                );
            }
            if (object.assignedUserId != null)
              message.assignedUserId = String(object.assignedUserId);
            if (object.assignedUser != null) {
              if (typeof object.assignedUser !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.assignedUser: object expected"
                );
              message.assignedUser =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.assignedUser
                );
            }
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.reasonId != null)
              message.reasonId = String(object.reasonId);
            if (object.reason != null) {
              if (typeof object.reason !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.reason: object expected"
                );
              message.reason =
                $root.stronachgroup.first.racehorse360.HorseExamReason.fromObject(
                  object.reason
                );
            }
            if (object.conclusionId != null)
              message.conclusionId = String(object.conclusionId);
            if (object.conclusion != null) {
              if (typeof object.conclusion !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.conclusion: object expected"
                );
              message.conclusion =
                $root.stronachgroup.first.racehorse360.HorseExamConclusion.fromObject(
                  object.conclusion
                );
            }
            if (object.highSpeedFurlongs != null)
              message.highSpeedFurlongs = object.highSpeedFurlongs | 0;
            switch (object.riskLevel) {
              case "HEALTH_WATCH_STATUS_INVALID":
              case 0:
                message.riskLevel = 0;
                break;
              case "HEALTH_WATCH_STATUS_GREEN":
              case 1:
                message.riskLevel = 1;
                break;
              case "HEALTH_WATCH_STATUS_YELLOW":
              case 2:
                message.riskLevel = 2;
                break;
              case "HEALTH_WATCH_STATUS_RED":
              case 3:
                message.riskLevel = 3;
                break;
            }
            if (object.note != null) message.note = String(object.note);
            if (object.jogs) {
              if (!Array.isArray(object.jogs))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.jogs: array expected"
                );
              message.jogs = [];
              for (var i = 0; i < object.jogs.length; ++i) {
                if (typeof object.jogs[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorseExam.jogs: object expected"
                  );
                message.jogs[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamJog.fromObject(
                    object.jogs[i]
                  );
              }
            }
            if (object.examDetails) {
              if (!Array.isArray(object.examDetails))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.examDetails: array expected"
                );
              message.examDetails = [];
              for (var i = 0; i < object.examDetails.length; ++i) {
                if (typeof object.examDetails[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorseExam.examDetails: object expected"
                  );
                message.examDetails[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetail.fromObject(
                    object.examDetails[i]
                  );
              }
            }
            if (object.commentToTrainer != null) {
              if (typeof object.commentToTrainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.commentToTrainer: object expected"
                );
              message.commentToTrainer =
                $root.stronachgroup.first.racehorse360.HorseExamComment.fromObject(
                  object.commentToTrainer
                );
            }
            if (object.isWorkoutExam != null)
              message.isWorkoutExam = Boolean(object.isWorkoutExam);
            if (object.isEntryExam != null)
              message.isEntryExam = Boolean(object.isEntryExam);
            if (object.isRaceDayExam != null)
              message.isRaceDayExam = Boolean(object.isRaceDayExam);
            if (object.sentToIncompassOn != null)
              message.sentToIncompassOn = String(object.sentToIncompassOn);
            if (object.recompletedOn != null)
              message.recompletedOn = String(object.recompletedOn);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdById != null)
              message.createdById = String(object.createdById);
            if (object.updatedById != null)
              message.updatedById = String(object.updatedById);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExam.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExam message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExam} message HorseExam
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExam.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.jogs = [];
              object.examDetails = [];
            }
            if (options.defaults) {
              object.id = "";
              object.status =
                options.enums === String ? "HORSE_EXAM_STATUS_INVALID" : 0;
              object.type =
                options.enums === String ? "HORSE_EXAM_TYPE_INVALID" : 0;
              object.result =
                options.enums === String ? "HORSE_EXAM_RESULT_INVALID" : 0;
              object.completedDate = "";
              object.workoutRequestId = "";
              object.workoutRequest = null;
              object.upcomingRaceEntryId = "";
              object.upcomingRaceEntry = null;
              object.assignedUserId = "";
              object.assignedUser = null;
              object.facilityId = "";
              object.facility = null;
              object.horseId = "";
              object.horse = null;
              object.reasonId = "";
              object.reason = null;
              object.conclusionId = "";
              object.conclusion = null;
              object.highSpeedFurlongs = 0;
              object.riskLevel =
                options.enums === String ? "HEALTH_WATCH_STATUS_INVALID" : 0;
              object.note = "";
              object.commentToTrainer = null;
              object.isWorkoutExam = false;
              object.isEntryExam = false;
              object.isRaceDayExam = false;
              object.sentToIncompassOn = "";
              object.recompletedOn = "";
              object.createdOn = "";
              object.updatedOn = "";
              object.createdById = "";
              object.updatedById = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamStatus[
                      message.status
                    ]
                  : message.status;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamType[
                      message.type
                    ]
                  : message.type;
            if (message.result != null && message.hasOwnProperty("result"))
              object.result =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                      message.result
                    ]
                  : message.result;
            if (
              message.completedDate != null &&
              message.hasOwnProperty("completedDate")
            )
              object.completedDate = message.completedDate;
            if (
              message.workoutRequestId != null &&
              message.hasOwnProperty("workoutRequestId")
            )
              object.workoutRequestId = message.workoutRequestId;
            if (
              message.workoutRequest != null &&
              message.hasOwnProperty("workoutRequest")
            )
              object.workoutRequest =
                $root.stronachgroup.first.racehorse360.WorkoutRequest.toObject(
                  message.workoutRequest,
                  options
                );
            if (
              message.upcomingRaceEntryId != null &&
              message.hasOwnProperty("upcomingRaceEntryId")
            )
              object.upcomingRaceEntryId = message.upcomingRaceEntryId;
            if (
              message.upcomingRaceEntry != null &&
              message.hasOwnProperty("upcomingRaceEntry")
            )
              object.upcomingRaceEntry =
                $root.stronachgroup.first.racehorse360.UpcomingRaceEntry.toObject(
                  message.upcomingRaceEntry,
                  options
                );
            if (
              message.assignedUserId != null &&
              message.hasOwnProperty("assignedUserId")
            )
              object.assignedUserId = message.assignedUserId;
            if (
              message.assignedUser != null &&
              message.hasOwnProperty("assignedUser")
            )
              object.assignedUser =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.assignedUser,
                  options
                );
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.reasonId != null && message.hasOwnProperty("reasonId"))
              object.reasonId = message.reasonId;
            if (message.reason != null && message.hasOwnProperty("reason"))
              object.reason =
                $root.stronachgroup.first.racehorse360.HorseExamReason.toObject(
                  message.reason,
                  options
                );
            if (
              message.conclusionId != null &&
              message.hasOwnProperty("conclusionId")
            )
              object.conclusionId = message.conclusionId;
            if (
              message.conclusion != null &&
              message.hasOwnProperty("conclusion")
            )
              object.conclusion =
                $root.stronachgroup.first.racehorse360.HorseExamConclusion.toObject(
                  message.conclusion,
                  options
                );
            if (
              message.highSpeedFurlongs != null &&
              message.hasOwnProperty("highSpeedFurlongs")
            )
              object.highSpeedFurlongs = message.highSpeedFurlongs;
            if (
              message.riskLevel != null &&
              message.hasOwnProperty("riskLevel")
            )
              object.riskLevel =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HealthWatchStatus[
                      message.riskLevel
                    ]
                  : message.riskLevel;
            if (message.note != null && message.hasOwnProperty("note"))
              object.note = message.note;
            if (message.jogs && message.jogs.length) {
              object.jogs = [];
              for (var j = 0; j < message.jogs.length; ++j)
                object.jogs[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamJog.toObject(
                    message.jogs[j],
                    options
                  );
            }
            if (message.examDetails && message.examDetails.length) {
              object.examDetails = [];
              for (var j = 0; j < message.examDetails.length; ++j)
                object.examDetails[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetail.toObject(
                    message.examDetails[j],
                    options
                  );
            }
            if (
              message.commentToTrainer != null &&
              message.hasOwnProperty("commentToTrainer")
            )
              object.commentToTrainer =
                $root.stronachgroup.first.racehorse360.HorseExamComment.toObject(
                  message.commentToTrainer,
                  options
                );
            if (
              message.isWorkoutExam != null &&
              message.hasOwnProperty("isWorkoutExam")
            )
              object.isWorkoutExam = message.isWorkoutExam;
            if (
              message.isEntryExam != null &&
              message.hasOwnProperty("isEntryExam")
            )
              object.isEntryExam = message.isEntryExam;
            if (
              message.isRaceDayExam != null &&
              message.hasOwnProperty("isRaceDayExam")
            )
              object.isRaceDayExam = message.isRaceDayExam;
            if (
              message.sentToIncompassOn != null &&
              message.hasOwnProperty("sentToIncompassOn")
            )
              object.sentToIncompassOn = message.sentToIncompassOn;
            if (
              message.recompletedOn != null &&
              message.hasOwnProperty("recompletedOn")
            )
              object.recompletedOn = message.recompletedOn;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdById != null &&
              message.hasOwnProperty("createdById")
            )
              object.createdById = message.createdById;
            if (
              message.updatedById != null &&
              message.hasOwnProperty("updatedById")
            )
              object.updatedById = message.updatedById;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseExam to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExam
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExam;
        })();

        racehorse360.HorseExamReason = (function () {
          /**
           * Properties of a HorseExamReason.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamReason
           * @property {string|null} [id] HorseExamReason id
           * @property {string|null} [description] HorseExamReason description
           * @property {stronachgroup.first.racehorse360.HorseExamReasonCode|null} [code] HorseExamReason code
           */

          /**
           * Constructs a new HorseExamReason.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamReason.
           * @implements IHorseExamReason
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamReason=} [properties] Properties to set
           */
          function HorseExamReason(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamReason id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @instance
           */
          HorseExamReason.prototype.id = "";

          /**
           * HorseExamReason description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @instance
           */
          HorseExamReason.prototype.description = "";

          /**
           * HorseExamReason code.
           * @member {stronachgroup.first.racehorse360.HorseExamReasonCode} code
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @instance
           */
          HorseExamReason.prototype.code = 0;

          /**
           * Creates a new HorseExamReason instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamReason=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamReason} HorseExamReason instance
           */
          HorseExamReason.create = function create(properties) {
            return new HorseExamReason(properties);
          };

          /**
           * Encodes the specified HorseExamReason message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamReason.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamReason} message HorseExamReason message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamReason.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.code != null &&
              Object.hasOwnProperty.call(message, "code")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.code);
            return writer;
          };

          /**
           * Decodes a HorseExamReason message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamReason} HorseExamReason
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamReason.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamReason();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.code = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamReason message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamReason} HorseExamReason
           */
          HorseExamReason.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamReason
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamReason();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            switch (object.code) {
              case "HORSE_EXAM_REASON_CODE_INVALID":
              case 0:
                message.code = 0;
                break;
              case "HORSE_EXAM_REASON_CODE_WORKOUT_REQUEST":
              case 1:
                message.code = 1;
                break;
              case "HORSE_EXAM_REASON_CODE_FLAGGED_WORKOUT":
              case 2:
                message.code = 2;
                break;
              case "HORSE_EXAM_REASON_CODE_TRAINER_REQUESTED":
              case 3:
                message.code = 3;
                break;
              case "HORSE_EXAM_REASON_CODE_PANEL_EXAM":
              case 4:
                message.code = 4;
                break;
              case "HORSE_EXAM_REASON_CODE_REGULATORY_VET":
              case 5:
                message.code = 5;
                break;
              case "HORSE_EXAM_REASON_CODE_PRE_RACE":
              case 6:
                message.code = 6;
                break;
              case "HORSE_EXAM_REASON_CODE_PRE_WORK":
              case 7:
                message.code = 7;
                break;
              case "HORSE_EXAM_REASON_CODE_ENTRY_EXAM":
              case 8:
                message.code = 8;
                break;
              case "HORSE_EXAM_REASON_CODE_RACE_DAY_EXAM":
              case 9:
                message.code = 9;
                break;
              case "HORSE_EXAM_REASON_CODE_TSE_1":
              case 10:
                message.code = 10;
                break;
              case "HORSE_EXAM_REASON_CODE_TSE_2":
              case 11:
                message.code = 11;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamReason message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamReason} message HorseExamReason
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamReason.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.code =
                options.enums === String ? "HORSE_EXAM_REASON_CODE_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.code != null && message.hasOwnProperty("code"))
              object.code =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamReasonCode[
                      message.code
                    ]
                  : message.code;
            return object;
          };

          /**
           * Converts this HorseExamReason to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamReason
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamReason.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamReason;
        })();

        racehorse360.HorseExamConclusion = (function () {
          /**
           * Properties of a HorseExamConclusion.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamConclusion
           * @property {string|null} [id] HorseExamConclusion id
           * @property {string|null} [description] HorseExamConclusion description
           */

          /**
           * Constructs a new HorseExamConclusion.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamConclusion.
           * @implements IHorseExamConclusion
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamConclusion=} [properties] Properties to set
           */
          function HorseExamConclusion(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamConclusion id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @instance
           */
          HorseExamConclusion.prototype.id = "";

          /**
           * HorseExamConclusion description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @instance
           */
          HorseExamConclusion.prototype.description = "";

          /**
           * Creates a new HorseExamConclusion instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamConclusion=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamConclusion} HorseExamConclusion instance
           */
          HorseExamConclusion.create = function create(properties) {
            return new HorseExamConclusion(properties);
          };

          /**
           * Encodes the specified HorseExamConclusion message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamConclusion.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamConclusion} message HorseExamConclusion message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamConclusion.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a HorseExamConclusion message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamConclusion} HorseExamConclusion
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamConclusion.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamConclusion();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamConclusion message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamConclusion} HorseExamConclusion
           */
          HorseExamConclusion.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamConclusion
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamConclusion();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamConclusion message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamConclusion} message HorseExamConclusion
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamConclusion.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this HorseExamConclusion to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamConclusion
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamConclusion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamConclusion;
        })();

        racehorse360.HorseExamLimb = (function () {
          /**
           * Properties of a HorseExamLimb.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamLimb
           * @property {string|null} [id] HorseExamLimb id
           * @property {string|null} [description] HorseExamLimb description
           * @property {string|null} [shortDescription] HorseExamLimb shortDescription
           */

          /**
           * Constructs a new HorseExamLimb.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamLimb.
           * @implements IHorseExamLimb
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamLimb=} [properties] Properties to set
           */
          function HorseExamLimb(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamLimb id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @instance
           */
          HorseExamLimb.prototype.id = "";

          /**
           * HorseExamLimb description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @instance
           */
          HorseExamLimb.prototype.description = "";

          /**
           * HorseExamLimb shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @instance
           */
          HorseExamLimb.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamLimb instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamLimb=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamLimb} HorseExamLimb instance
           */
          HorseExamLimb.create = function create(properties) {
            return new HorseExamLimb(properties);
          };

          /**
           * Encodes the specified HorseExamLimb message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamLimb.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamLimb} message HorseExamLimb message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamLimb.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamLimb message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamLimb} HorseExamLimb
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamLimb.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamLimb();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamLimb message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamLimb} HorseExamLimb
           */
          HorseExamLimb.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamLimb
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamLimb();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamLimb message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamLimb} message HorseExamLimb
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamLimb.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamLimb to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamLimb
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamLimb.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamLimb;
        })();

        racehorse360.HorseExamFilter = (function () {
          /**
           * Properties of a HorseExamFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamFilter
           * @property {Array.<string>|null} [ids] HorseExamFilter ids
           * @property {string|null} [workoutRequestId] HorseExamFilter workoutRequestId
           * @property {string|null} [upcomingRaceEntryId] HorseExamFilter upcomingRaceEntryId
           * @property {Array.<string>|null} [horseIds] HorseExamFilter horseIds
           * @property {Array.<string>|null} [trainerIds] HorseExamFilter trainerIds
           * @property {Array.<string>|null} [assignedVetIds] HorseExamFilter assignedVetIds
           * @property {Array.<string>|null} [facilityIds] HorseExamFilter facilityIds
           * @property {Array.<stronachgroup.first.racehorse360.HorseExamStatus>|null} [statuses] HorseExamFilter statuses
           * @property {Array.<stronachgroup.first.racehorse360.HorseExamResult>|null} [results] HorseExamFilter results
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [completedDate] HorseExamFilter completedDate
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [createdOn] HorseExamFilter createdOn
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseOrTrainerName] HorseExamFilter horseOrTrainerName
           * @property {Array.<stronachgroup.first.racehorse360.HorseExamType>|null} [horseExamTypes] HorseExamFilter horseExamTypes
           * @property {google.protobuf.IBoolValue|null} [withWorkout] HorseExamFilter withWorkout
           * @property {google.protobuf.IBoolValue|null} [withUpcomingRaceEntry] HorseExamFilter withUpcomingRaceEntry
           * @property {boolean|null} [withNoteOnly] HorseExamFilter withNoteOnly
           */

          /**
           * Constructs a new HorseExamFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamFilter.
           * @implements IHorseExamFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamFilter=} [properties] Properties to set
           */
          function HorseExamFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.trainerIds = [];
            this.assignedVetIds = [];
            this.facilityIds = [];
            this.statuses = [];
            this.results = [];
            this.horseExamTypes = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseExamFilter workoutRequestId.
           * @member {string} workoutRequestId
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.workoutRequestId = "";

          /**
           * HorseExamFilter upcomingRaceEntryId.
           * @member {string} upcomingRaceEntryId
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.upcomingRaceEntryId = "";

          /**
           * HorseExamFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.horseIds = $util.emptyArray;

          /**
           * HorseExamFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * HorseExamFilter assignedVetIds.
           * @member {Array.<string>} assignedVetIds
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.assignedVetIds = $util.emptyArray;

          /**
           * HorseExamFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * HorseExamFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.HorseExamStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.statuses = $util.emptyArray;

          /**
           * HorseExamFilter results.
           * @member {Array.<stronachgroup.first.racehorse360.HorseExamResult>} results
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.results = $util.emptyArray;

          /**
           * HorseExamFilter completedDate.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} completedDate
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.completedDate = null;

          /**
           * HorseExamFilter createdOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.createdOn = null;

          /**
           * HorseExamFilter horseOrTrainerName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseOrTrainerName
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.horseOrTrainerName = null;

          /**
           * HorseExamFilter horseExamTypes.
           * @member {Array.<stronachgroup.first.racehorse360.HorseExamType>} horseExamTypes
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.horseExamTypes = $util.emptyArray;

          /**
           * HorseExamFilter withWorkout.
           * @member {google.protobuf.IBoolValue|null|undefined} withWorkout
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.withWorkout = null;

          /**
           * HorseExamFilter withUpcomingRaceEntry.
           * @member {google.protobuf.IBoolValue|null|undefined} withUpcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.withUpcomingRaceEntry = null;

          /**
           * HorseExamFilter withNoteOnly.
           * @member {boolean} withNoteOnly
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           */
          HorseExamFilter.prototype.withNoteOnly = false;

          /**
           * Creates a new HorseExamFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamFilter} HorseExamFilter instance
           */
          HorseExamFilter.create = function create(properties) {
            return new HorseExamFilter(properties);
          };

          /**
           * Encodes the specified HorseExamFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamFilter} message HorseExamFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.workoutRequestId != null &&
              Object.hasOwnProperty.call(message, "workoutRequestId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.workoutRequestId);
            if (
              message.upcomingRaceEntryId != null &&
              Object.hasOwnProperty.call(message, "upcomingRaceEntryId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.upcomingRaceEntryId);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.horseIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.trainerIds[i]);
            if (message.assignedVetIds != null && message.assignedVetIds.length)
              for (var i = 0; i < message.assignedVetIds.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.assignedVetIds[i]);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.facilityIds[i]);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            if (message.results != null && message.results.length) {
              writer.uint32(/* id 9, wireType 2 =*/ 74).fork();
              for (var i = 0; i < message.results.length; ++i)
                writer.int32(message.results[i]);
              writer.ldelim();
            }
            if (
              message.completedDate != null &&
              Object.hasOwnProperty.call(message, "completedDate")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.completedDate,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.createdOn,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.horseOrTrainerName != null &&
              Object.hasOwnProperty.call(message, "horseOrTrainerName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseOrTrainerName,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.horseExamTypes != null &&
              message.horseExamTypes.length
            ) {
              writer.uint32(/* id 13, wireType 2 =*/ 106).fork();
              for (var i = 0; i < message.horseExamTypes.length; ++i)
                writer.int32(message.horseExamTypes[i]);
              writer.ldelim();
            }
            if (
              message.withWorkout != null &&
              Object.hasOwnProperty.call(message, "withWorkout")
            )
              $root.google.protobuf.BoolValue.encode(
                message.withWorkout,
                writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
              ).ldelim();
            if (
              message.withUpcomingRaceEntry != null &&
              Object.hasOwnProperty.call(message, "withUpcomingRaceEntry")
            )
              $root.google.protobuf.BoolValue.encode(
                message.withUpcomingRaceEntry,
                writer.uint32(/* id 15, wireType 2 =*/ 122).fork()
              ).ldelim();
            if (
              message.withNoteOnly != null &&
              Object.hasOwnProperty.call(message, "withNoteOnly")
            )
              writer
                .uint32(/* id 16, wireType 0 =*/ 128)
                .bool(message.withNoteOnly);
            return writer;
          };

          /**
           * Decodes a HorseExamFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamFilter} HorseExamFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.workoutRequestId = reader.string();
                  break;
                case 3:
                  message.upcomingRaceEntryId = reader.string();
                  break;
                case 4:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 5:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 6:
                  if (
                    !(message.assignedVetIds && message.assignedVetIds.length)
                  )
                    message.assignedVetIds = [];
                  message.assignedVetIds.push(reader.string());
                  break;
                case 7:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 8:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                case 9:
                  if (!(message.results && message.results.length))
                    message.results = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.results.push(reader.int32());
                  } else message.results.push(reader.int32());
                  break;
                case 10:
                  message.completedDate =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.createdOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.horseOrTrainerName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  if (
                    !(message.horseExamTypes && message.horseExamTypes.length)
                  )
                    message.horseExamTypes = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.horseExamTypes.push(reader.int32());
                  } else message.horseExamTypes.push(reader.int32());
                  break;
                case 14:
                  message.withWorkout = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 15:
                  message.withUpcomingRaceEntry =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 16:
                  message.withNoteOnly = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamFilter} HorseExamFilter
           */
          HorseExamFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.workoutRequestId != null)
              message.workoutRequestId = String(object.workoutRequestId);
            if (object.upcomingRaceEntryId != null)
              message.upcomingRaceEntryId = String(object.upcomingRaceEntryId);
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.assignedVetIds) {
              if (!Array.isArray(object.assignedVetIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.assignedVetIds: array expected"
                );
              message.assignedVetIds = [];
              for (var i = 0; i < object.assignedVetIds.length; ++i)
                message.assignedVetIds[i] = String(object.assignedVetIds[i]);
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "HORSE_EXAM_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "HORSE_EXAM_STATUS_REQUESTED":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "HORSE_EXAM_STATUS_IN_PROGRESS":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                  case "HORSE_EXAM_STATUS_PENDING":
                  case 3:
                    message.statuses[i] = 3;
                    break;
                  case "HORSE_EXAM_STATUS_COMPLETED":
                  case 4:
                    message.statuses[i] = 4;
                    break;
                  case "HORSE_EXAM_STATUS_CANCELLED":
                  case 5:
                    message.statuses[i] = 5;
                    break;
                  case "HORSE_EXAM_STATUS_ABANDONED":
                  case 6:
                    message.statuses[i] = 6;
                    break;
                }
            }
            if (object.results) {
              if (!Array.isArray(object.results))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.results: array expected"
                );
              message.results = [];
              for (var i = 0; i < object.results.length; ++i)
                switch (object.results[i]) {
                  default:
                  case "HORSE_EXAM_RESULT_INVALID":
                  case 0:
                    message.results[i] = 0;
                    break;
                  case "HORSE_EXAM_RESULT_PASSED":
                  case 1:
                    message.results[i] = 1;
                    break;
                  case "HORSE_EXAM_RESULT_FAILED":
                  case 2:
                    message.results[i] = 2;
                    break;
                }
            }
            if (object.completedDate != null) {
              if (typeof object.completedDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.completedDate: object expected"
                );
              message.completedDate =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.completedDate
                );
            }
            if (object.createdOn != null) {
              if (typeof object.createdOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.createdOn: object expected"
                );
              message.createdOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.createdOn
                );
            }
            if (object.horseOrTrainerName != null) {
              if (typeof object.horseOrTrainerName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.horseOrTrainerName: object expected"
                );
              message.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseOrTrainerName
                );
            }
            if (object.horseExamTypes) {
              if (!Array.isArray(object.horseExamTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.horseExamTypes: array expected"
                );
              message.horseExamTypes = [];
              for (var i = 0; i < object.horseExamTypes.length; ++i)
                switch (object.horseExamTypes[i]) {
                  default:
                  case "HORSE_EXAM_TYPE_INVALID":
                  case 0:
                    message.horseExamTypes[i] = 0;
                    break;
                  case "HORSE_EXAM_TYPE_NORMAL":
                  case 1:
                    message.horseExamTypes[i] = 1;
                    break;
                  case "HORSE_EXAM_TYPE_QUICK_PASS":
                  case 2:
                    message.horseExamTypes[i] = 2;
                    break;
                  case "HORSE_EXAM_TYPE_FULL_EXAM":
                  case 3:
                    message.horseExamTypes[i] = 3;
                    break;
                }
            }
            if (object.withWorkout != null) {
              if (typeof object.withWorkout !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.withWorkout: object expected"
                );
              message.withWorkout = $root.google.protobuf.BoolValue.fromObject(
                object.withWorkout
              );
            }
            if (object.withUpcomingRaceEntry != null) {
              if (typeof object.withUpcomingRaceEntry !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamFilter.withUpcomingRaceEntry: object expected"
                );
              message.withUpcomingRaceEntry =
                $root.google.protobuf.BoolValue.fromObject(
                  object.withUpcomingRaceEntry
                );
            }
            if (object.withNoteOnly != null)
              message.withNoteOnly = Boolean(object.withNoteOnly);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamFilter} message HorseExamFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.trainerIds = [];
              object.assignedVetIds = [];
              object.facilityIds = [];
              object.statuses = [];
              object.results = [];
              object.horseExamTypes = [];
            }
            if (options.defaults) {
              object.workoutRequestId = "";
              object.upcomingRaceEntryId = "";
              object.completedDate = null;
              object.createdOn = null;
              object.horseOrTrainerName = null;
              object.withWorkout = null;
              object.withUpcomingRaceEntry = null;
              object.withNoteOnly = false;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.workoutRequestId != null &&
              message.hasOwnProperty("workoutRequestId")
            )
              object.workoutRequestId = message.workoutRequestId;
            if (
              message.upcomingRaceEntryId != null &&
              message.hasOwnProperty("upcomingRaceEntryId")
            )
              object.upcomingRaceEntryId = message.upcomingRaceEntryId;
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.assignedVetIds && message.assignedVetIds.length) {
              object.assignedVetIds = [];
              for (var j = 0; j < message.assignedVetIds.length; ++j)
                object.assignedVetIds[j] = message.assignedVetIds[j];
            }
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.HorseExamStatus[
                        message.statuses[j]
                      ]
                    : message.statuses[j];
            }
            if (message.results && message.results.length) {
              object.results = [];
              for (var j = 0; j < message.results.length; ++j)
                object.results[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.HorseExamResult[
                        message.results[j]
                      ]
                    : message.results[j];
            }
            if (
              message.completedDate != null &&
              message.hasOwnProperty("completedDate")
            )
              object.completedDate =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.completedDate,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.createdOn,
                  options
                );
            if (
              message.horseOrTrainerName != null &&
              message.hasOwnProperty("horseOrTrainerName")
            )
              object.horseOrTrainerName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseOrTrainerName,
                  options
                );
            if (message.horseExamTypes && message.horseExamTypes.length) {
              object.horseExamTypes = [];
              for (var j = 0; j < message.horseExamTypes.length; ++j)
                object.horseExamTypes[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.HorseExamType[
                        message.horseExamTypes[j]
                      ]
                    : message.horseExamTypes[j];
            }
            if (
              message.withWorkout != null &&
              message.hasOwnProperty("withWorkout")
            )
              object.withWorkout = $root.google.protobuf.BoolValue.toObject(
                message.withWorkout,
                options
              );
            if (
              message.withUpcomingRaceEntry != null &&
              message.hasOwnProperty("withUpcomingRaceEntry")
            )
              object.withUpcomingRaceEntry =
                $root.google.protobuf.BoolValue.toObject(
                  message.withUpcomingRaceEntry,
                  options
                );
            if (
              message.withNoteOnly != null &&
              message.hasOwnProperty("withNoteOnly")
            )
              object.withNoteOnly = message.withNoteOnly;
            return object;
          };

          /**
           * Converts this HorseExamFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamFilter;
        })();

        racehorse360.ListHorseExamsRequest = (function () {
          /**
           * Properties of a ListHorseExamsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamsRequest
           * @property {stronachgroup.first.racehorse360.IHorseExamFilter|null} [query] ListHorseExamsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseExamsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseExamsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseExamsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamsRequest.
           * @implements IListHorseExamsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamsRequest=} [properties] Properties to set
           */
          function ListHorseExamsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseExamFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @instance
           */
          ListHorseExamsRequest.prototype.query = null;

          /**
           * ListHorseExamsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @instance
           */
          ListHorseExamsRequest.prototype.getOptions = null;

          /**
           * ListHorseExamsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @instance
           */
          ListHorseExamsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseExamsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsRequest} ListHorseExamsRequest instance
           */
          ListHorseExamsRequest.create = function create(properties) {
            return new ListHorseExamsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseExamsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamsRequest} message ListHorseExamsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseExamFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsRequest} ListHorseExamsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseExamFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsRequest} ListHorseExamsRequest
           */
          ListHorseExamsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseExamsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamsRequest} message ListHorseExamsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamsRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseExamFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseExamsRequest;
        })();

        racehorse360.ListHorseExamsResponse = (function () {
          /**
           * Properties of a ListHorseExamsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExam>|null} [horseExams] ListHorseExamsResponse horseExams
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseExamsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseExamsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamsResponse.
           * @implements IListHorseExamsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamsResponse=} [properties] Properties to set
           */
          function ListHorseExamsResponse(properties) {
            this.horseExams = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamsResponse horseExams.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExam>} horseExams
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @instance
           */
          ListHorseExamsResponse.prototype.horseExams = $util.emptyArray;

          /**
           * ListHorseExamsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @instance
           */
          ListHorseExamsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseExamsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsResponse} ListHorseExamsResponse instance
           */
          ListHorseExamsResponse.create = function create(properties) {
            return new ListHorseExamsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseExamsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamsResponse} message ListHorseExamsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.horseExams != null && message.horseExams.length)
              for (var i = 0; i < message.horseExams.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExam.encode(
                  message.horseExams[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsResponse} ListHorseExamsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.horseExams && message.horseExams.length))
                    message.horseExams = [];
                  message.horseExams.push(
                    $root.stronachgroup.first.racehorse360.HorseExam.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamsResponse} ListHorseExamsResponse
           */
          ListHorseExamsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseExamsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamsResponse();
            if (object.horseExams) {
              if (!Array.isArray(object.horseExams))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamsResponse.horseExams: array expected"
                );
              message.horseExams = [];
              for (var i = 0; i < object.horseExams.length; ++i) {
                if (typeof object.horseExams[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseExamsResponse.horseExams: object expected"
                  );
                message.horseExams[i] =
                  $root.stronachgroup.first.racehorse360.HorseExam.fromObject(
                    object.horseExams[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamsResponse} message ListHorseExamsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horseExams = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horseExams && message.horseExams.length) {
              object.horseExams = [];
              for (var j = 0; j < message.horseExams.length; ++j)
                object.horseExams[j] =
                  $root.stronachgroup.first.racehorse360.HorseExam.toObject(
                    message.horseExams[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseExamsResponse;
        })();

        racehorse360.GetHorseExamRequest = (function () {
          /**
           * Properties of a GetHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetHorseExamRequest
           * @property {string|null} [id] GetHorseExamRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetHorseExamRequest getOptions
           */

          /**
           * Constructs a new GetHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetHorseExamRequest.
           * @implements IGetHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetHorseExamRequest=} [properties] Properties to set
           */
          function GetHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetHorseExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @instance
           */
          GetHorseExamRequest.prototype.id = "";

          /**
           * GetHorseExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @instance
           */
          GetHorseExamRequest.prototype.getOptions = null;

          /**
           * Creates a new GetHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetHorseExamRequest} GetHorseExamRequest instance
           */
          GetHorseExamRequest.create = function create(properties) {
            return new GetHorseExamRequest(properties);
          };

          /**
           * Encodes the specified GetHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseExamRequest} message GetHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetHorseExamRequest} GetHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetHorseExamRequest} GetHorseExamRequest
           */
          GetHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetHorseExamRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetHorseExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetHorseExamRequest} message GetHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetHorseExamRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetHorseExamRequest;
        })();

        racehorse360.CreateHorseExamRequest = (function () {
          /**
           * Properties of a CreateHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateHorseExamRequest
           * @property {string|null} [horseId] CreateHorseExamRequest horseId
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateHorseExamRequest getOptions
           */

          /**
           * Constructs a new CreateHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateHorseExamRequest.
           * @implements ICreateHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamRequest=} [properties] Properties to set
           */
          function CreateHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateHorseExamRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @instance
           */
          CreateHorseExamRequest.prototype.horseId = "";

          /**
           * CreateHorseExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @instance
           */
          CreateHorseExamRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamRequest} CreateHorseExamRequest instance
           */
          CreateHorseExamRequest.create = function create(properties) {
            return new CreateHorseExamRequest(properties);
          };

          /**
           * Encodes the specified CreateHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamRequest} message CreateHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamRequest} CreateHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamRequest} CreateHorseExamRequest
           */
          CreateHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateHorseExamRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateHorseExamRequest} message CreateHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateHorseExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseId = "";
              object.getOptions = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateHorseExamRequest;
        })();

        racehorse360.EditHorseExamRequest = (function () {
          /**
           * Properties of an EditHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditHorseExamRequest
           * @property {stronachgroup.first.racehorse360.IHorseExam|null} [horseExam] EditHorseExamRequest horseExam
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditHorseExamRequest getOptions
           */

          /**
           * Constructs a new EditHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditHorseExamRequest.
           * @implements IEditHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditHorseExamRequest=} [properties] Properties to set
           */
          function EditHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditHorseExamRequest horseExam.
           * @member {stronachgroup.first.racehorse360.IHorseExam|null|undefined} horseExam
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @instance
           */
          EditHorseExamRequest.prototype.horseExam = null;

          /**
           * EditHorseExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @instance
           */
          EditHorseExamRequest.prototype.getOptions = null;

          /**
           * Creates a new EditHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditHorseExamRequest} EditHorseExamRequest instance
           */
          EditHorseExamRequest.create = function create(properties) {
            return new EditHorseExamRequest(properties);
          };

          /**
           * Encodes the specified EditHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditHorseExamRequest} message EditHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExam != null &&
              Object.hasOwnProperty.call(message, "horseExam")
            )
              $root.stronachgroup.first.racehorse360.HorseExam.encode(
                message.horseExam,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditHorseExamRequest} EditHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseExam =
                    $root.stronachgroup.first.racehorse360.HorseExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditHorseExamRequest} EditHorseExamRequest
           */
          EditHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.EditHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditHorseExamRequest();
            if (object.horseExam != null) {
              if (typeof object.horseExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditHorseExamRequest.horseExam: object expected"
                );
              message.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.fromObject(
                  object.horseExam
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditHorseExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditHorseExamRequest} message EditHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditHorseExamRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseExam = null;
              object.getOptions = null;
            }
            if (
              message.horseExam != null &&
              message.hasOwnProperty("horseExam")
            )
              object.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.toObject(
                  message.horseExam,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return EditHorseExamRequest;
        })();

        racehorse360.DeleteHorseExamRequest = (function () {
          /**
           * Properties of a DeleteHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseExamRequest
           * @property {string|null} [id] DeleteHorseExamRequest id
           */

          /**
           * Constructs a new DeleteHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseExamRequest.
           * @implements IDeleteHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamRequest=} [properties] Properties to set
           */
          function DeleteHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @instance
           */
          DeleteHorseExamRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamRequest} DeleteHorseExamRequest instance
           */
          DeleteHorseExamRequest.create = function create(properties) {
            return new DeleteHorseExamRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamRequest} message DeleteHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamRequest} DeleteHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamRequest} DeleteHorseExamRequest
           */
          DeleteHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseExamRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseExamRequest} message DeleteHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteHorseExamRequest;
        })();

        racehorse360.CancelHorseExamRequest = (function () {
          /**
           * Properties of a CancelHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICancelHorseExamRequest
           * @property {string|null} [id] CancelHorseExamRequest id
           */

          /**
           * Constructs a new CancelHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CancelHorseExamRequest.
           * @implements ICancelHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICancelHorseExamRequest=} [properties] Properties to set
           */
          function CancelHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CancelHorseExamRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @instance
           */
          CancelHorseExamRequest.prototype.id = "";

          /**
           * Creates a new CancelHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CancelHorseExamRequest} CancelHorseExamRequest instance
           */
          CancelHorseExamRequest.create = function create(properties) {
            return new CancelHorseExamRequest(properties);
          };

          /**
           * Encodes the specified CancelHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CancelHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelHorseExamRequest} message CancelHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CancelHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a CancelHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CancelHorseExamRequest} CancelHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CancelHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CancelHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CancelHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CancelHorseExamRequest} CancelHorseExamRequest
           */
          CancelHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CancelHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CancelHorseExamRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a CancelHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CancelHorseExamRequest} message CancelHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CancelHorseExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this CancelHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CancelHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CancelHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CancelHorseExamRequest;
        })();

        racehorse360.CompleteHorseExamRequest = (function () {
          /**
           * Properties of a CompleteHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICompleteHorseExamRequest
           * @property {stronachgroup.first.racehorse360.IHorseExam|null} [horseExam] CompleteHorseExamRequest horseExam
           * @property {string|null} [completedDate] CompleteHorseExamRequest completedDate
           * @property {string|null} [timezone] CompleteHorseExamRequest timezone
           * @property {boolean|null} [shouldSkipIncompassUpdate] CompleteHorseExamRequest shouldSkipIncompassUpdate
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CompleteHorseExamRequest getOptions
           */

          /**
           * Constructs a new CompleteHorseExamRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CompleteHorseExamRequest.
           * @implements ICompleteHorseExamRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICompleteHorseExamRequest=} [properties] Properties to set
           */
          function CompleteHorseExamRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CompleteHorseExamRequest horseExam.
           * @member {stronachgroup.first.racehorse360.IHorseExam|null|undefined} horseExam
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           */
          CompleteHorseExamRequest.prototype.horseExam = null;

          /**
           * CompleteHorseExamRequest completedDate.
           * @member {string} completedDate
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           */
          CompleteHorseExamRequest.prototype.completedDate = "";

          /**
           * CompleteHorseExamRequest timezone.
           * @member {string} timezone
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           */
          CompleteHorseExamRequest.prototype.timezone = "";

          /**
           * CompleteHorseExamRequest shouldSkipIncompassUpdate.
           * @member {boolean} shouldSkipIncompassUpdate
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           */
          CompleteHorseExamRequest.prototype.shouldSkipIncompassUpdate = false;

          /**
           * CompleteHorseExamRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           */
          CompleteHorseExamRequest.prototype.getOptions = null;

          /**
           * Creates a new CompleteHorseExamRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteHorseExamRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CompleteHorseExamRequest} CompleteHorseExamRequest instance
           */
          CompleteHorseExamRequest.create = function create(properties) {
            return new CompleteHorseExamRequest(properties);
          };

          /**
           * Encodes the specified CompleteHorseExamRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CompleteHorseExamRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteHorseExamRequest} message CompleteHorseExamRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CompleteHorseExamRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExam != null &&
              Object.hasOwnProperty.call(message, "horseExam")
            )
              $root.stronachgroup.first.racehorse360.HorseExam.encode(
                message.horseExam,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.completedDate != null &&
              Object.hasOwnProperty.call(message, "completedDate")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.completedDate);
            if (
              message.timezone != null &&
              Object.hasOwnProperty.call(message, "timezone")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.timezone);
            if (
              message.shouldSkipIncompassUpdate != null &&
              Object.hasOwnProperty.call(message, "shouldSkipIncompassUpdate")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.shouldSkipIncompassUpdate);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CompleteHorseExamRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CompleteHorseExamRequest} CompleteHorseExamRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CompleteHorseExamRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CompleteHorseExamRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseExam =
                    $root.stronachgroup.first.racehorse360.HorseExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.completedDate = reader.string();
                  break;
                case 3:
                  message.timezone = reader.string();
                  break;
                case 4:
                  message.shouldSkipIncompassUpdate = reader.bool();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CompleteHorseExamRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CompleteHorseExamRequest} CompleteHorseExamRequest
           */
          CompleteHorseExamRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CompleteHorseExamRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CompleteHorseExamRequest();
            if (object.horseExam != null) {
              if (typeof object.horseExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteHorseExamRequest.horseExam: object expected"
                );
              message.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.fromObject(
                  object.horseExam
                );
            }
            if (object.completedDate != null)
              message.completedDate = String(object.completedDate);
            if (object.timezone != null)
              message.timezone = String(object.timezone);
            if (object.shouldSkipIncompassUpdate != null)
              message.shouldSkipIncompassUpdate = Boolean(
                object.shouldSkipIncompassUpdate
              );
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteHorseExamRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CompleteHorseExamRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CompleteHorseExamRequest} message CompleteHorseExamRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CompleteHorseExamRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseExam = null;
              object.completedDate = "";
              object.timezone = "";
              object.shouldSkipIncompassUpdate = false;
              object.getOptions = null;
            }
            if (
              message.horseExam != null &&
              message.hasOwnProperty("horseExam")
            )
              object.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.toObject(
                  message.horseExam,
                  options
                );
            if (
              message.completedDate != null &&
              message.hasOwnProperty("completedDate")
            )
              object.completedDate = message.completedDate;
            if (message.timezone != null && message.hasOwnProperty("timezone"))
              object.timezone = message.timezone;
            if (
              message.shouldSkipIncompassUpdate != null &&
              message.hasOwnProperty("shouldSkipIncompassUpdate")
            )
              object.shouldSkipIncompassUpdate =
                message.shouldSkipIncompassUpdate;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CompleteHorseExamRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CompleteHorseExamRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CompleteHorseExamRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CompleteHorseExamRequest;
        })();

        racehorse360.PullHorseExamConditionsRequest = (function () {
          /**
           * Properties of a PullHorseExamConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseExamConditionsRequest
           */

          /**
           * Constructs a new PullHorseExamConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseExamConditionsRequest.
           * @implements IPullHorseExamConditionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsRequest=} [properties] Properties to set
           */
          function PullHorseExamConditionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new PullHorseExamConditionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} PullHorseExamConditionsRequest instance
           */
          PullHorseExamConditionsRequest.create = function create(properties) {
            return new PullHorseExamConditionsRequest(properties);
          };

          /**
           * Encodes the specified PullHorseExamConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseExamConditionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsRequest} message PullHorseExamConditionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseExamConditionsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a PullHorseExamConditionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} PullHorseExamConditionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseExamConditionsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseExamConditionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} PullHorseExamConditionsRequest
           */
          PullHorseExamConditionsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorseExamConditionsRequest
            )
              return object;
            return new $root.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest();
          };

          /**
           * Creates a plain object from a PullHorseExamConditionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseExamConditionsRequest} message PullHorseExamConditionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseExamConditionsRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this PullHorseExamConditionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseExamConditionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorseExamConditionsRequest;
        })();

        racehorse360.PullHorseExamConditionsResponse = (function () {
          /**
           * Properties of a PullHorseExamConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseExamConditionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamReason>|null} [reasons] PullHorseExamConditionsResponse reasons
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamConclusion>|null} [conclusions] PullHorseExamConditionsResponse conclusions
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamLimb>|null} [limbs] PullHorseExamConditionsResponse limbs
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamJogCondition>|null} [jogConditions] PullHorseExamConditionsResponse jogConditions
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamJogInfo>|null} [jogInfos] PullHorseExamConditionsResponse jogInfos
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamJogScore>|null} [jogScores] PullHorseExamConditionsResponse jogScores
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailCondition>|null} [detailConditions] PullHorseExamConditionsResponse detailConditions
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailLocation>|null} [detailLocations] PullHorseExamConditionsResponse detailLocations
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailObservation>|null} [detailObservations] PullHorseExamConditionsResponse detailObservations
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailSeverity>|null} [detailSeverities] PullHorseExamConditionsResponse detailSeverities
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailStructure>|null} [detailStructures] PullHorseExamConditionsResponse detailStructures
           */

          /**
           * Constructs a new PullHorseExamConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseExamConditionsResponse.
           * @implements IPullHorseExamConditionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsResponse=} [properties] Properties to set
           */
          function PullHorseExamConditionsResponse(properties) {
            this.reasons = [];
            this.conclusions = [];
            this.limbs = [];
            this.jogConditions = [];
            this.jogInfos = [];
            this.jogScores = [];
            this.detailConditions = [];
            this.detailLocations = [];
            this.detailObservations = [];
            this.detailSeverities = [];
            this.detailStructures = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorseExamConditionsResponse reasons.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamReason>} reasons
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.reasons = $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse conclusions.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamConclusion>} conclusions
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.conclusions =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse limbs.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamLimb>} limbs
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.limbs = $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse jogConditions.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamJogCondition>} jogConditions
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.jogConditions =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse jogInfos.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamJogInfo>} jogInfos
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.jogInfos = $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse jogScores.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamJogScore>} jogScores
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.jogScores =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse detailConditions.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailCondition>} detailConditions
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.detailConditions =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse detailLocations.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailLocation>} detailLocations
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.detailLocations =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse detailObservations.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailObservation>} detailObservations
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.detailObservations =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse detailSeverities.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailSeverity>} detailSeverities
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.detailSeverities =
            $util.emptyArray;

          /**
           * PullHorseExamConditionsResponse detailStructures.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailStructure>} detailStructures
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           */
          PullHorseExamConditionsResponse.prototype.detailStructures =
            $util.emptyArray;

          /**
           * Creates a new PullHorseExamConditionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsResponse} PullHorseExamConditionsResponse instance
           */
          PullHorseExamConditionsResponse.create = function create(properties) {
            return new PullHorseExamConditionsResponse(properties);
          };

          /**
           * Encodes the specified PullHorseExamConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsResponse} message PullHorseExamConditionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseExamConditionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.reasons != null && message.reasons.length)
              for (var i = 0; i < message.reasons.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamReason.encode(
                  message.reasons[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (message.conclusions != null && message.conclusions.length)
              for (var i = 0; i < message.conclusions.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamConclusion.encode(
                  message.conclusions[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (message.limbs != null && message.limbs.length)
              for (var i = 0; i < message.limbs.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamLimb.encode(
                  message.limbs[i],
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
            if (message.jogConditions != null && message.jogConditions.length)
              for (var i = 0; i < message.jogConditions.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamJogCondition.encode(
                  message.jogConditions[i],
                  writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
                ).ldelim();
            if (message.jogInfos != null && message.jogInfos.length)
              for (var i = 0; i < message.jogInfos.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamJogInfo.encode(
                  message.jogInfos[i],
                  writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
                ).ldelim();
            if (message.jogScores != null && message.jogScores.length)
              for (var i = 0; i < message.jogScores.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamJogScore.encode(
                  message.jogScores[i],
                  writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
                ).ldelim();
            if (
              message.detailConditions != null &&
              message.detailConditions.length
            )
              for (var i = 0; i < message.detailConditions.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.encode(
                  message.detailConditions[i],
                  writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
                ).ldelim();
            if (
              message.detailLocations != null &&
              message.detailLocations.length
            )
              for (var i = 0; i < message.detailLocations.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.encode(
                  message.detailLocations[i],
                  writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
                ).ldelim();
            if (
              message.detailObservations != null &&
              message.detailObservations.length
            )
              for (var i = 0; i < message.detailObservations.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.encode(
                  message.detailObservations[i],
                  writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
                ).ldelim();
            if (
              message.detailSeverities != null &&
              message.detailSeverities.length
            )
              for (var i = 0; i < message.detailSeverities.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.encode(
                  message.detailSeverities[i],
                  writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
                ).ldelim();
            if (
              message.detailStructures != null &&
              message.detailStructures.length
            )
              for (var i = 0; i < message.detailStructures.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.encode(
                  message.detailStructures[i],
                  writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorseExamConditionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsResponse} PullHorseExamConditionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseExamConditionsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.reasons && message.reasons.length))
                    message.reasons = [];
                  message.reasons.push(
                    $root.stronachgroup.first.racehorse360.HorseExamReason.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 2:
                  if (!(message.conclusions && message.conclusions.length))
                    message.conclusions = [];
                  message.conclusions.push(
                    $root.stronachgroup.first.racehorse360.HorseExamConclusion.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 3:
                  if (!(message.limbs && message.limbs.length))
                    message.limbs = [];
                  message.limbs.push(
                    $root.stronachgroup.first.racehorse360.HorseExamLimb.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 4:
                  if (!(message.jogConditions && message.jogConditions.length))
                    message.jogConditions = [];
                  message.jogConditions.push(
                    $root.stronachgroup.first.racehorse360.HorseExamJogCondition.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 5:
                  if (!(message.jogInfos && message.jogInfos.length))
                    message.jogInfos = [];
                  message.jogInfos.push(
                    $root.stronachgroup.first.racehorse360.HorseExamJogInfo.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 6:
                  if (!(message.jogScores && message.jogScores.length))
                    message.jogScores = [];
                  message.jogScores.push(
                    $root.stronachgroup.first.racehorse360.HorseExamJogScore.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 7:
                  if (
                    !(
                      message.detailConditions &&
                      message.detailConditions.length
                    )
                  )
                    message.detailConditions = [];
                  message.detailConditions.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 8:
                  if (
                    !(message.detailLocations && message.detailLocations.length)
                  )
                    message.detailLocations = [];
                  message.detailLocations.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 9:
                  if (
                    !(
                      message.detailObservations &&
                      message.detailObservations.length
                    )
                  )
                    message.detailObservations = [];
                  message.detailObservations.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 10:
                  if (
                    !(
                      message.detailSeverities &&
                      message.detailSeverities.length
                    )
                  )
                    message.detailSeverities = [];
                  message.detailSeverities.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 11:
                  if (
                    !(
                      message.detailStructures &&
                      message.detailStructures.length
                    )
                  )
                    message.detailStructures = [];
                  message.detailStructures.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseExamConditionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseExamConditionsResponse} PullHorseExamConditionsResponse
           */
          PullHorseExamConditionsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorseExamConditionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse();
            if (object.reasons) {
              if (!Array.isArray(object.reasons))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.reasons: array expected"
                );
              message.reasons = [];
              for (var i = 0; i < object.reasons.length; ++i) {
                if (typeof object.reasons[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.reasons: object expected"
                  );
                message.reasons[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamReason.fromObject(
                    object.reasons[i]
                  );
              }
            }
            if (object.conclusions) {
              if (!Array.isArray(object.conclusions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.conclusions: array expected"
                );
              message.conclusions = [];
              for (var i = 0; i < object.conclusions.length; ++i) {
                if (typeof object.conclusions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.conclusions: object expected"
                  );
                message.conclusions[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamConclusion.fromObject(
                    object.conclusions[i]
                  );
              }
            }
            if (object.limbs) {
              if (!Array.isArray(object.limbs))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.limbs: array expected"
                );
              message.limbs = [];
              for (var i = 0; i < object.limbs.length; ++i) {
                if (typeof object.limbs[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.limbs: object expected"
                  );
                message.limbs[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamLimb.fromObject(
                    object.limbs[i]
                  );
              }
            }
            if (object.jogConditions) {
              if (!Array.isArray(object.jogConditions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogConditions: array expected"
                );
              message.jogConditions = [];
              for (var i = 0; i < object.jogConditions.length; ++i) {
                if (typeof object.jogConditions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogConditions: object expected"
                  );
                message.jogConditions[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogCondition.fromObject(
                    object.jogConditions[i]
                  );
              }
            }
            if (object.jogInfos) {
              if (!Array.isArray(object.jogInfos))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogInfos: array expected"
                );
              message.jogInfos = [];
              for (var i = 0; i < object.jogInfos.length; ++i) {
                if (typeof object.jogInfos[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogInfos: object expected"
                  );
                message.jogInfos[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogInfo.fromObject(
                    object.jogInfos[i]
                  );
              }
            }
            if (object.jogScores) {
              if (!Array.isArray(object.jogScores))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogScores: array expected"
                );
              message.jogScores = [];
              for (var i = 0; i < object.jogScores.length; ++i) {
                if (typeof object.jogScores[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.jogScores: object expected"
                  );
                message.jogScores[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogScore.fromObject(
                    object.jogScores[i]
                  );
              }
            }
            if (object.detailConditions) {
              if (!Array.isArray(object.detailConditions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailConditions: array expected"
                );
              message.detailConditions = [];
              for (var i = 0; i < object.detailConditions.length; ++i) {
                if (typeof object.detailConditions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailConditions: object expected"
                  );
                message.detailConditions[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.fromObject(
                    object.detailConditions[i]
                  );
              }
            }
            if (object.detailLocations) {
              if (!Array.isArray(object.detailLocations))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailLocations: array expected"
                );
              message.detailLocations = [];
              for (var i = 0; i < object.detailLocations.length; ++i) {
                if (typeof object.detailLocations[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailLocations: object expected"
                  );
                message.detailLocations[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.fromObject(
                    object.detailLocations[i]
                  );
              }
            }
            if (object.detailObservations) {
              if (!Array.isArray(object.detailObservations))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailObservations: array expected"
                );
              message.detailObservations = [];
              for (var i = 0; i < object.detailObservations.length; ++i) {
                if (typeof object.detailObservations[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailObservations: object expected"
                  );
                message.detailObservations[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.fromObject(
                    object.detailObservations[i]
                  );
              }
            }
            if (object.detailSeverities) {
              if (!Array.isArray(object.detailSeverities))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailSeverities: array expected"
                );
              message.detailSeverities = [];
              for (var i = 0; i < object.detailSeverities.length; ++i) {
                if (typeof object.detailSeverities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailSeverities: object expected"
                  );
                message.detailSeverities[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.fromObject(
                    object.detailSeverities[i]
                  );
              }
            }
            if (object.detailStructures) {
              if (!Array.isArray(object.detailStructures))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailStructures: array expected"
                );
              message.detailStructures = [];
              for (var i = 0; i < object.detailStructures.length; ++i) {
                if (typeof object.detailStructures[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.detailStructures: object expected"
                  );
                message.detailStructures[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.fromObject(
                    object.detailStructures[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorseExamConditionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseExamConditionsResponse} message PullHorseExamConditionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseExamConditionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.reasons = [];
              object.conclusions = [];
              object.limbs = [];
              object.jogConditions = [];
              object.jogInfos = [];
              object.jogScores = [];
              object.detailConditions = [];
              object.detailLocations = [];
              object.detailObservations = [];
              object.detailSeverities = [];
              object.detailStructures = [];
            }
            if (message.reasons && message.reasons.length) {
              object.reasons = [];
              for (var j = 0; j < message.reasons.length; ++j)
                object.reasons[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamReason.toObject(
                    message.reasons[j],
                    options
                  );
            }
            if (message.conclusions && message.conclusions.length) {
              object.conclusions = [];
              for (var j = 0; j < message.conclusions.length; ++j)
                object.conclusions[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamConclusion.toObject(
                    message.conclusions[j],
                    options
                  );
            }
            if (message.limbs && message.limbs.length) {
              object.limbs = [];
              for (var j = 0; j < message.limbs.length; ++j)
                object.limbs[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamLimb.toObject(
                    message.limbs[j],
                    options
                  );
            }
            if (message.jogConditions && message.jogConditions.length) {
              object.jogConditions = [];
              for (var j = 0; j < message.jogConditions.length; ++j)
                object.jogConditions[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogCondition.toObject(
                    message.jogConditions[j],
                    options
                  );
            }
            if (message.jogInfos && message.jogInfos.length) {
              object.jogInfos = [];
              for (var j = 0; j < message.jogInfos.length; ++j)
                object.jogInfos[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogInfo.toObject(
                    message.jogInfos[j],
                    options
                  );
            }
            if (message.jogScores && message.jogScores.length) {
              object.jogScores = [];
              for (var j = 0; j < message.jogScores.length; ++j)
                object.jogScores[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamJogScore.toObject(
                    message.jogScores[j],
                    options
                  );
            }
            if (message.detailConditions && message.detailConditions.length) {
              object.detailConditions = [];
              for (var j = 0; j < message.detailConditions.length; ++j)
                object.detailConditions[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.toObject(
                    message.detailConditions[j],
                    options
                  );
            }
            if (message.detailLocations && message.detailLocations.length) {
              object.detailLocations = [];
              for (var j = 0; j < message.detailLocations.length; ++j)
                object.detailLocations[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.toObject(
                    message.detailLocations[j],
                    options
                  );
            }
            if (
              message.detailObservations &&
              message.detailObservations.length
            ) {
              object.detailObservations = [];
              for (var j = 0; j < message.detailObservations.length; ++j)
                object.detailObservations[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.toObject(
                    message.detailObservations[j],
                    options
                  );
            }
            if (message.detailSeverities && message.detailSeverities.length) {
              object.detailSeverities = [];
              for (var j = 0; j < message.detailSeverities.length; ++j)
                object.detailSeverities[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.toObject(
                    message.detailSeverities[j],
                    options
                  );
            }
            if (message.detailStructures && message.detailStructures.length) {
              object.detailStructures = [];
              for (var j = 0; j < message.detailStructures.length; ++j)
                object.detailStructures[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.toObject(
                    message.detailStructures[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullHorseExamConditionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseExamConditionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseExamConditionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorseExamConditionsResponse;
        })();

        racehorse360.PullHorseExamReportRequest = (function () {
          /**
           * Properties of a PullHorseExamReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseExamReportRequest
           * @property {Array.<string>|null} [facilityIds] PullHorseExamReportRequest facilityIds
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [dateRange] PullHorseExamReportRequest dateRange
           */

          /**
           * Constructs a new PullHorseExamReportRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseExamReportRequest.
           * @implements IPullHorseExamReportRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportRequest=} [properties] Properties to set
           */
          function PullHorseExamReportRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorseExamReportRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @instance
           */
          PullHorseExamReportRequest.prototype.facilityIds = $util.emptyArray;

          /**
           * PullHorseExamReportRequest dateRange.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} dateRange
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @instance
           */
          PullHorseExamReportRequest.prototype.dateRange = null;

          /**
           * Creates a new PullHorseExamReportRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportRequest} PullHorseExamReportRequest instance
           */
          PullHorseExamReportRequest.create = function create(properties) {
            return new PullHorseExamReportRequest(properties);
          };

          /**
           * Encodes the specified PullHorseExamReportRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseExamReportRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportRequest} message PullHorseExamReportRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseExamReportRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            if (
              message.dateRange != null &&
              Object.hasOwnProperty.call(message, "dateRange")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.dateRange,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullHorseExamReportRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportRequest} PullHorseExamReportRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseExamReportRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseExamReportRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 2:
                  message.dateRange =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseExamReportRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportRequest} PullHorseExamReportRequest
           */
          PullHorseExamReportRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullHorseExamReportRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorseExamReportRequest();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamReportRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.dateRange != null) {
              if (typeof object.dateRange !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorseExamReportRequest.dateRange: object expected"
                );
              message.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.dateRange
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorseExamReportRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseExamReportRequest} message PullHorseExamReportRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseExamReportRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.dateRange = null;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (
              message.dateRange != null &&
              message.hasOwnProperty("dateRange")
            )
              object.dateRange =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.dateRange,
                  options
                );
            return object;
          };

          /**
           * Converts this PullHorseExamReportRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseExamReportRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorseExamReportRequest;
        })();

        racehorse360.PullHorseExamReportResponse = (function () {
          /**
           * Properties of a PullHorseExamReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorseExamReportResponse
           * @property {Uint8Array|null} [file] PullHorseExamReportResponse file
           */

          /**
           * Constructs a new PullHorseExamReportResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorseExamReportResponse.
           * @implements IPullHorseExamReportResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportResponse=} [properties] Properties to set
           */
          function PullHorseExamReportResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorseExamReportResponse file.
           * @member {Uint8Array} file
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @instance
           */
          PullHorseExamReportResponse.prototype.file = $util.newBuffer([]);

          /**
           * Creates a new PullHorseExamReportResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportResponse} PullHorseExamReportResponse instance
           */
          PullHorseExamReportResponse.create = function create(properties) {
            return new PullHorseExamReportResponse(properties);
          };

          /**
           * Encodes the specified PullHorseExamReportResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorseExamReportResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportResponse} message PullHorseExamReportResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorseExamReportResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.file != null &&
              Object.hasOwnProperty.call(message, "file")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.file);
            return writer;
          };

          /**
           * Decodes a PullHorseExamReportResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportResponse} PullHorseExamReportResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorseExamReportResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorseExamReportResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.file = reader.bytes();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorseExamReportResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorseExamReportResponse} PullHorseExamReportResponse
           */
          PullHorseExamReportResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullHorseExamReportResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorseExamReportResponse();
            if (object.file != null)
              if (typeof object.file === "string")
                $util.base64.decode(
                  object.file,
                  (message.file = $util.newBuffer(
                    $util.base64.length(object.file)
                  )),
                  0
                );
              else if (object.file.length) message.file = object.file;
            return message;
          };

          /**
           * Creates a plain object from a PullHorseExamReportResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorseExamReportResponse} message PullHorseExamReportResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorseExamReportResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults)
              if (options.bytes === String) object.file = "";
              else {
                object.file = [];
                if (options.bytes !== Array)
                  object.file = $util.newBuffer(object.file);
              }
            if (message.file != null && message.hasOwnProperty("file"))
              object.file =
                options.bytes === String
                  ? $util.base64.encode(message.file, 0, message.file.length)
                  : options.bytes === Array
                  ? Array.prototype.slice.call(message.file)
                  : message.file;
            return object;
          };

          /**
           * Converts this PullHorseExamReportResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorseExamReportResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorseExamReportResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorseExamReportResponse;
        })();

        racehorse360.HorseExamJog = (function () {
          /**
           * Properties of a HorseExamJog.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamJog
           * @property {string|null} [id] HorseExamJog id
           * @property {string|null} [horseExamId] HorseExamJog horseExamId
           * @property {string|null} [jogConditionId] HorseExamJog jogConditionId
           * @property {stronachgroup.first.racehorse360.IHorseExamJogCondition|null} [jogCondition] HorseExamJog jogCondition
           * @property {google.protobuf.IStringValue|null} [customJogCondition] HorseExamJog customJogCondition
           * @property {string|null} [jogScoreId] HorseExamJog jogScoreId
           * @property {stronachgroup.first.racehorse360.IHorseExamJogScore|null} [jogScore] HorseExamJog jogScore
           * @property {string|null} [jogInfoId] HorseExamJog jogInfoId
           * @property {stronachgroup.first.racehorse360.IHorseExamJogInfo|null} [jogInfo] HorseExamJog jogInfo
           * @property {google.protobuf.IStringValue|null} [customJogInfo] HorseExamJog customJogInfo
           * @property {string|null} [jogLimbId] HorseExamJog jogLimbId
           * @property {stronachgroup.first.racehorse360.IHorseExamLimb|null} [jogLimb] HorseExamJog jogLimb
           * @property {google.protobuf.IStringValue|null} [customJogLimb] HorseExamJog customJogLimb
           */

          /**
           * Constructs a new HorseExamJog.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamJog.
           * @implements IHorseExamJog
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamJog=} [properties] Properties to set
           */
          function HorseExamJog(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamJog id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.id = "";

          /**
           * HorseExamJog horseExamId.
           * @member {string} horseExamId
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.horseExamId = "";

          /**
           * HorseExamJog jogConditionId.
           * @member {string} jogConditionId
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogConditionId = "";

          /**
           * HorseExamJog jogCondition.
           * @member {stronachgroup.first.racehorse360.IHorseExamJogCondition|null|undefined} jogCondition
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogCondition = null;

          /**
           * HorseExamJog customJogCondition.
           * @member {google.protobuf.IStringValue|null|undefined} customJogCondition
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.customJogCondition = null;

          /**
           * HorseExamJog jogScoreId.
           * @member {string} jogScoreId
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogScoreId = "";

          /**
           * HorseExamJog jogScore.
           * @member {stronachgroup.first.racehorse360.IHorseExamJogScore|null|undefined} jogScore
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogScore = null;

          /**
           * HorseExamJog jogInfoId.
           * @member {string} jogInfoId
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogInfoId = "";

          /**
           * HorseExamJog jogInfo.
           * @member {stronachgroup.first.racehorse360.IHorseExamJogInfo|null|undefined} jogInfo
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogInfo = null;

          /**
           * HorseExamJog customJogInfo.
           * @member {google.protobuf.IStringValue|null|undefined} customJogInfo
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.customJogInfo = null;

          /**
           * HorseExamJog jogLimbId.
           * @member {string} jogLimbId
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogLimbId = "";

          /**
           * HorseExamJog jogLimb.
           * @member {stronachgroup.first.racehorse360.IHorseExamLimb|null|undefined} jogLimb
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.jogLimb = null;

          /**
           * HorseExamJog customJogLimb.
           * @member {google.protobuf.IStringValue|null|undefined} customJogLimb
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           */
          HorseExamJog.prototype.customJogLimb = null;

          /**
           * Creates a new HorseExamJog instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJog=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamJog} HorseExamJog instance
           */
          HorseExamJog.create = function create(properties) {
            return new HorseExamJog(properties);
          };

          /**
           * Encodes the specified HorseExamJog message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamJog.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJog} message HorseExamJog message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamJog.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseExamId != null &&
              Object.hasOwnProperty.call(message, "horseExamId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseExamId);
            if (
              message.jogConditionId != null &&
              Object.hasOwnProperty.call(message, "jogConditionId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.jogConditionId);
            if (
              message.jogCondition != null &&
              Object.hasOwnProperty.call(message, "jogCondition")
            )
              $root.stronachgroup.first.racehorse360.HorseExamJogCondition.encode(
                message.jogCondition,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.customJogCondition != null &&
              Object.hasOwnProperty.call(message, "customJogCondition")
            )
              $root.google.protobuf.StringValue.encode(
                message.customJogCondition,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.jogScoreId != null &&
              Object.hasOwnProperty.call(message, "jogScoreId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.jogScoreId);
            if (
              message.jogScore != null &&
              Object.hasOwnProperty.call(message, "jogScore")
            )
              $root.stronachgroup.first.racehorse360.HorseExamJogScore.encode(
                message.jogScore,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.jogInfoId != null &&
              Object.hasOwnProperty.call(message, "jogInfoId")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.jogInfoId);
            if (
              message.jogInfo != null &&
              Object.hasOwnProperty.call(message, "jogInfo")
            )
              $root.stronachgroup.first.racehorse360.HorseExamJogInfo.encode(
                message.jogInfo,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.customJogInfo != null &&
              Object.hasOwnProperty.call(message, "customJogInfo")
            )
              $root.google.protobuf.StringValue.encode(
                message.customJogInfo,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.jogLimbId != null &&
              Object.hasOwnProperty.call(message, "jogLimbId")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.jogLimbId);
            if (
              message.jogLimb != null &&
              Object.hasOwnProperty.call(message, "jogLimb")
            )
              $root.stronachgroup.first.racehorse360.HorseExamLimb.encode(
                message.jogLimb,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.customJogLimb != null &&
              Object.hasOwnProperty.call(message, "customJogLimb")
            )
              $root.google.protobuf.StringValue.encode(
                message.customJogLimb,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExamJog message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamJog} HorseExamJog
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamJog.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamJog();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseExamId = reader.string();
                  break;
                case 3:
                  message.jogConditionId = reader.string();
                  break;
                case 4:
                  message.jogCondition =
                    $root.stronachgroup.first.racehorse360.HorseExamJogCondition.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.customJogCondition =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.jogScoreId = reader.string();
                  break;
                case 7:
                  message.jogScore =
                    $root.stronachgroup.first.racehorse360.HorseExamJogScore.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.jogInfoId = reader.string();
                  break;
                case 9:
                  message.jogInfo =
                    $root.stronachgroup.first.racehorse360.HorseExamJogInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.customJogInfo =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.jogLimbId = reader.string();
                  break;
                case 12:
                  message.jogLimb =
                    $root.stronachgroup.first.racehorse360.HorseExamLimb.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 13:
                  message.customJogLimb =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamJog message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamJog} HorseExamJog
           */
          HorseExamJog.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamJog
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamJog();
            if (object.id != null) message.id = String(object.id);
            if (object.horseExamId != null)
              message.horseExamId = String(object.horseExamId);
            if (object.jogConditionId != null)
              message.jogConditionId = String(object.jogConditionId);
            if (object.jogCondition != null) {
              if (typeof object.jogCondition !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.jogCondition: object expected"
                );
              message.jogCondition =
                $root.stronachgroup.first.racehorse360.HorseExamJogCondition.fromObject(
                  object.jogCondition
                );
            }
            if (object.customJogCondition != null) {
              if (typeof object.customJogCondition !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.customJogCondition: object expected"
                );
              message.customJogCondition =
                $root.google.protobuf.StringValue.fromObject(
                  object.customJogCondition
                );
            }
            if (object.jogScoreId != null)
              message.jogScoreId = String(object.jogScoreId);
            if (object.jogScore != null) {
              if (typeof object.jogScore !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.jogScore: object expected"
                );
              message.jogScore =
                $root.stronachgroup.first.racehorse360.HorseExamJogScore.fromObject(
                  object.jogScore
                );
            }
            if (object.jogInfoId != null)
              message.jogInfoId = String(object.jogInfoId);
            if (object.jogInfo != null) {
              if (typeof object.jogInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.jogInfo: object expected"
                );
              message.jogInfo =
                $root.stronachgroup.first.racehorse360.HorseExamJogInfo.fromObject(
                  object.jogInfo
                );
            }
            if (object.customJogInfo != null) {
              if (typeof object.customJogInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.customJogInfo: object expected"
                );
              message.customJogInfo =
                $root.google.protobuf.StringValue.fromObject(
                  object.customJogInfo
                );
            }
            if (object.jogLimbId != null)
              message.jogLimbId = String(object.jogLimbId);
            if (object.jogLimb != null) {
              if (typeof object.jogLimb !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.jogLimb: object expected"
                );
              message.jogLimb =
                $root.stronachgroup.first.racehorse360.HorseExamLimb.fromObject(
                  object.jogLimb
                );
            }
            if (object.customJogLimb != null) {
              if (typeof object.customJogLimb !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamJog.customJogLimb: object expected"
                );
              message.customJogLimb =
                $root.google.protobuf.StringValue.fromObject(
                  object.customJogLimb
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamJog message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamJog} message HorseExamJog
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamJog.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseExamId = "";
              object.jogConditionId = "";
              object.jogCondition = null;
              object.customJogCondition = null;
              object.jogScoreId = "";
              object.jogScore = null;
              object.jogInfoId = "";
              object.jogInfo = null;
              object.customJogInfo = null;
              object.jogLimbId = "";
              object.jogLimb = null;
              object.customJogLimb = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseExamId != null &&
              message.hasOwnProperty("horseExamId")
            )
              object.horseExamId = message.horseExamId;
            if (
              message.jogConditionId != null &&
              message.hasOwnProperty("jogConditionId")
            )
              object.jogConditionId = message.jogConditionId;
            if (
              message.jogCondition != null &&
              message.hasOwnProperty("jogCondition")
            )
              object.jogCondition =
                $root.stronachgroup.first.racehorse360.HorseExamJogCondition.toObject(
                  message.jogCondition,
                  options
                );
            if (
              message.customJogCondition != null &&
              message.hasOwnProperty("customJogCondition")
            )
              object.customJogCondition =
                $root.google.protobuf.StringValue.toObject(
                  message.customJogCondition,
                  options
                );
            if (
              message.jogScoreId != null &&
              message.hasOwnProperty("jogScoreId")
            )
              object.jogScoreId = message.jogScoreId;
            if (message.jogScore != null && message.hasOwnProperty("jogScore"))
              object.jogScore =
                $root.stronachgroup.first.racehorse360.HorseExamJogScore.toObject(
                  message.jogScore,
                  options
                );
            if (
              message.jogInfoId != null &&
              message.hasOwnProperty("jogInfoId")
            )
              object.jogInfoId = message.jogInfoId;
            if (message.jogInfo != null && message.hasOwnProperty("jogInfo"))
              object.jogInfo =
                $root.stronachgroup.first.racehorse360.HorseExamJogInfo.toObject(
                  message.jogInfo,
                  options
                );
            if (
              message.customJogInfo != null &&
              message.hasOwnProperty("customJogInfo")
            )
              object.customJogInfo = $root.google.protobuf.StringValue.toObject(
                message.customJogInfo,
                options
              );
            if (
              message.jogLimbId != null &&
              message.hasOwnProperty("jogLimbId")
            )
              object.jogLimbId = message.jogLimbId;
            if (message.jogLimb != null && message.hasOwnProperty("jogLimb"))
              object.jogLimb =
                $root.stronachgroup.first.racehorse360.HorseExamLimb.toObject(
                  message.jogLimb,
                  options
                );
            if (
              message.customJogLimb != null &&
              message.hasOwnProperty("customJogLimb")
            )
              object.customJogLimb = $root.google.protobuf.StringValue.toObject(
                message.customJogLimb,
                options
              );
            return object;
          };

          /**
           * Converts this HorseExamJog to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamJog
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamJog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamJog;
        })();

        racehorse360.HorseExamJogCondition = (function () {
          /**
           * Properties of a HorseExamJogCondition.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamJogCondition
           * @property {string|null} [id] HorseExamJogCondition id
           * @property {string|null} [description] HorseExamJogCondition description
           */

          /**
           * Constructs a new HorseExamJogCondition.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamJogCondition.
           * @implements IHorseExamJogCondition
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamJogCondition=} [properties] Properties to set
           */
          function HorseExamJogCondition(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamJogCondition id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @instance
           */
          HorseExamJogCondition.prototype.id = "";

          /**
           * HorseExamJogCondition description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @instance
           */
          HorseExamJogCondition.prototype.description = "";

          /**
           * Creates a new HorseExamJogCondition instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogCondition=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamJogCondition} HorseExamJogCondition instance
           */
          HorseExamJogCondition.create = function create(properties) {
            return new HorseExamJogCondition(properties);
          };

          /**
           * Encodes the specified HorseExamJogCondition message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamJogCondition.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogCondition} message HorseExamJogCondition message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamJogCondition.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a HorseExamJogCondition message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamJogCondition} HorseExamJogCondition
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamJogCondition.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamJogCondition();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamJogCondition message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamJogCondition} HorseExamJogCondition
           */
          HorseExamJogCondition.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamJogCondition
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamJogCondition();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamJogCondition message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamJogCondition} message HorseExamJogCondition
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamJogCondition.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this HorseExamJogCondition to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamJogCondition
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamJogCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamJogCondition;
        })();

        racehorse360.HorseExamJogScore = (function () {
          /**
           * Properties of a HorseExamJogScore.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamJogScore
           * @property {string|null} [id] HorseExamJogScore id
           * @property {string|null} [description] HorseExamJogScore description
           * @property {number|null} [value] HorseExamJogScore value
           */

          /**
           * Constructs a new HorseExamJogScore.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamJogScore.
           * @implements IHorseExamJogScore
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamJogScore=} [properties] Properties to set
           */
          function HorseExamJogScore(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamJogScore id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @instance
           */
          HorseExamJogScore.prototype.id = "";

          /**
           * HorseExamJogScore description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @instance
           */
          HorseExamJogScore.prototype.description = "";

          /**
           * HorseExamJogScore value.
           * @member {number} value
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @instance
           */
          HorseExamJogScore.prototype.value = 0;

          /**
           * Creates a new HorseExamJogScore instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogScore=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamJogScore} HorseExamJogScore instance
           */
          HorseExamJogScore.create = function create(properties) {
            return new HorseExamJogScore(properties);
          };

          /**
           * Encodes the specified HorseExamJogScore message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamJogScore.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogScore} message HorseExamJogScore message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamJogScore.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.value != null &&
              Object.hasOwnProperty.call(message, "value")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.value);
            return writer;
          };

          /**
           * Decodes a HorseExamJogScore message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamJogScore} HorseExamJogScore
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamJogScore.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamJogScore();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.value = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamJogScore message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamJogScore} HorseExamJogScore
           */
          HorseExamJogScore.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamJogScore
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamJogScore();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.value != null) message.value = object.value | 0;
            return message;
          };

          /**
           * Creates a plain object from a HorseExamJogScore message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamJogScore} message HorseExamJogScore
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamJogScore.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.value = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.value != null && message.hasOwnProperty("value"))
              object.value = message.value;
            return object;
          };

          /**
           * Converts this HorseExamJogScore to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamJogScore
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamJogScore.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamJogScore;
        })();

        racehorse360.HorseExamJogInfo = (function () {
          /**
           * Properties of a HorseExamJogInfo.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamJogInfo
           * @property {string|null} [id] HorseExamJogInfo id
           * @property {string|null} [description] HorseExamJogInfo description
           * @property {string|null} [shortDescription] HorseExamJogInfo shortDescription
           */

          /**
           * Constructs a new HorseExamJogInfo.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamJogInfo.
           * @implements IHorseExamJogInfo
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamJogInfo=} [properties] Properties to set
           */
          function HorseExamJogInfo(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamJogInfo id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @instance
           */
          HorseExamJogInfo.prototype.id = "";

          /**
           * HorseExamJogInfo description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @instance
           */
          HorseExamJogInfo.prototype.description = "";

          /**
           * HorseExamJogInfo shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @instance
           */
          HorseExamJogInfo.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamJogInfo instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogInfo=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamJogInfo} HorseExamJogInfo instance
           */
          HorseExamJogInfo.create = function create(properties) {
            return new HorseExamJogInfo(properties);
          };

          /**
           * Encodes the specified HorseExamJogInfo message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamJogInfo.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamJogInfo} message HorseExamJogInfo message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamJogInfo.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamJogInfo message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamJogInfo} HorseExamJogInfo
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamJogInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamJogInfo();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamJogInfo message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamJogInfo} HorseExamJogInfo
           */
          HorseExamJogInfo.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamJogInfo
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamJogInfo();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamJogInfo message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamJogInfo} message HorseExamJogInfo
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamJogInfo.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamJogInfo to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamJogInfo
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamJogInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamJogInfo;
        })();

        racehorse360.HorseExamDetail = (function () {
          /**
           * Properties of a HorseExamDetail.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetail
           * @property {string|null} [id] HorseExamDetail id
           * @property {string|null} [horseExamId] HorseExamDetail horseExamId
           * @property {string|null} [detailStructureId] HorseExamDetail detailStructureId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailStructure|null} [detailStructure] HorseExamDetail detailStructure
           * @property {google.protobuf.IStringValue|null} [customDetailStructure] HorseExamDetail customDetailStructure
           * @property {string|null} [detailLimbId] HorseExamDetail detailLimbId
           * @property {stronachgroup.first.racehorse360.IHorseExamLimb|null} [detailLimb] HorseExamDetail detailLimb
           * @property {google.protobuf.IStringValue|null} [customDetailLimb] HorseExamDetail customDetailLimb
           * @property {string|null} [detailLocationId] HorseExamDetail detailLocationId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailLocation|null} [detailLocation] HorseExamDetail detailLocation
           * @property {google.protobuf.IStringValue|null} [customDetailLocation] HorseExamDetail customDetailLocation
           * @property {string|null} [detailLasixCCsId] HorseExamDetail detailLasixCCsId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailLasix|null} [detailLasixCCs] HorseExamDetail detailLasixCCs
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamDetailObservationEntry>|null} [observationEntries] HorseExamDetail observationEntries
           */

          /**
           * Constructs a new HorseExamDetail.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetail.
           * @implements IHorseExamDetail
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetail=} [properties] Properties to set
           */
          function HorseExamDetail(properties) {
            this.observationEntries = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetail id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.id = "";

          /**
           * HorseExamDetail horseExamId.
           * @member {string} horseExamId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.horseExamId = "";

          /**
           * HorseExamDetail detailStructureId.
           * @member {string} detailStructureId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailStructureId = "";

          /**
           * HorseExamDetail detailStructure.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailStructure|null|undefined} detailStructure
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailStructure = null;

          /**
           * HorseExamDetail customDetailStructure.
           * @member {google.protobuf.IStringValue|null|undefined} customDetailStructure
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.customDetailStructure = null;

          /**
           * HorseExamDetail detailLimbId.
           * @member {string} detailLimbId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLimbId = "";

          /**
           * HorseExamDetail detailLimb.
           * @member {stronachgroup.first.racehorse360.IHorseExamLimb|null|undefined} detailLimb
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLimb = null;

          /**
           * HorseExamDetail customDetailLimb.
           * @member {google.protobuf.IStringValue|null|undefined} customDetailLimb
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.customDetailLimb = null;

          /**
           * HorseExamDetail detailLocationId.
           * @member {string} detailLocationId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLocationId = "";

          /**
           * HorseExamDetail detailLocation.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailLocation|null|undefined} detailLocation
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLocation = null;

          /**
           * HorseExamDetail customDetailLocation.
           * @member {google.protobuf.IStringValue|null|undefined} customDetailLocation
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.customDetailLocation = null;

          /**
           * HorseExamDetail detailLasixCCsId.
           * @member {string} detailLasixCCsId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLasixCCsId = "";

          /**
           * HorseExamDetail detailLasixCCs.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailLasix|null|undefined} detailLasixCCs
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.detailLasixCCs = null;

          /**
           * HorseExamDetail observationEntries.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamDetailObservationEntry>} observationEntries
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           */
          HorseExamDetail.prototype.observationEntries = $util.emptyArray;

          /**
           * Creates a new HorseExamDetail instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetail=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetail} HorseExamDetail instance
           */
          HorseExamDetail.create = function create(properties) {
            return new HorseExamDetail(properties);
          };

          /**
           * Encodes the specified HorseExamDetail message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetail.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetail} message HorseExamDetail message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetail.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseExamId != null &&
              Object.hasOwnProperty.call(message, "horseExamId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseExamId);
            if (
              message.detailStructureId != null &&
              Object.hasOwnProperty.call(message, "detailStructureId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.detailStructureId);
            if (
              message.detailStructure != null &&
              Object.hasOwnProperty.call(message, "detailStructure")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.encode(
                message.detailStructure,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.customDetailStructure != null &&
              Object.hasOwnProperty.call(message, "customDetailStructure")
            )
              $root.google.protobuf.StringValue.encode(
                message.customDetailStructure,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.detailLimbId != null &&
              Object.hasOwnProperty.call(message, "detailLimbId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.detailLimbId);
            if (
              message.detailLimb != null &&
              Object.hasOwnProperty.call(message, "detailLimb")
            )
              $root.stronachgroup.first.racehorse360.HorseExamLimb.encode(
                message.detailLimb,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.customDetailLimb != null &&
              Object.hasOwnProperty.call(message, "customDetailLimb")
            )
              $root.google.protobuf.StringValue.encode(
                message.customDetailLimb,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            if (
              message.detailLocationId != null &&
              Object.hasOwnProperty.call(message, "detailLocationId")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.detailLocationId);
            if (
              message.detailLocation != null &&
              Object.hasOwnProperty.call(message, "detailLocation")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.encode(
                message.detailLocation,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.customDetailLocation != null &&
              Object.hasOwnProperty.call(message, "customDetailLocation")
            )
              $root.google.protobuf.StringValue.encode(
                message.customDetailLocation,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.detailLasixCCsId != null &&
              Object.hasOwnProperty.call(message, "detailLasixCCsId")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.detailLasixCCsId);
            if (
              message.detailLasixCCs != null &&
              Object.hasOwnProperty.call(message, "detailLasixCCs")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailLasix.encode(
                message.detailLasixCCs,
                writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
              ).ldelim();
            if (
              message.observationEntries != null &&
              message.observationEntries.length
            )
              for (var i = 0; i < message.observationEntries.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.encode(
                  message.observationEntries[i],
                  writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExamDetail message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetail} HorseExamDetail
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetail.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetail();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseExamId = reader.string();
                  break;
                case 3:
                  message.detailStructureId = reader.string();
                  break;
                case 4:
                  message.detailStructure =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.customDetailStructure =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.detailLimbId = reader.string();
                  break;
                case 7:
                  message.detailLimb =
                    $root.stronachgroup.first.racehorse360.HorseExamLimb.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.customDetailLimb =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 9:
                  message.detailLocationId = reader.string();
                  break;
                case 10:
                  message.detailLocation =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.customDetailLocation =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.detailLasixCCsId = reader.string();
                  break;
                case 13:
                  message.detailLasixCCs =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailLasix.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  if (
                    !(
                      message.observationEntries &&
                      message.observationEntries.length
                    )
                  )
                    message.observationEntries = [];
                  message.observationEntries.push(
                    $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetail message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetail} HorseExamDetail
           */
          HorseExamDetail.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetail
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetail();
            if (object.id != null) message.id = String(object.id);
            if (object.horseExamId != null)
              message.horseExamId = String(object.horseExamId);
            if (object.detailStructureId != null)
              message.detailStructureId = String(object.detailStructureId);
            if (object.detailStructure != null) {
              if (typeof object.detailStructure !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.detailStructure: object expected"
                );
              message.detailStructure =
                $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.fromObject(
                  object.detailStructure
                );
            }
            if (object.customDetailStructure != null) {
              if (typeof object.customDetailStructure !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.customDetailStructure: object expected"
                );
              message.customDetailStructure =
                $root.google.protobuf.StringValue.fromObject(
                  object.customDetailStructure
                );
            }
            if (object.detailLimbId != null)
              message.detailLimbId = String(object.detailLimbId);
            if (object.detailLimb != null) {
              if (typeof object.detailLimb !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.detailLimb: object expected"
                );
              message.detailLimb =
                $root.stronachgroup.first.racehorse360.HorseExamLimb.fromObject(
                  object.detailLimb
                );
            }
            if (object.customDetailLimb != null) {
              if (typeof object.customDetailLimb !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.customDetailLimb: object expected"
                );
              message.customDetailLimb =
                $root.google.protobuf.StringValue.fromObject(
                  object.customDetailLimb
                );
            }
            if (object.detailLocationId != null)
              message.detailLocationId = String(object.detailLocationId);
            if (object.detailLocation != null) {
              if (typeof object.detailLocation !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.detailLocation: object expected"
                );
              message.detailLocation =
                $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.fromObject(
                  object.detailLocation
                );
            }
            if (object.customDetailLocation != null) {
              if (typeof object.customDetailLocation !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.customDetailLocation: object expected"
                );
              message.customDetailLocation =
                $root.google.protobuf.StringValue.fromObject(
                  object.customDetailLocation
                );
            }
            if (object.detailLasixCCsId != null)
              message.detailLasixCCsId = String(object.detailLasixCCsId);
            if (object.detailLasixCCs != null) {
              if (typeof object.detailLasixCCs !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.detailLasixCCs: object expected"
                );
              message.detailLasixCCs =
                $root.stronachgroup.first.racehorse360.HorseExamDetailLasix.fromObject(
                  object.detailLasixCCs
                );
            }
            if (object.observationEntries) {
              if (!Array.isArray(object.observationEntries))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetail.observationEntries: array expected"
                );
              message.observationEntries = [];
              for (var i = 0; i < object.observationEntries.length; ++i) {
                if (typeof object.observationEntries[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.HorseExamDetail.observationEntries: object expected"
                  );
                message.observationEntries[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.fromObject(
                    object.observationEntries[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetail message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetail} message HorseExamDetail
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetail.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.observationEntries = [];
            if (options.defaults) {
              object.id = "";
              object.horseExamId = "";
              object.detailStructureId = "";
              object.detailStructure = null;
              object.customDetailStructure = null;
              object.detailLimbId = "";
              object.detailLimb = null;
              object.customDetailLimb = null;
              object.detailLocationId = "";
              object.detailLocation = null;
              object.customDetailLocation = null;
              object.detailLasixCCsId = "";
              object.detailLasixCCs = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseExamId != null &&
              message.hasOwnProperty("horseExamId")
            )
              object.horseExamId = message.horseExamId;
            if (
              message.detailStructureId != null &&
              message.hasOwnProperty("detailStructureId")
            )
              object.detailStructureId = message.detailStructureId;
            if (
              message.detailStructure != null &&
              message.hasOwnProperty("detailStructure")
            )
              object.detailStructure =
                $root.stronachgroup.first.racehorse360.HorseExamDetailStructure.toObject(
                  message.detailStructure,
                  options
                );
            if (
              message.customDetailStructure != null &&
              message.hasOwnProperty("customDetailStructure")
            )
              object.customDetailStructure =
                $root.google.protobuf.StringValue.toObject(
                  message.customDetailStructure,
                  options
                );
            if (
              message.detailLimbId != null &&
              message.hasOwnProperty("detailLimbId")
            )
              object.detailLimbId = message.detailLimbId;
            if (
              message.detailLimb != null &&
              message.hasOwnProperty("detailLimb")
            )
              object.detailLimb =
                $root.stronachgroup.first.racehorse360.HorseExamLimb.toObject(
                  message.detailLimb,
                  options
                );
            if (
              message.customDetailLimb != null &&
              message.hasOwnProperty("customDetailLimb")
            )
              object.customDetailLimb =
                $root.google.protobuf.StringValue.toObject(
                  message.customDetailLimb,
                  options
                );
            if (
              message.detailLocationId != null &&
              message.hasOwnProperty("detailLocationId")
            )
              object.detailLocationId = message.detailLocationId;
            if (
              message.detailLocation != null &&
              message.hasOwnProperty("detailLocation")
            )
              object.detailLocation =
                $root.stronachgroup.first.racehorse360.HorseExamDetailLocation.toObject(
                  message.detailLocation,
                  options
                );
            if (
              message.customDetailLocation != null &&
              message.hasOwnProperty("customDetailLocation")
            )
              object.customDetailLocation =
                $root.google.protobuf.StringValue.toObject(
                  message.customDetailLocation,
                  options
                );
            if (
              message.detailLasixCCsId != null &&
              message.hasOwnProperty("detailLasixCCsId")
            )
              object.detailLasixCCsId = message.detailLasixCCsId;
            if (
              message.detailLasixCCs != null &&
              message.hasOwnProperty("detailLasixCCs")
            )
              object.detailLasixCCs =
                $root.stronachgroup.first.racehorse360.HorseExamDetailLasix.toObject(
                  message.detailLasixCCs,
                  options
                );
            if (
              message.observationEntries &&
              message.observationEntries.length
            ) {
              object.observationEntries = [];
              for (var j = 0; j < message.observationEntries.length; ++j)
                object.observationEntries[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.toObject(
                    message.observationEntries[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this HorseExamDetail to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetail
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetail;
        })();

        racehorse360.HorseExamDetailCondition = (function () {
          /**
           * Properties of a HorseExamDetailCondition.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailCondition
           * @property {string|null} [id] HorseExamDetailCondition id
           * @property {string|null} [description] HorseExamDetailCondition description
           * @property {string|null} [shortDescription] HorseExamDetailCondition shortDescription
           */

          /**
           * Constructs a new HorseExamDetailCondition.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailCondition.
           * @implements IHorseExamDetailCondition
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailCondition=} [properties] Properties to set
           */
          function HorseExamDetailCondition(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailCondition id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @instance
           */
          HorseExamDetailCondition.prototype.id = "";

          /**
           * HorseExamDetailCondition description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @instance
           */
          HorseExamDetailCondition.prototype.description = "";

          /**
           * HorseExamDetailCondition shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @instance
           */
          HorseExamDetailCondition.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamDetailCondition instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailCondition=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailCondition} HorseExamDetailCondition instance
           */
          HorseExamDetailCondition.create = function create(properties) {
            return new HorseExamDetailCondition(properties);
          };

          /**
           * Encodes the specified HorseExamDetailCondition message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailCondition.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailCondition} message HorseExamDetailCondition message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailCondition.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailCondition message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailCondition} HorseExamDetailCondition
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailCondition.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailCondition();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailCondition message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailCondition} HorseExamDetailCondition
           */
          HorseExamDetailCondition.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailCondition
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailCondition();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailCondition message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailCondition} message HorseExamDetailCondition
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailCondition.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamDetailCondition to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailCondition
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailCondition;
        })();

        racehorse360.HorseExamDetailObservation = (function () {
          /**
           * Properties of a HorseExamDetailObservation.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailObservation
           * @property {string|null} [id] HorseExamDetailObservation id
           * @property {string|null} [description] HorseExamDetailObservation description
           * @property {string|null} [shortDescription] HorseExamDetailObservation shortDescription
           */

          /**
           * Constructs a new HorseExamDetailObservation.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailObservation.
           * @implements IHorseExamDetailObservation
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservation=} [properties] Properties to set
           */
          function HorseExamDetailObservation(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailObservation id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @instance
           */
          HorseExamDetailObservation.prototype.id = "";

          /**
           * HorseExamDetailObservation description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @instance
           */
          HorseExamDetailObservation.prototype.description = "";

          /**
           * HorseExamDetailObservation shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @instance
           */
          HorseExamDetailObservation.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamDetailObservation instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservation=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservation} HorseExamDetailObservation instance
           */
          HorseExamDetailObservation.create = function create(properties) {
            return new HorseExamDetailObservation(properties);
          };

          /**
           * Encodes the specified HorseExamDetailObservation message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailObservation.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservation} message HorseExamDetailObservation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailObservation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailObservation message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservation} HorseExamDetailObservation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailObservation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailObservation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailObservation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservation} HorseExamDetailObservation
           */
          HorseExamDetailObservation.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailObservation
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailObservation();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailObservation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailObservation} message HorseExamDetailObservation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailObservation.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamDetailObservation to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailObservation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailObservation;
        })();

        racehorse360.HorseExamDetailSeverity = (function () {
          /**
           * Properties of a HorseExamDetailSeverity.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailSeverity
           * @property {string|null} [id] HorseExamDetailSeverity id
           * @property {string|null} [description] HorseExamDetailSeverity description
           * @property {string|null} [shortDescription] HorseExamDetailSeverity shortDescription
           */

          /**
           * Constructs a new HorseExamDetailSeverity.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailSeverity.
           * @implements IHorseExamDetailSeverity
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailSeverity=} [properties] Properties to set
           */
          function HorseExamDetailSeverity(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailSeverity id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @instance
           */
          HorseExamDetailSeverity.prototype.id = "";

          /**
           * HorseExamDetailSeverity description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @instance
           */
          HorseExamDetailSeverity.prototype.description = "";

          /**
           * HorseExamDetailSeverity shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @instance
           */
          HorseExamDetailSeverity.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamDetailSeverity instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailSeverity=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailSeverity} HorseExamDetailSeverity instance
           */
          HorseExamDetailSeverity.create = function create(properties) {
            return new HorseExamDetailSeverity(properties);
          };

          /**
           * Encodes the specified HorseExamDetailSeverity message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailSeverity.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailSeverity} message HorseExamDetailSeverity message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailSeverity.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailSeverity message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailSeverity} HorseExamDetailSeverity
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailSeverity.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailSeverity message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailSeverity} HorseExamDetailSeverity
           */
          HorseExamDetailSeverity.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailSeverity message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailSeverity} message HorseExamDetailSeverity
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailSeverity.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamDetailSeverity to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailSeverity
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailSeverity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailSeverity;
        })();

        racehorse360.HorseExamDetailStructure = (function () {
          /**
           * Properties of a HorseExamDetailStructure.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailStructure
           * @property {string|null} [id] HorseExamDetailStructure id
           * @property {string|null} [description] HorseExamDetailStructure description
           * @property {string|null} [shortDescription] HorseExamDetailStructure shortDescription
           */

          /**
           * Constructs a new HorseExamDetailStructure.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailStructure.
           * @implements IHorseExamDetailStructure
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailStructure=} [properties] Properties to set
           */
          function HorseExamDetailStructure(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailStructure id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @instance
           */
          HorseExamDetailStructure.prototype.id = "";

          /**
           * HorseExamDetailStructure description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @instance
           */
          HorseExamDetailStructure.prototype.description = "";

          /**
           * HorseExamDetailStructure shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @instance
           */
          HorseExamDetailStructure.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamDetailStructure instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailStructure=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailStructure} HorseExamDetailStructure instance
           */
          HorseExamDetailStructure.create = function create(properties) {
            return new HorseExamDetailStructure(properties);
          };

          /**
           * Encodes the specified HorseExamDetailStructure message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailStructure.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailStructure} message HorseExamDetailStructure message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailStructure.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailStructure message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailStructure} HorseExamDetailStructure
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailStructure.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailStructure();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailStructure message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailStructure} HorseExamDetailStructure
           */
          HorseExamDetailStructure.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailStructure
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailStructure();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailStructure message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailStructure} message HorseExamDetailStructure
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailStructure.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamDetailStructure to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailStructure
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailStructure.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailStructure;
        })();

        racehorse360.HorseExamDetailLocation = (function () {
          /**
           * Properties of a HorseExamDetailLocation.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailLocation
           * @property {string|null} [id] HorseExamDetailLocation id
           * @property {string|null} [description] HorseExamDetailLocation description
           * @property {string|null} [shortDescription] HorseExamDetailLocation shortDescription
           */

          /**
           * Constructs a new HorseExamDetailLocation.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailLocation.
           * @implements IHorseExamDetailLocation
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLocation=} [properties] Properties to set
           */
          function HorseExamDetailLocation(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailLocation id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @instance
           */
          HorseExamDetailLocation.prototype.id = "";

          /**
           * HorseExamDetailLocation description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @instance
           */
          HorseExamDetailLocation.prototype.description = "";

          /**
           * HorseExamDetailLocation shortDescription.
           * @member {string} shortDescription
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @instance
           */
          HorseExamDetailLocation.prototype.shortDescription = "";

          /**
           * Creates a new HorseExamDetailLocation instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLocation=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLocation} HorseExamDetailLocation instance
           */
          HorseExamDetailLocation.create = function create(properties) {
            return new HorseExamDetailLocation(properties);
          };

          /**
           * Encodes the specified HorseExamDetailLocation message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailLocation.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLocation} message HorseExamDetailLocation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailLocation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.shortDescription != null &&
              Object.hasOwnProperty.call(message, "shortDescription")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.shortDescription);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailLocation message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLocation} HorseExamDetailLocation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailLocation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailLocation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.shortDescription = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailLocation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLocation} HorseExamDetailLocation
           */
          HorseExamDetailLocation.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailLocation
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailLocation();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.shortDescription != null)
              message.shortDescription = String(object.shortDescription);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailLocation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailLocation} message HorseExamDetailLocation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailLocation.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.shortDescription = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (
              message.shortDescription != null &&
              message.hasOwnProperty("shortDescription")
            )
              object.shortDescription = message.shortDescription;
            return object;
          };

          /**
           * Converts this HorseExamDetailLocation to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLocation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailLocation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailLocation;
        })();

        racehorse360.HorseExamDetailLasix = (function () {
          /**
           * Properties of a HorseExamDetailLasix.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailLasix
           * @property {string|null} [id] HorseExamDetailLasix id
           * @property {string|null} [description] HorseExamDetailLasix description
           * @property {string|null} [position] HorseExamDetailLasix position
           */

          /**
           * Constructs a new HorseExamDetailLasix.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailLasix.
           * @implements IHorseExamDetailLasix
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLasix=} [properties] Properties to set
           */
          function HorseExamDetailLasix(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailLasix id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @instance
           */
          HorseExamDetailLasix.prototype.id = "";

          /**
           * HorseExamDetailLasix description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @instance
           */
          HorseExamDetailLasix.prototype.description = "";

          /**
           * HorseExamDetailLasix position.
           * @member {string} position
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @instance
           */
          HorseExamDetailLasix.prototype.position = "";

          /**
           * Creates a new HorseExamDetailLasix instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLasix=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLasix} HorseExamDetailLasix instance
           */
          HorseExamDetailLasix.create = function create(properties) {
            return new HorseExamDetailLasix(properties);
          };

          /**
           * Encodes the specified HorseExamDetailLasix message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailLasix.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailLasix} message HorseExamDetailLasix message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailLasix.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.position != null &&
              Object.hasOwnProperty.call(message, "position")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.position);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailLasix message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLasix} HorseExamDetailLasix
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailLasix.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailLasix();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.position = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailLasix message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailLasix} HorseExamDetailLasix
           */
          HorseExamDetailLasix.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamDetailLasix
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailLasix();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.position != null)
              message.position = String(object.position);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailLasix message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailLasix} message HorseExamDetailLasix
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailLasix.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.position = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.position != null && message.hasOwnProperty("position"))
              object.position = message.position;
            return object;
          };

          /**
           * Converts this HorseExamDetailLasix to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailLasix
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailLasix.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailLasix;
        })();

        racehorse360.HorseExamDetailObservationEntry = (function () {
          /**
           * Properties of a HorseExamDetailObservationEntry.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamDetailObservationEntry
           * @property {string|null} [id] HorseExamDetailObservationEntry id
           * @property {string|null} [horseExamDetailId] HorseExamDetailObservationEntry horseExamDetailId
           * @property {string|null} [detailObservationId] HorseExamDetailObservationEntry detailObservationId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailObservation|null} [detailObservation] HorseExamDetailObservationEntry detailObservation
           * @property {google.protobuf.IStringValue|null} [customDetailObservation] HorseExamDetailObservationEntry customDetailObservation
           * @property {string|null} [detailSeverityId] HorseExamDetailObservationEntry detailSeverityId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailSeverity|null} [detailSeverity] HorseExamDetailObservationEntry detailSeverity
           * @property {string|null} [detailConditionId] HorseExamDetailObservationEntry detailConditionId
           * @property {stronachgroup.first.racehorse360.IHorseExamDetailCondition|null} [detailCondition] HorseExamDetailObservationEntry detailCondition
           * @property {google.protobuf.IStringValue|null} [customDetailCondition] HorseExamDetailObservationEntry customDetailCondition
           * @property {string|null} [notes] HorseExamDetailObservationEntry notes
           */

          /**
           * Constructs a new HorseExamDetailObservationEntry.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamDetailObservationEntry.
           * @implements IHorseExamDetailObservationEntry
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservationEntry=} [properties] Properties to set
           */
          function HorseExamDetailObservationEntry(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamDetailObservationEntry id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.id = "";

          /**
           * HorseExamDetailObservationEntry horseExamDetailId.
           * @member {string} horseExamDetailId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.horseExamDetailId = "";

          /**
           * HorseExamDetailObservationEntry detailObservationId.
           * @member {string} detailObservationId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailObservationId = "";

          /**
           * HorseExamDetailObservationEntry detailObservation.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailObservation|null|undefined} detailObservation
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailObservation = null;

          /**
           * HorseExamDetailObservationEntry customDetailObservation.
           * @member {google.protobuf.IStringValue|null|undefined} customDetailObservation
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.customDetailObservation =
            null;

          /**
           * HorseExamDetailObservationEntry detailSeverityId.
           * @member {string} detailSeverityId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailSeverityId = "";

          /**
           * HorseExamDetailObservationEntry detailSeverity.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailSeverity|null|undefined} detailSeverity
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailSeverity = null;

          /**
           * HorseExamDetailObservationEntry detailConditionId.
           * @member {string} detailConditionId
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailConditionId = "";

          /**
           * HorseExamDetailObservationEntry detailCondition.
           * @member {stronachgroup.first.racehorse360.IHorseExamDetailCondition|null|undefined} detailCondition
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.detailCondition = null;

          /**
           * HorseExamDetailObservationEntry customDetailCondition.
           * @member {google.protobuf.IStringValue|null|undefined} customDetailCondition
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.customDetailCondition =
            null;

          /**
           * HorseExamDetailObservationEntry notes.
           * @member {string} notes
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           */
          HorseExamDetailObservationEntry.prototype.notes = "";

          /**
           * Creates a new HorseExamDetailObservationEntry instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservationEntry=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservationEntry} HorseExamDetailObservationEntry instance
           */
          HorseExamDetailObservationEntry.create = function create(properties) {
            return new HorseExamDetailObservationEntry(properties);
          };

          /**
           * Encodes the specified HorseExamDetailObservationEntry message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamDetailObservationEntry} message HorseExamDetailObservationEntry message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamDetailObservationEntry.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseExamDetailId != null &&
              Object.hasOwnProperty.call(message, "horseExamDetailId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseExamDetailId);
            if (
              message.detailObservationId != null &&
              Object.hasOwnProperty.call(message, "detailObservationId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.detailObservationId);
            if (
              message.detailObservation != null &&
              Object.hasOwnProperty.call(message, "detailObservation")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.encode(
                message.detailObservation,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.customDetailObservation != null &&
              Object.hasOwnProperty.call(message, "customDetailObservation")
            )
              $root.google.protobuf.StringValue.encode(
                message.customDetailObservation,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.detailSeverityId != null &&
              Object.hasOwnProperty.call(message, "detailSeverityId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.detailSeverityId);
            if (
              message.detailSeverity != null &&
              Object.hasOwnProperty.call(message, "detailSeverity")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.encode(
                message.detailSeverity,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.detailConditionId != null &&
              Object.hasOwnProperty.call(message, "detailConditionId")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.detailConditionId);
            if (
              message.detailCondition != null &&
              Object.hasOwnProperty.call(message, "detailCondition")
            )
              $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.encode(
                message.detailCondition,
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
            if (
              message.customDetailCondition != null &&
              Object.hasOwnProperty.call(message, "customDetailCondition")
            )
              $root.google.protobuf.StringValue.encode(
                message.customDetailCondition,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.notes != null &&
              Object.hasOwnProperty.call(message, "notes")
            )
              writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.notes);
            return writer;
          };

          /**
           * Decodes a HorseExamDetailObservationEntry message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservationEntry} HorseExamDetailObservationEntry
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamDetailObservationEntry.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseExamDetailId = reader.string();
                  break;
                case 3:
                  message.detailObservationId = reader.string();
                  break;
                case 4:
                  message.detailObservation =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.customDetailObservation =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.detailSeverityId = reader.string();
                  break;
                case 7:
                  message.detailSeverity =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.detailConditionId = reader.string();
                  break;
                case 9:
                  message.detailCondition =
                    $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 10:
                  message.customDetailCondition =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.notes = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamDetailObservationEntry message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamDetailObservationEntry} HorseExamDetailObservationEntry
           */
          HorseExamDetailObservationEntry.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .HorseExamDetailObservationEntry
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamDetailObservationEntry();
            if (object.id != null) message.id = String(object.id);
            if (object.horseExamDetailId != null)
              message.horseExamDetailId = String(object.horseExamDetailId);
            if (object.detailObservationId != null)
              message.detailObservationId = String(object.detailObservationId);
            if (object.detailObservation != null) {
              if (typeof object.detailObservation !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.detailObservation: object expected"
                );
              message.detailObservation =
                $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.fromObject(
                  object.detailObservation
                );
            }
            if (object.customDetailObservation != null) {
              if (typeof object.customDetailObservation !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.customDetailObservation: object expected"
                );
              message.customDetailObservation =
                $root.google.protobuf.StringValue.fromObject(
                  object.customDetailObservation
                );
            }
            if (object.detailSeverityId != null)
              message.detailSeverityId = String(object.detailSeverityId);
            if (object.detailSeverity != null) {
              if (typeof object.detailSeverity !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.detailSeverity: object expected"
                );
              message.detailSeverity =
                $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.fromObject(
                  object.detailSeverity
                );
            }
            if (object.detailConditionId != null)
              message.detailConditionId = String(object.detailConditionId);
            if (object.detailCondition != null) {
              if (typeof object.detailCondition !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.detailCondition: object expected"
                );
              message.detailCondition =
                $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.fromObject(
                  object.detailCondition
                );
            }
            if (object.customDetailCondition != null) {
              if (typeof object.customDetailCondition !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamDetailObservationEntry.customDetailCondition: object expected"
                );
              message.customDetailCondition =
                $root.google.protobuf.StringValue.fromObject(
                  object.customDetailCondition
                );
            }
            if (object.notes != null) message.notes = String(object.notes);
            return message;
          };

          /**
           * Creates a plain object from a HorseExamDetailObservationEntry message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamDetailObservationEntry} message HorseExamDetailObservationEntry
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamDetailObservationEntry.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseExamDetailId = "";
              object.detailObservationId = "";
              object.detailObservation = null;
              object.customDetailObservation = null;
              object.detailSeverityId = "";
              object.detailSeverity = null;
              object.detailConditionId = "";
              object.detailCondition = null;
              object.customDetailCondition = null;
              object.notes = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseExamDetailId != null &&
              message.hasOwnProperty("horseExamDetailId")
            )
              object.horseExamDetailId = message.horseExamDetailId;
            if (
              message.detailObservationId != null &&
              message.hasOwnProperty("detailObservationId")
            )
              object.detailObservationId = message.detailObservationId;
            if (
              message.detailObservation != null &&
              message.hasOwnProperty("detailObservation")
            )
              object.detailObservation =
                $root.stronachgroup.first.racehorse360.HorseExamDetailObservation.toObject(
                  message.detailObservation,
                  options
                );
            if (
              message.customDetailObservation != null &&
              message.hasOwnProperty("customDetailObservation")
            )
              object.customDetailObservation =
                $root.google.protobuf.StringValue.toObject(
                  message.customDetailObservation,
                  options
                );
            if (
              message.detailSeverityId != null &&
              message.hasOwnProperty("detailSeverityId")
            )
              object.detailSeverityId = message.detailSeverityId;
            if (
              message.detailSeverity != null &&
              message.hasOwnProperty("detailSeverity")
            )
              object.detailSeverity =
                $root.stronachgroup.first.racehorse360.HorseExamDetailSeverity.toObject(
                  message.detailSeverity,
                  options
                );
            if (
              message.detailConditionId != null &&
              message.hasOwnProperty("detailConditionId")
            )
              object.detailConditionId = message.detailConditionId;
            if (
              message.detailCondition != null &&
              message.hasOwnProperty("detailCondition")
            )
              object.detailCondition =
                $root.stronachgroup.first.racehorse360.HorseExamDetailCondition.toObject(
                  message.detailCondition,
                  options
                );
            if (
              message.customDetailCondition != null &&
              message.hasOwnProperty("customDetailCondition")
            )
              object.customDetailCondition =
                $root.google.protobuf.StringValue.toObject(
                  message.customDetailCondition,
                  options
                );
            if (message.notes != null && message.hasOwnProperty("notes"))
              object.notes = message.notes;
            return object;
          };

          /**
           * Converts this HorseExamDetailObservationEntry to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamDetailObservationEntry
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamDetailObservationEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamDetailObservationEntry;
        })();

        racehorse360.HorseExamComment = (function () {
          /**
           * Properties of a HorseExamComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamComment
           * @property {string|null} [id] HorseExamComment id
           * @property {string|null} [body] HorseExamComment body
           * @property {stronachgroup.first.racehorse360.IHorseExam|null} [horseExam] HorseExamComment horseExam
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] HorseExamComment trainer
           * @property {stronachgroup.first.racehorse360.HorseExamCommentType|null} [commentType] HorseExamComment commentType
           * @property {boolean|null} [isManual] HorseExamComment isManual
           * @property {boolean|null} [isRead] HorseExamComment isRead
           * @property {string|null} [createdOn] HorseExamComment createdOn
           * @property {string|null} [updatedOn] HorseExamComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseExamComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseExamComment updatedBy
           */

          /**
           * Constructs a new HorseExamComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamComment.
           * @implements IHorseExamComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamComment=} [properties] Properties to set
           */
          function HorseExamComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.id = "";

          /**
           * HorseExamComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.body = "";

          /**
           * HorseExamComment horseExam.
           * @member {stronachgroup.first.racehorse360.IHorseExam|null|undefined} horseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.horseExam = null;

          /**
           * HorseExamComment trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.trainer = null;

          /**
           * HorseExamComment commentType.
           * @member {stronachgroup.first.racehorse360.HorseExamCommentType} commentType
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.commentType = 0;

          /**
           * HorseExamComment isManual.
           * @member {boolean} isManual
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.isManual = false;

          /**
           * HorseExamComment isRead.
           * @member {boolean} isRead
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.isRead = false;

          /**
           * HorseExamComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.createdOn = "";

          /**
           * HorseExamComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.updatedOn = "";

          /**
           * HorseExamComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.createdBy = null;

          /**
           * HorseExamComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           */
          HorseExamComment.prototype.updatedBy = null;

          /**
           * Creates a new HorseExamComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamComment} HorseExamComment instance
           */
          HorseExamComment.create = function create(properties) {
            return new HorseExamComment(properties);
          };

          /**
           * Encodes the specified HorseExamComment message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamComment} message HorseExamComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.body);
            if (
              message.horseExam != null &&
              Object.hasOwnProperty.call(message, "horseExam")
            )
              $root.stronachgroup.first.racehorse360.HorseExam.encode(
                message.horseExam,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.commentType != null &&
              Object.hasOwnProperty.call(message, "commentType")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.commentType);
            if (
              message.isManual != null &&
              Object.hasOwnProperty.call(message, "isManual")
            )
              writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.isManual);
            if (
              message.isRead != null &&
              Object.hasOwnProperty.call(message, "isRead")
            )
              writer.uint32(/* id 8, wireType 0 =*/ 64).bool(message.isRead);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExamComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamComment} HorseExamComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.body = reader.string();
                  break;
                case 4:
                  message.horseExam =
                    $root.stronachgroup.first.racehorse360.HorseExam.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.commentType = reader.int32();
                  break;
                case 7:
                  message.isManual = reader.bool();
                  break;
                case 8:
                  message.isRead = reader.bool();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamComment} HorseExamComment
           */
          HorseExamComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamComment();
            if (object.id != null) message.id = String(object.id);
            if (object.body != null) message.body = String(object.body);
            if (object.horseExam != null) {
              if (typeof object.horseExam !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamComment.horseExam: object expected"
                );
              message.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.fromObject(
                  object.horseExam
                );
            }
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamComment.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            switch (object.commentType) {
              case "HORSE_EXAM_COMMENT_TYPE_INVALID":
              case 0:
                message.commentType = 0;
                break;
              case "HORSE_EXAM_COMMENT_TYPE_TRAINER_COMMUNICATION":
              case 1:
                message.commentType = 1;
                break;
              case "HORSE_EXAM_COMMENT_TYPE_VET_COMMUNICATION":
              case 2:
                message.commentType = 2;
                break;
            }
            if (object.isManual != null)
              message.isManual = Boolean(object.isManual);
            if (object.isRead != null) message.isRead = Boolean(object.isRead);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamComment} message HorseExamComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamComment.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.body = "";
              object.horseExam = null;
              object.trainer = null;
              object.commentType =
                options.enums === String
                  ? "HORSE_EXAM_COMMENT_TYPE_INVALID"
                  : 0;
              object.isManual = false;
              object.isRead = false;
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.horseExam != null &&
              message.hasOwnProperty("horseExam")
            )
              object.horseExam =
                $root.stronachgroup.first.racehorse360.HorseExam.toObject(
                  message.horseExam,
                  options
                );
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (
              message.commentType != null &&
              message.hasOwnProperty("commentType")
            )
              object.commentType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.HorseExamCommentType[
                      message.commentType
                    ]
                  : message.commentType;
            if (message.isManual != null && message.hasOwnProperty("isManual"))
              object.isManual = message.isManual;
            if (message.isRead != null && message.hasOwnProperty("isRead"))
              object.isRead = message.isRead;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseExamComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamComment;
        })();

        racehorse360.HorseExamCommentFilter = (function () {
          /**
           * Properties of a HorseExamCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamCommentFilter
           * @property {Array.<string>|null} [ids] HorseExamCommentFilter ids
           * @property {Array.<string>|null} [horseExamIds] HorseExamCommentFilter horseExamIds
           * @property {Array.<string>|null} [trainerIds] HorseExamCommentFilter trainerIds
           * @property {google.protobuf.IBoolValue|null} [isManual] HorseExamCommentFilter isManual
           */

          /**
           * Constructs a new HorseExamCommentFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamCommentFilter.
           * @implements IHorseExamCommentFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamCommentFilter=} [properties] Properties to set
           */
          function HorseExamCommentFilter(properties) {
            this.ids = [];
            this.horseExamIds = [];
            this.trainerIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamCommentFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @instance
           */
          HorseExamCommentFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseExamCommentFilter horseExamIds.
           * @member {Array.<string>} horseExamIds
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @instance
           */
          HorseExamCommentFilter.prototype.horseExamIds = $util.emptyArray;

          /**
           * HorseExamCommentFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @instance
           */
          HorseExamCommentFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * HorseExamCommentFilter isManual.
           * @member {google.protobuf.IBoolValue|null|undefined} isManual
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @instance
           */
          HorseExamCommentFilter.prototype.isManual = null;

          /**
           * Creates a new HorseExamCommentFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamCommentFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamCommentFilter} HorseExamCommentFilter instance
           */
          HorseExamCommentFilter.create = function create(properties) {
            return new HorseExamCommentFilter(properties);
          };

          /**
           * Encodes the specified HorseExamCommentFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamCommentFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamCommentFilter} message HorseExamCommentFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamCommentFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseExamIds != null && message.horseExamIds.length)
              for (var i = 0; i < message.horseExamIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseExamIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.trainerIds[i]);
            if (
              message.isManual != null &&
              Object.hasOwnProperty.call(message, "isManual")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isManual,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExamCommentFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamCommentFilter} HorseExamCommentFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamCommentFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamCommentFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.horseExamIds && message.horseExamIds.length))
                    message.horseExamIds = [];
                  message.horseExamIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 4:
                  message.isManual = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamCommentFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamCommentFilter} HorseExamCommentFilter
           */
          HorseExamCommentFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamCommentFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamCommentFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamCommentFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseExamIds) {
              if (!Array.isArray(object.horseExamIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamCommentFilter.horseExamIds: array expected"
                );
              message.horseExamIds = [];
              for (var i = 0; i < object.horseExamIds.length; ++i)
                message.horseExamIds[i] = String(object.horseExamIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamCommentFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.isManual != null) {
              if (typeof object.isManual !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamCommentFilter.isManual: object expected"
                );
              message.isManual = $root.google.protobuf.BoolValue.fromObject(
                object.isManual
              );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamCommentFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamCommentFilter} message HorseExamCommentFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamCommentFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseExamIds = [];
              object.trainerIds = [];
            }
            if (options.defaults) object.isManual = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseExamIds && message.horseExamIds.length) {
              object.horseExamIds = [];
              for (var j = 0; j < message.horseExamIds.length; ++j)
                object.horseExamIds[j] = message.horseExamIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.isManual != null && message.hasOwnProperty("isManual"))
              object.isManual = $root.google.protobuf.BoolValue.toObject(
                message.isManual,
                options
              );
            return object;
          };

          /**
           * Converts this HorseExamCommentFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamCommentFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamCommentFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamCommentFilter;
        })();

        racehorse360.GetHorseExamCommentRequest = (function () {
          /**
           * Properties of a GetHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetHorseExamCommentRequest
           * @property {string|null} [id] GetHorseExamCommentRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetHorseExamCommentRequest getOptions
           */

          /**
           * Constructs a new GetHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetHorseExamCommentRequest.
           * @implements IGetHorseExamCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetHorseExamCommentRequest=} [properties] Properties to set
           */
          function GetHorseExamCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetHorseExamCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @instance
           */
          GetHorseExamCommentRequest.prototype.id = "";

          /**
           * GetHorseExamCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @instance
           */
          GetHorseExamCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new GetHorseExamCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseExamCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetHorseExamCommentRequest} GetHorseExamCommentRequest instance
           */
          GetHorseExamCommentRequest.create = function create(properties) {
            return new GetHorseExamCommentRequest(properties);
          };

          /**
           * Encodes the specified GetHorseExamCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetHorseExamCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseExamCommentRequest} message GetHorseExamCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetHorseExamCommentRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetHorseExamCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetHorseExamCommentRequest} GetHorseExamCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetHorseExamCommentRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetHorseExamCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetHorseExamCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetHorseExamCommentRequest} GetHorseExamCommentRequest
           */
          GetHorseExamCommentRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetHorseExamCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetHorseExamCommentRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetHorseExamCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetHorseExamCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetHorseExamCommentRequest} message GetHorseExamCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetHorseExamCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetHorseExamCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetHorseExamCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetHorseExamCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetHorseExamCommentRequest;
        })();

        racehorse360.CreateHorseExamCommentRequest = (function () {
          /**
           * Properties of a CreateHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateHorseExamCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseExamComment|null} [horseExamComment] CreateHorseExamCommentRequest horseExamComment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateHorseExamCommentRequest getOptions
           */

          /**
           * Constructs a new CreateHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateHorseExamCommentRequest.
           * @implements ICreateHorseExamCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamCommentRequest=} [properties] Properties to set
           */
          function CreateHorseExamCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateHorseExamCommentRequest horseExamComment.
           * @member {stronachgroup.first.racehorse360.IHorseExamComment|null|undefined} horseExamComment
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @instance
           */
          CreateHorseExamCommentRequest.prototype.horseExamComment = null;

          /**
           * CreateHorseExamCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @instance
           */
          CreateHorseExamCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateHorseExamCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamCommentRequest} CreateHorseExamCommentRequest instance
           */
          CreateHorseExamCommentRequest.create = function create(properties) {
            return new CreateHorseExamCommentRequest(properties);
          };

          /**
           * Encodes the specified CreateHorseExamCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateHorseExamCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamCommentRequest} message CreateHorseExamCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateHorseExamCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExamComment != null &&
              Object.hasOwnProperty.call(message, "horseExamComment")
            )
              $root.stronachgroup.first.racehorse360.HorseExamComment.encode(
                message.horseExamComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateHorseExamCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamCommentRequest} CreateHorseExamCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateHorseExamCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateHorseExamCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseExamComment =
                    $root.stronachgroup.first.racehorse360.HorseExamComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateHorseExamCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateHorseExamCommentRequest} CreateHorseExamCommentRequest
           */
          CreateHorseExamCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateHorseExamCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateHorseExamCommentRequest();
            if (object.horseExamComment != null) {
              if (typeof object.horseExamComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseExamCommentRequest.horseExamComment: object expected"
                );
              message.horseExamComment =
                $root.stronachgroup.first.racehorse360.HorseExamComment.fromObject(
                  object.horseExamComment
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseExamCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateHorseExamCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateHorseExamCommentRequest} message CreateHorseExamCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateHorseExamCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseExamComment = null;
              object.getOptions = null;
            }
            if (
              message.horseExamComment != null &&
              message.hasOwnProperty("horseExamComment")
            )
              object.horseExamComment =
                $root.stronachgroup.first.racehorse360.HorseExamComment.toObject(
                  message.horseExamComment,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateHorseExamCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateHorseExamCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateHorseExamCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateHorseExamCommentRequest;
        })();

        racehorse360.UpdateHorseExamCommentRequest = (function () {
          /**
           * Properties of an UpdateHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateHorseExamCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseExamComment|null} [horseExamComment] UpdateHorseExamCommentRequest horseExamComment
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateHorseExamCommentRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateHorseExamCommentRequest getOptions
           */

          /**
           * Constructs a new UpdateHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateHorseExamCommentRequest.
           * @implements IUpdateHorseExamCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateHorseExamCommentRequest=} [properties] Properties to set
           */
          function UpdateHorseExamCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateHorseExamCommentRequest horseExamComment.
           * @member {stronachgroup.first.racehorse360.IHorseExamComment|null|undefined} horseExamComment
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @instance
           */
          UpdateHorseExamCommentRequest.prototype.horseExamComment = null;

          /**
           * UpdateHorseExamCommentRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @instance
           */
          UpdateHorseExamCommentRequest.prototype.updateMask = null;

          /**
           * UpdateHorseExamCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @instance
           */
          UpdateHorseExamCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateHorseExamCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseExamCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest} UpdateHorseExamCommentRequest instance
           */
          UpdateHorseExamCommentRequest.create = function create(properties) {
            return new UpdateHorseExamCommentRequest(properties);
          };

          /**
           * Encodes the specified UpdateHorseExamCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseExamCommentRequest} message UpdateHorseExamCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateHorseExamCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExamComment != null &&
              Object.hasOwnProperty.call(message, "horseExamComment")
            )
              $root.stronachgroup.first.racehorse360.HorseExamComment.encode(
                message.horseExamComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateHorseExamCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest} UpdateHorseExamCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateHorseExamCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseExamComment =
                    $root.stronachgroup.first.racehorse360.HorseExamComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateHorseExamCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest} UpdateHorseExamCommentRequest
           */
          UpdateHorseExamCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateHorseExamCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest();
            if (object.horseExamComment != null) {
              if (typeof object.horseExamComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest.horseExamComment: object expected"
                );
              message.horseExamComment =
                $root.stronachgroup.first.racehorse360.HorseExamComment.fromObject(
                  object.horseExamComment
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateHorseExamCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest} message UpdateHorseExamCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateHorseExamCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseExamComment = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.horseExamComment != null &&
              message.hasOwnProperty("horseExamComment")
            )
              object.horseExamComment =
                $root.stronachgroup.first.racehorse360.HorseExamComment.toObject(
                  message.horseExamComment,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateHorseExamCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateHorseExamCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateHorseExamCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateHorseExamCommentRequest;
        })();

        racehorse360.DeleteHorseExamCommentRequest = (function () {
          /**
           * Properties of a DeleteHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseExamCommentRequest
           * @property {string|null} [id] DeleteHorseExamCommentRequest id
           */

          /**
           * Constructs a new DeleteHorseExamCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseExamCommentRequest.
           * @implements IDeleteHorseExamCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamCommentRequest=} [properties] Properties to set
           */
          function DeleteHorseExamCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseExamCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @instance
           */
          DeleteHorseExamCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseExamCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest} DeleteHorseExamCommentRequest instance
           */
          DeleteHorseExamCommentRequest.create = function create(properties) {
            return new DeleteHorseExamCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseExamCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamCommentRequest} message DeleteHorseExamCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseExamCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseExamCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest} DeleteHorseExamCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseExamCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseExamCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest} DeleteHorseExamCommentRequest
           */
          DeleteHorseExamCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteHorseExamCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseExamCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest} message DeleteHorseExamCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseExamCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseExamCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseExamCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseExamCommentRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteHorseExamCommentRequest;
        })();

        racehorse360.ListHorseExamCommentsRequest = (function () {
          /**
           * Properties of a ListHorseExamCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamCommentsRequest
           * @property {stronachgroup.first.racehorse360.IHorseExamCommentFilter|null} [query] ListHorseExamCommentsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseExamCommentsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseExamCommentsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseExamCommentsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamCommentsRequest.
           * @implements IListHorseExamCommentsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsRequest=} [properties] Properties to set
           */
          function ListHorseExamCommentsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamCommentsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseExamCommentFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @instance
           */
          ListHorseExamCommentsRequest.prototype.query = null;

          /**
           * ListHorseExamCommentsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @instance
           */
          ListHorseExamCommentsRequest.prototype.getOptions = null;

          /**
           * ListHorseExamCommentsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @instance
           */
          ListHorseExamCommentsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseExamCommentsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} ListHorseExamCommentsRequest instance
           */
          ListHorseExamCommentsRequest.create = function create(properties) {
            return new ListHorseExamCommentsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseExamCommentsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamCommentsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsRequest} message ListHorseExamCommentsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamCommentsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseExamCommentFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamCommentsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} ListHorseExamCommentsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamCommentsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseExamCommentFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamCommentsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} ListHorseExamCommentsRequest
           */
          ListHorseExamCommentsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseExamCommentsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamCommentsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseExamCommentFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamCommentsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamCommentsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamCommentsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamCommentsRequest} message ListHorseExamCommentsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamCommentsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseExamCommentFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamCommentsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamCommentsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseExamCommentsRequest;
        })();

        racehorse360.ListHorseExamCommentsResponse = (function () {
          /**
           * Properties of a ListHorseExamCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamCommentsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamComment>|null} [horseExamComments] ListHorseExamCommentsResponse horseExamComments
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseExamCommentsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseExamCommentsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamCommentsResponse.
           * @implements IListHorseExamCommentsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsResponse=} [properties] Properties to set
           */
          function ListHorseExamCommentsResponse(properties) {
            this.horseExamComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamCommentsResponse horseExamComments.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamComment>} horseExamComments
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @instance
           */
          ListHorseExamCommentsResponse.prototype.horseExamComments =
            $util.emptyArray;

          /**
           * ListHorseExamCommentsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @instance
           */
          ListHorseExamCommentsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseExamCommentsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsResponse} ListHorseExamCommentsResponse instance
           */
          ListHorseExamCommentsResponse.create = function create(properties) {
            return new ListHorseExamCommentsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseExamCommentsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamCommentsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsResponse} message ListHorseExamCommentsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamCommentsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExamComments != null &&
              message.horseExamComments.length
            )
              for (var i = 0; i < message.horseExamComments.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamComment.encode(
                  message.horseExamComments[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamCommentsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsResponse} ListHorseExamCommentsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamCommentsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseExamComments &&
                      message.horseExamComments.length
                    )
                  )
                    message.horseExamComments = [];
                  message.horseExamComments.push(
                    $root.stronachgroup.first.racehorse360.HorseExamComment.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamCommentsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamCommentsResponse} ListHorseExamCommentsResponse
           */
          ListHorseExamCommentsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseExamCommentsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse();
            if (object.horseExamComments) {
              if (!Array.isArray(object.horseExamComments))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamCommentsResponse.horseExamComments: array expected"
                );
              message.horseExamComments = [];
              for (var i = 0; i < object.horseExamComments.length; ++i) {
                if (typeof object.horseExamComments[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseExamCommentsResponse.horseExamComments: object expected"
                  );
                message.horseExamComments[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamComment.fromObject(
                    object.horseExamComments[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamCommentsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamCommentsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamCommentsResponse} message ListHorseExamCommentsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamCommentsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseExamComments = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horseExamComments && message.horseExamComments.length) {
              object.horseExamComments = [];
              for (var j = 0; j < message.horseExamComments.length; ++j)
                object.horseExamComments[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamComment.toObject(
                    message.horseExamComments[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamCommentsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamCommentsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamCommentsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseExamCommentsResponse;
        })();

        racehorse360.Jockey = (function () {
          /**
           * Properties of a Jockey.
           * @memberof stronachgroup.first.racehorse360
           * @interface IJockey
           * @property {string|null} [id] Jockey id
           * @property {number|null} [jockeyNumber] Jockey jockeyNumber
           * @property {string|null} [firstName] Jockey firstName
           * @property {string|null} [lastName] Jockey lastName
           * @property {string|null} [type] Jockey type
           */

          /**
           * Constructs a new Jockey.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Jockey.
           * @implements IJockey
           * @constructor
           * @param {stronachgroup.first.racehorse360.IJockey=} [properties] Properties to set
           */
          function Jockey(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Jockey id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           */
          Jockey.prototype.id = "";

          /**
           * Jockey jockeyNumber.
           * @member {number} jockeyNumber
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           */
          Jockey.prototype.jockeyNumber = 0;

          /**
           * Jockey firstName.
           * @member {string} firstName
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           */
          Jockey.prototype.firstName = "";

          /**
           * Jockey lastName.
           * @member {string} lastName
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           */
          Jockey.prototype.lastName = "";

          /**
           * Jockey type.
           * @member {string} type
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           */
          Jockey.prototype.type = "";

          /**
           * Creates a new Jockey instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @static
           * @param {stronachgroup.first.racehorse360.IJockey=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Jockey} Jockey instance
           */
          Jockey.create = function create(properties) {
            return new Jockey(properties);
          };

          /**
           * Encodes the specified Jockey message. Does not implicitly {@link stronachgroup.first.racehorse360.Jockey.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @static
           * @param {stronachgroup.first.racehorse360.IJockey} message Jockey message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Jockey.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.jockeyNumber != null &&
              Object.hasOwnProperty.call(message, "jockeyNumber")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.jockeyNumber);
            if (
              message.firstName != null &&
              Object.hasOwnProperty.call(message, "firstName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.firstName);
            if (
              message.lastName != null &&
              Object.hasOwnProperty.call(message, "lastName")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.lastName);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.type);
            return writer;
          };

          /**
           * Decodes a Jockey message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Jockey} Jockey
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Jockey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Jockey();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.jockeyNumber = reader.int32();
                  break;
                case 3:
                  message.firstName = reader.string();
                  break;
                case 4:
                  message.lastName = reader.string();
                  break;
                case 5:
                  message.type = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Jockey message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Jockey} Jockey
           */
          Jockey.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Jockey)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Jockey();
            if (object.id != null) message.id = String(object.id);
            if (object.jockeyNumber != null)
              message.jockeyNumber = object.jockeyNumber | 0;
            if (object.firstName != null)
              message.firstName = String(object.firstName);
            if (object.lastName != null)
              message.lastName = String(object.lastName);
            if (object.type != null) message.type = String(object.type);
            return message;
          };

          /**
           * Creates a plain object from a Jockey message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @static
           * @param {stronachgroup.first.racehorse360.Jockey} message Jockey
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Jockey.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.jockeyNumber = 0;
              object.firstName = "";
              object.lastName = "";
              object.type = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.jockeyNumber != null &&
              message.hasOwnProperty("jockeyNumber")
            )
              object.jockeyNumber = message.jockeyNumber;
            if (
              message.firstName != null &&
              message.hasOwnProperty("firstName")
            )
              object.firstName = message.firstName;
            if (message.lastName != null && message.hasOwnProperty("lastName"))
              object.lastName = message.lastName;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type = message.type;
            return object;
          };

          /**
           * Converts this Jockey to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Jockey
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Jockey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Jockey;
        })();

        racehorse360.RaceRestriction = (function () {
          /**
           * Properties of a RaceRestriction.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceRestriction
           * @property {string|null} [id] RaceRestriction id
           * @property {stronachgroup.first.racehorse360.IRace|null} [race] RaceRestriction race
           * @property {string|null} [restrictionType] RaceRestriction restrictionType
           * @property {string|null} [description] RaceRestriction description
           */

          /**
           * Constructs a new RaceRestriction.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceRestriction.
           * @implements IRaceRestriction
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceRestriction=} [properties] Properties to set
           */
          function RaceRestriction(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceRestriction id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @instance
           */
          RaceRestriction.prototype.id = "";

          /**
           * RaceRestriction race.
           * @member {stronachgroup.first.racehorse360.IRace|null|undefined} race
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @instance
           */
          RaceRestriction.prototype.race = null;

          /**
           * RaceRestriction restrictionType.
           * @member {string} restrictionType
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @instance
           */
          RaceRestriction.prototype.restrictionType = "";

          /**
           * RaceRestriction description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @instance
           */
          RaceRestriction.prototype.description = "";

          /**
           * Creates a new RaceRestriction instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceRestriction=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceRestriction} RaceRestriction instance
           */
          RaceRestriction.create = function create(properties) {
            return new RaceRestriction(properties);
          };

          /**
           * Encodes the specified RaceRestriction message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceRestriction.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceRestriction} message RaceRestriction message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceRestriction.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.race != null &&
              Object.hasOwnProperty.call(message, "race")
            )
              $root.stronachgroup.first.racehorse360.Race.encode(
                message.race,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.restrictionType != null &&
              Object.hasOwnProperty.call(message, "restrictionType")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.restrictionType);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a RaceRestriction message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceRestriction} RaceRestriction
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceRestriction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceRestriction();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.race =
                    $root.stronachgroup.first.racehorse360.Race.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.restrictionType = reader.string();
                  break;
                case 4:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceRestriction message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceRestriction} RaceRestriction
           */
          RaceRestriction.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceRestriction
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceRestriction();
            if (object.id != null) message.id = String(object.id);
            if (object.race != null) {
              if (typeof object.race !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceRestriction.race: object expected"
                );
              message.race =
                $root.stronachgroup.first.racehorse360.Race.fromObject(
                  object.race
                );
            }
            if (object.restrictionType != null)
              message.restrictionType = String(object.restrictionType);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a RaceRestriction message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @static
           * @param {stronachgroup.first.racehorse360.RaceRestriction} message RaceRestriction
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceRestriction.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.race = null;
              object.restrictionType = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.race != null && message.hasOwnProperty("race"))
              object.race =
                $root.stronachgroup.first.racehorse360.Race.toObject(
                  message.race,
                  options
                );
            if (
              message.restrictionType != null &&
              message.hasOwnProperty("restrictionType")
            )
              object.restrictionType = message.restrictionType;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this RaceRestriction to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceRestriction
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceRestriction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceRestriction;
        })();

        racehorse360.RaceRestrictionFilter = (function () {
          /**
           * Properties of a RaceRestrictionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceRestrictionFilter
           * @property {Array.<string>|null} [ids] RaceRestrictionFilter ids
           * @property {Array.<string>|null} [raceIds] RaceRestrictionFilter raceIds
           */

          /**
           * Constructs a new RaceRestrictionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceRestrictionFilter.
           * @implements IRaceRestrictionFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceRestrictionFilter=} [properties] Properties to set
           */
          function RaceRestrictionFilter(properties) {
            this.ids = [];
            this.raceIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceRestrictionFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @instance
           */
          RaceRestrictionFilter.prototype.ids = $util.emptyArray;

          /**
           * RaceRestrictionFilter raceIds.
           * @member {Array.<string>} raceIds
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @instance
           */
          RaceRestrictionFilter.prototype.raceIds = $util.emptyArray;

          /**
           * Creates a new RaceRestrictionFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceRestrictionFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceRestrictionFilter} RaceRestrictionFilter instance
           */
          RaceRestrictionFilter.create = function create(properties) {
            return new RaceRestrictionFilter(properties);
          };

          /**
           * Encodes the specified RaceRestrictionFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceRestrictionFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceRestrictionFilter} message RaceRestrictionFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceRestrictionFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.raceIds != null && message.raceIds.length)
              for (var i = 0; i < message.raceIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.raceIds[i]);
            return writer;
          };

          /**
           * Decodes a RaceRestrictionFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceRestrictionFilter} RaceRestrictionFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceRestrictionFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceRestrictionFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.raceIds && message.raceIds.length))
                    message.raceIds = [];
                  message.raceIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceRestrictionFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceRestrictionFilter} RaceRestrictionFilter
           */
          RaceRestrictionFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceRestrictionFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceRestrictionFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceRestrictionFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.raceIds) {
              if (!Array.isArray(object.raceIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceRestrictionFilter.raceIds: array expected"
                );
              message.raceIds = [];
              for (var i = 0; i < object.raceIds.length; ++i)
                message.raceIds[i] = String(object.raceIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a RaceRestrictionFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RaceRestrictionFilter} message RaceRestrictionFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceRestrictionFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.raceIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.raceIds && message.raceIds.length) {
              object.raceIds = [];
              for (var j = 0; j < message.raceIds.length; ++j)
                object.raceIds[j] = message.raceIds[j];
            }
            return object;
          };

          /**
           * Converts this RaceRestrictionFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceRestrictionFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceRestrictionFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceRestrictionFilter;
        })();

        racehorse360.ListRaceRestrictionsRequest = (function () {
          /**
           * Properties of a ListRaceRestrictionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRaceRestrictionsRequest
           * @property {stronachgroup.first.racehorse360.IRaceRestrictionFilter|null} [query] ListRaceRestrictionsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListRaceRestrictionsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListRaceRestrictionsRequest pagingOptions
           */

          /**
           * Constructs a new ListRaceRestrictionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRaceRestrictionsRequest.
           * @implements IListRaceRestrictionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsRequest=} [properties] Properties to set
           */
          function ListRaceRestrictionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRaceRestrictionsRequest query.
           * @member {stronachgroup.first.racehorse360.IRaceRestrictionFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @instance
           */
          ListRaceRestrictionsRequest.prototype.query = null;

          /**
           * ListRaceRestrictionsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @instance
           */
          ListRaceRestrictionsRequest.prototype.getOptions = null;

          /**
           * ListRaceRestrictionsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @instance
           */
          ListRaceRestrictionsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListRaceRestrictionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} ListRaceRestrictionsRequest instance
           */
          ListRaceRestrictionsRequest.create = function create(properties) {
            return new ListRaceRestrictionsRequest(properties);
          };

          /**
           * Encodes the specified ListRaceRestrictionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRaceRestrictionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsRequest} message ListRaceRestrictionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRaceRestrictionsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RaceRestrictionFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRaceRestrictionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} ListRaceRestrictionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRaceRestrictionsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RaceRestrictionFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRaceRestrictionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} ListRaceRestrictionsRequest
           */
          ListRaceRestrictionsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceRestrictionsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RaceRestrictionFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceRestrictionsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceRestrictionsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRaceRestrictionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} message ListRaceRestrictionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRaceRestrictionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RaceRestrictionFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRaceRestrictionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRaceRestrictionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRaceRestrictionsRequest;
        })();

        racehorse360.ListRaceRestrictionsResponse = (function () {
          /**
           * Properties of a ListRaceRestrictionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListRaceRestrictionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRaceRestriction>|null} [raceRestrictions] ListRaceRestrictionsResponse raceRestrictions
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListRaceRestrictionsResponse pagingInfo
           */

          /**
           * Constructs a new ListRaceRestrictionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListRaceRestrictionsResponse.
           * @implements IListRaceRestrictionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsResponse=} [properties] Properties to set
           */
          function ListRaceRestrictionsResponse(properties) {
            this.raceRestrictions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListRaceRestrictionsResponse raceRestrictions.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceRestriction>} raceRestrictions
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @instance
           */
          ListRaceRestrictionsResponse.prototype.raceRestrictions =
            $util.emptyArray;

          /**
           * ListRaceRestrictionsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @instance
           */
          ListRaceRestrictionsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListRaceRestrictionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsResponse} ListRaceRestrictionsResponse instance
           */
          ListRaceRestrictionsResponse.create = function create(properties) {
            return new ListRaceRestrictionsResponse(properties);
          };

          /**
           * Encodes the specified ListRaceRestrictionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListRaceRestrictionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsResponse} message ListRaceRestrictionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListRaceRestrictionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.raceRestrictions != null &&
              message.raceRestrictions.length
            )
              for (var i = 0; i < message.raceRestrictions.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceRestriction.encode(
                  message.raceRestrictions[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListRaceRestrictionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsResponse} ListRaceRestrictionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListRaceRestrictionsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.raceRestrictions &&
                      message.raceRestrictions.length
                    )
                  )
                    message.raceRestrictions = [];
                  message.raceRestrictions.push(
                    $root.stronachgroup.first.racehorse360.RaceRestriction.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListRaceRestrictionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListRaceRestrictionsResponse} ListRaceRestrictionsResponse
           */
          ListRaceRestrictionsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListRaceRestrictionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse();
            if (object.raceRestrictions) {
              if (!Array.isArray(object.raceRestrictions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceRestrictionsResponse.raceRestrictions: array expected"
                );
              message.raceRestrictions = [];
              for (var i = 0; i < object.raceRestrictions.length; ++i) {
                if (typeof object.raceRestrictions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListRaceRestrictionsResponse.raceRestrictions: object expected"
                  );
                message.raceRestrictions[i] =
                  $root.stronachgroup.first.racehorse360.RaceRestriction.fromObject(
                    object.raceRestrictions[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListRaceRestrictionsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListRaceRestrictionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListRaceRestrictionsResponse} message ListRaceRestrictionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListRaceRestrictionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.raceRestrictions = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.raceRestrictions && message.raceRestrictions.length) {
              object.raceRestrictions = [];
              for (var j = 0; j < message.raceRestrictions.length; ++j)
                object.raceRestrictions[j] =
                  $root.stronachgroup.first.racehorse360.RaceRestriction.toObject(
                    message.raceRestrictions[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListRaceRestrictionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListRaceRestrictionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListRaceRestrictionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListRaceRestrictionsResponse;
        })();

        racehorse360.Course = (function () {
          /**
           * Properties of a Course.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICourse
           * @property {string|null} [id] Course id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] Course facility
           * @property {string|null} [name] Course name
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] Course surface
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] Course trackCondition
           * @property {boolean|null} [active] Course active
           * @property {string|null} [comment] Course comment
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [previousTrackCondition] Course previousTrackCondition
           * @property {boolean|null} [isOnlyCommentUpdated] Course isOnlyCommentUpdated
           * @property {string|null} [createdOn] Course createdOn
           * @property {string|null} [updatedOn] Course updatedOn
           */

          /**
           * Constructs a new Course.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Course.
           * @implements ICourse
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICourse=} [properties] Properties to set
           */
          function Course(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Course id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.id = "";

          /**
           * Course facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.facility = null;

          /**
           * Course name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.name = "";

          /**
           * Course surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.surface = 0;

          /**
           * Course trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.trackCondition = 0;

          /**
           * Course active.
           * @member {boolean} active
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.active = false;

          /**
           * Course comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.comment = "";

          /**
           * Course previousTrackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} previousTrackCondition
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.previousTrackCondition = 0;

          /**
           * Course isOnlyCommentUpdated.
           * @member {boolean} isOnlyCommentUpdated
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.isOnlyCommentUpdated = false;

          /**
           * Course createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.createdOn = "";

          /**
           * Course updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           */
          Course.prototype.updatedOn = "";

          /**
           * Creates a new Course instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Course
           * @static
           * @param {stronachgroup.first.racehorse360.ICourse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Course} Course instance
           */
          Course.create = function create(properties) {
            return new Course(properties);
          };

          /**
           * Encodes the specified Course message. Does not implicitly {@link stronachgroup.first.racehorse360.Course.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Course
           * @static
           * @param {stronachgroup.first.racehorse360.ICourse} message Course message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Course.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.surface);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.trackCondition);
            if (
              message.active != null &&
              Object.hasOwnProperty.call(message, "active")
            )
              writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.active);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.comment);
            if (
              message.previousTrackCondition != null &&
              Object.hasOwnProperty.call(message, "previousTrackCondition")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.previousTrackCondition);
            if (
              message.isOnlyCommentUpdated != null &&
              Object.hasOwnProperty.call(message, "isOnlyCommentUpdated")
            )
              writer
                .uint32(/* id 9, wireType 0 =*/ 72)
                .bool(message.isOnlyCommentUpdated);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            return writer;
          };

          /**
           * Decodes a Course message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Course
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Course} Course
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Course.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Course();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.name = reader.string();
                  break;
                case 4:
                  message.surface = reader.int32();
                  break;
                case 5:
                  message.trackCondition = reader.int32();
                  break;
                case 6:
                  message.active = reader.bool();
                  break;
                case 7:
                  message.comment = reader.string();
                  break;
                case 8:
                  message.previousTrackCondition = reader.int32();
                  break;
                case 9:
                  message.isOnlyCommentUpdated = reader.bool();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Course message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Course
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Course} Course
           */
          Course.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Course)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Course();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Course.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.name != null) message.name = String(object.name);
            switch (object.surface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.surface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.surface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.surface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.surface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.surface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.surface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.surface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.surface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.surface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.surface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.surface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.surface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.surface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.surface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.surface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.surface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.surface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.surface = 17;
                break;
            }
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.active != null) message.active = Boolean(object.active);
            if (object.comment != null)
              message.comment = String(object.comment);
            switch (object.previousTrackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.previousTrackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.previousTrackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.previousTrackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.previousTrackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.previousTrackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.previousTrackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.previousTrackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.previousTrackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.previousTrackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.previousTrackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.previousTrackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.previousTrackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.previousTrackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.previousTrackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.previousTrackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.previousTrackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.previousTrackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.previousTrackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.previousTrackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.previousTrackCondition = 19;
                break;
            }
            if (object.isOnlyCommentUpdated != null)
              message.isOnlyCommentUpdated = Boolean(
                object.isOnlyCommentUpdated
              );
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            return message;
          };

          /**
           * Creates a plain object from a Course message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Course
           * @static
           * @param {stronachgroup.first.racehorse360.Course} message Course
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Course.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.name = "";
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.active = false;
              object.comment = "";
              object.previousTrackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.isOnlyCommentUpdated = false;
              object.createdOn = "";
              object.updatedOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (message.active != null && message.hasOwnProperty("active"))
              object.active = message.active;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.previousTrackCondition != null &&
              message.hasOwnProperty("previousTrackCondition")
            )
              object.previousTrackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.previousTrackCondition
                    ]
                  : message.previousTrackCondition;
            if (
              message.isOnlyCommentUpdated != null &&
              message.hasOwnProperty("isOnlyCommentUpdated")
            )
              object.isOnlyCommentUpdated = message.isOnlyCommentUpdated;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            return object;
          };

          /**
           * Converts this Course to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Course
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Course.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Course;
        })();

        racehorse360.CourseFilter = (function () {
          /**
           * Properties of a CourseFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICourseFilter
           * @property {Array.<string>|null} [ids] CourseFilter ids
           * @property {Array.<string>|null} [facilityIds] CourseFilter facilityIds
           * @property {google.protobuf.IBoolValue|null} [isActive] CourseFilter isActive
           * @property {google.protobuf.IBoolValue|null} [isFacilityActive] CourseFilter isFacilityActive
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [updatedOn] CourseFilter updatedOn
           * @property {google.protobuf.IBoolValue|null} [isTrainingOnly] CourseFilter isTrainingOnly
           */

          /**
           * Constructs a new CourseFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CourseFilter.
           * @implements ICourseFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICourseFilter=} [properties] Properties to set
           */
          function CourseFilter(properties) {
            this.ids = [];
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CourseFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.ids = $util.emptyArray;

          /**
           * CourseFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * CourseFilter isActive.
           * @member {google.protobuf.IBoolValue|null|undefined} isActive
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.isActive = null;

          /**
           * CourseFilter isFacilityActive.
           * @member {google.protobuf.IBoolValue|null|undefined} isFacilityActive
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.isFacilityActive = null;

          /**
           * CourseFilter updatedOn.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} updatedOn
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.updatedOn = null;

          /**
           * CourseFilter isTrainingOnly.
           * @member {google.protobuf.IBoolValue|null|undefined} isTrainingOnly
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           */
          CourseFilter.prototype.isTrainingOnly = null;

          /**
           * Creates a new CourseFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ICourseFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CourseFilter} CourseFilter instance
           */
          CourseFilter.create = function create(properties) {
            return new CourseFilter(properties);
          };

          /**
           * Encodes the specified CourseFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.CourseFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ICourseFilter} message CourseFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CourseFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.facilityIds[i]);
            if (
              message.isActive != null &&
              Object.hasOwnProperty.call(message, "isActive")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isActive,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.isFacilityActive != null &&
              Object.hasOwnProperty.call(message, "isFacilityActive")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isFacilityActive,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.updatedOn,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.isTrainingOnly != null &&
              Object.hasOwnProperty.call(message, "isTrainingOnly")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isTrainingOnly,
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CourseFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CourseFilter} CourseFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CourseFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CourseFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 3:
                  message.isActive = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 4:
                  message.isFacilityActive =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.updatedOn =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.isTrainingOnly =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CourseFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CourseFilter} CourseFilter
           */
          CourseFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CourseFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CourseFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.isActive != null) {
              if (typeof object.isActive !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.isActive: object expected"
                );
              message.isActive = $root.google.protobuf.BoolValue.fromObject(
                object.isActive
              );
            }
            if (object.isFacilityActive != null) {
              if (typeof object.isFacilityActive !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.isFacilityActive: object expected"
                );
              message.isFacilityActive =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isFacilityActive
                );
            }
            if (object.updatedOn != null) {
              if (typeof object.updatedOn !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.updatedOn: object expected"
                );
              message.updatedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.updatedOn
                );
            }
            if (object.isTrainingOnly != null) {
              if (typeof object.isTrainingOnly !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CourseFilter.isTrainingOnly: object expected"
                );
              message.isTrainingOnly =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isTrainingOnly
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CourseFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @static
           * @param {stronachgroup.first.racehorse360.CourseFilter} message CourseFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CourseFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.facilityIds = [];
            }
            if (options.defaults) {
              object.isActive = null;
              object.isFacilityActive = null;
              object.updatedOn = null;
              object.isTrainingOnly = null;
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.isActive != null && message.hasOwnProperty("isActive"))
              object.isActive = $root.google.protobuf.BoolValue.toObject(
                message.isActive,
                options
              );
            if (
              message.isFacilityActive != null &&
              message.hasOwnProperty("isFacilityActive")
            )
              object.isFacilityActive =
                $root.google.protobuf.BoolValue.toObject(
                  message.isFacilityActive,
                  options
                );
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.updatedOn,
                  options
                );
            if (
              message.isTrainingOnly != null &&
              message.hasOwnProperty("isTrainingOnly")
            )
              object.isTrainingOnly = $root.google.protobuf.BoolValue.toObject(
                message.isTrainingOnly,
                options
              );
            return object;
          };

          /**
           * Converts this CourseFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CourseFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CourseFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CourseFilter;
        })();

        racehorse360.ListCoursesRequest = (function () {
          /**
           * Properties of a ListCoursesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListCoursesRequest
           * @property {stronachgroup.first.racehorse360.ICourseFilter|null} [query] ListCoursesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListCoursesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListCoursesRequest pagingOptions
           */

          /**
           * Constructs a new ListCoursesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListCoursesRequest.
           * @implements IListCoursesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListCoursesRequest=} [properties] Properties to set
           */
          function ListCoursesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListCoursesRequest query.
           * @member {stronachgroup.first.racehorse360.ICourseFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @instance
           */
          ListCoursesRequest.prototype.query = null;

          /**
           * ListCoursesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @instance
           */
          ListCoursesRequest.prototype.getOptions = null;

          /**
           * ListCoursesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @instance
           */
          ListCoursesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListCoursesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListCoursesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListCoursesRequest} ListCoursesRequest instance
           */
          ListCoursesRequest.create = function create(properties) {
            return new ListCoursesRequest(properties);
          };

          /**
           * Encodes the specified ListCoursesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListCoursesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListCoursesRequest} message ListCoursesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListCoursesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.CourseFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListCoursesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListCoursesRequest} ListCoursesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListCoursesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListCoursesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.CourseFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListCoursesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListCoursesRequest} ListCoursesRequest
           */
          ListCoursesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListCoursesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListCoursesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListCoursesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.CourseFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListCoursesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListCoursesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListCoursesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListCoursesRequest} message ListCoursesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListCoursesRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.CourseFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListCoursesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListCoursesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListCoursesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListCoursesRequest;
        })();

        racehorse360.ListCoursesResponse = (function () {
          /**
           * Properties of a ListCoursesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListCoursesResponse
           * @property {Array.<stronachgroup.first.racehorse360.ICourse>|null} [courses] ListCoursesResponse courses
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListCoursesResponse pagingInfo
           */

          /**
           * Constructs a new ListCoursesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListCoursesResponse.
           * @implements IListCoursesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListCoursesResponse=} [properties] Properties to set
           */
          function ListCoursesResponse(properties) {
            this.courses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListCoursesResponse courses.
           * @member {Array.<stronachgroup.first.racehorse360.ICourse>} courses
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @instance
           */
          ListCoursesResponse.prototype.courses = $util.emptyArray;

          /**
           * ListCoursesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @instance
           */
          ListCoursesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListCoursesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListCoursesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListCoursesResponse} ListCoursesResponse instance
           */
          ListCoursesResponse.create = function create(properties) {
            return new ListCoursesResponse(properties);
          };

          /**
           * Encodes the specified ListCoursesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListCoursesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListCoursesResponse} message ListCoursesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListCoursesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.courses != null && message.courses.length)
              for (var i = 0; i < message.courses.length; ++i)
                $root.stronachgroup.first.racehorse360.Course.encode(
                  message.courses[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListCoursesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListCoursesResponse} ListCoursesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListCoursesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListCoursesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.courses && message.courses.length))
                    message.courses = [];
                  message.courses.push(
                    $root.stronachgroup.first.racehorse360.Course.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListCoursesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListCoursesResponse} ListCoursesResponse
           */
          ListCoursesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListCoursesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListCoursesResponse();
            if (object.courses) {
              if (!Array.isArray(object.courses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListCoursesResponse.courses: array expected"
                );
              message.courses = [];
              for (var i = 0; i < object.courses.length; ++i) {
                if (typeof object.courses[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListCoursesResponse.courses: object expected"
                  );
                message.courses[i] =
                  $root.stronachgroup.first.racehorse360.Course.fromObject(
                    object.courses[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListCoursesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListCoursesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListCoursesResponse} message ListCoursesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListCoursesResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.courses = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.courses && message.courses.length) {
              object.courses = [];
              for (var j = 0; j < message.courses.length; ++j)
                object.courses[j] =
                  $root.stronachgroup.first.racehorse360.Course.toObject(
                    message.courses[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListCoursesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListCoursesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListCoursesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListCoursesResponse;
        })();

        racehorse360.EditCurrentTrackConditionRequest = (function () {
          /**
           * Properties of an EditCurrentTrackConditionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IEditCurrentTrackConditionRequest
           * @property {string|null} [id] EditCurrentTrackConditionRequest id
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] EditCurrentTrackConditionRequest trackCondition
           * @property {string|null} [comment] EditCurrentTrackConditionRequest comment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] EditCurrentTrackConditionRequest getOptions
           */

          /**
           * Constructs a new EditCurrentTrackConditionRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an EditCurrentTrackConditionRequest.
           * @implements IEditCurrentTrackConditionRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IEditCurrentTrackConditionRequest=} [properties] Properties to set
           */
          function EditCurrentTrackConditionRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * EditCurrentTrackConditionRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @instance
           */
          EditCurrentTrackConditionRequest.prototype.id = "";

          /**
           * EditCurrentTrackConditionRequest trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @instance
           */
          EditCurrentTrackConditionRequest.prototype.trackCondition = 0;

          /**
           * EditCurrentTrackConditionRequest comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @instance
           */
          EditCurrentTrackConditionRequest.prototype.comment = "";

          /**
           * EditCurrentTrackConditionRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @instance
           */
          EditCurrentTrackConditionRequest.prototype.getOptions = null;

          /**
           * Creates a new EditCurrentTrackConditionRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditCurrentTrackConditionRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} EditCurrentTrackConditionRequest instance
           */
          EditCurrentTrackConditionRequest.create = function create(
            properties
          ) {
            return new EditCurrentTrackConditionRequest(properties);
          };

          /**
           * Encodes the specified EditCurrentTrackConditionRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IEditCurrentTrackConditionRequest} message EditCurrentTrackConditionRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          EditCurrentTrackConditionRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.trackCondition);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.comment);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an EditCurrentTrackConditionRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} EditCurrentTrackConditionRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          EditCurrentTrackConditionRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.trackCondition = reader.int32();
                  break;
                case 4:
                  message.comment = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an EditCurrentTrackConditionRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} EditCurrentTrackConditionRequest
           */
          EditCurrentTrackConditionRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .EditCurrentTrackConditionRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest();
            if (object.id != null) message.id = String(object.id);
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an EditCurrentTrackConditionRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @static
           * @param {stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest} message EditCurrentTrackConditionRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          EditCurrentTrackConditionRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.comment = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this EditCurrentTrackConditionRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.EditCurrentTrackConditionRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          EditCurrentTrackConditionRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return EditCurrentTrackConditionRequest;
        })();

        racehorse360.Notification = (function () {
          /**
           * Properties of a Notification.
           * @memberof stronachgroup.first.racehorse360
           * @interface INotification
           * @property {string|null} [id] Notification id
           * @property {stronachgroup.first.racehorse360.NotificationType|null} [type] Notification type
           * @property {stronachgroup.first.racehorse360.NotificationCreatorRole|null} [creatorRole] Notification creatorRole
           * @property {stronachgroup.first.racehorse360.EventType|null} [eventType] Notification eventType
           * @property {string|null} [eventDate] Notification eventDate
           * @property {string|null} [body] Notification body
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] Notification horse
           * @property {boolean|null} [isRead] Notification isRead
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] Notification createdBy
           * @property {string|null} [createdOn] Notification createdOn
           * @property {string|null} [updatedOn] Notification updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] Notification updatedBy
           */

          /**
           * Constructs a new Notification.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Notification.
           * @implements INotification
           * @constructor
           * @param {stronachgroup.first.racehorse360.INotification=} [properties] Properties to set
           */
          function Notification(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Notification id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.id = "";

          /**
           * Notification type.
           * @member {stronachgroup.first.racehorse360.NotificationType} type
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.type = 0;

          /**
           * Notification creatorRole.
           * @member {stronachgroup.first.racehorse360.NotificationCreatorRole} creatorRole
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.creatorRole = 0;

          /**
           * Notification eventType.
           * @member {stronachgroup.first.racehorse360.EventType} eventType
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.eventType = 0;

          /**
           * Notification eventDate.
           * @member {string} eventDate
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.eventDate = "";

          /**
           * Notification body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.body = "";

          /**
           * Notification horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.horse = null;

          /**
           * Notification isRead.
           * @member {boolean} isRead
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.isRead = false;

          /**
           * Notification createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.createdBy = null;

          /**
           * Notification createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.createdOn = "";

          /**
           * Notification updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.updatedOn = "";

          /**
           * Notification updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           */
          Notification.prototype.updatedBy = null;

          /**
           * Creates a new Notification instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Notification
           * @static
           * @param {stronachgroup.first.racehorse360.INotification=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Notification} Notification instance
           */
          Notification.create = function create(properties) {
            return new Notification(properties);
          };

          /**
           * Encodes the specified Notification message. Does not implicitly {@link stronachgroup.first.racehorse360.Notification.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Notification
           * @static
           * @param {stronachgroup.first.racehorse360.INotification} message Notification message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Notification.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.type);
            if (
              message.creatorRole != null &&
              Object.hasOwnProperty.call(message, "creatorRole")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.creatorRole);
            if (
              message.eventType != null &&
              Object.hasOwnProperty.call(message, "eventType")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.eventType);
            if (
              message.eventDate != null &&
              Object.hasOwnProperty.call(message, "eventDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.eventDate);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.body);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
            if (
              message.isRead != null &&
              Object.hasOwnProperty.call(message, "isRead")
            )
              writer.uint32(/* id 8, wireType 0 =*/ 64).bool(message.isRead);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1001, wireType 2 =*/ 8010).fork()
              ).ldelim();
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1003, wireType 2 =*/ 8026)
                .string(message.updatedOn);
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a Notification message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Notification
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Notification} Notification
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Notification.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.Notification();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.type = reader.int32();
                  break;
                case 3:
                  message.creatorRole = reader.int32();
                  break;
                case 4:
                  message.eventType = reader.int32();
                  break;
                case 5:
                  message.eventDate = reader.string();
                  break;
                case 6:
                  message.body = reader.string();
                  break;
                case 7:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 8:
                  message.isRead = reader.bool();
                  break;
                case 1001:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1002:
                  message.createdOn = reader.string();
                  break;
                case 1003:
                  message.updatedOn = reader.string();
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Notification message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Notification
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Notification} Notification
           */
          Notification.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.Notification
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.Notification();
            if (object.id != null) message.id = String(object.id);
            switch (object.type) {
              case "NOTIFICATION_TYPE_INVALID":
              case 0:
                message.type = 0;
                break;
              case "NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED":
              case 1:
                message.type = 1;
                break;
              case "NOTIFICATION_TYPE_HORSE_EXAM_PASSED":
              case 3:
                message.type = 3;
                break;
              case "NOTIFICATION_TYPE_HORSE_EXAM_FAILED":
              case 4:
                message.type = 4;
                break;
              case "NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED":
              case 5:
                message.type = 5;
                break;
            }
            switch (object.creatorRole) {
              case "NOTIFICATION_CREATOR_ROLE_INVALID":
              case 0:
                message.creatorRole = 0;
                break;
              case "NOTIFICATION_CREATOR_ROLE_VETERINARIAN":
              case 1:
                message.creatorRole = 1;
                break;
              case "NOTIFICATION_CREATOR_ROLE_RACING_SECRETARY":
              case 2:
                message.creatorRole = 2;
                break;
              case "NOTIFICATION_CREATOR_ROLE_OTHER":
              case 3:
                message.creatorRole = 3;
                break;
            }
            switch (object.eventType) {
              case "EVENT_TYPE_INVALID":
              case 0:
                message.eventType = 0;
                break;
              case "EVENT_TYPE_WORKOUT_REQUEST":
              case 1:
                message.eventType = 1;
                break;
              case "EVENT_TYPE_HORSE_EXAM":
              case 2:
                message.eventType = 2;
                break;
              case "EVENT_TYPE_HORSE_GENERAL_VET_COMMENT":
              case 3:
                message.eventType = 3;
                break;
              case "EVENT_TYPE_HORSE_FLAG_ON_TRACK":
              case 4:
                message.eventType = 4;
                break;
            }
            if (object.eventDate != null)
              message.eventDate = String(object.eventDate);
            if (object.body != null) message.body = String(object.body);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Notification.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.isRead != null) message.isRead = Boolean(object.isRead);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Notification.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.Notification.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a Notification message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Notification
           * @static
           * @param {stronachgroup.first.racehorse360.Notification} message Notification
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Notification.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.type =
                options.enums === String ? "NOTIFICATION_TYPE_INVALID" : 0;
              object.creatorRole =
                options.enums === String
                  ? "NOTIFICATION_CREATOR_ROLE_INVALID"
                  : 0;
              object.eventType =
                options.enums === String ? "EVENT_TYPE_INVALID" : 0;
              object.eventDate = "";
              object.body = "";
              object.horse = null;
              object.isRead = false;
              object.createdBy = null;
              object.createdOn = "";
              object.updatedOn = "";
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.NotificationType[
                      message.type
                    ]
                  : message.type;
            if (
              message.creatorRole != null &&
              message.hasOwnProperty("creatorRole")
            )
              object.creatorRole =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .NotificationCreatorRole[message.creatorRole]
                  : message.creatorRole;
            if (
              message.eventType != null &&
              message.hasOwnProperty("eventType")
            )
              object.eventType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.EventType[
                      message.eventType
                    ]
                  : message.eventType;
            if (
              message.eventDate != null &&
              message.hasOwnProperty("eventDate")
            )
              object.eventDate = message.eventDate;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.isRead != null && message.hasOwnProperty("isRead"))
              object.isRead = message.isRead;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this Notification to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Notification
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Notification.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Notification;
        })();

        racehorse360.NotificationFilter = (function () {
          /**
           * Properties of a NotificationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface INotificationFilter
           * @property {Array.<string>|null} [ids] NotificationFilter ids
           * @property {Array.<string>|null} [horseFacilityIds] NotificationFilter horseFacilityIds
           * @property {Array.<string>|null} [horseIds] NotificationFilter horseIds
           */

          /**
           * Constructs a new NotificationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a NotificationFilter.
           * @implements INotificationFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.INotificationFilter=} [properties] Properties to set
           */
          function NotificationFilter(properties) {
            this.ids = [];
            this.horseFacilityIds = [];
            this.horseIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * NotificationFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @instance
           */
          NotificationFilter.prototype.ids = $util.emptyArray;

          /**
           * NotificationFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @instance
           */
          NotificationFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * NotificationFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @instance
           */
          NotificationFilter.prototype.horseIds = $util.emptyArray;

          /**
           * Creates a new NotificationFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.INotificationFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.NotificationFilter} NotificationFilter instance
           */
          NotificationFilter.create = function create(properties) {
            return new NotificationFilter(properties);
          };

          /**
           * Encodes the specified NotificationFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.NotificationFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.INotificationFilter} message NotificationFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          NotificationFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseFacilityIds[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.horseIds[i]);
            return writer;
          };

          /**
           * Decodes a NotificationFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.NotificationFilter} NotificationFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          NotificationFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.NotificationFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a NotificationFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.NotificationFilter} NotificationFilter
           */
          NotificationFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.NotificationFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.NotificationFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.NotificationFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.NotificationFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.NotificationFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a NotificationFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.NotificationFilter} message NotificationFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          NotificationFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseFacilityIds = [];
              object.horseIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            return object;
          };

          /**
           * Converts this NotificationFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.NotificationFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          NotificationFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return NotificationFilter;
        })();

        racehorse360.PullNotificationsRequest = (function () {
          /**
           * Properties of a PullNotificationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullNotificationsRequest
           * @property {stronachgroup.first.racehorse360.INotificationFilter|null} [query] PullNotificationsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] PullNotificationsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] PullNotificationsRequest pagingOptions
           */

          /**
           * Constructs a new PullNotificationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullNotificationsRequest.
           * @implements IPullNotificationsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullNotificationsRequest=} [properties] Properties to set
           */
          function PullNotificationsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullNotificationsRequest query.
           * @member {stronachgroup.first.racehorse360.INotificationFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @instance
           */
          PullNotificationsRequest.prototype.query = null;

          /**
           * PullNotificationsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @instance
           */
          PullNotificationsRequest.prototype.getOptions = null;

          /**
           * PullNotificationsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @instance
           */
          PullNotificationsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new PullNotificationsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullNotificationsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullNotificationsRequest} PullNotificationsRequest instance
           */
          PullNotificationsRequest.create = function create(properties) {
            return new PullNotificationsRequest(properties);
          };

          /**
           * Encodes the specified PullNotificationsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullNotificationsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullNotificationsRequest} message PullNotificationsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullNotificationsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.NotificationFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullNotificationsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullNotificationsRequest} PullNotificationsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullNotificationsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullNotificationsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.NotificationFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullNotificationsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullNotificationsRequest} PullNotificationsRequest
           */
          PullNotificationsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullNotificationsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullNotificationsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullNotificationsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.NotificationFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullNotificationsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullNotificationsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullNotificationsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullNotificationsRequest} message PullNotificationsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullNotificationsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.NotificationFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullNotificationsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullNotificationsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullNotificationsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullNotificationsRequest;
        })();

        racehorse360.PullNotificationsResponse = (function () {
          /**
           * Properties of a PullNotificationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullNotificationsResponse
           * @property {Array.<stronachgroup.first.racehorse360.INotification>|null} [notifications] PullNotificationsResponse notifications
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] PullNotificationsResponse pagingInfo
           */

          /**
           * Constructs a new PullNotificationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullNotificationsResponse.
           * @implements IPullNotificationsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullNotificationsResponse=} [properties] Properties to set
           */
          function PullNotificationsResponse(properties) {
            this.notifications = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullNotificationsResponse notifications.
           * @member {Array.<stronachgroup.first.racehorse360.INotification>} notifications
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @instance
           */
          PullNotificationsResponse.prototype.notifications = $util.emptyArray;

          /**
           * PullNotificationsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @instance
           */
          PullNotificationsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new PullNotificationsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullNotificationsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullNotificationsResponse} PullNotificationsResponse instance
           */
          PullNotificationsResponse.create = function create(properties) {
            return new PullNotificationsResponse(properties);
          };

          /**
           * Encodes the specified PullNotificationsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullNotificationsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullNotificationsResponse} message PullNotificationsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullNotificationsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.notifications != null && message.notifications.length)
              for (var i = 0; i < message.notifications.length; ++i)
                $root.stronachgroup.first.racehorse360.Notification.encode(
                  message.notifications[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullNotificationsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullNotificationsResponse} PullNotificationsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullNotificationsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullNotificationsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.notifications && message.notifications.length))
                    message.notifications = [];
                  message.notifications.push(
                    $root.stronachgroup.first.racehorse360.Notification.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullNotificationsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullNotificationsResponse} PullNotificationsResponse
           */
          PullNotificationsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullNotificationsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullNotificationsResponse();
            if (object.notifications) {
              if (!Array.isArray(object.notifications))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullNotificationsResponse.notifications: array expected"
                );
              message.notifications = [];
              for (var i = 0; i < object.notifications.length; ++i) {
                if (typeof object.notifications[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullNotificationsResponse.notifications: object expected"
                  );
                message.notifications[i] =
                  $root.stronachgroup.first.racehorse360.Notification.fromObject(
                    object.notifications[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullNotificationsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullNotificationsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullNotificationsResponse} message PullNotificationsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullNotificationsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.notifications = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.notifications && message.notifications.length) {
              object.notifications = [];
              for (var j = 0; j < message.notifications.length; ++j)
                object.notifications[j] =
                  $root.stronachgroup.first.racehorse360.Notification.toObject(
                    message.notifications[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this PullNotificationsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullNotificationsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullNotificationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullNotificationsResponse;
        })();

        racehorse360.MarkNotificationsAsReadRequest = (function () {
          /**
           * Properties of a MarkNotificationsAsReadRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IMarkNotificationsAsReadRequest
           * @property {Array.<string>|null} [ids] MarkNotificationsAsReadRequest ids
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] MarkNotificationsAsReadRequest getOptions
           */

          /**
           * Constructs a new MarkNotificationsAsReadRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a MarkNotificationsAsReadRequest.
           * @implements IMarkNotificationsAsReadRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IMarkNotificationsAsReadRequest=} [properties] Properties to set
           */
          function MarkNotificationsAsReadRequest(properties) {
            this.ids = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * MarkNotificationsAsReadRequest ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @instance
           */
          MarkNotificationsAsReadRequest.prototype.ids = $util.emptyArray;

          /**
           * MarkNotificationsAsReadRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @instance
           */
          MarkNotificationsAsReadRequest.prototype.getOptions = null;

          /**
           * Creates a new MarkNotificationsAsReadRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMarkNotificationsAsReadRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} MarkNotificationsAsReadRequest instance
           */
          MarkNotificationsAsReadRequest.create = function create(properties) {
            return new MarkNotificationsAsReadRequest(properties);
          };

          /**
           * Encodes the specified MarkNotificationsAsReadRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IMarkNotificationsAsReadRequest} message MarkNotificationsAsReadRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          MarkNotificationsAsReadRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a MarkNotificationsAsReadRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} MarkNotificationsAsReadRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          MarkNotificationsAsReadRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a MarkNotificationsAsReadRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} MarkNotificationsAsReadRequest
           */
          MarkNotificationsAsReadRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .MarkNotificationsAsReadRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a MarkNotificationsAsReadRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @static
           * @param {stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} message MarkNotificationsAsReadRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          MarkNotificationsAsReadRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.ids = [];
            if (options.defaults) object.getOptions = null;
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this MarkNotificationsAsReadRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          MarkNotificationsAsReadRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return MarkNotificationsAsReadRequest;
        })();

        racehorse360.RaceCondition = (function () {
          /**
           * Properties of a RaceCondition.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceCondition
           * @property {string|null} [id] RaceCondition id
           * @property {string|null} [code] RaceCondition code
           * @property {string|null} [raceDate] RaceCondition raceDate
           * @property {string|null} [entryCloseDate] RaceCondition entryCloseDate
           * @property {string|null} [scratchDate] RaceCondition scratchDate
           * @property {string|null} [scratchTime] RaceCondition scratchTime
           * @property {string|null} [raceCloseDate] RaceCondition raceCloseDate
           * @property {stronachgroup.first.racehorse360.RaceConditionRestriction|null} [restriction] RaceCondition restriction
           * @property {string|null} [restrictionDescription] RaceCondition restrictionDescription
           * @property {string|null} [raceDescription] RaceCondition raceDescription
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] RaceCondition facility
           * @property {stronachgroup.first.racehorse360.RaceConditionGender|null} [gender] RaceCondition gender
           * @property {stronachgroup.first.racehorse360.RaceConditionAge|null} [age] RaceCondition age
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] RaceCondition surface
           * @property {string|null} [surfaceDescription] RaceCondition surfaceDescription
           * @property {string|null} [day] RaceCondition day
           * @property {string|null} [number] RaceCondition number
           * @property {string|null} [numberText] RaceCondition numberText
           * @property {string|null} [claimingText] RaceCondition claimingText
           * @property {string|null} [claimingStepAllowance] RaceCondition claimingStepAllowance
           * @property {number|null} [distance] RaceCondition distance
           * @property {string|null} [distanceDescription] RaceCondition distanceDescription
           * @property {boolean|null} [isChallenge] RaceCondition isChallenge
           * @property {string|null} [condition] RaceCondition condition
           * @property {string|null} [detailsBold] RaceCondition detailsBold
           * @property {string|null} [details] RaceCondition details
           * @property {string|null} [weight_1Condition] RaceCondition weight_1Condition
           * @property {google.protobuf.IInt32Value|null} [weight_1LbsValue] RaceCondition weight_1LbsValue
           * @property {string|null} [weight_2Condition] RaceCondition weight_2Condition
           * @property {google.protobuf.IInt32Value|null} [weight_2LbsValue] RaceCondition weight_2LbsValue
           * @property {string|null} [weight_3Condition] RaceCondition weight_3Condition
           * @property {google.protobuf.IInt32Value|null} [weight_3LbsValue] RaceCondition weight_3LbsValue
           * @property {google.protobuf.IStringValue|null} [allowance] RaceCondition allowance
           * @property {string|null} [preference] RaceCondition preference
           * @property {string|null} [notConsidered] RaceCondition notConsidered
           * @property {boolean|null} [isStake] RaceCondition isStake
           * @property {string|null} [runningOfRace] RaceCondition runningOfRace
           * @property {string|null} [raceName_1] RaceCondition raceName_1
           * @property {string|null} [raceName_2] RaceCondition raceName_2
           * @property {string|null} [raceName_3] RaceCondition raceName_3
           * @property {string|null} [raceName_4] RaceCondition raceName_4
           * @property {string|null} [purse] RaceCondition purse
           * @property {string|null} [guaranteedIndicator] RaceCondition guaranteedIndicator
           * @property {string|null} [grade] RaceCondition grade
           * @property {google.protobuf.IStringValue|null} [publishedDescriptions] RaceCondition publishedDescriptions
           * @property {Array.<stronachgroup.first.racehorse360.IHorse>|null} [matchedHorses] RaceCondition matchedHorses
           */

          /**
           * Constructs a new RaceCondition.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceCondition.
           * @implements IRaceCondition
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceCondition=} [properties] Properties to set
           */
          function RaceCondition(properties) {
            this.matchedHorses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceCondition id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.id = "";

          /**
           * RaceCondition code.
           * @member {string} code
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.code = "";

          /**
           * RaceCondition raceDate.
           * @member {string} raceDate
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceDate = "";

          /**
           * RaceCondition entryCloseDate.
           * @member {string} entryCloseDate
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.entryCloseDate = "";

          /**
           * RaceCondition scratchDate.
           * @member {string} scratchDate
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.scratchDate = "";

          /**
           * RaceCondition scratchTime.
           * @member {string} scratchTime
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.scratchTime = "";

          /**
           * RaceCondition raceCloseDate.
           * @member {string} raceCloseDate
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceCloseDate = "";

          /**
           * RaceCondition restriction.
           * @member {stronachgroup.first.racehorse360.RaceConditionRestriction} restriction
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.restriction = 0;

          /**
           * RaceCondition restrictionDescription.
           * @member {string} restrictionDescription
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.restrictionDescription = "";

          /**
           * RaceCondition raceDescription.
           * @member {string} raceDescription
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceDescription = "";

          /**
           * RaceCondition facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.facility = null;

          /**
           * RaceCondition gender.
           * @member {stronachgroup.first.racehorse360.RaceConditionGender} gender
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.gender = 0;

          /**
           * RaceCondition age.
           * @member {stronachgroup.first.racehorse360.RaceConditionAge} age
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.age = 0;

          /**
           * RaceCondition surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.surface = 0;

          /**
           * RaceCondition surfaceDescription.
           * @member {string} surfaceDescription
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.surfaceDescription = "";

          /**
           * RaceCondition day.
           * @member {string} day
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.day = "";

          /**
           * RaceCondition number.
           * @member {string} number
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.number = "";

          /**
           * RaceCondition numberText.
           * @member {string} numberText
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.numberText = "";

          /**
           * RaceCondition claimingText.
           * @member {string} claimingText
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.claimingText = "";

          /**
           * RaceCondition claimingStepAllowance.
           * @member {string} claimingStepAllowance
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.claimingStepAllowance = "";

          /**
           * RaceCondition distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.distance = 0;

          /**
           * RaceCondition distanceDescription.
           * @member {string} distanceDescription
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.distanceDescription = "";

          /**
           * RaceCondition isChallenge.
           * @member {boolean} isChallenge
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.isChallenge = false;

          /**
           * RaceCondition condition.
           * @member {string} condition
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.condition = "";

          /**
           * RaceCondition detailsBold.
           * @member {string} detailsBold
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.detailsBold = "";

          /**
           * RaceCondition details.
           * @member {string} details
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.details = "";

          /**
           * RaceCondition weight_1Condition.
           * @member {string} weight_1Condition
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_1Condition = "";

          /**
           * RaceCondition weight_1LbsValue.
           * @member {google.protobuf.IInt32Value|null|undefined} weight_1LbsValue
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_1LbsValue = null;

          /**
           * RaceCondition weight_2Condition.
           * @member {string} weight_2Condition
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_2Condition = "";

          /**
           * RaceCondition weight_2LbsValue.
           * @member {google.protobuf.IInt32Value|null|undefined} weight_2LbsValue
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_2LbsValue = null;

          /**
           * RaceCondition weight_3Condition.
           * @member {string} weight_3Condition
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_3Condition = "";

          /**
           * RaceCondition weight_3LbsValue.
           * @member {google.protobuf.IInt32Value|null|undefined} weight_3LbsValue
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.weight_3LbsValue = null;

          /**
           * RaceCondition allowance.
           * @member {google.protobuf.IStringValue|null|undefined} allowance
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.allowance = null;

          /**
           * RaceCondition preference.
           * @member {string} preference
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.preference = "";

          /**
           * RaceCondition notConsidered.
           * @member {string} notConsidered
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.notConsidered = "";

          /**
           * RaceCondition isStake.
           * @member {boolean} isStake
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.isStake = false;

          /**
           * RaceCondition runningOfRace.
           * @member {string} runningOfRace
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.runningOfRace = "";

          /**
           * RaceCondition raceName_1.
           * @member {string} raceName_1
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceName_1 = "";

          /**
           * RaceCondition raceName_2.
           * @member {string} raceName_2
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceName_2 = "";

          /**
           * RaceCondition raceName_3.
           * @member {string} raceName_3
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceName_3 = "";

          /**
           * RaceCondition raceName_4.
           * @member {string} raceName_4
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.raceName_4 = "";

          /**
           * RaceCondition purse.
           * @member {string} purse
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.purse = "";

          /**
           * RaceCondition guaranteedIndicator.
           * @member {string} guaranteedIndicator
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.guaranteedIndicator = "";

          /**
           * RaceCondition grade.
           * @member {string} grade
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.grade = "";

          /**
           * RaceCondition publishedDescriptions.
           * @member {google.protobuf.IStringValue|null|undefined} publishedDescriptions
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.publishedDescriptions = null;

          /**
           * RaceCondition matchedHorses.
           * @member {Array.<stronachgroup.first.racehorse360.IHorse>} matchedHorses
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           */
          RaceCondition.prototype.matchedHorses = $util.emptyArray;

          /**
           * Creates a new RaceCondition instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceCondition=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceCondition} RaceCondition instance
           */
          RaceCondition.create = function create(properties) {
            return new RaceCondition(properties);
          };

          /**
           * Encodes the specified RaceCondition message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceCondition.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceCondition} message RaceCondition message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceCondition.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.code != null &&
              Object.hasOwnProperty.call(message, "code")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.code);
            if (
              message.raceDate != null &&
              Object.hasOwnProperty.call(message, "raceDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.raceDate);
            if (
              message.entryCloseDate != null &&
              Object.hasOwnProperty.call(message, "entryCloseDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.entryCloseDate);
            if (
              message.scratchDate != null &&
              Object.hasOwnProperty.call(message, "scratchDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.scratchDate);
            if (
              message.scratchTime != null &&
              Object.hasOwnProperty.call(message, "scratchTime")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.scratchTime);
            if (
              message.raceCloseDate != null &&
              Object.hasOwnProperty.call(message, "raceCloseDate")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.raceCloseDate);
            if (
              message.restriction != null &&
              Object.hasOwnProperty.call(message, "restriction")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.restriction);
            if (
              message.restrictionDescription != null &&
              Object.hasOwnProperty.call(message, "restrictionDescription")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.restrictionDescription);
            if (
              message.raceDescription != null &&
              Object.hasOwnProperty.call(message, "raceDescription")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.raceDescription);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.gender != null &&
              Object.hasOwnProperty.call(message, "gender")
            )
              writer.uint32(/* id 12, wireType 0 =*/ 96).int32(message.gender);
            if (
              message.age != null &&
              Object.hasOwnProperty.call(message, "age")
            )
              writer.uint32(/* id 13, wireType 0 =*/ 104).int32(message.age);
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer
                .uint32(/* id 14, wireType 0 =*/ 112)
                .int32(message.surface);
            if (
              message.surfaceDescription != null &&
              Object.hasOwnProperty.call(message, "surfaceDescription")
            )
              writer
                .uint32(/* id 15, wireType 2 =*/ 122)
                .string(message.surfaceDescription);
            if (
              message.day != null &&
              Object.hasOwnProperty.call(message, "day")
            )
              writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.day);
            if (
              message.number != null &&
              Object.hasOwnProperty.call(message, "number")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.number);
            if (
              message.numberText != null &&
              Object.hasOwnProperty.call(message, "numberText")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.numberText);
            if (
              message.claimingText != null &&
              Object.hasOwnProperty.call(message, "claimingText")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.claimingText);
            if (
              message.claimingStepAllowance != null &&
              Object.hasOwnProperty.call(message, "claimingStepAllowance")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.claimingStepAllowance);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer
                .uint32(/* id 21, wireType 0 =*/ 168)
                .int32(message.distance);
            if (
              message.distanceDescription != null &&
              Object.hasOwnProperty.call(message, "distanceDescription")
            )
              writer
                .uint32(/* id 22, wireType 2 =*/ 178)
                .string(message.distanceDescription);
            if (
              message.isChallenge != null &&
              Object.hasOwnProperty.call(message, "isChallenge")
            )
              writer
                .uint32(/* id 23, wireType 0 =*/ 184)
                .bool(message.isChallenge);
            if (
              message.condition != null &&
              Object.hasOwnProperty.call(message, "condition")
            )
              writer
                .uint32(/* id 24, wireType 2 =*/ 194)
                .string(message.condition);
            if (
              message.detailsBold != null &&
              Object.hasOwnProperty.call(message, "detailsBold")
            )
              writer
                .uint32(/* id 25, wireType 2 =*/ 202)
                .string(message.detailsBold);
            if (
              message.details != null &&
              Object.hasOwnProperty.call(message, "details")
            )
              writer
                .uint32(/* id 26, wireType 2 =*/ 210)
                .string(message.details);
            if (
              message.weight_1Condition != null &&
              Object.hasOwnProperty.call(message, "weight_1Condition")
            )
              writer
                .uint32(/* id 27, wireType 2 =*/ 218)
                .string(message.weight_1Condition);
            if (
              message.weight_1LbsValue != null &&
              Object.hasOwnProperty.call(message, "weight_1LbsValue")
            )
              $root.google.protobuf.Int32Value.encode(
                message.weight_1LbsValue,
                writer.uint32(/* id 28, wireType 2 =*/ 226).fork()
              ).ldelim();
            if (
              message.weight_2Condition != null &&
              Object.hasOwnProperty.call(message, "weight_2Condition")
            )
              writer
                .uint32(/* id 29, wireType 2 =*/ 234)
                .string(message.weight_2Condition);
            if (
              message.weight_2LbsValue != null &&
              Object.hasOwnProperty.call(message, "weight_2LbsValue")
            )
              $root.google.protobuf.Int32Value.encode(
                message.weight_2LbsValue,
                writer.uint32(/* id 30, wireType 2 =*/ 242).fork()
              ).ldelim();
            if (
              message.weight_3Condition != null &&
              Object.hasOwnProperty.call(message, "weight_3Condition")
            )
              writer
                .uint32(/* id 31, wireType 2 =*/ 250)
                .string(message.weight_3Condition);
            if (
              message.weight_3LbsValue != null &&
              Object.hasOwnProperty.call(message, "weight_3LbsValue")
            )
              $root.google.protobuf.Int32Value.encode(
                message.weight_3LbsValue,
                writer.uint32(/* id 32, wireType 2 =*/ 258).fork()
              ).ldelim();
            if (
              message.allowance != null &&
              Object.hasOwnProperty.call(message, "allowance")
            )
              $root.google.protobuf.StringValue.encode(
                message.allowance,
                writer.uint32(/* id 33, wireType 2 =*/ 266).fork()
              ).ldelim();
            if (
              message.preference != null &&
              Object.hasOwnProperty.call(message, "preference")
            )
              writer
                .uint32(/* id 34, wireType 2 =*/ 274)
                .string(message.preference);
            if (
              message.notConsidered != null &&
              Object.hasOwnProperty.call(message, "notConsidered")
            )
              writer
                .uint32(/* id 35, wireType 2 =*/ 282)
                .string(message.notConsidered);
            if (
              message.isStake != null &&
              Object.hasOwnProperty.call(message, "isStake")
            )
              writer.uint32(/* id 36, wireType 0 =*/ 288).bool(message.isStake);
            if (
              message.runningOfRace != null &&
              Object.hasOwnProperty.call(message, "runningOfRace")
            )
              writer
                .uint32(/* id 37, wireType 2 =*/ 298)
                .string(message.runningOfRace);
            if (
              message.raceName_1 != null &&
              Object.hasOwnProperty.call(message, "raceName_1")
            )
              writer
                .uint32(/* id 38, wireType 2 =*/ 306)
                .string(message.raceName_1);
            if (
              message.raceName_2 != null &&
              Object.hasOwnProperty.call(message, "raceName_2")
            )
              writer
                .uint32(/* id 39, wireType 2 =*/ 314)
                .string(message.raceName_2);
            if (
              message.raceName_3 != null &&
              Object.hasOwnProperty.call(message, "raceName_3")
            )
              writer
                .uint32(/* id 40, wireType 2 =*/ 322)
                .string(message.raceName_3);
            if (
              message.raceName_4 != null &&
              Object.hasOwnProperty.call(message, "raceName_4")
            )
              writer
                .uint32(/* id 41, wireType 2 =*/ 330)
                .string(message.raceName_4);
            if (
              message.purse != null &&
              Object.hasOwnProperty.call(message, "purse")
            )
              writer.uint32(/* id 42, wireType 2 =*/ 338).string(message.purse);
            if (
              message.guaranteedIndicator != null &&
              Object.hasOwnProperty.call(message, "guaranteedIndicator")
            )
              writer
                .uint32(/* id 43, wireType 2 =*/ 346)
                .string(message.guaranteedIndicator);
            if (
              message.grade != null &&
              Object.hasOwnProperty.call(message, "grade")
            )
              writer.uint32(/* id 44, wireType 2 =*/ 354).string(message.grade);
            if (
              message.publishedDescriptions != null &&
              Object.hasOwnProperty.call(message, "publishedDescriptions")
            )
              $root.google.protobuf.StringValue.encode(
                message.publishedDescriptions,
                writer.uint32(/* id 45, wireType 2 =*/ 362).fork()
              ).ldelim();
            if (message.matchedHorses != null && message.matchedHorses.length)
              for (var i = 0; i < message.matchedHorses.length; ++i)
                $root.stronachgroup.first.racehorse360.Horse.encode(
                  message.matchedHorses[i],
                  writer.uint32(/* id 46, wireType 2 =*/ 370).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a RaceCondition message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceCondition} RaceCondition
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceCondition.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceCondition();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.code = reader.string();
                  break;
                case 3:
                  message.raceDate = reader.string();
                  break;
                case 4:
                  message.entryCloseDate = reader.string();
                  break;
                case 5:
                  message.scratchDate = reader.string();
                  break;
                case 6:
                  message.scratchTime = reader.string();
                  break;
                case 7:
                  message.raceCloseDate = reader.string();
                  break;
                case 8:
                  message.restriction = reader.int32();
                  break;
                case 9:
                  message.restrictionDescription = reader.string();
                  break;
                case 10:
                  message.raceDescription = reader.string();
                  break;
                case 11:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.gender = reader.int32();
                  break;
                case 13:
                  message.age = reader.int32();
                  break;
                case 14:
                  message.surface = reader.int32();
                  break;
                case 15:
                  message.surfaceDescription = reader.string();
                  break;
                case 16:
                  message.day = reader.string();
                  break;
                case 17:
                  message.number = reader.string();
                  break;
                case 18:
                  message.numberText = reader.string();
                  break;
                case 19:
                  message.claimingText = reader.string();
                  break;
                case 20:
                  message.claimingStepAllowance = reader.string();
                  break;
                case 21:
                  message.distance = reader.int32();
                  break;
                case 22:
                  message.distanceDescription = reader.string();
                  break;
                case 23:
                  message.isChallenge = reader.bool();
                  break;
                case 24:
                  message.condition = reader.string();
                  break;
                case 25:
                  message.detailsBold = reader.string();
                  break;
                case 26:
                  message.details = reader.string();
                  break;
                case 27:
                  message.weight_1Condition = reader.string();
                  break;
                case 28:
                  message.weight_1LbsValue =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 29:
                  message.weight_2Condition = reader.string();
                  break;
                case 30:
                  message.weight_2LbsValue =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 31:
                  message.weight_3Condition = reader.string();
                  break;
                case 32:
                  message.weight_3LbsValue =
                    $root.google.protobuf.Int32Value.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 33:
                  message.allowance = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 34:
                  message.preference = reader.string();
                  break;
                case 35:
                  message.notConsidered = reader.string();
                  break;
                case 36:
                  message.isStake = reader.bool();
                  break;
                case 37:
                  message.runningOfRace = reader.string();
                  break;
                case 38:
                  message.raceName_1 = reader.string();
                  break;
                case 39:
                  message.raceName_2 = reader.string();
                  break;
                case 40:
                  message.raceName_3 = reader.string();
                  break;
                case 41:
                  message.raceName_4 = reader.string();
                  break;
                case 42:
                  message.purse = reader.string();
                  break;
                case 43:
                  message.guaranteedIndicator = reader.string();
                  break;
                case 44:
                  message.grade = reader.string();
                  break;
                case 45:
                  message.publishedDescriptions =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 46:
                  if (!(message.matchedHorses && message.matchedHorses.length))
                    message.matchedHorses = [];
                  message.matchedHorses.push(
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceCondition message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceCondition} RaceCondition
           */
          RaceCondition.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceCondition
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceCondition();
            if (object.id != null) message.id = String(object.id);
            if (object.code != null) message.code = String(object.code);
            if (object.raceDate != null)
              message.raceDate = String(object.raceDate);
            if (object.entryCloseDate != null)
              message.entryCloseDate = String(object.entryCloseDate);
            if (object.scratchDate != null)
              message.scratchDate = String(object.scratchDate);
            if (object.scratchTime != null)
              message.scratchTime = String(object.scratchTime);
            if (object.raceCloseDate != null)
              message.raceCloseDate = String(object.raceCloseDate);
            switch (object.restriction) {
              case "RACE_CONDITION_RESTRICTION_INVALID":
              case 0:
                message.restriction = 0;
                break;
              case "RACE_CONDITION_RESTRICTION_NO_RESTRICTION":
              case 1:
                message.restriction = 1;
                break;
              case "RACE_CONDITION_RESTRICTION_STATE_BRED_OR_SIRED":
              case 2:
                message.restriction = 2;
                break;
              case "RACE_CONDITION_RESTRICTION_OTHER":
              case 3:
                message.restriction = 3;
                break;
            }
            if (object.restrictionDescription != null)
              message.restrictionDescription = String(
                object.restrictionDescription
              );
            if (object.raceDescription != null)
              message.raceDescription = String(object.raceDescription);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            switch (object.gender) {
              case "RACE_CONDITION_GENDER_INVALID":
              case 0:
                message.gender = 0;
                break;
              case "RACE_CONDITION_GENDER_FILLIES":
              case 1:
                message.gender = 1;
                break;
              case "RACE_CONDITION_GENDER_FILLIES_AND_MARES":
              case 2:
                message.gender = 2;
                break;
              case "RACE_CONDITION_GENDER_OPEN":
              case 3:
                message.gender = 3;
                break;
              case "RACE_CONDITION_GENDER_COLTS_AND_GELDINGS":
              case 4:
                message.gender = 4;
                break;
            }
            switch (object.age) {
              case "RACE_CONDITION_AGE_INVALID":
              case 0:
                message.age = 0;
                break;
              case "RACE_CONDITION_AGE_TWO":
              case 1:
                message.age = 1;
                break;
              case "RACE_CONDITION_AGE_THREE":
              case 2:
                message.age = 2;
                break;
              case "RACE_CONDITION_AGE_THREE_PLUS":
              case 3:
                message.age = 3;
                break;
              case "RACE_CONDITION_AGE_FOUR_PLUS":
              case 4:
                message.age = 4;
                break;
              case "RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS":
              case 5:
                message.age = 5;
                break;
              case "RACE_CONDITION_AGE_FOUR":
              case 6:
                message.age = 6;
                break;
              case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE":
              case 7:
                message.age = 7;
                break;
              case "RACE_CONDITION_AGE_FOUR_OR_FIVE":
              case 8:
                message.age = 8;
                break;
              case "RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX":
              case 9:
                message.age = 9;
                break;
              case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX":
              case 10:
                message.age = 10;
                break;
            }
            switch (object.surface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.surface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.surface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.surface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.surface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.surface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.surface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.surface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.surface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.surface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.surface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.surface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.surface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.surface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.surface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.surface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.surface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.surface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.surface = 17;
                break;
            }
            if (object.surfaceDescription != null)
              message.surfaceDescription = String(object.surfaceDescription);
            if (object.day != null) message.day = String(object.day);
            if (object.number != null) message.number = String(object.number);
            if (object.numberText != null)
              message.numberText = String(object.numberText);
            if (object.claimingText != null)
              message.claimingText = String(object.claimingText);
            if (object.claimingStepAllowance != null)
              message.claimingStepAllowance = String(
                object.claimingStepAllowance
              );
            if (object.distance != null) message.distance = object.distance | 0;
            if (object.distanceDescription != null)
              message.distanceDescription = String(object.distanceDescription);
            if (object.isChallenge != null)
              message.isChallenge = Boolean(object.isChallenge);
            if (object.condition != null)
              message.condition = String(object.condition);
            if (object.detailsBold != null)
              message.detailsBold = String(object.detailsBold);
            if (object.details != null)
              message.details = String(object.details);
            if (object.weight_1Condition != null)
              message.weight_1Condition = String(object.weight_1Condition);
            if (object.weight_1LbsValue != null) {
              if (typeof object.weight_1LbsValue !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.weight_1LbsValue: object expected"
                );
              message.weight_1LbsValue =
                $root.google.protobuf.Int32Value.fromObject(
                  object.weight_1LbsValue
                );
            }
            if (object.weight_2Condition != null)
              message.weight_2Condition = String(object.weight_2Condition);
            if (object.weight_2LbsValue != null) {
              if (typeof object.weight_2LbsValue !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.weight_2LbsValue: object expected"
                );
              message.weight_2LbsValue =
                $root.google.protobuf.Int32Value.fromObject(
                  object.weight_2LbsValue
                );
            }
            if (object.weight_3Condition != null)
              message.weight_3Condition = String(object.weight_3Condition);
            if (object.weight_3LbsValue != null) {
              if (typeof object.weight_3LbsValue !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.weight_3LbsValue: object expected"
                );
              message.weight_3LbsValue =
                $root.google.protobuf.Int32Value.fromObject(
                  object.weight_3LbsValue
                );
            }
            if (object.allowance != null) {
              if (typeof object.allowance !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.allowance: object expected"
                );
              message.allowance = $root.google.protobuf.StringValue.fromObject(
                object.allowance
              );
            }
            if (object.preference != null)
              message.preference = String(object.preference);
            if (object.notConsidered != null)
              message.notConsidered = String(object.notConsidered);
            if (object.isStake != null)
              message.isStake = Boolean(object.isStake);
            if (object.runningOfRace != null)
              message.runningOfRace = String(object.runningOfRace);
            if (object.raceName_1 != null)
              message.raceName_1 = String(object.raceName_1);
            if (object.raceName_2 != null)
              message.raceName_2 = String(object.raceName_2);
            if (object.raceName_3 != null)
              message.raceName_3 = String(object.raceName_3);
            if (object.raceName_4 != null)
              message.raceName_4 = String(object.raceName_4);
            if (object.purse != null) message.purse = String(object.purse);
            if (object.guaranteedIndicator != null)
              message.guaranteedIndicator = String(object.guaranteedIndicator);
            if (object.grade != null) message.grade = String(object.grade);
            if (object.publishedDescriptions != null) {
              if (typeof object.publishedDescriptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.publishedDescriptions: object expected"
                );
              message.publishedDescriptions =
                $root.google.protobuf.StringValue.fromObject(
                  object.publishedDescriptions
                );
            }
            if (object.matchedHorses) {
              if (!Array.isArray(object.matchedHorses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceCondition.matchedHorses: array expected"
                );
              message.matchedHorses = [];
              for (var i = 0; i < object.matchedHorses.length; ++i) {
                if (typeof object.matchedHorses[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RaceCondition.matchedHorses: object expected"
                  );
                message.matchedHorses[i] =
                  $root.stronachgroup.first.racehorse360.Horse.fromObject(
                    object.matchedHorses[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a RaceCondition message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @static
           * @param {stronachgroup.first.racehorse360.RaceCondition} message RaceCondition
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceCondition.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.matchedHorses = [];
            if (options.defaults) {
              object.id = "";
              object.code = "";
              object.raceDate = "";
              object.entryCloseDate = "";
              object.scratchDate = "";
              object.scratchTime = "";
              object.raceCloseDate = "";
              object.restriction =
                options.enums === String
                  ? "RACE_CONDITION_RESTRICTION_INVALID"
                  : 0;
              object.restrictionDescription = "";
              object.raceDescription = "";
              object.facility = null;
              object.gender =
                options.enums === String ? "RACE_CONDITION_GENDER_INVALID" : 0;
              object.age =
                options.enums === String ? "RACE_CONDITION_AGE_INVALID" : 0;
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.surfaceDescription = "";
              object.day = "";
              object.number = "";
              object.numberText = "";
              object.claimingText = "";
              object.claimingStepAllowance = "";
              object.distance = 0;
              object.distanceDescription = "";
              object.isChallenge = false;
              object.condition = "";
              object.detailsBold = "";
              object.details = "";
              object.weight_1Condition = "";
              object.weight_1LbsValue = null;
              object.weight_2Condition = "";
              object.weight_2LbsValue = null;
              object.weight_3Condition = "";
              object.weight_3LbsValue = null;
              object.allowance = null;
              object.preference = "";
              object.notConsidered = "";
              object.isStake = false;
              object.runningOfRace = "";
              object.raceName_1 = "";
              object.raceName_2 = "";
              object.raceName_3 = "";
              object.raceName_4 = "";
              object.purse = "";
              object.guaranteedIndicator = "";
              object.grade = "";
              object.publishedDescriptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.code != null && message.hasOwnProperty("code"))
              object.code = message.code;
            if (message.raceDate != null && message.hasOwnProperty("raceDate"))
              object.raceDate = message.raceDate;
            if (
              message.entryCloseDate != null &&
              message.hasOwnProperty("entryCloseDate")
            )
              object.entryCloseDate = message.entryCloseDate;
            if (
              message.scratchDate != null &&
              message.hasOwnProperty("scratchDate")
            )
              object.scratchDate = message.scratchDate;
            if (
              message.scratchTime != null &&
              message.hasOwnProperty("scratchTime")
            )
              object.scratchTime = message.scratchTime;
            if (
              message.raceCloseDate != null &&
              message.hasOwnProperty("raceCloseDate")
            )
              object.raceCloseDate = message.raceCloseDate;
            if (
              message.restriction != null &&
              message.hasOwnProperty("restriction")
            )
              object.restriction =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .RaceConditionRestriction[message.restriction]
                  : message.restriction;
            if (
              message.restrictionDescription != null &&
              message.hasOwnProperty("restrictionDescription")
            )
              object.restrictionDescription = message.restrictionDescription;
            if (
              message.raceDescription != null &&
              message.hasOwnProperty("raceDescription")
            )
              object.raceDescription = message.raceDescription;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.gender != null && message.hasOwnProperty("gender"))
              object.gender =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.RaceConditionGender[
                      message.gender
                    ]
                  : message.gender;
            if (message.age != null && message.hasOwnProperty("age"))
              object.age =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.RaceConditionAge[
                      message.age
                    ]
                  : message.age;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (
              message.surfaceDescription != null &&
              message.hasOwnProperty("surfaceDescription")
            )
              object.surfaceDescription = message.surfaceDescription;
            if (message.day != null && message.hasOwnProperty("day"))
              object.day = message.day;
            if (message.number != null && message.hasOwnProperty("number"))
              object.number = message.number;
            if (
              message.numberText != null &&
              message.hasOwnProperty("numberText")
            )
              object.numberText = message.numberText;
            if (
              message.claimingText != null &&
              message.hasOwnProperty("claimingText")
            )
              object.claimingText = message.claimingText;
            if (
              message.claimingStepAllowance != null &&
              message.hasOwnProperty("claimingStepAllowance")
            )
              object.claimingStepAllowance = message.claimingStepAllowance;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.distanceDescription != null &&
              message.hasOwnProperty("distanceDescription")
            )
              object.distanceDescription = message.distanceDescription;
            if (
              message.isChallenge != null &&
              message.hasOwnProperty("isChallenge")
            )
              object.isChallenge = message.isChallenge;
            if (
              message.condition != null &&
              message.hasOwnProperty("condition")
            )
              object.condition = message.condition;
            if (
              message.detailsBold != null &&
              message.hasOwnProperty("detailsBold")
            )
              object.detailsBold = message.detailsBold;
            if (message.details != null && message.hasOwnProperty("details"))
              object.details = message.details;
            if (
              message.weight_1Condition != null &&
              message.hasOwnProperty("weight_1Condition")
            )
              object.weight_1Condition = message.weight_1Condition;
            if (
              message.weight_1LbsValue != null &&
              message.hasOwnProperty("weight_1LbsValue")
            )
              object.weight_1LbsValue =
                $root.google.protobuf.Int32Value.toObject(
                  message.weight_1LbsValue,
                  options
                );
            if (
              message.weight_2Condition != null &&
              message.hasOwnProperty("weight_2Condition")
            )
              object.weight_2Condition = message.weight_2Condition;
            if (
              message.weight_2LbsValue != null &&
              message.hasOwnProperty("weight_2LbsValue")
            )
              object.weight_2LbsValue =
                $root.google.protobuf.Int32Value.toObject(
                  message.weight_2LbsValue,
                  options
                );
            if (
              message.weight_3Condition != null &&
              message.hasOwnProperty("weight_3Condition")
            )
              object.weight_3Condition = message.weight_3Condition;
            if (
              message.weight_3LbsValue != null &&
              message.hasOwnProperty("weight_3LbsValue")
            )
              object.weight_3LbsValue =
                $root.google.protobuf.Int32Value.toObject(
                  message.weight_3LbsValue,
                  options
                );
            if (
              message.allowance != null &&
              message.hasOwnProperty("allowance")
            )
              object.allowance = $root.google.protobuf.StringValue.toObject(
                message.allowance,
                options
              );
            if (
              message.preference != null &&
              message.hasOwnProperty("preference")
            )
              object.preference = message.preference;
            if (
              message.notConsidered != null &&
              message.hasOwnProperty("notConsidered")
            )
              object.notConsidered = message.notConsidered;
            if (message.isStake != null && message.hasOwnProperty("isStake"))
              object.isStake = message.isStake;
            if (
              message.runningOfRace != null &&
              message.hasOwnProperty("runningOfRace")
            )
              object.runningOfRace = message.runningOfRace;
            if (
              message.raceName_1 != null &&
              message.hasOwnProperty("raceName_1")
            )
              object.raceName_1 = message.raceName_1;
            if (
              message.raceName_2 != null &&
              message.hasOwnProperty("raceName_2")
            )
              object.raceName_2 = message.raceName_2;
            if (
              message.raceName_3 != null &&
              message.hasOwnProperty("raceName_3")
            )
              object.raceName_3 = message.raceName_3;
            if (
              message.raceName_4 != null &&
              message.hasOwnProperty("raceName_4")
            )
              object.raceName_4 = message.raceName_4;
            if (message.purse != null && message.hasOwnProperty("purse"))
              object.purse = message.purse;
            if (
              message.guaranteedIndicator != null &&
              message.hasOwnProperty("guaranteedIndicator")
            )
              object.guaranteedIndicator = message.guaranteedIndicator;
            if (message.grade != null && message.hasOwnProperty("grade"))
              object.grade = message.grade;
            if (
              message.publishedDescriptions != null &&
              message.hasOwnProperty("publishedDescriptions")
            )
              object.publishedDescriptions =
                $root.google.protobuf.StringValue.toObject(
                  message.publishedDescriptions,
                  options
                );
            if (message.matchedHorses && message.matchedHorses.length) {
              object.matchedHorses = [];
              for (var j = 0; j < message.matchedHorses.length; ++j)
                object.matchedHorses[j] =
                  $root.stronachgroup.first.racehorse360.Horse.toObject(
                    message.matchedHorses[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this RaceCondition to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceCondition
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceCondition;
        })();

        racehorse360.RaceConditionFilter = (function () {
          /**
           * Properties of a RaceConditionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceConditionFilter
           * @property {string|null} [facilityId] RaceConditionFilter facilityId
           * @property {string|null} [startDateTime] RaceConditionFilter startDateTime
           * @property {string|null} [endDateTime] RaceConditionFilter endDateTime
           * @property {Array.<stronachgroup.first.racehorse360.RaceConditionRestriction>|null} [restrictions] RaceConditionFilter restrictions
           * @property {Array.<stronachgroup.first.racehorse360.RaceConditionDistance>|null} [distances] RaceConditionFilter distances
           * @property {Array.<stronachgroup.first.racehorse360.RaceConditionAge>|null} [ages] RaceConditionFilter ages
           * @property {Array.<stronachgroup.first.racehorse360.RaceConditionGender>|null} [genders] RaceConditionFilter genders
           * @property {Array.<string>|null} [conditions] RaceConditionFilter conditions
           */

          /**
           * Constructs a new RaceConditionFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceConditionFilter.
           * @implements IRaceConditionFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceConditionFilter=} [properties] Properties to set
           */
          function RaceConditionFilter(properties) {
            this.restrictions = [];
            this.distances = [];
            this.ages = [];
            this.genders = [];
            this.conditions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceConditionFilter facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.facilityId = "";

          /**
           * RaceConditionFilter startDateTime.
           * @member {string} startDateTime
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.startDateTime = "";

          /**
           * RaceConditionFilter endDateTime.
           * @member {string} endDateTime
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.endDateTime = "";

          /**
           * RaceConditionFilter restrictions.
           * @member {Array.<stronachgroup.first.racehorse360.RaceConditionRestriction>} restrictions
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.restrictions = $util.emptyArray;

          /**
           * RaceConditionFilter distances.
           * @member {Array.<stronachgroup.first.racehorse360.RaceConditionDistance>} distances
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.distances = $util.emptyArray;

          /**
           * RaceConditionFilter ages.
           * @member {Array.<stronachgroup.first.racehorse360.RaceConditionAge>} ages
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.ages = $util.emptyArray;

          /**
           * RaceConditionFilter genders.
           * @member {Array.<stronachgroup.first.racehorse360.RaceConditionGender>} genders
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.genders = $util.emptyArray;

          /**
           * RaceConditionFilter conditions.
           * @member {Array.<string>} conditions
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           */
          RaceConditionFilter.prototype.conditions = $util.emptyArray;

          /**
           * Creates a new RaceConditionFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceConditionFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceConditionFilter} RaceConditionFilter instance
           */
          RaceConditionFilter.create = function create(properties) {
            return new RaceConditionFilter(properties);
          };

          /**
           * Encodes the specified RaceConditionFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceConditionFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceConditionFilter} message RaceConditionFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceConditionFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.startDateTime != null &&
              Object.hasOwnProperty.call(message, "startDateTime")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.startDateTime);
            if (
              message.endDateTime != null &&
              Object.hasOwnProperty.call(message, "endDateTime")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.endDateTime);
            if (message.restrictions != null && message.restrictions.length) {
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
              for (var i = 0; i < message.restrictions.length; ++i)
                writer.int32(message.restrictions[i]);
              writer.ldelim();
            }
            if (message.distances != null && message.distances.length) {
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork();
              for (var i = 0; i < message.distances.length; ++i)
                writer.int32(message.distances[i]);
              writer.ldelim();
            }
            if (message.ages != null && message.ages.length) {
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork();
              for (var i = 0; i < message.ages.length; ++i)
                writer.int32(message.ages[i]);
              writer.ldelim();
            }
            if (message.genders != null && message.genders.length) {
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork();
              for (var i = 0; i < message.genders.length; ++i)
                writer.int32(message.genders[i]);
              writer.ldelim();
            }
            if (message.conditions != null && message.conditions.length)
              for (var i = 0; i < message.conditions.length; ++i)
                writer
                  .uint32(/* id 8, wireType 2 =*/ 66)
                  .string(message.conditions[i]);
            return writer;
          };

          /**
           * Decodes a RaceConditionFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceConditionFilter} RaceConditionFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceConditionFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceConditionFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.startDateTime = reader.string();
                  break;
                case 3:
                  message.endDateTime = reader.string();
                  break;
                case 4:
                  if (!(message.restrictions && message.restrictions.length))
                    message.restrictions = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.restrictions.push(reader.int32());
                  } else message.restrictions.push(reader.int32());
                  break;
                case 5:
                  if (!(message.distances && message.distances.length))
                    message.distances = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.distances.push(reader.int32());
                  } else message.distances.push(reader.int32());
                  break;
                case 6:
                  if (!(message.ages && message.ages.length)) message.ages = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2) message.ages.push(reader.int32());
                  } else message.ages.push(reader.int32());
                  break;
                case 7:
                  if (!(message.genders && message.genders.length))
                    message.genders = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.genders.push(reader.int32());
                  } else message.genders.push(reader.int32());
                  break;
                case 8:
                  if (!(message.conditions && message.conditions.length))
                    message.conditions = [];
                  message.conditions.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceConditionFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceConditionFilter} RaceConditionFilter
           */
          RaceConditionFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceConditionFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceConditionFilter();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.startDateTime != null)
              message.startDateTime = String(object.startDateTime);
            if (object.endDateTime != null)
              message.endDateTime = String(object.endDateTime);
            if (object.restrictions) {
              if (!Array.isArray(object.restrictions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceConditionFilter.restrictions: array expected"
                );
              message.restrictions = [];
              for (var i = 0; i < object.restrictions.length; ++i)
                switch (object.restrictions[i]) {
                  default:
                  case "RACE_CONDITION_RESTRICTION_INVALID":
                  case 0:
                    message.restrictions[i] = 0;
                    break;
                  case "RACE_CONDITION_RESTRICTION_NO_RESTRICTION":
                  case 1:
                    message.restrictions[i] = 1;
                    break;
                  case "RACE_CONDITION_RESTRICTION_STATE_BRED_OR_SIRED":
                  case 2:
                    message.restrictions[i] = 2;
                    break;
                  case "RACE_CONDITION_RESTRICTION_OTHER":
                  case 3:
                    message.restrictions[i] = 3;
                    break;
                }
            }
            if (object.distances) {
              if (!Array.isArray(object.distances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceConditionFilter.distances: array expected"
                );
              message.distances = [];
              for (var i = 0; i < object.distances.length; ++i)
                switch (object.distances[i]) {
                  default:
                  case "RACE_CONDITION_DISTANCE_INVALID":
                  case 0:
                    message.distances[i] = 0;
                    break;
                  case "RACE_CONDITION_DISTANCE_SHORT":
                  case 1:
                    message.distances[i] = 1;
                    break;
                  case "RACE_CONDITION_DISTANCE_LONG":
                  case 2:
                    message.distances[i] = 2;
                    break;
                }
            }
            if (object.ages) {
              if (!Array.isArray(object.ages))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceConditionFilter.ages: array expected"
                );
              message.ages = [];
              for (var i = 0; i < object.ages.length; ++i)
                switch (object.ages[i]) {
                  default:
                  case "RACE_CONDITION_AGE_INVALID":
                  case 0:
                    message.ages[i] = 0;
                    break;
                  case "RACE_CONDITION_AGE_TWO":
                  case 1:
                    message.ages[i] = 1;
                    break;
                  case "RACE_CONDITION_AGE_THREE":
                  case 2:
                    message.ages[i] = 2;
                    break;
                  case "RACE_CONDITION_AGE_THREE_PLUS":
                  case 3:
                    message.ages[i] = 3;
                    break;
                  case "RACE_CONDITION_AGE_FOUR_PLUS":
                  case 4:
                    message.ages[i] = 4;
                    break;
                  case "RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS":
                  case 5:
                    message.ages[i] = 5;
                    break;
                  case "RACE_CONDITION_AGE_FOUR":
                  case 6:
                    message.ages[i] = 6;
                    break;
                  case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE":
                  case 7:
                    message.ages[i] = 7;
                    break;
                  case "RACE_CONDITION_AGE_FOUR_OR_FIVE":
                  case 8:
                    message.ages[i] = 8;
                    break;
                  case "RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX":
                  case 9:
                    message.ages[i] = 9;
                    break;
                  case "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX":
                  case 10:
                    message.ages[i] = 10;
                    break;
                }
            }
            if (object.genders) {
              if (!Array.isArray(object.genders))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceConditionFilter.genders: array expected"
                );
              message.genders = [];
              for (var i = 0; i < object.genders.length; ++i)
                switch (object.genders[i]) {
                  default:
                  case "RACE_CONDITION_GENDER_INVALID":
                  case 0:
                    message.genders[i] = 0;
                    break;
                  case "RACE_CONDITION_GENDER_FILLIES":
                  case 1:
                    message.genders[i] = 1;
                    break;
                  case "RACE_CONDITION_GENDER_FILLIES_AND_MARES":
                  case 2:
                    message.genders[i] = 2;
                    break;
                  case "RACE_CONDITION_GENDER_OPEN":
                  case 3:
                    message.genders[i] = 3;
                    break;
                  case "RACE_CONDITION_GENDER_COLTS_AND_GELDINGS":
                  case 4:
                    message.genders[i] = 4;
                    break;
                }
            }
            if (object.conditions) {
              if (!Array.isArray(object.conditions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceConditionFilter.conditions: array expected"
                );
              message.conditions = [];
              for (var i = 0; i < object.conditions.length; ++i)
                message.conditions[i] = String(object.conditions[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a RaceConditionFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @static
           * @param {stronachgroup.first.racehorse360.RaceConditionFilter} message RaceConditionFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceConditionFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.restrictions = [];
              object.distances = [];
              object.ages = [];
              object.genders = [];
              object.conditions = [];
            }
            if (options.defaults) {
              object.facilityId = "";
              object.startDateTime = "";
              object.endDateTime = "";
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.startDateTime != null &&
              message.hasOwnProperty("startDateTime")
            )
              object.startDateTime = message.startDateTime;
            if (
              message.endDateTime != null &&
              message.hasOwnProperty("endDateTime")
            )
              object.endDateTime = message.endDateTime;
            if (message.restrictions && message.restrictions.length) {
              object.restrictions = [];
              for (var j = 0; j < message.restrictions.length; ++j)
                object.restrictions[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .RaceConditionRestriction[message.restrictions[j]]
                    : message.restrictions[j];
            }
            if (message.distances && message.distances.length) {
              object.distances = [];
              for (var j = 0; j < message.distances.length; ++j)
                object.distances[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .RaceConditionDistance[message.distances[j]]
                    : message.distances[j];
            }
            if (message.ages && message.ages.length) {
              object.ages = [];
              for (var j = 0; j < message.ages.length; ++j)
                object.ages[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360.RaceConditionAge[
                        message.ages[j]
                      ]
                    : message.ages[j];
            }
            if (message.genders && message.genders.length) {
              object.genders = [];
              for (var j = 0; j < message.genders.length; ++j)
                object.genders[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .RaceConditionGender[message.genders[j]]
                    : message.genders[j];
            }
            if (message.conditions && message.conditions.length) {
              object.conditions = [];
              for (var j = 0; j < message.conditions.length; ++j)
                object.conditions[j] = message.conditions[j];
            }
            return object;
          };

          /**
           * Converts this RaceConditionFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceConditionFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceConditionFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceConditionFilter;
        })();

        racehorse360.PullRaceConditionsRequest = (function () {
          /**
           * Properties of a PullRaceConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsRequest
           * @property {stronachgroup.first.racehorse360.IRaceConditionFilter|null} [query] PullRaceConditionsRequest query
           */

          /**
           * Constructs a new PullRaceConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsRequest.
           * @implements IPullRaceConditionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsRequest=} [properties] Properties to set
           */
          function PullRaceConditionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsRequest query.
           * @member {stronachgroup.first.racehorse360.IRaceConditionFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @instance
           */
          PullRaceConditionsRequest.prototype.query = null;

          /**
           * Creates a new PullRaceConditionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsRequest} PullRaceConditionsRequest instance
           */
          PullRaceConditionsRequest.create = function create(properties) {
            return new PullRaceConditionsRequest(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsRequest} message PullRaceConditionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.RaceConditionFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsRequest} PullRaceConditionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.RaceConditionFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsRequest} PullRaceConditionsRequest
           */
          PullRaceConditionsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullRaceConditionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRaceConditionsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.RaceConditionFilter.fromObject(
                  object.query
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsRequest} message PullRaceConditionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.query = null;
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.RaceConditionFilter.toObject(
                  message.query,
                  options
                );
            return object;
          };

          /**
           * Converts this PullRaceConditionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullRaceConditionsRequest;
        })();

        racehorse360.PullRaceConditionsResponse = (function () {
          /**
           * Properties of a PullRaceConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRaceCondition>|null} [raceConditions] PullRaceConditionsResponse raceConditions
           */

          /**
           * Constructs a new PullRaceConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsResponse.
           * @implements IPullRaceConditionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsResponse=} [properties] Properties to set
           */
          function PullRaceConditionsResponse(properties) {
            this.raceConditions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsResponse raceConditions.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceCondition>} raceConditions
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @instance
           */
          PullRaceConditionsResponse.prototype.raceConditions =
            $util.emptyArray;

          /**
           * Creates a new PullRaceConditionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsResponse} PullRaceConditionsResponse instance
           */
          PullRaceConditionsResponse.create = function create(properties) {
            return new PullRaceConditionsResponse(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsResponse} message PullRaceConditionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.raceConditions != null && message.raceConditions.length)
              for (var i = 0; i < message.raceConditions.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceCondition.encode(
                  message.raceConditions[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsResponse} PullRaceConditionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.raceConditions && message.raceConditions.length)
                  )
                    message.raceConditions = [];
                  message.raceConditions.push(
                    $root.stronachgroup.first.racehorse360.RaceCondition.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsResponse} PullRaceConditionsResponse
           */
          PullRaceConditionsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullRaceConditionsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsResponse();
            if (object.raceConditions) {
              if (!Array.isArray(object.raceConditions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRaceConditionsResponse.raceConditions: array expected"
                );
              message.raceConditions = [];
              for (var i = 0; i < object.raceConditions.length; ++i) {
                if (typeof object.raceConditions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRaceConditionsResponse.raceConditions: object expected"
                  );
                message.raceConditions[i] =
                  $root.stronachgroup.first.racehorse360.RaceCondition.fromObject(
                    object.raceConditions[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsResponse} message PullRaceConditionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.raceConditions = [];
            if (message.raceConditions && message.raceConditions.length) {
              object.raceConditions = [];
              for (var j = 0; j < message.raceConditions.length; ++j)
                object.raceConditions[j] =
                  $root.stronachgroup.first.racehorse360.RaceCondition.toObject(
                    message.raceConditions[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullRaceConditionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullRaceConditionsResponse;
        })();

        racehorse360.PullRaceConditionsForHorseRequest = (function () {
          /**
           * Properties of a PullRaceConditionsForHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsForHorseRequest
           * @property {string|null} [horseId] PullRaceConditionsForHorseRequest horseId
           */

          /**
           * Constructs a new PullRaceConditionsForHorseRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsForHorseRequest.
           * @implements IPullRaceConditionsForHorseRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseRequest=} [properties] Properties to set
           */
          function PullRaceConditionsForHorseRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsForHorseRequest horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @instance
           */
          PullRaceConditionsForHorseRequest.prototype.horseId = "";

          /**
           * Creates a new PullRaceConditionsForHorseRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} PullRaceConditionsForHorseRequest instance
           */
          PullRaceConditionsForHorseRequest.create = function create(
            properties
          ) {
            return new PullRaceConditionsForHorseRequest(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsForHorseRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseRequest} message PullRaceConditionsForHorseRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsForHorseRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.horseId);
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsForHorseRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} PullRaceConditionsForHorseRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsForHorseRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsForHorseRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} PullRaceConditionsForHorseRequest
           */
          PullRaceConditionsForHorseRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullRaceConditionsForHorseRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest();
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsForHorseRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} message PullRaceConditionsForHorseRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsForHorseRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.horseId = "";
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            return object;
          };

          /**
           * Converts this PullRaceConditionsForHorseRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsForHorseRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRaceConditionsForHorseRequest;
        })();

        racehorse360.PullRaceConditionsForHorseResponse = (function () {
          /**
           * Properties of a PullRaceConditionsForHorseResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsForHorseResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRaceCondition>|null} [raceConditions] PullRaceConditionsForHorseResponse raceConditions
           */

          /**
           * Constructs a new PullRaceConditionsForHorseResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsForHorseResponse.
           * @implements IPullRaceConditionsForHorseResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseResponse=} [properties] Properties to set
           */
          function PullRaceConditionsForHorseResponse(properties) {
            this.raceConditions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsForHorseResponse raceConditions.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceCondition>} raceConditions
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @instance
           */
          PullRaceConditionsForHorseResponse.prototype.raceConditions =
            $util.emptyArray;

          /**
           * Creates a new PullRaceConditionsForHorseResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse} PullRaceConditionsForHorseResponse instance
           */
          PullRaceConditionsForHorseResponse.create = function create(
            properties
          ) {
            return new PullRaceConditionsForHorseResponse(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsForHorseResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseResponse} message PullRaceConditionsForHorseResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsForHorseResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.raceConditions != null && message.raceConditions.length)
              for (var i = 0; i < message.raceConditions.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceCondition.encode(
                  message.raceConditions[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsForHorseResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse} PullRaceConditionsForHorseResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsForHorseResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(message.raceConditions && message.raceConditions.length)
                  )
                    message.raceConditions = [];
                  message.raceConditions.push(
                    $root.stronachgroup.first.racehorse360.RaceCondition.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsForHorseResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse} PullRaceConditionsForHorseResponse
           */
          PullRaceConditionsForHorseResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullRaceConditionsForHorseResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse();
            if (object.raceConditions) {
              if (!Array.isArray(object.raceConditions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse.raceConditions: array expected"
                );
              message.raceConditions = [];
              for (var i = 0; i < object.raceConditions.length; ++i) {
                if (typeof object.raceConditions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse.raceConditions: object expected"
                  );
                message.raceConditions[i] =
                  $root.stronachgroup.first.racehorse360.RaceCondition.fromObject(
                    object.raceConditions[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsForHorseResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse} message PullRaceConditionsForHorseResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsForHorseResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.raceConditions = [];
            if (message.raceConditions && message.raceConditions.length) {
              object.raceConditions = [];
              for (var j = 0; j < message.raceConditions.length; ++j)
                object.raceConditions[j] =
                  $root.stronachgroup.first.racehorse360.RaceCondition.toObject(
                    message.raceConditions[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullRaceConditionsForHorseResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsForHorseResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRaceConditionsForHorseResponse;
        })();

        racehorse360.RaceConditionsFacility = (function () {
          /**
           * Properties of a RaceConditionsFacility.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceConditionsFacility
           * @property {string|null} [facilityId] RaceConditionsFacility facilityId
           * @property {string|null} [facilityName] RaceConditionsFacility facilityName
           * @property {string|null} [facilityCode] RaceConditionsFacility facilityCode
           * @property {string|null} [earliestRaceDate] RaceConditionsFacility earliestRaceDate
           * @property {string|null} [latestRaceDate] RaceConditionsFacility latestRaceDate
           */

          /**
           * Constructs a new RaceConditionsFacility.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceConditionsFacility.
           * @implements IRaceConditionsFacility
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceConditionsFacility=} [properties] Properties to set
           */
          function RaceConditionsFacility(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceConditionsFacility facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           */
          RaceConditionsFacility.prototype.facilityId = "";

          /**
           * RaceConditionsFacility facilityName.
           * @member {string} facilityName
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           */
          RaceConditionsFacility.prototype.facilityName = "";

          /**
           * RaceConditionsFacility facilityCode.
           * @member {string} facilityCode
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           */
          RaceConditionsFacility.prototype.facilityCode = "";

          /**
           * RaceConditionsFacility earliestRaceDate.
           * @member {string} earliestRaceDate
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           */
          RaceConditionsFacility.prototype.earliestRaceDate = "";

          /**
           * RaceConditionsFacility latestRaceDate.
           * @member {string} latestRaceDate
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           */
          RaceConditionsFacility.prototype.latestRaceDate = "";

          /**
           * Creates a new RaceConditionsFacility instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceConditionsFacility=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceConditionsFacility} RaceConditionsFacility instance
           */
          RaceConditionsFacility.create = function create(properties) {
            return new RaceConditionsFacility(properties);
          };

          /**
           * Encodes the specified RaceConditionsFacility message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceConditionsFacility.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceConditionsFacility} message RaceConditionsFacility message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceConditionsFacility.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.facilityName != null &&
              Object.hasOwnProperty.call(message, "facilityName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.facilityName);
            if (
              message.facilityCode != null &&
              Object.hasOwnProperty.call(message, "facilityCode")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.facilityCode);
            if (
              message.earliestRaceDate != null &&
              Object.hasOwnProperty.call(message, "earliestRaceDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.earliestRaceDate);
            if (
              message.latestRaceDate != null &&
              Object.hasOwnProperty.call(message, "latestRaceDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.latestRaceDate);
            return writer;
          };

          /**
           * Decodes a RaceConditionsFacility message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceConditionsFacility} RaceConditionsFacility
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceConditionsFacility.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceConditionsFacility();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.facilityName = reader.string();
                  break;
                case 3:
                  message.facilityCode = reader.string();
                  break;
                case 4:
                  message.earliestRaceDate = reader.string();
                  break;
                case 5:
                  message.latestRaceDate = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceConditionsFacility message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceConditionsFacility} RaceConditionsFacility
           */
          RaceConditionsFacility.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceConditionsFacility
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceConditionsFacility();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.facilityName != null)
              message.facilityName = String(object.facilityName);
            if (object.facilityCode != null)
              message.facilityCode = String(object.facilityCode);
            if (object.earliestRaceDate != null)
              message.earliestRaceDate = String(object.earliestRaceDate);
            if (object.latestRaceDate != null)
              message.latestRaceDate = String(object.latestRaceDate);
            return message;
          };

          /**
           * Creates a plain object from a RaceConditionsFacility message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @static
           * @param {stronachgroup.first.racehorse360.RaceConditionsFacility} message RaceConditionsFacility
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceConditionsFacility.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.facilityName = "";
              object.facilityCode = "";
              object.earliestRaceDate = "";
              object.latestRaceDate = "";
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.facilityName != null &&
              message.hasOwnProperty("facilityName")
            )
              object.facilityName = message.facilityName;
            if (
              message.facilityCode != null &&
              message.hasOwnProperty("facilityCode")
            )
              object.facilityCode = message.facilityCode;
            if (
              message.earliestRaceDate != null &&
              message.hasOwnProperty("earliestRaceDate")
            )
              object.earliestRaceDate = message.earliestRaceDate;
            if (
              message.latestRaceDate != null &&
              message.hasOwnProperty("latestRaceDate")
            )
              object.latestRaceDate = message.latestRaceDate;
            return object;
          };

          /**
           * Converts this RaceConditionsFacility to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceConditionsFacility
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceConditionsFacility.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceConditionsFacility;
        })();

        racehorse360.PullRaceConditionsFacilitiesRequest = (function () {
          /**
           * Properties of a PullRaceConditionsFacilitiesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsFacilitiesRequest
           * @property {Array.<string>|null} [facilityIds] PullRaceConditionsFacilitiesRequest facilityIds
           */

          /**
           * Constructs a new PullRaceConditionsFacilitiesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsFacilitiesRequest.
           * @implements IPullRaceConditionsFacilitiesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesRequest=} [properties] Properties to set
           */
          function PullRaceConditionsFacilitiesRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsFacilitiesRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @instance
           */
          PullRaceConditionsFacilitiesRequest.prototype.facilityIds =
            $util.emptyArray;

          /**
           * Creates a new PullRaceConditionsFacilitiesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} PullRaceConditionsFacilitiesRequest instance
           */
          PullRaceConditionsFacilitiesRequest.create = function create(
            properties
          ) {
            return new PullRaceConditionsFacilitiesRequest(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsFacilitiesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesRequest} message PullRaceConditionsFacilitiesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsFacilitiesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.facilityIds[i]);
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsFacilitiesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} PullRaceConditionsFacilitiesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsFacilitiesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsFacilitiesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} PullRaceConditionsFacilitiesRequest
           */
          PullRaceConditionsFacilitiesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullRaceConditionsFacilitiesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest();
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsFacilitiesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} message PullRaceConditionsFacilitiesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsFacilitiesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            return object;
          };

          /**
           * Converts this PullRaceConditionsFacilitiesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsFacilitiesRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRaceConditionsFacilitiesRequest;
        })();

        racehorse360.PullRaceConditionsFacilitiesResponse = (function () {
          /**
           * Properties of a PullRaceConditionsFacilitiesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRaceConditionsFacilitiesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IRaceConditionsFacility>|null} [raceConditionsFacilities] PullRaceConditionsFacilitiesResponse raceConditionsFacilities
           */

          /**
           * Constructs a new PullRaceConditionsFacilitiesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRaceConditionsFacilitiesResponse.
           * @implements IPullRaceConditionsFacilitiesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesResponse=} [properties] Properties to set
           */
          function PullRaceConditionsFacilitiesResponse(properties) {
            this.raceConditionsFacilities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRaceConditionsFacilitiesResponse raceConditionsFacilities.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceConditionsFacility>} raceConditionsFacilities
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @instance
           */
          PullRaceConditionsFacilitiesResponse.prototype.raceConditionsFacilities =
            $util.emptyArray;

          /**
           * Creates a new PullRaceConditionsFacilitiesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse} PullRaceConditionsFacilitiesResponse instance
           */
          PullRaceConditionsFacilitiesResponse.create = function create(
            properties
          ) {
            return new PullRaceConditionsFacilitiesResponse(properties);
          };

          /**
           * Encodes the specified PullRaceConditionsFacilitiesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesResponse} message PullRaceConditionsFacilitiesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRaceConditionsFacilitiesResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.raceConditionsFacilities != null &&
              message.raceConditionsFacilities.length
            )
              for (var i = 0; i < message.raceConditionsFacilities.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceConditionsFacility.encode(
                  message.raceConditionsFacilities[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRaceConditionsFacilitiesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse} PullRaceConditionsFacilitiesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRaceConditionsFacilitiesResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.raceConditionsFacilities &&
                      message.raceConditionsFacilities.length
                    )
                  )
                    message.raceConditionsFacilities = [];
                  message.raceConditionsFacilities.push(
                    $root.stronachgroup.first.racehorse360.RaceConditionsFacility.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRaceConditionsFacilitiesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse} PullRaceConditionsFacilitiesResponse
           */
          PullRaceConditionsFacilitiesResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullRaceConditionsFacilitiesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse();
            if (object.raceConditionsFacilities) {
              if (!Array.isArray(object.raceConditionsFacilities))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse.raceConditionsFacilities: array expected"
                );
              message.raceConditionsFacilities = [];
              for (var i = 0; i < object.raceConditionsFacilities.length; ++i) {
                if (typeof object.raceConditionsFacilities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse.raceConditionsFacilities: object expected"
                  );
                message.raceConditionsFacilities[i] =
                  $root.stronachgroup.first.racehorse360.RaceConditionsFacility.fromObject(
                    object.raceConditionsFacilities[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRaceConditionsFacilitiesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse} message PullRaceConditionsFacilitiesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRaceConditionsFacilitiesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.raceConditionsFacilities = [];
            if (
              message.raceConditionsFacilities &&
              message.raceConditionsFacilities.length
            ) {
              object.raceConditionsFacilities = [];
              for (var j = 0; j < message.raceConditionsFacilities.length; ++j)
                object.raceConditionsFacilities[j] =
                  $root.stronachgroup.first.racehorse360.RaceConditionsFacility.toObject(
                    message.raceConditionsFacilities[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullRaceConditionsFacilitiesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRaceConditionsFacilitiesResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRaceConditionsFacilitiesResponse;
        })();

        racehorse360.HorseInjury = (function () {
          /**
           * Properties of a HorseInjury.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseInjury
           * @property {string|null} [id] HorseInjury id
           * @property {number|null} [incompassInjuryId] HorseInjury incompassInjuryId
           * @property {string|null} [incidentDate] HorseInjury incidentDate
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] HorseInjury facility
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] HorseInjury horse
           * @property {stronachgroup.first.racehorse360.InjuryType|null} [injuryType] HorseInjury injuryType
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [courseSurface] HorseInjury courseSurface
           * @property {stronachgroup.first.racehorse360.TrackCondition|null} [trackCondition] HorseInjury trackCondition
           * @property {string|null} [location] HorseInjury location
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] HorseInjury trainer
           * @property {stronachgroup.first.racehorse360.IJockey|null} [jockey] HorseInjury jockey
           * @property {string|null} [officialVet] HorseInjury officialVet
           * @property {string|null} [attendingVet] HorseInjury attendingVet
           * @property {string|null} [medications] HorseInjury medications
           * @property {string|null} [comments] HorseInjury comments
           */

          /**
           * Constructs a new HorseInjury.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseInjury.
           * @implements IHorseInjury
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseInjury=} [properties] Properties to set
           */
          function HorseInjury(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseInjury id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.id = "";

          /**
           * HorseInjury incompassInjuryId.
           * @member {number} incompassInjuryId
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.incompassInjuryId = 0;

          /**
           * HorseInjury incidentDate.
           * @member {string} incidentDate
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.incidentDate = "";

          /**
           * HorseInjury facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.facility = null;

          /**
           * HorseInjury horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.horse = null;

          /**
           * HorseInjury injuryType.
           * @member {stronachgroup.first.racehorse360.InjuryType} injuryType
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.injuryType = 0;

          /**
           * HorseInjury courseSurface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} courseSurface
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.courseSurface = 0;

          /**
           * HorseInjury trackCondition.
           * @member {stronachgroup.first.racehorse360.TrackCondition} trackCondition
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.trackCondition = 0;

          /**
           * HorseInjury location.
           * @member {string} location
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.location = "";

          /**
           * HorseInjury trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.trainer = null;

          /**
           * HorseInjury jockey.
           * @member {stronachgroup.first.racehorse360.IJockey|null|undefined} jockey
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.jockey = null;

          /**
           * HorseInjury officialVet.
           * @member {string} officialVet
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.officialVet = "";

          /**
           * HorseInjury attendingVet.
           * @member {string} attendingVet
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.attendingVet = "";

          /**
           * HorseInjury medications.
           * @member {string} medications
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.medications = "";

          /**
           * HorseInjury comments.
           * @member {string} comments
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           */
          HorseInjury.prototype.comments = "";

          /**
           * Creates a new HorseInjury instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjury=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseInjury} HorseInjury instance
           */
          HorseInjury.create = function create(properties) {
            return new HorseInjury(properties);
          };

          /**
           * Encodes the specified HorseInjury message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseInjury.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjury} message HorseInjury message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseInjury.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.incompassInjuryId != null &&
              Object.hasOwnProperty.call(message, "incompassInjuryId")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.incompassInjuryId);
            if (
              message.incidentDate != null &&
              Object.hasOwnProperty.call(message, "incidentDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.incidentDate);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
            if (
              message.injuryType != null &&
              Object.hasOwnProperty.call(message, "injuryType")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.injuryType);
            if (
              message.courseSurface != null &&
              Object.hasOwnProperty.call(message, "courseSurface")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.courseSurface);
            if (
              message.trackCondition != null &&
              Object.hasOwnProperty.call(message, "trackCondition")
            )
              writer
                .uint32(/* id 8, wireType 0 =*/ 64)
                .int32(message.trackCondition);
            if (
              message.location != null &&
              Object.hasOwnProperty.call(message, "location")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.location);
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.jockey != null &&
              Object.hasOwnProperty.call(message, "jockey")
            )
              $root.stronachgroup.first.racehorse360.Jockey.encode(
                message.jockey,
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
            if (
              message.officialVet != null &&
              Object.hasOwnProperty.call(message, "officialVet")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.officialVet);
            if (
              message.attendingVet != null &&
              Object.hasOwnProperty.call(message, "attendingVet")
            )
              writer
                .uint32(/* id 13, wireType 2 =*/ 106)
                .string(message.attendingVet);
            if (
              message.medications != null &&
              Object.hasOwnProperty.call(message, "medications")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.medications);
            if (
              message.comments != null &&
              Object.hasOwnProperty.call(message, "comments")
            )
              writer
                .uint32(/* id 15, wireType 2 =*/ 122)
                .string(message.comments);
            return writer;
          };

          /**
           * Decodes a HorseInjury message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseInjury} HorseInjury
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseInjury.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseInjury();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.incompassInjuryId = reader.int32();
                  break;
                case 3:
                  message.incidentDate = reader.string();
                  break;
                case 4:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 6:
                  message.injuryType = reader.int32();
                  break;
                case 7:
                  message.courseSurface = reader.int32();
                  break;
                case 8:
                  message.trackCondition = reader.int32();
                  break;
                case 9:
                  message.location = reader.string();
                  break;
                case 10:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.jockey =
                    $root.stronachgroup.first.racehorse360.Jockey.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 12:
                  message.officialVet = reader.string();
                  break;
                case 13:
                  message.attendingVet = reader.string();
                  break;
                case 14:
                  message.medications = reader.string();
                  break;
                case 15:
                  message.comments = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseInjury message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseInjury} HorseInjury
           */
          HorseInjury.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseInjury
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseInjury();
            if (object.id != null) message.id = String(object.id);
            if (object.incompassInjuryId != null)
              message.incompassInjuryId = object.incompassInjuryId | 0;
            if (object.incidentDate != null)
              message.incidentDate = String(object.incidentDate);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjury.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjury.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            switch (object.injuryType) {
              case "INJURY_TYPE_INVALID":
              case 0:
                message.injuryType = 0;
                break;
              case "INJURY_TYPE_RACING":
              case 1:
                message.injuryType = 1;
                break;
              case "INJURY_TYPE_WORKOUT":
              case 2:
                message.injuryType = 2;
                break;
              case "INJURY_TYPE_OTHER":
              case 3:
                message.injuryType = 3;
                break;
            }
            switch (object.courseSurface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.courseSurface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.courseSurface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.courseSurface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.courseSurface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.courseSurface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.courseSurface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.courseSurface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.courseSurface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.courseSurface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.courseSurface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.courseSurface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.courseSurface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.courseSurface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.courseSurface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.courseSurface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.courseSurface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.courseSurface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.courseSurface = 17;
                break;
            }
            switch (object.trackCondition) {
              case "TRACK_CONDITION_INVALID":
              case 0:
                message.trackCondition = 0;
                break;
              case "TRACK_CONDITION_FAST":
              case 1:
                message.trackCondition = 1;
                break;
              case "TRACK_CONDITION_FIRM":
              case 2:
                message.trackCondition = 2;
                break;
              case "TRACK_CONDITION_FROZEN":
              case 3:
                message.trackCondition = 3;
                break;
              case "TRACK_CONDITION_GOOD":
              case 4:
                message.trackCondition = 4;
                break;
              case "TRACK_CONDITION_HARD":
              case 5:
                message.trackCondition = 5;
                break;
              case "TRACK_CONDITION_HEAVY":
              case 6:
                message.trackCondition = 6;
                break;
              case "TRACK_CONDITION_MUDDY":
              case 7:
                message.trackCondition = 7;
                break;
              case "TRACK_CONDITION_SLOPPY":
              case 8:
                message.trackCondition = 8;
                break;
              case "TRACK_CONDITION_SLOW":
              case 9:
                message.trackCondition = 9;
                break;
              case "TRACK_CONDITION_SOFT":
              case 10:
                message.trackCondition = 10;
                break;
              case "TRACK_CONDITION_WET_FAST":
              case 11:
                message.trackCondition = 11;
                break;
              case "TRACK_CONDITION_YIELDING":
              case 12:
                message.trackCondition = 12;
                break;
              case "TRACK_CONDITION_STANDARD":
              case 13:
                message.trackCondition = 13;
                break;
              case "TRACK_CONDITION_WET":
              case 14:
                message.trackCondition = 14;
                break;
              case "TRACK_CONDITION_DEAD":
              case 15:
                message.trackCondition = 15;
                break;
              case "TRACK_CONDITION_EASY":
              case 16:
                message.trackCondition = 16;
                break;
              case "TRACK_CONDITION_GOOD_TO_FIRM":
              case 17:
                message.trackCondition = 17;
                break;
              case "TRACK_CONDITION_GOOD_TO_SOFT":
              case 18:
                message.trackCondition = 18;
                break;
              case "TRACK_CONDITION_UNKNOWN":
              case 19:
                message.trackCondition = 19;
                break;
            }
            if (object.location != null)
              message.location = String(object.location);
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjury.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.jockey != null) {
              if (typeof object.jockey !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjury.jockey: object expected"
                );
              message.jockey =
                $root.stronachgroup.first.racehorse360.Jockey.fromObject(
                  object.jockey
                );
            }
            if (object.officialVet != null)
              message.officialVet = String(object.officialVet);
            if (object.attendingVet != null)
              message.attendingVet = String(object.attendingVet);
            if (object.medications != null)
              message.medications = String(object.medications);
            if (object.comments != null)
              message.comments = String(object.comments);
            return message;
          };

          /**
           * Creates a plain object from a HorseInjury message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @static
           * @param {stronachgroup.first.racehorse360.HorseInjury} message HorseInjury
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseInjury.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.incompassInjuryId = 0;
              object.incidentDate = "";
              object.facility = null;
              object.horse = null;
              object.injuryType =
                options.enums === String ? "INJURY_TYPE_INVALID" : 0;
              object.courseSurface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
              object.trackCondition =
                options.enums === String ? "TRACK_CONDITION_INVALID" : 0;
              object.location = "";
              object.trainer = null;
              object.jockey = null;
              object.officialVet = "";
              object.attendingVet = "";
              object.medications = "";
              object.comments = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.incompassInjuryId != null &&
              message.hasOwnProperty("incompassInjuryId")
            )
              object.incompassInjuryId = message.incompassInjuryId;
            if (
              message.incidentDate != null &&
              message.hasOwnProperty("incidentDate")
            )
              object.incidentDate = message.incidentDate;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (
              message.injuryType != null &&
              message.hasOwnProperty("injuryType")
            )
              object.injuryType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.InjuryType[
                      message.injuryType
                    ]
                  : message.injuryType;
            if (
              message.courseSurface != null &&
              message.hasOwnProperty("courseSurface")
            )
              object.courseSurface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.courseSurface
                    ]
                  : message.courseSurface;
            if (
              message.trackCondition != null &&
              message.hasOwnProperty("trackCondition")
            )
              object.trackCondition =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackCondition[
                      message.trackCondition
                    ]
                  : message.trackCondition;
            if (message.location != null && message.hasOwnProperty("location"))
              object.location = message.location;
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (message.jockey != null && message.hasOwnProperty("jockey"))
              object.jockey =
                $root.stronachgroup.first.racehorse360.Jockey.toObject(
                  message.jockey,
                  options
                );
            if (
              message.officialVet != null &&
              message.hasOwnProperty("officialVet")
            )
              object.officialVet = message.officialVet;
            if (
              message.attendingVet != null &&
              message.hasOwnProperty("attendingVet")
            )
              object.attendingVet = message.attendingVet;
            if (
              message.medications != null &&
              message.hasOwnProperty("medications")
            )
              object.medications = message.medications;
            if (message.comments != null && message.hasOwnProperty("comments"))
              object.comments = message.comments;
            return object;
          };

          /**
           * Converts this HorseInjury to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseInjury
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseInjury.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseInjury;
        })();

        racehorse360.HorseInjuryFilter = (function () {
          /**
           * Properties of a HorseInjuryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseInjuryFilter
           * @property {Array.<string>|null} [ids] HorseInjuryFilter ids
           * @property {Array.<string>|null} [horseIds] HorseInjuryFilter horseIds
           * @property {Array.<string>|null} [facilityIds] HorseInjuryFilter facilityIds
           */

          /**
           * Constructs a new HorseInjuryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseInjuryFilter.
           * @implements IHorseInjuryFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseInjuryFilter=} [properties] Properties to set
           */
          function HorseInjuryFilter(properties) {
            this.ids = [];
            this.horseIds = [];
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseInjuryFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @instance
           */
          HorseInjuryFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseInjuryFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @instance
           */
          HorseInjuryFilter.prototype.horseIds = $util.emptyArray;

          /**
           * HorseInjuryFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @instance
           */
          HorseInjuryFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * Creates a new HorseInjuryFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseInjuryFilter} HorseInjuryFilter instance
           */
          HorseInjuryFilter.create = function create(properties) {
            return new HorseInjuryFilter(properties);
          };

          /**
           * Encodes the specified HorseInjuryFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseInjuryFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryFilter} message HorseInjuryFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseInjuryFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseIds[i]);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.facilityIds[i]);
            return writer;
          };

          /**
           * Decodes a HorseInjuryFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseInjuryFilter} HorseInjuryFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseInjuryFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseInjuryFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseInjuryFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseInjuryFilter} HorseInjuryFilter
           */
          HorseInjuryFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseInjuryFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseInjuryFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseInjuryFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseInjuryFilter} message HorseInjuryFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseInjuryFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseIds = [];
              object.facilityIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            return object;
          };

          /**
           * Converts this HorseInjuryFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseInjuryFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseInjuryFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseInjuryFilter;
        })();

        racehorse360.ListHorseInjuriesRequest = (function () {
          /**
           * Properties of a ListHorseInjuriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseInjuriesRequest
           * @property {stronachgroup.first.racehorse360.IHorseInjuryFilter|null} [query] ListHorseInjuriesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseInjuriesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseInjuriesRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseInjuriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseInjuriesRequest.
           * @implements IListHorseInjuriesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesRequest=} [properties] Properties to set
           */
          function ListHorseInjuriesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseInjuriesRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseInjuryFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @instance
           */
          ListHorseInjuriesRequest.prototype.query = null;

          /**
           * ListHorseInjuriesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @instance
           */
          ListHorseInjuriesRequest.prototype.getOptions = null;

          /**
           * ListHorseInjuriesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @instance
           */
          ListHorseInjuriesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseInjuriesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesRequest} ListHorseInjuriesRequest instance
           */
          ListHorseInjuriesRequest.create = function create(properties) {
            return new ListHorseInjuriesRequest(properties);
          };

          /**
           * Encodes the specified ListHorseInjuriesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseInjuriesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesRequest} message ListHorseInjuriesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseInjuriesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseInjuryFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseInjuriesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesRequest} ListHorseInjuriesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseInjuriesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseInjuriesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseInjuryFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseInjuriesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesRequest} ListHorseInjuriesRequest
           */
          ListHorseInjuriesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseInjuriesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseInjuriesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuriesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseInjuryFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuriesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuriesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseInjuriesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseInjuriesRequest} message ListHorseInjuriesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseInjuriesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseInjuryFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseInjuriesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseInjuriesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseInjuriesRequest;
        })();

        racehorse360.ListHorseInjuriesResponse = (function () {
          /**
           * Properties of a ListHorseInjuriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseInjuriesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseInjury>|null} [horseInjuries] ListHorseInjuriesResponse horseInjuries
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseInjuriesResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseInjuriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseInjuriesResponse.
           * @implements IListHorseInjuriesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesResponse=} [properties] Properties to set
           */
          function ListHorseInjuriesResponse(properties) {
            this.horseInjuries = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseInjuriesResponse horseInjuries.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseInjury>} horseInjuries
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @instance
           */
          ListHorseInjuriesResponse.prototype.horseInjuries = $util.emptyArray;

          /**
           * ListHorseInjuriesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @instance
           */
          ListHorseInjuriesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseInjuriesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesResponse} ListHorseInjuriesResponse instance
           */
          ListHorseInjuriesResponse.create = function create(properties) {
            return new ListHorseInjuriesResponse(properties);
          };

          /**
           * Encodes the specified ListHorseInjuriesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseInjuriesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesResponse} message ListHorseInjuriesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseInjuriesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.horseInjuries != null && message.horseInjuries.length)
              for (var i = 0; i < message.horseInjuries.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseInjury.encode(
                  message.horseInjuries[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseInjuriesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesResponse} ListHorseInjuriesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseInjuriesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseInjuriesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.horseInjuries && message.horseInjuries.length))
                    message.horseInjuries = [];
                  message.horseInjuries.push(
                    $root.stronachgroup.first.racehorse360.HorseInjury.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseInjuriesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuriesResponse} ListHorseInjuriesResponse
           */
          ListHorseInjuriesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseInjuriesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseInjuriesResponse();
            if (object.horseInjuries) {
              if (!Array.isArray(object.horseInjuries))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuriesResponse.horseInjuries: array expected"
                );
              message.horseInjuries = [];
              for (var i = 0; i < object.horseInjuries.length; ++i) {
                if (typeof object.horseInjuries[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseInjuriesResponse.horseInjuries: object expected"
                  );
                message.horseInjuries[i] =
                  $root.stronachgroup.first.racehorse360.HorseInjury.fromObject(
                    object.horseInjuries[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuriesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseInjuriesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseInjuriesResponse} message ListHorseInjuriesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseInjuriesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horseInjuries = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horseInjuries && message.horseInjuries.length) {
              object.horseInjuries = [];
              for (var j = 0; j < message.horseInjuries.length; ++j)
                object.horseInjuries[j] =
                  $root.stronachgroup.first.racehorse360.HorseInjury.toObject(
                    message.horseInjuries[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseInjuriesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuriesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseInjuriesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseInjuriesResponse;
        })();

        racehorse360.HorseInjuryDetail = (function () {
          /**
           * Properties of a HorseInjuryDetail.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseInjuryDetail
           * @property {string|null} [id] HorseInjuryDetail id
           * @property {stronachgroup.first.racehorse360.IHorseInjury|null} [horseInjury] HorseInjuryDetail horseInjury
           * @property {number|null} [sequence] HorseInjuryDetail sequence
           * @property {string|null} [detail] HorseInjuryDetail detail
           */

          /**
           * Constructs a new HorseInjuryDetail.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseInjuryDetail.
           * @implements IHorseInjuryDetail
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetail=} [properties] Properties to set
           */
          function HorseInjuryDetail(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseInjuryDetail id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @instance
           */
          HorseInjuryDetail.prototype.id = "";

          /**
           * HorseInjuryDetail horseInjury.
           * @member {stronachgroup.first.racehorse360.IHorseInjury|null|undefined} horseInjury
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @instance
           */
          HorseInjuryDetail.prototype.horseInjury = null;

          /**
           * HorseInjuryDetail sequence.
           * @member {number} sequence
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @instance
           */
          HorseInjuryDetail.prototype.sequence = 0;

          /**
           * HorseInjuryDetail detail.
           * @member {string} detail
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @instance
           */
          HorseInjuryDetail.prototype.detail = "";

          /**
           * Creates a new HorseInjuryDetail instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetail=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetail} HorseInjuryDetail instance
           */
          HorseInjuryDetail.create = function create(properties) {
            return new HorseInjuryDetail(properties);
          };

          /**
           * Encodes the specified HorseInjuryDetail message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseInjuryDetail.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetail} message HorseInjuryDetail message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseInjuryDetail.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseInjury != null &&
              Object.hasOwnProperty.call(message, "horseInjury")
            )
              $root.stronachgroup.first.racehorse360.HorseInjury.encode(
                message.horseInjury,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.sequence != null &&
              Object.hasOwnProperty.call(message, "sequence")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.sequence);
            if (
              message.detail != null &&
              Object.hasOwnProperty.call(message, "detail")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.detail);
            return writer;
          };

          /**
           * Decodes a HorseInjuryDetail message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetail} HorseInjuryDetail
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseInjuryDetail.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseInjuryDetail();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseInjury =
                    $root.stronachgroup.first.racehorse360.HorseInjury.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.sequence = reader.int32();
                  break;
                case 4:
                  message.detail = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseInjuryDetail message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetail} HorseInjuryDetail
           */
          HorseInjuryDetail.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseInjuryDetail
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseInjuryDetail();
            if (object.id != null) message.id = String(object.id);
            if (object.horseInjury != null) {
              if (typeof object.horseInjury !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryDetail.horseInjury: object expected"
                );
              message.horseInjury =
                $root.stronachgroup.first.racehorse360.HorseInjury.fromObject(
                  object.horseInjury
                );
            }
            if (object.sequence != null) message.sequence = object.sequence | 0;
            if (object.detail != null) message.detail = String(object.detail);
            return message;
          };

          /**
           * Creates a plain object from a HorseInjuryDetail message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @static
           * @param {stronachgroup.first.racehorse360.HorseInjuryDetail} message HorseInjuryDetail
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseInjuryDetail.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseInjury = null;
              object.sequence = 0;
              object.detail = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.horseInjury != null &&
              message.hasOwnProperty("horseInjury")
            )
              object.horseInjury =
                $root.stronachgroup.first.racehorse360.HorseInjury.toObject(
                  message.horseInjury,
                  options
                );
            if (message.sequence != null && message.hasOwnProperty("sequence"))
              object.sequence = message.sequence;
            if (message.detail != null && message.hasOwnProperty("detail"))
              object.detail = message.detail;
            return object;
          };

          /**
           * Converts this HorseInjuryDetail to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetail
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseInjuryDetail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseInjuryDetail;
        })();

        racehorse360.HorseInjuryDetailFilter = (function () {
          /**
           * Properties of a HorseInjuryDetailFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseInjuryDetailFilter
           * @property {Array.<string>|null} [ids] HorseInjuryDetailFilter ids
           * @property {Array.<string>|null} [horseInjuryIds] HorseInjuryDetailFilter horseInjuryIds
           */

          /**
           * Constructs a new HorseInjuryDetailFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseInjuryDetailFilter.
           * @implements IHorseInjuryDetailFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetailFilter=} [properties] Properties to set
           */
          function HorseInjuryDetailFilter(properties) {
            this.ids = [];
            this.horseInjuryIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseInjuryDetailFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @instance
           */
          HorseInjuryDetailFilter.prototype.ids = $util.emptyArray;

          /**
           * HorseInjuryDetailFilter horseInjuryIds.
           * @member {Array.<string>} horseInjuryIds
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @instance
           */
          HorseInjuryDetailFilter.prototype.horseInjuryIds = $util.emptyArray;

          /**
           * Creates a new HorseInjuryDetailFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetailFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetailFilter} HorseInjuryDetailFilter instance
           */
          HorseInjuryDetailFilter.create = function create(properties) {
            return new HorseInjuryDetailFilter(properties);
          };

          /**
           * Encodes the specified HorseInjuryDetailFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseInjuryDetailFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseInjuryDetailFilter} message HorseInjuryDetailFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseInjuryDetailFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.horseInjuryIds != null && message.horseInjuryIds.length)
              for (var i = 0; i < message.horseInjuryIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseInjuryIds[i]);
            return writer;
          };

          /**
           * Decodes a HorseInjuryDetailFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetailFilter} HorseInjuryDetailFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseInjuryDetailFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(message.horseInjuryIds && message.horseInjuryIds.length)
                  )
                    message.horseInjuryIds = [];
                  message.horseInjuryIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseInjuryDetailFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseInjuryDetailFilter} HorseInjuryDetailFilter
           */
          HorseInjuryDetailFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryDetailFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.horseInjuryIds) {
              if (!Array.isArray(object.horseInjuryIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseInjuryDetailFilter.horseInjuryIds: array expected"
                );
              message.horseInjuryIds = [];
              for (var i = 0; i < object.horseInjuryIds.length; ++i)
                message.horseInjuryIds[i] = String(object.horseInjuryIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseInjuryDetailFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseInjuryDetailFilter} message HorseInjuryDetailFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseInjuryDetailFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.horseInjuryIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.horseInjuryIds && message.horseInjuryIds.length) {
              object.horseInjuryIds = [];
              for (var j = 0; j < message.horseInjuryIds.length; ++j)
                object.horseInjuryIds[j] = message.horseInjuryIds[j];
            }
            return object;
          };

          /**
           * Converts this HorseInjuryDetailFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseInjuryDetailFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseInjuryDetailFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseInjuryDetailFilter;
        })();

        racehorse360.ListHorseInjuryDetailsRequest = (function () {
          /**
           * Properties of a ListHorseInjuryDetailsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseInjuryDetailsRequest
           * @property {stronachgroup.first.racehorse360.IHorseInjuryDetailFilter|null} [query] ListHorseInjuryDetailsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseInjuryDetailsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseInjuryDetailsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseInjuryDetailsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseInjuryDetailsRequest.
           * @implements IListHorseInjuryDetailsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsRequest=} [properties] Properties to set
           */
          function ListHorseInjuryDetailsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseInjuryDetailsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseInjuryDetailFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @instance
           */
          ListHorseInjuryDetailsRequest.prototype.query = null;

          /**
           * ListHorseInjuryDetailsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @instance
           */
          ListHorseInjuryDetailsRequest.prototype.getOptions = null;

          /**
           * ListHorseInjuryDetailsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @instance
           */
          ListHorseInjuryDetailsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseInjuryDetailsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} ListHorseInjuryDetailsRequest instance
           */
          ListHorseInjuryDetailsRequest.create = function create(properties) {
            return new ListHorseInjuryDetailsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseInjuryDetailsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsRequest} message ListHorseInjuryDetailsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseInjuryDetailsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseInjuryDetailsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} ListHorseInjuryDetailsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseInjuryDetailsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseInjuryDetailsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} ListHorseInjuryDetailsRequest
           */
          ListHorseInjuryDetailsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseInjuryDetailsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseInjuryDetailsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest} message ListHorseInjuryDetailsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseInjuryDetailsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseInjuryDetailFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseInjuryDetailsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseInjuryDetailsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseInjuryDetailsRequest;
        })();

        racehorse360.ListHorseInjuryDetailsResponse = (function () {
          /**
           * Properties of a ListHorseInjuryDetailsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseInjuryDetailsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseInjuryDetail>|null} [horseInjuryDetails] ListHorseInjuryDetailsResponse horseInjuryDetails
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseInjuryDetailsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseInjuryDetailsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseInjuryDetailsResponse.
           * @implements IListHorseInjuryDetailsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsResponse=} [properties] Properties to set
           */
          function ListHorseInjuryDetailsResponse(properties) {
            this.horseInjuryDetails = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseInjuryDetailsResponse horseInjuryDetails.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseInjuryDetail>} horseInjuryDetails
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @instance
           */
          ListHorseInjuryDetailsResponse.prototype.horseInjuryDetails =
            $util.emptyArray;

          /**
           * ListHorseInjuryDetailsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @instance
           */
          ListHorseInjuryDetailsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseInjuryDetailsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse} ListHorseInjuryDetailsResponse instance
           */
          ListHorseInjuryDetailsResponse.create = function create(properties) {
            return new ListHorseInjuryDetailsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseInjuryDetailsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsResponse} message ListHorseInjuryDetailsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseInjuryDetailsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseInjuryDetails != null &&
              message.horseInjuryDetails.length
            )
              for (var i = 0; i < message.horseInjuryDetails.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseInjuryDetail.encode(
                  message.horseInjuryDetails[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseInjuryDetailsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse} ListHorseInjuryDetailsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseInjuryDetailsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseInjuryDetails &&
                      message.horseInjuryDetails.length
                    )
                  )
                    message.horseInjuryDetails = [];
                  message.horseInjuryDetails.push(
                    $root.stronachgroup.first.racehorse360.HorseInjuryDetail.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseInjuryDetailsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse} ListHorseInjuryDetailsResponse
           */
          ListHorseInjuryDetailsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseInjuryDetailsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse();
            if (object.horseInjuryDetails) {
              if (!Array.isArray(object.horseInjuryDetails))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse.horseInjuryDetails: array expected"
                );
              message.horseInjuryDetails = [];
              for (var i = 0; i < object.horseInjuryDetails.length; ++i) {
                if (typeof object.horseInjuryDetails[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse.horseInjuryDetails: object expected"
                  );
                message.horseInjuryDetails[i] =
                  $root.stronachgroup.first.racehorse360.HorseInjuryDetail.fromObject(
                    object.horseInjuryDetails[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseInjuryDetailsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse} message ListHorseInjuryDetailsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseInjuryDetailsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseInjuryDetails = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.horseInjuryDetails &&
              message.horseInjuryDetails.length
            ) {
              object.horseInjuryDetails = [];
              for (var j = 0; j < message.horseInjuryDetails.length; ++j)
                object.horseInjuryDetails[j] =
                  $root.stronachgroup.first.racehorse360.HorseInjuryDetail.toObject(
                    message.horseInjuryDetails[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseInjuryDetailsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseInjuryDetailsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseInjuryDetailsResponse;
        })();

        racehorse360.HorseOnList = (function () {
          /**
           * Properties of a HorseOnList.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseOnList
           * @property {string|null} [id] HorseOnList id
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] HorseOnList horse
           * @property {string|null} [listType] HorseOnList listType
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] HorseOnList facility
           * @property {string|null} [dateOn] HorseOnList dateOn
           * @property {string|null} [dateOff] HorseOnList dateOff
           * @property {string|null} [reason] HorseOnList reason
           * @property {string|null} [comment] HorseOnList comment
           */

          /**
           * Constructs a new HorseOnList.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseOnList.
           * @implements IHorseOnList
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseOnList=} [properties] Properties to set
           */
          function HorseOnList(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseOnList id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.id = "";

          /**
           * HorseOnList horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.horse = null;

          /**
           * HorseOnList listType.
           * @member {string} listType
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.listType = "";

          /**
           * HorseOnList facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.facility = null;

          /**
           * HorseOnList dateOn.
           * @member {string} dateOn
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.dateOn = "";

          /**
           * HorseOnList dateOff.
           * @member {string} dateOff
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.dateOff = "";

          /**
           * HorseOnList reason.
           * @member {string} reason
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.reason = "";

          /**
           * HorseOnList comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           */
          HorseOnList.prototype.comment = "";

          /**
           * Creates a new HorseOnList instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOnList=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseOnList} HorseOnList instance
           */
          HorseOnList.create = function create(properties) {
            return new HorseOnList(properties);
          };

          /**
           * Encodes the specified HorseOnList message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseOnList.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOnList} message HorseOnList message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseOnList.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.listType != null &&
              Object.hasOwnProperty.call(message, "listType")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.listType);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.dateOn != null &&
              Object.hasOwnProperty.call(message, "dateOn")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.dateOn);
            if (
              message.dateOff != null &&
              Object.hasOwnProperty.call(message, "dateOff")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.dateOff);
            if (
              message.reason != null &&
              Object.hasOwnProperty.call(message, "reason")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.reason);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.comment);
            return writer;
          };

          /**
           * Decodes a HorseOnList message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseOnList} HorseOnList
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseOnList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseOnList();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.listType = reader.string();
                  break;
                case 4:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.dateOn = reader.string();
                  break;
                case 6:
                  message.dateOff = reader.string();
                  break;
                case 7:
                  message.reason = reader.string();
                  break;
                case 8:
                  message.comment = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseOnList message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseOnList} HorseOnList
           */
          HorseOnList.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseOnList
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseOnList();
            if (object.id != null) message.id = String(object.id);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnList.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.listType != null)
              message.listType = String(object.listType);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnList.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.dateOn != null) message.dateOn = String(object.dateOn);
            if (object.dateOff != null)
              message.dateOff = String(object.dateOff);
            if (object.reason != null) message.reason = String(object.reason);
            if (object.comment != null)
              message.comment = String(object.comment);
            return message;
          };

          /**
           * Creates a plain object from a HorseOnList message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @static
           * @param {stronachgroup.first.racehorse360.HorseOnList} message HorseOnList
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseOnList.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horse = null;
              object.listType = "";
              object.facility = null;
              object.dateOn = "";
              object.dateOff = "";
              object.reason = "";
              object.comment = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.listType != null && message.hasOwnProperty("listType"))
              object.listType = message.listType;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.dateOn != null && message.hasOwnProperty("dateOn"))
              object.dateOn = message.dateOn;
            if (message.dateOff != null && message.hasOwnProperty("dateOff"))
              object.dateOff = message.dateOff;
            if (message.reason != null && message.hasOwnProperty("reason"))
              object.reason = message.reason;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            return object;
          };

          /**
           * Converts this HorseOnList to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseOnList
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseOnList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseOnList;
        })();

        racehorse360.HorseOnListFilter = (function () {
          /**
           * Properties of a HorseOnListFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseOnListFilter
           * @property {google.protobuf.IStringValue|null} [horseId] HorseOnListFilter horseId
           * @property {google.protobuf.IStringValue|null} [trainerId] HorseOnListFilter trainerId
           * @property {Array.<string>|null} [horseFacilityIds] HorseOnListFilter horseFacilityIds
           * @property {google.protobuf.IBoolValue|null} [activeOnly] HorseOnListFilter activeOnly
           * @property {Array.<string>|null} [horseIds] HorseOnListFilter horseIds
           */

          /**
           * Constructs a new HorseOnListFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseOnListFilter.
           * @implements IHorseOnListFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseOnListFilter=} [properties] Properties to set
           */
          function HorseOnListFilter(properties) {
            this.horseFacilityIds = [];
            this.horseIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseOnListFilter horseId.
           * @member {google.protobuf.IStringValue|null|undefined} horseId
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           */
          HorseOnListFilter.prototype.horseId = null;

          /**
           * HorseOnListFilter trainerId.
           * @member {google.protobuf.IStringValue|null|undefined} trainerId
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           */
          HorseOnListFilter.prototype.trainerId = null;

          /**
           * HorseOnListFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           */
          HorseOnListFilter.prototype.horseFacilityIds = $util.emptyArray;

          /**
           * HorseOnListFilter activeOnly.
           * @member {google.protobuf.IBoolValue|null|undefined} activeOnly
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           */
          HorseOnListFilter.prototype.activeOnly = null;

          /**
           * HorseOnListFilter horseIds.
           * @member {Array.<string>} horseIds
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           */
          HorseOnListFilter.prototype.horseIds = $util.emptyArray;

          /**
           * Creates a new HorseOnListFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOnListFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseOnListFilter} HorseOnListFilter instance
           */
          HorseOnListFilter.create = function create(properties) {
            return new HorseOnListFilter(properties);
          };

          /**
           * Encodes the specified HorseOnListFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseOnListFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseOnListFilter} message HorseOnListFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseOnListFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              $root.google.protobuf.StringValue.encode(
                message.horseId,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              $root.google.protobuf.StringValue.encode(
                message.trainerId,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.horseFacilityIds[i]);
            if (
              message.activeOnly != null &&
              Object.hasOwnProperty.call(message, "activeOnly")
            )
              $root.google.protobuf.BoolValue.encode(
                message.activeOnly,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (message.horseIds != null && message.horseIds.length)
              for (var i = 0; i < message.horseIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.horseIds[i]);
            return writer;
          };

          /**
           * Decodes a HorseOnListFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseOnListFilter} HorseOnListFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseOnListFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseOnListFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseId = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 2:
                  message.trainerId = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 3:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                case 4:
                  message.activeOnly = $root.google.protobuf.BoolValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 5:
                  if (!(message.horseIds && message.horseIds.length))
                    message.horseIds = [];
                  message.horseIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseOnListFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseOnListFilter} HorseOnListFilter
           */
          HorseOnListFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseOnListFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseOnListFilter();
            if (object.horseId != null) {
              if (typeof object.horseId !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnListFilter.horseId: object expected"
                );
              message.horseId = $root.google.protobuf.StringValue.fromObject(
                object.horseId
              );
            }
            if (object.trainerId != null) {
              if (typeof object.trainerId !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnListFilter.trainerId: object expected"
                );
              message.trainerId = $root.google.protobuf.StringValue.fromObject(
                object.trainerId
              );
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnListFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            if (object.activeOnly != null) {
              if (typeof object.activeOnly !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnListFilter.activeOnly: object expected"
                );
              message.activeOnly = $root.google.protobuf.BoolValue.fromObject(
                object.activeOnly
              );
            }
            if (object.horseIds) {
              if (!Array.isArray(object.horseIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseOnListFilter.horseIds: array expected"
                );
              message.horseIds = [];
              for (var i = 0; i < object.horseIds.length; ++i)
                message.horseIds[i] = String(object.horseIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseOnListFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseOnListFilter} message HorseOnListFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseOnListFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.horseFacilityIds = [];
              object.horseIds = [];
            }
            if (options.defaults) {
              object.horseId = null;
              object.trainerId = null;
              object.activeOnly = null;
            }
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = $root.google.protobuf.StringValue.toObject(
                message.horseId,
                options
              );
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = $root.google.protobuf.StringValue.toObject(
                message.trainerId,
                options
              );
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            if (
              message.activeOnly != null &&
              message.hasOwnProperty("activeOnly")
            )
              object.activeOnly = $root.google.protobuf.BoolValue.toObject(
                message.activeOnly,
                options
              );
            if (message.horseIds && message.horseIds.length) {
              object.horseIds = [];
              for (var j = 0; j < message.horseIds.length; ++j)
                object.horseIds[j] = message.horseIds[j];
            }
            return object;
          };

          /**
           * Converts this HorseOnListFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseOnListFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseOnListFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseOnListFilter;
        })();

        racehorse360.ListHorseOnListsRequest = (function () {
          /**
           * Properties of a ListHorseOnListsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseOnListsRequest
           * @property {stronachgroup.first.racehorse360.IHorseOnListFilter|null} [query] ListHorseOnListsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseOnListsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseOnListsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseOnListsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseOnListsRequest.
           * @implements IListHorseOnListsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsRequest=} [properties] Properties to set
           */
          function ListHorseOnListsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseOnListsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseOnListFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @instance
           */
          ListHorseOnListsRequest.prototype.query = null;

          /**
           * ListHorseOnListsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @instance
           */
          ListHorseOnListsRequest.prototype.getOptions = null;

          /**
           * ListHorseOnListsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @instance
           */
          ListHorseOnListsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseOnListsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsRequest} ListHorseOnListsRequest instance
           */
          ListHorseOnListsRequest.create = function create(properties) {
            return new ListHorseOnListsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseOnListsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseOnListsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsRequest} message ListHorseOnListsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseOnListsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseOnListFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseOnListsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsRequest} ListHorseOnListsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseOnListsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseOnListsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseOnListFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseOnListsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsRequest} ListHorseOnListsRequest
           */
          ListHorseOnListsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseOnListsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseOnListsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseOnListsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseOnListFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseOnListsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseOnListsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseOnListsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseOnListsRequest} message ListHorseOnListsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseOnListsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseOnListFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseOnListsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseOnListsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseOnListsRequest;
        })();

        racehorse360.ListHorseOnListsResponse = (function () {
          /**
           * Properties of a ListHorseOnListsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseOnListsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseOnList>|null} [horseOnLists] ListHorseOnListsResponse horseOnLists
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseOnListsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseOnListsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseOnListsResponse.
           * @implements IListHorseOnListsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsResponse=} [properties] Properties to set
           */
          function ListHorseOnListsResponse(properties) {
            this.horseOnLists = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseOnListsResponse horseOnLists.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseOnList>} horseOnLists
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @instance
           */
          ListHorseOnListsResponse.prototype.horseOnLists = $util.emptyArray;

          /**
           * ListHorseOnListsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @instance
           */
          ListHorseOnListsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseOnListsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsResponse} ListHorseOnListsResponse instance
           */
          ListHorseOnListsResponse.create = function create(properties) {
            return new ListHorseOnListsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseOnListsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseOnListsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsResponse} message ListHorseOnListsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseOnListsResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.horseOnLists != null && message.horseOnLists.length)
              for (var i = 0; i < message.horseOnLists.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseOnList.encode(
                  message.horseOnLists[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseOnListsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsResponse} ListHorseOnListsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseOnListsResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseOnListsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.horseOnLists && message.horseOnLists.length))
                    message.horseOnLists = [];
                  message.horseOnLists.push(
                    $root.stronachgroup.first.racehorse360.HorseOnList.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseOnListsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseOnListsResponse} ListHorseOnListsResponse
           */
          ListHorseOnListsResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListHorseOnListsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseOnListsResponse();
            if (object.horseOnLists) {
              if (!Array.isArray(object.horseOnLists))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseOnListsResponse.horseOnLists: array expected"
                );
              message.horseOnLists = [];
              for (var i = 0; i < object.horseOnLists.length; ++i) {
                if (typeof object.horseOnLists[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseOnListsResponse.horseOnLists: object expected"
                  );
                message.horseOnLists[i] =
                  $root.stronachgroup.first.racehorse360.HorseOnList.fromObject(
                    object.horseOnLists[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseOnListsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseOnListsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseOnListsResponse} message ListHorseOnListsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseOnListsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.horseOnLists = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.horseOnLists && message.horseOnLists.length) {
              object.horseOnLists = [];
              for (var j = 0; j < message.horseOnLists.length; ++j)
                object.horseOnLists[j] =
                  $root.stronachgroup.first.racehorse360.HorseOnList.toObject(
                    message.horseOnLists[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseOnListsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseOnListsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseOnListsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListHorseOnListsResponse;
        })();

        racehorse360.PullHorsesFromListsCountRequest = (function () {
          /**
           * Properties of a PullHorsesFromListsCountRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesFromListsCountRequest
           * @property {string|null} [trainerId] PullHorsesFromListsCountRequest trainerId
           * @property {Array.<string>|null} [horseFacilityIds] PullHorsesFromListsCountRequest horseFacilityIds
           */

          /**
           * Constructs a new PullHorsesFromListsCountRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesFromListsCountRequest.
           * @implements IPullHorsesFromListsCountRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountRequest=} [properties] Properties to set
           */
          function PullHorsesFromListsCountRequest(properties) {
            this.horseFacilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesFromListsCountRequest trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @instance
           */
          PullHorsesFromListsCountRequest.prototype.trainerId = "";

          /**
           * PullHorsesFromListsCountRequest horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @instance
           */
          PullHorsesFromListsCountRequest.prototype.horseFacilityIds =
            $util.emptyArray;

          /**
           * Creates a new PullHorsesFromListsCountRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} PullHorsesFromListsCountRequest instance
           */
          PullHorsesFromListsCountRequest.create = function create(properties) {
            return new PullHorsesFromListsCountRequest(properties);
          };

          /**
           * Encodes the specified PullHorsesFromListsCountRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountRequest} message PullHorsesFromListsCountRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesFromListsCountRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.trainerId);
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseFacilityIds[i]);
            return writer;
          };

          /**
           * Decodes a PullHorsesFromListsCountRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} PullHorsesFromListsCountRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesFromListsCountRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.trainerId = reader.string();
                  break;
                case 2:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesFromListsCountRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} PullHorsesFromListsCountRequest
           */
          PullHorsesFromListsCountRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorsesFromListsCountRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest();
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesFromListsCountRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest} message PullHorsesFromListsCountRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesFromListsCountRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseFacilityIds = [];
            if (options.defaults) object.trainerId = "";
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            return object;
          };

          /**
           * Converts this PullHorsesFromListsCountRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesFromListsCountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullHorsesFromListsCountRequest;
        })();

        racehorse360.PullHorsesFromListsCountResponse = (function () {
          /**
           * Properties of a PullHorsesFromListsCountResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullHorsesFromListsCountResponse
           * @property {number|null} [count] PullHorsesFromListsCountResponse count
           */

          /**
           * Constructs a new PullHorsesFromListsCountResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullHorsesFromListsCountResponse.
           * @implements IPullHorsesFromListsCountResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountResponse=} [properties] Properties to set
           */
          function PullHorsesFromListsCountResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullHorsesFromListsCountResponse count.
           * @member {number} count
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @instance
           */
          PullHorsesFromListsCountResponse.prototype.count = 0;

          /**
           * Creates a new PullHorsesFromListsCountResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse} PullHorsesFromListsCountResponse instance
           */
          PullHorsesFromListsCountResponse.create = function create(
            properties
          ) {
            return new PullHorsesFromListsCountResponse(properties);
          };

          /**
           * Encodes the specified PullHorsesFromListsCountResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountResponse} message PullHorsesFromListsCountResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullHorsesFromListsCountResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.count != null &&
              Object.hasOwnProperty.call(message, "count")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.count);
            return writer;
          };

          /**
           * Decodes a PullHorsesFromListsCountResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse} PullHorsesFromListsCountResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullHorsesFromListsCountResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.count = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullHorsesFromListsCountResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse} PullHorsesFromListsCountResponse
           */
          PullHorsesFromListsCountResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullHorsesFromListsCountResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse();
            if (object.count != null) message.count = object.count | 0;
            return message;
          };

          /**
           * Creates a plain object from a PullHorsesFromListsCountResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse} message PullHorsesFromListsCountResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullHorsesFromListsCountResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.count = 0;
            if (message.count != null && message.hasOwnProperty("count"))
              object.count = message.count;
            return object;
          };

          /**
           * Converts this PullHorsesFromListsCountResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullHorsesFromListsCountResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullHorsesFromListsCountResponse;
        })();

        racehorse360.FacilityBlackout = (function () {
          /**
           * Properties of a FacilityBlackout.
           * @memberof stronachgroup.first.racehorse360
           * @interface IFacilityBlackout
           * @property {string|null} [id] FacilityBlackout id
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] FacilityBlackout facility
           * @property {string|null} [dateFrom] FacilityBlackout dateFrom
           * @property {string|null} [dateTo] FacilityBlackout dateTo
           * @property {stronachgroup.first.racehorse360.FacilityBlackoutRepeatance|null} [repeatance] FacilityBlackout repeatance
           * @property {string|null} [dateRepeatTo] FacilityBlackout dateRepeatTo
           * @property {Array.<stronachgroup.first.racehorse360.IFacilityBlackoutExcludedDate>|null} [facilityBlackoutExcludedDates] FacilityBlackout facilityBlackoutExcludedDates
           */

          /**
           * Constructs a new FacilityBlackout.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FacilityBlackout.
           * @implements IFacilityBlackout
           * @constructor
           * @param {stronachgroup.first.racehorse360.IFacilityBlackout=} [properties] Properties to set
           */
          function FacilityBlackout(properties) {
            this.facilityBlackoutExcludedDates = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FacilityBlackout id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.id = "";

          /**
           * FacilityBlackout facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.facility = null;

          /**
           * FacilityBlackout dateFrom.
           * @member {string} dateFrom
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.dateFrom = "";

          /**
           * FacilityBlackout dateTo.
           * @member {string} dateTo
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.dateTo = "";

          /**
           * FacilityBlackout repeatance.
           * @member {stronachgroup.first.racehorse360.FacilityBlackoutRepeatance} repeatance
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.repeatance = 0;

          /**
           * FacilityBlackout dateRepeatTo.
           * @member {string} dateRepeatTo
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.dateRepeatTo = "";

          /**
           * FacilityBlackout facilityBlackoutExcludedDates.
           * @member {Array.<stronachgroup.first.racehorse360.IFacilityBlackoutExcludedDate>} facilityBlackoutExcludedDates
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           */
          FacilityBlackout.prototype.facilityBlackoutExcludedDates =
            $util.emptyArray;

          /**
           * Creates a new FacilityBlackout instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityBlackout=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.FacilityBlackout} FacilityBlackout instance
           */
          FacilityBlackout.create = function create(properties) {
            return new FacilityBlackout(properties);
          };

          /**
           * Encodes the specified FacilityBlackout message. Does not implicitly {@link stronachgroup.first.racehorse360.FacilityBlackout.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityBlackout} message FacilityBlackout message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FacilityBlackout.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.dateFrom != null &&
              Object.hasOwnProperty.call(message, "dateFrom")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.dateFrom);
            if (
              message.dateTo != null &&
              Object.hasOwnProperty.call(message, "dateTo")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.dateTo);
            if (
              message.repeatance != null &&
              Object.hasOwnProperty.call(message, "repeatance")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.repeatance);
            if (
              message.dateRepeatTo != null &&
              Object.hasOwnProperty.call(message, "dateRepeatTo")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.dateRepeatTo);
            if (
              message.facilityBlackoutExcludedDates != null &&
              message.facilityBlackoutExcludedDates.length
            )
              for (
                var i = 0;
                i < message.facilityBlackoutExcludedDates.length;
                ++i
              )
                $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate.encode(
                  message.facilityBlackoutExcludedDates[i],
                  writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a FacilityBlackout message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.FacilityBlackout} FacilityBlackout
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FacilityBlackout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.FacilityBlackout();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.dateFrom = reader.string();
                  break;
                case 4:
                  message.dateTo = reader.string();
                  break;
                case 5:
                  message.repeatance = reader.int32();
                  break;
                case 6:
                  message.dateRepeatTo = reader.string();
                  break;
                case 7:
                  if (
                    !(
                      message.facilityBlackoutExcludedDates &&
                      message.facilityBlackoutExcludedDates.length
                    )
                  )
                    message.facilityBlackoutExcludedDates = [];
                  message.facilityBlackoutExcludedDates.push(
                    $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FacilityBlackout message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.FacilityBlackout} FacilityBlackout
           */
          FacilityBlackout.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.FacilityBlackout
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.FacilityBlackout();
            if (object.id != null) message.id = String(object.id);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityBlackout.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            if (object.dateFrom != null)
              message.dateFrom = String(object.dateFrom);
            if (object.dateTo != null) message.dateTo = String(object.dateTo);
            switch (object.repeatance) {
              case "FACILITY_BLACKOUT_REPEATANCE_INVALID":
              case 0:
                message.repeatance = 0;
                break;
              case "FACILITY_BLACKOUT_REPEATANCE_DOES_NOT_REPEAT":
              case 1:
                message.repeatance = 1;
                break;
              case "FACILITY_BLACKOUT_REPEATANCE_WEEKLY":
              case 2:
                message.repeatance = 2;
                break;
            }
            if (object.dateRepeatTo != null)
              message.dateRepeatTo = String(object.dateRepeatTo);
            if (object.facilityBlackoutExcludedDates) {
              if (!Array.isArray(object.facilityBlackoutExcludedDates))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.FacilityBlackout.facilityBlackoutExcludedDates: array expected"
                );
              message.facilityBlackoutExcludedDates = [];
              for (
                var i = 0;
                i < object.facilityBlackoutExcludedDates.length;
                ++i
              ) {
                if (typeof object.facilityBlackoutExcludedDates[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.FacilityBlackout.facilityBlackoutExcludedDates: object expected"
                  );
                message.facilityBlackoutExcludedDates[i] =
                  $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate.fromObject(
                    object.facilityBlackoutExcludedDates[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a FacilityBlackout message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @static
           * @param {stronachgroup.first.racehorse360.FacilityBlackout} message FacilityBlackout
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FacilityBlackout.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.facilityBlackoutExcludedDates = [];
            if (options.defaults) {
              object.id = "";
              object.facility = null;
              object.dateFrom = "";
              object.dateTo = "";
              object.repeatance =
                options.enums === String
                  ? "FACILITY_BLACKOUT_REPEATANCE_INVALID"
                  : 0;
              object.dateRepeatTo = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.dateFrom != null && message.hasOwnProperty("dateFrom"))
              object.dateFrom = message.dateFrom;
            if (message.dateTo != null && message.hasOwnProperty("dateTo"))
              object.dateTo = message.dateTo;
            if (
              message.repeatance != null &&
              message.hasOwnProperty("repeatance")
            )
              object.repeatance =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .FacilityBlackoutRepeatance[message.repeatance]
                  : message.repeatance;
            if (
              message.dateRepeatTo != null &&
              message.hasOwnProperty("dateRepeatTo")
            )
              object.dateRepeatTo = message.dateRepeatTo;
            if (
              message.facilityBlackoutExcludedDates &&
              message.facilityBlackoutExcludedDates.length
            ) {
              object.facilityBlackoutExcludedDates = [];
              for (
                var j = 0;
                j < message.facilityBlackoutExcludedDates.length;
                ++j
              )
                object.facilityBlackoutExcludedDates[j] =
                  $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate.toObject(
                    message.facilityBlackoutExcludedDates[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this FacilityBlackout to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.FacilityBlackout
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FacilityBlackout.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FacilityBlackout;
        })();

        racehorse360.FacilityBlackoutExcludedDate = (function () {
          /**
           * Properties of a FacilityBlackoutExcludedDate.
           * @memberof stronachgroup.first.racehorse360
           * @interface IFacilityBlackoutExcludedDate
           * @property {string|null} [id] FacilityBlackoutExcludedDate id
           * @property {string|null} [date] FacilityBlackoutExcludedDate date
           */

          /**
           * Constructs a new FacilityBlackoutExcludedDate.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FacilityBlackoutExcludedDate.
           * @implements IFacilityBlackoutExcludedDate
           * @constructor
           * @param {stronachgroup.first.racehorse360.IFacilityBlackoutExcludedDate=} [properties] Properties to set
           */
          function FacilityBlackoutExcludedDate(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FacilityBlackoutExcludedDate id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @instance
           */
          FacilityBlackoutExcludedDate.prototype.id = "";

          /**
           * FacilityBlackoutExcludedDate date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @instance
           */
          FacilityBlackoutExcludedDate.prototype.date = "";

          /**
           * Creates a new FacilityBlackoutExcludedDate instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityBlackoutExcludedDate=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate} FacilityBlackoutExcludedDate instance
           */
          FacilityBlackoutExcludedDate.create = function create(properties) {
            return new FacilityBlackoutExcludedDate(properties);
          };

          /**
           * Encodes the specified FacilityBlackoutExcludedDate message. Does not implicitly {@link stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @static
           * @param {stronachgroup.first.racehorse360.IFacilityBlackoutExcludedDate} message FacilityBlackoutExcludedDate message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FacilityBlackoutExcludedDate.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.date);
            return writer;
          };

          /**
           * Decodes a FacilityBlackoutExcludedDate message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate} FacilityBlackoutExcludedDate
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FacilityBlackoutExcludedDate.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.date = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FacilityBlackoutExcludedDate message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate} FacilityBlackoutExcludedDate
           */
          FacilityBlackoutExcludedDate.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .FacilityBlackoutExcludedDate
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate();
            if (object.id != null) message.id = String(object.id);
            if (object.date != null) message.date = String(object.date);
            return message;
          };

          /**
           * Creates a plain object from a FacilityBlackoutExcludedDate message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @static
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate} message FacilityBlackoutExcludedDate
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FacilityBlackoutExcludedDate.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.date = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            return object;
          };

          /**
           * Converts this FacilityBlackoutExcludedDate to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutExcludedDate
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FacilityBlackoutExcludedDate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FacilityBlackoutExcludedDate;
        })();

        racehorse360.CreateFacilityBlackoutRequest = (function () {
          /**
           * Properties of a CreateFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateFacilityBlackoutRequest
           * @property {string|null} [facilityId] CreateFacilityBlackoutRequest facilityId
           * @property {string|null} [dateFrom] CreateFacilityBlackoutRequest dateFrom
           * @property {string|null} [dateTo] CreateFacilityBlackoutRequest dateTo
           * @property {stronachgroup.first.racehorse360.FacilityBlackoutRepeatance|null} [repeatance] CreateFacilityBlackoutRequest repeatance
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateFacilityBlackoutRequest getOptions
           */

          /**
           * Constructs a new CreateFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateFacilityBlackoutRequest.
           * @implements ICreateFacilityBlackoutRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateFacilityBlackoutRequest=} [properties] Properties to set
           */
          function CreateFacilityBlackoutRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateFacilityBlackoutRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           */
          CreateFacilityBlackoutRequest.prototype.facilityId = "";

          /**
           * CreateFacilityBlackoutRequest dateFrom.
           * @member {string} dateFrom
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           */
          CreateFacilityBlackoutRequest.prototype.dateFrom = "";

          /**
           * CreateFacilityBlackoutRequest dateTo.
           * @member {string} dateTo
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           */
          CreateFacilityBlackoutRequest.prototype.dateTo = "";

          /**
           * CreateFacilityBlackoutRequest repeatance.
           * @member {stronachgroup.first.racehorse360.FacilityBlackoutRepeatance} repeatance
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           */
          CreateFacilityBlackoutRequest.prototype.repeatance = 0;

          /**
           * CreateFacilityBlackoutRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           */
          CreateFacilityBlackoutRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateFacilityBlackoutRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateFacilityBlackoutRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} CreateFacilityBlackoutRequest instance
           */
          CreateFacilityBlackoutRequest.create = function create(properties) {
            return new CreateFacilityBlackoutRequest(properties);
          };

          /**
           * Encodes the specified CreateFacilityBlackoutRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateFacilityBlackoutRequest} message CreateFacilityBlackoutRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateFacilityBlackoutRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.dateFrom != null &&
              Object.hasOwnProperty.call(message, "dateFrom")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.dateFrom);
            if (
              message.dateTo != null &&
              Object.hasOwnProperty.call(message, "dateTo")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.dateTo);
            if (
              message.repeatance != null &&
              Object.hasOwnProperty.call(message, "repeatance")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.repeatance);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateFacilityBlackoutRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} CreateFacilityBlackoutRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateFacilityBlackoutRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.dateFrom = reader.string();
                  break;
                case 3:
                  message.dateTo = reader.string();
                  break;
                case 4:
                  message.repeatance = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateFacilityBlackoutRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} CreateFacilityBlackoutRequest
           */
          CreateFacilityBlackoutRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateFacilityBlackoutRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.dateFrom != null)
              message.dateFrom = String(object.dateFrom);
            if (object.dateTo != null) message.dateTo = String(object.dateTo);
            switch (object.repeatance) {
              case "FACILITY_BLACKOUT_REPEATANCE_INVALID":
              case 0:
                message.repeatance = 0;
                break;
              case "FACILITY_BLACKOUT_REPEATANCE_DOES_NOT_REPEAT":
              case 1:
                message.repeatance = 1;
                break;
              case "FACILITY_BLACKOUT_REPEATANCE_WEEKLY":
              case 2:
                message.repeatance = 2;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateFacilityBlackoutRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest} message CreateFacilityBlackoutRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateFacilityBlackoutRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.dateFrom = "";
              object.dateTo = "";
              object.repeatance =
                options.enums === String
                  ? "FACILITY_BLACKOUT_REPEATANCE_INVALID"
                  : 0;
              object.getOptions = null;
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (message.dateFrom != null && message.hasOwnProperty("dateFrom"))
              object.dateFrom = message.dateFrom;
            if (message.dateTo != null && message.hasOwnProperty("dateTo"))
              object.dateTo = message.dateTo;
            if (
              message.repeatance != null &&
              message.hasOwnProperty("repeatance")
            )
              object.repeatance =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .FacilityBlackoutRepeatance[message.repeatance]
                  : message.repeatance;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateFacilityBlackoutRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateFacilityBlackoutRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateFacilityBlackoutRequest;
        })();

        racehorse360.PullFacilityBlackoutsRequest = (function () {
          /**
           * Properties of a PullFacilityBlackoutsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullFacilityBlackoutsRequest
           * @property {string|null} [facilityId] PullFacilityBlackoutsRequest facilityId
           * @property {string|null} [startDate] PullFacilityBlackoutsRequest startDate
           * @property {string|null} [endDate] PullFacilityBlackoutsRequest endDate
           */

          /**
           * Constructs a new PullFacilityBlackoutsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullFacilityBlackoutsRequest.
           * @implements IPullFacilityBlackoutsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsRequest=} [properties] Properties to set
           */
          function PullFacilityBlackoutsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullFacilityBlackoutsRequest facilityId.
           * @member {string} facilityId
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @instance
           */
          PullFacilityBlackoutsRequest.prototype.facilityId = "";

          /**
           * PullFacilityBlackoutsRequest startDate.
           * @member {string} startDate
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @instance
           */
          PullFacilityBlackoutsRequest.prototype.startDate = "";

          /**
           * PullFacilityBlackoutsRequest endDate.
           * @member {string} endDate
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @instance
           */
          PullFacilityBlackoutsRequest.prototype.endDate = "";

          /**
           * Creates a new PullFacilityBlackoutsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} PullFacilityBlackoutsRequest instance
           */
          PullFacilityBlackoutsRequest.create = function create(properties) {
            return new PullFacilityBlackoutsRequest(properties);
          };

          /**
           * Encodes the specified PullFacilityBlackoutsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsRequest} message PullFacilityBlackoutsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullFacilityBlackoutsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityId != null &&
              Object.hasOwnProperty.call(message, "facilityId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.facilityId);
            if (
              message.startDate != null &&
              Object.hasOwnProperty.call(message, "startDate")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.startDate);
            if (
              message.endDate != null &&
              Object.hasOwnProperty.call(message, "endDate")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.endDate);
            return writer;
          };

          /**
           * Decodes a PullFacilityBlackoutsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} PullFacilityBlackoutsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullFacilityBlackoutsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.facilityId = reader.string();
                  break;
                case 2:
                  message.startDate = reader.string();
                  break;
                case 3:
                  message.endDate = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullFacilityBlackoutsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} PullFacilityBlackoutsRequest
           */
          PullFacilityBlackoutsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullFacilityBlackoutsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest();
            if (object.facilityId != null)
              message.facilityId = String(object.facilityId);
            if (object.startDate != null)
              message.startDate = String(object.startDate);
            if (object.endDate != null)
              message.endDate = String(object.endDate);
            return message;
          };

          /**
           * Creates a plain object from a PullFacilityBlackoutsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest} message PullFacilityBlackoutsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullFacilityBlackoutsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.facilityId = "";
              object.startDate = "";
              object.endDate = "";
            }
            if (
              message.facilityId != null &&
              message.hasOwnProperty("facilityId")
            )
              object.facilityId = message.facilityId;
            if (
              message.startDate != null &&
              message.hasOwnProperty("startDate")
            )
              object.startDate = message.startDate;
            if (message.endDate != null && message.hasOwnProperty("endDate"))
              object.endDate = message.endDate;
            return object;
          };

          /**
           * Converts this PullFacilityBlackoutsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullFacilityBlackoutsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullFacilityBlackoutsRequest;
        })();

        racehorse360.PullFacilityBlackoutsResponse = (function () {
          /**
           * Properties of a PullFacilityBlackoutsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullFacilityBlackoutsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IFacilityBlackout>|null} [facilityBlackouts] PullFacilityBlackoutsResponse facilityBlackouts
           */

          /**
           * Constructs a new PullFacilityBlackoutsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullFacilityBlackoutsResponse.
           * @implements IPullFacilityBlackoutsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsResponse=} [properties] Properties to set
           */
          function PullFacilityBlackoutsResponse(properties) {
            this.facilityBlackouts = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullFacilityBlackoutsResponse facilityBlackouts.
           * @member {Array.<stronachgroup.first.racehorse360.IFacilityBlackout>} facilityBlackouts
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @instance
           */
          PullFacilityBlackoutsResponse.prototype.facilityBlackouts =
            $util.emptyArray;

          /**
           * Creates a new PullFacilityBlackoutsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse} PullFacilityBlackoutsResponse instance
           */
          PullFacilityBlackoutsResponse.create = function create(properties) {
            return new PullFacilityBlackoutsResponse(properties);
          };

          /**
           * Encodes the specified PullFacilityBlackoutsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsResponse} message PullFacilityBlackoutsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullFacilityBlackoutsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.facilityBlackouts != null &&
              message.facilityBlackouts.length
            )
              for (var i = 0; i < message.facilityBlackouts.length; ++i)
                $root.stronachgroup.first.racehorse360.FacilityBlackout.encode(
                  message.facilityBlackouts[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullFacilityBlackoutsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse} PullFacilityBlackoutsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullFacilityBlackoutsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.facilityBlackouts &&
                      message.facilityBlackouts.length
                    )
                  )
                    message.facilityBlackouts = [];
                  message.facilityBlackouts.push(
                    $root.stronachgroup.first.racehorse360.FacilityBlackout.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullFacilityBlackoutsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse} PullFacilityBlackoutsResponse
           */
          PullFacilityBlackoutsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullFacilityBlackoutsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse();
            if (object.facilityBlackouts) {
              if (!Array.isArray(object.facilityBlackouts))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse.facilityBlackouts: array expected"
                );
              message.facilityBlackouts = [];
              for (var i = 0; i < object.facilityBlackouts.length; ++i) {
                if (typeof object.facilityBlackouts[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse.facilityBlackouts: object expected"
                  );
                message.facilityBlackouts[i] =
                  $root.stronachgroup.first.racehorse360.FacilityBlackout.fromObject(
                    object.facilityBlackouts[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullFacilityBlackoutsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse} message PullFacilityBlackoutsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullFacilityBlackoutsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.facilityBlackouts = [];
            if (message.facilityBlackouts && message.facilityBlackouts.length) {
              object.facilityBlackouts = [];
              for (var j = 0; j < message.facilityBlackouts.length; ++j)
                object.facilityBlackouts[j] =
                  $root.stronachgroup.first.racehorse360.FacilityBlackout.toObject(
                    message.facilityBlackouts[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullFacilityBlackoutsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullFacilityBlackoutsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullFacilityBlackoutsResponse;
        })();

        racehorse360.CancelFacilityBlackoutRequest = (function () {
          /**
           * Properties of a CancelFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICancelFacilityBlackoutRequest
           * @property {string|null} [id] CancelFacilityBlackoutRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CancelFacilityBlackoutRequest getOptions
           */

          /**
           * Constructs a new CancelFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CancelFacilityBlackoutRequest.
           * @implements ICancelFacilityBlackoutRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICancelFacilityBlackoutRequest=} [properties] Properties to set
           */
          function CancelFacilityBlackoutRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CancelFacilityBlackoutRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @instance
           */
          CancelFacilityBlackoutRequest.prototype.id = "";

          /**
           * CancelFacilityBlackoutRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @instance
           */
          CancelFacilityBlackoutRequest.prototype.getOptions = null;

          /**
           * Creates a new CancelFacilityBlackoutRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelFacilityBlackoutRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} CancelFacilityBlackoutRequest instance
           */
          CancelFacilityBlackoutRequest.create = function create(properties) {
            return new CancelFacilityBlackoutRequest(properties);
          };

          /**
           * Encodes the specified CancelFacilityBlackoutRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICancelFacilityBlackoutRequest} message CancelFacilityBlackoutRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CancelFacilityBlackoutRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CancelFacilityBlackoutRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} CancelFacilityBlackoutRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CancelFacilityBlackoutRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CancelFacilityBlackoutRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} CancelFacilityBlackoutRequest
           */
          CancelFacilityBlackoutRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CancelFacilityBlackoutRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CancelFacilityBlackoutRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest} message CancelFacilityBlackoutRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CancelFacilityBlackoutRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CancelFacilityBlackoutRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CancelFacilityBlackoutRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CancelFacilityBlackoutRequest;
        })();

        racehorse360.ExcludeSingleFacilityBlackoutDateRequest = (function () {
          /**
           * Properties of an ExcludeSingleFacilityBlackoutDateRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IExcludeSingleFacilityBlackoutDateRequest
           * @property {string|null} [id] ExcludeSingleFacilityBlackoutDateRequest id
           * @property {string|null} [date] ExcludeSingleFacilityBlackoutDateRequest date
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ExcludeSingleFacilityBlackoutDateRequest getOptions
           */

          /**
           * Constructs a new ExcludeSingleFacilityBlackoutDateRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an ExcludeSingleFacilityBlackoutDateRequest.
           * @implements IExcludeSingleFacilityBlackoutDateRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IExcludeSingleFacilityBlackoutDateRequest=} [properties] Properties to set
           */
          function ExcludeSingleFacilityBlackoutDateRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ExcludeSingleFacilityBlackoutDateRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @instance
           */
          ExcludeSingleFacilityBlackoutDateRequest.prototype.id = "";

          /**
           * ExcludeSingleFacilityBlackoutDateRequest date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @instance
           */
          ExcludeSingleFacilityBlackoutDateRequest.prototype.date = "";

          /**
           * ExcludeSingleFacilityBlackoutDateRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @instance
           */
          ExcludeSingleFacilityBlackoutDateRequest.prototype.getOptions = null;

          /**
           * Creates a new ExcludeSingleFacilityBlackoutDateRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IExcludeSingleFacilityBlackoutDateRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} ExcludeSingleFacilityBlackoutDateRequest instance
           */
          ExcludeSingleFacilityBlackoutDateRequest.create = function create(
            properties
          ) {
            return new ExcludeSingleFacilityBlackoutDateRequest(properties);
          };

          /**
           * Encodes the specified ExcludeSingleFacilityBlackoutDateRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IExcludeSingleFacilityBlackoutDateRequest} message ExcludeSingleFacilityBlackoutDateRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ExcludeSingleFacilityBlackoutDateRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.date);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an ExcludeSingleFacilityBlackoutDateRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} ExcludeSingleFacilityBlackoutDateRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ExcludeSingleFacilityBlackoutDateRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.date = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an ExcludeSingleFacilityBlackoutDateRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} ExcludeSingleFacilityBlackoutDateRequest
           */
          ExcludeSingleFacilityBlackoutDateRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .ExcludeSingleFacilityBlackoutDateRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.date != null) message.date = String(object.date);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from an ExcludeSingleFacilityBlackoutDateRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest} message ExcludeSingleFacilityBlackoutDateRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ExcludeSingleFacilityBlackoutDateRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.date = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ExcludeSingleFacilityBlackoutDateRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ExcludeSingleFacilityBlackoutDateRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ExcludeSingleFacilityBlackoutDateRequest;
        })();

        racehorse360.SetRepeatToForFacilityBlackoutRequest = (function () {
          /**
           * Properties of a SetRepeatToForFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetRepeatToForFacilityBlackoutRequest
           * @property {string|null} [id] SetRepeatToForFacilityBlackoutRequest id
           * @property {string|null} [date] SetRepeatToForFacilityBlackoutRequest date
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SetRepeatToForFacilityBlackoutRequest getOptions
           */

          /**
           * Constructs a new SetRepeatToForFacilityBlackoutRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetRepeatToForFacilityBlackoutRequest.
           * @implements ISetRepeatToForFacilityBlackoutRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetRepeatToForFacilityBlackoutRequest=} [properties] Properties to set
           */
          function SetRepeatToForFacilityBlackoutRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetRepeatToForFacilityBlackoutRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @instance
           */
          SetRepeatToForFacilityBlackoutRequest.prototype.id = "";

          /**
           * SetRepeatToForFacilityBlackoutRequest date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @instance
           */
          SetRepeatToForFacilityBlackoutRequest.prototype.date = "";

          /**
           * SetRepeatToForFacilityBlackoutRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @instance
           */
          SetRepeatToForFacilityBlackoutRequest.prototype.getOptions = null;

          /**
           * Creates a new SetRepeatToForFacilityBlackoutRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetRepeatToForFacilityBlackoutRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} SetRepeatToForFacilityBlackoutRequest instance
           */
          SetRepeatToForFacilityBlackoutRequest.create = function create(
            properties
          ) {
            return new SetRepeatToForFacilityBlackoutRequest(properties);
          };

          /**
           * Encodes the specified SetRepeatToForFacilityBlackoutRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetRepeatToForFacilityBlackoutRequest} message SetRepeatToForFacilityBlackoutRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetRepeatToForFacilityBlackoutRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.date);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SetRepeatToForFacilityBlackoutRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} SetRepeatToForFacilityBlackoutRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetRepeatToForFacilityBlackoutRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.date = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetRepeatToForFacilityBlackoutRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} SetRepeatToForFacilityBlackoutRequest
           */
          SetRepeatToForFacilityBlackoutRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .SetRepeatToForFacilityBlackoutRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.date != null) message.date = String(object.date);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a SetRepeatToForFacilityBlackoutRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest} message SetRepeatToForFacilityBlackoutRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetRepeatToForFacilityBlackoutRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.date = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SetRepeatToForFacilityBlackoutRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetRepeatToForFacilityBlackoutRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return SetRepeatToForFacilityBlackoutRequest;
        })();

        racehorse360.Region = (function () {
          /**
           * Properties of a Region.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRegion
           * @property {string|null} [id] Region id
           * @property {string|null} [name] Region name
           */

          /**
           * Constructs a new Region.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a Region.
           * @implements IRegion
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRegion=} [properties] Properties to set
           */
          function Region(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Region id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.Region
           * @instance
           */
          Region.prototype.id = "";

          /**
           * Region name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.Region
           * @instance
           */
          Region.prototype.name = "";

          /**
           * Creates a new Region instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.Region
           * @static
           * @param {stronachgroup.first.racehorse360.IRegion=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.Region} Region instance
           */
          Region.create = function create(properties) {
            return new Region(properties);
          };

          /**
           * Encodes the specified Region message. Does not implicitly {@link stronachgroup.first.racehorse360.Region.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.Region
           * @static
           * @param {stronachgroup.first.racehorse360.IRegion} message Region message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Region.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            return writer;
          };

          /**
           * Decodes a Region message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.Region
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.Region} Region
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Region.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.Region();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Region message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.Region
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.Region} Region
           */
          Region.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.racehorse360.Region)
              return object;
            var message = new $root.stronachgroup.first.racehorse360.Region();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            return message;
          };

          /**
           * Creates a plain object from a Region message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.Region
           * @static
           * @param {stronachgroup.first.racehorse360.Region} message Region
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Region.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            return object;
          };

          /**
           * Converts this Region to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.Region
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Region.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Region;
        })();

        racehorse360.RaceType = (function () {
          /**
           * Properties of a RaceType.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceType
           * @property {string|null} [id] RaceType id
           * @property {string|null} [name] RaceType name
           */

          /**
           * Constructs a new RaceType.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceType.
           * @implements IRaceType
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceType=} [properties] Properties to set
           */
          function RaceType(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceType id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @instance
           */
          RaceType.prototype.id = "";

          /**
           * RaceType name.
           * @member {string} name
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @instance
           */
          RaceType.prototype.name = "";

          /**
           * Creates a new RaceType instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceType=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceType} RaceType instance
           */
          RaceType.create = function create(properties) {
            return new RaceType(properties);
          };

          /**
           * Encodes the specified RaceType message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceType.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceType} message RaceType message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceType.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
            return writer;
          };

          /**
           * Decodes a RaceType message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceType} RaceType
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.RaceType();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.name = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceType message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceType} RaceType
           */
          RaceType.fromObject = function fromObject(object) {
            if (
              object instanceof $root.stronachgroup.first.racehorse360.RaceType
            )
              return object;
            var message = new $root.stronachgroup.first.racehorse360.RaceType();
            if (object.id != null) message.id = String(object.id);
            if (object.name != null) message.name = String(object.name);
            return message;
          };

          /**
           * Creates a plain object from a RaceType message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @static
           * @param {stronachgroup.first.racehorse360.RaceType} message RaceType
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceType.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.name = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            return object;
          };

          /**
           * Converts this RaceType to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceType
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceType;
        })();

        racehorse360.RaceDistance = (function () {
          /**
           * Properties of a RaceDistance.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceDistance
           * @property {string|null} [id] RaceDistance id
           * @property {number|null} [distance] RaceDistance distance
           * @property {string|null} [description] RaceDistance description
           */

          /**
           * Constructs a new RaceDistance.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceDistance.
           * @implements IRaceDistance
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceDistance=} [properties] Properties to set
           */
          function RaceDistance(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceDistance id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @instance
           */
          RaceDistance.prototype.id = "";

          /**
           * RaceDistance distance.
           * @member {number} distance
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @instance
           */
          RaceDistance.prototype.distance = 0;

          /**
           * RaceDistance description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @instance
           */
          RaceDistance.prototype.description = "";

          /**
           * Creates a new RaceDistance instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceDistance=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceDistance} RaceDistance instance
           */
          RaceDistance.create = function create(properties) {
            return new RaceDistance(properties);
          };

          /**
           * Encodes the specified RaceDistance message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceDistance.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceDistance} message RaceDistance message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceDistance.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.distance != null &&
              Object.hasOwnProperty.call(message, "distance")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.distance);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a RaceDistance message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceDistance} RaceDistance
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceDistance.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceDistance();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.distance = reader.int32();
                  break;
                case 3:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceDistance message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceDistance} RaceDistance
           */
          RaceDistance.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceDistance
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceDistance();
            if (object.id != null) message.id = String(object.id);
            if (object.distance != null) message.distance = object.distance | 0;
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a RaceDistance message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.RaceDistance} message RaceDistance
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceDistance.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.distance = 0;
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.distance != null && message.hasOwnProperty("distance"))
              object.distance = message.distance;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this RaceDistance to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceDistance
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceDistance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceDistance;
        })();

        racehorse360.ClaimingPrice = (function () {
          /**
           * Properties of a ClaimingPrice.
           * @memberof stronachgroup.first.racehorse360
           * @interface IClaimingPrice
           * @property {string|null} [id] ClaimingPrice id
           * @property {string|null} [description] ClaimingPrice description
           * @property {number|null} [minPrice] ClaimingPrice minPrice
           * @property {number|null} [maxPrice] ClaimingPrice maxPrice
           */

          /**
           * Constructs a new ClaimingPrice.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ClaimingPrice.
           * @implements IClaimingPrice
           * @constructor
           * @param {stronachgroup.first.racehorse360.IClaimingPrice=} [properties] Properties to set
           */
          function ClaimingPrice(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ClaimingPrice id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @instance
           */
          ClaimingPrice.prototype.id = "";

          /**
           * ClaimingPrice description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @instance
           */
          ClaimingPrice.prototype.description = "";

          /**
           * ClaimingPrice minPrice.
           * @member {number} minPrice
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @instance
           */
          ClaimingPrice.prototype.minPrice = 0;

          /**
           * ClaimingPrice maxPrice.
           * @member {number} maxPrice
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @instance
           */
          ClaimingPrice.prototype.maxPrice = 0;

          /**
           * Creates a new ClaimingPrice instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.IClaimingPrice=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ClaimingPrice} ClaimingPrice instance
           */
          ClaimingPrice.create = function create(properties) {
            return new ClaimingPrice(properties);
          };

          /**
           * Encodes the specified ClaimingPrice message. Does not implicitly {@link stronachgroup.first.racehorse360.ClaimingPrice.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.IClaimingPrice} message ClaimingPrice message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ClaimingPrice.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.minPrice != null &&
              Object.hasOwnProperty.call(message, "minPrice")
            )
              writer.uint32(/* id 3, wireType 5 =*/ 29).float(message.minPrice);
            if (
              message.maxPrice != null &&
              Object.hasOwnProperty.call(message, "maxPrice")
            )
              writer.uint32(/* id 4, wireType 5 =*/ 37).float(message.maxPrice);
            return writer;
          };

          /**
           * Decodes a ClaimingPrice message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ClaimingPrice} ClaimingPrice
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ClaimingPrice.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ClaimingPrice();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.minPrice = reader.float();
                  break;
                case 4:
                  message.maxPrice = reader.float();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ClaimingPrice message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ClaimingPrice} ClaimingPrice
           */
          ClaimingPrice.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ClaimingPrice
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ClaimingPrice();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.minPrice != null)
              message.minPrice = Number(object.minPrice);
            if (object.maxPrice != null)
              message.maxPrice = Number(object.maxPrice);
            return message;
          };

          /**
           * Creates a plain object from a ClaimingPrice message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.ClaimingPrice} message ClaimingPrice
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ClaimingPrice.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.minPrice = 0;
              object.maxPrice = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.minPrice != null && message.hasOwnProperty("minPrice"))
              object.minPrice =
                options.json && !isFinite(message.minPrice)
                  ? String(message.minPrice)
                  : message.minPrice;
            if (message.maxPrice != null && message.hasOwnProperty("maxPrice"))
              object.maxPrice =
                options.json && !isFinite(message.maxPrice)
                  ? String(message.maxPrice)
                  : message.maxPrice;
            return object;
          };

          /**
           * Converts this ClaimingPrice to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ClaimingPrice
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ClaimingPrice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ClaimingPrice;
        })();

        racehorse360.PullRegionPreferredConditionsRequest = (function () {
          /**
           * Properties of a PullRegionPreferredConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRegionPreferredConditionsRequest
           * @property {google.protobuf.IStringValue|null} [id] PullRegionPreferredConditionsRequest id
           */

          /**
           * Constructs a new PullRegionPreferredConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRegionPreferredConditionsRequest.
           * @implements IPullRegionPreferredConditionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsRequest=} [properties] Properties to set
           */
          function PullRegionPreferredConditionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRegionPreferredConditionsRequest id.
           * @member {google.protobuf.IStringValue|null|undefined} id
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @instance
           */
          PullRegionPreferredConditionsRequest.prototype.id = null;

          /**
           * Creates a new PullRegionPreferredConditionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest} PullRegionPreferredConditionsRequest instance
           */
          PullRegionPreferredConditionsRequest.create = function create(
            properties
          ) {
            return new PullRegionPreferredConditionsRequest(properties);
          };

          /**
           * Encodes the specified PullRegionPreferredConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsRequest} message PullRegionPreferredConditionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRegionPreferredConditionsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              $root.google.protobuf.StringValue.encode(
                message.id,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRegionPreferredConditionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest} PullRegionPreferredConditionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRegionPreferredConditionsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = $root.google.protobuf.StringValue.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRegionPreferredConditionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest} PullRegionPreferredConditionsRequest
           */
          PullRegionPreferredConditionsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullRegionPreferredConditionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest();
            if (object.id != null) {
              if (typeof object.id !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest.id: object expected"
                );
              message.id = $root.google.protobuf.StringValue.fromObject(
                object.id
              );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullRegionPreferredConditionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest} message PullRegionPreferredConditionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRegionPreferredConditionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = $root.google.protobuf.StringValue.toObject(
                message.id,
                options
              );
            return object;
          };

          /**
           * Converts this PullRegionPreferredConditionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRegionPreferredConditionsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRegionPreferredConditionsRequest;
        })();

        racehorse360.PullRegionPreferredConditionsResponse = (function () {
          /**
           * Properties of a PullRegionPreferredConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullRegionPreferredConditionsResponse
           * @property {stronachgroup.first.racehorse360.IRegionPreferredConditions|null} [regionPreferredConditions] PullRegionPreferredConditionsResponse regionPreferredConditions
           */

          /**
           * Constructs a new PullRegionPreferredConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullRegionPreferredConditionsResponse.
           * @implements IPullRegionPreferredConditionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsResponse=} [properties] Properties to set
           */
          function PullRegionPreferredConditionsResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullRegionPreferredConditionsResponse regionPreferredConditions.
           * @member {stronachgroup.first.racehorse360.IRegionPreferredConditions|null|undefined} regionPreferredConditions
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @instance
           */
          PullRegionPreferredConditionsResponse.prototype.regionPreferredConditions =
            null;

          /**
           * Creates a new PullRegionPreferredConditionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse} PullRegionPreferredConditionsResponse instance
           */
          PullRegionPreferredConditionsResponse.create = function create(
            properties
          ) {
            return new PullRegionPreferredConditionsResponse(properties);
          };

          /**
           * Encodes the specified PullRegionPreferredConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsResponse} message PullRegionPreferredConditionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullRegionPreferredConditionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.regionPreferredConditions != null &&
              Object.hasOwnProperty.call(message, "regionPreferredConditions")
            )
              $root.stronachgroup.first.racehorse360.RegionPreferredConditions.encode(
                message.regionPreferredConditions,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullRegionPreferredConditionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse} PullRegionPreferredConditionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullRegionPreferredConditionsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.regionPreferredConditions =
                    $root.stronachgroup.first.racehorse360.RegionPreferredConditions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullRegionPreferredConditionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse} PullRegionPreferredConditionsResponse
           */
          PullRegionPreferredConditionsResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullRegionPreferredConditionsResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse();
              if (object.regionPreferredConditions != null) {
                if (typeof object.regionPreferredConditions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse.regionPreferredConditions: object expected"
                  );
                message.regionPreferredConditions =
                  $root.stronachgroup.first.racehorse360.RegionPreferredConditions.fromObject(
                    object.regionPreferredConditions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a PullRegionPreferredConditionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse} message PullRegionPreferredConditionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullRegionPreferredConditionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.regionPreferredConditions = null;
            if (
              message.regionPreferredConditions != null &&
              message.hasOwnProperty("regionPreferredConditions")
            )
              object.regionPreferredConditions =
                $root.stronachgroup.first.racehorse360.RegionPreferredConditions.toObject(
                  message.regionPreferredConditions,
                  options
                );
            return object;
          };

          /**
           * Converts this PullRegionPreferredConditionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullRegionPreferredConditionsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullRegionPreferredConditionsResponse;
        })();

        racehorse360.RegionPreferredConditions = (function () {
          /**
           * Properties of a RegionPreferredConditions.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRegionPreferredConditions
           * @property {Array.<stronachgroup.first.racehorse360.ISurfaceRaceDistance>|null} [surfaceRaceDistances] RegionPreferredConditions surfaceRaceDistances
           * @property {Array.<stronachgroup.first.racehorse360.IRaceType>|null} [raceTypes] RegionPreferredConditions raceTypes
           * @property {Array.<stronachgroup.first.racehorse360.IRaceTypeClaimingPrice>|null} [raceTypeClaimingPrices] RegionPreferredConditions raceTypeClaimingPrices
           */

          /**
           * Constructs a new RegionPreferredConditions.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RegionPreferredConditions.
           * @implements IRegionPreferredConditions
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRegionPreferredConditions=} [properties] Properties to set
           */
          function RegionPreferredConditions(properties) {
            this.surfaceRaceDistances = [];
            this.raceTypes = [];
            this.raceTypeClaimingPrices = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RegionPreferredConditions surfaceRaceDistances.
           * @member {Array.<stronachgroup.first.racehorse360.ISurfaceRaceDistance>} surfaceRaceDistances
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @instance
           */
          RegionPreferredConditions.prototype.surfaceRaceDistances =
            $util.emptyArray;

          /**
           * RegionPreferredConditions raceTypes.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceType>} raceTypes
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @instance
           */
          RegionPreferredConditions.prototype.raceTypes = $util.emptyArray;

          /**
           * RegionPreferredConditions raceTypeClaimingPrices.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceTypeClaimingPrice>} raceTypeClaimingPrices
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @instance
           */
          RegionPreferredConditions.prototype.raceTypeClaimingPrices =
            $util.emptyArray;

          /**
           * Creates a new RegionPreferredConditions instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.IRegionPreferredConditions=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RegionPreferredConditions} RegionPreferredConditions instance
           */
          RegionPreferredConditions.create = function create(properties) {
            return new RegionPreferredConditions(properties);
          };

          /**
           * Encodes the specified RegionPreferredConditions message. Does not implicitly {@link stronachgroup.first.racehorse360.RegionPreferredConditions.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.IRegionPreferredConditions} message RegionPreferredConditions message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RegionPreferredConditions.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.surfaceRaceDistances != null &&
              message.surfaceRaceDistances.length
            )
              for (var i = 0; i < message.surfaceRaceDistances.length; ++i)
                $root.stronachgroup.first.racehorse360.SurfaceRaceDistance.encode(
                  message.surfaceRaceDistances[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (message.raceTypes != null && message.raceTypes.length)
              for (var i = 0; i < message.raceTypes.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceType.encode(
                  message.raceTypes[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (
              message.raceTypeClaimingPrices != null &&
              message.raceTypeClaimingPrices.length
            )
              for (var i = 0; i < message.raceTypeClaimingPrices.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice.encode(
                  message.raceTypeClaimingPrices[i],
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a RegionPreferredConditions message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RegionPreferredConditions} RegionPreferredConditions
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RegionPreferredConditions.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RegionPreferredConditions();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.surfaceRaceDistances &&
                      message.surfaceRaceDistances.length
                    )
                  )
                    message.surfaceRaceDistances = [];
                  message.surfaceRaceDistances.push(
                    $root.stronachgroup.first.racehorse360.SurfaceRaceDistance.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 2:
                  if (!(message.raceTypes && message.raceTypes.length))
                    message.raceTypes = [];
                  message.raceTypes.push(
                    $root.stronachgroup.first.racehorse360.RaceType.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 3:
                  if (
                    !(
                      message.raceTypeClaimingPrices &&
                      message.raceTypeClaimingPrices.length
                    )
                  )
                    message.raceTypeClaimingPrices = [];
                  message.raceTypeClaimingPrices.push(
                    $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RegionPreferredConditions message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RegionPreferredConditions} RegionPreferredConditions
           */
          RegionPreferredConditions.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RegionPreferredConditions
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RegionPreferredConditions();
            if (object.surfaceRaceDistances) {
              if (!Array.isArray(object.surfaceRaceDistances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RegionPreferredConditions.surfaceRaceDistances: array expected"
                );
              message.surfaceRaceDistances = [];
              for (var i = 0; i < object.surfaceRaceDistances.length; ++i) {
                if (typeof object.surfaceRaceDistances[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RegionPreferredConditions.surfaceRaceDistances: object expected"
                  );
                message.surfaceRaceDistances[i] =
                  $root.stronachgroup.first.racehorse360.SurfaceRaceDistance.fromObject(
                    object.surfaceRaceDistances[i]
                  );
              }
            }
            if (object.raceTypes) {
              if (!Array.isArray(object.raceTypes))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RegionPreferredConditions.raceTypes: array expected"
                );
              message.raceTypes = [];
              for (var i = 0; i < object.raceTypes.length; ++i) {
                if (typeof object.raceTypes[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RegionPreferredConditions.raceTypes: object expected"
                  );
                message.raceTypes[i] =
                  $root.stronachgroup.first.racehorse360.RaceType.fromObject(
                    object.raceTypes[i]
                  );
              }
            }
            if (object.raceTypeClaimingPrices) {
              if (!Array.isArray(object.raceTypeClaimingPrices))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RegionPreferredConditions.raceTypeClaimingPrices: array expected"
                );
              message.raceTypeClaimingPrices = [];
              for (var i = 0; i < object.raceTypeClaimingPrices.length; ++i) {
                if (typeof object.raceTypeClaimingPrices[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RegionPreferredConditions.raceTypeClaimingPrices: object expected"
                  );
                message.raceTypeClaimingPrices[i] =
                  $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice.fromObject(
                    object.raceTypeClaimingPrices[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a RegionPreferredConditions message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @static
           * @param {stronachgroup.first.racehorse360.RegionPreferredConditions} message RegionPreferredConditions
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RegionPreferredConditions.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.surfaceRaceDistances = [];
              object.raceTypes = [];
              object.raceTypeClaimingPrices = [];
            }
            if (
              message.surfaceRaceDistances &&
              message.surfaceRaceDistances.length
            ) {
              object.surfaceRaceDistances = [];
              for (var j = 0; j < message.surfaceRaceDistances.length; ++j)
                object.surfaceRaceDistances[j] =
                  $root.stronachgroup.first.racehorse360.SurfaceRaceDistance.toObject(
                    message.surfaceRaceDistances[j],
                    options
                  );
            }
            if (message.raceTypes && message.raceTypes.length) {
              object.raceTypes = [];
              for (var j = 0; j < message.raceTypes.length; ++j)
                object.raceTypes[j] =
                  $root.stronachgroup.first.racehorse360.RaceType.toObject(
                    message.raceTypes[j],
                    options
                  );
            }
            if (
              message.raceTypeClaimingPrices &&
              message.raceTypeClaimingPrices.length
            ) {
              object.raceTypeClaimingPrices = [];
              for (var j = 0; j < message.raceTypeClaimingPrices.length; ++j)
                object.raceTypeClaimingPrices[j] =
                  $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice.toObject(
                    message.raceTypeClaimingPrices[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this RegionPreferredConditions to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RegionPreferredConditions
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RegionPreferredConditions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RegionPreferredConditions;
        })();

        racehorse360.SurfaceRaceDistance = (function () {
          /**
           * Properties of a SurfaceRaceDistance.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISurfaceRaceDistance
           * @property {stronachgroup.first.racehorse360.CourseSurface|null} [surface] SurfaceRaceDistance surface
           * @property {Array.<stronachgroup.first.racehorse360.IRaceDistance>|null} [raceDistances] SurfaceRaceDistance raceDistances
           */

          /**
           * Constructs a new SurfaceRaceDistance.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SurfaceRaceDistance.
           * @implements ISurfaceRaceDistance
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISurfaceRaceDistance=} [properties] Properties to set
           */
          function SurfaceRaceDistance(properties) {
            this.raceDistances = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SurfaceRaceDistance surface.
           * @member {stronachgroup.first.racehorse360.CourseSurface} surface
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @instance
           */
          SurfaceRaceDistance.prototype.surface = 0;

          /**
           * SurfaceRaceDistance raceDistances.
           * @member {Array.<stronachgroup.first.racehorse360.IRaceDistance>} raceDistances
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @instance
           */
          SurfaceRaceDistance.prototype.raceDistances = $util.emptyArray;

          /**
           * Creates a new SurfaceRaceDistance instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.ISurfaceRaceDistance=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SurfaceRaceDistance} SurfaceRaceDistance instance
           */
          SurfaceRaceDistance.create = function create(properties) {
            return new SurfaceRaceDistance(properties);
          };

          /**
           * Encodes the specified SurfaceRaceDistance message. Does not implicitly {@link stronachgroup.first.racehorse360.SurfaceRaceDistance.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.ISurfaceRaceDistance} message SurfaceRaceDistance message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SurfaceRaceDistance.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.surface != null &&
              Object.hasOwnProperty.call(message, "surface")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.surface);
            if (message.raceDistances != null && message.raceDistances.length)
              for (var i = 0; i < message.raceDistances.length; ++i)
                $root.stronachgroup.first.racehorse360.RaceDistance.encode(
                  message.raceDistances[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a SurfaceRaceDistance message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SurfaceRaceDistance} SurfaceRaceDistance
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SurfaceRaceDistance.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SurfaceRaceDistance();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.surface = reader.int32();
                  break;
                case 2:
                  if (!(message.raceDistances && message.raceDistances.length))
                    message.raceDistances = [];
                  message.raceDistances.push(
                    $root.stronachgroup.first.racehorse360.RaceDistance.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SurfaceRaceDistance message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SurfaceRaceDistance} SurfaceRaceDistance
           */
          SurfaceRaceDistance.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.SurfaceRaceDistance
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SurfaceRaceDistance();
            switch (object.surface) {
              case "COURSE_SURFACE_INVALID":
              case 0:
                message.surface = 0;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRACK":
              case 1:
                message.surface = 1;
                break;
              case "COURSE_SURFACE_TURF":
              case 2:
                message.surface = 2;
                break;
              case "COURSE_SURFACE_STEEPLECHASE":
              case 3:
                message.surface = 3;
                break;
              case "COURSE_SURFACE_INNER_TRACK":
              case 4:
                message.surface = 4;
                break;
              case "COURSE_SURFACE_OUTER_TURF":
              case 5:
                message.surface = 5;
                break;
              case "COURSE_SURFACE_WOOD_CHIPS":
              case 6:
                message.surface = 6;
                break;
              case "COURSE_SURFACE_HUNT_ON_TURF":
              case 7:
                message.surface = 7;
                break;
              case "COURSE_SURFACE_TIMBER":
              case 8:
                message.surface = 8;
                break;
              case "COURSE_SURFACE_DIRT":
              case 9:
                message.surface = 9;
                break;
              case "COURSE_SURFACE_TURF_TRAINING":
              case 10:
                message.surface = 10;
                break;
              case "COURSE_SURFACE_JUMP":
              case 11:
                message.surface = 11;
                break;
              case "COURSE_SURFACE_ALL_WEATHER_TRAINING":
              case 12:
                message.surface = 12;
                break;
              case "COURSE_SURFACE_HUNT":
              case 13:
                message.surface = 13;
                break;
              case "COURSE_SURFACE_DOWNHILL_TURF":
              case 14:
                message.surface = 14;
                break;
              case "COURSE_SURFACE_DIRT_TRAINING":
              case 15:
                message.surface = 15;
                break;
              case "COURSE_SURFACE_INNER_TURF":
              case 16:
                message.surface = 16;
                break;
              case "COURSE_SURFACE_HURDLE":
              case 17:
                message.surface = 17;
                break;
            }
            if (object.raceDistances) {
              if (!Array.isArray(object.raceDistances))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SurfaceRaceDistance.raceDistances: array expected"
                );
              message.raceDistances = [];
              for (var i = 0; i < object.raceDistances.length; ++i) {
                if (typeof object.raceDistances[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.SurfaceRaceDistance.raceDistances: object expected"
                  );
                message.raceDistances[i] =
                  $root.stronachgroup.first.racehorse360.RaceDistance.fromObject(
                    object.raceDistances[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a SurfaceRaceDistance message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @static
           * @param {stronachgroup.first.racehorse360.SurfaceRaceDistance} message SurfaceRaceDistance
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SurfaceRaceDistance.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.raceDistances = [];
            if (options.defaults)
              object.surface =
                options.enums === String ? "COURSE_SURFACE_INVALID" : 0;
            if (message.surface != null && message.hasOwnProperty("surface"))
              object.surface =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.CourseSurface[
                      message.surface
                    ]
                  : message.surface;
            if (message.raceDistances && message.raceDistances.length) {
              object.raceDistances = [];
              for (var j = 0; j < message.raceDistances.length; ++j)
                object.raceDistances[j] =
                  $root.stronachgroup.first.racehorse360.RaceDistance.toObject(
                    message.raceDistances[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this SurfaceRaceDistance to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SurfaceRaceDistance
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SurfaceRaceDistance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SurfaceRaceDistance;
        })();

        racehorse360.RaceTypeClaimingPrice = (function () {
          /**
           * Properties of a RaceTypeClaimingPrice.
           * @memberof stronachgroup.first.racehorse360
           * @interface IRaceTypeClaimingPrice
           * @property {string|null} [raceTypeId] RaceTypeClaimingPrice raceTypeId
           * @property {Array.<stronachgroup.first.racehorse360.IClaimingPrice>|null} [claimingPrices] RaceTypeClaimingPrice claimingPrices
           */

          /**
           * Constructs a new RaceTypeClaimingPrice.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceTypeClaimingPrice.
           * @implements IRaceTypeClaimingPrice
           * @constructor
           * @param {stronachgroup.first.racehorse360.IRaceTypeClaimingPrice=} [properties] Properties to set
           */
          function RaceTypeClaimingPrice(properties) {
            this.claimingPrices = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * RaceTypeClaimingPrice raceTypeId.
           * @member {string} raceTypeId
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @instance
           */
          RaceTypeClaimingPrice.prototype.raceTypeId = "";

          /**
           * RaceTypeClaimingPrice claimingPrices.
           * @member {Array.<stronachgroup.first.racehorse360.IClaimingPrice>} claimingPrices
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @instance
           */
          RaceTypeClaimingPrice.prototype.claimingPrices = $util.emptyArray;

          /**
           * Creates a new RaceTypeClaimingPrice instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceTypeClaimingPrice=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.RaceTypeClaimingPrice} RaceTypeClaimingPrice instance
           */
          RaceTypeClaimingPrice.create = function create(properties) {
            return new RaceTypeClaimingPrice(properties);
          };

          /**
           * Encodes the specified RaceTypeClaimingPrice message. Does not implicitly {@link stronachgroup.first.racehorse360.RaceTypeClaimingPrice.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.IRaceTypeClaimingPrice} message RaceTypeClaimingPrice message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          RaceTypeClaimingPrice.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.raceTypeId != null &&
              Object.hasOwnProperty.call(message, "raceTypeId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.raceTypeId);
            if (message.claimingPrices != null && message.claimingPrices.length)
              for (var i = 0; i < message.claimingPrices.length; ++i)
                $root.stronachgroup.first.racehorse360.ClaimingPrice.encode(
                  message.claimingPrices[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a RaceTypeClaimingPrice message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.RaceTypeClaimingPrice} RaceTypeClaimingPrice
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          RaceTypeClaimingPrice.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.raceTypeId = reader.string();
                  break;
                case 2:
                  if (
                    !(message.claimingPrices && message.claimingPrices.length)
                  )
                    message.claimingPrices = [];
                  message.claimingPrices.push(
                    $root.stronachgroup.first.racehorse360.ClaimingPrice.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a RaceTypeClaimingPrice message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.RaceTypeClaimingPrice} RaceTypeClaimingPrice
           */
          RaceTypeClaimingPrice.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.RaceTypeClaimingPrice();
            if (object.raceTypeId != null)
              message.raceTypeId = String(object.raceTypeId);
            if (object.claimingPrices) {
              if (!Array.isArray(object.claimingPrices))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.RaceTypeClaimingPrice.claimingPrices: array expected"
                );
              message.claimingPrices = [];
              for (var i = 0; i < object.claimingPrices.length; ++i) {
                if (typeof object.claimingPrices[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.RaceTypeClaimingPrice.claimingPrices: object expected"
                  );
                message.claimingPrices[i] =
                  $root.stronachgroup.first.racehorse360.ClaimingPrice.fromObject(
                    object.claimingPrices[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a RaceTypeClaimingPrice message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @static
           * @param {stronachgroup.first.racehorse360.RaceTypeClaimingPrice} message RaceTypeClaimingPrice
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          RaceTypeClaimingPrice.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.claimingPrices = [];
            if (options.defaults) object.raceTypeId = "";
            if (
              message.raceTypeId != null &&
              message.hasOwnProperty("raceTypeId")
            )
              object.raceTypeId = message.raceTypeId;
            if (message.claimingPrices && message.claimingPrices.length) {
              object.claimingPrices = [];
              for (var j = 0; j < message.claimingPrices.length; ++j)
                object.claimingPrices[j] =
                  $root.stronachgroup.first.racehorse360.ClaimingPrice.toObject(
                    message.claimingPrices[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this RaceTypeClaimingPrice to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.RaceTypeClaimingPrice
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          RaceTypeClaimingPrice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return RaceTypeClaimingPrice;
        })();

        racehorse360.ApplicationFeatureFlag = (function () {
          /**
           * Properties of an ApplicationFeatureFlag.
           * @memberof stronachgroup.first.racehorse360
           * @interface IApplicationFeatureFlag
           * @property {stronachgroup.first.racehorse360.ApplicationFeatureKey|null} [key] ApplicationFeatureFlag key
           * @property {boolean|null} [isEnabled] ApplicationFeatureFlag isEnabled
           */

          /**
           * Constructs a new ApplicationFeatureFlag.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an ApplicationFeatureFlag.
           * @implements IApplicationFeatureFlag
           * @constructor
           * @param {stronachgroup.first.racehorse360.IApplicationFeatureFlag=} [properties] Properties to set
           */
          function ApplicationFeatureFlag(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ApplicationFeatureFlag key.
           * @member {stronachgroup.first.racehorse360.ApplicationFeatureKey} key
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @instance
           */
          ApplicationFeatureFlag.prototype.key = 0;

          /**
           * ApplicationFeatureFlag isEnabled.
           * @member {boolean} isEnabled
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @instance
           */
          ApplicationFeatureFlag.prototype.isEnabled = false;

          /**
           * Creates a new ApplicationFeatureFlag instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IApplicationFeatureFlag=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ApplicationFeatureFlag} ApplicationFeatureFlag instance
           */
          ApplicationFeatureFlag.create = function create(properties) {
            return new ApplicationFeatureFlag(properties);
          };

          /**
           * Encodes the specified ApplicationFeatureFlag message. Does not implicitly {@link stronachgroup.first.racehorse360.ApplicationFeatureFlag.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @static
           * @param {stronachgroup.first.racehorse360.IApplicationFeatureFlag} message ApplicationFeatureFlag message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ApplicationFeatureFlag.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.key != null &&
              Object.hasOwnProperty.call(message, "key")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.key);
            if (
              message.isEnabled != null &&
              Object.hasOwnProperty.call(message, "isEnabled")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.isEnabled);
            return writer;
          };

          /**
           * Decodes an ApplicationFeatureFlag message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ApplicationFeatureFlag} ApplicationFeatureFlag
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ApplicationFeatureFlag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.key = reader.int32();
                  break;
                case 2:
                  message.isEnabled = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an ApplicationFeatureFlag message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ApplicationFeatureFlag} ApplicationFeatureFlag
           */
          ApplicationFeatureFlag.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag();
            switch (object.key) {
              case "APPLICATION_FEATURE_KEY_INVALID":
              case 0:
                message.key = 0;
                break;
              case "APPLICATION_FEATURE_KEY_STALL_APPLICATION_FORMS":
              case 1:
                message.key = 1;
                break;
              case "APPLICATION_FEATURE_KEY_WORK_ORDERS":
              case 2:
                message.key = 2;
                break;
              case "APPLICATION_FEATURE_KEY_INVENTORY_ANALYTICS":
              case 3:
                message.key = 3;
                break;
              case "APPLICATION_FEATURE_KEY_TRAINER_WORKOUT_REQUESTS":
              case 4:
                message.key = 4;
                break;
              case "APPLICATION_FEATURE_KEY_VET_WORKOUT_REQUESTS":
              case 5:
                message.key = 5;
                break;
              case "APPLICATION_FEATURE_KEY_TRACK_OPTICS":
              case 6:
                message.key = 6;
                break;
              case "APPLICATION_FEATURE_KEY_DASHBOARD_EXAM_REQUIREMENTS":
              case 7:
                message.key = 7;
                break;
            }
            if (object.isEnabled != null)
              message.isEnabled = Boolean(object.isEnabled);
            return message;
          };

          /**
           * Creates a plain object from an ApplicationFeatureFlag message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @static
           * @param {stronachgroup.first.racehorse360.ApplicationFeatureFlag} message ApplicationFeatureFlag
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ApplicationFeatureFlag.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.key =
                options.enums === String
                  ? "APPLICATION_FEATURE_KEY_INVALID"
                  : 0;
              object.isEnabled = false;
            }
            if (message.key != null && message.hasOwnProperty("key"))
              object.key =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .ApplicationFeatureKey[message.key]
                  : message.key;
            if (
              message.isEnabled != null &&
              message.hasOwnProperty("isEnabled")
            )
              object.isEnabled = message.isEnabled;
            return object;
          };

          /**
           * Converts this ApplicationFeatureFlag to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ApplicationFeatureFlag
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ApplicationFeatureFlag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ApplicationFeatureFlag;
        })();

        racehorse360.PullApplicationFeatureFlagsRequest = (function () {
          /**
           * Properties of a PullApplicationFeatureFlagsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullApplicationFeatureFlagsRequest
           * @property {Array.<stronachgroup.first.racehorse360.ApplicationFeatureKey>|null} [keys] PullApplicationFeatureFlagsRequest keys
           */

          /**
           * Constructs a new PullApplicationFeatureFlagsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullApplicationFeatureFlagsRequest.
           * @implements IPullApplicationFeatureFlagsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsRequest=} [properties] Properties to set
           */
          function PullApplicationFeatureFlagsRequest(properties) {
            this.keys = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullApplicationFeatureFlagsRequest keys.
           * @member {Array.<stronachgroup.first.racehorse360.ApplicationFeatureKey>} keys
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @instance
           */
          PullApplicationFeatureFlagsRequest.prototype.keys = $util.emptyArray;

          /**
           * Creates a new PullApplicationFeatureFlagsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} PullApplicationFeatureFlagsRequest instance
           */
          PullApplicationFeatureFlagsRequest.create = function create(
            properties
          ) {
            return new PullApplicationFeatureFlagsRequest(properties);
          };

          /**
           * Encodes the specified PullApplicationFeatureFlagsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsRequest} message PullApplicationFeatureFlagsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullApplicationFeatureFlagsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.keys != null && message.keys.length) {
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
              for (var i = 0; i < message.keys.length; ++i)
                writer.int32(message.keys[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes a PullApplicationFeatureFlagsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} PullApplicationFeatureFlagsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullApplicationFeatureFlagsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.keys && message.keys.length)) message.keys = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2) message.keys.push(reader.int32());
                  } else message.keys.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullApplicationFeatureFlagsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} PullApplicationFeatureFlagsRequest
           */
          PullApplicationFeatureFlagsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullApplicationFeatureFlagsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest();
            if (object.keys) {
              if (!Array.isArray(object.keys))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest.keys: array expected"
                );
              message.keys = [];
              for (var i = 0; i < object.keys.length; ++i)
                switch (object.keys[i]) {
                  default:
                  case "APPLICATION_FEATURE_KEY_INVALID":
                  case 0:
                    message.keys[i] = 0;
                    break;
                  case "APPLICATION_FEATURE_KEY_STALL_APPLICATION_FORMS":
                  case 1:
                    message.keys[i] = 1;
                    break;
                  case "APPLICATION_FEATURE_KEY_WORK_ORDERS":
                  case 2:
                    message.keys[i] = 2;
                    break;
                  case "APPLICATION_FEATURE_KEY_INVENTORY_ANALYTICS":
                  case 3:
                    message.keys[i] = 3;
                    break;
                  case "APPLICATION_FEATURE_KEY_TRAINER_WORKOUT_REQUESTS":
                  case 4:
                    message.keys[i] = 4;
                    break;
                  case "APPLICATION_FEATURE_KEY_VET_WORKOUT_REQUESTS":
                  case 5:
                    message.keys[i] = 5;
                    break;
                  case "APPLICATION_FEATURE_KEY_TRACK_OPTICS":
                  case 6:
                    message.keys[i] = 6;
                    break;
                  case "APPLICATION_FEATURE_KEY_DASHBOARD_EXAM_REQUIREMENTS":
                  case 7:
                    message.keys[i] = 7;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullApplicationFeatureFlagsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest} message PullApplicationFeatureFlagsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullApplicationFeatureFlagsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.keys = [];
            if (message.keys && message.keys.length) {
              object.keys = [];
              for (var j = 0; j < message.keys.length; ++j)
                object.keys[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .ApplicationFeatureKey[message.keys[j]]
                    : message.keys[j];
            }
            return object;
          };

          /**
           * Converts this PullApplicationFeatureFlagsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullApplicationFeatureFlagsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullApplicationFeatureFlagsRequest;
        })();

        racehorse360.PullApplicationFeatureFlagsResponse = (function () {
          /**
           * Properties of a PullApplicationFeatureFlagsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullApplicationFeatureFlagsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IApplicationFeatureFlag>|null} [featureFlags] PullApplicationFeatureFlagsResponse featureFlags
           */

          /**
           * Constructs a new PullApplicationFeatureFlagsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullApplicationFeatureFlagsResponse.
           * @implements IPullApplicationFeatureFlagsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsResponse=} [properties] Properties to set
           */
          function PullApplicationFeatureFlagsResponse(properties) {
            this.featureFlags = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullApplicationFeatureFlagsResponse featureFlags.
           * @member {Array.<stronachgroup.first.racehorse360.IApplicationFeatureFlag>} featureFlags
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @instance
           */
          PullApplicationFeatureFlagsResponse.prototype.featureFlags =
            $util.emptyArray;

          /**
           * Creates a new PullApplicationFeatureFlagsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse} PullApplicationFeatureFlagsResponse instance
           */
          PullApplicationFeatureFlagsResponse.create = function create(
            properties
          ) {
            return new PullApplicationFeatureFlagsResponse(properties);
          };

          /**
           * Encodes the specified PullApplicationFeatureFlagsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullApplicationFeatureFlagsResponse} message PullApplicationFeatureFlagsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullApplicationFeatureFlagsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.featureFlags != null && message.featureFlags.length)
              for (var i = 0; i < message.featureFlags.length; ++i)
                $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag.encode(
                  message.featureFlags[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullApplicationFeatureFlagsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse} PullApplicationFeatureFlagsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullApplicationFeatureFlagsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.featureFlags && message.featureFlags.length))
                    message.featureFlags = [];
                  message.featureFlags.push(
                    $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullApplicationFeatureFlagsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse} PullApplicationFeatureFlagsResponse
           */
          PullApplicationFeatureFlagsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullApplicationFeatureFlagsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse();
            if (object.featureFlags) {
              if (!Array.isArray(object.featureFlags))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse.featureFlags: array expected"
                );
              message.featureFlags = [];
              for (var i = 0; i < object.featureFlags.length; ++i) {
                if (typeof object.featureFlags[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse.featureFlags: object expected"
                  );
                message.featureFlags[i] =
                  $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag.fromObject(
                    object.featureFlags[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullApplicationFeatureFlagsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse} message PullApplicationFeatureFlagsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullApplicationFeatureFlagsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.featureFlags = [];
            if (message.featureFlags && message.featureFlags.length) {
              object.featureFlags = [];
              for (var j = 0; j < message.featureFlags.length; ++j)
                object.featureFlags[j] =
                  $root.stronachgroup.first.racehorse360.ApplicationFeatureFlag.toObject(
                    message.featureFlags[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullApplicationFeatureFlagsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullApplicationFeatureFlagsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullApplicationFeatureFlagsResponse;
        })();

        racehorse360.HorseGeneralVetComment = (function () {
          /**
           * Properties of a HorseGeneralVetComment.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseGeneralVetComment
           * @property {string|null} [id] HorseGeneralVetComment id
           * @property {string|null} [horseId] HorseGeneralVetComment horseId
           * @property {string|null} [body] HorseGeneralVetComment body
           * @property {string|null} [warningMessage] HorseGeneralVetComment warningMessage
           * @property {string|null} [createdOn] HorseGeneralVetComment createdOn
           * @property {string|null} [updatedOn] HorseGeneralVetComment updatedOn
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] HorseGeneralVetComment createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] HorseGeneralVetComment updatedBy
           */

          /**
           * Constructs a new HorseGeneralVetComment.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseGeneralVetComment.
           * @implements IHorseGeneralVetComment
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseGeneralVetComment=} [properties] Properties to set
           */
          function HorseGeneralVetComment(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseGeneralVetComment id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.id = "";

          /**
           * HorseGeneralVetComment horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.horseId = "";

          /**
           * HorseGeneralVetComment body.
           * @member {string} body
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.body = "";

          /**
           * HorseGeneralVetComment warningMessage.
           * @member {string} warningMessage
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.warningMessage = "";

          /**
           * HorseGeneralVetComment createdOn.
           * @member {string} createdOn
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.createdOn = "";

          /**
           * HorseGeneralVetComment updatedOn.
           * @member {string} updatedOn
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.updatedOn = "";

          /**
           * HorseGeneralVetComment createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.createdBy = null;

          /**
           * HorseGeneralVetComment updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           */
          HorseGeneralVetComment.prototype.updatedBy = null;

          /**
           * Creates a new HorseGeneralVetComment instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseGeneralVetComment=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseGeneralVetComment} HorseGeneralVetComment instance
           */
          HorseGeneralVetComment.create = function create(properties) {
            return new HorseGeneralVetComment(properties);
          };

          /**
           * Encodes the specified HorseGeneralVetComment message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseGeneralVetComment.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseGeneralVetComment} message HorseGeneralVetComment message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseGeneralVetComment.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.horseId);
            if (
              message.body != null &&
              Object.hasOwnProperty.call(message, "body")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.body);
            if (
              message.warningMessage != null &&
              Object.hasOwnProperty.call(message, "warningMessage")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.warningMessage);
            if (
              message.createdOn != null &&
              Object.hasOwnProperty.call(message, "createdOn")
            )
              writer
                .uint32(/* id 1001, wireType 2 =*/ 8010)
                .string(message.createdOn);
            if (
              message.updatedOn != null &&
              Object.hasOwnProperty.call(message, "updatedOn")
            )
              writer
                .uint32(/* id 1002, wireType 2 =*/ 8018)
                .string(message.updatedOn);
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseGeneralVetComment message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseGeneralVetComment} HorseGeneralVetComment
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseGeneralVetComment.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseGeneralVetComment();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horseId = reader.string();
                  break;
                case 3:
                  message.body = reader.string();
                  break;
                case 4:
                  message.warningMessage = reader.string();
                  break;
                case 1001:
                  message.createdOn = reader.string();
                  break;
                case 1002:
                  message.updatedOn = reader.string();
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseGeneralVetComment message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseGeneralVetComment} HorseGeneralVetComment
           */
          HorseGeneralVetComment.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseGeneralVetComment
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseGeneralVetComment();
            if (object.id != null) message.id = String(object.id);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.body != null) message.body = String(object.body);
            if (object.warningMessage != null)
              message.warningMessage = String(object.warningMessage);
            if (object.createdOn != null)
              message.createdOn = String(object.createdOn);
            if (object.updatedOn != null)
              message.updatedOn = String(object.updatedOn);
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseGeneralVetComment.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseGeneralVetComment.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseGeneralVetComment message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @static
           * @param {stronachgroup.first.racehorse360.HorseGeneralVetComment} message HorseGeneralVetComment
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseGeneralVetComment.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horseId = "";
              object.body = "";
              object.warningMessage = "";
              object.createdOn = "";
              object.updatedOn = "";
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.body != null && message.hasOwnProperty("body"))
              object.body = message.body;
            if (
              message.warningMessage != null &&
              message.hasOwnProperty("warningMessage")
            )
              object.warningMessage = message.warningMessage;
            if (
              message.createdOn != null &&
              message.hasOwnProperty("createdOn")
            )
              object.createdOn = message.createdOn;
            if (
              message.updatedOn != null &&
              message.hasOwnProperty("updatedOn")
            )
              object.updatedOn = message.updatedOn;
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this HorseGeneralVetComment to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseGeneralVetComment
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseGeneralVetComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseGeneralVetComment;
        })();

        racehorse360.CreateHorseGeneralVetCommentRequest = (function () {
          /**
           * Properties of a CreateHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateHorseGeneralVetCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseGeneralVetComment|null} [horseGeneralVetComment] CreateHorseGeneralVetCommentRequest horseGeneralVetComment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateHorseGeneralVetCommentRequest getOptions
           */

          /**
           * Constructs a new CreateHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateHorseGeneralVetCommentRequest.
           * @implements ICreateHorseGeneralVetCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateHorseGeneralVetCommentRequest=} [properties] Properties to set
           */
          function CreateHorseGeneralVetCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateHorseGeneralVetCommentRequest horseGeneralVetComment.
           * @member {stronachgroup.first.racehorse360.IHorseGeneralVetComment|null|undefined} horseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @instance
           */
          CreateHorseGeneralVetCommentRequest.prototype.horseGeneralVetComment =
            null;

          /**
           * CreateHorseGeneralVetCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @instance
           */
          CreateHorseGeneralVetCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateHorseGeneralVetCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseGeneralVetCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} CreateHorseGeneralVetCommentRequest instance
           */
          CreateHorseGeneralVetCommentRequest.create = function create(
            properties
          ) {
            return new CreateHorseGeneralVetCommentRequest(properties);
          };

          /**
           * Encodes the specified CreateHorseGeneralVetCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateHorseGeneralVetCommentRequest} message CreateHorseGeneralVetCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateHorseGeneralVetCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseGeneralVetComment != null &&
              Object.hasOwnProperty.call(message, "horseGeneralVetComment")
            )
              $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.encode(
                message.horseGeneralVetComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateHorseGeneralVetCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} CreateHorseGeneralVetCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateHorseGeneralVetCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseGeneralVetComment =
                    $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateHorseGeneralVetCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} CreateHorseGeneralVetCommentRequest
           */
          CreateHorseGeneralVetCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateHorseGeneralVetCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest();
            if (object.horseGeneralVetComment != null) {
              if (typeof object.horseGeneralVetComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest.horseGeneralVetComment: object expected"
                );
              message.horseGeneralVetComment =
                $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.fromObject(
                  object.horseGeneralVetComment
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateHorseGeneralVetCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest} message CreateHorseGeneralVetCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateHorseGeneralVetCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseGeneralVetComment = null;
              object.getOptions = null;
            }
            if (
              message.horseGeneralVetComment != null &&
              message.hasOwnProperty("horseGeneralVetComment")
            )
              object.horseGeneralVetComment =
                $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.toObject(
                  message.horseGeneralVetComment,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateHorseGeneralVetCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateHorseGeneralVetCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateHorseGeneralVetCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return CreateHorseGeneralVetCommentRequest;
        })();

        racehorse360.DeleteHorseGeneralVetCommentRequest = (function () {
          /**
           * Properties of a DeleteHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteHorseGeneralVetCommentRequest
           * @property {string|null} [id] DeleteHorseGeneralVetCommentRequest id
           */

          /**
           * Constructs a new DeleteHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteHorseGeneralVetCommentRequest.
           * @implements IDeleteHorseGeneralVetCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteHorseGeneralVetCommentRequest=} [properties] Properties to set
           */
          function DeleteHorseGeneralVetCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteHorseGeneralVetCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @instance
           */
          DeleteHorseGeneralVetCommentRequest.prototype.id = "";

          /**
           * Creates a new DeleteHorseGeneralVetCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseGeneralVetCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} DeleteHorseGeneralVetCommentRequest instance
           */
          DeleteHorseGeneralVetCommentRequest.create = function create(
            properties
          ) {
            return new DeleteHorseGeneralVetCommentRequest(properties);
          };

          /**
           * Encodes the specified DeleteHorseGeneralVetCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteHorseGeneralVetCommentRequest} message DeleteHorseGeneralVetCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteHorseGeneralVetCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteHorseGeneralVetCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} DeleteHorseGeneralVetCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteHorseGeneralVetCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteHorseGeneralVetCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} DeleteHorseGeneralVetCommentRequest
           */
          DeleteHorseGeneralVetCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteHorseGeneralVetCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteHorseGeneralVetCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest} message DeleteHorseGeneralVetCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteHorseGeneralVetCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteHorseGeneralVetCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteHorseGeneralVetCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteHorseGeneralVetCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return DeleteHorseGeneralVetCommentRequest;
        })();

        racehorse360.UpdateHorseGeneralVetCommentRequest = (function () {
          /**
           * Properties of an UpdateHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateHorseGeneralVetCommentRequest
           * @property {stronachgroup.first.racehorse360.IHorseGeneralVetComment|null} [horseGeneralVetComment] UpdateHorseGeneralVetCommentRequest horseGeneralVetComment
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateHorseGeneralVetCommentRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateHorseGeneralVetCommentRequest getOptions
           */

          /**
           * Constructs a new UpdateHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateHorseGeneralVetCommentRequest.
           * @implements IUpdateHorseGeneralVetCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateHorseGeneralVetCommentRequest=} [properties] Properties to set
           */
          function UpdateHorseGeneralVetCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateHorseGeneralVetCommentRequest horseGeneralVetComment.
           * @member {stronachgroup.first.racehorse360.IHorseGeneralVetComment|null|undefined} horseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @instance
           */
          UpdateHorseGeneralVetCommentRequest.prototype.horseGeneralVetComment =
            null;

          /**
           * UpdateHorseGeneralVetCommentRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @instance
           */
          UpdateHorseGeneralVetCommentRequest.prototype.updateMask = null;

          /**
           * UpdateHorseGeneralVetCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @instance
           */
          UpdateHorseGeneralVetCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateHorseGeneralVetCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseGeneralVetCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} UpdateHorseGeneralVetCommentRequest instance
           */
          UpdateHorseGeneralVetCommentRequest.create = function create(
            properties
          ) {
            return new UpdateHorseGeneralVetCommentRequest(properties);
          };

          /**
           * Encodes the specified UpdateHorseGeneralVetCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateHorseGeneralVetCommentRequest} message UpdateHorseGeneralVetCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateHorseGeneralVetCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseGeneralVetComment != null &&
              Object.hasOwnProperty.call(message, "horseGeneralVetComment")
            )
              $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.encode(
                message.horseGeneralVetComment,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateHorseGeneralVetCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} UpdateHorseGeneralVetCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateHorseGeneralVetCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseGeneralVetComment =
                    $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateHorseGeneralVetCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} UpdateHorseGeneralVetCommentRequest
           */
          UpdateHorseGeneralVetCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateHorseGeneralVetCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest();
            if (object.horseGeneralVetComment != null) {
              if (typeof object.horseGeneralVetComment !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest.horseGeneralVetComment: object expected"
                );
              message.horseGeneralVetComment =
                $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.fromObject(
                  object.horseGeneralVetComment
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateHorseGeneralVetCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest} message UpdateHorseGeneralVetCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateHorseGeneralVetCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.horseGeneralVetComment = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.horseGeneralVetComment != null &&
              message.hasOwnProperty("horseGeneralVetComment")
            )
              object.horseGeneralVetComment =
                $root.stronachgroup.first.racehorse360.HorseGeneralVetComment.toObject(
                  message.horseGeneralVetComment,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateHorseGeneralVetCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateHorseGeneralVetCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateHorseGeneralVetCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UpdateHorseGeneralVetCommentRequest;
        })();

        racehorse360.GetHorseGeneralVetCommentRequest = (function () {
          /**
           * Properties of a GetHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetHorseGeneralVetCommentRequest
           * @property {string|null} [id] GetHorseGeneralVetCommentRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetHorseGeneralVetCommentRequest getOptions
           */

          /**
           * Constructs a new GetHorseGeneralVetCommentRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetHorseGeneralVetCommentRequest.
           * @implements IGetHorseGeneralVetCommentRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetHorseGeneralVetCommentRequest=} [properties] Properties to set
           */
          function GetHorseGeneralVetCommentRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetHorseGeneralVetCommentRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @instance
           */
          GetHorseGeneralVetCommentRequest.prototype.id = "";

          /**
           * GetHorseGeneralVetCommentRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @instance
           */
          GetHorseGeneralVetCommentRequest.prototype.getOptions = null;

          /**
           * Creates a new GetHorseGeneralVetCommentRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseGeneralVetCommentRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} GetHorseGeneralVetCommentRequest instance
           */
          GetHorseGeneralVetCommentRequest.create = function create(
            properties
          ) {
            return new GetHorseGeneralVetCommentRequest(properties);
          };

          /**
           * Encodes the specified GetHorseGeneralVetCommentRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetHorseGeneralVetCommentRequest} message GetHorseGeneralVetCommentRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetHorseGeneralVetCommentRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetHorseGeneralVetCommentRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} GetHorseGeneralVetCommentRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetHorseGeneralVetCommentRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetHorseGeneralVetCommentRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} GetHorseGeneralVetCommentRequest
           */
          GetHorseGeneralVetCommentRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .GetHorseGeneralVetCommentRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetHorseGeneralVetCommentRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest} message GetHorseGeneralVetCommentRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetHorseGeneralVetCommentRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetHorseGeneralVetCommentRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetHorseGeneralVetCommentRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetHorseGeneralVetCommentRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return GetHorseGeneralVetCommentRequest;
        })();

        racehorse360.PageLocker = (function () {
          /**
           * Properties of a PageLocker.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPageLocker
           * @property {string|null} [id] PageLocker id
           * @property {string|null} [lockedById] PageLocker lockedById
           * @property {string|null} [startedOn] PageLocker startedOn
           * @property {string|null} [expiresOn] PageLocker expiresOn
           */

          /**
           * Constructs a new PageLocker.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PageLocker.
           * @implements IPageLocker
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPageLocker=} [properties] Properties to set
           */
          function PageLocker(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PageLocker id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @instance
           */
          PageLocker.prototype.id = "";

          /**
           * PageLocker lockedById.
           * @member {string} lockedById
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @instance
           */
          PageLocker.prototype.lockedById = "";

          /**
           * PageLocker startedOn.
           * @member {string} startedOn
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @instance
           */
          PageLocker.prototype.startedOn = "";

          /**
           * PageLocker expiresOn.
           * @member {string} expiresOn
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @instance
           */
          PageLocker.prototype.expiresOn = "";

          /**
           * Creates a new PageLocker instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @static
           * @param {stronachgroup.first.racehorse360.IPageLocker=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PageLocker} PageLocker instance
           */
          PageLocker.create = function create(properties) {
            return new PageLocker(properties);
          };

          /**
           * Encodes the specified PageLocker message. Does not implicitly {@link stronachgroup.first.racehorse360.PageLocker.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @static
           * @param {stronachgroup.first.racehorse360.IPageLocker} message PageLocker message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PageLocker.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.lockedById != null &&
              Object.hasOwnProperty.call(message, "lockedById")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.lockedById);
            if (
              message.startedOn != null &&
              Object.hasOwnProperty.call(message, "startedOn")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.startedOn);
            if (
              message.expiresOn != null &&
              Object.hasOwnProperty.call(message, "expiresOn")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.expiresOn);
            return writer;
          };

          /**
           * Decodes a PageLocker message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PageLocker} PageLocker
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PageLocker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.racehorse360.PageLocker();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.lockedById = reader.string();
                  break;
                case 3:
                  message.startedOn = reader.string();
                  break;
                case 4:
                  message.expiresOn = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PageLocker message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PageLocker} PageLocker
           */
          PageLocker.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PageLocker
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PageLocker();
            if (object.id != null) message.id = String(object.id);
            if (object.lockedById != null)
              message.lockedById = String(object.lockedById);
            if (object.startedOn != null)
              message.startedOn = String(object.startedOn);
            if (object.expiresOn != null)
              message.expiresOn = String(object.expiresOn);
            return message;
          };

          /**
           * Creates a plain object from a PageLocker message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @static
           * @param {stronachgroup.first.racehorse360.PageLocker} message PageLocker
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PageLocker.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.lockedById = "";
              object.startedOn = "";
              object.expiresOn = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.lockedById != null &&
              message.hasOwnProperty("lockedById")
            )
              object.lockedById = message.lockedById;
            if (
              message.startedOn != null &&
              message.hasOwnProperty("startedOn")
            )
              object.startedOn = message.startedOn;
            if (
              message.expiresOn != null &&
              message.hasOwnProperty("expiresOn")
            )
              object.expiresOn = message.expiresOn;
            return object;
          };

          /**
           * Converts this PageLocker to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PageLocker
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PageLocker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PageLocker;
        })();

        racehorse360.PageLockerRequest = (function () {
          /**
           * Properties of a PageLockerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPageLockerRequest
           * @property {string|null} [recordId] PageLockerRequest recordId
           * @property {stronachgroup.first.racehorse360.LockerPageType|null} [lockerPageType] PageLockerRequest lockerPageType
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] PageLockerRequest getOptions
           */

          /**
           * Constructs a new PageLockerRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PageLockerRequest.
           * @implements IPageLockerRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest=} [properties] Properties to set
           */
          function PageLockerRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PageLockerRequest recordId.
           * @member {string} recordId
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @instance
           */
          PageLockerRequest.prototype.recordId = "";

          /**
           * PageLockerRequest lockerPageType.
           * @member {stronachgroup.first.racehorse360.LockerPageType} lockerPageType
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @instance
           */
          PageLockerRequest.prototype.lockerPageType = 0;

          /**
           * PageLockerRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @instance
           */
          PageLockerRequest.prototype.getOptions = null;

          /**
           * Creates a new PageLockerRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PageLockerRequest} PageLockerRequest instance
           */
          PageLockerRequest.create = function create(properties) {
            return new PageLockerRequest(properties);
          };

          /**
           * Encodes the specified PageLockerRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PageLockerRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} message PageLockerRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PageLockerRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.recordId != null &&
              Object.hasOwnProperty.call(message, "recordId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.recordId);
            if (
              message.lockerPageType != null &&
              Object.hasOwnProperty.call(message, "lockerPageType")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.lockerPageType);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PageLockerRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PageLockerRequest} PageLockerRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PageLockerRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PageLockerRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.recordId = reader.string();
                  break;
                case 2:
                  message.lockerPageType = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PageLockerRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PageLockerRequest} PageLockerRequest
           */
          PageLockerRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PageLockerRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PageLockerRequest();
            if (object.recordId != null)
              message.recordId = String(object.recordId);
            switch (object.lockerPageType) {
              case "LOCKER_PAGE_TYPE_INVALID":
              case 0:
                message.lockerPageType = 0;
                break;
              case "LOCKER_PAGE_TYPE_HORSE_EXAM_PAGE":
              case 1:
                message.lockerPageType = 1;
                break;
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PageLockerRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PageLockerRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PageLockerRequest} message PageLockerRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PageLockerRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.recordId = "";
              object.lockerPageType =
                options.enums === String ? "LOCKER_PAGE_TYPE_INVALID" : 0;
              object.getOptions = null;
            }
            if (message.recordId != null && message.hasOwnProperty("recordId"))
              object.recordId = message.recordId;
            if (
              message.lockerPageType != null &&
              message.hasOwnProperty("lockerPageType")
            )
              object.lockerPageType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.LockerPageType[
                      message.lockerPageType
                    ]
                  : message.lockerPageType;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this PageLockerRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PageLockerRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PageLockerRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PageLockerRequest;
        })();

        racehorse360.TriggerPageLockerResponse = (function () {
          /**
           * Properties of a TriggerPageLockerResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITriggerPageLockerResponse
           * @property {boolean|null} [isSucceeded] TriggerPageLockerResponse isSucceeded
           * @property {stronachgroup.first.racehorse360.IPageLocker|null} [pageLocker] TriggerPageLockerResponse pageLocker
           */

          /**
           * Constructs a new TriggerPageLockerResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TriggerPageLockerResponse.
           * @implements ITriggerPageLockerResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITriggerPageLockerResponse=} [properties] Properties to set
           */
          function TriggerPageLockerResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TriggerPageLockerResponse isSucceeded.
           * @member {boolean} isSucceeded
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @instance
           */
          TriggerPageLockerResponse.prototype.isSucceeded = false;

          /**
           * TriggerPageLockerResponse pageLocker.
           * @member {stronachgroup.first.racehorse360.IPageLocker|null|undefined} pageLocker
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @instance
           */
          TriggerPageLockerResponse.prototype.pageLocker = null;

          /**
           * Creates a new TriggerPageLockerResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ITriggerPageLockerResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TriggerPageLockerResponse} TriggerPageLockerResponse instance
           */
          TriggerPageLockerResponse.create = function create(properties) {
            return new TriggerPageLockerResponse(properties);
          };

          /**
           * Encodes the specified TriggerPageLockerResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.TriggerPageLockerResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ITriggerPageLockerResponse} message TriggerPageLockerResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TriggerPageLockerResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.isSucceeded != null &&
              Object.hasOwnProperty.call(message, "isSucceeded")
            )
              writer
                .uint32(/* id 1, wireType 0 =*/ 8)
                .bool(message.isSucceeded);
            if (
              message.pageLocker != null &&
              Object.hasOwnProperty.call(message, "pageLocker")
            )
              $root.stronachgroup.first.racehorse360.PageLocker.encode(
                message.pageLocker,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a TriggerPageLockerResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TriggerPageLockerResponse} TriggerPageLockerResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TriggerPageLockerResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TriggerPageLockerResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.isSucceeded = reader.bool();
                  break;
                case 2:
                  message.pageLocker =
                    $root.stronachgroup.first.racehorse360.PageLocker.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TriggerPageLockerResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TriggerPageLockerResponse} TriggerPageLockerResponse
           */
          TriggerPageLockerResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TriggerPageLockerResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TriggerPageLockerResponse();
            if (object.isSucceeded != null)
              message.isSucceeded = Boolean(object.isSucceeded);
            if (object.pageLocker != null) {
              if (typeof object.pageLocker !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TriggerPageLockerResponse.pageLocker: object expected"
                );
              message.pageLocker =
                $root.stronachgroup.first.racehorse360.PageLocker.fromObject(
                  object.pageLocker
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a TriggerPageLockerResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.TriggerPageLockerResponse} message TriggerPageLockerResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TriggerPageLockerResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.isSucceeded = false;
              object.pageLocker = null;
            }
            if (
              message.isSucceeded != null &&
              message.hasOwnProperty("isSucceeded")
            )
              object.isSucceeded = message.isSucceeded;
            if (
              message.pageLocker != null &&
              message.hasOwnProperty("pageLocker")
            )
              object.pageLocker =
                $root.stronachgroup.first.racehorse360.PageLocker.toObject(
                  message.pageLocker,
                  options
                );
            return object;
          };

          /**
           * Converts this TriggerPageLockerResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TriggerPageLockerResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TriggerPageLockerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TriggerPageLockerResponse;
        })();

        racehorse360.PullPageLockerResponse = (function () {
          /**
           * Properties of a PullPageLockerResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullPageLockerResponse
           * @property {boolean|null} [isLocked] PullPageLockerResponse isLocked
           * @property {stronachgroup.first.racehorse360.IPageLocker|null} [pageLocker] PullPageLockerResponse pageLocker
           */

          /**
           * Constructs a new PullPageLockerResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullPageLockerResponse.
           * @implements IPullPageLockerResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullPageLockerResponse=} [properties] Properties to set
           */
          function PullPageLockerResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullPageLockerResponse isLocked.
           * @member {boolean} isLocked
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @instance
           */
          PullPageLockerResponse.prototype.isLocked = false;

          /**
           * PullPageLockerResponse pageLocker.
           * @member {stronachgroup.first.racehorse360.IPageLocker|null|undefined} pageLocker
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @instance
           */
          PullPageLockerResponse.prototype.pageLocker = null;

          /**
           * Creates a new PullPageLockerResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullPageLockerResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullPageLockerResponse} PullPageLockerResponse instance
           */
          PullPageLockerResponse.create = function create(properties) {
            return new PullPageLockerResponse(properties);
          };

          /**
           * Encodes the specified PullPageLockerResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullPageLockerResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullPageLockerResponse} message PullPageLockerResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullPageLockerResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.isLocked != null &&
              Object.hasOwnProperty.call(message, "isLocked")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.isLocked);
            if (
              message.pageLocker != null &&
              Object.hasOwnProperty.call(message, "pageLocker")
            )
              $root.stronachgroup.first.racehorse360.PageLocker.encode(
                message.pageLocker,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullPageLockerResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullPageLockerResponse} PullPageLockerResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullPageLockerResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullPageLockerResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.isLocked = reader.bool();
                  break;
                case 2:
                  message.pageLocker =
                    $root.stronachgroup.first.racehorse360.PageLocker.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullPageLockerResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullPageLockerResponse} PullPageLockerResponse
           */
          PullPageLockerResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.PullPageLockerResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullPageLockerResponse();
            if (object.isLocked != null)
              message.isLocked = Boolean(object.isLocked);
            if (object.pageLocker != null) {
              if (typeof object.pageLocker !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullPageLockerResponse.pageLocker: object expected"
                );
              message.pageLocker =
                $root.stronachgroup.first.racehorse360.PageLocker.fromObject(
                  object.pageLocker
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a PullPageLockerResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullPageLockerResponse} message PullPageLockerResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullPageLockerResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.isLocked = false;
              object.pageLocker = null;
            }
            if (message.isLocked != null && message.hasOwnProperty("isLocked"))
              object.isLocked = message.isLocked;
            if (
              message.pageLocker != null &&
              message.hasOwnProperty("pageLocker")
            )
              object.pageLocker =
                $root.stronachgroup.first.racehorse360.PageLocker.toObject(
                  message.pageLocker,
                  options
                );
            return object;
          };

          /**
           * Converts this PullPageLockerResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullPageLockerResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullPageLockerResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullPageLockerResponse;
        })();

        racehorse360.StallApplicationForm = (function () {
          /**
           * Properties of a StallApplicationForm.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStallApplicationForm
           * @property {string|null} [id] StallApplicationForm id
           * @property {string|null} [title] StallApplicationForm title
           * @property {string|null} [startDate] StallApplicationForm startDate
           * @property {string|null} [deadlineDate] StallApplicationForm deadlineDate
           * @property {string|null} [closeDate] StallApplicationForm closeDate
           * @property {number|null} [stallApplicationsCount] StallApplicationForm stallApplicationsCount
           * @property {Array.<stronachgroup.first.racehorse360.IFacility>|null} [facilityOptions] StallApplicationForm facilityOptions
           * @property {stronachgroup.first.racehorse360.IUser|null} [createdBy] StallApplicationForm createdBy
           * @property {stronachgroup.first.racehorse360.IUser|null} [updatedBy] StallApplicationForm updatedBy
           */

          /**
           * Constructs a new StallApplicationForm.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StallApplicationForm.
           * @implements IStallApplicationForm
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStallApplicationForm=} [properties] Properties to set
           */
          function StallApplicationForm(properties) {
            this.facilityOptions = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StallApplicationForm id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.id = "";

          /**
           * StallApplicationForm title.
           * @member {string} title
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.title = "";

          /**
           * StallApplicationForm startDate.
           * @member {string} startDate
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.startDate = "";

          /**
           * StallApplicationForm deadlineDate.
           * @member {string} deadlineDate
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.deadlineDate = "";

          /**
           * StallApplicationForm closeDate.
           * @member {string} closeDate
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.closeDate = "";

          /**
           * StallApplicationForm stallApplicationsCount.
           * @member {number} stallApplicationsCount
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.stallApplicationsCount = 0;

          /**
           * StallApplicationForm facilityOptions.
           * @member {Array.<stronachgroup.first.racehorse360.IFacility>} facilityOptions
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.facilityOptions = $util.emptyArray;

          /**
           * StallApplicationForm createdBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} createdBy
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.createdBy = null;

          /**
           * StallApplicationForm updatedBy.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} updatedBy
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           */
          StallApplicationForm.prototype.updatedBy = null;

          /**
           * Creates a new StallApplicationForm instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationForm=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StallApplicationForm} StallApplicationForm instance
           */
          StallApplicationForm.create = function create(properties) {
            return new StallApplicationForm(properties);
          };

          /**
           * Encodes the specified StallApplicationForm message. Does not implicitly {@link stronachgroup.first.racehorse360.StallApplicationForm.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationForm} message StallApplicationForm message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StallApplicationForm.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.title != null &&
              Object.hasOwnProperty.call(message, "title")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.title);
            if (
              message.startDate != null &&
              Object.hasOwnProperty.call(message, "startDate")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.startDate);
            if (
              message.deadlineDate != null &&
              Object.hasOwnProperty.call(message, "deadlineDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.deadlineDate);
            if (
              message.closeDate != null &&
              Object.hasOwnProperty.call(message, "closeDate")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.closeDate);
            if (
              message.stallApplicationsCount != null &&
              Object.hasOwnProperty.call(message, "stallApplicationsCount")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.stallApplicationsCount);
            if (
              message.facilityOptions != null &&
              message.facilityOptions.length
            )
              for (var i = 0; i < message.facilityOptions.length; ++i)
                $root.stronachgroup.first.racehorse360.Facility.encode(
                  message.facilityOptions[i],
                  writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
                ).ldelim();
            if (
              message.createdBy != null &&
              Object.hasOwnProperty.call(message, "createdBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.createdBy,
                writer.uint32(/* id 1003, wireType 2 =*/ 8026).fork()
              ).ldelim();
            if (
              message.updatedBy != null &&
              Object.hasOwnProperty.call(message, "updatedBy")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.updatedBy,
                writer.uint32(/* id 1004, wireType 2 =*/ 8034).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a StallApplicationForm message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StallApplicationForm} StallApplicationForm
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StallApplicationForm.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StallApplicationForm();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.title = reader.string();
                  break;
                case 3:
                  message.startDate = reader.string();
                  break;
                case 4:
                  message.deadlineDate = reader.string();
                  break;
                case 5:
                  message.closeDate = reader.string();
                  break;
                case 6:
                  message.stallApplicationsCount = reader.int32();
                  break;
                case 7:
                  if (
                    !(message.facilityOptions && message.facilityOptions.length)
                  )
                    message.facilityOptions = [];
                  message.facilityOptions.push(
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 1003:
                  message.createdBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 1004:
                  message.updatedBy =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StallApplicationForm message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StallApplicationForm} StallApplicationForm
           */
          StallApplicationForm.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StallApplicationForm
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StallApplicationForm();
            if (object.id != null) message.id = String(object.id);
            if (object.title != null) message.title = String(object.title);
            if (object.startDate != null)
              message.startDate = String(object.startDate);
            if (object.deadlineDate != null)
              message.deadlineDate = String(object.deadlineDate);
            if (object.closeDate != null)
              message.closeDate = String(object.closeDate);
            if (object.stallApplicationsCount != null)
              message.stallApplicationsCount =
                object.stallApplicationsCount | 0;
            if (object.facilityOptions) {
              if (!Array.isArray(object.facilityOptions))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationForm.facilityOptions: array expected"
                );
              message.facilityOptions = [];
              for (var i = 0; i < object.facilityOptions.length; ++i) {
                if (typeof object.facilityOptions[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.StallApplicationForm.facilityOptions: object expected"
                  );
                message.facilityOptions[i] =
                  $root.stronachgroup.first.racehorse360.Facility.fromObject(
                    object.facilityOptions[i]
                  );
              }
            }
            if (object.createdBy != null) {
              if (typeof object.createdBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationForm.createdBy: object expected"
                );
              message.createdBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.createdBy
                );
            }
            if (object.updatedBy != null) {
              if (typeof object.updatedBy !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationForm.updatedBy: object expected"
                );
              message.updatedBy =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.updatedBy
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a StallApplicationForm message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @static
           * @param {stronachgroup.first.racehorse360.StallApplicationForm} message StallApplicationForm
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StallApplicationForm.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityOptions = [];
            if (options.defaults) {
              object.id = "";
              object.title = "";
              object.startDate = "";
              object.deadlineDate = "";
              object.closeDate = "";
              object.stallApplicationsCount = 0;
              object.createdBy = null;
              object.updatedBy = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
              object.title = message.title;
            if (
              message.startDate != null &&
              message.hasOwnProperty("startDate")
            )
              object.startDate = message.startDate;
            if (
              message.deadlineDate != null &&
              message.hasOwnProperty("deadlineDate")
            )
              object.deadlineDate = message.deadlineDate;
            if (
              message.closeDate != null &&
              message.hasOwnProperty("closeDate")
            )
              object.closeDate = message.closeDate;
            if (
              message.stallApplicationsCount != null &&
              message.hasOwnProperty("stallApplicationsCount")
            )
              object.stallApplicationsCount = message.stallApplicationsCount;
            if (message.facilityOptions && message.facilityOptions.length) {
              object.facilityOptions = [];
              for (var j = 0; j < message.facilityOptions.length; ++j)
                object.facilityOptions[j] =
                  $root.stronachgroup.first.racehorse360.Facility.toObject(
                    message.facilityOptions[j],
                    options
                  );
            }
            if (
              message.createdBy != null &&
              message.hasOwnProperty("createdBy")
            )
              object.createdBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.createdBy,
                  options
                );
            if (
              message.updatedBy != null &&
              message.hasOwnProperty("updatedBy")
            )
              object.updatedBy =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.updatedBy,
                  options
                );
            return object;
          };

          /**
           * Converts this StallApplicationForm to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StallApplicationForm
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StallApplicationForm.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StallApplicationForm;
        })();

        racehorse360.ListStallApplicationFormsRequest = (function () {
          /**
           * Properties of a ListStallApplicationFormsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStallApplicationFormsRequest
           * @property {stronachgroup.first.racehorse360.IStallApplicationFormFilter|null} [query] ListStallApplicationFormsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListStallApplicationFormsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListStallApplicationFormsRequest pagingOptions
           */

          /**
           * Constructs a new ListStallApplicationFormsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStallApplicationFormsRequest.
           * @implements IListStallApplicationFormsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsRequest=} [properties] Properties to set
           */
          function ListStallApplicationFormsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStallApplicationFormsRequest query.
           * @member {stronachgroup.first.racehorse360.IStallApplicationFormFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @instance
           */
          ListStallApplicationFormsRequest.prototype.query = null;

          /**
           * ListStallApplicationFormsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @instance
           */
          ListStallApplicationFormsRequest.prototype.getOptions = null;

          /**
           * ListStallApplicationFormsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @instance
           */
          ListStallApplicationFormsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListStallApplicationFormsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} ListStallApplicationFormsRequest instance
           */
          ListStallApplicationFormsRequest.create = function create(
            properties
          ) {
            return new ListStallApplicationFormsRequest(properties);
          };

          /**
           * Encodes the specified ListStallApplicationFormsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStallApplicationFormsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsRequest} message ListStallApplicationFormsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStallApplicationFormsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.StallApplicationFormFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStallApplicationFormsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} ListStallApplicationFormsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStallApplicationFormsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.StallApplicationFormFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStallApplicationFormsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} ListStallApplicationFormsRequest
           */
          ListStallApplicationFormsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListStallApplicationFormsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationFormsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.StallApplicationFormFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationFormsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationFormsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStallApplicationFormsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} message ListStallApplicationFormsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStallApplicationFormsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.StallApplicationFormFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStallApplicationFormsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStallApplicationFormsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListStallApplicationFormsRequest;
        })();

        racehorse360.StallApplicationFormFilter = (function () {
          /**
           * Properties of a StallApplicationFormFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStallApplicationFormFilter
           * @property {Array.<string>|null} [ids] StallApplicationFormFilter ids
           * @property {Array.<string>|null} [createdByIds] StallApplicationFormFilter createdByIds
           */

          /**
           * Constructs a new StallApplicationFormFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StallApplicationFormFilter.
           * @implements IStallApplicationFormFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStallApplicationFormFilter=} [properties] Properties to set
           */
          function StallApplicationFormFilter(properties) {
            this.ids = [];
            this.createdByIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StallApplicationFormFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @instance
           */
          StallApplicationFormFilter.prototype.ids = $util.emptyArray;

          /**
           * StallApplicationFormFilter createdByIds.
           * @member {Array.<string>} createdByIds
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @instance
           */
          StallApplicationFormFilter.prototype.createdByIds = $util.emptyArray;

          /**
           * Creates a new StallApplicationFormFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationFormFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StallApplicationFormFilter} StallApplicationFormFilter instance
           */
          StallApplicationFormFilter.create = function create(properties) {
            return new StallApplicationFormFilter(properties);
          };

          /**
           * Encodes the specified StallApplicationFormFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.StallApplicationFormFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationFormFilter} message StallApplicationFormFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StallApplicationFormFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (message.createdByIds != null && message.createdByIds.length)
              for (var i = 0; i < message.createdByIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.createdByIds[i]);
            return writer;
          };

          /**
           * Decodes a StallApplicationFormFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StallApplicationFormFilter} StallApplicationFormFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StallApplicationFormFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StallApplicationFormFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (!(message.createdByIds && message.createdByIds.length))
                    message.createdByIds = [];
                  message.createdByIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StallApplicationFormFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StallApplicationFormFilter} StallApplicationFormFilter
           */
          StallApplicationFormFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StallApplicationFormFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StallApplicationFormFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFormFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.createdByIds) {
              if (!Array.isArray(object.createdByIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFormFilter.createdByIds: array expected"
                );
              message.createdByIds = [];
              for (var i = 0; i < object.createdByIds.length; ++i)
                message.createdByIds[i] = String(object.createdByIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a StallApplicationFormFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @static
           * @param {stronachgroup.first.racehorse360.StallApplicationFormFilter} message StallApplicationFormFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StallApplicationFormFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.createdByIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (message.createdByIds && message.createdByIds.length) {
              object.createdByIds = [];
              for (var j = 0; j < message.createdByIds.length; ++j)
                object.createdByIds[j] = message.createdByIds[j];
            }
            return object;
          };

          /**
           * Converts this StallApplicationFormFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StallApplicationFormFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StallApplicationFormFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StallApplicationFormFilter;
        })();

        racehorse360.ListStallApplicationFormsResponse = (function () {
          /**
           * Properties of a ListStallApplicationFormsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStallApplicationFormsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IStallApplicationForm>|null} [stallApplicationForms] ListStallApplicationFormsResponse stallApplicationForms
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListStallApplicationFormsResponse pagingInfo
           */

          /**
           * Constructs a new ListStallApplicationFormsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStallApplicationFormsResponse.
           * @implements IListStallApplicationFormsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsResponse=} [properties] Properties to set
           */
          function ListStallApplicationFormsResponse(properties) {
            this.stallApplicationForms = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStallApplicationFormsResponse stallApplicationForms.
           * @member {Array.<stronachgroup.first.racehorse360.IStallApplicationForm>} stallApplicationForms
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @instance
           */
          ListStallApplicationFormsResponse.prototype.stallApplicationForms =
            $util.emptyArray;

          /**
           * ListStallApplicationFormsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @instance
           */
          ListStallApplicationFormsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListStallApplicationFormsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsResponse} ListStallApplicationFormsResponse instance
           */
          ListStallApplicationFormsResponse.create = function create(
            properties
          ) {
            return new ListStallApplicationFormsResponse(properties);
          };

          /**
           * Encodes the specified ListStallApplicationFormsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStallApplicationFormsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsResponse} message ListStallApplicationFormsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStallApplicationFormsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationForms != null &&
              message.stallApplicationForms.length
            )
              for (var i = 0; i < message.stallApplicationForms.length; ++i)
                $root.stronachgroup.first.racehorse360.StallApplicationForm.encode(
                  message.stallApplicationForms[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStallApplicationFormsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsResponse} ListStallApplicationFormsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStallApplicationFormsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.stallApplicationForms &&
                      message.stallApplicationForms.length
                    )
                  )
                    message.stallApplicationForms = [];
                  message.stallApplicationForms.push(
                    $root.stronachgroup.first.racehorse360.StallApplicationForm.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStallApplicationFormsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationFormsResponse} ListStallApplicationFormsResponse
           */
          ListStallApplicationFormsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListStallApplicationFormsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse();
            if (object.stallApplicationForms) {
              if (!Array.isArray(object.stallApplicationForms))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationFormsResponse.stallApplicationForms: array expected"
                );
              message.stallApplicationForms = [];
              for (var i = 0; i < object.stallApplicationForms.length; ++i) {
                if (typeof object.stallApplicationForms[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListStallApplicationFormsResponse.stallApplicationForms: object expected"
                  );
                message.stallApplicationForms[i] =
                  $root.stronachgroup.first.racehorse360.StallApplicationForm.fromObject(
                    object.stallApplicationForms[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationFormsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStallApplicationFormsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListStallApplicationFormsResponse} message ListStallApplicationFormsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStallApplicationFormsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.stallApplicationForms = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.stallApplicationForms &&
              message.stallApplicationForms.length
            ) {
              object.stallApplicationForms = [];
              for (var j = 0; j < message.stallApplicationForms.length; ++j)
                object.stallApplicationForms[j] =
                  $root.stronachgroup.first.racehorse360.StallApplicationForm.toObject(
                    message.stallApplicationForms[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStallApplicationFormsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationFormsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStallApplicationFormsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListStallApplicationFormsResponse;
        })();

        racehorse360.GetStallApplicationFormRequest = (function () {
          /**
           * Properties of a GetStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetStallApplicationFormRequest
           * @property {string|null} [id] GetStallApplicationFormRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetStallApplicationFormRequest getOptions
           */

          /**
           * Constructs a new GetStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetStallApplicationFormRequest.
           * @implements IGetStallApplicationFormRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationFormRequest=} [properties] Properties to set
           */
          function GetStallApplicationFormRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetStallApplicationFormRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @instance
           */
          GetStallApplicationFormRequest.prototype.id = "";

          /**
           * GetStallApplicationFormRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @instance
           */
          GetStallApplicationFormRequest.prototype.getOptions = null;

          /**
           * Creates a new GetStallApplicationFormRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationFormRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationFormRequest} GetStallApplicationFormRequest instance
           */
          GetStallApplicationFormRequest.create = function create(properties) {
            return new GetStallApplicationFormRequest(properties);
          };

          /**
           * Encodes the specified GetStallApplicationFormRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetStallApplicationFormRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationFormRequest} message GetStallApplicationFormRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetStallApplicationFormRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetStallApplicationFormRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationFormRequest} GetStallApplicationFormRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetStallApplicationFormRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetStallApplicationFormRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetStallApplicationFormRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationFormRequest} GetStallApplicationFormRequest
           */
          GetStallApplicationFormRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .GetStallApplicationFormRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetStallApplicationFormRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetStallApplicationFormRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetStallApplicationFormRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetStallApplicationFormRequest} message GetStallApplicationFormRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetStallApplicationFormRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetStallApplicationFormRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationFormRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetStallApplicationFormRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetStallApplicationFormRequest;
        })();

        racehorse360.CreateStallApplicationFormRequest = (function () {
          /**
           * Properties of a CreateStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateStallApplicationFormRequest
           * @property {stronachgroup.first.racehorse360.IStallApplicationForm|null} [stallApplicationForm] CreateStallApplicationFormRequest stallApplicationForm
           * @property {Uint8Array|null} [termsFile] CreateStallApplicationFormRequest termsFile
           * @property {boolean|null} [shouldSkipTermsFileUpload] CreateStallApplicationFormRequest shouldSkipTermsFileUpload
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateStallApplicationFormRequest getOptions
           */

          /**
           * Constructs a new CreateStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateStallApplicationFormRequest.
           * @implements ICreateStallApplicationFormRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationFormRequest=} [properties] Properties to set
           */
          function CreateStallApplicationFormRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateStallApplicationFormRequest stallApplicationForm.
           * @member {stronachgroup.first.racehorse360.IStallApplicationForm|null|undefined} stallApplicationForm
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @instance
           */
          CreateStallApplicationFormRequest.prototype.stallApplicationForm =
            null;

          /**
           * CreateStallApplicationFormRequest termsFile.
           * @member {Uint8Array} termsFile
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @instance
           */
          CreateStallApplicationFormRequest.prototype.termsFile =
            $util.newBuffer([]);

          /**
           * CreateStallApplicationFormRequest shouldSkipTermsFileUpload.
           * @member {boolean} shouldSkipTermsFileUpload
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @instance
           */
          CreateStallApplicationFormRequest.prototype.shouldSkipTermsFileUpload = false;

          /**
           * CreateStallApplicationFormRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @instance
           */
          CreateStallApplicationFormRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateStallApplicationFormRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationFormRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} CreateStallApplicationFormRequest instance
           */
          CreateStallApplicationFormRequest.create = function create(
            properties
          ) {
            return new CreateStallApplicationFormRequest(properties);
          };

          /**
           * Encodes the specified CreateStallApplicationFormRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateStallApplicationFormRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationFormRequest} message CreateStallApplicationFormRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateStallApplicationFormRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationForm != null &&
              Object.hasOwnProperty.call(message, "stallApplicationForm")
            )
              $root.stronachgroup.first.racehorse360.StallApplicationForm.encode(
                message.stallApplicationForm,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.termsFile != null &&
              Object.hasOwnProperty.call(message, "termsFile")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .bytes(message.termsFile);
            if (
              message.shouldSkipTermsFileUpload != null &&
              Object.hasOwnProperty.call(message, "shouldSkipTermsFileUpload")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .bool(message.shouldSkipTermsFileUpload);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateStallApplicationFormRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} CreateStallApplicationFormRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateStallApplicationFormRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationForm =
                    $root.stronachgroup.first.racehorse360.StallApplicationForm.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.termsFile = reader.bytes();
                  break;
                case 3:
                  message.shouldSkipTermsFileUpload = reader.bool();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateStallApplicationFormRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} CreateStallApplicationFormRequest
           */
          CreateStallApplicationFormRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateStallApplicationFormRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest();
            if (object.stallApplicationForm != null) {
              if (typeof object.stallApplicationForm !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStallApplicationFormRequest.stallApplicationForm: object expected"
                );
              message.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.fromObject(
                  object.stallApplicationForm
                );
            }
            if (object.termsFile != null)
              if (typeof object.termsFile === "string")
                $util.base64.decode(
                  object.termsFile,
                  (message.termsFile = $util.newBuffer(
                    $util.base64.length(object.termsFile)
                  )),
                  0
                );
              else if (object.termsFile.length)
                message.termsFile = object.termsFile;
            if (object.shouldSkipTermsFileUpload != null)
              message.shouldSkipTermsFileUpload = Boolean(
                object.shouldSkipTermsFileUpload
              );
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStallApplicationFormRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateStallApplicationFormRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} message CreateStallApplicationFormRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateStallApplicationFormRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplicationForm = null;
              if (options.bytes === String) object.termsFile = "";
              else {
                object.termsFile = [];
                if (options.bytes !== Array)
                  object.termsFile = $util.newBuffer(object.termsFile);
              }
              object.shouldSkipTermsFileUpload = false;
              object.getOptions = null;
            }
            if (
              message.stallApplicationForm != null &&
              message.hasOwnProperty("stallApplicationForm")
            )
              object.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.toObject(
                  message.stallApplicationForm,
                  options
                );
            if (
              message.termsFile != null &&
              message.hasOwnProperty("termsFile")
            )
              object.termsFile =
                options.bytes === String
                  ? $util.base64.encode(
                      message.termsFile,
                      0,
                      message.termsFile.length
                    )
                  : options.bytes === Array
                  ? Array.prototype.slice.call(message.termsFile)
                  : message.termsFile;
            if (
              message.shouldSkipTermsFileUpload != null &&
              message.hasOwnProperty("shouldSkipTermsFileUpload")
            )
              object.shouldSkipTermsFileUpload =
                message.shouldSkipTermsFileUpload;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateStallApplicationFormRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationFormRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateStallApplicationFormRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return CreateStallApplicationFormRequest;
        })();

        racehorse360.UpdateStallApplicationFormRequest = (function () {
          /**
           * Properties of an UpdateStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateStallApplicationFormRequest
           * @property {stronachgroup.first.racehorse360.IStallApplicationForm|null} [stallApplicationForm] UpdateStallApplicationFormRequest stallApplicationForm
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStallApplicationFormRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateStallApplicationFormRequest getOptions
           */

          /**
           * Constructs a new UpdateStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateStallApplicationFormRequest.
           * @implements IUpdateStallApplicationFormRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationFormRequest=} [properties] Properties to set
           */
          function UpdateStallApplicationFormRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateStallApplicationFormRequest stallApplicationForm.
           * @member {stronachgroup.first.racehorse360.IStallApplicationForm|null|undefined} stallApplicationForm
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @instance
           */
          UpdateStallApplicationFormRequest.prototype.stallApplicationForm =
            null;

          /**
           * UpdateStallApplicationFormRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @instance
           */
          UpdateStallApplicationFormRequest.prototype.updateMask = null;

          /**
           * UpdateStallApplicationFormRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @instance
           */
          UpdateStallApplicationFormRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateStallApplicationFormRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationFormRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} UpdateStallApplicationFormRequest instance
           */
          UpdateStallApplicationFormRequest.create = function create(
            properties
          ) {
            return new UpdateStallApplicationFormRequest(properties);
          };

          /**
           * Encodes the specified UpdateStallApplicationFormRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationFormRequest} message UpdateStallApplicationFormRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateStallApplicationFormRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationForm != null &&
              Object.hasOwnProperty.call(message, "stallApplicationForm")
            )
              $root.stronachgroup.first.racehorse360.StallApplicationForm.encode(
                message.stallApplicationForm,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateStallApplicationFormRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} UpdateStallApplicationFormRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateStallApplicationFormRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationForm =
                    $root.stronachgroup.first.racehorse360.StallApplicationForm.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateStallApplicationFormRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} UpdateStallApplicationFormRequest
           */
          UpdateStallApplicationFormRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateStallApplicationFormRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest();
            if (object.stallApplicationForm != null) {
              if (typeof object.stallApplicationForm !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest.stallApplicationForm: object expected"
                );
              message.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.fromObject(
                  object.stallApplicationForm
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateStallApplicationFormRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} message UpdateStallApplicationFormRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateStallApplicationFormRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplicationForm = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.stallApplicationForm != null &&
              message.hasOwnProperty("stallApplicationForm")
            )
              object.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.toObject(
                  message.stallApplicationForm,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateStallApplicationFormRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateStallApplicationFormRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UpdateStallApplicationFormRequest;
        })();

        racehorse360.DeleteStallApplicationFormRequest = (function () {
          /**
           * Properties of a DeleteStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteStallApplicationFormRequest
           * @property {string|null} [id] DeleteStallApplicationFormRequest id
           * @property {boolean|null} [shouldSkipTermsFileDelete] DeleteStallApplicationFormRequest shouldSkipTermsFileDelete
           */

          /**
           * Constructs a new DeleteStallApplicationFormRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteStallApplicationFormRequest.
           * @implements IDeleteStallApplicationFormRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationFormRequest=} [properties] Properties to set
           */
          function DeleteStallApplicationFormRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteStallApplicationFormRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @instance
           */
          DeleteStallApplicationFormRequest.prototype.id = "";

          /**
           * DeleteStallApplicationFormRequest shouldSkipTermsFileDelete.
           * @member {boolean} shouldSkipTermsFileDelete
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @instance
           */
          DeleteStallApplicationFormRequest.prototype.shouldSkipTermsFileDelete = false;

          /**
           * Creates a new DeleteStallApplicationFormRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationFormRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} DeleteStallApplicationFormRequest instance
           */
          DeleteStallApplicationFormRequest.create = function create(
            properties
          ) {
            return new DeleteStallApplicationFormRequest(properties);
          };

          /**
           * Encodes the specified DeleteStallApplicationFormRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationFormRequest} message DeleteStallApplicationFormRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteStallApplicationFormRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.shouldSkipTermsFileDelete != null &&
              Object.hasOwnProperty.call(message, "shouldSkipTermsFileDelete")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .bool(message.shouldSkipTermsFileDelete);
            return writer;
          };

          /**
           * Decodes a DeleteStallApplicationFormRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} DeleteStallApplicationFormRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteStallApplicationFormRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.shouldSkipTermsFileDelete = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteStallApplicationFormRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} DeleteStallApplicationFormRequest
           */
          DeleteStallApplicationFormRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteStallApplicationFormRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.shouldSkipTermsFileDelete != null)
              message.shouldSkipTermsFileDelete = Boolean(
                object.shouldSkipTermsFileDelete
              );
            return message;
          };

          /**
           * Creates a plain object from a DeleteStallApplicationFormRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} message DeleteStallApplicationFormRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteStallApplicationFormRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.shouldSkipTermsFileDelete = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.shouldSkipTermsFileDelete != null &&
              message.hasOwnProperty("shouldSkipTermsFileDelete")
            )
              object.shouldSkipTermsFileDelete =
                message.shouldSkipTermsFileDelete;
            return object;
          };

          /**
           * Converts this DeleteStallApplicationFormRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteStallApplicationFormRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return DeleteStallApplicationFormRequest;
        })();

        racehorse360.SetFacilityOptionsRequest = (function () {
          /**
           * Properties of a SetFacilityOptionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetFacilityOptionsRequest
           * @property {string|null} [stallApplicationFormId] SetFacilityOptionsRequest stallApplicationFormId
           * @property {Array.<string>|null} [facilityIds] SetFacilityOptionsRequest facilityIds
           */

          /**
           * Constructs a new SetFacilityOptionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetFacilityOptionsRequest.
           * @implements ISetFacilityOptionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetFacilityOptionsRequest=} [properties] Properties to set
           */
          function SetFacilityOptionsRequest(properties) {
            this.facilityIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetFacilityOptionsRequest stallApplicationFormId.
           * @member {string} stallApplicationFormId
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @instance
           */
          SetFacilityOptionsRequest.prototype.stallApplicationFormId = "";

          /**
           * SetFacilityOptionsRequest facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @instance
           */
          SetFacilityOptionsRequest.prototype.facilityIds = $util.emptyArray;

          /**
           * Creates a new SetFacilityOptionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetFacilityOptionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetFacilityOptionsRequest} SetFacilityOptionsRequest instance
           */
          SetFacilityOptionsRequest.create = function create(properties) {
            return new SetFacilityOptionsRequest(properties);
          };

          /**
           * Encodes the specified SetFacilityOptionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetFacilityOptionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetFacilityOptionsRequest} message SetFacilityOptionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetFacilityOptionsRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationFormId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationFormId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationFormId);
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.facilityIds[i]);
            return writer;
          };

          /**
           * Decodes a SetFacilityOptionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetFacilityOptionsRequest} SetFacilityOptionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetFacilityOptionsRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetFacilityOptionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationFormId = reader.string();
                  break;
                case 2:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetFacilityOptionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetFacilityOptionsRequest} SetFacilityOptionsRequest
           */
          SetFacilityOptionsRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.SetFacilityOptionsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetFacilityOptionsRequest();
            if (object.stallApplicationFormId != null)
              message.stallApplicationFormId = String(
                object.stallApplicationFormId
              );
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SetFacilityOptionsRequest.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a SetFacilityOptionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetFacilityOptionsRequest} message SetFacilityOptionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetFacilityOptionsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.facilityIds = [];
            if (options.defaults) object.stallApplicationFormId = "";
            if (
              message.stallApplicationFormId != null &&
              message.hasOwnProperty("stallApplicationFormId")
            )
              object.stallApplicationFormId = message.stallApplicationFormId;
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            return object;
          };

          /**
           * Converts this SetFacilityOptionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetFacilityOptionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetFacilityOptionsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetFacilityOptionsRequest;
        })();

        racehorse360.SetFacilityPreferencesRequest = (function () {
          /**
           * Properties of a SetFacilityPreferencesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISetFacilityPreferencesRequest
           * @property {string|null} [stallApplicationId] SetFacilityPreferencesRequest stallApplicationId
           * @property {string|null} [firstChoiceFacilityId] SetFacilityPreferencesRequest firstChoiceFacilityId
           * @property {string|null} [secondChoiceFacilityId] SetFacilityPreferencesRequest secondChoiceFacilityId
           */

          /**
           * Constructs a new SetFacilityPreferencesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SetFacilityPreferencesRequest.
           * @implements ISetFacilityPreferencesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISetFacilityPreferencesRequest=} [properties] Properties to set
           */
          function SetFacilityPreferencesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SetFacilityPreferencesRequest stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @instance
           */
          SetFacilityPreferencesRequest.prototype.stallApplicationId = "";

          /**
           * SetFacilityPreferencesRequest firstChoiceFacilityId.
           * @member {string} firstChoiceFacilityId
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @instance
           */
          SetFacilityPreferencesRequest.prototype.firstChoiceFacilityId = "";

          /**
           * SetFacilityPreferencesRequest secondChoiceFacilityId.
           * @member {string} secondChoiceFacilityId
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @instance
           */
          SetFacilityPreferencesRequest.prototype.secondChoiceFacilityId = "";

          /**
           * Creates a new SetFacilityPreferencesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetFacilityPreferencesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} SetFacilityPreferencesRequest instance
           */
          SetFacilityPreferencesRequest.create = function create(properties) {
            return new SetFacilityPreferencesRequest(properties);
          };

          /**
           * Encodes the specified SetFacilityPreferencesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SetFacilityPreferencesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISetFacilityPreferencesRequest} message SetFacilityPreferencesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SetFacilityPreferencesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationId);
            if (
              message.firstChoiceFacilityId != null &&
              Object.hasOwnProperty.call(message, "firstChoiceFacilityId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.firstChoiceFacilityId);
            if (
              message.secondChoiceFacilityId != null &&
              Object.hasOwnProperty.call(message, "secondChoiceFacilityId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.secondChoiceFacilityId);
            return writer;
          };

          /**
           * Decodes a SetFacilityPreferencesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} SetFacilityPreferencesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SetFacilityPreferencesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationId = reader.string();
                  break;
                case 2:
                  message.firstChoiceFacilityId = reader.string();
                  break;
                case 3:
                  message.secondChoiceFacilityId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SetFacilityPreferencesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} SetFacilityPreferencesRequest
           */
          SetFacilityPreferencesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SetFacilityPreferencesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest();
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            if (object.firstChoiceFacilityId != null)
              message.firstChoiceFacilityId = String(
                object.firstChoiceFacilityId
              );
            if (object.secondChoiceFacilityId != null)
              message.secondChoiceFacilityId = String(
                object.secondChoiceFacilityId
              );
            return message;
          };

          /**
           * Creates a plain object from a SetFacilityPreferencesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} message SetFacilityPreferencesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SetFacilityPreferencesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplicationId = "";
              object.firstChoiceFacilityId = "";
              object.secondChoiceFacilityId = "";
            }
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            if (
              message.firstChoiceFacilityId != null &&
              message.hasOwnProperty("firstChoiceFacilityId")
            )
              object.firstChoiceFacilityId = message.firstChoiceFacilityId;
            if (
              message.secondChoiceFacilityId != null &&
              message.hasOwnProperty("secondChoiceFacilityId")
            )
              object.secondChoiceFacilityId = message.secondChoiceFacilityId;
            return object;
          };

          /**
           * Converts this SetFacilityPreferencesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SetFacilityPreferencesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SetFacilityPreferencesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SetFacilityPreferencesRequest;
        })();

        racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest =
          (function () {
            /**
             * Properties of a PullStallApplicationFormTermsFileSignedUrlRequest.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullStallApplicationFormTermsFileSignedUrlRequest
             * @property {string|null} [stallApplicationFormId] PullStallApplicationFormTermsFileSignedUrlRequest stallApplicationFormId
             */

            /**
             * Constructs a new PullStallApplicationFormTermsFileSignedUrlRequest.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullStallApplicationFormTermsFileSignedUrlRequest.
             * @implements IPullStallApplicationFormTermsFileSignedUrlRequest
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlRequest=} [properties] Properties to set
             */
            function PullStallApplicationFormTermsFileSignedUrlRequest(
              properties
            ) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullStallApplicationFormTermsFileSignedUrlRequest stallApplicationFormId.
             * @member {string} stallApplicationFormId
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @instance
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.prototype.stallApplicationFormId =
              "";

            /**
             * Creates a new PullStallApplicationFormTermsFileSignedUrlRequest instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlRequest=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} PullStallApplicationFormTermsFileSignedUrlRequest instance
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.create =
              function create(properties) {
                return new PullStallApplicationFormTermsFileSignedUrlRequest(
                  properties
                );
              };

            /**
             * Encodes the specified PullStallApplicationFormTermsFileSignedUrlRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @static
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlRequest} message PullStallApplicationFormTermsFileSignedUrlRequest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.stallApplicationFormId != null &&
                  Object.hasOwnProperty.call(message, "stallApplicationFormId")
                )
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(message.stallApplicationFormId);
                return writer;
              };

            /**
             * Decodes a PullStallApplicationFormTermsFileSignedUrlRequest message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} PullStallApplicationFormTermsFileSignedUrlRequest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.stallApplicationFormId = reader.string();
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullStallApplicationFormTermsFileSignedUrlRequest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} PullStallApplicationFormTermsFileSignedUrlRequest
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormTermsFileSignedUrlRequest
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest();
                if (object.stallApplicationFormId != null)
                  message.stallApplicationFormId = String(
                    object.stallApplicationFormId
                  );
                return message;
              };

            /**
             * Creates a plain object from a PullStallApplicationFormTermsFileSignedUrlRequest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @static
             * @param {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} message PullStallApplicationFormTermsFileSignedUrlRequest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) object.stallApplicationFormId = "";
                if (
                  message.stallApplicationFormId != null &&
                  message.hasOwnProperty("stallApplicationFormId")
                )
                  object.stallApplicationFormId =
                    message.stallApplicationFormId;
                return object;
              };

            /**
             * Converts this PullStallApplicationFormTermsFileSignedUrlRequest to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullStallApplicationFormTermsFileSignedUrlRequest.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullStallApplicationFormTermsFileSignedUrlRequest;
          })();

        racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse =
          (function () {
            /**
             * Properties of a PullStallApplicationFormTermsFileSignedUrlResponse.
             * @memberof stronachgroup.first.racehorse360
             * @interface IPullStallApplicationFormTermsFileSignedUrlResponse
             * @property {string|null} [signedUrl] PullStallApplicationFormTermsFileSignedUrlResponse signedUrl
             */

            /**
             * Constructs a new PullStallApplicationFormTermsFileSignedUrlResponse.
             * @memberof stronachgroup.first.racehorse360
             * @classdesc Represents a PullStallApplicationFormTermsFileSignedUrlResponse.
             * @implements IPullStallApplicationFormTermsFileSignedUrlResponse
             * @constructor
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlResponse=} [properties] Properties to set
             */
            function PullStallApplicationFormTermsFileSignedUrlResponse(
              properties
            ) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * PullStallApplicationFormTermsFileSignedUrlResponse signedUrl.
             * @member {string} signedUrl
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @instance
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.prototype.signedUrl =
              "";

            /**
             * Creates a new PullStallApplicationFormTermsFileSignedUrlResponse instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlResponse=} [properties] Properties to set
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse} PullStallApplicationFormTermsFileSignedUrlResponse instance
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.create =
              function create(properties) {
                return new PullStallApplicationFormTermsFileSignedUrlResponse(
                  properties
                );
              };

            /**
             * Encodes the specified PullStallApplicationFormTermsFileSignedUrlResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @static
             * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlResponse} message PullStallApplicationFormTermsFileSignedUrlResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.encode =
              function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.signedUrl != null &&
                  Object.hasOwnProperty.call(message, "signedUrl")
                )
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(message.signedUrl);
                return writer;
              };

            /**
             * Decodes a PullStallApplicationFormTermsFileSignedUrlResponse message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse} PullStallApplicationFormTermsFileSignedUrlResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.decode =
              function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      message.signedUrl = reader.string();
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

            /**
             * Creates a PullStallApplicationFormTermsFileSignedUrlResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse} PullStallApplicationFormTermsFileSignedUrlResponse
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.fromObject =
              function fromObject(object) {
                if (
                  object instanceof
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormTermsFileSignedUrlResponse
                )
                  return object;
                var message =
                  new $root.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse();
                if (object.signedUrl != null)
                  message.signedUrl = String(object.signedUrl);
                return message;
              };

            /**
             * Creates a plain object from a PullStallApplicationFormTermsFileSignedUrlResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @static
             * @param {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse} message PullStallApplicationFormTermsFileSignedUrlResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.toObject =
              function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) object.signedUrl = "";
                if (
                  message.signedUrl != null &&
                  message.hasOwnProperty("signedUrl")
                )
                  object.signedUrl = message.signedUrl;
                return object;
              };

            /**
             * Converts this PullStallApplicationFormTermsFileSignedUrlResponse to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PullStallApplicationFormTermsFileSignedUrlResponse.prototype.toJSON =
              function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

            return PullStallApplicationFormTermsFileSignedUrlResponse;
          })();

        racehorse360.PullStallApplicationFormSummaryRequest = (function () {
          /**
           * Properties of a PullStallApplicationFormSummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullStallApplicationFormSummaryRequest
           * @property {string|null} [stallApplicationFormId] PullStallApplicationFormSummaryRequest stallApplicationFormId
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [contactFullName] PullStallApplicationFormSummaryRequest contactFullName
           */

          /**
           * Constructs a new PullStallApplicationFormSummaryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullStallApplicationFormSummaryRequest.
           * @implements IPullStallApplicationFormSummaryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryRequest=} [properties] Properties to set
           */
          function PullStallApplicationFormSummaryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullStallApplicationFormSummaryRequest stallApplicationFormId.
           * @member {string} stallApplicationFormId
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @instance
           */
          PullStallApplicationFormSummaryRequest.prototype.stallApplicationFormId =
            "";

          /**
           * PullStallApplicationFormSummaryRequest contactFullName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} contactFullName
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @instance
           */
          PullStallApplicationFormSummaryRequest.prototype.contactFullName =
            null;

          /**
           * Creates a new PullStallApplicationFormSummaryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} PullStallApplicationFormSummaryRequest instance
           */
          PullStallApplicationFormSummaryRequest.create = function create(
            properties
          ) {
            return new PullStallApplicationFormSummaryRequest(properties);
          };

          /**
           * Encodes the specified PullStallApplicationFormSummaryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryRequest} message PullStallApplicationFormSummaryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullStallApplicationFormSummaryRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationFormId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationFormId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationFormId);
            if (
              message.contactFullName != null &&
              Object.hasOwnProperty.call(message, "contactFullName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.contactFullName,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullStallApplicationFormSummaryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} PullStallApplicationFormSummaryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullStallApplicationFormSummaryRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationFormId = reader.string();
                  break;
                case 2:
                  message.contactFullName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullStallApplicationFormSummaryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} PullStallApplicationFormSummaryRequest
           */
          PullStallApplicationFormSummaryRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullStallApplicationFormSummaryRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest();
              if (object.stallApplicationFormId != null)
                message.stallApplicationFormId = String(
                  object.stallApplicationFormId
                );
              if (object.contactFullName != null) {
                if (typeof object.contactFullName !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest.contactFullName: object expected"
                  );
                message.contactFullName =
                  $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                    object.contactFullName
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a PullStallApplicationFormSummaryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} message PullStallApplicationFormSummaryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullStallApplicationFormSummaryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplicationFormId = "";
              object.contactFullName = null;
            }
            if (
              message.stallApplicationFormId != null &&
              message.hasOwnProperty("stallApplicationFormId")
            )
              object.stallApplicationFormId = message.stallApplicationFormId;
            if (
              message.contactFullName != null &&
              message.hasOwnProperty("contactFullName")
            )
              object.contactFullName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.contactFullName,
                  options
                );
            return object;
          };

          /**
           * Converts this PullStallApplicationFormSummaryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullStallApplicationFormSummaryRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullStallApplicationFormSummaryRequest;
        })();

        racehorse360.PullStallApplicationFormSummaryResponse = (function () {
          /**
           * Properties of a PullStallApplicationFormSummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullStallApplicationFormSummaryResponse
           * @property {number|null} [applicantsCount] PullStallApplicationFormSummaryResponse applicantsCount
           * @property {number|null} [reviewedCount] PullStallApplicationFormSummaryResponse reviewedCount
           * @property {number|null} [inProgressCount] PullStallApplicationFormSummaryResponse inProgressCount
           */

          /**
           * Constructs a new PullStallApplicationFormSummaryResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullStallApplicationFormSummaryResponse.
           * @implements IPullStallApplicationFormSummaryResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryResponse=} [properties] Properties to set
           */
          function PullStallApplicationFormSummaryResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullStallApplicationFormSummaryResponse applicantsCount.
           * @member {number} applicantsCount
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @instance
           */
          PullStallApplicationFormSummaryResponse.prototype.applicantsCount = 0;

          /**
           * PullStallApplicationFormSummaryResponse reviewedCount.
           * @member {number} reviewedCount
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @instance
           */
          PullStallApplicationFormSummaryResponse.prototype.reviewedCount = 0;

          /**
           * PullStallApplicationFormSummaryResponse inProgressCount.
           * @member {number} inProgressCount
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @instance
           */
          PullStallApplicationFormSummaryResponse.prototype.inProgressCount = 0;

          /**
           * Creates a new PullStallApplicationFormSummaryResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse} PullStallApplicationFormSummaryResponse instance
           */
          PullStallApplicationFormSummaryResponse.create = function create(
            properties
          ) {
            return new PullStallApplicationFormSummaryResponse(properties);
          };

          /**
           * Encodes the specified PullStallApplicationFormSummaryResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryResponse} message PullStallApplicationFormSummaryResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullStallApplicationFormSummaryResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.applicantsCount != null &&
              Object.hasOwnProperty.call(message, "applicantsCount")
            )
              writer
                .uint32(/* id 1, wireType 0 =*/ 8)
                .int32(message.applicantsCount);
            if (
              message.reviewedCount != null &&
              Object.hasOwnProperty.call(message, "reviewedCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.reviewedCount);
            if (
              message.inProgressCount != null &&
              Object.hasOwnProperty.call(message, "inProgressCount")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.inProgressCount);
            return writer;
          };

          /**
           * Decodes a PullStallApplicationFormSummaryResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse} PullStallApplicationFormSummaryResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullStallApplicationFormSummaryResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.applicantsCount = reader.int32();
                  break;
                case 2:
                  message.reviewedCount = reader.int32();
                  break;
                case 3:
                  message.inProgressCount = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullStallApplicationFormSummaryResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse} PullStallApplicationFormSummaryResponse
           */
          PullStallApplicationFormSummaryResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullStallApplicationFormSummaryResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse();
              if (object.applicantsCount != null)
                message.applicantsCount = object.applicantsCount | 0;
              if (object.reviewedCount != null)
                message.reviewedCount = object.reviewedCount | 0;
              if (object.inProgressCount != null)
                message.inProgressCount = object.inProgressCount | 0;
              return message;
            };

          /**
           * Creates a plain object from a PullStallApplicationFormSummaryResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse} message PullStallApplicationFormSummaryResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullStallApplicationFormSummaryResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.applicantsCount = 0;
              object.reviewedCount = 0;
              object.inProgressCount = 0;
            }
            if (
              message.applicantsCount != null &&
              message.hasOwnProperty("applicantsCount")
            )
              object.applicantsCount = message.applicantsCount;
            if (
              message.reviewedCount != null &&
              message.hasOwnProperty("reviewedCount")
            )
              object.reviewedCount = message.reviewedCount;
            if (
              message.inProgressCount != null &&
              message.hasOwnProperty("inProgressCount")
            )
              object.inProgressCount = message.inProgressCount;
            return object;
          };

          /**
           * Converts this PullStallApplicationFormSummaryResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullStallApplicationFormSummaryResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullStallApplicationFormSummaryResponse;
        })();

        racehorse360.StallApplication = (function () {
          /**
           * Properties of a StallApplication.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStallApplication
           * @property {string|null} [id] StallApplication id
           * @property {string|null} [arrivalDate] StallApplication arrivalDate
           * @property {number|null} [sleepingRoomsNumber] StallApplication sleepingRoomsNumber
           * @property {string|null} [trainerId] StallApplication trainerId
           * @property {string|null} [contactFullName] StallApplication contactFullName
           * @property {string|null} [contactPhone] StallApplication contactPhone
           * @property {string|null} [contactEmail] StallApplication contactEmail
           * @property {string|null} [contactZipCode] StallApplication contactZipCode
           * @property {string|null} [contactState] StallApplication contactState
           * @property {string|null} [contactCity] StallApplication contactCity
           * @property {string|null} [contactStreetAddress] StallApplication contactStreetAddress
           * @property {string|null} [contactStreetAddressOptional] StallApplication contactStreetAddressOptional
           * @property {string|null} [carrierName] StallApplication carrierName
           * @property {string|null} [policyNumber] StallApplication policyNumber
           * @property {string|null} [policyExpirationDate] StallApplication policyExpirationDate
           * @property {string|null} [carrierZipCode] StallApplication carrierZipCode
           * @property {string|null} [carrierState] StallApplication carrierState
           * @property {string|null} [carrierCity] StallApplication carrierCity
           * @property {string|null} [carrierStreetAddress] StallApplication carrierStreetAddress
           * @property {string|null} [carrierStreetAddressOptional] StallApplication carrierStreetAddressOptional
           * @property {google.protobuf.IBoolValue|null} [isStablePlannedToSplit] StallApplication isStablePlannedToSplit
           * @property {string|null} [comment] StallApplication comment
           * @property {stronachgroup.first.racehorse360.ITrainer|null} [trainer] StallApplication trainer
           * @property {number|null} [stableEntriesCount] StallApplication stableEntriesCount
           * @property {number|null} [stableEntriesAwaitingCount] StallApplication stableEntriesAwaitingCount
           * @property {number|null} [stableEntriesApprovedCount] StallApplication stableEntriesApprovedCount
           * @property {number|null} [stableEntriesDeniedCount] StallApplication stableEntriesDeniedCount
           * @property {stronachgroup.first.racehorse360.IFacility|null} [firstChoiceFacility] StallApplication firstChoiceFacility
           * @property {stronachgroup.first.racehorse360.IFacility|null} [secondChoiceFacility] StallApplication secondChoiceFacility
           * @property {string|null} [stallApplicationFormId] StallApplication stallApplicationFormId
           * @property {stronachgroup.first.racehorse360.StallApplicationStatus|null} [status] StallApplication status
           * @property {stronachgroup.first.racehorse360.IStallApplicationForm|null} [stallApplicationForm] StallApplication stallApplicationForm
           * @property {number|null} [sleepingRoomsNumberFirstChoice] StallApplication sleepingRoomsNumberFirstChoice
           * @property {number|null} [stallsNumberFirstChoice] StallApplication stallsNumberFirstChoice
           * @property {number|null} [sleepingRoomsNumberSecondChoice] StallApplication sleepingRoomsNumberSecondChoice
           * @property {number|null} [stallsNumberSecondChoice] StallApplication stallsNumberSecondChoice
           */

          /**
           * Constructs a new StallApplication.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StallApplication.
           * @implements IStallApplication
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStallApplication=} [properties] Properties to set
           */
          function StallApplication(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StallApplication id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.id = "";

          /**
           * StallApplication arrivalDate.
           * @member {string} arrivalDate
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.arrivalDate = "";

          /**
           * StallApplication sleepingRoomsNumber.
           * @member {number} sleepingRoomsNumber
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.sleepingRoomsNumber = 0;

          /**
           * StallApplication trainerId.
           * @member {string} trainerId
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.trainerId = "";

          /**
           * StallApplication contactFullName.
           * @member {string} contactFullName
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactFullName = "";

          /**
           * StallApplication contactPhone.
           * @member {string} contactPhone
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactPhone = "";

          /**
           * StallApplication contactEmail.
           * @member {string} contactEmail
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactEmail = "";

          /**
           * StallApplication contactZipCode.
           * @member {string} contactZipCode
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactZipCode = "";

          /**
           * StallApplication contactState.
           * @member {string} contactState
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactState = "";

          /**
           * StallApplication contactCity.
           * @member {string} contactCity
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactCity = "";

          /**
           * StallApplication contactStreetAddress.
           * @member {string} contactStreetAddress
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactStreetAddress = "";

          /**
           * StallApplication contactStreetAddressOptional.
           * @member {string} contactStreetAddressOptional
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.contactStreetAddressOptional = "";

          /**
           * StallApplication carrierName.
           * @member {string} carrierName
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierName = "";

          /**
           * StallApplication policyNumber.
           * @member {string} policyNumber
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.policyNumber = "";

          /**
           * StallApplication policyExpirationDate.
           * @member {string} policyExpirationDate
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.policyExpirationDate = "";

          /**
           * StallApplication carrierZipCode.
           * @member {string} carrierZipCode
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierZipCode = "";

          /**
           * StallApplication carrierState.
           * @member {string} carrierState
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierState = "";

          /**
           * StallApplication carrierCity.
           * @member {string} carrierCity
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierCity = "";

          /**
           * StallApplication carrierStreetAddress.
           * @member {string} carrierStreetAddress
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierStreetAddress = "";

          /**
           * StallApplication carrierStreetAddressOptional.
           * @member {string} carrierStreetAddressOptional
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.carrierStreetAddressOptional = "";

          /**
           * StallApplication isStablePlannedToSplit.
           * @member {google.protobuf.IBoolValue|null|undefined} isStablePlannedToSplit
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.isStablePlannedToSplit = null;

          /**
           * StallApplication comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.comment = "";

          /**
           * StallApplication trainer.
           * @member {stronachgroup.first.racehorse360.ITrainer|null|undefined} trainer
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.trainer = null;

          /**
           * StallApplication stableEntriesCount.
           * @member {number} stableEntriesCount
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stableEntriesCount = 0;

          /**
           * StallApplication stableEntriesAwaitingCount.
           * @member {number} stableEntriesAwaitingCount
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stableEntriesAwaitingCount = 0;

          /**
           * StallApplication stableEntriesApprovedCount.
           * @member {number} stableEntriesApprovedCount
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stableEntriesApprovedCount = 0;

          /**
           * StallApplication stableEntriesDeniedCount.
           * @member {number} stableEntriesDeniedCount
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stableEntriesDeniedCount = 0;

          /**
           * StallApplication firstChoiceFacility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} firstChoiceFacility
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.firstChoiceFacility = null;

          /**
           * StallApplication secondChoiceFacility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} secondChoiceFacility
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.secondChoiceFacility = null;

          /**
           * StallApplication stallApplicationFormId.
           * @member {string} stallApplicationFormId
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stallApplicationFormId = "";

          /**
           * StallApplication status.
           * @member {stronachgroup.first.racehorse360.StallApplicationStatus} status
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.status = 0;

          /**
           * StallApplication stallApplicationForm.
           * @member {stronachgroup.first.racehorse360.IStallApplicationForm|null|undefined} stallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stallApplicationForm = null;

          /**
           * StallApplication sleepingRoomsNumberFirstChoice.
           * @member {number} sleepingRoomsNumberFirstChoice
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.sleepingRoomsNumberFirstChoice = 0;

          /**
           * StallApplication stallsNumberFirstChoice.
           * @member {number} stallsNumberFirstChoice
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stallsNumberFirstChoice = 0;

          /**
           * StallApplication sleepingRoomsNumberSecondChoice.
           * @member {number} sleepingRoomsNumberSecondChoice
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.sleepingRoomsNumberSecondChoice = 0;

          /**
           * StallApplication stallsNumberSecondChoice.
           * @member {number} stallsNumberSecondChoice
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           */
          StallApplication.prototype.stallsNumberSecondChoice = 0;

          /**
           * Creates a new StallApplication instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplication=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StallApplication} StallApplication instance
           */
          StallApplication.create = function create(properties) {
            return new StallApplication(properties);
          };

          /**
           * Encodes the specified StallApplication message. Does not implicitly {@link stronachgroup.first.racehorse360.StallApplication.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplication} message StallApplication message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StallApplication.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.arrivalDate != null &&
              Object.hasOwnProperty.call(message, "arrivalDate")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.arrivalDate);
            if (
              message.sleepingRoomsNumber != null &&
              Object.hasOwnProperty.call(message, "sleepingRoomsNumber")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.sleepingRoomsNumber);
            if (
              message.trainerId != null &&
              Object.hasOwnProperty.call(message, "trainerId")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.trainerId);
            if (
              message.contactFullName != null &&
              Object.hasOwnProperty.call(message, "contactFullName")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.contactFullName);
            if (
              message.contactPhone != null &&
              Object.hasOwnProperty.call(message, "contactPhone")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.contactPhone);
            if (
              message.contactEmail != null &&
              Object.hasOwnProperty.call(message, "contactEmail")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.contactEmail);
            if (
              message.contactZipCode != null &&
              Object.hasOwnProperty.call(message, "contactZipCode")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.contactZipCode);
            if (
              message.contactState != null &&
              Object.hasOwnProperty.call(message, "contactState")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.contactState);
            if (
              message.contactCity != null &&
              Object.hasOwnProperty.call(message, "contactCity")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.contactCity);
            if (
              message.contactStreetAddress != null &&
              Object.hasOwnProperty.call(message, "contactStreetAddress")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.contactStreetAddress);
            if (
              message.contactStreetAddressOptional != null &&
              Object.hasOwnProperty.call(
                message,
                "contactStreetAddressOptional"
              )
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.contactStreetAddressOptional);
            if (
              message.carrierName != null &&
              Object.hasOwnProperty.call(message, "carrierName")
            )
              writer
                .uint32(/* id 13, wireType 2 =*/ 106)
                .string(message.carrierName);
            if (
              message.policyNumber != null &&
              Object.hasOwnProperty.call(message, "policyNumber")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.policyNumber);
            if (
              message.policyExpirationDate != null &&
              Object.hasOwnProperty.call(message, "policyExpirationDate")
            )
              writer
                .uint32(/* id 15, wireType 2 =*/ 122)
                .string(message.policyExpirationDate);
            if (
              message.carrierZipCode != null &&
              Object.hasOwnProperty.call(message, "carrierZipCode")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.carrierZipCode);
            if (
              message.carrierState != null &&
              Object.hasOwnProperty.call(message, "carrierState")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.carrierState);
            if (
              message.carrierCity != null &&
              Object.hasOwnProperty.call(message, "carrierCity")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.carrierCity);
            if (
              message.carrierStreetAddress != null &&
              Object.hasOwnProperty.call(message, "carrierStreetAddress")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.carrierStreetAddress);
            if (
              message.carrierStreetAddressOptional != null &&
              Object.hasOwnProperty.call(
                message,
                "carrierStreetAddressOptional"
              )
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.carrierStreetAddressOptional);
            if (
              message.isStablePlannedToSplit != null &&
              Object.hasOwnProperty.call(message, "isStablePlannedToSplit")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isStablePlannedToSplit,
                writer.uint32(/* id 21, wireType 2 =*/ 170).fork()
              ).ldelim();
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer
                .uint32(/* id 22, wireType 2 =*/ 178)
                .string(message.comment);
            if (
              message.trainer != null &&
              Object.hasOwnProperty.call(message, "trainer")
            )
              $root.stronachgroup.first.racehorse360.Trainer.encode(
                message.trainer,
                writer.uint32(/* id 23, wireType 2 =*/ 186).fork()
              ).ldelim();
            if (
              message.stableEntriesCount != null &&
              Object.hasOwnProperty.call(message, "stableEntriesCount")
            )
              writer
                .uint32(/* id 24, wireType 0 =*/ 192)
                .int32(message.stableEntriesCount);
            if (
              message.stableEntriesAwaitingCount != null &&
              Object.hasOwnProperty.call(message, "stableEntriesAwaitingCount")
            )
              writer
                .uint32(/* id 25, wireType 0 =*/ 200)
                .int32(message.stableEntriesAwaitingCount);
            if (
              message.stableEntriesApprovedCount != null &&
              Object.hasOwnProperty.call(message, "stableEntriesApprovedCount")
            )
              writer
                .uint32(/* id 26, wireType 0 =*/ 208)
                .int32(message.stableEntriesApprovedCount);
            if (
              message.stableEntriesDeniedCount != null &&
              Object.hasOwnProperty.call(message, "stableEntriesDeniedCount")
            )
              writer
                .uint32(/* id 27, wireType 0 =*/ 216)
                .int32(message.stableEntriesDeniedCount);
            if (
              message.firstChoiceFacility != null &&
              Object.hasOwnProperty.call(message, "firstChoiceFacility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.firstChoiceFacility,
                writer.uint32(/* id 28, wireType 2 =*/ 226).fork()
              ).ldelim();
            if (
              message.secondChoiceFacility != null &&
              Object.hasOwnProperty.call(message, "secondChoiceFacility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.secondChoiceFacility,
                writer.uint32(/* id 29, wireType 2 =*/ 234).fork()
              ).ldelim();
            if (
              message.stallApplicationFormId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationFormId")
            )
              writer
                .uint32(/* id 30, wireType 2 =*/ 242)
                .string(message.stallApplicationFormId);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 31, wireType 0 =*/ 248).int32(message.status);
            if (
              message.stallApplicationForm != null &&
              Object.hasOwnProperty.call(message, "stallApplicationForm")
            )
              $root.stronachgroup.first.racehorse360.StallApplicationForm.encode(
                message.stallApplicationForm,
                writer.uint32(/* id 32, wireType 2 =*/ 258).fork()
              ).ldelim();
            if (
              message.sleepingRoomsNumberFirstChoice != null &&
              Object.hasOwnProperty.call(
                message,
                "sleepingRoomsNumberFirstChoice"
              )
            )
              writer
                .uint32(/* id 33, wireType 0 =*/ 264)
                .int32(message.sleepingRoomsNumberFirstChoice);
            if (
              message.stallsNumberFirstChoice != null &&
              Object.hasOwnProperty.call(message, "stallsNumberFirstChoice")
            )
              writer
                .uint32(/* id 34, wireType 0 =*/ 272)
                .int32(message.stallsNumberFirstChoice);
            if (
              message.sleepingRoomsNumberSecondChoice != null &&
              Object.hasOwnProperty.call(
                message,
                "sleepingRoomsNumberSecondChoice"
              )
            )
              writer
                .uint32(/* id 35, wireType 0 =*/ 280)
                .int32(message.sleepingRoomsNumberSecondChoice);
            if (
              message.stallsNumberSecondChoice != null &&
              Object.hasOwnProperty.call(message, "stallsNumberSecondChoice")
            )
              writer
                .uint32(/* id 36, wireType 0 =*/ 288)
                .int32(message.stallsNumberSecondChoice);
            return writer;
          };

          /**
           * Decodes a StallApplication message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StallApplication} StallApplication
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StallApplication.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StallApplication();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.arrivalDate = reader.string();
                  break;
                case 3:
                  message.sleepingRoomsNumber = reader.int32();
                  break;
                case 4:
                  message.trainerId = reader.string();
                  break;
                case 5:
                  message.contactFullName = reader.string();
                  break;
                case 6:
                  message.contactPhone = reader.string();
                  break;
                case 7:
                  message.contactEmail = reader.string();
                  break;
                case 8:
                  message.contactZipCode = reader.string();
                  break;
                case 9:
                  message.contactState = reader.string();
                  break;
                case 10:
                  message.contactCity = reader.string();
                  break;
                case 11:
                  message.contactStreetAddress = reader.string();
                  break;
                case 12:
                  message.contactStreetAddressOptional = reader.string();
                  break;
                case 13:
                  message.carrierName = reader.string();
                  break;
                case 14:
                  message.policyNumber = reader.string();
                  break;
                case 15:
                  message.policyExpirationDate = reader.string();
                  break;
                case 16:
                  message.carrierZipCode = reader.string();
                  break;
                case 17:
                  message.carrierState = reader.string();
                  break;
                case 18:
                  message.carrierCity = reader.string();
                  break;
                case 19:
                  message.carrierStreetAddress = reader.string();
                  break;
                case 20:
                  message.carrierStreetAddressOptional = reader.string();
                  break;
                case 21:
                  message.isStablePlannedToSplit =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 22:
                  message.comment = reader.string();
                  break;
                case 23:
                  message.trainer =
                    $root.stronachgroup.first.racehorse360.Trainer.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 24:
                  message.stableEntriesCount = reader.int32();
                  break;
                case 25:
                  message.stableEntriesAwaitingCount = reader.int32();
                  break;
                case 26:
                  message.stableEntriesApprovedCount = reader.int32();
                  break;
                case 27:
                  message.stableEntriesDeniedCount = reader.int32();
                  break;
                case 28:
                  message.firstChoiceFacility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 29:
                  message.secondChoiceFacility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 30:
                  message.stallApplicationFormId = reader.string();
                  break;
                case 31:
                  message.status = reader.int32();
                  break;
                case 32:
                  message.stallApplicationForm =
                    $root.stronachgroup.first.racehorse360.StallApplicationForm.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 33:
                  message.sleepingRoomsNumberFirstChoice = reader.int32();
                  break;
                case 34:
                  message.stallsNumberFirstChoice = reader.int32();
                  break;
                case 35:
                  message.sleepingRoomsNumberSecondChoice = reader.int32();
                  break;
                case 36:
                  message.stallsNumberSecondChoice = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StallApplication message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StallApplication} StallApplication
           */
          StallApplication.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StallApplication
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StallApplication();
            if (object.id != null) message.id = String(object.id);
            if (object.arrivalDate != null)
              message.arrivalDate = String(object.arrivalDate);
            if (object.sleepingRoomsNumber != null)
              message.sleepingRoomsNumber = object.sleepingRoomsNumber | 0;
            if (object.trainerId != null)
              message.trainerId = String(object.trainerId);
            if (object.contactFullName != null)
              message.contactFullName = String(object.contactFullName);
            if (object.contactPhone != null)
              message.contactPhone = String(object.contactPhone);
            if (object.contactEmail != null)
              message.contactEmail = String(object.contactEmail);
            if (object.contactZipCode != null)
              message.contactZipCode = String(object.contactZipCode);
            if (object.contactState != null)
              message.contactState = String(object.contactState);
            if (object.contactCity != null)
              message.contactCity = String(object.contactCity);
            if (object.contactStreetAddress != null)
              message.contactStreetAddress = String(
                object.contactStreetAddress
              );
            if (object.contactStreetAddressOptional != null)
              message.contactStreetAddressOptional = String(
                object.contactStreetAddressOptional
              );
            if (object.carrierName != null)
              message.carrierName = String(object.carrierName);
            if (object.policyNumber != null)
              message.policyNumber = String(object.policyNumber);
            if (object.policyExpirationDate != null)
              message.policyExpirationDate = String(
                object.policyExpirationDate
              );
            if (object.carrierZipCode != null)
              message.carrierZipCode = String(object.carrierZipCode);
            if (object.carrierState != null)
              message.carrierState = String(object.carrierState);
            if (object.carrierCity != null)
              message.carrierCity = String(object.carrierCity);
            if (object.carrierStreetAddress != null)
              message.carrierStreetAddress = String(
                object.carrierStreetAddress
              );
            if (object.carrierStreetAddressOptional != null)
              message.carrierStreetAddressOptional = String(
                object.carrierStreetAddressOptional
              );
            if (object.isStablePlannedToSplit != null) {
              if (typeof object.isStablePlannedToSplit !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplication.isStablePlannedToSplit: object expected"
                );
              message.isStablePlannedToSplit =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isStablePlannedToSplit
                );
            }
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.trainer != null) {
              if (typeof object.trainer !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplication.trainer: object expected"
                );
              message.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.fromObject(
                  object.trainer
                );
            }
            if (object.stableEntriesCount != null)
              message.stableEntriesCount = object.stableEntriesCount | 0;
            if (object.stableEntriesAwaitingCount != null)
              message.stableEntriesAwaitingCount =
                object.stableEntriesAwaitingCount | 0;
            if (object.stableEntriesApprovedCount != null)
              message.stableEntriesApprovedCount =
                object.stableEntriesApprovedCount | 0;
            if (object.stableEntriesDeniedCount != null)
              message.stableEntriesDeniedCount =
                object.stableEntriesDeniedCount | 0;
            if (object.firstChoiceFacility != null) {
              if (typeof object.firstChoiceFacility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplication.firstChoiceFacility: object expected"
                );
              message.firstChoiceFacility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.firstChoiceFacility
                );
            }
            if (object.secondChoiceFacility != null) {
              if (typeof object.secondChoiceFacility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplication.secondChoiceFacility: object expected"
                );
              message.secondChoiceFacility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.secondChoiceFacility
                );
            }
            if (object.stallApplicationFormId != null)
              message.stallApplicationFormId = String(
                object.stallApplicationFormId
              );
            switch (object.status) {
              case "STALL_APPLICATION_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "STALL_APPLICATION_STATUS_IN_PROGRESS":
              case 1:
                message.status = 1;
                break;
              case "STALL_APPLICATION_STATUS_APPLIED":
              case 2:
                message.status = 2;
                break;
              case "STALL_APPLICATION_STATUS_UNDER_REVIEW":
              case 3:
                message.status = 3;
                break;
              case "STALL_APPLICATION_STATUS_COMPLETE":
              case 4:
                message.status = 4;
                break;
              case "STALL_APPLICATION_STATUS_CANCELLED":
              case 5:
                message.status = 5;
                break;
            }
            if (object.stallApplicationForm != null) {
              if (typeof object.stallApplicationForm !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplication.stallApplicationForm: object expected"
                );
              message.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.fromObject(
                  object.stallApplicationForm
                );
            }
            if (object.sleepingRoomsNumberFirstChoice != null)
              message.sleepingRoomsNumberFirstChoice =
                object.sleepingRoomsNumberFirstChoice | 0;
            if (object.stallsNumberFirstChoice != null)
              message.stallsNumberFirstChoice =
                object.stallsNumberFirstChoice | 0;
            if (object.sleepingRoomsNumberSecondChoice != null)
              message.sleepingRoomsNumberSecondChoice =
                object.sleepingRoomsNumberSecondChoice | 0;
            if (object.stallsNumberSecondChoice != null)
              message.stallsNumberSecondChoice =
                object.stallsNumberSecondChoice | 0;
            return message;
          };

          /**
           * Creates a plain object from a StallApplication message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @static
           * @param {stronachgroup.first.racehorse360.StallApplication} message StallApplication
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StallApplication.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.arrivalDate = "";
              object.sleepingRoomsNumber = 0;
              object.trainerId = "";
              object.contactFullName = "";
              object.contactPhone = "";
              object.contactEmail = "";
              object.contactZipCode = "";
              object.contactState = "";
              object.contactCity = "";
              object.contactStreetAddress = "";
              object.contactStreetAddressOptional = "";
              object.carrierName = "";
              object.policyNumber = "";
              object.policyExpirationDate = "";
              object.carrierZipCode = "";
              object.carrierState = "";
              object.carrierCity = "";
              object.carrierStreetAddress = "";
              object.carrierStreetAddressOptional = "";
              object.isStablePlannedToSplit = null;
              object.comment = "";
              object.trainer = null;
              object.stableEntriesCount = 0;
              object.stableEntriesAwaitingCount = 0;
              object.stableEntriesApprovedCount = 0;
              object.stableEntriesDeniedCount = 0;
              object.firstChoiceFacility = null;
              object.secondChoiceFacility = null;
              object.stallApplicationFormId = "";
              object.status =
                options.enums === String
                  ? "STALL_APPLICATION_STATUS_INVALID"
                  : 0;
              object.stallApplicationForm = null;
              object.sleepingRoomsNumberFirstChoice = 0;
              object.stallsNumberFirstChoice = 0;
              object.sleepingRoomsNumberSecondChoice = 0;
              object.stallsNumberSecondChoice = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.arrivalDate != null &&
              message.hasOwnProperty("arrivalDate")
            )
              object.arrivalDate = message.arrivalDate;
            if (
              message.sleepingRoomsNumber != null &&
              message.hasOwnProperty("sleepingRoomsNumber")
            )
              object.sleepingRoomsNumber = message.sleepingRoomsNumber;
            if (
              message.trainerId != null &&
              message.hasOwnProperty("trainerId")
            )
              object.trainerId = message.trainerId;
            if (
              message.contactFullName != null &&
              message.hasOwnProperty("contactFullName")
            )
              object.contactFullName = message.contactFullName;
            if (
              message.contactPhone != null &&
              message.hasOwnProperty("contactPhone")
            )
              object.contactPhone = message.contactPhone;
            if (
              message.contactEmail != null &&
              message.hasOwnProperty("contactEmail")
            )
              object.contactEmail = message.contactEmail;
            if (
              message.contactZipCode != null &&
              message.hasOwnProperty("contactZipCode")
            )
              object.contactZipCode = message.contactZipCode;
            if (
              message.contactState != null &&
              message.hasOwnProperty("contactState")
            )
              object.contactState = message.contactState;
            if (
              message.contactCity != null &&
              message.hasOwnProperty("contactCity")
            )
              object.contactCity = message.contactCity;
            if (
              message.contactStreetAddress != null &&
              message.hasOwnProperty("contactStreetAddress")
            )
              object.contactStreetAddress = message.contactStreetAddress;
            if (
              message.contactStreetAddressOptional != null &&
              message.hasOwnProperty("contactStreetAddressOptional")
            )
              object.contactStreetAddressOptional =
                message.contactStreetAddressOptional;
            if (
              message.carrierName != null &&
              message.hasOwnProperty("carrierName")
            )
              object.carrierName = message.carrierName;
            if (
              message.policyNumber != null &&
              message.hasOwnProperty("policyNumber")
            )
              object.policyNumber = message.policyNumber;
            if (
              message.policyExpirationDate != null &&
              message.hasOwnProperty("policyExpirationDate")
            )
              object.policyExpirationDate = message.policyExpirationDate;
            if (
              message.carrierZipCode != null &&
              message.hasOwnProperty("carrierZipCode")
            )
              object.carrierZipCode = message.carrierZipCode;
            if (
              message.carrierState != null &&
              message.hasOwnProperty("carrierState")
            )
              object.carrierState = message.carrierState;
            if (
              message.carrierCity != null &&
              message.hasOwnProperty("carrierCity")
            )
              object.carrierCity = message.carrierCity;
            if (
              message.carrierStreetAddress != null &&
              message.hasOwnProperty("carrierStreetAddress")
            )
              object.carrierStreetAddress = message.carrierStreetAddress;
            if (
              message.carrierStreetAddressOptional != null &&
              message.hasOwnProperty("carrierStreetAddressOptional")
            )
              object.carrierStreetAddressOptional =
                message.carrierStreetAddressOptional;
            if (
              message.isStablePlannedToSplit != null &&
              message.hasOwnProperty("isStablePlannedToSplit")
            )
              object.isStablePlannedToSplit =
                $root.google.protobuf.BoolValue.toObject(
                  message.isStablePlannedToSplit,
                  options
                );
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (message.trainer != null && message.hasOwnProperty("trainer"))
              object.trainer =
                $root.stronachgroup.first.racehorse360.Trainer.toObject(
                  message.trainer,
                  options
                );
            if (
              message.stableEntriesCount != null &&
              message.hasOwnProperty("stableEntriesCount")
            )
              object.stableEntriesCount = message.stableEntriesCount;
            if (
              message.stableEntriesAwaitingCount != null &&
              message.hasOwnProperty("stableEntriesAwaitingCount")
            )
              object.stableEntriesAwaitingCount =
                message.stableEntriesAwaitingCount;
            if (
              message.stableEntriesApprovedCount != null &&
              message.hasOwnProperty("stableEntriesApprovedCount")
            )
              object.stableEntriesApprovedCount =
                message.stableEntriesApprovedCount;
            if (
              message.stableEntriesDeniedCount != null &&
              message.hasOwnProperty("stableEntriesDeniedCount")
            )
              object.stableEntriesDeniedCount =
                message.stableEntriesDeniedCount;
            if (
              message.firstChoiceFacility != null &&
              message.hasOwnProperty("firstChoiceFacility")
            )
              object.firstChoiceFacility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.firstChoiceFacility,
                  options
                );
            if (
              message.secondChoiceFacility != null &&
              message.hasOwnProperty("secondChoiceFacility")
            )
              object.secondChoiceFacility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.secondChoiceFacility,
                  options
                );
            if (
              message.stallApplicationFormId != null &&
              message.hasOwnProperty("stallApplicationFormId")
            )
              object.stallApplicationFormId = message.stallApplicationFormId;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .StallApplicationStatus[message.status]
                  : message.status;
            if (
              message.stallApplicationForm != null &&
              message.hasOwnProperty("stallApplicationForm")
            )
              object.stallApplicationForm =
                $root.stronachgroup.first.racehorse360.StallApplicationForm.toObject(
                  message.stallApplicationForm,
                  options
                );
            if (
              message.sleepingRoomsNumberFirstChoice != null &&
              message.hasOwnProperty("sleepingRoomsNumberFirstChoice")
            )
              object.sleepingRoomsNumberFirstChoice =
                message.sleepingRoomsNumberFirstChoice;
            if (
              message.stallsNumberFirstChoice != null &&
              message.hasOwnProperty("stallsNumberFirstChoice")
            )
              object.stallsNumberFirstChoice = message.stallsNumberFirstChoice;
            if (
              message.sleepingRoomsNumberSecondChoice != null &&
              message.hasOwnProperty("sleepingRoomsNumberSecondChoice")
            )
              object.sleepingRoomsNumberSecondChoice =
                message.sleepingRoomsNumberSecondChoice;
            if (
              message.stallsNumberSecondChoice != null &&
              message.hasOwnProperty("stallsNumberSecondChoice")
            )
              object.stallsNumberSecondChoice =
                message.stallsNumberSecondChoice;
            return object;
          };

          /**
           * Converts this StallApplication to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StallApplication
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StallApplication.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StallApplication;
        })();

        racehorse360.ListStallApplicationsRequest = (function () {
          /**
           * Properties of a ListStallApplicationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStallApplicationsRequest
           * @property {stronachgroup.first.racehorse360.IStallApplicationFilter|null} [query] ListStallApplicationsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListStallApplicationsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListStallApplicationsRequest pagingOptions
           */

          /**
           * Constructs a new ListStallApplicationsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStallApplicationsRequest.
           * @implements IListStallApplicationsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsRequest=} [properties] Properties to set
           */
          function ListStallApplicationsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStallApplicationsRequest query.
           * @member {stronachgroup.first.racehorse360.IStallApplicationFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @instance
           */
          ListStallApplicationsRequest.prototype.query = null;

          /**
           * ListStallApplicationsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @instance
           */
          ListStallApplicationsRequest.prototype.getOptions = null;

          /**
           * ListStallApplicationsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @instance
           */
          ListStallApplicationsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListStallApplicationsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsRequest} ListStallApplicationsRequest instance
           */
          ListStallApplicationsRequest.create = function create(properties) {
            return new ListStallApplicationsRequest(properties);
          };

          /**
           * Encodes the specified ListStallApplicationsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStallApplicationsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsRequest} message ListStallApplicationsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStallApplicationsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.StallApplicationFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStallApplicationsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsRequest} ListStallApplicationsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStallApplicationsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStallApplicationsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.StallApplicationFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStallApplicationsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsRequest} ListStallApplicationsRequest
           */
          ListStallApplicationsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListStallApplicationsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStallApplicationsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.StallApplicationFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStallApplicationsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListStallApplicationsRequest} message ListStallApplicationsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStallApplicationsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.StallApplicationFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStallApplicationsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStallApplicationsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListStallApplicationsRequest;
        })();

        racehorse360.StallApplicationFilter = (function () {
          /**
           * Properties of a StallApplicationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStallApplicationFilter
           * @property {Array.<string>|null} [ids] StallApplicationFilter ids
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [contactFullName] StallApplicationFilter contactFullName
           * @property {Array.<string>|null} [createdByIds] StallApplicationFilter createdByIds
           * @property {Array.<string>|null} [trainerIds] StallApplicationFilter trainerIds
           * @property {string|null} [stallApplicationFormId] StallApplicationFilter stallApplicationFormId
           * @property {Array.<stronachgroup.first.racehorse360.StallApplicationStatus>|null} [statuses] StallApplicationFilter statuses
           */

          /**
           * Constructs a new StallApplicationFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StallApplicationFilter.
           * @implements IStallApplicationFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStallApplicationFilter=} [properties] Properties to set
           */
          function StallApplicationFilter(properties) {
            this.ids = [];
            this.createdByIds = [];
            this.trainerIds = [];
            this.statuses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StallApplicationFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.ids = $util.emptyArray;

          /**
           * StallApplicationFilter contactFullName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} contactFullName
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.contactFullName = null;

          /**
           * StallApplicationFilter createdByIds.
           * @member {Array.<string>} createdByIds
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.createdByIds = $util.emptyArray;

          /**
           * StallApplicationFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * StallApplicationFilter stallApplicationFormId.
           * @member {string} stallApplicationFormId
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.stallApplicationFormId = "";

          /**
           * StallApplicationFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.StallApplicationStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           */
          StallApplicationFilter.prototype.statuses = $util.emptyArray;

          /**
           * Creates a new StallApplicationFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StallApplicationFilter} StallApplicationFilter instance
           */
          StallApplicationFilter.create = function create(properties) {
            return new StallApplicationFilter(properties);
          };

          /**
           * Encodes the specified StallApplicationFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.StallApplicationFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStallApplicationFilter} message StallApplicationFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StallApplicationFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.contactFullName != null &&
              Object.hasOwnProperty.call(message, "contactFullName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.contactFullName,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (message.createdByIds != null && message.createdByIds.length)
              for (var i = 0; i < message.createdByIds.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.createdByIds[i]);
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.trainerIds[i]);
            if (
              message.stallApplicationFormId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationFormId")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.stallApplicationFormId);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            return writer;
          };

          /**
           * Decodes a StallApplicationFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StallApplicationFilter} StallApplicationFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StallApplicationFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StallApplicationFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  message.contactFullName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  if (!(message.createdByIds && message.createdByIds.length))
                    message.createdByIds = [];
                  message.createdByIds.push(reader.string());
                  break;
                case 4:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 5:
                  message.stallApplicationFormId = reader.string();
                  break;
                case 6:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StallApplicationFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StallApplicationFilter} StallApplicationFilter
           */
          StallApplicationFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StallApplicationFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StallApplicationFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.contactFullName != null) {
              if (typeof object.contactFullName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFilter.contactFullName: object expected"
                );
              message.contactFullName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.contactFullName
                );
            }
            if (object.createdByIds) {
              if (!Array.isArray(object.createdByIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFilter.createdByIds: array expected"
                );
              message.createdByIds = [];
              for (var i = 0; i < object.createdByIds.length; ++i)
                message.createdByIds[i] = String(object.createdByIds[i]);
            }
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.stallApplicationFormId != null)
              message.stallApplicationFormId = String(
                object.stallApplicationFormId
              );
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StallApplicationFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "STALL_APPLICATION_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "STALL_APPLICATION_STATUS_IN_PROGRESS":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "STALL_APPLICATION_STATUS_APPLIED":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                  case "STALL_APPLICATION_STATUS_UNDER_REVIEW":
                  case 3:
                    message.statuses[i] = 3;
                    break;
                  case "STALL_APPLICATION_STATUS_COMPLETE":
                  case 4:
                    message.statuses[i] = 4;
                    break;
                  case "STALL_APPLICATION_STATUS_CANCELLED":
                  case 5:
                    message.statuses[i] = 5;
                    break;
                }
            }
            return message;
          };

          /**
           * Creates a plain object from a StallApplicationFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @static
           * @param {stronachgroup.first.racehorse360.StallApplicationFilter} message StallApplicationFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StallApplicationFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.createdByIds = [];
              object.trainerIds = [];
              object.statuses = [];
            }
            if (options.defaults) {
              object.contactFullName = null;
              object.stallApplicationFormId = "";
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.contactFullName != null &&
              message.hasOwnProperty("contactFullName")
            )
              object.contactFullName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.contactFullName,
                  options
                );
            if (message.createdByIds && message.createdByIds.length) {
              object.createdByIds = [];
              for (var j = 0; j < message.createdByIds.length; ++j)
                object.createdByIds[j] = message.createdByIds[j];
            }
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (
              message.stallApplicationFormId != null &&
              message.hasOwnProperty("stallApplicationFormId")
            )
              object.stallApplicationFormId = message.stallApplicationFormId;
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .StallApplicationStatus[message.statuses[j]]
                    : message.statuses[j];
            }
            return object;
          };

          /**
           * Converts this StallApplicationFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StallApplicationFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StallApplicationFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StallApplicationFilter;
        })();

        racehorse360.ListStallApplicationsResponse = (function () {
          /**
           * Properties of a ListStallApplicationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStallApplicationsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IStallApplication>|null} [stallApplications] ListStallApplicationsResponse stallApplications
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListStallApplicationsResponse pagingInfo
           */

          /**
           * Constructs a new ListStallApplicationsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStallApplicationsResponse.
           * @implements IListStallApplicationsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsResponse=} [properties] Properties to set
           */
          function ListStallApplicationsResponse(properties) {
            this.stallApplications = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStallApplicationsResponse stallApplications.
           * @member {Array.<stronachgroup.first.racehorse360.IStallApplication>} stallApplications
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @instance
           */
          ListStallApplicationsResponse.prototype.stallApplications =
            $util.emptyArray;

          /**
           * ListStallApplicationsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @instance
           */
          ListStallApplicationsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListStallApplicationsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsResponse} ListStallApplicationsResponse instance
           */
          ListStallApplicationsResponse.create = function create(properties) {
            return new ListStallApplicationsResponse(properties);
          };

          /**
           * Encodes the specified ListStallApplicationsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStallApplicationsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsResponse} message ListStallApplicationsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStallApplicationsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplications != null &&
              message.stallApplications.length
            )
              for (var i = 0; i < message.stallApplications.length; ++i)
                $root.stronachgroup.first.racehorse360.StallApplication.encode(
                  message.stallApplications[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStallApplicationsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsResponse} ListStallApplicationsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStallApplicationsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStallApplicationsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.stallApplications &&
                      message.stallApplications.length
                    )
                  )
                    message.stallApplications = [];
                  message.stallApplications.push(
                    $root.stronachgroup.first.racehorse360.StallApplication.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStallApplicationsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStallApplicationsResponse} ListStallApplicationsResponse
           */
          ListStallApplicationsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListStallApplicationsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStallApplicationsResponse();
            if (object.stallApplications) {
              if (!Array.isArray(object.stallApplications))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationsResponse.stallApplications: array expected"
                );
              message.stallApplications = [];
              for (var i = 0; i < object.stallApplications.length; ++i) {
                if (typeof object.stallApplications[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListStallApplicationsResponse.stallApplications: object expected"
                  );
                message.stallApplications[i] =
                  $root.stronachgroup.first.racehorse360.StallApplication.fromObject(
                    object.stallApplications[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStallApplicationsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStallApplicationsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListStallApplicationsResponse} message ListStallApplicationsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStallApplicationsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.stallApplications = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.stallApplications && message.stallApplications.length) {
              object.stallApplications = [];
              for (var j = 0; j < message.stallApplications.length; ++j)
                object.stallApplications[j] =
                  $root.stronachgroup.first.racehorse360.StallApplication.toObject(
                    message.stallApplications[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStallApplicationsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStallApplicationsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStallApplicationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListStallApplicationsResponse;
        })();

        racehorse360.GetStallApplicationRequest = (function () {
          /**
           * Properties of a GetStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetStallApplicationRequest
           * @property {string|null} [id] GetStallApplicationRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetStallApplicationRequest getOptions
           */

          /**
           * Constructs a new GetStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetStallApplicationRequest.
           * @implements IGetStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationRequest=} [properties] Properties to set
           */
          function GetStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetStallApplicationRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @instance
           */
          GetStallApplicationRequest.prototype.id = "";

          /**
           * GetStallApplicationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @instance
           */
          GetStallApplicationRequest.prototype.getOptions = null;

          /**
           * Creates a new GetStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationRequest} GetStallApplicationRequest instance
           */
          GetStallApplicationRequest.create = function create(properties) {
            return new GetStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified GetStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationRequest} message GetStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetStallApplicationRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationRequest} GetStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetStallApplicationRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetStallApplicationRequest} GetStallApplicationRequest
           */
          GetStallApplicationRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetStallApplicationRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetStallApplicationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetStallApplicationRequest} message GetStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetStallApplicationRequest;
        })();

        racehorse360.UpdateStallApplicationRequest = (function () {
          /**
           * Properties of an UpdateStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateStallApplicationRequest
           * @property {stronachgroup.first.racehorse360.IStallApplication|null} [stallApplication] UpdateStallApplicationRequest stallApplication
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStallApplicationRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateStallApplicationRequest getOptions
           */

          /**
           * Constructs a new UpdateStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateStallApplicationRequest.
           * @implements IUpdateStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationRequest=} [properties] Properties to set
           */
          function UpdateStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateStallApplicationRequest stallApplication.
           * @member {stronachgroup.first.racehorse360.IStallApplication|null|undefined} stallApplication
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @instance
           */
          UpdateStallApplicationRequest.prototype.stallApplication = null;

          /**
           * UpdateStallApplicationRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @instance
           */
          UpdateStallApplicationRequest.prototype.updateMask = null;

          /**
           * UpdateStallApplicationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @instance
           */
          UpdateStallApplicationRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationRequest} UpdateStallApplicationRequest instance
           */
          UpdateStallApplicationRequest.create = function create(properties) {
            return new UpdateStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified UpdateStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationRequest} message UpdateStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplication != null &&
              Object.hasOwnProperty.call(message, "stallApplication")
            )
              $root.stronachgroup.first.racehorse360.StallApplication.encode(
                message.stallApplication,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationRequest} UpdateStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplication =
                    $root.stronachgroup.first.racehorse360.StallApplication.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateStallApplicationRequest} UpdateStallApplicationRequest
           */
          UpdateStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .UpdateStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateStallApplicationRequest();
            if (object.stallApplication != null) {
              if (typeof object.stallApplication !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationRequest.stallApplication: object expected"
                );
              message.stallApplication =
                $root.stronachgroup.first.racehorse360.StallApplication.fromObject(
                  object.stallApplication
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStallApplicationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateStallApplicationRequest} message UpdateStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplication = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.stallApplication != null &&
              message.hasOwnProperty("stallApplication")
            )
              object.stallApplication =
                $root.stronachgroup.first.racehorse360.StallApplication.toObject(
                  message.stallApplication,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateStallApplicationRequest;
        })();

        racehorse360.CreateStallApplicationRequest = (function () {
          /**
           * Properties of a CreateStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateStallApplicationRequest
           * @property {stronachgroup.first.racehorse360.IStallApplication|null} [stallApplication] CreateStallApplicationRequest stallApplication
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateStallApplicationRequest getOptions
           */

          /**
           * Constructs a new CreateStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateStallApplicationRequest.
           * @implements ICreateStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationRequest=} [properties] Properties to set
           */
          function CreateStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateStallApplicationRequest stallApplication.
           * @member {stronachgroup.first.racehorse360.IStallApplication|null|undefined} stallApplication
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @instance
           */
          CreateStallApplicationRequest.prototype.stallApplication = null;

          /**
           * CreateStallApplicationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @instance
           */
          CreateStallApplicationRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationRequest} CreateStallApplicationRequest instance
           */
          CreateStallApplicationRequest.create = function create(properties) {
            return new CreateStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified CreateStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationRequest} message CreateStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplication != null &&
              Object.hasOwnProperty.call(message, "stallApplication")
            )
              $root.stronachgroup.first.racehorse360.StallApplication.encode(
                message.stallApplication,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationRequest} CreateStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplication =
                    $root.stronachgroup.first.racehorse360.StallApplication.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateStallApplicationRequest} CreateStallApplicationRequest
           */
          CreateStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CreateStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateStallApplicationRequest();
            if (object.stallApplication != null) {
              if (typeof object.stallApplication !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStallApplicationRequest.stallApplication: object expected"
                );
              message.stallApplication =
                $root.stronachgroup.first.racehorse360.StallApplication.fromObject(
                  object.stallApplication
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStallApplicationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateStallApplicationRequest} message CreateStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stallApplication = null;
              object.getOptions = null;
            }
            if (
              message.stallApplication != null &&
              message.hasOwnProperty("stallApplication")
            )
              object.stallApplication =
                $root.stronachgroup.first.racehorse360.StallApplication.toObject(
                  message.stallApplication,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateStallApplicationRequest;
        })();

        racehorse360.DeleteStallApplicationRequest = (function () {
          /**
           * Properties of a DeleteStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteStallApplicationRequest
           * @property {string|null} [id] DeleteStallApplicationRequest id
           */

          /**
           * Constructs a new DeleteStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteStallApplicationRequest.
           * @implements IDeleteStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationRequest=} [properties] Properties to set
           */
          function DeleteStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteStallApplicationRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @instance
           */
          DeleteStallApplicationRequest.prototype.id = "";

          /**
           * Creates a new DeleteStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationRequest} DeleteStallApplicationRequest instance
           */
          DeleteStallApplicationRequest.create = function create(properties) {
            return new DeleteStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified DeleteStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationRequest} message DeleteStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationRequest} DeleteStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteStallApplicationRequest} DeleteStallApplicationRequest
           */
          DeleteStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .DeleteStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteStallApplicationRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteStallApplicationRequest} message DeleteStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteStallApplicationRequest;
        })();

        racehorse360.SubmitStallApplicationRequest = (function () {
          /**
           * Properties of a SubmitStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISubmitStallApplicationRequest
           * @property {string|null} [stallApplicationId] SubmitStallApplicationRequest stallApplicationId
           */

          /**
           * Constructs a new SubmitStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SubmitStallApplicationRequest.
           * @implements ISubmitStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISubmitStallApplicationRequest=} [properties] Properties to set
           */
          function SubmitStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SubmitStallApplicationRequest stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @instance
           */
          SubmitStallApplicationRequest.prototype.stallApplicationId = "";

          /**
           * Creates a new SubmitStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISubmitStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SubmitStallApplicationRequest} SubmitStallApplicationRequest instance
           */
          SubmitStallApplicationRequest.create = function create(properties) {
            return new SubmitStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified SubmitStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SubmitStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISubmitStallApplicationRequest} message SubmitStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SubmitStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationId);
            return writer;
          };

          /**
           * Decodes a SubmitStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SubmitStallApplicationRequest} SubmitStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SubmitStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SubmitStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SubmitStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SubmitStallApplicationRequest} SubmitStallApplicationRequest
           */
          SubmitStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SubmitStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SubmitStallApplicationRequest();
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            return message;
          };

          /**
           * Creates a plain object from a SubmitStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SubmitStallApplicationRequest} message SubmitStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SubmitStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.stallApplicationId = "";
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            return object;
          };

          /**
           * Converts this SubmitStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SubmitStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SubmitStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SubmitStallApplicationRequest;
        })();

        racehorse360.WithdrawStallApplicationRequest = (function () {
          /**
           * Properties of a WithdrawStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IWithdrawStallApplicationRequest
           * @property {string|null} [stallApplicationId] WithdrawStallApplicationRequest stallApplicationId
           */

          /**
           * Constructs a new WithdrawStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WithdrawStallApplicationRequest.
           * @implements IWithdrawStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IWithdrawStallApplicationRequest=} [properties] Properties to set
           */
          function WithdrawStallApplicationRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * WithdrawStallApplicationRequest stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @instance
           */
          WithdrawStallApplicationRequest.prototype.stallApplicationId = "";

          /**
           * Creates a new WithdrawStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IWithdrawStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} WithdrawStallApplicationRequest instance
           */
          WithdrawStallApplicationRequest.create = function create(properties) {
            return new WithdrawStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified WithdrawStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.WithdrawStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IWithdrawStallApplicationRequest} message WithdrawStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          WithdrawStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationId);
            return writer;
          };

          /**
           * Decodes a WithdrawStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} WithdrawStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          WithdrawStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a WithdrawStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} WithdrawStallApplicationRequest
           */
          WithdrawStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .WithdrawStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest();
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            return message;
          };

          /**
           * Creates a plain object from a WithdrawStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} message WithdrawStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          WithdrawStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.stallApplicationId = "";
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            return object;
          };

          /**
           * Converts this WithdrawStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.WithdrawStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          WithdrawStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return WithdrawStallApplicationRequest;
        })();

        racehorse360.SaveDraftStallApplicationRequest = (function () {
          /**
           * Properties of a SaveDraftStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISaveDraftStallApplicationRequest
           * @property {string|null} [stallApplicationId] SaveDraftStallApplicationRequest stallApplicationId
           * @property {Array.<stronachgroup.first.racehorse360.IStableEntryWithStatusOnly>|null} [stableEntriesWithStatus] SaveDraftStallApplicationRequest stableEntriesWithStatus
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SaveDraftStallApplicationRequest getOptions
           */

          /**
           * Constructs a new SaveDraftStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SaveDraftStallApplicationRequest.
           * @implements ISaveDraftStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISaveDraftStallApplicationRequest=} [properties] Properties to set
           */
          function SaveDraftStallApplicationRequest(properties) {
            this.stableEntriesWithStatus = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SaveDraftStallApplicationRequest stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @instance
           */
          SaveDraftStallApplicationRequest.prototype.stallApplicationId = "";

          /**
           * SaveDraftStallApplicationRequest stableEntriesWithStatus.
           * @member {Array.<stronachgroup.first.racehorse360.IStableEntryWithStatusOnly>} stableEntriesWithStatus
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @instance
           */
          SaveDraftStallApplicationRequest.prototype.stableEntriesWithStatus =
            $util.emptyArray;

          /**
           * SaveDraftStallApplicationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @instance
           */
          SaveDraftStallApplicationRequest.prototype.getOptions = null;

          /**
           * Creates a new SaveDraftStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISaveDraftStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} SaveDraftStallApplicationRequest instance
           */
          SaveDraftStallApplicationRequest.create = function create(
            properties
          ) {
            return new SaveDraftStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified SaveDraftStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISaveDraftStallApplicationRequest} message SaveDraftStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SaveDraftStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationId);
            if (
              message.stableEntriesWithStatus != null &&
              message.stableEntriesWithStatus.length
            )
              for (var i = 0; i < message.stableEntriesWithStatus.length; ++i)
                $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.encode(
                  message.stableEntriesWithStatus[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SaveDraftStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} SaveDraftStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SaveDraftStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationId = reader.string();
                  break;
                case 2:
                  if (
                    !(
                      message.stableEntriesWithStatus &&
                      message.stableEntriesWithStatus.length
                    )
                  )
                    message.stableEntriesWithStatus = [];
                  message.stableEntriesWithStatus.push(
                    $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SaveDraftStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} SaveDraftStallApplicationRequest
           */
          SaveDraftStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SaveDraftStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest();
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            if (object.stableEntriesWithStatus) {
              if (!Array.isArray(object.stableEntriesWithStatus))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest.stableEntriesWithStatus: array expected"
                );
              message.stableEntriesWithStatus = [];
              for (var i = 0; i < object.stableEntriesWithStatus.length; ++i) {
                if (typeof object.stableEntriesWithStatus[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest.stableEntriesWithStatus: object expected"
                  );
                message.stableEntriesWithStatus[i] =
                  $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.fromObject(
                    object.stableEntriesWithStatus[i]
                  );
              }
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SaveDraftStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} message SaveDraftStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SaveDraftStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.stableEntriesWithStatus = [];
            if (options.defaults) {
              object.stallApplicationId = "";
              object.getOptions = null;
            }
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            if (
              message.stableEntriesWithStatus &&
              message.stableEntriesWithStatus.length
            ) {
              object.stableEntriesWithStatus = [];
              for (var j = 0; j < message.stableEntriesWithStatus.length; ++j)
                object.stableEntriesWithStatus[j] =
                  $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.toObject(
                    message.stableEntriesWithStatus[j],
                    options
                  );
            }
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SaveDraftStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SaveDraftStallApplicationRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return SaveDraftStallApplicationRequest;
        })();

        racehorse360.CompleteStallApplicationRequest = (function () {
          /**
           * Properties of a CompleteStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICompleteStallApplicationRequest
           * @property {string|null} [stallApplicationId] CompleteStallApplicationRequest stallApplicationId
           * @property {Array.<stronachgroup.first.racehorse360.IStableEntryWithStatusOnly>|null} [stableEntriesWithStatus] CompleteStallApplicationRequest stableEntriesWithStatus
           * @property {number|null} [sleepingRoomsNumberFirstChoice] CompleteStallApplicationRequest sleepingRoomsNumberFirstChoice
           * @property {number|null} [stallsNumberFirstChoice] CompleteStallApplicationRequest stallsNumberFirstChoice
           * @property {number|null} [sleepingRoomsNumberSecondChoice] CompleteStallApplicationRequest sleepingRoomsNumberSecondChoice
           * @property {number|null} [stallsNumberSecondChoice] CompleteStallApplicationRequest stallsNumberSecondChoice
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CompleteStallApplicationRequest getOptions
           */

          /**
           * Constructs a new CompleteStallApplicationRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CompleteStallApplicationRequest.
           * @implements ICompleteStallApplicationRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICompleteStallApplicationRequest=} [properties] Properties to set
           */
          function CompleteStallApplicationRequest(properties) {
            this.stableEntriesWithStatus = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CompleteStallApplicationRequest stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.stallApplicationId = "";

          /**
           * CompleteStallApplicationRequest stableEntriesWithStatus.
           * @member {Array.<stronachgroup.first.racehorse360.IStableEntryWithStatusOnly>} stableEntriesWithStatus
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.stableEntriesWithStatus =
            $util.emptyArray;

          /**
           * CompleteStallApplicationRequest sleepingRoomsNumberFirstChoice.
           * @member {number} sleepingRoomsNumberFirstChoice
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.sleepingRoomsNumberFirstChoice = 0;

          /**
           * CompleteStallApplicationRequest stallsNumberFirstChoice.
           * @member {number} stallsNumberFirstChoice
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.stallsNumberFirstChoice = 0;

          /**
           * CompleteStallApplicationRequest sleepingRoomsNumberSecondChoice.
           * @member {number} sleepingRoomsNumberSecondChoice
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.sleepingRoomsNumberSecondChoice = 0;

          /**
           * CompleteStallApplicationRequest stallsNumberSecondChoice.
           * @member {number} stallsNumberSecondChoice
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.stallsNumberSecondChoice = 0;

          /**
           * CompleteStallApplicationRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           */
          CompleteStallApplicationRequest.prototype.getOptions = null;

          /**
           * Creates a new CompleteStallApplicationRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteStallApplicationRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CompleteStallApplicationRequest} CompleteStallApplicationRequest instance
           */
          CompleteStallApplicationRequest.create = function create(properties) {
            return new CompleteStallApplicationRequest(properties);
          };

          /**
           * Encodes the specified CompleteStallApplicationRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CompleteStallApplicationRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICompleteStallApplicationRequest} message CompleteStallApplicationRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CompleteStallApplicationRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stallApplicationId);
            if (
              message.stableEntriesWithStatus != null &&
              message.stableEntriesWithStatus.length
            )
              for (var i = 0; i < message.stableEntriesWithStatus.length; ++i)
                $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.encode(
                  message.stableEntriesWithStatus[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (
              message.sleepingRoomsNumberFirstChoice != null &&
              Object.hasOwnProperty.call(
                message,
                "sleepingRoomsNumberFirstChoice"
              )
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.sleepingRoomsNumberFirstChoice);
            if (
              message.stallsNumberFirstChoice != null &&
              Object.hasOwnProperty.call(message, "stallsNumberFirstChoice")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.stallsNumberFirstChoice);
            if (
              message.sleepingRoomsNumberSecondChoice != null &&
              Object.hasOwnProperty.call(
                message,
                "sleepingRoomsNumberSecondChoice"
              )
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.sleepingRoomsNumberSecondChoice);
            if (
              message.stallsNumberSecondChoice != null &&
              Object.hasOwnProperty.call(message, "stallsNumberSecondChoice")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.stallsNumberSecondChoice);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CompleteStallApplicationRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CompleteStallApplicationRequest} CompleteStallApplicationRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CompleteStallApplicationRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CompleteStallApplicationRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stallApplicationId = reader.string();
                  break;
                case 2:
                  if (
                    !(
                      message.stableEntriesWithStatus &&
                      message.stableEntriesWithStatus.length
                    )
                  )
                    message.stableEntriesWithStatus = [];
                  message.stableEntriesWithStatus.push(
                    $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 3:
                  message.sleepingRoomsNumberFirstChoice = reader.int32();
                  break;
                case 4:
                  message.stallsNumberFirstChoice = reader.int32();
                  break;
                case 5:
                  message.sleepingRoomsNumberSecondChoice = reader.int32();
                  break;
                case 6:
                  message.stallsNumberSecondChoice = reader.int32();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CompleteStallApplicationRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CompleteStallApplicationRequest} CompleteStallApplicationRequest
           */
          CompleteStallApplicationRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .CompleteStallApplicationRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CompleteStallApplicationRequest();
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            if (object.stableEntriesWithStatus) {
              if (!Array.isArray(object.stableEntriesWithStatus))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteStallApplicationRequest.stableEntriesWithStatus: array expected"
                );
              message.stableEntriesWithStatus = [];
              for (var i = 0; i < object.stableEntriesWithStatus.length; ++i) {
                if (typeof object.stableEntriesWithStatus[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.CompleteStallApplicationRequest.stableEntriesWithStatus: object expected"
                  );
                message.stableEntriesWithStatus[i] =
                  $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.fromObject(
                    object.stableEntriesWithStatus[i]
                  );
              }
            }
            if (object.sleepingRoomsNumberFirstChoice != null)
              message.sleepingRoomsNumberFirstChoice =
                object.sleepingRoomsNumberFirstChoice | 0;
            if (object.stallsNumberFirstChoice != null)
              message.stallsNumberFirstChoice =
                object.stallsNumberFirstChoice | 0;
            if (object.sleepingRoomsNumberSecondChoice != null)
              message.sleepingRoomsNumberSecondChoice =
                object.sleepingRoomsNumberSecondChoice | 0;
            if (object.stallsNumberSecondChoice != null)
              message.stallsNumberSecondChoice =
                object.stallsNumberSecondChoice | 0;
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CompleteStallApplicationRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CompleteStallApplicationRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CompleteStallApplicationRequest} message CompleteStallApplicationRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CompleteStallApplicationRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.stableEntriesWithStatus = [];
            if (options.defaults) {
              object.stallApplicationId = "";
              object.sleepingRoomsNumberFirstChoice = 0;
              object.stallsNumberFirstChoice = 0;
              object.sleepingRoomsNumberSecondChoice = 0;
              object.stallsNumberSecondChoice = 0;
              object.getOptions = null;
            }
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            if (
              message.stableEntriesWithStatus &&
              message.stableEntriesWithStatus.length
            ) {
              object.stableEntriesWithStatus = [];
              for (var j = 0; j < message.stableEntriesWithStatus.length; ++j)
                object.stableEntriesWithStatus[j] =
                  $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly.toObject(
                    message.stableEntriesWithStatus[j],
                    options
                  );
            }
            if (
              message.sleepingRoomsNumberFirstChoice != null &&
              message.hasOwnProperty("sleepingRoomsNumberFirstChoice")
            )
              object.sleepingRoomsNumberFirstChoice =
                message.sleepingRoomsNumberFirstChoice;
            if (
              message.stallsNumberFirstChoice != null &&
              message.hasOwnProperty("stallsNumberFirstChoice")
            )
              object.stallsNumberFirstChoice = message.stallsNumberFirstChoice;
            if (
              message.sleepingRoomsNumberSecondChoice != null &&
              message.hasOwnProperty("sleepingRoomsNumberSecondChoice")
            )
              object.sleepingRoomsNumberSecondChoice =
                message.sleepingRoomsNumberSecondChoice;
            if (
              message.stallsNumberSecondChoice != null &&
              message.hasOwnProperty("stallsNumberSecondChoice")
            )
              object.stallsNumberSecondChoice =
                message.stallsNumberSecondChoice;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CompleteStallApplicationRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CompleteStallApplicationRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CompleteStallApplicationRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CompleteStallApplicationRequest;
        })();

        racehorse360.StableEntry = (function () {
          /**
           * Properties of a StableEntry.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStableEntry
           * @property {string|null} [id] StableEntry id
           * @property {string|null} [stallApplicationId] StableEntry stallApplicationId
           * @property {string|null} [horseId] StableEntry horseId
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] StableEntry horse
           * @property {string|null} [customHorseRegistrationNumber] StableEntry customHorseRegistrationNumber
           * @property {string|null} [customHorseName] StableEntry customHorseName
           * @property {string|null} [raceReadyDate] StableEntry raceReadyDate
           * @property {stronachgroup.first.racehorse360.StableEntryStatus|null} [status] StableEntry status
           */

          /**
           * Constructs a new StableEntry.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StableEntry.
           * @implements IStableEntry
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStableEntry=} [properties] Properties to set
           */
          function StableEntry(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StableEntry id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.id = "";

          /**
           * StableEntry stallApplicationId.
           * @member {string} stallApplicationId
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.stallApplicationId = "";

          /**
           * StableEntry horseId.
           * @member {string} horseId
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.horseId = "";

          /**
           * StableEntry horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.horse = null;

          /**
           * StableEntry customHorseRegistrationNumber.
           * @member {string} customHorseRegistrationNumber
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.customHorseRegistrationNumber = "";

          /**
           * StableEntry customHorseName.
           * @member {string} customHorseName
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.customHorseName = "";

          /**
           * StableEntry raceReadyDate.
           * @member {string} raceReadyDate
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.raceReadyDate = "";

          /**
           * StableEntry status.
           * @member {stronachgroup.first.racehorse360.StableEntryStatus} status
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           */
          StableEntry.prototype.status = 0;

          /**
           * Creates a new StableEntry instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntry=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StableEntry} StableEntry instance
           */
          StableEntry.create = function create(properties) {
            return new StableEntry(properties);
          };

          /**
           * Encodes the specified StableEntry message. Does not implicitly {@link stronachgroup.first.racehorse360.StableEntry.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntry} message StableEntry message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StableEntry.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.stallApplicationId != null &&
              Object.hasOwnProperty.call(message, "stallApplicationId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.stallApplicationId);
            if (
              message.horseId != null &&
              Object.hasOwnProperty.call(message, "horseId")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.horseId);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.customHorseRegistrationNumber != null &&
              Object.hasOwnProperty.call(
                message,
                "customHorseRegistrationNumber"
              )
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.customHorseRegistrationNumber);
            if (
              message.customHorseName != null &&
              Object.hasOwnProperty.call(message, "customHorseName")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.customHorseName);
            if (
              message.raceReadyDate != null &&
              Object.hasOwnProperty.call(message, "raceReadyDate")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.raceReadyDate);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.status);
            return writer;
          };

          /**
           * Decodes a StableEntry message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StableEntry} StableEntry
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StableEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StableEntry();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.stallApplicationId = reader.string();
                  break;
                case 3:
                  message.horseId = reader.string();
                  break;
                case 4:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.customHorseRegistrationNumber = reader.string();
                  break;
                case 6:
                  message.customHorseName = reader.string();
                  break;
                case 7:
                  message.raceReadyDate = reader.string();
                  break;
                case 8:
                  message.status = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StableEntry message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StableEntry} StableEntry
           */
          StableEntry.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StableEntry
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StableEntry();
            if (object.id != null) message.id = String(object.id);
            if (object.stallApplicationId != null)
              message.stallApplicationId = String(object.stallApplicationId);
            if (object.horseId != null)
              message.horseId = String(object.horseId);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StableEntry.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.customHorseRegistrationNumber != null)
              message.customHorseRegistrationNumber = String(
                object.customHorseRegistrationNumber
              );
            if (object.customHorseName != null)
              message.customHorseName = String(object.customHorseName);
            if (object.raceReadyDate != null)
              message.raceReadyDate = String(object.raceReadyDate);
            switch (object.status) {
              case "STABLE_ENTRY_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "STABLE_ENTRY_STATUS_AWAITING":
              case 1:
                message.status = 1;
                break;
              case "STABLE_ENTRY_STATUS_APPROVED":
              case 2:
                message.status = 2;
                break;
              case "STABLE_ENTRY_STATUS_DENIED":
              case 3:
                message.status = 3;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a StableEntry message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @static
           * @param {stronachgroup.first.racehorse360.StableEntry} message StableEntry
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StableEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.stallApplicationId = "";
              object.horseId = "";
              object.horse = null;
              object.customHorseRegistrationNumber = "";
              object.customHorseName = "";
              object.raceReadyDate = "";
              object.status =
                options.enums === String ? "STABLE_ENTRY_STATUS_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.stallApplicationId != null &&
              message.hasOwnProperty("stallApplicationId")
            )
              object.stallApplicationId = message.stallApplicationId;
            if (message.horseId != null && message.hasOwnProperty("horseId"))
              object.horseId = message.horseId;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (
              message.customHorseRegistrationNumber != null &&
              message.hasOwnProperty("customHorseRegistrationNumber")
            )
              object.customHorseRegistrationNumber =
                message.customHorseRegistrationNumber;
            if (
              message.customHorseName != null &&
              message.hasOwnProperty("customHorseName")
            )
              object.customHorseName = message.customHorseName;
            if (
              message.raceReadyDate != null &&
              message.hasOwnProperty("raceReadyDate")
            )
              object.raceReadyDate = message.raceReadyDate;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.StableEntryStatus[
                      message.status
                    ]
                  : message.status;
            return object;
          };

          /**
           * Converts this StableEntry to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StableEntry
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StableEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StableEntry;
        })();

        racehorse360.StableEntryWithStatusOnly = (function () {
          /**
           * Properties of a StableEntryWithStatusOnly.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStableEntryWithStatusOnly
           * @property {string|null} [id] StableEntryWithStatusOnly id
           * @property {stronachgroup.first.racehorse360.StableEntryStatus|null} [status] StableEntryWithStatusOnly status
           */

          /**
           * Constructs a new StableEntryWithStatusOnly.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StableEntryWithStatusOnly.
           * @implements IStableEntryWithStatusOnly
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStableEntryWithStatusOnly=} [properties] Properties to set
           */
          function StableEntryWithStatusOnly(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StableEntryWithStatusOnly id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @instance
           */
          StableEntryWithStatusOnly.prototype.id = "";

          /**
           * StableEntryWithStatusOnly status.
           * @member {stronachgroup.first.racehorse360.StableEntryStatus} status
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @instance
           */
          StableEntryWithStatusOnly.prototype.status = 0;

          /**
           * Creates a new StableEntryWithStatusOnly instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntryWithStatusOnly=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StableEntryWithStatusOnly} StableEntryWithStatusOnly instance
           */
          StableEntryWithStatusOnly.create = function create(properties) {
            return new StableEntryWithStatusOnly(properties);
          };

          /**
           * Encodes the specified StableEntryWithStatusOnly message. Does not implicitly {@link stronachgroup.first.racehorse360.StableEntryWithStatusOnly.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntryWithStatusOnly} message StableEntryWithStatusOnly message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StableEntryWithStatusOnly.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.status);
            return writer;
          };

          /**
           * Decodes a StableEntryWithStatusOnly message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StableEntryWithStatusOnly} StableEntryWithStatusOnly
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StableEntryWithStatusOnly.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.status = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StableEntryWithStatusOnly message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StableEntryWithStatusOnly} StableEntryWithStatusOnly
           */
          StableEntryWithStatusOnly.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StableEntryWithStatusOnly();
            if (object.id != null) message.id = String(object.id);
            switch (object.status) {
              case "STABLE_ENTRY_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "STABLE_ENTRY_STATUS_AWAITING":
              case 1:
                message.status = 1;
                break;
              case "STABLE_ENTRY_STATUS_APPROVED":
              case 2:
                message.status = 2;
                break;
              case "STABLE_ENTRY_STATUS_DENIED":
              case 3:
                message.status = 3;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a StableEntryWithStatusOnly message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @static
           * @param {stronachgroup.first.racehorse360.StableEntryWithStatusOnly} message StableEntryWithStatusOnly
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StableEntryWithStatusOnly.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.status =
                options.enums === String ? "STABLE_ENTRY_STATUS_INVALID" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.StableEntryStatus[
                      message.status
                    ]
                  : message.status;
            return object;
          };

          /**
           * Converts this StableEntryWithStatusOnly to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StableEntryWithStatusOnly
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StableEntryWithStatusOnly.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StableEntryWithStatusOnly;
        })();

        racehorse360.ListStableEntriesRequest = (function () {
          /**
           * Properties of a ListStableEntriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStableEntriesRequest
           * @property {stronachgroup.first.racehorse360.IStableEntryFilter|null} [query] ListStableEntriesRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListStableEntriesRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListStableEntriesRequest pagingOptions
           */

          /**
           * Constructs a new ListStableEntriesRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStableEntriesRequest.
           * @implements IListStableEntriesRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStableEntriesRequest=} [properties] Properties to set
           */
          function ListStableEntriesRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStableEntriesRequest query.
           * @member {stronachgroup.first.racehorse360.IStableEntryFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @instance
           */
          ListStableEntriesRequest.prototype.query = null;

          /**
           * ListStableEntriesRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @instance
           */
          ListStableEntriesRequest.prototype.getOptions = null;

          /**
           * ListStableEntriesRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @instance
           */
          ListStableEntriesRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListStableEntriesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStableEntriesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesRequest} ListStableEntriesRequest instance
           */
          ListStableEntriesRequest.create = function create(properties) {
            return new ListStableEntriesRequest(properties);
          };

          /**
           * Encodes the specified ListStableEntriesRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStableEntriesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListStableEntriesRequest} message ListStableEntriesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStableEntriesRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.StableEntryFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStableEntriesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesRequest} ListStableEntriesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStableEntriesRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStableEntriesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.StableEntryFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStableEntriesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesRequest} ListStableEntriesRequest
           */
          ListStableEntriesRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListStableEntriesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStableEntriesRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStableEntriesRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.StableEntryFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStableEntriesRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStableEntriesRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStableEntriesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListStableEntriesRequest} message ListStableEntriesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStableEntriesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.StableEntryFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStableEntriesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStableEntriesRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListStableEntriesRequest;
        })();

        racehorse360.StableEntryFilter = (function () {
          /**
           * Properties of a StableEntryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IStableEntryFilter
           * @property {Array.<string>|null} [ids] StableEntryFilter ids
           * @property {Array.<string>|null} [stallApplicationIds] StableEntryFilter stallApplicationIds
           */

          /**
           * Constructs a new StableEntryFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StableEntryFilter.
           * @implements IStableEntryFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IStableEntryFilter=} [properties] Properties to set
           */
          function StableEntryFilter(properties) {
            this.ids = [];
            this.stallApplicationIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * StableEntryFilter ids.
           * @member {Array.<string>} ids
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @instance
           */
          StableEntryFilter.prototype.ids = $util.emptyArray;

          /**
           * StableEntryFilter stallApplicationIds.
           * @member {Array.<string>} stallApplicationIds
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @instance
           */
          StableEntryFilter.prototype.stallApplicationIds = $util.emptyArray;

          /**
           * Creates a new StableEntryFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntryFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.StableEntryFilter} StableEntryFilter instance
           */
          StableEntryFilter.create = function create(properties) {
            return new StableEntryFilter(properties);
          };

          /**
           * Encodes the specified StableEntryFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.StableEntryFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IStableEntryFilter} message StableEntryFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          StableEntryFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.ids != null && message.ids.length)
              for (var i = 0; i < message.ids.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.ids[i]);
            if (
              message.stallApplicationIds != null &&
              message.stallApplicationIds.length
            )
              for (var i = 0; i < message.stallApplicationIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.stallApplicationIds[i]);
            return writer;
          };

          /**
           * Decodes a StableEntryFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.StableEntryFilter} StableEntryFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          StableEntryFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.StableEntryFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.ids && message.ids.length)) message.ids = [];
                  message.ids.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.stallApplicationIds &&
                      message.stallApplicationIds.length
                    )
                  )
                    message.stallApplicationIds = [];
                  message.stallApplicationIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a StableEntryFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.StableEntryFilter} StableEntryFilter
           */
          StableEntryFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.StableEntryFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.StableEntryFilter();
            if (object.ids) {
              if (!Array.isArray(object.ids))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StableEntryFilter.ids: array expected"
                );
              message.ids = [];
              for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
            }
            if (object.stallApplicationIds) {
              if (!Array.isArray(object.stallApplicationIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.StableEntryFilter.stallApplicationIds: array expected"
                );
              message.stallApplicationIds = [];
              for (var i = 0; i < object.stallApplicationIds.length; ++i)
                message.stallApplicationIds[i] = String(
                  object.stallApplicationIds[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a StableEntryFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @static
           * @param {stronachgroup.first.racehorse360.StableEntryFilter} message StableEntryFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          StableEntryFilter.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.ids = [];
              object.stallApplicationIds = [];
            }
            if (message.ids && message.ids.length) {
              object.ids = [];
              for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
            }
            if (
              message.stallApplicationIds &&
              message.stallApplicationIds.length
            ) {
              object.stallApplicationIds = [];
              for (var j = 0; j < message.stallApplicationIds.length; ++j)
                object.stallApplicationIds[j] = message.stallApplicationIds[j];
            }
            return object;
          };

          /**
           * Converts this StableEntryFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.StableEntryFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          StableEntryFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return StableEntryFilter;
        })();

        racehorse360.ListStableEntriesResponse = (function () {
          /**
           * Properties of a ListStableEntriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListStableEntriesResponse
           * @property {Array.<stronachgroup.first.racehorse360.IStableEntry>|null} [stableEntries] ListStableEntriesResponse stableEntries
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListStableEntriesResponse pagingInfo
           */

          /**
           * Constructs a new ListStableEntriesResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListStableEntriesResponse.
           * @implements IListStableEntriesResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListStableEntriesResponse=} [properties] Properties to set
           */
          function ListStableEntriesResponse(properties) {
            this.stableEntries = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListStableEntriesResponse stableEntries.
           * @member {Array.<stronachgroup.first.racehorse360.IStableEntry>} stableEntries
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @instance
           */
          ListStableEntriesResponse.prototype.stableEntries = $util.emptyArray;

          /**
           * ListStableEntriesResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @instance
           */
          ListStableEntriesResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListStableEntriesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStableEntriesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesResponse} ListStableEntriesResponse instance
           */
          ListStableEntriesResponse.create = function create(properties) {
            return new ListStableEntriesResponse(properties);
          };

          /**
           * Encodes the specified ListStableEntriesResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListStableEntriesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListStableEntriesResponse} message ListStableEntriesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListStableEntriesResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.stableEntries != null && message.stableEntries.length)
              for (var i = 0; i < message.stableEntries.length; ++i)
                $root.stronachgroup.first.racehorse360.StableEntry.encode(
                  message.stableEntries[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListStableEntriesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesResponse} ListStableEntriesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListStableEntriesResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListStableEntriesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.stableEntries && message.stableEntries.length))
                    message.stableEntries = [];
                  message.stableEntries.push(
                    $root.stronachgroup.first.racehorse360.StableEntry.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListStableEntriesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListStableEntriesResponse} ListStableEntriesResponse
           */
          ListStableEntriesResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.ListStableEntriesResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListStableEntriesResponse();
            if (object.stableEntries) {
              if (!Array.isArray(object.stableEntries))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStableEntriesResponse.stableEntries: array expected"
                );
              message.stableEntries = [];
              for (var i = 0; i < object.stableEntries.length; ++i) {
                if (typeof object.stableEntries[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListStableEntriesResponse.stableEntries: object expected"
                  );
                message.stableEntries[i] =
                  $root.stronachgroup.first.racehorse360.StableEntry.fromObject(
                    object.stableEntries[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListStableEntriesResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListStableEntriesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListStableEntriesResponse} message ListStableEntriesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListStableEntriesResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.stableEntries = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.stableEntries && message.stableEntries.length) {
              object.stableEntries = [];
              for (var j = 0; j < message.stableEntries.length; ++j)
                object.stableEntries[j] =
                  $root.stronachgroup.first.racehorse360.StableEntry.toObject(
                    message.stableEntries[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListStableEntriesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListStableEntriesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListStableEntriesResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListStableEntriesResponse;
        })();

        racehorse360.GetStableEntryRequest = (function () {
          /**
           * Properties of a GetStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetStableEntryRequest
           * @property {string|null} [id] GetStableEntryRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetStableEntryRequest getOptions
           */

          /**
           * Constructs a new GetStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetStableEntryRequest.
           * @implements IGetStableEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetStableEntryRequest=} [properties] Properties to set
           */
          function GetStableEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetStableEntryRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @instance
           */
          GetStableEntryRequest.prototype.id = "";

          /**
           * GetStableEntryRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @instance
           */
          GetStableEntryRequest.prototype.getOptions = null;

          /**
           * Creates a new GetStableEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStableEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetStableEntryRequest} GetStableEntryRequest instance
           */
          GetStableEntryRequest.create = function create(properties) {
            return new GetStableEntryRequest(properties);
          };

          /**
           * Encodes the specified GetStableEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetStableEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetStableEntryRequest} message GetStableEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetStableEntryRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetStableEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetStableEntryRequest} GetStableEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetStableEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetStableEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetStableEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetStableEntryRequest} GetStableEntryRequest
           */
          GetStableEntryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetStableEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetStableEntryRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetStableEntryRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetStableEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetStableEntryRequest} message GetStableEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetStableEntryRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetStableEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetStableEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetStableEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetStableEntryRequest;
        })();

        racehorse360.CreateStableEntryRequest = (function () {
          /**
           * Properties of a CreateStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ICreateStableEntryRequest
           * @property {stronachgroup.first.racehorse360.IStableEntry|null} [stableEntry] CreateStableEntryRequest stableEntry
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] CreateStableEntryRequest getOptions
           */

          /**
           * Constructs a new CreateStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a CreateStableEntryRequest.
           * @implements ICreateStableEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ICreateStableEntryRequest=} [properties] Properties to set
           */
          function CreateStableEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * CreateStableEntryRequest stableEntry.
           * @member {stronachgroup.first.racehorse360.IStableEntry|null|undefined} stableEntry
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @instance
           */
          CreateStableEntryRequest.prototype.stableEntry = null;

          /**
           * CreateStableEntryRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @instance
           */
          CreateStableEntryRequest.prototype.getOptions = null;

          /**
           * Creates a new CreateStableEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStableEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.CreateStableEntryRequest} CreateStableEntryRequest instance
           */
          CreateStableEntryRequest.create = function create(properties) {
            return new CreateStableEntryRequest(properties);
          };

          /**
           * Encodes the specified CreateStableEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.CreateStableEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ICreateStableEntryRequest} message CreateStableEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          CreateStableEntryRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.stableEntry != null &&
              Object.hasOwnProperty.call(message, "stableEntry")
            )
              $root.stronachgroup.first.racehorse360.StableEntry.encode(
                message.stableEntry,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a CreateStableEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.CreateStableEntryRequest} CreateStableEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          CreateStableEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.CreateStableEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stableEntry =
                    $root.stronachgroup.first.racehorse360.StableEntry.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a CreateStableEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.CreateStableEntryRequest} CreateStableEntryRequest
           */
          CreateStableEntryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.CreateStableEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.CreateStableEntryRequest();
            if (object.stableEntry != null) {
              if (typeof object.stableEntry !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStableEntryRequest.stableEntry: object expected"
                );
              message.stableEntry =
                $root.stronachgroup.first.racehorse360.StableEntry.fromObject(
                  object.stableEntry
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.CreateStableEntryRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a CreateStableEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.CreateStableEntryRequest} message CreateStableEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          CreateStableEntryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stableEntry = null;
              object.getOptions = null;
            }
            if (
              message.stableEntry != null &&
              message.hasOwnProperty("stableEntry")
            )
              object.stableEntry =
                $root.stronachgroup.first.racehorse360.StableEntry.toObject(
                  message.stableEntry,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this CreateStableEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.CreateStableEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          CreateStableEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return CreateStableEntryRequest;
        })();

        racehorse360.UpdateStableEntryRequest = (function () {
          /**
           * Properties of an UpdateStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IUpdateStableEntryRequest
           * @property {stronachgroup.first.racehorse360.IStableEntry|null} [stableEntry] UpdateStableEntryRequest stableEntry
           * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStableEntryRequest updateMask
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] UpdateStableEntryRequest getOptions
           */

          /**
           * Constructs a new UpdateStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpdateStableEntryRequest.
           * @implements IUpdateStableEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IUpdateStableEntryRequest=} [properties] Properties to set
           */
          function UpdateStableEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateStableEntryRequest stableEntry.
           * @member {stronachgroup.first.racehorse360.IStableEntry|null|undefined} stableEntry
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @instance
           */
          UpdateStableEntryRequest.prototype.stableEntry = null;

          /**
           * UpdateStableEntryRequest updateMask.
           * @member {google.protobuf.IFieldMask|null|undefined} updateMask
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @instance
           */
          UpdateStableEntryRequest.prototype.updateMask = null;

          /**
           * UpdateStableEntryRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @instance
           */
          UpdateStableEntryRequest.prototype.getOptions = null;

          /**
           * Creates a new UpdateStableEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStableEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.UpdateStableEntryRequest} UpdateStableEntryRequest instance
           */
          UpdateStableEntryRequest.create = function create(properties) {
            return new UpdateStableEntryRequest(properties);
          };

          /**
           * Encodes the specified UpdateStableEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.UpdateStableEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IUpdateStableEntryRequest} message UpdateStableEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateStableEntryRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.stableEntry != null &&
              Object.hasOwnProperty.call(message, "stableEntry")
            )
              $root.stronachgroup.first.racehorse360.StableEntry.encode(
                message.stableEntry,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.updateMask != null &&
              Object.hasOwnProperty.call(message, "updateMask")
            )
              $root.google.protobuf.FieldMask.encode(
                message.updateMask,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UpdateStableEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.UpdateStableEntryRequest} UpdateStableEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateStableEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.UpdateStableEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.stableEntry =
                    $root.stronachgroup.first.racehorse360.StableEntry.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.updateMask = $root.google.protobuf.FieldMask.decode(
                    reader,
                    reader.uint32()
                  );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateStableEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.UpdateStableEntryRequest} UpdateStableEntryRequest
           */
          UpdateStableEntryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.UpdateStableEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.UpdateStableEntryRequest();
            if (object.stableEntry != null) {
              if (typeof object.stableEntry !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStableEntryRequest.stableEntry: object expected"
                );
              message.stableEntry =
                $root.stronachgroup.first.racehorse360.StableEntry.fromObject(
                  object.stableEntry
                );
            }
            if (object.updateMask != null) {
              if (typeof object.updateMask !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStableEntryRequest.updateMask: object expected"
                );
              message.updateMask = $root.google.protobuf.FieldMask.fromObject(
                object.updateMask
              );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.UpdateStableEntryRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UpdateStableEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.UpdateStableEntryRequest} message UpdateStableEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateStableEntryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.stableEntry = null;
              object.updateMask = null;
              object.getOptions = null;
            }
            if (
              message.stableEntry != null &&
              message.hasOwnProperty("stableEntry")
            )
              object.stableEntry =
                $root.stronachgroup.first.racehorse360.StableEntry.toObject(
                  message.stableEntry,
                  options
                );
            if (
              message.updateMask != null &&
              message.hasOwnProperty("updateMask")
            )
              object.updateMask = $root.google.protobuf.FieldMask.toObject(
                message.updateMask,
                options
              );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this UpdateStableEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.UpdateStableEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateStableEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateStableEntryRequest;
        })();

        racehorse360.DeleteStableEntryRequest = (function () {
          /**
           * Properties of a DeleteStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IDeleteStableEntryRequest
           * @property {string|null} [id] DeleteStableEntryRequest id
           */

          /**
           * Constructs a new DeleteStableEntryRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a DeleteStableEntryRequest.
           * @implements IDeleteStableEntryRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IDeleteStableEntryRequest=} [properties] Properties to set
           */
          function DeleteStableEntryRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DeleteStableEntryRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @instance
           */
          DeleteStableEntryRequest.prototype.id = "";

          /**
           * Creates a new DeleteStableEntryRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStableEntryRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.DeleteStableEntryRequest} DeleteStableEntryRequest instance
           */
          DeleteStableEntryRequest.create = function create(properties) {
            return new DeleteStableEntryRequest(properties);
          };

          /**
           * Encodes the specified DeleteStableEntryRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.DeleteStableEntryRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IDeleteStableEntryRequest} message DeleteStableEntryRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DeleteStableEntryRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            return writer;
          };

          /**
           * Decodes a DeleteStableEntryRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.DeleteStableEntryRequest} DeleteStableEntryRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DeleteStableEntryRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.DeleteStableEntryRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DeleteStableEntryRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.DeleteStableEntryRequest} DeleteStableEntryRequest
           */
          DeleteStableEntryRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.DeleteStableEntryRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.DeleteStableEntryRequest();
            if (object.id != null) message.id = String(object.id);
            return message;
          };

          /**
           * Creates a plain object from a DeleteStableEntryRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @static
           * @param {stronachgroup.first.racehorse360.DeleteStableEntryRequest} message DeleteStableEntryRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DeleteStableEntryRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            return object;
          };

          /**
           * Converts this DeleteStableEntryRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.DeleteStableEntryRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DeleteStableEntryRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DeleteStableEntryRequest;
        })();

        racehorse360.InventoryAnalyticsBucket = (function () {
          /**
           * Properties of an InventoryAnalyticsBucket.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInventoryAnalyticsBucket
           * @property {stronachgroup.first.racehorse360.RaceClass|null} ["class"] InventoryAnalyticsBucket class
           * @property {Array.<stronachgroup.first.racehorse360.IInventoryAnalyticsRaceSubclass>|null} [subclasses] InventoryAnalyticsBucket subclasses
           */

          /**
           * Constructs a new InventoryAnalyticsBucket.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an InventoryAnalyticsBucket.
           * @implements IInventoryAnalyticsBucket
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsBucket=} [properties] Properties to set
           */
          function InventoryAnalyticsBucket(properties) {
            this.subclasses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * InventoryAnalyticsBucket class.
           * @member {stronachgroup.first.racehorse360.RaceClass} class
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @instance
           */
          InventoryAnalyticsBucket.prototype["class"] = 0;

          /**
           * InventoryAnalyticsBucket subclasses.
           * @member {Array.<stronachgroup.first.racehorse360.IInventoryAnalyticsRaceSubclass>} subclasses
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @instance
           */
          InventoryAnalyticsBucket.prototype.subclasses = $util.emptyArray;

          /**
           * Creates a new InventoryAnalyticsBucket instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsBucket=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsBucket} InventoryAnalyticsBucket instance
           */
          InventoryAnalyticsBucket.create = function create(properties) {
            return new InventoryAnalyticsBucket(properties);
          };

          /**
           * Encodes the specified InventoryAnalyticsBucket message. Does not implicitly {@link stronachgroup.first.racehorse360.InventoryAnalyticsBucket.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsBucket} message InventoryAnalyticsBucket message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          InventoryAnalyticsBucket.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message["class"] != null &&
              Object.hasOwnProperty.call(message, "class")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message["class"]);
            if (message.subclasses != null && message.subclasses.length)
              for (var i = 0; i < message.subclasses.length; ++i)
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.encode(
                  message.subclasses[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes an InventoryAnalyticsBucket message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsBucket} InventoryAnalyticsBucket
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          InventoryAnalyticsBucket.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message["class"] = reader.int32();
                  break;
                case 2:
                  if (!(message.subclasses && message.subclasses.length))
                    message.subclasses = [];
                  message.subclasses.push(
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an InventoryAnalyticsBucket message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsBucket} InventoryAnalyticsBucket
           */
          InventoryAnalyticsBucket.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket();
            switch (object["class"]) {
              case "RACE_CLASS_INVALID":
              case 0:
                message["class"] = 0;
                break;
              case "RACE_CLASS_STAKES":
              case 1:
                message["class"] = 1;
                break;
              case "RACE_CLASS_ALLOWANCE":
              case 2:
                message["class"] = 2;
                break;
              case "RACE_CLASS_STARTER":
              case 3:
                message["class"] = 3;
                break;
              case "RACE_CLASS_OPEN_CLAMING":
              case 4:
                message["class"] = 4;
                break;
              case "RACE_CLASS_CLAMING_CONDITION":
              case 5:
                message["class"] = 5;
                break;
              case "RACE_CLASS_MAIDEN":
              case 6:
                message["class"] = 6;
                break;
              case "RACE_CLASS_NO_STARTS":
              case 7:
                message["class"] = 7;
                break;
            }
            if (object.subclasses) {
              if (!Array.isArray(object.subclasses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InventoryAnalyticsBucket.subclasses: array expected"
                );
              message.subclasses = [];
              for (var i = 0; i < object.subclasses.length; ++i) {
                if (typeof object.subclasses[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.InventoryAnalyticsBucket.subclasses: object expected"
                  );
                message.subclasses[i] =
                  $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.fromObject(
                    object.subclasses[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from an InventoryAnalyticsBucket message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @static
           * @param {stronachgroup.first.racehorse360.InventoryAnalyticsBucket} message InventoryAnalyticsBucket
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          InventoryAnalyticsBucket.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.subclasses = [];
            if (options.defaults)
              object["class"] =
                options.enums === String ? "RACE_CLASS_INVALID" : 0;
            if (message["class"] != null && message.hasOwnProperty("class"))
              object["class"] =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.RaceClass[
                      message["class"]
                    ]
                  : message["class"];
            if (message.subclasses && message.subclasses.length) {
              object.subclasses = [];
              for (var j = 0; j < message.subclasses.length; ++j)
                object.subclasses[j] =
                  $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.toObject(
                    message.subclasses[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this InventoryAnalyticsBucket to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsBucket
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          InventoryAnalyticsBucket.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return InventoryAnalyticsBucket;
        })();

        racehorse360.InventoryAnalyticsRaceSubclass = (function () {
          /**
           * Properties of an InventoryAnalyticsRaceSubclass.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInventoryAnalyticsRaceSubclass
           * @property {string|null} [subclass] InventoryAnalyticsRaceSubclass subclass
           * @property {number|null} [totalCount] InventoryAnalyticsRaceSubclass totalCount
           * @property {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup|null} [dirtSurfaceGroup] InventoryAnalyticsRaceSubclass dirtSurfaceGroup
           * @property {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup|null} [turfSyntheticSurfaceGroup] InventoryAnalyticsRaceSubclass turfSyntheticSurfaceGroup
           */

          /**
           * Constructs a new InventoryAnalyticsRaceSubclass.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an InventoryAnalyticsRaceSubclass.
           * @implements IInventoryAnalyticsRaceSubclass
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsRaceSubclass=} [properties] Properties to set
           */
          function InventoryAnalyticsRaceSubclass(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * InventoryAnalyticsRaceSubclass subclass.
           * @member {string} subclass
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @instance
           */
          InventoryAnalyticsRaceSubclass.prototype.subclass = "";

          /**
           * InventoryAnalyticsRaceSubclass totalCount.
           * @member {number} totalCount
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @instance
           */
          InventoryAnalyticsRaceSubclass.prototype.totalCount = 0;

          /**
           * InventoryAnalyticsRaceSubclass dirtSurfaceGroup.
           * @member {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup|null|undefined} dirtSurfaceGroup
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @instance
           */
          InventoryAnalyticsRaceSubclass.prototype.dirtSurfaceGroup = null;

          /**
           * InventoryAnalyticsRaceSubclass turfSyntheticSurfaceGroup.
           * @member {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup|null|undefined} turfSyntheticSurfaceGroup
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @instance
           */
          InventoryAnalyticsRaceSubclass.prototype.turfSyntheticSurfaceGroup =
            null;

          /**
           * Creates a new InventoryAnalyticsRaceSubclass instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsRaceSubclass=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass} InventoryAnalyticsRaceSubclass instance
           */
          InventoryAnalyticsRaceSubclass.create = function create(properties) {
            return new InventoryAnalyticsRaceSubclass(properties);
          };

          /**
           * Encodes the specified InventoryAnalyticsRaceSubclass message. Does not implicitly {@link stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsRaceSubclass} message InventoryAnalyticsRaceSubclass message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          InventoryAnalyticsRaceSubclass.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.subclass != null &&
              Object.hasOwnProperty.call(message, "subclass")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.subclass);
            if (
              message.totalCount != null &&
              Object.hasOwnProperty.call(message, "totalCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.totalCount);
            if (
              message.dirtSurfaceGroup != null &&
              Object.hasOwnProperty.call(message, "dirtSurfaceGroup")
            )
              $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.encode(
                message.dirtSurfaceGroup,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.turfSyntheticSurfaceGroup != null &&
              Object.hasOwnProperty.call(message, "turfSyntheticSurfaceGroup")
            )
              $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.encode(
                message.turfSyntheticSurfaceGroup,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an InventoryAnalyticsRaceSubclass message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass} InventoryAnalyticsRaceSubclass
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          InventoryAnalyticsRaceSubclass.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.subclass = reader.string();
                  break;
                case 2:
                  message.totalCount = reader.int32();
                  break;
                case 3:
                  message.dirtSurfaceGroup =
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.turfSyntheticSurfaceGroup =
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an InventoryAnalyticsRaceSubclass message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass} InventoryAnalyticsRaceSubclass
           */
          InventoryAnalyticsRaceSubclass.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .InventoryAnalyticsRaceSubclass
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass();
            if (object.subclass != null)
              message.subclass = String(object.subclass);
            if (object.totalCount != null)
              message.totalCount = object.totalCount | 0;
            if (object.dirtSurfaceGroup != null) {
              if (typeof object.dirtSurfaceGroup !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.dirtSurfaceGroup: object expected"
                );
              message.dirtSurfaceGroup =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.fromObject(
                  object.dirtSurfaceGroup
                );
            }
            if (object.turfSyntheticSurfaceGroup != null) {
              if (typeof object.turfSyntheticSurfaceGroup !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass.turfSyntheticSurfaceGroup: object expected"
                );
              message.turfSyntheticSurfaceGroup =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.fromObject(
                  object.turfSyntheticSurfaceGroup
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an InventoryAnalyticsRaceSubclass message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @static
           * @param {stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass} message InventoryAnalyticsRaceSubclass
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          InventoryAnalyticsRaceSubclass.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.subclass = "";
              object.totalCount = 0;
              object.dirtSurfaceGroup = null;
              object.turfSyntheticSurfaceGroup = null;
            }
            if (message.subclass != null && message.hasOwnProperty("subclass"))
              object.subclass = message.subclass;
            if (
              message.totalCount != null &&
              message.hasOwnProperty("totalCount")
            )
              object.totalCount = message.totalCount;
            if (
              message.dirtSurfaceGroup != null &&
              message.hasOwnProperty("dirtSurfaceGroup")
            )
              object.dirtSurfaceGroup =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.toObject(
                  message.dirtSurfaceGroup,
                  options
                );
            if (
              message.turfSyntheticSurfaceGroup != null &&
              message.hasOwnProperty("turfSyntheticSurfaceGroup")
            )
              object.turfSyntheticSurfaceGroup =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.toObject(
                  message.turfSyntheticSurfaceGroup,
                  options
                );
            return object;
          };

          /**
           * Converts this InventoryAnalyticsRaceSubclass to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsRaceSubclass
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          InventoryAnalyticsRaceSubclass.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return InventoryAnalyticsRaceSubclass;
        })();

        racehorse360.InventoryAnalyticsSurfaceGroup = (function () {
          /**
           * Properties of an InventoryAnalyticsSurfaceGroup.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInventoryAnalyticsSurfaceGroup
           * @property {number|null} [totalCount] InventoryAnalyticsSurfaceGroup totalCount
           * @property {number|null} [activeCount] InventoryAnalyticsSurfaceGroup activeCount
           * @property {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup|null} [sprinter] InventoryAnalyticsSurfaceGroup sprinter
           * @property {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup|null} [route] InventoryAnalyticsSurfaceGroup route
           */

          /**
           * Constructs a new InventoryAnalyticsSurfaceGroup.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an InventoryAnalyticsSurfaceGroup.
           * @implements IInventoryAnalyticsSurfaceGroup
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup=} [properties] Properties to set
           */
          function InventoryAnalyticsSurfaceGroup(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * InventoryAnalyticsSurfaceGroup totalCount.
           * @member {number} totalCount
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @instance
           */
          InventoryAnalyticsSurfaceGroup.prototype.totalCount = 0;

          /**
           * InventoryAnalyticsSurfaceGroup activeCount.
           * @member {number} activeCount
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @instance
           */
          InventoryAnalyticsSurfaceGroup.prototype.activeCount = 0;

          /**
           * InventoryAnalyticsSurfaceGroup sprinter.
           * @member {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup|null|undefined} sprinter
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @instance
           */
          InventoryAnalyticsSurfaceGroup.prototype.sprinter = null;

          /**
           * InventoryAnalyticsSurfaceGroup route.
           * @member {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup|null|undefined} route
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @instance
           */
          InventoryAnalyticsSurfaceGroup.prototype.route = null;

          /**
           * Creates a new InventoryAnalyticsSurfaceGroup instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup} InventoryAnalyticsSurfaceGroup instance
           */
          InventoryAnalyticsSurfaceGroup.create = function create(properties) {
            return new InventoryAnalyticsSurfaceGroup(properties);
          };

          /**
           * Encodes the specified InventoryAnalyticsSurfaceGroup message. Does not implicitly {@link stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsSurfaceGroup} message InventoryAnalyticsSurfaceGroup message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          InventoryAnalyticsSurfaceGroup.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.totalCount != null &&
              Object.hasOwnProperty.call(message, "totalCount")
            )
              writer
                .uint32(/* id 1, wireType 0 =*/ 8)
                .int32(message.totalCount);
            if (
              message.activeCount != null &&
              Object.hasOwnProperty.call(message, "activeCount")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.activeCount);
            if (
              message.sprinter != null &&
              Object.hasOwnProperty.call(message, "sprinter")
            )
              $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.encode(
                message.sprinter,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.route != null &&
              Object.hasOwnProperty.call(message, "route")
            )
              $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.encode(
                message.route,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an InventoryAnalyticsSurfaceGroup message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup} InventoryAnalyticsSurfaceGroup
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          InventoryAnalyticsSurfaceGroup.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.totalCount = reader.int32();
                  break;
                case 2:
                  message.activeCount = reader.int32();
                  break;
                case 3:
                  message.sprinter =
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.route =
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an InventoryAnalyticsSurfaceGroup message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup} InventoryAnalyticsSurfaceGroup
           */
          InventoryAnalyticsSurfaceGroup.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .InventoryAnalyticsSurfaceGroup
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup();
            if (object.totalCount != null)
              message.totalCount = object.totalCount | 0;
            if (object.activeCount != null)
              message.activeCount = object.activeCount | 0;
            if (object.sprinter != null) {
              if (typeof object.sprinter !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.sprinter: object expected"
                );
              message.sprinter =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.fromObject(
                  object.sprinter
                );
            }
            if (object.route != null) {
              if (typeof object.route !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup.route: object expected"
                );
              message.route =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.fromObject(
                  object.route
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an InventoryAnalyticsSurfaceGroup message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup} message InventoryAnalyticsSurfaceGroup
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          InventoryAnalyticsSurfaceGroup.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.totalCount = 0;
              object.activeCount = 0;
              object.sprinter = null;
              object.route = null;
            }
            if (
              message.totalCount != null &&
              message.hasOwnProperty("totalCount")
            )
              object.totalCount = message.totalCount;
            if (
              message.activeCount != null &&
              message.hasOwnProperty("activeCount")
            )
              object.activeCount = message.activeCount;
            if (message.sprinter != null && message.hasOwnProperty("sprinter"))
              object.sprinter =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.toObject(
                  message.sprinter,
                  options
                );
            if (message.route != null && message.hasOwnProperty("route"))
              object.route =
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.toObject(
                  message.route,
                  options
                );
            return object;
          };

          /**
           * Converts this InventoryAnalyticsSurfaceGroup to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsSurfaceGroup
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          InventoryAnalyticsSurfaceGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return InventoryAnalyticsSurfaceGroup;
        })();

        racehorse360.InventoryAnalyticsDistanceGroup = (function () {
          /**
           * Properties of an InventoryAnalyticsDistanceGroup.
           * @memberof stronachgroup.first.racehorse360
           * @interface IInventoryAnalyticsDistanceGroup
           * @property {number|null} [totalCount] InventoryAnalyticsDistanceGroup totalCount
           * @property {number|null} [twoYearOlds] InventoryAnalyticsDistanceGroup twoYearOlds
           * @property {number|null} [threeYearOlds] InventoryAnalyticsDistanceGroup threeYearOlds
           * @property {number|null} [fourAndUpYearOlds] InventoryAnalyticsDistanceGroup fourAndUpYearOlds
           */

          /**
           * Constructs a new InventoryAnalyticsDistanceGroup.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an InventoryAnalyticsDistanceGroup.
           * @implements IInventoryAnalyticsDistanceGroup
           * @constructor
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup=} [properties] Properties to set
           */
          function InventoryAnalyticsDistanceGroup(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * InventoryAnalyticsDistanceGroup totalCount.
           * @member {number} totalCount
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @instance
           */
          InventoryAnalyticsDistanceGroup.prototype.totalCount = 0;

          /**
           * InventoryAnalyticsDistanceGroup twoYearOlds.
           * @member {number} twoYearOlds
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @instance
           */
          InventoryAnalyticsDistanceGroup.prototype.twoYearOlds = 0;

          /**
           * InventoryAnalyticsDistanceGroup threeYearOlds.
           * @member {number} threeYearOlds
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @instance
           */
          InventoryAnalyticsDistanceGroup.prototype.threeYearOlds = 0;

          /**
           * InventoryAnalyticsDistanceGroup fourAndUpYearOlds.
           * @member {number} fourAndUpYearOlds
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @instance
           */
          InventoryAnalyticsDistanceGroup.prototype.fourAndUpYearOlds = 0;

          /**
           * Creates a new InventoryAnalyticsDistanceGroup instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup} InventoryAnalyticsDistanceGroup instance
           */
          InventoryAnalyticsDistanceGroup.create = function create(properties) {
            return new InventoryAnalyticsDistanceGroup(properties);
          };

          /**
           * Encodes the specified InventoryAnalyticsDistanceGroup message. Does not implicitly {@link stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.IInventoryAnalyticsDistanceGroup} message InventoryAnalyticsDistanceGroup message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          InventoryAnalyticsDistanceGroup.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.totalCount != null &&
              Object.hasOwnProperty.call(message, "totalCount")
            )
              writer
                .uint32(/* id 1, wireType 0 =*/ 8)
                .int32(message.totalCount);
            if (
              message.twoYearOlds != null &&
              Object.hasOwnProperty.call(message, "twoYearOlds")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.twoYearOlds);
            if (
              message.threeYearOlds != null &&
              Object.hasOwnProperty.call(message, "threeYearOlds")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .int32(message.threeYearOlds);
            if (
              message.fourAndUpYearOlds != null &&
              Object.hasOwnProperty.call(message, "fourAndUpYearOlds")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .int32(message.fourAndUpYearOlds);
            return writer;
          };

          /**
           * Decodes an InventoryAnalyticsDistanceGroup message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup} InventoryAnalyticsDistanceGroup
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          InventoryAnalyticsDistanceGroup.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.totalCount = reader.int32();
                  break;
                case 2:
                  message.twoYearOlds = reader.int32();
                  break;
                case 3:
                  message.threeYearOlds = reader.int32();
                  break;
                case 4:
                  message.fourAndUpYearOlds = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an InventoryAnalyticsDistanceGroup message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup} InventoryAnalyticsDistanceGroup
           */
          InventoryAnalyticsDistanceGroup.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .InventoryAnalyticsDistanceGroup
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup();
            if (object.totalCount != null)
              message.totalCount = object.totalCount | 0;
            if (object.twoYearOlds != null)
              message.twoYearOlds = object.twoYearOlds | 0;
            if (object.threeYearOlds != null)
              message.threeYearOlds = object.threeYearOlds | 0;
            if (object.fourAndUpYearOlds != null)
              message.fourAndUpYearOlds = object.fourAndUpYearOlds | 0;
            return message;
          };

          /**
           * Creates a plain object from an InventoryAnalyticsDistanceGroup message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @static
           * @param {stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup} message InventoryAnalyticsDistanceGroup
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          InventoryAnalyticsDistanceGroup.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.totalCount = 0;
              object.twoYearOlds = 0;
              object.threeYearOlds = 0;
              object.fourAndUpYearOlds = 0;
            }
            if (
              message.totalCount != null &&
              message.hasOwnProperty("totalCount")
            )
              object.totalCount = message.totalCount;
            if (
              message.twoYearOlds != null &&
              message.hasOwnProperty("twoYearOlds")
            )
              object.twoYearOlds = message.twoYearOlds;
            if (
              message.threeYearOlds != null &&
              message.hasOwnProperty("threeYearOlds")
            )
              object.threeYearOlds = message.threeYearOlds;
            if (
              message.fourAndUpYearOlds != null &&
              message.hasOwnProperty("fourAndUpYearOlds")
            )
              object.fourAndUpYearOlds = message.fourAndUpYearOlds;
            return object;
          };

          /**
           * Converts this InventoryAnalyticsDistanceGroup to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.InventoryAnalyticsDistanceGroup
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          InventoryAnalyticsDistanceGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return InventoryAnalyticsDistanceGroup;
        })();

        racehorse360.PullInventoryAnalyticsRequest = (function () {
          /**
           * Properties of a PullInventoryAnalyticsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullInventoryAnalyticsRequest
           */

          /**
           * Constructs a new PullInventoryAnalyticsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullInventoryAnalyticsRequest.
           * @implements IPullInventoryAnalyticsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsRequest=} [properties] Properties to set
           */
          function PullInventoryAnalyticsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new PullInventoryAnalyticsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} PullInventoryAnalyticsRequest instance
           */
          PullInventoryAnalyticsRequest.create = function create(properties) {
            return new PullInventoryAnalyticsRequest(properties);
          };

          /**
           * Encodes the specified PullInventoryAnalyticsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsRequest} message PullInventoryAnalyticsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullInventoryAnalyticsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a PullInventoryAnalyticsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} PullInventoryAnalyticsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullInventoryAnalyticsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullInventoryAnalyticsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} PullInventoryAnalyticsRequest
           */
          PullInventoryAnalyticsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullInventoryAnalyticsRequest
            )
              return object;
            return new $root.stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest();
          };

          /**
           * Creates a plain object from a PullInventoryAnalyticsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest} message PullInventoryAnalyticsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullInventoryAnalyticsRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this PullInventoryAnalyticsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullInventoryAnalyticsRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullInventoryAnalyticsRequest;
        })();

        racehorse360.PullInventoryAnalyticsResponse = (function () {
          /**
           * Properties of a PullInventoryAnalyticsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullInventoryAnalyticsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IInventoryAnalyticsBucket>|null} [chart] PullInventoryAnalyticsResponse chart
           */

          /**
           * Constructs a new PullInventoryAnalyticsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullInventoryAnalyticsResponse.
           * @implements IPullInventoryAnalyticsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsResponse=} [properties] Properties to set
           */
          function PullInventoryAnalyticsResponse(properties) {
            this.chart = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullInventoryAnalyticsResponse chart.
           * @member {Array.<stronachgroup.first.racehorse360.IInventoryAnalyticsBucket>} chart
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @instance
           */
          PullInventoryAnalyticsResponse.prototype.chart = $util.emptyArray;

          /**
           * Creates a new PullInventoryAnalyticsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse} PullInventoryAnalyticsResponse instance
           */
          PullInventoryAnalyticsResponse.create = function create(properties) {
            return new PullInventoryAnalyticsResponse(properties);
          };

          /**
           * Encodes the specified PullInventoryAnalyticsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsResponse} message PullInventoryAnalyticsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullInventoryAnalyticsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.chart != null && message.chart.length)
              for (var i = 0; i < message.chart.length; ++i)
                $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket.encode(
                  message.chart[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullInventoryAnalyticsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse} PullInventoryAnalyticsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullInventoryAnalyticsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.chart && message.chart.length))
                    message.chart = [];
                  message.chart.push(
                    $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullInventoryAnalyticsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse} PullInventoryAnalyticsResponse
           */
          PullInventoryAnalyticsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .PullInventoryAnalyticsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse();
            if (object.chart) {
              if (!Array.isArray(object.chart))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse.chart: array expected"
                );
              message.chart = [];
              for (var i = 0; i < object.chart.length; ++i) {
                if (typeof object.chart[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse.chart: object expected"
                  );
                message.chart[i] =
                  $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket.fromObject(
                    object.chart[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a PullInventoryAnalyticsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse} message PullInventoryAnalyticsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullInventoryAnalyticsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.chart = [];
            if (message.chart && message.chart.length) {
              object.chart = [];
              for (var j = 0; j < message.chart.length; ++j)
                object.chart[j] =
                  $root.stronachgroup.first.racehorse360.InventoryAnalyticsBucket.toObject(
                    message.chart[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullInventoryAnalyticsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullInventoryAnalyticsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return PullInventoryAnalyticsResponse;
        })();

        racehorse360.TrackOpticsVideo = (function () {
          /**
           * Properties of a TrackOpticsVideo.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideo
           * @property {string|null} [id] TrackOpticsVideo id
           * @property {string|null} [videoId] TrackOpticsVideo videoId
           * @property {boolean|null} [hasStandardView] TrackOpticsVideo hasStandardView
           * @property {boolean|null} [hasDetectionsView] TrackOpticsVideo hasDetectionsView
           * @property {string|null} [mimeType] TrackOpticsVideo mimeType
           * @property {string|null} [date] TrackOpticsVideo date
           * @property {stronachgroup.first.racehorse360.IFacility|null} [facility] TrackOpticsVideo facility
           * @property {stronachgroup.first.racehorse360.TrackOpticsVideoStatus|null} [status] TrackOpticsVideo status
           * @property {string|null} [horseNameOrRegistrationNumber] TrackOpticsVideo horseNameOrRegistrationNumber
           * @property {stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry|null} [injuryEntry] TrackOpticsVideo injuryEntry
           * @property {stronachgroup.first.racehorse360.ITrackOpticsVideoLimb|null} [limb] TrackOpticsVideo limb
           * @property {stronachgroup.first.racehorse360.ITrackOpticsVideoStride|null} [stride] TrackOpticsVideo stride
           * @property {string|null} [comment] TrackOpticsVideo comment
           * @property {stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity|null} [injurySeverity] TrackOpticsVideo injurySeverity
           * @property {google.protobuf.IStringValue|null} [injuryReportDate] TrackOpticsVideo injuryReportDate
           * @property {stronachgroup.first.racehorse360.IUser|null} [injuryReportCreator] TrackOpticsVideo injuryReportCreator
           */

          /**
           * Constructs a new TrackOpticsVideo.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideo.
           * @implements ITrackOpticsVideo
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideo=} [properties] Properties to set
           */
          function TrackOpticsVideo(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideo id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.id = "";

          /**
           * TrackOpticsVideo videoId.
           * @member {string} videoId
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.videoId = "";

          /**
           * TrackOpticsVideo hasStandardView.
           * @member {boolean} hasStandardView
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.hasStandardView = false;

          /**
           * TrackOpticsVideo hasDetectionsView.
           * @member {boolean} hasDetectionsView
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.hasDetectionsView = false;

          /**
           * TrackOpticsVideo mimeType.
           * @member {string} mimeType
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.mimeType = "";

          /**
           * TrackOpticsVideo date.
           * @member {string} date
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.date = "";

          /**
           * TrackOpticsVideo facility.
           * @member {stronachgroup.first.racehorse360.IFacility|null|undefined} facility
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.facility = null;

          /**
           * TrackOpticsVideo status.
           * @member {stronachgroup.first.racehorse360.TrackOpticsVideoStatus} status
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.status = 0;

          /**
           * TrackOpticsVideo horseNameOrRegistrationNumber.
           * @member {string} horseNameOrRegistrationNumber
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.horseNameOrRegistrationNumber = "";

          /**
           * TrackOpticsVideo injuryEntry.
           * @member {stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry|null|undefined} injuryEntry
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.injuryEntry = null;

          /**
           * TrackOpticsVideo limb.
           * @member {stronachgroup.first.racehorse360.ITrackOpticsVideoLimb|null|undefined} limb
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.limb = null;

          /**
           * TrackOpticsVideo stride.
           * @member {stronachgroup.first.racehorse360.ITrackOpticsVideoStride|null|undefined} stride
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.stride = null;

          /**
           * TrackOpticsVideo comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.comment = "";

          /**
           * TrackOpticsVideo injurySeverity.
           * @member {stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity|null|undefined} injurySeverity
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.injurySeverity = null;

          /**
           * TrackOpticsVideo injuryReportDate.
           * @member {google.protobuf.IStringValue|null|undefined} injuryReportDate
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.injuryReportDate = null;

          /**
           * TrackOpticsVideo injuryReportCreator.
           * @member {stronachgroup.first.racehorse360.IUser|null|undefined} injuryReportCreator
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           */
          TrackOpticsVideo.prototype.injuryReportCreator = null;

          /**
           * Creates a new TrackOpticsVideo instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideo=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideo} TrackOpticsVideo instance
           */
          TrackOpticsVideo.create = function create(properties) {
            return new TrackOpticsVideo(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideo message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideo.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideo} message TrackOpticsVideo message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideo.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.videoId != null &&
              Object.hasOwnProperty.call(message, "videoId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.videoId);
            if (
              message.hasStandardView != null &&
              Object.hasOwnProperty.call(message, "hasStandardView")
            )
              writer
                .uint32(/* id 3, wireType 0 =*/ 24)
                .bool(message.hasStandardView);
            if (
              message.hasDetectionsView != null &&
              Object.hasOwnProperty.call(message, "hasDetectionsView")
            )
              writer
                .uint32(/* id 4, wireType 0 =*/ 32)
                .bool(message.hasDetectionsView);
            if (
              message.mimeType != null &&
              Object.hasOwnProperty.call(message, "mimeType")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.mimeType);
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.date);
            if (
              message.facility != null &&
              Object.hasOwnProperty.call(message, "facility")
            )
              $root.stronachgroup.first.racehorse360.Facility.encode(
                message.facility,
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.status);
            if (
              message.horseNameOrRegistrationNumber != null &&
              Object.hasOwnProperty.call(
                message,
                "horseNameOrRegistrationNumber"
              )
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.horseNameOrRegistrationNumber);
            if (
              message.injuryEntry != null &&
              Object.hasOwnProperty.call(message, "injuryEntry")
            )
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.encode(
                message.injuryEntry,
                writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
              ).ldelim();
            if (
              message.limb != null &&
              Object.hasOwnProperty.call(message, "limb")
            )
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.encode(
                message.limb,
                writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
              ).ldelim();
            if (
              message.stride != null &&
              Object.hasOwnProperty.call(message, "stride")
            )
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.encode(
                message.stride,
                writer.uint32(/* id 16, wireType 2 =*/ 130).fork()
              ).ldelim();
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.comment);
            if (
              message.injurySeverity != null &&
              Object.hasOwnProperty.call(message, "injurySeverity")
            )
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.encode(
                message.injurySeverity,
                writer.uint32(/* id 19, wireType 2 =*/ 154).fork()
              ).ldelim();
            if (
              message.injuryReportDate != null &&
              Object.hasOwnProperty.call(message, "injuryReportDate")
            )
              $root.google.protobuf.StringValue.encode(
                message.injuryReportDate,
                writer.uint32(/* id 20, wireType 2 =*/ 162).fork()
              ).ldelim();
            if (
              message.injuryReportCreator != null &&
              Object.hasOwnProperty.call(message, "injuryReportCreator")
            )
              $root.stronachgroup.first.racehorse360.User.encode(
                message.injuryReportCreator,
                writer.uint32(/* id 21, wireType 2 =*/ 170).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideo message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideo} TrackOpticsVideo
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideo();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.videoId = reader.string();
                  break;
                case 3:
                  message.hasStandardView = reader.bool();
                  break;
                case 4:
                  message.hasDetectionsView = reader.bool();
                  break;
                case 5:
                  message.mimeType = reader.string();
                  break;
                case 6:
                  message.date = reader.string();
                  break;
                case 8:
                  message.facility =
                    $root.stronachgroup.first.racehorse360.Facility.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 9:
                  message.status = reader.int32();
                  break;
                case 10:
                  message.horseNameOrRegistrationNumber = reader.string();
                  break;
                case 12:
                  message.injuryEntry =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 14:
                  message.limb =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 16:
                  message.stride =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 18:
                  message.comment = reader.string();
                  break;
                case 19:
                  message.injurySeverity =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 20:
                  message.injuryReportDate =
                    $root.google.protobuf.StringValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 21:
                  message.injuryReportCreator =
                    $root.stronachgroup.first.racehorse360.User.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideo message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideo} TrackOpticsVideo
           */
          TrackOpticsVideo.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrackOpticsVideo
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideo();
            if (object.id != null) message.id = String(object.id);
            if (object.videoId != null)
              message.videoId = String(object.videoId);
            if (object.hasStandardView != null)
              message.hasStandardView = Boolean(object.hasStandardView);
            if (object.hasDetectionsView != null)
              message.hasDetectionsView = Boolean(object.hasDetectionsView);
            if (object.mimeType != null)
              message.mimeType = String(object.mimeType);
            if (object.date != null) message.date = String(object.date);
            if (object.facility != null) {
              if (typeof object.facility !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.facility: object expected"
                );
              message.facility =
                $root.stronachgroup.first.racehorse360.Facility.fromObject(
                  object.facility
                );
            }
            switch (object.status) {
              case "TRACK_OPTICS_VIDEO_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "TRACK_OPTICS_VIDEO_STATUS_IN_PROGRESS":
              case 1:
                message.status = 1;
                break;
              case "TRACK_OPTICS_VIDEO_STATUS_REVIEWED":
              case 2:
                message.status = 2;
                break;
            }
            if (object.horseNameOrRegistrationNumber != null)
              message.horseNameOrRegistrationNumber = String(
                object.horseNameOrRegistrationNumber
              );
            if (object.injuryEntry != null) {
              if (typeof object.injuryEntry !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.injuryEntry: object expected"
                );
              message.injuryEntry =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.fromObject(
                  object.injuryEntry
                );
            }
            if (object.limb != null) {
              if (typeof object.limb !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.limb: object expected"
                );
              message.limb =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.fromObject(
                  object.limb
                );
            }
            if (object.stride != null) {
              if (typeof object.stride !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.stride: object expected"
                );
              message.stride =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.fromObject(
                  object.stride
                );
            }
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.injurySeverity != null) {
              if (typeof object.injurySeverity !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.injurySeverity: object expected"
                );
              message.injurySeverity =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.fromObject(
                  object.injurySeverity
                );
            }
            if (object.injuryReportDate != null) {
              if (typeof object.injuryReportDate !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.injuryReportDate: object expected"
                );
              message.injuryReportDate =
                $root.google.protobuf.StringValue.fromObject(
                  object.injuryReportDate
                );
            }
            if (object.injuryReportCreator != null) {
              if (typeof object.injuryReportCreator !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideo.injuryReportCreator: object expected"
                );
              message.injuryReportCreator =
                $root.stronachgroup.first.racehorse360.User.fromObject(
                  object.injuryReportCreator
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideo message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideo} message TrackOpticsVideo
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideo.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.videoId = "";
              object.hasStandardView = false;
              object.hasDetectionsView = false;
              object.mimeType = "";
              object.date = "";
              object.facility = null;
              object.status =
                options.enums === String
                  ? "TRACK_OPTICS_VIDEO_STATUS_INVALID"
                  : 0;
              object.horseNameOrRegistrationNumber = "";
              object.injuryEntry = null;
              object.limb = null;
              object.stride = null;
              object.comment = "";
              object.injurySeverity = null;
              object.injuryReportDate = null;
              object.injuryReportCreator = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.videoId != null && message.hasOwnProperty("videoId"))
              object.videoId = message.videoId;
            if (
              message.hasStandardView != null &&
              message.hasOwnProperty("hasStandardView")
            )
              object.hasStandardView = message.hasStandardView;
            if (
              message.hasDetectionsView != null &&
              message.hasOwnProperty("hasDetectionsView")
            )
              object.hasDetectionsView = message.hasDetectionsView;
            if (message.mimeType != null && message.hasOwnProperty("mimeType"))
              object.mimeType = message.mimeType;
            if (message.date != null && message.hasOwnProperty("date"))
              object.date = message.date;
            if (message.facility != null && message.hasOwnProperty("facility"))
              object.facility =
                $root.stronachgroup.first.racehorse360.Facility.toObject(
                  message.facility,
                  options
                );
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .TrackOpticsVideoStatus[message.status]
                  : message.status;
            if (
              message.horseNameOrRegistrationNumber != null &&
              message.hasOwnProperty("horseNameOrRegistrationNumber")
            )
              object.horseNameOrRegistrationNumber =
                message.horseNameOrRegistrationNumber;
            if (
              message.injuryEntry != null &&
              message.hasOwnProperty("injuryEntry")
            )
              object.injuryEntry =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.toObject(
                  message.injuryEntry,
                  options
                );
            if (message.limb != null && message.hasOwnProperty("limb"))
              object.limb =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.toObject(
                  message.limb,
                  options
                );
            if (message.stride != null && message.hasOwnProperty("stride"))
              object.stride =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.toObject(
                  message.stride,
                  options
                );
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.injurySeverity != null &&
              message.hasOwnProperty("injurySeverity")
            )
              object.injurySeverity =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.toObject(
                  message.injurySeverity,
                  options
                );
            if (
              message.injuryReportDate != null &&
              message.hasOwnProperty("injuryReportDate")
            )
              object.injuryReportDate =
                $root.google.protobuf.StringValue.toObject(
                  message.injuryReportDate,
                  options
                );
            if (
              message.injuryReportCreator != null &&
              message.hasOwnProperty("injuryReportCreator")
            )
              object.injuryReportCreator =
                $root.stronachgroup.first.racehorse360.User.toObject(
                  message.injuryReportCreator,
                  options
                );
            return object;
          };

          /**
           * Converts this TrackOpticsVideo to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideo
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideo;
        })();

        racehorse360.TrackOpticsVideoInjuryEntry = (function () {
          /**
           * Properties of a TrackOpticsVideoInjuryEntry.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideoInjuryEntry
           * @property {string|null} [id] TrackOpticsVideoInjuryEntry id
           * @property {string|null} [description] TrackOpticsVideoInjuryEntry description
           */

          /**
           * Constructs a new TrackOpticsVideoInjuryEntry.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoInjuryEntry.
           * @implements ITrackOpticsVideoInjuryEntry
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry=} [properties] Properties to set
           */
          function TrackOpticsVideoInjuryEntry(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideoInjuryEntry id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @instance
           */
          TrackOpticsVideoInjuryEntry.prototype.id = "";

          /**
           * TrackOpticsVideoInjuryEntry description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @instance
           */
          TrackOpticsVideoInjuryEntry.prototype.description = "";

          /**
           * Creates a new TrackOpticsVideoInjuryEntry instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry} TrackOpticsVideoInjuryEntry instance
           */
          TrackOpticsVideoInjuryEntry.create = function create(properties) {
            return new TrackOpticsVideoInjuryEntry(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideoInjuryEntry message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry} message TrackOpticsVideoInjuryEntry message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideoInjuryEntry.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideoInjuryEntry message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry} TrackOpticsVideoInjuryEntry
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideoInjuryEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideoInjuryEntry message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry} TrackOpticsVideoInjuryEntry
           */
          TrackOpticsVideoInjuryEntry.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideoInjuryEntry message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry} message TrackOpticsVideoInjuryEntry
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideoInjuryEntry.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this TrackOpticsVideoInjuryEntry to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideoInjuryEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideoInjuryEntry;
        })();

        racehorse360.TrackOpticsVideoLimb = (function () {
          /**
           * Properties of a TrackOpticsVideoLimb.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideoLimb
           * @property {string|null} [id] TrackOpticsVideoLimb id
           * @property {string|null} [description] TrackOpticsVideoLimb description
           */

          /**
           * Constructs a new TrackOpticsVideoLimb.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoLimb.
           * @implements ITrackOpticsVideoLimb
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoLimb=} [properties] Properties to set
           */
          function TrackOpticsVideoLimb(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideoLimb id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @instance
           */
          TrackOpticsVideoLimb.prototype.id = "";

          /**
           * TrackOpticsVideoLimb description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @instance
           */
          TrackOpticsVideoLimb.prototype.description = "";

          /**
           * Creates a new TrackOpticsVideoLimb instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoLimb=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoLimb} TrackOpticsVideoLimb instance
           */
          TrackOpticsVideoLimb.create = function create(properties) {
            return new TrackOpticsVideoLimb(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideoLimb message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideoLimb.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoLimb} message TrackOpticsVideoLimb message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideoLimb.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideoLimb message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoLimb} TrackOpticsVideoLimb
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideoLimb.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideoLimb message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoLimb} TrackOpticsVideoLimb
           */
          TrackOpticsVideoLimb.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideoLimb message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoLimb} message TrackOpticsVideoLimb
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideoLimb.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this TrackOpticsVideoLimb to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoLimb
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideoLimb.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideoLimb;
        })();

        racehorse360.TrackOpticsVideoStride = (function () {
          /**
           * Properties of a TrackOpticsVideoStride.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideoStride
           * @property {string|null} [id] TrackOpticsVideoStride id
           * @property {string|null} [description] TrackOpticsVideoStride description
           */

          /**
           * Constructs a new TrackOpticsVideoStride.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoStride.
           * @implements ITrackOpticsVideoStride
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoStride=} [properties] Properties to set
           */
          function TrackOpticsVideoStride(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideoStride id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @instance
           */
          TrackOpticsVideoStride.prototype.id = "";

          /**
           * TrackOpticsVideoStride description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @instance
           */
          TrackOpticsVideoStride.prototype.description = "";

          /**
           * Creates a new TrackOpticsVideoStride instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoStride=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoStride} TrackOpticsVideoStride instance
           */
          TrackOpticsVideoStride.create = function create(properties) {
            return new TrackOpticsVideoStride(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideoStride message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideoStride.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoStride} message TrackOpticsVideoStride message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideoStride.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideoStride message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoStride} TrackOpticsVideoStride
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideoStride.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideoStride message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoStride} TrackOpticsVideoStride
           */
          TrackOpticsVideoStride.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideoStride message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoStride} message TrackOpticsVideoStride
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideoStride.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this TrackOpticsVideoStride to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoStride
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideoStride.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideoStride;
        })();

        racehorse360.TrackOpticsVideoInjurySeverity = (function () {
          /**
           * Properties of a TrackOpticsVideoInjurySeverity.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideoInjurySeverity
           * @property {string|null} [id] TrackOpticsVideoInjurySeverity id
           * @property {string|null} [description] TrackOpticsVideoInjurySeverity description
           * @property {number|null} [value] TrackOpticsVideoInjurySeverity value
           */

          /**
           * Constructs a new TrackOpticsVideoInjurySeverity.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoInjurySeverity.
           * @implements ITrackOpticsVideoInjurySeverity
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity=} [properties] Properties to set
           */
          function TrackOpticsVideoInjurySeverity(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideoInjurySeverity id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @instance
           */
          TrackOpticsVideoInjurySeverity.prototype.id = "";

          /**
           * TrackOpticsVideoInjurySeverity description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @instance
           */
          TrackOpticsVideoInjurySeverity.prototype.description = "";

          /**
           * TrackOpticsVideoInjurySeverity value.
           * @member {number} value
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @instance
           */
          TrackOpticsVideoInjurySeverity.prototype.value = 0;

          /**
           * Creates a new TrackOpticsVideoInjurySeverity instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity} TrackOpticsVideoInjurySeverity instance
           */
          TrackOpticsVideoInjurySeverity.create = function create(properties) {
            return new TrackOpticsVideoInjurySeverity(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideoInjurySeverity message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity} message TrackOpticsVideoInjurySeverity message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideoInjurySeverity.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.value != null &&
              Object.hasOwnProperty.call(message, "value")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.value);
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideoInjurySeverity message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity} TrackOpticsVideoInjurySeverity
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideoInjurySeverity.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.value = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideoInjurySeverity message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity} TrackOpticsVideoInjurySeverity
           */
          TrackOpticsVideoInjurySeverity.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .TrackOpticsVideoInjurySeverity
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            if (object.value != null) message.value = object.value | 0;
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideoInjurySeverity message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity} message TrackOpticsVideoInjurySeverity
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideoInjurySeverity.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.value = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.value != null && message.hasOwnProperty("value"))
              object.value = message.value;
            return object;
          };

          /**
           * Converts this TrackOpticsVideoInjurySeverity to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideoInjurySeverity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideoInjurySeverity;
        })();

        racehorse360.TrackOpticsVideoFilter = (function () {
          /**
           * Properties of a TrackOpticsVideoFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface ITrackOpticsVideoFilter
           * @property {stronachgroup.first.racehorse360.IStringMatch|null} [horseName] TrackOpticsVideoFilter horseName
           * @property {google.protobuf.IBoolValue|null} [hasStandardView] TrackOpticsVideoFilter hasStandardView
           * @property {google.protobuf.IBoolValue|null} [hasDetectionsView] TrackOpticsVideoFilter hasDetectionsView
           * @property {stronachgroup.first.racehorse360.IDateMatch|null} [date] TrackOpticsVideoFilter date
           * @property {Array.<string>|null} [facilityIds] TrackOpticsVideoFilter facilityIds
           * @property {Array.<stronachgroup.first.racehorse360.TrackOpticsVideoStatus>|null} [statuses] TrackOpticsVideoFilter statuses
           * @property {Array.<string>|null} [videoIds] TrackOpticsVideoFilter videoIds
           */

          /**
           * Constructs a new TrackOpticsVideoFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoFilter.
           * @implements ITrackOpticsVideoFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoFilter=} [properties] Properties to set
           */
          function TrackOpticsVideoFilter(properties) {
            this.facilityIds = [];
            this.statuses = [];
            this.videoIds = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * TrackOpticsVideoFilter horseName.
           * @member {stronachgroup.first.racehorse360.IStringMatch|null|undefined} horseName
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.horseName = null;

          /**
           * TrackOpticsVideoFilter hasStandardView.
           * @member {google.protobuf.IBoolValue|null|undefined} hasStandardView
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.hasStandardView = null;

          /**
           * TrackOpticsVideoFilter hasDetectionsView.
           * @member {google.protobuf.IBoolValue|null|undefined} hasDetectionsView
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.hasDetectionsView = null;

          /**
           * TrackOpticsVideoFilter date.
           * @member {stronachgroup.first.racehorse360.IDateMatch|null|undefined} date
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.date = null;

          /**
           * TrackOpticsVideoFilter facilityIds.
           * @member {Array.<string>} facilityIds
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.facilityIds = $util.emptyArray;

          /**
           * TrackOpticsVideoFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.TrackOpticsVideoStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.statuses = $util.emptyArray;

          /**
           * TrackOpticsVideoFilter videoIds.
           * @member {Array.<string>} videoIds
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           */
          TrackOpticsVideoFilter.prototype.videoIds = $util.emptyArray;

          /**
           * Creates a new TrackOpticsVideoFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoFilter} TrackOpticsVideoFilter instance
           */
          TrackOpticsVideoFilter.create = function create(properties) {
            return new TrackOpticsVideoFilter(properties);
          };

          /**
           * Encodes the specified TrackOpticsVideoFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.TrackOpticsVideoFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.ITrackOpticsVideoFilter} message TrackOpticsVideoFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          TrackOpticsVideoFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseName != null &&
              Object.hasOwnProperty.call(message, "horseName")
            )
              $root.stronachgroup.first.racehorse360.StringMatch.encode(
                message.horseName,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.hasStandardView != null &&
              Object.hasOwnProperty.call(message, "hasStandardView")
            )
              $root.google.protobuf.BoolValue.encode(
                message.hasStandardView,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.hasDetectionsView != null &&
              Object.hasOwnProperty.call(message, "hasDetectionsView")
            )
              $root.google.protobuf.BoolValue.encode(
                message.hasDetectionsView,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.date != null &&
              Object.hasOwnProperty.call(message, "date")
            )
              $root.stronachgroup.first.racehorse360.DateMatch.encode(
                message.date,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (message.facilityIds != null && message.facilityIds.length)
              for (var i = 0; i < message.facilityIds.length; ++i)
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.facilityIds[i]);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            if (message.videoIds != null && message.videoIds.length)
              for (var i = 0; i < message.videoIds.length; ++i)
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.videoIds[i]);
            return writer;
          };

          /**
           * Decodes a TrackOpticsVideoFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoFilter} TrackOpticsVideoFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          TrackOpticsVideoFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.horseName =
                    $root.stronachgroup.first.racehorse360.StringMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 2:
                  message.hasStandardView =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.hasDetectionsView =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.date =
                    $root.stronachgroup.first.racehorse360.DateMatch.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  if (!(message.facilityIds && message.facilityIds.length))
                    message.facilityIds = [];
                  message.facilityIds.push(reader.string());
                  break;
                case 6:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                case 7:
                  if (!(message.videoIds && message.videoIds.length))
                    message.videoIds = [];
                  message.videoIds.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a TrackOpticsVideoFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.TrackOpticsVideoFilter} TrackOpticsVideoFilter
           */
          TrackOpticsVideoFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter();
            if (object.horseName != null) {
              if (typeof object.horseName !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.horseName: object expected"
                );
              message.horseName =
                $root.stronachgroup.first.racehorse360.StringMatch.fromObject(
                  object.horseName
                );
            }
            if (object.hasStandardView != null) {
              if (typeof object.hasStandardView !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.hasStandardView: object expected"
                );
              message.hasStandardView =
                $root.google.protobuf.BoolValue.fromObject(
                  object.hasStandardView
                );
            }
            if (object.hasDetectionsView != null) {
              if (typeof object.hasDetectionsView !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.hasDetectionsView: object expected"
                );
              message.hasDetectionsView =
                $root.google.protobuf.BoolValue.fromObject(
                  object.hasDetectionsView
                );
            }
            if (object.date != null) {
              if (typeof object.date !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.date: object expected"
                );
              message.date =
                $root.stronachgroup.first.racehorse360.DateMatch.fromObject(
                  object.date
                );
            }
            if (object.facilityIds) {
              if (!Array.isArray(object.facilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.facilityIds: array expected"
                );
              message.facilityIds = [];
              for (var i = 0; i < object.facilityIds.length; ++i)
                message.facilityIds[i] = String(object.facilityIds[i]);
            }
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "TRACK_OPTICS_VIDEO_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "TRACK_OPTICS_VIDEO_STATUS_IN_PROGRESS":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "TRACK_OPTICS_VIDEO_STATUS_REVIEWED":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                }
            }
            if (object.videoIds) {
              if (!Array.isArray(object.videoIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.TrackOpticsVideoFilter.videoIds: array expected"
                );
              message.videoIds = [];
              for (var i = 0; i < object.videoIds.length; ++i)
                message.videoIds[i] = String(object.videoIds[i]);
            }
            return message;
          };

          /**
           * Creates a plain object from a TrackOpticsVideoFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @static
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoFilter} message TrackOpticsVideoFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          TrackOpticsVideoFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.facilityIds = [];
              object.statuses = [];
              object.videoIds = [];
            }
            if (options.defaults) {
              object.horseName = null;
              object.hasStandardView = null;
              object.hasDetectionsView = null;
              object.date = null;
            }
            if (
              message.horseName != null &&
              message.hasOwnProperty("horseName")
            )
              object.horseName =
                $root.stronachgroup.first.racehorse360.StringMatch.toObject(
                  message.horseName,
                  options
                );
            if (
              message.hasStandardView != null &&
              message.hasOwnProperty("hasStandardView")
            )
              object.hasStandardView = $root.google.protobuf.BoolValue.toObject(
                message.hasStandardView,
                options
              );
            if (
              message.hasDetectionsView != null &&
              message.hasOwnProperty("hasDetectionsView")
            )
              object.hasDetectionsView =
                $root.google.protobuf.BoolValue.toObject(
                  message.hasDetectionsView,
                  options
                );
            if (message.date != null && message.hasOwnProperty("date"))
              object.date =
                $root.stronachgroup.first.racehorse360.DateMatch.toObject(
                  message.date,
                  options
                );
            if (message.facilityIds && message.facilityIds.length) {
              object.facilityIds = [];
              for (var j = 0; j < message.facilityIds.length; ++j)
                object.facilityIds[j] = message.facilityIds[j];
            }
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .TrackOpticsVideoStatus[message.statuses[j]]
                    : message.statuses[j];
            }
            if (message.videoIds && message.videoIds.length) {
              object.videoIds = [];
              for (var j = 0; j < message.videoIds.length; ++j)
                object.videoIds[j] = message.videoIds[j];
            }
            return object;
          };

          /**
           * Converts this TrackOpticsVideoFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          TrackOpticsVideoFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return TrackOpticsVideoFilter;
        })();

        racehorse360.ListTrackOpticsVideosRequest = (function () {
          /**
           * Properties of a ListTrackOpticsVideosRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListTrackOpticsVideosRequest
           * @property {stronachgroup.first.racehorse360.ITrackOpticsVideoFilter|null} [query] ListTrackOpticsVideosRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListTrackOpticsVideosRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListTrackOpticsVideosRequest pagingOptions
           */

          /**
           * Constructs a new ListTrackOpticsVideosRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListTrackOpticsVideosRequest.
           * @implements IListTrackOpticsVideosRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosRequest=} [properties] Properties to set
           */
          function ListTrackOpticsVideosRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListTrackOpticsVideosRequest query.
           * @member {stronachgroup.first.racehorse360.ITrackOpticsVideoFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @instance
           */
          ListTrackOpticsVideosRequest.prototype.query = null;

          /**
           * ListTrackOpticsVideosRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @instance
           */
          ListTrackOpticsVideosRequest.prototype.getOptions = null;

          /**
           * ListTrackOpticsVideosRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @instance
           */
          ListTrackOpticsVideosRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListTrackOpticsVideosRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} ListTrackOpticsVideosRequest instance
           */
          ListTrackOpticsVideosRequest.create = function create(properties) {
            return new ListTrackOpticsVideosRequest(properties);
          };

          /**
           * Encodes the specified ListTrackOpticsVideosRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosRequest} message ListTrackOpticsVideosRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListTrackOpticsVideosRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListTrackOpticsVideosRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} ListTrackOpticsVideosRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListTrackOpticsVideosRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListTrackOpticsVideosRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} ListTrackOpticsVideosRequest
           */
          ListTrackOpticsVideosRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListTrackOpticsVideosRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListTrackOpticsVideosRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest} message ListTrackOpticsVideosRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListTrackOpticsVideosRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListTrackOpticsVideosRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListTrackOpticsVideosRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListTrackOpticsVideosRequest;
        })();

        racehorse360.ListTrackOpticsVideosResponse = (function () {
          /**
           * Properties of a ListTrackOpticsVideosResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListTrackOpticsVideosResponse
           * @property {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideo>|null} [trackOpticsVideos] ListTrackOpticsVideosResponse trackOpticsVideos
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListTrackOpticsVideosResponse pagingInfo
           */

          /**
           * Constructs a new ListTrackOpticsVideosResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListTrackOpticsVideosResponse.
           * @implements IListTrackOpticsVideosResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosResponse=} [properties] Properties to set
           */
          function ListTrackOpticsVideosResponse(properties) {
            this.trackOpticsVideos = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListTrackOpticsVideosResponse trackOpticsVideos.
           * @member {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideo>} trackOpticsVideos
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @instance
           */
          ListTrackOpticsVideosResponse.prototype.trackOpticsVideos =
            $util.emptyArray;

          /**
           * ListTrackOpticsVideosResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @instance
           */
          ListTrackOpticsVideosResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListTrackOpticsVideosResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse} ListTrackOpticsVideosResponse instance
           */
          ListTrackOpticsVideosResponse.create = function create(properties) {
            return new ListTrackOpticsVideosResponse(properties);
          };

          /**
           * Encodes the specified ListTrackOpticsVideosResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosResponse} message ListTrackOpticsVideosResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListTrackOpticsVideosResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.trackOpticsVideos != null &&
              message.trackOpticsVideos.length
            )
              for (var i = 0; i < message.trackOpticsVideos.length; ++i)
                $root.stronachgroup.first.racehorse360.TrackOpticsVideo.encode(
                  message.trackOpticsVideos[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListTrackOpticsVideosResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse} ListTrackOpticsVideosResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListTrackOpticsVideosResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.trackOpticsVideos &&
                      message.trackOpticsVideos.length
                    )
                  )
                    message.trackOpticsVideos = [];
                  message.trackOpticsVideos.push(
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideo.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListTrackOpticsVideosResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse} ListTrackOpticsVideosResponse
           */
          ListTrackOpticsVideosResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListTrackOpticsVideosResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse();
            if (object.trackOpticsVideos) {
              if (!Array.isArray(object.trackOpticsVideos))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse.trackOpticsVideos: array expected"
                );
              message.trackOpticsVideos = [];
              for (var i = 0; i < object.trackOpticsVideos.length; ++i) {
                if (typeof object.trackOpticsVideos[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse.trackOpticsVideos: object expected"
                  );
                message.trackOpticsVideos[i] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideo.fromObject(
                    object.trackOpticsVideos[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListTrackOpticsVideosResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse} message ListTrackOpticsVideosResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListTrackOpticsVideosResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.trackOpticsVideos = [];
            if (options.defaults) object.pagingInfo = null;
            if (message.trackOpticsVideos && message.trackOpticsVideos.length) {
              object.trackOpticsVideos = [];
              for (var j = 0; j < message.trackOpticsVideos.length; ++j)
                object.trackOpticsVideos[j] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideo.toObject(
                    message.trackOpticsVideos[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListTrackOpticsVideosResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListTrackOpticsVideosResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ListTrackOpticsVideosResponse;
        })();

        racehorse360.GetTrackOpticsVideoRequest = (function () {
          /**
           * Properties of a GetTrackOpticsVideoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IGetTrackOpticsVideoRequest
           * @property {string|null} [id] GetTrackOpticsVideoRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] GetTrackOpticsVideoRequest getOptions
           */

          /**
           * Constructs a new GetTrackOpticsVideoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a GetTrackOpticsVideoRequest.
           * @implements IGetTrackOpticsVideoRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IGetTrackOpticsVideoRequest=} [properties] Properties to set
           */
          function GetTrackOpticsVideoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetTrackOpticsVideoRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @instance
           */
          GetTrackOpticsVideoRequest.prototype.id = "";

          /**
           * GetTrackOpticsVideoRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @instance
           */
          GetTrackOpticsVideoRequest.prototype.getOptions = null;

          /**
           * Creates a new GetTrackOpticsVideoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetTrackOpticsVideoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} GetTrackOpticsVideoRequest instance
           */
          GetTrackOpticsVideoRequest.create = function create(properties) {
            return new GetTrackOpticsVideoRequest(properties);
          };

          /**
           * Encodes the specified GetTrackOpticsVideoRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IGetTrackOpticsVideoRequest} message GetTrackOpticsVideoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetTrackOpticsVideoRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetTrackOpticsVideoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} GetTrackOpticsVideoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetTrackOpticsVideoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetTrackOpticsVideoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} GetTrackOpticsVideoRequest
           */
          GetTrackOpticsVideoRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest();
            if (object.id != null) message.id = String(object.id);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetTrackOpticsVideoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest} message GetTrackOpticsVideoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetTrackOpticsVideoRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this GetTrackOpticsVideoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.GetTrackOpticsVideoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetTrackOpticsVideoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetTrackOpticsVideoRequest;
        })();

        racehorse360.SubmitTrackOpticsVideoRequest = (function () {
          /**
           * Properties of a SubmitTrackOpticsVideoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface ISubmitTrackOpticsVideoRequest
           * @property {string|null} [trackOpticsVideoId] SubmitTrackOpticsVideoRequest trackOpticsVideoId
           * @property {string|null} [horseNameOrRegistrationNumber] SubmitTrackOpticsVideoRequest horseNameOrRegistrationNumber
           * @property {string|null} [injuryEntryId] SubmitTrackOpticsVideoRequest injuryEntryId
           * @property {string|null} [limbId] SubmitTrackOpticsVideoRequest limbId
           * @property {string|null} [strideId] SubmitTrackOpticsVideoRequest strideId
           * @property {string|null} [injurySeverityId] SubmitTrackOpticsVideoRequest injurySeverityId
           * @property {string|null} [comment] SubmitTrackOpticsVideoRequest comment
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] SubmitTrackOpticsVideoRequest getOptions
           */

          /**
           * Constructs a new SubmitTrackOpticsVideoRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a SubmitTrackOpticsVideoRequest.
           * @implements ISubmitTrackOpticsVideoRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.ISubmitTrackOpticsVideoRequest=} [properties] Properties to set
           */
          function SubmitTrackOpticsVideoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * SubmitTrackOpticsVideoRequest trackOpticsVideoId.
           * @member {string} trackOpticsVideoId
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.trackOpticsVideoId = "";

          /**
           * SubmitTrackOpticsVideoRequest horseNameOrRegistrationNumber.
           * @member {string} horseNameOrRegistrationNumber
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.horseNameOrRegistrationNumber =
            "";

          /**
           * SubmitTrackOpticsVideoRequest injuryEntryId.
           * @member {string} injuryEntryId
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.injuryEntryId = "";

          /**
           * SubmitTrackOpticsVideoRequest limbId.
           * @member {string} limbId
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.limbId = "";

          /**
           * SubmitTrackOpticsVideoRequest strideId.
           * @member {string} strideId
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.strideId = "";

          /**
           * SubmitTrackOpticsVideoRequest injurySeverityId.
           * @member {string} injurySeverityId
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.injurySeverityId = "";

          /**
           * SubmitTrackOpticsVideoRequest comment.
           * @member {string} comment
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.comment = "";

          /**
           * SubmitTrackOpticsVideoRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           */
          SubmitTrackOpticsVideoRequest.prototype.getOptions = null;

          /**
           * Creates a new SubmitTrackOpticsVideoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISubmitTrackOpticsVideoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} SubmitTrackOpticsVideoRequest instance
           */
          SubmitTrackOpticsVideoRequest.create = function create(properties) {
            return new SubmitTrackOpticsVideoRequest(properties);
          };

          /**
           * Encodes the specified SubmitTrackOpticsVideoRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ISubmitTrackOpticsVideoRequest} message SubmitTrackOpticsVideoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          SubmitTrackOpticsVideoRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.trackOpticsVideoId != null &&
              Object.hasOwnProperty.call(message, "trackOpticsVideoId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.trackOpticsVideoId);
            if (
              message.horseNameOrRegistrationNumber != null &&
              Object.hasOwnProperty.call(
                message,
                "horseNameOrRegistrationNumber"
              )
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.horseNameOrRegistrationNumber);
            if (
              message.injuryEntryId != null &&
              Object.hasOwnProperty.call(message, "injuryEntryId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.injuryEntryId);
            if (
              message.limbId != null &&
              Object.hasOwnProperty.call(message, "limbId")
            )
              writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.limbId);
            if (
              message.strideId != null &&
              Object.hasOwnProperty.call(message, "strideId")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.strideId);
            if (
              message.injurySeverityId != null &&
              Object.hasOwnProperty.call(message, "injurySeverityId")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.injurySeverityId);
            if (
              message.comment != null &&
              Object.hasOwnProperty.call(message, "comment")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.comment);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a SubmitTrackOpticsVideoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} SubmitTrackOpticsVideoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          SubmitTrackOpticsVideoRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.trackOpticsVideoId = reader.string();
                  break;
                case 2:
                  message.horseNameOrRegistrationNumber = reader.string();
                  break;
                case 3:
                  message.injuryEntryId = reader.string();
                  break;
                case 4:
                  message.limbId = reader.string();
                  break;
                case 5:
                  message.strideId = reader.string();
                  break;
                case 6:
                  message.injurySeverityId = reader.string();
                  break;
                case 7:
                  message.comment = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a SubmitTrackOpticsVideoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} SubmitTrackOpticsVideoRequest
           */
          SubmitTrackOpticsVideoRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .SubmitTrackOpticsVideoRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest();
            if (object.trackOpticsVideoId != null)
              message.trackOpticsVideoId = String(object.trackOpticsVideoId);
            if (object.horseNameOrRegistrationNumber != null)
              message.horseNameOrRegistrationNumber = String(
                object.horseNameOrRegistrationNumber
              );
            if (object.injuryEntryId != null)
              message.injuryEntryId = String(object.injuryEntryId);
            if (object.limbId != null) message.limbId = String(object.limbId);
            if (object.strideId != null)
              message.strideId = String(object.strideId);
            if (object.injurySeverityId != null)
              message.injurySeverityId = String(object.injurySeverityId);
            if (object.comment != null)
              message.comment = String(object.comment);
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a SubmitTrackOpticsVideoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @static
           * @param {stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest} message SubmitTrackOpticsVideoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          SubmitTrackOpticsVideoRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.trackOpticsVideoId = "";
              object.horseNameOrRegistrationNumber = "";
              object.injuryEntryId = "";
              object.limbId = "";
              object.strideId = "";
              object.injurySeverityId = "";
              object.comment = "";
              object.getOptions = null;
            }
            if (
              message.trackOpticsVideoId != null &&
              message.hasOwnProperty("trackOpticsVideoId")
            )
              object.trackOpticsVideoId = message.trackOpticsVideoId;
            if (
              message.horseNameOrRegistrationNumber != null &&
              message.hasOwnProperty("horseNameOrRegistrationNumber")
            )
              object.horseNameOrRegistrationNumber =
                message.horseNameOrRegistrationNumber;
            if (
              message.injuryEntryId != null &&
              message.hasOwnProperty("injuryEntryId")
            )
              object.injuryEntryId = message.injuryEntryId;
            if (message.limbId != null && message.hasOwnProperty("limbId"))
              object.limbId = message.limbId;
            if (message.strideId != null && message.hasOwnProperty("strideId"))
              object.strideId = message.strideId;
            if (
              message.injurySeverityId != null &&
              message.hasOwnProperty("injurySeverityId")
            )
              object.injurySeverityId = message.injurySeverityId;
            if (message.comment != null && message.hasOwnProperty("comment"))
              object.comment = message.comment;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this SubmitTrackOpticsVideoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.SubmitTrackOpticsVideoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          SubmitTrackOpticsVideoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return SubmitTrackOpticsVideoRequest;
        })();

        racehorse360.PullTrackOpticsVideoConditionsRequest = (function () {
          /**
           * Properties of a PullTrackOpticsVideoConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullTrackOpticsVideoConditionsRequest
           */

          /**
           * Constructs a new PullTrackOpticsVideoConditionsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullTrackOpticsVideoConditionsRequest.
           * @implements IPullTrackOpticsVideoConditionsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsRequest=} [properties] Properties to set
           */
          function PullTrackOpticsVideoConditionsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new PullTrackOpticsVideoConditionsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} PullTrackOpticsVideoConditionsRequest instance
           */
          PullTrackOpticsVideoConditionsRequest.create = function create(
            properties
          ) {
            return new PullTrackOpticsVideoConditionsRequest(properties);
          };

          /**
           * Encodes the specified PullTrackOpticsVideoConditionsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsRequest} message PullTrackOpticsVideoConditionsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullTrackOpticsVideoConditionsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a PullTrackOpticsVideoConditionsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} PullTrackOpticsVideoConditionsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullTrackOpticsVideoConditionsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullTrackOpticsVideoConditionsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} PullTrackOpticsVideoConditionsRequest
           */
          PullTrackOpticsVideoConditionsRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullTrackOpticsVideoConditionsRequest
              )
                return object;
              return new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest();
            };

          /**
           * Creates a plain object from a PullTrackOpticsVideoConditionsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest} message PullTrackOpticsVideoConditionsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullTrackOpticsVideoConditionsRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this PullTrackOpticsVideoConditionsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullTrackOpticsVideoConditionsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullTrackOpticsVideoConditionsRequest;
        })();

        racehorse360.PullTrackOpticsVideoConditionsResponse = (function () {
          /**
           * Properties of a PullTrackOpticsVideoConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullTrackOpticsVideoConditionsResponse
           * @property {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry>|null} [trackOpticsVideoInjuryEntries] PullTrackOpticsVideoConditionsResponse trackOpticsVideoInjuryEntries
           * @property {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoLimb>|null} [trackOpticsVideoLimbs] PullTrackOpticsVideoConditionsResponse trackOpticsVideoLimbs
           * @property {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoStride>|null} [trackOpticsVideoStrides] PullTrackOpticsVideoConditionsResponse trackOpticsVideoStrides
           * @property {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity>|null} [trackOpticsVideoInjurySeverities] PullTrackOpticsVideoConditionsResponse trackOpticsVideoInjurySeverities
           */

          /**
           * Constructs a new PullTrackOpticsVideoConditionsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullTrackOpticsVideoConditionsResponse.
           * @implements IPullTrackOpticsVideoConditionsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsResponse=} [properties] Properties to set
           */
          function PullTrackOpticsVideoConditionsResponse(properties) {
            this.trackOpticsVideoInjuryEntries = [];
            this.trackOpticsVideoLimbs = [];
            this.trackOpticsVideoStrides = [];
            this.trackOpticsVideoInjurySeverities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullTrackOpticsVideoConditionsResponse trackOpticsVideoInjuryEntries.
           * @member {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoInjuryEntry>} trackOpticsVideoInjuryEntries
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @instance
           */
          PullTrackOpticsVideoConditionsResponse.prototype.trackOpticsVideoInjuryEntries =
            $util.emptyArray;

          /**
           * PullTrackOpticsVideoConditionsResponse trackOpticsVideoLimbs.
           * @member {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoLimb>} trackOpticsVideoLimbs
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @instance
           */
          PullTrackOpticsVideoConditionsResponse.prototype.trackOpticsVideoLimbs =
            $util.emptyArray;

          /**
           * PullTrackOpticsVideoConditionsResponse trackOpticsVideoStrides.
           * @member {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoStride>} trackOpticsVideoStrides
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @instance
           */
          PullTrackOpticsVideoConditionsResponse.prototype.trackOpticsVideoStrides =
            $util.emptyArray;

          /**
           * PullTrackOpticsVideoConditionsResponse trackOpticsVideoInjurySeverities.
           * @member {Array.<stronachgroup.first.racehorse360.ITrackOpticsVideoInjurySeverity>} trackOpticsVideoInjurySeverities
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @instance
           */
          PullTrackOpticsVideoConditionsResponse.prototype.trackOpticsVideoInjurySeverities =
            $util.emptyArray;

          /**
           * Creates a new PullTrackOpticsVideoConditionsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse} PullTrackOpticsVideoConditionsResponse instance
           */
          PullTrackOpticsVideoConditionsResponse.create = function create(
            properties
          ) {
            return new PullTrackOpticsVideoConditionsResponse(properties);
          };

          /**
           * Encodes the specified PullTrackOpticsVideoConditionsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsResponse} message PullTrackOpticsVideoConditionsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullTrackOpticsVideoConditionsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.trackOpticsVideoInjuryEntries != null &&
              message.trackOpticsVideoInjuryEntries.length
            )
              for (
                var i = 0;
                i < message.trackOpticsVideoInjuryEntries.length;
                ++i
              )
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.encode(
                  message.trackOpticsVideoInjuryEntries[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.trackOpticsVideoLimbs != null &&
              message.trackOpticsVideoLimbs.length
            )
              for (var i = 0; i < message.trackOpticsVideoLimbs.length; ++i)
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.encode(
                  message.trackOpticsVideoLimbs[i],
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
            if (
              message.trackOpticsVideoStrides != null &&
              message.trackOpticsVideoStrides.length
            )
              for (var i = 0; i < message.trackOpticsVideoStrides.length; ++i)
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.encode(
                  message.trackOpticsVideoStrides[i],
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
            if (
              message.trackOpticsVideoInjurySeverities != null &&
              message.trackOpticsVideoInjurySeverities.length
            )
              for (
                var i = 0;
                i < message.trackOpticsVideoInjurySeverities.length;
                ++i
              )
                $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.encode(
                  message.trackOpticsVideoInjurySeverities[i],
                  writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a PullTrackOpticsVideoConditionsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse} PullTrackOpticsVideoConditionsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullTrackOpticsVideoConditionsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.trackOpticsVideoInjuryEntries &&
                      message.trackOpticsVideoInjuryEntries.length
                    )
                  )
                    message.trackOpticsVideoInjuryEntries = [];
                  message.trackOpticsVideoInjuryEntries.push(
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 2:
                  if (
                    !(
                      message.trackOpticsVideoLimbs &&
                      message.trackOpticsVideoLimbs.length
                    )
                  )
                    message.trackOpticsVideoLimbs = [];
                  message.trackOpticsVideoLimbs.push(
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 3:
                  if (
                    !(
                      message.trackOpticsVideoStrides &&
                      message.trackOpticsVideoStrides.length
                    )
                  )
                    message.trackOpticsVideoStrides = [];
                  message.trackOpticsVideoStrides.push(
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 4:
                  if (
                    !(
                      message.trackOpticsVideoInjurySeverities &&
                      message.trackOpticsVideoInjurySeverities.length
                    )
                  )
                    message.trackOpticsVideoInjurySeverities = [];
                  message.trackOpticsVideoInjurySeverities.push(
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullTrackOpticsVideoConditionsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse} PullTrackOpticsVideoConditionsResponse
           */
          PullTrackOpticsVideoConditionsResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullTrackOpticsVideoConditionsResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse();
              if (object.trackOpticsVideoInjuryEntries) {
                if (!Array.isArray(object.trackOpticsVideoInjuryEntries))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoInjuryEntries: array expected"
                  );
                message.trackOpticsVideoInjuryEntries = [];
                for (
                  var i = 0;
                  i < object.trackOpticsVideoInjuryEntries.length;
                  ++i
                ) {
                  if (
                    typeof object.trackOpticsVideoInjuryEntries[i] !== "object"
                  )
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoInjuryEntries: object expected"
                    );
                  message.trackOpticsVideoInjuryEntries[i] =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.fromObject(
                      object.trackOpticsVideoInjuryEntries[i]
                    );
                }
              }
              if (object.trackOpticsVideoLimbs) {
                if (!Array.isArray(object.trackOpticsVideoLimbs))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoLimbs: array expected"
                  );
                message.trackOpticsVideoLimbs = [];
                for (var i = 0; i < object.trackOpticsVideoLimbs.length; ++i) {
                  if (typeof object.trackOpticsVideoLimbs[i] !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoLimbs: object expected"
                    );
                  message.trackOpticsVideoLimbs[i] =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.fromObject(
                      object.trackOpticsVideoLimbs[i]
                    );
                }
              }
              if (object.trackOpticsVideoStrides) {
                if (!Array.isArray(object.trackOpticsVideoStrides))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoStrides: array expected"
                  );
                message.trackOpticsVideoStrides = [];
                for (
                  var i = 0;
                  i < object.trackOpticsVideoStrides.length;
                  ++i
                ) {
                  if (typeof object.trackOpticsVideoStrides[i] !== "object")
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoStrides: object expected"
                    );
                  message.trackOpticsVideoStrides[i] =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.fromObject(
                      object.trackOpticsVideoStrides[i]
                    );
                }
              }
              if (object.trackOpticsVideoInjurySeverities) {
                if (!Array.isArray(object.trackOpticsVideoInjurySeverities))
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoInjurySeverities: array expected"
                  );
                message.trackOpticsVideoInjurySeverities = [];
                for (
                  var i = 0;
                  i < object.trackOpticsVideoInjurySeverities.length;
                  ++i
                ) {
                  if (
                    typeof object.trackOpticsVideoInjurySeverities[i] !==
                    "object"
                  )
                    throw TypeError(
                      ".stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse.trackOpticsVideoInjurySeverities: object expected"
                    );
                  message.trackOpticsVideoInjurySeverities[i] =
                    $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.fromObject(
                      object.trackOpticsVideoInjurySeverities[i]
                    );
                }
              }
              return message;
            };

          /**
           * Creates a plain object from a PullTrackOpticsVideoConditionsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse} message PullTrackOpticsVideoConditionsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullTrackOpticsVideoConditionsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.trackOpticsVideoInjuryEntries = [];
              object.trackOpticsVideoLimbs = [];
              object.trackOpticsVideoStrides = [];
              object.trackOpticsVideoInjurySeverities = [];
            }
            if (
              message.trackOpticsVideoInjuryEntries &&
              message.trackOpticsVideoInjuryEntries.length
            ) {
              object.trackOpticsVideoInjuryEntries = [];
              for (
                var j = 0;
                j < message.trackOpticsVideoInjuryEntries.length;
                ++j
              )
                object.trackOpticsVideoInjuryEntries[j] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjuryEntry.toObject(
                    message.trackOpticsVideoInjuryEntries[j],
                    options
                  );
            }
            if (
              message.trackOpticsVideoLimbs &&
              message.trackOpticsVideoLimbs.length
            ) {
              object.trackOpticsVideoLimbs = [];
              for (var j = 0; j < message.trackOpticsVideoLimbs.length; ++j)
                object.trackOpticsVideoLimbs[j] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideoLimb.toObject(
                    message.trackOpticsVideoLimbs[j],
                    options
                  );
            }
            if (
              message.trackOpticsVideoStrides &&
              message.trackOpticsVideoStrides.length
            ) {
              object.trackOpticsVideoStrides = [];
              for (var j = 0; j < message.trackOpticsVideoStrides.length; ++j)
                object.trackOpticsVideoStrides[j] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideoStride.toObject(
                    message.trackOpticsVideoStrides[j],
                    options
                  );
            }
            if (
              message.trackOpticsVideoInjurySeverities &&
              message.trackOpticsVideoInjurySeverities.length
            ) {
              object.trackOpticsVideoInjurySeverities = [];
              for (
                var j = 0;
                j < message.trackOpticsVideoInjurySeverities.length;
                ++j
              )
                object.trackOpticsVideoInjurySeverities[j] =
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideoInjurySeverity.toObject(
                    message.trackOpticsVideoInjurySeverities[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this PullTrackOpticsVideoConditionsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullTrackOpticsVideoConditionsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullTrackOpticsVideoConditionsResponse;
        })();

        racehorse360.PullTrackOpticsVideoFileSignedUrlRequest = (function () {
          /**
           * Properties of a PullTrackOpticsVideoFileSignedUrlRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullTrackOpticsVideoFileSignedUrlRequest
           * @property {string|null} [trackOpticsVideoId] PullTrackOpticsVideoFileSignedUrlRequest trackOpticsVideoId
           * @property {stronachgroup.first.racehorse360.TrackOpticsVideoType|null} [videoType] PullTrackOpticsVideoFileSignedUrlRequest videoType
           */

          /**
           * Constructs a new PullTrackOpticsVideoFileSignedUrlRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullTrackOpticsVideoFileSignedUrlRequest.
           * @implements IPullTrackOpticsVideoFileSignedUrlRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlRequest=} [properties] Properties to set
           */
          function PullTrackOpticsVideoFileSignedUrlRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullTrackOpticsVideoFileSignedUrlRequest trackOpticsVideoId.
           * @member {string} trackOpticsVideoId
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @instance
           */
          PullTrackOpticsVideoFileSignedUrlRequest.prototype.trackOpticsVideoId =
            "";

          /**
           * PullTrackOpticsVideoFileSignedUrlRequest videoType.
           * @member {stronachgroup.first.racehorse360.TrackOpticsVideoType} videoType
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @instance
           */
          PullTrackOpticsVideoFileSignedUrlRequest.prototype.videoType = 0;

          /**
           * Creates a new PullTrackOpticsVideoFileSignedUrlRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} PullTrackOpticsVideoFileSignedUrlRequest instance
           */
          PullTrackOpticsVideoFileSignedUrlRequest.create = function create(
            properties
          ) {
            return new PullTrackOpticsVideoFileSignedUrlRequest(properties);
          };

          /**
           * Encodes the specified PullTrackOpticsVideoFileSignedUrlRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlRequest} message PullTrackOpticsVideoFileSignedUrlRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullTrackOpticsVideoFileSignedUrlRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.trackOpticsVideoId != null &&
              Object.hasOwnProperty.call(message, "trackOpticsVideoId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.trackOpticsVideoId);
            if (
              message.videoType != null &&
              Object.hasOwnProperty.call(message, "videoType")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.videoType);
            return writer;
          };

          /**
           * Decodes a PullTrackOpticsVideoFileSignedUrlRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} PullTrackOpticsVideoFileSignedUrlRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullTrackOpticsVideoFileSignedUrlRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.trackOpticsVideoId = reader.string();
                  break;
                case 2:
                  message.videoType = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullTrackOpticsVideoFileSignedUrlRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} PullTrackOpticsVideoFileSignedUrlRequest
           */
          PullTrackOpticsVideoFileSignedUrlRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullTrackOpticsVideoFileSignedUrlRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest();
              if (object.trackOpticsVideoId != null)
                message.trackOpticsVideoId = String(object.trackOpticsVideoId);
              switch (object.videoType) {
                case "TRACK_OPTICS_VIDEO_TYPE_INVALID":
                case 0:
                  message.videoType = 0;
                  break;
                case "TRACK_OPTICS_VIDEO_TYPE_STANDARD":
                case 1:
                  message.videoType = 1;
                  break;
                case "TRACK_OPTICS_VIDEO_TYPE_DETECTIONS":
                case 2:
                  message.videoType = 2;
                  break;
              }
              return message;
            };

          /**
           * Creates a plain object from a PullTrackOpticsVideoFileSignedUrlRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @static
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest} message PullTrackOpticsVideoFileSignedUrlRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullTrackOpticsVideoFileSignedUrlRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.trackOpticsVideoId = "";
              object.videoType =
                options.enums === String
                  ? "TRACK_OPTICS_VIDEO_TYPE_INVALID"
                  : 0;
            }
            if (
              message.trackOpticsVideoId != null &&
              message.hasOwnProperty("trackOpticsVideoId")
            )
              object.trackOpticsVideoId = message.trackOpticsVideoId;
            if (
              message.videoType != null &&
              message.hasOwnProperty("videoType")
            )
              object.videoType =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360.TrackOpticsVideoType[
                      message.videoType
                    ]
                  : message.videoType;
            return object;
          };

          /**
           * Converts this PullTrackOpticsVideoFileSignedUrlRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullTrackOpticsVideoFileSignedUrlRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullTrackOpticsVideoFileSignedUrlRequest;
        })();

        racehorse360.PullTrackOpticsVideoFileSignedUrlResponse = (function () {
          /**
           * Properties of a PullTrackOpticsVideoFileSignedUrlResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IPullTrackOpticsVideoFileSignedUrlResponse
           * @property {string|null} [signedUrl] PullTrackOpticsVideoFileSignedUrlResponse signedUrl
           */

          /**
           * Constructs a new PullTrackOpticsVideoFileSignedUrlResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a PullTrackOpticsVideoFileSignedUrlResponse.
           * @implements IPullTrackOpticsVideoFileSignedUrlResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlResponse=} [properties] Properties to set
           */
          function PullTrackOpticsVideoFileSignedUrlResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * PullTrackOpticsVideoFileSignedUrlResponse signedUrl.
           * @member {string} signedUrl
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @instance
           */
          PullTrackOpticsVideoFileSignedUrlResponse.prototype.signedUrl = "";

          /**
           * Creates a new PullTrackOpticsVideoFileSignedUrlResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse} PullTrackOpticsVideoFileSignedUrlResponse instance
           */
          PullTrackOpticsVideoFileSignedUrlResponse.create = function create(
            properties
          ) {
            return new PullTrackOpticsVideoFileSignedUrlResponse(properties);
          };

          /**
           * Encodes the specified PullTrackOpticsVideoFileSignedUrlResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlResponse} message PullTrackOpticsVideoFileSignedUrlResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          PullTrackOpticsVideoFileSignedUrlResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.signedUrl != null &&
              Object.hasOwnProperty.call(message, "signedUrl")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.signedUrl);
            return writer;
          };

          /**
           * Decodes a PullTrackOpticsVideoFileSignedUrlResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse} PullTrackOpticsVideoFileSignedUrlResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          PullTrackOpticsVideoFileSignedUrlResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.signedUrl = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a PullTrackOpticsVideoFileSignedUrlResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse} PullTrackOpticsVideoFileSignedUrlResponse
           */
          PullTrackOpticsVideoFileSignedUrlResponse.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .PullTrackOpticsVideoFileSignedUrlResponse
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse();
              if (object.signedUrl != null)
                message.signedUrl = String(object.signedUrl);
              return message;
            };

          /**
           * Creates a plain object from a PullTrackOpticsVideoFileSignedUrlResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @static
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse} message PullTrackOpticsVideoFileSignedUrlResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          PullTrackOpticsVideoFileSignedUrlResponse.toObject =
            function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) object.signedUrl = "";
              if (
                message.signedUrl != null &&
                message.hasOwnProperty("signedUrl")
              )
                object.signedUrl = message.signedUrl;
              return object;
            };

          /**
           * Converts this PullTrackOpticsVideoFileSignedUrlResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          PullTrackOpticsVideoFileSignedUrlResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return PullTrackOpticsVideoFileSignedUrlResponse;
        })();

        racehorse360.HandleTrackOpticsVideoPubsubRequest = (function () {
          /**
           * Properties of a HandleTrackOpticsVideoPubsubRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHandleTrackOpticsVideoPubsubRequest
           * @property {stronachgroup.first.external.INotificationMessage|null} [message] HandleTrackOpticsVideoPubsubRequest message
           */

          /**
           * Constructs a new HandleTrackOpticsVideoPubsubRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HandleTrackOpticsVideoPubsubRequest.
           * @implements IHandleTrackOpticsVideoPubsubRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHandleTrackOpticsVideoPubsubRequest=} [properties] Properties to set
           */
          function HandleTrackOpticsVideoPubsubRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HandleTrackOpticsVideoPubsubRequest message.
           * @member {stronachgroup.first.external.INotificationMessage|null|undefined} message
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @instance
           */
          HandleTrackOpticsVideoPubsubRequest.prototype.message = null;

          /**
           * Creates a new HandleTrackOpticsVideoPubsubRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IHandleTrackOpticsVideoPubsubRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} HandleTrackOpticsVideoPubsubRequest instance
           */
          HandleTrackOpticsVideoPubsubRequest.create = function create(
            properties
          ) {
            return new HandleTrackOpticsVideoPubsubRequest(properties);
          };

          /**
           * Encodes the specified HandleTrackOpticsVideoPubsubRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IHandleTrackOpticsVideoPubsubRequest} message HandleTrackOpticsVideoPubsubRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HandleTrackOpticsVideoPubsubRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.message != null &&
              Object.hasOwnProperty.call(message, "message")
            )
              $root.stronachgroup.first.external.NotificationMessage.encode(
                message.message,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HandleTrackOpticsVideoPubsubRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} HandleTrackOpticsVideoPubsubRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HandleTrackOpticsVideoPubsubRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.message =
                    $root.stronachgroup.first.external.NotificationMessage.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HandleTrackOpticsVideoPubsubRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} HandleTrackOpticsVideoPubsubRequest
           */
          HandleTrackOpticsVideoPubsubRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .HandleTrackOpticsVideoPubsubRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest();
            if (object.message != null) {
              if (typeof object.message !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest.message: object expected"
                );
              message.message =
                $root.stronachgroup.first.external.NotificationMessage.fromObject(
                  object.message
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HandleTrackOpticsVideoPubsubRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @static
           * @param {stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest} message HandleTrackOpticsVideoPubsubRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HandleTrackOpticsVideoPubsubRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.message = null;
            if (message.message != null && message.hasOwnProperty("message"))
              object.message =
                $root.stronachgroup.first.external.NotificationMessage.toObject(
                  message.message,
                  options
                );
            return object;
          };

          /**
           * Converts this HandleTrackOpticsVideoPubsubRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HandleTrackOpticsVideoPubsubRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HandleTrackOpticsVideoPubsubRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return HandleTrackOpticsVideoPubsubRequest;
        })();

        racehorse360.HorseExamRequirement = (function () {
          /**
           * Properties of a HorseExamRequirement.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamRequirement
           * @property {string|null} [id] HorseExamRequirement id
           * @property {stronachgroup.first.racehorse360.IHorse|null} [horse] HorseExamRequirement horse
           * @property {stronachgroup.first.racehorse360.IHorseExamRequirementType|null} [type] HorseExamRequirement type
           * @property {string|null} [baseEventDate] HorseExamRequirement baseEventDate
           * @property {stronachgroup.first.racehorse360.HorseExamRequirementStatus|null} [status] HorseExamRequirement status
           * @property {number|null} [reactivationDays] HorseExamRequirement reactivationDays
           */

          /**
           * Constructs a new HorseExamRequirement.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamRequirement.
           * @implements IHorseExamRequirement
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirement=} [properties] Properties to set
           */
          function HorseExamRequirement(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamRequirement id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.id = "";

          /**
           * HorseExamRequirement horse.
           * @member {stronachgroup.first.racehorse360.IHorse|null|undefined} horse
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.horse = null;

          /**
           * HorseExamRequirement type.
           * @member {stronachgroup.first.racehorse360.IHorseExamRequirementType|null|undefined} type
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.type = null;

          /**
           * HorseExamRequirement baseEventDate.
           * @member {string} baseEventDate
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.baseEventDate = "";

          /**
           * HorseExamRequirement status.
           * @member {stronachgroup.first.racehorse360.HorseExamRequirementStatus} status
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.status = 0;

          /**
           * HorseExamRequirement reactivationDays.
           * @member {number} reactivationDays
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           */
          HorseExamRequirement.prototype.reactivationDays = 0;

          /**
           * Creates a new HorseExamRequirement instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirement=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirement} HorseExamRequirement instance
           */
          HorseExamRequirement.create = function create(properties) {
            return new HorseExamRequirement(properties);
          };

          /**
           * Encodes the specified HorseExamRequirement message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamRequirement.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirement} message HorseExamRequirement message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamRequirement.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.horse != null &&
              Object.hasOwnProperty.call(message, "horse")
            )
              $root.stronachgroup.first.racehorse360.Horse.encode(
                message.horse,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              $root.stronachgroup.first.racehorse360.HorseExamRequirementType.encode(
                message.type,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.baseEventDate != null &&
              Object.hasOwnProperty.call(message, "baseEventDate")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.baseEventDate);
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.status);
            if (
              message.reactivationDays != null &&
              Object.hasOwnProperty.call(message, "reactivationDays")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.reactivationDays);
            return writer;
          };

          /**
           * Decodes a HorseExamRequirement message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirement} HorseExamRequirement
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamRequirement.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamRequirement();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.horse =
                    $root.stronachgroup.first.racehorse360.Horse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 3:
                  message.type =
                    $root.stronachgroup.first.racehorse360.HorseExamRequirementType.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.baseEventDate = reader.string();
                  break;
                case 5:
                  message.status = reader.int32();
                  break;
                case 6:
                  message.reactivationDays = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamRequirement message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirement} HorseExamRequirement
           */
          HorseExamRequirement.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamRequirement
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamRequirement();
            if (object.id != null) message.id = String(object.id);
            if (object.horse != null) {
              if (typeof object.horse !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirement.horse: object expected"
                );
              message.horse =
                $root.stronachgroup.first.racehorse360.Horse.fromObject(
                  object.horse
                );
            }
            if (object.type != null) {
              if (typeof object.type !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirement.type: object expected"
                );
              message.type =
                $root.stronachgroup.first.racehorse360.HorseExamRequirementType.fromObject(
                  object.type
                );
            }
            if (object.baseEventDate != null)
              message.baseEventDate = String(object.baseEventDate);
            switch (object.status) {
              case "HORSE_EXAM_REQUIREMENT_STATUS_INVALID":
              case 0:
                message.status = 0;
                break;
              case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_REQUIRED":
              case 1:
                message.status = 1;
                break;
              case "HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM":
              case 2:
                message.status = 2;
                break;
              case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_COMPLETED":
              case 3:
                message.status = 3;
                break;
              case "HORSE_EXAM_REQUIREMENT_STATUS_VOIDED":
              case 4:
                message.status = 4;
                break;
              case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_EXPIRING":
              case 5:
                message.status = 5;
                break;
            }
            if (object.reactivationDays != null)
              message.reactivationDays = object.reactivationDays | 0;
            return message;
          };

          /**
           * Creates a plain object from a HorseExamRequirement message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamRequirement} message HorseExamRequirement
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamRequirement.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.horse = null;
              object.type = null;
              object.baseEventDate = "";
              object.status =
                options.enums === String
                  ? "HORSE_EXAM_REQUIREMENT_STATUS_INVALID"
                  : 0;
              object.reactivationDays = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (message.horse != null && message.hasOwnProperty("horse"))
              object.horse =
                $root.stronachgroup.first.racehorse360.Horse.toObject(
                  message.horse,
                  options
                );
            if (message.type != null && message.hasOwnProperty("type"))
              object.type =
                $root.stronachgroup.first.racehorse360.HorseExamRequirementType.toObject(
                  message.type,
                  options
                );
            if (
              message.baseEventDate != null &&
              message.hasOwnProperty("baseEventDate")
            )
              object.baseEventDate = message.baseEventDate;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .HorseExamRequirementStatus[message.status]
                  : message.status;
            if (
              message.reactivationDays != null &&
              message.hasOwnProperty("reactivationDays")
            )
              object.reactivationDays = message.reactivationDays;
            return object;
          };

          /**
           * Converts this HorseExamRequirement to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirement
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamRequirement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamRequirement;
        })();

        racehorse360.HorseExamRequirementFilter = (function () {
          /**
           * Properties of a HorseExamRequirementFilter.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamRequirementFilter
           * @property {Array.<string>|null} [trainerIds] HorseExamRequirementFilter trainerIds
           * @property {Array.<string>|null} [horseFacilityIds] HorseExamRequirementFilter horseFacilityIds
           * @property {Array.<stronachgroup.first.racehorse360.HorseExamRequirementStatus>|null} [statuses] HorseExamRequirementFilter statuses
           * @property {google.protobuf.IBoolValue|null} [isReactivatable] HorseExamRequirementFilter isReactivatable
           */

          /**
           * Constructs a new HorseExamRequirementFilter.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamRequirementFilter.
           * @implements IHorseExamRequirementFilter
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementFilter=} [properties] Properties to set
           */
          function HorseExamRequirementFilter(properties) {
            this.trainerIds = [];
            this.horseFacilityIds = [];
            this.statuses = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamRequirementFilter trainerIds.
           * @member {Array.<string>} trainerIds
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @instance
           */
          HorseExamRequirementFilter.prototype.trainerIds = $util.emptyArray;

          /**
           * HorseExamRequirementFilter horseFacilityIds.
           * @member {Array.<string>} horseFacilityIds
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @instance
           */
          HorseExamRequirementFilter.prototype.horseFacilityIds =
            $util.emptyArray;

          /**
           * HorseExamRequirementFilter statuses.
           * @member {Array.<stronachgroup.first.racehorse360.HorseExamRequirementStatus>} statuses
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @instance
           */
          HorseExamRequirementFilter.prototype.statuses = $util.emptyArray;

          /**
           * HorseExamRequirementFilter isReactivatable.
           * @member {google.protobuf.IBoolValue|null|undefined} isReactivatable
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @instance
           */
          HorseExamRequirementFilter.prototype.isReactivatable = null;

          /**
           * Creates a new HorseExamRequirementFilter instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementFilter=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementFilter} HorseExamRequirementFilter instance
           */
          HorseExamRequirementFilter.create = function create(properties) {
            return new HorseExamRequirementFilter(properties);
          };

          /**
           * Encodes the specified HorseExamRequirementFilter message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamRequirementFilter.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementFilter} message HorseExamRequirementFilter message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamRequirementFilter.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.trainerIds != null && message.trainerIds.length)
              for (var i = 0; i < message.trainerIds.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.trainerIds[i]);
            if (
              message.horseFacilityIds != null &&
              message.horseFacilityIds.length
            )
              for (var i = 0; i < message.horseFacilityIds.length; ++i)
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.horseFacilityIds[i]);
            if (message.statuses != null && message.statuses.length) {
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork();
              for (var i = 0; i < message.statuses.length; ++i)
                writer.int32(message.statuses[i]);
              writer.ldelim();
            }
            if (
              message.isReactivatable != null &&
              Object.hasOwnProperty.call(message, "isReactivatable")
            )
              $root.google.protobuf.BoolValue.encode(
                message.isReactivatable,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a HorseExamRequirementFilter message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementFilter} HorseExamRequirementFilter
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamRequirementFilter.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.trainerIds && message.trainerIds.length))
                    message.trainerIds = [];
                  message.trainerIds.push(reader.string());
                  break;
                case 2:
                  if (
                    !(
                      message.horseFacilityIds &&
                      message.horseFacilityIds.length
                    )
                  )
                    message.horseFacilityIds = [];
                  message.horseFacilityIds.push(reader.string());
                  break;
                case 3:
                  if (!(message.statuses && message.statuses.length))
                    message.statuses = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                      message.statuses.push(reader.int32());
                  } else message.statuses.push(reader.int32());
                  break;
                case 4:
                  message.isReactivatable =
                    $root.google.protobuf.BoolValue.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamRequirementFilter message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementFilter} HorseExamRequirementFilter
           */
          HorseExamRequirementFilter.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter();
            if (object.trainerIds) {
              if (!Array.isArray(object.trainerIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirementFilter.trainerIds: array expected"
                );
              message.trainerIds = [];
              for (var i = 0; i < object.trainerIds.length; ++i)
                message.trainerIds[i] = String(object.trainerIds[i]);
            }
            if (object.horseFacilityIds) {
              if (!Array.isArray(object.horseFacilityIds))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirementFilter.horseFacilityIds: array expected"
                );
              message.horseFacilityIds = [];
              for (var i = 0; i < object.horseFacilityIds.length; ++i)
                message.horseFacilityIds[i] = String(
                  object.horseFacilityIds[i]
                );
            }
            if (object.statuses) {
              if (!Array.isArray(object.statuses))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirementFilter.statuses: array expected"
                );
              message.statuses = [];
              for (var i = 0; i < object.statuses.length; ++i)
                switch (object.statuses[i]) {
                  default:
                  case "HORSE_EXAM_REQUIREMENT_STATUS_INVALID":
                  case 0:
                    message.statuses[i] = 0;
                    break;
                  case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_REQUIRED":
                  case 1:
                    message.statuses[i] = 1;
                    break;
                  case "HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM":
                  case 2:
                    message.statuses[i] = 2;
                    break;
                  case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_COMPLETED":
                  case 3:
                    message.statuses[i] = 3;
                    break;
                  case "HORSE_EXAM_REQUIREMENT_STATUS_VOIDED":
                  case 4:
                    message.statuses[i] = 4;
                    break;
                  case "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_EXPIRING":
                  case 5:
                    message.statuses[i] = 5;
                    break;
                }
            }
            if (object.isReactivatable != null) {
              if (typeof object.isReactivatable !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.HorseExamRequirementFilter.isReactivatable: object expected"
                );
              message.isReactivatable =
                $root.google.protobuf.BoolValue.fromObject(
                  object.isReactivatable
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamRequirementFilter message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamRequirementFilter} message HorseExamRequirementFilter
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamRequirementFilter.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.trainerIds = [];
              object.horseFacilityIds = [];
              object.statuses = [];
            }
            if (options.defaults) object.isReactivatable = null;
            if (message.trainerIds && message.trainerIds.length) {
              object.trainerIds = [];
              for (var j = 0; j < message.trainerIds.length; ++j)
                object.trainerIds[j] = message.trainerIds[j];
            }
            if (message.horseFacilityIds && message.horseFacilityIds.length) {
              object.horseFacilityIds = [];
              for (var j = 0; j < message.horseFacilityIds.length; ++j)
                object.horseFacilityIds[j] = message.horseFacilityIds[j];
            }
            if (message.statuses && message.statuses.length) {
              object.statuses = [];
              for (var j = 0; j < message.statuses.length; ++j)
                object.statuses[j] =
                  options.enums === String
                    ? $root.stronachgroup.first.racehorse360
                        .HorseExamRequirementStatus[message.statuses[j]]
                    : message.statuses[j];
            }
            if (
              message.isReactivatable != null &&
              message.hasOwnProperty("isReactivatable")
            )
              object.isReactivatable = $root.google.protobuf.BoolValue.toObject(
                message.isReactivatable,
                options
              );
            return object;
          };

          /**
           * Converts this HorseExamRequirementFilter to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementFilter
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamRequirementFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamRequirementFilter;
        })();

        racehorse360.HorseExamRequirementType = (function () {
          /**
           * Properties of a HorseExamRequirementType.
           * @memberof stronachgroup.first.racehorse360
           * @interface IHorseExamRequirementType
           * @property {string|null} [id] HorseExamRequirementType id
           * @property {string|null} [description] HorseExamRequirementType description
           * @property {stronachgroup.first.racehorse360.HorseExamRequirementTypeCode|null} [code] HorseExamRequirementType code
           */

          /**
           * Constructs a new HorseExamRequirementType.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamRequirementType.
           * @implements IHorseExamRequirementType
           * @constructor
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementType=} [properties] Properties to set
           */
          function HorseExamRequirementType(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HorseExamRequirementType id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @instance
           */
          HorseExamRequirementType.prototype.id = "";

          /**
           * HorseExamRequirementType description.
           * @member {string} description
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @instance
           */
          HorseExamRequirementType.prototype.description = "";

          /**
           * HorseExamRequirementType code.
           * @member {stronachgroup.first.racehorse360.HorseExamRequirementTypeCode} code
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @instance
           */
          HorseExamRequirementType.prototype.code = 0;

          /**
           * Creates a new HorseExamRequirementType instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementType=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementType} HorseExamRequirementType instance
           */
          HorseExamRequirementType.create = function create(properties) {
            return new HorseExamRequirementType(properties);
          };

          /**
           * Encodes the specified HorseExamRequirementType message. Does not implicitly {@link stronachgroup.first.racehorse360.HorseExamRequirementType.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @static
           * @param {stronachgroup.first.racehorse360.IHorseExamRequirementType} message HorseExamRequirementType message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HorseExamRequirementType.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            if (
              message.code != null &&
              Object.hasOwnProperty.call(message, "code")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.code);
            return writer;
          };

          /**
           * Decodes a HorseExamRequirementType message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementType} HorseExamRequirementType
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HorseExamRequirementType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.HorseExamRequirementType();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                case 3:
                  message.code = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HorseExamRequirementType message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.HorseExamRequirementType} HorseExamRequirementType
           */
          HorseExamRequirementType.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360.HorseExamRequirementType
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.HorseExamRequirementType();
            if (object.id != null) message.id = String(object.id);
            if (object.description != null)
              message.description = String(object.description);
            switch (object.code) {
              case "HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID":
              case 0:
                message.code = 0;
                break;
              case "HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM":
              case 1:
                message.code = 1;
                break;
              case "HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA":
              case 2:
                message.code = 2;
                break;
              case "HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1":
              case 3:
                message.code = 3;
                break;
              case "HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2":
              case 4:
                message.code = 4;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a HorseExamRequirementType message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @static
           * @param {stronachgroup.first.racehorse360.HorseExamRequirementType} message HorseExamRequirementType
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HorseExamRequirementType.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.description = "";
              object.code =
                options.enums === String
                  ? "HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID"
                  : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.code != null && message.hasOwnProperty("code"))
              object.code =
                options.enums === String
                  ? $root.stronachgroup.first.racehorse360
                      .HorseExamRequirementTypeCode[message.code]
                  : message.code;
            return object;
          };

          /**
           * Converts this HorseExamRequirementType to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementType
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HorseExamRequirementType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HorseExamRequirementType;
        })();

        racehorse360.ListHorseExamRequirementsRequest = (function () {
          /**
           * Properties of a ListHorseExamRequirementsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamRequirementsRequest
           * @property {stronachgroup.first.racehorse360.IHorseExamRequirementFilter|null} [query] ListHorseExamRequirementsRequest query
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ListHorseExamRequirementsRequest getOptions
           * @property {stronachgroup.first.racehorse360.IPagingOptions|null} [pagingOptions] ListHorseExamRequirementsRequest pagingOptions
           */

          /**
           * Constructs a new ListHorseExamRequirementsRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamRequirementsRequest.
           * @implements IListHorseExamRequirementsRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsRequest=} [properties] Properties to set
           */
          function ListHorseExamRequirementsRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamRequirementsRequest query.
           * @member {stronachgroup.first.racehorse360.IHorseExamRequirementFilter|null|undefined} query
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @instance
           */
          ListHorseExamRequirementsRequest.prototype.query = null;

          /**
           * ListHorseExamRequirementsRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @instance
           */
          ListHorseExamRequirementsRequest.prototype.getOptions = null;

          /**
           * ListHorseExamRequirementsRequest pagingOptions.
           * @member {stronachgroup.first.racehorse360.IPagingOptions|null|undefined} pagingOptions
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @instance
           */
          ListHorseExamRequirementsRequest.prototype.pagingOptions = null;

          /**
           * Creates a new ListHorseExamRequirementsRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} ListHorseExamRequirementsRequest instance
           */
          ListHorseExamRequirementsRequest.create = function create(
            properties
          ) {
            return new ListHorseExamRequirementsRequest(properties);
          };

          /**
           * Encodes the specified ListHorseExamRequirementsRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsRequest} message ListHorseExamRequirementsRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamRequirementsRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.query != null &&
              Object.hasOwnProperty.call(message, "query")
            )
              $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter.encode(
                message.query,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            if (
              message.pagingOptions != null &&
              Object.hasOwnProperty.call(message, "pagingOptions")
            )
              $root.stronachgroup.first.racehorse360.PagingOptions.encode(
                message.pagingOptions,
                writer.uint32(/* id 101, wireType 2 =*/ 810).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamRequirementsRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} ListHorseExamRequirementsRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamRequirementsRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.query =
                    $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 101:
                  message.pagingOptions =
                    $root.stronachgroup.first.racehorse360.PagingOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamRequirementsRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} ListHorseExamRequirementsRequest
           */
          ListHorseExamRequirementsRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseExamRequirementsRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest();
            if (object.query != null) {
              if (typeof object.query !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest.query: object expected"
                );
              message.query =
                $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter.fromObject(
                  object.query
                );
            }
            if (object.getOptions != null) {
              if (typeof object.getOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest.getOptions: object expected"
                );
              message.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                  object.getOptions
                );
            }
            if (object.pagingOptions != null) {
              if (typeof object.pagingOptions !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest.pagingOptions: object expected"
                );
              message.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.fromObject(
                  object.pagingOptions
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamRequirementsRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest} message ListHorseExamRequirementsRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamRequirementsRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.query = null;
              object.getOptions = null;
              object.pagingOptions = null;
            }
            if (message.query != null && message.hasOwnProperty("query"))
              object.query =
                $root.stronachgroup.first.racehorse360.HorseExamRequirementFilter.toObject(
                  message.query,
                  options
                );
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            if (
              message.pagingOptions != null &&
              message.hasOwnProperty("pagingOptions")
            )
              object.pagingOptions =
                $root.stronachgroup.first.racehorse360.PagingOptions.toObject(
                  message.pagingOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamRequirementsRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamRequirementsRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListHorseExamRequirementsRequest;
        })();

        racehorse360.ListHorseExamRequirementsResponse = (function () {
          /**
           * Properties of a ListHorseExamRequirementsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @interface IListHorseExamRequirementsResponse
           * @property {Array.<stronachgroup.first.racehorse360.IHorseExamRequirement>|null} [horseExamRequirements] ListHorseExamRequirementsResponse horseExamRequirements
           * @property {stronachgroup.first.racehorse360.IPagingInfo|null} [pagingInfo] ListHorseExamRequirementsResponse pagingInfo
           */

          /**
           * Constructs a new ListHorseExamRequirementsResponse.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ListHorseExamRequirementsResponse.
           * @implements IListHorseExamRequirementsResponse
           * @constructor
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsResponse=} [properties] Properties to set
           */
          function ListHorseExamRequirementsResponse(properties) {
            this.horseExamRequirements = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ListHorseExamRequirementsResponse horseExamRequirements.
           * @member {Array.<stronachgroup.first.racehorse360.IHorseExamRequirement>} horseExamRequirements
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @instance
           */
          ListHorseExamRequirementsResponse.prototype.horseExamRequirements =
            $util.emptyArray;

          /**
           * ListHorseExamRequirementsResponse pagingInfo.
           * @member {stronachgroup.first.racehorse360.IPagingInfo|null|undefined} pagingInfo
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @instance
           */
          ListHorseExamRequirementsResponse.prototype.pagingInfo = null;

          /**
           * Creates a new ListHorseExamRequirementsResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse} ListHorseExamRequirementsResponse instance
           */
          ListHorseExamRequirementsResponse.create = function create(
            properties
          ) {
            return new ListHorseExamRequirementsResponse(properties);
          };

          /**
           * Encodes the specified ListHorseExamRequirementsResponse message. Does not implicitly {@link stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsResponse} message ListHorseExamRequirementsResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ListHorseExamRequirementsResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.horseExamRequirements != null &&
              message.horseExamRequirements.length
            )
              for (var i = 0; i < message.horseExamRequirements.length; ++i)
                $root.stronachgroup.first.racehorse360.HorseExamRequirement.encode(
                  message.horseExamRequirements[i],
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
            if (
              message.pagingInfo != null &&
              Object.hasOwnProperty.call(message, "pagingInfo")
            )
              $root.stronachgroup.first.racehorse360.PagingInfo.encode(
                message.pagingInfo,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ListHorseExamRequirementsResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse} ListHorseExamRequirementsResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ListHorseExamRequirementsResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.horseExamRequirements &&
                      message.horseExamRequirements.length
                    )
                  )
                    message.horseExamRequirements = [];
                  message.horseExamRequirements.push(
                    $root.stronachgroup.first.racehorse360.HorseExamRequirement.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                case 100:
                  message.pagingInfo =
                    $root.stronachgroup.first.racehorse360.PagingInfo.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ListHorseExamRequirementsResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse} ListHorseExamRequirementsResponse
           */
          ListHorseExamRequirementsResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.racehorse360
                .ListHorseExamRequirementsResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse();
            if (object.horseExamRequirements) {
              if (!Array.isArray(object.horseExamRequirements))
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse.horseExamRequirements: array expected"
                );
              message.horseExamRequirements = [];
              for (var i = 0; i < object.horseExamRequirements.length; ++i) {
                if (typeof object.horseExamRequirements[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse.horseExamRequirements: object expected"
                  );
                message.horseExamRequirements[i] =
                  $root.stronachgroup.first.racehorse360.HorseExamRequirement.fromObject(
                    object.horseExamRequirements[i]
                  );
              }
            }
            if (object.pagingInfo != null) {
              if (typeof object.pagingInfo !== "object")
                throw TypeError(
                  ".stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse.pagingInfo: object expected"
                );
              message.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.fromObject(
                  object.pagingInfo
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ListHorseExamRequirementsResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @static
           * @param {stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse} message ListHorseExamRequirementsResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ListHorseExamRequirementsResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.horseExamRequirements = [];
            if (options.defaults) object.pagingInfo = null;
            if (
              message.horseExamRequirements &&
              message.horseExamRequirements.length
            ) {
              object.horseExamRequirements = [];
              for (var j = 0; j < message.horseExamRequirements.length; ++j)
                object.horseExamRequirements[j] =
                  $root.stronachgroup.first.racehorse360.HorseExamRequirement.toObject(
                    message.horseExamRequirements[j],
                    options
                  );
            }
            if (
              message.pagingInfo != null &&
              message.hasOwnProperty("pagingInfo")
            )
              object.pagingInfo =
                $root.stronachgroup.first.racehorse360.PagingInfo.toObject(
                  message.pagingInfo,
                  options
                );
            return object;
          };

          /**
           * Converts this ListHorseExamRequirementsResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ListHorseExamRequirementsResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ListHorseExamRequirementsResponse;
        })();

        racehorse360.ConfirmExamRequirementReadinessRequest = (function () {
          /**
           * Properties of a ConfirmExamRequirementReadinessRequest.
           * @memberof stronachgroup.first.racehorse360
           * @interface IConfirmExamRequirementReadinessRequest
           * @property {string|null} [id] ConfirmExamRequirementReadinessRequest id
           * @property {stronachgroup.first.racehorse360.IGetOptions|null} [getOptions] ConfirmExamRequirementReadinessRequest getOptions
           */

          /**
           * Constructs a new ConfirmExamRequirementReadinessRequest.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a ConfirmExamRequirementReadinessRequest.
           * @implements IConfirmExamRequirementReadinessRequest
           * @constructor
           * @param {stronachgroup.first.racehorse360.IConfirmExamRequirementReadinessRequest=} [properties] Properties to set
           */
          function ConfirmExamRequirementReadinessRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ConfirmExamRequirementReadinessRequest id.
           * @member {string} id
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @instance
           */
          ConfirmExamRequirementReadinessRequest.prototype.id = "";

          /**
           * ConfirmExamRequirementReadinessRequest getOptions.
           * @member {stronachgroup.first.racehorse360.IGetOptions|null|undefined} getOptions
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @instance
           */
          ConfirmExamRequirementReadinessRequest.prototype.getOptions = null;

          /**
           * Creates a new ConfirmExamRequirementReadinessRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IConfirmExamRequirementReadinessRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} ConfirmExamRequirementReadinessRequest instance
           */
          ConfirmExamRequirementReadinessRequest.create = function create(
            properties
          ) {
            return new ConfirmExamRequirementReadinessRequest(properties);
          };

          /**
           * Encodes the specified ConfirmExamRequirementReadinessRequest message. Does not implicitly {@link stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.IConfirmExamRequirementReadinessRequest} message ConfirmExamRequirementReadinessRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ConfirmExamRequirementReadinessRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
            if (
              message.getOptions != null &&
              Object.hasOwnProperty.call(message, "getOptions")
            )
              $root.stronachgroup.first.racehorse360.GetOptions.encode(
                message.getOptions,
                writer.uint32(/* id 100, wireType 2 =*/ 802).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a ConfirmExamRequirementReadinessRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} ConfirmExamRequirementReadinessRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ConfirmExamRequirementReadinessRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.id = reader.string();
                  break;
                case 100:
                  message.getOptions =
                    $root.stronachgroup.first.racehorse360.GetOptions.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ConfirmExamRequirementReadinessRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} ConfirmExamRequirementReadinessRequest
           */
          ConfirmExamRequirementReadinessRequest.fromObject =
            function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.racehorse360
                  .ConfirmExamRequirementReadinessRequest
              )
                return object;
              var message =
                new $root.stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest();
              if (object.id != null) message.id = String(object.id);
              if (object.getOptions != null) {
                if (typeof object.getOptions !== "object")
                  throw TypeError(
                    ".stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest.getOptions: object expected"
                  );
                message.getOptions =
                  $root.stronachgroup.first.racehorse360.GetOptions.fromObject(
                    object.getOptions
                  );
              }
              return message;
            };

          /**
           * Creates a plain object from a ConfirmExamRequirementReadinessRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @static
           * @param {stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest} message ConfirmExamRequirementReadinessRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ConfirmExamRequirementReadinessRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.id = "";
              object.getOptions = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
              object.id = message.id;
            if (
              message.getOptions != null &&
              message.hasOwnProperty("getOptions")
            )
              object.getOptions =
                $root.stronachgroup.first.racehorse360.GetOptions.toObject(
                  message.getOptions,
                  options
                );
            return object;
          };

          /**
           * Converts this ConfirmExamRequirementReadinessRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.racehorse360.ConfirmExamRequirementReadinessRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ConfirmExamRequirementReadinessRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ConfirmExamRequirementReadinessRequest;
        })();

        /**
         * CourseCondition enum.
         * @name stronachgroup.first.racehorse360.CourseCondition
         * @enum {string}
         * @property {number} COURSE_CONDITION_INVALID=0 COURSE_CONDITION_INVALID value
         * @property {number} COURSE_CONDITION_MVL=1 COURSE_CONDITION_MVL value
         * @property {number} COURSE_CONDITION_MSW=2 COURSE_CONDITION_MSW value
         * @property {number} COURSE_CONDITION_NXT=3 COURSE_CONDITION_NXT value
         * @property {number} COURSE_CONDITION_N2=4 COURSE_CONDITION_N2 value
         * @property {number} COURSE_CONDITION_N2X=5 COURSE_CONDITION_N2X value
         * @property {number} COURSE_CONDITION_N3=6 COURSE_CONDITION_N3 value
         * @property {number} COURSE_CONDITION_N3X=7 COURSE_CONDITION_N3X value
         * @property {number} COURSE_CONDITION_AOC=8 COURSE_CONDITION_AOC value
         * @property {number} COURSE_CONDITION_ALW=9 COURSE_CONDITION_ALW value
         */
        racehorse360.CourseCondition = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "COURSE_CONDITION_INVALID")] = 0;
          values[(valuesById[1] = "COURSE_CONDITION_MVL")] = 1;
          values[(valuesById[2] = "COURSE_CONDITION_MSW")] = 2;
          values[(valuesById[3] = "COURSE_CONDITION_NXT")] = 3;
          values[(valuesById[4] = "COURSE_CONDITION_N2")] = 4;
          values[(valuesById[5] = "COURSE_CONDITION_N2X")] = 5;
          values[(valuesById[6] = "COURSE_CONDITION_N3")] = 6;
          values[(valuesById[7] = "COURSE_CONDITION_N3X")] = 7;
          values[(valuesById[8] = "COURSE_CONDITION_AOC")] = 8;
          values[(valuesById[9] = "COURSE_CONDITION_ALW")] = 9;
          return values;
        })();

        /**
         * CourseDistance enum.
         * @name stronachgroup.first.racehorse360.CourseDistance
         * @enum {string}
         * @property {number} COURSE_DISTANCE_INVALID=0 COURSE_DISTANCE_INVALID value
         * @property {number} COURSE_DISTANCE_SHORT=1 COURSE_DISTANCE_SHORT value
         * @property {number} COURSE_DISTANCE_LONG=2 COURSE_DISTANCE_LONG value
         */
        racehorse360.CourseDistance = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "COURSE_DISTANCE_INVALID")] = 0;
          values[(valuesById[1] = "COURSE_DISTANCE_SHORT")] = 1;
          values[(valuesById[2] = "COURSE_DISTANCE_LONG")] = 2;
          return values;
        })();

        /**
         * CourseSurface enum.
         * @name stronachgroup.first.racehorse360.CourseSurface
         * @enum {string}
         * @property {number} COURSE_SURFACE_INVALID=0 COURSE_SURFACE_INVALID value
         * @property {number} COURSE_SURFACE_ALL_WEATHER_TRACK=1 COURSE_SURFACE_ALL_WEATHER_TRACK value
         * @property {number} COURSE_SURFACE_TURF=2 COURSE_SURFACE_TURF value
         * @property {number} COURSE_SURFACE_STEEPLECHASE=3 COURSE_SURFACE_STEEPLECHASE value
         * @property {number} COURSE_SURFACE_INNER_TRACK=4 COURSE_SURFACE_INNER_TRACK value
         * @property {number} COURSE_SURFACE_OUTER_TURF=5 COURSE_SURFACE_OUTER_TURF value
         * @property {number} COURSE_SURFACE_WOOD_CHIPS=6 COURSE_SURFACE_WOOD_CHIPS value
         * @property {number} COURSE_SURFACE_HUNT_ON_TURF=7 COURSE_SURFACE_HUNT_ON_TURF value
         * @property {number} COURSE_SURFACE_TIMBER=8 COURSE_SURFACE_TIMBER value
         * @property {number} COURSE_SURFACE_DIRT=9 COURSE_SURFACE_DIRT value
         * @property {number} COURSE_SURFACE_TURF_TRAINING=10 COURSE_SURFACE_TURF_TRAINING value
         * @property {number} COURSE_SURFACE_JUMP=11 COURSE_SURFACE_JUMP value
         * @property {number} COURSE_SURFACE_ALL_WEATHER_TRAINING=12 COURSE_SURFACE_ALL_WEATHER_TRAINING value
         * @property {number} COURSE_SURFACE_HUNT=13 COURSE_SURFACE_HUNT value
         * @property {number} COURSE_SURFACE_DOWNHILL_TURF=14 COURSE_SURFACE_DOWNHILL_TURF value
         * @property {number} COURSE_SURFACE_DIRT_TRAINING=15 COURSE_SURFACE_DIRT_TRAINING value
         * @property {number} COURSE_SURFACE_INNER_TURF=16 COURSE_SURFACE_INNER_TURF value
         * @property {number} COURSE_SURFACE_HURDLE=17 COURSE_SURFACE_HURDLE value
         */
        racehorse360.CourseSurface = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "COURSE_SURFACE_INVALID")] = 0;
          values[(valuesById[1] = "COURSE_SURFACE_ALL_WEATHER_TRACK")] = 1;
          values[(valuesById[2] = "COURSE_SURFACE_TURF")] = 2;
          values[(valuesById[3] = "COURSE_SURFACE_STEEPLECHASE")] = 3;
          values[(valuesById[4] = "COURSE_SURFACE_INNER_TRACK")] = 4;
          values[(valuesById[5] = "COURSE_SURFACE_OUTER_TURF")] = 5;
          values[(valuesById[6] = "COURSE_SURFACE_WOOD_CHIPS")] = 6;
          values[(valuesById[7] = "COURSE_SURFACE_HUNT_ON_TURF")] = 7;
          values[(valuesById[8] = "COURSE_SURFACE_TIMBER")] = 8;
          values[(valuesById[9] = "COURSE_SURFACE_DIRT")] = 9;
          values[(valuesById[10] = "COURSE_SURFACE_TURF_TRAINING")] = 10;
          values[(valuesById[11] = "COURSE_SURFACE_JUMP")] = 11;
          values[(valuesById[12] = "COURSE_SURFACE_ALL_WEATHER_TRAINING")] = 12;
          values[(valuesById[13] = "COURSE_SURFACE_HUNT")] = 13;
          values[(valuesById[14] = "COURSE_SURFACE_DOWNHILL_TURF")] = 14;
          values[(valuesById[15] = "COURSE_SURFACE_DIRT_TRAINING")] = 15;
          values[(valuesById[16] = "COURSE_SURFACE_INNER_TURF")] = 16;
          values[(valuesById[17] = "COURSE_SURFACE_HURDLE")] = 17;
          return values;
        })();

        /**
         * DistanceUnit enum.
         * @name stronachgroup.first.racehorse360.DistanceUnit
         * @enum {string}
         * @property {number} DISTANCE_UNIT_INVALID=0 DISTANCE_UNIT_INVALID value
         * @property {number} DISTANCE_UNIT_FURLONG=1 DISTANCE_UNIT_FURLONG value
         * @property {number} DISTANCE_UNIT_METER=2 DISTANCE_UNIT_METER value
         * @property {number} DISTANCE_UNIT_YARD=3 DISTANCE_UNIT_YARD value
         */
        racehorse360.DistanceUnit = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "DISTANCE_UNIT_INVALID")] = 0;
          values[(valuesById[1] = "DISTANCE_UNIT_FURLONG")] = 1;
          values[(valuesById[2] = "DISTANCE_UNIT_METER")] = 2;
          values[(valuesById[3] = "DISTANCE_UNIT_YARD")] = 3;
          return values;
        })();

        /**
         * JogScore enum.
         * @name stronachgroup.first.racehorse360.JogScore
         * @enum {string}
         * @property {number} JOG_SCORE_INVALID=0 JOG_SCORE_INVALID value
         * @property {number} JOG_SCORE_NORMAL=1 JOG_SCORE_NORMAL value
         * @property {number} JOG_SCORE_SLIGHT=2 JOG_SCORE_SLIGHT value
         * @property {number} JOG_SCORE_MID=3 JOG_SCORE_MID value
         * @property {number} JOG_SCORE_MODERATE=4 JOG_SCORE_MODERATE value
         * @property {number} JOG_SCORE_SEVERE=5 JOG_SCORE_SEVERE value
         * @property {number} JOG_SCORE_EXTREME=6 JOG_SCORE_EXTREME value
         */
        racehorse360.JogScore = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "JOG_SCORE_INVALID")] = 0;
          values[(valuesById[1] = "JOG_SCORE_NORMAL")] = 1;
          values[(valuesById[2] = "JOG_SCORE_SLIGHT")] = 2;
          values[(valuesById[3] = "JOG_SCORE_MID")] = 3;
          values[(valuesById[4] = "JOG_SCORE_MODERATE")] = 4;
          values[(valuesById[5] = "JOG_SCORE_SEVERE")] = 5;
          values[(valuesById[6] = "JOG_SCORE_EXTREME")] = 6;
          return values;
        })();

        /**
         * FacilityType enum.
         * @name stronachgroup.first.racehorse360.FacilityType
         * @enum {string}
         * @property {number} FACILITY_TYPE_INVALID=0 FACILITY_TYPE_INVALID value
         * @property {number} FACILITY_TYPE_TRAINING_CENTER=1 FACILITY_TYPE_TRAINING_CENTER value
         * @property {number} FACILITY_TYPE_TRACK=2 FACILITY_TYPE_TRACK value
         */
        racehorse360.FacilityType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "FACILITY_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "FACILITY_TYPE_TRAINING_CENTER")] = 1;
          values[(valuesById[2] = "FACILITY_TYPE_TRACK")] = 2;
          return values;
        })();

        /**
         * HorseGender enum.
         * @name stronachgroup.first.racehorse360.HorseGender
         * @enum {string}
         * @property {number} HORSE_GENDER_INVALID=0 HORSE_GENDER_INVALID value
         * @property {number} HORSE_GENDER_FILLY=1 HORSE_GENDER_FILLY value
         * @property {number} HORSE_GENDER_COLT=2 HORSE_GENDER_COLT value
         * @property {number} HORSE_GENDER_GELDING=3 HORSE_GENDER_GELDING value
         * @property {number} HORSE_GENDER_MARE=4 HORSE_GENDER_MARE value
         * @property {number} HORSE_GENDER_HORSE=5 HORSE_GENDER_HORSE value
         * @property {number} HORSE_GENDER_SPAYED_MARE=6 HORSE_GENDER_SPAYED_MARE value
         * @property {number} HORSE_GENDER_RIDGLING=7 HORSE_GENDER_RIDGLING value
         */
        racehorse360.HorseGender = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_GENDER_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_GENDER_FILLY")] = 1;
          values[(valuesById[2] = "HORSE_GENDER_COLT")] = 2;
          values[(valuesById[3] = "HORSE_GENDER_GELDING")] = 3;
          values[(valuesById[4] = "HORSE_GENDER_MARE")] = 4;
          values[(valuesById[5] = "HORSE_GENDER_HORSE")] = 5;
          values[(valuesById[6] = "HORSE_GENDER_SPAYED_MARE")] = 6;
          values[(valuesById[7] = "HORSE_GENDER_RIDGLING")] = 7;
          return values;
        })();

        /**
         * RoleGroup enum.
         * @name stronachgroup.first.racehorse360.RoleGroup
         * @enum {string}
         * @property {number} ROLE_GROUP_INVALID=0 ROLE_GROUP_INVALID value
         * @property {number} ROLE_GROUP_TRAINERS=1 ROLE_GROUP_TRAINERS value
         * @property {number} ROLE_GROUP_VETERINARIANS=2 ROLE_GROUP_VETERINARIANS value
         */
        racehorse360.RoleGroup = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "ROLE_GROUP_INVALID")] = 0;
          values[(valuesById[1] = "ROLE_GROUP_TRAINERS")] = 1;
          values[(valuesById[2] = "ROLE_GROUP_VETERINARIANS")] = 2;
          return values;
        })();

        /**
         * RoleType enum.
         * @name stronachgroup.first.racehorse360.RoleType
         * @enum {string}
         * @property {number} ROLE_TYPE_INVALID=0 ROLE_TYPE_INVALID value
         * @property {number} ROLE_TYPE_NORMAL=1 ROLE_TYPE_NORMAL value
         * @property {number} ROLE_TYPE_FACILITY=2 ROLE_TYPE_FACILITY value
         * @property {number} ROLE_TYPE_TRAINER=3 ROLE_TYPE_TRAINER value
         */
        racehorse360.RoleType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "ROLE_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "ROLE_TYPE_NORMAL")] = 1;
          values[(valuesById[2] = "ROLE_TYPE_FACILITY")] = 2;
          values[(valuesById[3] = "ROLE_TYPE_TRAINER")] = 3;
          return values;
        })();

        /**
         * TrackCondition enum.
         * @name stronachgroup.first.racehorse360.TrackCondition
         * @enum {string}
         * @property {number} TRACK_CONDITION_INVALID=0 TRACK_CONDITION_INVALID value
         * @property {number} TRACK_CONDITION_FAST=1 TRACK_CONDITION_FAST value
         * @property {number} TRACK_CONDITION_FIRM=2 TRACK_CONDITION_FIRM value
         * @property {number} TRACK_CONDITION_FROZEN=3 TRACK_CONDITION_FROZEN value
         * @property {number} TRACK_CONDITION_GOOD=4 TRACK_CONDITION_GOOD value
         * @property {number} TRACK_CONDITION_HARD=5 TRACK_CONDITION_HARD value
         * @property {number} TRACK_CONDITION_HEAVY=6 TRACK_CONDITION_HEAVY value
         * @property {number} TRACK_CONDITION_MUDDY=7 TRACK_CONDITION_MUDDY value
         * @property {number} TRACK_CONDITION_SLOPPY=8 TRACK_CONDITION_SLOPPY value
         * @property {number} TRACK_CONDITION_SLOW=9 TRACK_CONDITION_SLOW value
         * @property {number} TRACK_CONDITION_SOFT=10 TRACK_CONDITION_SOFT value
         * @property {number} TRACK_CONDITION_WET_FAST=11 TRACK_CONDITION_WET_FAST value
         * @property {number} TRACK_CONDITION_YIELDING=12 TRACK_CONDITION_YIELDING value
         * @property {number} TRACK_CONDITION_STANDARD=13 TRACK_CONDITION_STANDARD value
         * @property {number} TRACK_CONDITION_WET=14 TRACK_CONDITION_WET value
         * @property {number} TRACK_CONDITION_DEAD=15 TRACK_CONDITION_DEAD value
         * @property {number} TRACK_CONDITION_EASY=16 TRACK_CONDITION_EASY value
         * @property {number} TRACK_CONDITION_GOOD_TO_FIRM=17 TRACK_CONDITION_GOOD_TO_FIRM value
         * @property {number} TRACK_CONDITION_GOOD_TO_SOFT=18 TRACK_CONDITION_GOOD_TO_SOFT value
         * @property {number} TRACK_CONDITION_UNKNOWN=19 TRACK_CONDITION_UNKNOWN value
         */
        racehorse360.TrackCondition = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TRACK_CONDITION_INVALID")] = 0;
          values[(valuesById[1] = "TRACK_CONDITION_FAST")] = 1;
          values[(valuesById[2] = "TRACK_CONDITION_FIRM")] = 2;
          values[(valuesById[3] = "TRACK_CONDITION_FROZEN")] = 3;
          values[(valuesById[4] = "TRACK_CONDITION_GOOD")] = 4;
          values[(valuesById[5] = "TRACK_CONDITION_HARD")] = 5;
          values[(valuesById[6] = "TRACK_CONDITION_HEAVY")] = 6;
          values[(valuesById[7] = "TRACK_CONDITION_MUDDY")] = 7;
          values[(valuesById[8] = "TRACK_CONDITION_SLOPPY")] = 8;
          values[(valuesById[9] = "TRACK_CONDITION_SLOW")] = 9;
          values[(valuesById[10] = "TRACK_CONDITION_SOFT")] = 10;
          values[(valuesById[11] = "TRACK_CONDITION_WET_FAST")] = 11;
          values[(valuesById[12] = "TRACK_CONDITION_YIELDING")] = 12;
          values[(valuesById[13] = "TRACK_CONDITION_STANDARD")] = 13;
          values[(valuesById[14] = "TRACK_CONDITION_WET")] = 14;
          values[(valuesById[15] = "TRACK_CONDITION_DEAD")] = 15;
          values[(valuesById[16] = "TRACK_CONDITION_EASY")] = 16;
          values[(valuesById[17] = "TRACK_CONDITION_GOOD_TO_FIRM")] = 17;
          values[(valuesById[18] = "TRACK_CONDITION_GOOD_TO_SOFT")] = 18;
          values[(valuesById[19] = "TRACK_CONDITION_UNKNOWN")] = 19;
          return values;
        })();

        /**
         * HorseExamStatus enum.
         * @name stronachgroup.first.racehorse360.HorseExamStatus
         * @enum {string}
         * @property {number} HORSE_EXAM_STATUS_INVALID=0 HORSE_EXAM_STATUS_INVALID value
         * @property {number} HORSE_EXAM_STATUS_REQUESTED=1 HORSE_EXAM_STATUS_REQUESTED value
         * @property {number} HORSE_EXAM_STATUS_IN_PROGRESS=2 HORSE_EXAM_STATUS_IN_PROGRESS value
         * @property {number} HORSE_EXAM_STATUS_PENDING=3 HORSE_EXAM_STATUS_PENDING value
         * @property {number} HORSE_EXAM_STATUS_COMPLETED=4 HORSE_EXAM_STATUS_COMPLETED value
         * @property {number} HORSE_EXAM_STATUS_CANCELLED=5 HORSE_EXAM_STATUS_CANCELLED value
         * @property {number} HORSE_EXAM_STATUS_ABANDONED=6 HORSE_EXAM_STATUS_ABANDONED value
         */
        racehorse360.HorseExamStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_EXAM_STATUS_REQUESTED")] = 1;
          values[(valuesById[2] = "HORSE_EXAM_STATUS_IN_PROGRESS")] = 2;
          values[(valuesById[3] = "HORSE_EXAM_STATUS_PENDING")] = 3;
          values[(valuesById[4] = "HORSE_EXAM_STATUS_COMPLETED")] = 4;
          values[(valuesById[5] = "HORSE_EXAM_STATUS_CANCELLED")] = 5;
          values[(valuesById[6] = "HORSE_EXAM_STATUS_ABANDONED")] = 6;
          return values;
        })();

        /**
         * HorseExamResult enum.
         * @name stronachgroup.first.racehorse360.HorseExamResult
         * @enum {string}
         * @property {number} HORSE_EXAM_RESULT_INVALID=0 HORSE_EXAM_RESULT_INVALID value
         * @property {number} HORSE_EXAM_RESULT_PASSED=1 HORSE_EXAM_RESULT_PASSED value
         * @property {number} HORSE_EXAM_RESULT_FAILED=2 HORSE_EXAM_RESULT_FAILED value
         */
        racehorse360.HorseExamResult = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_RESULT_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_EXAM_RESULT_PASSED")] = 1;
          values[(valuesById[2] = "HORSE_EXAM_RESULT_FAILED")] = 2;
          return values;
        })();

        /**
         * HorseExamType enum.
         * @name stronachgroup.first.racehorse360.HorseExamType
         * @enum {string}
         * @property {number} HORSE_EXAM_TYPE_INVALID=0 HORSE_EXAM_TYPE_INVALID value
         * @property {number} HORSE_EXAM_TYPE_NORMAL=1 HORSE_EXAM_TYPE_NORMAL value
         * @property {number} HORSE_EXAM_TYPE_QUICK_PASS=2 HORSE_EXAM_TYPE_QUICK_PASS value
         * @property {number} HORSE_EXAM_TYPE_FULL_EXAM=3 HORSE_EXAM_TYPE_FULL_EXAM value
         */
        racehorse360.HorseExamType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_EXAM_TYPE_NORMAL")] = 1;
          values[(valuesById[2] = "HORSE_EXAM_TYPE_QUICK_PASS")] = 2;
          values[(valuesById[3] = "HORSE_EXAM_TYPE_FULL_EXAM")] = 3;
          return values;
        })();

        /**
         * HorseExamReasonCode enum.
         * @name stronachgroup.first.racehorse360.HorseExamReasonCode
         * @enum {string}
         * @property {number} HORSE_EXAM_REASON_CODE_INVALID=0 HORSE_EXAM_REASON_CODE_INVALID value
         * @property {number} HORSE_EXAM_REASON_CODE_WORKOUT_REQUEST=1 HORSE_EXAM_REASON_CODE_WORKOUT_REQUEST value
         * @property {number} HORSE_EXAM_REASON_CODE_FLAGGED_WORKOUT=2 HORSE_EXAM_REASON_CODE_FLAGGED_WORKOUT value
         * @property {number} HORSE_EXAM_REASON_CODE_TRAINER_REQUESTED=3 HORSE_EXAM_REASON_CODE_TRAINER_REQUESTED value
         * @property {number} HORSE_EXAM_REASON_CODE_PANEL_EXAM=4 HORSE_EXAM_REASON_CODE_PANEL_EXAM value
         * @property {number} HORSE_EXAM_REASON_CODE_REGULATORY_VET=5 HORSE_EXAM_REASON_CODE_REGULATORY_VET value
         * @property {number} HORSE_EXAM_REASON_CODE_PRE_RACE=6 HORSE_EXAM_REASON_CODE_PRE_RACE value
         * @property {number} HORSE_EXAM_REASON_CODE_PRE_WORK=7 HORSE_EXAM_REASON_CODE_PRE_WORK value
         * @property {number} HORSE_EXAM_REASON_CODE_ENTRY_EXAM=8 HORSE_EXAM_REASON_CODE_ENTRY_EXAM value
         * @property {number} HORSE_EXAM_REASON_CODE_RACE_DAY_EXAM=9 HORSE_EXAM_REASON_CODE_RACE_DAY_EXAM value
         * @property {number} HORSE_EXAM_REASON_CODE_TSE_1=10 HORSE_EXAM_REASON_CODE_TSE_1 value
         * @property {number} HORSE_EXAM_REASON_CODE_TSE_2=11 HORSE_EXAM_REASON_CODE_TSE_2 value
         */
        racehorse360.HorseExamReasonCode = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_REASON_CODE_INVALID")] = 0;
          values[
            (valuesById[1] = "HORSE_EXAM_REASON_CODE_WORKOUT_REQUEST")
          ] = 1;
          values[
            (valuesById[2] = "HORSE_EXAM_REASON_CODE_FLAGGED_WORKOUT")
          ] = 2;
          values[
            (valuesById[3] = "HORSE_EXAM_REASON_CODE_TRAINER_REQUESTED")
          ] = 3;
          values[(valuesById[4] = "HORSE_EXAM_REASON_CODE_PANEL_EXAM")] = 4;
          values[(valuesById[5] = "HORSE_EXAM_REASON_CODE_REGULATORY_VET")] = 5;
          values[(valuesById[6] = "HORSE_EXAM_REASON_CODE_PRE_RACE")] = 6;
          values[(valuesById[7] = "HORSE_EXAM_REASON_CODE_PRE_WORK")] = 7;
          values[(valuesById[8] = "HORSE_EXAM_REASON_CODE_ENTRY_EXAM")] = 8;
          values[(valuesById[9] = "HORSE_EXAM_REASON_CODE_RACE_DAY_EXAM")] = 9;
          values[(valuesById[10] = "HORSE_EXAM_REASON_CODE_TSE_1")] = 10;
          values[(valuesById[11] = "HORSE_EXAM_REASON_CODE_TSE_2")] = 11;
          return values;
        })();

        /**
         * WorkoutType enum.
         * @name stronachgroup.first.racehorse360.WorkoutType
         * @enum {string}
         * @property {number} WORKOUT_TYPE_INVALID=0 WORKOUT_TYPE_INVALID value
         * @property {number} WORKOUT_TYPE_BREEZING=1 WORKOUT_TYPE_BREEZING value
         * @property {number} WORKOUT_TYPE_DRIVING=2 WORKOUT_TYPE_DRIVING value
         * @property {number} WORKOUT_TYPE_HANDILY=3 WORKOUT_TYPE_HANDILY value
         */
        racehorse360.WorkoutType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORKOUT_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "WORKOUT_TYPE_BREEZING")] = 1;
          values[(valuesById[2] = "WORKOUT_TYPE_DRIVING")] = 2;
          values[(valuesById[3] = "WORKOUT_TYPE_HANDILY")] = 3;
          return values;
        })();

        /**
         * WorkoutRequestStatus enum.
         * @name stronachgroup.first.racehorse360.WorkoutRequestStatus
         * @enum {string}
         * @property {number} WORKOUT_REQUEST_STATUS_INVALID=0 WORKOUT_REQUEST_STATUS_INVALID value
         * @property {number} WORKOUT_REQUEST_STATUS_REQUESTED=1 WORKOUT_REQUEST_STATUS_REQUESTED value
         * @property {number} WORKOUT_REQUEST_STATUS_EXAM_PENDING=2 WORKOUT_REQUEST_STATUS_EXAM_PENDING value
         * @property {number} WORKOUT_REQUEST_STATUS_APPROVED=3 WORKOUT_REQUEST_STATUS_APPROVED value
         * @property {number} WORKOUT_REQUEST_STATUS_DENIED=4 WORKOUT_REQUEST_STATUS_DENIED value
         * @property {number} WORKOUT_REQUEST_STATUS_CANCELLED=5 WORKOUT_REQUEST_STATUS_CANCELLED value
         * @property {number} WORKOUT_REQUEST_STATUS_REJECTED=6 WORKOUT_REQUEST_STATUS_REJECTED value
         */
        racehorse360.WorkoutRequestStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORKOUT_REQUEST_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "WORKOUT_REQUEST_STATUS_REQUESTED")] = 1;
          values[(valuesById[2] = "WORKOUT_REQUEST_STATUS_EXAM_PENDING")] = 2;
          values[(valuesById[3] = "WORKOUT_REQUEST_STATUS_APPROVED")] = 3;
          values[(valuesById[4] = "WORKOUT_REQUEST_STATUS_DENIED")] = 4;
          values[(valuesById[5] = "WORKOUT_REQUEST_STATUS_CANCELLED")] = 5;
          values[(valuesById[6] = "WORKOUT_REQUEST_STATUS_REJECTED")] = 6;
          return values;
        })();

        /**
         * WorkOrderStatus enum.
         * @name stronachgroup.first.racehorse360.WorkOrderStatus
         * @enum {string}
         * @property {number} WORK_ORDER_STATUS_INVALID=0 WORK_ORDER_STATUS_INVALID value
         * @property {number} WORK_ORDER_STATUS_OPEN=1 WORK_ORDER_STATUS_OPEN value
         * @property {number} WORK_ORDER_STATUS_ASSIGNED=2 WORK_ORDER_STATUS_ASSIGNED value
         * @property {number} WORK_ORDER_STATUS_COMPLETE=3 WORK_ORDER_STATUS_COMPLETE value
         * @property {number} WORK_ORDER_STATUS_CLOSED=4 WORK_ORDER_STATUS_CLOSED value
         * @property {number} WORK_ORDER_STATUS_CANCELED=5 WORK_ORDER_STATUS_CANCELED value
         */
        racehorse360.WorkOrderStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORK_ORDER_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "WORK_ORDER_STATUS_OPEN")] = 1;
          values[(valuesById[2] = "WORK_ORDER_STATUS_ASSIGNED")] = 2;
          values[(valuesById[3] = "WORK_ORDER_STATUS_COMPLETE")] = 3;
          values[(valuesById[4] = "WORK_ORDER_STATUS_CLOSED")] = 4;
          values[(valuesById[5] = "WORK_ORDER_STATUS_CANCELED")] = 5;
          return values;
        })();

        /**
         * WorkOrderReasonToClose enum.
         * @name stronachgroup.first.racehorse360.WorkOrderReasonToClose
         * @enum {string}
         * @property {number} WORK_ORDER_REASON_TO_CLOSE_INVALID=0 WORK_ORDER_REASON_TO_CLOSE_INVALID value
         * @property {number} WORK_ORDER_REASON_TO_CLOSE_WORK_COMPLETED=1 WORK_ORDER_REASON_TO_CLOSE_WORK_COMPLETED value
         * @property {number} WORK_ORDER_REASON_TO_CLOSE_DUPLICATE_WORK_ORDER=2 WORK_ORDER_REASON_TO_CLOSE_DUPLICATE_WORK_ORDER value
         * @property {number} WORK_ORDER_REASON_TO_CLOSE_WILL_NOT_FIX_NON_ISSUE=3 WORK_ORDER_REASON_TO_CLOSE_WILL_NOT_FIX_NON_ISSUE value
         * @property {number} WORK_ORDER_REASON_TO_CLOSE_OTHER=4 WORK_ORDER_REASON_TO_CLOSE_OTHER value
         */
        racehorse360.WorkOrderReasonToClose = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORK_ORDER_REASON_TO_CLOSE_INVALID")] = 0;
          values[
            (valuesById[1] = "WORK_ORDER_REASON_TO_CLOSE_WORK_COMPLETED")
          ] = 1;
          values[
            (valuesById[2] = "WORK_ORDER_REASON_TO_CLOSE_DUPLICATE_WORK_ORDER")
          ] = 2;
          values[
            (valuesById[3] =
              "WORK_ORDER_REASON_TO_CLOSE_WILL_NOT_FIX_NON_ISSUE")
          ] = 3;
          values[(valuesById[4] = "WORK_ORDER_REASON_TO_CLOSE_OTHER")] = 4;
          return values;
        })();

        /**
         * HealthWatchStatus enum.
         * @name stronachgroup.first.racehorse360.HealthWatchStatus
         * @enum {string}
         * @property {number} HEALTH_WATCH_STATUS_INVALID=0 HEALTH_WATCH_STATUS_INVALID value
         * @property {number} HEALTH_WATCH_STATUS_GREEN=1 HEALTH_WATCH_STATUS_GREEN value
         * @property {number} HEALTH_WATCH_STATUS_YELLOW=2 HEALTH_WATCH_STATUS_YELLOW value
         * @property {number} HEALTH_WATCH_STATUS_RED=3 HEALTH_WATCH_STATUS_RED value
         */
        racehorse360.HealthWatchStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HEALTH_WATCH_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "HEALTH_WATCH_STATUS_GREEN")] = 1;
          values[(valuesById[2] = "HEALTH_WATCH_STATUS_YELLOW")] = 2;
          values[(valuesById[3] = "HEALTH_WATCH_STATUS_RED")] = 3;
          return values;
        })();

        /**
         * UserRoleRequestStatus enum.
         * @name stronachgroup.first.racehorse360.UserRoleRequestStatus
         * @enum {string}
         * @property {number} USER_ROLE_REQUEST_STATUS_INVALID=0 USER_ROLE_REQUEST_STATUS_INVALID value
         * @property {number} USER_ROLE_REQUEST_STATUS_REQUESTED=1 USER_ROLE_REQUEST_STATUS_REQUESTED value
         * @property {number} USER_ROLE_REQUEST_STATUS_APPROVED=2 USER_ROLE_REQUEST_STATUS_APPROVED value
         * @property {number} USER_ROLE_REQUEST_STATUS_REJECTED=3 USER_ROLE_REQUEST_STATUS_REJECTED value
         */
        racehorse360.UserRoleRequestStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "USER_ROLE_REQUEST_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "USER_ROLE_REQUEST_STATUS_REQUESTED")] = 1;
          values[(valuesById[2] = "USER_ROLE_REQUEST_STATUS_APPROVED")] = 2;
          values[(valuesById[3] = "USER_ROLE_REQUEST_STATUS_REJECTED")] = 3;
          return values;
        })();

        /**
         * HorseAge enum.
         * @name stronachgroup.first.racehorse360.HorseAge
         * @enum {string}
         * @property {number} HORSE_AGE_INVALID=0 HORSE_AGE_INVALID value
         * @property {number} HORSE_AGE_TWO=1 HORSE_AGE_TWO value
         * @property {number} HORSE_AGE_THREE=2 HORSE_AGE_THREE value
         * @property {number} HORSE_AGE_THREE_PLUS=3 HORSE_AGE_THREE_PLUS value
         * @property {number} HORSE_AGE_FOUR=4 HORSE_AGE_FOUR value
         * @property {number} HORSE_AGE_FOUR_PLUS=5 HORSE_AGE_FOUR_PLUS value
         */
        racehorse360.HorseAge = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_AGE_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_AGE_TWO")] = 1;
          values[(valuesById[2] = "HORSE_AGE_THREE")] = 2;
          values[(valuesById[3] = "HORSE_AGE_THREE_PLUS")] = 3;
          values[(valuesById[4] = "HORSE_AGE_FOUR")] = 4;
          values[(valuesById[5] = "HORSE_AGE_FOUR_PLUS")] = 5;
          return values;
        })();

        /**
         * HorseStateEligibility enum.
         * @name stronachgroup.first.racehorse360.HorseStateEligibility
         * @enum {string}
         * @property {number} HORSE_STATE_ELIGIBILITY_INVALID=0 HORSE_STATE_ELIGIBILITY_INVALID value
         * @property {number} HORSE_STATE_ELIGIBILITY_CALIFORNIA=1 HORSE_STATE_ELIGIBILITY_CALIFORNIA value
         * @property {number} HORSE_STATE_ELIGIBILITY_FLORIDA=2 HORSE_STATE_ELIGIBILITY_FLORIDA value
         * @property {number} HORSE_STATE_ELIGIBILITY_MARYLAND=3 HORSE_STATE_ELIGIBILITY_MARYLAND value
         * @property {number} HORSE_STATE_ELIGIBILITY_NONE=4 HORSE_STATE_ELIGIBILITY_NONE value
         */
        racehorse360.HorseStateEligibility = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_STATE_ELIGIBILITY_INVALID")] = 0;
          values[(valuesById[1] = "HORSE_STATE_ELIGIBILITY_CALIFORNIA")] = 1;
          values[(valuesById[2] = "HORSE_STATE_ELIGIBILITY_FLORIDA")] = 2;
          values[(valuesById[3] = "HORSE_STATE_ELIGIBILITY_MARYLAND")] = 3;
          values[(valuesById[4] = "HORSE_STATE_ELIGIBILITY_NONE")] = 4;
          return values;
        })();

        /**
         * NotificationType enum.
         * @name stronachgroup.first.racehorse360.NotificationType
         * @enum {string}
         * @property {number} NOTIFICATION_TYPE_INVALID=0 NOTIFICATION_TYPE_INVALID value
         * @property {number} NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED=1 NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED value
         * @property {number} NOTIFICATION_TYPE_HORSE_EXAM_PASSED=3 NOTIFICATION_TYPE_HORSE_EXAM_PASSED value
         * @property {number} NOTIFICATION_TYPE_HORSE_EXAM_FAILED=4 NOTIFICATION_TYPE_HORSE_EXAM_FAILED value
         * @property {number} NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED=5 NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED value
         */
        racehorse360.NotificationType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "NOTIFICATION_TYPE_INVALID")] = 0;
          values[
            (valuesById[1] = "NOTIFICATION_TYPE_WORKOUT_REQUEST_COMMENT_ADDED")
          ] = 1;
          values[(valuesById[3] = "NOTIFICATION_TYPE_HORSE_EXAM_PASSED")] = 3;
          values[(valuesById[4] = "NOTIFICATION_TYPE_HORSE_EXAM_FAILED")] = 4;
          values[
            (valuesById[5] = "NOTIFICATION_TYPE_WORKOUT_REQUEST_CANCELLED")
          ] = 5;
          return values;
        })();

        /**
         * NotificationCreatorRole enum.
         * @name stronachgroup.first.racehorse360.NotificationCreatorRole
         * @enum {string}
         * @property {number} NOTIFICATION_CREATOR_ROLE_INVALID=0 NOTIFICATION_CREATOR_ROLE_INVALID value
         * @property {number} NOTIFICATION_CREATOR_ROLE_VETERINARIAN=1 NOTIFICATION_CREATOR_ROLE_VETERINARIAN value
         * @property {number} NOTIFICATION_CREATOR_ROLE_RACING_SECRETARY=2 NOTIFICATION_CREATOR_ROLE_RACING_SECRETARY value
         * @property {number} NOTIFICATION_CREATOR_ROLE_OTHER=3 NOTIFICATION_CREATOR_ROLE_OTHER value
         */
        racehorse360.NotificationCreatorRole = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "NOTIFICATION_CREATOR_ROLE_INVALID")] = 0;
          values[
            (valuesById[1] = "NOTIFICATION_CREATOR_ROLE_VETERINARIAN")
          ] = 1;
          values[
            (valuesById[2] = "NOTIFICATION_CREATOR_ROLE_RACING_SECRETARY")
          ] = 2;
          values[(valuesById[3] = "NOTIFICATION_CREATOR_ROLE_OTHER")] = 3;
          return values;
        })();

        /**
         * WorkoutRequestCommentType enum.
         * @name stronachgroup.first.racehorse360.WorkoutRequestCommentType
         * @enum {string}
         * @property {number} WORKOUT_REQUEST_COMMENT_TYPE_INVALID=0 WORKOUT_REQUEST_COMMENT_TYPE_INVALID value
         * @property {number} WORKOUT_REQUEST_COMMENT_TYPE_TRAINER_COMMUNICATION=1 WORKOUT_REQUEST_COMMENT_TYPE_TRAINER_COMMUNICATION value
         * @property {number} WORKOUT_REQUEST_COMMENT_TYPE_RACING_SECRETARY_COMMUNICATION=2 WORKOUT_REQUEST_COMMENT_TYPE_RACING_SECRETARY_COMMUNICATION value
         */
        racehorse360.WorkoutRequestCommentType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORKOUT_REQUEST_COMMENT_TYPE_INVALID")] = 0;
          values[
            (valuesById[1] =
              "WORKOUT_REQUEST_COMMENT_TYPE_TRAINER_COMMUNICATION")
          ] = 1;
          values[
            (valuesById[2] =
              "WORKOUT_REQUEST_COMMENT_TYPE_RACING_SECRETARY_COMMUNICATION")
          ] = 2;
          return values;
        })();

        /**
         * HorseExamCommentType enum.
         * @name stronachgroup.first.racehorse360.HorseExamCommentType
         * @enum {string}
         * @property {number} HORSE_EXAM_COMMENT_TYPE_INVALID=0 HORSE_EXAM_COMMENT_TYPE_INVALID value
         * @property {number} HORSE_EXAM_COMMENT_TYPE_TRAINER_COMMUNICATION=1 HORSE_EXAM_COMMENT_TYPE_TRAINER_COMMUNICATION value
         * @property {number} HORSE_EXAM_COMMENT_TYPE_VET_COMMUNICATION=2 HORSE_EXAM_COMMENT_TYPE_VET_COMMUNICATION value
         */
        racehorse360.HorseExamCommentType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_COMMENT_TYPE_INVALID")] = 0;
          values[
            (valuesById[1] = "HORSE_EXAM_COMMENT_TYPE_TRAINER_COMMUNICATION")
          ] = 1;
          values[
            (valuesById[2] = "HORSE_EXAM_COMMENT_TYPE_VET_COMMUNICATION")
          ] = 2;
          return values;
        })();

        /**
         * RaceConditionDistance enum.
         * @name stronachgroup.first.racehorse360.RaceConditionDistance
         * @enum {string}
         * @property {number} RACE_CONDITION_DISTANCE_INVALID=0 RACE_CONDITION_DISTANCE_INVALID value
         * @property {number} RACE_CONDITION_DISTANCE_SHORT=1 RACE_CONDITION_DISTANCE_SHORT value
         * @property {number} RACE_CONDITION_DISTANCE_LONG=2 RACE_CONDITION_DISTANCE_LONG value
         */
        racehorse360.RaceConditionDistance = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "RACE_CONDITION_DISTANCE_INVALID")] = 0;
          values[(valuesById[1] = "RACE_CONDITION_DISTANCE_SHORT")] = 1;
          values[(valuesById[2] = "RACE_CONDITION_DISTANCE_LONG")] = 2;
          return values;
        })();

        /**
         * RaceConditionGender enum.
         * @name stronachgroup.first.racehorse360.RaceConditionGender
         * @enum {string}
         * @property {number} RACE_CONDITION_GENDER_INVALID=0 RACE_CONDITION_GENDER_INVALID value
         * @property {number} RACE_CONDITION_GENDER_FILLIES=1 RACE_CONDITION_GENDER_FILLIES value
         * @property {number} RACE_CONDITION_GENDER_FILLIES_AND_MARES=2 RACE_CONDITION_GENDER_FILLIES_AND_MARES value
         * @property {number} RACE_CONDITION_GENDER_OPEN=3 RACE_CONDITION_GENDER_OPEN value
         * @property {number} RACE_CONDITION_GENDER_COLTS_AND_GELDINGS=4 RACE_CONDITION_GENDER_COLTS_AND_GELDINGS value
         */
        racehorse360.RaceConditionGender = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "RACE_CONDITION_GENDER_INVALID")] = 0;
          values[(valuesById[1] = "RACE_CONDITION_GENDER_FILLIES")] = 1;
          values[
            (valuesById[2] = "RACE_CONDITION_GENDER_FILLIES_AND_MARES")
          ] = 2;
          values[(valuesById[3] = "RACE_CONDITION_GENDER_OPEN")] = 3;
          values[
            (valuesById[4] = "RACE_CONDITION_GENDER_COLTS_AND_GELDINGS")
          ] = 4;
          return values;
        })();

        /**
         * RaceConditionAge enum.
         * @name stronachgroup.first.racehorse360.RaceConditionAge
         * @enum {string}
         * @property {number} RACE_CONDITION_AGE_INVALID=0 RACE_CONDITION_AGE_INVALID value
         * @property {number} RACE_CONDITION_AGE_TWO=1 RACE_CONDITION_AGE_TWO value
         * @property {number} RACE_CONDITION_AGE_THREE=2 RACE_CONDITION_AGE_THREE value
         * @property {number} RACE_CONDITION_AGE_THREE_PLUS=3 RACE_CONDITION_AGE_THREE_PLUS value
         * @property {number} RACE_CONDITION_AGE_FOUR_PLUS=4 RACE_CONDITION_AGE_FOUR_PLUS value
         * @property {number} RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS=5 RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS value
         * @property {number} RACE_CONDITION_AGE_FOUR=6 RACE_CONDITION_AGE_FOUR value
         * @property {number} RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE=7 RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE value
         * @property {number} RACE_CONDITION_AGE_FOUR_OR_FIVE=8 RACE_CONDITION_AGE_FOUR_OR_FIVE value
         * @property {number} RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX=9 RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX value
         * @property {number} RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX=10 RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX value
         */
        racehorse360.RaceConditionAge = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "RACE_CONDITION_AGE_INVALID")] = 0;
          values[(valuesById[1] = "RACE_CONDITION_AGE_TWO")] = 1;
          values[(valuesById[2] = "RACE_CONDITION_AGE_THREE")] = 2;
          values[(valuesById[3] = "RACE_CONDITION_AGE_THREE_PLUS")] = 3;
          values[(valuesById[4] = "RACE_CONDITION_AGE_FOUR_PLUS")] = 4;
          values[(valuesById[5] = "RACE_CONDITION_AGE_THREE_OR_FOUR_PLUS")] = 5;
          values[(valuesById[6] = "RACE_CONDITION_AGE_FOUR")] = 6;
          values[
            (valuesById[7] = "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE")
          ] = 7;
          values[(valuesById[8] = "RACE_CONDITION_AGE_FOUR_OR_FIVE")] = 8;
          values[
            (valuesById[9] = "RACE_CONDITION_AGE_FOUR_OR_FIVE_OR_SIX")
          ] = 9;
          values[
            (valuesById[10] = "RACE_CONDITION_AGE_THREE_OR_FOUR_OR_FIVE_OR_SIX")
          ] = 10;
          return values;
        })();

        /**
         * RaceConditionRestriction enum.
         * @name stronachgroup.first.racehorse360.RaceConditionRestriction
         * @enum {string}
         * @property {number} RACE_CONDITION_RESTRICTION_INVALID=0 RACE_CONDITION_RESTRICTION_INVALID value
         * @property {number} RACE_CONDITION_RESTRICTION_NO_RESTRICTION=1 RACE_CONDITION_RESTRICTION_NO_RESTRICTION value
         * @property {number} RACE_CONDITION_RESTRICTION_STATE_BRED_OR_SIRED=2 RACE_CONDITION_RESTRICTION_STATE_BRED_OR_SIRED value
         * @property {number} RACE_CONDITION_RESTRICTION_OTHER=3 RACE_CONDITION_RESTRICTION_OTHER value
         */
        racehorse360.RaceConditionRestriction = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "RACE_CONDITION_RESTRICTION_INVALID")] = 0;
          values[
            (valuesById[1] = "RACE_CONDITION_RESTRICTION_NO_RESTRICTION")
          ] = 1;
          values[
            (valuesById[2] = "RACE_CONDITION_RESTRICTION_STATE_BRED_OR_SIRED")
          ] = 2;
          values[(valuesById[3] = "RACE_CONDITION_RESTRICTION_OTHER")] = 3;
          return values;
        })();

        /**
         * InjuryType enum.
         * @name stronachgroup.first.racehorse360.InjuryType
         * @enum {string}
         * @property {number} INJURY_TYPE_INVALID=0 INJURY_TYPE_INVALID value
         * @property {number} INJURY_TYPE_RACING=1 INJURY_TYPE_RACING value
         * @property {number} INJURY_TYPE_WORKOUT=2 INJURY_TYPE_WORKOUT value
         * @property {number} INJURY_TYPE_OTHER=3 INJURY_TYPE_OTHER value
         */
        racehorse360.InjuryType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "INJURY_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "INJURY_TYPE_RACING")] = 1;
          values[(valuesById[2] = "INJURY_TYPE_WORKOUT")] = 2;
          values[(valuesById[3] = "INJURY_TYPE_OTHER")] = 3;
          return values;
        })();

        /**
         * FacilityBlackoutRepeatance enum.
         * @name stronachgroup.first.racehorse360.FacilityBlackoutRepeatance
         * @enum {string}
         * @property {number} FACILITY_BLACKOUT_REPEATANCE_INVALID=0 FACILITY_BLACKOUT_REPEATANCE_INVALID value
         * @property {number} FACILITY_BLACKOUT_REPEATANCE_DOES_NOT_REPEAT=1 FACILITY_BLACKOUT_REPEATANCE_DOES_NOT_REPEAT value
         * @property {number} FACILITY_BLACKOUT_REPEATANCE_WEEKLY=2 FACILITY_BLACKOUT_REPEATANCE_WEEKLY value
         */
        racehorse360.FacilityBlackoutRepeatance = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "FACILITY_BLACKOUT_REPEATANCE_INVALID")] = 0;
          values[
            (valuesById[1] = "FACILITY_BLACKOUT_REPEATANCE_DOES_NOT_REPEAT")
          ] = 1;
          values[(valuesById[2] = "FACILITY_BLACKOUT_REPEATANCE_WEEKLY")] = 2;
          return values;
        })();

        /**
         * ApplicationFeatureKey enum.
         * @name stronachgroup.first.racehorse360.ApplicationFeatureKey
         * @enum {string}
         * @property {number} APPLICATION_FEATURE_KEY_INVALID=0 APPLICATION_FEATURE_KEY_INVALID value
         * @property {number} APPLICATION_FEATURE_KEY_STALL_APPLICATION_FORMS=1 APPLICATION_FEATURE_KEY_STALL_APPLICATION_FORMS value
         * @property {number} APPLICATION_FEATURE_KEY_WORK_ORDERS=2 APPLICATION_FEATURE_KEY_WORK_ORDERS value
         * @property {number} APPLICATION_FEATURE_KEY_INVENTORY_ANALYTICS=3 APPLICATION_FEATURE_KEY_INVENTORY_ANALYTICS value
         * @property {number} APPLICATION_FEATURE_KEY_TRAINER_WORKOUT_REQUESTS=4 APPLICATION_FEATURE_KEY_TRAINER_WORKOUT_REQUESTS value
         * @property {number} APPLICATION_FEATURE_KEY_VET_WORKOUT_REQUESTS=5 APPLICATION_FEATURE_KEY_VET_WORKOUT_REQUESTS value
         * @property {number} APPLICATION_FEATURE_KEY_TRACK_OPTICS=6 APPLICATION_FEATURE_KEY_TRACK_OPTICS value
         * @property {number} APPLICATION_FEATURE_KEY_DASHBOARD_EXAM_REQUIREMENTS=7 APPLICATION_FEATURE_KEY_DASHBOARD_EXAM_REQUIREMENTS value
         */
        racehorse360.ApplicationFeatureKey = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "APPLICATION_FEATURE_KEY_INVALID")] = 0;
          values[
            (valuesById[1] = "APPLICATION_FEATURE_KEY_STALL_APPLICATION_FORMS")
          ] = 1;
          values[(valuesById[2] = "APPLICATION_FEATURE_KEY_WORK_ORDERS")] = 2;
          values[
            (valuesById[3] = "APPLICATION_FEATURE_KEY_INVENTORY_ANALYTICS")
          ] = 3;
          values[
            (valuesById[4] = "APPLICATION_FEATURE_KEY_TRAINER_WORKOUT_REQUESTS")
          ] = 4;
          values[
            (valuesById[5] = "APPLICATION_FEATURE_KEY_VET_WORKOUT_REQUESTS")
          ] = 5;
          values[(valuesById[6] = "APPLICATION_FEATURE_KEY_TRACK_OPTICS")] = 6;
          values[
            (valuesById[7] =
              "APPLICATION_FEATURE_KEY_DASHBOARD_EXAM_REQUIREMENTS")
          ] = 7;
          return values;
        })();

        /**
         * EventType enum.
         * @name stronachgroup.first.racehorse360.EventType
         * @enum {string}
         * @property {number} EVENT_TYPE_INVALID=0 EVENT_TYPE_INVALID value
         * @property {number} EVENT_TYPE_WORKOUT_REQUEST=1 EVENT_TYPE_WORKOUT_REQUEST value
         * @property {number} EVENT_TYPE_HORSE_EXAM=2 EVENT_TYPE_HORSE_EXAM value
         * @property {number} EVENT_TYPE_HORSE_GENERAL_VET_COMMENT=3 EVENT_TYPE_HORSE_GENERAL_VET_COMMENT value
         * @property {number} EVENT_TYPE_HORSE_FLAG_ON_TRACK=4 EVENT_TYPE_HORSE_FLAG_ON_TRACK value
         */
        racehorse360.EventType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "EVENT_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "EVENT_TYPE_WORKOUT_REQUEST")] = 1;
          values[(valuesById[2] = "EVENT_TYPE_HORSE_EXAM")] = 2;
          values[(valuesById[3] = "EVENT_TYPE_HORSE_GENERAL_VET_COMMENT")] = 3;
          values[(valuesById[4] = "EVENT_TYPE_HORSE_FLAG_ON_TRACK")] = 4;
          return values;
        })();

        /**
         * CommentSourceKind enum.
         * @name stronachgroup.first.racehorse360.CommentSourceKind
         * @enum {string}
         * @property {number} COMMENT_SOURCE_KIND_INVALID=0 COMMENT_SOURCE_KIND_INVALID value
         * @property {number} COMMENT_SOURCE_KIND_HORSE_GENERAL_VET_COMMENT=1 COMMENT_SOURCE_KIND_HORSE_GENERAL_VET_COMMENT value
         * @property {number} COMMENT_SOURCE_KIND_HORSE_EXAM_COMMENT=2 COMMENT_SOURCE_KIND_HORSE_EXAM_COMMENT value
         * @property {number} COMMENT_SOURCE_KIND_WORKOUT_REQUEST_COMMENT=3 COMMENT_SOURCE_KIND_WORKOUT_REQUEST_COMMENT value
         * @property {number} COMMENT_SOURCE_KIND_HORSE_FLAG_ON_TRACK=4 COMMENT_SOURCE_KIND_HORSE_FLAG_ON_TRACK value
         */
        racehorse360.CommentSourceKind = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "COMMENT_SOURCE_KIND_INVALID")] = 0;
          values[
            (valuesById[1] = "COMMENT_SOURCE_KIND_HORSE_GENERAL_VET_COMMENT")
          ] = 1;
          values[
            (valuesById[2] = "COMMENT_SOURCE_KIND_HORSE_EXAM_COMMENT")
          ] = 2;
          values[
            (valuesById[3] = "COMMENT_SOURCE_KIND_WORKOUT_REQUEST_COMMENT")
          ] = 3;
          values[
            (valuesById[4] = "COMMENT_SOURCE_KIND_HORSE_FLAG_ON_TRACK")
          ] = 4;
          return values;
        })();

        /**
         * HorseAggregatedCommentIconType enum.
         * @name stronachgroup.first.racehorse360.HorseAggregatedCommentIconType
         * @enum {string}
         * @property {number} HORSE_AGGREGATED_COMMENT_ICON_TYPE_INVALID=0 HORSE_AGGREGATED_COMMENT_ICON_TYPE_INVALID value
         * @property {number} HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL=1 HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL value
         * @property {number} HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN=2 HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN value
         * @property {number} HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER=3 HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER value
         */
        racehorse360.HorseAggregatedCommentIconType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[
            (valuesById[0] = "HORSE_AGGREGATED_COMMENT_ICON_TYPE_INVALID")
          ] = 0;
          values[
            (valuesById[1] = "HORSE_AGGREGATED_COMMENT_ICON_TYPE_GENERAL")
          ] = 1;
          values[
            (valuesById[2] = "HORSE_AGGREGATED_COMMENT_ICON_TYPE_VETERINARIAN")
          ] = 2;
          values[
            (valuesById[3] = "HORSE_AGGREGATED_COMMENT_ICON_TYPE_TRAINER")
          ] = 3;
          return values;
        })();

        /**
         * MedicineType enum.
         * @name stronachgroup.first.racehorse360.MedicineType
         * @enum {string}
         * @property {number} MEDICINE_TYPE_INVALID=0 MEDICINE_TYPE_INVALID value
         * @property {number} MEDICINE_TYPE_VACCINE=1 MEDICINE_TYPE_VACCINE value
         * @property {number} MEDICINE_TYPE_BOOSTER=2 MEDICINE_TYPE_BOOSTER value
         */
        racehorse360.MedicineType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "MEDICINE_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "MEDICINE_TYPE_VACCINE")] = 1;
          values[(valuesById[2] = "MEDICINE_TYPE_BOOSTER")] = 2;
          return values;
        })();

        /**
         * InjectionDataSource enum.
         * @name stronachgroup.first.racehorse360.InjectionDataSource
         * @enum {string}
         * @property {number} INJECTION_DATA_SOURCE_INVALID=0 INJECTION_DATA_SOURCE_INVALID value
         * @property {number} INJECTION_DATA_SOURCE_RH360=1 INJECTION_DATA_SOURCE_RH360 value
         * @property {number} INJECTION_DATA_SOURCE_INCOMPASS=2 INJECTION_DATA_SOURCE_INCOMPASS value
         */
        racehorse360.InjectionDataSource = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "INJECTION_DATA_SOURCE_INVALID")] = 0;
          values[(valuesById[1] = "INJECTION_DATA_SOURCE_RH360")] = 1;
          values[(valuesById[2] = "INJECTION_DATA_SOURCE_INCOMPASS")] = 2;
          return values;
        })();

        /**
         * HorseDetailPageDataColumn enum.
         * @name stronachgroup.first.racehorse360.HorseDetailPageDataColumn
         * @enum {string}
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_INVALID=0 HORSE_DETAIL_PAGE_DATA_COLUMN_INVALID value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_LEVEL=1 HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_LEVEL value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_HIGH_SPEED_FURLONGS=2 HORSE_DETAIL_PAGE_DATA_COLUMN_HIGH_SPEED_FURLONGS value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTORS=3 HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTORS value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_VET_LIST=4 HORSE_DETAIL_PAGE_DATA_COLUMN_VET_LIST value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_AGE_SEX_COLOR=5 HORSE_DETAIL_PAGE_DATA_COLUMN_AGE_SEX_COLOR value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_BARN_STALL=6 HORSE_DETAIL_PAGE_DATA_COLUMN_BARN_STALL value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_RACE=7 HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_RACE value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_WORK=8 HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_WORK value
         * @property {number} HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTOR_SCORE=9 HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTOR_SCORE value
         */
        racehorse360.HorseDetailPageDataColumn = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_DETAIL_PAGE_DATA_COLUMN_INVALID")] = 0;
          values[
            (valuesById[1] = "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_LEVEL")
          ] = 1;
          values[
            (valuesById[2] =
              "HORSE_DETAIL_PAGE_DATA_COLUMN_HIGH_SPEED_FURLONGS")
          ] = 2;
          values[
            (valuesById[3] = "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTORS")
          ] = 3;
          values[
            (valuesById[4] = "HORSE_DETAIL_PAGE_DATA_COLUMN_VET_LIST")
          ] = 4;
          values[
            (valuesById[5] = "HORSE_DETAIL_PAGE_DATA_COLUMN_AGE_SEX_COLOR")
          ] = 5;
          values[
            (valuesById[6] = "HORSE_DETAIL_PAGE_DATA_COLUMN_BARN_STALL")
          ] = 6;
          values[
            (valuesById[7] = "HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_RACE")
          ] = 7;
          values[
            (valuesById[8] = "HORSE_DETAIL_PAGE_DATA_COLUMN_DAYS_LAST_WORK")
          ] = 8;
          values[
            (valuesById[9] = "HORSE_DETAIL_PAGE_DATA_COLUMN_RISK_FACTOR_SCORE")
          ] = 9;
          return values;
        })();

        /**
         * LockerPageType enum.
         * @name stronachgroup.first.racehorse360.LockerPageType
         * @enum {string}
         * @property {number} LOCKER_PAGE_TYPE_INVALID=0 LOCKER_PAGE_TYPE_INVALID value
         * @property {number} LOCKER_PAGE_TYPE_HORSE_EXAM_PAGE=1 LOCKER_PAGE_TYPE_HORSE_EXAM_PAGE value
         */
        racehorse360.LockerPageType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "LOCKER_PAGE_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "LOCKER_PAGE_TYPE_HORSE_EXAM_PAGE")] = 1;
          return values;
        })();

        /**
         * StallApplicationStatus enum.
         * @name stronachgroup.first.racehorse360.StallApplicationStatus
         * @enum {string}
         * @property {number} STALL_APPLICATION_STATUS_INVALID=0 STALL_APPLICATION_STATUS_INVALID value
         * @property {number} STALL_APPLICATION_STATUS_IN_PROGRESS=1 STALL_APPLICATION_STATUS_IN_PROGRESS value
         * @property {number} STALL_APPLICATION_STATUS_APPLIED=2 STALL_APPLICATION_STATUS_APPLIED value
         * @property {number} STALL_APPLICATION_STATUS_UNDER_REVIEW=3 STALL_APPLICATION_STATUS_UNDER_REVIEW value
         * @property {number} STALL_APPLICATION_STATUS_COMPLETE=4 STALL_APPLICATION_STATUS_COMPLETE value
         * @property {number} STALL_APPLICATION_STATUS_CANCELLED=5 STALL_APPLICATION_STATUS_CANCELLED value
         */
        racehorse360.StallApplicationStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "STALL_APPLICATION_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "STALL_APPLICATION_STATUS_IN_PROGRESS")] = 1;
          values[(valuesById[2] = "STALL_APPLICATION_STATUS_APPLIED")] = 2;
          values[(valuesById[3] = "STALL_APPLICATION_STATUS_UNDER_REVIEW")] = 3;
          values[(valuesById[4] = "STALL_APPLICATION_STATUS_COMPLETE")] = 4;
          values[(valuesById[5] = "STALL_APPLICATION_STATUS_CANCELLED")] = 5;
          return values;
        })();

        /**
         * WorkoutRequestFlagPriority enum.
         * @name stronachgroup.first.racehorse360.WorkoutRequestFlagPriority
         * @enum {string}
         * @property {number} WORKOUT_REQUEST_FLAG_PRIORITY_INVALID=0 WORKOUT_REQUEST_FLAG_PRIORITY_INVALID value
         * @property {number} WORKOUT_REQUEST_FLAG_PRIORITY_LOWER=1 WORKOUT_REQUEST_FLAG_PRIORITY_LOWER value
         * @property {number} WORKOUT_REQUEST_FLAG_PRIORITY_MEDIUM=2 WORKOUT_REQUEST_FLAG_PRIORITY_MEDIUM value
         * @property {number} WORKOUT_REQUEST_FLAG_PRIORITY_HIGHEST=3 WORKOUT_REQUEST_FLAG_PRIORITY_HIGHEST value
         */
        racehorse360.WorkoutRequestFlagPriority = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "WORKOUT_REQUEST_FLAG_PRIORITY_INVALID")] = 0;
          values[(valuesById[1] = "WORKOUT_REQUEST_FLAG_PRIORITY_LOWER")] = 1;
          values[(valuesById[2] = "WORKOUT_REQUEST_FLAG_PRIORITY_MEDIUM")] = 2;
          values[(valuesById[3] = "WORKOUT_REQUEST_FLAG_PRIORITY_HIGHEST")] = 3;
          return values;
        })();

        /**
         * RaceClass enum.
         * @name stronachgroup.first.racehorse360.RaceClass
         * @enum {string}
         * @property {number} RACE_CLASS_INVALID=0 RACE_CLASS_INVALID value
         * @property {number} RACE_CLASS_STAKES=1 RACE_CLASS_STAKES value
         * @property {number} RACE_CLASS_ALLOWANCE=2 RACE_CLASS_ALLOWANCE value
         * @property {number} RACE_CLASS_STARTER=3 RACE_CLASS_STARTER value
         * @property {number} RACE_CLASS_OPEN_CLAMING=4 RACE_CLASS_OPEN_CLAMING value
         * @property {number} RACE_CLASS_CLAMING_CONDITION=5 RACE_CLASS_CLAMING_CONDITION value
         * @property {number} RACE_CLASS_MAIDEN=6 RACE_CLASS_MAIDEN value
         * @property {number} RACE_CLASS_NO_STARTS=7 RACE_CLASS_NO_STARTS value
         */
        racehorse360.RaceClass = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "RACE_CLASS_INVALID")] = 0;
          values[(valuesById[1] = "RACE_CLASS_STAKES")] = 1;
          values[(valuesById[2] = "RACE_CLASS_ALLOWANCE")] = 2;
          values[(valuesById[3] = "RACE_CLASS_STARTER")] = 3;
          values[(valuesById[4] = "RACE_CLASS_OPEN_CLAMING")] = 4;
          values[(valuesById[5] = "RACE_CLASS_CLAMING_CONDITION")] = 5;
          values[(valuesById[6] = "RACE_CLASS_MAIDEN")] = 6;
          values[(valuesById[7] = "RACE_CLASS_NO_STARTS")] = 7;
          return values;
        })();

        /**
         * StableEntryStatus enum.
         * @name stronachgroup.first.racehorse360.StableEntryStatus
         * @enum {string}
         * @property {number} STABLE_ENTRY_STATUS_INVALID=0 STABLE_ENTRY_STATUS_INVALID value
         * @property {number} STABLE_ENTRY_STATUS_AWAITING=1 STABLE_ENTRY_STATUS_AWAITING value
         * @property {number} STABLE_ENTRY_STATUS_APPROVED=2 STABLE_ENTRY_STATUS_APPROVED value
         * @property {number} STABLE_ENTRY_STATUS_DENIED=3 STABLE_ENTRY_STATUS_DENIED value
         */
        racehorse360.StableEntryStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "STABLE_ENTRY_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "STABLE_ENTRY_STATUS_AWAITING")] = 1;
          values[(valuesById[2] = "STABLE_ENTRY_STATUS_APPROVED")] = 2;
          values[(valuesById[3] = "STABLE_ENTRY_STATUS_DENIED")] = 3;
          return values;
        })();

        /**
         * TrackOpticsVideoStatus enum.
         * @name stronachgroup.first.racehorse360.TrackOpticsVideoStatus
         * @enum {string}
         * @property {number} TRACK_OPTICS_VIDEO_STATUS_INVALID=0 TRACK_OPTICS_VIDEO_STATUS_INVALID value
         * @property {number} TRACK_OPTICS_VIDEO_STATUS_IN_PROGRESS=1 TRACK_OPTICS_VIDEO_STATUS_IN_PROGRESS value
         * @property {number} TRACK_OPTICS_VIDEO_STATUS_REVIEWED=2 TRACK_OPTICS_VIDEO_STATUS_REVIEWED value
         */
        racehorse360.TrackOpticsVideoStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TRACK_OPTICS_VIDEO_STATUS_INVALID")] = 0;
          values[(valuesById[1] = "TRACK_OPTICS_VIDEO_STATUS_IN_PROGRESS")] = 1;
          values[(valuesById[2] = "TRACK_OPTICS_VIDEO_STATUS_REVIEWED")] = 2;
          return values;
        })();

        /**
         * TrackOpticsVideoType enum.
         * @name stronachgroup.first.racehorse360.TrackOpticsVideoType
         * @enum {string}
         * @property {number} TRACK_OPTICS_VIDEO_TYPE_INVALID=0 TRACK_OPTICS_VIDEO_TYPE_INVALID value
         * @property {number} TRACK_OPTICS_VIDEO_TYPE_STANDARD=1 TRACK_OPTICS_VIDEO_TYPE_STANDARD value
         * @property {number} TRACK_OPTICS_VIDEO_TYPE_DETECTIONS=2 TRACK_OPTICS_VIDEO_TYPE_DETECTIONS value
         */
        racehorse360.TrackOpticsVideoType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "TRACK_OPTICS_VIDEO_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "TRACK_OPTICS_VIDEO_TYPE_STANDARD")] = 1;
          values[(valuesById[2] = "TRACK_OPTICS_VIDEO_TYPE_DETECTIONS")] = 2;
          return values;
        })();

        /**
         * UpcomingRaceEntryStatus enum.
         * @name stronachgroup.first.racehorse360.UpcomingRaceEntryStatus
         * @enum {string}
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_INVALID=0 UPCOMING_RACE_ENTRY_STATUS_INVALID value
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED=1 UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED value
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING=2 UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING value
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED=3 UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED value
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING=4 UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING value
         * @property {number} UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED=5 UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED value
         */
        racehorse360.UpcomingRaceEntryStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "UPCOMING_RACE_ENTRY_STATUS_INVALID")] = 0;
          values[
            (valuesById[1] = "UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED")
          ] = 1;
          values[
            (valuesById[2] = "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING")
          ] = 2;
          values[
            (valuesById[3] = "UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED")
          ] = 3;
          values[
            (valuesById[4] = "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING")
          ] = 4;
          values[
            (valuesById[5] =
              "UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED")
          ] = 5;
          return values;
        })();

        /**
         * UpcomingRaceEntryFlagPriority enum.
         * @name stronachgroup.first.racehorse360.UpcomingRaceEntryFlagPriority
         * @enum {string}
         * @property {number} UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID=0 UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID value
         * @property {number} UPCOMING_RACE_ENTRY_FLAG_PRIORITY_LOWER=1 UPCOMING_RACE_ENTRY_FLAG_PRIORITY_LOWER value
         * @property {number} UPCOMING_RACE_ENTRY_FLAG_PRIORITY_MEDIUM=2 UPCOMING_RACE_ENTRY_FLAG_PRIORITY_MEDIUM value
         * @property {number} UPCOMING_RACE_ENTRY_FLAG_PRIORITY_HIGHEST=3 UPCOMING_RACE_ENTRY_FLAG_PRIORITY_HIGHEST value
         */
        racehorse360.UpcomingRaceEntryFlagPriority = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[
            (valuesById[0] = "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_INVALID")
          ] = 0;
          values[
            (valuesById[1] = "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_LOWER")
          ] = 1;
          values[
            (valuesById[2] = "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_MEDIUM")
          ] = 2;
          values[
            (valuesById[3] = "UPCOMING_RACE_ENTRY_FLAG_PRIORITY_HIGHEST")
          ] = 3;
          return values;
        })();

        /**
         * HorseExamRequirementTypeCode enum.
         * @name stronachgroup.first.racehorse360.HorseExamRequirementTypeCode
         * @enum {string}
         * @property {number} HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID=0 HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID value
         * @property {number} HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM=1 HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM value
         * @property {number} HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA=2 HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA value
         * @property {number} HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1=3 HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1 value
         * @property {number} HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2=4 HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2 value
         */
        racehorse360.HorseExamRequirementTypeCode = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[
            (valuesById[0] = "HORSE_EXAM_REQUIREMENT_TYPE_CODE_INVALID")
          ] = 0;
          values[
            (valuesById[1] = "HORSE_EXAM_REQUIREMENT_TYPE_CODE_ENTRY_EXAM")
          ] = 1;
          values[(valuesById[2] = "HORSE_EXAM_REQUIREMENT_TYPE_CODE_HISA")] = 2;
          values[(valuesById[3] = "HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE1")] = 3;
          values[(valuesById[4] = "HORSE_EXAM_REQUIREMENT_TYPE_CODE_TSE2")] = 4;
          return values;
        })();

        /**
         * HorseExamRequirementStatus enum.
         * @name stronachgroup.first.racehorse360.HorseExamRequirementStatus
         * @enum {string}
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_INVALID=0 HORSE_EXAM_REQUIREMENT_STATUS_INVALID value
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_EXAM_REQUIRED=1 HORSE_EXAM_REQUIREMENT_STATUS_EXAM_REQUIRED value
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM=2 HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM value
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_EXAM_COMPLETED=3 HORSE_EXAM_REQUIREMENT_STATUS_EXAM_COMPLETED value
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_VOIDED=4 HORSE_EXAM_REQUIREMENT_STATUS_VOIDED value
         * @property {number} HORSE_EXAM_REQUIREMENT_STATUS_EXAM_EXPIRING=5 HORSE_EXAM_REQUIREMENT_STATUS_EXAM_EXPIRING value
         */
        racehorse360.HorseExamRequirementStatus = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HORSE_EXAM_REQUIREMENT_STATUS_INVALID")] = 0;
          values[
            (valuesById[1] = "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_REQUIRED")
          ] = 1;
          values[
            (valuesById[2] = "HORSE_EXAM_REQUIREMENT_STATUS_READY_FOR_EXAM")
          ] = 2;
          values[
            (valuesById[3] = "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_COMPLETED")
          ] = 3;
          values[(valuesById[4] = "HORSE_EXAM_REQUIREMENT_STATUS_VOIDED")] = 4;
          values[
            (valuesById[5] = "HORSE_EXAM_REQUIREMENT_STATUS_EXAM_EXPIRING")
          ] = 5;
          return values;
        })();

        /**
         * FacilityScope enum.
         * @name stronachgroup.first.racehorse360.FacilityScope
         * @enum {string}
         * @property {number} FACILITY_SCOPE_INVALID=0 FACILITY_SCOPE_INVALID value
         * @property {number} FACILITY_SCOPE_TSG=1 FACILITY_SCOPE_TSG value
         * @property {number} FACILITY_SCOPE_DEL_MAR=2 FACILITY_SCOPE_DEL_MAR value
         * @property {number} FACILITY_SCOPE_OTHER=3 FACILITY_SCOPE_OTHER value
         */
        racehorse360.FacilityScope = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "FACILITY_SCOPE_INVALID")] = 0;
          values[(valuesById[1] = "FACILITY_SCOPE_TSG")] = 1;
          values[(valuesById[2] = "FACILITY_SCOPE_DEL_MAR")] = 2;
          values[(valuesById[3] = "FACILITY_SCOPE_OTHER")] = 3;
          return values;
        })();

        racehorse360.FacilityBlackoutService = (function () {
          /**
           * Constructs a new FacilityBlackoutService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FacilityBlackoutService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function FacilityBlackoutService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (FacilityBlackoutService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = FacilityBlackoutService;

          /**
           * Creates new FacilityBlackoutService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {FacilityBlackoutService} RPC service. Useful where requests and/or responses are streamed.
           */
          FacilityBlackoutService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityBlackoutService#createFacilityBlackout}.
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @typedef CreateFacilityBlackoutCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.FacilityBlackout} [response] FacilityBlackout
           */

          /**
           * Calls CreateFacilityBlackout.
           * @function createFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateFacilityBlackoutRequest} request CreateFacilityBlackoutRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutService.CreateFacilityBlackoutCallback} callback Node-style callback called with the error, if any, and FacilityBlackout
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityBlackoutService.prototype.createFacilityBlackout =
              function createFacilityBlackout(request, callback) {
                return this.rpcCall(
                  createFacilityBlackout,
                  $root.stronachgroup.first.racehorse360
                    .CreateFacilityBlackoutRequest,
                  $root.stronachgroup.first.racehorse360.FacilityBlackout,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateFacilityBlackout" }
          );

          /**
           * Calls CreateFacilityBlackout.
           * @function createFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateFacilityBlackoutRequest} request CreateFacilityBlackoutRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.FacilityBlackout>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityBlackoutService#pullFacilityBlackouts}.
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @typedef PullFacilityBlackoutsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse} [response] PullFacilityBlackoutsResponse
           */

          /**
           * Calls PullFacilityBlackouts.
           * @function pullFacilityBlackouts
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsRequest} request PullFacilityBlackoutsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutService.PullFacilityBlackoutsCallback} callback Node-style callback called with the error, if any, and PullFacilityBlackoutsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityBlackoutService.prototype.pullFacilityBlackouts =
              function pullFacilityBlackouts(request, callback) {
                return this.rpcCall(
                  pullFacilityBlackouts,
                  $root.stronachgroup.first.racehorse360
                    .PullFacilityBlackoutsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullFacilityBlackoutsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullFacilityBlackouts" }
          );

          /**
           * Calls PullFacilityBlackouts.
           * @function pullFacilityBlackouts
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullFacilityBlackoutsRequest} request PullFacilityBlackoutsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityBlackoutService#cancelFacilityBlackout}.
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @typedef CancelFacilityBlackoutCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.FacilityBlackout} [response] FacilityBlackout
           */

          /**
           * Calls CancelFacilityBlackout.
           * @function cancelFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelFacilityBlackoutRequest} request CancelFacilityBlackoutRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutService.CancelFacilityBlackoutCallback} callback Node-style callback called with the error, if any, and FacilityBlackout
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityBlackoutService.prototype.cancelFacilityBlackout =
              function cancelFacilityBlackout(request, callback) {
                return this.rpcCall(
                  cancelFacilityBlackout,
                  $root.stronachgroup.first.racehorse360
                    .CancelFacilityBlackoutRequest,
                  $root.stronachgroup.first.racehorse360.FacilityBlackout,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CancelFacilityBlackout" }
          );

          /**
           * Calls CancelFacilityBlackout.
           * @function cancelFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelFacilityBlackoutRequest} request CancelFacilityBlackoutRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.FacilityBlackout>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityBlackoutService#excludeSingleFacilityBlackoutDate}.
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @typedef ExcludeSingleFacilityBlackoutDateCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.FacilityBlackout} [response] FacilityBlackout
           */

          /**
           * Calls ExcludeSingleFacilityBlackoutDate.
           * @function excludeSingleFacilityBlackoutDate
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IExcludeSingleFacilityBlackoutDateRequest} request ExcludeSingleFacilityBlackoutDateRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutService.ExcludeSingleFacilityBlackoutDateCallback} callback Node-style callback called with the error, if any, and FacilityBlackout
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityBlackoutService.prototype.excludeSingleFacilityBlackoutDate =
              function excludeSingleFacilityBlackoutDate(request, callback) {
                return this.rpcCall(
                  excludeSingleFacilityBlackoutDate,
                  $root.stronachgroup.first.racehorse360
                    .ExcludeSingleFacilityBlackoutDateRequest,
                  $root.stronachgroup.first.racehorse360.FacilityBlackout,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ExcludeSingleFacilityBlackoutDate" }
          );

          /**
           * Calls ExcludeSingleFacilityBlackoutDate.
           * @function excludeSingleFacilityBlackoutDate
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IExcludeSingleFacilityBlackoutDateRequest} request ExcludeSingleFacilityBlackoutDateRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.FacilityBlackout>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityBlackoutService#setRepeatToForFacilityBlackout}.
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @typedef SetRepeatToForFacilityBlackoutCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.FacilityBlackout} [response] FacilityBlackout
           */

          /**
           * Calls SetRepeatToForFacilityBlackout.
           * @function setRepeatToForFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetRepeatToForFacilityBlackoutRequest} request SetRepeatToForFacilityBlackoutRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityBlackoutService.SetRepeatToForFacilityBlackoutCallback} callback Node-style callback called with the error, if any, and FacilityBlackout
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityBlackoutService.prototype.setRepeatToForFacilityBlackout =
              function setRepeatToForFacilityBlackout(request, callback) {
                return this.rpcCall(
                  setRepeatToForFacilityBlackout,
                  $root.stronachgroup.first.racehorse360
                    .SetRepeatToForFacilityBlackoutRequest,
                  $root.stronachgroup.first.racehorse360.FacilityBlackout,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetRepeatToForFacilityBlackout" }
          );

          /**
           * Calls SetRepeatToForFacilityBlackout.
           * @function setRepeatToForFacilityBlackout
           * @memberof stronachgroup.first.racehorse360.FacilityBlackoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetRepeatToForFacilityBlackoutRequest} request SetRepeatToForFacilityBlackoutRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.FacilityBlackout>} Promise
           * @variation 2
           */

          return FacilityBlackoutService;
        })();

        racehorse360.FacilityService = (function () {
          /**
           * Constructs a new FacilityService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a FacilityService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function FacilityService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (FacilityService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = FacilityService;

          /**
           * Creates new FacilityService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {FacilityService} RPC service. Useful where requests and/or responses are streamed.
           */
          FacilityService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#listBarns}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef ListBarnsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListBarnsResponse} [response] ListBarnsResponse
           */

          /**
           * Calls ListBarns.
           * @function listBarns
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListBarnsRequest} request ListBarnsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.ListBarnsCallback} callback Node-style callback called with the error, if any, and ListBarnsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.listBarns = function listBarns(
              request,
              callback
            ) {
              return this.rpcCall(
                listBarns,
                $root.stronachgroup.first.racehorse360.ListBarnsRequest,
                $root.stronachgroup.first.racehorse360.ListBarnsResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListBarns" }
          );

          /**
           * Calls ListBarns.
           * @function listBarns
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListBarnsRequest} request ListBarnsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListBarnsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#getBarn}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef GetBarnCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Barn} [response] Barn
           */

          /**
           * Calls GetBarn.
           * @function getBarn
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetBarnRequest} request GetBarnRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.GetBarnCallback} callback Node-style callback called with the error, if any, and Barn
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.getBarn = function getBarn(
              request,
              callback
            ) {
              return this.rpcCall(
                getBarn,
                $root.stronachgroup.first.racehorse360.GetBarnRequest,
                $root.stronachgroup.first.racehorse360.Barn,
                request,
                callback
              );
            }),
            "name",
            { value: "GetBarn" }
          );

          /**
           * Calls GetBarn.
           * @function getBarn
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetBarnRequest} request GetBarnRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Barn>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#getFacility}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef GetFacilityCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Facility} [response] Facility
           */

          /**
           * Calls GetFacility.
           * @function getFacility
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetFacilityRequest} request GetFacilityRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.GetFacilityCallback} callback Node-style callback called with the error, if any, and Facility
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.getFacility = function getFacility(
              request,
              callback
            ) {
              return this.rpcCall(
                getFacility,
                $root.stronachgroup.first.racehorse360.GetFacilityRequest,
                $root.stronachgroup.first.racehorse360.Facility,
                request,
                callback
              );
            }),
            "name",
            { value: "GetFacility" }
          );

          /**
           * Calls GetFacility.
           * @function getFacility
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetFacilityRequest} request GetFacilityRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Facility>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#listFacilities}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef ListFacilitiesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListFacilitiesResponse} [response] ListFacilitiesResponse
           */

          /**
           * Calls ListFacilities.
           * @function listFacilities
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListFacilitiesRequest} request ListFacilitiesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.ListFacilitiesCallback} callback Node-style callback called with the error, if any, and ListFacilitiesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.listFacilities = function listFacilities(
              request,
              callback
            ) {
              return this.rpcCall(
                listFacilities,
                $root.stronachgroup.first.racehorse360.ListFacilitiesRequest,
                $root.stronachgroup.first.racehorse360.ListFacilitiesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListFacilities" }
          );

          /**
           * Calls ListFacilities.
           * @function listFacilities
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListFacilitiesRequest} request ListFacilitiesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListFacilitiesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#editFacilityInfo}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef EditFacilityInfoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Facility} [response] Facility
           */

          /**
           * Calls EditFacilityInfo.
           * @function editFacilityInfo
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditFacilityInfoRequest} request EditFacilityInfoRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.EditFacilityInfoCallback} callback Node-style callback called with the error, if any, and Facility
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.editFacilityInfo =
              function editFacilityInfo(request, callback) {
                return this.rpcCall(
                  editFacilityInfo,
                  $root.stronachgroup.first.racehorse360
                    .EditFacilityInfoRequest,
                  $root.stronachgroup.first.racehorse360.Facility,
                  request,
                  callback
                );
              }),
            "name",
            { value: "EditFacilityInfo" }
          );

          /**
           * Calls EditFacilityInfo.
           * @function editFacilityInfo
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditFacilityInfoRequest} request EditFacilityInfoRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Facility>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#listCourses}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef ListCoursesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListCoursesResponse} [response] ListCoursesResponse
           */

          /**
           * Calls ListCourses.
           * @function listCourses
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListCoursesRequest} request ListCoursesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.ListCoursesCallback} callback Node-style callback called with the error, if any, and ListCoursesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.listCourses = function listCourses(
              request,
              callback
            ) {
              return this.rpcCall(
                listCourses,
                $root.stronachgroup.first.racehorse360.ListCoursesRequest,
                $root.stronachgroup.first.racehorse360.ListCoursesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListCourses" }
          );

          /**
           * Calls ListCourses.
           * @function listCourses
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListCoursesRequest} request ListCoursesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListCoursesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.FacilityService#editCurrentTrackCondition}.
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @typedef EditCurrentTrackConditionCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Course} [response] Course
           */

          /**
           * Calls EditCurrentTrackCondition.
           * @function editCurrentTrackCondition
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditCurrentTrackConditionRequest} request EditCurrentTrackConditionRequest message or plain object
           * @param {stronachgroup.first.racehorse360.FacilityService.EditCurrentTrackConditionCallback} callback Node-style callback called with the error, if any, and Course
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (FacilityService.prototype.editCurrentTrackCondition =
              function editCurrentTrackCondition(request, callback) {
                return this.rpcCall(
                  editCurrentTrackCondition,
                  $root.stronachgroup.first.racehorse360
                    .EditCurrentTrackConditionRequest,
                  $root.stronachgroup.first.racehorse360.Course,
                  request,
                  callback
                );
              }),
            "name",
            { value: "EditCurrentTrackCondition" }
          );

          /**
           * Calls EditCurrentTrackCondition.
           * @function editCurrentTrackCondition
           * @memberof stronachgroup.first.racehorse360.FacilityService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditCurrentTrackConditionRequest} request EditCurrentTrackConditionRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Course>} Promise
           * @variation 2
           */

          return FacilityService;
        })();

        racehorse360.HorseExamRequirementService = (function () {
          /**
           * Constructs a new HorseExamRequirementService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamRequirementService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function HorseExamRequirementService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (HorseExamRequirementService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = HorseExamRequirementService;

          /**
           * Creates new HorseExamRequirementService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {HorseExamRequirementService} RPC service. Useful where requests and/or responses are streamed.
           */
          HorseExamRequirementService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamRequirementService#listHorseExamRequirements}.
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @typedef ListHorseExamRequirementsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse} [response] ListHorseExamRequirementsResponse
           */

          /**
           * Calls ListHorseExamRequirements.
           * @function listHorseExamRequirements
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsRequest} request ListHorseExamRequirementsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamRequirementService.ListHorseExamRequirementsCallback} callback Node-style callback called with the error, if any, and ListHorseExamRequirementsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamRequirementService.prototype.listHorseExamRequirements =
              function listHorseExamRequirements(request, callback) {
                return this.rpcCall(
                  listHorseExamRequirements,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseExamRequirementsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseExamRequirementsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseExamRequirements" }
          );

          /**
           * Calls ListHorseExamRequirements.
           * @function listHorseExamRequirements
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamRequirementsRequest} request ListHorseExamRequirementsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseExamRequirementsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamRequirementService#confirmExamRequirementReadiness}.
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @typedef ConfirmExamRequirementReadinessCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExamRequirement} [response] HorseExamRequirement
           */

          /**
           * Calls ConfirmExamRequirementReadiness.
           * @function confirmExamRequirementReadiness
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @instance
           * @param {stronachgroup.first.racehorse360.IConfirmExamRequirementReadinessRequest} request ConfirmExamRequirementReadinessRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamRequirementService.ConfirmExamRequirementReadinessCallback} callback Node-style callback called with the error, if any, and HorseExamRequirement
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamRequirementService.prototype.confirmExamRequirementReadiness =
              function confirmExamRequirementReadiness(request, callback) {
                return this.rpcCall(
                  confirmExamRequirementReadiness,
                  $root.stronachgroup.first.racehorse360
                    .ConfirmExamRequirementReadinessRequest,
                  $root.stronachgroup.first.racehorse360.HorseExamRequirement,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ConfirmExamRequirementReadiness" }
          );

          /**
           * Calls ConfirmExamRequirementReadiness.
           * @function confirmExamRequirementReadiness
           * @memberof stronachgroup.first.racehorse360.HorseExamRequirementService
           * @instance
           * @param {stronachgroup.first.racehorse360.IConfirmExamRequirementReadinessRequest} request ConfirmExamRequirementReadinessRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExamRequirement>} Promise
           * @variation 2
           */

          return HorseExamRequirementService;
        })();

        racehorse360.HorseExamService = (function () {
          /**
           * Constructs a new HorseExamService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseExamService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function HorseExamService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (HorseExamService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = HorseExamService;

          /**
           * Creates new HorseExamService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {HorseExamService} RPC service. Useful where requests and/or responses are streamed.
           */
          HorseExamService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#getHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef GetHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExam} [response] HorseExam
           */

          /**
           * Calls GetHorseExam.
           * @function getHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseExamRequest} request GetHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.GetHorseExamCallback} callback Node-style callback called with the error, if any, and HorseExam
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.getHorseExam = function getHorseExam(
              request,
              callback
            ) {
              return this.rpcCall(
                getHorseExam,
                $root.stronachgroup.first.racehorse360.GetHorseExamRequest,
                $root.stronachgroup.first.racehorse360.HorseExam,
                request,
                callback
              );
            }),
            "name",
            { value: "GetHorseExam" }
          );

          /**
           * Calls GetHorseExam.
           * @function getHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseExamRequest} request GetHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExam>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#listHorseExams}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef ListHorseExamsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseExamsResponse} [response] ListHorseExamsResponse
           */

          /**
           * Calls ListHorseExams.
           * @function listHorseExams
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamsRequest} request ListHorseExamsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.ListHorseExamsCallback} callback Node-style callback called with the error, if any, and ListHorseExamsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.listHorseExams =
              function listHorseExams(request, callback) {
                return this.rpcCall(
                  listHorseExams,
                  $root.stronachgroup.first.racehorse360.ListHorseExamsRequest,
                  $root.stronachgroup.first.racehorse360.ListHorseExamsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseExams" }
          );

          /**
           * Calls ListHorseExams.
           * @function listHorseExams
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamsRequest} request ListHorseExamsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseExamsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#createHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef CreateHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExam} [response] HorseExam
           */

          /**
           * Calls CreateHorseExam.
           * @function createHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamRequest} request CreateHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.CreateHorseExamCallback} callback Node-style callback called with the error, if any, and HorseExam
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.createHorseExam =
              function createHorseExam(request, callback) {
                return this.rpcCall(
                  createHorseExam,
                  $root.stronachgroup.first.racehorse360.CreateHorseExamRequest,
                  $root.stronachgroup.first.racehorse360.HorseExam,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateHorseExam" }
          );

          /**
           * Calls CreateHorseExam.
           * @function createHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseExamRequest} request CreateHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExam>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#editHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef EditHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExam} [response] HorseExam
           */

          /**
           * Calls EditHorseExam.
           * @function editHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseExamRequest} request EditHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.EditHorseExamCallback} callback Node-style callback called with the error, if any, and HorseExam
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.editHorseExam = function editHorseExam(
              request,
              callback
            ) {
              return this.rpcCall(
                editHorseExam,
                $root.stronachgroup.first.racehorse360.EditHorseExamRequest,
                $root.stronachgroup.first.racehorse360.HorseExam,
                request,
                callback
              );
            }),
            "name",
            { value: "EditHorseExam" }
          );

          /**
           * Calls EditHorseExam.
           * @function editHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseExamRequest} request EditHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExam>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#deleteHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef DeleteHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseExam.
           * @function deleteHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamRequest} request DeleteHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.DeleteHorseExamCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.deleteHorseExam =
              function deleteHorseExam(request, callback) {
                return this.rpcCall(
                  deleteHorseExam,
                  $root.stronachgroup.first.racehorse360.DeleteHorseExamRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteHorseExam" }
          );

          /**
           * Calls DeleteHorseExam.
           * @function deleteHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseExamRequest} request DeleteHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#cancelHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef CancelHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls CancelHorseExam.
           * @function cancelHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelHorseExamRequest} request CancelHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.CancelHorseExamCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.cancelHorseExam =
              function cancelHorseExam(request, callback) {
                return this.rpcCall(
                  cancelHorseExam,
                  $root.stronachgroup.first.racehorse360.CancelHorseExamRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CancelHorseExam" }
          );

          /**
           * Calls CancelHorseExam.
           * @function cancelHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelHorseExamRequest} request CancelHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#completeHorseExam}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef CompleteHorseExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExam} [response] HorseExam
           */

          /**
           * Calls CompleteHorseExam.
           * @function completeHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteHorseExamRequest} request CompleteHorseExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.CompleteHorseExamCallback} callback Node-style callback called with the error, if any, and HorseExam
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.completeHorseExam =
              function completeHorseExam(request, callback) {
                return this.rpcCall(
                  completeHorseExam,
                  $root.stronachgroup.first.racehorse360
                    .CompleteHorseExamRequest,
                  $root.stronachgroup.first.racehorse360.HorseExam,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CompleteHorseExam" }
          );

          /**
           * Calls CompleteHorseExam.
           * @function completeHorseExam
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteHorseExamRequest} request CompleteHorseExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExam>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#pullHorseExamConditions}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef PullHorseExamConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorseExamConditionsResponse} [response] PullHorseExamConditionsResponse
           */

          /**
           * Calls PullHorseExamConditions.
           * @function pullHorseExamConditions
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsRequest} request PullHorseExamConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.PullHorseExamConditionsCallback} callback Node-style callback called with the error, if any, and PullHorseExamConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.pullHorseExamConditions =
              function pullHorseExamConditions(request, callback) {
                return this.rpcCall(
                  pullHorseExamConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseExamConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseExamConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorseExamConditions" }
          );

          /**
           * Calls PullHorseExamConditions.
           * @function pullHorseExamConditions
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseExamConditionsRequest} request PullHorseExamConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorseExamConditionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#getHorseExamComment}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef GetHorseExamCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseExamComment} [response] HorseExamComment
           */

          /**
           * Calls GetHorseExamComment.
           * @function getHorseExamComment
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseExamCommentRequest} request GetHorseExamCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.GetHorseExamCommentCallback} callback Node-style callback called with the error, if any, and HorseExamComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.getHorseExamComment =
              function getHorseExamComment(request, callback) {
                return this.rpcCall(
                  getHorseExamComment,
                  $root.stronachgroup.first.racehorse360
                    .GetHorseExamCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseExamComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetHorseExamComment" }
          );

          /**
           * Calls GetHorseExamComment.
           * @function getHorseExamComment
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseExamCommentRequest} request GetHorseExamCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseExamComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#listHorseExamComment}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef ListHorseExamCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseExamCommentsResponse} [response] ListHorseExamCommentsResponse
           */

          /**
           * Calls ListHorseExamComment.
           * @function listHorseExamComment
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsRequest} request ListHorseExamCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.ListHorseExamCommentCallback} callback Node-style callback called with the error, if any, and ListHorseExamCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.listHorseExamComment =
              function listHorseExamComment(request, callback) {
                return this.rpcCall(
                  listHorseExamComment,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseExamCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseExamCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseExamComment" }
          );

          /**
           * Calls ListHorseExamComment.
           * @function listHorseExamComment
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseExamCommentsRequest} request ListHorseExamCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseExamCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseExamService#pullHorseExamReport}.
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @typedef PullHorseExamReportCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorseExamReportResponse} [response] PullHorseExamReportResponse
           */

          /**
           * Calls PullHorseExamReport.
           * @function pullHorseExamReport
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportRequest} request PullHorseExamReportRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseExamService.PullHorseExamReportCallback} callback Node-style callback called with the error, if any, and PullHorseExamReportResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseExamService.prototype.pullHorseExamReport =
              function pullHorseExamReport(request, callback) {
                return this.rpcCall(
                  pullHorseExamReport,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseExamReportRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseExamReportResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorseExamReport" }
          );

          /**
           * Calls PullHorseExamReport.
           * @function pullHorseExamReport
           * @memberof stronachgroup.first.racehorse360.HorseExamService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseExamReportRequest} request PullHorseExamReportRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorseExamReportResponse>} Promise
           * @variation 2
           */

          return HorseExamService;
        })();

        racehorse360.HorseService = (function () {
          /**
           * Constructs a new HorseService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a HorseService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function HorseService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (HorseService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = HorseService;

          /**
           * Creates new HorseService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {HorseService} RPC service. Useful where requests and/or responses are streamed.
           */
          HorseService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#getHorse}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef GetHorseCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls GetHorse.
           * @function getHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseRequest} request GetHorseRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.GetHorseCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.getHorse = function getHorse(
              request,
              callback
            ) {
              return this.rpcCall(
                getHorse,
                $root.stronachgroup.first.racehorse360.GetHorseRequest,
                $root.stronachgroup.first.racehorse360.Horse,
                request,
                callback
              );
            }),
            "name",
            { value: "GetHorse" }
          );

          /**
           * Calls GetHorse.
           * @function getHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseRequest} request GetHorseRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorses}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorsesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorsesResponse} [response] ListHorsesResponse
           */

          /**
           * Calls ListHorses.
           * @function listHorses
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorsesRequest} request ListHorsesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorsesCallback} callback Node-style callback called with the error, if any, and ListHorsesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorses = function listHorses(
              request,
              callback
            ) {
              return this.rpcCall(
                listHorses,
                $root.stronachgroup.first.racehorse360.ListHorsesRequest,
                $root.stronachgroup.first.racehorse360.ListHorsesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListHorses" }
          );

          /**
           * Calls ListHorses.
           * @function listHorses
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorsesRequest} request ListHorsesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorsesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#assignHorseToBarn}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef AssignHorseToBarnCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls AssignHorseToBarn.
           * @function assignHorseToBarn
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToBarnRequest} request AssignHorseToBarnRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.AssignHorseToBarnCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.assignHorseToBarn =
              function assignHorseToBarn(request, callback) {
                return this.rpcCall(
                  assignHorseToBarn,
                  $root.stronachgroup.first.racehorse360
                    .AssignHorseToBarnRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignHorseToBarn" }
          );

          /**
           * Calls AssignHorseToBarn.
           * @function assignHorseToBarn
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToBarnRequest} request AssignHorseToBarnRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#unassignHorseFromBarn}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef UnassignHorseFromBarnCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls UnassignHorseFromBarn.
           * @function unassignHorseFromBarn
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromBarnRequest} request UnassignHorseFromBarnRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.UnassignHorseFromBarnCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.unassignHorseFromBarn =
              function unassignHorseFromBarn(request, callback) {
                return this.rpcCall(
                  unassignHorseFromBarn,
                  $root.stronachgroup.first.racehorse360
                    .UnassignHorseFromBarnRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignHorseFromBarn" }
          );

          /**
           * Calls UnassignHorseFromBarn.
           * @function unassignHorseFromBarn
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromBarnRequest} request UnassignHorseFromBarnRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#assignHorseToFacility}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef AssignHorseToFacilityCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls AssignHorseToFacility.
           * @function assignHorseToFacility
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToFacilityRequest} request AssignHorseToFacilityRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.AssignHorseToFacilityCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.assignHorseToFacility =
              function assignHorseToFacility(request, callback) {
                return this.rpcCall(
                  assignHorseToFacility,
                  $root.stronachgroup.first.racehorse360
                    .AssignHorseToFacilityRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignHorseToFacility" }
          );

          /**
           * Calls AssignHorseToFacility.
           * @function assignHorseToFacility
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToFacilityRequest} request AssignHorseToFacilityRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#assignHorseToStall}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef AssignHorseToStallCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls AssignHorseToStall.
           * @function assignHorseToStall
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToStallRequest} request AssignHorseToStallRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.AssignHorseToStallCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.assignHorseToStall =
              function assignHorseToStall(request, callback) {
                return this.rpcCall(
                  assignHorseToStall,
                  $root.stronachgroup.first.racehorse360
                    .AssignHorseToStallRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignHorseToStall" }
          );

          /**
           * Calls AssignHorseToStall.
           * @function assignHorseToStall
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToStallRequest} request AssignHorseToStallRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#unassignHorseFromStall}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef UnassignHorseFromStallCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls UnassignHorseFromStall.
           * @function unassignHorseFromStall
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromStallRequest} request UnassignHorseFromStallRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.UnassignHorseFromStallCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.unassignHorseFromStall =
              function unassignHorseFromStall(request, callback) {
                return this.rpcCall(
                  unassignHorseFromStall,
                  $root.stronachgroup.first.racehorse360
                    .UnassignHorseFromStallRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignHorseFromStall" }
          );

          /**
           * Calls UnassignHorseFromStall.
           * @function unassignHorseFromStall
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromStallRequest} request UnassignHorseFromStallRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#assignHorseToTrainer}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef AssignHorseToTrainerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls AssignHorseToTrainer.
           * @function assignHorseToTrainer
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToTrainerRequest} request AssignHorseToTrainerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.AssignHorseToTrainerCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.assignHorseToTrainer =
              function assignHorseToTrainer(request, callback) {
                return this.rpcCall(
                  assignHorseToTrainer,
                  $root.stronachgroup.first.racehorse360
                    .AssignHorseToTrainerRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignHorseToTrainer" }
          );

          /**
           * Calls AssignHorseToTrainer.
           * @function assignHorseToTrainer
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignHorseToTrainerRequest} request AssignHorseToTrainerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#unassignHorseFromTrainer}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef UnassignHorseFromTrainerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls UnassignHorseFromTrainer.
           * @function unassignHorseFromTrainer
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromTrainerRequest} request UnassignHorseFromTrainerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.UnassignHorseFromTrainerCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.unassignHorseFromTrainer =
              function unassignHorseFromTrainer(request, callback) {
                return this.rpcCall(
                  unassignHorseFromTrainer,
                  $root.stronachgroup.first.racehorse360
                    .UnassignHorseFromTrainerRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignHorseFromTrainer" }
          );

          /**
           * Calls UnassignHorseFromTrainer.
           * @function unassignHorseFromTrainer
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignHorseFromTrainerRequest} request UnassignHorseFromTrainerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#assignPreferredConditionsHorse}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef AssignPreferredConditionsHorseCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls AssignPreferredConditionsHorse.
           * @function assignPreferredConditionsHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignPreferredConditionsHorseRequest} request AssignPreferredConditionsHorseRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.AssignPreferredConditionsHorseCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.assignPreferredConditionsHorse =
              function assignPreferredConditionsHorse(request, callback) {
                return this.rpcCall(
                  assignPreferredConditionsHorse,
                  $root.stronachgroup.first.racehorse360
                    .AssignPreferredConditionsHorseRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignPreferredConditionsHorse" }
          );

          /**
           * Calls AssignPreferredConditionsHorse.
           * @function assignPreferredConditionsHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignPreferredConditionsHorseRequest} request AssignPreferredConditionsHorseRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#resetPreferredConditionsHorse}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ResetPreferredConditionsHorseCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls ResetPreferredConditionsHorse.
           * @function resetPreferredConditionsHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetPreferredConditionsHorseRequest} request ResetPreferredConditionsHorseRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ResetPreferredConditionsHorseCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.resetPreferredConditionsHorse =
              function resetPreferredConditionsHorse(request, callback) {
                return this.rpcCall(
                  resetPreferredConditionsHorse,
                  $root.stronachgroup.first.racehorse360
                    .ResetPreferredConditionsHorseRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetPreferredConditionsHorse" }
          );

          /**
           * Calls ResetPreferredConditionsHorse.
           * @function resetPreferredConditionsHorse
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetPreferredConditionsHorseRequest} request ResetPreferredConditionsHorseRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#editHorseHealthWatchStatus}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef EditHorseHealthWatchStatusCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls EditHorseHealthWatchStatus.
           * @function editHorseHealthWatchStatus
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseHealthWatchStatusRequest} request EditHorseHealthWatchStatusRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.EditHorseHealthWatchStatusCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.editHorseHealthWatchStatus =
              function editHorseHealthWatchStatus(request, callback) {
                return this.rpcCall(
                  editHorseHealthWatchStatus,
                  $root.stronachgroup.first.racehorse360
                    .EditHorseHealthWatchStatusRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "EditHorseHealthWatchStatus" }
          );

          /**
           * Calls EditHorseHealthWatchStatus.
           * @function editHorseHealthWatchStatus
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseHealthWatchStatusRequest} request EditHorseHealthWatchStatusRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#setHorseWarningMessage}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef SetHorseWarningMessageCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls SetHorseWarningMessage.
           * @function setHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetHorseWarningMessageRequest} request SetHorseWarningMessageRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.SetHorseWarningMessageCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.setHorseWarningMessage =
              function setHorseWarningMessage(request, callback) {
                return this.rpcCall(
                  setHorseWarningMessage,
                  $root.stronachgroup.first.racehorse360
                    .SetHorseWarningMessageRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetHorseWarningMessage" }
          );

          /**
           * Calls SetHorseWarningMessage.
           * @function setHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetHorseWarningMessageRequest} request SetHorseWarningMessageRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#resetHorseWarningMessage}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ResetHorseWarningMessageCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls ResetHorseWarningMessage.
           * @function resetHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetHorseWarningMessageRequest} request ResetHorseWarningMessageRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ResetHorseWarningMessageCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.resetHorseWarningMessage =
              function resetHorseWarningMessage(request, callback) {
                return this.rpcCall(
                  resetHorseWarningMessage,
                  $root.stronachgroup.first.racehorse360
                    .ResetHorseWarningMessageRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetHorseWarningMessage" }
          );

          /**
           * Calls ResetHorseWarningMessage.
           * @function resetHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetHorseWarningMessageRequest} request ResetHorseWarningMessageRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullRelevantHorseWarningMessage}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullRelevantHorseWarningMessageCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse} [response] PullRelevantHorseWarningMessageResponse
           */

          /**
           * Calls PullRelevantHorseWarningMessage.
           * @function pullRelevantHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageRequest} request PullRelevantHorseWarningMessageRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullRelevantHorseWarningMessageCallback} callback Node-style callback called with the error, if any, and PullRelevantHorseWarningMessageResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullRelevantHorseWarningMessage =
              function pullRelevantHorseWarningMessage(request, callback) {
                return this.rpcCall(
                  pullRelevantHorseWarningMessage,
                  $root.stronachgroup.first.racehorse360
                    .PullRelevantHorseWarningMessageRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullRelevantHorseWarningMessageResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullRelevantHorseWarningMessage" }
          );

          /**
           * Calls PullRelevantHorseWarningMessage.
           * @function pullRelevantHorseWarningMessage
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRelevantHorseWarningMessageRequest} request PullRelevantHorseWarningMessageRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullRelevantHorseWarningMessageResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsesCountByFacilitySummary}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsesCountByFacilitySummaryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse} [response] PullHorsesCountByFacilitySummaryResponse
           */

          /**
           * Calls PullHorsesCountByFacilitySummary.
           * @function pullHorsesCountByFacilitySummary
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryRequest} request PullHorsesCountByFacilitySummaryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsesCountByFacilitySummaryCallback} callback Node-style callback called with the error, if any, and PullHorsesCountByFacilitySummaryResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsesCountByFacilitySummary =
              function pullHorsesCountByFacilitySummary(request, callback) {
                return this.rpcCall(
                  pullHorsesCountByFacilitySummary,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountByFacilitySummaryRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountByFacilitySummaryResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsesCountByFacilitySummary" }
          );

          /**
           * Calls PullHorsesCountByFacilitySummary.
           * @function pullHorsesCountByFacilitySummary
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountByFacilitySummaryRequest} request PullHorsesCountByFacilitySummaryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsesCountByFacilitySummaryResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullTrainerHorsesWithMatchingRacesCount}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullTrainerHorsesWithMatchingRacesCountCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse} [response] PullTrainerHorsesWithMatchingRacesCountResponse
           */

          /**
           * Calls PullTrainerHorsesWithMatchingRacesCount.
           * @function pullTrainerHorsesWithMatchingRacesCount
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountRequest} request PullTrainerHorsesWithMatchingRacesCountRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullTrainerHorsesWithMatchingRacesCountCallback} callback Node-style callback called with the error, if any, and PullTrainerHorsesWithMatchingRacesCountResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullTrainerHorsesWithMatchingRacesCount =
              function pullTrainerHorsesWithMatchingRacesCount(
                request,
                callback
              ) {
                return this.rpcCall(
                  pullTrainerHorsesWithMatchingRacesCount,
                  $root.stronachgroup.first.racehorse360
                    .PullTrainerHorsesWithMatchingRacesCountRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullTrainerHorsesWithMatchingRacesCountResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullTrainerHorsesWithMatchingRacesCount" }
          );

          /**
           * Calls PullTrainerHorsesWithMatchingRacesCount.
           * @function pullTrainerHorsesWithMatchingRacesCount
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrainerHorsesWithMatchingRacesCountRequest} request PullTrainerHorsesWithMatchingRacesCountRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullTrainerHorsesWithMatchingRacesCountResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsesCountGroupedByPreferredConditions}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsesCountGroupedByPreferredConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse} [response] PullHorsesCountGroupedByPreferredConditionsResponse
           */

          /**
           * Calls PullHorsesCountGroupedByPreferredConditions.
           * @function pullHorsesCountGroupedByPreferredConditions
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsRequest} request PullHorsesCountGroupedByPreferredConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsesCountGroupedByPreferredConditionsCallback} callback Node-style callback called with the error, if any, and PullHorsesCountGroupedByPreferredConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsesCountGroupedByPreferredConditions =
              function pullHorsesCountGroupedByPreferredConditions(
                request,
                callback
              ) {
                return this.rpcCall(
                  pullHorsesCountGroupedByPreferredConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountGroupedByPreferredConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesCountGroupedByPreferredConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsesCountGroupedByPreferredConditions" }
          );

          /**
           * Calls PullHorsesCountGroupedByPreferredConditions.
           * @function pullHorsesCountGroupedByPreferredConditions
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesCountGroupedByPreferredConditionsRequest} request PullHorsesCountGroupedByPreferredConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsesCountGroupedByPreferredConditionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseRisks}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseRisksCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseRisksResponse} [response] ListHorseRisksResponse
           */

          /**
           * Calls ListHorseRisks.
           * @function listHorseRisks
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseRisksRequest} request ListHorseRisksRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseRisksCallback} callback Node-style callback called with the error, if any, and ListHorseRisksResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseRisks = function listHorseRisks(
              request,
              callback
            ) {
              return this.rpcCall(
                listHorseRisks,
                $root.stronachgroup.first.racehorse360.ListHorseRisksRequest,
                $root.stronachgroup.first.racehorse360.ListHorseRisksResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListHorseRisks" }
          );

          /**
           * Calls ListHorseRisks.
           * @function listHorseRisks
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseRisksRequest} request ListHorseRisksRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseRisksResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#createHorseRisk}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef CreateHorseRiskCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseRisk} [response] HorseRisk
           */

          /**
           * Calls CreateHorseRisk.
           * @function createHorseRisk
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseRiskRequest} request CreateHorseRiskRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.CreateHorseRiskCallback} callback Node-style callback called with the error, if any, and HorseRisk
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.createHorseRisk = function createHorseRisk(
              request,
              callback
            ) {
              return this.rpcCall(
                createHorseRisk,
                $root.stronachgroup.first.racehorse360.CreateHorseRiskRequest,
                $root.stronachgroup.first.racehorse360.HorseRisk,
                request,
                callback
              );
            }),
            "name",
            { value: "CreateHorseRisk" }
          );

          /**
           * Calls CreateHorseRisk.
           * @function createHorseRisk
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseRiskRequest} request CreateHorseRiskRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseRisk>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#deleteHorseRisk}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef DeleteHorseRiskCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseRisk.
           * @function deleteHorseRisk
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseRiskRequest} request DeleteHorseRiskRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.DeleteHorseRiskCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.deleteHorseRisk = function deleteHorseRisk(
              request,
              callback
            ) {
              return this.rpcCall(
                deleteHorseRisk,
                $root.stronachgroup.first.racehorse360.DeleteHorseRiskRequest,
                $root.stronachgroup.first.racehorse360.EmptyResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "DeleteHorseRisk" }
          );

          /**
           * Calls DeleteHorseRisk.
           * @function deleteHorseRisk
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseRiskRequest} request DeleteHorseRiskRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listRiskFactors}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListRiskFactorsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRiskFactorsResponse} [response] ListRiskFactorsResponse
           */

          /**
           * Calls ListRiskFactors.
           * @function listRiskFactors
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsRequest} request ListRiskFactorsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListRiskFactorsCallback} callback Node-style callback called with the error, if any, and ListRiskFactorsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listRiskFactors = function listRiskFactors(
              request,
              callback
            ) {
              return this.rpcCall(
                listRiskFactors,
                $root.stronachgroup.first.racehorse360.ListRiskFactorsRequest,
                $root.stronachgroup.first.racehorse360.ListRiskFactorsResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListRiskFactors" }
          );

          /**
           * Calls ListRiskFactors.
           * @function listRiskFactors
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRiskFactorsRequest} request ListRiskFactorsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRiskFactorsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseInjuries}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseInjuriesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseInjuriesResponse} [response] ListHorseInjuriesResponse
           */

          /**
           * Calls ListHorseInjuries.
           * @function listHorseInjuries
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesRequest} request ListHorseInjuriesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseInjuriesCallback} callback Node-style callback called with the error, if any, and ListHorseInjuriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseInjuries =
              function listHorseInjuries(request, callback) {
                return this.rpcCall(
                  listHorseInjuries,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseInjuriesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseInjuriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseInjuries" }
          );

          /**
           * Calls ListHorseInjuries.
           * @function listHorseInjuries
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseInjuriesRequest} request ListHorseInjuriesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseInjuriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseInjuryDetails}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseInjuryDetailsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse} [response] ListHorseInjuryDetailsResponse
           */

          /**
           * Calls ListHorseInjuryDetails.
           * @function listHorseInjuryDetails
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsRequest} request ListHorseInjuryDetailsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseInjuryDetailsCallback} callback Node-style callback called with the error, if any, and ListHorseInjuryDetailsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseInjuryDetails =
              function listHorseInjuryDetails(request, callback) {
                return this.rpcCall(
                  listHorseInjuryDetails,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseInjuryDetailsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseInjuryDetailsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseInjuryDetails" }
          );

          /**
           * Calls ListHorseInjuryDetails.
           * @function listHorseInjuryDetails
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseInjuryDetailsRequest} request ListHorseInjuryDetailsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseInjuryDetailsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseOnLists}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseOnListsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseOnListsResponse} [response] ListHorseOnListsResponse
           */

          /**
           * Calls ListHorseOnLists.
           * @function listHorseOnLists
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsRequest} request ListHorseOnListsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseOnListsCallback} callback Node-style callback called with the error, if any, and ListHorseOnListsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseOnLists =
              function listHorseOnLists(request, callback) {
                return this.rpcCall(
                  listHorseOnLists,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseOnListsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseOnListsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseOnLists" }
          );

          /**
           * Calls ListHorseOnLists.
           * @function listHorseOnLists
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseOnListsRequest} request ListHorseOnListsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseOnListsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsesFromListsCount}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsesFromListsCountCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse} [response] PullHorsesFromListsCountResponse
           */

          /**
           * Calls PullHorsesFromListsCount.
           * @function pullHorsesFromListsCount
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountRequest} request PullHorsesFromListsCountRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsesFromListsCountCallback} callback Node-style callback called with the error, if any, and PullHorsesFromListsCountResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsesFromListsCount =
              function pullHorsesFromListsCount(request, callback) {
                return this.rpcCall(
                  pullHorsesFromListsCount,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesFromListsCountRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesFromListsCountResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsesFromListsCount" }
          );

          /**
           * Calls PullHorsesFromListsCount.
           * @function pullHorsesFromListsCount
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesFromListsCountRequest} request PullHorsesFromListsCountRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsesFromListsCountResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsePreferredConditions}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsePreferredConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse} [response] PullHorsePreferredConditionsResponse
           */

          /**
           * Calls PullHorsePreferredConditions.
           * @function pullHorsePreferredConditions
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsRequest} request PullHorsePreferredConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsePreferredConditionsCallback} callback Node-style callback called with the error, if any, and PullHorsePreferredConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsePreferredConditions =
              function pullHorsePreferredConditions(request, callback) {
                return this.rpcCall(
                  pullHorsePreferredConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsePreferredConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsePreferredConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsePreferredConditions" }
          );

          /**
           * Calls PullHorsePreferredConditions.
           * @function pullHorsePreferredConditions
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsePreferredConditionsRequest} request PullHorsePreferredConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsePreferredConditionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#createHorseNotepadComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef CreateHorseNotepadCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseNotepadComment} [response] HorseNotepadComment
           */

          /**
           * Calls CreateHorseNotepadComment.
           * @function createHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseNotepadCommentRequest} request CreateHorseNotepadCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.CreateHorseNotepadCommentCallback} callback Node-style callback called with the error, if any, and HorseNotepadComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.createHorseNotepadComment =
              function createHorseNotepadComment(request, callback) {
                return this.rpcCall(
                  createHorseNotepadComment,
                  $root.stronachgroup.first.racehorse360
                    .CreateHorseNotepadCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseNotepadComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateHorseNotepadComment" }
          );

          /**
           * Calls CreateHorseNotepadComment.
           * @function createHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseNotepadCommentRequest} request CreateHorseNotepadCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseNotepadComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#updateHorseNotepadComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef UpdateHorseNotepadCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseNotepadComment} [response] HorseNotepadComment
           */

          /**
           * Calls UpdateHorseNotepadComment.
           * @function updateHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateHorseNotepadCommentRequest} request UpdateHorseNotepadCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.UpdateHorseNotepadCommentCallback} callback Node-style callback called with the error, if any, and HorseNotepadComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.updateHorseNotepadComment =
              function updateHorseNotepadComment(request, callback) {
                return this.rpcCall(
                  updateHorseNotepadComment,
                  $root.stronachgroup.first.racehorse360
                    .UpdateHorseNotepadCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseNotepadComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateHorseNotepadComment" }
          );

          /**
           * Calls UpdateHorseNotepadComment.
           * @function updateHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateHorseNotepadCommentRequest} request UpdateHorseNotepadCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseNotepadComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseNotepadComments}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseNotepadCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse} [response] ListHorseNotepadCommentsResponse
           */

          /**
           * Calls ListHorseNotepadComments.
           * @function listHorseNotepadComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsRequest} request ListHorseNotepadCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseNotepadCommentsCallback} callback Node-style callback called with the error, if any, and ListHorseNotepadCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseNotepadComments =
              function listHorseNotepadComments(request, callback) {
                return this.rpcCall(
                  listHorseNotepadComments,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseNotepadCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseNotepadCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseNotepadComments" }
          );

          /**
           * Calls ListHorseNotepadComments.
           * @function listHorseNotepadComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseNotepadCommentsRequest} request ListHorseNotepadCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseNotepadCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#deleteHorseNotepadComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef DeleteHorseNotepadCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseNotepadComment.
           * @function deleteHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseNotepadCommentRequest} request DeleteHorseNotepadCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.DeleteHorseNotepadCommentCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.deleteHorseNotepadComment =
              function deleteHorseNotepadComment(request, callback) {
                return this.rpcCall(
                  deleteHorseNotepadComment,
                  $root.stronachgroup.first.racehorse360
                    .DeleteHorseNotepadCommentRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteHorseNotepadComment" }
          );

          /**
           * Calls DeleteHorseNotepadComment.
           * @function deleteHorseNotepadComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseNotepadCommentRequest} request DeleteHorseNotepadCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorseAggregatedComments}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorseAggregatedCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse} [response] PullHorseAggregatedCommentsResponse
           */

          /**
           * Calls PullHorseAggregatedComments.
           * @function pullHorseAggregatedComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsRequest} request PullHorseAggregatedCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorseAggregatedCommentsCallback} callback Node-style callback called with the error, if any, and PullHorseAggregatedCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorseAggregatedComments =
              function pullHorseAggregatedComments(request, callback) {
                return this.rpcCall(
                  pullHorseAggregatedComments,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseAggregatedCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorseAggregatedCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorseAggregatedComments" }
          );

          /**
           * Calls PullHorseAggregatedComments.
           * @function pullHorseAggregatedComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorseAggregatedCommentsRequest} request PullHorseAggregatedCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorseAggregatedCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#markHorseAggregatedCommentsAsRead}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef MarkHorseAggregatedCommentsAsReadCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls MarkHorseAggregatedCommentsAsRead.
           * @function markHorseAggregatedCommentsAsRead
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMarkHorseAggregatedCommentsAsReadRequest} request MarkHorseAggregatedCommentsAsReadRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.MarkHorseAggregatedCommentsAsReadCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.markHorseAggregatedCommentsAsRead =
              function markHorseAggregatedCommentsAsRead(request, callback) {
                return this.rpcCall(
                  markHorseAggregatedCommentsAsRead,
                  $root.stronachgroup.first.racehorse360
                    .MarkHorseAggregatedCommentsAsReadRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "MarkHorseAggregatedCommentsAsRead" }
          );

          /**
           * Calls MarkHorseAggregatedCommentsAsRead.
           * @function markHorseAggregatedCommentsAsRead
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMarkHorseAggregatedCommentsAsReadRequest} request MarkHorseAggregatedCommentsAsReadRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#createHorseGeneralVetComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef CreateHorseGeneralVetCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseGeneralVetComment} [response] HorseGeneralVetComment
           */

          /**
           * Calls CreateHorseGeneralVetComment.
           * @function createHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseGeneralVetCommentRequest} request CreateHorseGeneralVetCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.CreateHorseGeneralVetCommentCallback} callback Node-style callback called with the error, if any, and HorseGeneralVetComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.createHorseGeneralVetComment =
              function createHorseGeneralVetComment(request, callback) {
                return this.rpcCall(
                  createHorseGeneralVetComment,
                  $root.stronachgroup.first.racehorse360
                    .CreateHorseGeneralVetCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseGeneralVetComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateHorseGeneralVetComment" }
          );

          /**
           * Calls CreateHorseGeneralVetComment.
           * @function createHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateHorseGeneralVetCommentRequest} request CreateHorseGeneralVetCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseGeneralVetComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#updateHorseGeneralVetComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef UpdateHorseGeneralVetCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseGeneralVetComment} [response] HorseGeneralVetComment
           */

          /**
           * Calls UpdateHorseGeneralVetComment.
           * @function updateHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateHorseGeneralVetCommentRequest} request UpdateHorseGeneralVetCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.UpdateHorseGeneralVetCommentCallback} callback Node-style callback called with the error, if any, and HorseGeneralVetComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.updateHorseGeneralVetComment =
              function updateHorseGeneralVetComment(request, callback) {
                return this.rpcCall(
                  updateHorseGeneralVetComment,
                  $root.stronachgroup.first.racehorse360
                    .UpdateHorseGeneralVetCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseGeneralVetComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateHorseGeneralVetComment" }
          );

          /**
           * Calls UpdateHorseGeneralVetComment.
           * @function updateHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateHorseGeneralVetCommentRequest} request UpdateHorseGeneralVetCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseGeneralVetComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#deleteHorseGeneralVetComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef DeleteHorseGeneralVetCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseGeneralVetComment.
           * @function deleteHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseGeneralVetCommentRequest} request DeleteHorseGeneralVetCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.DeleteHorseGeneralVetCommentCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.deleteHorseGeneralVetComment =
              function deleteHorseGeneralVetComment(request, callback) {
                return this.rpcCall(
                  deleteHorseGeneralVetComment,
                  $root.stronachgroup.first.racehorse360
                    .DeleteHorseGeneralVetCommentRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteHorseGeneralVetComment" }
          );

          /**
           * Calls DeleteHorseGeneralVetComment.
           * @function deleteHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseGeneralVetCommentRequest} request DeleteHorseGeneralVetCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#getHorseGeneralVetComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef GetHorseGeneralVetCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseGeneralVetComment} [response] HorseGeneralVetComment
           */

          /**
           * Calls GetHorseGeneralVetComment.
           * @function getHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseGeneralVetCommentRequest} request GetHorseGeneralVetCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.GetHorseGeneralVetCommentCallback} callback Node-style callback called with the error, if any, and HorseGeneralVetComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.getHorseGeneralVetComment =
              function getHorseGeneralVetComment(request, callback) {
                return this.rpcCall(
                  getHorseGeneralVetComment,
                  $root.stronachgroup.first.racehorse360
                    .GetHorseGeneralVetCommentRequest,
                  $root.stronachgroup.first.racehorse360.HorseGeneralVetComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetHorseGeneralVetComment" }
          );

          /**
           * Calls GetHorseGeneralVetComment.
           * @function getHorseGeneralVetComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseGeneralVetCommentRequest} request GetHorseGeneralVetCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseGeneralVetComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsesOrTrainersByName}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsesOrTrainersByNameCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse} [response] PullHorsesOrTrainersResponse
           */

          /**
           * Calls PullHorsesOrTrainersByName.
           * @function pullHorsesOrTrainersByName
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersRequest} request PullHorsesOrTrainersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsesOrTrainersByNameCallback} callback Node-style callback called with the error, if any, and PullHorsesOrTrainersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsesOrTrainersByName =
              function pullHorsesOrTrainersByName(request, callback) {
                return this.rpcCall(
                  pullHorsesOrTrainersByName,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesOrTrainersRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesOrTrainersResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsesOrTrainersByName" }
          );

          /**
           * Calls PullHorsesOrTrainersByName.
           * @function pullHorsesOrTrainersByName
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesOrTrainersRequest} request PullHorsesOrTrainersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsesOrTrainersResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#setHorseFlagOnTrack}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef SetHorseFlagOnTrackCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls SetHorseFlagOnTrack.
           * @function setHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetHorseFlagOnTrackRequest} request SetHorseFlagOnTrackRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.SetHorseFlagOnTrackCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.setHorseFlagOnTrack =
              function setHorseFlagOnTrack(request, callback) {
                return this.rpcCall(
                  setHorseFlagOnTrack,
                  $root.stronachgroup.first.racehorse360
                    .SetHorseFlagOnTrackRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetHorseFlagOnTrack" }
          );

          /**
           * Calls SetHorseFlagOnTrack.
           * @function setHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetHorseFlagOnTrackRequest} request SetHorseFlagOnTrackRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#editHorseFlagOnTrack}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef EditHorseFlagOnTrackCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls EditHorseFlagOnTrack.
           * @function editHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseFlagOnTrackRequest} request EditHorseFlagOnTrackRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.EditHorseFlagOnTrackCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.editHorseFlagOnTrack =
              function editHorseFlagOnTrack(request, callback) {
                return this.rpcCall(
                  editHorseFlagOnTrack,
                  $root.stronachgroup.first.racehorse360
                    .EditHorseFlagOnTrackRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "EditHorseFlagOnTrack" }
          );

          /**
           * Calls EditHorseFlagOnTrack.
           * @function editHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditHorseFlagOnTrackRequest} request EditHorseFlagOnTrackRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#resetHorseFlagOnTrack}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ResetHorseFlagOnTrackCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Horse} [response] Horse
           */

          /**
           * Calls ResetHorseFlagOnTrack.
           * @function resetHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetHorseFlagOnTrackRequest} request ResetHorseFlagOnTrackRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ResetHorseFlagOnTrackCallback} callback Node-style callback called with the error, if any, and Horse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.resetHorseFlagOnTrack =
              function resetHorseFlagOnTrack(request, callback) {
                return this.rpcCall(
                  resetHorseFlagOnTrack,
                  $root.stronachgroup.first.racehorse360
                    .ResetHorseFlagOnTrackRequest,
                  $root.stronachgroup.first.racehorse360.Horse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetHorseFlagOnTrack" }
          );

          /**
           * Calls ResetHorseFlagOnTrack.
           * @function resetHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetHorseFlagOnTrackRequest} request ResetHorseFlagOnTrackRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Horse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#deleteHorseFlagOnTrack}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef DeleteHorseFlagOnTrackCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseFlagOnTrack.
           * @function deleteHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackRequest} request DeleteHorseFlagOnTrackRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.DeleteHorseFlagOnTrackCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.deleteHorseFlagOnTrack =
              function deleteHorseFlagOnTrack(request, callback) {
                return this.rpcCall(
                  deleteHorseFlagOnTrack,
                  $root.stronachgroup.first.racehorse360
                    .DeleteHorseFlagOnTrackRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteHorseFlagOnTrack" }
          );

          /**
           * Calls DeleteHorseFlagOnTrack.
           * @function deleteHorseFlagOnTrack
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackRequest} request DeleteHorseFlagOnTrackRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#getHorseFlagOnTrackComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef GetHorseFlagOnTrackCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.HorseFlagOnTrackComment} [response] HorseFlagOnTrackComment
           */

          /**
           * Calls GetHorseFlagOnTrackComment.
           * @function getHorseFlagOnTrackComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseFlagOnTrackCommentRequest} request GetHorseFlagOnTrackCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.GetHorseFlagOnTrackCommentCallback} callback Node-style callback called with the error, if any, and HorseFlagOnTrackComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.getHorseFlagOnTrackComment =
              function getHorseFlagOnTrackComment(request, callback) {
                return this.rpcCall(
                  getHorseFlagOnTrackComment,
                  $root.stronachgroup.first.racehorse360
                    .GetHorseFlagOnTrackCommentRequest,
                  $root.stronachgroup.first.racehorse360
                    .HorseFlagOnTrackComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetHorseFlagOnTrackComment" }
          );

          /**
           * Calls GetHorseFlagOnTrackComment.
           * @function getHorseFlagOnTrackComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetHorseFlagOnTrackCommentRequest} request GetHorseFlagOnTrackCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.HorseFlagOnTrackComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#listHorseFlagOnTrackComments}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef ListHorseFlagOnTrackCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse} [response] ListHorseFlagOnTrackCommentsResponse
           */

          /**
           * Calls ListHorseFlagOnTrackComments.
           * @function listHorseFlagOnTrackComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsRequest} request ListHorseFlagOnTrackCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.ListHorseFlagOnTrackCommentsCallback} callback Node-style callback called with the error, if any, and ListHorseFlagOnTrackCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.listHorseFlagOnTrackComments =
              function listHorseFlagOnTrackComments(request, callback) {
                return this.rpcCall(
                  listHorseFlagOnTrackComments,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseFlagOnTrackCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListHorseFlagOnTrackCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListHorseFlagOnTrackComments" }
          );

          /**
           * Calls ListHorseFlagOnTrackComments.
           * @function listHorseFlagOnTrackComments
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListHorseFlagOnTrackCommentsRequest} request ListHorseFlagOnTrackCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListHorseFlagOnTrackCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#deleteHorseFlagOnTrackComment}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef DeleteHorseFlagOnTrackCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteHorseFlagOnTrackComment.
           * @function deleteHorseFlagOnTrackComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackCommentRequest} request DeleteHorseFlagOnTrackCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.DeleteHorseFlagOnTrackCommentCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.deleteHorseFlagOnTrackComment =
              function deleteHorseFlagOnTrackComment(request, callback) {
                return this.rpcCall(
                  deleteHorseFlagOnTrackComment,
                  $root.stronachgroup.first.racehorse360
                    .DeleteHorseFlagOnTrackCommentRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteHorseFlagOnTrackComment" }
          );

          /**
           * Calls DeleteHorseFlagOnTrackComment.
           * @function deleteHorseFlagOnTrackComment
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteHorseFlagOnTrackCommentRequest} request DeleteHorseFlagOnTrackCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullInventoryAnalytics}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullInventoryAnalyticsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse} [response] PullInventoryAnalyticsResponse
           */

          /**
           * Calls PullInventoryAnalytics.
           * @function pullInventoryAnalytics
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsRequest} request PullInventoryAnalyticsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullInventoryAnalyticsCallback} callback Node-style callback called with the error, if any, and PullInventoryAnalyticsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullInventoryAnalytics =
              function pullInventoryAnalytics(request, callback) {
                return this.rpcCall(
                  pullInventoryAnalytics,
                  $root.stronachgroup.first.racehorse360
                    .PullInventoryAnalyticsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullInventoryAnalyticsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullInventoryAnalytics" }
          );

          /**
           * Calls PullInventoryAnalytics.
           * @function pullInventoryAnalytics
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullInventoryAnalyticsRequest} request PullInventoryAnalyticsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullInventoryAnalyticsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.HorseService#pullHorsesShortInfo}.
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @typedef PullHorsesShortInfoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullHorsesShortInfoResponse} [response] PullHorsesShortInfoResponse
           */

          /**
           * Calls PullHorsesShortInfo.
           * @function pullHorsesShortInfo
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoRequest} request PullHorsesShortInfoRequest message or plain object
           * @param {stronachgroup.first.racehorse360.HorseService.PullHorsesShortInfoCallback} callback Node-style callback called with the error, if any, and PullHorsesShortInfoResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (HorseService.prototype.pullHorsesShortInfo =
              function pullHorsesShortInfo(request, callback) {
                return this.rpcCall(
                  pullHorsesShortInfo,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesShortInfoRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullHorsesShortInfoResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullHorsesShortInfo" }
          );

          /**
           * Calls PullHorsesShortInfo.
           * @function pullHorsesShortInfo
           * @memberof stronachgroup.first.racehorse360.HorseService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullHorsesShortInfoRequest} request PullHorsesShortInfoRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullHorsesShortInfoResponse>} Promise
           * @variation 2
           */

          return HorseService;
        })();

        racehorse360.NotificationService = (function () {
          /**
           * Constructs a new NotificationService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a NotificationService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function NotificationService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (NotificationService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = NotificationService;

          /**
           * Creates new NotificationService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {NotificationService} RPC service. Useful where requests and/or responses are streamed.
           */
          NotificationService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.NotificationService#pullNotifications}.
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @typedef PullNotificationsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullNotificationsResponse} [response] PullNotificationsResponse
           */

          /**
           * Calls PullNotifications.
           * @function pullNotifications
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullNotificationsRequest} request PullNotificationsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.NotificationService.PullNotificationsCallback} callback Node-style callback called with the error, if any, and PullNotificationsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (NotificationService.prototype.pullNotifications =
              function pullNotifications(request, callback) {
                return this.rpcCall(
                  pullNotifications,
                  $root.stronachgroup.first.racehorse360
                    .PullNotificationsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullNotificationsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullNotifications" }
          );

          /**
           * Calls PullNotifications.
           * @function pullNotifications
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullNotificationsRequest} request PullNotificationsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullNotificationsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.NotificationService#markNotificationsAsRead}.
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @typedef MarkNotificationsAsReadCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls MarkNotificationsAsRead.
           * @function markNotificationsAsRead
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMarkNotificationsAsReadRequest} request MarkNotificationsAsReadRequest message or plain object
           * @param {stronachgroup.first.racehorse360.NotificationService.MarkNotificationsAsReadCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (NotificationService.prototype.markNotificationsAsRead =
              function markNotificationsAsRead(request, callback) {
                return this.rpcCall(
                  markNotificationsAsRead,
                  $root.stronachgroup.first.racehorse360
                    .MarkNotificationsAsReadRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "MarkNotificationsAsRead" }
          );

          /**
           * Calls MarkNotificationsAsRead.
           * @function markNotificationsAsRead
           * @memberof stronachgroup.first.racehorse360.NotificationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMarkNotificationsAsReadRequest} request MarkNotificationsAsReadRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          return NotificationService;
        })();

        racehorse360.RaceConditionService = (function () {
          /**
           * Constructs a new RaceConditionService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceConditionService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function RaceConditionService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (RaceConditionService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = RaceConditionService;

          /**
           * Creates new RaceConditionService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {RaceConditionService} RPC service. Useful where requests and/or responses are streamed.
           */
          RaceConditionService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceConditionService#pullRaceConditions}.
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @typedef PullRaceConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsResponse} [response] PullRaceConditionsResponse
           */

          /**
           * Calls PullRaceConditions.
           * @function pullRaceConditions
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsRequest} request PullRaceConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceConditionService.PullRaceConditionsCallback} callback Node-style callback called with the error, if any, and PullRaceConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceConditionService.prototype.pullRaceConditions =
              function pullRaceConditions(request, callback) {
                return this.rpcCall(
                  pullRaceConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullRaceConditions" }
          );

          /**
           * Calls PullRaceConditions.
           * @function pullRaceConditions
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsRequest} request PullRaceConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullRaceConditionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceConditionService#pullRaceConditionsForHorse}.
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @typedef PullRaceConditionsForHorseCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse} [response] PullRaceConditionsForHorseResponse
           */

          /**
           * Calls PullRaceConditionsForHorse.
           * @function pullRaceConditionsForHorse
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseRequest} request PullRaceConditionsForHorseRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceConditionService.PullRaceConditionsForHorseCallback} callback Node-style callback called with the error, if any, and PullRaceConditionsForHorseResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceConditionService.prototype.pullRaceConditionsForHorse =
              function pullRaceConditionsForHorse(request, callback) {
                return this.rpcCall(
                  pullRaceConditionsForHorse,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsForHorseRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsForHorseResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullRaceConditionsForHorse" }
          );

          /**
           * Calls PullRaceConditionsForHorse.
           * @function pullRaceConditionsForHorse
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsForHorseRequest} request PullRaceConditionsForHorseRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceConditionService#pullRaceConditionsFacilities}.
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @typedef PullRaceConditionsFacilitiesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse} [response] PullRaceConditionsFacilitiesResponse
           */

          /**
           * Calls PullRaceConditionsFacilities.
           * @function pullRaceConditionsFacilities
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesRequest} request PullRaceConditionsFacilitiesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceConditionService.PullRaceConditionsFacilitiesCallback} callback Node-style callback called with the error, if any, and PullRaceConditionsFacilitiesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceConditionService.prototype.pullRaceConditionsFacilities =
              function pullRaceConditionsFacilities(request, callback) {
                return this.rpcCall(
                  pullRaceConditionsFacilities,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsFacilitiesRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullRaceConditionsFacilitiesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullRaceConditionsFacilities" }
          );

          /**
           * Calls PullRaceConditionsFacilities.
           * @function pullRaceConditionsFacilities
           * @memberof stronachgroup.first.racehorse360.RaceConditionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRaceConditionsFacilitiesRequest} request PullRaceConditionsFacilitiesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse>} Promise
           * @variation 2
           */

          return RaceConditionService;
        })();

        racehorse360.RaceService = (function () {
          /**
           * Constructs a new RaceService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RaceService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function RaceService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (RaceService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = RaceService;

          /**
           * Creates new RaceService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {RaceService} RPC service. Useful where requests and/or responses are streamed.
           */
          RaceService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceService#listRace}.
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @typedef ListRaceCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRacesResponse} [response] ListRacesResponse
           */

          /**
           * Calls ListRace.
           * @function listRace
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRacesRequest} request ListRacesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceService.ListRaceCallback} callback Node-style callback called with the error, if any, and ListRacesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceService.prototype.listRace = function listRace(
              request,
              callback
            ) {
              return this.rpcCall(
                listRace,
                $root.stronachgroup.first.racehorse360.ListRacesRequest,
                $root.stronachgroup.first.racehorse360.ListRacesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListRace" }
          );

          /**
           * Calls ListRace.
           * @function listRace
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRacesRequest} request ListRacesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRacesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceService#listRaceHistories}.
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @typedef ListRaceHistoriesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRaceHistoriesResponse} [response] ListRaceHistoriesResponse
           */

          /**
           * Calls ListRaceHistories.
           * @function listRaceHistories
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesRequest} request ListRaceHistoriesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceService.ListRaceHistoriesCallback} callback Node-style callback called with the error, if any, and ListRaceHistoriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceService.prototype.listRaceHistories =
              function listRaceHistories(request, callback) {
                return this.rpcCall(
                  listRaceHistories,
                  $root.stronachgroup.first.racehorse360
                    .ListRaceHistoriesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListRaceHistoriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListRaceHistories" }
          );

          /**
           * Calls ListRaceHistories.
           * @function listRaceHistories
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRaceHistoriesRequest} request ListRaceHistoriesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRaceHistoriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceService#listRaceRestrictions}.
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @typedef ListRaceRestrictionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRaceRestrictionsResponse} [response] ListRaceRestrictionsResponse
           */

          /**
           * Calls ListRaceRestrictions.
           * @function listRaceRestrictions
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsRequest} request ListRaceRestrictionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceService.ListRaceRestrictionsCallback} callback Node-style callback called with the error, if any, and ListRaceRestrictionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceService.prototype.listRaceRestrictions =
              function listRaceRestrictions(request, callback) {
                return this.rpcCall(
                  listRaceRestrictions,
                  $root.stronachgroup.first.racehorse360
                    .ListRaceRestrictionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListRaceRestrictionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListRaceRestrictions" }
          );

          /**
           * Calls ListRaceRestrictions.
           * @function listRaceRestrictions
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRaceRestrictionsRequest} request ListRaceRestrictionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRaceRestrictionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RaceService#listUpcomingRaces}.
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @typedef ListUpcomingRacesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUpcomingRacesResponse} [response] ListUpcomingRacesResponse
           */

          /**
           * Calls ListUpcomingRaces.
           * @function listUpcomingRaces
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesRequest} request ListUpcomingRacesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RaceService.ListUpcomingRacesCallback} callback Node-style callback called with the error, if any, and ListUpcomingRacesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RaceService.prototype.listUpcomingRaces =
              function listUpcomingRaces(request, callback) {
                return this.rpcCall(
                  listUpcomingRaces,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRacesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRacesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListUpcomingRaces" }
          );

          /**
           * Calls ListUpcomingRaces.
           * @function listUpcomingRaces
           * @memberof stronachgroup.first.racehorse360.RaceService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUpcomingRacesRequest} request ListUpcomingRacesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUpcomingRacesResponse>} Promise
           * @variation 2
           */

          return RaceService;
        })();

        racehorse360.RegionService = (function () {
          /**
           * Constructs a new RegionService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RegionService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function RegionService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (RegionService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = RegionService;

          /**
           * Creates new RegionService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RegionService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {RegionService} RPC service. Useful where requests and/or responses are streamed.
           */
          RegionService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RegionService#pullRegionPreferredConditions}.
           * @memberof stronachgroup.first.racehorse360.RegionService
           * @typedef PullRegionPreferredConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse} [response] PullRegionPreferredConditionsResponse
           */

          /**
           * Calls PullRegionPreferredConditions.
           * @function pullRegionPreferredConditions
           * @memberof stronachgroup.first.racehorse360.RegionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsRequest} request PullRegionPreferredConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RegionService.PullRegionPreferredConditionsCallback} callback Node-style callback called with the error, if any, and PullRegionPreferredConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RegionService.prototype.pullRegionPreferredConditions =
              function pullRegionPreferredConditions(request, callback) {
                return this.rpcCall(
                  pullRegionPreferredConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullRegionPreferredConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullRegionPreferredConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullRegionPreferredConditions" }
          );

          /**
           * Calls PullRegionPreferredConditions.
           * @function pullRegionPreferredConditions
           * @memberof stronachgroup.first.racehorse360.RegionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullRegionPreferredConditionsRequest} request PullRegionPreferredConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse>} Promise
           * @variation 2
           */

          return RegionService;
        })();

        racehorse360.RolePermissionService = (function () {
          /**
           * Constructs a new RolePermissionService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a RolePermissionService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function RolePermissionService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (RolePermissionService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = RolePermissionService;

          /**
           * Creates new RolePermissionService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {RolePermissionService} RPC service. Useful where requests and/or responses are streamed.
           */
          RolePermissionService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RolePermissionService#listRoles}.
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @typedef ListRolesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRolesResponse} [response] ListRolesResponse
           */

          /**
           * Calls ListRoles.
           * @function listRoles
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRolesRequest} request ListRolesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RolePermissionService.ListRolesCallback} callback Node-style callback called with the error, if any, and ListRolesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RolePermissionService.prototype.listRoles = function listRoles(
              request,
              callback
            ) {
              return this.rpcCall(
                listRoles,
                $root.stronachgroup.first.racehorse360.ListRolesRequest,
                $root.stronachgroup.first.racehorse360.ListRolesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListRoles" }
          );

          /**
           * Calls ListRoles.
           * @function listRoles
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRolesRequest} request ListRolesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRolesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.RolePermissionService#listRolePermissions}.
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @typedef ListRolePermissionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListRolePermissionsResponse} [response] ListRolePermissionsResponse
           */

          /**
           * Calls ListRolePermissions.
           * @function listRolePermissions
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsRequest} request ListRolePermissionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.RolePermissionService.ListRolePermissionsCallback} callback Node-style callback called with the error, if any, and ListRolePermissionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (RolePermissionService.prototype.listRolePermissions =
              function listRolePermissions(request, callback) {
                return this.rpcCall(
                  listRolePermissions,
                  $root.stronachgroup.first.racehorse360
                    .ListRolePermissionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListRolePermissionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListRolePermissions" }
          );

          /**
           * Calls ListRolePermissions.
           * @function listRolePermissions
           * @memberof stronachgroup.first.racehorse360.RolePermissionService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListRolePermissionsRequest} request ListRolePermissionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListRolePermissionsResponse>} Promise
           * @variation 2
           */

          return RolePermissionService;
        })();

        racehorse360.StallApplicationService = (function () {
          /**
           * Constructs a new StallApplicationService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a StallApplicationService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function StallApplicationService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (StallApplicationService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = StallApplicationService;

          /**
           * Creates new StallApplicationService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {StallApplicationService} RPC service. Useful where requests and/or responses are streamed.
           */
          StallApplicationService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#listStallApplications}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef ListStallApplicationsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListStallApplicationsResponse} [response] ListStallApplicationsResponse
           */

          /**
           * Calls ListStallApplications.
           * @function listStallApplications
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsRequest} request ListStallApplicationsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.ListStallApplicationsCallback} callback Node-style callback called with the error, if any, and ListStallApplicationsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.listStallApplications =
              function listStallApplications(request, callback) {
                return this.rpcCall(
                  listStallApplications,
                  $root.stronachgroup.first.racehorse360
                    .ListStallApplicationsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListStallApplicationsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListStallApplications" }
          );

          /**
           * Calls ListStallApplications.
           * @function listStallApplications
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStallApplicationsRequest} request ListStallApplicationsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListStallApplicationsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#getStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef GetStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplication} [response] StallApplication
           */

          /**
           * Calls GetStallApplication.
           * @function getStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationRequest} request GetStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.GetStallApplicationCallback} callback Node-style callback called with the error, if any, and StallApplication
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.getStallApplication =
              function getStallApplication(request, callback) {
                return this.rpcCall(
                  getStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .GetStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.StallApplication,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetStallApplication" }
          );

          /**
           * Calls GetStallApplication.
           * @function getStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationRequest} request GetStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplication>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#deleteStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef DeleteStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteStallApplication.
           * @function deleteStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationRequest} request DeleteStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.DeleteStallApplicationCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.deleteStallApplication =
              function deleteStallApplication(request, callback) {
                return this.rpcCall(
                  deleteStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .DeleteStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteStallApplication" }
          );

          /**
           * Calls DeleteStallApplication.
           * @function deleteStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationRequest} request DeleteStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#updateStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef UpdateStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplication} [response] StallApplication
           */

          /**
           * Calls UpdateStallApplication.
           * @function updateStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationRequest} request UpdateStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.UpdateStallApplicationCallback} callback Node-style callback called with the error, if any, and StallApplication
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.updateStallApplication =
              function updateStallApplication(request, callback) {
                return this.rpcCall(
                  updateStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .UpdateStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.StallApplication,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateStallApplication" }
          );

          /**
           * Calls UpdateStallApplication.
           * @function updateStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationRequest} request UpdateStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplication>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#createStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef CreateStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplication} [response] StallApplication
           */

          /**
           * Calls CreateStallApplication.
           * @function createStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationRequest} request CreateStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.CreateStallApplicationCallback} callback Node-style callback called with the error, if any, and StallApplication
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.createStallApplication =
              function createStallApplication(request, callback) {
                return this.rpcCall(
                  createStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .CreateStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.StallApplication,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateStallApplication" }
          );

          /**
           * Calls CreateStallApplication.
           * @function createStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationRequest} request CreateStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplication>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#submitStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef SubmitStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls SubmitStallApplication.
           * @function submitStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISubmitStallApplicationRequest} request SubmitStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.SubmitStallApplicationCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.submitStallApplication =
              function submitStallApplication(request, callback) {
                return this.rpcCall(
                  submitStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .SubmitStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SubmitStallApplication" }
          );

          /**
           * Calls SubmitStallApplication.
           * @function submitStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISubmitStallApplicationRequest} request SubmitStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#withdrawStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef WithdrawStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls WithdrawStallApplication.
           * @function withdrawStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IWithdrawStallApplicationRequest} request WithdrawStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.WithdrawStallApplicationCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.withdrawStallApplication =
              function withdrawStallApplication(request, callback) {
                return this.rpcCall(
                  withdrawStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .WithdrawStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "WithdrawStallApplication" }
          );

          /**
           * Calls WithdrawStallApplication.
           * @function withdrawStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IWithdrawStallApplicationRequest} request WithdrawStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#completeStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef CompleteStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplication} [response] StallApplication
           */

          /**
           * Calls CompleteStallApplication.
           * @function completeStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteStallApplicationRequest} request CompleteStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.CompleteStallApplicationCallback} callback Node-style callback called with the error, if any, and StallApplication
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.completeStallApplication =
              function completeStallApplication(request, callback) {
                return this.rpcCall(
                  completeStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .CompleteStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.StallApplication,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CompleteStallApplication" }
          );

          /**
           * Calls CompleteStallApplication.
           * @function completeStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteStallApplicationRequest} request CompleteStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplication>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#saveDraftStallApplication}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef SaveDraftStallApplicationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplication} [response] StallApplication
           */

          /**
           * Calls SaveDraftStallApplication.
           * @function saveDraftStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISaveDraftStallApplicationRequest} request SaveDraftStallApplicationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.SaveDraftStallApplicationCallback} callback Node-style callback called with the error, if any, and StallApplication
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.saveDraftStallApplication =
              function saveDraftStallApplication(request, callback) {
                return this.rpcCall(
                  saveDraftStallApplication,
                  $root.stronachgroup.first.racehorse360
                    .SaveDraftStallApplicationRequest,
                  $root.stronachgroup.first.racehorse360.StallApplication,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SaveDraftStallApplication" }
          );

          /**
           * Calls SaveDraftStallApplication.
           * @function saveDraftStallApplication
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISaveDraftStallApplicationRequest} request SaveDraftStallApplicationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplication>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#listStableEntries}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef ListStableEntriesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListStableEntriesResponse} [response] ListStableEntriesResponse
           */

          /**
           * Calls ListStableEntries.
           * @function listStableEntries
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStableEntriesRequest} request ListStableEntriesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.ListStableEntriesCallback} callback Node-style callback called with the error, if any, and ListStableEntriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.listStableEntries =
              function listStableEntries(request, callback) {
                return this.rpcCall(
                  listStableEntries,
                  $root.stronachgroup.first.racehorse360
                    .ListStableEntriesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListStableEntriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListStableEntries" }
          );

          /**
           * Calls ListStableEntries.
           * @function listStableEntries
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStableEntriesRequest} request ListStableEntriesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListStableEntriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#getStableEntry}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef GetStableEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StableEntry} [response] StableEntry
           */

          /**
           * Calls GetStableEntry.
           * @function getStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStableEntryRequest} request GetStableEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.GetStableEntryCallback} callback Node-style callback called with the error, if any, and StableEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.getStableEntry =
              function getStableEntry(request, callback) {
                return this.rpcCall(
                  getStableEntry,
                  $root.stronachgroup.first.racehorse360.GetStableEntryRequest,
                  $root.stronachgroup.first.racehorse360.StableEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetStableEntry" }
          );

          /**
           * Calls GetStableEntry.
           * @function getStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStableEntryRequest} request GetStableEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StableEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#deleteStableEntry}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef DeleteStableEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteStableEntry.
           * @function deleteStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStableEntryRequest} request DeleteStableEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.DeleteStableEntryCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.deleteStableEntry =
              function deleteStableEntry(request, callback) {
                return this.rpcCall(
                  deleteStableEntry,
                  $root.stronachgroup.first.racehorse360
                    .DeleteStableEntryRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteStableEntry" }
          );

          /**
           * Calls DeleteStableEntry.
           * @function deleteStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStableEntryRequest} request DeleteStableEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#updateStableEntry}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef UpdateStableEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StableEntry} [response] StableEntry
           */

          /**
           * Calls UpdateStableEntry.
           * @function updateStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStableEntryRequest} request UpdateStableEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.UpdateStableEntryCallback} callback Node-style callback called with the error, if any, and StableEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.updateStableEntry =
              function updateStableEntry(request, callback) {
                return this.rpcCall(
                  updateStableEntry,
                  $root.stronachgroup.first.racehorse360
                    .UpdateStableEntryRequest,
                  $root.stronachgroup.first.racehorse360.StableEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateStableEntry" }
          );

          /**
           * Calls UpdateStableEntry.
           * @function updateStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStableEntryRequest} request UpdateStableEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StableEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#createStableEntry}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef CreateStableEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StableEntry} [response] StableEntry
           */

          /**
           * Calls CreateStableEntry.
           * @function createStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStableEntryRequest} request CreateStableEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.CreateStableEntryCallback} callback Node-style callback called with the error, if any, and StableEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.createStableEntry =
              function createStableEntry(request, callback) {
                return this.rpcCall(
                  createStableEntry,
                  $root.stronachgroup.first.racehorse360
                    .CreateStableEntryRequest,
                  $root.stronachgroup.first.racehorse360.StableEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateStableEntry" }
          );

          /**
           * Calls CreateStableEntry.
           * @function createStableEntry
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStableEntryRequest} request CreateStableEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StableEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#getStallApplicationForm}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef GetStallApplicationFormCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplicationForm} [response] StallApplicationForm
           */

          /**
           * Calls GetStallApplicationForm.
           * @function getStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationFormRequest} request GetStallApplicationFormRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.GetStallApplicationFormCallback} callback Node-style callback called with the error, if any, and StallApplicationForm
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.getStallApplicationForm =
              function getStallApplicationForm(request, callback) {
                return this.rpcCall(
                  getStallApplicationForm,
                  $root.stronachgroup.first.racehorse360
                    .GetStallApplicationFormRequest,
                  $root.stronachgroup.first.racehorse360.StallApplicationForm,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetStallApplicationForm" }
          );

          /**
           * Calls GetStallApplicationForm.
           * @function getStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetStallApplicationFormRequest} request GetStallApplicationFormRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplicationForm>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#deleteStallApplicationForm}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef DeleteStallApplicationFormCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteStallApplicationForm.
           * @function deleteStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationFormRequest} request DeleteStallApplicationFormRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.DeleteStallApplicationFormCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.deleteStallApplicationForm =
              function deleteStallApplicationForm(request, callback) {
                return this.rpcCall(
                  deleteStallApplicationForm,
                  $root.stronachgroup.first.racehorse360
                    .DeleteStallApplicationFormRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteStallApplicationForm" }
          );

          /**
           * Calls DeleteStallApplicationForm.
           * @function deleteStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteStallApplicationFormRequest} request DeleteStallApplicationFormRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#updateStallApplicationForm}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef UpdateStallApplicationFormCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplicationForm} [response] StallApplicationForm
           */

          /**
           * Calls UpdateStallApplicationForm.
           * @function updateStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationFormRequest} request UpdateStallApplicationFormRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.UpdateStallApplicationFormCallback} callback Node-style callback called with the error, if any, and StallApplicationForm
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.updateStallApplicationForm =
              function updateStallApplicationForm(request, callback) {
                return this.rpcCall(
                  updateStallApplicationForm,
                  $root.stronachgroup.first.racehorse360
                    .UpdateStallApplicationFormRequest,
                  $root.stronachgroup.first.racehorse360.StallApplicationForm,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateStallApplicationForm" }
          );

          /**
           * Calls UpdateStallApplicationForm.
           * @function updateStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateStallApplicationFormRequest} request UpdateStallApplicationFormRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplicationForm>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#createStallApplicationForm}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef CreateStallApplicationFormCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.StallApplicationForm} [response] StallApplicationForm
           */

          /**
           * Calls CreateStallApplicationForm.
           * @function createStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationFormRequest} request CreateStallApplicationFormRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.CreateStallApplicationFormCallback} callback Node-style callback called with the error, if any, and StallApplicationForm
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.createStallApplicationForm =
              function createStallApplicationForm(request, callback) {
                return this.rpcCall(
                  createStallApplicationForm,
                  $root.stronachgroup.first.racehorse360
                    .CreateStallApplicationFormRequest,
                  $root.stronachgroup.first.racehorse360.StallApplicationForm,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateStallApplicationForm" }
          );

          /**
           * Calls CreateStallApplicationForm.
           * @function createStallApplicationForm
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateStallApplicationFormRequest} request CreateStallApplicationFormRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.StallApplicationForm>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#listStallApplicationForms}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef ListStallApplicationFormsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListStallApplicationFormsResponse} [response] ListStallApplicationFormsResponse
           */

          /**
           * Calls ListStallApplicationForms.
           * @function listStallApplicationForms
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsRequest} request ListStallApplicationFormsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.ListStallApplicationFormsCallback} callback Node-style callback called with the error, if any, and ListStallApplicationFormsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.listStallApplicationForms =
              function listStallApplicationForms(request, callback) {
                return this.rpcCall(
                  listStallApplicationForms,
                  $root.stronachgroup.first.racehorse360
                    .ListStallApplicationFormsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListStallApplicationFormsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListStallApplicationForms" }
          );

          /**
           * Calls ListStallApplicationForms.
           * @function listStallApplicationForms
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListStallApplicationFormsRequest} request ListStallApplicationFormsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListStallApplicationFormsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#setFacilityOptions}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef SetFacilityOptionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls SetFacilityOptions.
           * @function setFacilityOptions
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetFacilityOptionsRequest} request SetFacilityOptionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.SetFacilityOptionsCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.setFacilityOptions =
              function setFacilityOptions(request, callback) {
                return this.rpcCall(
                  setFacilityOptions,
                  $root.stronachgroup.first.racehorse360
                    .SetFacilityOptionsRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetFacilityOptions" }
          );

          /**
           * Calls SetFacilityOptions.
           * @function setFacilityOptions
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetFacilityOptionsRequest} request SetFacilityOptionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#setFacilityPreferences}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef SetFacilityPreferencesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls SetFacilityPreferences.
           * @function setFacilityPreferences
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetFacilityPreferencesRequest} request SetFacilityPreferencesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.SetFacilityPreferencesCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.setFacilityPreferences =
              function setFacilityPreferences(request, callback) {
                return this.rpcCall(
                  setFacilityPreferences,
                  $root.stronachgroup.first.racehorse360
                    .SetFacilityPreferencesRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetFacilityPreferences" }
          );

          /**
           * Calls SetFacilityPreferences.
           * @function setFacilityPreferences
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetFacilityPreferencesRequest} request SetFacilityPreferencesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#pullStallApplicationFormTermsFileSignedUrl}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef PullStallApplicationFormTermsFileSignedUrlCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse} [response] PullStallApplicationFormTermsFileSignedUrlResponse
           */

          /**
           * Calls PullStallApplicationFormTermsFileSignedUrl.
           * @function pullStallApplicationFormTermsFileSignedUrl
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlRequest} request PullStallApplicationFormTermsFileSignedUrlRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.PullStallApplicationFormTermsFileSignedUrlCallback} callback Node-style callback called with the error, if any, and PullStallApplicationFormTermsFileSignedUrlResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.pullStallApplicationFormTermsFileSignedUrl =
              function pullStallApplicationFormTermsFileSignedUrl(
                request,
                callback
              ) {
                return this.rpcCall(
                  pullStallApplicationFormTermsFileSignedUrl,
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormTermsFileSignedUrlRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormTermsFileSignedUrlResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullStallApplicationFormTermsFileSignedUrl" }
          );

          /**
           * Calls PullStallApplicationFormTermsFileSignedUrl.
           * @function pullStallApplicationFormTermsFileSignedUrl
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormTermsFileSignedUrlRequest} request PullStallApplicationFormTermsFileSignedUrlRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.StallApplicationService#pullStallApplicationFormSummary}.
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @typedef PullStallApplicationFormSummaryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse} [response] PullStallApplicationFormSummaryResponse
           */

          /**
           * Calls PullStallApplicationFormSummary.
           * @function pullStallApplicationFormSummary
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryRequest} request PullStallApplicationFormSummaryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.StallApplicationService.PullStallApplicationFormSummaryCallback} callback Node-style callback called with the error, if any, and PullStallApplicationFormSummaryResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (StallApplicationService.prototype.pullStallApplicationFormSummary =
              function pullStallApplicationFormSummary(request, callback) {
                return this.rpcCall(
                  pullStallApplicationFormSummary,
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormSummaryRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullStallApplicationFormSummaryResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullStallApplicationFormSummary" }
          );

          /**
           * Calls PullStallApplicationFormSummary.
           * @function pullStallApplicationFormSummary
           * @memberof stronachgroup.first.racehorse360.StallApplicationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullStallApplicationFormSummaryRequest} request PullStallApplicationFormSummaryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse>} Promise
           * @variation 2
           */

          return StallApplicationService;
        })();

        racehorse360.TrackOpticsVideoService = (function () {
          /**
           * Constructs a new TrackOpticsVideoService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrackOpticsVideoService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function TrackOpticsVideoService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (TrackOpticsVideoService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = TrackOpticsVideoService;

          /**
           * Creates new TrackOpticsVideoService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {TrackOpticsVideoService} RPC service. Useful where requests and/or responses are streamed.
           */
          TrackOpticsVideoService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#listTrackOpticsVideos}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef ListTrackOpticsVideosCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse} [response] ListTrackOpticsVideosResponse
           */

          /**
           * Calls ListTrackOpticsVideos.
           * @function listTrackOpticsVideos
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosRequest} request ListTrackOpticsVideosRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.ListTrackOpticsVideosCallback} callback Node-style callback called with the error, if any, and ListTrackOpticsVideosResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.listTrackOpticsVideos =
              function listTrackOpticsVideos(request, callback) {
                return this.rpcCall(
                  listTrackOpticsVideos,
                  $root.stronachgroup.first.racehorse360
                    .ListTrackOpticsVideosRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListTrackOpticsVideosResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListTrackOpticsVideos" }
          );

          /**
           * Calls ListTrackOpticsVideos.
           * @function listTrackOpticsVideos
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListTrackOpticsVideosRequest} request ListTrackOpticsVideosRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListTrackOpticsVideosResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#getTrackOpticsVideo}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef GetTrackOpticsVideoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideo} [response] TrackOpticsVideo
           */

          /**
           * Calls GetTrackOpticsVideo.
           * @function getTrackOpticsVideo
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetTrackOpticsVideoRequest} request GetTrackOpticsVideoRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.GetTrackOpticsVideoCallback} callback Node-style callback called with the error, if any, and TrackOpticsVideo
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.getTrackOpticsVideo =
              function getTrackOpticsVideo(request, callback) {
                return this.rpcCall(
                  getTrackOpticsVideo,
                  $root.stronachgroup.first.racehorse360
                    .GetTrackOpticsVideoRequest,
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideo,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetTrackOpticsVideo" }
          );

          /**
           * Calls GetTrackOpticsVideo.
           * @function getTrackOpticsVideo
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetTrackOpticsVideoRequest} request GetTrackOpticsVideoRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.TrackOpticsVideo>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#submitTrackOpticsVideo}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef SubmitTrackOpticsVideoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideo} [response] TrackOpticsVideo
           */

          /**
           * Calls SubmitTrackOpticsVideo.
           * @function submitTrackOpticsVideo
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISubmitTrackOpticsVideoRequest} request SubmitTrackOpticsVideoRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.SubmitTrackOpticsVideoCallback} callback Node-style callback called with the error, if any, and TrackOpticsVideo
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.submitTrackOpticsVideo =
              function submitTrackOpticsVideo(request, callback) {
                return this.rpcCall(
                  submitTrackOpticsVideo,
                  $root.stronachgroup.first.racehorse360
                    .SubmitTrackOpticsVideoRequest,
                  $root.stronachgroup.first.racehorse360.TrackOpticsVideo,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SubmitTrackOpticsVideo" }
          );

          /**
           * Calls SubmitTrackOpticsVideo.
           * @function submitTrackOpticsVideo
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISubmitTrackOpticsVideoRequest} request SubmitTrackOpticsVideoRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.TrackOpticsVideo>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#pullTrackOpticsVideoConditions}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef PullTrackOpticsVideoConditionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse} [response] PullTrackOpticsVideoConditionsResponse
           */

          /**
           * Calls PullTrackOpticsVideoConditions.
           * @function pullTrackOpticsVideoConditions
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsRequest} request PullTrackOpticsVideoConditionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.PullTrackOpticsVideoConditionsCallback} callback Node-style callback called with the error, if any, and PullTrackOpticsVideoConditionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.pullTrackOpticsVideoConditions =
              function pullTrackOpticsVideoConditions(request, callback) {
                return this.rpcCall(
                  pullTrackOpticsVideoConditions,
                  $root.stronachgroup.first.racehorse360
                    .PullTrackOpticsVideoConditionsRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullTrackOpticsVideoConditionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullTrackOpticsVideoConditions" }
          );

          /**
           * Calls PullTrackOpticsVideoConditions.
           * @function pullTrackOpticsVideoConditions
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoConditionsRequest} request PullTrackOpticsVideoConditionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullTrackOpticsVideoConditionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#pullTrackOpticsVideoFileSignedUrl}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef PullTrackOpticsVideoFileSignedUrlCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse} [response] PullTrackOpticsVideoFileSignedUrlResponse
           */

          /**
           * Calls PullTrackOpticsVideoFileSignedUrl.
           * @function pullTrackOpticsVideoFileSignedUrl
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlRequest} request PullTrackOpticsVideoFileSignedUrlRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.PullTrackOpticsVideoFileSignedUrlCallback} callback Node-style callback called with the error, if any, and PullTrackOpticsVideoFileSignedUrlResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.pullTrackOpticsVideoFileSignedUrl =
              function pullTrackOpticsVideoFileSignedUrl(request, callback) {
                return this.rpcCall(
                  pullTrackOpticsVideoFileSignedUrl,
                  $root.stronachgroup.first.racehorse360
                    .PullTrackOpticsVideoFileSignedUrlRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullTrackOpticsVideoFileSignedUrlResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullTrackOpticsVideoFileSignedUrl" }
          );

          /**
           * Calls PullTrackOpticsVideoFileSignedUrl.
           * @function pullTrackOpticsVideoFileSignedUrl
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullTrackOpticsVideoFileSignedUrlRequest} request PullTrackOpticsVideoFileSignedUrlRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullTrackOpticsVideoFileSignedUrlResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrackOpticsVideoService#handleTrackOpticsVideoPubsub}.
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @typedef HandleTrackOpticsVideoPubsubCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls HandleTrackOpticsVideoPubsub.
           * @function handleTrackOpticsVideoPubsub
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IHandleTrackOpticsVideoPubsubRequest} request HandleTrackOpticsVideoPubsubRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrackOpticsVideoService.HandleTrackOpticsVideoPubsubCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrackOpticsVideoService.prototype.handleTrackOpticsVideoPubsub =
              function handleTrackOpticsVideoPubsub(request, callback) {
                return this.rpcCall(
                  handleTrackOpticsVideoPubsub,
                  $root.stronachgroup.first.racehorse360
                    .HandleTrackOpticsVideoPubsubRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "HandleTrackOpticsVideoPubsub" }
          );

          /**
           * Calls HandleTrackOpticsVideoPubsub.
           * @function handleTrackOpticsVideoPubsub
           * @memberof stronachgroup.first.racehorse360.TrackOpticsVideoService
           * @instance
           * @param {stronachgroup.first.racehorse360.IHandleTrackOpticsVideoPubsubRequest} request HandleTrackOpticsVideoPubsubRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          return TrackOpticsVideoService;
        })();

        racehorse360.TrainerService = (function () {
          /**
           * Constructs a new TrainerService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a TrainerService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function TrainerService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (TrainerService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = TrainerService;

          /**
           * Creates new TrainerService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {TrainerService} RPC service. Useful where requests and/or responses are streamed.
           */
          TrainerService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrainerService#getTrainer}.
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @typedef GetTrainerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Trainer} [response] Trainer
           */

          /**
           * Calls GetTrainer.
           * @function getTrainer
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetTrainerRequest} request GetTrainerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrainerService.GetTrainerCallback} callback Node-style callback called with the error, if any, and Trainer
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrainerService.prototype.getTrainer = function getTrainer(
              request,
              callback
            ) {
              return this.rpcCall(
                getTrainer,
                $root.stronachgroup.first.racehorse360.GetTrainerRequest,
                $root.stronachgroup.first.racehorse360.Trainer,
                request,
                callback
              );
            }),
            "name",
            { value: "GetTrainer" }
          );

          /**
           * Calls GetTrainer.
           * @function getTrainer
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetTrainerRequest} request GetTrainerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Trainer>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.TrainerService#listTrainers}.
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @typedef ListTrainersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListTrainersResponse} [response] ListTrainersResponse
           */

          /**
           * Calls ListTrainers.
           * @function listTrainers
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListTrainersRequest} request ListTrainersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.TrainerService.ListTrainersCallback} callback Node-style callback called with the error, if any, and ListTrainersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (TrainerService.prototype.listTrainers = function listTrainers(
              request,
              callback
            ) {
              return this.rpcCall(
                listTrainers,
                $root.stronachgroup.first.racehorse360.ListTrainersRequest,
                $root.stronachgroup.first.racehorse360.ListTrainersResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListTrainers" }
          );

          /**
           * Calls ListTrainers.
           * @function listTrainers
           * @memberof stronachgroup.first.racehorse360.TrainerService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListTrainersRequest} request ListTrainersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListTrainersResponse>} Promise
           * @variation 2
           */

          return TrainerService;
        })();

        racehorse360.UpcomingRaceEntryService = (function () {
          /**
           * Constructs a new UpcomingRaceEntryService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents an UpcomingRaceEntryService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function UpcomingRaceEntryService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (UpcomingRaceEntryService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = UpcomingRaceEntryService;

          /**
           * Creates new UpcomingRaceEntryService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {UpcomingRaceEntryService} RPC service. Useful where requests and/or responses are streamed.
           */
          UpcomingRaceEntryService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#listUpcomingRaceEntries}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef ListUpcomingRaceEntriesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} [response] ListUpcomingRaceEntriesResponse
           */

          /**
           * Calls ListUpcomingRaceEntries.
           * @function listUpcomingRaceEntries
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesRequest} request ListUpcomingRaceEntriesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.ListUpcomingRaceEntriesCallback} callback Node-style callback called with the error, if any, and ListUpcomingRaceEntriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.listUpcomingRaceEntries =
              function listUpcomingRaceEntries(request, callback) {
                return this.rpcCall(
                  listUpcomingRaceEntries,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRaceEntriesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRaceEntriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListUpcomingRaceEntries" }
          );

          /**
           * Calls ListUpcomingRaceEntries.
           * @function listUpcomingRaceEntries
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUpcomingRaceEntriesRequest} request ListUpcomingRaceEntriesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#getUpcomingRaceEntry}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef GetUpcomingRaceEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls GetUpcomingRaceEntry.
           * @function getUpcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUpcomingRaceEntryRequest} request GetUpcomingRaceEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.GetUpcomingRaceEntryCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.getUpcomingRaceEntry =
              function getUpcomingRaceEntry(request, callback) {
                return this.rpcCall(
                  getUpcomingRaceEntry,
                  $root.stronachgroup.first.racehorse360
                    .GetUpcomingRaceEntryRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetUpcomingRaceEntry" }
          );

          /**
           * Calls GetUpcomingRaceEntry.
           * @function getUpcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUpcomingRaceEntryRequest} request GetUpcomingRaceEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#requireUpcomingRaceEntryExam}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef RequireUpcomingRaceEntryExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls RequireUpcomingRaceEntryExam.
           * @function requireUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRequireUpcomingRaceEntryExamRequest} request RequireUpcomingRaceEntryExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.RequireUpcomingRaceEntryExamCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.requireUpcomingRaceEntryExam =
              function requireUpcomingRaceEntryExam(request, callback) {
                return this.rpcCall(
                  requireUpcomingRaceEntryExam,
                  $root.stronachgroup.first.racehorse360
                    .RequireUpcomingRaceEntryExamRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RequireUpcomingRaceEntryExam" }
          );

          /**
           * Calls RequireUpcomingRaceEntryExam.
           * @function requireUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRequireUpcomingRaceEntryExamRequest} request RequireUpcomingRaceEntryExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#bulkAssignUpcomingRaceEntryExams}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef BulkAssignUpcomingRaceEntryExamsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} [response] ListUpcomingRaceEntriesResponse
           */

          /**
           * Calls BulkAssignUpcomingRaceEntryExams.
           * @function bulkAssignUpcomingRaceEntryExams
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkAssignUpcomingRaceEntryExamsRequest} request BulkAssignUpcomingRaceEntryExamsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.BulkAssignUpcomingRaceEntryExamsCallback} callback Node-style callback called with the error, if any, and ListUpcomingRaceEntriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.bulkAssignUpcomingRaceEntryExams =
              function bulkAssignUpcomingRaceEntryExams(request, callback) {
                return this.rpcCall(
                  bulkAssignUpcomingRaceEntryExams,
                  $root.stronachgroup.first.racehorse360
                    .BulkAssignUpcomingRaceEntryExamsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRaceEntriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "BulkAssignUpcomingRaceEntryExams" }
          );

          /**
           * Calls BulkAssignUpcomingRaceEntryExams.
           * @function bulkAssignUpcomingRaceEntryExams
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkAssignUpcomingRaceEntryExamsRequest} request BulkAssignUpcomingRaceEntryExamsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#unassignUpcomingRaceEntryExam}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef UnassignUpcomingRaceEntryExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls UnassignUpcomingRaceEntryExam.
           * @function unassignUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryExamRequest} request UnassignUpcomingRaceEntryExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.UnassignUpcomingRaceEntryExamCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.unassignUpcomingRaceEntryExam =
              function unassignUpcomingRaceEntryExam(request, callback) {
                return this.rpcCall(
                  unassignUpcomingRaceEntryExam,
                  $root.stronachgroup.first.racehorse360
                    .UnassignUpcomingRaceEntryExamRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignUpcomingRaceEntryExam" }
          );

          /**
           * Calls UnassignUpcomingRaceEntryExam.
           * @function unassignUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryExamRequest} request UnassignUpcomingRaceEntryExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#quickPassUpcomingRaceEntry}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef QuickPassUpcomingRaceEntryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls QuickPassUpcomingRaceEntry.
           * @function quickPassUpcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IQuickPassUpcomingRaceEntryRequest} request QuickPassUpcomingRaceEntryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.QuickPassUpcomingRaceEntryCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.quickPassUpcomingRaceEntry =
              function quickPassUpcomingRaceEntry(request, callback) {
                return this.rpcCall(
                  quickPassUpcomingRaceEntry,
                  $root.stronachgroup.first.racehorse360
                    .QuickPassUpcomingRaceEntryRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "QuickPassUpcomingRaceEntry" }
          );

          /**
           * Calls QuickPassUpcomingRaceEntry.
           * @function quickPassUpcomingRaceEntry
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IQuickPassUpcomingRaceEntryRequest} request QuickPassUpcomingRaceEntryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#revertQuickPassUpcomingRaceEntryExam}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef RevertQuickPassUpcomingRaceEntryExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls RevertQuickPassUpcomingRaceEntryExam.
           * @function revertQuickPassUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassUpcomingRaceEntryExamRequest} request RevertQuickPassUpcomingRaceEntryExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.RevertQuickPassUpcomingRaceEntryExamCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.revertQuickPassUpcomingRaceEntryExam =
              function revertQuickPassUpcomingRaceEntryExam(request, callback) {
                return this.rpcCall(
                  revertQuickPassUpcomingRaceEntryExam,
                  $root.stronachgroup.first.racehorse360
                    .RevertQuickPassUpcomingRaceEntryExamRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RevertQuickPassUpcomingRaceEntryExam" }
          );

          /**
           * Calls RevertQuickPassUpcomingRaceEntryExam.
           * @function revertQuickPassUpcomingRaceEntryExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassUpcomingRaceEntryExamRequest} request RevertQuickPassUpcomingRaceEntryExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#bulkRequireAndAssignUpcomingRaceEntryRaceDayExams}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse} [response] ListUpcomingRaceEntriesResponse
           */

          /**
           * Calls BulkRequireAndAssignUpcomingRaceEntryRaceDayExams.
           * @function bulkRequireAndAssignUpcomingRaceEntryRaceDayExams
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} request BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsCallback} callback Node-style callback called with the error, if any, and ListUpcomingRaceEntriesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
              function bulkRequireAndAssignUpcomingRaceEntryRaceDayExams(
                request,
                callback
              ) {
                return this.rpcCall(
                  bulkRequireAndAssignUpcomingRaceEntryRaceDayExams,
                  $root.stronachgroup.first.racehorse360
                    .BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListUpcomingRaceEntriesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "BulkRequireAndAssignUpcomingRaceEntryRaceDayExams" }
          );

          /**
           * Calls BulkRequireAndAssignUpcomingRaceEntryRaceDayExams.
           * @function bulkRequireAndAssignUpcomingRaceEntryRaceDayExams
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest} request BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#unassignUpcomingRaceEntryRaceDayExam}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef UnassignUpcomingRaceEntryRaceDayExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls UnassignUpcomingRaceEntryRaceDayExam.
           * @function unassignUpcomingRaceEntryRaceDayExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryRaceDayExamRequest} request UnassignUpcomingRaceEntryRaceDayExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.UnassignUpcomingRaceEntryRaceDayExamCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.unassignUpcomingRaceEntryRaceDayExam =
              function unassignUpcomingRaceEntryRaceDayExam(request, callback) {
                return this.rpcCall(
                  unassignUpcomingRaceEntryRaceDayExam,
                  $root.stronachgroup.first.racehorse360
                    .UnassignUpcomingRaceEntryRaceDayExamRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignUpcomingRaceEntryRaceDayExam" }
          );

          /**
           * Calls UnassignUpcomingRaceEntryRaceDayExam.
           * @function unassignUpcomingRaceEntryRaceDayExam
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignUpcomingRaceEntryRaceDayExamRequest} request UnassignUpcomingRaceEntryRaceDayExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#setUpcomingRaceEntryExamNote}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef SetUpcomingRaceEntryExamNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls SetUpcomingRaceEntryExamNote.
           * @function setUpcomingRaceEntryExamNote
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryExamNoteRequest} request SetUpcomingRaceEntryExamNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.SetUpcomingRaceEntryExamNoteCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.setUpcomingRaceEntryExamNote =
              function setUpcomingRaceEntryExamNote(request, callback) {
                return this.rpcCall(
                  setUpcomingRaceEntryExamNote,
                  $root.stronachgroup.first.racehorse360
                    .SetUpcomingRaceEntryExamNoteRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetUpcomingRaceEntryExamNote" }
          );

          /**
           * Calls SetUpcomingRaceEntryExamNote.
           * @function setUpcomingRaceEntryExamNote
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryExamNoteRequest} request SetUpcomingRaceEntryExamNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#resetUpcomingRaceEntryExamNote}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef ResetUpcomingRaceEntryExamNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls ResetUpcomingRaceEntryExamNote.
           * @function resetUpcomingRaceEntryExamNote
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryExamNoteRequest} request ResetUpcomingRaceEntryExamNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.ResetUpcomingRaceEntryExamNoteCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.resetUpcomingRaceEntryExamNote =
              function resetUpcomingRaceEntryExamNote(request, callback) {
                return this.rpcCall(
                  resetUpcomingRaceEntryExamNote,
                  $root.stronachgroup.first.racehorse360
                    .ResetUpcomingRaceEntryExamNoteRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetUpcomingRaceEntryExamNote" }
          );

          /**
           * Calls ResetUpcomingRaceEntryExamNote.
           * @function resetUpcomingRaceEntryExamNote
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryExamNoteRequest} request ResetUpcomingRaceEntryExamNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#setUpcomingRaceEntryFlag}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef SetUpcomingRaceEntryFlagCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls SetUpcomingRaceEntryFlag.
           * @function setUpcomingRaceEntryFlag
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryFlagRequest} request SetUpcomingRaceEntryFlagRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.SetUpcomingRaceEntryFlagCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.setUpcomingRaceEntryFlag =
              function setUpcomingRaceEntryFlag(request, callback) {
                return this.rpcCall(
                  setUpcomingRaceEntryFlag,
                  $root.stronachgroup.first.racehorse360
                    .SetUpcomingRaceEntryFlagRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetUpcomingRaceEntryFlag" }
          );

          /**
           * Calls SetUpcomingRaceEntryFlag.
           * @function setUpcomingRaceEntryFlag
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetUpcomingRaceEntryFlagRequest} request SetUpcomingRaceEntryFlagRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UpcomingRaceEntryService#resetUpcomingRaceEntryFlag}.
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @typedef ResetUpcomingRaceEntryFlagCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntry} [response] UpcomingRaceEntry
           */

          /**
           * Calls ResetUpcomingRaceEntryFlag.
           * @function resetUpcomingRaceEntryFlag
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryFlagRequest} request ResetUpcomingRaceEntryFlagRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UpcomingRaceEntryService.ResetUpcomingRaceEntryFlagCallback} callback Node-style callback called with the error, if any, and UpcomingRaceEntry
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UpcomingRaceEntryService.prototype.resetUpcomingRaceEntryFlag =
              function resetUpcomingRaceEntryFlag(request, callback) {
                return this.rpcCall(
                  resetUpcomingRaceEntryFlag,
                  $root.stronachgroup.first.racehorse360
                    .ResetUpcomingRaceEntryFlagRequest,
                  $root.stronachgroup.first.racehorse360.UpcomingRaceEntry,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetUpcomingRaceEntryFlag" }
          );

          /**
           * Calls ResetUpcomingRaceEntryFlag.
           * @function resetUpcomingRaceEntryFlag
           * @memberof stronachgroup.first.racehorse360.UpcomingRaceEntryService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetUpcomingRaceEntryFlagRequest} request ResetUpcomingRaceEntryFlagRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UpcomingRaceEntry>} Promise
           * @variation 2
           */

          return UpcomingRaceEntryService;
        })();

        racehorse360.UserService = (function () {
          /**
           * Constructs a new UserService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a UserService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function UserService(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (UserService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = UserService;

          /**
           * Creates new UserService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.UserService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {UserService} RPC service. Useful where requests and/or responses are streamed.
           */
          UserService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#findOrCreateUser}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef FindOrCreateUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.AuthUser} [response] AuthUser
           */

          /**
           * Calls FindOrCreateUser.
           * @function findOrCreateUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IFindOrCreateUserRequest} request FindOrCreateUserRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.FindOrCreateUserCallback} callback Node-style callback called with the error, if any, and AuthUser
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.findOrCreateUser = function findOrCreateUser(
              request,
              callback
            ) {
              return this.rpcCall(
                findOrCreateUser,
                $root.stronachgroup.first.racehorse360.FindOrCreateUserRequest,
                $root.stronachgroup.first.racehorse360.AuthUser,
                request,
                callback
              );
            }),
            "name",
            { value: "FindOrCreateUser" }
          );

          /**
           * Calls FindOrCreateUser.
           * @function findOrCreateUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IFindOrCreateUserRequest} request FindOrCreateUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.AuthUser>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#grantDeveloperAccess}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef GrantDeveloperAccessCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.User} [response] User
           */

          /**
           * Calls GrantDeveloperAccess.
           * @function grantDeveloperAccess
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGrantDeveloperAccessRequest} request GrantDeveloperAccessRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.GrantDeveloperAccessCallback} callback Node-style callback called with the error, if any, and User
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.grantDeveloperAccess =
              function grantDeveloperAccess(request, callback) {
                return this.rpcCall(
                  grantDeveloperAccess,
                  $root.stronachgroup.first.racehorse360
                    .GrantDeveloperAccessRequest,
                  $root.stronachgroup.first.racehorse360.User,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GrantDeveloperAccess" }
          );

          /**
           * Calls GrantDeveloperAccess.
           * @function grantDeveloperAccess
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGrantDeveloperAccessRequest} request GrantDeveloperAccessRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.User>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#assignRole}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef AssignRoleCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.User} [response] User
           */

          /**
           * Calls AssignRole.
           * @function assignRole
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignRoleRequest} request AssignRoleRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.AssignRoleCallback} callback Node-style callback called with the error, if any, and User
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.assignRole = function assignRole(
              request,
              callback
            ) {
              return this.rpcCall(
                assignRole,
                $root.stronachgroup.first.racehorse360.AssignRoleRequest,
                $root.stronachgroup.first.racehorse360.User,
                request,
                callback
              );
            }),
            "name",
            { value: "AssignRole" }
          );

          /**
           * Calls AssignRole.
           * @function assignRole
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignRoleRequest} request AssignRoleRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.User>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#removeRole}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef RemoveRoleCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.User} [response] User
           */

          /**
           * Calls RemoveRole.
           * @function removeRole
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRemoveRoleRequest} request RemoveRoleRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.RemoveRoleCallback} callback Node-style callback called with the error, if any, and User
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.removeRole = function removeRole(
              request,
              callback
            ) {
              return this.rpcCall(
                removeRole,
                $root.stronachgroup.first.racehorse360.RemoveRoleRequest,
                $root.stronachgroup.first.racehorse360.User,
                request,
                callback
              );
            }),
            "name",
            { value: "RemoveRole" }
          );

          /**
           * Calls RemoveRole.
           * @function removeRole
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRemoveRoleRequest} request RemoveRoleRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.User>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#getUser}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef GetUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.User} [response] User
           */

          /**
           * Calls GetUser.
           * @function getUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUserRequest} request GetUserRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.GetUserCallback} callback Node-style callback called with the error, if any, and User
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.getUser = function getUser(
              request,
              callback
            ) {
              return this.rpcCall(
                getUser,
                $root.stronachgroup.first.racehorse360.GetUserRequest,
                $root.stronachgroup.first.racehorse360.User,
                request,
                callback
              );
            }),
            "name",
            { value: "GetUser" }
          );

          /**
           * Calls GetUser.
           * @function getUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUserRequest} request GetUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.User>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#updateUserPreferences}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef UpdateUserPreferencesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UserPreferences} [response] UserPreferences
           */

          /**
           * Calls UpdateUserPreferences.
           * @function updateUserPreferences
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateUserPreferencesRequest} request UpdateUserPreferencesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.UpdateUserPreferencesCallback} callback Node-style callback called with the error, if any, and UserPreferences
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.updateUserPreferences =
              function updateUserPreferences(request, callback) {
                return this.rpcCall(
                  updateUserPreferences,
                  $root.stronachgroup.first.racehorse360
                    .UpdateUserPreferencesRequest,
                  $root.stronachgroup.first.racehorse360.UserPreferences,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateUserPreferences" }
          );

          /**
           * Calls UpdateUserPreferences.
           * @function updateUserPreferences
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateUserPreferencesRequest} request UpdateUserPreferencesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UserPreferences>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#editUser}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef EditUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.User} [response] User
           */

          /**
           * Calls EditUser.
           * @function editUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditUserRequest} request EditUserRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.EditUserCallback} callback Node-style callback called with the error, if any, and User
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.editUser = function editUser(
              request,
              callback
            ) {
              return this.rpcCall(
                editUser,
                $root.stronachgroup.first.racehorse360.EditUserRequest,
                $root.stronachgroup.first.racehorse360.User,
                request,
                callback
              );
            }),
            "name",
            { value: "EditUser" }
          );

          /**
           * Calls EditUser.
           * @function editUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditUserRequest} request EditUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.User>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#deleteUser}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef DeleteUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteUser.
           * @function deleteUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteUserRequest} request DeleteUserRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.DeleteUserCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.deleteUser = function deleteUser(
              request,
              callback
            ) {
              return this.rpcCall(
                deleteUser,
                $root.stronachgroup.first.racehorse360.DeleteUserRequest,
                $root.stronachgroup.first.racehorse360.EmptyResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "DeleteUser" }
          );

          /**
           * Calls DeleteUser.
           * @function deleteUser
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteUserRequest} request DeleteUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#listUsers}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef ListUsersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUserResponse} [response] ListUserResponse
           */

          /**
           * Calls ListUsers.
           * @function listUsers
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRequest} request ListUserRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.ListUsersCallback} callback Node-style callback called with the error, if any, and ListUserResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.listUsers = function listUsers(
              request,
              callback
            ) {
              return this.rpcCall(
                listUsers,
                $root.stronachgroup.first.racehorse360.ListUserRequest,
                $root.stronachgroup.first.racehorse360.ListUserResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListUsers" }
          );

          /**
           * Calls ListUsers.
           * @function listUsers
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRequest} request ListUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUserResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#listUserRoles}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef ListUserRolesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUserRolesResponse} [response] ListUserRolesResponse
           */

          /**
           * Calls ListUserRoles.
           * @function listUserRoles
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRolesRequest} request ListUserRolesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.ListUserRolesCallback} callback Node-style callback called with the error, if any, and ListUserRolesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.listUserRoles = function listUserRoles(
              request,
              callback
            ) {
              return this.rpcCall(
                listUserRoles,
                $root.stronachgroup.first.racehorse360.ListUserRolesRequest,
                $root.stronachgroup.first.racehorse360.ListUserRolesResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListUserRoles" }
          );

          /**
           * Calls ListUserRoles.
           * @function listUserRoles
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRolesRequest} request ListUserRolesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUserRolesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#getUserRoleRequest}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef GetUserRoleRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UserRoleRequest} [response] UserRoleRequest
           */

          /**
           * Calls GetUserRoleRequest.
           * @function getUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUserRoleRequestRequest} request GetUserRoleRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.GetUserRoleRequestCallback} callback Node-style callback called with the error, if any, and UserRoleRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.getUserRoleRequest =
              function getUserRoleRequest(request, callback) {
                return this.rpcCall(
                  getUserRoleRequest,
                  $root.stronachgroup.first.racehorse360
                    .GetUserRoleRequestRequest,
                  $root.stronachgroup.first.racehorse360.UserRoleRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetUserRoleRequest" }
          );

          /**
           * Calls GetUserRoleRequest.
           * @function getUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetUserRoleRequestRequest} request GetUserRoleRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UserRoleRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#createUserRoleRequest}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef CreateUserRoleRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UserRoleRequest} [response] UserRoleRequest
           */

          /**
           * Calls CreateUserRoleRequest.
           * @function createUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateUserRoleRequestRequest} request CreateUserRoleRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.CreateUserRoleRequestCallback} callback Node-style callback called with the error, if any, and UserRoleRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.createUserRoleRequest =
              function createUserRoleRequest(request, callback) {
                return this.rpcCall(
                  createUserRoleRequest,
                  $root.stronachgroup.first.racehorse360
                    .CreateUserRoleRequestRequest,
                  $root.stronachgroup.first.racehorse360.UserRoleRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateUserRoleRequest" }
          );

          /**
           * Calls CreateUserRoleRequest.
           * @function createUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateUserRoleRequestRequest} request CreateUserRoleRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UserRoleRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#listUserRoleRequests}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef ListUserRoleRequestsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListUserRoleRequestsResponse} [response] ListUserRoleRequestsResponse
           */

          /**
           * Calls ListUserRoleRequests.
           * @function listUserRoleRequests
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsRequest} request ListUserRoleRequestsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.ListUserRoleRequestsCallback} callback Node-style callback called with the error, if any, and ListUserRoleRequestsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.listUserRoleRequests =
              function listUserRoleRequests(request, callback) {
                return this.rpcCall(
                  listUserRoleRequests,
                  $root.stronachgroup.first.racehorse360
                    .ListUserRoleRequestsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListUserRoleRequestsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListUserRoleRequests" }
          );

          /**
           * Calls ListUserRoleRequests.
           * @function listUserRoleRequests
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListUserRoleRequestsRequest} request ListUserRoleRequestsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListUserRoleRequestsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#approveUserRoleRequest}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef ApproveUserRoleRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UserRoleRequest} [response] UserRoleRequest
           */

          /**
           * Calls ApproveUserRoleRequest.
           * @function approveUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IApproveUserRoleRequestRequest} request ApproveUserRoleRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.ApproveUserRoleRequestCallback} callback Node-style callback called with the error, if any, and UserRoleRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.approveUserRoleRequest =
              function approveUserRoleRequest(request, callback) {
                return this.rpcCall(
                  approveUserRoleRequest,
                  $root.stronachgroup.first.racehorse360
                    .ApproveUserRoleRequestRequest,
                  $root.stronachgroup.first.racehorse360.UserRoleRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ApproveUserRoleRequest" }
          );

          /**
           * Calls ApproveUserRoleRequest.
           * @function approveUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IApproveUserRoleRequestRequest} request ApproveUserRoleRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UserRoleRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#rejectUserRoleRequest}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef RejectUserRoleRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.UserRoleRequest} [response] UserRoleRequest
           */

          /**
           * Calls RejectUserRoleRequest.
           * @function rejectUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRejectUserRoleRequestRequest} request RejectUserRoleRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.RejectUserRoleRequestCallback} callback Node-style callback called with the error, if any, and UserRoleRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.rejectUserRoleRequest =
              function rejectUserRoleRequest(request, callback) {
                return this.rpcCall(
                  rejectUserRoleRequest,
                  $root.stronachgroup.first.racehorse360
                    .RejectUserRoleRequestRequest,
                  $root.stronachgroup.first.racehorse360.UserRoleRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RejectUserRoleRequest" }
          );

          /**
           * Calls RejectUserRoleRequest.
           * @function rejectUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRejectUserRoleRequestRequest} request RejectUserRoleRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.UserRoleRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#deleteUserRoleRequest}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef DeleteUserRoleRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteUserRoleRequest.
           * @function deleteUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteUserRoleRequestRequest} request DeleteUserRoleRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.DeleteUserRoleRequestCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.deleteUserRoleRequest =
              function deleteUserRoleRequest(request, callback) {
                return this.rpcCall(
                  deleteUserRoleRequest,
                  $root.stronachgroup.first.racehorse360
                    .DeleteUserRoleRequestRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteUserRoleRequest" }
          );

          /**
           * Calls DeleteUserRoleRequest.
           * @function deleteUserRoleRequest
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteUserRoleRequestRequest} request DeleteUserRoleRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#triggerPageLocker}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef TriggerPageLockerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.TriggerPageLockerResponse} [response] TriggerPageLockerResponse
           */

          /**
           * Calls TriggerPageLocker.
           * @function triggerPageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.TriggerPageLockerCallback} callback Node-style callback called with the error, if any, and TriggerPageLockerResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.triggerPageLocker =
              function triggerPageLocker(request, callback) {
                return this.rpcCall(
                  triggerPageLocker,
                  $root.stronachgroup.first.racehorse360.PageLockerRequest,
                  $root.stronachgroup.first.racehorse360
                    .TriggerPageLockerResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "TriggerPageLocker" }
          );

          /**
           * Calls TriggerPageLocker.
           * @function triggerPageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.TriggerPageLockerResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#releasePageLocker}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef ReleasePageLockerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls ReleasePageLocker.
           * @function releasePageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.ReleasePageLockerCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.releasePageLocker =
              function releasePageLocker(request, callback) {
                return this.rpcCall(
                  releasePageLocker,
                  $root.stronachgroup.first.racehorse360.PageLockerRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ReleasePageLocker" }
          );

          /**
           * Calls ReleasePageLocker.
           * @function releasePageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.UserService#pullPageLocker}.
           * @memberof stronachgroup.first.racehorse360.UserService
           * @typedef PullPageLockerCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullPageLockerResponse} [response] PullPageLockerResponse
           */

          /**
           * Calls PullPageLocker.
           * @function pullPageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @param {stronachgroup.first.racehorse360.UserService.PullPageLockerCallback} callback Node-style callback called with the error, if any, and PullPageLockerResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserService.prototype.pullPageLocker = function pullPageLocker(
              request,
              callback
            ) {
              return this.rpcCall(
                pullPageLocker,
                $root.stronachgroup.first.racehorse360.PageLockerRequest,
                $root.stronachgroup.first.racehorse360.PullPageLockerResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "PullPageLocker" }
          );

          /**
           * Calls PullPageLocker.
           * @function pullPageLocker
           * @memberof stronachgroup.first.racehorse360.UserService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPageLockerRequest} request PageLockerRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullPageLockerResponse>} Promise
           * @variation 2
           */

          return UserService;
        })();

        racehorse360.VaccinationService = (function () {
          /**
           * Constructs a new VaccinationService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a VaccinationService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function VaccinationService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (VaccinationService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = VaccinationService;

          /**
           * Creates new VaccinationService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {VaccinationService} RPC service. Useful where requests and/or responses are streamed.
           */
          VaccinationService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#listVaccinations}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef ListVaccinationsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListVaccinationsResponse} [response] ListVaccinationsResponse
           */

          /**
           * Calls ListVaccinations.
           * @function listVaccinations
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListVaccinationsRequest} request ListVaccinationsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.ListVaccinationsCallback} callback Node-style callback called with the error, if any, and ListVaccinationsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.listVaccinations =
              function listVaccinations(request, callback) {
                return this.rpcCall(
                  listVaccinations,
                  $root.stronachgroup.first.racehorse360
                    .ListVaccinationsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListVaccinationsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListVaccinations" }
          );

          /**
           * Calls ListVaccinations.
           * @function listVaccinations
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListVaccinationsRequest} request ListVaccinationsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListVaccinationsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#getVaccination}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef GetVaccinationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Vaccination} [response] Vaccination
           */

          /**
           * Calls GetVaccination.
           * @function getVaccination
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetVaccinationRequest} request GetVaccinationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.GetVaccinationCallback} callback Node-style callback called with the error, if any, and Vaccination
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.getVaccination =
              function getVaccination(request, callback) {
                return this.rpcCall(
                  getVaccination,
                  $root.stronachgroup.first.racehorse360.GetVaccinationRequest,
                  $root.stronachgroup.first.racehorse360.Vaccination,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetVaccination" }
          );

          /**
           * Calls GetVaccination.
           * @function getVaccination
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetVaccinationRequest} request GetVaccinationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Vaccination>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#deleteVaccination}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef DeleteVaccinationCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteVaccination.
           * @function deleteVaccination
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationRequest} request DeleteVaccinationRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.DeleteVaccinationCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.deleteVaccination =
              function deleteVaccination(request, callback) {
                return this.rpcCall(
                  deleteVaccination,
                  $root.stronachgroup.first.racehorse360
                    .DeleteVaccinationRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteVaccination" }
          );

          /**
           * Calls DeleteVaccination.
           * @function deleteVaccination
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationRequest} request DeleteVaccinationRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#listVaccinationComments}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef ListVaccinationCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListVaccinationCommentsResponse} [response] ListVaccinationCommentsResponse
           */

          /**
           * Calls ListVaccinationComments.
           * @function listVaccinationComments
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsRequest} request ListVaccinationCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.ListVaccinationCommentsCallback} callback Node-style callback called with the error, if any, and ListVaccinationCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.listVaccinationComments =
              function listVaccinationComments(request, callback) {
                return this.rpcCall(
                  listVaccinationComments,
                  $root.stronachgroup.first.racehorse360
                    .ListVaccinationCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListVaccinationCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListVaccinationComments" }
          );

          /**
           * Calls ListVaccinationComments.
           * @function listVaccinationComments
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListVaccinationCommentsRequest} request ListVaccinationCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListVaccinationCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#createVaccinationComment}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef CreateVaccinationCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.VaccinationComment} [response] VaccinationComment
           */

          /**
           * Calls CreateVaccinationComment.
           * @function createVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationCommentRequest} request CreateVaccinationCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.CreateVaccinationCommentCallback} callback Node-style callback called with the error, if any, and VaccinationComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.createVaccinationComment =
              function createVaccinationComment(request, callback) {
                return this.rpcCall(
                  createVaccinationComment,
                  $root.stronachgroup.first.racehorse360
                    .CreateVaccinationCommentRequest,
                  $root.stronachgroup.first.racehorse360.VaccinationComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateVaccinationComment" }
          );

          /**
           * Calls CreateVaccinationComment.
           * @function createVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateVaccinationCommentRequest} request CreateVaccinationCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.VaccinationComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#deleteVaccinationComment}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef DeleteVaccinationCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteVaccinationComment.
           * @function deleteVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationCommentRequest} request DeleteVaccinationCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.DeleteVaccinationCommentCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.deleteVaccinationComment =
              function deleteVaccinationComment(request, callback) {
                return this.rpcCall(
                  deleteVaccinationComment,
                  $root.stronachgroup.first.racehorse360
                    .DeleteVaccinationCommentRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteVaccinationComment" }
          );

          /**
           * Calls DeleteVaccinationComment.
           * @function deleteVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteVaccinationCommentRequest} request DeleteVaccinationCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#updateVaccinationComment}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef UpdateVaccinationCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.VaccinationComment} [response] VaccinationComment
           */

          /**
           * Calls UpdateVaccinationComment.
           * @function updateVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateVaccinationCommentRequest} request UpdateVaccinationCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.UpdateVaccinationCommentCallback} callback Node-style callback called with the error, if any, and VaccinationComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.updateVaccinationComment =
              function updateVaccinationComment(request, callback) {
                return this.rpcCall(
                  updateVaccinationComment,
                  $root.stronachgroup.first.racehorse360
                    .UpdateVaccinationCommentRequest,
                  $root.stronachgroup.first.racehorse360.VaccinationComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateVaccinationComment" }
          );

          /**
           * Calls UpdateVaccinationComment.
           * @function updateVaccinationComment
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateVaccinationCommentRequest} request UpdateVaccinationCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.VaccinationComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#addVaccineInjection}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef AddVaccineInjectionCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Injection} [response] Injection
           */

          /**
           * Calls AddVaccineInjection.
           * @function addVaccineInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAddVaccineInjectionRequest} request AddVaccineInjectionRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.AddVaccineInjectionCallback} callback Node-style callback called with the error, if any, and Injection
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.addVaccineInjection =
              function addVaccineInjection(request, callback) {
                return this.rpcCall(
                  addVaccineInjection,
                  $root.stronachgroup.first.racehorse360
                    .AddVaccineInjectionRequest,
                  $root.stronachgroup.first.racehorse360.Injection,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AddVaccineInjection" }
          );

          /**
           * Calls AddVaccineInjection.
           * @function addVaccineInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAddVaccineInjectionRequest} request AddVaccineInjectionRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Injection>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#addBoosterInjection}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef AddBoosterInjectionCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Injection} [response] Injection
           */

          /**
           * Calls AddBoosterInjection.
           * @function addBoosterInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAddBoosterInjectionRequest} request AddBoosterInjectionRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.AddBoosterInjectionCallback} callback Node-style callback called with the error, if any, and Injection
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.addBoosterInjection =
              function addBoosterInjection(request, callback) {
                return this.rpcCall(
                  addBoosterInjection,
                  $root.stronachgroup.first.racehorse360
                    .AddBoosterInjectionRequest,
                  $root.stronachgroup.first.racehorse360.Injection,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AddBoosterInjection" }
          );

          /**
           * Calls AddBoosterInjection.
           * @function addBoosterInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAddBoosterInjectionRequest} request AddBoosterInjectionRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Injection>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#listInjections}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef ListInjectionsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListInjectionsResponse} [response] ListInjectionsResponse
           */

          /**
           * Calls ListInjections.
           * @function listInjections
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListInjectionsRequest} request ListInjectionsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.ListInjectionsCallback} callback Node-style callback called with the error, if any, and ListInjectionsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.listInjections =
              function listInjections(request, callback) {
                return this.rpcCall(
                  listInjections,
                  $root.stronachgroup.first.racehorse360.ListInjectionsRequest,
                  $root.stronachgroup.first.racehorse360.ListInjectionsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListInjections" }
          );

          /**
           * Calls ListInjections.
           * @function listInjections
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListInjectionsRequest} request ListInjectionsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListInjectionsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#deleteInjection}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef DeleteInjectionCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteInjection.
           * @function deleteInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteInjectionRequest} request DeleteInjectionRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.DeleteInjectionCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.deleteInjection =
              function deleteInjection(request, callback) {
                return this.rpcCall(
                  deleteInjection,
                  $root.stronachgroup.first.racehorse360.DeleteInjectionRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteInjection" }
          );

          /**
           * Calls DeleteInjection.
           * @function deleteInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteInjectionRequest} request DeleteInjectionRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#updateInjection}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef UpdateInjectionCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.Injection} [response] Injection
           */

          /**
           * Calls UpdateInjection.
           * @function updateInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateInjectionRequest} request UpdateInjectionRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.UpdateInjectionCallback} callback Node-style callback called with the error, if any, and Injection
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.updateInjection =
              function updateInjection(request, callback) {
                return this.rpcCall(
                  updateInjection,
                  $root.stronachgroup.first.racehorse360.UpdateInjectionRequest,
                  $root.stronachgroup.first.racehorse360.Injection,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateInjection" }
          );

          /**
           * Calls UpdateInjection.
           * @function updateInjection
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUpdateInjectionRequest} request UpdateInjectionRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.Injection>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.VaccinationService#listMedicines}.
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @typedef ListMedicinesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListMedicinesResponse} [response] ListMedicinesResponse
           */

          /**
           * Calls ListMedicines.
           * @function listMedicines
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListMedicinesRequest} request ListMedicinesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.VaccinationService.ListMedicinesCallback} callback Node-style callback called with the error, if any, and ListMedicinesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (VaccinationService.prototype.listMedicines =
              function listMedicines(request, callback) {
                return this.rpcCall(
                  listMedicines,
                  $root.stronachgroup.first.racehorse360.ListMedicinesRequest,
                  $root.stronachgroup.first.racehorse360.ListMedicinesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListMedicines" }
          );

          /**
           * Calls ListMedicines.
           * @function listMedicines
           * @memberof stronachgroup.first.racehorse360.VaccinationService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListMedicinesRequest} request ListMedicinesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListMedicinesResponse>} Promise
           * @variation 2
           */

          return VaccinationService;
        })();

        racehorse360.WorkOrderService = (function () {
          /**
           * Constructs a new WorkOrderService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkOrderService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function WorkOrderService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (WorkOrderService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = WorkOrderService;

          /**
           * Creates new WorkOrderService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {WorkOrderService} RPC service. Useful where requests and/or responses are streamed.
           */
          WorkOrderService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#createWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef CreateWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls CreateWorkOrder.
           * @function createWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderRequest} request CreateWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.CreateWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.createWorkOrder =
              function createWorkOrder(request, callback) {
                return this.rpcCall(
                  createWorkOrder,
                  $root.stronachgroup.first.racehorse360.CreateWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateWorkOrder" }
          );

          /**
           * Calls CreateWorkOrder.
           * @function createWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderRequest} request CreateWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#listWorkOrders}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef ListWorkOrdersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkOrdersResponse} [response] ListWorkOrdersResponse
           */

          /**
           * Calls ListWorkOrders.
           * @function listWorkOrders
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersRequest} request ListWorkOrdersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.ListWorkOrdersCallback} callback Node-style callback called with the error, if any, and ListWorkOrdersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.listWorkOrders =
              function listWorkOrders(request, callback) {
                return this.rpcCall(
                  listWorkOrders,
                  $root.stronachgroup.first.racehorse360.ListWorkOrdersRequest,
                  $root.stronachgroup.first.racehorse360.ListWorkOrdersResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkOrders" }
          );

          /**
           * Calls ListWorkOrders.
           * @function listWorkOrders
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrdersRequest} request ListWorkOrdersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkOrdersResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#listWorkOrderTypes}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef ListWorkOrderTypesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkOrderTypesResponse} [response] ListWorkOrderTypesResponse
           */

          /**
           * Calls ListWorkOrderTypes.
           * @function listWorkOrderTypes
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesRequest} request ListWorkOrderTypesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.ListWorkOrderTypesCallback} callback Node-style callback called with the error, if any, and ListWorkOrderTypesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.listWorkOrderTypes =
              function listWorkOrderTypes(request, callback) {
                return this.rpcCall(
                  listWorkOrderTypes,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkOrderTypesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkOrderTypesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkOrderTypes" }
          );

          /**
           * Calls ListWorkOrderTypes.
           * @function listWorkOrderTypes
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrderTypesRequest} request ListWorkOrderTypesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkOrderTypesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#closeWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef CloseWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls CloseWorkOrder.
           * @function closeWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICloseWorkOrderRequest} request CloseWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.CloseWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.closeWorkOrder =
              function closeWorkOrder(request, callback) {
                return this.rpcCall(
                  closeWorkOrder,
                  $root.stronachgroup.first.racehorse360.CloseWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CloseWorkOrder" }
          );

          /**
           * Calls CloseWorkOrder.
           * @function closeWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICloseWorkOrderRequest} request CloseWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#completeWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef CompleteWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls CompleteWorkOrder.
           * @function completeWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteWorkOrderRequest} request CompleteWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.CompleteWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.completeWorkOrder =
              function completeWorkOrder(request, callback) {
                return this.rpcCall(
                  completeWorkOrder,
                  $root.stronachgroup.first.racehorse360
                    .CompleteWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CompleteWorkOrder" }
          );

          /**
           * Calls CompleteWorkOrder.
           * @function completeWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICompleteWorkOrderRequest} request CompleteWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#reopenWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef ReopenWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls ReopenWorkOrder.
           * @function reopenWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IReopenWorkOrderRequest} request ReopenWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.ReopenWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.reopenWorkOrder =
              function reopenWorkOrder(request, callback) {
                return this.rpcCall(
                  reopenWorkOrder,
                  $root.stronachgroup.first.racehorse360.ReopenWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ReopenWorkOrder" }
          );

          /**
           * Calls ReopenWorkOrder.
           * @function reopenWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IReopenWorkOrderRequest} request ReopenWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#deleteWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef DeleteWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteWorkOrder.
           * @function deleteWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderRequest} request DeleteWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.DeleteWorkOrderCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.deleteWorkOrder =
              function deleteWorkOrder(request, callback) {
                return this.rpcCall(
                  deleteWorkOrder,
                  $root.stronachgroup.first.racehorse360.DeleteWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteWorkOrder" }
          );

          /**
           * Calls DeleteWorkOrder.
           * @function deleteWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderRequest} request DeleteWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#createWorkOrderNote}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef CreateWorkOrderNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrderNote} [response] WorkOrderNote
           */

          /**
           * Calls CreateWorkOrderNote.
           * @function createWorkOrderNote
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderNoteRequest} request CreateWorkOrderNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.CreateWorkOrderNoteCallback} callback Node-style callback called with the error, if any, and WorkOrderNote
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.createWorkOrderNote =
              function createWorkOrderNote(request, callback) {
                return this.rpcCall(
                  createWorkOrderNote,
                  $root.stronachgroup.first.racehorse360
                    .CreateWorkOrderNoteRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrderNote,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateWorkOrderNote" }
          );

          /**
           * Calls CreateWorkOrderNote.
           * @function createWorkOrderNote
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkOrderNoteRequest} request CreateWorkOrderNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrderNote>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#deleteWorkOrderNote}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef DeleteWorkOrderNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteWorkOrderNote.
           * @function deleteWorkOrderNote
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderNoteRequest} request DeleteWorkOrderNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.DeleteWorkOrderNoteCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.deleteWorkOrderNote =
              function deleteWorkOrderNote(request, callback) {
                return this.rpcCall(
                  deleteWorkOrderNote,
                  $root.stronachgroup.first.racehorse360
                    .DeleteWorkOrderNoteRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteWorkOrderNote" }
          );

          /**
           * Calls DeleteWorkOrderNote.
           * @function deleteWorkOrderNote
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkOrderNoteRequest} request DeleteWorkOrderNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#cancelWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef CancelWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls CancelWorkOrder.
           * @function cancelWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelWorkOrderRequest} request CancelWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.CancelWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.cancelWorkOrder =
              function cancelWorkOrder(request, callback) {
                return this.rpcCall(
                  cancelWorkOrder,
                  $root.stronachgroup.first.racehorse360.CancelWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CancelWorkOrder" }
          );

          /**
           * Calls CancelWorkOrder.
           * @function cancelWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelWorkOrderRequest} request CancelWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#editWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef EditWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls EditWorkOrder.
           * @function editWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditWorkOrderRequest} request EditWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.EditWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.editWorkOrder = function editWorkOrder(
              request,
              callback
            ) {
              return this.rpcCall(
                editWorkOrder,
                $root.stronachgroup.first.racehorse360.EditWorkOrderRequest,
                $root.stronachgroup.first.racehorse360.WorkOrder,
                request,
                callback
              );
            }),
            "name",
            { value: "EditWorkOrder" }
          );

          /**
           * Calls EditWorkOrder.
           * @function editWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditWorkOrderRequest} request EditWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#sendBackWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef SendBackWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls SendBackWorkOrder.
           * @function sendBackWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISendBackWorkOrderRequest} request SendBackWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.SendBackWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.sendBackWorkOrder =
              function sendBackWorkOrder(request, callback) {
                return this.rpcCall(
                  sendBackWorkOrder,
                  $root.stronachgroup.first.racehorse360
                    .SendBackWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SendBackWorkOrder" }
          );

          /**
           * Calls SendBackWorkOrder.
           * @function sendBackWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISendBackWorkOrderRequest} request SendBackWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#pullWorkOrderSummary}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef PullWorkOrderSummaryCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse} [response] PullWorkOrderSummaryResponse
           */

          /**
           * Calls PullWorkOrderSummary.
           * @function pullWorkOrderSummary
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryRequest} request PullWorkOrderSummaryRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.PullWorkOrderSummaryCallback} callback Node-style callback called with the error, if any, and PullWorkOrderSummaryResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.pullWorkOrderSummary =
              function pullWorkOrderSummary(request, callback) {
                return this.rpcCall(
                  pullWorkOrderSummary,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderSummaryRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderSummaryResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullWorkOrderSummary" }
          );

          /**
           * Calls PullWorkOrderSummary.
           * @function pullWorkOrderSummary
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderSummaryRequest} request PullWorkOrderSummaryRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#assignMaintenanceUserToWorkOrder}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef AssignMaintenanceUserToWorkOrderCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkOrder} [response] WorkOrder
           */

          /**
           * Calls AssignMaintenanceUserToWorkOrder.
           * @function assignMaintenanceUserToWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignMaintenanceUserToWorkOrderRequest} request AssignMaintenanceUserToWorkOrderRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.AssignMaintenanceUserToWorkOrderCallback} callback Node-style callback called with the error, if any, and WorkOrder
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.assignMaintenanceUserToWorkOrder =
              function assignMaintenanceUserToWorkOrder(request, callback) {
                return this.rpcCall(
                  assignMaintenanceUserToWorkOrder,
                  $root.stronachgroup.first.racehorse360
                    .AssignMaintenanceUserToWorkOrderRequest,
                  $root.stronachgroup.first.racehorse360.WorkOrder,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AssignMaintenanceUserToWorkOrder" }
          );

          /**
           * Calls AssignMaintenanceUserToWorkOrder.
           * @function assignMaintenanceUserToWorkOrder
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IAssignMaintenanceUserToWorkOrderRequest} request AssignMaintenanceUserToWorkOrderRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkOrder>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#pullMaintenanceUsers}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef PullMaintenanceUsersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullMaintenanceUsersResponse} [response] PullMaintenanceUsersResponse
           */

          /**
           * Calls PullMaintenanceUsers.
           * @function pullMaintenanceUsers
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersRequest} request PullMaintenanceUsersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.PullMaintenanceUsersCallback} callback Node-style callback called with the error, if any, and PullMaintenanceUsersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.pullMaintenanceUsers =
              function pullMaintenanceUsers(request, callback) {
                return this.rpcCall(
                  pullMaintenanceUsers,
                  $root.stronachgroup.first.racehorse360
                    .PullMaintenanceUsersRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullMaintenanceUsersResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullMaintenanceUsers" }
          );

          /**
           * Calls PullMaintenanceUsers.
           * @function pullMaintenanceUsers
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullMaintenanceUsersRequest} request PullMaintenanceUsersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullMaintenanceUsersResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#listWorkOrderNotes}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef ListWorkOrderNotesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkOrderNotesResponse} [response] ListWorkOrderNotesResponse
           */

          /**
           * Calls ListWorkOrderNotes.
           * @function listWorkOrderNotes
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesRequest} request ListWorkOrderNotesRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.ListWorkOrderNotesCallback} callback Node-style callback called with the error, if any, and ListWorkOrderNotesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.listWorkOrderNotes =
              function listWorkOrderNotes(request, callback) {
                return this.rpcCall(
                  listWorkOrderNotes,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkOrderNotesRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkOrderNotesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkOrderNotes" }
          );

          /**
           * Calls ListWorkOrderNotes.
           * @function listWorkOrderNotes
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkOrderNotesRequest} request ListWorkOrderNotesRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkOrderNotesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#pullWorkOrderReporters}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef PullWorkOrderReportersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullWorkOrderReportersResponse} [response] PullWorkOrderReportersResponse
           */

          /**
           * Calls PullWorkOrderReporters.
           * @function pullWorkOrderReporters
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersRequest} request PullWorkOrderReportersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.PullWorkOrderReportersCallback} callback Node-style callback called with the error, if any, and PullWorkOrderReportersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.pullWorkOrderReporters =
              function pullWorkOrderReporters(request, callback) {
                return this.rpcCall(
                  pullWorkOrderReporters,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderReportersRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderReportersResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullWorkOrderReporters" }
          );

          /**
           * Calls PullWorkOrderReporters.
           * @function pullWorkOrderReporters
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderReportersRequest} request PullWorkOrderReportersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullWorkOrderReportersResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkOrderService#pullWorkOrderAssignedUsers}.
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @typedef PullWorkOrderAssignedUsersCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse} [response] PullWorkOrderAssignedUsersResponse
           */

          /**
           * Calls PullWorkOrderAssignedUsers.
           * @function pullWorkOrderAssignedUsers
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersRequest} request PullWorkOrderAssignedUsersRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkOrderService.PullWorkOrderAssignedUsersCallback} callback Node-style callback called with the error, if any, and PullWorkOrderAssignedUsersResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkOrderService.prototype.pullWorkOrderAssignedUsers =
              function pullWorkOrderAssignedUsers(request, callback) {
                return this.rpcCall(
                  pullWorkOrderAssignedUsers,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderAssignedUsersRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkOrderAssignedUsersResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullWorkOrderAssignedUsers" }
          );

          /**
           * Calls PullWorkOrderAssignedUsers.
           * @function pullWorkOrderAssignedUsers
           * @memberof stronachgroup.first.racehorse360.WorkOrderService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkOrderAssignedUsersRequest} request PullWorkOrderAssignedUsersRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse>} Promise
           * @variation 2
           */

          return WorkOrderService;
        })();

        racehorse360.WorkoutRequestService = (function () {
          /**
           * Constructs a new WorkoutRequestService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutRequestService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function WorkoutRequestService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (WorkoutRequestService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = WorkoutRequestService;

          /**
           * Creates new WorkoutRequestService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {WorkoutRequestService} RPC service. Useful where requests and/or responses are streamed.
           */
          WorkoutRequestService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#listWorkoutRequests}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef ListWorkoutRequestsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} [response] ListWorkoutRequestsResponse
           */

          /**
           * Calls ListWorkoutRequests.
           * @function listWorkoutRequests
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsRequest} request ListWorkoutRequestsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.ListWorkoutRequestsCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.listWorkoutRequests =
              function listWorkoutRequests(request, callback) {
                return this.rpcCall(
                  listWorkoutRequests,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkoutRequests" }
          );

          /**
           * Calls ListWorkoutRequests.
           * @function listWorkoutRequests
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestsRequest} request ListWorkoutRequestsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#getWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef GetWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls GetWorkoutRequest.
           * @function getWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRequest} request GetWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.GetWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.getWorkoutRequest =
              function getWorkoutRequest(request, callback) {
                return this.rpcCall(
                  getWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .GetWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetWorkoutRequest" }
          );

          /**
           * Calls GetWorkoutRequest.
           * @function getWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRequest} request GetWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#createWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef CreateWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls CreateWorkoutRequest.
           * @function createWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestRequest} request CreateWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.CreateWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.createWorkoutRequest =
              function createWorkoutRequest(request, callback) {
                return this.rpcCall(
                  createWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .CreateWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateWorkoutRequest" }
          );

          /**
           * Calls CreateWorkoutRequest.
           * @function createWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestRequest} request CreateWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#deleteWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef DeleteWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteWorkoutRequest.
           * @function deleteWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestRequest} request DeleteWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.DeleteWorkoutRequestCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.deleteWorkoutRequest =
              function deleteWorkoutRequest(request, callback) {
                return this.rpcCall(
                  deleteWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .DeleteWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteWorkoutRequest" }
          );

          /**
           * Calls DeleteWorkoutRequest.
           * @function deleteWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestRequest} request DeleteWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#bulkQuickPassWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef BulkQuickPassWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} [response] ListWorkoutRequestsResponse
           */

          /**
           * Calls BulkQuickPassWorkoutRequest.
           * @function bulkQuickPassWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkQuickPassWorkoutRequestRequest} request BulkQuickPassWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.BulkQuickPassWorkoutRequestCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.bulkQuickPassWorkoutRequest =
              function bulkQuickPassWorkoutRequest(request, callback) {
                return this.rpcCall(
                  bulkQuickPassWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .BulkQuickPassWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "BulkQuickPassWorkoutRequest" }
          );

          /**
           * Calls BulkQuickPassWorkoutRequest.
           * @function bulkQuickPassWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkQuickPassWorkoutRequestRequest} request BulkQuickPassWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#revertQuickPassWorkoutRequestExam}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef RevertQuickPassWorkoutRequestExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls RevertQuickPassWorkoutRequestExam.
           * @function revertQuickPassWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassWorkoutRequestExamRequest} request RevertQuickPassWorkoutRequestExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.RevertQuickPassWorkoutRequestExamCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.revertQuickPassWorkoutRequestExam =
              function revertQuickPassWorkoutRequestExam(request, callback) {
                return this.rpcCall(
                  revertQuickPassWorkoutRequestExam,
                  $root.stronachgroup.first.racehorse360
                    .RevertQuickPassWorkoutRequestExamRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RevertQuickPassWorkoutRequestExam" }
          );

          /**
           * Calls RevertQuickPassWorkoutRequestExam.
           * @function revertQuickPassWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertQuickPassWorkoutRequestExamRequest} request RevertQuickPassWorkoutRequestExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#bulkRequireWorkoutRequestExam}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef BulkRequireWorkoutRequestExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} [response] ListWorkoutRequestsResponse
           */

          /**
           * Calls BulkRequireWorkoutRequestExam.
           * @function bulkRequireWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkRequireWorkoutRequestExamRequest} request BulkRequireWorkoutRequestExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.BulkRequireWorkoutRequestExamCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.bulkRequireWorkoutRequestExam =
              function bulkRequireWorkoutRequestExam(request, callback) {
                return this.rpcCall(
                  bulkRequireWorkoutRequestExam,
                  $root.stronachgroup.first.racehorse360
                    .BulkRequireWorkoutRequestExamRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "BulkRequireWorkoutRequestExam" }
          );

          /**
           * Calls BulkRequireWorkoutRequestExam.
           * @function bulkRequireWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkRequireWorkoutRequestExamRequest} request BulkRequireWorkoutRequestExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#bulkAssignWorkoutRequestExam}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef BulkAssignWorkoutRequestExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestsResponse} [response] ListWorkoutRequestsResponse
           */

          /**
           * Calls BulkAssignWorkoutRequestExam.
           * @function bulkAssignWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkAssignWorkoutRequestExamRequest} request BulkAssignWorkoutRequestExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.BulkAssignWorkoutRequestExamCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.bulkAssignWorkoutRequestExam =
              function bulkAssignWorkoutRequestExam(request, callback) {
                return this.rpcCall(
                  bulkAssignWorkoutRequestExam,
                  $root.stronachgroup.first.racehorse360
                    .BulkAssignWorkoutRequestExamRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "BulkAssignWorkoutRequestExam" }
          );

          /**
           * Calls BulkAssignWorkoutRequestExam.
           * @function bulkAssignWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IBulkAssignWorkoutRequestExamRequest} request BulkAssignWorkoutRequestExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#unassignWorkoutRequestExam}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef UnassignWorkoutRequestExamCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls UnassignWorkoutRequestExam.
           * @function unassignWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignWorkoutRequestExamRequest} request UnassignWorkoutRequestExamRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.UnassignWorkoutRequestExamCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.unassignWorkoutRequestExam =
              function unassignWorkoutRequestExam(request, callback) {
                return this.rpcCall(
                  unassignWorkoutRequestExam,
                  $root.stronachgroup.first.racehorse360
                    .UnassignWorkoutRequestExamRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnassignWorkoutRequestExam" }
          );

          /**
           * Calls UnassignWorkoutRequestExam.
           * @function unassignWorkoutRequestExam
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IUnassignWorkoutRequestExamRequest} request UnassignWorkoutRequestExamRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#moveFacilityWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef MoveFacilityWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls MoveFacilityWorkoutRequest.
           * @function moveFacilityWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMoveFacilityWorkoutRequestRequest} request MoveFacilityWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.MoveFacilityWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.moveFacilityWorkoutRequest =
              function moveFacilityWorkoutRequest(request, callback) {
                return this.rpcCall(
                  moveFacilityWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .MoveFacilityWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "MoveFacilityWorkoutRequest" }
          );

          /**
           * Calls MoveFacilityWorkoutRequest.
           * @function moveFacilityWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IMoveFacilityWorkoutRequestRequest} request MoveFacilityWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#cancelWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef CancelWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls CancelWorkoutRequest.
           * @function cancelWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelWorkoutRequestRequest} request CancelWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.CancelWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.cancelWorkoutRequest =
              function cancelWorkoutRequest(request, callback) {
                return this.rpcCall(
                  cancelWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .CancelWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CancelWorkoutRequest" }
          );

          /**
           * Calls CancelWorkoutRequest.
           * @function cancelWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICancelWorkoutRequestRequest} request CancelWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#rejectWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef RejectWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls RejectWorkoutRequest.
           * @function rejectWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRejectWorkoutRequestRequest} request RejectWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.RejectWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.rejectWorkoutRequest =
              function rejectWorkoutRequest(request, callback) {
                return this.rpcCall(
                  rejectWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .RejectWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RejectWorkoutRequest" }
          );

          /**
           * Calls RejectWorkoutRequest.
           * @function rejectWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRejectWorkoutRequestRequest} request RejectWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#revertWorkoutRequest}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef RevertWorkoutRequestCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls RevertWorkoutRequest.
           * @function revertWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertWorkoutRequestRequest} request RevertWorkoutRequestRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.RevertWorkoutRequestCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.revertWorkoutRequest =
              function revertWorkoutRequest(request, callback) {
                return this.rpcCall(
                  revertWorkoutRequest,
                  $root.stronachgroup.first.racehorse360
                    .RevertWorkoutRequestRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "RevertWorkoutRequest" }
          );

          /**
           * Calls RevertWorkoutRequest.
           * @function revertWorkoutRequest
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IRevertWorkoutRequestRequest} request RevertWorkoutRequestRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#createWorkoutRequestComment}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef CreateWorkoutRequestCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequestComment} [response] WorkoutRequestComment
           */

          /**
           * Calls CreateWorkoutRequestComment.
           * @function createWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestCommentRequest} request CreateWorkoutRequestCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.CreateWorkoutRequestCommentCallback} callback Node-style callback called with the error, if any, and WorkoutRequestComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.createWorkoutRequestComment =
              function createWorkoutRequestComment(request, callback) {
                return this.rpcCall(
                  createWorkoutRequestComment,
                  $root.stronachgroup.first.racehorse360
                    .CreateWorkoutRequestCommentRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequestComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "CreateWorkoutRequestComment" }
          );

          /**
           * Calls CreateWorkoutRequestComment.
           * @function createWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ICreateWorkoutRequestCommentRequest} request CreateWorkoutRequestCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequestComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#deleteWorkoutRequestComment}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef DeleteWorkoutRequestCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.EmptyResponse} [response] EmptyResponse
           */

          /**
           * Calls DeleteWorkoutRequestComment.
           * @function deleteWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestCommentRequest} request DeleteWorkoutRequestCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.DeleteWorkoutRequestCommentCallback} callback Node-style callback called with the error, if any, and EmptyResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.deleteWorkoutRequestComment =
              function deleteWorkoutRequestComment(request, callback) {
                return this.rpcCall(
                  deleteWorkoutRequestComment,
                  $root.stronachgroup.first.racehorse360
                    .DeleteWorkoutRequestCommentRequest,
                  $root.stronachgroup.first.racehorse360.EmptyResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "DeleteWorkoutRequestComment" }
          );

          /**
           * Calls DeleteWorkoutRequestComment.
           * @function deleteWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IDeleteWorkoutRequestCommentRequest} request DeleteWorkoutRequestCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.EmptyResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#getWorkoutRequestComment}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef GetWorkoutRequestCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequestComment} [response] WorkoutRequestComment
           */

          /**
           * Calls GetWorkoutRequestComment.
           * @function getWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestCommentRequest} request GetWorkoutRequestCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.GetWorkoutRequestCommentCallback} callback Node-style callback called with the error, if any, and WorkoutRequestComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.getWorkoutRequestComment =
              function getWorkoutRequestComment(request, callback) {
                return this.rpcCall(
                  getWorkoutRequestComment,
                  $root.stronachgroup.first.racehorse360
                    .GetWorkoutRequestCommentRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequestComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetWorkoutRequestComment" }
          );

          /**
           * Calls GetWorkoutRequestComment.
           * @function getWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestCommentRequest} request GetWorkoutRequestCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequestComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#listWorkoutRequestComments}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef ListWorkoutRequestCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse} [response] ListWorkoutRequestCommentsResponse
           */

          /**
           * Calls ListWorkoutRequestComments.
           * @function listWorkoutRequestComments
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsRequest} request ListWorkoutRequestCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.ListWorkoutRequestCommentsCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.listWorkoutRequestComments =
              function listWorkoutRequestComments(request, callback) {
                return this.rpcCall(
                  listWorkoutRequestComments,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkoutRequestComments" }
          );

          /**
           * Calls ListWorkoutRequestComments.
           * @function listWorkoutRequestComments
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestCommentsRequest} request ListWorkoutRequestCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#editWorkoutRequestComment}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef EditWorkoutRequestCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequestComment} [response] WorkoutRequestComment
           */

          /**
           * Calls EditWorkoutRequestComment.
           * @function editWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditWorkoutRequestCommentRequest} request EditWorkoutRequestCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.EditWorkoutRequestCommentCallback} callback Node-style callback called with the error, if any, and WorkoutRequestComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.editWorkoutRequestComment =
              function editWorkoutRequestComment(request, callback) {
                return this.rpcCall(
                  editWorkoutRequestComment,
                  $root.stronachgroup.first.racehorse360
                    .EditWorkoutRequestCommentRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequestComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "EditWorkoutRequestComment" }
          );

          /**
           * Calls EditWorkoutRequestComment.
           * @function editWorkoutRequestComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IEditWorkoutRequestCommentRequest} request EditWorkoutRequestCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequestComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#pullWorkoutRequestReport}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef PullWorkoutRequestReportCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse} [response] PullWorkoutRequestReportResponse
           */

          /**
           * Calls PullWorkoutRequestReport.
           * @function pullWorkoutRequestReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportRequest} request PullWorkoutRequestReportRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.PullWorkoutRequestReportCallback} callback Node-style callback called with the error, if any, and PullWorkoutRequestReportResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.pullWorkoutRequestReport =
              function pullWorkoutRequestReport(request, callback) {
                return this.rpcCall(
                  pullWorkoutRequestReport,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkoutRequestReportRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullWorkoutRequestReportResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullWorkoutRequestReport" }
          );

          /**
           * Calls PullWorkoutRequestReport.
           * @function pullWorkoutRequestReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWorkoutRequestReportRequest} request PullWorkoutRequestReportRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#pullWrongfulWorkoutReport}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef PullWrongfulWorkoutReportCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse} [response] PullWrongfulWorkoutReportResponse
           */

          /**
           * Calls PullWrongfulWorkoutReport.
           * @function pullWrongfulWorkoutReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportRequest} request PullWrongfulWorkoutReportRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.PullWrongfulWorkoutReportCallback} callback Node-style callback called with the error, if any, and PullWrongfulWorkoutReportResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.pullWrongfulWorkoutReport =
              function pullWrongfulWorkoutReport(request, callback) {
                return this.rpcCall(
                  pullWrongfulWorkoutReport,
                  $root.stronachgroup.first.racehorse360
                    .PullWrongfulWorkoutReportRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullWrongfulWorkoutReportResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullWrongfulWorkoutReport" }
          );

          /**
           * Calls PullWrongfulWorkoutReport.
           * @function pullWrongfulWorkoutReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullWrongfulWorkoutReportRequest} request PullWrongfulWorkoutReportRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#pullScheduledWorkoutReport}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef PullScheduledWorkoutReportCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse} [response] PullScheduledWorkoutReportResponse
           */

          /**
           * Calls PullScheduledWorkoutReport.
           * @function pullScheduledWorkoutReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportRequest} request PullScheduledWorkoutReportRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.PullScheduledWorkoutReportCallback} callback Node-style callback called with the error, if any, and PullScheduledWorkoutReportResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.pullScheduledWorkoutReport =
              function pullScheduledWorkoutReport(request, callback) {
                return this.rpcCall(
                  pullScheduledWorkoutReport,
                  $root.stronachgroup.first.racehorse360
                    .PullScheduledWorkoutReportRequest,
                  $root.stronachgroup.first.racehorse360
                    .PullScheduledWorkoutReportResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "PullScheduledWorkoutReport" }
          );

          /**
           * Calls PullScheduledWorkoutReport.
           * @function pullScheduledWorkoutReport
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IPullScheduledWorkoutReportRequest} request PullScheduledWorkoutReportRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#setWorkoutRequestFlag}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef SetWorkoutRequestFlagCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls SetWorkoutRequestFlag.
           * @function setWorkoutRequestFlag
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestFlagRequest} request SetWorkoutRequestFlagRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.SetWorkoutRequestFlagCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.setWorkoutRequestFlag =
              function setWorkoutRequestFlag(request, callback) {
                return this.rpcCall(
                  setWorkoutRequestFlag,
                  $root.stronachgroup.first.racehorse360
                    .SetWorkoutRequestFlagRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetWorkoutRequestFlag" }
          );

          /**
           * Calls SetWorkoutRequestFlag.
           * @function setWorkoutRequestFlag
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestFlagRequest} request SetWorkoutRequestFlagRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#resetWorkoutRequestFlag}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef ResetWorkoutRequestFlagCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls ResetWorkoutRequestFlag.
           * @function resetWorkoutRequestFlag
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestFlagRequest} request ResetWorkoutRequestFlagRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.ResetWorkoutRequestFlagCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.resetWorkoutRequestFlag =
              function resetWorkoutRequestFlag(request, callback) {
                return this.rpcCall(
                  resetWorkoutRequestFlag,
                  $root.stronachgroup.first.racehorse360
                    .ResetWorkoutRequestFlagRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetWorkoutRequestFlag" }
          );

          /**
           * Calls ResetWorkoutRequestFlag.
           * @function resetWorkoutRequestFlag
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestFlagRequest} request ResetWorkoutRequestFlagRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#setWorkoutRequestExamReasonNote}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef SetWorkoutRequestExamReasonNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls SetWorkoutRequestExamReasonNote.
           * @function setWorkoutRequestExamReasonNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestExamReasonNoteRequest} request SetWorkoutRequestExamReasonNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.SetWorkoutRequestExamReasonNoteCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.setWorkoutRequestExamReasonNote =
              function setWorkoutRequestExamReasonNote(request, callback) {
                return this.rpcCall(
                  setWorkoutRequestExamReasonNote,
                  $root.stronachgroup.first.racehorse360
                    .SetWorkoutRequestExamReasonNoteRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "SetWorkoutRequestExamReasonNote" }
          );

          /**
           * Calls SetWorkoutRequestExamReasonNote.
           * @function setWorkoutRequestExamReasonNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.ISetWorkoutRequestExamReasonNoteRequest} request SetWorkoutRequestExamReasonNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#resetWorkoutRequestExamReasonNote}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef ResetWorkoutRequestExamReasonNoteCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequest} [response] WorkoutRequest
           */

          /**
           * Calls ResetWorkoutRequestExamReasonNote.
           * @function resetWorkoutRequestExamReasonNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestExamReasonNoteRequest} request ResetWorkoutRequestExamReasonNoteRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.ResetWorkoutRequestExamReasonNoteCallback} callback Node-style callback called with the error, if any, and WorkoutRequest
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.resetWorkoutRequestExamReasonNote =
              function resetWorkoutRequestExamReasonNote(request, callback) {
                return this.rpcCall(
                  resetWorkoutRequestExamReasonNote,
                  $root.stronachgroup.first.racehorse360
                    .ResetWorkoutRequestExamReasonNoteRequest,
                  $root.stronachgroup.first.racehorse360.WorkoutRequest,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ResetWorkoutRequestExamReasonNote" }
          );

          /**
           * Calls ResetWorkoutRequestExamReasonNote.
           * @function resetWorkoutRequestExamReasonNote
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IResetWorkoutRequestExamReasonNoteRequest} request ResetWorkoutRequestExamReasonNoteRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequest>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#getWorkoutRequestRejectionComment}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef GetWorkoutRequestRejectionCommentCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.WorkoutRequestRejectionComment} [response] WorkoutRequestRejectionComment
           */

          /**
           * Calls GetWorkoutRequestRejectionComment.
           * @function getWorkoutRequestRejectionComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRejectionCommentRequest} request GetWorkoutRequestRejectionCommentRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.GetWorkoutRequestRejectionCommentCallback} callback Node-style callback called with the error, if any, and WorkoutRequestRejectionComment
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.getWorkoutRequestRejectionComment =
              function getWorkoutRequestRejectionComment(request, callback) {
                return this.rpcCall(
                  getWorkoutRequestRejectionComment,
                  $root.stronachgroup.first.racehorse360
                    .GetWorkoutRequestRejectionCommentRequest,
                  $root.stronachgroup.first.racehorse360
                    .WorkoutRequestRejectionComment,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetWorkoutRequestRejectionComment" }
          );

          /**
           * Calls GetWorkoutRequestRejectionComment.
           * @function getWorkoutRequestRejectionComment
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IGetWorkoutRequestRejectionCommentRequest} request GetWorkoutRequestRejectionCommentRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.WorkoutRequestRejectionComment>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutRequestService#listWorkoutRequestRejectionComments}.
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @typedef ListWorkoutRequestRejectionCommentsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse} [response] ListWorkoutRequestRejectionCommentsResponse
           */

          /**
           * Calls ListWorkoutRequestRejectionComments.
           * @function listWorkoutRequestRejectionComments
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsRequest} request ListWorkoutRequestRejectionCommentsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutRequestService.ListWorkoutRequestRejectionCommentsCallback} callback Node-style callback called with the error, if any, and ListWorkoutRequestRejectionCommentsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutRequestService.prototype.listWorkoutRequestRejectionComments =
              function listWorkoutRequestRejectionComments(request, callback) {
                return this.rpcCall(
                  listWorkoutRequestRejectionComments,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestRejectionCommentsRequest,
                  $root.stronachgroup.first.racehorse360
                    .ListWorkoutRequestRejectionCommentsResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ListWorkoutRequestRejectionComments" }
          );

          /**
           * Calls ListWorkoutRequestRejectionComments.
           * @function listWorkoutRequestRejectionComments
           * @memberof stronachgroup.first.racehorse360.WorkoutRequestService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutRequestRejectionCommentsRequest} request ListWorkoutRequestRejectionCommentsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse>} Promise
           * @variation 2
           */

          return WorkoutRequestService;
        })();

        racehorse360.WorkoutService = (function () {
          /**
           * Constructs a new WorkoutService service.
           * @memberof stronachgroup.first.racehorse360
           * @classdesc Represents a WorkoutService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function WorkoutService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (WorkoutService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = WorkoutService;

          /**
           * Creates new WorkoutService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.racehorse360.WorkoutService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {WorkoutService} RPC service. Useful where requests and/or responses are streamed.
           */
          WorkoutService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.racehorse360.WorkoutService#listWorkouts}.
           * @memberof stronachgroup.first.racehorse360.WorkoutService
           * @typedef ListWorkoutsCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.racehorse360.ListWorkoutsResponse} [response] ListWorkoutsResponse
           */

          /**
           * Calls ListWorkouts.
           * @function listWorkouts
           * @memberof stronachgroup.first.racehorse360.WorkoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutsRequest} request ListWorkoutsRequest message or plain object
           * @param {stronachgroup.first.racehorse360.WorkoutService.ListWorkoutsCallback} callback Node-style callback called with the error, if any, and ListWorkoutsResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (WorkoutService.prototype.listWorkouts = function listWorkouts(
              request,
              callback
            ) {
              return this.rpcCall(
                listWorkouts,
                $root.stronachgroup.first.racehorse360.ListWorkoutsRequest,
                $root.stronachgroup.first.racehorse360.ListWorkoutsResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "ListWorkouts" }
          );

          /**
           * Calls ListWorkouts.
           * @function listWorkouts
           * @memberof stronachgroup.first.racehorse360.WorkoutService
           * @instance
           * @param {stronachgroup.first.racehorse360.IListWorkoutsRequest} request ListWorkoutsRequest message or plain object
           * @returns {Promise<stronachgroup.first.racehorse360.ListWorkoutsResponse>} Promise
           * @variation 2
           */

          return WorkoutService;
        })();

        return racehorse360;
      })();

      first.external = (function () {
        /**
         * Namespace external.
         * @memberof stronachgroup.first
         * @namespace
         */
        var external = {};

        external.NotificationMessage = (function () {
          /**
           * Properties of a NotificationMessage.
           * @memberof stronachgroup.first.external
           * @interface INotificationMessage
           * @property {string|null} [data] NotificationMessage data
           * @property {stronachgroup.first.external.INotificationAttributes|null} [attributes] NotificationMessage attributes
           */

          /**
           * Constructs a new NotificationMessage.
           * @memberof stronachgroup.first.external
           * @classdesc Represents a NotificationMessage.
           * @implements INotificationMessage
           * @constructor
           * @param {stronachgroup.first.external.INotificationMessage=} [properties] Properties to set
           */
          function NotificationMessage(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * NotificationMessage data.
           * @member {string} data
           * @memberof stronachgroup.first.external.NotificationMessage
           * @instance
           */
          NotificationMessage.prototype.data = "";

          /**
           * NotificationMessage attributes.
           * @member {stronachgroup.first.external.INotificationAttributes|null|undefined} attributes
           * @memberof stronachgroup.first.external.NotificationMessage
           * @instance
           */
          NotificationMessage.prototype.attributes = null;

          /**
           * Creates a new NotificationMessage instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.external.NotificationMessage
           * @static
           * @param {stronachgroup.first.external.INotificationMessage=} [properties] Properties to set
           * @returns {stronachgroup.first.external.NotificationMessage} NotificationMessage instance
           */
          NotificationMessage.create = function create(properties) {
            return new NotificationMessage(properties);
          };

          /**
           * Encodes the specified NotificationMessage message. Does not implicitly {@link stronachgroup.first.external.NotificationMessage.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.external.NotificationMessage
           * @static
           * @param {stronachgroup.first.external.INotificationMessage} message NotificationMessage message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          NotificationMessage.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.data != null &&
              Object.hasOwnProperty.call(message, "data")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.data);
            if (
              message.attributes != null &&
              Object.hasOwnProperty.call(message, "attributes")
            )
              $root.stronachgroup.first.external.NotificationAttributes.encode(
                message.attributes,
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a NotificationMessage message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.external.NotificationMessage
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.external.NotificationMessage} NotificationMessage
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          NotificationMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.external.NotificationMessage();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.data = reader.string();
                  break;
                case 2:
                  message.attributes =
                    $root.stronachgroup.first.external.NotificationAttributes.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a NotificationMessage message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.external.NotificationMessage
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.external.NotificationMessage} NotificationMessage
           */
          NotificationMessage.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.external.NotificationMessage
            )
              return object;
            var message =
              new $root.stronachgroup.first.external.NotificationMessage();
            if (object.data != null) message.data = String(object.data);
            if (object.attributes != null) {
              if (typeof object.attributes !== "object")
                throw TypeError(
                  ".stronachgroup.first.external.NotificationMessage.attributes: object expected"
                );
              message.attributes =
                $root.stronachgroup.first.external.NotificationAttributes.fromObject(
                  object.attributes
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a NotificationMessage message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.external.NotificationMessage
           * @static
           * @param {stronachgroup.first.external.NotificationMessage} message NotificationMessage
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          NotificationMessage.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.data = "";
              object.attributes = null;
            }
            if (message.data != null && message.hasOwnProperty("data"))
              object.data = message.data;
            if (
              message.attributes != null &&
              message.hasOwnProperty("attributes")
            )
              object.attributes =
                $root.stronachgroup.first.external.NotificationAttributes.toObject(
                  message.attributes,
                  options
                );
            return object;
          };

          /**
           * Converts this NotificationMessage to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.external.NotificationMessage
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          NotificationMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return NotificationMessage;
        })();

        external.NotificationAttributes = (function () {
          /**
           * Properties of a NotificationAttributes.
           * @memberof stronachgroup.first.external
           * @interface INotificationAttributes
           * @property {string|null} [eventType] NotificationAttributes eventType
           * @property {string|null} [bucketId] NotificationAttributes bucketId
           * @property {string|null} [objectId] NotificationAttributes objectId
           * @property {string|null} [objectGeneration] NotificationAttributes objectGeneration
           * @property {string|null} [payloadFormat] NotificationAttributes payloadFormat
           */

          /**
           * Constructs a new NotificationAttributes.
           * @memberof stronachgroup.first.external
           * @classdesc Represents a NotificationAttributes.
           * @implements INotificationAttributes
           * @constructor
           * @param {stronachgroup.first.external.INotificationAttributes=} [properties] Properties to set
           */
          function NotificationAttributes(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * NotificationAttributes eventType.
           * @member {string} eventType
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           */
          NotificationAttributes.prototype.eventType = "";

          /**
           * NotificationAttributes bucketId.
           * @member {string} bucketId
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           */
          NotificationAttributes.prototype.bucketId = "";

          /**
           * NotificationAttributes objectId.
           * @member {string} objectId
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           */
          NotificationAttributes.prototype.objectId = "";

          /**
           * NotificationAttributes objectGeneration.
           * @member {string} objectGeneration
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           */
          NotificationAttributes.prototype.objectGeneration = "";

          /**
           * NotificationAttributes payloadFormat.
           * @member {string} payloadFormat
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           */
          NotificationAttributes.prototype.payloadFormat = "";

          /**
           * Creates a new NotificationAttributes instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @static
           * @param {stronachgroup.first.external.INotificationAttributes=} [properties] Properties to set
           * @returns {stronachgroup.first.external.NotificationAttributes} NotificationAttributes instance
           */
          NotificationAttributes.create = function create(properties) {
            return new NotificationAttributes(properties);
          };

          /**
           * Encodes the specified NotificationAttributes message. Does not implicitly {@link stronachgroup.first.external.NotificationAttributes.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @static
           * @param {stronachgroup.first.external.INotificationAttributes} message NotificationAttributes message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          NotificationAttributes.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.eventType != null &&
              Object.hasOwnProperty.call(message, "eventType")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.eventType);
            if (
              message.bucketId != null &&
              Object.hasOwnProperty.call(message, "bucketId")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.bucketId);
            if (
              message.objectId != null &&
              Object.hasOwnProperty.call(message, "objectId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.objectId);
            if (
              message.objectGeneration != null &&
              Object.hasOwnProperty.call(message, "objectGeneration")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.objectGeneration);
            if (
              message.payloadFormat != null &&
              Object.hasOwnProperty.call(message, "payloadFormat")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.payloadFormat);
            return writer;
          };

          /**
           * Decodes a NotificationAttributes message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.external.NotificationAttributes} NotificationAttributes
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          NotificationAttributes.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.external.NotificationAttributes();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.eventType = reader.string();
                  break;
                case 2:
                  message.bucketId = reader.string();
                  break;
                case 3:
                  message.objectId = reader.string();
                  break;
                case 4:
                  message.objectGeneration = reader.string();
                  break;
                case 5:
                  message.payloadFormat = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a NotificationAttributes message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.external.NotificationAttributes} NotificationAttributes
           */
          NotificationAttributes.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.external.NotificationAttributes
            )
              return object;
            var message =
              new $root.stronachgroup.first.external.NotificationAttributes();
            if (object.eventType != null)
              message.eventType = String(object.eventType);
            if (object.bucketId != null)
              message.bucketId = String(object.bucketId);
            if (object.objectId != null)
              message.objectId = String(object.objectId);
            if (object.objectGeneration != null)
              message.objectGeneration = String(object.objectGeneration);
            if (object.payloadFormat != null)
              message.payloadFormat = String(object.payloadFormat);
            return message;
          };

          /**
           * Creates a plain object from a NotificationAttributes message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @static
           * @param {stronachgroup.first.external.NotificationAttributes} message NotificationAttributes
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          NotificationAttributes.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.eventType = "";
              object.bucketId = "";
              object.objectId = "";
              object.objectGeneration = "";
              object.payloadFormat = "";
            }
            if (
              message.eventType != null &&
              message.hasOwnProperty("eventType")
            )
              object.eventType = message.eventType;
            if (message.bucketId != null && message.hasOwnProperty("bucketId"))
              object.bucketId = message.bucketId;
            if (message.objectId != null && message.hasOwnProperty("objectId"))
              object.objectId = message.objectId;
            if (
              message.objectGeneration != null &&
              message.hasOwnProperty("objectGeneration")
            )
              object.objectGeneration = message.objectGeneration;
            if (
              message.payloadFormat != null &&
              message.hasOwnProperty("payloadFormat")
            )
              object.payloadFormat = message.payloadFormat;
            return object;
          };

          /**
           * Converts this NotificationAttributes to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.external.NotificationAttributes
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          NotificationAttributes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return NotificationAttributes;
        })();

        return external;
      })();

      first.auth = (function () {
        /**
         * Namespace auth.
         * @memberof stronachgroup.first
         * @namespace
         */
        var auth = {};

        auth.AuthenticateUserRequest = (function () {
          /**
           * Properties of an AuthenticateUserRequest.
           * @memberof stronachgroup.first.auth
           * @interface IAuthenticateUserRequest
           * @property {string|null} [email] AuthenticateUserRequest email
           * @property {string|null} [password] AuthenticateUserRequest password
           * @property {string|null} [partner] AuthenticateUserRequest partner
           */

          /**
           * Constructs a new AuthenticateUserRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an AuthenticateUserRequest.
           * @implements IAuthenticateUserRequest
           * @constructor
           * @param {stronachgroup.first.auth.IAuthenticateUserRequest=} [properties] Properties to set
           */
          function AuthenticateUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AuthenticateUserRequest email.
           * @member {string} email
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @instance
           */
          AuthenticateUserRequest.prototype.email = "";

          /**
           * AuthenticateUserRequest password.
           * @member {string} password
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @instance
           */
          AuthenticateUserRequest.prototype.password = "";

          /**
           * AuthenticateUserRequest partner.
           * @member {string} partner
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @instance
           */
          AuthenticateUserRequest.prototype.partner = "";

          /**
           * Creates a new AuthenticateUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @static
           * @param {stronachgroup.first.auth.IAuthenticateUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.AuthenticateUserRequest} AuthenticateUserRequest instance
           */
          AuthenticateUserRequest.create = function create(properties) {
            return new AuthenticateUserRequest(properties);
          };

          /**
           * Encodes the specified AuthenticateUserRequest message. Does not implicitly {@link stronachgroup.first.auth.AuthenticateUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @static
           * @param {stronachgroup.first.auth.IAuthenticateUserRequest} message AuthenticateUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AuthenticateUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.email);
            if (
              message.password != null &&
              Object.hasOwnProperty.call(message, "password")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.password);
            if (
              message.partner != null &&
              Object.hasOwnProperty.call(message, "partner")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.partner);
            return writer;
          };

          /**
           * Decodes an AuthenticateUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.AuthenticateUserRequest} AuthenticateUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AuthenticateUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.AuthenticateUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.email = reader.string();
                  break;
                case 2:
                  message.password = reader.string();
                  break;
                case 3:
                  message.partner = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AuthenticateUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.AuthenticateUserRequest} AuthenticateUserRequest
           */
          AuthenticateUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.AuthenticateUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.AuthenticateUserRequest();
            if (object.email != null) message.email = String(object.email);
            if (object.password != null)
              message.password = String(object.password);
            if (object.partner != null)
              message.partner = String(object.partner);
            return message;
          };

          /**
           * Creates a plain object from an AuthenticateUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @static
           * @param {stronachgroup.first.auth.AuthenticateUserRequest} message AuthenticateUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AuthenticateUserRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.email = "";
              object.password = "";
              object.partner = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
              object.password = message.password;
            if (message.partner != null && message.hasOwnProperty("partner"))
              object.partner = message.partner;
            return object;
          };

          /**
           * Converts this AuthenticateUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.AuthenticateUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AuthenticateUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AuthenticateUserRequest;
        })();

        auth.AuthenticatePinUserRequest = (function () {
          /**
           * Properties of an AuthenticatePinUserRequest.
           * @memberof stronachgroup.first.auth
           * @interface IAuthenticatePinUserRequest
           * @property {string|null} [accountId] AuthenticatePinUserRequest accountId
           * @property {string|null} [pin] AuthenticatePinUserRequest pin
           * @property {string|null} [partner] AuthenticatePinUserRequest partner
           */

          /**
           * Constructs a new AuthenticatePinUserRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an AuthenticatePinUserRequest.
           * @implements IAuthenticatePinUserRequest
           * @constructor
           * @param {stronachgroup.first.auth.IAuthenticatePinUserRequest=} [properties] Properties to set
           */
          function AuthenticatePinUserRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AuthenticatePinUserRequest accountId.
           * @member {string} accountId
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @instance
           */
          AuthenticatePinUserRequest.prototype.accountId = "";

          /**
           * AuthenticatePinUserRequest pin.
           * @member {string} pin
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @instance
           */
          AuthenticatePinUserRequest.prototype.pin = "";

          /**
           * AuthenticatePinUserRequest partner.
           * @member {string} partner
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @instance
           */
          AuthenticatePinUserRequest.prototype.partner = "";

          /**
           * Creates a new AuthenticatePinUserRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @static
           * @param {stronachgroup.first.auth.IAuthenticatePinUserRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.AuthenticatePinUserRequest} AuthenticatePinUserRequest instance
           */
          AuthenticatePinUserRequest.create = function create(properties) {
            return new AuthenticatePinUserRequest(properties);
          };

          /**
           * Encodes the specified AuthenticatePinUserRequest message. Does not implicitly {@link stronachgroup.first.auth.AuthenticatePinUserRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @static
           * @param {stronachgroup.first.auth.IAuthenticatePinUserRequest} message AuthenticatePinUserRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AuthenticatePinUserRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.accountId != null &&
              Object.hasOwnProperty.call(message, "accountId")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.accountId);
            if (
              message.pin != null &&
              Object.hasOwnProperty.call(message, "pin")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.pin);
            if (
              message.partner != null &&
              Object.hasOwnProperty.call(message, "partner")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.partner);
            return writer;
          };

          /**
           * Decodes an AuthenticatePinUserRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.AuthenticatePinUserRequest} AuthenticatePinUserRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AuthenticatePinUserRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.AuthenticatePinUserRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.accountId = reader.string();
                  break;
                case 2:
                  message.pin = reader.string();
                  break;
                case 3:
                  message.partner = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AuthenticatePinUserRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.AuthenticatePinUserRequest} AuthenticatePinUserRequest
           */
          AuthenticatePinUserRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.AuthenticatePinUserRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.AuthenticatePinUserRequest();
            if (object.accountId != null)
              message.accountId = String(object.accountId);
            if (object.pin != null) message.pin = String(object.pin);
            if (object.partner != null)
              message.partner = String(object.partner);
            return message;
          };

          /**
           * Creates a plain object from an AuthenticatePinUserRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @static
           * @param {stronachgroup.first.auth.AuthenticatePinUserRequest} message AuthenticatePinUserRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AuthenticatePinUserRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.accountId = "";
              object.pin = "";
              object.partner = "";
            }
            if (
              message.accountId != null &&
              message.hasOwnProperty("accountId")
            )
              object.accountId = message.accountId;
            if (message.pin != null && message.hasOwnProperty("pin"))
              object.pin = message.pin;
            if (message.partner != null && message.hasOwnProperty("partner"))
              object.partner = message.partner;
            return object;
          };

          /**
           * Converts this AuthenticatePinUserRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.AuthenticatePinUserRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AuthenticatePinUserRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AuthenticatePinUserRequest;
        })();

        auth.DatabaseConnectorLoginResponse = (function () {
          /**
           * Properties of a DatabaseConnectorLoginResponse.
           * @memberof stronachgroup.first.auth
           * @interface IDatabaseConnectorLoginResponse
           * @property {string|null} [email] DatabaseConnectorLoginResponse email
           * @property {string|null} [username] DatabaseConnectorLoginResponse username
           * @property {stronachgroup.first.auth.IUserMetadata|null} [userMetadata] DatabaseConnectorLoginResponse userMetadata
           * @property {stronachgroup.first.auth.IAppMetadata|null} [metadata] DatabaseConnectorLoginResponse metadata
           * @property {string|null} [givenName] DatabaseConnectorLoginResponse givenName
           * @property {string|null} [familyName] DatabaseConnectorLoginResponse familyName
           * @property {string|null} [name] DatabaseConnectorLoginResponse name
           * @property {string|null} [phoneNumber] DatabaseConnectorLoginResponse phoneNumber
           * @property {string|null} [userId] DatabaseConnectorLoginResponse userId
           */

          /**
           * Constructs a new DatabaseConnectorLoginResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a DatabaseConnectorLoginResponse.
           * @implements IDatabaseConnectorLoginResponse
           * @constructor
           * @param {stronachgroup.first.auth.IDatabaseConnectorLoginResponse=} [properties] Properties to set
           */
          function DatabaseConnectorLoginResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * DatabaseConnectorLoginResponse email.
           * @member {string} email
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.email = "";

          /**
           * DatabaseConnectorLoginResponse username.
           * @member {string} username
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.username = "";

          /**
           * DatabaseConnectorLoginResponse userMetadata.
           * @member {stronachgroup.first.auth.IUserMetadata|null|undefined} userMetadata
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.userMetadata = null;

          /**
           * DatabaseConnectorLoginResponse metadata.
           * @member {stronachgroup.first.auth.IAppMetadata|null|undefined} metadata
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.metadata = null;

          /**
           * DatabaseConnectorLoginResponse givenName.
           * @member {string} givenName
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.givenName = "";

          /**
           * DatabaseConnectorLoginResponse familyName.
           * @member {string} familyName
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.familyName = "";

          /**
           * DatabaseConnectorLoginResponse name.
           * @member {string} name
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.name = "";

          /**
           * DatabaseConnectorLoginResponse phoneNumber.
           * @member {string} phoneNumber
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.phoneNumber = "";

          /**
           * DatabaseConnectorLoginResponse userId.
           * @member {string} userId
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           */
          DatabaseConnectorLoginResponse.prototype.userId = "";

          /**
           * Creates a new DatabaseConnectorLoginResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @static
           * @param {stronachgroup.first.auth.IDatabaseConnectorLoginResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.DatabaseConnectorLoginResponse} DatabaseConnectorLoginResponse instance
           */
          DatabaseConnectorLoginResponse.create = function create(properties) {
            return new DatabaseConnectorLoginResponse(properties);
          };

          /**
           * Encodes the specified DatabaseConnectorLoginResponse message. Does not implicitly {@link stronachgroup.first.auth.DatabaseConnectorLoginResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @static
           * @param {stronachgroup.first.auth.IDatabaseConnectorLoginResponse} message DatabaseConnectorLoginResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          DatabaseConnectorLoginResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.email);
            if (
              message.username != null &&
              Object.hasOwnProperty.call(message, "username")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.username);
            if (
              message.userMetadata != null &&
              Object.hasOwnProperty.call(message, "userMetadata")
            )
              $root.stronachgroup.first.auth.UserMetadata.encode(
                message.userMetadata,
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
            if (
              message.metadata != null &&
              Object.hasOwnProperty.call(message, "metadata")
            )
              $root.stronachgroup.first.auth.AppMetadata.encode(
                message.metadata,
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
            if (
              message.givenName != null &&
              Object.hasOwnProperty.call(message, "givenName")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.givenName);
            if (
              message.familyName != null &&
              Object.hasOwnProperty.call(message, "familyName")
            )
              writer
                .uint32(/* id 6, wireType 2 =*/ 50)
                .string(message.familyName);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.name);
            if (
              message.phoneNumber != null &&
              Object.hasOwnProperty.call(message, "phoneNumber")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.phoneNumber);
            if (
              message.userId != null &&
              Object.hasOwnProperty.call(message, "userId")
            )
              writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.userId);
            return writer;
          };

          /**
           * Decodes a DatabaseConnectorLoginResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.DatabaseConnectorLoginResponse} DatabaseConnectorLoginResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          DatabaseConnectorLoginResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.email = reader.string();
                  break;
                case 2:
                  message.username = reader.string();
                  break;
                case 3:
                  message.userMetadata =
                    $root.stronachgroup.first.auth.UserMetadata.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 4:
                  message.metadata =
                    $root.stronachgroup.first.auth.AppMetadata.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 5:
                  message.givenName = reader.string();
                  break;
                case 6:
                  message.familyName = reader.string();
                  break;
                case 7:
                  message.name = reader.string();
                  break;
                case 8:
                  message.phoneNumber = reader.string();
                  break;
                case 9:
                  message.userId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a DatabaseConnectorLoginResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.DatabaseConnectorLoginResponse} DatabaseConnectorLoginResponse
           */
          DatabaseConnectorLoginResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse();
            if (object.email != null) message.email = String(object.email);
            if (object.username != null)
              message.username = String(object.username);
            if (object.userMetadata != null) {
              if (typeof object.userMetadata !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.DatabaseConnectorLoginResponse.userMetadata: object expected"
                );
              message.userMetadata =
                $root.stronachgroup.first.auth.UserMetadata.fromObject(
                  object.userMetadata
                );
            }
            if (object.metadata != null) {
              if (typeof object.metadata !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.DatabaseConnectorLoginResponse.metadata: object expected"
                );
              message.metadata =
                $root.stronachgroup.first.auth.AppMetadata.fromObject(
                  object.metadata
                );
            }
            if (object.givenName != null)
              message.givenName = String(object.givenName);
            if (object.familyName != null)
              message.familyName = String(object.familyName);
            if (object.name != null) message.name = String(object.name);
            if (object.phoneNumber != null)
              message.phoneNumber = String(object.phoneNumber);
            if (object.userId != null) message.userId = String(object.userId);
            return message;
          };

          /**
           * Creates a plain object from a DatabaseConnectorLoginResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @static
           * @param {stronachgroup.first.auth.DatabaseConnectorLoginResponse} message DatabaseConnectorLoginResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          DatabaseConnectorLoginResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.email = "";
              object.username = "";
              object.userMetadata = null;
              object.metadata = null;
              object.givenName = "";
              object.familyName = "";
              object.name = "";
              object.phoneNumber = "";
              object.userId = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (message.username != null && message.hasOwnProperty("username"))
              object.username = message.username;
            if (
              message.userMetadata != null &&
              message.hasOwnProperty("userMetadata")
            )
              object.userMetadata =
                $root.stronachgroup.first.auth.UserMetadata.toObject(
                  message.userMetadata,
                  options
                );
            if (message.metadata != null && message.hasOwnProperty("metadata"))
              object.metadata =
                $root.stronachgroup.first.auth.AppMetadata.toObject(
                  message.metadata,
                  options
                );
            if (
              message.givenName != null &&
              message.hasOwnProperty("givenName")
            )
              object.givenName = message.givenName;
            if (
              message.familyName != null &&
              message.hasOwnProperty("familyName")
            )
              object.familyName = message.familyName;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (
              message.phoneNumber != null &&
              message.hasOwnProperty("phoneNumber")
            )
              object.phoneNumber = message.phoneNumber;
            if (message.userId != null && message.hasOwnProperty("userId"))
              object.userId = message.userId;
            return object;
          };

          /**
           * Converts this DatabaseConnectorLoginResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.DatabaseConnectorLoginResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          DatabaseConnectorLoginResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return DatabaseConnectorLoginResponse;
        })();

        auth.UserMetadata = (function () {
          /**
           * Properties of a UserMetadata.
           * @memberof stronachgroup.first.auth
           * @interface IUserMetadata
           */

          /**
           * Constructs a new UserMetadata.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a UserMetadata.
           * @implements IUserMetadata
           * @constructor
           * @param {stronachgroup.first.auth.IUserMetadata=} [properties] Properties to set
           */
          function UserMetadata(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new UserMetadata instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UserMetadata
           * @static
           * @param {stronachgroup.first.auth.IUserMetadata=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UserMetadata} UserMetadata instance
           */
          UserMetadata.create = function create(properties) {
            return new UserMetadata(properties);
          };

          /**
           * Encodes the specified UserMetadata message. Does not implicitly {@link stronachgroup.first.auth.UserMetadata.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UserMetadata
           * @static
           * @param {stronachgroup.first.auth.IUserMetadata} message UserMetadata message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserMetadata.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a UserMetadata message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UserMetadata
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UserMetadata} UserMetadata
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserMetadata.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.auth.UserMetadata();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserMetadata message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UserMetadata
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UserMetadata} UserMetadata
           */
          UserMetadata.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.auth.UserMetadata)
              return object;
            return new $root.stronachgroup.first.auth.UserMetadata();
          };

          /**
           * Creates a plain object from a UserMetadata message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UserMetadata
           * @static
           * @param {stronachgroup.first.auth.UserMetadata} message UserMetadata
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserMetadata.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this UserMetadata to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UserMetadata
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserMetadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserMetadata;
        })();

        auth.AppMetadata = (function () {
          /**
           * Properties of an AppMetadata.
           * @memberof stronachgroup.first.auth
           * @interface IAppMetadata
           * @property {string|null} [encryptedPin] AppMetadata encryptedPin
           * @property {number|null} [customerId] AppMetadata customerId
           * @property {string|null} [accountId] AppMetadata accountId
           * @property {string|null} [customerStatus] AppMetadata customerStatus
           * @property {string|null} [birthday] AppMetadata birthday
           * @property {string|null} [zipcode] AppMetadata zipcode
           * @property {string|null} [community] AppMetadata community
           * @property {string|null} [firebaseUid] AppMetadata firebaseUid
           * @property {string|null} [pscAcct] AppMetadata pscAcct
           * @property {string|null} [residentialState] AppMetadata residentialState
           * @property {string|null} [xboproduct] AppMetadata xboproduct
           * @property {string|null} [vipLevel] AppMetadata vipLevel
           * @property {string|null} [vipLevelName] AppMetadata vipLevelName
           * @property {string|null} [rewardsType] AppMetadata rewardsType
           * @property {string|null} [accessLevel] AppMetadata accessLevel
           * @property {string|null} [customerSegment] AppMetadata customerSegment
           * @property {string|null} [customField] AppMetadata customField
           * @property {string|null} [country] AppMetadata country
           * @property {string|null} [xboRole] AppMetadata xboRole
           * @property {string|null} [preferredLanguage] AppMetadata preferredLanguage
           * @property {string|null} [username] AppMetadata username
           * @property {string|null} [address1] AppMetadata address1
           * @property {string|null} [address2] AppMetadata address2
           * @property {string|null} [city] AppMetadata city
           * @property {boolean|null} [ismyracehorse] AppMetadata ismyracehorse
           * @property {string|null} [firsttvAccount] AppMetadata firsttvAccount
           */

          /**
           * Constructs a new AppMetadata.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an AppMetadata.
           * @implements IAppMetadata
           * @constructor
           * @param {stronachgroup.first.auth.IAppMetadata=} [properties] Properties to set
           */
          function AppMetadata(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AppMetadata encryptedPin.
           * @member {string} encryptedPin
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.encryptedPin = "";

          /**
           * AppMetadata customerId.
           * @member {number} customerId
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.customerId = 0;

          /**
           * AppMetadata accountId.
           * @member {string} accountId
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.accountId = "";

          /**
           * AppMetadata customerStatus.
           * @member {string} customerStatus
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.customerStatus = "";

          /**
           * AppMetadata birthday.
           * @member {string} birthday
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.birthday = "";

          /**
           * AppMetadata zipcode.
           * @member {string} zipcode
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.zipcode = "";

          /**
           * AppMetadata community.
           * @member {string} community
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.community = "";

          /**
           * AppMetadata firebaseUid.
           * @member {string} firebaseUid
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.firebaseUid = "";

          /**
           * AppMetadata pscAcct.
           * @member {string} pscAcct
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.pscAcct = "";

          /**
           * AppMetadata residentialState.
           * @member {string} residentialState
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.residentialState = "";

          /**
           * AppMetadata xboproduct.
           * @member {string} xboproduct
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.xboproduct = "";

          /**
           * AppMetadata vipLevel.
           * @member {string} vipLevel
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.vipLevel = "";

          /**
           * AppMetadata vipLevelName.
           * @member {string} vipLevelName
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.vipLevelName = "";

          /**
           * AppMetadata rewardsType.
           * @member {string} rewardsType
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.rewardsType = "";

          /**
           * AppMetadata accessLevel.
           * @member {string} accessLevel
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.accessLevel = "";

          /**
           * AppMetadata customerSegment.
           * @member {string} customerSegment
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.customerSegment = "";

          /**
           * AppMetadata customField.
           * @member {string} customField
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.customField = "";

          /**
           * AppMetadata country.
           * @member {string} country
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.country = "";

          /**
           * AppMetadata xboRole.
           * @member {string} xboRole
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.xboRole = "";

          /**
           * AppMetadata preferredLanguage.
           * @member {string} preferredLanguage
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.preferredLanguage = "";

          /**
           * AppMetadata username.
           * @member {string} username
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.username = "";

          /**
           * AppMetadata address1.
           * @member {string} address1
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.address1 = "";

          /**
           * AppMetadata address2.
           * @member {string} address2
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.address2 = "";

          /**
           * AppMetadata city.
           * @member {string} city
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.city = "";

          /**
           * AppMetadata ismyracehorse.
           * @member {boolean} ismyracehorse
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.ismyracehorse = false;

          /**
           * AppMetadata firsttvAccount.
           * @member {string} firsttvAccount
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           */
          AppMetadata.prototype.firsttvAccount = "";

          /**
           * Creates a new AppMetadata instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.AppMetadata
           * @static
           * @param {stronachgroup.first.auth.IAppMetadata=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.AppMetadata} AppMetadata instance
           */
          AppMetadata.create = function create(properties) {
            return new AppMetadata(properties);
          };

          /**
           * Encodes the specified AppMetadata message. Does not implicitly {@link stronachgroup.first.auth.AppMetadata.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.AppMetadata
           * @static
           * @param {stronachgroup.first.auth.IAppMetadata} message AppMetadata message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AppMetadata.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.encryptedPin != null &&
              Object.hasOwnProperty.call(message, "encryptedPin")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.encryptedPin);
            if (
              message.customerId != null &&
              Object.hasOwnProperty.call(message, "customerId")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .int32(message.customerId);
            if (
              message.accountId != null &&
              Object.hasOwnProperty.call(message, "accountId")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.accountId);
            if (
              message.customerStatus != null &&
              Object.hasOwnProperty.call(message, "customerStatus")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.customerStatus);
            if (
              message.birthday != null &&
              Object.hasOwnProperty.call(message, "birthday")
            )
              writer
                .uint32(/* id 5, wireType 2 =*/ 42)
                .string(message.birthday);
            if (
              message.zipcode != null &&
              Object.hasOwnProperty.call(message, "zipcode")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.zipcode);
            if (
              message.community != null &&
              Object.hasOwnProperty.call(message, "community")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.community);
            if (
              message.firebaseUid != null &&
              Object.hasOwnProperty.call(message, "firebaseUid")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.firebaseUid);
            if (
              message.pscAcct != null &&
              Object.hasOwnProperty.call(message, "pscAcct")
            )
              writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.pscAcct);
            if (
              message.residentialState != null &&
              Object.hasOwnProperty.call(message, "residentialState")
            )
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.residentialState);
            if (
              message.xboproduct != null &&
              Object.hasOwnProperty.call(message, "xboproduct")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.xboproduct);
            if (
              message.vipLevel != null &&
              Object.hasOwnProperty.call(message, "vipLevel")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.vipLevel);
            if (
              message.vipLevelName != null &&
              Object.hasOwnProperty.call(message, "vipLevelName")
            )
              writer
                .uint32(/* id 13, wireType 2 =*/ 106)
                .string(message.vipLevelName);
            if (
              message.rewardsType != null &&
              Object.hasOwnProperty.call(message, "rewardsType")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.rewardsType);
            if (
              message.accessLevel != null &&
              Object.hasOwnProperty.call(message, "accessLevel")
            )
              writer
                .uint32(/* id 15, wireType 2 =*/ 122)
                .string(message.accessLevel);
            if (
              message.customerSegment != null &&
              Object.hasOwnProperty.call(message, "customerSegment")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.customerSegment);
            if (
              message.customField != null &&
              Object.hasOwnProperty.call(message, "customField")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.customField);
            if (
              message.country != null &&
              Object.hasOwnProperty.call(message, "country")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.country);
            if (
              message.xboRole != null &&
              Object.hasOwnProperty.call(message, "xboRole")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.xboRole);
            if (
              message.preferredLanguage != null &&
              Object.hasOwnProperty.call(message, "preferredLanguage")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.preferredLanguage);
            if (
              message.username != null &&
              Object.hasOwnProperty.call(message, "username")
            )
              writer
                .uint32(/* id 21, wireType 2 =*/ 170)
                .string(message.username);
            if (
              message.address1 != null &&
              Object.hasOwnProperty.call(message, "address1")
            )
              writer
                .uint32(/* id 22, wireType 2 =*/ 178)
                .string(message.address1);
            if (
              message.address2 != null &&
              Object.hasOwnProperty.call(message, "address2")
            )
              writer
                .uint32(/* id 23, wireType 2 =*/ 186)
                .string(message.address2);
            if (
              message.city != null &&
              Object.hasOwnProperty.call(message, "city")
            )
              writer.uint32(/* id 24, wireType 2 =*/ 194).string(message.city);
            if (
              message.ismyracehorse != null &&
              Object.hasOwnProperty.call(message, "ismyracehorse")
            )
              writer
                .uint32(/* id 25, wireType 0 =*/ 200)
                .bool(message.ismyracehorse);
            if (
              message.firsttvAccount != null &&
              Object.hasOwnProperty.call(message, "firsttvAccount")
            )
              writer
                .uint32(/* id 26, wireType 2 =*/ 210)
                .string(message.firsttvAccount);
            return writer;
          };

          /**
           * Decodes an AppMetadata message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.AppMetadata
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.AppMetadata} AppMetadata
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AppMetadata.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.auth.AppMetadata();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.encryptedPin = reader.string();
                  break;
                case 2:
                  message.customerId = reader.int32();
                  break;
                case 3:
                  message.accountId = reader.string();
                  break;
                case 4:
                  message.customerStatus = reader.string();
                  break;
                case 5:
                  message.birthday = reader.string();
                  break;
                case 6:
                  message.zipcode = reader.string();
                  break;
                case 7:
                  message.community = reader.string();
                  break;
                case 8:
                  message.firebaseUid = reader.string();
                  break;
                case 9:
                  message.pscAcct = reader.string();
                  break;
                case 10:
                  message.residentialState = reader.string();
                  break;
                case 11:
                  message.xboproduct = reader.string();
                  break;
                case 12:
                  message.vipLevel = reader.string();
                  break;
                case 13:
                  message.vipLevelName = reader.string();
                  break;
                case 14:
                  message.rewardsType = reader.string();
                  break;
                case 15:
                  message.accessLevel = reader.string();
                  break;
                case 16:
                  message.customerSegment = reader.string();
                  break;
                case 17:
                  message.customField = reader.string();
                  break;
                case 18:
                  message.country = reader.string();
                  break;
                case 19:
                  message.xboRole = reader.string();
                  break;
                case 20:
                  message.preferredLanguage = reader.string();
                  break;
                case 21:
                  message.username = reader.string();
                  break;
                case 22:
                  message.address1 = reader.string();
                  break;
                case 23:
                  message.address2 = reader.string();
                  break;
                case 24:
                  message.city = reader.string();
                  break;
                case 25:
                  message.ismyracehorse = reader.bool();
                  break;
                case 26:
                  message.firsttvAccount = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AppMetadata message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.AppMetadata
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.AppMetadata} AppMetadata
           */
          AppMetadata.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.auth.AppMetadata)
              return object;
            var message = new $root.stronachgroup.first.auth.AppMetadata();
            if (object.encryptedPin != null)
              message.encryptedPin = String(object.encryptedPin);
            if (object.customerId != null)
              message.customerId = object.customerId | 0;
            if (object.accountId != null)
              message.accountId = String(object.accountId);
            if (object.customerStatus != null)
              message.customerStatus = String(object.customerStatus);
            if (object.birthday != null)
              message.birthday = String(object.birthday);
            if (object.zipcode != null)
              message.zipcode = String(object.zipcode);
            if (object.community != null)
              message.community = String(object.community);
            if (object.firebaseUid != null)
              message.firebaseUid = String(object.firebaseUid);
            if (object.pscAcct != null)
              message.pscAcct = String(object.pscAcct);
            if (object.residentialState != null)
              message.residentialState = String(object.residentialState);
            if (object.xboproduct != null)
              message.xboproduct = String(object.xboproduct);
            if (object.vipLevel != null)
              message.vipLevel = String(object.vipLevel);
            if (object.vipLevelName != null)
              message.vipLevelName = String(object.vipLevelName);
            if (object.rewardsType != null)
              message.rewardsType = String(object.rewardsType);
            if (object.accessLevel != null)
              message.accessLevel = String(object.accessLevel);
            if (object.customerSegment != null)
              message.customerSegment = String(object.customerSegment);
            if (object.customField != null)
              message.customField = String(object.customField);
            if (object.country != null)
              message.country = String(object.country);
            if (object.xboRole != null)
              message.xboRole = String(object.xboRole);
            if (object.preferredLanguage != null)
              message.preferredLanguage = String(object.preferredLanguage);
            if (object.username != null)
              message.username = String(object.username);
            if (object.address1 != null)
              message.address1 = String(object.address1);
            if (object.address2 != null)
              message.address2 = String(object.address2);
            if (object.city != null) message.city = String(object.city);
            if (object.ismyracehorse != null)
              message.ismyracehorse = Boolean(object.ismyracehorse);
            if (object.firsttvAccount != null)
              message.firsttvAccount = String(object.firsttvAccount);
            return message;
          };

          /**
           * Creates a plain object from an AppMetadata message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.AppMetadata
           * @static
           * @param {stronachgroup.first.auth.AppMetadata} message AppMetadata
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AppMetadata.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.encryptedPin = "";
              object.customerId = 0;
              object.accountId = "";
              object.customerStatus = "";
              object.birthday = "";
              object.zipcode = "";
              object.community = "";
              object.firebaseUid = "";
              object.pscAcct = "";
              object.residentialState = "";
              object.xboproduct = "";
              object.vipLevel = "";
              object.vipLevelName = "";
              object.rewardsType = "";
              object.accessLevel = "";
              object.customerSegment = "";
              object.customField = "";
              object.country = "";
              object.xboRole = "";
              object.preferredLanguage = "";
              object.username = "";
              object.address1 = "";
              object.address2 = "";
              object.city = "";
              object.ismyracehorse = false;
              object.firsttvAccount = "";
            }
            if (
              message.encryptedPin != null &&
              message.hasOwnProperty("encryptedPin")
            )
              object.encryptedPin = message.encryptedPin;
            if (
              message.customerId != null &&
              message.hasOwnProperty("customerId")
            )
              object.customerId = message.customerId;
            if (
              message.accountId != null &&
              message.hasOwnProperty("accountId")
            )
              object.accountId = message.accountId;
            if (
              message.customerStatus != null &&
              message.hasOwnProperty("customerStatus")
            )
              object.customerStatus = message.customerStatus;
            if (message.birthday != null && message.hasOwnProperty("birthday"))
              object.birthday = message.birthday;
            if (message.zipcode != null && message.hasOwnProperty("zipcode"))
              object.zipcode = message.zipcode;
            if (
              message.community != null &&
              message.hasOwnProperty("community")
            )
              object.community = message.community;
            if (
              message.firebaseUid != null &&
              message.hasOwnProperty("firebaseUid")
            )
              object.firebaseUid = message.firebaseUid;
            if (message.pscAcct != null && message.hasOwnProperty("pscAcct"))
              object.pscAcct = message.pscAcct;
            if (
              message.residentialState != null &&
              message.hasOwnProperty("residentialState")
            )
              object.residentialState = message.residentialState;
            if (
              message.xboproduct != null &&
              message.hasOwnProperty("xboproduct")
            )
              object.xboproduct = message.xboproduct;
            if (message.vipLevel != null && message.hasOwnProperty("vipLevel"))
              object.vipLevel = message.vipLevel;
            if (
              message.vipLevelName != null &&
              message.hasOwnProperty("vipLevelName")
            )
              object.vipLevelName = message.vipLevelName;
            if (
              message.rewardsType != null &&
              message.hasOwnProperty("rewardsType")
            )
              object.rewardsType = message.rewardsType;
            if (
              message.accessLevel != null &&
              message.hasOwnProperty("accessLevel")
            )
              object.accessLevel = message.accessLevel;
            if (
              message.customerSegment != null &&
              message.hasOwnProperty("customerSegment")
            )
              object.customerSegment = message.customerSegment;
            if (
              message.customField != null &&
              message.hasOwnProperty("customField")
            )
              object.customField = message.customField;
            if (message.country != null && message.hasOwnProperty("country"))
              object.country = message.country;
            if (message.xboRole != null && message.hasOwnProperty("xboRole"))
              object.xboRole = message.xboRole;
            if (
              message.preferredLanguage != null &&
              message.hasOwnProperty("preferredLanguage")
            )
              object.preferredLanguage = message.preferredLanguage;
            if (message.username != null && message.hasOwnProperty("username"))
              object.username = message.username;
            if (message.address1 != null && message.hasOwnProperty("address1"))
              object.address1 = message.address1;
            if (message.address2 != null && message.hasOwnProperty("address2"))
              object.address2 = message.address2;
            if (message.city != null && message.hasOwnProperty("city"))
              object.city = message.city;
            if (
              message.ismyracehorse != null &&
              message.hasOwnProperty("ismyracehorse")
            )
              object.ismyracehorse = message.ismyracehorse;
            if (
              message.firsttvAccount != null &&
              message.hasOwnProperty("firsttvAccount")
            )
              object.firsttvAccount = message.firsttvAccount;
            return object;
          };

          /**
           * Converts this AppMetadata to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.AppMetadata
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AppMetadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AppMetadata;
        })();

        auth.AuthenticateUserResponse = (function () {
          /**
           * Properties of an AuthenticateUserResponse.
           * @memberof stronachgroup.first.auth
           * @interface IAuthenticateUserResponse
           * @property {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null} [auth0Data] AuthenticateUserResponse auth0Data
           */

          /**
           * Constructs a new AuthenticateUserResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an AuthenticateUserResponse.
           * @implements IAuthenticateUserResponse
           * @constructor
           * @param {stronachgroup.first.auth.IAuthenticateUserResponse=} [properties] Properties to set
           */
          function AuthenticateUserResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AuthenticateUserResponse auth0Data.
           * @member {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null|undefined} auth0Data
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @instance
           */
          AuthenticateUserResponse.prototype.auth0Data = null;

          /**
           * Creates a new AuthenticateUserResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @static
           * @param {stronachgroup.first.auth.IAuthenticateUserResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.AuthenticateUserResponse} AuthenticateUserResponse instance
           */
          AuthenticateUserResponse.create = function create(properties) {
            return new AuthenticateUserResponse(properties);
          };

          /**
           * Encodes the specified AuthenticateUserResponse message. Does not implicitly {@link stronachgroup.first.auth.AuthenticateUserResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @static
           * @param {stronachgroup.first.auth.IAuthenticateUserResponse} message AuthenticateUserResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AuthenticateUserResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.auth0Data != null &&
              Object.hasOwnProperty.call(message, "auth0Data")
            )
              $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.encode(
                message.auth0Data,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AuthenticateUserResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.AuthenticateUserResponse} AuthenticateUserResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AuthenticateUserResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.AuthenticateUserResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.auth0Data =
                    $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AuthenticateUserResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.AuthenticateUserResponse} AuthenticateUserResponse
           */
          AuthenticateUserResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.AuthenticateUserResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.AuthenticateUserResponse();
            if (object.auth0Data != null) {
              if (typeof object.auth0Data !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.AuthenticateUserResponse.auth0Data: object expected"
                );
              message.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.fromObject(
                  object.auth0Data
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AuthenticateUserResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @static
           * @param {stronachgroup.first.auth.AuthenticateUserResponse} message AuthenticateUserResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AuthenticateUserResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.auth0Data = null;
            if (
              message.auth0Data != null &&
              message.hasOwnProperty("auth0Data")
            )
              object.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.toObject(
                  message.auth0Data,
                  options
                );
            return object;
          };

          /**
           * Converts this AuthenticateUserResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.AuthenticateUserResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AuthenticateUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AuthenticateUserResponse;
        })();

        auth.AuthenticatePinUserResponse = (function () {
          /**
           * Properties of an AuthenticatePinUserResponse.
           * @memberof stronachgroup.first.auth
           * @interface IAuthenticatePinUserResponse
           * @property {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null} [auth0Data] AuthenticatePinUserResponse auth0Data
           */

          /**
           * Constructs a new AuthenticatePinUserResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an AuthenticatePinUserResponse.
           * @implements IAuthenticatePinUserResponse
           * @constructor
           * @param {stronachgroup.first.auth.IAuthenticatePinUserResponse=} [properties] Properties to set
           */
          function AuthenticatePinUserResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * AuthenticatePinUserResponse auth0Data.
           * @member {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null|undefined} auth0Data
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @instance
           */
          AuthenticatePinUserResponse.prototype.auth0Data = null;

          /**
           * Creates a new AuthenticatePinUserResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @static
           * @param {stronachgroup.first.auth.IAuthenticatePinUserResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.AuthenticatePinUserResponse} AuthenticatePinUserResponse instance
           */
          AuthenticatePinUserResponse.create = function create(properties) {
            return new AuthenticatePinUserResponse(properties);
          };

          /**
           * Encodes the specified AuthenticatePinUserResponse message. Does not implicitly {@link stronachgroup.first.auth.AuthenticatePinUserResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @static
           * @param {stronachgroup.first.auth.IAuthenticatePinUserResponse} message AuthenticatePinUserResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          AuthenticatePinUserResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.auth0Data != null &&
              Object.hasOwnProperty.call(message, "auth0Data")
            )
              $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.encode(
                message.auth0Data,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an AuthenticatePinUserResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.AuthenticatePinUserResponse} AuthenticatePinUserResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          AuthenticatePinUserResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.AuthenticatePinUserResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.auth0Data =
                    $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an AuthenticatePinUserResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.AuthenticatePinUserResponse} AuthenticatePinUserResponse
           */
          AuthenticatePinUserResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.AuthenticatePinUserResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.AuthenticatePinUserResponse();
            if (object.auth0Data != null) {
              if (typeof object.auth0Data !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.AuthenticatePinUserResponse.auth0Data: object expected"
                );
              message.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.fromObject(
                  object.auth0Data
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an AuthenticatePinUserResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @static
           * @param {stronachgroup.first.auth.AuthenticatePinUserResponse} message AuthenticatePinUserResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          AuthenticatePinUserResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.auth0Data = null;
            if (
              message.auth0Data != null &&
              message.hasOwnProperty("auth0Data")
            )
              object.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.toObject(
                  message.auth0Data,
                  options
                );
            return object;
          };

          /**
           * Converts this AuthenticatePinUserResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.AuthenticatePinUserResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          AuthenticatePinUserResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return AuthenticatePinUserResponse;
        })();

        auth.FirebaseTokenRequest = (function () {
          /**
           * Properties of a FirebaseTokenRequest.
           * @memberof stronachgroup.first.auth
           * @interface IFirebaseTokenRequest
           */

          /**
           * Constructs a new FirebaseTokenRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a FirebaseTokenRequest.
           * @implements IFirebaseTokenRequest
           * @constructor
           * @param {stronachgroup.first.auth.IFirebaseTokenRequest=} [properties] Properties to set
           */
          function FirebaseTokenRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new FirebaseTokenRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @static
           * @param {stronachgroup.first.auth.IFirebaseTokenRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.FirebaseTokenRequest} FirebaseTokenRequest instance
           */
          FirebaseTokenRequest.create = function create(properties) {
            return new FirebaseTokenRequest(properties);
          };

          /**
           * Encodes the specified FirebaseTokenRequest message. Does not implicitly {@link stronachgroup.first.auth.FirebaseTokenRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @static
           * @param {stronachgroup.first.auth.IFirebaseTokenRequest} message FirebaseTokenRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FirebaseTokenRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a FirebaseTokenRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.FirebaseTokenRequest} FirebaseTokenRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FirebaseTokenRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.FirebaseTokenRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FirebaseTokenRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.FirebaseTokenRequest} FirebaseTokenRequest
           */
          FirebaseTokenRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.FirebaseTokenRequest
            )
              return object;
            return new $root.stronachgroup.first.auth.FirebaseTokenRequest();
          };

          /**
           * Creates a plain object from a FirebaseTokenRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @static
           * @param {stronachgroup.first.auth.FirebaseTokenRequest} message FirebaseTokenRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FirebaseTokenRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this FirebaseTokenRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.FirebaseTokenRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FirebaseTokenRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FirebaseTokenRequest;
        })();

        auth.FirebaseTokenResponse = (function () {
          /**
           * Properties of a FirebaseTokenResponse.
           * @memberof stronachgroup.first.auth
           * @interface IFirebaseTokenResponse
           * @property {string|null} [token] FirebaseTokenResponse token
           */

          /**
           * Constructs a new FirebaseTokenResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a FirebaseTokenResponse.
           * @implements IFirebaseTokenResponse
           * @constructor
           * @param {stronachgroup.first.auth.IFirebaseTokenResponse=} [properties] Properties to set
           */
          function FirebaseTokenResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FirebaseTokenResponse token.
           * @member {string} token
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @instance
           */
          FirebaseTokenResponse.prototype.token = "";

          /**
           * Creates a new FirebaseTokenResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @static
           * @param {stronachgroup.first.auth.IFirebaseTokenResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.FirebaseTokenResponse} FirebaseTokenResponse instance
           */
          FirebaseTokenResponse.create = function create(properties) {
            return new FirebaseTokenResponse(properties);
          };

          /**
           * Encodes the specified FirebaseTokenResponse message. Does not implicitly {@link stronachgroup.first.auth.FirebaseTokenResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @static
           * @param {stronachgroup.first.auth.IFirebaseTokenResponse} message FirebaseTokenResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FirebaseTokenResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.token != null &&
              Object.hasOwnProperty.call(message, "token")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.token);
            return writer;
          };

          /**
           * Decodes a FirebaseTokenResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.FirebaseTokenResponse} FirebaseTokenResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FirebaseTokenResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.FirebaseTokenResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.token = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FirebaseTokenResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.FirebaseTokenResponse} FirebaseTokenResponse
           */
          FirebaseTokenResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.FirebaseTokenResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.FirebaseTokenResponse();
            if (object.token != null) message.token = String(object.token);
            return message;
          };

          /**
           * Creates a plain object from a FirebaseTokenResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @static
           * @param {stronachgroup.first.auth.FirebaseTokenResponse} message FirebaseTokenResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FirebaseTokenResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.token = "";
            if (message.token != null && message.hasOwnProperty("token"))
              object.token = message.token;
            return object;
          };

          /**
           * Converts this FirebaseTokenResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.FirebaseTokenResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FirebaseTokenResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FirebaseTokenResponse;
        })();

        auth.GetUserByUsernameRequest = (function () {
          /**
           * Properties of a GetUserByUsernameRequest.
           * @memberof stronachgroup.first.auth
           * @interface IGetUserByUsernameRequest
           * @property {string|null} [username] GetUserByUsernameRequest username
           * @property {boolean|null} [emailLookupFallback] GetUserByUsernameRequest emailLookupFallback
           * @property {string|null} [partner] GetUserByUsernameRequest partner
           */

          /**
           * Constructs a new GetUserByUsernameRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetUserByUsernameRequest.
           * @implements IGetUserByUsernameRequest
           * @constructor
           * @param {stronachgroup.first.auth.IGetUserByUsernameRequest=} [properties] Properties to set
           */
          function GetUserByUsernameRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUserByUsernameRequest username.
           * @member {string} username
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @instance
           */
          GetUserByUsernameRequest.prototype.username = "";

          /**
           * GetUserByUsernameRequest emailLookupFallback.
           * @member {boolean} emailLookupFallback
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @instance
           */
          GetUserByUsernameRequest.prototype.emailLookupFallback = false;

          /**
           * GetUserByUsernameRequest partner.
           * @member {string} partner
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @instance
           */
          GetUserByUsernameRequest.prototype.partner = "";

          /**
           * Creates a new GetUserByUsernameRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @static
           * @param {stronachgroup.first.auth.IGetUserByUsernameRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetUserByUsernameRequest} GetUserByUsernameRequest instance
           */
          GetUserByUsernameRequest.create = function create(properties) {
            return new GetUserByUsernameRequest(properties);
          };

          /**
           * Encodes the specified GetUserByUsernameRequest message. Does not implicitly {@link stronachgroup.first.auth.GetUserByUsernameRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @static
           * @param {stronachgroup.first.auth.IGetUserByUsernameRequest} message GetUserByUsernameRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserByUsernameRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.username != null &&
              Object.hasOwnProperty.call(message, "username")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.username);
            if (
              message.emailLookupFallback != null &&
              Object.hasOwnProperty.call(message, "emailLookupFallback")
            )
              writer
                .uint32(/* id 2, wireType 0 =*/ 16)
                .bool(message.emailLookupFallback);
            if (
              message.partner != null &&
              Object.hasOwnProperty.call(message, "partner")
            )
              writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.partner);
            return writer;
          };

          /**
           * Decodes a GetUserByUsernameRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetUserByUsernameRequest} GetUserByUsernameRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserByUsernameRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.GetUserByUsernameRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.username = reader.string();
                  break;
                case 2:
                  message.emailLookupFallback = reader.bool();
                  break;
                case 3:
                  message.partner = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserByUsernameRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetUserByUsernameRequest} GetUserByUsernameRequest
           */
          GetUserByUsernameRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetUserByUsernameRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.GetUserByUsernameRequest();
            if (object.username != null)
              message.username = String(object.username);
            if (object.emailLookupFallback != null)
              message.emailLookupFallback = Boolean(object.emailLookupFallback);
            if (object.partner != null)
              message.partner = String(object.partner);
            return message;
          };

          /**
           * Creates a plain object from a GetUserByUsernameRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @static
           * @param {stronachgroup.first.auth.GetUserByUsernameRequest} message GetUserByUsernameRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserByUsernameRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.username = "";
              object.emailLookupFallback = false;
              object.partner = "";
            }
            if (message.username != null && message.hasOwnProperty("username"))
              object.username = message.username;
            if (
              message.emailLookupFallback != null &&
              message.hasOwnProperty("emailLookupFallback")
            )
              object.emailLookupFallback = message.emailLookupFallback;
            if (message.partner != null && message.hasOwnProperty("partner"))
              object.partner = message.partner;
            return object;
          };

          /**
           * Converts this GetUserByUsernameRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetUserByUsernameRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserByUsernameRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUserByUsernameRequest;
        })();

        auth.GetUserByUsernameResponse = (function () {
          /**
           * Properties of a GetUserByUsernameResponse.
           * @memberof stronachgroup.first.auth
           * @interface IGetUserByUsernameResponse
           * @property {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null} [auth0Data] GetUserByUsernameResponse auth0Data
           */

          /**
           * Constructs a new GetUserByUsernameResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetUserByUsernameResponse.
           * @implements IGetUserByUsernameResponse
           * @constructor
           * @param {stronachgroup.first.auth.IGetUserByUsernameResponse=} [properties] Properties to set
           */
          function GetUserByUsernameResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUserByUsernameResponse auth0Data.
           * @member {stronachgroup.first.auth.IDatabaseConnectorLoginResponse|null|undefined} auth0Data
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @instance
           */
          GetUserByUsernameResponse.prototype.auth0Data = null;

          /**
           * Creates a new GetUserByUsernameResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @static
           * @param {stronachgroup.first.auth.IGetUserByUsernameResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetUserByUsernameResponse} GetUserByUsernameResponse instance
           */
          GetUserByUsernameResponse.create = function create(properties) {
            return new GetUserByUsernameResponse(properties);
          };

          /**
           * Encodes the specified GetUserByUsernameResponse message. Does not implicitly {@link stronachgroup.first.auth.GetUserByUsernameResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @static
           * @param {stronachgroup.first.auth.IGetUserByUsernameResponse} message GetUserByUsernameResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserByUsernameResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.auth0Data != null &&
              Object.hasOwnProperty.call(message, "auth0Data")
            )
              $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.encode(
                message.auth0Data,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetUserByUsernameResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetUserByUsernameResponse} GetUserByUsernameResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserByUsernameResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.GetUserByUsernameResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.auth0Data =
                    $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserByUsernameResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetUserByUsernameResponse} GetUserByUsernameResponse
           */
          GetUserByUsernameResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetUserByUsernameResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.GetUserByUsernameResponse();
            if (object.auth0Data != null) {
              if (typeof object.auth0Data !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.GetUserByUsernameResponse.auth0Data: object expected"
                );
              message.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.fromObject(
                  object.auth0Data
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a GetUserByUsernameResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @static
           * @param {stronachgroup.first.auth.GetUserByUsernameResponse} message GetUserByUsernameResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserByUsernameResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.auth0Data = null;
            if (
              message.auth0Data != null &&
              message.hasOwnProperty("auth0Data")
            )
              object.auth0Data =
                $root.stronachgroup.first.auth.DatabaseConnectorLoginResponse.toObject(
                  message.auth0Data,
                  options
                );
            return object;
          };

          /**
           * Converts this GetUserByUsernameResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetUserByUsernameResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserByUsernameResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUserByUsernameResponse;
        })();

        auth.GetUserInfoRequest = (function () {
          /**
           * Properties of a GetUserInfoRequest.
           * @memberof stronachgroup.first.auth
           * @interface IGetUserInfoRequest
           */

          /**
           * Constructs a new GetUserInfoRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetUserInfoRequest.
           * @implements IGetUserInfoRequest
           * @constructor
           * @param {stronachgroup.first.auth.IGetUserInfoRequest=} [properties] Properties to set
           */
          function GetUserInfoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new GetUserInfoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @static
           * @param {stronachgroup.first.auth.IGetUserInfoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetUserInfoRequest} GetUserInfoRequest instance
           */
          GetUserInfoRequest.create = function create(properties) {
            return new GetUserInfoRequest(properties);
          };

          /**
           * Encodes the specified GetUserInfoRequest message. Does not implicitly {@link stronachgroup.first.auth.GetUserInfoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @static
           * @param {stronachgroup.first.auth.IGetUserInfoRequest} message GetUserInfoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserInfoRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a GetUserInfoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetUserInfoRequest} GetUserInfoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.auth.GetUserInfoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserInfoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetUserInfoRequest} GetUserInfoRequest
           */
          GetUserInfoRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetUserInfoRequest
            )
              return object;
            return new $root.stronachgroup.first.auth.GetUserInfoRequest();
          };

          /**
           * Creates a plain object from a GetUserInfoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @static
           * @param {stronachgroup.first.auth.GetUserInfoRequest} message GetUserInfoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserInfoRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this GetUserInfoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetUserInfoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetUserInfoRequest;
        })();

        auth.GetUserInfoResponse = (function () {
          /**
           * Properties of a GetUserInfoResponse.
           * @memberof stronachgroup.first.auth
           * @interface IGetUserInfoResponse
           * @property {string|null} [sub] GetUserInfoResponse sub
           * @property {string|null} [givenName] GetUserInfoResponse givenName
           * @property {string|null} [familyName] GetUserInfoResponse familyName
           * @property {string|null} [nickname] GetUserInfoResponse nickname
           * @property {string|null} [name] GetUserInfoResponse name
           * @property {string|null} [picture] GetUserInfoResponse picture
           * @property {string|null} [birthdate] GetUserInfoResponse birthdate
           * @property {string|null} [updatedAt] GetUserInfoResponse updatedAt
           * @property {string|null} [email] GetUserInfoResponse email
           * @property {stronachgroup.first.auth.GetUserInfoResponse.IAddress|null} [address] GetUserInfoResponse address
           * @property {string|null} [phoneNumber] GetUserInfoResponse phoneNumber
           * @property {string|null} [accountId] GetUserInfoResponse accountId
           * @property {number|null} [customerId] GetUserInfoResponse customerId
           * @property {string|null} [customerStatus] GetUserInfoResponse customerStatus
           * @property {string|null} [pin] GetUserInfoResponse pin
           * @property {string|null} [gatewayId] GetUserInfoResponse gatewayId
           * @property {string|null} [community] GetUserInfoResponse community
           * @property {string|null} [firebaseUid] GetUserInfoResponse firebaseUid
           * @property {string|null} [pscAcct] GetUserInfoResponse pscAcct
           * @property {string|null} [xboproduct] GetUserInfoResponse xboproduct
           * @property {string|null} [vipLevel] GetUserInfoResponse vipLevel
           * @property {string|null} [vipLevelName] GetUserInfoResponse vipLevelName
           * @property {string|null} [rewardsType] GetUserInfoResponse rewardsType
           * @property {string|null} [accessLevel] GetUserInfoResponse accessLevel
           * @property {string|null} [customerSegment] GetUserInfoResponse customerSegment
           * @property {string|null} [customField] GetUserInfoResponse customField
           * @property {string|null} [xboRole] GetUserInfoResponse xboRole
           * @property {string|null} [preferredLanguage] GetUserInfoResponse preferredLanguage
           * @property {string|null} [username] GetUserInfoResponse username
           * @property {Array.<stronachgroup.first.auth.IUserIdentity>|null} [identities] GetUserInfoResponse identities
           */

          /**
           * Constructs a new GetUserInfoResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetUserInfoResponse.
           * @implements IGetUserInfoResponse
           * @constructor
           * @param {stronachgroup.first.auth.IGetUserInfoResponse=} [properties] Properties to set
           */
          function GetUserInfoResponse(properties) {
            this.identities = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetUserInfoResponse sub.
           * @member {string} sub
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.sub = "";

          /**
           * GetUserInfoResponse givenName.
           * @member {string} givenName
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.givenName = "";

          /**
           * GetUserInfoResponse familyName.
           * @member {string} familyName
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.familyName = "";

          /**
           * GetUserInfoResponse nickname.
           * @member {string} nickname
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.nickname = "";

          /**
           * GetUserInfoResponse name.
           * @member {string} name
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.name = "";

          /**
           * GetUserInfoResponse picture.
           * @member {string} picture
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.picture = "";

          /**
           * GetUserInfoResponse birthdate.
           * @member {string} birthdate
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.birthdate = "";

          /**
           * GetUserInfoResponse updatedAt.
           * @member {string} updatedAt
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.updatedAt = "";

          /**
           * GetUserInfoResponse email.
           * @member {string} email
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.email = "";

          /**
           * GetUserInfoResponse address.
           * @member {stronachgroup.first.auth.GetUserInfoResponse.IAddress|null|undefined} address
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.address = null;

          /**
           * GetUserInfoResponse phoneNumber.
           * @member {string} phoneNumber
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.phoneNumber = "";

          /**
           * GetUserInfoResponse accountId.
           * @member {string} accountId
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.accountId = "";

          /**
           * GetUserInfoResponse customerId.
           * @member {number} customerId
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.customerId = 0;

          /**
           * GetUserInfoResponse customerStatus.
           * @member {string} customerStatus
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.customerStatus = "";

          /**
           * GetUserInfoResponse pin.
           * @member {string} pin
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.pin = "";

          /**
           * GetUserInfoResponse gatewayId.
           * @member {string} gatewayId
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.gatewayId = "";

          /**
           * GetUserInfoResponse community.
           * @member {string} community
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.community = "";

          /**
           * GetUserInfoResponse firebaseUid.
           * @member {string} firebaseUid
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.firebaseUid = "";

          /**
           * GetUserInfoResponse pscAcct.
           * @member {string} pscAcct
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.pscAcct = "";

          /**
           * GetUserInfoResponse xboproduct.
           * @member {string} xboproduct
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.xboproduct = "";

          /**
           * GetUserInfoResponse vipLevel.
           * @member {string} vipLevel
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.vipLevel = "";

          /**
           * GetUserInfoResponse vipLevelName.
           * @member {string} vipLevelName
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.vipLevelName = "";

          /**
           * GetUserInfoResponse rewardsType.
           * @member {string} rewardsType
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.rewardsType = "";

          /**
           * GetUserInfoResponse accessLevel.
           * @member {string} accessLevel
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.accessLevel = "";

          /**
           * GetUserInfoResponse customerSegment.
           * @member {string} customerSegment
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.customerSegment = "";

          /**
           * GetUserInfoResponse customField.
           * @member {string} customField
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.customField = "";

          /**
           * GetUserInfoResponse xboRole.
           * @member {string} xboRole
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.xboRole = "";

          /**
           * GetUserInfoResponse preferredLanguage.
           * @member {string} preferredLanguage
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.preferredLanguage = "";

          /**
           * GetUserInfoResponse username.
           * @member {string} username
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.username = "";

          /**
           * GetUserInfoResponse identities.
           * @member {Array.<stronachgroup.first.auth.IUserIdentity>} identities
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           */
          GetUserInfoResponse.prototype.identities = $util.emptyArray;

          /**
           * Creates a new GetUserInfoResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @static
           * @param {stronachgroup.first.auth.IGetUserInfoResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetUserInfoResponse} GetUserInfoResponse instance
           */
          GetUserInfoResponse.create = function create(properties) {
            return new GetUserInfoResponse(properties);
          };

          /**
           * Encodes the specified GetUserInfoResponse message. Does not implicitly {@link stronachgroup.first.auth.GetUserInfoResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @static
           * @param {stronachgroup.first.auth.IGetUserInfoResponse} message GetUserInfoResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetUserInfoResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.sub != null &&
              Object.hasOwnProperty.call(message, "sub")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sub);
            if (
              message.givenName != null &&
              Object.hasOwnProperty.call(message, "givenName")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.givenName);
            if (
              message.familyName != null &&
              Object.hasOwnProperty.call(message, "familyName")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.familyName);
            if (
              message.nickname != null &&
              Object.hasOwnProperty.call(message, "nickname")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.nickname);
            if (
              message.name != null &&
              Object.hasOwnProperty.call(message, "name")
            )
              writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.name);
            if (
              message.picture != null &&
              Object.hasOwnProperty.call(message, "picture")
            )
              writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.picture);
            if (
              message.birthdate != null &&
              Object.hasOwnProperty.call(message, "birthdate")
            )
              writer
                .uint32(/* id 7, wireType 2 =*/ 58)
                .string(message.birthdate);
            if (
              message.updatedAt != null &&
              Object.hasOwnProperty.call(message, "updatedAt")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.updatedAt);
            if (
              message.email != null &&
              Object.hasOwnProperty.call(message, "email")
            )
              writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.email);
            if (
              message.address != null &&
              Object.hasOwnProperty.call(message, "address")
            )
              $root.stronachgroup.first.auth.GetUserInfoResponse.Address.encode(
                message.address,
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork()
              ).ldelim();
            if (
              message.phoneNumber != null &&
              Object.hasOwnProperty.call(message, "phoneNumber")
            )
              writer
                .uint32(/* id 11, wireType 2 =*/ 90)
                .string(message.phoneNumber);
            if (
              message.accountId != null &&
              Object.hasOwnProperty.call(message, "accountId")
            )
              writer
                .uint32(/* id 12, wireType 2 =*/ 98)
                .string(message.accountId);
            if (
              message.customerId != null &&
              Object.hasOwnProperty.call(message, "customerId")
            )
              writer
                .uint32(/* id 13, wireType 0 =*/ 104)
                .int32(message.customerId);
            if (
              message.customerStatus != null &&
              Object.hasOwnProperty.call(message, "customerStatus")
            )
              writer
                .uint32(/* id 14, wireType 2 =*/ 114)
                .string(message.customerStatus);
            if (
              message.pin != null &&
              Object.hasOwnProperty.call(message, "pin")
            )
              writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.pin);
            if (
              message.gatewayId != null &&
              Object.hasOwnProperty.call(message, "gatewayId")
            )
              writer
                .uint32(/* id 16, wireType 2 =*/ 130)
                .string(message.gatewayId);
            if (
              message.community != null &&
              Object.hasOwnProperty.call(message, "community")
            )
              writer
                .uint32(/* id 17, wireType 2 =*/ 138)
                .string(message.community);
            if (
              message.firebaseUid != null &&
              Object.hasOwnProperty.call(message, "firebaseUid")
            )
              writer
                .uint32(/* id 18, wireType 2 =*/ 146)
                .string(message.firebaseUid);
            if (
              message.pscAcct != null &&
              Object.hasOwnProperty.call(message, "pscAcct")
            )
              writer
                .uint32(/* id 19, wireType 2 =*/ 154)
                .string(message.pscAcct);
            if (
              message.xboproduct != null &&
              Object.hasOwnProperty.call(message, "xboproduct")
            )
              writer
                .uint32(/* id 20, wireType 2 =*/ 162)
                .string(message.xboproduct);
            if (
              message.vipLevel != null &&
              Object.hasOwnProperty.call(message, "vipLevel")
            )
              writer
                .uint32(/* id 21, wireType 2 =*/ 170)
                .string(message.vipLevel);
            if (
              message.vipLevelName != null &&
              Object.hasOwnProperty.call(message, "vipLevelName")
            )
              writer
                .uint32(/* id 22, wireType 2 =*/ 178)
                .string(message.vipLevelName);
            if (
              message.rewardsType != null &&
              Object.hasOwnProperty.call(message, "rewardsType")
            )
              writer
                .uint32(/* id 23, wireType 2 =*/ 186)
                .string(message.rewardsType);
            if (
              message.accessLevel != null &&
              Object.hasOwnProperty.call(message, "accessLevel")
            )
              writer
                .uint32(/* id 24, wireType 2 =*/ 194)
                .string(message.accessLevel);
            if (
              message.customerSegment != null &&
              Object.hasOwnProperty.call(message, "customerSegment")
            )
              writer
                .uint32(/* id 25, wireType 2 =*/ 202)
                .string(message.customerSegment);
            if (
              message.customField != null &&
              Object.hasOwnProperty.call(message, "customField")
            )
              writer
                .uint32(/* id 26, wireType 2 =*/ 210)
                .string(message.customField);
            if (
              message.xboRole != null &&
              Object.hasOwnProperty.call(message, "xboRole")
            )
              writer
                .uint32(/* id 27, wireType 2 =*/ 218)
                .string(message.xboRole);
            if (
              message.preferredLanguage != null &&
              Object.hasOwnProperty.call(message, "preferredLanguage")
            )
              writer
                .uint32(/* id 28, wireType 2 =*/ 226)
                .string(message.preferredLanguage);
            if (
              message.username != null &&
              Object.hasOwnProperty.call(message, "username")
            )
              writer
                .uint32(/* id 29, wireType 2 =*/ 234)
                .string(message.username);
            if (message.identities != null && message.identities.length)
              for (var i = 0; i < message.identities.length; ++i)
                $root.stronachgroup.first.auth.UserIdentity.encode(
                  message.identities[i],
                  writer.uint32(/* id 30, wireType 2 =*/ 242).fork()
                ).ldelim();
            return writer;
          };

          /**
           * Decodes a GetUserInfoResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetUserInfoResponse} GetUserInfoResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetUserInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.GetUserInfoResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.sub = reader.string();
                  break;
                case 2:
                  message.givenName = reader.string();
                  break;
                case 3:
                  message.familyName = reader.string();
                  break;
                case 4:
                  message.nickname = reader.string();
                  break;
                case 5:
                  message.name = reader.string();
                  break;
                case 6:
                  message.picture = reader.string();
                  break;
                case 7:
                  message.birthdate = reader.string();
                  break;
                case 8:
                  message.updatedAt = reader.string();
                  break;
                case 9:
                  message.email = reader.string();
                  break;
                case 10:
                  message.address =
                    $root.stronachgroup.first.auth.GetUserInfoResponse.Address.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                case 11:
                  message.phoneNumber = reader.string();
                  break;
                case 12:
                  message.accountId = reader.string();
                  break;
                case 13:
                  message.customerId = reader.int32();
                  break;
                case 14:
                  message.customerStatus = reader.string();
                  break;
                case 15:
                  message.pin = reader.string();
                  break;
                case 16:
                  message.gatewayId = reader.string();
                  break;
                case 17:
                  message.community = reader.string();
                  break;
                case 18:
                  message.firebaseUid = reader.string();
                  break;
                case 19:
                  message.pscAcct = reader.string();
                  break;
                case 20:
                  message.xboproduct = reader.string();
                  break;
                case 21:
                  message.vipLevel = reader.string();
                  break;
                case 22:
                  message.vipLevelName = reader.string();
                  break;
                case 23:
                  message.rewardsType = reader.string();
                  break;
                case 24:
                  message.accessLevel = reader.string();
                  break;
                case 25:
                  message.customerSegment = reader.string();
                  break;
                case 26:
                  message.customField = reader.string();
                  break;
                case 27:
                  message.xboRole = reader.string();
                  break;
                case 28:
                  message.preferredLanguage = reader.string();
                  break;
                case 29:
                  message.username = reader.string();
                  break;
                case 30:
                  if (!(message.identities && message.identities.length))
                    message.identities = [];
                  message.identities.push(
                    $root.stronachgroup.first.auth.UserIdentity.decode(
                      reader,
                      reader.uint32()
                    )
                  );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetUserInfoResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetUserInfoResponse} GetUserInfoResponse
           */
          GetUserInfoResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetUserInfoResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.GetUserInfoResponse();
            if (object.sub != null) message.sub = String(object.sub);
            if (object.givenName != null)
              message.givenName = String(object.givenName);
            if (object.familyName != null)
              message.familyName = String(object.familyName);
            if (object.nickname != null)
              message.nickname = String(object.nickname);
            if (object.name != null) message.name = String(object.name);
            if (object.picture != null)
              message.picture = String(object.picture);
            if (object.birthdate != null)
              message.birthdate = String(object.birthdate);
            if (object.updatedAt != null)
              message.updatedAt = String(object.updatedAt);
            if (object.email != null) message.email = String(object.email);
            if (object.address != null) {
              if (typeof object.address !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.GetUserInfoResponse.address: object expected"
                );
              message.address =
                $root.stronachgroup.first.auth.GetUserInfoResponse.Address.fromObject(
                  object.address
                );
            }
            if (object.phoneNumber != null)
              message.phoneNumber = String(object.phoneNumber);
            if (object.accountId != null)
              message.accountId = String(object.accountId);
            if (object.customerId != null)
              message.customerId = object.customerId | 0;
            if (object.customerStatus != null)
              message.customerStatus = String(object.customerStatus);
            if (object.pin != null) message.pin = String(object.pin);
            if (object.gatewayId != null)
              message.gatewayId = String(object.gatewayId);
            if (object.community != null)
              message.community = String(object.community);
            if (object.firebaseUid != null)
              message.firebaseUid = String(object.firebaseUid);
            if (object.pscAcct != null)
              message.pscAcct = String(object.pscAcct);
            if (object.xboproduct != null)
              message.xboproduct = String(object.xboproduct);
            if (object.vipLevel != null)
              message.vipLevel = String(object.vipLevel);
            if (object.vipLevelName != null)
              message.vipLevelName = String(object.vipLevelName);
            if (object.rewardsType != null)
              message.rewardsType = String(object.rewardsType);
            if (object.accessLevel != null)
              message.accessLevel = String(object.accessLevel);
            if (object.customerSegment != null)
              message.customerSegment = String(object.customerSegment);
            if (object.customField != null)
              message.customField = String(object.customField);
            if (object.xboRole != null)
              message.xboRole = String(object.xboRole);
            if (object.preferredLanguage != null)
              message.preferredLanguage = String(object.preferredLanguage);
            if (object.username != null)
              message.username = String(object.username);
            if (object.identities) {
              if (!Array.isArray(object.identities))
                throw TypeError(
                  ".stronachgroup.first.auth.GetUserInfoResponse.identities: array expected"
                );
              message.identities = [];
              for (var i = 0; i < object.identities.length; ++i) {
                if (typeof object.identities[i] !== "object")
                  throw TypeError(
                    ".stronachgroup.first.auth.GetUserInfoResponse.identities: object expected"
                  );
                message.identities[i] =
                  $root.stronachgroup.first.auth.UserIdentity.fromObject(
                    object.identities[i]
                  );
              }
            }
            return message;
          };

          /**
           * Creates a plain object from a GetUserInfoResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @static
           * @param {stronachgroup.first.auth.GetUserInfoResponse} message GetUserInfoResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetUserInfoResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.identities = [];
            if (options.defaults) {
              object.sub = "";
              object.givenName = "";
              object.familyName = "";
              object.nickname = "";
              object.name = "";
              object.picture = "";
              object.birthdate = "";
              object.updatedAt = "";
              object.email = "";
              object.address = null;
              object.phoneNumber = "";
              object.accountId = "";
              object.customerId = 0;
              object.customerStatus = "";
              object.pin = "";
              object.gatewayId = "";
              object.community = "";
              object.firebaseUid = "";
              object.pscAcct = "";
              object.xboproduct = "";
              object.vipLevel = "";
              object.vipLevelName = "";
              object.rewardsType = "";
              object.accessLevel = "";
              object.customerSegment = "";
              object.customField = "";
              object.xboRole = "";
              object.preferredLanguage = "";
              object.username = "";
            }
            if (message.sub != null && message.hasOwnProperty("sub"))
              object.sub = message.sub;
            if (
              message.givenName != null &&
              message.hasOwnProperty("givenName")
            )
              object.givenName = message.givenName;
            if (
              message.familyName != null &&
              message.hasOwnProperty("familyName")
            )
              object.familyName = message.familyName;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
              object.nickname = message.nickname;
            if (message.name != null && message.hasOwnProperty("name"))
              object.name = message.name;
            if (message.picture != null && message.hasOwnProperty("picture"))
              object.picture = message.picture;
            if (
              message.birthdate != null &&
              message.hasOwnProperty("birthdate")
            )
              object.birthdate = message.birthdate;
            if (
              message.updatedAt != null &&
              message.hasOwnProperty("updatedAt")
            )
              object.updatedAt = message.updatedAt;
            if (message.email != null && message.hasOwnProperty("email"))
              object.email = message.email;
            if (message.address != null && message.hasOwnProperty("address"))
              object.address =
                $root.stronachgroup.first.auth.GetUserInfoResponse.Address.toObject(
                  message.address,
                  options
                );
            if (
              message.phoneNumber != null &&
              message.hasOwnProperty("phoneNumber")
            )
              object.phoneNumber = message.phoneNumber;
            if (
              message.accountId != null &&
              message.hasOwnProperty("accountId")
            )
              object.accountId = message.accountId;
            if (
              message.customerId != null &&
              message.hasOwnProperty("customerId")
            )
              object.customerId = message.customerId;
            if (
              message.customerStatus != null &&
              message.hasOwnProperty("customerStatus")
            )
              object.customerStatus = message.customerStatus;
            if (message.pin != null && message.hasOwnProperty("pin"))
              object.pin = message.pin;
            if (
              message.gatewayId != null &&
              message.hasOwnProperty("gatewayId")
            )
              object.gatewayId = message.gatewayId;
            if (
              message.community != null &&
              message.hasOwnProperty("community")
            )
              object.community = message.community;
            if (
              message.firebaseUid != null &&
              message.hasOwnProperty("firebaseUid")
            )
              object.firebaseUid = message.firebaseUid;
            if (message.pscAcct != null && message.hasOwnProperty("pscAcct"))
              object.pscAcct = message.pscAcct;
            if (
              message.xboproduct != null &&
              message.hasOwnProperty("xboproduct")
            )
              object.xboproduct = message.xboproduct;
            if (message.vipLevel != null && message.hasOwnProperty("vipLevel"))
              object.vipLevel = message.vipLevel;
            if (
              message.vipLevelName != null &&
              message.hasOwnProperty("vipLevelName")
            )
              object.vipLevelName = message.vipLevelName;
            if (
              message.rewardsType != null &&
              message.hasOwnProperty("rewardsType")
            )
              object.rewardsType = message.rewardsType;
            if (
              message.accessLevel != null &&
              message.hasOwnProperty("accessLevel")
            )
              object.accessLevel = message.accessLevel;
            if (
              message.customerSegment != null &&
              message.hasOwnProperty("customerSegment")
            )
              object.customerSegment = message.customerSegment;
            if (
              message.customField != null &&
              message.hasOwnProperty("customField")
            )
              object.customField = message.customField;
            if (message.xboRole != null && message.hasOwnProperty("xboRole"))
              object.xboRole = message.xboRole;
            if (
              message.preferredLanguage != null &&
              message.hasOwnProperty("preferredLanguage")
            )
              object.preferredLanguage = message.preferredLanguage;
            if (message.username != null && message.hasOwnProperty("username"))
              object.username = message.username;
            if (message.identities && message.identities.length) {
              object.identities = [];
              for (var j = 0; j < message.identities.length; ++j)
                object.identities[j] =
                  $root.stronachgroup.first.auth.UserIdentity.toObject(
                    message.identities[j],
                    options
                  );
            }
            return object;
          };

          /**
           * Converts this GetUserInfoResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetUserInfoResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetUserInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          GetUserInfoResponse.Address = (function () {
            /**
             * Properties of an Address.
             * @memberof stronachgroup.first.auth.GetUserInfoResponse
             * @interface IAddress
             * @property {string|null} [postalCode] Address postalCode
             * @property {string|null} [region] Address region
             * @property {string|null} [country] Address country
             */

            /**
             * Constructs a new Address.
             * @memberof stronachgroup.first.auth.GetUserInfoResponse
             * @classdesc Represents an Address.
             * @implements IAddress
             * @constructor
             * @param {stronachgroup.first.auth.GetUserInfoResponse.IAddress=} [properties] Properties to set
             */
            function Address(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Address postalCode.
             * @member {string} postalCode
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @instance
             */
            Address.prototype.postalCode = "";

            /**
             * Address region.
             * @member {string} region
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @instance
             */
            Address.prototype.region = "";

            /**
             * Address country.
             * @member {string} country
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @instance
             */
            Address.prototype.country = "";

            /**
             * Creates a new Address instance using the specified properties.
             * @function create
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @static
             * @param {stronachgroup.first.auth.GetUserInfoResponse.IAddress=} [properties] Properties to set
             * @returns {stronachgroup.first.auth.GetUserInfoResponse.Address} Address instance
             */
            Address.create = function create(properties) {
              return new Address(properties);
            };

            /**
             * Encodes the specified Address message. Does not implicitly {@link stronachgroup.first.auth.GetUserInfoResponse.Address.verify|verify} messages.
             * @function encode
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @static
             * @param {stronachgroup.first.auth.GetUserInfoResponse.IAddress} message Address message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Address.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.postalCode != null &&
                Object.hasOwnProperty.call(message, "postalCode")
              )
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.postalCode);
              if (
                message.region != null &&
                Object.hasOwnProperty.call(message, "region")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.region);
              if (
                message.country != null &&
                Object.hasOwnProperty.call(message, "country")
              )
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.country);
              return writer;
            };

            /**
             * Decodes an Address message from the specified reader or buffer.
             * @function decode
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {stronachgroup.first.auth.GetUserInfoResponse.Address} Address
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Address.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.stronachgroup.first.auth.GetUserInfoResponse.Address();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.postalCode = reader.string();
                    break;
                  case 2:
                    message.region = reader.string();
                    break;
                  case 3:
                    message.country = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an Address message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {stronachgroup.first.auth.GetUserInfoResponse.Address} Address
             */
            Address.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.stronachgroup.first.auth.GetUserInfoResponse.Address
              )
                return object;
              var message =
                new $root.stronachgroup.first.auth.GetUserInfoResponse.Address();
              if (object.postalCode != null)
                message.postalCode = String(object.postalCode);
              if (object.region != null) message.region = String(object.region);
              if (object.country != null)
                message.country = String(object.country);
              return message;
            };

            /**
             * Creates a plain object from an Address message. Also converts values to other types if specified.
             * @function toObject
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @static
             * @param {stronachgroup.first.auth.GetUserInfoResponse.Address} message Address
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Address.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.postalCode = "";
                object.region = "";
                object.country = "";
              }
              if (
                message.postalCode != null &&
                message.hasOwnProperty("postalCode")
              )
                object.postalCode = message.postalCode;
              if (message.region != null && message.hasOwnProperty("region"))
                object.region = message.region;
              if (message.country != null && message.hasOwnProperty("country"))
                object.country = message.country;
              return object;
            };

            /**
             * Converts this Address to JSON.
             * @function toJSON
             * @memberof stronachgroup.first.auth.GetUserInfoResponse.Address
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Address.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Address;
          })();

          return GetUserInfoResponse;
        })();

        auth.UserIdentity = (function () {
          /**
           * Properties of a UserIdentity.
           * @memberof stronachgroup.first.auth
           * @interface IUserIdentity
           * @property {string|null} [connection] UserIdentity connection
           * @property {string|null} [userId] UserIdentity userId
           * @property {string|null} [accessToken] UserIdentity accessToken
           * @property {string|null} [provider] UserIdentity provider
           * @property {boolean|null} [isSocial] UserIdentity isSocial
           */

          /**
           * Constructs a new UserIdentity.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a UserIdentity.
           * @implements IUserIdentity
           * @constructor
           * @param {stronachgroup.first.auth.IUserIdentity=} [properties] Properties to set
           */
          function UserIdentity(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UserIdentity connection.
           * @member {string} connection
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           */
          UserIdentity.prototype.connection = "";

          /**
           * UserIdentity userId.
           * @member {string} userId
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           */
          UserIdentity.prototype.userId = "";

          /**
           * UserIdentity accessToken.
           * @member {string} accessToken
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           */
          UserIdentity.prototype.accessToken = "";

          /**
           * UserIdentity provider.
           * @member {string} provider
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           */
          UserIdentity.prototype.provider = "";

          /**
           * UserIdentity isSocial.
           * @member {boolean} isSocial
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           */
          UserIdentity.prototype.isSocial = false;

          /**
           * Creates a new UserIdentity instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UserIdentity
           * @static
           * @param {stronachgroup.first.auth.IUserIdentity=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UserIdentity} UserIdentity instance
           */
          UserIdentity.create = function create(properties) {
            return new UserIdentity(properties);
          };

          /**
           * Encodes the specified UserIdentity message. Does not implicitly {@link stronachgroup.first.auth.UserIdentity.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UserIdentity
           * @static
           * @param {stronachgroup.first.auth.IUserIdentity} message UserIdentity message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UserIdentity.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.connection != null &&
              Object.hasOwnProperty.call(message, "connection")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.connection);
            if (
              message.userId != null &&
              Object.hasOwnProperty.call(message, "userId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.userId);
            if (
              message.accessToken != null &&
              Object.hasOwnProperty.call(message, "accessToken")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.accessToken);
            if (
              message.provider != null &&
              Object.hasOwnProperty.call(message, "provider")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.provider);
            if (
              message.isSocial != null &&
              Object.hasOwnProperty.call(message, "isSocial")
            )
              writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.isSocial);
            return writer;
          };

          /**
           * Decodes a UserIdentity message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UserIdentity
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UserIdentity} UserIdentity
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UserIdentity.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.stronachgroup.first.auth.UserIdentity();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.connection = reader.string();
                  break;
                case 2:
                  message.userId = reader.string();
                  break;
                case 3:
                  message.accessToken = reader.string();
                  break;
                case 4:
                  message.provider = reader.string();
                  break;
                case 5:
                  message.isSocial = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a UserIdentity message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UserIdentity
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UserIdentity} UserIdentity
           */
          UserIdentity.fromObject = function fromObject(object) {
            if (object instanceof $root.stronachgroup.first.auth.UserIdentity)
              return object;
            var message = new $root.stronachgroup.first.auth.UserIdentity();
            if (object.connection != null)
              message.connection = String(object.connection);
            if (object.userId != null) message.userId = String(object.userId);
            if (object.accessToken != null)
              message.accessToken = String(object.accessToken);
            if (object.provider != null)
              message.provider = String(object.provider);
            if (object.isSocial != null)
              message.isSocial = Boolean(object.isSocial);
            return message;
          };

          /**
           * Creates a plain object from a UserIdentity message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UserIdentity
           * @static
           * @param {stronachgroup.first.auth.UserIdentity} message UserIdentity
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UserIdentity.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.connection = "";
              object.userId = "";
              object.accessToken = "";
              object.provider = "";
              object.isSocial = false;
            }
            if (
              message.connection != null &&
              message.hasOwnProperty("connection")
            )
              object.connection = message.connection;
            if (message.userId != null && message.hasOwnProperty("userId"))
              object.userId = message.userId;
            if (
              message.accessToken != null &&
              message.hasOwnProperty("accessToken")
            )
              object.accessToken = message.accessToken;
            if (message.provider != null && message.hasOwnProperty("provider"))
              object.provider = message.provider;
            if (message.isSocial != null && message.hasOwnProperty("isSocial"))
              object.isSocial = message.isSocial;
            return object;
          };

          /**
           * Converts this UserIdentity to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UserIdentity
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UserIdentity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UserIdentity;
        })();

        auth.UnlinkIdentityRequest = (function () {
          /**
           * Properties of an UnlinkIdentityRequest.
           * @memberof stronachgroup.first.auth
           * @interface IUnlinkIdentityRequest
           * @property {string|null} [connection] UnlinkIdentityRequest connection
           * @property {string|null} [userId] UnlinkIdentityRequest userId
           */

          /**
           * Constructs a new UnlinkIdentityRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UnlinkIdentityRequest.
           * @implements IUnlinkIdentityRequest
           * @constructor
           * @param {stronachgroup.first.auth.IUnlinkIdentityRequest=} [properties] Properties to set
           */
          function UnlinkIdentityRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnlinkIdentityRequest connection.
           * @member {string} connection
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @instance
           */
          UnlinkIdentityRequest.prototype.connection = "";

          /**
           * UnlinkIdentityRequest userId.
           * @member {string} userId
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @instance
           */
          UnlinkIdentityRequest.prototype.userId = "";

          /**
           * Creates a new UnlinkIdentityRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @static
           * @param {stronachgroup.first.auth.IUnlinkIdentityRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UnlinkIdentityRequest} UnlinkIdentityRequest instance
           */
          UnlinkIdentityRequest.create = function create(properties) {
            return new UnlinkIdentityRequest(properties);
          };

          /**
           * Encodes the specified UnlinkIdentityRequest message. Does not implicitly {@link stronachgroup.first.auth.UnlinkIdentityRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @static
           * @param {stronachgroup.first.auth.IUnlinkIdentityRequest} message UnlinkIdentityRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnlinkIdentityRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.connection != null &&
              Object.hasOwnProperty.call(message, "connection")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.connection);
            if (
              message.userId != null &&
              Object.hasOwnProperty.call(message, "userId")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.userId);
            return writer;
          };

          /**
           * Decodes an UnlinkIdentityRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UnlinkIdentityRequest} UnlinkIdentityRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnlinkIdentityRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UnlinkIdentityRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.connection = reader.string();
                  break;
                case 2:
                  message.userId = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnlinkIdentityRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UnlinkIdentityRequest} UnlinkIdentityRequest
           */
          UnlinkIdentityRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UnlinkIdentityRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.UnlinkIdentityRequest();
            if (object.connection != null)
              message.connection = String(object.connection);
            if (object.userId != null) message.userId = String(object.userId);
            return message;
          };

          /**
           * Creates a plain object from an UnlinkIdentityRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @static
           * @param {stronachgroup.first.auth.UnlinkIdentityRequest} message UnlinkIdentityRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnlinkIdentityRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.connection = "";
              object.userId = "";
            }
            if (
              message.connection != null &&
              message.hasOwnProperty("connection")
            )
              object.connection = message.connection;
            if (message.userId != null && message.hasOwnProperty("userId"))
              object.userId = message.userId;
            return object;
          };

          /**
           * Converts this UnlinkIdentityRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UnlinkIdentityRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnlinkIdentityRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UnlinkIdentityRequest;
        })();

        auth.UnlinkIdentityResponse = (function () {
          /**
           * Properties of an UnlinkIdentityResponse.
           * @memberof stronachgroup.first.auth
           * @interface IUnlinkIdentityResponse
           * @property {stronachgroup.first.auth.IUserIdentity|null} [identity] UnlinkIdentityResponse identity
           */

          /**
           * Constructs a new UnlinkIdentityResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UnlinkIdentityResponse.
           * @implements IUnlinkIdentityResponse
           * @constructor
           * @param {stronachgroup.first.auth.IUnlinkIdentityResponse=} [properties] Properties to set
           */
          function UnlinkIdentityResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UnlinkIdentityResponse identity.
           * @member {stronachgroup.first.auth.IUserIdentity|null|undefined} identity
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @instance
           */
          UnlinkIdentityResponse.prototype.identity = null;

          /**
           * Creates a new UnlinkIdentityResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @static
           * @param {stronachgroup.first.auth.IUnlinkIdentityResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UnlinkIdentityResponse} UnlinkIdentityResponse instance
           */
          UnlinkIdentityResponse.create = function create(properties) {
            return new UnlinkIdentityResponse(properties);
          };

          /**
           * Encodes the specified UnlinkIdentityResponse message. Does not implicitly {@link stronachgroup.first.auth.UnlinkIdentityResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @static
           * @param {stronachgroup.first.auth.IUnlinkIdentityResponse} message UnlinkIdentityResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UnlinkIdentityResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.identity != null &&
              Object.hasOwnProperty.call(message, "identity")
            )
              $root.stronachgroup.first.auth.UserIdentity.encode(
                message.identity,
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
            return writer;
          };

          /**
           * Decodes an UnlinkIdentityResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UnlinkIdentityResponse} UnlinkIdentityResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UnlinkIdentityResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UnlinkIdentityResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.identity =
                    $root.stronachgroup.first.auth.UserIdentity.decode(
                      reader,
                      reader.uint32()
                    );
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UnlinkIdentityResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UnlinkIdentityResponse} UnlinkIdentityResponse
           */
          UnlinkIdentityResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UnlinkIdentityResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.UnlinkIdentityResponse();
            if (object.identity != null) {
              if (typeof object.identity !== "object")
                throw TypeError(
                  ".stronachgroup.first.auth.UnlinkIdentityResponse.identity: object expected"
                );
              message.identity =
                $root.stronachgroup.first.auth.UserIdentity.fromObject(
                  object.identity
                );
            }
            return message;
          };

          /**
           * Creates a plain object from an UnlinkIdentityResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @static
           * @param {stronachgroup.first.auth.UnlinkIdentityResponse} message UnlinkIdentityResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UnlinkIdentityResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.identity = null;
            if (message.identity != null && message.hasOwnProperty("identity"))
              object.identity =
                $root.stronachgroup.first.auth.UserIdentity.toObject(
                  message.identity,
                  options
                );
            return object;
          };

          /**
           * Converts this UnlinkIdentityResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UnlinkIdentityResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UnlinkIdentityResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UnlinkIdentityResponse;
        })();

        /**
         * ReviewBetType enum.
         * @name stronachgroup.first.auth.ReviewBetType
         * @enum {string}
         * @property {number} REVIEW_BET_TYPE_INVALID=0 REVIEW_BET_TYPE_INVALID value
         * @property {number} REVIEW_BET_TYPE_REVIEW=1 REVIEW_BET_TYPE_REVIEW value
         * @property {number} REVIEW_BET_TYPE_PLACE=2 REVIEW_BET_TYPE_PLACE value
         */
        auth.ReviewBetType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "REVIEW_BET_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "REVIEW_BET_TYPE_REVIEW")] = 1;
          values[(valuesById[2] = "REVIEW_BET_TYPE_PLACE")] = 2;
          return values;
        })();

        /**
         * ClearWagerConfirmation enum.
         * @name stronachgroup.first.auth.ClearWagerConfirmation
         * @enum {string}
         * @property {number} CLEAR_WAGER_TYPE_INVALID=0 CLEAR_WAGER_TYPE_INVALID value
         * @property {number} CLEAR_WAGER_TYPE_SHOW=1 CLEAR_WAGER_TYPE_SHOW value
         * @property {number} CLEAR_WAGER_TYPE_HIDE=2 CLEAR_WAGER_TYPE_HIDE value
         */
        auth.ClearWagerConfirmation = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "CLEAR_WAGER_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "CLEAR_WAGER_TYPE_SHOW")] = 1;
          values[(valuesById[2] = "CLEAR_WAGER_TYPE_HIDE")] = 2;
          return values;
        })();

        /**
         * AutoHandicapType enum.
         * @name stronachgroup.first.auth.AutoHandicapType
         * @enum {string}
         * @property {number} AUTO_HANDICAP_TYPE_INVALID=0 AUTO_HANDICAP_TYPE_INVALID value
         * @property {number} AUTO_HANDICAP_TYPE_ON=1 AUTO_HANDICAP_TYPE_ON value
         * @property {number} AUTO_HANDICAP_TYPE_OFF=2 AUTO_HANDICAP_TYPE_OFF value
         */
        auth.AutoHandicapType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "AUTO_HANDICAP_TYPE_INVALID")] = 0;
          values[(valuesById[1] = "AUTO_HANDICAP_TYPE_ON")] = 1;
          values[(valuesById[2] = "AUTO_HANDICAP_TYPE_OFF")] = 2;
          return values;
        })();

        auth.UpdateUser1stbetPreferencesRequest = (function () {
          /**
           * Properties of an UpdateUser1stbetPreferencesRequest.
           * @memberof stronachgroup.first.auth
           * @interface IUpdateUser1stbetPreferencesRequest
           * @property {string|null} [wagerpad] UpdateUser1stbetPreferencesRequest wagerpad
           * @property {string|null} [defaultSort] UpdateUser1stbetPreferencesRequest defaultSort
           * @property {Array.<string>|null} [trackFilterRaceType] UpdateUser1stbetPreferencesRequest trackFilterRaceType
           * @property {Array.<string>|null} [trackFilterRegion] UpdateUser1stbetPreferencesRequest trackFilterRegion
           * @property {stronachgroup.first.auth.ReviewBetType|null} [reviewBet] UpdateUser1stbetPreferencesRequest reviewBet
           * @property {stronachgroup.first.auth.ClearWagerConfirmation|null} [clearWagerConfirmation] UpdateUser1stbetPreferencesRequest clearWagerConfirmation
           * @property {stronachgroup.first.auth.AutoHandicapType|null} [autoHandicap] UpdateUser1stbetPreferencesRequest autoHandicap
           * @property {string|null} [autoHandicapSetDirt] UpdateUser1stbetPreferencesRequest autoHandicapSetDirt
           * @property {string|null} [autoHandicapSetTurf] UpdateUser1stbetPreferencesRequest autoHandicapSetTurf
           */

          /**
           * Constructs a new UpdateUser1stbetPreferencesRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UpdateUser1stbetPreferencesRequest.
           * @implements IUpdateUser1stbetPreferencesRequest
           * @constructor
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesRequest=} [properties] Properties to set
           */
          function UpdateUser1stbetPreferencesRequest(properties) {
            this.trackFilterRaceType = [];
            this.trackFilterRegion = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * UpdateUser1stbetPreferencesRequest wagerpad.
           * @member {string} wagerpad
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.wagerpad = "";

          /**
           * UpdateUser1stbetPreferencesRequest defaultSort.
           * @member {string} defaultSort
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.defaultSort = "";

          /**
           * UpdateUser1stbetPreferencesRequest trackFilterRaceType.
           * @member {Array.<string>} trackFilterRaceType
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.trackFilterRaceType =
            $util.emptyArray;

          /**
           * UpdateUser1stbetPreferencesRequest trackFilterRegion.
           * @member {Array.<string>} trackFilterRegion
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.trackFilterRegion =
            $util.emptyArray;

          /**
           * UpdateUser1stbetPreferencesRequest reviewBet.
           * @member {stronachgroup.first.auth.ReviewBetType} reviewBet
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.reviewBet = 0;

          /**
           * UpdateUser1stbetPreferencesRequest clearWagerConfirmation.
           * @member {stronachgroup.first.auth.ClearWagerConfirmation} clearWagerConfirmation
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.clearWagerConfirmation = 0;

          /**
           * UpdateUser1stbetPreferencesRequest autoHandicap.
           * @member {stronachgroup.first.auth.AutoHandicapType} autoHandicap
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.autoHandicap = 0;

          /**
           * UpdateUser1stbetPreferencesRequest autoHandicapSetDirt.
           * @member {string} autoHandicapSetDirt
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.autoHandicapSetDirt = "";

          /**
           * UpdateUser1stbetPreferencesRequest autoHandicapSetTurf.
           * @member {string} autoHandicapSetTurf
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           */
          UpdateUser1stbetPreferencesRequest.prototype.autoHandicapSetTurf = "";

          /**
           * Creates a new UpdateUser1stbetPreferencesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} UpdateUser1stbetPreferencesRequest instance
           */
          UpdateUser1stbetPreferencesRequest.create = function create(
            properties
          ) {
            return new UpdateUser1stbetPreferencesRequest(properties);
          };

          /**
           * Encodes the specified UpdateUser1stbetPreferencesRequest message. Does not implicitly {@link stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesRequest} message UpdateUser1stbetPreferencesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateUser1stbetPreferencesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.wagerpad != null &&
              Object.hasOwnProperty.call(message, "wagerpad")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.wagerpad);
            if (
              message.defaultSort != null &&
              Object.hasOwnProperty.call(message, "defaultSort")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.defaultSort);
            if (
              message.trackFilterRaceType != null &&
              message.trackFilterRaceType.length
            )
              for (var i = 0; i < message.trackFilterRaceType.length; ++i)
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.trackFilterRaceType[i]);
            if (
              message.trackFilterRegion != null &&
              message.trackFilterRegion.length
            )
              for (var i = 0; i < message.trackFilterRegion.length; ++i)
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.trackFilterRegion[i]);
            if (
              message.reviewBet != null &&
              Object.hasOwnProperty.call(message, "reviewBet")
            )
              writer
                .uint32(/* id 5, wireType 0 =*/ 40)
                .int32(message.reviewBet);
            if (
              message.clearWagerConfirmation != null &&
              Object.hasOwnProperty.call(message, "clearWagerConfirmation")
            )
              writer
                .uint32(/* id 6, wireType 0 =*/ 48)
                .int32(message.clearWagerConfirmation);
            if (
              message.autoHandicap != null &&
              Object.hasOwnProperty.call(message, "autoHandicap")
            )
              writer
                .uint32(/* id 7, wireType 0 =*/ 56)
                .int32(message.autoHandicap);
            if (
              message.autoHandicapSetDirt != null &&
              Object.hasOwnProperty.call(message, "autoHandicapSetDirt")
            )
              writer
                .uint32(/* id 8, wireType 2 =*/ 66)
                .string(message.autoHandicapSetDirt);
            if (
              message.autoHandicapSetTurf != null &&
              Object.hasOwnProperty.call(message, "autoHandicapSetTurf")
            )
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.autoHandicapSetTurf);
            return writer;
          };

          /**
           * Decodes an UpdateUser1stbetPreferencesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} UpdateUser1stbetPreferencesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateUser1stbetPreferencesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.wagerpad = reader.string();
                  break;
                case 2:
                  message.defaultSort = reader.string();
                  break;
                case 3:
                  if (
                    !(
                      message.trackFilterRaceType &&
                      message.trackFilterRaceType.length
                    )
                  )
                    message.trackFilterRaceType = [];
                  message.trackFilterRaceType.push(reader.string());
                  break;
                case 4:
                  if (
                    !(
                      message.trackFilterRegion &&
                      message.trackFilterRegion.length
                    )
                  )
                    message.trackFilterRegion = [];
                  message.trackFilterRegion.push(reader.string());
                  break;
                case 5:
                  message.reviewBet = reader.int32();
                  break;
                case 6:
                  message.clearWagerConfirmation = reader.int32();
                  break;
                case 7:
                  message.autoHandicap = reader.int32();
                  break;
                case 8:
                  message.autoHandicapSetDirt = reader.string();
                  break;
                case 9:
                  message.autoHandicapSetTurf = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateUser1stbetPreferencesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} UpdateUser1stbetPreferencesRequest
           */
          UpdateUser1stbetPreferencesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest();
            if (object.wagerpad != null)
              message.wagerpad = String(object.wagerpad);
            if (object.defaultSort != null)
              message.defaultSort = String(object.defaultSort);
            if (object.trackFilterRaceType) {
              if (!Array.isArray(object.trackFilterRaceType))
                throw TypeError(
                  ".stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest.trackFilterRaceType: array expected"
                );
              message.trackFilterRaceType = [];
              for (var i = 0; i < object.trackFilterRaceType.length; ++i)
                message.trackFilterRaceType[i] = String(
                  object.trackFilterRaceType[i]
                );
            }
            if (object.trackFilterRegion) {
              if (!Array.isArray(object.trackFilterRegion))
                throw TypeError(
                  ".stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest.trackFilterRegion: array expected"
                );
              message.trackFilterRegion = [];
              for (var i = 0; i < object.trackFilterRegion.length; ++i)
                message.trackFilterRegion[i] = String(
                  object.trackFilterRegion[i]
                );
            }
            switch (object.reviewBet) {
              case "REVIEW_BET_TYPE_INVALID":
              case 0:
                message.reviewBet = 0;
                break;
              case "REVIEW_BET_TYPE_REVIEW":
              case 1:
                message.reviewBet = 1;
                break;
              case "REVIEW_BET_TYPE_PLACE":
              case 2:
                message.reviewBet = 2;
                break;
            }
            switch (object.clearWagerConfirmation) {
              case "CLEAR_WAGER_TYPE_INVALID":
              case 0:
                message.clearWagerConfirmation = 0;
                break;
              case "CLEAR_WAGER_TYPE_SHOW":
              case 1:
                message.clearWagerConfirmation = 1;
                break;
              case "CLEAR_WAGER_TYPE_HIDE":
              case 2:
                message.clearWagerConfirmation = 2;
                break;
            }
            switch (object.autoHandicap) {
              case "AUTO_HANDICAP_TYPE_INVALID":
              case 0:
                message.autoHandicap = 0;
                break;
              case "AUTO_HANDICAP_TYPE_ON":
              case 1:
                message.autoHandicap = 1;
                break;
              case "AUTO_HANDICAP_TYPE_OFF":
              case 2:
                message.autoHandicap = 2;
                break;
            }
            if (object.autoHandicapSetDirt != null)
              message.autoHandicapSetDirt = String(object.autoHandicapSetDirt);
            if (object.autoHandicapSetTurf != null)
              message.autoHandicapSetTurf = String(object.autoHandicapSetTurf);
            return message;
          };

          /**
           * Creates a plain object from an UpdateUser1stbetPreferencesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest} message UpdateUser1stbetPreferencesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateUser1stbetPreferencesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.trackFilterRaceType = [];
              object.trackFilterRegion = [];
            }
            if (options.defaults) {
              object.wagerpad = "";
              object.defaultSort = "";
              object.reviewBet =
                options.enums === String ? "REVIEW_BET_TYPE_INVALID" : 0;
              object.clearWagerConfirmation =
                options.enums === String ? "CLEAR_WAGER_TYPE_INVALID" : 0;
              object.autoHandicap =
                options.enums === String ? "AUTO_HANDICAP_TYPE_INVALID" : 0;
              object.autoHandicapSetDirt = "";
              object.autoHandicapSetTurf = "";
            }
            if (message.wagerpad != null && message.hasOwnProperty("wagerpad"))
              object.wagerpad = message.wagerpad;
            if (
              message.defaultSort != null &&
              message.hasOwnProperty("defaultSort")
            )
              object.defaultSort = message.defaultSort;
            if (
              message.trackFilterRaceType &&
              message.trackFilterRaceType.length
            ) {
              object.trackFilterRaceType = [];
              for (var j = 0; j < message.trackFilterRaceType.length; ++j)
                object.trackFilterRaceType[j] = message.trackFilterRaceType[j];
            }
            if (message.trackFilterRegion && message.trackFilterRegion.length) {
              object.trackFilterRegion = [];
              for (var j = 0; j < message.trackFilterRegion.length; ++j)
                object.trackFilterRegion[j] = message.trackFilterRegion[j];
            }
            if (
              message.reviewBet != null &&
              message.hasOwnProperty("reviewBet")
            )
              object.reviewBet =
                options.enums === String
                  ? $root.stronachgroup.first.auth.ReviewBetType[
                      message.reviewBet
                    ]
                  : message.reviewBet;
            if (
              message.clearWagerConfirmation != null &&
              message.hasOwnProperty("clearWagerConfirmation")
            )
              object.clearWagerConfirmation =
                options.enums === String
                  ? $root.stronachgroup.first.auth.ClearWagerConfirmation[
                      message.clearWagerConfirmation
                    ]
                  : message.clearWagerConfirmation;
            if (
              message.autoHandicap != null &&
              message.hasOwnProperty("autoHandicap")
            )
              object.autoHandicap =
                options.enums === String
                  ? $root.stronachgroup.first.auth.AutoHandicapType[
                      message.autoHandicap
                    ]
                  : message.autoHandicap;
            if (
              message.autoHandicapSetDirt != null &&
              message.hasOwnProperty("autoHandicapSetDirt")
            )
              object.autoHandicapSetDirt = message.autoHandicapSetDirt;
            if (
              message.autoHandicapSetTurf != null &&
              message.hasOwnProperty("autoHandicapSetTurf")
            )
              object.autoHandicapSetTurf = message.autoHandicapSetTurf;
            return object;
          };

          /**
           * Converts this UpdateUser1stbetPreferencesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateUser1stbetPreferencesRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UpdateUser1stbetPreferencesRequest;
        })();

        auth.UpdateUser1stbetPreferencesResponse = (function () {
          /**
           * Properties of an UpdateUser1stbetPreferencesResponse.
           * @memberof stronachgroup.first.auth
           * @interface IUpdateUser1stbetPreferencesResponse
           */

          /**
           * Constructs a new UpdateUser1stbetPreferencesResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UpdateUser1stbetPreferencesResponse.
           * @implements IUpdateUser1stbetPreferencesResponse
           * @constructor
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesResponse=} [properties] Properties to set
           */
          function UpdateUser1stbetPreferencesResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new UpdateUser1stbetPreferencesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse} UpdateUser1stbetPreferencesResponse instance
           */
          UpdateUser1stbetPreferencesResponse.create = function create(
            properties
          ) {
            return new UpdateUser1stbetPreferencesResponse(properties);
          };

          /**
           * Encodes the specified UpdateUser1stbetPreferencesResponse message. Does not implicitly {@link stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesResponse} message UpdateUser1stbetPreferencesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateUser1stbetPreferencesResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes an UpdateUser1stbetPreferencesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse} UpdateUser1stbetPreferencesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateUser1stbetPreferencesResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateUser1stbetPreferencesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse} UpdateUser1stbetPreferencesResponse
           */
          UpdateUser1stbetPreferencesResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
            )
              return object;
            return new $root.stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse();
          };

          /**
           * Creates a plain object from an UpdateUser1stbetPreferencesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse} message UpdateUser1stbetPreferencesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateUser1stbetPreferencesResponse.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this UpdateUser1stbetPreferencesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateUser1stbetPreferencesResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return UpdateUser1stbetPreferencesResponse;
        })();

        auth.UpdateAccountRequest = (function () {
          /**
           * Properties of an UpdateAccountRequest.
           * @memberof stronachgroup.first.auth
           * @interface IUpdateAccountRequest
           */

          /**
           * Constructs a new UpdateAccountRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UpdateAccountRequest.
           * @implements IUpdateAccountRequest
           * @constructor
           * @param {stronachgroup.first.auth.IUpdateAccountRequest=} [properties] Properties to set
           */
          function UpdateAccountRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new UpdateAccountRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @static
           * @param {stronachgroup.first.auth.IUpdateAccountRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UpdateAccountRequest} UpdateAccountRequest instance
           */
          UpdateAccountRequest.create = function create(properties) {
            return new UpdateAccountRequest(properties);
          };

          /**
           * Encodes the specified UpdateAccountRequest message. Does not implicitly {@link stronachgroup.first.auth.UpdateAccountRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @static
           * @param {stronachgroup.first.auth.IUpdateAccountRequest} message UpdateAccountRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateAccountRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes an UpdateAccountRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UpdateAccountRequest} UpdateAccountRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateAccountRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UpdateAccountRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateAccountRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UpdateAccountRequest} UpdateAccountRequest
           */
          UpdateAccountRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UpdateAccountRequest
            )
              return object;
            return new $root.stronachgroup.first.auth.UpdateAccountRequest();
          };

          /**
           * Creates a plain object from an UpdateAccountRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @static
           * @param {stronachgroup.first.auth.UpdateAccountRequest} message UpdateAccountRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateAccountRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this UpdateAccountRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UpdateAccountRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateAccountRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateAccountRequest;
        })();

        auth.UpdateAccountResponse = (function () {
          /**
           * Properties of an UpdateAccountResponse.
           * @memberof stronachgroup.first.auth
           * @interface IUpdateAccountResponse
           */

          /**
           * Constructs a new UpdateAccountResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents an UpdateAccountResponse.
           * @implements IUpdateAccountResponse
           * @constructor
           * @param {stronachgroup.first.auth.IUpdateAccountResponse=} [properties] Properties to set
           */
          function UpdateAccountResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new UpdateAccountResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @static
           * @param {stronachgroup.first.auth.IUpdateAccountResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.UpdateAccountResponse} UpdateAccountResponse instance
           */
          UpdateAccountResponse.create = function create(properties) {
            return new UpdateAccountResponse(properties);
          };

          /**
           * Encodes the specified UpdateAccountResponse message. Does not implicitly {@link stronachgroup.first.auth.UpdateAccountResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @static
           * @param {stronachgroup.first.auth.IUpdateAccountResponse} message UpdateAccountResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          UpdateAccountResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes an UpdateAccountResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.UpdateAccountResponse} UpdateAccountResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          UpdateAccountResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.UpdateAccountResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an UpdateAccountResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.UpdateAccountResponse} UpdateAccountResponse
           */
          UpdateAccountResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.UpdateAccountResponse
            )
              return object;
            return new $root.stronachgroup.first.auth.UpdateAccountResponse();
          };

          /**
           * Creates a plain object from an UpdateAccountResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @static
           * @param {stronachgroup.first.auth.UpdateAccountResponse} message UpdateAccountResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          UpdateAccountResponse.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this UpdateAccountResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.UpdateAccountResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          UpdateAccountResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return UpdateAccountResponse;
        })();

        auth.ClearUser1stbetPreferencesRequest = (function () {
          /**
           * Properties of a ClearUser1stbetPreferencesRequest.
           * @memberof stronachgroup.first.auth
           * @interface IClearUser1stbetPreferencesRequest
           * @property {Array.<string>|null} [preferencesToClear] ClearUser1stbetPreferencesRequest preferencesToClear
           */

          /**
           * Constructs a new ClearUser1stbetPreferencesRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a ClearUser1stbetPreferencesRequest.
           * @implements IClearUser1stbetPreferencesRequest
           * @constructor
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesRequest=} [properties] Properties to set
           */
          function ClearUser1stbetPreferencesRequest(properties) {
            this.preferencesToClear = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ClearUser1stbetPreferencesRequest preferencesToClear.
           * @member {Array.<string>} preferencesToClear
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @instance
           */
          ClearUser1stbetPreferencesRequest.prototype.preferencesToClear =
            $util.emptyArray;

          /**
           * Creates a new ClearUser1stbetPreferencesRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} ClearUser1stbetPreferencesRequest instance
           */
          ClearUser1stbetPreferencesRequest.create = function create(
            properties
          ) {
            return new ClearUser1stbetPreferencesRequest(properties);
          };

          /**
           * Encodes the specified ClearUser1stbetPreferencesRequest message. Does not implicitly {@link stronachgroup.first.auth.ClearUser1stbetPreferencesRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesRequest} message ClearUser1stbetPreferencesRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ClearUser1stbetPreferencesRequest.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            if (
              message.preferencesToClear != null &&
              message.preferencesToClear.length
            )
              for (var i = 0; i < message.preferencesToClear.length; ++i)
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.preferencesToClear[i]);
            return writer;
          };

          /**
           * Decodes a ClearUser1stbetPreferencesRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} ClearUser1stbetPreferencesRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ClearUser1stbetPreferencesRequest.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (
                    !(
                      message.preferencesToClear &&
                      message.preferencesToClear.length
                    )
                  )
                    message.preferencesToClear = [];
                  message.preferencesToClear.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ClearUser1stbetPreferencesRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} ClearUser1stbetPreferencesRequest
           */
          ClearUser1stbetPreferencesRequest.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.ClearUser1stbetPreferencesRequest();
            if (object.preferencesToClear) {
              if (!Array.isArray(object.preferencesToClear))
                throw TypeError(
                  ".stronachgroup.first.auth.ClearUser1stbetPreferencesRequest.preferencesToClear: array expected"
                );
              message.preferencesToClear = [];
              for (var i = 0; i < object.preferencesToClear.length; ++i)
                message.preferencesToClear[i] = String(
                  object.preferencesToClear[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a ClearUser1stbetPreferencesRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @static
           * @param {stronachgroup.first.auth.ClearUser1stbetPreferencesRequest} message ClearUser1stbetPreferencesRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ClearUser1stbetPreferencesRequest.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults)
              object.preferencesToClear = [];
            if (
              message.preferencesToClear &&
              message.preferencesToClear.length
            ) {
              object.preferencesToClear = [];
              for (var j = 0; j < message.preferencesToClear.length; ++j)
                object.preferencesToClear[j] = message.preferencesToClear[j];
            }
            return object;
          };

          /**
           * Converts this ClearUser1stbetPreferencesRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ClearUser1stbetPreferencesRequest.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ClearUser1stbetPreferencesRequest;
        })();

        auth.ClearUser1stbetPreferencesResponse = (function () {
          /**
           * Properties of a ClearUser1stbetPreferencesResponse.
           * @memberof stronachgroup.first.auth
           * @interface IClearUser1stbetPreferencesResponse
           */

          /**
           * Constructs a new ClearUser1stbetPreferencesResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a ClearUser1stbetPreferencesResponse.
           * @implements IClearUser1stbetPreferencesResponse
           * @constructor
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesResponse=} [properties] Properties to set
           */
          function ClearUser1stbetPreferencesResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new ClearUser1stbetPreferencesResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesResponse} ClearUser1stbetPreferencesResponse instance
           */
          ClearUser1stbetPreferencesResponse.create = function create(
            properties
          ) {
            return new ClearUser1stbetPreferencesResponse(properties);
          };

          /**
           * Encodes the specified ClearUser1stbetPreferencesResponse message. Does not implicitly {@link stronachgroup.first.auth.ClearUser1stbetPreferencesResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesResponse} message ClearUser1stbetPreferencesResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ClearUser1stbetPreferencesResponse.encode = function encode(
            message,
            writer
          ) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a ClearUser1stbetPreferencesResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesResponse} ClearUser1stbetPreferencesResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ClearUser1stbetPreferencesResponse.decode = function decode(
            reader,
            length
          ) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ClearUser1stbetPreferencesResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.ClearUser1stbetPreferencesResponse} ClearUser1stbetPreferencesResponse
           */
          ClearUser1stbetPreferencesResponse.fromObject = function fromObject(
            object
          ) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
            )
              return object;
            return new $root.stronachgroup.first.auth.ClearUser1stbetPreferencesResponse();
          };

          /**
           * Creates a plain object from a ClearUser1stbetPreferencesResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @static
           * @param {stronachgroup.first.auth.ClearUser1stbetPreferencesResponse} message ClearUser1stbetPreferencesResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ClearUser1stbetPreferencesResponse.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this ClearUser1stbetPreferencesResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.ClearUser1stbetPreferencesResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ClearUser1stbetPreferencesResponse.prototype.toJSON =
            function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

          return ClearUser1stbetPreferencesResponse;
        })();

        auth.GetAccountInfoRequest = (function () {
          /**
           * Properties of a GetAccountInfoRequest.
           * @memberof stronachgroup.first.auth
           * @interface IGetAccountInfoRequest
           */

          /**
           * Constructs a new GetAccountInfoRequest.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetAccountInfoRequest.
           * @implements IGetAccountInfoRequest
           * @constructor
           * @param {stronachgroup.first.auth.IGetAccountInfoRequest=} [properties] Properties to set
           */
          function GetAccountInfoRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Creates a new GetAccountInfoRequest instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @static
           * @param {stronachgroup.first.auth.IGetAccountInfoRequest=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetAccountInfoRequest} GetAccountInfoRequest instance
           */
          GetAccountInfoRequest.create = function create(properties) {
            return new GetAccountInfoRequest(properties);
          };

          /**
           * Encodes the specified GetAccountInfoRequest message. Does not implicitly {@link stronachgroup.first.auth.GetAccountInfoRequest.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @static
           * @param {stronachgroup.first.auth.IGetAccountInfoRequest} message GetAccountInfoRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetAccountInfoRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            return writer;
          };

          /**
           * Decodes a GetAccountInfoRequest message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetAccountInfoRequest} GetAccountInfoRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetAccountInfoRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.GetAccountInfoRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetAccountInfoRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetAccountInfoRequest} GetAccountInfoRequest
           */
          GetAccountInfoRequest.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetAccountInfoRequest
            )
              return object;
            return new $root.stronachgroup.first.auth.GetAccountInfoRequest();
          };

          /**
           * Creates a plain object from a GetAccountInfoRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @static
           * @param {stronachgroup.first.auth.GetAccountInfoRequest} message GetAccountInfoRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetAccountInfoRequest.toObject = function toObject() {
            return {};
          };

          /**
           * Converts this GetAccountInfoRequest to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetAccountInfoRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetAccountInfoRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetAccountInfoRequest;
        })();

        auth.GetAccountInfoResponse = (function () {
          /**
           * Properties of a GetAccountInfoResponse.
           * @memberof stronachgroup.first.auth
           * @interface IGetAccountInfoResponse
           * @property {string|null} [pscAcct] GetAccountInfoResponse pscAcct
           * @property {string|null} [xboproduct] GetAccountInfoResponse xboproduct
           * @property {string|null} [customerStatus] GetAccountInfoResponse customerStatus
           */

          /**
           * Constructs a new GetAccountInfoResponse.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a GetAccountInfoResponse.
           * @implements IGetAccountInfoResponse
           * @constructor
           * @param {stronachgroup.first.auth.IGetAccountInfoResponse=} [properties] Properties to set
           */
          function GetAccountInfoResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * GetAccountInfoResponse pscAcct.
           * @member {string} pscAcct
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @instance
           */
          GetAccountInfoResponse.prototype.pscAcct = "";

          /**
           * GetAccountInfoResponse xboproduct.
           * @member {string} xboproduct
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @instance
           */
          GetAccountInfoResponse.prototype.xboproduct = "";

          /**
           * GetAccountInfoResponse customerStatus.
           * @member {string} customerStatus
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @instance
           */
          GetAccountInfoResponse.prototype.customerStatus = "";

          /**
           * Creates a new GetAccountInfoResponse instance using the specified properties.
           * @function create
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @static
           * @param {stronachgroup.first.auth.IGetAccountInfoResponse=} [properties] Properties to set
           * @returns {stronachgroup.first.auth.GetAccountInfoResponse} GetAccountInfoResponse instance
           */
          GetAccountInfoResponse.create = function create(properties) {
            return new GetAccountInfoResponse(properties);
          };

          /**
           * Encodes the specified GetAccountInfoResponse message. Does not implicitly {@link stronachgroup.first.auth.GetAccountInfoResponse.verify|verify} messages.
           * @function encode
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @static
           * @param {stronachgroup.first.auth.IGetAccountInfoResponse} message GetAccountInfoResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          GetAccountInfoResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.pscAcct != null &&
              Object.hasOwnProperty.call(message, "pscAcct")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.pscAcct);
            if (
              message.xboproduct != null &&
              Object.hasOwnProperty.call(message, "xboproduct")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.xboproduct);
            if (
              message.customerStatus != null &&
              Object.hasOwnProperty.call(message, "customerStatus")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.customerStatus);
            return writer;
          };

          /**
           * Decodes a GetAccountInfoResponse message from the specified reader or buffer.
           * @function decode
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {stronachgroup.first.auth.GetAccountInfoResponse} GetAccountInfoResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          GetAccountInfoResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.stronachgroup.first.auth.GetAccountInfoResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.pscAcct = reader.string();
                  break;
                case 2:
                  message.xboproduct = reader.string();
                  break;
                case 3:
                  message.customerStatus = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a GetAccountInfoResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {stronachgroup.first.auth.GetAccountInfoResponse} GetAccountInfoResponse
           */
          GetAccountInfoResponse.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.stronachgroup.first.auth.GetAccountInfoResponse
            )
              return object;
            var message =
              new $root.stronachgroup.first.auth.GetAccountInfoResponse();
            if (object.pscAcct != null)
              message.pscAcct = String(object.pscAcct);
            if (object.xboproduct != null)
              message.xboproduct = String(object.xboproduct);
            if (object.customerStatus != null)
              message.customerStatus = String(object.customerStatus);
            return message;
          };

          /**
           * Creates a plain object from a GetAccountInfoResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @static
           * @param {stronachgroup.first.auth.GetAccountInfoResponse} message GetAccountInfoResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          GetAccountInfoResponse.toObject = function toObject(
            message,
            options
          ) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.pscAcct = "";
              object.xboproduct = "";
              object.customerStatus = "";
            }
            if (message.pscAcct != null && message.hasOwnProperty("pscAcct"))
              object.pscAcct = message.pscAcct;
            if (
              message.xboproduct != null &&
              message.hasOwnProperty("xboproduct")
            )
              object.xboproduct = message.xboproduct;
            if (
              message.customerStatus != null &&
              message.hasOwnProperty("customerStatus")
            )
              object.customerStatus = message.customerStatus;
            return object;
          };

          /**
           * Converts this GetAccountInfoResponse to JSON.
           * @function toJSON
           * @memberof stronachgroup.first.auth.GetAccountInfoResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          GetAccountInfoResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return GetAccountInfoResponse;
        })();

        auth.UserProfileService = (function () {
          /**
           * Constructs a new UserProfileService service.
           * @memberof stronachgroup.first.auth
           * @classdesc Represents a UserProfileService
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function UserProfileService(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (UserProfileService.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = UserProfileService;

          /**
           * Creates new UserProfileService service using the specified rpc implementation.
           * @function create
           * @memberof stronachgroup.first.auth.UserProfileService
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {UserProfileService} RPC service. Useful where requests and/or responses are streamed.
           */
          UserProfileService.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#authenticateUser}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef AuthenticateUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.AuthenticateUserResponse} [response] AuthenticateUserResponse
           */

          /**
           * Calls AuthenticateUser.
           * @function authenticateUser
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IAuthenticateUserRequest} request AuthenticateUserRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.AuthenticateUserCallback} callback Node-style callback called with the error, if any, and AuthenticateUserResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.authenticateUser =
              function authenticateUser(request, callback) {
                return this.rpcCall(
                  authenticateUser,
                  $root.stronachgroup.first.auth.AuthenticateUserRequest,
                  $root.stronachgroup.first.auth.AuthenticateUserResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AuthenticateUser" }
          );

          /**
           * Calls AuthenticateUser.
           * @function authenticateUser
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IAuthenticateUserRequest} request AuthenticateUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.AuthenticateUserResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#authenticatePinUser}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef AuthenticatePinUserCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.AuthenticatePinUserResponse} [response] AuthenticatePinUserResponse
           */

          /**
           * Calls AuthenticatePinUser.
           * @function authenticatePinUser
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IAuthenticatePinUserRequest} request AuthenticatePinUserRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.AuthenticatePinUserCallback} callback Node-style callback called with the error, if any, and AuthenticatePinUserResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.authenticatePinUser =
              function authenticatePinUser(request, callback) {
                return this.rpcCall(
                  authenticatePinUser,
                  $root.stronachgroup.first.auth.AuthenticatePinUserRequest,
                  $root.stronachgroup.first.auth.AuthenticatePinUserResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "AuthenticatePinUser" }
          );

          /**
           * Calls AuthenticatePinUser.
           * @function authenticatePinUser
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IAuthenticatePinUserRequest} request AuthenticatePinUserRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.AuthenticatePinUserResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#getUserByUsername}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef GetUserByUsernameCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.GetUserByUsernameResponse} [response] GetUserByUsernameResponse
           */

          /**
           * Calls GetUserByUsername.
           * @function getUserByUsername
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetUserByUsernameRequest} request GetUserByUsernameRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.GetUserByUsernameCallback} callback Node-style callback called with the error, if any, and GetUserByUsernameResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.getUserByUsername =
              function getUserByUsername(request, callback) {
                return this.rpcCall(
                  getUserByUsername,
                  $root.stronachgroup.first.auth.GetUserByUsernameRequest,
                  $root.stronachgroup.first.auth.GetUserByUsernameResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetUserByUsername" }
          );

          /**
           * Calls GetUserByUsername.
           * @function getUserByUsername
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetUserByUsernameRequest} request GetUserByUsernameRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.GetUserByUsernameResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#getUserInfo}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef GetUserInfoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.GetUserInfoResponse} [response] GetUserInfoResponse
           */

          /**
           * Calls GetUserInfo.
           * @function getUserInfo
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetUserInfoRequest} request GetUserInfoRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.GetUserInfoCallback} callback Node-style callback called with the error, if any, and GetUserInfoResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.getUserInfo = function getUserInfo(
              request,
              callback
            ) {
              return this.rpcCall(
                getUserInfo,
                $root.stronachgroup.first.auth.GetUserInfoRequest,
                $root.stronachgroup.first.auth.GetUserInfoResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "GetUserInfo" }
          );

          /**
           * Calls GetUserInfo.
           * @function getUserInfo
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetUserInfoRequest} request GetUserInfoRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.GetUserInfoResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#getFirebaseToken}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef GetFirebaseTokenCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.FirebaseTokenResponse} [response] FirebaseTokenResponse
           */

          /**
           * Calls GetFirebaseToken.
           * @function getFirebaseToken
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IFirebaseTokenRequest} request FirebaseTokenRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.GetFirebaseTokenCallback} callback Node-style callback called with the error, if any, and FirebaseTokenResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.getFirebaseToken =
              function getFirebaseToken(request, callback) {
                return this.rpcCall(
                  getFirebaseToken,
                  $root.stronachgroup.first.auth.FirebaseTokenRequest,
                  $root.stronachgroup.first.auth.FirebaseTokenResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetFirebaseToken" }
          );

          /**
           * Calls GetFirebaseToken.
           * @function getFirebaseToken
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IFirebaseTokenRequest} request FirebaseTokenRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.FirebaseTokenResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#unlinkIdentity}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef UnlinkIdentityCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.UnlinkIdentityResponse} [response] UnlinkIdentityResponse
           */

          /**
           * Calls UnlinkIdentity.
           * @function unlinkIdentity
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUnlinkIdentityRequest} request UnlinkIdentityRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.UnlinkIdentityCallback} callback Node-style callback called with the error, if any, and UnlinkIdentityResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.unlinkIdentity =
              function unlinkIdentity(request, callback) {
                return this.rpcCall(
                  unlinkIdentity,
                  $root.stronachgroup.first.auth.UnlinkIdentityRequest,
                  $root.stronachgroup.first.auth.UnlinkIdentityResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UnlinkIdentity" }
          );

          /**
           * Calls UnlinkIdentity.
           * @function unlinkIdentity
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUnlinkIdentityRequest} request UnlinkIdentityRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.UnlinkIdentityResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#updateUser1stbetPreferences}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef UpdateUser1stbetPreferencesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse} [response] UpdateUser1stbetPreferencesResponse
           */

          /**
           * Calls UpdateUser1stbetPreferences.
           * @function updateUser1stbetPreferences
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesRequest} request UpdateUser1stbetPreferencesRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.UpdateUser1stbetPreferencesCallback} callback Node-style callback called with the error, if any, and UpdateUser1stbetPreferencesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.updateUser1stbetPreferences =
              function updateUser1stbetPreferences(request, callback) {
                return this.rpcCall(
                  updateUser1stbetPreferences,
                  $root.stronachgroup.first.auth
                    .UpdateUser1stbetPreferencesRequest,
                  $root.stronachgroup.first.auth
                    .UpdateUser1stbetPreferencesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateUser1stbetPreferences" }
          );

          /**
           * Calls UpdateUser1stbetPreferences.
           * @function updateUser1stbetPreferences
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUpdateUser1stbetPreferencesRequest} request UpdateUser1stbetPreferencesRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.UpdateUser1stbetPreferencesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#clearUser1stbetPreferences}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef ClearUser1stbetPreferencesCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.ClearUser1stbetPreferencesResponse} [response] ClearUser1stbetPreferencesResponse
           */

          /**
           * Calls ClearUser1stbetPreferences.
           * @function clearUser1stbetPreferences
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesRequest} request ClearUser1stbetPreferencesRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.ClearUser1stbetPreferencesCallback} callback Node-style callback called with the error, if any, and ClearUser1stbetPreferencesResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.clearUser1stbetPreferences =
              function clearUser1stbetPreferences(request, callback) {
                return this.rpcCall(
                  clearUser1stbetPreferences,
                  $root.stronachgroup.first.auth
                    .ClearUser1stbetPreferencesRequest,
                  $root.stronachgroup.first.auth
                    .ClearUser1stbetPreferencesResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "ClearUser1stbetPreferences" }
          );

          /**
           * Calls ClearUser1stbetPreferences.
           * @function clearUser1stbetPreferences
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IClearUser1stbetPreferencesRequest} request ClearUser1stbetPreferencesRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.ClearUser1stbetPreferencesResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#getAccountInfo}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef GetAccountInfoCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.GetAccountInfoResponse} [response] GetAccountInfoResponse
           */

          /**
           * Calls GetAccountInfo.
           * @function getAccountInfo
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetAccountInfoRequest} request GetAccountInfoRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.GetAccountInfoCallback} callback Node-style callback called with the error, if any, and GetAccountInfoResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.getAccountInfo =
              function getAccountInfo(request, callback) {
                return this.rpcCall(
                  getAccountInfo,
                  $root.stronachgroup.first.auth.GetAccountInfoRequest,
                  $root.stronachgroup.first.auth.GetAccountInfoResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "GetAccountInfo" }
          );

          /**
           * Calls GetAccountInfo.
           * @function getAccountInfo
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IGetAccountInfoRequest} request GetAccountInfoRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.GetAccountInfoResponse>} Promise
           * @variation 2
           */

          /**
           * Callback as used by {@link stronachgroup.first.auth.UserProfileService#updateAccount}.
           * @memberof stronachgroup.first.auth.UserProfileService
           * @typedef UpdateAccountCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {stronachgroup.first.auth.UpdateAccountResponse} [response] UpdateAccountResponse
           */

          /**
           * Calls UpdateAccount.
           * @function updateAccount
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUpdateAccountRequest} request UpdateAccountRequest message or plain object
           * @param {stronachgroup.first.auth.UserProfileService.UpdateAccountCallback} callback Node-style callback called with the error, if any, and UpdateAccountResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (UserProfileService.prototype.updateAccount =
              function updateAccount(request, callback) {
                return this.rpcCall(
                  updateAccount,
                  $root.stronachgroup.first.auth.UpdateAccountRequest,
                  $root.stronachgroup.first.auth.UpdateAccountResponse,
                  request,
                  callback
                );
              }),
            "name",
            { value: "UpdateAccount" }
          );

          /**
           * Calls UpdateAccount.
           * @function updateAccount
           * @memberof stronachgroup.first.auth.UserProfileService
           * @instance
           * @param {stronachgroup.first.auth.IUpdateAccountRequest} request UpdateAccountRequest message or plain object
           * @returns {Promise<stronachgroup.first.auth.UpdateAccountResponse>} Promise
           * @variation 2
           */

          return UserProfileService;
        })();

        return auth;
      })();

      return first;
    })();

    return stronachgroup;
  })();

  $root.grpc = (function () {
    /**
     * Namespace grpc.
     * @exports grpc
     * @namespace
     */
    var grpc = {};

    grpc.health = (function () {
      /**
       * Namespace health.
       * @memberof grpc
       * @namespace
       */
      var health = {};

      health.v1 = (function () {
        /**
         * Namespace v1.
         * @memberof grpc.health
         * @namespace
         */
        var v1 = {};

        v1.HealthCheckRequest = (function () {
          /**
           * Properties of a HealthCheckRequest.
           * @memberof grpc.health.v1
           * @interface IHealthCheckRequest
           * @property {string|null} [service] HealthCheckRequest service
           */

          /**
           * Constructs a new HealthCheckRequest.
           * @memberof grpc.health.v1
           * @classdesc Represents a HealthCheckRequest.
           * @implements IHealthCheckRequest
           * @constructor
           * @param {grpc.health.v1.IHealthCheckRequest=} [properties] Properties to set
           */
          function HealthCheckRequest(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HealthCheckRequest service.
           * @member {string} service
           * @memberof grpc.health.v1.HealthCheckRequest
           * @instance
           */
          HealthCheckRequest.prototype.service = "";

          /**
           * Creates a new HealthCheckRequest instance using the specified properties.
           * @function create
           * @memberof grpc.health.v1.HealthCheckRequest
           * @static
           * @param {grpc.health.v1.IHealthCheckRequest=} [properties] Properties to set
           * @returns {grpc.health.v1.HealthCheckRequest} HealthCheckRequest instance
           */
          HealthCheckRequest.create = function create(properties) {
            return new HealthCheckRequest(properties);
          };

          /**
           * Encodes the specified HealthCheckRequest message. Does not implicitly {@link grpc.health.v1.HealthCheckRequest.verify|verify} messages.
           * @function encode
           * @memberof grpc.health.v1.HealthCheckRequest
           * @static
           * @param {grpc.health.v1.IHealthCheckRequest} message HealthCheckRequest message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HealthCheckRequest.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.service != null &&
              Object.hasOwnProperty.call(message, "service")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.service);
            return writer;
          };

          /**
           * Decodes a HealthCheckRequest message from the specified reader or buffer.
           * @function decode
           * @memberof grpc.health.v1.HealthCheckRequest
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {grpc.health.v1.HealthCheckRequest} HealthCheckRequest
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HealthCheckRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.grpc.health.v1.HealthCheckRequest();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.service = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HealthCheckRequest message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof grpc.health.v1.HealthCheckRequest
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {grpc.health.v1.HealthCheckRequest} HealthCheckRequest
           */
          HealthCheckRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.grpc.health.v1.HealthCheckRequest)
              return object;
            var message = new $root.grpc.health.v1.HealthCheckRequest();
            if (object.service != null)
              message.service = String(object.service);
            return message;
          };

          /**
           * Creates a plain object from a HealthCheckRequest message. Also converts values to other types if specified.
           * @function toObject
           * @memberof grpc.health.v1.HealthCheckRequest
           * @static
           * @param {grpc.health.v1.HealthCheckRequest} message HealthCheckRequest
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HealthCheckRequest.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) object.service = "";
            if (message.service != null && message.hasOwnProperty("service"))
              object.service = message.service;
            return object;
          };

          /**
           * Converts this HealthCheckRequest to JSON.
           * @function toJSON
           * @memberof grpc.health.v1.HealthCheckRequest
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HealthCheckRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return HealthCheckRequest;
        })();

        v1.HealthCheckResponse = (function () {
          /**
           * Properties of a HealthCheckResponse.
           * @memberof grpc.health.v1
           * @interface IHealthCheckResponse
           * @property {grpc.health.v1.HealthCheckResponse.ServingStatus|null} [status] HealthCheckResponse status
           */

          /**
           * Constructs a new HealthCheckResponse.
           * @memberof grpc.health.v1
           * @classdesc Represents a HealthCheckResponse.
           * @implements IHealthCheckResponse
           * @constructor
           * @param {grpc.health.v1.IHealthCheckResponse=} [properties] Properties to set
           */
          function HealthCheckResponse(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * HealthCheckResponse status.
           * @member {grpc.health.v1.HealthCheckResponse.ServingStatus} status
           * @memberof grpc.health.v1.HealthCheckResponse
           * @instance
           */
          HealthCheckResponse.prototype.status = 0;

          /**
           * Creates a new HealthCheckResponse instance using the specified properties.
           * @function create
           * @memberof grpc.health.v1.HealthCheckResponse
           * @static
           * @param {grpc.health.v1.IHealthCheckResponse=} [properties] Properties to set
           * @returns {grpc.health.v1.HealthCheckResponse} HealthCheckResponse instance
           */
          HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
          };

          /**
           * Encodes the specified HealthCheckResponse message. Does not implicitly {@link grpc.health.v1.HealthCheckResponse.verify|verify} messages.
           * @function encode
           * @memberof grpc.health.v1.HealthCheckResponse
           * @static
           * @param {grpc.health.v1.IHealthCheckResponse} message HealthCheckResponse message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          HealthCheckResponse.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.status != null &&
              Object.hasOwnProperty.call(message, "status")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.status);
            return writer;
          };

          /**
           * Decodes a HealthCheckResponse message from the specified reader or buffer.
           * @function decode
           * @memberof grpc.health.v1.HealthCheckResponse
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {grpc.health.v1.HealthCheckResponse} HealthCheckResponse
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          HealthCheckResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.grpc.health.v1.HealthCheckResponse();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.status = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a HealthCheckResponse message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof grpc.health.v1.HealthCheckResponse
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {grpc.health.v1.HealthCheckResponse} HealthCheckResponse
           */
          HealthCheckResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.grpc.health.v1.HealthCheckResponse)
              return object;
            var message = new $root.grpc.health.v1.HealthCheckResponse();
            switch (object.status) {
              case "UNKNOWN":
              case 0:
                message.status = 0;
                break;
              case "SERVING":
              case 1:
                message.status = 1;
                break;
              case "NOT_SERVING":
              case 2:
                message.status = 2;
                break;
            }
            return message;
          };

          /**
           * Creates a plain object from a HealthCheckResponse message. Also converts values to other types if specified.
           * @function toObject
           * @memberof grpc.health.v1.HealthCheckResponse
           * @static
           * @param {grpc.health.v1.HealthCheckResponse} message HealthCheckResponse
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          HealthCheckResponse.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults)
              object.status = options.enums === String ? "UNKNOWN" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
              object.status =
                options.enums === String
                  ? $root.grpc.health.v1.HealthCheckResponse.ServingStatus[
                      message.status
                    ]
                  : message.status;
            return object;
          };

          /**
           * Converts this HealthCheckResponse to JSON.
           * @function toJSON
           * @memberof grpc.health.v1.HealthCheckResponse
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          HealthCheckResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          /**
           * ServingStatus enum.
           * @name grpc.health.v1.HealthCheckResponse.ServingStatus
           * @enum {string}
           * @property {number} UNKNOWN=0 UNKNOWN value
           * @property {number} SERVING=1 SERVING value
           * @property {number} NOT_SERVING=2 NOT_SERVING value
           */
          HealthCheckResponse.ServingStatus = (function () {
            var valuesById = {},
              values = Object.create(valuesById);
            values[(valuesById[0] = "UNKNOWN")] = 0;
            values[(valuesById[1] = "SERVING")] = 1;
            values[(valuesById[2] = "NOT_SERVING")] = 2;
            return values;
          })();

          return HealthCheckResponse;
        })();

        v1.Health = (function () {
          /**
           * Constructs a new Health service.
           * @memberof grpc.health.v1
           * @classdesc Represents a Health
           * @extends $protobuf.rpc.Service
           * @constructor
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           */
          function Health(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(
              this,
              rpcImpl,
              requestDelimited,
              responseDelimited
            );
          }

          (Health.prototype = Object.create(
            $protobuf.rpc.Service.prototype
          )).constructor = Health;

          /**
           * Creates new Health service using the specified rpc implementation.
           * @function create
           * @memberof grpc.health.v1.Health
           * @static
           * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
           * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
           * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
           * @returns {Health} RPC service. Useful where requests and/or responses are streamed.
           */
          Health.create = function create(
            rpcImpl,
            requestDelimited,
            responseDelimited
          ) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
          };

          /**
           * Callback as used by {@link grpc.health.v1.Health#check}.
           * @memberof grpc.health.v1.Health
           * @typedef CheckCallback
           * @type {function}
           * @param {Error|null} error Error, if any
           * @param {grpc.health.v1.HealthCheckResponse} [response] HealthCheckResponse
           */

          /**
           * Calls Check.
           * @function check
           * @memberof grpc.health.v1.Health
           * @instance
           * @param {grpc.health.v1.IHealthCheckRequest} request HealthCheckRequest message or plain object
           * @param {grpc.health.v1.Health.CheckCallback} callback Node-style callback called with the error, if any, and HealthCheckResponse
           * @returns {undefined}
           * @variation 1
           */
          Object.defineProperty(
            (Health.prototype.check = function check(request, callback) {
              return this.rpcCall(
                check,
                $root.grpc.health.v1.HealthCheckRequest,
                $root.grpc.health.v1.HealthCheckResponse,
                request,
                callback
              );
            }),
            "name",
            { value: "Check" }
          );

          /**
           * Calls Check.
           * @function check
           * @memberof grpc.health.v1.Health
           * @instance
           * @param {grpc.health.v1.IHealthCheckRequest} request HealthCheckRequest message or plain object
           * @returns {Promise<grpc.health.v1.HealthCheckResponse>} Promise
           * @variation 2
           */

          return Health;
        })();

        return v1;
      })();

      return health;
    })();

    grpc.gateway = (function () {
      /**
       * Namespace gateway.
       * @memberof grpc
       * @namespace
       */
      var gateway = {};

      gateway.protoc_gen_openapiv2 = (function () {
        /**
         * Namespace protoc_gen_openapiv2.
         * @memberof grpc.gateway
         * @namespace
         */
        var protoc_gen_openapiv2 = {};

        protoc_gen_openapiv2.options = (function () {
          /**
           * Namespace options.
           * @memberof grpc.gateway.protoc_gen_openapiv2
           * @namespace
           */
          var options = {};

          /**
           * Scheme enum.
           * @name grpc.gateway.protoc_gen_openapiv2.options.Scheme
           * @enum {string}
           * @property {number} UNKNOWN=0 UNKNOWN value
           * @property {number} HTTP=1 HTTP value
           * @property {number} HTTPS=2 HTTPS value
           * @property {number} WS=3 WS value
           * @property {number} WSS=4 WSS value
           */
          options.Scheme = (function () {
            var valuesById = {},
              values = Object.create(valuesById);
            values[(valuesById[0] = "UNKNOWN")] = 0;
            values[(valuesById[1] = "HTTP")] = 1;
            values[(valuesById[2] = "HTTPS")] = 2;
            values[(valuesById[3] = "WS")] = 3;
            values[(valuesById[4] = "WSS")] = 4;
            return values;
          })();

          options.Swagger = (function () {
            /**
             * Properties of a Swagger.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ISwagger
             * @property {string|null} [swagger] Swagger swagger
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IInfo|null} [info] Swagger info
             * @property {string|null} [host] Swagger host
             * @property {string|null} [basePath] Swagger basePath
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.Scheme>|null} [schemes] Swagger schemes
             * @property {Array.<string>|null} [consumes] Swagger consumes
             * @property {Array.<string>|null} [produces] Swagger produces
             * @property {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IResponse>|null} [responses] Swagger responses
             * @property {grpc.gateway.protoc_gen_openapiv2.options.ISecurityDefinitions|null} [securityDefinitions] Swagger securityDefinitions
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement>|null} [security] Swagger security
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.ITag>|null} [tags] Swagger tags
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null} [externalDocs] Swagger externalDocs
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] Swagger extensions
             */

            /**
             * Constructs a new Swagger.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Swagger.
             * @implements ISwagger
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISwagger=} [properties] Properties to set
             */
            function Swagger(properties) {
              this.schemes = [];
              this.consumes = [];
              this.produces = [];
              this.responses = {};
              this.security = [];
              this.tags = [];
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Swagger swagger.
             * @member {string} swagger
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.swagger = "";

            /**
             * Swagger info.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IInfo|null|undefined} info
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.info = null;

            /**
             * Swagger host.
             * @member {string} host
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.host = "";

            /**
             * Swagger basePath.
             * @member {string} basePath
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.basePath = "";

            /**
             * Swagger schemes.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.Scheme>} schemes
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.schemes = $util.emptyArray;

            /**
             * Swagger consumes.
             * @member {Array.<string>} consumes
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.consumes = $util.emptyArray;

            /**
             * Swagger produces.
             * @member {Array.<string>} produces
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.produces = $util.emptyArray;

            /**
             * Swagger responses.
             * @member {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IResponse>} responses
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.responses = $util.emptyObject;

            /**
             * Swagger securityDefinitions.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.ISecurityDefinitions|null|undefined} securityDefinitions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.securityDefinitions = null;

            /**
             * Swagger security.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement>} security
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.security = $util.emptyArray;

            /**
             * Swagger tags.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.ITag>} tags
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.tags = $util.emptyArray;

            /**
             * Swagger externalDocs.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null|undefined} externalDocs
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.externalDocs = null;

            /**
             * Swagger extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             */
            Swagger.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new Swagger instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISwagger=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Swagger} Swagger instance
             */
            Swagger.create = function create(properties) {
              return new Swagger(properties);
            };

            /**
             * Encodes the specified Swagger message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Swagger.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISwagger} message Swagger message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Swagger.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.swagger != null &&
                Object.hasOwnProperty.call(message, "swagger")
              )
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.swagger);
              if (
                message.info != null &&
                Object.hasOwnProperty.call(message, "info")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.Info.encode(
                  message.info,
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
              if (
                message.host != null &&
                Object.hasOwnProperty.call(message, "host")
              )
                writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.host);
              if (
                message.basePath != null &&
                Object.hasOwnProperty.call(message, "basePath")
              )
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.basePath);
              if (message.schemes != null && message.schemes.length) {
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork();
                for (var i = 0; i < message.schemes.length; ++i)
                  writer.int32(message.schemes[i]);
                writer.ldelim();
              }
              if (message.consumes != null && message.consumes.length)
                for (var i = 0; i < message.consumes.length; ++i)
                  writer
                    .uint32(/* id 6, wireType 2 =*/ 50)
                    .string(message.consumes[i]);
              if (message.produces != null && message.produces.length)
                for (var i = 0; i < message.produces.length; ++i)
                  writer
                    .uint32(/* id 7, wireType 2 =*/ 58)
                    .string(message.produces[i]);
              if (
                message.responses != null &&
                Object.hasOwnProperty.call(message, "responses")
              )
                for (
                  var keys = Object.keys(message.responses), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 10, wireType 2 =*/ 82)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Response.encode(
                    message.responses[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              if (
                message.securityDefinitions != null &&
                Object.hasOwnProperty.call(message, "securityDefinitions")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.encode(
                  message.securityDefinitions,
                  writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
                ).ldelim();
              if (message.security != null && message.security.length)
                for (var i = 0; i < message.security.length; ++i)
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.encode(
                    message.security[i],
                    writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
                  ).ldelim();
              if (message.tags != null && message.tags.length)
                for (var i = 0; i < message.tags.length; ++i)
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.encode(
                    message.tags[i],
                    writer.uint32(/* id 13, wireType 2 =*/ 106).fork()
                  ).ldelim();
              if (
                message.externalDocs != null &&
                Object.hasOwnProperty.call(message, "externalDocs")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.encode(
                  message.externalDocs,
                  writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
                ).ldelim();
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 15, wireType 2 =*/ 122)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a Swagger message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Swagger} Swagger
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Swagger.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.swagger = reader.string();
                    break;
                  case 2:
                    message.info =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Info.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 3:
                    message.host = reader.string();
                    break;
                  case 4:
                    message.basePath = reader.string();
                    break;
                  case 5:
                    if (!(message.schemes && message.schemes.length))
                      message.schemes = [];
                    if ((tag & 7) === 2) {
                      var end2 = reader.uint32() + reader.pos;
                      while (reader.pos < end2)
                        message.schemes.push(reader.int32());
                    } else message.schemes.push(reader.int32());
                    break;
                  case 6:
                    if (!(message.consumes && message.consumes.length))
                      message.consumes = [];
                    message.consumes.push(reader.string());
                    break;
                  case 7:
                    if (!(message.produces && message.produces.length))
                      message.produces = [];
                    message.produces.push(reader.string());
                    break;
                  case 10:
                    reader.skip().pos++;
                    if (message.responses === $util.emptyObject)
                      message.responses = {};
                    key = reader.string();
                    reader.pos++;
                    message.responses[key] =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Response.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 11:
                    message.securityDefinitions =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 12:
                    if (!(message.security && message.security.length))
                      message.security = [];
                    message.security.push(
                      $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.decode(
                        reader,
                        reader.uint32()
                      )
                    );
                    break;
                  case 13:
                    if (!(message.tags && message.tags.length))
                      message.tags = [];
                    message.tags.push(
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.decode(
                        reader,
                        reader.uint32()
                      )
                    );
                    break;
                  case 14:
                    message.externalDocs =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 15:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Swagger message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Swagger} Swagger
             */
            Swagger.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger();
              if (object.swagger != null)
                message.swagger = String(object.swagger);
              if (object.info != null) {
                if (typeof object.info !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.info: object expected"
                  );
                message.info =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Info.fromObject(
                    object.info
                  );
              }
              if (object.host != null) message.host = String(object.host);
              if (object.basePath != null)
                message.basePath = String(object.basePath);
              if (object.schemes) {
                if (!Array.isArray(object.schemes))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.schemes: array expected"
                  );
                message.schemes = [];
                for (var i = 0; i < object.schemes.length; ++i)
                  switch (object.schemes[i]) {
                    default:
                    case "UNKNOWN":
                    case 0:
                      message.schemes[i] = 0;
                      break;
                    case "HTTP":
                    case 1:
                      message.schemes[i] = 1;
                      break;
                    case "HTTPS":
                    case 2:
                      message.schemes[i] = 2;
                      break;
                    case "WS":
                    case 3:
                      message.schemes[i] = 3;
                      break;
                    case "WSS":
                    case 4:
                      message.schemes[i] = 4;
                      break;
                  }
              }
              if (object.consumes) {
                if (!Array.isArray(object.consumes))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.consumes: array expected"
                  );
                message.consumes = [];
                for (var i = 0; i < object.consumes.length; ++i)
                  message.consumes[i] = String(object.consumes[i]);
              }
              if (object.produces) {
                if (!Array.isArray(object.produces))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.produces: array expected"
                  );
                message.produces = [];
                for (var i = 0; i < object.produces.length; ++i)
                  message.produces[i] = String(object.produces[i]);
              }
              if (object.responses) {
                if (typeof object.responses !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.responses: object expected"
                  );
                message.responses = {};
                for (
                  var keys = Object.keys(object.responses), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.responses[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.responses: object expected"
                    );
                  message.responses[keys[i]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Response.fromObject(
                      object.responses[keys[i]]
                    );
                }
              }
              if (object.securityDefinitions != null) {
                if (typeof object.securityDefinitions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.securityDefinitions: object expected"
                  );
                message.securityDefinitions =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.fromObject(
                    object.securityDefinitions
                  );
              }
              if (object.security) {
                if (!Array.isArray(object.security))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.security: array expected"
                  );
                message.security = [];
                for (var i = 0; i < object.security.length; ++i) {
                  if (typeof object.security[i] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.security: object expected"
                    );
                  message.security[i] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.fromObject(
                      object.security[i]
                    );
                }
              }
              if (object.tags) {
                if (!Array.isArray(object.tags))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.tags: array expected"
                  );
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i) {
                  if (typeof object.tags[i] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.tags: object expected"
                    );
                  message.tags[i] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.fromObject(
                      object.tags[i]
                    );
                }
              }
              if (object.externalDocs != null) {
                if (typeof object.externalDocs !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.externalDocs: object expected"
                  );
                message.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.fromObject(
                    object.externalDocs
                  );
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Swagger.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a Swagger message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Swagger} message Swagger
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Swagger.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.arrays || options.defaults) {
                object.schemes = [];
                object.consumes = [];
                object.produces = [];
                object.security = [];
                object.tags = [];
              }
              if (options.objects || options.defaults) {
                object.responses = {};
                object.extensions = {};
              }
              if (options.defaults) {
                object.swagger = "";
                object.info = null;
                object.host = "";
                object.basePath = "";
                object.securityDefinitions = null;
                object.externalDocs = null;
              }
              if (message.swagger != null && message.hasOwnProperty("swagger"))
                object.swagger = message.swagger;
              if (message.info != null && message.hasOwnProperty("info"))
                object.info =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Info.toObject(
                    message.info,
                    options
                  );
              if (message.host != null && message.hasOwnProperty("host"))
                object.host = message.host;
              if (
                message.basePath != null &&
                message.hasOwnProperty("basePath")
              )
                object.basePath = message.basePath;
              if (message.schemes && message.schemes.length) {
                object.schemes = [];
                for (var j = 0; j < message.schemes.length; ++j)
                  object.schemes[j] =
                    options.enums === String
                      ? $root.grpc.gateway.protoc_gen_openapiv2.options.Scheme[
                          message.schemes[j]
                        ]
                      : message.schemes[j];
              }
              if (message.consumes && message.consumes.length) {
                object.consumes = [];
                for (var j = 0; j < message.consumes.length; ++j)
                  object.consumes[j] = message.consumes[j];
              }
              if (message.produces && message.produces.length) {
                object.produces = [];
                for (var j = 0; j < message.produces.length; ++j)
                  object.produces[j] = message.produces[j];
              }
              var keys2;
              if (
                message.responses &&
                (keys2 = Object.keys(message.responses)).length
              ) {
                object.responses = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.responses[keys2[j]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Response.toObject(
                      message.responses[keys2[j]],
                      options
                    );
              }
              if (
                message.securityDefinitions != null &&
                message.hasOwnProperty("securityDefinitions")
              )
                object.securityDefinitions =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.toObject(
                    message.securityDefinitions,
                    options
                  );
              if (message.security && message.security.length) {
                object.security = [];
                for (var j = 0; j < message.security.length; ++j)
                  object.security[j] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.toObject(
                      message.security[j],
                      options
                    );
              }
              if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                  object.tags[j] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.toObject(
                      message.tags[j],
                      options
                    );
              }
              if (
                message.externalDocs != null &&
                message.hasOwnProperty("externalDocs")
              )
                object.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.toObject(
                    message.externalDocs,
                    options
                  );
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this Swagger to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Swagger
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Swagger.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Swagger;
          })();

          options.Operation = (function () {
            /**
             * Properties of an Operation.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IOperation
             * @property {Array.<string>|null} [tags] Operation tags
             * @property {string|null} [summary] Operation summary
             * @property {string|null} [description] Operation description
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null} [externalDocs] Operation externalDocs
             * @property {string|null} [operationId] Operation operationId
             * @property {Array.<string>|null} [consumes] Operation consumes
             * @property {Array.<string>|null} [produces] Operation produces
             * @property {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IResponse>|null} [responses] Operation responses
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.Scheme>|null} [schemes] Operation schemes
             * @property {boolean|null} [deprecated] Operation deprecated
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement>|null} [security] Operation security
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] Operation extensions
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IParameters|null} [parameters] Operation parameters
             */

            /**
             * Constructs a new Operation.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents an Operation.
             * @implements IOperation
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IOperation=} [properties] Properties to set
             */
            function Operation(properties) {
              this.tags = [];
              this.consumes = [];
              this.produces = [];
              this.responses = {};
              this.schemes = [];
              this.security = [];
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Operation tags.
             * @member {Array.<string>} tags
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.tags = $util.emptyArray;

            /**
             * Operation summary.
             * @member {string} summary
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.summary = "";

            /**
             * Operation description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.description = "";

            /**
             * Operation externalDocs.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null|undefined} externalDocs
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.externalDocs = null;

            /**
             * Operation operationId.
             * @member {string} operationId
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.operationId = "";

            /**
             * Operation consumes.
             * @member {Array.<string>} consumes
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.consumes = $util.emptyArray;

            /**
             * Operation produces.
             * @member {Array.<string>} produces
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.produces = $util.emptyArray;

            /**
             * Operation responses.
             * @member {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IResponse>} responses
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.responses = $util.emptyObject;

            /**
             * Operation schemes.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.Scheme>} schemes
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.schemes = $util.emptyArray;

            /**
             * Operation deprecated.
             * @member {boolean} deprecated
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.deprecated = false;

            /**
             * Operation security.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement>} security
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.security = $util.emptyArray;

            /**
             * Operation extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.extensions = $util.emptyObject;

            /**
             * Operation parameters.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IParameters|null|undefined} parameters
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             */
            Operation.prototype.parameters = null;

            /**
             * Creates a new Operation instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IOperation=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Operation} Operation instance
             */
            Operation.create = function create(properties) {
              return new Operation(properties);
            };

            /**
             * Encodes the specified Operation message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Operation.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IOperation} message Operation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Operation.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (message.tags != null && message.tags.length)
                for (var i = 0; i < message.tags.length; ++i)
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(message.tags[i]);
              if (
                message.summary != null &&
                Object.hasOwnProperty.call(message, "summary")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.summary);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.description);
              if (
                message.externalDocs != null &&
                Object.hasOwnProperty.call(message, "externalDocs")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.encode(
                  message.externalDocs,
                  writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
                ).ldelim();
              if (
                message.operationId != null &&
                Object.hasOwnProperty.call(message, "operationId")
              )
                writer
                  .uint32(/* id 5, wireType 2 =*/ 42)
                  .string(message.operationId);
              if (message.consumes != null && message.consumes.length)
                for (var i = 0; i < message.consumes.length; ++i)
                  writer
                    .uint32(/* id 6, wireType 2 =*/ 50)
                    .string(message.consumes[i]);
              if (message.produces != null && message.produces.length)
                for (var i = 0; i < message.produces.length; ++i)
                  writer
                    .uint32(/* id 7, wireType 2 =*/ 58)
                    .string(message.produces[i]);
              if (
                message.responses != null &&
                Object.hasOwnProperty.call(message, "responses")
              )
                for (
                  var keys = Object.keys(message.responses), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 9, wireType 2 =*/ 74)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Response.encode(
                    message.responses[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              if (message.schemes != null && message.schemes.length) {
                writer.uint32(/* id 10, wireType 2 =*/ 82).fork();
                for (var i = 0; i < message.schemes.length; ++i)
                  writer.int32(message.schemes[i]);
                writer.ldelim();
              }
              if (
                message.deprecated != null &&
                Object.hasOwnProperty.call(message, "deprecated")
              )
                writer
                  .uint32(/* id 11, wireType 0 =*/ 88)
                  .bool(message.deprecated);
              if (message.security != null && message.security.length)
                for (var i = 0; i < message.security.length; ++i)
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.encode(
                    message.security[i],
                    writer.uint32(/* id 12, wireType 2 =*/ 98).fork()
                  ).ldelim();
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 13, wireType 2 =*/ 106)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              if (
                message.parameters != null &&
                Object.hasOwnProperty.call(message, "parameters")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters.encode(
                  message.parameters,
                  writer.uint32(/* id 14, wireType 2 =*/ 114).fork()
                ).ldelim();
              return writer;
            };

            /**
             * Decodes an Operation message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Operation} Operation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Operation.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Operation(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    if (!(message.tags && message.tags.length))
                      message.tags = [];
                    message.tags.push(reader.string());
                    break;
                  case 2:
                    message.summary = reader.string();
                    break;
                  case 3:
                    message.description = reader.string();
                    break;
                  case 4:
                    message.externalDocs =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 5:
                    message.operationId = reader.string();
                    break;
                  case 6:
                    if (!(message.consumes && message.consumes.length))
                      message.consumes = [];
                    message.consumes.push(reader.string());
                    break;
                  case 7:
                    if (!(message.produces && message.produces.length))
                      message.produces = [];
                    message.produces.push(reader.string());
                    break;
                  case 9:
                    reader.skip().pos++;
                    if (message.responses === $util.emptyObject)
                      message.responses = {};
                    key = reader.string();
                    reader.pos++;
                    message.responses[key] =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Response.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 10:
                    if (!(message.schemes && message.schemes.length))
                      message.schemes = [];
                    if ((tag & 7) === 2) {
                      var end2 = reader.uint32() + reader.pos;
                      while (reader.pos < end2)
                        message.schemes.push(reader.int32());
                    } else message.schemes.push(reader.int32());
                    break;
                  case 11:
                    message.deprecated = reader.bool();
                    break;
                  case 12:
                    if (!(message.security && message.security.length))
                      message.security = [];
                    message.security.push(
                      $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.decode(
                        reader,
                        reader.uint32()
                      )
                    );
                    break;
                  case 13:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 14:
                    message.parameters =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an Operation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Operation} Operation
             */
            Operation.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Operation
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Operation();
              if (object.tags) {
                if (!Array.isArray(object.tags))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.tags: array expected"
                  );
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                  message.tags[i] = String(object.tags[i]);
              }
              if (object.summary != null)
                message.summary = String(object.summary);
              if (object.description != null)
                message.description = String(object.description);
              if (object.externalDocs != null) {
                if (typeof object.externalDocs !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.externalDocs: object expected"
                  );
                message.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.fromObject(
                    object.externalDocs
                  );
              }
              if (object.operationId != null)
                message.operationId = String(object.operationId);
              if (object.consumes) {
                if (!Array.isArray(object.consumes))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.consumes: array expected"
                  );
                message.consumes = [];
                for (var i = 0; i < object.consumes.length; ++i)
                  message.consumes[i] = String(object.consumes[i]);
              }
              if (object.produces) {
                if (!Array.isArray(object.produces))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.produces: array expected"
                  );
                message.produces = [];
                for (var i = 0; i < object.produces.length; ++i)
                  message.produces[i] = String(object.produces[i]);
              }
              if (object.responses) {
                if (typeof object.responses !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.responses: object expected"
                  );
                message.responses = {};
                for (
                  var keys = Object.keys(object.responses), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.responses[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Operation.responses: object expected"
                    );
                  message.responses[keys[i]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Response.fromObject(
                      object.responses[keys[i]]
                    );
                }
              }
              if (object.schemes) {
                if (!Array.isArray(object.schemes))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.schemes: array expected"
                  );
                message.schemes = [];
                for (var i = 0; i < object.schemes.length; ++i)
                  switch (object.schemes[i]) {
                    default:
                    case "UNKNOWN":
                    case 0:
                      message.schemes[i] = 0;
                      break;
                    case "HTTP":
                    case 1:
                      message.schemes[i] = 1;
                      break;
                    case "HTTPS":
                    case 2:
                      message.schemes[i] = 2;
                      break;
                    case "WS":
                    case 3:
                      message.schemes[i] = 3;
                      break;
                    case "WSS":
                    case 4:
                      message.schemes[i] = 4;
                      break;
                  }
              }
              if (object.deprecated != null)
                message.deprecated = Boolean(object.deprecated);
              if (object.security) {
                if (!Array.isArray(object.security))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.security: array expected"
                  );
                message.security = [];
                for (var i = 0; i < object.security.length; ++i) {
                  if (typeof object.security[i] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Operation.security: object expected"
                    );
                  message.security[i] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.fromObject(
                      object.security[i]
                    );
                }
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Operation.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              if (object.parameters != null) {
                if (typeof object.parameters !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Operation.parameters: object expected"
                  );
                message.parameters =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters.fromObject(
                    object.parameters
                  );
              }
              return message;
            };

            /**
             * Creates a plain object from an Operation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Operation} message Operation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Operation.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.arrays || options.defaults) {
                object.tags = [];
                object.consumes = [];
                object.produces = [];
                object.schemes = [];
                object.security = [];
              }
              if (options.objects || options.defaults) {
                object.responses = {};
                object.extensions = {};
              }
              if (options.defaults) {
                object.summary = "";
                object.description = "";
                object.externalDocs = null;
                object.operationId = "";
                object.deprecated = false;
                object.parameters = null;
              }
              if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                  object.tags[j] = message.tags[j];
              }
              if (message.summary != null && message.hasOwnProperty("summary"))
                object.summary = message.summary;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (
                message.externalDocs != null &&
                message.hasOwnProperty("externalDocs")
              )
                object.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.toObject(
                    message.externalDocs,
                    options
                  );
              if (
                message.operationId != null &&
                message.hasOwnProperty("operationId")
              )
                object.operationId = message.operationId;
              if (message.consumes && message.consumes.length) {
                object.consumes = [];
                for (var j = 0; j < message.consumes.length; ++j)
                  object.consumes[j] = message.consumes[j];
              }
              if (message.produces && message.produces.length) {
                object.produces = [];
                for (var j = 0; j < message.produces.length; ++j)
                  object.produces[j] = message.produces[j];
              }
              var keys2;
              if (
                message.responses &&
                (keys2 = Object.keys(message.responses)).length
              ) {
                object.responses = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.responses[keys2[j]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Response.toObject(
                      message.responses[keys2[j]],
                      options
                    );
              }
              if (message.schemes && message.schemes.length) {
                object.schemes = [];
                for (var j = 0; j < message.schemes.length; ++j)
                  object.schemes[j] =
                    options.enums === String
                      ? $root.grpc.gateway.protoc_gen_openapiv2.options.Scheme[
                          message.schemes[j]
                        ]
                      : message.schemes[j];
              }
              if (
                message.deprecated != null &&
                message.hasOwnProperty("deprecated")
              )
                object.deprecated = message.deprecated;
              if (message.security && message.security.length) {
                object.security = [];
                for (var j = 0; j < message.security.length; ++j)
                  object.security[j] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.toObject(
                      message.security[j],
                      options
                    );
              }
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              if (
                message.parameters != null &&
                message.hasOwnProperty("parameters")
              )
                object.parameters =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters.toObject(
                    message.parameters,
                    options
                  );
              return object;
            };

            /**
             * Converts this Operation to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Operation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Operation.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Operation;
          })();

          options.Parameters = (function () {
            /**
             * Properties of a Parameters.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IParameters
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.IHeaderParameter>|null} [headers] Parameters headers
             */

            /**
             * Constructs a new Parameters.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Parameters.
             * @implements IParameters
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IParameters=} [properties] Properties to set
             */
            function Parameters(properties) {
              this.headers = [];
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Parameters headers.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.IHeaderParameter>} headers
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @instance
             */
            Parameters.prototype.headers = $util.emptyArray;

            /**
             * Creates a new Parameters instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IParameters=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Parameters} Parameters instance
             */
            Parameters.create = function create(properties) {
              return new Parameters(properties);
            };

            /**
             * Encodes the specified Parameters message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Parameters.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IParameters} message Parameters message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Parameters.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (message.headers != null && message.headers.length)
                for (var i = 0; i < message.headers.length; ++i)
                  $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.encode(
                    message.headers[i],
                    writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                  ).ldelim();
              return writer;
            };

            /**
             * Decodes a Parameters message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Parameters} Parameters
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Parameters.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    if (!(message.headers && message.headers.length))
                      message.headers = [];
                    message.headers.push(
                      $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.decode(
                        reader,
                        reader.uint32()
                      )
                    );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Parameters message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Parameters} Parameters
             */
            Parameters.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Parameters();
              if (object.headers) {
                if (!Array.isArray(object.headers))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Parameters.headers: array expected"
                  );
                message.headers = [];
                for (var i = 0; i < object.headers.length; ++i) {
                  if (typeof object.headers[i] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Parameters.headers: object expected"
                    );
                  message.headers[i] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.fromObject(
                      object.headers[i]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a Parameters message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Parameters} message Parameters
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Parameters.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.arrays || options.defaults) object.headers = [];
              if (message.headers && message.headers.length) {
                object.headers = [];
                for (var j = 0; j < message.headers.length; ++j)
                  object.headers[j] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.toObject(
                      message.headers[j],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this Parameters to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Parameters
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Parameters.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Parameters;
          })();

          options.HeaderParameter = (function () {
            /**
             * Properties of a HeaderParameter.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IHeaderParameter
             * @property {string|null} [name] HeaderParameter name
             * @property {string|null} [description] HeaderParameter description
             * @property {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.Type|null} [type] HeaderParameter type
             * @property {string|null} [format] HeaderParameter format
             * @property {boolean|null} [required] HeaderParameter required
             */

            /**
             * Constructs a new HeaderParameter.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a HeaderParameter.
             * @implements IHeaderParameter
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeaderParameter=} [properties] Properties to set
             */
            function HeaderParameter(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * HeaderParameter name.
             * @member {string} name
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             */
            HeaderParameter.prototype.name = "";

            /**
             * HeaderParameter description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             */
            HeaderParameter.prototype.description = "";

            /**
             * HeaderParameter type.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.Type} type
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             */
            HeaderParameter.prototype.type = 0;

            /**
             * HeaderParameter format.
             * @member {string} format
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             */
            HeaderParameter.prototype.format = "";

            /**
             * HeaderParameter required.
             * @member {boolean} required
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             */
            HeaderParameter.prototype.required = false;

            /**
             * Creates a new HeaderParameter instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeaderParameter=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter} HeaderParameter instance
             */
            HeaderParameter.create = function create(properties) {
              return new HeaderParameter(properties);
            };

            /**
             * Encodes the specified HeaderParameter message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeaderParameter} message HeaderParameter message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HeaderParameter.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.description);
              if (
                message.type != null &&
                Object.hasOwnProperty.call(message, "type")
              )
                writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.type);
              if (
                message.format != null &&
                Object.hasOwnProperty.call(message, "format")
              )
                writer
                  .uint32(/* id 4, wireType 2 =*/ 34)
                  .string(message.format);
              if (
                message.required != null &&
                Object.hasOwnProperty.call(message, "required")
              )
                writer
                  .uint32(/* id 5, wireType 0 =*/ 40)
                  .bool(message.required);
              return writer;
            };

            /**
             * Decodes a HeaderParameter message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter} HeaderParameter
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HeaderParameter.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.name = reader.string();
                    break;
                  case 2:
                    message.description = reader.string();
                    break;
                  case 3:
                    message.type = reader.int32();
                    break;
                  case 4:
                    message.format = reader.string();
                    break;
                  case 5:
                    message.required = reader.bool();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a HeaderParameter message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter} HeaderParameter
             */
            HeaderParameter.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter();
              if (object.name != null) message.name = String(object.name);
              if (object.description != null)
                message.description = String(object.description);
              switch (object.type) {
                case "UNKNOWN":
                case 0:
                  message.type = 0;
                  break;
                case "STRING":
                case 1:
                  message.type = 1;
                  break;
                case "NUMBER":
                case 2:
                  message.type = 2;
                  break;
                case "INTEGER":
                case 3:
                  message.type = 3;
                  break;
                case "BOOLEAN":
                case 4:
                  message.type = 4;
                  break;
              }
              if (object.format != null) message.format = String(object.format);
              if (object.required != null)
                message.required = Boolean(object.required);
              return message;
            };

            /**
             * Creates a plain object from a HeaderParameter message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter} message HeaderParameter
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HeaderParameter.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.name = "";
                object.description = "";
                object.type = options.enums === String ? "UNKNOWN" : 0;
                object.format = "";
                object.required = false;
              }
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (message.type != null && message.hasOwnProperty("type"))
                object.type =
                  options.enums === String
                    ? $root.grpc.gateway.protoc_gen_openapiv2.options
                        .HeaderParameter.Type[message.type]
                    : message.type;
              if (message.format != null && message.hasOwnProperty("format"))
                object.format = message.format;
              if (
                message.required != null &&
                message.hasOwnProperty("required")
              )
                object.required = message.required;
              return object;
            };

            /**
             * Converts this HeaderParameter to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HeaderParameter.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            /**
             * Type enum.
             * @name grpc.gateway.protoc_gen_openapiv2.options.HeaderParameter.Type
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} STRING=1 STRING value
             * @property {number} NUMBER=2 NUMBER value
             * @property {number} INTEGER=3 INTEGER value
             * @property {number} BOOLEAN=4 BOOLEAN value
             */
            HeaderParameter.Type = (function () {
              var valuesById = {},
                values = Object.create(valuesById);
              values[(valuesById[0] = "UNKNOWN")] = 0;
              values[(valuesById[1] = "STRING")] = 1;
              values[(valuesById[2] = "NUMBER")] = 2;
              values[(valuesById[3] = "INTEGER")] = 3;
              values[(valuesById[4] = "BOOLEAN")] = 4;
              return values;
            })();

            return HeaderParameter;
          })();

          options.Header = (function () {
            /**
             * Properties of a Header.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IHeader
             * @property {string|null} [description] Header description
             * @property {string|null} [type] Header type
             * @property {string|null} [format] Header format
             * @property {string|null} ["default"] Header default
             * @property {string|null} [pattern] Header pattern
             */

            /**
             * Constructs a new Header.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Header.
             * @implements IHeader
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeader=} [properties] Properties to set
             */
            function Header(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Header description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             */
            Header.prototype.description = "";

            /**
             * Header type.
             * @member {string} type
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             */
            Header.prototype.type = "";

            /**
             * Header format.
             * @member {string} format
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             */
            Header.prototype.format = "";

            /**
             * Header default.
             * @member {string} default
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             */
            Header.prototype["default"] = "";

            /**
             * Header pattern.
             * @member {string} pattern
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             */
            Header.prototype.pattern = "";

            /**
             * Creates a new Header instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeader=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Header} Header instance
             */
            Header.create = function create(properties) {
              return new Header(properties);
            };

            /**
             * Encodes the specified Header message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Header.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IHeader} message Header message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Header.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.description);
              if (
                message.type != null &&
                Object.hasOwnProperty.call(message, "type")
              )
                writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.type);
              if (
                message.format != null &&
                Object.hasOwnProperty.call(message, "format")
              )
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.format);
              if (
                message["default"] != null &&
                Object.hasOwnProperty.call(message, "default")
              )
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message["default"]);
              if (
                message.pattern != null &&
                Object.hasOwnProperty.call(message, "pattern")
              )
                writer
                  .uint32(/* id 13, wireType 2 =*/ 106)
                  .string(message.pattern);
              return writer;
            };

            /**
             * Decodes a Header message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Header} Header
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Header.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Header();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.description = reader.string();
                    break;
                  case 2:
                    message.type = reader.string();
                    break;
                  case 3:
                    message.format = reader.string();
                    break;
                  case 6:
                    message["default"] = reader.string();
                    break;
                  case 13:
                    message.pattern = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Header message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Header} Header
             */
            Header.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Header
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Header();
              if (object.description != null)
                message.description = String(object.description);
              if (object.type != null) message.type = String(object.type);
              if (object.format != null) message.format = String(object.format);
              if (object["default"] != null)
                message["default"] = String(object["default"]);
              if (object.pattern != null)
                message.pattern = String(object.pattern);
              return message;
            };

            /**
             * Creates a plain object from a Header message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Header} message Header
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Header.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.description = "";
                object.type = "";
                object.format = "";
                object["default"] = "";
                object.pattern = "";
              }
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
              if (message.format != null && message.hasOwnProperty("format"))
                object.format = message.format;
              if (
                message["default"] != null &&
                message.hasOwnProperty("default")
              )
                object["default"] = message["default"];
              if (message.pattern != null && message.hasOwnProperty("pattern"))
                object.pattern = message.pattern;
              return object;
            };

            /**
             * Converts this Header to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Header
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Header.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Header;
          })();

          options.Response = (function () {
            /**
             * Properties of a Response.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IResponse
             * @property {string|null} [description] Response description
             * @property {grpc.gateway.protoc_gen_openapiv2.options.ISchema|null} [schema] Response schema
             * @property {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IHeader>|null} [headers] Response headers
             * @property {Object.<string,string>|null} [examples] Response examples
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] Response extensions
             */

            /**
             * Constructs a new Response.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
              this.headers = {};
              this.examples = {};
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             */
            Response.prototype.description = "";

            /**
             * Response schema.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.ISchema|null|undefined} schema
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             */
            Response.prototype.schema = null;

            /**
             * Response headers.
             * @member {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.IHeader>} headers
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             */
            Response.prototype.headers = $util.emptyObject;

            /**
             * Response examples.
             * @member {Object.<string,string>} examples
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             */
            Response.prototype.examples = $util.emptyObject;

            /**
             * Response extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             */
            Response.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IResponse=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Response} Response instance
             */
            Response.create = function create(properties) {
              return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Response.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.description);
              if (
                message.schema != null &&
                Object.hasOwnProperty.call(message, "schema")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.encode(
                  message.schema,
                  writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                ).ldelim();
              if (
                message.headers != null &&
                Object.hasOwnProperty.call(message, "headers")
              )
                for (
                  var keys = Object.keys(message.headers), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 3, wireType 2 =*/ 26)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Header.encode(
                    message.headers[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              if (
                message.examples != null &&
                Object.hasOwnProperty.call(message, "examples")
              )
                for (
                  var keys = Object.keys(message.examples), i = 0;
                  i < keys.length;
                  ++i
                )
                  writer
                    .uint32(/* id 4, wireType 2 =*/ 34)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i])
                    .uint32(/* id 2, wireType 2 =*/ 18)
                    .string(message.examples[keys[i]])
                    .ldelim();
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 5, wireType 2 =*/ 42)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Response(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.description = reader.string();
                    break;
                  case 2:
                    message.schema =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 3:
                    reader.skip().pos++;
                    if (message.headers === $util.emptyObject)
                      message.headers = {};
                    key = reader.string();
                    reader.pos++;
                    message.headers[key] =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Header.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 4:
                    reader.skip().pos++;
                    if (message.examples === $util.emptyObject)
                      message.examples = {};
                    key = reader.string();
                    reader.pos++;
                    message.examples[key] = reader.string();
                    break;
                  case 5:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Response} Response
             */
            Response.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Response
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Response();
              if (object.description != null)
                message.description = String(object.description);
              if (object.schema != null) {
                if (typeof object.schema !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Response.schema: object expected"
                  );
                message.schema =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.fromObject(
                    object.schema
                  );
              }
              if (object.headers) {
                if (typeof object.headers !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Response.headers: object expected"
                  );
                message.headers = {};
                for (
                  var keys = Object.keys(object.headers), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.headers[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Response.headers: object expected"
                    );
                  message.headers[keys[i]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Header.fromObject(
                      object.headers[keys[i]]
                    );
                }
              }
              if (object.examples) {
                if (typeof object.examples !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Response.examples: object expected"
                  );
                message.examples = {};
                for (
                  var keys = Object.keys(object.examples), i = 0;
                  i < keys.length;
                  ++i
                )
                  message.examples[keys[i]] = String(object.examples[keys[i]]);
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Response.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Response.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) {
                object.headers = {};
                object.examples = {};
                object.extensions = {};
              }
              if (options.defaults) {
                object.description = "";
                object.schema = null;
              }
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (message.schema != null && message.hasOwnProperty("schema"))
                object.schema =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.toObject(
                    message.schema,
                    options
                  );
              var keys2;
              if (
                message.headers &&
                (keys2 = Object.keys(message.headers)).length
              ) {
                object.headers = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.headers[keys2[j]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.Header.toObject(
                      message.headers[keys2[j]],
                      options
                    );
              }
              if (
                message.examples &&
                (keys2 = Object.keys(message.examples)).length
              ) {
                object.examples = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.examples[keys2[j]] = message.examples[keys2[j]];
              }
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Response;
          })();

          options.Info = (function () {
            /**
             * Properties of an Info.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IInfo
             * @property {string|null} [title] Info title
             * @property {string|null} [description] Info description
             * @property {string|null} [termsOfService] Info termsOfService
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IContact|null} [contact] Info contact
             * @property {grpc.gateway.protoc_gen_openapiv2.options.ILicense|null} [license] Info license
             * @property {string|null} [version] Info version
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] Info extensions
             */

            /**
             * Constructs a new Info.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents an Info.
             * @implements IInfo
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IInfo=} [properties] Properties to set
             */
            function Info(properties) {
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Info title.
             * @member {string} title
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.title = "";

            /**
             * Info description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.description = "";

            /**
             * Info termsOfService.
             * @member {string} termsOfService
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.termsOfService = "";

            /**
             * Info contact.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IContact|null|undefined} contact
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.contact = null;

            /**
             * Info license.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.ILicense|null|undefined} license
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.license = null;

            /**
             * Info version.
             * @member {string} version
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.version = "";

            /**
             * Info extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             */
            Info.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new Info instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IInfo=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Info} Info instance
             */
            Info.create = function create(properties) {
              return new Info(properties);
            };

            /**
             * Encodes the specified Info message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Info.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IInfo} message Info message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Info.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.title != null &&
                Object.hasOwnProperty.call(message, "title")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.title);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.description);
              if (
                message.termsOfService != null &&
                Object.hasOwnProperty.call(message, "termsOfService")
              )
                writer
                  .uint32(/* id 3, wireType 2 =*/ 26)
                  .string(message.termsOfService);
              if (
                message.contact != null &&
                Object.hasOwnProperty.call(message, "contact")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.Contact.encode(
                  message.contact,
                  writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
                ).ldelim();
              if (
                message.license != null &&
                Object.hasOwnProperty.call(message, "license")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.License.encode(
                  message.license,
                  writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
                ).ldelim();
              if (
                message.version != null &&
                Object.hasOwnProperty.call(message, "version")
              )
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.version);
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 7, wireType 2 =*/ 58)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes an Info message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Info} Info
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Info.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Info(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.title = reader.string();
                    break;
                  case 2:
                    message.description = reader.string();
                    break;
                  case 3:
                    message.termsOfService = reader.string();
                    break;
                  case 4:
                    message.contact =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Contact.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 5:
                    message.license =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.License.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 6:
                    message.version = reader.string();
                    break;
                  case 7:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an Info message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Info} Info
             */
            Info.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Info
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Info();
              if (object.title != null) message.title = String(object.title);
              if (object.description != null)
                message.description = String(object.description);
              if (object.termsOfService != null)
                message.termsOfService = String(object.termsOfService);
              if (object.contact != null) {
                if (typeof object.contact !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Info.contact: object expected"
                  );
                message.contact =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Contact.fromObject(
                    object.contact
                  );
              }
              if (object.license != null) {
                if (typeof object.license !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Info.license: object expected"
                  );
                message.license =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.License.fromObject(
                    object.license
                  );
              }
              if (object.version != null)
                message.version = String(object.version);
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Info.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Info.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from an Info message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Info} message Info
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Info.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) object.extensions = {};
              if (options.defaults) {
                object.title = "";
                object.description = "";
                object.termsOfService = "";
                object.contact = null;
                object.license = null;
                object.version = "";
              }
              if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (
                message.termsOfService != null &&
                message.hasOwnProperty("termsOfService")
              )
                object.termsOfService = message.termsOfService;
              if (message.contact != null && message.hasOwnProperty("contact"))
                object.contact =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Contact.toObject(
                    message.contact,
                    options
                  );
              if (message.license != null && message.hasOwnProperty("license"))
                object.license =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.License.toObject(
                    message.license,
                    options
                  );
              if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
              var keys2;
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this Info to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Info
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Info.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Info;
          })();

          options.Contact = (function () {
            /**
             * Properties of a Contact.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IContact
             * @property {string|null} [name] Contact name
             * @property {string|null} [url] Contact url
             * @property {string|null} [email] Contact email
             */

            /**
             * Constructs a new Contact.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Contact.
             * @implements IContact
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IContact=} [properties] Properties to set
             */
            function Contact(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Contact name.
             * @member {string} name
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @instance
             */
            Contact.prototype.name = "";

            /**
             * Contact url.
             * @member {string} url
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @instance
             */
            Contact.prototype.url = "";

            /**
             * Contact email.
             * @member {string} email
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @instance
             */
            Contact.prototype.email = "";

            /**
             * Creates a new Contact instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IContact=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Contact} Contact instance
             */
            Contact.create = function create(properties) {
              return new Contact(properties);
            };

            /**
             * Encodes the specified Contact message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Contact.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IContact} message Contact message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Contact.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
              if (
                message.url != null &&
                Object.hasOwnProperty.call(message, "url")
              )
                writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
              if (
                message.email != null &&
                Object.hasOwnProperty.call(message, "email")
              )
                writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.email);
              return writer;
            };

            /**
             * Decodes a Contact message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Contact} Contact
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Contact.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Contact();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.name = reader.string();
                    break;
                  case 2:
                    message.url = reader.string();
                    break;
                  case 3:
                    message.email = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Contact message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Contact} Contact
             */
            Contact.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Contact
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Contact();
              if (object.name != null) message.name = String(object.name);
              if (object.url != null) message.url = String(object.url);
              if (object.email != null) message.email = String(object.email);
              return message;
            };

            /**
             * Creates a plain object from a Contact message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Contact} message Contact
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Contact.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.name = "";
                object.url = "";
                object.email = "";
              }
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
              if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
              return object;
            };

            /**
             * Converts this Contact to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Contact
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Contact.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Contact;
          })();

          options.License = (function () {
            /**
             * Properties of a License.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ILicense
             * @property {string|null} [name] License name
             * @property {string|null} [url] License url
             */

            /**
             * Constructs a new License.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a License.
             * @implements ILicense
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ILicense=} [properties] Properties to set
             */
            function License(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * License name.
             * @member {string} name
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @instance
             */
            License.prototype.name = "";

            /**
             * License url.
             * @member {string} url
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @instance
             */
            License.prototype.url = "";

            /**
             * Creates a new License instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ILicense=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.License} License instance
             */
            License.create = function create(properties) {
              return new License(properties);
            };

            /**
             * Encodes the specified License message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.License.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ILicense} message License message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            License.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
              if (
                message.url != null &&
                Object.hasOwnProperty.call(message, "url")
              )
                writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
              return writer;
            };

            /**
             * Decodes a License message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.License} License
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            License.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.License();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.name = reader.string();
                    break;
                  case 2:
                    message.url = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a License message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.License} License
             */
            License.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.License
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.License();
              if (object.name != null) message.name = String(object.name);
              if (object.url != null) message.url = String(object.url);
              return message;
            };

            /**
             * Creates a plain object from a License message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.License} message License
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            License.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.name = "";
                object.url = "";
              }
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
              return object;
            };

            /**
             * Converts this License to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.License
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            License.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return License;
          })();

          options.ExternalDocumentation = (function () {
            /**
             * Properties of an ExternalDocumentation.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IExternalDocumentation
             * @property {string|null} [description] ExternalDocumentation description
             * @property {string|null} [url] ExternalDocumentation url
             */

            /**
             * Constructs a new ExternalDocumentation.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents an ExternalDocumentation.
             * @implements IExternalDocumentation
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation=} [properties] Properties to set
             */
            function ExternalDocumentation(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * ExternalDocumentation description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @instance
             */
            ExternalDocumentation.prototype.description = "";

            /**
             * ExternalDocumentation url.
             * @member {string} url
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @instance
             */
            ExternalDocumentation.prototype.url = "";

            /**
             * Creates a new ExternalDocumentation instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation} ExternalDocumentation instance
             */
            ExternalDocumentation.create = function create(properties) {
              return new ExternalDocumentation(properties);
            };

            /**
             * Encodes the specified ExternalDocumentation message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation} message ExternalDocumentation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ExternalDocumentation.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 1, wireType 2 =*/ 10)
                  .string(message.description);
              if (
                message.url != null &&
                Object.hasOwnProperty.call(message, "url")
              )
                writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
              return writer;
            };

            /**
             * Decodes an ExternalDocumentation message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation} ExternalDocumentation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ExternalDocumentation.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.description = reader.string();
                    break;
                  case 2:
                    message.url = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates an ExternalDocumentation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation} ExternalDocumentation
             */
            ExternalDocumentation.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options
                  .ExternalDocumentation
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation();
              if (object.description != null)
                message.description = String(object.description);
              if (object.url != null) message.url = String(object.url);
              return message;
            };

            /**
             * Creates a plain object from an ExternalDocumentation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation} message ExternalDocumentation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ExternalDocumentation.toObject = function toObject(
              message,
              options
            ) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.description = "";
                object.url = "";
              }
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
              return object;
            };

            /**
             * Converts this ExternalDocumentation to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ExternalDocumentation.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return ExternalDocumentation;
          })();

          options.Schema = (function () {
            /**
             * Properties of a Schema.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ISchema
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema|null} [jsonSchema] Schema jsonSchema
             * @property {string|null} [discriminator] Schema discriminator
             * @property {boolean|null} [readOnly] Schema readOnly
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null} [externalDocs] Schema externalDocs
             * @property {string|null} [example] Schema example
             */

            /**
             * Constructs a new Schema.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Schema.
             * @implements ISchema
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISchema=} [properties] Properties to set
             */
            function Schema(properties) {
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Schema jsonSchema.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema|null|undefined} jsonSchema
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             */
            Schema.prototype.jsonSchema = null;

            /**
             * Schema discriminator.
             * @member {string} discriminator
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             */
            Schema.prototype.discriminator = "";

            /**
             * Schema readOnly.
             * @member {boolean} readOnly
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             */
            Schema.prototype.readOnly = false;

            /**
             * Schema externalDocs.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null|undefined} externalDocs
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             */
            Schema.prototype.externalDocs = null;

            /**
             * Schema example.
             * @member {string} example
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             */
            Schema.prototype.example = "";

            /**
             * Creates a new Schema instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISchema=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Schema} Schema instance
             */
            Schema.create = function create(properties) {
              return new Schema(properties);
            };

            /**
             * Encodes the specified Schema message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Schema.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISchema} message Schema message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Schema.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.jsonSchema != null &&
                Object.hasOwnProperty.call(message, "jsonSchema")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.encode(
                  message.jsonSchema,
                  writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
                ).ldelim();
              if (
                message.discriminator != null &&
                Object.hasOwnProperty.call(message, "discriminator")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.discriminator);
              if (
                message.readOnly != null &&
                Object.hasOwnProperty.call(message, "readOnly")
              )
                writer
                  .uint32(/* id 3, wireType 0 =*/ 24)
                  .bool(message.readOnly);
              if (
                message.externalDocs != null &&
                Object.hasOwnProperty.call(message, "externalDocs")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.encode(
                  message.externalDocs,
                  writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
                ).ldelim();
              if (
                message.example != null &&
                Object.hasOwnProperty.call(message, "example")
              )
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.example);
              return writer;
            };

            /**
             * Decodes a Schema message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Schema} Schema
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Schema.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Schema();
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.jsonSchema =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 2:
                    message.discriminator = reader.string();
                    break;
                  case 3:
                    message.readOnly = reader.bool();
                    break;
                  case 5:
                    message.externalDocs =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 6:
                    message.example = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Schema message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Schema} Schema
             */
            Schema.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Schema
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Schema();
              if (object.jsonSchema != null) {
                if (typeof object.jsonSchema !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Schema.jsonSchema: object expected"
                  );
                message.jsonSchema =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.fromObject(
                    object.jsonSchema
                  );
              }
              if (object.discriminator != null)
                message.discriminator = String(object.discriminator);
              if (object.readOnly != null)
                message.readOnly = Boolean(object.readOnly);
              if (object.externalDocs != null) {
                if (typeof object.externalDocs !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Schema.externalDocs: object expected"
                  );
                message.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.fromObject(
                    object.externalDocs
                  );
              }
              if (object.example != null)
                message.example = String(object.example);
              return message;
            };

            /**
             * Creates a plain object from a Schema message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Schema} message Schema
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Schema.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.defaults) {
                object.jsonSchema = null;
                object.discriminator = "";
                object.readOnly = false;
                object.externalDocs = null;
                object.example = "";
              }
              if (
                message.jsonSchema != null &&
                message.hasOwnProperty("jsonSchema")
              )
                object.jsonSchema =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.toObject(
                    message.jsonSchema,
                    options
                  );
              if (
                message.discriminator != null &&
                message.hasOwnProperty("discriminator")
              )
                object.discriminator = message.discriminator;
              if (
                message.readOnly != null &&
                message.hasOwnProperty("readOnly")
              )
                object.readOnly = message.readOnly;
              if (
                message.externalDocs != null &&
                message.hasOwnProperty("externalDocs")
              )
                object.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.toObject(
                    message.externalDocs,
                    options
                  );
              if (message.example != null && message.hasOwnProperty("example"))
                object.example = message.example;
              return object;
            };

            /**
             * Converts this Schema to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Schema
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Schema.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Schema;
          })();

          options.JSONSchema = (function () {
            /**
             * Properties of a JSONSchema.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IJSONSchema
             * @property {string|null} [ref] JSONSchema ref
             * @property {string|null} [title] JSONSchema title
             * @property {string|null} [description] JSONSchema description
             * @property {string|null} ["default"] JSONSchema default
             * @property {boolean|null} [readOnly] JSONSchema readOnly
             * @property {string|null} [example] JSONSchema example
             * @property {number|null} [multipleOf] JSONSchema multipleOf
             * @property {number|null} [maximum] JSONSchema maximum
             * @property {boolean|null} [exclusiveMaximum] JSONSchema exclusiveMaximum
             * @property {number|null} [minimum] JSONSchema minimum
             * @property {boolean|null} [exclusiveMinimum] JSONSchema exclusiveMinimum
             * @property {number|Long|null} [maxLength] JSONSchema maxLength
             * @property {number|Long|null} [minLength] JSONSchema minLength
             * @property {string|null} [pattern] JSONSchema pattern
             * @property {number|Long|null} [maxItems] JSONSchema maxItems
             * @property {number|Long|null} [minItems] JSONSchema minItems
             * @property {boolean|null} [uniqueItems] JSONSchema uniqueItems
             * @property {number|Long|null} [maxProperties] JSONSchema maxProperties
             * @property {number|Long|null} [minProperties] JSONSchema minProperties
             * @property {Array.<string>|null} [required] JSONSchema required
             * @property {Array.<string>|null} [array] JSONSchema array
             * @property {Array.<grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.JSONSchemaSimpleTypes>|null} [type] JSONSchema type
             * @property {string|null} [format] JSONSchema format
             * @property {Array.<string>|null} ["enum"] JSONSchema enum
             * @property {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.IFieldConfiguration|null} [fieldConfiguration] JSONSchema fieldConfiguration
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] JSONSchema extensions
             */

            /**
             * Constructs a new JSONSchema.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a JSONSchema.
             * @implements IJSONSchema
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema=} [properties] Properties to set
             */
            function JSONSchema(properties) {
              this.required = [];
              this.array = [];
              this.type = [];
              this["enum"] = [];
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * JSONSchema ref.
             * @member {string} ref
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.ref = "";

            /**
             * JSONSchema title.
             * @member {string} title
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.title = "";

            /**
             * JSONSchema description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.description = "";

            /**
             * JSONSchema default.
             * @member {string} default
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype["default"] = "";

            /**
             * JSONSchema readOnly.
             * @member {boolean} readOnly
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.readOnly = false;

            /**
             * JSONSchema example.
             * @member {string} example
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.example = "";

            /**
             * JSONSchema multipleOf.
             * @member {number} multipleOf
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.multipleOf = 0;

            /**
             * JSONSchema maximum.
             * @member {number} maximum
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.maximum = 0;

            /**
             * JSONSchema exclusiveMaximum.
             * @member {boolean} exclusiveMaximum
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.exclusiveMaximum = false;

            /**
             * JSONSchema minimum.
             * @member {number} minimum
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.minimum = 0;

            /**
             * JSONSchema exclusiveMinimum.
             * @member {boolean} exclusiveMinimum
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.exclusiveMinimum = false;

            /**
             * JSONSchema maxLength.
             * @member {number|Long} maxLength
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.maxLength = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema minLength.
             * @member {number|Long} minLength
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.minLength = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema pattern.
             * @member {string} pattern
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.pattern = "";

            /**
             * JSONSchema maxItems.
             * @member {number|Long} maxItems
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.maxItems = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema minItems.
             * @member {number|Long} minItems
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.minItems = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema uniqueItems.
             * @member {boolean} uniqueItems
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.uniqueItems = false;

            /**
             * JSONSchema maxProperties.
             * @member {number|Long} maxProperties
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.maxProperties = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema minProperties.
             * @member {number|Long} minProperties
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.minProperties = $util.Long
              ? $util.Long.fromBits(0, 0, true)
              : 0;

            /**
             * JSONSchema required.
             * @member {Array.<string>} required
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.required = $util.emptyArray;

            /**
             * JSONSchema array.
             * @member {Array.<string>} array
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.array = $util.emptyArray;

            /**
             * JSONSchema type.
             * @member {Array.<grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.JSONSchemaSimpleTypes>} type
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.type = $util.emptyArray;

            /**
             * JSONSchema format.
             * @member {string} format
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.format = "";

            /**
             * JSONSchema enum.
             * @member {Array.<string>} enum
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype["enum"] = $util.emptyArray;

            /**
             * JSONSchema fieldConfiguration.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.IFieldConfiguration|null|undefined} fieldConfiguration
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.fieldConfiguration = null;

            /**
             * JSONSchema extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             */
            JSONSchema.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new JSONSchema instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema} JSONSchema instance
             */
            JSONSchema.create = function create(properties) {
              return new JSONSchema(properties);
            };

            /**
             * Encodes the specified JSONSchema message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema} message JSONSchema message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            JSONSchema.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.ref != null &&
                Object.hasOwnProperty.call(message, "ref")
              )
                writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.ref);
              if (
                message.title != null &&
                Object.hasOwnProperty.call(message, "title")
              )
                writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.title);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.description);
              if (
                message["default"] != null &&
                Object.hasOwnProperty.call(message, "default")
              )
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message["default"]);
              if (
                message.readOnly != null &&
                Object.hasOwnProperty.call(message, "readOnly")
              )
                writer
                  .uint32(/* id 8, wireType 0 =*/ 64)
                  .bool(message.readOnly);
              if (
                message.example != null &&
                Object.hasOwnProperty.call(message, "example")
              )
                writer
                  .uint32(/* id 9, wireType 2 =*/ 74)
                  .string(message.example);
              if (
                message.multipleOf != null &&
                Object.hasOwnProperty.call(message, "multipleOf")
              )
                writer
                  .uint32(/* id 10, wireType 1 =*/ 81)
                  .double(message.multipleOf);
              if (
                message.maximum != null &&
                Object.hasOwnProperty.call(message, "maximum")
              )
                writer
                  .uint32(/* id 11, wireType 1 =*/ 89)
                  .double(message.maximum);
              if (
                message.exclusiveMaximum != null &&
                Object.hasOwnProperty.call(message, "exclusiveMaximum")
              )
                writer
                  .uint32(/* id 12, wireType 0 =*/ 96)
                  .bool(message.exclusiveMaximum);
              if (
                message.minimum != null &&
                Object.hasOwnProperty.call(message, "minimum")
              )
                writer
                  .uint32(/* id 13, wireType 1 =*/ 105)
                  .double(message.minimum);
              if (
                message.exclusiveMinimum != null &&
                Object.hasOwnProperty.call(message, "exclusiveMinimum")
              )
                writer
                  .uint32(/* id 14, wireType 0 =*/ 112)
                  .bool(message.exclusiveMinimum);
              if (
                message.maxLength != null &&
                Object.hasOwnProperty.call(message, "maxLength")
              )
                writer
                  .uint32(/* id 15, wireType 0 =*/ 120)
                  .uint64(message.maxLength);
              if (
                message.minLength != null &&
                Object.hasOwnProperty.call(message, "minLength")
              )
                writer
                  .uint32(/* id 16, wireType 0 =*/ 128)
                  .uint64(message.minLength);
              if (
                message.pattern != null &&
                Object.hasOwnProperty.call(message, "pattern")
              )
                writer
                  .uint32(/* id 17, wireType 2 =*/ 138)
                  .string(message.pattern);
              if (
                message.maxItems != null &&
                Object.hasOwnProperty.call(message, "maxItems")
              )
                writer
                  .uint32(/* id 20, wireType 0 =*/ 160)
                  .uint64(message.maxItems);
              if (
                message.minItems != null &&
                Object.hasOwnProperty.call(message, "minItems")
              )
                writer
                  .uint32(/* id 21, wireType 0 =*/ 168)
                  .uint64(message.minItems);
              if (
                message.uniqueItems != null &&
                Object.hasOwnProperty.call(message, "uniqueItems")
              )
                writer
                  .uint32(/* id 22, wireType 0 =*/ 176)
                  .bool(message.uniqueItems);
              if (
                message.maxProperties != null &&
                Object.hasOwnProperty.call(message, "maxProperties")
              )
                writer
                  .uint32(/* id 24, wireType 0 =*/ 192)
                  .uint64(message.maxProperties);
              if (
                message.minProperties != null &&
                Object.hasOwnProperty.call(message, "minProperties")
              )
                writer
                  .uint32(/* id 25, wireType 0 =*/ 200)
                  .uint64(message.minProperties);
              if (message.required != null && message.required.length)
                for (var i = 0; i < message.required.length; ++i)
                  writer
                    .uint32(/* id 26, wireType 2 =*/ 210)
                    .string(message.required[i]);
              if (message.array != null && message.array.length)
                for (var i = 0; i < message.array.length; ++i)
                  writer
                    .uint32(/* id 34, wireType 2 =*/ 274)
                    .string(message.array[i]);
              if (message.type != null && message.type.length) {
                writer.uint32(/* id 35, wireType 2 =*/ 282).fork();
                for (var i = 0; i < message.type.length; ++i)
                  writer.int32(message.type[i]);
                writer.ldelim();
              }
              if (
                message.format != null &&
                Object.hasOwnProperty.call(message, "format")
              )
                writer
                  .uint32(/* id 36, wireType 2 =*/ 290)
                  .string(message.format);
              if (message["enum"] != null && message["enum"].length)
                for (var i = 0; i < message["enum"].length; ++i)
                  writer
                    .uint32(/* id 46, wireType 2 =*/ 370)
                    .string(message["enum"][i]);
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 48, wireType 2 =*/ 386)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              if (
                message.fieldConfiguration != null &&
                Object.hasOwnProperty.call(message, "fieldConfiguration")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration.encode(
                  message.fieldConfiguration,
                  writer.uint32(/* id 1001, wireType 2 =*/ 8010).fork()
                ).ldelim();
              return writer;
            };

            /**
             * Decodes a JSONSchema message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema} JSONSchema
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            JSONSchema.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 3:
                    message.ref = reader.string();
                    break;
                  case 5:
                    message.title = reader.string();
                    break;
                  case 6:
                    message.description = reader.string();
                    break;
                  case 7:
                    message["default"] = reader.string();
                    break;
                  case 8:
                    message.readOnly = reader.bool();
                    break;
                  case 9:
                    message.example = reader.string();
                    break;
                  case 10:
                    message.multipleOf = reader.double();
                    break;
                  case 11:
                    message.maximum = reader.double();
                    break;
                  case 12:
                    message.exclusiveMaximum = reader.bool();
                    break;
                  case 13:
                    message.minimum = reader.double();
                    break;
                  case 14:
                    message.exclusiveMinimum = reader.bool();
                    break;
                  case 15:
                    message.maxLength = reader.uint64();
                    break;
                  case 16:
                    message.minLength = reader.uint64();
                    break;
                  case 17:
                    message.pattern = reader.string();
                    break;
                  case 20:
                    message.maxItems = reader.uint64();
                    break;
                  case 21:
                    message.minItems = reader.uint64();
                    break;
                  case 22:
                    message.uniqueItems = reader.bool();
                    break;
                  case 24:
                    message.maxProperties = reader.uint64();
                    break;
                  case 25:
                    message.minProperties = reader.uint64();
                    break;
                  case 26:
                    if (!(message.required && message.required.length))
                      message.required = [];
                    message.required.push(reader.string());
                    break;
                  case 34:
                    if (!(message.array && message.array.length))
                      message.array = [];
                    message.array.push(reader.string());
                    break;
                  case 35:
                    if (!(message.type && message.type.length))
                      message.type = [];
                    if ((tag & 7) === 2) {
                      var end2 = reader.uint32() + reader.pos;
                      while (reader.pos < end2)
                        message.type.push(reader.int32());
                    } else message.type.push(reader.int32());
                    break;
                  case 36:
                    message.format = reader.string();
                    break;
                  case 46:
                    if (!(message["enum"] && message["enum"].length))
                      message["enum"] = [];
                    message["enum"].push(reader.string());
                    break;
                  case 1001:
                    message.fieldConfiguration =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 48:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a JSONSchema message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema} JSONSchema
             */
            JSONSchema.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema();
              if (object.ref != null) message.ref = String(object.ref);
              if (object.title != null) message.title = String(object.title);
              if (object.description != null)
                message.description = String(object.description);
              if (object["default"] != null)
                message["default"] = String(object["default"]);
              if (object.readOnly != null)
                message.readOnly = Boolean(object.readOnly);
              if (object.example != null)
                message.example = String(object.example);
              if (object.multipleOf != null)
                message.multipleOf = Number(object.multipleOf);
              if (object.maximum != null)
                message.maximum = Number(object.maximum);
              if (object.exclusiveMaximum != null)
                message.exclusiveMaximum = Boolean(object.exclusiveMaximum);
              if (object.minimum != null)
                message.minimum = Number(object.minimum);
              if (object.exclusiveMinimum != null)
                message.exclusiveMinimum = Boolean(object.exclusiveMinimum);
              if (object.maxLength != null)
                if ($util.Long)
                  (message.maxLength = $util.Long.fromValue(
                    object.maxLength
                  )).unsigned = true;
                else if (typeof object.maxLength === "string")
                  message.maxLength = parseInt(object.maxLength, 10);
                else if (typeof object.maxLength === "number")
                  message.maxLength = object.maxLength;
                else if (typeof object.maxLength === "object")
                  message.maxLength = new $util.LongBits(
                    object.maxLength.low >>> 0,
                    object.maxLength.high >>> 0
                  ).toNumber(true);
              if (object.minLength != null)
                if ($util.Long)
                  (message.minLength = $util.Long.fromValue(
                    object.minLength
                  )).unsigned = true;
                else if (typeof object.minLength === "string")
                  message.minLength = parseInt(object.minLength, 10);
                else if (typeof object.minLength === "number")
                  message.minLength = object.minLength;
                else if (typeof object.minLength === "object")
                  message.minLength = new $util.LongBits(
                    object.minLength.low >>> 0,
                    object.minLength.high >>> 0
                  ).toNumber(true);
              if (object.pattern != null)
                message.pattern = String(object.pattern);
              if (object.maxItems != null)
                if ($util.Long)
                  (message.maxItems = $util.Long.fromValue(
                    object.maxItems
                  )).unsigned = true;
                else if (typeof object.maxItems === "string")
                  message.maxItems = parseInt(object.maxItems, 10);
                else if (typeof object.maxItems === "number")
                  message.maxItems = object.maxItems;
                else if (typeof object.maxItems === "object")
                  message.maxItems = new $util.LongBits(
                    object.maxItems.low >>> 0,
                    object.maxItems.high >>> 0
                  ).toNumber(true);
              if (object.minItems != null)
                if ($util.Long)
                  (message.minItems = $util.Long.fromValue(
                    object.minItems
                  )).unsigned = true;
                else if (typeof object.minItems === "string")
                  message.minItems = parseInt(object.minItems, 10);
                else if (typeof object.minItems === "number")
                  message.minItems = object.minItems;
                else if (typeof object.minItems === "object")
                  message.minItems = new $util.LongBits(
                    object.minItems.low >>> 0,
                    object.minItems.high >>> 0
                  ).toNumber(true);
              if (object.uniqueItems != null)
                message.uniqueItems = Boolean(object.uniqueItems);
              if (object.maxProperties != null)
                if ($util.Long)
                  (message.maxProperties = $util.Long.fromValue(
                    object.maxProperties
                  )).unsigned = true;
                else if (typeof object.maxProperties === "string")
                  message.maxProperties = parseInt(object.maxProperties, 10);
                else if (typeof object.maxProperties === "number")
                  message.maxProperties = object.maxProperties;
                else if (typeof object.maxProperties === "object")
                  message.maxProperties = new $util.LongBits(
                    object.maxProperties.low >>> 0,
                    object.maxProperties.high >>> 0
                  ).toNumber(true);
              if (object.minProperties != null)
                if ($util.Long)
                  (message.minProperties = $util.Long.fromValue(
                    object.minProperties
                  )).unsigned = true;
                else if (typeof object.minProperties === "string")
                  message.minProperties = parseInt(object.minProperties, 10);
                else if (typeof object.minProperties === "number")
                  message.minProperties = object.minProperties;
                else if (typeof object.minProperties === "object")
                  message.minProperties = new $util.LongBits(
                    object.minProperties.low >>> 0,
                    object.minProperties.high >>> 0
                  ).toNumber(true);
              if (object.required) {
                if (!Array.isArray(object.required))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.required: array expected"
                  );
                message.required = [];
                for (var i = 0; i < object.required.length; ++i)
                  message.required[i] = String(object.required[i]);
              }
              if (object.array) {
                if (!Array.isArray(object.array))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.array: array expected"
                  );
                message.array = [];
                for (var i = 0; i < object.array.length; ++i)
                  message.array[i] = String(object.array[i]);
              }
              if (object.type) {
                if (!Array.isArray(object.type))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.type: array expected"
                  );
                message.type = [];
                for (var i = 0; i < object.type.length; ++i)
                  switch (object.type[i]) {
                    default:
                    case "UNKNOWN":
                    case 0:
                      message.type[i] = 0;
                      break;
                    case "ARRAY":
                    case 1:
                      message.type[i] = 1;
                      break;
                    case "BOOLEAN":
                    case 2:
                      message.type[i] = 2;
                      break;
                    case "INTEGER":
                    case 3:
                      message.type[i] = 3;
                      break;
                    case "NULL":
                    case 4:
                      message.type[i] = 4;
                      break;
                    case "NUMBER":
                    case 5:
                      message.type[i] = 5;
                      break;
                    case "OBJECT":
                    case 6:
                      message.type[i] = 6;
                      break;
                    case "STRING":
                    case 7:
                      message.type[i] = 7;
                      break;
                  }
              }
              if (object.format != null) message.format = String(object.format);
              if (object["enum"]) {
                if (!Array.isArray(object["enum"]))
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.enum: array expected"
                  );
                message["enum"] = [];
                for (var i = 0; i < object["enum"].length; ++i)
                  message["enum"][i] = String(object["enum"][i]);
              }
              if (object.fieldConfiguration != null) {
                if (typeof object.fieldConfiguration !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.fieldConfiguration: object expected"
                  );
                message.fieldConfiguration =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration.fromObject(
                    object.fieldConfiguration
                  );
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a JSONSchema message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema} message JSONSchema
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            JSONSchema.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.arrays || options.defaults) {
                object.required = [];
                object.array = [];
                object.type = [];
                object["enum"] = [];
              }
              if (options.objects || options.defaults) object.extensions = {};
              if (options.defaults) {
                object.ref = "";
                object.title = "";
                object.description = "";
                object["default"] = "";
                object.readOnly = false;
                object.example = "";
                object.multipleOf = 0;
                object.maximum = 0;
                object.exclusiveMaximum = false;
                object.minimum = 0;
                object.exclusiveMinimum = false;
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.maxLength =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else object.maxLength = options.longs === String ? "0" : 0;
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.minLength =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else object.minLength = options.longs === String ? "0" : 0;
                object.pattern = "";
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.maxItems =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else object.maxItems = options.longs === String ? "0" : 0;
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.minItems =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else object.minItems = options.longs === String ? "0" : 0;
                object.uniqueItems = false;
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.maxProperties =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else
                  object.maxProperties = options.longs === String ? "0" : 0;
                if ($util.Long) {
                  var long = new $util.Long(0, 0, true);
                  object.minProperties =
                    options.longs === String
                      ? long.toString()
                      : options.longs === Number
                      ? long.toNumber()
                      : long;
                } else
                  object.minProperties = options.longs === String ? "0" : 0;
                object.format = "";
                object.fieldConfiguration = null;
              }
              if (message.ref != null && message.hasOwnProperty("ref"))
                object.ref = message.ref;
              if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (
                message["default"] != null &&
                message.hasOwnProperty("default")
              )
                object["default"] = message["default"];
              if (
                message.readOnly != null &&
                message.hasOwnProperty("readOnly")
              )
                object.readOnly = message.readOnly;
              if (message.example != null && message.hasOwnProperty("example"))
                object.example = message.example;
              if (
                message.multipleOf != null &&
                message.hasOwnProperty("multipleOf")
              )
                object.multipleOf =
                  options.json && !isFinite(message.multipleOf)
                    ? String(message.multipleOf)
                    : message.multipleOf;
              if (message.maximum != null && message.hasOwnProperty("maximum"))
                object.maximum =
                  options.json && !isFinite(message.maximum)
                    ? String(message.maximum)
                    : message.maximum;
              if (
                message.exclusiveMaximum != null &&
                message.hasOwnProperty("exclusiveMaximum")
              )
                object.exclusiveMaximum = message.exclusiveMaximum;
              if (message.minimum != null && message.hasOwnProperty("minimum"))
                object.minimum =
                  options.json && !isFinite(message.minimum)
                    ? String(message.minimum)
                    : message.minimum;
              if (
                message.exclusiveMinimum != null &&
                message.hasOwnProperty("exclusiveMinimum")
              )
                object.exclusiveMinimum = message.exclusiveMinimum;
              if (
                message.maxLength != null &&
                message.hasOwnProperty("maxLength")
              )
                if (typeof message.maxLength === "number")
                  object.maxLength =
                    options.longs === String
                      ? String(message.maxLength)
                      : message.maxLength;
                else
                  object.maxLength =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(message.maxLength)
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.maxLength.low >>> 0,
                          message.maxLength.high >>> 0
                        ).toNumber(true)
                      : message.maxLength;
              if (
                message.minLength != null &&
                message.hasOwnProperty("minLength")
              )
                if (typeof message.minLength === "number")
                  object.minLength =
                    options.longs === String
                      ? String(message.minLength)
                      : message.minLength;
                else
                  object.minLength =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(message.minLength)
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.minLength.low >>> 0,
                          message.minLength.high >>> 0
                        ).toNumber(true)
                      : message.minLength;
              if (message.pattern != null && message.hasOwnProperty("pattern"))
                object.pattern = message.pattern;
              if (
                message.maxItems != null &&
                message.hasOwnProperty("maxItems")
              )
                if (typeof message.maxItems === "number")
                  object.maxItems =
                    options.longs === String
                      ? String(message.maxItems)
                      : message.maxItems;
                else
                  object.maxItems =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(message.maxItems)
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.maxItems.low >>> 0,
                          message.maxItems.high >>> 0
                        ).toNumber(true)
                      : message.maxItems;
              if (
                message.minItems != null &&
                message.hasOwnProperty("minItems")
              )
                if (typeof message.minItems === "number")
                  object.minItems =
                    options.longs === String
                      ? String(message.minItems)
                      : message.minItems;
                else
                  object.minItems =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(message.minItems)
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.minItems.low >>> 0,
                          message.minItems.high >>> 0
                        ).toNumber(true)
                      : message.minItems;
              if (
                message.uniqueItems != null &&
                message.hasOwnProperty("uniqueItems")
              )
                object.uniqueItems = message.uniqueItems;
              if (
                message.maxProperties != null &&
                message.hasOwnProperty("maxProperties")
              )
                if (typeof message.maxProperties === "number")
                  object.maxProperties =
                    options.longs === String
                      ? String(message.maxProperties)
                      : message.maxProperties;
                else
                  object.maxProperties =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(
                          message.maxProperties
                        )
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.maxProperties.low >>> 0,
                          message.maxProperties.high >>> 0
                        ).toNumber(true)
                      : message.maxProperties;
              if (
                message.minProperties != null &&
                message.hasOwnProperty("minProperties")
              )
                if (typeof message.minProperties === "number")
                  object.minProperties =
                    options.longs === String
                      ? String(message.minProperties)
                      : message.minProperties;
                else
                  object.minProperties =
                    options.longs === String
                      ? $util.Long.prototype.toString.call(
                          message.minProperties
                        )
                      : options.longs === Number
                      ? new $util.LongBits(
                          message.minProperties.low >>> 0,
                          message.minProperties.high >>> 0
                        ).toNumber(true)
                      : message.minProperties;
              if (message.required && message.required.length) {
                object.required = [];
                for (var j = 0; j < message.required.length; ++j)
                  object.required[j] = message.required[j];
              }
              if (message.array && message.array.length) {
                object.array = [];
                for (var j = 0; j < message.array.length; ++j)
                  object.array[j] = message.array[j];
              }
              if (message.type && message.type.length) {
                object.type = [];
                for (var j = 0; j < message.type.length; ++j)
                  object.type[j] =
                    options.enums === String
                      ? $root.grpc.gateway.protoc_gen_openapiv2.options
                          .JSONSchema.JSONSchemaSimpleTypes[message.type[j]]
                      : message.type[j];
              }
              if (message.format != null && message.hasOwnProperty("format"))
                object.format = message.format;
              if (message["enum"] && message["enum"].length) {
                object["enum"] = [];
                for (var j = 0; j < message["enum"].length; ++j)
                  object["enum"][j] = message["enum"][j];
              }
              var keys2;
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              if (
                message.fieldConfiguration != null &&
                message.hasOwnProperty("fieldConfiguration")
              )
                object.fieldConfiguration =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration.toObject(
                    message.fieldConfiguration,
                    options
                  );
              return object;
            };

            /**
             * Converts this JSONSchema to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            JSONSchema.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            /**
             * JSONSchemaSimpleTypes enum.
             * @name grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.JSONSchemaSimpleTypes
             * @enum {string}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} ARRAY=1 ARRAY value
             * @property {number} BOOLEAN=2 BOOLEAN value
             * @property {number} INTEGER=3 INTEGER value
             * @property {number} NULL=4 NULL value
             * @property {number} NUMBER=5 NUMBER value
             * @property {number} OBJECT=6 OBJECT value
             * @property {number} STRING=7 STRING value
             */
            JSONSchema.JSONSchemaSimpleTypes = (function () {
              var valuesById = {},
                values = Object.create(valuesById);
              values[(valuesById[0] = "UNKNOWN")] = 0;
              values[(valuesById[1] = "ARRAY")] = 1;
              values[(valuesById[2] = "BOOLEAN")] = 2;
              values[(valuesById[3] = "INTEGER")] = 3;
              values[(valuesById[4] = "NULL")] = 4;
              values[(valuesById[5] = "NUMBER")] = 5;
              values[(valuesById[6] = "OBJECT")] = 6;
              values[(valuesById[7] = "STRING")] = 7;
              return values;
            })();

            JSONSchema.FieldConfiguration = (function () {
              /**
               * Properties of a FieldConfiguration.
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
               * @interface IFieldConfiguration
               * @property {string|null} [pathParamName] FieldConfiguration pathParamName
               */

              /**
               * Constructs a new FieldConfiguration.
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
               * @classdesc Represents a FieldConfiguration.
               * @implements IFieldConfiguration
               * @constructor
               * @param {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.IFieldConfiguration=} [properties] Properties to set
               */
              function FieldConfiguration(properties) {
                if (properties)
                  for (
                    var keys = Object.keys(properties), i = 0;
                    i < keys.length;
                    ++i
                  )
                    if (properties[keys[i]] != null)
                      this[keys[i]] = properties[keys[i]];
              }

              /**
               * FieldConfiguration pathParamName.
               * @member {string} pathParamName
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @instance
               */
              FieldConfiguration.prototype.pathParamName = "";

              /**
               * Creates a new FieldConfiguration instance using the specified properties.
               * @function create
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.IFieldConfiguration=} [properties] Properties to set
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration} FieldConfiguration instance
               */
              FieldConfiguration.create = function create(properties) {
                return new FieldConfiguration(properties);
              };

              /**
               * Encodes the specified FieldConfiguration message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration.verify|verify} messages.
               * @function encode
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.IFieldConfiguration} message FieldConfiguration message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */
              FieldConfiguration.encode = function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (
                  message.pathParamName != null &&
                  Object.hasOwnProperty.call(message, "pathParamName")
                )
                  writer
                    .uint32(/* id 47, wireType 2 =*/ 378)
                    .string(message.pathParamName);
                return writer;
              };

              /**
               * Decodes a FieldConfiguration message from the specified reader or buffer.
               * @function decode
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration} FieldConfiguration
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */
              FieldConfiguration.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 47:
                      message.pathParamName = reader.string();
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

              /**
               * Creates a FieldConfiguration message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration} FieldConfiguration
               */
              FieldConfiguration.fromObject = function fromObject(object) {
                if (
                  object instanceof
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema
                    .FieldConfiguration
                )
                  return object;
                var message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration();
                if (object.pathParamName != null)
                  message.pathParamName = String(object.pathParamName);
                return message;
              };

              /**
               * Creates a plain object from a FieldConfiguration message. Also converts values to other types if specified.
               * @function toObject
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration} message FieldConfiguration
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */
              FieldConfiguration.toObject = function toObject(
                message,
                options
              ) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) object.pathParamName = "";
                if (
                  message.pathParamName != null &&
                  message.hasOwnProperty("pathParamName")
                )
                  object.pathParamName = message.pathParamName;
                return object;
              };

              /**
               * Converts this FieldConfiguration to JSON.
               * @function toJSON
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.FieldConfiguration
               * @instance
               * @returns {Object.<string,*>} JSON object
               */
              FieldConfiguration.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

              return FieldConfiguration;
            })();

            return JSONSchema;
          })();

          options.Tag = (function () {
            /**
             * Properties of a Tag.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ITag
             * @property {string|null} [name] Tag name
             * @property {string|null} [description] Tag description
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null} [externalDocs] Tag externalDocs
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] Tag extensions
             */

            /**
             * Constructs a new Tag.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Tag.
             * @implements ITag
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ITag=} [properties] Properties to set
             */
            function Tag(properties) {
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Tag name.
             * @member {string} name
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @instance
             */
            Tag.prototype.name = "";

            /**
             * Tag description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @instance
             */
            Tag.prototype.description = "";

            /**
             * Tag externalDocs.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IExternalDocumentation|null|undefined} externalDocs
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @instance
             */
            Tag.prototype.externalDocs = null;

            /**
             * Tag extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @instance
             */
            Tag.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new Tag instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ITag=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Tag} Tag instance
             */
            Tag.create = function create(properties) {
              return new Tag(properties);
            };

            /**
             * Encodes the specified Tag message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Tag.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ITag} message Tag message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Tag.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.description);
              if (
                message.externalDocs != null &&
                Object.hasOwnProperty.call(message, "externalDocs")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.encode(
                  message.externalDocs,
                  writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
                ).ldelim();
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 4, wireType 2 =*/ 34)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a Tag message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Tag} Tag
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Tag.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Tag(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.name = reader.string();
                    break;
                  case 2:
                    message.description = reader.string();
                    break;
                  case 3:
                    message.externalDocs =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 4:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Tag message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Tag} Tag
             */
            Tag.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Tag
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Tag();
              if (object.name != null) message.name = String(object.name);
              if (object.description != null)
                message.description = String(object.description);
              if (object.externalDocs != null) {
                if (typeof object.externalDocs !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Tag.externalDocs: object expected"
                  );
                message.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.fromObject(
                    object.externalDocs
                  );
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Tag.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.Tag.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a Tag message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Tag} message Tag
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Tag.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) object.extensions = {};
              if (options.defaults) {
                object.name = "";
                object.description = "";
                object.externalDocs = null;
              }
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (
                message.externalDocs != null &&
                message.hasOwnProperty("externalDocs")
              )
                object.externalDocs =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.ExternalDocumentation.toObject(
                    message.externalDocs,
                    options
                  );
              var keys2;
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this Tag to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Tag
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Tag.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Tag;
          })();

          options.SecurityDefinitions = (function () {
            /**
             * Properties of a SecurityDefinitions.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ISecurityDefinitions
             * @property {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.ISecurityScheme>|null} [security] SecurityDefinitions security
             */

            /**
             * Constructs a new SecurityDefinitions.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a SecurityDefinitions.
             * @implements ISecurityDefinitions
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityDefinitions=} [properties] Properties to set
             */
            function SecurityDefinitions(properties) {
              this.security = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * SecurityDefinitions security.
             * @member {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.ISecurityScheme>} security
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @instance
             */
            SecurityDefinitions.prototype.security = $util.emptyObject;

            /**
             * Creates a new SecurityDefinitions instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityDefinitions=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions} SecurityDefinitions instance
             */
            SecurityDefinitions.create = function create(properties) {
              return new SecurityDefinitions(properties);
            };

            /**
             * Encodes the specified SecurityDefinitions message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityDefinitions} message SecurityDefinitions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SecurityDefinitions.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.security != null &&
                Object.hasOwnProperty.call(message, "security")
              )
                for (
                  var keys = Object.keys(message.security), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.encode(
                    message.security[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a SecurityDefinitions message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions} SecurityDefinitions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SecurityDefinitions.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    reader.skip().pos++;
                    if (message.security === $util.emptyObject)
                      message.security = {};
                    key = reader.string();
                    reader.pos++;
                    message.security[key] =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a SecurityDefinitions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions} SecurityDefinitions
             */
            SecurityDefinitions.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options
                  .SecurityDefinitions
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions();
              if (object.security) {
                if (typeof object.security !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.security: object expected"
                  );
                message.security = {};
                for (
                  var keys = Object.keys(object.security), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.security[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions.security: object expected"
                    );
                  message.security[keys[i]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.fromObject(
                      object.security[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a SecurityDefinitions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions} message SecurityDefinitions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SecurityDefinitions.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) object.security = {};
              var keys2;
              if (
                message.security &&
                (keys2 = Object.keys(message.security)).length
              ) {
                object.security = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.security[keys2[j]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.toObject(
                      message.security[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this SecurityDefinitions to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityDefinitions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SecurityDefinitions.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return SecurityDefinitions;
          })();

          options.SecurityScheme = (function () {
            /**
             * Properties of a SecurityScheme.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ISecurityScheme
             * @property {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Type|null} [type] SecurityScheme type
             * @property {string|null} [description] SecurityScheme description
             * @property {string|null} [name] SecurityScheme name
             * @property {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.In|null} ["in"] SecurityScheme in
             * @property {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Flow|null} [flow] SecurityScheme flow
             * @property {string|null} [authorizationUrl] SecurityScheme authorizationUrl
             * @property {string|null} [tokenUrl] SecurityScheme tokenUrl
             * @property {grpc.gateway.protoc_gen_openapiv2.options.IScopes|null} [scopes] SecurityScheme scopes
             * @property {Object.<string,google.protobuf.IValue>|null} [extensions] SecurityScheme extensions
             */

            /**
             * Constructs a new SecurityScheme.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a SecurityScheme.
             * @implements ISecurityScheme
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityScheme=} [properties] Properties to set
             */
            function SecurityScheme(properties) {
              this.extensions = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * SecurityScheme type.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Type} type
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.type = 0;

            /**
             * SecurityScheme description.
             * @member {string} description
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.description = "";

            /**
             * SecurityScheme name.
             * @member {string} name
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.name = "";

            /**
             * SecurityScheme in.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.In} in
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype["in"] = 0;

            /**
             * SecurityScheme flow.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Flow} flow
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.flow = 0;

            /**
             * SecurityScheme authorizationUrl.
             * @member {string} authorizationUrl
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.authorizationUrl = "";

            /**
             * SecurityScheme tokenUrl.
             * @member {string} tokenUrl
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.tokenUrl = "";

            /**
             * SecurityScheme scopes.
             * @member {grpc.gateway.protoc_gen_openapiv2.options.IScopes|null|undefined} scopes
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.scopes = null;

            /**
             * SecurityScheme extensions.
             * @member {Object.<string,google.protobuf.IValue>} extensions
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             */
            SecurityScheme.prototype.extensions = $util.emptyObject;

            /**
             * Creates a new SecurityScheme instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityScheme=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme} SecurityScheme instance
             */
            SecurityScheme.create = function create(properties) {
              return new SecurityScheme(properties);
            };

            /**
             * Encodes the specified SecurityScheme message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityScheme} message SecurityScheme message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SecurityScheme.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.type != null &&
                Object.hasOwnProperty.call(message, "type")
              )
                writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
              if (
                message.description != null &&
                Object.hasOwnProperty.call(message, "description")
              )
                writer
                  .uint32(/* id 2, wireType 2 =*/ 18)
                  .string(message.description);
              if (
                message.name != null &&
                Object.hasOwnProperty.call(message, "name")
              )
                writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
              if (
                message["in"] != null &&
                Object.hasOwnProperty.call(message, "in")
              )
                writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message["in"]);
              if (
                message.flow != null &&
                Object.hasOwnProperty.call(message, "flow")
              )
                writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.flow);
              if (
                message.authorizationUrl != null &&
                Object.hasOwnProperty.call(message, "authorizationUrl")
              )
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.authorizationUrl);
              if (
                message.tokenUrl != null &&
                Object.hasOwnProperty.call(message, "tokenUrl")
              )
                writer
                  .uint32(/* id 7, wireType 2 =*/ 58)
                  .string(message.tokenUrl);
              if (
                message.scopes != null &&
                Object.hasOwnProperty.call(message, "scopes")
              )
                $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes.encode(
                  message.scopes,
                  writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
                ).ldelim();
              if (
                message.extensions != null &&
                Object.hasOwnProperty.call(message, "extensions")
              )
                for (
                  var keys = Object.keys(message.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 9, wireType 2 =*/ 74)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.google.protobuf.Value.encode(
                    message.extensions[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a SecurityScheme message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme} SecurityScheme
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SecurityScheme.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    message.type = reader.int32();
                    break;
                  case 2:
                    message.description = reader.string();
                    break;
                  case 3:
                    message.name = reader.string();
                    break;
                  case 4:
                    message["in"] = reader.int32();
                    break;
                  case 5:
                    message.flow = reader.int32();
                    break;
                  case 6:
                    message.authorizationUrl = reader.string();
                    break;
                  case 7:
                    message.tokenUrl = reader.string();
                    break;
                  case 8:
                    message.scopes =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  case 9:
                    reader.skip().pos++;
                    if (message.extensions === $util.emptyObject)
                      message.extensions = {};
                    key = reader.string();
                    reader.pos++;
                    message.extensions[key] =
                      $root.google.protobuf.Value.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a SecurityScheme message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme} SecurityScheme
             */
            SecurityScheme.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme();
              switch (object.type) {
                case "TYPE_INVALID":
                case 0:
                  message.type = 0;
                  break;
                case "TYPE_BASIC":
                case 1:
                  message.type = 1;
                  break;
                case "TYPE_API_KEY":
                case 2:
                  message.type = 2;
                  break;
                case "TYPE_OAUTH2":
                case 3:
                  message.type = 3;
                  break;
              }
              if (object.description != null)
                message.description = String(object.description);
              if (object.name != null) message.name = String(object.name);
              switch (object["in"]) {
                case "IN_INVALID":
                case 0:
                  message["in"] = 0;
                  break;
                case "IN_QUERY":
                case 1:
                  message["in"] = 1;
                  break;
                case "IN_HEADER":
                case 2:
                  message["in"] = 2;
                  break;
              }
              switch (object.flow) {
                case "FLOW_INVALID":
                case 0:
                  message.flow = 0;
                  break;
                case "FLOW_IMPLICIT":
                case 1:
                  message.flow = 1;
                  break;
                case "FLOW_PASSWORD":
                case 2:
                  message.flow = 2;
                  break;
                case "FLOW_APPLICATION":
                case 3:
                  message.flow = 3;
                  break;
                case "FLOW_ACCESS_CODE":
                case 4:
                  message.flow = 4;
                  break;
              }
              if (object.authorizationUrl != null)
                message.authorizationUrl = String(object.authorizationUrl);
              if (object.tokenUrl != null)
                message.tokenUrl = String(object.tokenUrl);
              if (object.scopes != null) {
                if (typeof object.scopes !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.scopes: object expected"
                  );
                message.scopes =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes.fromObject(
                    object.scopes
                  );
              }
              if (object.extensions) {
                if (typeof object.extensions !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.extensions: object expected"
                  );
                message.extensions = {};
                for (
                  var keys = Object.keys(object.extensions), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.extensions[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.extensions: object expected"
                    );
                  message.extensions[keys[i]] =
                    $root.google.protobuf.Value.fromObject(
                      object.extensions[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a SecurityScheme message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme} message SecurityScheme
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SecurityScheme.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) object.extensions = {};
              if (options.defaults) {
                object.type = options.enums === String ? "TYPE_INVALID" : 0;
                object.description = "";
                object.name = "";
                object["in"] = options.enums === String ? "IN_INVALID" : 0;
                object.flow = options.enums === String ? "FLOW_INVALID" : 0;
                object.authorizationUrl = "";
                object.tokenUrl = "";
                object.scopes = null;
              }
              if (message.type != null && message.hasOwnProperty("type"))
                object.type =
                  options.enums === String
                    ? $root.grpc.gateway.protoc_gen_openapiv2.options
                        .SecurityScheme.Type[message.type]
                    : message.type;
              if (
                message.description != null &&
                message.hasOwnProperty("description")
              )
                object.description = message.description;
              if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
              if (message["in"] != null && message.hasOwnProperty("in"))
                object["in"] =
                  options.enums === String
                    ? $root.grpc.gateway.protoc_gen_openapiv2.options
                        .SecurityScheme.In[message["in"]]
                    : message["in"];
              if (message.flow != null && message.hasOwnProperty("flow"))
                object.flow =
                  options.enums === String
                    ? $root.grpc.gateway.protoc_gen_openapiv2.options
                        .SecurityScheme.Flow[message.flow]
                    : message.flow;
              if (
                message.authorizationUrl != null &&
                message.hasOwnProperty("authorizationUrl")
              )
                object.authorizationUrl = message.authorizationUrl;
              if (
                message.tokenUrl != null &&
                message.hasOwnProperty("tokenUrl")
              )
                object.tokenUrl = message.tokenUrl;
              if (message.scopes != null && message.hasOwnProperty("scopes"))
                object.scopes =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes.toObject(
                    message.scopes,
                    options
                  );
              var keys2;
              if (
                message.extensions &&
                (keys2 = Object.keys(message.extensions)).length
              ) {
                object.extensions = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.extensions[keys2[j]] =
                    $root.google.protobuf.Value.toObject(
                      message.extensions[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this SecurityScheme to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SecurityScheme.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            /**
             * Type enum.
             * @name grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Type
             * @enum {string}
             * @property {number} TYPE_INVALID=0 TYPE_INVALID value
             * @property {number} TYPE_BASIC=1 TYPE_BASIC value
             * @property {number} TYPE_API_KEY=2 TYPE_API_KEY value
             * @property {number} TYPE_OAUTH2=3 TYPE_OAUTH2 value
             */
            SecurityScheme.Type = (function () {
              var valuesById = {},
                values = Object.create(valuesById);
              values[(valuesById[0] = "TYPE_INVALID")] = 0;
              values[(valuesById[1] = "TYPE_BASIC")] = 1;
              values[(valuesById[2] = "TYPE_API_KEY")] = 2;
              values[(valuesById[3] = "TYPE_OAUTH2")] = 3;
              return values;
            })();

            /**
             * In enum.
             * @name grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.In
             * @enum {string}
             * @property {number} IN_INVALID=0 IN_INVALID value
             * @property {number} IN_QUERY=1 IN_QUERY value
             * @property {number} IN_HEADER=2 IN_HEADER value
             */
            SecurityScheme.In = (function () {
              var valuesById = {},
                values = Object.create(valuesById);
              values[(valuesById[0] = "IN_INVALID")] = 0;
              values[(valuesById[1] = "IN_QUERY")] = 1;
              values[(valuesById[2] = "IN_HEADER")] = 2;
              return values;
            })();

            /**
             * Flow enum.
             * @name grpc.gateway.protoc_gen_openapiv2.options.SecurityScheme.Flow
             * @enum {string}
             * @property {number} FLOW_INVALID=0 FLOW_INVALID value
             * @property {number} FLOW_IMPLICIT=1 FLOW_IMPLICIT value
             * @property {number} FLOW_PASSWORD=2 FLOW_PASSWORD value
             * @property {number} FLOW_APPLICATION=3 FLOW_APPLICATION value
             * @property {number} FLOW_ACCESS_CODE=4 FLOW_ACCESS_CODE value
             */
            SecurityScheme.Flow = (function () {
              var valuesById = {},
                values = Object.create(valuesById);
              values[(valuesById[0] = "FLOW_INVALID")] = 0;
              values[(valuesById[1] = "FLOW_IMPLICIT")] = 1;
              values[(valuesById[2] = "FLOW_PASSWORD")] = 2;
              values[(valuesById[3] = "FLOW_APPLICATION")] = 3;
              values[(valuesById[4] = "FLOW_ACCESS_CODE")] = 4;
              return values;
            })();

            return SecurityScheme;
          })();

          options.SecurityRequirement = (function () {
            /**
             * Properties of a SecurityRequirement.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface ISecurityRequirement
             * @property {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.ISecurityRequirementValue>|null} [securityRequirement] SecurityRequirement securityRequirement
             */

            /**
             * Constructs a new SecurityRequirement.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a SecurityRequirement.
             * @implements ISecurityRequirement
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement=} [properties] Properties to set
             */
            function SecurityRequirement(properties) {
              this.securityRequirement = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * SecurityRequirement securityRequirement.
             * @member {Object.<string,grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.ISecurityRequirementValue>} securityRequirement
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @instance
             */
            SecurityRequirement.prototype.securityRequirement =
              $util.emptyObject;

            /**
             * Creates a new SecurityRequirement instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement} SecurityRequirement instance
             */
            SecurityRequirement.create = function create(properties) {
              return new SecurityRequirement(properties);
            };

            /**
             * Encodes the specified SecurityRequirement message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.ISecurityRequirement} message SecurityRequirement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SecurityRequirement.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.securityRequirement != null &&
                Object.hasOwnProperty.call(message, "securityRequirement")
              )
                for (
                  var keys = Object.keys(message.securityRequirement), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i]);
                  $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.encode(
                    message.securityRequirement[keys[i]],
                    writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
                  )
                    .ldelim()
                    .ldelim();
                }
              return writer;
            };

            /**
             * Decodes a SecurityRequirement message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement} SecurityRequirement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SecurityRequirement.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    reader.skip().pos++;
                    if (message.securityRequirement === $util.emptyObject)
                      message.securityRequirement = {};
                    key = reader.string();
                    reader.pos++;
                    message.securityRequirement[key] =
                      $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.decode(
                        reader,
                        reader.uint32()
                      );
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a SecurityRequirement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement} SecurityRequirement
             */
            SecurityRequirement.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options
                  .SecurityRequirement
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement();
              if (object.securityRequirement) {
                if (typeof object.securityRequirement !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.securityRequirement: object expected"
                  );
                message.securityRequirement = {};
                for (
                  var keys = Object.keys(object.securityRequirement), i = 0;
                  i < keys.length;
                  ++i
                ) {
                  if (typeof object.securityRequirement[keys[i]] !== "object")
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.securityRequirement: object expected"
                    );
                  message.securityRequirement[keys[i]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.fromObject(
                      object.securityRequirement[keys[i]]
                    );
                }
              }
              return message;
            };

            /**
             * Creates a plain object from a SecurityRequirement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement} message SecurityRequirement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SecurityRequirement.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults)
                object.securityRequirement = {};
              var keys2;
              if (
                message.securityRequirement &&
                (keys2 = Object.keys(message.securityRequirement)).length
              ) {
                object.securityRequirement = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.securityRequirement[keys2[j]] =
                    $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.toObject(
                      message.securityRequirement[keys2[j]],
                      options
                    );
              }
              return object;
            };

            /**
             * Converts this SecurityRequirement to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SecurityRequirement.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            SecurityRequirement.SecurityRequirementValue = (function () {
              /**
               * Properties of a SecurityRequirementValue.
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
               * @interface ISecurityRequirementValue
               * @property {Array.<string>|null} [scope] SecurityRequirementValue scope
               */

              /**
               * Constructs a new SecurityRequirementValue.
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement
               * @classdesc Represents a SecurityRequirementValue.
               * @implements ISecurityRequirementValue
               * @constructor
               * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.ISecurityRequirementValue=} [properties] Properties to set
               */
              function SecurityRequirementValue(properties) {
                this.scope = [];
                if (properties)
                  for (
                    var keys = Object.keys(properties), i = 0;
                    i < keys.length;
                    ++i
                  )
                    if (properties[keys[i]] != null)
                      this[keys[i]] = properties[keys[i]];
              }

              /**
               * SecurityRequirementValue scope.
               * @member {Array.<string>} scope
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @instance
               */
              SecurityRequirementValue.prototype.scope = $util.emptyArray;

              /**
               * Creates a new SecurityRequirementValue instance using the specified properties.
               * @function create
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.ISecurityRequirementValue=} [properties] Properties to set
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue} SecurityRequirementValue instance
               */
              SecurityRequirementValue.create = function create(properties) {
                return new SecurityRequirementValue(properties);
              };

              /**
               * Encodes the specified SecurityRequirementValue message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.verify|verify} messages.
               * @function encode
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.ISecurityRequirementValue} message SecurityRequirementValue message or plain object to encode
               * @param {$protobuf.Writer} [writer] Writer to encode to
               * @returns {$protobuf.Writer} Writer
               */
              SecurityRequirementValue.encode = function encode(
                message,
                writer
              ) {
                if (!writer) writer = $Writer.create();
                if (message.scope != null && message.scope.length)
                  for (var i = 0; i < message.scope.length; ++i)
                    writer
                      .uint32(/* id 1, wireType 2 =*/ 10)
                      .string(message.scope[i]);
                return writer;
              };

              /**
               * Decodes a SecurityRequirementValue message from the specified reader or buffer.
               * @function decode
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @static
               * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
               * @param {number} [length] Message length if known beforehand
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue} SecurityRequirementValue
               * @throws {Error} If the payload is not a reader or valid buffer
               * @throws {$protobuf.util.ProtocolError} If required fields are missing
               */
              SecurityRequirementValue.decode = function decode(
                reader,
                length
              ) {
                if (!(reader instanceof $Reader))
                  reader = $Reader.create(reader);
                var end =
                    length === undefined ? reader.len : reader.pos + length,
                  message =
                    new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue();
                while (reader.pos < end) {
                  var tag = reader.uint32();
                  switch (tag >>> 3) {
                    case 1:
                      if (!(message.scope && message.scope.length))
                        message.scope = [];
                      message.scope.push(reader.string());
                      break;
                    default:
                      reader.skipType(tag & 7);
                      break;
                  }
                }
                return message;
              };

              /**
               * Creates a SecurityRequirementValue message from a plain object. Also converts values to their respective internal types.
               * @function fromObject
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @static
               * @param {Object.<string,*>} object Plain object
               * @returns {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue} SecurityRequirementValue
               */
              SecurityRequirementValue.fromObject = function fromObject(
                object
              ) {
                if (
                  object instanceof
                  $root.grpc.gateway.protoc_gen_openapiv2.options
                    .SecurityRequirement.SecurityRequirementValue
                )
                  return object;
                var message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue();
                if (object.scope) {
                  if (!Array.isArray(object.scope))
                    throw TypeError(
                      ".grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue.scope: array expected"
                    );
                  message.scope = [];
                  for (var i = 0; i < object.scope.length; ++i)
                    message.scope[i] = String(object.scope[i]);
                }
                return message;
              };

              /**
               * Creates a plain object from a SecurityRequirementValue message. Also converts values to other types if specified.
               * @function toObject
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @static
               * @param {grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue} message SecurityRequirementValue
               * @param {$protobuf.IConversionOptions} [options] Conversion options
               * @returns {Object.<string,*>} Plain object
               */
              SecurityRequirementValue.toObject = function toObject(
                message,
                options
              ) {
                if (!options) options = {};
                var object = {};
                if (options.arrays || options.defaults) object.scope = [];
                if (message.scope && message.scope.length) {
                  object.scope = [];
                  for (var j = 0; j < message.scope.length; ++j)
                    object.scope[j] = message.scope[j];
                }
                return object;
              };

              /**
               * Converts this SecurityRequirementValue to JSON.
               * @function toJSON
               * @memberof grpc.gateway.protoc_gen_openapiv2.options.SecurityRequirement.SecurityRequirementValue
               * @instance
               * @returns {Object.<string,*>} JSON object
               */
              SecurityRequirementValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(
                  this,
                  $protobuf.util.toJSONOptions
                );
              };

              return SecurityRequirementValue;
            })();

            return SecurityRequirement;
          })();

          options.Scopes = (function () {
            /**
             * Properties of a Scopes.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @interface IScopes
             * @property {Object.<string,string>|null} [scope] Scopes scope
             */

            /**
             * Constructs a new Scopes.
             * @memberof grpc.gateway.protoc_gen_openapiv2.options
             * @classdesc Represents a Scopes.
             * @implements IScopes
             * @constructor
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IScopes=} [properties] Properties to set
             */
            function Scopes(properties) {
              this.scope = {};
              if (properties)
                for (
                  var keys = Object.keys(properties), i = 0;
                  i < keys.length;
                  ++i
                )
                  if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
            }

            /**
             * Scopes scope.
             * @member {Object.<string,string>} scope
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @instance
             */
            Scopes.prototype.scope = $util.emptyObject;

            /**
             * Creates a new Scopes instance using the specified properties.
             * @function create
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IScopes=} [properties] Properties to set
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Scopes} Scopes instance
             */
            Scopes.create = function create(properties) {
              return new Scopes(properties);
            };

            /**
             * Encodes the specified Scopes message. Does not implicitly {@link grpc.gateway.protoc_gen_openapiv2.options.Scopes.verify|verify} messages.
             * @function encode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.IScopes} message Scopes message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Scopes.encode = function encode(message, writer) {
              if (!writer) writer = $Writer.create();
              if (
                message.scope != null &&
                Object.hasOwnProperty.call(message, "scope")
              )
                for (
                  var keys = Object.keys(message.scope), i = 0;
                  i < keys.length;
                  ++i
                )
                  writer
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .fork()
                    .uint32(/* id 1, wireType 2 =*/ 10)
                    .string(keys[i])
                    .uint32(/* id 2, wireType 2 =*/ 18)
                    .string(message.scope[keys[i]])
                    .ldelim();
              return writer;
            };

            /**
             * Decodes a Scopes message from the specified reader or buffer.
             * @function decode
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Scopes} Scopes
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Scopes.decode = function decode(reader, length) {
              if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
              var end = length === undefined ? reader.len : reader.pos + length,
                message =
                  new $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes(),
                key;
              while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                  case 1:
                    reader.skip().pos++;
                    if (message.scope === $util.emptyObject) message.scope = {};
                    key = reader.string();
                    reader.pos++;
                    message.scope[key] = reader.string();
                    break;
                  default:
                    reader.skipType(tag & 7);
                    break;
                }
              }
              return message;
            };

            /**
             * Creates a Scopes message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {grpc.gateway.protoc_gen_openapiv2.options.Scopes} Scopes
             */
            Scopes.fromObject = function fromObject(object) {
              if (
                object instanceof
                $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes
              )
                return object;
              var message =
                new $root.grpc.gateway.protoc_gen_openapiv2.options.Scopes();
              if (object.scope) {
                if (typeof object.scope !== "object")
                  throw TypeError(
                    ".grpc.gateway.protoc_gen_openapiv2.options.Scopes.scope: object expected"
                  );
                message.scope = {};
                for (
                  var keys = Object.keys(object.scope), i = 0;
                  i < keys.length;
                  ++i
                )
                  message.scope[keys[i]] = String(object.scope[keys[i]]);
              }
              return message;
            };

            /**
             * Creates a plain object from a Scopes message. Also converts values to other types if specified.
             * @function toObject
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @static
             * @param {grpc.gateway.protoc_gen_openapiv2.options.Scopes} message Scopes
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Scopes.toObject = function toObject(message, options) {
              if (!options) options = {};
              var object = {};
              if (options.objects || options.defaults) object.scope = {};
              var keys2;
              if (
                message.scope &&
                (keys2 = Object.keys(message.scope)).length
              ) {
                object.scope = {};
                for (var j = 0; j < keys2.length; ++j)
                  object.scope[keys2[j]] = message.scope[keys2[j]];
              }
              return object;
            };

            /**
             * Converts this Scopes to JSON.
             * @function toJSON
             * @memberof grpc.gateway.protoc_gen_openapiv2.options.Scopes
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Scopes.prototype.toJSON = function toJSON() {
              return this.constructor.toObject(
                this,
                $protobuf.util.toJSONOptions
              );
            };

            return Scopes;
          })();

          return options;
        })();

        return protoc_gen_openapiv2;
      })();

      return gateway;
    })();

    return grpc;
  })();

  $root.google = (function () {
    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    var google = {};

    google.protobuf = (function () {
      /**
       * Namespace protobuf.
       * @memberof google
       * @namespace
       */
      var protobuf = {};

      protobuf.FileDescriptorSet = (function () {
        /**
         * Properties of a FileDescriptorSet.
         * @memberof google.protobuf
         * @interface IFileDescriptorSet
         * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
         */

        /**
         * Constructs a new FileDescriptorSet.
         * @memberof google.protobuf
         * @classdesc Represents a FileDescriptorSet.
         * @implements IFileDescriptorSet
         * @constructor
         * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
         */
        function FileDescriptorSet(properties) {
          this.file = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileDescriptorSet file.
         * @member {Array.<google.protobuf.IFileDescriptorProto>} file
         * @memberof google.protobuf.FileDescriptorSet
         * @instance
         */
        FileDescriptorSet.prototype.file = $util.emptyArray;

        /**
         * Creates a new FileDescriptorSet instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FileDescriptorSet
         * @static
         * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
         * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
         */
        FileDescriptorSet.create = function create(properties) {
          return new FileDescriptorSet(properties);
        };

        /**
         * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FileDescriptorSet
         * @static
         * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDescriptorSet.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.file != null && message.file.length)
            for (var i = 0; i < message.file.length; ++i)
              $root.google.protobuf.FileDescriptorProto.encode(
                message.file[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a FileDescriptorSet message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FileDescriptorSet
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDescriptorSet.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FileDescriptorSet();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.file && message.file.length)) message.file = [];
                message.file.push(
                  $root.google.protobuf.FileDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FileDescriptorSet message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FileDescriptorSet
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
         */
        FileDescriptorSet.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FileDescriptorSet)
            return object;
          var message = new $root.google.protobuf.FileDescriptorSet();
          if (object.file) {
            if (!Array.isArray(object.file))
              throw TypeError(
                ".google.protobuf.FileDescriptorSet.file: array expected"
              );
            message.file = [];
            for (var i = 0; i < object.file.length; ++i) {
              if (typeof object.file[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileDescriptorSet.file: object expected"
                );
              message.file[i] =
                $root.google.protobuf.FileDescriptorProto.fromObject(
                  object.file[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a FileDescriptorSet message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FileDescriptorSet
         * @static
         * @param {google.protobuf.FileDescriptorSet} message FileDescriptorSet
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileDescriptorSet.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.file = [];
          if (message.file && message.file.length) {
            object.file = [];
            for (var j = 0; j < message.file.length; ++j)
              object.file[j] =
                $root.google.protobuf.FileDescriptorProto.toObject(
                  message.file[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this FileDescriptorSet to JSON.
         * @function toJSON
         * @memberof google.protobuf.FileDescriptorSet
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileDescriptorSet.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileDescriptorSet;
      })();

      protobuf.FileDescriptorProto = (function () {
        /**
         * Properties of a FileDescriptorProto.
         * @memberof google.protobuf
         * @interface IFileDescriptorProto
         * @property {string|null} [name] FileDescriptorProto name
         * @property {string|null} ["package"] FileDescriptorProto package
         * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
         * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
         * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
         * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
         * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
         * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
         * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
         * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
         * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
         * @property {string|null} [syntax] FileDescriptorProto syntax
         */

        /**
         * Constructs a new FileDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents a FileDescriptorProto.
         * @implements IFileDescriptorProto
         * @constructor
         * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
         */
        function FileDescriptorProto(properties) {
          this.dependency = [];
          this.publicDependency = [];
          this.weakDependency = [];
          this.messageType = [];
          this.enumType = [];
          this.service = [];
          this.extension = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.name = "";

        /**
         * FileDescriptorProto package.
         * @member {string} package
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype["package"] = "";

        /**
         * FileDescriptorProto dependency.
         * @member {Array.<string>} dependency
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.dependency = $util.emptyArray;

        /**
         * FileDescriptorProto publicDependency.
         * @member {Array.<number>} publicDependency
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.publicDependency = $util.emptyArray;

        /**
         * FileDescriptorProto weakDependency.
         * @member {Array.<number>} weakDependency
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.weakDependency = $util.emptyArray;

        /**
         * FileDescriptorProto messageType.
         * @member {Array.<google.protobuf.IDescriptorProto>} messageType
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.messageType = $util.emptyArray;

        /**
         * FileDescriptorProto enumType.
         * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.enumType = $util.emptyArray;

        /**
         * FileDescriptorProto service.
         * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.service = $util.emptyArray;

        /**
         * FileDescriptorProto extension.
         * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.extension = $util.emptyArray;

        /**
         * FileDescriptorProto options.
         * @member {google.protobuf.IFileOptions|null|undefined} options
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.options = null;

        /**
         * FileDescriptorProto sourceCodeInfo.
         * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.sourceCodeInfo = null;

        /**
         * FileDescriptorProto syntax.
         * @member {string} syntax
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         */
        FileDescriptorProto.prototype.syntax = "";

        /**
         * Creates a new FileDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FileDescriptorProto
         * @static
         * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
         */
        FileDescriptorProto.create = function create(properties) {
          return new FileDescriptorProto(properties);
        };

        /**
         * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FileDescriptorProto
         * @static
         * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message["package"] != null &&
            Object.hasOwnProperty.call(message, "package")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message["package"]);
          if (message.dependency != null && message.dependency.length)
            for (var i = 0; i < message.dependency.length; ++i)
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.dependency[i]);
          if (message.messageType != null && message.messageType.length)
            for (var i = 0; i < message.messageType.length; ++i)
              $root.google.protobuf.DescriptorProto.encode(
                message.messageType[i],
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
          if (message.enumType != null && message.enumType.length)
            for (var i = 0; i < message.enumType.length; ++i)
              $root.google.protobuf.EnumDescriptorProto.encode(
                message.enumType[i],
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
          if (message.service != null && message.service.length)
            for (var i = 0; i < message.service.length; ++i)
              $root.google.protobuf.ServiceDescriptorProto.encode(
                message.service[i],
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
          if (message.extension != null && message.extension.length)
            for (var i = 0; i < message.extension.length; ++i)
              $root.google.protobuf.FieldDescriptorProto.encode(
                message.extension[i],
                writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
              ).ldelim();
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.FileOptions.encode(
              message.options,
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
          if (
            message.sourceCodeInfo != null &&
            Object.hasOwnProperty.call(message, "sourceCodeInfo")
          )
            $root.google.protobuf.SourceCodeInfo.encode(
              message.sourceCodeInfo,
              writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
            ).ldelim();
          if (
            message.publicDependency != null &&
            message.publicDependency.length
          )
            for (var i = 0; i < message.publicDependency.length; ++i)
              writer
                .uint32(/* id 10, wireType 0 =*/ 80)
                .int32(message.publicDependency[i]);
          if (message.weakDependency != null && message.weakDependency.length)
            for (var i = 0; i < message.weakDependency.length; ++i)
              writer
                .uint32(/* id 11, wireType 0 =*/ 88)
                .int32(message.weakDependency[i]);
          if (
            message.syntax != null &&
            Object.hasOwnProperty.call(message, "syntax")
          )
            writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.syntax);
          return writer;
        };

        /**
         * Decodes a FileDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FileDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FileDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message["package"] = reader.string();
                break;
              case 3:
                if (!(message.dependency && message.dependency.length))
                  message.dependency = [];
                message.dependency.push(reader.string());
                break;
              case 10:
                if (
                  !(message.publicDependency && message.publicDependency.length)
                )
                  message.publicDependency = [];
                if ((tag & 7) === 2) {
                  var end2 = reader.uint32() + reader.pos;
                  while (reader.pos < end2)
                    message.publicDependency.push(reader.int32());
                } else message.publicDependency.push(reader.int32());
                break;
              case 11:
                if (!(message.weakDependency && message.weakDependency.length))
                  message.weakDependency = [];
                if ((tag & 7) === 2) {
                  var end2 = reader.uint32() + reader.pos;
                  while (reader.pos < end2)
                    message.weakDependency.push(reader.int32());
                } else message.weakDependency.push(reader.int32());
                break;
              case 4:
                if (!(message.messageType && message.messageType.length))
                  message.messageType = [];
                message.messageType.push(
                  $root.google.protobuf.DescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 5:
                if (!(message.enumType && message.enumType.length))
                  message.enumType = [];
                message.enumType.push(
                  $root.google.protobuf.EnumDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 6:
                if (!(message.service && message.service.length))
                  message.service = [];
                message.service.push(
                  $root.google.protobuf.ServiceDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 7:
                if (!(message.extension && message.extension.length))
                  message.extension = [];
                message.extension.push(
                  $root.google.protobuf.FieldDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 8:
                message.options = $root.google.protobuf.FileOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 9:
                message.sourceCodeInfo =
                  $root.google.protobuf.SourceCodeInfo.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 12:
                message.syntax = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FileDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FileDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
         */
        FileDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FileDescriptorProto)
            return object;
          var message = new $root.google.protobuf.FileDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object["package"] != null)
            message["package"] = String(object["package"]);
          if (object.dependency) {
            if (!Array.isArray(object.dependency))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.dependency: array expected"
              );
            message.dependency = [];
            for (var i = 0; i < object.dependency.length; ++i)
              message.dependency[i] = String(object.dependency[i]);
          }
          if (object.publicDependency) {
            if (!Array.isArray(object.publicDependency))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.publicDependency: array expected"
              );
            message.publicDependency = [];
            for (var i = 0; i < object.publicDependency.length; ++i)
              message.publicDependency[i] = object.publicDependency[i] | 0;
          }
          if (object.weakDependency) {
            if (!Array.isArray(object.weakDependency))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.weakDependency: array expected"
              );
            message.weakDependency = [];
            for (var i = 0; i < object.weakDependency.length; ++i)
              message.weakDependency[i] = object.weakDependency[i] | 0;
          }
          if (object.messageType) {
            if (!Array.isArray(object.messageType))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.messageType: array expected"
              );
            message.messageType = [];
            for (var i = 0; i < object.messageType.length; ++i) {
              if (typeof object.messageType[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileDescriptorProto.messageType: object expected"
                );
              message.messageType[i] =
                $root.google.protobuf.DescriptorProto.fromObject(
                  object.messageType[i]
                );
            }
          }
          if (object.enumType) {
            if (!Array.isArray(object.enumType))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.enumType: array expected"
              );
            message.enumType = [];
            for (var i = 0; i < object.enumType.length; ++i) {
              if (typeof object.enumType[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileDescriptorProto.enumType: object expected"
                );
              message.enumType[i] =
                $root.google.protobuf.EnumDescriptorProto.fromObject(
                  object.enumType[i]
                );
            }
          }
          if (object.service) {
            if (!Array.isArray(object.service))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.service: array expected"
              );
            message.service = [];
            for (var i = 0; i < object.service.length; ++i) {
              if (typeof object.service[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileDescriptorProto.service: object expected"
                );
              message.service[i] =
                $root.google.protobuf.ServiceDescriptorProto.fromObject(
                  object.service[i]
                );
            }
          }
          if (object.extension) {
            if (!Array.isArray(object.extension))
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.extension: array expected"
              );
            message.extension = [];
            for (var i = 0; i < object.extension.length; ++i) {
              if (typeof object.extension[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileDescriptorProto.extension: object expected"
                );
              message.extension[i] =
                $root.google.protobuf.FieldDescriptorProto.fromObject(
                  object.extension[i]
                );
            }
          }
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.FileOptions.fromObject(
              object.options
            );
          }
          if (object.sourceCodeInfo != null) {
            if (typeof object.sourceCodeInfo !== "object")
              throw TypeError(
                ".google.protobuf.FileDescriptorProto.sourceCodeInfo: object expected"
              );
            message.sourceCodeInfo =
              $root.google.protobuf.SourceCodeInfo.fromObject(
                object.sourceCodeInfo
              );
          }
          if (object.syntax != null) message.syntax = String(object.syntax);
          return message;
        };

        /**
         * Creates a plain object from a FileDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FileDescriptorProto
         * @static
         * @param {google.protobuf.FileDescriptorProto} message FileDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.dependency = [];
            object.messageType = [];
            object.enumType = [];
            object.service = [];
            object.extension = [];
            object.publicDependency = [];
            object.weakDependency = [];
          }
          if (options.defaults) {
            object.name = "";
            object["package"] = "";
            object.options = null;
            object.sourceCodeInfo = null;
            object.syntax = "";
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message["package"] != null && message.hasOwnProperty("package"))
            object["package"] = message["package"];
          if (message.dependency && message.dependency.length) {
            object.dependency = [];
            for (var j = 0; j < message.dependency.length; ++j)
              object.dependency[j] = message.dependency[j];
          }
          if (message.messageType && message.messageType.length) {
            object.messageType = [];
            for (var j = 0; j < message.messageType.length; ++j)
              object.messageType[j] =
                $root.google.protobuf.DescriptorProto.toObject(
                  message.messageType[j],
                  options
                );
          }
          if (message.enumType && message.enumType.length) {
            object.enumType = [];
            for (var j = 0; j < message.enumType.length; ++j)
              object.enumType[j] =
                $root.google.protobuf.EnumDescriptorProto.toObject(
                  message.enumType[j],
                  options
                );
          }
          if (message.service && message.service.length) {
            object.service = [];
            for (var j = 0; j < message.service.length; ++j)
              object.service[j] =
                $root.google.protobuf.ServiceDescriptorProto.toObject(
                  message.service[j],
                  options
                );
          }
          if (message.extension && message.extension.length) {
            object.extension = [];
            for (var j = 0; j < message.extension.length; ++j)
              object.extension[j] =
                $root.google.protobuf.FieldDescriptorProto.toObject(
                  message.extension[j],
                  options
                );
          }
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.FileOptions.toObject(
              message.options,
              options
            );
          if (
            message.sourceCodeInfo != null &&
            message.hasOwnProperty("sourceCodeInfo")
          )
            object.sourceCodeInfo =
              $root.google.protobuf.SourceCodeInfo.toObject(
                message.sourceCodeInfo,
                options
              );
          if (message.publicDependency && message.publicDependency.length) {
            object.publicDependency = [];
            for (var j = 0; j < message.publicDependency.length; ++j)
              object.publicDependency[j] = message.publicDependency[j];
          }
          if (message.weakDependency && message.weakDependency.length) {
            object.weakDependency = [];
            for (var j = 0; j < message.weakDependency.length; ++j)
              object.weakDependency[j] = message.weakDependency[j];
          }
          if (message.syntax != null && message.hasOwnProperty("syntax"))
            object.syntax = message.syntax;
          return object;
        };

        /**
         * Converts this FileDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.FileDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileDescriptorProto;
      })();

      protobuf.DescriptorProto = (function () {
        /**
         * Properties of a DescriptorProto.
         * @memberof google.protobuf
         * @interface IDescriptorProto
         * @property {string|null} [name] DescriptorProto name
         * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
         * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
         * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
         * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
         * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
         * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
         * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
         * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
         * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
         */

        /**
         * Constructs a new DescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents a DescriptorProto.
         * @implements IDescriptorProto
         * @constructor
         * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
         */
        function DescriptorProto(properties) {
          this.field = [];
          this.extension = [];
          this.nestedType = [];
          this.enumType = [];
          this.extensionRange = [];
          this.oneofDecl = [];
          this.reservedRange = [];
          this.reservedName = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * DescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.name = "";

        /**
         * DescriptorProto field.
         * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.field = $util.emptyArray;

        /**
         * DescriptorProto extension.
         * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.extension = $util.emptyArray;

        /**
         * DescriptorProto nestedType.
         * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.nestedType = $util.emptyArray;

        /**
         * DescriptorProto enumType.
         * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.enumType = $util.emptyArray;

        /**
         * DescriptorProto extensionRange.
         * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.extensionRange = $util.emptyArray;

        /**
         * DescriptorProto oneofDecl.
         * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.oneofDecl = $util.emptyArray;

        /**
         * DescriptorProto options.
         * @member {google.protobuf.IMessageOptions|null|undefined} options
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.options = null;

        /**
         * DescriptorProto reservedRange.
         * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.reservedRange = $util.emptyArray;

        /**
         * DescriptorProto reservedName.
         * @member {Array.<string>} reservedName
         * @memberof google.protobuf.DescriptorProto
         * @instance
         */
        DescriptorProto.prototype.reservedName = $util.emptyArray;

        /**
         * Creates a new DescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.DescriptorProto
         * @static
         * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
         */
        DescriptorProto.create = function create(properties) {
          return new DescriptorProto(properties);
        };

        /**
         * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.DescriptorProto
         * @static
         * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (message.field != null && message.field.length)
            for (var i = 0; i < message.field.length; ++i)
              $root.google.protobuf.FieldDescriptorProto.encode(
                message.field[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (message.nestedType != null && message.nestedType.length)
            for (var i = 0; i < message.nestedType.length; ++i)
              $root.google.protobuf.DescriptorProto.encode(
                message.nestedType[i],
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
          if (message.enumType != null && message.enumType.length)
            for (var i = 0; i < message.enumType.length; ++i)
              $root.google.protobuf.EnumDescriptorProto.encode(
                message.enumType[i],
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
              ).ldelim();
          if (message.extensionRange != null && message.extensionRange.length)
            for (var i = 0; i < message.extensionRange.length; ++i)
              $root.google.protobuf.DescriptorProto.ExtensionRange.encode(
                message.extensionRange[i],
                writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
              ).ldelim();
          if (message.extension != null && message.extension.length)
            for (var i = 0; i < message.extension.length; ++i)
              $root.google.protobuf.FieldDescriptorProto.encode(
                message.extension[i],
                writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
              ).ldelim();
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.MessageOptions.encode(
              message.options,
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
            ).ldelim();
          if (message.oneofDecl != null && message.oneofDecl.length)
            for (var i = 0; i < message.oneofDecl.length; ++i)
              $root.google.protobuf.OneofDescriptorProto.encode(
                message.oneofDecl[i],
                writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
              ).ldelim();
          if (message.reservedRange != null && message.reservedRange.length)
            for (var i = 0; i < message.reservedRange.length; ++i)
              $root.google.protobuf.DescriptorProto.ReservedRange.encode(
                message.reservedRange[i],
                writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
              ).ldelim();
          if (message.reservedName != null && message.reservedName.length)
            for (var i = 0; i < message.reservedName.length; ++i)
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.reservedName[i]);
          return writer;
        };

        /**
         * Decodes a DescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.DescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.DescriptorProto} DescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.DescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                if (!(message.field && message.field.length))
                  message.field = [];
                message.field.push(
                  $root.google.protobuf.FieldDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 6:
                if (!(message.extension && message.extension.length))
                  message.extension = [];
                message.extension.push(
                  $root.google.protobuf.FieldDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 3:
                if (!(message.nestedType && message.nestedType.length))
                  message.nestedType = [];
                message.nestedType.push(
                  $root.google.protobuf.DescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 4:
                if (!(message.enumType && message.enumType.length))
                  message.enumType = [];
                message.enumType.push(
                  $root.google.protobuf.EnumDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 5:
                if (!(message.extensionRange && message.extensionRange.length))
                  message.extensionRange = [];
                message.extensionRange.push(
                  $root.google.protobuf.DescriptorProto.ExtensionRange.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 8:
                if (!(message.oneofDecl && message.oneofDecl.length))
                  message.oneofDecl = [];
                message.oneofDecl.push(
                  $root.google.protobuf.OneofDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 7:
                message.options = $root.google.protobuf.MessageOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 9:
                if (!(message.reservedRange && message.reservedRange.length))
                  message.reservedRange = [];
                message.reservedRange.push(
                  $root.google.protobuf.DescriptorProto.ReservedRange.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 10:
                if (!(message.reservedName && message.reservedName.length))
                  message.reservedName = [];
                message.reservedName.push(reader.string());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a DescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.DescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.DescriptorProto} DescriptorProto
         */
        DescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.DescriptorProto)
            return object;
          var message = new $root.google.protobuf.DescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.field) {
            if (!Array.isArray(object.field))
              throw TypeError(
                ".google.protobuf.DescriptorProto.field: array expected"
              );
            message.field = [];
            for (var i = 0; i < object.field.length; ++i) {
              if (typeof object.field[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.field: object expected"
                );
              message.field[i] =
                $root.google.protobuf.FieldDescriptorProto.fromObject(
                  object.field[i]
                );
            }
          }
          if (object.extension) {
            if (!Array.isArray(object.extension))
              throw TypeError(
                ".google.protobuf.DescriptorProto.extension: array expected"
              );
            message.extension = [];
            for (var i = 0; i < object.extension.length; ++i) {
              if (typeof object.extension[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.extension: object expected"
                );
              message.extension[i] =
                $root.google.protobuf.FieldDescriptorProto.fromObject(
                  object.extension[i]
                );
            }
          }
          if (object.nestedType) {
            if (!Array.isArray(object.nestedType))
              throw TypeError(
                ".google.protobuf.DescriptorProto.nestedType: array expected"
              );
            message.nestedType = [];
            for (var i = 0; i < object.nestedType.length; ++i) {
              if (typeof object.nestedType[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.nestedType: object expected"
                );
              message.nestedType[i] =
                $root.google.protobuf.DescriptorProto.fromObject(
                  object.nestedType[i]
                );
            }
          }
          if (object.enumType) {
            if (!Array.isArray(object.enumType))
              throw TypeError(
                ".google.protobuf.DescriptorProto.enumType: array expected"
              );
            message.enumType = [];
            for (var i = 0; i < object.enumType.length; ++i) {
              if (typeof object.enumType[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.enumType: object expected"
                );
              message.enumType[i] =
                $root.google.protobuf.EnumDescriptorProto.fromObject(
                  object.enumType[i]
                );
            }
          }
          if (object.extensionRange) {
            if (!Array.isArray(object.extensionRange))
              throw TypeError(
                ".google.protobuf.DescriptorProto.extensionRange: array expected"
              );
            message.extensionRange = [];
            for (var i = 0; i < object.extensionRange.length; ++i) {
              if (typeof object.extensionRange[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.extensionRange: object expected"
                );
              message.extensionRange[i] =
                $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(
                  object.extensionRange[i]
                );
            }
          }
          if (object.oneofDecl) {
            if (!Array.isArray(object.oneofDecl))
              throw TypeError(
                ".google.protobuf.DescriptorProto.oneofDecl: array expected"
              );
            message.oneofDecl = [];
            for (var i = 0; i < object.oneofDecl.length; ++i) {
              if (typeof object.oneofDecl[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.oneofDecl: object expected"
                );
              message.oneofDecl[i] =
                $root.google.protobuf.OneofDescriptorProto.fromObject(
                  object.oneofDecl[i]
                );
            }
          }
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.DescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.MessageOptions.fromObject(
              object.options
            );
          }
          if (object.reservedRange) {
            if (!Array.isArray(object.reservedRange))
              throw TypeError(
                ".google.protobuf.DescriptorProto.reservedRange: array expected"
              );
            message.reservedRange = [];
            for (var i = 0; i < object.reservedRange.length; ++i) {
              if (typeof object.reservedRange[i] !== "object")
                throw TypeError(
                  ".google.protobuf.DescriptorProto.reservedRange: object expected"
                );
              message.reservedRange[i] =
                $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(
                  object.reservedRange[i]
                );
            }
          }
          if (object.reservedName) {
            if (!Array.isArray(object.reservedName))
              throw TypeError(
                ".google.protobuf.DescriptorProto.reservedName: array expected"
              );
            message.reservedName = [];
            for (var i = 0; i < object.reservedName.length; ++i)
              message.reservedName[i] = String(object.reservedName[i]);
          }
          return message;
        };

        /**
         * Creates a plain object from a DescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.DescriptorProto
         * @static
         * @param {google.protobuf.DescriptorProto} message DescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.field = [];
            object.nestedType = [];
            object.enumType = [];
            object.extensionRange = [];
            object.extension = [];
            object.oneofDecl = [];
            object.reservedRange = [];
            object.reservedName = [];
          }
          if (options.defaults) {
            object.name = "";
            object.options = null;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.field && message.field.length) {
            object.field = [];
            for (var j = 0; j < message.field.length; ++j)
              object.field[j] =
                $root.google.protobuf.FieldDescriptorProto.toObject(
                  message.field[j],
                  options
                );
          }
          if (message.nestedType && message.nestedType.length) {
            object.nestedType = [];
            for (var j = 0; j < message.nestedType.length; ++j)
              object.nestedType[j] =
                $root.google.protobuf.DescriptorProto.toObject(
                  message.nestedType[j],
                  options
                );
          }
          if (message.enumType && message.enumType.length) {
            object.enumType = [];
            for (var j = 0; j < message.enumType.length; ++j)
              object.enumType[j] =
                $root.google.protobuf.EnumDescriptorProto.toObject(
                  message.enumType[j],
                  options
                );
          }
          if (message.extensionRange && message.extensionRange.length) {
            object.extensionRange = [];
            for (var j = 0; j < message.extensionRange.length; ++j)
              object.extensionRange[j] =
                $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(
                  message.extensionRange[j],
                  options
                );
          }
          if (message.extension && message.extension.length) {
            object.extension = [];
            for (var j = 0; j < message.extension.length; ++j)
              object.extension[j] =
                $root.google.protobuf.FieldDescriptorProto.toObject(
                  message.extension[j],
                  options
                );
          }
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.MessageOptions.toObject(
              message.options,
              options
            );
          if (message.oneofDecl && message.oneofDecl.length) {
            object.oneofDecl = [];
            for (var j = 0; j < message.oneofDecl.length; ++j)
              object.oneofDecl[j] =
                $root.google.protobuf.OneofDescriptorProto.toObject(
                  message.oneofDecl[j],
                  options
                );
          }
          if (message.reservedRange && message.reservedRange.length) {
            object.reservedRange = [];
            for (var j = 0; j < message.reservedRange.length; ++j)
              object.reservedRange[j] =
                $root.google.protobuf.DescriptorProto.ReservedRange.toObject(
                  message.reservedRange[j],
                  options
                );
          }
          if (message.reservedName && message.reservedName.length) {
            object.reservedName = [];
            for (var j = 0; j < message.reservedName.length; ++j)
              object.reservedName[j] = message.reservedName[j];
          }
          return object;
        };

        /**
         * Converts this DescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.DescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DescriptorProto.ExtensionRange = (function () {
          /**
           * Properties of an ExtensionRange.
           * @memberof google.protobuf.DescriptorProto
           * @interface IExtensionRange
           * @property {number|null} [start] ExtensionRange start
           * @property {number|null} [end] ExtensionRange end
           */

          /**
           * Constructs a new ExtensionRange.
           * @memberof google.protobuf.DescriptorProto
           * @classdesc Represents an ExtensionRange.
           * @implements IExtensionRange
           * @constructor
           * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
           */
          function ExtensionRange(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ExtensionRange start.
           * @member {number} start
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @instance
           */
          ExtensionRange.prototype.start = 0;

          /**
           * ExtensionRange end.
           * @member {number} end
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @instance
           */
          ExtensionRange.prototype.end = 0;

          /**
           * Creates a new ExtensionRange instance using the specified properties.
           * @function create
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @static
           * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
           * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
           */
          ExtensionRange.create = function create(properties) {
            return new ExtensionRange(properties);
          };

          /**
           * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
           * @function encode
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @static
           * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ExtensionRange.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.start != null &&
              Object.hasOwnProperty.call(message, "start")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.start);
            if (
              message.end != null &&
              Object.hasOwnProperty.call(message, "end")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.end);
            return writer;
          };

          /**
           * Decodes an ExtensionRange message from the specified reader or buffer.
           * @function decode
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ExtensionRange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.google.protobuf.DescriptorProto.ExtensionRange();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.start = reader.int32();
                  break;
                case 2:
                  message.end = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an ExtensionRange message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
           */
          ExtensionRange.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.google.protobuf.DescriptorProto.ExtensionRange
            )
              return object;
            var message =
              new $root.google.protobuf.DescriptorProto.ExtensionRange();
            if (object.start != null) message.start = object.start | 0;
            if (object.end != null) message.end = object.end | 0;
            return message;
          };

          /**
           * Creates a plain object from an ExtensionRange message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @static
           * @param {google.protobuf.DescriptorProto.ExtensionRange} message ExtensionRange
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ExtensionRange.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.start = 0;
              object.end = 0;
            }
            if (message.start != null && message.hasOwnProperty("start"))
              object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
              object.end = message.end;
            return object;
          };

          /**
           * Converts this ExtensionRange to JSON.
           * @function toJSON
           * @memberof google.protobuf.DescriptorProto.ExtensionRange
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ExtensionRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ExtensionRange;
        })();

        DescriptorProto.ReservedRange = (function () {
          /**
           * Properties of a ReservedRange.
           * @memberof google.protobuf.DescriptorProto
           * @interface IReservedRange
           * @property {number|null} [start] ReservedRange start
           * @property {number|null} [end] ReservedRange end
           */

          /**
           * Constructs a new ReservedRange.
           * @memberof google.protobuf.DescriptorProto
           * @classdesc Represents a ReservedRange.
           * @implements IReservedRange
           * @constructor
           * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
           */
          function ReservedRange(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * ReservedRange start.
           * @member {number} start
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @instance
           */
          ReservedRange.prototype.start = 0;

          /**
           * ReservedRange end.
           * @member {number} end
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @instance
           */
          ReservedRange.prototype.end = 0;

          /**
           * Creates a new ReservedRange instance using the specified properties.
           * @function create
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @static
           * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
           * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
           */
          ReservedRange.create = function create(properties) {
            return new ReservedRange(properties);
          };

          /**
           * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
           * @function encode
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @static
           * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          ReservedRange.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.start != null &&
              Object.hasOwnProperty.call(message, "start")
            )
              writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.start);
            if (
              message.end != null &&
              Object.hasOwnProperty.call(message, "end")
            )
              writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.end);
            return writer;
          };

          /**
           * Decodes a ReservedRange message from the specified reader or buffer.
           * @function decode
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          ReservedRange.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.google.protobuf.DescriptorProto.ReservedRange();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.start = reader.int32();
                  break;
                case 2:
                  message.end = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a ReservedRange message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
           */
          ReservedRange.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.google.protobuf.DescriptorProto.ReservedRange
            )
              return object;
            var message =
              new $root.google.protobuf.DescriptorProto.ReservedRange();
            if (object.start != null) message.start = object.start | 0;
            if (object.end != null) message.end = object.end | 0;
            return message;
          };

          /**
           * Creates a plain object from a ReservedRange message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @static
           * @param {google.protobuf.DescriptorProto.ReservedRange} message ReservedRange
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          ReservedRange.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.start = 0;
              object.end = 0;
            }
            if (message.start != null && message.hasOwnProperty("start"))
              object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
              object.end = message.end;
            return object;
          };

          /**
           * Converts this ReservedRange to JSON.
           * @function toJSON
           * @memberof google.protobuf.DescriptorProto.ReservedRange
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          ReservedRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return ReservedRange;
        })();

        return DescriptorProto;
      })();

      protobuf.FieldDescriptorProto = (function () {
        /**
         * Properties of a FieldDescriptorProto.
         * @memberof google.protobuf
         * @interface IFieldDescriptorProto
         * @property {string|null} [name] FieldDescriptorProto name
         * @property {number|null} [number] FieldDescriptorProto number
         * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
         * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
         * @property {string|null} [typeName] FieldDescriptorProto typeName
         * @property {string|null} [extendee] FieldDescriptorProto extendee
         * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
         * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
         * @property {string|null} [jsonName] FieldDescriptorProto jsonName
         * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
         */

        /**
         * Constructs a new FieldDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents a FieldDescriptorProto.
         * @implements IFieldDescriptorProto
         * @constructor
         * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
         */
        function FieldDescriptorProto(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.name = "";

        /**
         * FieldDescriptorProto number.
         * @member {number} number
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.number = 0;

        /**
         * FieldDescriptorProto label.
         * @member {google.protobuf.FieldDescriptorProto.Label} label
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.label = 1;

        /**
         * FieldDescriptorProto type.
         * @member {google.protobuf.FieldDescriptorProto.Type} type
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.type = 1;

        /**
         * FieldDescriptorProto typeName.
         * @member {string} typeName
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.typeName = "";

        /**
         * FieldDescriptorProto extendee.
         * @member {string} extendee
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.extendee = "";

        /**
         * FieldDescriptorProto defaultValue.
         * @member {string} defaultValue
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.defaultValue = "";

        /**
         * FieldDescriptorProto oneofIndex.
         * @member {number} oneofIndex
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.oneofIndex = 0;

        /**
         * FieldDescriptorProto jsonName.
         * @member {string} jsonName
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.jsonName = "";

        /**
         * FieldDescriptorProto options.
         * @member {google.protobuf.IFieldOptions|null|undefined} options
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         */
        FieldDescriptorProto.prototype.options = null;

        /**
         * Creates a new FieldDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FieldDescriptorProto
         * @static
         * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
         */
        FieldDescriptorProto.create = function create(properties) {
          return new FieldDescriptorProto(properties);
        };

        /**
         * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FieldDescriptorProto
         * @static
         * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FieldDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.extendee != null &&
            Object.hasOwnProperty.call(message, "extendee")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.extendee);
          if (
            message.number != null &&
            Object.hasOwnProperty.call(message, "number")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.number);
          if (
            message.label != null &&
            Object.hasOwnProperty.call(message, "label")
          )
            writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.label);
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.type);
          if (
            message.typeName != null &&
            Object.hasOwnProperty.call(message, "typeName")
          )
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.typeName);
          if (
            message.defaultValue != null &&
            Object.hasOwnProperty.call(message, "defaultValue")
          )
            writer
              .uint32(/* id 7, wireType 2 =*/ 58)
              .string(message.defaultValue);
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.FieldOptions.encode(
              message.options,
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
          if (
            message.oneofIndex != null &&
            Object.hasOwnProperty.call(message, "oneofIndex")
          )
            writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.oneofIndex);
          if (
            message.jsonName != null &&
            Object.hasOwnProperty.call(message, "jsonName")
          )
            writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.jsonName);
          return writer;
        };

        /**
         * Decodes a FieldDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FieldDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FieldDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FieldDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 3:
                message.number = reader.int32();
                break;
              case 4:
                message.label = reader.int32();
                break;
              case 5:
                message.type = reader.int32();
                break;
              case 6:
                message.typeName = reader.string();
                break;
              case 2:
                message.extendee = reader.string();
                break;
              case 7:
                message.defaultValue = reader.string();
                break;
              case 9:
                message.oneofIndex = reader.int32();
                break;
              case 10:
                message.jsonName = reader.string();
                break;
              case 8:
                message.options = $root.google.protobuf.FieldOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FieldDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FieldDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
         */
        FieldDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FieldDescriptorProto)
            return object;
          var message = new $root.google.protobuf.FieldDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.number != null) message.number = object.number | 0;
          switch (object.label) {
            case "LABEL_OPTIONAL":
            case 1:
              message.label = 1;
              break;
            case "LABEL_REQUIRED":
            case 2:
              message.label = 2;
              break;
            case "LABEL_REPEATED":
            case 3:
              message.label = 3;
              break;
          }
          switch (object.type) {
            case "TYPE_DOUBLE":
            case 1:
              message.type = 1;
              break;
            case "TYPE_FLOAT":
            case 2:
              message.type = 2;
              break;
            case "TYPE_INT64":
            case 3:
              message.type = 3;
              break;
            case "TYPE_UINT64":
            case 4:
              message.type = 4;
              break;
            case "TYPE_INT32":
            case 5:
              message.type = 5;
              break;
            case "TYPE_FIXED64":
            case 6:
              message.type = 6;
              break;
            case "TYPE_FIXED32":
            case 7:
              message.type = 7;
              break;
            case "TYPE_BOOL":
            case 8:
              message.type = 8;
              break;
            case "TYPE_STRING":
            case 9:
              message.type = 9;
              break;
            case "TYPE_GROUP":
            case 10:
              message.type = 10;
              break;
            case "TYPE_MESSAGE":
            case 11:
              message.type = 11;
              break;
            case "TYPE_BYTES":
            case 12:
              message.type = 12;
              break;
            case "TYPE_UINT32":
            case 13:
              message.type = 13;
              break;
            case "TYPE_ENUM":
            case 14:
              message.type = 14;
              break;
            case "TYPE_SFIXED32":
            case 15:
              message.type = 15;
              break;
            case "TYPE_SFIXED64":
            case 16:
              message.type = 16;
              break;
            case "TYPE_SINT32":
            case 17:
              message.type = 17;
              break;
            case "TYPE_SINT64":
            case 18:
              message.type = 18;
              break;
          }
          if (object.typeName != null)
            message.typeName = String(object.typeName);
          if (object.extendee != null)
            message.extendee = String(object.extendee);
          if (object.defaultValue != null)
            message.defaultValue = String(object.defaultValue);
          if (object.oneofIndex != null)
            message.oneofIndex = object.oneofIndex | 0;
          if (object.jsonName != null)
            message.jsonName = String(object.jsonName);
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.FieldDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.FieldOptions.fromObject(
              object.options
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a FieldDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FieldDescriptorProto
         * @static
         * @param {google.protobuf.FieldDescriptorProto} message FieldDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = "";
            object.extendee = "";
            object.number = 0;
            object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
            object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
            object.typeName = "";
            object.defaultValue = "";
            object.options = null;
            object.oneofIndex = 0;
            object.jsonName = "";
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.extendee != null && message.hasOwnProperty("extendee"))
            object.extendee = message.extendee;
          if (message.number != null && message.hasOwnProperty("number"))
            object.number = message.number;
          if (message.label != null && message.hasOwnProperty("label"))
            object.label =
              options.enums === String
                ? $root.google.protobuf.FieldDescriptorProto.Label[
                    message.label
                  ]
                : message.label;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type =
              options.enums === String
                ? $root.google.protobuf.FieldDescriptorProto.Type[message.type]
                : message.type;
          if (message.typeName != null && message.hasOwnProperty("typeName"))
            object.typeName = message.typeName;
          if (
            message.defaultValue != null &&
            message.hasOwnProperty("defaultValue")
          )
            object.defaultValue = message.defaultValue;
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.FieldOptions.toObject(
              message.options,
              options
            );
          if (
            message.oneofIndex != null &&
            message.hasOwnProperty("oneofIndex")
          )
            object.oneofIndex = message.oneofIndex;
          if (message.jsonName != null && message.hasOwnProperty("jsonName"))
            object.jsonName = message.jsonName;
          return object;
        };

        /**
         * Converts this FieldDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.FieldDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Type enum.
         * @name google.protobuf.FieldDescriptorProto.Type
         * @enum {string}
         * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
         * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
         * @property {number} TYPE_INT64=3 TYPE_INT64 value
         * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
         * @property {number} TYPE_INT32=5 TYPE_INT32 value
         * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
         * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
         * @property {number} TYPE_BOOL=8 TYPE_BOOL value
         * @property {number} TYPE_STRING=9 TYPE_STRING value
         * @property {number} TYPE_GROUP=10 TYPE_GROUP value
         * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
         * @property {number} TYPE_BYTES=12 TYPE_BYTES value
         * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
         * @property {number} TYPE_ENUM=14 TYPE_ENUM value
         * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
         * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
         * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
         * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
         */
        FieldDescriptorProto.Type = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[1] = "TYPE_DOUBLE")] = 1;
          values[(valuesById[2] = "TYPE_FLOAT")] = 2;
          values[(valuesById[3] = "TYPE_INT64")] = 3;
          values[(valuesById[4] = "TYPE_UINT64")] = 4;
          values[(valuesById[5] = "TYPE_INT32")] = 5;
          values[(valuesById[6] = "TYPE_FIXED64")] = 6;
          values[(valuesById[7] = "TYPE_FIXED32")] = 7;
          values[(valuesById[8] = "TYPE_BOOL")] = 8;
          values[(valuesById[9] = "TYPE_STRING")] = 9;
          values[(valuesById[10] = "TYPE_GROUP")] = 10;
          values[(valuesById[11] = "TYPE_MESSAGE")] = 11;
          values[(valuesById[12] = "TYPE_BYTES")] = 12;
          values[(valuesById[13] = "TYPE_UINT32")] = 13;
          values[(valuesById[14] = "TYPE_ENUM")] = 14;
          values[(valuesById[15] = "TYPE_SFIXED32")] = 15;
          values[(valuesById[16] = "TYPE_SFIXED64")] = 16;
          values[(valuesById[17] = "TYPE_SINT32")] = 17;
          values[(valuesById[18] = "TYPE_SINT64")] = 18;
          return values;
        })();

        /**
         * Label enum.
         * @name google.protobuf.FieldDescriptorProto.Label
         * @enum {string}
         * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
         * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
         * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
         */
        FieldDescriptorProto.Label = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[1] = "LABEL_OPTIONAL")] = 1;
          values[(valuesById[2] = "LABEL_REQUIRED")] = 2;
          values[(valuesById[3] = "LABEL_REPEATED")] = 3;
          return values;
        })();

        return FieldDescriptorProto;
      })();

      protobuf.OneofDescriptorProto = (function () {
        /**
         * Properties of an OneofDescriptorProto.
         * @memberof google.protobuf
         * @interface IOneofDescriptorProto
         * @property {string|null} [name] OneofDescriptorProto name
         * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
         */

        /**
         * Constructs a new OneofDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents an OneofDescriptorProto.
         * @implements IOneofDescriptorProto
         * @constructor
         * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
         */
        function OneofDescriptorProto(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * OneofDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.OneofDescriptorProto
         * @instance
         */
        OneofDescriptorProto.prototype.name = "";

        /**
         * OneofDescriptorProto options.
         * @member {google.protobuf.IOneofOptions|null|undefined} options
         * @memberof google.protobuf.OneofDescriptorProto
         * @instance
         */
        OneofDescriptorProto.prototype.options = null;

        /**
         * Creates a new OneofDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.OneofDescriptorProto
         * @static
         * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
         */
        OneofDescriptorProto.create = function create(properties) {
          return new OneofDescriptorProto(properties);
        };

        /**
         * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.OneofDescriptorProto
         * @static
         * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneofDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.OneofOptions.encode(
              message.options,
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes an OneofDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.OneofDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneofDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.OneofDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message.options = $root.google.protobuf.OneofOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an OneofDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.OneofDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
         */
        OneofDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.OneofDescriptorProto)
            return object;
          var message = new $root.google.protobuf.OneofDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.OneofDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.OneofOptions.fromObject(
              object.options
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an OneofDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.OneofDescriptorProto
         * @static
         * @param {google.protobuf.OneofDescriptorProto} message OneofDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OneofDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = "";
            object.options = null;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.OneofOptions.toObject(
              message.options,
              options
            );
          return object;
        };

        /**
         * Converts this OneofDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.OneofDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OneofDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OneofDescriptorProto;
      })();

      protobuf.EnumDescriptorProto = (function () {
        /**
         * Properties of an EnumDescriptorProto.
         * @memberof google.protobuf
         * @interface IEnumDescriptorProto
         * @property {string|null} [name] EnumDescriptorProto name
         * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
         * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
         */

        /**
         * Constructs a new EnumDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents an EnumDescriptorProto.
         * @implements IEnumDescriptorProto
         * @constructor
         * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
         */
        function EnumDescriptorProto(properties) {
          this.value = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnumDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.EnumDescriptorProto
         * @instance
         */
        EnumDescriptorProto.prototype.name = "";

        /**
         * EnumDescriptorProto value.
         * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
         * @memberof google.protobuf.EnumDescriptorProto
         * @instance
         */
        EnumDescriptorProto.prototype.value = $util.emptyArray;

        /**
         * EnumDescriptorProto options.
         * @member {google.protobuf.IEnumOptions|null|undefined} options
         * @memberof google.protobuf.EnumDescriptorProto
         * @instance
         */
        EnumDescriptorProto.prototype.options = null;

        /**
         * Creates a new EnumDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.EnumDescriptorProto
         * @static
         * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
         */
        EnumDescriptorProto.create = function create(properties) {
          return new EnumDescriptorProto(properties);
        };

        /**
         * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.EnumDescriptorProto
         * @static
         * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnumDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (message.value != null && message.value.length)
            for (var i = 0; i < message.value.length; ++i)
              $root.google.protobuf.EnumValueDescriptorProto.encode(
                message.value[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.EnumOptions.encode(
              message.options,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes an EnumDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.EnumDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnumDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.EnumDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                if (!(message.value && message.value.length))
                  message.value = [];
                message.value.push(
                  $root.google.protobuf.EnumValueDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 3:
                message.options = $root.google.protobuf.EnumOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an EnumDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.EnumDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
         */
        EnumDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.EnumDescriptorProto)
            return object;
          var message = new $root.google.protobuf.EnumDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.value) {
            if (!Array.isArray(object.value))
              throw TypeError(
                ".google.protobuf.EnumDescriptorProto.value: array expected"
              );
            message.value = [];
            for (var i = 0; i < object.value.length; ++i) {
              if (typeof object.value[i] !== "object")
                throw TypeError(
                  ".google.protobuf.EnumDescriptorProto.value: object expected"
                );
              message.value[i] =
                $root.google.protobuf.EnumValueDescriptorProto.fromObject(
                  object.value[i]
                );
            }
          }
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.EnumDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.EnumOptions.fromObject(
              object.options
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an EnumDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.EnumDescriptorProto
         * @static
         * @param {google.protobuf.EnumDescriptorProto} message EnumDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnumDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.value = [];
          if (options.defaults) {
            object.name = "";
            object.options = null;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.value && message.value.length) {
            object.value = [];
            for (var j = 0; j < message.value.length; ++j)
              object.value[j] =
                $root.google.protobuf.EnumValueDescriptorProto.toObject(
                  message.value[j],
                  options
                );
          }
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.EnumOptions.toObject(
              message.options,
              options
            );
          return object;
        };

        /**
         * Converts this EnumDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.EnumDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnumDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnumDescriptorProto;
      })();

      protobuf.EnumValueDescriptorProto = (function () {
        /**
         * Properties of an EnumValueDescriptorProto.
         * @memberof google.protobuf
         * @interface IEnumValueDescriptorProto
         * @property {string|null} [name] EnumValueDescriptorProto name
         * @property {number|null} [number] EnumValueDescriptorProto number
         * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
         */

        /**
         * Constructs a new EnumValueDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents an EnumValueDescriptorProto.
         * @implements IEnumValueDescriptorProto
         * @constructor
         * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
         */
        function EnumValueDescriptorProto(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnumValueDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @instance
         */
        EnumValueDescriptorProto.prototype.name = "";

        /**
         * EnumValueDescriptorProto number.
         * @member {number} number
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @instance
         */
        EnumValueDescriptorProto.prototype.number = 0;

        /**
         * EnumValueDescriptorProto options.
         * @member {google.protobuf.IEnumValueOptions|null|undefined} options
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @instance
         */
        EnumValueDescriptorProto.prototype.options = null;

        /**
         * Creates a new EnumValueDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @static
         * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
         */
        EnumValueDescriptorProto.create = function create(properties) {
          return new EnumValueDescriptorProto(properties);
        };

        /**
         * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @static
         * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnumValueDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.number != null &&
            Object.hasOwnProperty.call(message, "number")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.number);
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.EnumValueOptions.encode(
              message.options,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnumValueDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.EnumValueDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message.number = reader.int32();
                break;
              case 3:
                message.options = $root.google.protobuf.EnumValueOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an EnumValueDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
         */
        EnumValueDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
            return object;
          var message = new $root.google.protobuf.EnumValueDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.number != null) message.number = object.number | 0;
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.EnumValueDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.EnumValueOptions.fromObject(
              object.options
            );
          }
          return message;
        };

        /**
         * Creates a plain object from an EnumValueDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @static
         * @param {google.protobuf.EnumValueDescriptorProto} message EnumValueDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnumValueDescriptorProto.toObject = function toObject(
          message,
          options
        ) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = "";
            object.number = 0;
            object.options = null;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.number != null && message.hasOwnProperty("number"))
            object.number = message.number;
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.EnumValueOptions.toObject(
              message.options,
              options
            );
          return object;
        };

        /**
         * Converts this EnumValueDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.EnumValueDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnumValueDescriptorProto;
      })();

      protobuf.ServiceDescriptorProto = (function () {
        /**
         * Properties of a ServiceDescriptorProto.
         * @memberof google.protobuf
         * @interface IServiceDescriptorProto
         * @property {string|null} [name] ServiceDescriptorProto name
         * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
         * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
         */

        /**
         * Constructs a new ServiceDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents a ServiceDescriptorProto.
         * @implements IServiceDescriptorProto
         * @constructor
         * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
         */
        function ServiceDescriptorProto(properties) {
          this.method = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServiceDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.ServiceDescriptorProto
         * @instance
         */
        ServiceDescriptorProto.prototype.name = "";

        /**
         * ServiceDescriptorProto method.
         * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
         * @memberof google.protobuf.ServiceDescriptorProto
         * @instance
         */
        ServiceDescriptorProto.prototype.method = $util.emptyArray;

        /**
         * ServiceDescriptorProto options.
         * @member {google.protobuf.IServiceOptions|null|undefined} options
         * @memberof google.protobuf.ServiceDescriptorProto
         * @instance
         */
        ServiceDescriptorProto.prototype.options = null;

        /**
         * Creates a new ServiceDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.ServiceDescriptorProto
         * @static
         * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
         */
        ServiceDescriptorProto.create = function create(properties) {
          return new ServiceDescriptorProto(properties);
        };

        /**
         * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.ServiceDescriptorProto
         * @static
         * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServiceDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (message.method != null && message.method.length)
            for (var i = 0; i < message.method.length; ++i)
              $root.google.protobuf.MethodDescriptorProto.encode(
                message.method[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.ServiceOptions.encode(
              message.options,
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.ServiceDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServiceDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.ServiceDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                if (!(message.method && message.method.length))
                  message.method = [];
                message.method.push(
                  $root.google.protobuf.MethodDescriptorProto.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 3:
                message.options = $root.google.protobuf.ServiceOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ServiceDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.ServiceDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
         */
        ServiceDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
            return object;
          var message = new $root.google.protobuf.ServiceDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.method) {
            if (!Array.isArray(object.method))
              throw TypeError(
                ".google.protobuf.ServiceDescriptorProto.method: array expected"
              );
            message.method = [];
            for (var i = 0; i < object.method.length; ++i) {
              if (typeof object.method[i] !== "object")
                throw TypeError(
                  ".google.protobuf.ServiceDescriptorProto.method: object expected"
                );
              message.method[i] =
                $root.google.protobuf.MethodDescriptorProto.fromObject(
                  object.method[i]
                );
            }
          }
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.ServiceDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.ServiceOptions.fromObject(
              object.options
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a ServiceDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.ServiceDescriptorProto
         * @static
         * @param {google.protobuf.ServiceDescriptorProto} message ServiceDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServiceDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.method = [];
          if (options.defaults) {
            object.name = "";
            object.options = null;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.method && message.method.length) {
            object.method = [];
            for (var j = 0; j < message.method.length; ++j)
              object.method[j] =
                $root.google.protobuf.MethodDescriptorProto.toObject(
                  message.method[j],
                  options
                );
          }
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.ServiceOptions.toObject(
              message.options,
              options
            );
          return object;
        };

        /**
         * Converts this ServiceDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.ServiceDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServiceDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ServiceDescriptorProto;
      })();

      protobuf.MethodDescriptorProto = (function () {
        /**
         * Properties of a MethodDescriptorProto.
         * @memberof google.protobuf
         * @interface IMethodDescriptorProto
         * @property {string|null} [name] MethodDescriptorProto name
         * @property {string|null} [inputType] MethodDescriptorProto inputType
         * @property {string|null} [outputType] MethodDescriptorProto outputType
         * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
         * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
         * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
         */

        /**
         * Constructs a new MethodDescriptorProto.
         * @memberof google.protobuf
         * @classdesc Represents a MethodDescriptorProto.
         * @implements IMethodDescriptorProto
         * @constructor
         * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
         */
        function MethodDescriptorProto(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * MethodDescriptorProto name.
         * @member {string} name
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.name = "";

        /**
         * MethodDescriptorProto inputType.
         * @member {string} inputType
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.inputType = "";

        /**
         * MethodDescriptorProto outputType.
         * @member {string} outputType
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.outputType = "";

        /**
         * MethodDescriptorProto options.
         * @member {google.protobuf.IMethodOptions|null|undefined} options
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.options = null;

        /**
         * MethodDescriptorProto clientStreaming.
         * @member {boolean} clientStreaming
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.clientStreaming = false;

        /**
         * MethodDescriptorProto serverStreaming.
         * @member {boolean} serverStreaming
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         */
        MethodDescriptorProto.prototype.serverStreaming = false;

        /**
         * Creates a new MethodDescriptorProto instance using the specified properties.
         * @function create
         * @memberof google.protobuf.MethodDescriptorProto
         * @static
         * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
         * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
         */
        MethodDescriptorProto.create = function create(properties) {
          return new MethodDescriptorProto(properties);
        };

        /**
         * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.MethodDescriptorProto
         * @static
         * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MethodDescriptorProto.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.inputType != null &&
            Object.hasOwnProperty.call(message, "inputType")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.inputType);
          if (
            message.outputType != null &&
            Object.hasOwnProperty.call(message, "outputType")
          )
            writer
              .uint32(/* id 3, wireType 2 =*/ 26)
              .string(message.outputType);
          if (
            message.options != null &&
            Object.hasOwnProperty.call(message, "options")
          )
            $root.google.protobuf.MethodOptions.encode(
              message.options,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          if (
            message.clientStreaming != null &&
            Object.hasOwnProperty.call(message, "clientStreaming")
          )
            writer
              .uint32(/* id 5, wireType 0 =*/ 40)
              .bool(message.clientStreaming);
          if (
            message.serverStreaming != null &&
            Object.hasOwnProperty.call(message, "serverStreaming")
          )
            writer
              .uint32(/* id 6, wireType 0 =*/ 48)
              .bool(message.serverStreaming);
          return writer;
        };

        /**
         * Decodes a MethodDescriptorProto message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.MethodDescriptorProto
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MethodDescriptorProto.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.MethodDescriptorProto();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.name = reader.string();
                break;
              case 2:
                message.inputType = reader.string();
                break;
              case 3:
                message.outputType = reader.string();
                break;
              case 4:
                message.options = $root.google.protobuf.MethodOptions.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 5:
                message.clientStreaming = reader.bool();
                break;
              case 6:
                message.serverStreaming = reader.bool();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a MethodDescriptorProto message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.MethodDescriptorProto
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
         */
        MethodDescriptorProto.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.MethodDescriptorProto)
            return object;
          var message = new $root.google.protobuf.MethodDescriptorProto();
          if (object.name != null) message.name = String(object.name);
          if (object.inputType != null)
            message.inputType = String(object.inputType);
          if (object.outputType != null)
            message.outputType = String(object.outputType);
          if (object.options != null) {
            if (typeof object.options !== "object")
              throw TypeError(
                ".google.protobuf.MethodDescriptorProto.options: object expected"
              );
            message.options = $root.google.protobuf.MethodOptions.fromObject(
              object.options
            );
          }
          if (object.clientStreaming != null)
            message.clientStreaming = Boolean(object.clientStreaming);
          if (object.serverStreaming != null)
            message.serverStreaming = Boolean(object.serverStreaming);
          return message;
        };

        /**
         * Creates a plain object from a MethodDescriptorProto message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.MethodDescriptorProto
         * @static
         * @param {google.protobuf.MethodDescriptorProto} message MethodDescriptorProto
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MethodDescriptorProto.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.name = "";
            object.inputType = "";
            object.outputType = "";
            object.options = null;
            object.clientStreaming = false;
            object.serverStreaming = false;
          }
          if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
          if (message.inputType != null && message.hasOwnProperty("inputType"))
            object.inputType = message.inputType;
          if (
            message.outputType != null &&
            message.hasOwnProperty("outputType")
          )
            object.outputType = message.outputType;
          if (message.options != null && message.hasOwnProperty("options"))
            object.options = $root.google.protobuf.MethodOptions.toObject(
              message.options,
              options
            );
          if (
            message.clientStreaming != null &&
            message.hasOwnProperty("clientStreaming")
          )
            object.clientStreaming = message.clientStreaming;
          if (
            message.serverStreaming != null &&
            message.hasOwnProperty("serverStreaming")
          )
            object.serverStreaming = message.serverStreaming;
          return object;
        };

        /**
         * Converts this MethodDescriptorProto to JSON.
         * @function toJSON
         * @memberof google.protobuf.MethodDescriptorProto
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MethodDescriptorProto.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MethodDescriptorProto;
      })();

      protobuf.FileOptions = (function () {
        /**
         * Properties of a FileOptions.
         * @memberof google.protobuf
         * @interface IFileOptions
         * @property {string|null} [javaPackage] FileOptions javaPackage
         * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
         * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
         * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
         * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
         * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
         * @property {string|null} [goPackage] FileOptions goPackage
         * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
         * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
         * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
         * @property {boolean|null} [deprecated] FileOptions deprecated
         * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
         * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
         * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.fileAudience"] FileOptions .stronachgroup.first.extensions.fileAudience
         * @property {grpc.gateway.protoc_gen_openapiv2.options.ISwagger|null} [".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"] FileOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger
         * @property {Array.<google.api.IResourceDescriptor>|null} [".google.api.resourceDefinition"] FileOptions .google.api.resourceDefinition
         */

        /**
         * Constructs a new FileOptions.
         * @memberof google.protobuf
         * @classdesc Represents a FileOptions.
         * @implements IFileOptions
         * @constructor
         * @param {google.protobuf.IFileOptions=} [properties] Properties to set
         */
        function FileOptions(properties) {
          this.uninterpretedOption = [];
          this[".google.api.resourceDefinition"] = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileOptions javaPackage.
         * @member {string} javaPackage
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaPackage = "";

        /**
         * FileOptions javaOuterClassname.
         * @member {string} javaOuterClassname
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaOuterClassname = "";

        /**
         * FileOptions javaMultipleFiles.
         * @member {boolean} javaMultipleFiles
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaMultipleFiles = false;

        /**
         * FileOptions javaGenerateEqualsAndHash.
         * @member {boolean} javaGenerateEqualsAndHash
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaGenerateEqualsAndHash = false;

        /**
         * FileOptions javaStringCheckUtf8.
         * @member {boolean} javaStringCheckUtf8
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaStringCheckUtf8 = false;

        /**
         * FileOptions optimizeFor.
         * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.optimizeFor = 1;

        /**
         * FileOptions goPackage.
         * @member {string} goPackage
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.goPackage = "";

        /**
         * FileOptions ccGenericServices.
         * @member {boolean} ccGenericServices
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.ccGenericServices = false;

        /**
         * FileOptions javaGenericServices.
         * @member {boolean} javaGenericServices
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.javaGenericServices = false;

        /**
         * FileOptions pyGenericServices.
         * @member {boolean} pyGenericServices
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.pyGenericServices = false;

        /**
         * FileOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.deprecated = false;

        /**
         * FileOptions ccEnableArenas.
         * @member {boolean} ccEnableArenas
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.ccEnableArenas = false;

        /**
         * FileOptions objcClassPrefix.
         * @member {string} objcClassPrefix
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.objcClassPrefix = "";

        /**
         * FileOptions csharpNamespace.
         * @member {string} csharpNamespace
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.csharpNamespace = "";

        /**
         * FileOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * FileOptions .stronachgroup.first.extensions.fileAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.fileAudience
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype[
          ".stronachgroup.first.extensions.fileAudience"
        ] = 0;

        /**
         * FileOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger.
         * @member {grpc.gateway.protoc_gen_openapiv2.options.ISwagger|null|undefined} .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype[
          ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
        ] = null;

        /**
         * FileOptions .google.api.resourceDefinition.
         * @member {Array.<google.api.IResourceDescriptor>} .google.api.resourceDefinition
         * @memberof google.protobuf.FileOptions
         * @instance
         */
        FileOptions.prototype[".google.api.resourceDefinition"] =
          $util.emptyArray;

        /**
         * Creates a new FileOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FileOptions
         * @static
         * @param {google.protobuf.IFileOptions=} [properties] Properties to set
         * @returns {google.protobuf.FileOptions} FileOptions instance
         */
        FileOptions.create = function create(properties) {
          return new FileOptions(properties);
        };

        /**
         * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FileOptions
         * @static
         * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.javaPackage != null &&
            Object.hasOwnProperty.call(message, "javaPackage")
          )
            writer
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(message.javaPackage);
          if (
            message.javaOuterClassname != null &&
            Object.hasOwnProperty.call(message, "javaOuterClassname")
          )
            writer
              .uint32(/* id 8, wireType 2 =*/ 66)
              .string(message.javaOuterClassname);
          if (
            message.optimizeFor != null &&
            Object.hasOwnProperty.call(message, "optimizeFor")
          )
            writer
              .uint32(/* id 9, wireType 0 =*/ 72)
              .int32(message.optimizeFor);
          if (
            message.javaMultipleFiles != null &&
            Object.hasOwnProperty.call(message, "javaMultipleFiles")
          )
            writer
              .uint32(/* id 10, wireType 0 =*/ 80)
              .bool(message.javaMultipleFiles);
          if (
            message.goPackage != null &&
            Object.hasOwnProperty.call(message, "goPackage")
          )
            writer
              .uint32(/* id 11, wireType 2 =*/ 90)
              .string(message.goPackage);
          if (
            message.ccGenericServices != null &&
            Object.hasOwnProperty.call(message, "ccGenericServices")
          )
            writer
              .uint32(/* id 16, wireType 0 =*/ 128)
              .bool(message.ccGenericServices);
          if (
            message.javaGenericServices != null &&
            Object.hasOwnProperty.call(message, "javaGenericServices")
          )
            writer
              .uint32(/* id 17, wireType 0 =*/ 136)
              .bool(message.javaGenericServices);
          if (
            message.pyGenericServices != null &&
            Object.hasOwnProperty.call(message, "pyGenericServices")
          )
            writer
              .uint32(/* id 18, wireType 0 =*/ 144)
              .bool(message.pyGenericServices);
          if (
            message.javaGenerateEqualsAndHash != null &&
            Object.hasOwnProperty.call(message, "javaGenerateEqualsAndHash")
          )
            writer
              .uint32(/* id 20, wireType 0 =*/ 160)
              .bool(message.javaGenerateEqualsAndHash);
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer
              .uint32(/* id 23, wireType 0 =*/ 184)
              .bool(message.deprecated);
          if (
            message.javaStringCheckUtf8 != null &&
            Object.hasOwnProperty.call(message, "javaStringCheckUtf8")
          )
            writer
              .uint32(/* id 27, wireType 0 =*/ 216)
              .bool(message.javaStringCheckUtf8);
          if (
            message.ccEnableArenas != null &&
            Object.hasOwnProperty.call(message, "ccEnableArenas")
          )
            writer
              .uint32(/* id 31, wireType 0 =*/ 248)
              .bool(message.ccEnableArenas);
          if (
            message.objcClassPrefix != null &&
            Object.hasOwnProperty.call(message, "objcClassPrefix")
          )
            writer
              .uint32(/* id 36, wireType 2 =*/ 290)
              .string(message.objcClassPrefix);
          if (
            message.csharpNamespace != null &&
            Object.hasOwnProperty.call(message, "csharpNamespace")
          )
            writer
              .uint32(/* id 37, wireType 2 =*/ 298)
              .string(message.csharpNamespace);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] != null &&
            Object.hasOwnProperty.call(
              message,
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            )
          )
            $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger.encode(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
              ],
              writer.uint32(/* id 1042, wireType 2 =*/ 8338).fork()
            ).ldelim();
          if (
            message[".google.api.resourceDefinition"] != null &&
            message[".google.api.resourceDefinition"].length
          )
            for (
              var i = 0;
              i < message[".google.api.resourceDefinition"].length;
              ++i
            )
              $root.google.api.ResourceDescriptor.encode(
                message[".google.api.resourceDefinition"][i],
                writer.uint32(/* id 1053, wireType 2 =*/ 8426).fork()
              ).ldelim();
          if (
            message[".stronachgroup.first.extensions.fileAudience"] != null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.fileAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(message[".stronachgroup.first.extensions.fileAudience"]);
          return writer;
        };

        /**
         * Decodes a FileOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FileOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FileOptions} FileOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FileOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.javaPackage = reader.string();
                break;
              case 8:
                message.javaOuterClassname = reader.string();
                break;
              case 10:
                message.javaMultipleFiles = reader.bool();
                break;
              case 20:
                message.javaGenerateEqualsAndHash = reader.bool();
                break;
              case 27:
                message.javaStringCheckUtf8 = reader.bool();
                break;
              case 9:
                message.optimizeFor = reader.int32();
                break;
              case 11:
                message.goPackage = reader.string();
                break;
              case 16:
                message.ccGenericServices = reader.bool();
                break;
              case 17:
                message.javaGenericServices = reader.bool();
                break;
              case 18:
                message.pyGenericServices = reader.bool();
                break;
              case 23:
                message.deprecated = reader.bool();
                break;
              case 31:
                message.ccEnableArenas = reader.bool();
                break;
              case 36:
                message.objcClassPrefix = reader.string();
                break;
              case 37:
                message.csharpNamespace = reader.string();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.fileAudience"] =
                  reader.int32();
                break;
              case 1042:
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
                ] =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 1053:
                if (
                  !(
                    message[".google.api.resourceDefinition"] &&
                    message[".google.api.resourceDefinition"].length
                  )
                )
                  message[".google.api.resourceDefinition"] = [];
                message[".google.api.resourceDefinition"].push(
                  $root.google.api.ResourceDescriptor.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FileOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FileOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FileOptions} FileOptions
         */
        FileOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FileOptions)
            return object;
          var message = new $root.google.protobuf.FileOptions();
          if (object.javaPackage != null)
            message.javaPackage = String(object.javaPackage);
          if (object.javaOuterClassname != null)
            message.javaOuterClassname = String(object.javaOuterClassname);
          if (object.javaMultipleFiles != null)
            message.javaMultipleFiles = Boolean(object.javaMultipleFiles);
          if (object.javaGenerateEqualsAndHash != null)
            message.javaGenerateEqualsAndHash = Boolean(
              object.javaGenerateEqualsAndHash
            );
          if (object.javaStringCheckUtf8 != null)
            message.javaStringCheckUtf8 = Boolean(object.javaStringCheckUtf8);
          switch (object.optimizeFor) {
            case "SPEED":
            case 1:
              message.optimizeFor = 1;
              break;
            case "CODE_SIZE":
            case 2:
              message.optimizeFor = 2;
              break;
            case "LITE_RUNTIME":
            case 3:
              message.optimizeFor = 3;
              break;
          }
          if (object.goPackage != null)
            message.goPackage = String(object.goPackage);
          if (object.ccGenericServices != null)
            message.ccGenericServices = Boolean(object.ccGenericServices);
          if (object.javaGenericServices != null)
            message.javaGenericServices = Boolean(object.javaGenericServices);
          if (object.pyGenericServices != null)
            message.pyGenericServices = Boolean(object.pyGenericServices);
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.ccEnableArenas != null)
            message.ccEnableArenas = Boolean(object.ccEnableArenas);
          if (object.objcClassPrefix != null)
            message.objcClassPrefix = String(object.objcClassPrefix);
          if (object.csharpNamespace != null)
            message.csharpNamespace = String(object.csharpNamespace);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.FileOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FileOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.fileAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.fileAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.fileAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.fileAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.fileAudience"] = 3;
              break;
          }
          if (
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] != null
          ) {
            if (
              typeof object[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
              ] !== "object"
            )
              throw TypeError(
                ".google.protobuf.FileOptions..grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger: object expected"
              );
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger.fromObject(
                object[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
                ]
              );
          }
          if (object[".google.api.resourceDefinition"]) {
            if (!Array.isArray(object[".google.api.resourceDefinition"]))
              throw TypeError(
                ".google.protobuf.FileOptions..google.api.resourceDefinition: array expected"
              );
            message[".google.api.resourceDefinition"] = [];
            for (
              var i = 0;
              i < object[".google.api.resourceDefinition"].length;
              ++i
            ) {
              if (
                typeof object[".google.api.resourceDefinition"][i] !== "object"
              )
                throw TypeError(
                  ".google.protobuf.FileOptions..google.api.resourceDefinition: object expected"
                );
              message[".google.api.resourceDefinition"][i] =
                $root.google.api.ResourceDescriptor.fromObject(
                  object[".google.api.resourceDefinition"][i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a FileOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FileOptions
         * @static
         * @param {google.protobuf.FileOptions} message FileOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.uninterpretedOption = [];
            object[".google.api.resourceDefinition"] = [];
          }
          if (options.defaults) {
            object.javaPackage = "";
            object.javaOuterClassname = "";
            object.optimizeFor = options.enums === String ? "SPEED" : 1;
            object.javaMultipleFiles = false;
            object.goPackage = "";
            object.ccGenericServices = false;
            object.javaGenericServices = false;
            object.pyGenericServices = false;
            object.javaGenerateEqualsAndHash = false;
            object.deprecated = false;
            object.javaStringCheckUtf8 = false;
            object.ccEnableArenas = false;
            object.objcClassPrefix = "";
            object.csharpNamespace = "";
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] = null;
            object[".stronachgroup.first.extensions.fileAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
          }
          if (
            message.javaPackage != null &&
            message.hasOwnProperty("javaPackage")
          )
            object.javaPackage = message.javaPackage;
          if (
            message.javaOuterClassname != null &&
            message.hasOwnProperty("javaOuterClassname")
          )
            object.javaOuterClassname = message.javaOuterClassname;
          if (
            message.optimizeFor != null &&
            message.hasOwnProperty("optimizeFor")
          )
            object.optimizeFor =
              options.enums === String
                ? $root.google.protobuf.FileOptions.OptimizeMode[
                    message.optimizeFor
                  ]
                : message.optimizeFor;
          if (
            message.javaMultipleFiles != null &&
            message.hasOwnProperty("javaMultipleFiles")
          )
            object.javaMultipleFiles = message.javaMultipleFiles;
          if (message.goPackage != null && message.hasOwnProperty("goPackage"))
            object.goPackage = message.goPackage;
          if (
            message.ccGenericServices != null &&
            message.hasOwnProperty("ccGenericServices")
          )
            object.ccGenericServices = message.ccGenericServices;
          if (
            message.javaGenericServices != null &&
            message.hasOwnProperty("javaGenericServices")
          )
            object.javaGenericServices = message.javaGenericServices;
          if (
            message.pyGenericServices != null &&
            message.hasOwnProperty("pyGenericServices")
          )
            object.pyGenericServices = message.pyGenericServices;
          if (
            message.javaGenerateEqualsAndHash != null &&
            message.hasOwnProperty("javaGenerateEqualsAndHash")
          )
            object.javaGenerateEqualsAndHash =
              message.javaGenerateEqualsAndHash;
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (
            message.javaStringCheckUtf8 != null &&
            message.hasOwnProperty("javaStringCheckUtf8")
          )
            object.javaStringCheckUtf8 = message.javaStringCheckUtf8;
          if (
            message.ccEnableArenas != null &&
            message.hasOwnProperty("ccEnableArenas")
          )
            object.ccEnableArenas = message.ccEnableArenas;
          if (
            message.objcClassPrefix != null &&
            message.hasOwnProperty("objcClassPrefix")
          )
            object.objcClassPrefix = message.objcClassPrefix;
          if (
            message.csharpNamespace != null &&
            message.hasOwnProperty("csharpNamespace")
          )
            object.csharpNamespace = message.csharpNamespace;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] != null &&
            message.hasOwnProperty(
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            )
          )
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Swagger.toObject(
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Swagger"
                ],
                options
              );
          if (
            message[".google.api.resourceDefinition"] &&
            message[".google.api.resourceDefinition"].length
          ) {
            object[".google.api.resourceDefinition"] = [];
            for (
              var j = 0;
              j < message[".google.api.resourceDefinition"].length;
              ++j
            )
              object[".google.api.resourceDefinition"][j] =
                $root.google.api.ResourceDescriptor.toObject(
                  message[".google.api.resourceDefinition"][j],
                  options
                );
          }
          if (
            message[".stronachgroup.first.extensions.fileAudience"] != null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.fileAudience"
            )
          )
            object[".stronachgroup.first.extensions.fileAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.fileAudience"]
                  ]
                : message[".stronachgroup.first.extensions.fileAudience"];
          return object;
        };

        /**
         * Converts this FileOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.FileOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * OptimizeMode enum.
         * @name google.protobuf.FileOptions.OptimizeMode
         * @enum {string}
         * @property {number} SPEED=1 SPEED value
         * @property {number} CODE_SIZE=2 CODE_SIZE value
         * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
         */
        FileOptions.OptimizeMode = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[1] = "SPEED")] = 1;
          values[(valuesById[2] = "CODE_SIZE")] = 2;
          values[(valuesById[3] = "LITE_RUNTIME")] = 3;
          return values;
        })();

        return FileOptions;
      })();

      protobuf.MessageOptions = (function () {
        /**
         * Properties of a MessageOptions.
         * @memberof google.protobuf
         * @interface IMessageOptions
         * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
         * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
         * @property {boolean|null} [deprecated] MessageOptions deprecated
         * @property {boolean|null} [mapEntry] MessageOptions mapEntry
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.ITopicOptions|null} [".stronachgroup.first.extensions.topicOptions"] MessageOptions .stronachgroup.first.extensions.topicOptions
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.messageAudience"] MessageOptions .stronachgroup.first.extensions.messageAudience
         * @property {grpc.gateway.protoc_gen_openapiv2.options.ISchema|null} [".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"] MessageOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema
         * @property {google.api.IResourceDescriptor|null} [".google.api.resource"] MessageOptions .google.api.resource
         * @property {google.api.IVisibilityRule|null} [".google.api.messageVisibility"] MessageOptions .google.api.messageVisibility
         */

        /**
         * Constructs a new MessageOptions.
         * @memberof google.protobuf
         * @classdesc Represents a MessageOptions.
         * @implements IMessageOptions
         * @constructor
         * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
         */
        function MessageOptions(properties) {
          this.uninterpretedOption = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageOptions messageSetWireFormat.
         * @member {boolean} messageSetWireFormat
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype.messageSetWireFormat = false;

        /**
         * MessageOptions noStandardDescriptorAccessor.
         * @member {boolean} noStandardDescriptorAccessor
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype.noStandardDescriptorAccessor = false;

        /**
         * MessageOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype.deprecated = false;

        /**
         * MessageOptions mapEntry.
         * @member {boolean} mapEntry
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype.mapEntry = false;

        /**
         * MessageOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * MessageOptions .stronachgroup.first.extensions.topicOptions.
         * @member {stronachgroup.first.extensions.ITopicOptions|null|undefined} .stronachgroup.first.extensions.topicOptions
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype[
          ".stronachgroup.first.extensions.topicOptions"
        ] = null;

        /**
         * MessageOptions .stronachgroup.first.extensions.messageAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.messageAudience
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype[
          ".stronachgroup.first.extensions.messageAudience"
        ] = 0;

        /**
         * MessageOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema.
         * @member {grpc.gateway.protoc_gen_openapiv2.options.ISchema|null|undefined} .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype[
          ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
        ] = null;

        /**
         * MessageOptions .google.api.resource.
         * @member {google.api.IResourceDescriptor|null|undefined} .google.api.resource
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype[".google.api.resource"] = null;

        /**
         * MessageOptions .google.api.messageVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.messageVisibility
         * @memberof google.protobuf.MessageOptions
         * @instance
         */
        MessageOptions.prototype[".google.api.messageVisibility"] = null;

        /**
         * Creates a new MessageOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.MessageOptions
         * @static
         * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
         * @returns {google.protobuf.MessageOptions} MessageOptions instance
         */
        MessageOptions.create = function create(properties) {
          return new MessageOptions(properties);
        };

        /**
         * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.MessageOptions
         * @static
         * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.messageSetWireFormat != null &&
            Object.hasOwnProperty.call(message, "messageSetWireFormat")
          )
            writer
              .uint32(/* id 1, wireType 0 =*/ 8)
              .bool(message.messageSetWireFormat);
          if (
            message.noStandardDescriptorAccessor != null &&
            Object.hasOwnProperty.call(message, "noStandardDescriptorAccessor")
          )
            writer
              .uint32(/* id 2, wireType 0 =*/ 16)
              .bool(message.noStandardDescriptorAccessor);
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.deprecated);
          if (
            message.mapEntry != null &&
            Object.hasOwnProperty.call(message, "mapEntry")
          )
            writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.mapEntry);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] != null &&
            Object.hasOwnProperty.call(
              message,
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            )
          )
            $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.encode(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
              ],
              writer.uint32(/* id 1042, wireType 2 =*/ 8338).fork()
            ).ldelim();
          if (
            message[".google.api.resource"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.resource")
          )
            $root.google.api.ResourceDescriptor.encode(
              message[".google.api.resource"],
              writer.uint32(/* id 1053, wireType 2 =*/ 8426).fork()
            ).ldelim();
          if (
            message[".stronachgroup.first.extensions.topicOptions"] != null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.topicOptions"
            )
          )
            $root.stronachgroup.first.extensions.TopicOptions.encode(
              message[".stronachgroup.first.extensions.topicOptions"],
              writer.uint32(/* id 2050, wireType 2 =*/ 16402).fork()
            ).ldelim();
          if (
            message[".stronachgroup.first.extensions.messageAudience"] !=
              null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.messageAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(
                message[".stronachgroup.first.extensions.messageAudience"]
              );
          if (
            message[".google.api.messageVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.messageVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.messageVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a MessageOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.MessageOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.MessageOptions} MessageOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.MessageOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.messageSetWireFormat = reader.bool();
                break;
              case 2:
                message.noStandardDescriptorAccessor = reader.bool();
                break;
              case 3:
                message.deprecated = reader.bool();
                break;
              case 7:
                message.mapEntry = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2050:
                message[".stronachgroup.first.extensions.topicOptions"] =
                  $root.stronachgroup.first.extensions.TopicOptions.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.messageAudience"] =
                  reader.int32();
                break;
              case 1042:
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
                ] =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 1053:
                message[".google.api.resource"] =
                  $root.google.api.ResourceDescriptor.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 72295727:
                message[".google.api.messageVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a MessageOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.MessageOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.MessageOptions} MessageOptions
         */
        MessageOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.MessageOptions)
            return object;
          var message = new $root.google.protobuf.MessageOptions();
          if (object.messageSetWireFormat != null)
            message.messageSetWireFormat = Boolean(object.messageSetWireFormat);
          if (object.noStandardDescriptorAccessor != null)
            message.noStandardDescriptorAccessor = Boolean(
              object.noStandardDescriptorAccessor
            );
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.mapEntry != null)
            message.mapEntry = Boolean(object.mapEntry);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.MessageOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.MessageOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          if (object[".stronachgroup.first.extensions.topicOptions"] != null) {
            if (
              typeof object[".stronachgroup.first.extensions.topicOptions"] !==
              "object"
            )
              throw TypeError(
                ".google.protobuf.MessageOptions..stronachgroup.first.extensions.topicOptions: object expected"
              );
            message[".stronachgroup.first.extensions.topicOptions"] =
              $root.stronachgroup.first.extensions.TopicOptions.fromObject(
                object[".stronachgroup.first.extensions.topicOptions"]
              );
          }
          switch (object[".stronachgroup.first.extensions.messageAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.messageAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.messageAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.messageAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.messageAudience"] = 3;
              break;
          }
          if (
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] != null
          ) {
            if (
              typeof object[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
              ] !== "object"
            )
              throw TypeError(
                ".google.protobuf.MessageOptions..grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema: object expected"
              );
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.fromObject(
                object[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
                ]
              );
          }
          if (object[".google.api.resource"] != null) {
            if (typeof object[".google.api.resource"] !== "object")
              throw TypeError(
                ".google.protobuf.MessageOptions..google.api.resource: object expected"
              );
            message[".google.api.resource"] =
              $root.google.api.ResourceDescriptor.fromObject(
                object[".google.api.resource"]
              );
          }
          if (object[".google.api.messageVisibility"] != null) {
            if (typeof object[".google.api.messageVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.MessageOptions..google.api.messageVisibility: object expected"
              );
            message[".google.api.messageVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.messageVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from a MessageOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.MessageOptions
         * @static
         * @param {google.protobuf.MessageOptions} message MessageOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.uninterpretedOption = [];
          if (options.defaults) {
            object.messageSetWireFormat = false;
            object.noStandardDescriptorAccessor = false;
            object.deprecated = false;
            object.mapEntry = false;
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] = null;
            object[".google.api.resource"] = null;
            object[".stronachgroup.first.extensions.topicOptions"] = null;
            object[".stronachgroup.first.extensions.messageAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.messageVisibility"] = null;
          }
          if (
            message.messageSetWireFormat != null &&
            message.hasOwnProperty("messageSetWireFormat")
          )
            object.messageSetWireFormat = message.messageSetWireFormat;
          if (
            message.noStandardDescriptorAccessor != null &&
            message.hasOwnProperty("noStandardDescriptorAccessor")
          )
            object.noStandardDescriptorAccessor =
              message.noStandardDescriptorAccessor;
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
            object.mapEntry = message.mapEntry;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] != null &&
            message.hasOwnProperty(
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            )
          )
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
            ] = $root.grpc.gateway.protoc_gen_openapiv2.options.Schema.toObject(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Schema"
              ],
              options
            );
          if (
            message[".google.api.resource"] != null &&
            message.hasOwnProperty(".google.api.resource")
          )
            object[".google.api.resource"] =
              $root.google.api.ResourceDescriptor.toObject(
                message[".google.api.resource"],
                options
              );
          if (
            message[".stronachgroup.first.extensions.topicOptions"] != null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.topicOptions"
            )
          )
            object[".stronachgroup.first.extensions.topicOptions"] =
              $root.stronachgroup.first.extensions.TopicOptions.toObject(
                message[".stronachgroup.first.extensions.topicOptions"],
                options
              );
          if (
            message[".stronachgroup.first.extensions.messageAudience"] !=
              null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.messageAudience"
            )
          )
            object[".stronachgroup.first.extensions.messageAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.messageAudience"]
                  ]
                : message[".stronachgroup.first.extensions.messageAudience"];
          if (
            message[".google.api.messageVisibility"] != null &&
            message.hasOwnProperty(".google.api.messageVisibility")
          )
            object[".google.api.messageVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.messageVisibility"],
                options
              );
          return object;
        };

        /**
         * Converts this MessageOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.MessageOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessageOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageOptions;
      })();

      protobuf.FieldOptions = (function () {
        /**
         * Properties of a FieldOptions.
         * @memberof google.protobuf
         * @interface IFieldOptions
         * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
         * @property {boolean|null} [packed] FieldOptions packed
         * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
         * @property {boolean|null} [lazy] FieldOptions lazy
         * @property {boolean|null} [deprecated] FieldOptions deprecated
         * @property {boolean|null} [weak] FieldOptions weak
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.fieldAudience"] FieldOptions .stronachgroup.first.extensions.fieldAudience
         * @property {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema|null} [".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"] FieldOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field
         * @property {Array.<google.api.FieldBehavior>|null} [".google.api.fieldBehavior"] FieldOptions .google.api.fieldBehavior
         * @property {google.api.IResourceReference|null} [".google.api.resourceReference"] FieldOptions .google.api.resourceReference
         * @property {google.api.IVisibilityRule|null} [".google.api.fieldVisibility"] FieldOptions .google.api.fieldVisibility
         */

        /**
         * Constructs a new FieldOptions.
         * @memberof google.protobuf
         * @classdesc Represents a FieldOptions.
         * @implements IFieldOptions
         * @constructor
         * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
         */
        function FieldOptions(properties) {
          this.uninterpretedOption = [];
          this[".google.api.fieldBehavior"] = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldOptions ctype.
         * @member {google.protobuf.FieldOptions.CType} ctype
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.ctype = 0;

        /**
         * FieldOptions packed.
         * @member {boolean} packed
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.packed = false;

        /**
         * FieldOptions jstype.
         * @member {google.protobuf.FieldOptions.JSType} jstype
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.jstype = 0;

        /**
         * FieldOptions lazy.
         * @member {boolean} lazy
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.lazy = false;

        /**
         * FieldOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.deprecated = false;

        /**
         * FieldOptions weak.
         * @member {boolean} weak
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.weak = false;

        /**
         * FieldOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * FieldOptions .stronachgroup.first.extensions.fieldAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.fieldAudience
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype[
          ".stronachgroup.first.extensions.fieldAudience"
        ] = 0;

        /**
         * FieldOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field.
         * @member {grpc.gateway.protoc_gen_openapiv2.options.IJSONSchema|null|undefined} .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype[
          ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
        ] = null;

        /**
         * FieldOptions .google.api.fieldBehavior.
         * @member {Array.<google.api.FieldBehavior>} .google.api.fieldBehavior
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype[".google.api.fieldBehavior"] = $util.emptyArray;

        /**
         * FieldOptions .google.api.resourceReference.
         * @member {google.api.IResourceReference|null|undefined} .google.api.resourceReference
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype[".google.api.resourceReference"] = null;

        /**
         * FieldOptions .google.api.fieldVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.fieldVisibility
         * @memberof google.protobuf.FieldOptions
         * @instance
         */
        FieldOptions.prototype[".google.api.fieldVisibility"] = null;

        /**
         * Creates a new FieldOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FieldOptions
         * @static
         * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
         * @returns {google.protobuf.FieldOptions} FieldOptions instance
         */
        FieldOptions.create = function create(properties) {
          return new FieldOptions(properties);
        };

        /**
         * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FieldOptions
         * @static
         * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FieldOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.ctype != null &&
            Object.hasOwnProperty.call(message, "ctype")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.ctype);
          if (
            message.packed != null &&
            Object.hasOwnProperty.call(message, "packed")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.packed);
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.deprecated);
          if (
            message.lazy != null &&
            Object.hasOwnProperty.call(message, "lazy")
          )
            writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.lazy);
          if (
            message.jstype != null &&
            Object.hasOwnProperty.call(message, "jstype")
          )
            writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.jstype);
          if (
            message.weak != null &&
            Object.hasOwnProperty.call(message, "weak")
          )
            writer.uint32(/* id 10, wireType 0 =*/ 80).bool(message.weak);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] != null &&
            Object.hasOwnProperty.call(
              message,
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            )
          )
            $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.encode(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
              ],
              writer.uint32(/* id 1042, wireType 2 =*/ 8338).fork()
            ).ldelim();
          if (
            message[".google.api.fieldBehavior"] != null &&
            message[".google.api.fieldBehavior"].length
          ) {
            writer.uint32(/* id 1052, wireType 2 =*/ 8418).fork();
            for (
              var i = 0;
              i < message[".google.api.fieldBehavior"].length;
              ++i
            )
              writer.int32(message[".google.api.fieldBehavior"][i]);
            writer.ldelim();
          }
          if (
            message[".google.api.resourceReference"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.resourceReference")
          )
            $root.google.api.ResourceReference.encode(
              message[".google.api.resourceReference"],
              writer.uint32(/* id 1055, wireType 2 =*/ 8442).fork()
            ).ldelim();
          if (
            message[".stronachgroup.first.extensions.fieldAudience"] != null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.fieldAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(message[".stronachgroup.first.extensions.fieldAudience"]);
          if (
            message[".google.api.fieldVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.fieldVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.fieldVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a FieldOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FieldOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FieldOptions} FieldOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FieldOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FieldOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.ctype = reader.int32();
                break;
              case 2:
                message.packed = reader.bool();
                break;
              case 6:
                message.jstype = reader.int32();
                break;
              case 5:
                message.lazy = reader.bool();
                break;
              case 3:
                message.deprecated = reader.bool();
                break;
              case 10:
                message.weak = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.fieldAudience"] =
                  reader.int32();
                break;
              case 1042:
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
                ] =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 1052:
                if (
                  !(
                    message[".google.api.fieldBehavior"] &&
                    message[".google.api.fieldBehavior"].length
                  )
                )
                  message[".google.api.fieldBehavior"] = [];
                if ((tag & 7) === 2) {
                  var end2 = reader.uint32() + reader.pos;
                  while (reader.pos < end2)
                    message[".google.api.fieldBehavior"].push(reader.int32());
                } else
                  message[".google.api.fieldBehavior"].push(reader.int32());
                break;
              case 1055:
                message[".google.api.resourceReference"] =
                  $root.google.api.ResourceReference.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 72295727:
                message[".google.api.fieldVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FieldOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FieldOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FieldOptions} FieldOptions
         */
        FieldOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FieldOptions)
            return object;
          var message = new $root.google.protobuf.FieldOptions();
          switch (object.ctype) {
            case "STRING":
            case 0:
              message.ctype = 0;
              break;
            case "CORD":
            case 1:
              message.ctype = 1;
              break;
            case "STRING_PIECE":
            case 2:
              message.ctype = 2;
              break;
          }
          if (object.packed != null) message.packed = Boolean(object.packed);
          switch (object.jstype) {
            case "JS_NORMAL":
            case 0:
              message.jstype = 0;
              break;
            case "JS_STRING":
            case 1:
              message.jstype = 1;
              break;
            case "JS_NUMBER":
            case 2:
              message.jstype = 2;
              break;
          }
          if (object.lazy != null) message.lazy = Boolean(object.lazy);
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.weak != null) message.weak = Boolean(object.weak);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.FieldOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.FieldOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.fieldAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.fieldAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.fieldAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.fieldAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.fieldAudience"] = 3;
              break;
          }
          if (
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] != null
          ) {
            if (
              typeof object[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
              ] !== "object"
            )
              throw TypeError(
                ".google.protobuf.FieldOptions..grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field: object expected"
              );
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.fromObject(
                object[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
                ]
              );
          }
          if (object[".google.api.fieldBehavior"]) {
            if (!Array.isArray(object[".google.api.fieldBehavior"]))
              throw TypeError(
                ".google.protobuf.FieldOptions..google.api.fieldBehavior: array expected"
              );
            message[".google.api.fieldBehavior"] = [];
            for (var i = 0; i < object[".google.api.fieldBehavior"].length; ++i)
              switch (object[".google.api.fieldBehavior"][i]) {
                default:
                case "FIELD_BEHAVIOR_UNSPECIFIED":
                case 0:
                  message[".google.api.fieldBehavior"][i] = 0;
                  break;
                case "OPTIONAL":
                case 1:
                  message[".google.api.fieldBehavior"][i] = 1;
                  break;
                case "REQUIRED":
                case 2:
                  message[".google.api.fieldBehavior"][i] = 2;
                  break;
                case "OUTPUT_ONLY":
                case 3:
                  message[".google.api.fieldBehavior"][i] = 3;
                  break;
                case "INPUT_ONLY":
                case 4:
                  message[".google.api.fieldBehavior"][i] = 4;
                  break;
                case "IMMUTABLE":
                case 5:
                  message[".google.api.fieldBehavior"][i] = 5;
                  break;
              }
          }
          if (object[".google.api.resourceReference"] != null) {
            if (typeof object[".google.api.resourceReference"] !== "object")
              throw TypeError(
                ".google.protobuf.FieldOptions..google.api.resourceReference: object expected"
              );
            message[".google.api.resourceReference"] =
              $root.google.api.ResourceReference.fromObject(
                object[".google.api.resourceReference"]
              );
          }
          if (object[".google.api.fieldVisibility"] != null) {
            if (typeof object[".google.api.fieldVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.FieldOptions..google.api.fieldVisibility: object expected"
              );
            message[".google.api.fieldVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.fieldVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from a FieldOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FieldOptions
         * @static
         * @param {google.protobuf.FieldOptions} message FieldOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.uninterpretedOption = [];
            object[".google.api.fieldBehavior"] = [];
          }
          if (options.defaults) {
            object.ctype = options.enums === String ? "STRING" : 0;
            object.packed = false;
            object.deprecated = false;
            object.lazy = false;
            object.jstype = options.enums === String ? "JS_NORMAL" : 0;
            object.weak = false;
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] = null;
            object[".google.api.resourceReference"] = null;
            object[".stronachgroup.first.extensions.fieldAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.fieldVisibility"] = null;
          }
          if (message.ctype != null && message.hasOwnProperty("ctype"))
            object.ctype =
              options.enums === String
                ? $root.google.protobuf.FieldOptions.CType[message.ctype]
                : message.ctype;
          if (message.packed != null && message.hasOwnProperty("packed"))
            object.packed = message.packed;
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (message.lazy != null && message.hasOwnProperty("lazy"))
            object.lazy = message.lazy;
          if (message.jstype != null && message.hasOwnProperty("jstype"))
            object.jstype =
              options.enums === String
                ? $root.google.protobuf.FieldOptions.JSType[message.jstype]
                : message.jstype;
          if (message.weak != null && message.hasOwnProperty("weak"))
            object.weak = message.weak;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] != null &&
            message.hasOwnProperty(
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            )
          )
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.JSONSchema.toObject(
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Field"
                ],
                options
              );
          if (
            message[".google.api.fieldBehavior"] &&
            message[".google.api.fieldBehavior"].length
          ) {
            object[".google.api.fieldBehavior"] = [];
            for (
              var j = 0;
              j < message[".google.api.fieldBehavior"].length;
              ++j
            )
              object[".google.api.fieldBehavior"][j] =
                options.enums === String
                  ? $root.google.api.FieldBehavior[
                      message[".google.api.fieldBehavior"][j]
                    ]
                  : message[".google.api.fieldBehavior"][j];
          }
          if (
            message[".google.api.resourceReference"] != null &&
            message.hasOwnProperty(".google.api.resourceReference")
          )
            object[".google.api.resourceReference"] =
              $root.google.api.ResourceReference.toObject(
                message[".google.api.resourceReference"],
                options
              );
          if (
            message[".stronachgroup.first.extensions.fieldAudience"] != null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.fieldAudience"
            )
          )
            object[".stronachgroup.first.extensions.fieldAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.fieldAudience"]
                  ]
                : message[".stronachgroup.first.extensions.fieldAudience"];
          if (
            message[".google.api.fieldVisibility"] != null &&
            message.hasOwnProperty(".google.api.fieldVisibility")
          )
            object[".google.api.fieldVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.fieldVisibility"],
                options
              );
          return object;
        };

        /**
         * Converts this FieldOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.FieldOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * CType enum.
         * @name google.protobuf.FieldOptions.CType
         * @enum {string}
         * @property {number} STRING=0 STRING value
         * @property {number} CORD=1 CORD value
         * @property {number} STRING_PIECE=2 STRING_PIECE value
         */
        FieldOptions.CType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "STRING")] = 0;
          values[(valuesById[1] = "CORD")] = 1;
          values[(valuesById[2] = "STRING_PIECE")] = 2;
          return values;
        })();

        /**
         * JSType enum.
         * @name google.protobuf.FieldOptions.JSType
         * @enum {string}
         * @property {number} JS_NORMAL=0 JS_NORMAL value
         * @property {number} JS_STRING=1 JS_STRING value
         * @property {number} JS_NUMBER=2 JS_NUMBER value
         */
        FieldOptions.JSType = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "JS_NORMAL")] = 0;
          values[(valuesById[1] = "JS_STRING")] = 1;
          values[(valuesById[2] = "JS_NUMBER")] = 2;
          return values;
        })();

        return FieldOptions;
      })();

      protobuf.OneofOptions = (function () {
        /**
         * Properties of an OneofOptions.
         * @memberof google.protobuf
         * @interface IOneofOptions
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
         */

        /**
         * Constructs a new OneofOptions.
         * @memberof google.protobuf
         * @classdesc Represents an OneofOptions.
         * @implements IOneofOptions
         * @constructor
         * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
         */
        function OneofOptions(properties) {
          this.uninterpretedOption = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * OneofOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.OneofOptions
         * @instance
         */
        OneofOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * Creates a new OneofOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.OneofOptions
         * @static
         * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
         * @returns {google.protobuf.OneofOptions} OneofOptions instance
         */
        OneofOptions.create = function create(properties) {
          return new OneofOptions(properties);
        };

        /**
         * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.OneofOptions
         * @static
         * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneofOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes an OneofOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.OneofOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.OneofOptions} OneofOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneofOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.OneofOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an OneofOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.OneofOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.OneofOptions} OneofOptions
         */
        OneofOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.OneofOptions)
            return object;
          var message = new $root.google.protobuf.OneofOptions();
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.OneofOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.OneofOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from an OneofOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.OneofOptions
         * @static
         * @param {google.protobuf.OneofOptions} message OneofOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OneofOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.uninterpretedOption = [];
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this OneofOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.OneofOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OneofOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OneofOptions;
      })();

      protobuf.EnumOptions = (function () {
        /**
         * Properties of an EnumOptions.
         * @memberof google.protobuf
         * @interface IEnumOptions
         * @property {boolean|null} [allowAlias] EnumOptions allowAlias
         * @property {boolean|null} [deprecated] EnumOptions deprecated
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.enumAudience"] EnumOptions .stronachgroup.first.extensions.enumAudience
         * @property {google.api.IVisibilityRule|null} [".google.api.enumVisibility"] EnumOptions .google.api.enumVisibility
         */

        /**
         * Constructs a new EnumOptions.
         * @memberof google.protobuf
         * @classdesc Represents an EnumOptions.
         * @implements IEnumOptions
         * @constructor
         * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
         */
        function EnumOptions(properties) {
          this.uninterpretedOption = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnumOptions allowAlias.
         * @member {boolean} allowAlias
         * @memberof google.protobuf.EnumOptions
         * @instance
         */
        EnumOptions.prototype.allowAlias = false;

        /**
         * EnumOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.EnumOptions
         * @instance
         */
        EnumOptions.prototype.deprecated = false;

        /**
         * EnumOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.EnumOptions
         * @instance
         */
        EnumOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * EnumOptions .stronachgroup.first.extensions.enumAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.enumAudience
         * @memberof google.protobuf.EnumOptions
         * @instance
         */
        EnumOptions.prototype[
          ".stronachgroup.first.extensions.enumAudience"
        ] = 0;

        /**
         * EnumOptions .google.api.enumVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.enumVisibility
         * @memberof google.protobuf.EnumOptions
         * @instance
         */
        EnumOptions.prototype[".google.api.enumVisibility"] = null;

        /**
         * Creates a new EnumOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.EnumOptions
         * @static
         * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
         * @returns {google.protobuf.EnumOptions} EnumOptions instance
         */
        EnumOptions.create = function create(properties) {
          return new EnumOptions(properties);
        };

        /**
         * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.EnumOptions
         * @static
         * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnumOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.allowAlias != null &&
            Object.hasOwnProperty.call(message, "allowAlias")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.allowAlias);
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.deprecated);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[".stronachgroup.first.extensions.enumAudience"] != null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.enumAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(message[".stronachgroup.first.extensions.enumAudience"]);
          if (
            message[".google.api.enumVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.enumVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.enumVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes an EnumOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.EnumOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.EnumOptions} EnumOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnumOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.EnumOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 2:
                message.allowAlias = reader.bool();
                break;
              case 3:
                message.deprecated = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.enumAudience"] =
                  reader.int32();
                break;
              case 72295727:
                message[".google.api.enumVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an EnumOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.EnumOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.EnumOptions} EnumOptions
         */
        EnumOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.EnumOptions)
            return object;
          var message = new $root.google.protobuf.EnumOptions();
          if (object.allowAlias != null)
            message.allowAlias = Boolean(object.allowAlias);
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.EnumOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.EnumOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.enumAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.enumAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.enumAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.enumAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.enumAudience"] = 3;
              break;
          }
          if (object[".google.api.enumVisibility"] != null) {
            if (typeof object[".google.api.enumVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.EnumOptions..google.api.enumVisibility: object expected"
              );
            message[".google.api.enumVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.enumVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from an EnumOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.EnumOptions
         * @static
         * @param {google.protobuf.EnumOptions} message EnumOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnumOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.uninterpretedOption = [];
          if (options.defaults) {
            object.allowAlias = false;
            object.deprecated = false;
            object[".stronachgroup.first.extensions.enumAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.enumVisibility"] = null;
          }
          if (
            message.allowAlias != null &&
            message.hasOwnProperty("allowAlias")
          )
            object.allowAlias = message.allowAlias;
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[".stronachgroup.first.extensions.enumAudience"] != null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.enumAudience"
            )
          )
            object[".stronachgroup.first.extensions.enumAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.enumAudience"]
                  ]
                : message[".stronachgroup.first.extensions.enumAudience"];
          if (
            message[".google.api.enumVisibility"] != null &&
            message.hasOwnProperty(".google.api.enumVisibility")
          )
            object[".google.api.enumVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.enumVisibility"],
                options
              );
          return object;
        };

        /**
         * Converts this EnumOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.EnumOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnumOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnumOptions;
      })();

      protobuf.EnumValueOptions = (function () {
        /**
         * Properties of an EnumValueOptions.
         * @memberof google.protobuf
         * @interface IEnumValueOptions
         * @property {boolean|null} [deprecated] EnumValueOptions deprecated
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.enumValueAudience"] EnumValueOptions .stronachgroup.first.extensions.enumValueAudience
         * @property {google.api.IVisibilityRule|null} [".google.api.valueVisibility"] EnumValueOptions .google.api.valueVisibility
         */

        /**
         * Constructs a new EnumValueOptions.
         * @memberof google.protobuf
         * @classdesc Represents an EnumValueOptions.
         * @implements IEnumValueOptions
         * @constructor
         * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
         */
        function EnumValueOptions(properties) {
          this.uninterpretedOption = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnumValueOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.EnumValueOptions
         * @instance
         */
        EnumValueOptions.prototype.deprecated = false;

        /**
         * EnumValueOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.EnumValueOptions
         * @instance
         */
        EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * EnumValueOptions .stronachgroup.first.extensions.enumValueAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.enumValueAudience
         * @memberof google.protobuf.EnumValueOptions
         * @instance
         */
        EnumValueOptions.prototype[
          ".stronachgroup.first.extensions.enumValueAudience"
        ] = 0;

        /**
         * EnumValueOptions .google.api.valueVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.valueVisibility
         * @memberof google.protobuf.EnumValueOptions
         * @instance
         */
        EnumValueOptions.prototype[".google.api.valueVisibility"] = null;

        /**
         * Creates a new EnumValueOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.EnumValueOptions
         * @static
         * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
         * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
         */
        EnumValueOptions.create = function create(properties) {
          return new EnumValueOptions(properties);
        };

        /**
         * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.EnumValueOptions
         * @static
         * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnumValueOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.deprecated);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[".stronachgroup.first.extensions.enumValueAudience"] !=
              null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.enumValueAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(
                message[".stronachgroup.first.extensions.enumValueAudience"]
              );
          if (
            message[".google.api.valueVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.valueVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.valueVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes an EnumValueOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.EnumValueOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnumValueOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.EnumValueOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.deprecated = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.enumValueAudience"] =
                  reader.int32();
                break;
              case 72295727:
                message[".google.api.valueVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an EnumValueOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.EnumValueOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
         */
        EnumValueOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.EnumValueOptions)
            return object;
          var message = new $root.google.protobuf.EnumValueOptions();
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.EnumValueOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.EnumValueOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.enumValueAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.enumValueAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.enumValueAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.enumValueAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.enumValueAudience"] = 3;
              break;
          }
          if (object[".google.api.valueVisibility"] != null) {
            if (typeof object[".google.api.valueVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.EnumValueOptions..google.api.valueVisibility: object expected"
              );
            message[".google.api.valueVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.valueVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from an EnumValueOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.EnumValueOptions
         * @static
         * @param {google.protobuf.EnumValueOptions} message EnumValueOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnumValueOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.uninterpretedOption = [];
          if (options.defaults) {
            object.deprecated = false;
            object[".stronachgroup.first.extensions.enumValueAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.valueVisibility"] = null;
          }
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[".stronachgroup.first.extensions.enumValueAudience"] !=
              null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.enumValueAudience"
            )
          )
            object[".stronachgroup.first.extensions.enumValueAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.enumValueAudience"]
                  ]
                : message[".stronachgroup.first.extensions.enumValueAudience"];
          if (
            message[".google.api.valueVisibility"] != null &&
            message.hasOwnProperty(".google.api.valueVisibility")
          )
            object[".google.api.valueVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.valueVisibility"],
                options
              );
          return object;
        };

        /**
         * Converts this EnumValueOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.EnumValueOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnumValueOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnumValueOptions;
      })();

      protobuf.ServiceOptions = (function () {
        /**
         * Properties of a ServiceOptions.
         * @memberof google.protobuf
         * @interface IServiceOptions
         * @property {boolean|null} [deprecated] ServiceOptions deprecated
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.serviceAudience"] ServiceOptions .stronachgroup.first.extensions.serviceAudience
         * @property {grpc.gateway.protoc_gen_openapiv2.options.ITag|null} [".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"] ServiceOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag
         * @property {google.api.IVisibilityRule|null} [".google.api.apiVisibility"] ServiceOptions .google.api.apiVisibility
         */

        /**
         * Constructs a new ServiceOptions.
         * @memberof google.protobuf
         * @classdesc Represents a ServiceOptions.
         * @implements IServiceOptions
         * @constructor
         * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
         */
        function ServiceOptions(properties) {
          this.uninterpretedOption = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServiceOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.ServiceOptions
         * @instance
         */
        ServiceOptions.prototype.deprecated = false;

        /**
         * ServiceOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.ServiceOptions
         * @instance
         */
        ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * ServiceOptions .stronachgroup.first.extensions.serviceAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.serviceAudience
         * @memberof google.protobuf.ServiceOptions
         * @instance
         */
        ServiceOptions.prototype[
          ".stronachgroup.first.extensions.serviceAudience"
        ] = 0;

        /**
         * ServiceOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag.
         * @member {grpc.gateway.protoc_gen_openapiv2.options.ITag|null|undefined} .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag
         * @memberof google.protobuf.ServiceOptions
         * @instance
         */
        ServiceOptions.prototype[
          ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
        ] = null;

        /**
         * ServiceOptions .google.api.apiVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.apiVisibility
         * @memberof google.protobuf.ServiceOptions
         * @instance
         */
        ServiceOptions.prototype[".google.api.apiVisibility"] = null;

        /**
         * Creates a new ServiceOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.ServiceOptions
         * @static
         * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
         * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
         */
        ServiceOptions.create = function create(properties) {
          return new ServiceOptions(properties);
        };

        /**
         * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.ServiceOptions
         * @static
         * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServiceOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer
              .uint32(/* id 33, wireType 0 =*/ 264)
              .bool(message.deprecated);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
            ] != null &&
            Object.hasOwnProperty.call(
              message,
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
            )
          )
            $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.encode(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
              ],
              writer.uint32(/* id 1042, wireType 2 =*/ 8338).fork()
            ).ldelim();
          if (
            message[".stronachgroup.first.extensions.serviceAudience"] !=
              null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.serviceAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(
                message[".stronachgroup.first.extensions.serviceAudience"]
              );
          if (
            message[".google.api.apiVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.apiVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.apiVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a ServiceOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.ServiceOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.ServiceOptions} ServiceOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServiceOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.ServiceOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 33:
                message.deprecated = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.serviceAudience"] =
                  reader.int32();
                break;
              case 1042:
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
                ] = $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 72295727:
                message[".google.api.apiVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ServiceOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.ServiceOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.ServiceOptions} ServiceOptions
         */
        ServiceOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.ServiceOptions)
            return object;
          var message = new $root.google.protobuf.ServiceOptions();
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.ServiceOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.ServiceOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.serviceAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.serviceAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.serviceAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.serviceAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.serviceAudience"] = 3;
              break;
          }
          if (
            object[".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"] !=
            null
          ) {
            if (
              typeof object[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
              ] !== "object"
            )
              throw TypeError(
                ".google.protobuf.ServiceOptions..grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag: object expected"
              );
            message[".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.fromObject(
                object[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
                ]
              );
          }
          if (object[".google.api.apiVisibility"] != null) {
            if (typeof object[".google.api.apiVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.ServiceOptions..google.api.apiVisibility: object expected"
              );
            message[".google.api.apiVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.apiVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from a ServiceOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.ServiceOptions
         * @static
         * @param {google.protobuf.ServiceOptions} message ServiceOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServiceOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.uninterpretedOption = [];
          if (options.defaults) {
            object.deprecated = false;
            object[".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"] =
              null;
            object[".stronachgroup.first.extensions.serviceAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.apiVisibility"] = null;
          }
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
            ] != null &&
            message.hasOwnProperty(
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
            )
          )
            object[".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Tag.toObject(
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Tag"
                ],
                options
              );
          if (
            message[".stronachgroup.first.extensions.serviceAudience"] !=
              null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.serviceAudience"
            )
          )
            object[".stronachgroup.first.extensions.serviceAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.serviceAudience"]
                  ]
                : message[".stronachgroup.first.extensions.serviceAudience"];
          if (
            message[".google.api.apiVisibility"] != null &&
            message.hasOwnProperty(".google.api.apiVisibility")
          )
            object[".google.api.apiVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.apiVisibility"],
                options
              );
          return object;
        };

        /**
         * Converts this ServiceOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.ServiceOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServiceOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ServiceOptions;
      })();

      protobuf.MethodOptions = (function () {
        /**
         * Properties of a MethodOptions.
         * @memberof google.protobuf
         * @interface IMethodOptions
         * @property {boolean|null} [deprecated] MethodOptions deprecated
         * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
         * @property {stronachgroup.first.extensions.Audience|null} [".stronachgroup.first.extensions.methodAudience"] MethodOptions .stronachgroup.first.extensions.methodAudience
         * @property {Array.<string>|null} [".stronachgroup.first.extensions.methodPermission"] MethodOptions .stronachgroup.first.extensions.methodPermission
         * @property {grpc.gateway.protoc_gen_openapiv2.options.IOperation|null} [".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"] MethodOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation
         * @property {google.api.IHttpRule|null} [".google.api.http"] MethodOptions .google.api.http
         * @property {google.api.IVisibilityRule|null} [".google.api.methodVisibility"] MethodOptions .google.api.methodVisibility
         */

        /**
         * Constructs a new MethodOptions.
         * @memberof google.protobuf
         * @classdesc Represents a MethodOptions.
         * @implements IMethodOptions
         * @constructor
         * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
         */
        function MethodOptions(properties) {
          this.uninterpretedOption = [];
          this[".stronachgroup.first.extensions.methodPermission"] = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * MethodOptions deprecated.
         * @member {boolean} deprecated
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype.deprecated = false;

        /**
         * MethodOptions uninterpretedOption.
         * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype.uninterpretedOption = $util.emptyArray;

        /**
         * MethodOptions .stronachgroup.first.extensions.methodAudience.
         * @member {stronachgroup.first.extensions.Audience} .stronachgroup.first.extensions.methodAudience
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype[
          ".stronachgroup.first.extensions.methodAudience"
        ] = 0;

        /**
         * MethodOptions .stronachgroup.first.extensions.methodPermission.
         * @member {Array.<string>} .stronachgroup.first.extensions.methodPermission
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype[
          ".stronachgroup.first.extensions.methodPermission"
        ] = $util.emptyArray;

        /**
         * MethodOptions .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation.
         * @member {grpc.gateway.protoc_gen_openapiv2.options.IOperation|null|undefined} .grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype[
          ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
        ] = null;

        /**
         * MethodOptions .google.api.http.
         * @member {google.api.IHttpRule|null|undefined} .google.api.http
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype[".google.api.http"] = null;

        /**
         * MethodOptions .google.api.methodVisibility.
         * @member {google.api.IVisibilityRule|null|undefined} .google.api.methodVisibility
         * @memberof google.protobuf.MethodOptions
         * @instance
         */
        MethodOptions.prototype[".google.api.methodVisibility"] = null;

        /**
         * Creates a new MethodOptions instance using the specified properties.
         * @function create
         * @memberof google.protobuf.MethodOptions
         * @static
         * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
         * @returns {google.protobuf.MethodOptions} MethodOptions instance
         */
        MethodOptions.create = function create(properties) {
          return new MethodOptions(properties);
        };

        /**
         * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.MethodOptions
         * @static
         * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MethodOptions.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.deprecated != null &&
            Object.hasOwnProperty.call(message, "deprecated")
          )
            writer
              .uint32(/* id 33, wireType 0 =*/ 264)
              .bool(message.deprecated);
          if (
            message.uninterpretedOption != null &&
            message.uninterpretedOption.length
          )
            for (var i = 0; i < message.uninterpretedOption.length; ++i)
              $root.google.protobuf.UninterpretedOption.encode(
                message.uninterpretedOption[i],
                writer.uint32(/* id 999, wireType 2 =*/ 7994).fork()
              ).ldelim();
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] != null &&
            Object.hasOwnProperty.call(
              message,
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            )
          )
            $root.grpc.gateway.protoc_gen_openapiv2.options.Operation.encode(
              message[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
              ],
              writer.uint32(/* id 1042, wireType 2 =*/ 8338).fork()
            ).ldelim();
          if (
            message[".stronachgroup.first.extensions.methodAudience"] != null &&
            Object.hasOwnProperty.call(
              message,
              ".stronachgroup.first.extensions.methodAudience"
            )
          )
            writer
              .uint32(/* id 2051, wireType 0 =*/ 16408)
              .int32(message[".stronachgroup.first.extensions.methodAudience"]);
          if (
            message[".stronachgroup.first.extensions.methodPermission"] !=
              null &&
            message[".stronachgroup.first.extensions.methodPermission"].length
          )
            for (
              var i = 0;
              i <
              message[".stronachgroup.first.extensions.methodPermission"]
                .length;
              ++i
            )
              writer
                .uint32(/* id 2052, wireType 2 =*/ 16418)
                .string(
                  message[".stronachgroup.first.extensions.methodPermission"][i]
                );
          if (
            message[".google.api.methodVisibility"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.methodVisibility")
          )
            $root.google.api.VisibilityRule.encode(
              message[".google.api.methodVisibility"],
              writer.uint32(/* id 72295727, wireType 2 =*/ 578365818).fork()
            ).ldelim();
          if (
            message[".google.api.http"] != null &&
            Object.hasOwnProperty.call(message, ".google.api.http")
          )
            $root.google.api.HttpRule.encode(
              message[".google.api.http"],
              writer.uint32(/* id 72295728, wireType 2 =*/ 578365826).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a MethodOptions message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.MethodOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.MethodOptions} MethodOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MethodOptions.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.MethodOptions();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 33:
                message.deprecated = reader.bool();
                break;
              case 999:
                if (
                  !(
                    message.uninterpretedOption &&
                    message.uninterpretedOption.length
                  )
                )
                  message.uninterpretedOption = [];
                message.uninterpretedOption.push(
                  $root.google.protobuf.UninterpretedOption.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 2051:
                message[".stronachgroup.first.extensions.methodAudience"] =
                  reader.int32();
                break;
              case 2052:
                if (
                  !(
                    message[
                      ".stronachgroup.first.extensions.methodPermission"
                    ] &&
                    message[".stronachgroup.first.extensions.methodPermission"]
                      .length
                  )
                )
                  message[".stronachgroup.first.extensions.methodPermission"] =
                    [];
                message[
                  ".stronachgroup.first.extensions.methodPermission"
                ].push(reader.string());
                break;
              case 1042:
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
                ] =
                  $root.grpc.gateway.protoc_gen_openapiv2.options.Operation.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              case 72295728:
                message[".google.api.http"] = $root.google.api.HttpRule.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 72295727:
                message[".google.api.methodVisibility"] =
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a MethodOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.MethodOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.MethodOptions} MethodOptions
         */
        MethodOptions.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.MethodOptions)
            return object;
          var message = new $root.google.protobuf.MethodOptions();
          if (object.deprecated != null)
            message.deprecated = Boolean(object.deprecated);
          if (object.uninterpretedOption) {
            if (!Array.isArray(object.uninterpretedOption))
              throw TypeError(
                ".google.protobuf.MethodOptions.uninterpretedOption: array expected"
              );
            message.uninterpretedOption = [];
            for (var i = 0; i < object.uninterpretedOption.length; ++i) {
              if (typeof object.uninterpretedOption[i] !== "object")
                throw TypeError(
                  ".google.protobuf.MethodOptions.uninterpretedOption: object expected"
                );
              message.uninterpretedOption[i] =
                $root.google.protobuf.UninterpretedOption.fromObject(
                  object.uninterpretedOption[i]
                );
            }
          }
          switch (object[".stronachgroup.first.extensions.methodAudience"]) {
            case "AUDIENCE_UNSPECIFIED":
            case 0:
              message[".stronachgroup.first.extensions.methodAudience"] = 0;
              break;
            case "AUDIENCE_PUBLIC":
            case 1:
              message[".stronachgroup.first.extensions.methodAudience"] = 1;
              break;
            case "AUDIENCE_PARTNER":
            case 2:
              message[".stronachgroup.first.extensions.methodAudience"] = 2;
              break;
            case "AUDIENCE_INTERNAL":
            case 3:
              message[".stronachgroup.first.extensions.methodAudience"] = 3;
              break;
          }
          if (object[".stronachgroup.first.extensions.methodPermission"]) {
            if (
              !Array.isArray(
                object[".stronachgroup.first.extensions.methodPermission"]
              )
            )
              throw TypeError(
                ".google.protobuf.MethodOptions..stronachgroup.first.extensions.methodPermission: array expected"
              );
            message[".stronachgroup.first.extensions.methodPermission"] = [];
            for (
              var i = 0;
              i <
              object[".stronachgroup.first.extensions.methodPermission"].length;
              ++i
            )
              message[".stronachgroup.first.extensions.methodPermission"][i] =
                String(
                  object[".stronachgroup.first.extensions.methodPermission"][i]
                );
          }
          if (
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] != null
          ) {
            if (
              typeof object[
                ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
              ] !== "object"
            )
              throw TypeError(
                ".google.protobuf.MethodOptions..grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation: object expected"
              );
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Operation.fromObject(
                object[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
                ]
              );
          }
          if (object[".google.api.http"] != null) {
            if (typeof object[".google.api.http"] !== "object")
              throw TypeError(
                ".google.protobuf.MethodOptions..google.api.http: object expected"
              );
            message[".google.api.http"] = $root.google.api.HttpRule.fromObject(
              object[".google.api.http"]
            );
          }
          if (object[".google.api.methodVisibility"] != null) {
            if (typeof object[".google.api.methodVisibility"] !== "object")
              throw TypeError(
                ".google.protobuf.MethodOptions..google.api.methodVisibility: object expected"
              );
            message[".google.api.methodVisibility"] =
              $root.google.api.VisibilityRule.fromObject(
                object[".google.api.methodVisibility"]
              );
          }
          return message;
        };

        /**
         * Creates a plain object from a MethodOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.MethodOptions
         * @static
         * @param {google.protobuf.MethodOptions} message MethodOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MethodOptions.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.uninterpretedOption = [];
            object[".stronachgroup.first.extensions.methodPermission"] = [];
          }
          if (options.defaults) {
            object.deprecated = false;
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] = null;
            object[".stronachgroup.first.extensions.methodAudience"] =
              options.enums === String ? "AUDIENCE_UNSPECIFIED" : 0;
            object[".google.api.methodVisibility"] = null;
            object[".google.api.http"] = null;
          }
          if (
            message.deprecated != null &&
            message.hasOwnProperty("deprecated")
          )
            object.deprecated = message.deprecated;
          if (
            message.uninterpretedOption &&
            message.uninterpretedOption.length
          ) {
            object.uninterpretedOption = [];
            for (var j = 0; j < message.uninterpretedOption.length; ++j)
              object.uninterpretedOption[j] =
                $root.google.protobuf.UninterpretedOption.toObject(
                  message.uninterpretedOption[j],
                  options
                );
          }
          if (
            message[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] != null &&
            message.hasOwnProperty(
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            )
          )
            object[
              ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
            ] =
              $root.grpc.gateway.protoc_gen_openapiv2.options.Operation.toObject(
                message[
                  ".grpc.gateway.protoc_gen_openapiv2.options.openapiv2Operation"
                ],
                options
              );
          if (
            message[".stronachgroup.first.extensions.methodAudience"] != null &&
            message.hasOwnProperty(
              ".stronachgroup.first.extensions.methodAudience"
            )
          )
            object[".stronachgroup.first.extensions.methodAudience"] =
              options.enums === String
                ? $root.stronachgroup.first.extensions.Audience[
                    message[".stronachgroup.first.extensions.methodAudience"]
                  ]
                : message[".stronachgroup.first.extensions.methodAudience"];
          if (
            message[".stronachgroup.first.extensions.methodPermission"] &&
            message[".stronachgroup.first.extensions.methodPermission"].length
          ) {
            object[".stronachgroup.first.extensions.methodPermission"] = [];
            for (
              var j = 0;
              j <
              message[".stronachgroup.first.extensions.methodPermission"]
                .length;
              ++j
            )
              object[".stronachgroup.first.extensions.methodPermission"][j] =
                message[".stronachgroup.first.extensions.methodPermission"][j];
          }
          if (
            message[".google.api.methodVisibility"] != null &&
            message.hasOwnProperty(".google.api.methodVisibility")
          )
            object[".google.api.methodVisibility"] =
              $root.google.api.VisibilityRule.toObject(
                message[".google.api.methodVisibility"],
                options
              );
          if (
            message[".google.api.http"] != null &&
            message.hasOwnProperty(".google.api.http")
          )
            object[".google.api.http"] = $root.google.api.HttpRule.toObject(
              message[".google.api.http"],
              options
            );
          return object;
        };

        /**
         * Converts this MethodOptions to JSON.
         * @function toJSON
         * @memberof google.protobuf.MethodOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MethodOptions.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MethodOptions;
      })();

      protobuf.UninterpretedOption = (function () {
        /**
         * Properties of an UninterpretedOption.
         * @memberof google.protobuf
         * @interface IUninterpretedOption
         * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
         * @property {string|null} [identifierValue] UninterpretedOption identifierValue
         * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
         * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
         * @property {number|null} [doubleValue] UninterpretedOption doubleValue
         * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
         * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
         */

        /**
         * Constructs a new UninterpretedOption.
         * @memberof google.protobuf
         * @classdesc Represents an UninterpretedOption.
         * @implements IUninterpretedOption
         * @constructor
         * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
         */
        function UninterpretedOption(properties) {
          this.name = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * UninterpretedOption name.
         * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.name = $util.emptyArray;

        /**
         * UninterpretedOption identifierValue.
         * @member {string} identifierValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.identifierValue = "";

        /**
         * UninterpretedOption positiveIntValue.
         * @member {number|Long} positiveIntValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.positiveIntValue = $util.Long
          ? $util.Long.fromBits(0, 0, true)
          : 0;

        /**
         * UninterpretedOption negativeIntValue.
         * @member {number|Long} negativeIntValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.negativeIntValue = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * UninterpretedOption doubleValue.
         * @member {number} doubleValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.doubleValue = 0;

        /**
         * UninterpretedOption stringValue.
         * @member {Uint8Array} stringValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.stringValue = $util.newBuffer([]);

        /**
         * UninterpretedOption aggregateValue.
         * @member {string} aggregateValue
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         */
        UninterpretedOption.prototype.aggregateValue = "";

        /**
         * Creates a new UninterpretedOption instance using the specified properties.
         * @function create
         * @memberof google.protobuf.UninterpretedOption
         * @static
         * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
         * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
         */
        UninterpretedOption.create = function create(properties) {
          return new UninterpretedOption(properties);
        };

        /**
         * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.UninterpretedOption
         * @static
         * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UninterpretedOption.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.name != null && message.name.length)
            for (var i = 0; i < message.name.length; ++i)
              $root.google.protobuf.UninterpretedOption.NamePart.encode(
                message.name[i],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              ).ldelim();
          if (
            message.identifierValue != null &&
            Object.hasOwnProperty.call(message, "identifierValue")
          )
            writer
              .uint32(/* id 3, wireType 2 =*/ 26)
              .string(message.identifierValue);
          if (
            message.positiveIntValue != null &&
            Object.hasOwnProperty.call(message, "positiveIntValue")
          )
            writer
              .uint32(/* id 4, wireType 0 =*/ 32)
              .uint64(message.positiveIntValue);
          if (
            message.negativeIntValue != null &&
            Object.hasOwnProperty.call(message, "negativeIntValue")
          )
            writer
              .uint32(/* id 5, wireType 0 =*/ 40)
              .int64(message.negativeIntValue);
          if (
            message.doubleValue != null &&
            Object.hasOwnProperty.call(message, "doubleValue")
          )
            writer
              .uint32(/* id 6, wireType 1 =*/ 49)
              .double(message.doubleValue);
          if (
            message.stringValue != null &&
            Object.hasOwnProperty.call(message, "stringValue")
          )
            writer
              .uint32(/* id 7, wireType 2 =*/ 58)
              .bytes(message.stringValue);
          if (
            message.aggregateValue != null &&
            Object.hasOwnProperty.call(message, "aggregateValue")
          )
            writer
              .uint32(/* id 8, wireType 2 =*/ 66)
              .string(message.aggregateValue);
          return writer;
        };

        /**
         * Decodes an UninterpretedOption message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.UninterpretedOption
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UninterpretedOption.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.UninterpretedOption();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 2:
                if (!(message.name && message.name.length)) message.name = [];
                message.name.push(
                  $root.google.protobuf.UninterpretedOption.NamePart.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              case 3:
                message.identifierValue = reader.string();
                break;
              case 4:
                message.positiveIntValue = reader.uint64();
                break;
              case 5:
                message.negativeIntValue = reader.int64();
                break;
              case 6:
                message.doubleValue = reader.double();
                break;
              case 7:
                message.stringValue = reader.bytes();
                break;
              case 8:
                message.aggregateValue = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an UninterpretedOption message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.UninterpretedOption
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
         */
        UninterpretedOption.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.UninterpretedOption)
            return object;
          var message = new $root.google.protobuf.UninterpretedOption();
          if (object.name) {
            if (!Array.isArray(object.name))
              throw TypeError(
                ".google.protobuf.UninterpretedOption.name: array expected"
              );
            message.name = [];
            for (var i = 0; i < object.name.length; ++i) {
              if (typeof object.name[i] !== "object")
                throw TypeError(
                  ".google.protobuf.UninterpretedOption.name: object expected"
                );
              message.name[i] =
                $root.google.protobuf.UninterpretedOption.NamePart.fromObject(
                  object.name[i]
                );
            }
          }
          if (object.identifierValue != null)
            message.identifierValue = String(object.identifierValue);
          if (object.positiveIntValue != null)
            if ($util.Long)
              (message.positiveIntValue = $util.Long.fromValue(
                object.positiveIntValue
              )).unsigned = true;
            else if (typeof object.positiveIntValue === "string")
              message.positiveIntValue = parseInt(object.positiveIntValue, 10);
            else if (typeof object.positiveIntValue === "number")
              message.positiveIntValue = object.positiveIntValue;
            else if (typeof object.positiveIntValue === "object")
              message.positiveIntValue = new $util.LongBits(
                object.positiveIntValue.low >>> 0,
                object.positiveIntValue.high >>> 0
              ).toNumber(true);
          if (object.negativeIntValue != null)
            if ($util.Long)
              (message.negativeIntValue = $util.Long.fromValue(
                object.negativeIntValue
              )).unsigned = false;
            else if (typeof object.negativeIntValue === "string")
              message.negativeIntValue = parseInt(object.negativeIntValue, 10);
            else if (typeof object.negativeIntValue === "number")
              message.negativeIntValue = object.negativeIntValue;
            else if (typeof object.negativeIntValue === "object")
              message.negativeIntValue = new $util.LongBits(
                object.negativeIntValue.low >>> 0,
                object.negativeIntValue.high >>> 0
              ).toNumber();
          if (object.doubleValue != null)
            message.doubleValue = Number(object.doubleValue);
          if (object.stringValue != null)
            if (typeof object.stringValue === "string")
              $util.base64.decode(
                object.stringValue,
                (message.stringValue = $util.newBuffer(
                  $util.base64.length(object.stringValue)
                )),
                0
              );
            else if (object.stringValue.length)
              message.stringValue = object.stringValue;
          if (object.aggregateValue != null)
            message.aggregateValue = String(object.aggregateValue);
          return message;
        };

        /**
         * Creates a plain object from an UninterpretedOption message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.UninterpretedOption
         * @static
         * @param {google.protobuf.UninterpretedOption} message UninterpretedOption
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UninterpretedOption.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.name = [];
          if (options.defaults) {
            object.identifierValue = "";
            if ($util.Long) {
              var long = new $util.Long(0, 0, true);
              object.positiveIntValue =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.positiveIntValue = options.longs === String ? "0" : 0;
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.negativeIntValue =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.negativeIntValue = options.longs === String ? "0" : 0;
            object.doubleValue = 0;
            if (options.bytes === String) object.stringValue = "";
            else {
              object.stringValue = [];
              if (options.bytes !== Array)
                object.stringValue = $util.newBuffer(object.stringValue);
            }
            object.aggregateValue = "";
          }
          if (message.name && message.name.length) {
            object.name = [];
            for (var j = 0; j < message.name.length; ++j)
              object.name[j] =
                $root.google.protobuf.UninterpretedOption.NamePart.toObject(
                  message.name[j],
                  options
                );
          }
          if (
            message.identifierValue != null &&
            message.hasOwnProperty("identifierValue")
          )
            object.identifierValue = message.identifierValue;
          if (
            message.positiveIntValue != null &&
            message.hasOwnProperty("positiveIntValue")
          )
            if (typeof message.positiveIntValue === "number")
              object.positiveIntValue =
                options.longs === String
                  ? String(message.positiveIntValue)
                  : message.positiveIntValue;
            else
              object.positiveIntValue =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.positiveIntValue)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.positiveIntValue.low >>> 0,
                      message.positiveIntValue.high >>> 0
                    ).toNumber(true)
                  : message.positiveIntValue;
          if (
            message.negativeIntValue != null &&
            message.hasOwnProperty("negativeIntValue")
          )
            if (typeof message.negativeIntValue === "number")
              object.negativeIntValue =
                options.longs === String
                  ? String(message.negativeIntValue)
                  : message.negativeIntValue;
            else
              object.negativeIntValue =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.negativeIntValue)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.negativeIntValue.low >>> 0,
                      message.negativeIntValue.high >>> 0
                    ).toNumber()
                  : message.negativeIntValue;
          if (
            message.doubleValue != null &&
            message.hasOwnProperty("doubleValue")
          )
            object.doubleValue =
              options.json && !isFinite(message.doubleValue)
                ? String(message.doubleValue)
                : message.doubleValue;
          if (
            message.stringValue != null &&
            message.hasOwnProperty("stringValue")
          )
            object.stringValue =
              options.bytes === String
                ? $util.base64.encode(
                    message.stringValue,
                    0,
                    message.stringValue.length
                  )
                : options.bytes === Array
                ? Array.prototype.slice.call(message.stringValue)
                : message.stringValue;
          if (
            message.aggregateValue != null &&
            message.hasOwnProperty("aggregateValue")
          )
            object.aggregateValue = message.aggregateValue;
          return object;
        };

        /**
         * Converts this UninterpretedOption to JSON.
         * @function toJSON
         * @memberof google.protobuf.UninterpretedOption
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UninterpretedOption.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UninterpretedOption.NamePart = (function () {
          /**
           * Properties of a NamePart.
           * @memberof google.protobuf.UninterpretedOption
           * @interface INamePart
           * @property {string} namePart NamePart namePart
           * @property {boolean} isExtension NamePart isExtension
           */

          /**
           * Constructs a new NamePart.
           * @memberof google.protobuf.UninterpretedOption
           * @classdesc Represents a NamePart.
           * @implements INamePart
           * @constructor
           * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
           */
          function NamePart(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * NamePart namePart.
           * @member {string} namePart
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @instance
           */
          NamePart.prototype.namePart = "";

          /**
           * NamePart isExtension.
           * @member {boolean} isExtension
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @instance
           */
          NamePart.prototype.isExtension = false;

          /**
           * Creates a new NamePart instance using the specified properties.
           * @function create
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @static
           * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
           * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
           */
          NamePart.create = function create(properties) {
            return new NamePart(properties);
          };

          /**
           * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
           * @function encode
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @static
           * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          NamePart.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.namePart);
            writer.uint32(/* id 2, wireType 0 =*/ 16).bool(message.isExtension);
            return writer;
          };

          /**
           * Decodes a NamePart message from the specified reader or buffer.
           * @function decode
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          NamePart.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.google.protobuf.UninterpretedOption.NamePart();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.namePart = reader.string();
                  break;
                case 2:
                  message.isExtension = reader.bool();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            if (!message.hasOwnProperty("namePart"))
              throw $util.ProtocolError("missing required 'namePart'", {
                instance: message
              });
            if (!message.hasOwnProperty("isExtension"))
              throw $util.ProtocolError("missing required 'isExtension'", {
                instance: message
              });
            return message;
          };

          /**
           * Creates a NamePart message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
           */
          NamePart.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.google.protobuf.UninterpretedOption.NamePart
            )
              return object;
            var message =
              new $root.google.protobuf.UninterpretedOption.NamePart();
            if (object.namePart != null)
              message.namePart = String(object.namePart);
            if (object.isExtension != null)
              message.isExtension = Boolean(object.isExtension);
            return message;
          };

          /**
           * Creates a plain object from a NamePart message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @static
           * @param {google.protobuf.UninterpretedOption.NamePart} message NamePart
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          NamePart.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.namePart = "";
              object.isExtension = false;
            }
            if (message.namePart != null && message.hasOwnProperty("namePart"))
              object.namePart = message.namePart;
            if (
              message.isExtension != null &&
              message.hasOwnProperty("isExtension")
            )
              object.isExtension = message.isExtension;
            return object;
          };

          /**
           * Converts this NamePart to JSON.
           * @function toJSON
           * @memberof google.protobuf.UninterpretedOption.NamePart
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          NamePart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return NamePart;
        })();

        return UninterpretedOption;
      })();

      protobuf.SourceCodeInfo = (function () {
        /**
         * Properties of a SourceCodeInfo.
         * @memberof google.protobuf
         * @interface ISourceCodeInfo
         * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
         */

        /**
         * Constructs a new SourceCodeInfo.
         * @memberof google.protobuf
         * @classdesc Represents a SourceCodeInfo.
         * @implements ISourceCodeInfo
         * @constructor
         * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
         */
        function SourceCodeInfo(properties) {
          this.location = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * SourceCodeInfo location.
         * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
         * @memberof google.protobuf.SourceCodeInfo
         * @instance
         */
        SourceCodeInfo.prototype.location = $util.emptyArray;

        /**
         * Creates a new SourceCodeInfo instance using the specified properties.
         * @function create
         * @memberof google.protobuf.SourceCodeInfo
         * @static
         * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
         * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
         */
        SourceCodeInfo.create = function create(properties) {
          return new SourceCodeInfo(properties);
        };

        /**
         * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.SourceCodeInfo
         * @static
         * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SourceCodeInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.location != null && message.location.length)
            for (var i = 0; i < message.location.length; ++i)
              $root.google.protobuf.SourceCodeInfo.Location.encode(
                message.location[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a SourceCodeInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.SourceCodeInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SourceCodeInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.SourceCodeInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.location && message.location.length))
                  message.location = [];
                message.location.push(
                  $root.google.protobuf.SourceCodeInfo.Location.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a SourceCodeInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.SourceCodeInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
         */
        SourceCodeInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.SourceCodeInfo)
            return object;
          var message = new $root.google.protobuf.SourceCodeInfo();
          if (object.location) {
            if (!Array.isArray(object.location))
              throw TypeError(
                ".google.protobuf.SourceCodeInfo.location: array expected"
              );
            message.location = [];
            for (var i = 0; i < object.location.length; ++i) {
              if (typeof object.location[i] !== "object")
                throw TypeError(
                  ".google.protobuf.SourceCodeInfo.location: object expected"
                );
              message.location[i] =
                $root.google.protobuf.SourceCodeInfo.Location.fromObject(
                  object.location[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a SourceCodeInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.SourceCodeInfo
         * @static
         * @param {google.protobuf.SourceCodeInfo} message SourceCodeInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SourceCodeInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.location = [];
          if (message.location && message.location.length) {
            object.location = [];
            for (var j = 0; j < message.location.length; ++j)
              object.location[j] =
                $root.google.protobuf.SourceCodeInfo.Location.toObject(
                  message.location[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this SourceCodeInfo to JSON.
         * @function toJSON
         * @memberof google.protobuf.SourceCodeInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SourceCodeInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SourceCodeInfo.Location = (function () {
          /**
           * Properties of a Location.
           * @memberof google.protobuf.SourceCodeInfo
           * @interface ILocation
           * @property {Array.<number>|null} [path] Location path
           * @property {Array.<number>|null} [span] Location span
           * @property {string|null} [leadingComments] Location leadingComments
           * @property {string|null} [trailingComments] Location trailingComments
           * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
           */

          /**
           * Constructs a new Location.
           * @memberof google.protobuf.SourceCodeInfo
           * @classdesc Represents a Location.
           * @implements ILocation
           * @constructor
           * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
           */
          function Location(properties) {
            this.path = [];
            this.span = [];
            this.leadingDetachedComments = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Location path.
           * @member {Array.<number>} path
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           */
          Location.prototype.path = $util.emptyArray;

          /**
           * Location span.
           * @member {Array.<number>} span
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           */
          Location.prototype.span = $util.emptyArray;

          /**
           * Location leadingComments.
           * @member {string} leadingComments
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           */
          Location.prototype.leadingComments = "";

          /**
           * Location trailingComments.
           * @member {string} trailingComments
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           */
          Location.prototype.trailingComments = "";

          /**
           * Location leadingDetachedComments.
           * @member {Array.<string>} leadingDetachedComments
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           */
          Location.prototype.leadingDetachedComments = $util.emptyArray;

          /**
           * Creates a new Location instance using the specified properties.
           * @function create
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @static
           * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
           * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
           */
          Location.create = function create(properties) {
            return new Location(properties);
          };

          /**
           * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
           * @function encode
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @static
           * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Location.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.path != null && message.path.length) {
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
              for (var i = 0; i < message.path.length; ++i)
                writer.int32(message.path[i]);
              writer.ldelim();
            }
            if (message.span != null && message.span.length) {
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork();
              for (var i = 0; i < message.span.length; ++i)
                writer.int32(message.span[i]);
              writer.ldelim();
            }
            if (
              message.leadingComments != null &&
              Object.hasOwnProperty.call(message, "leadingComments")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.leadingComments);
            if (
              message.trailingComments != null &&
              Object.hasOwnProperty.call(message, "trailingComments")
            )
              writer
                .uint32(/* id 4, wireType 2 =*/ 34)
                .string(message.trailingComments);
            if (
              message.leadingDetachedComments != null &&
              message.leadingDetachedComments.length
            )
              for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                writer
                  .uint32(/* id 6, wireType 2 =*/ 50)
                  .string(message.leadingDetachedComments[i]);
            return writer;
          };

          /**
           * Decodes a Location message from the specified reader or buffer.
           * @function decode
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.protobuf.SourceCodeInfo.Location} Location
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Location.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.google.protobuf.SourceCodeInfo.Location();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.path && message.path.length)) message.path = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2) message.path.push(reader.int32());
                  } else message.path.push(reader.int32());
                  break;
                case 2:
                  if (!(message.span && message.span.length)) message.span = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2) message.span.push(reader.int32());
                  } else message.span.push(reader.int32());
                  break;
                case 3:
                  message.leadingComments = reader.string();
                  break;
                case 4:
                  message.trailingComments = reader.string();
                  break;
                case 6:
                  if (
                    !(
                      message.leadingDetachedComments &&
                      message.leadingDetachedComments.length
                    )
                  )
                    message.leadingDetachedComments = [];
                  message.leadingDetachedComments.push(reader.string());
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Location message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.protobuf.SourceCodeInfo.Location} Location
           */
          Location.fromObject = function fromObject(object) {
            if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
              return object;
            var message = new $root.google.protobuf.SourceCodeInfo.Location();
            if (object.path) {
              if (!Array.isArray(object.path))
                throw TypeError(
                  ".google.protobuf.SourceCodeInfo.Location.path: array expected"
                );
              message.path = [];
              for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] | 0;
            }
            if (object.span) {
              if (!Array.isArray(object.span))
                throw TypeError(
                  ".google.protobuf.SourceCodeInfo.Location.span: array expected"
                );
              message.span = [];
              for (var i = 0; i < object.span.length; ++i)
                message.span[i] = object.span[i] | 0;
            }
            if (object.leadingComments != null)
              message.leadingComments = String(object.leadingComments);
            if (object.trailingComments != null)
              message.trailingComments = String(object.trailingComments);
            if (object.leadingDetachedComments) {
              if (!Array.isArray(object.leadingDetachedComments))
                throw TypeError(
                  ".google.protobuf.SourceCodeInfo.Location.leadingDetachedComments: array expected"
                );
              message.leadingDetachedComments = [];
              for (var i = 0; i < object.leadingDetachedComments.length; ++i)
                message.leadingDetachedComments[i] = String(
                  object.leadingDetachedComments[i]
                );
            }
            return message;
          };

          /**
           * Creates a plain object from a Location message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @static
           * @param {google.protobuf.SourceCodeInfo.Location} message Location
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Location.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
              object.path = [];
              object.span = [];
              object.leadingDetachedComments = [];
            }
            if (options.defaults) {
              object.leadingComments = "";
              object.trailingComments = "";
            }
            if (message.path && message.path.length) {
              object.path = [];
              for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
            }
            if (message.span && message.span.length) {
              object.span = [];
              for (var j = 0; j < message.span.length; ++j)
                object.span[j] = message.span[j];
            }
            if (
              message.leadingComments != null &&
              message.hasOwnProperty("leadingComments")
            )
              object.leadingComments = message.leadingComments;
            if (
              message.trailingComments != null &&
              message.hasOwnProperty("trailingComments")
            )
              object.trailingComments = message.trailingComments;
            if (
              message.leadingDetachedComments &&
              message.leadingDetachedComments.length
            ) {
              object.leadingDetachedComments = [];
              for (var j = 0; j < message.leadingDetachedComments.length; ++j)
                object.leadingDetachedComments[j] =
                  message.leadingDetachedComments[j];
            }
            return object;
          };

          /**
           * Converts this Location to JSON.
           * @function toJSON
           * @memberof google.protobuf.SourceCodeInfo.Location
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Location;
        })();

        return SourceCodeInfo;
      })();

      protobuf.GeneratedCodeInfo = (function () {
        /**
         * Properties of a GeneratedCodeInfo.
         * @memberof google.protobuf
         * @interface IGeneratedCodeInfo
         * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
         */

        /**
         * Constructs a new GeneratedCodeInfo.
         * @memberof google.protobuf
         * @classdesc Represents a GeneratedCodeInfo.
         * @implements IGeneratedCodeInfo
         * @constructor
         * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
         */
        function GeneratedCodeInfo(properties) {
          this.annotation = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * GeneratedCodeInfo annotation.
         * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
         * @memberof google.protobuf.GeneratedCodeInfo
         * @instance
         */
        GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

        /**
         * Creates a new GeneratedCodeInfo instance using the specified properties.
         * @function create
         * @memberof google.protobuf.GeneratedCodeInfo
         * @static
         * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
         * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
         */
        GeneratedCodeInfo.create = function create(properties) {
          return new GeneratedCodeInfo(properties);
        };

        /**
         * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.GeneratedCodeInfo
         * @static
         * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeneratedCodeInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.annotation != null && message.annotation.length)
            for (var i = 0; i < message.annotation.length; ++i)
              $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(
                message.annotation[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.GeneratedCodeInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeneratedCodeInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.GeneratedCodeInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.annotation && message.annotation.length))
                  message.annotation = [];
                message.annotation.push(
                  $root.google.protobuf.GeneratedCodeInfo.Annotation.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a GeneratedCodeInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.GeneratedCodeInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
         */
        GeneratedCodeInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
            return object;
          var message = new $root.google.protobuf.GeneratedCodeInfo();
          if (object.annotation) {
            if (!Array.isArray(object.annotation))
              throw TypeError(
                ".google.protobuf.GeneratedCodeInfo.annotation: array expected"
              );
            message.annotation = [];
            for (var i = 0; i < object.annotation.length; ++i) {
              if (typeof object.annotation[i] !== "object")
                throw TypeError(
                  ".google.protobuf.GeneratedCodeInfo.annotation: object expected"
                );
              message.annotation[i] =
                $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(
                  object.annotation[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a GeneratedCodeInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.GeneratedCodeInfo
         * @static
         * @param {google.protobuf.GeneratedCodeInfo} message GeneratedCodeInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GeneratedCodeInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.annotation = [];
          if (message.annotation && message.annotation.length) {
            object.annotation = [];
            for (var j = 0; j < message.annotation.length; ++j)
              object.annotation[j] =
                $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(
                  message.annotation[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this GeneratedCodeInfo to JSON.
         * @function toJSON
         * @memberof google.protobuf.GeneratedCodeInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GeneratedCodeInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GeneratedCodeInfo.Annotation = (function () {
          /**
           * Properties of an Annotation.
           * @memberof google.protobuf.GeneratedCodeInfo
           * @interface IAnnotation
           * @property {Array.<number>|null} [path] Annotation path
           * @property {string|null} [sourceFile] Annotation sourceFile
           * @property {number|null} [begin] Annotation begin
           * @property {number|null} [end] Annotation end
           */

          /**
           * Constructs a new Annotation.
           * @memberof google.protobuf.GeneratedCodeInfo
           * @classdesc Represents an Annotation.
           * @implements IAnnotation
           * @constructor
           * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
           */
          function Annotation(properties) {
            this.path = [];
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Annotation path.
           * @member {Array.<number>} path
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @instance
           */
          Annotation.prototype.path = $util.emptyArray;

          /**
           * Annotation sourceFile.
           * @member {string} sourceFile
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @instance
           */
          Annotation.prototype.sourceFile = "";

          /**
           * Annotation begin.
           * @member {number} begin
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @instance
           */
          Annotation.prototype.begin = 0;

          /**
           * Annotation end.
           * @member {number} end
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @instance
           */
          Annotation.prototype.end = 0;

          /**
           * Creates a new Annotation instance using the specified properties.
           * @function create
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @static
           * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
           * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
           */
          Annotation.create = function create(properties) {
            return new Annotation(properties);
          };

          /**
           * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
           * @function encode
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @static
           * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Annotation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (message.path != null && message.path.length) {
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
              for (var i = 0; i < message.path.length; ++i)
                writer.int32(message.path[i]);
              writer.ldelim();
            }
            if (
              message.sourceFile != null &&
              Object.hasOwnProperty.call(message, "sourceFile")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.sourceFile);
            if (
              message.begin != null &&
              Object.hasOwnProperty.call(message, "begin")
            )
              writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.begin);
            if (
              message.end != null &&
              Object.hasOwnProperty.call(message, "end")
            )
              writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.end);
            return writer;
          };

          /**
           * Decodes an Annotation message from the specified reader or buffer.
           * @function decode
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Annotation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message =
                new $root.google.protobuf.GeneratedCodeInfo.Annotation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  if (!(message.path && message.path.length)) message.path = [];
                  if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2) message.path.push(reader.int32());
                  } else message.path.push(reader.int32());
                  break;
                case 2:
                  message.sourceFile = reader.string();
                  break;
                case 3:
                  message.begin = reader.int32();
                  break;
                case 4:
                  message.end = reader.int32();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates an Annotation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
           */
          Annotation.fromObject = function fromObject(object) {
            if (
              object instanceof
              $root.google.protobuf.GeneratedCodeInfo.Annotation
            )
              return object;
            var message =
              new $root.google.protobuf.GeneratedCodeInfo.Annotation();
            if (object.path) {
              if (!Array.isArray(object.path))
                throw TypeError(
                  ".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected"
                );
              message.path = [];
              for (var i = 0; i < object.path.length; ++i)
                message.path[i] = object.path[i] | 0;
            }
            if (object.sourceFile != null)
              message.sourceFile = String(object.sourceFile);
            if (object.begin != null) message.begin = object.begin | 0;
            if (object.end != null) message.end = object.end | 0;
            return message;
          };

          /**
           * Creates a plain object from an Annotation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @static
           * @param {google.protobuf.GeneratedCodeInfo.Annotation} message Annotation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Annotation.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
              object.sourceFile = "";
              object.begin = 0;
              object.end = 0;
            }
            if (message.path && message.path.length) {
              object.path = [];
              for (var j = 0; j < message.path.length; ++j)
                object.path[j] = message.path[j];
            }
            if (
              message.sourceFile != null &&
              message.hasOwnProperty("sourceFile")
            )
              object.sourceFile = message.sourceFile;
            if (message.begin != null && message.hasOwnProperty("begin"))
              object.begin = message.begin;
            if (message.end != null && message.hasOwnProperty("end"))
              object.end = message.end;
            return object;
          };

          /**
           * Converts this Annotation to JSON.
           * @function toJSON
           * @memberof google.protobuf.GeneratedCodeInfo.Annotation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Annotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Annotation;
        })();

        return GeneratedCodeInfo;
      })();

      protobuf.Any = (function () {
        /**
         * Properties of an Any.
         * @memberof google.protobuf
         * @interface IAny
         * @property {string|null} [type_url] Any type_url
         * @property {Uint8Array|null} [value] Any value
         */

        /**
         * Constructs a new Any.
         * @memberof google.protobuf
         * @classdesc Represents an Any.
         * @implements IAny
         * @constructor
         * @param {google.protobuf.IAny=} [properties] Properties to set
         */
        function Any(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Any type_url.
         * @member {string} type_url
         * @memberof google.protobuf.Any
         * @instance
         */
        Any.prototype.type_url = "";

        /**
         * Any value.
         * @member {Uint8Array} value
         * @memberof google.protobuf.Any
         * @instance
         */
        Any.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new Any instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Any
         * @static
         * @param {google.protobuf.IAny=} [properties] Properties to set
         * @returns {google.protobuf.Any} Any instance
         */
        Any.create = function create(properties) {
          return new Any(properties);
        };

        /**
         * Encodes the specified Any message. Does not implicitly {@link google.protobuf.Any.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Any
         * @static
         * @param {google.protobuf.IAny} message Any message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Any.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.type_url != null &&
            Object.hasOwnProperty.call(message, "type_url")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type_url);
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
          return writer;
        };

        /**
         * Decodes an Any message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Any
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Any} Any
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Any.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Any();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.type_url = reader.string();
                break;
              case 2:
                message.value = reader.bytes();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an Any message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Any
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Any} Any
         */
        Any.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Any) return object;
          var message = new $root.google.protobuf.Any();
          if (object.type_url != null)
            message.type_url = String(object.type_url);
          if (object.value != null)
            if (typeof object.value === "string")
              $util.base64.decode(
                object.value,
                (message.value = $util.newBuffer(
                  $util.base64.length(object.value)
                )),
                0
              );
            else if (object.value.length) message.value = object.value;
          return message;
        };

        /**
         * Creates a plain object from an Any message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Any
         * @static
         * @param {google.protobuf.Any} message Any
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Any.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.type_url = "";
            if (options.bytes === String) object.value = "";
            else {
              object.value = [];
              if (options.bytes !== Array)
                object.value = $util.newBuffer(object.value);
            }
          }
          if (message.type_url != null && message.hasOwnProperty("type_url"))
            object.type_url = message.type_url;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value =
              options.bytes === String
                ? $util.base64.encode(message.value, 0, message.value.length)
                : options.bytes === Array
                ? Array.prototype.slice.call(message.value)
                : message.value;
          return object;
        };

        /**
         * Converts this Any to JSON.
         * @function toJSON
         * @memberof google.protobuf.Any
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Any.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Any;
      })();

      protobuf.Duration = (function () {
        /**
         * Properties of a Duration.
         * @memberof google.protobuf
         * @interface IDuration
         * @property {number|Long|null} [seconds] Duration seconds
         * @property {number|null} [nanos] Duration nanos
         */

        /**
         * Constructs a new Duration.
         * @memberof google.protobuf
         * @classdesc Represents a Duration.
         * @implements IDuration
         * @constructor
         * @param {google.protobuf.IDuration=} [properties] Properties to set
         */
        function Duration(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Duration seconds.
         * @member {number|Long} seconds
         * @memberof google.protobuf.Duration
         * @instance
         */
        Duration.prototype.seconds = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * Duration nanos.
         * @member {number} nanos
         * @memberof google.protobuf.Duration
         * @instance
         */
        Duration.prototype.nanos = 0;

        /**
         * Creates a new Duration instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Duration
         * @static
         * @param {google.protobuf.IDuration=} [properties] Properties to set
         * @returns {google.protobuf.Duration} Duration instance
         */
        Duration.create = function create(properties) {
          return new Duration(properties);
        };

        /**
         * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Duration
         * @static
         * @param {google.protobuf.IDuration} message Duration message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Duration.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.seconds != null &&
            Object.hasOwnProperty.call(message, "seconds")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.seconds);
          if (
            message.nanos != null &&
            Object.hasOwnProperty.call(message, "nanos")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.nanos);
          return writer;
        };

        /**
         * Decodes a Duration message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Duration
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Duration} Duration
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Duration.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Duration();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.seconds = reader.int64();
                break;
              case 2:
                message.nanos = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Duration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Duration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Duration} Duration
         */
        Duration.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Duration) return object;
          var message = new $root.google.protobuf.Duration();
          if (object.seconds != null)
            if ($util.Long)
              (message.seconds = $util.Long.fromValue(
                object.seconds
              )).unsigned = false;
            else if (typeof object.seconds === "string")
              message.seconds = parseInt(object.seconds, 10);
            else if (typeof object.seconds === "number")
              message.seconds = object.seconds;
            else if (typeof object.seconds === "object")
              message.seconds = new $util.LongBits(
                object.seconds.low >>> 0,
                object.seconds.high >>> 0
              ).toNumber();
          if (object.nanos != null) message.nanos = object.nanos | 0;
          return message;
        };

        /**
         * Creates a plain object from a Duration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Duration
         * @static
         * @param {google.protobuf.Duration} message Duration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Duration.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.seconds =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.seconds = options.longs === String ? "0" : 0;
            object.nanos = 0;
          }
          if (message.seconds != null && message.hasOwnProperty("seconds"))
            if (typeof message.seconds === "number")
              object.seconds =
                options.longs === String
                  ? String(message.seconds)
                  : message.seconds;
            else
              object.seconds =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.seconds)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.seconds.low >>> 0,
                      message.seconds.high >>> 0
                    ).toNumber()
                  : message.seconds;
          if (message.nanos != null && message.hasOwnProperty("nanos"))
            object.nanos = message.nanos;
          return object;
        };

        /**
         * Converts this Duration to JSON.
         * @function toJSON
         * @memberof google.protobuf.Duration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Duration.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Duration;
      })();

      protobuf.DoubleValue = (function () {
        /**
         * Properties of a DoubleValue.
         * @memberof google.protobuf
         * @interface IDoubleValue
         * @property {number|null} [value] DoubleValue value
         */

        /**
         * Constructs a new DoubleValue.
         * @memberof google.protobuf
         * @classdesc Represents a DoubleValue.
         * @implements IDoubleValue
         * @constructor
         * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
         */
        function DoubleValue(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * DoubleValue value.
         * @member {number} value
         * @memberof google.protobuf.DoubleValue
         * @instance
         */
        DoubleValue.prototype.value = 0;

        /**
         * Creates a new DoubleValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.DoubleValue
         * @static
         * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
         * @returns {google.protobuf.DoubleValue} DoubleValue instance
         */
        DoubleValue.create = function create(properties) {
          return new DoubleValue(properties);
        };

        /**
         * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.DoubleValue
         * @static
         * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
          return writer;
        };

        /**
         * Decodes a DoubleValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.DoubleValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.DoubleValue} DoubleValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.DoubleValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.double();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.DoubleValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.DoubleValue} DoubleValue
         */
        DoubleValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.DoubleValue)
            return object;
          var message = new $root.google.protobuf.DoubleValue();
          if (object.value != null) message.value = Number(object.value);
          return message;
        };

        /**
         * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.DoubleValue
         * @static
         * @param {google.protobuf.DoubleValue} message DoubleValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DoubleValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = 0;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value =
              options.json && !isFinite(message.value)
                ? String(message.value)
                : message.value;
          return object;
        };

        /**
         * Converts this DoubleValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.DoubleValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DoubleValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DoubleValue;
      })();

      protobuf.FloatValue = (function () {
        /**
         * Properties of a FloatValue.
         * @memberof google.protobuf
         * @interface IFloatValue
         * @property {number|null} [value] FloatValue value
         */

        /**
         * Constructs a new FloatValue.
         * @memberof google.protobuf
         * @classdesc Represents a FloatValue.
         * @implements IFloatValue
         * @constructor
         * @param {google.protobuf.IFloatValue=} [properties] Properties to set
         */
        function FloatValue(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FloatValue value.
         * @member {number} value
         * @memberof google.protobuf.FloatValue
         * @instance
         */
        FloatValue.prototype.value = 0;

        /**
         * Creates a new FloatValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FloatValue
         * @static
         * @param {google.protobuf.IFloatValue=} [properties] Properties to set
         * @returns {google.protobuf.FloatValue} FloatValue instance
         */
        FloatValue.create = function create(properties) {
          return new FloatValue(properties);
        };

        /**
         * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FloatValue
         * @static
         * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FloatValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 5 =*/ 13).float(message.value);
          return writer;
        };

        /**
         * Decodes a FloatValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FloatValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FloatValue} FloatValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FloatValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FloatValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.float();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FloatValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FloatValue} FloatValue
         */
        FloatValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FloatValue) return object;
          var message = new $root.google.protobuf.FloatValue();
          if (object.value != null) message.value = Number(object.value);
          return message;
        };

        /**
         * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FloatValue
         * @static
         * @param {google.protobuf.FloatValue} message FloatValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FloatValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = 0;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value =
              options.json && !isFinite(message.value)
                ? String(message.value)
                : message.value;
          return object;
        };

        /**
         * Converts this FloatValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.FloatValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FloatValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FloatValue;
      })();

      protobuf.Int64Value = (function () {
        /**
         * Properties of an Int64Value.
         * @memberof google.protobuf
         * @interface IInt64Value
         * @property {number|Long|null} [value] Int64Value value
         */

        /**
         * Constructs a new Int64Value.
         * @memberof google.protobuf
         * @classdesc Represents an Int64Value.
         * @implements IInt64Value
         * @constructor
         * @param {google.protobuf.IInt64Value=} [properties] Properties to set
         */
        function Int64Value(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Int64Value value.
         * @member {number|Long} value
         * @memberof google.protobuf.Int64Value
         * @instance
         */
        Int64Value.prototype.value = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * Creates a new Int64Value instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Int64Value
         * @static
         * @param {google.protobuf.IInt64Value=} [properties] Properties to set
         * @returns {google.protobuf.Int64Value} Int64Value instance
         */
        Int64Value.create = function create(properties) {
          return new Int64Value(properties);
        };

        /**
         * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Int64Value
         * @static
         * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Int64Value.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.value);
          return writer;
        };

        /**
         * Decodes an Int64Value message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Int64Value
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Int64Value} Int64Value
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Int64Value.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Int64Value();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.int64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Int64Value
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Int64Value} Int64Value
         */
        Int64Value.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Int64Value) return object;
          var message = new $root.google.protobuf.Int64Value();
          if (object.value != null)
            if ($util.Long)
              (message.value = $util.Long.fromValue(
                object.value
              )).unsigned = false;
            else if (typeof object.value === "string")
              message.value = parseInt(object.value, 10);
            else if (typeof object.value === "number")
              message.value = object.value;
            else if (typeof object.value === "object")
              message.value = new $util.LongBits(
                object.value.low >>> 0,
                object.value.high >>> 0
              ).toNumber();
          return message;
        };

        /**
         * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Int64Value
         * @static
         * @param {google.protobuf.Int64Value} message Int64Value
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Int64Value.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults)
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.value =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.value = options.longs === String ? "0" : 0;
          if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value === "number")
              object.value =
                options.longs === String
                  ? String(message.value)
                  : message.value;
            else
              object.value =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.value)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.value.low >>> 0,
                      message.value.high >>> 0
                    ).toNumber()
                  : message.value;
          return object;
        };

        /**
         * Converts this Int64Value to JSON.
         * @function toJSON
         * @memberof google.protobuf.Int64Value
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Int64Value.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Int64Value;
      })();

      protobuf.UInt64Value = (function () {
        /**
         * Properties of a UInt64Value.
         * @memberof google.protobuf
         * @interface IUInt64Value
         * @property {number|Long|null} [value] UInt64Value value
         */

        /**
         * Constructs a new UInt64Value.
         * @memberof google.protobuf
         * @classdesc Represents a UInt64Value.
         * @implements IUInt64Value
         * @constructor
         * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
         */
        function UInt64Value(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * UInt64Value value.
         * @member {number|Long} value
         * @memberof google.protobuf.UInt64Value
         * @instance
         */
        UInt64Value.prototype.value = $util.Long
          ? $util.Long.fromBits(0, 0, true)
          : 0;

        /**
         * Creates a new UInt64Value instance using the specified properties.
         * @function create
         * @memberof google.protobuf.UInt64Value
         * @static
         * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
         * @returns {google.protobuf.UInt64Value} UInt64Value instance
         */
        UInt64Value.create = function create(properties) {
          return new UInt64Value(properties);
        };

        /**
         * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.UInt64Value
         * @static
         * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UInt64Value.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).uint64(message.value);
          return writer;
        };

        /**
         * Decodes a UInt64Value message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.UInt64Value
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.UInt64Value} UInt64Value
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UInt64Value.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.UInt64Value();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.uint64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.UInt64Value
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.UInt64Value} UInt64Value
         */
        UInt64Value.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.UInt64Value)
            return object;
          var message = new $root.google.protobuf.UInt64Value();
          if (object.value != null)
            if ($util.Long)
              (message.value = $util.Long.fromValue(
                object.value
              )).unsigned = true;
            else if (typeof object.value === "string")
              message.value = parseInt(object.value, 10);
            else if (typeof object.value === "number")
              message.value = object.value;
            else if (typeof object.value === "object")
              message.value = new $util.LongBits(
                object.value.low >>> 0,
                object.value.high >>> 0
              ).toNumber(true);
          return message;
        };

        /**
         * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.UInt64Value
         * @static
         * @param {google.protobuf.UInt64Value} message UInt64Value
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UInt64Value.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults)
            if ($util.Long) {
              var long = new $util.Long(0, 0, true);
              object.value =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.value = options.longs === String ? "0" : 0;
          if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value === "number")
              object.value =
                options.longs === String
                  ? String(message.value)
                  : message.value;
            else
              object.value =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.value)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.value.low >>> 0,
                      message.value.high >>> 0
                    ).toNumber(true)
                  : message.value;
          return object;
        };

        /**
         * Converts this UInt64Value to JSON.
         * @function toJSON
         * @memberof google.protobuf.UInt64Value
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UInt64Value.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UInt64Value;
      })();

      protobuf.Int32Value = (function () {
        /**
         * Properties of an Int32Value.
         * @memberof google.protobuf
         * @interface IInt32Value
         * @property {number|null} [value] Int32Value value
         */

        /**
         * Constructs a new Int32Value.
         * @memberof google.protobuf
         * @classdesc Represents an Int32Value.
         * @implements IInt32Value
         * @constructor
         * @param {google.protobuf.IInt32Value=} [properties] Properties to set
         */
        function Int32Value(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Int32Value value.
         * @member {number} value
         * @memberof google.protobuf.Int32Value
         * @instance
         */
        Int32Value.prototype.value = 0;

        /**
         * Creates a new Int32Value instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Int32Value
         * @static
         * @param {google.protobuf.IInt32Value=} [properties] Properties to set
         * @returns {google.protobuf.Int32Value} Int32Value instance
         */
        Int32Value.create = function create(properties) {
          return new Int32Value(properties);
        };

        /**
         * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Int32Value
         * @static
         * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Int32Value.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.value);
          return writer;
        };

        /**
         * Decodes an Int32Value message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Int32Value
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Int32Value} Int32Value
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Int32Value.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Int32Value();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Int32Value
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Int32Value} Int32Value
         */
        Int32Value.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Int32Value) return object;
          var message = new $root.google.protobuf.Int32Value();
          if (object.value != null) message.value = object.value | 0;
          return message;
        };

        /**
         * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Int32Value
         * @static
         * @param {google.protobuf.Int32Value} message Int32Value
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Int32Value.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = 0;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this Int32Value to JSON.
         * @function toJSON
         * @memberof google.protobuf.Int32Value
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Int32Value.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Int32Value;
      })();

      protobuf.UInt32Value = (function () {
        /**
         * Properties of a UInt32Value.
         * @memberof google.protobuf
         * @interface IUInt32Value
         * @property {number|null} [value] UInt32Value value
         */

        /**
         * Constructs a new UInt32Value.
         * @memberof google.protobuf
         * @classdesc Represents a UInt32Value.
         * @implements IUInt32Value
         * @constructor
         * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
         */
        function UInt32Value(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * UInt32Value value.
         * @member {number} value
         * @memberof google.protobuf.UInt32Value
         * @instance
         */
        UInt32Value.prototype.value = 0;

        /**
         * Creates a new UInt32Value instance using the specified properties.
         * @function create
         * @memberof google.protobuf.UInt32Value
         * @static
         * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
         * @returns {google.protobuf.UInt32Value} UInt32Value instance
         */
        UInt32Value.create = function create(properties) {
          return new UInt32Value(properties);
        };

        /**
         * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.UInt32Value
         * @static
         * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UInt32Value.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).uint32(message.value);
          return writer;
        };

        /**
         * Decodes a UInt32Value message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.UInt32Value
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.UInt32Value} UInt32Value
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UInt32Value.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.UInt32Value();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.uint32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.UInt32Value
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.UInt32Value} UInt32Value
         */
        UInt32Value.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.UInt32Value)
            return object;
          var message = new $root.google.protobuf.UInt32Value();
          if (object.value != null) message.value = object.value >>> 0;
          return message;
        };

        /**
         * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.UInt32Value
         * @static
         * @param {google.protobuf.UInt32Value} message UInt32Value
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UInt32Value.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = 0;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this UInt32Value to JSON.
         * @function toJSON
         * @memberof google.protobuf.UInt32Value
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UInt32Value.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UInt32Value;
      })();

      protobuf.BoolValue = (function () {
        /**
         * Properties of a BoolValue.
         * @memberof google.protobuf
         * @interface IBoolValue
         * @property {boolean|null} [value] BoolValue value
         */

        /**
         * Constructs a new BoolValue.
         * @memberof google.protobuf
         * @classdesc Represents a BoolValue.
         * @implements IBoolValue
         * @constructor
         * @param {google.protobuf.IBoolValue=} [properties] Properties to set
         */
        function BoolValue(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * BoolValue value.
         * @member {boolean} value
         * @memberof google.protobuf.BoolValue
         * @instance
         */
        BoolValue.prototype.value = false;

        /**
         * Creates a new BoolValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.BoolValue
         * @static
         * @param {google.protobuf.IBoolValue=} [properties] Properties to set
         * @returns {google.protobuf.BoolValue} BoolValue instance
         */
        BoolValue.create = function create(properties) {
          return new BoolValue(properties);
        };

        /**
         * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.BoolValue
         * @static
         * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BoolValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).bool(message.value);
          return writer;
        };

        /**
         * Decodes a BoolValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.BoolValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.BoolValue} BoolValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BoolValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.BoolValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.bool();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.BoolValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.BoolValue} BoolValue
         */
        BoolValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.BoolValue) return object;
          var message = new $root.google.protobuf.BoolValue();
          if (object.value != null) message.value = Boolean(object.value);
          return message;
        };

        /**
         * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.BoolValue
         * @static
         * @param {google.protobuf.BoolValue} message BoolValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BoolValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = false;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this BoolValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.BoolValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BoolValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BoolValue;
      })();

      protobuf.StringValue = (function () {
        /**
         * Properties of a StringValue.
         * @memberof google.protobuf
         * @interface IStringValue
         * @property {string|null} [value] StringValue value
         */

        /**
         * Constructs a new StringValue.
         * @memberof google.protobuf
         * @classdesc Represents a StringValue.
         * @implements IStringValue
         * @constructor
         * @param {google.protobuf.IStringValue=} [properties] Properties to set
         */
        function StringValue(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * StringValue value.
         * @member {string} value
         * @memberof google.protobuf.StringValue
         * @instance
         */
        StringValue.prototype.value = "";

        /**
         * Creates a new StringValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.StringValue
         * @static
         * @param {google.protobuf.IStringValue=} [properties] Properties to set
         * @returns {google.protobuf.StringValue} StringValue instance
         */
        StringValue.create = function create(properties) {
          return new StringValue(properties);
        };

        /**
         * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.StringValue
         * @static
         * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StringValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.value);
          return writer;
        };

        /**
         * Decodes a StringValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.StringValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.StringValue} StringValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StringValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.StringValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.StringValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.StringValue} StringValue
         */
        StringValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.StringValue)
            return object;
          var message = new $root.google.protobuf.StringValue();
          if (object.value != null) message.value = String(object.value);
          return message;
        };

        /**
         * Creates a plain object from a StringValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.StringValue
         * @static
         * @param {google.protobuf.StringValue} message StringValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StringValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = "";
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this StringValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.StringValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StringValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StringValue;
      })();

      protobuf.BytesValue = (function () {
        /**
         * Properties of a BytesValue.
         * @memberof google.protobuf
         * @interface IBytesValue
         * @property {Uint8Array|null} [value] BytesValue value
         */

        /**
         * Constructs a new BytesValue.
         * @memberof google.protobuf
         * @classdesc Represents a BytesValue.
         * @implements IBytesValue
         * @constructor
         * @param {google.protobuf.IBytesValue=} [properties] Properties to set
         */
        function BytesValue(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * BytesValue value.
         * @member {Uint8Array} value
         * @memberof google.protobuf.BytesValue
         * @instance
         */
        BytesValue.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new BytesValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.BytesValue
         * @static
         * @param {google.protobuf.IBytesValue=} [properties] Properties to set
         * @returns {google.protobuf.BytesValue} BytesValue instance
         */
        BytesValue.create = function create(properties) {
          return new BytesValue(properties);
        };

        /**
         * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.BytesValue
         * @static
         * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BytesValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.value);
          return writer;
        };

        /**
         * Decodes a BytesValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.BytesValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.BytesValue} BytesValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BytesValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.BytesValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.bytes();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.BytesValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.BytesValue} BytesValue
         */
        BytesValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.BytesValue) return object;
          var message = new $root.google.protobuf.BytesValue();
          if (object.value != null)
            if (typeof object.value === "string")
              $util.base64.decode(
                object.value,
                (message.value = $util.newBuffer(
                  $util.base64.length(object.value)
                )),
                0
              );
            else if (object.value.length) message.value = object.value;
          return message;
        };

        /**
         * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.BytesValue
         * @static
         * @param {google.protobuf.BytesValue} message BytesValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BytesValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults)
            if (options.bytes === String) object.value = "";
            else {
              object.value = [];
              if (options.bytes !== Array)
                object.value = $util.newBuffer(object.value);
            }
          if (message.value != null && message.hasOwnProperty("value"))
            object.value =
              options.bytes === String
                ? $util.base64.encode(message.value, 0, message.value.length)
                : options.bytes === Array
                ? Array.prototype.slice.call(message.value)
                : message.value;
          return object;
        };

        /**
         * Converts this BytesValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.BytesValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BytesValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BytesValue;
      })();

      protobuf.Struct = (function () {
        /**
         * Properties of a Struct.
         * @memberof google.protobuf
         * @interface IStruct
         * @property {Object.<string,google.protobuf.IValue>|null} [fields] Struct fields
         */

        /**
         * Constructs a new Struct.
         * @memberof google.protobuf
         * @classdesc Represents a Struct.
         * @implements IStruct
         * @constructor
         * @param {google.protobuf.IStruct=} [properties] Properties to set
         */
        function Struct(properties) {
          this.fields = {};
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Struct fields.
         * @member {Object.<string,google.protobuf.IValue>} fields
         * @memberof google.protobuf.Struct
         * @instance
         */
        Struct.prototype.fields = $util.emptyObject;

        /**
         * Creates a new Struct instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Struct
         * @static
         * @param {google.protobuf.IStruct=} [properties] Properties to set
         * @returns {google.protobuf.Struct} Struct instance
         */
        Struct.create = function create(properties) {
          return new Struct(properties);
        };

        /**
         * Encodes the specified Struct message. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Struct
         * @static
         * @param {google.protobuf.IStruct} message Struct message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Struct.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.fields != null &&
            Object.hasOwnProperty.call(message, "fields")
          )
            for (
              var keys = Object.keys(message.fields), i = 0;
              i < keys.length;
              ++i
            ) {
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i]);
              $root.google.protobuf.Value.encode(
                message.fields[keys[i]],
                writer.uint32(/* id 2, wireType 2 =*/ 18).fork()
              )
                .ldelim()
                .ldelim();
            }
          return writer;
        };

        /**
         * Decodes a Struct message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Struct
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Struct} Struct
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Struct.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Struct(),
            key;
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                reader.skip().pos++;
                if (message.fields === $util.emptyObject) message.fields = {};
                key = reader.string();
                reader.pos++;
                message.fields[key] = $root.google.protobuf.Value.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Struct message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Struct
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Struct} Struct
         */
        Struct.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Struct) return object;
          var message = new $root.google.protobuf.Struct();
          if (object.fields) {
            if (typeof object.fields !== "object")
              throw TypeError(
                ".google.protobuf.Struct.fields: object expected"
              );
            message.fields = {};
            for (
              var keys = Object.keys(object.fields), i = 0;
              i < keys.length;
              ++i
            ) {
              if (typeof object.fields[keys[i]] !== "object")
                throw TypeError(
                  ".google.protobuf.Struct.fields: object expected"
                );
              message.fields[keys[i]] = $root.google.protobuf.Value.fromObject(
                object.fields[keys[i]]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Struct message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Struct
         * @static
         * @param {google.protobuf.Struct} message Struct
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Struct.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.objects || options.defaults) object.fields = {};
          var keys2;
          if (message.fields && (keys2 = Object.keys(message.fields)).length) {
            object.fields = {};
            for (var j = 0; j < keys2.length; ++j)
              object.fields[keys2[j]] = $root.google.protobuf.Value.toObject(
                message.fields[keys2[j]],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Struct to JSON.
         * @function toJSON
         * @memberof google.protobuf.Struct
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Struct.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Struct;
      })();

      protobuf.Value = (function () {
        /**
         * Properties of a Value.
         * @memberof google.protobuf
         * @interface IValue
         * @property {google.protobuf.NullValue|null} [nullValue] Value nullValue
         * @property {number|null} [numberValue] Value numberValue
         * @property {string|null} [stringValue] Value stringValue
         * @property {boolean|null} [boolValue] Value boolValue
         * @property {google.protobuf.IStruct|null} [structValue] Value structValue
         * @property {google.protobuf.IListValue|null} [listValue] Value listValue
         */

        /**
         * Constructs a new Value.
         * @memberof google.protobuf
         * @classdesc Represents a Value.
         * @implements IValue
         * @constructor
         * @param {google.protobuf.IValue=} [properties] Properties to set
         */
        function Value(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Value nullValue.
         * @member {google.protobuf.NullValue} nullValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.nullValue = 0;

        /**
         * Value numberValue.
         * @member {number} numberValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.numberValue = 0;

        /**
         * Value stringValue.
         * @member {string} stringValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.stringValue = "";

        /**
         * Value boolValue.
         * @member {boolean} boolValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.boolValue = false;

        /**
         * Value structValue.
         * @member {google.protobuf.IStruct|null|undefined} structValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.structValue = null;

        /**
         * Value listValue.
         * @member {google.protobuf.IListValue|null|undefined} listValue
         * @memberof google.protobuf.Value
         * @instance
         */
        Value.prototype.listValue = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Value kind.
         * @member {"nullValue"|"numberValue"|"stringValue"|"boolValue"|"structValue"|"listValue"|undefined} kind
         * @memberof google.protobuf.Value
         * @instance
         */
        Object.defineProperty(Value.prototype, "kind", {
          get: $util.oneOfGetter(
            ($oneOfFields = [
              "nullValue",
              "numberValue",
              "stringValue",
              "boolValue",
              "structValue",
              "listValue"
            ])
          ),
          set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Value instance using the specified properties.
         * @function create
         * @memberof google.protobuf.Value
         * @static
         * @param {google.protobuf.IValue=} [properties] Properties to set
         * @returns {google.protobuf.Value} Value instance
         */
        Value.create = function create(properties) {
          return new Value(properties);
        };

        /**
         * Encodes the specified Value message. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.Value
         * @static
         * @param {google.protobuf.IValue} message Value message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Value.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.nullValue != null &&
            Object.hasOwnProperty.call(message, "nullValue")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.nullValue);
          if (
            message.numberValue != null &&
            Object.hasOwnProperty.call(message, "numberValue")
          )
            writer
              .uint32(/* id 2, wireType 1 =*/ 17)
              .double(message.numberValue);
          if (
            message.stringValue != null &&
            Object.hasOwnProperty.call(message, "stringValue")
          )
            writer
              .uint32(/* id 3, wireType 2 =*/ 26)
              .string(message.stringValue);
          if (
            message.boolValue != null &&
            Object.hasOwnProperty.call(message, "boolValue")
          )
            writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.boolValue);
          if (
            message.structValue != null &&
            Object.hasOwnProperty.call(message, "structValue")
          )
            $root.google.protobuf.Struct.encode(
              message.structValue,
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
          if (
            message.listValue != null &&
            Object.hasOwnProperty.call(message, "listValue")
          )
            $root.google.protobuf.ListValue.encode(
              message.listValue,
              writer.uint32(/* id 6, wireType 2 =*/ 50).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a Value message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.Value
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.Value} Value
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Value.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.Value();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.nullValue = reader.int32();
                break;
              case 2:
                message.numberValue = reader.double();
                break;
              case 3:
                message.stringValue = reader.string();
                break;
              case 4:
                message.boolValue = reader.bool();
                break;
              case 5:
                message.structValue = $root.google.protobuf.Struct.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 6:
                message.listValue = $root.google.protobuf.ListValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Value message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.Value
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.Value} Value
         */
        Value.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.Value) return object;
          var message = new $root.google.protobuf.Value();
          switch (object.nullValue) {
            case "NULL_VALUE":
            case 0:
              message.nullValue = 0;
              break;
          }
          if (object.numberValue != null)
            message.numberValue = Number(object.numberValue);
          if (object.stringValue != null)
            message.stringValue = String(object.stringValue);
          if (object.boolValue != null)
            message.boolValue = Boolean(object.boolValue);
          if (object.structValue != null) {
            if (typeof object.structValue !== "object")
              throw TypeError(
                ".google.protobuf.Value.structValue: object expected"
              );
            message.structValue = $root.google.protobuf.Struct.fromObject(
              object.structValue
            );
          }
          if (object.listValue != null) {
            if (typeof object.listValue !== "object")
              throw TypeError(
                ".google.protobuf.Value.listValue: object expected"
              );
            message.listValue = $root.google.protobuf.ListValue.fromObject(
              object.listValue
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a Value message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.Value
         * @static
         * @param {google.protobuf.Value} message Value
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Value.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (
            message.nullValue != null &&
            message.hasOwnProperty("nullValue")
          ) {
            object.nullValue =
              options.enums === String
                ? $root.google.protobuf.NullValue[message.nullValue]
                : message.nullValue;
            if (options.oneofs) object.kind = "nullValue";
          }
          if (
            message.numberValue != null &&
            message.hasOwnProperty("numberValue")
          ) {
            object.numberValue =
              options.json && !isFinite(message.numberValue)
                ? String(message.numberValue)
                : message.numberValue;
            if (options.oneofs) object.kind = "numberValue";
          }
          if (
            message.stringValue != null &&
            message.hasOwnProperty("stringValue")
          ) {
            object.stringValue = message.stringValue;
            if (options.oneofs) object.kind = "stringValue";
          }
          if (
            message.boolValue != null &&
            message.hasOwnProperty("boolValue")
          ) {
            object.boolValue = message.boolValue;
            if (options.oneofs) object.kind = "boolValue";
          }
          if (
            message.structValue != null &&
            message.hasOwnProperty("structValue")
          ) {
            object.structValue = $root.google.protobuf.Struct.toObject(
              message.structValue,
              options
            );
            if (options.oneofs) object.kind = "structValue";
          }
          if (
            message.listValue != null &&
            message.hasOwnProperty("listValue")
          ) {
            object.listValue = $root.google.protobuf.ListValue.toObject(
              message.listValue,
              options
            );
            if (options.oneofs) object.kind = "listValue";
          }
          return object;
        };

        /**
         * Converts this Value to JSON.
         * @function toJSON
         * @memberof google.protobuf.Value
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Value.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Value;
      })();

      /**
       * NullValue enum.
       * @name google.protobuf.NullValue
       * @enum {string}
       * @property {number} NULL_VALUE=0 NULL_VALUE value
       */
      protobuf.NullValue = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "NULL_VALUE")] = 0;
        return values;
      })();

      protobuf.ListValue = (function () {
        /**
         * Properties of a ListValue.
         * @memberof google.protobuf
         * @interface IListValue
         * @property {Array.<google.protobuf.IValue>|null} [values] ListValue values
         */

        /**
         * Constructs a new ListValue.
         * @memberof google.protobuf
         * @classdesc Represents a ListValue.
         * @implements IListValue
         * @constructor
         * @param {google.protobuf.IListValue=} [properties] Properties to set
         */
        function ListValue(properties) {
          this.values = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListValue values.
         * @member {Array.<google.protobuf.IValue>} values
         * @memberof google.protobuf.ListValue
         * @instance
         */
        ListValue.prototype.values = $util.emptyArray;

        /**
         * Creates a new ListValue instance using the specified properties.
         * @function create
         * @memberof google.protobuf.ListValue
         * @static
         * @param {google.protobuf.IListValue=} [properties] Properties to set
         * @returns {google.protobuf.ListValue} ListValue instance
         */
        ListValue.create = function create(properties) {
          return new ListValue(properties);
        };

        /**
         * Encodes the specified ListValue message. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.ListValue
         * @static
         * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListValue.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.values != null && message.values.length)
            for (var i = 0; i < message.values.length; ++i)
              $root.google.protobuf.Value.encode(
                message.values[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a ListValue message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.ListValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.ListValue} ListValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListValue.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.ListValue();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.values && message.values.length))
                  message.values = [];
                message.values.push(
                  $root.google.protobuf.Value.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ListValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.ListValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.ListValue} ListValue
         */
        ListValue.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.ListValue) return object;
          var message = new $root.google.protobuf.ListValue();
          if (object.values) {
            if (!Array.isArray(object.values))
              throw TypeError(
                ".google.protobuf.ListValue.values: array expected"
              );
            message.values = [];
            for (var i = 0; i < object.values.length; ++i) {
              if (typeof object.values[i] !== "object")
                throw TypeError(
                  ".google.protobuf.ListValue.values: object expected"
                );
              message.values[i] = $root.google.protobuf.Value.fromObject(
                object.values[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a ListValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.ListValue
         * @static
         * @param {google.protobuf.ListValue} message ListValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListValue.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.values = [];
          if (message.values && message.values.length) {
            object.values = [];
            for (var j = 0; j < message.values.length; ++j)
              object.values[j] = $root.google.protobuf.Value.toObject(
                message.values[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this ListValue to JSON.
         * @function toJSON
         * @memberof google.protobuf.ListValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListValue.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ListValue;
      })();

      protobuf.FieldMask = (function () {
        /**
         * Properties of a FieldMask.
         * @memberof google.protobuf
         * @interface IFieldMask
         * @property {Array.<string>|null} [paths] FieldMask paths
         */

        /**
         * Constructs a new FieldMask.
         * @memberof google.protobuf
         * @classdesc Represents a FieldMask.
         * @implements IFieldMask
         * @constructor
         * @param {google.protobuf.IFieldMask=} [properties] Properties to set
         */
        function FieldMask(properties) {
          this.paths = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * FieldMask paths.
         * @member {Array.<string>} paths
         * @memberof google.protobuf.FieldMask
         * @instance
         */
        FieldMask.prototype.paths = $util.emptyArray;

        /**
         * Creates a new FieldMask instance using the specified properties.
         * @function create
         * @memberof google.protobuf.FieldMask
         * @static
         * @param {google.protobuf.IFieldMask=} [properties] Properties to set
         * @returns {google.protobuf.FieldMask} FieldMask instance
         */
        FieldMask.create = function create(properties) {
          return new FieldMask(properties);
        };

        /**
         * Encodes the specified FieldMask message. Does not implicitly {@link google.protobuf.FieldMask.verify|verify} messages.
         * @function encode
         * @memberof google.protobuf.FieldMask
         * @static
         * @param {google.protobuf.IFieldMask} message FieldMask message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FieldMask.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.paths != null && message.paths.length)
            for (var i = 0; i < message.paths.length; ++i)
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.paths[i]);
          return writer;
        };

        /**
         * Decodes a FieldMask message from the specified reader or buffer.
         * @function decode
         * @memberof google.protobuf.FieldMask
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.protobuf.FieldMask} FieldMask
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FieldMask.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.protobuf.FieldMask();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.paths && message.paths.length))
                  message.paths = [];
                message.paths.push(reader.string());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a FieldMask message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.protobuf.FieldMask
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.protobuf.FieldMask} FieldMask
         */
        FieldMask.fromObject = function fromObject(object) {
          if (object instanceof $root.google.protobuf.FieldMask) return object;
          var message = new $root.google.protobuf.FieldMask();
          if (object.paths) {
            if (!Array.isArray(object.paths))
              throw TypeError(
                ".google.protobuf.FieldMask.paths: array expected"
              );
            message.paths = [];
            for (var i = 0; i < object.paths.length; ++i)
              message.paths[i] = String(object.paths[i]);
          }
          return message;
        };

        /**
         * Creates a plain object from a FieldMask message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.protobuf.FieldMask
         * @static
         * @param {google.protobuf.FieldMask} message FieldMask
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FieldMask.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.paths = [];
          if (message.paths && message.paths.length) {
            object.paths = [];
            for (var j = 0; j < message.paths.length; ++j)
              object.paths[j] = message.paths[j];
          }
          return object;
        };

        /**
         * Converts this FieldMask to JSON.
         * @function toJSON
         * @memberof google.protobuf.FieldMask
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FieldMask.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FieldMask;
      })();

      return protobuf;
    })();

    google.api = (function () {
      /**
       * Namespace api.
       * @memberof google
       * @namespace
       */
      var api = {};

      api.Http = (function () {
        /**
         * Properties of a Http.
         * @memberof google.api
         * @interface IHttp
         * @property {Array.<google.api.IHttpRule>|null} [rules] Http rules
         * @property {boolean|null} [fullyDecodeReservedExpansion] Http fullyDecodeReservedExpansion
         */

        /**
         * Constructs a new Http.
         * @memberof google.api
         * @classdesc Represents a Http.
         * @implements IHttp
         * @constructor
         * @param {google.api.IHttp=} [properties] Properties to set
         */
        function Http(properties) {
          this.rules = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Http rules.
         * @member {Array.<google.api.IHttpRule>} rules
         * @memberof google.api.Http
         * @instance
         */
        Http.prototype.rules = $util.emptyArray;

        /**
         * Http fullyDecodeReservedExpansion.
         * @member {boolean} fullyDecodeReservedExpansion
         * @memberof google.api.Http
         * @instance
         */
        Http.prototype.fullyDecodeReservedExpansion = false;

        /**
         * Creates a new Http instance using the specified properties.
         * @function create
         * @memberof google.api.Http
         * @static
         * @param {google.api.IHttp=} [properties] Properties to set
         * @returns {google.api.Http} Http instance
         */
        Http.create = function create(properties) {
          return new Http(properties);
        };

        /**
         * Encodes the specified Http message. Does not implicitly {@link google.api.Http.verify|verify} messages.
         * @function encode
         * @memberof google.api.Http
         * @static
         * @param {google.api.IHttp} message Http message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Http.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.rules != null && message.rules.length)
            for (var i = 0; i < message.rules.length; ++i)
              $root.google.api.HttpRule.encode(
                message.rules[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          if (
            message.fullyDecodeReservedExpansion != null &&
            Object.hasOwnProperty.call(message, "fullyDecodeReservedExpansion")
          )
            writer
              .uint32(/* id 2, wireType 0 =*/ 16)
              .bool(message.fullyDecodeReservedExpansion);
          return writer;
        };

        /**
         * Decodes a Http message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.Http
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.Http} Http
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Http.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.Http();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.rules && message.rules.length))
                  message.rules = [];
                message.rules.push(
                  $root.google.api.HttpRule.decode(reader, reader.uint32())
                );
                break;
              case 2:
                message.fullyDecodeReservedExpansion = reader.bool();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Http message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.Http
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.Http} Http
         */
        Http.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.Http) return object;
          var message = new $root.google.api.Http();
          if (object.rules) {
            if (!Array.isArray(object.rules))
              throw TypeError(".google.api.Http.rules: array expected");
            message.rules = [];
            for (var i = 0; i < object.rules.length; ++i) {
              if (typeof object.rules[i] !== "object")
                throw TypeError(".google.api.Http.rules: object expected");
              message.rules[i] = $root.google.api.HttpRule.fromObject(
                object.rules[i]
              );
            }
          }
          if (object.fullyDecodeReservedExpansion != null)
            message.fullyDecodeReservedExpansion = Boolean(
              object.fullyDecodeReservedExpansion
            );
          return message;
        };

        /**
         * Creates a plain object from a Http message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.Http
         * @static
         * @param {google.api.Http} message Http
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Http.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.rules = [];
          if (options.defaults) object.fullyDecodeReservedExpansion = false;
          if (message.rules && message.rules.length) {
            object.rules = [];
            for (var j = 0; j < message.rules.length; ++j)
              object.rules[j] = $root.google.api.HttpRule.toObject(
                message.rules[j],
                options
              );
          }
          if (
            message.fullyDecodeReservedExpansion != null &&
            message.hasOwnProperty("fullyDecodeReservedExpansion")
          )
            object.fullyDecodeReservedExpansion =
              message.fullyDecodeReservedExpansion;
          return object;
        };

        /**
         * Converts this Http to JSON.
         * @function toJSON
         * @memberof google.api.Http
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Http.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Http;
      })();

      api.HttpRule = (function () {
        /**
         * Properties of a HttpRule.
         * @memberof google.api
         * @interface IHttpRule
         * @property {string|null} [selector] HttpRule selector
         * @property {string|null} [get] HttpRule get
         * @property {string|null} [put] HttpRule put
         * @property {string|null} [post] HttpRule post
         * @property {string|null} ["delete"] HttpRule delete
         * @property {string|null} [patch] HttpRule patch
         * @property {google.api.ICustomHttpPattern|null} [custom] HttpRule custom
         * @property {string|null} [body] HttpRule body
         * @property {string|null} [responseBody] HttpRule responseBody
         * @property {Array.<google.api.IHttpRule>|null} [additionalBindings] HttpRule additionalBindings
         */

        /**
         * Constructs a new HttpRule.
         * @memberof google.api
         * @classdesc Represents a HttpRule.
         * @implements IHttpRule
         * @constructor
         * @param {google.api.IHttpRule=} [properties] Properties to set
         */
        function HttpRule(properties) {
          this.additionalBindings = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * HttpRule selector.
         * @member {string} selector
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.selector = "";

        /**
         * HttpRule get.
         * @member {string} get
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.get = "";

        /**
         * HttpRule put.
         * @member {string} put
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.put = "";

        /**
         * HttpRule post.
         * @member {string} post
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.post = "";

        /**
         * HttpRule delete.
         * @member {string} delete
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype["delete"] = "";

        /**
         * HttpRule patch.
         * @member {string} patch
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.patch = "";

        /**
         * HttpRule custom.
         * @member {google.api.ICustomHttpPattern|null|undefined} custom
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.custom = null;

        /**
         * HttpRule body.
         * @member {string} body
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.body = "";

        /**
         * HttpRule responseBody.
         * @member {string} responseBody
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.responseBody = "";

        /**
         * HttpRule additionalBindings.
         * @member {Array.<google.api.IHttpRule>} additionalBindings
         * @memberof google.api.HttpRule
         * @instance
         */
        HttpRule.prototype.additionalBindings = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * HttpRule pattern.
         * @member {"get"|"put"|"post"|"delete"|"patch"|"custom"|undefined} pattern
         * @memberof google.api.HttpRule
         * @instance
         */
        Object.defineProperty(HttpRule.prototype, "pattern", {
          get: $util.oneOfGetter(
            ($oneOfFields = ["get", "put", "post", "delete", "patch", "custom"])
          ),
          set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new HttpRule instance using the specified properties.
         * @function create
         * @memberof google.api.HttpRule
         * @static
         * @param {google.api.IHttpRule=} [properties] Properties to set
         * @returns {google.api.HttpRule} HttpRule instance
         */
        HttpRule.create = function create(properties) {
          return new HttpRule(properties);
        };

        /**
         * Encodes the specified HttpRule message. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
         * @function encode
         * @memberof google.api.HttpRule
         * @static
         * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HttpRule.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.selector != null &&
            Object.hasOwnProperty.call(message, "selector")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.selector);
          if (message.get != null && Object.hasOwnProperty.call(message, "get"))
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.get);
          if (message.put != null && Object.hasOwnProperty.call(message, "put"))
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.put);
          if (
            message.post != null &&
            Object.hasOwnProperty.call(message, "post")
          )
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.post);
          if (
            message["delete"] != null &&
            Object.hasOwnProperty.call(message, "delete")
          )
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message["delete"]);
          if (
            message.patch != null &&
            Object.hasOwnProperty.call(message, "patch")
          )
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.patch);
          if (
            message.body != null &&
            Object.hasOwnProperty.call(message, "body")
          )
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.body);
          if (
            message.custom != null &&
            Object.hasOwnProperty.call(message, "custom")
          )
            $root.google.api.CustomHttpPattern.encode(
              message.custom,
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
          if (
            message.additionalBindings != null &&
            message.additionalBindings.length
          )
            for (var i = 0; i < message.additionalBindings.length; ++i)
              $root.google.api.HttpRule.encode(
                message.additionalBindings[i],
                writer.uint32(/* id 11, wireType 2 =*/ 90).fork()
              ).ldelim();
          if (
            message.responseBody != null &&
            Object.hasOwnProperty.call(message, "responseBody")
          )
            writer
              .uint32(/* id 12, wireType 2 =*/ 98)
              .string(message.responseBody);
          return writer;
        };

        /**
         * Decodes a HttpRule message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.HttpRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.HttpRule} HttpRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HttpRule.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.HttpRule();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.selector = reader.string();
                break;
              case 2:
                message.get = reader.string();
                break;
              case 3:
                message.put = reader.string();
                break;
              case 4:
                message.post = reader.string();
                break;
              case 5:
                message["delete"] = reader.string();
                break;
              case 6:
                message.patch = reader.string();
                break;
              case 8:
                message.custom = $root.google.api.CustomHttpPattern.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 7:
                message.body = reader.string();
                break;
              case 12:
                message.responseBody = reader.string();
                break;
              case 11:
                if (
                  !(
                    message.additionalBindings &&
                    message.additionalBindings.length
                  )
                )
                  message.additionalBindings = [];
                message.additionalBindings.push(
                  $root.google.api.HttpRule.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a HttpRule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.HttpRule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.HttpRule} HttpRule
         */
        HttpRule.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.HttpRule) return object;
          var message = new $root.google.api.HttpRule();
          if (object.selector != null)
            message.selector = String(object.selector);
          if (object.get != null) message.get = String(object.get);
          if (object.put != null) message.put = String(object.put);
          if (object.post != null) message.post = String(object.post);
          if (object["delete"] != null)
            message["delete"] = String(object["delete"]);
          if (object.patch != null) message.patch = String(object.patch);
          if (object.custom != null) {
            if (typeof object.custom !== "object")
              throw TypeError(".google.api.HttpRule.custom: object expected");
            message.custom = $root.google.api.CustomHttpPattern.fromObject(
              object.custom
            );
          }
          if (object.body != null) message.body = String(object.body);
          if (object.responseBody != null)
            message.responseBody = String(object.responseBody);
          if (object.additionalBindings) {
            if (!Array.isArray(object.additionalBindings))
              throw TypeError(
                ".google.api.HttpRule.additionalBindings: array expected"
              );
            message.additionalBindings = [];
            for (var i = 0; i < object.additionalBindings.length; ++i) {
              if (typeof object.additionalBindings[i] !== "object")
                throw TypeError(
                  ".google.api.HttpRule.additionalBindings: object expected"
                );
              message.additionalBindings[i] =
                $root.google.api.HttpRule.fromObject(
                  object.additionalBindings[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a HttpRule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.HttpRule
         * @static
         * @param {google.api.HttpRule} message HttpRule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HttpRule.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults)
            object.additionalBindings = [];
          if (options.defaults) {
            object.selector = "";
            object.body = "";
            object.responseBody = "";
          }
          if (message.selector != null && message.hasOwnProperty("selector"))
            object.selector = message.selector;
          if (message.get != null && message.hasOwnProperty("get")) {
            object.get = message.get;
            if (options.oneofs) object.pattern = "get";
          }
          if (message.put != null && message.hasOwnProperty("put")) {
            object.put = message.put;
            if (options.oneofs) object.pattern = "put";
          }
          if (message.post != null && message.hasOwnProperty("post")) {
            object.post = message.post;
            if (options.oneofs) object.pattern = "post";
          }
          if (message["delete"] != null && message.hasOwnProperty("delete")) {
            object["delete"] = message["delete"];
            if (options.oneofs) object.pattern = "delete";
          }
          if (message.patch != null && message.hasOwnProperty("patch")) {
            object.patch = message.patch;
            if (options.oneofs) object.pattern = "patch";
          }
          if (message.body != null && message.hasOwnProperty("body"))
            object.body = message.body;
          if (message.custom != null && message.hasOwnProperty("custom")) {
            object.custom = $root.google.api.CustomHttpPattern.toObject(
              message.custom,
              options
            );
            if (options.oneofs) object.pattern = "custom";
          }
          if (message.additionalBindings && message.additionalBindings.length) {
            object.additionalBindings = [];
            for (var j = 0; j < message.additionalBindings.length; ++j)
              object.additionalBindings[j] = $root.google.api.HttpRule.toObject(
                message.additionalBindings[j],
                options
              );
          }
          if (
            message.responseBody != null &&
            message.hasOwnProperty("responseBody")
          )
            object.responseBody = message.responseBody;
          return object;
        };

        /**
         * Converts this HttpRule to JSON.
         * @function toJSON
         * @memberof google.api.HttpRule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HttpRule.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HttpRule;
      })();

      api.CustomHttpPattern = (function () {
        /**
         * Properties of a CustomHttpPattern.
         * @memberof google.api
         * @interface ICustomHttpPattern
         * @property {string|null} [kind] CustomHttpPattern kind
         * @property {string|null} [path] CustomHttpPattern path
         */

        /**
         * Constructs a new CustomHttpPattern.
         * @memberof google.api
         * @classdesc Represents a CustomHttpPattern.
         * @implements ICustomHttpPattern
         * @constructor
         * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
         */
        function CustomHttpPattern(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomHttpPattern kind.
         * @member {string} kind
         * @memberof google.api.CustomHttpPattern
         * @instance
         */
        CustomHttpPattern.prototype.kind = "";

        /**
         * CustomHttpPattern path.
         * @member {string} path
         * @memberof google.api.CustomHttpPattern
         * @instance
         */
        CustomHttpPattern.prototype.path = "";

        /**
         * Creates a new CustomHttpPattern instance using the specified properties.
         * @function create
         * @memberof google.api.CustomHttpPattern
         * @static
         * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
         * @returns {google.api.CustomHttpPattern} CustomHttpPattern instance
         */
        CustomHttpPattern.create = function create(properties) {
          return new CustomHttpPattern(properties);
        };

        /**
         * Encodes the specified CustomHttpPattern message. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
         * @function encode
         * @memberof google.api.CustomHttpPattern
         * @static
         * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomHttpPattern.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.kind != null &&
            Object.hasOwnProperty.call(message, "kind")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.kind);
          if (
            message.path != null &&
            Object.hasOwnProperty.call(message, "path")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.path);
          return writer;
        };

        /**
         * Decodes a CustomHttpPattern message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.CustomHttpPattern
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.CustomHttpPattern} CustomHttpPattern
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomHttpPattern.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.CustomHttpPattern();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.kind = reader.string();
                break;
              case 2:
                message.path = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a CustomHttpPattern message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.CustomHttpPattern
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.CustomHttpPattern} CustomHttpPattern
         */
        CustomHttpPattern.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.CustomHttpPattern)
            return object;
          var message = new $root.google.api.CustomHttpPattern();
          if (object.kind != null) message.kind = String(object.kind);
          if (object.path != null) message.path = String(object.path);
          return message;
        };

        /**
         * Creates a plain object from a CustomHttpPattern message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.CustomHttpPattern
         * @static
         * @param {google.api.CustomHttpPattern} message CustomHttpPattern
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomHttpPattern.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.kind = "";
            object.path = "";
          }
          if (message.kind != null && message.hasOwnProperty("kind"))
            object.kind = message.kind;
          if (message.path != null && message.hasOwnProperty("path"))
            object.path = message.path;
          return object;
        };

        /**
         * Converts this CustomHttpPattern to JSON.
         * @function toJSON
         * @memberof google.api.CustomHttpPattern
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomHttpPattern.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomHttpPattern;
      })();

      /**
       * FieldBehavior enum.
       * @name google.api.FieldBehavior
       * @enum {string}
       * @property {number} FIELD_BEHAVIOR_UNSPECIFIED=0 FIELD_BEHAVIOR_UNSPECIFIED value
       * @property {number} OPTIONAL=1 OPTIONAL value
       * @property {number} REQUIRED=2 REQUIRED value
       * @property {number} OUTPUT_ONLY=3 OUTPUT_ONLY value
       * @property {number} INPUT_ONLY=4 INPUT_ONLY value
       * @property {number} IMMUTABLE=5 IMMUTABLE value
       */
      api.FieldBehavior = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "FIELD_BEHAVIOR_UNSPECIFIED")] = 0;
        values[(valuesById[1] = "OPTIONAL")] = 1;
        values[(valuesById[2] = "REQUIRED")] = 2;
        values[(valuesById[3] = "OUTPUT_ONLY")] = 3;
        values[(valuesById[4] = "INPUT_ONLY")] = 4;
        values[(valuesById[5] = "IMMUTABLE")] = 5;
        return values;
      })();

      api.HttpBody = (function () {
        /**
         * Properties of a HttpBody.
         * @memberof google.api
         * @interface IHttpBody
         * @property {string|null} [contentType] HttpBody contentType
         * @property {Uint8Array|null} [data] HttpBody data
         * @property {Array.<google.protobuf.IAny>|null} [extensions] HttpBody extensions
         */

        /**
         * Constructs a new HttpBody.
         * @memberof google.api
         * @classdesc Represents a HttpBody.
         * @implements IHttpBody
         * @constructor
         * @param {google.api.IHttpBody=} [properties] Properties to set
         */
        function HttpBody(properties) {
          this.extensions = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * HttpBody contentType.
         * @member {string} contentType
         * @memberof google.api.HttpBody
         * @instance
         */
        HttpBody.prototype.contentType = "";

        /**
         * HttpBody data.
         * @member {Uint8Array} data
         * @memberof google.api.HttpBody
         * @instance
         */
        HttpBody.prototype.data = $util.newBuffer([]);

        /**
         * HttpBody extensions.
         * @member {Array.<google.protobuf.IAny>} extensions
         * @memberof google.api.HttpBody
         * @instance
         */
        HttpBody.prototype.extensions = $util.emptyArray;

        /**
         * Creates a new HttpBody instance using the specified properties.
         * @function create
         * @memberof google.api.HttpBody
         * @static
         * @param {google.api.IHttpBody=} [properties] Properties to set
         * @returns {google.api.HttpBody} HttpBody instance
         */
        HttpBody.create = function create(properties) {
          return new HttpBody(properties);
        };

        /**
         * Encodes the specified HttpBody message. Does not implicitly {@link google.api.HttpBody.verify|verify} messages.
         * @function encode
         * @memberof google.api.HttpBody
         * @static
         * @param {google.api.IHttpBody} message HttpBody message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HttpBody.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.contentType != null &&
            Object.hasOwnProperty.call(message, "contentType")
          )
            writer
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(message.contentType);
          if (
            message.data != null &&
            Object.hasOwnProperty.call(message, "data")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.data);
          if (message.extensions != null && message.extensions.length)
            for (var i = 0; i < message.extensions.length; ++i)
              $root.google.protobuf.Any.encode(
                message.extensions[i],
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a HttpBody message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.HttpBody
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.HttpBody} HttpBody
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HttpBody.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.HttpBody();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.contentType = reader.string();
                break;
              case 2:
                message.data = reader.bytes();
                break;
              case 3:
                if (!(message.extensions && message.extensions.length))
                  message.extensions = [];
                message.extensions.push(
                  $root.google.protobuf.Any.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a HttpBody message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.HttpBody
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.HttpBody} HttpBody
         */
        HttpBody.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.HttpBody) return object;
          var message = new $root.google.api.HttpBody();
          if (object.contentType != null)
            message.contentType = String(object.contentType);
          if (object.data != null)
            if (typeof object.data === "string")
              $util.base64.decode(
                object.data,
                (message.data = $util.newBuffer(
                  $util.base64.length(object.data)
                )),
                0
              );
            else if (object.data.length) message.data = object.data;
          if (object.extensions) {
            if (!Array.isArray(object.extensions))
              throw TypeError(
                ".google.api.HttpBody.extensions: array expected"
              );
            message.extensions = [];
            for (var i = 0; i < object.extensions.length; ++i) {
              if (typeof object.extensions[i] !== "object")
                throw TypeError(
                  ".google.api.HttpBody.extensions: object expected"
                );
              message.extensions[i] = $root.google.protobuf.Any.fromObject(
                object.extensions[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a HttpBody message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.HttpBody
         * @static
         * @param {google.api.HttpBody} message HttpBody
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HttpBody.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.extensions = [];
          if (options.defaults) {
            object.contentType = "";
            if (options.bytes === String) object.data = "";
            else {
              object.data = [];
              if (options.bytes !== Array)
                object.data = $util.newBuffer(object.data);
            }
          }
          if (
            message.contentType != null &&
            message.hasOwnProperty("contentType")
          )
            object.contentType = message.contentType;
          if (message.data != null && message.hasOwnProperty("data"))
            object.data =
              options.bytes === String
                ? $util.base64.encode(message.data, 0, message.data.length)
                : options.bytes === Array
                ? Array.prototype.slice.call(message.data)
                : message.data;
          if (message.extensions && message.extensions.length) {
            object.extensions = [];
            for (var j = 0; j < message.extensions.length; ++j)
              object.extensions[j] = $root.google.protobuf.Any.toObject(
                message.extensions[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this HttpBody to JSON.
         * @function toJSON
         * @memberof google.api.HttpBody
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HttpBody.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HttpBody;
      })();

      api.ResourceDescriptor = (function () {
        /**
         * Properties of a ResourceDescriptor.
         * @memberof google.api
         * @interface IResourceDescriptor
         * @property {string|null} [type] ResourceDescriptor type
         * @property {Array.<string>|null} [pattern] ResourceDescriptor pattern
         * @property {string|null} [nameField] ResourceDescriptor nameField
         * @property {google.api.ResourceDescriptor.History|null} [history] ResourceDescriptor history
         * @property {string|null} [plural] ResourceDescriptor plural
         * @property {string|null} [singular] ResourceDescriptor singular
         * @property {Array.<google.api.ResourceDescriptor.Style>|null} [style] ResourceDescriptor style
         */

        /**
         * Constructs a new ResourceDescriptor.
         * @memberof google.api
         * @classdesc Represents a ResourceDescriptor.
         * @implements IResourceDescriptor
         * @constructor
         * @param {google.api.IResourceDescriptor=} [properties] Properties to set
         */
        function ResourceDescriptor(properties) {
          this.pattern = [];
          this.style = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResourceDescriptor type.
         * @member {string} type
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.type = "";

        /**
         * ResourceDescriptor pattern.
         * @member {Array.<string>} pattern
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.pattern = $util.emptyArray;

        /**
         * ResourceDescriptor nameField.
         * @member {string} nameField
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.nameField = "";

        /**
         * ResourceDescriptor history.
         * @member {google.api.ResourceDescriptor.History} history
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.history = 0;

        /**
         * ResourceDescriptor plural.
         * @member {string} plural
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.plural = "";

        /**
         * ResourceDescriptor singular.
         * @member {string} singular
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.singular = "";

        /**
         * ResourceDescriptor style.
         * @member {Array.<google.api.ResourceDescriptor.Style>} style
         * @memberof google.api.ResourceDescriptor
         * @instance
         */
        ResourceDescriptor.prototype.style = $util.emptyArray;

        /**
         * Creates a new ResourceDescriptor instance using the specified properties.
         * @function create
         * @memberof google.api.ResourceDescriptor
         * @static
         * @param {google.api.IResourceDescriptor=} [properties] Properties to set
         * @returns {google.api.ResourceDescriptor} ResourceDescriptor instance
         */
        ResourceDescriptor.create = function create(properties) {
          return new ResourceDescriptor(properties);
        };

        /**
         * Encodes the specified ResourceDescriptor message. Does not implicitly {@link google.api.ResourceDescriptor.verify|verify} messages.
         * @function encode
         * @memberof google.api.ResourceDescriptor
         * @static
         * @param {google.api.IResourceDescriptor} message ResourceDescriptor message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResourceDescriptor.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
          if (message.pattern != null && message.pattern.length)
            for (var i = 0; i < message.pattern.length; ++i)
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.pattern[i]);
          if (
            message.nameField != null &&
            Object.hasOwnProperty.call(message, "nameField")
          )
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.nameField);
          if (
            message.history != null &&
            Object.hasOwnProperty.call(message, "history")
          )
            writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.history);
          if (
            message.plural != null &&
            Object.hasOwnProperty.call(message, "plural")
          )
            writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.plural);
          if (
            message.singular != null &&
            Object.hasOwnProperty.call(message, "singular")
          )
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.singular);
          if (message.style != null && message.style.length) {
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork();
            for (var i = 0; i < message.style.length; ++i)
              writer.int32(message.style[i]);
            writer.ldelim();
          }
          return writer;
        };

        /**
         * Decodes a ResourceDescriptor message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.ResourceDescriptor
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.ResourceDescriptor} ResourceDescriptor
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResourceDescriptor.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.ResourceDescriptor();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.type = reader.string();
                break;
              case 2:
                if (!(message.pattern && message.pattern.length))
                  message.pattern = [];
                message.pattern.push(reader.string());
                break;
              case 3:
                message.nameField = reader.string();
                break;
              case 4:
                message.history = reader.int32();
                break;
              case 5:
                message.plural = reader.string();
                break;
              case 6:
                message.singular = reader.string();
                break;
              case 10:
                if (!(message.style && message.style.length))
                  message.style = [];
                if ((tag & 7) === 2) {
                  var end2 = reader.uint32() + reader.pos;
                  while (reader.pos < end2) message.style.push(reader.int32());
                } else message.style.push(reader.int32());
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ResourceDescriptor message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.ResourceDescriptor
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.ResourceDescriptor} ResourceDescriptor
         */
        ResourceDescriptor.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.ResourceDescriptor)
            return object;
          var message = new $root.google.api.ResourceDescriptor();
          if (object.type != null) message.type = String(object.type);
          if (object.pattern) {
            if (!Array.isArray(object.pattern))
              throw TypeError(
                ".google.api.ResourceDescriptor.pattern: array expected"
              );
            message.pattern = [];
            for (var i = 0; i < object.pattern.length; ++i)
              message.pattern[i] = String(object.pattern[i]);
          }
          if (object.nameField != null)
            message.nameField = String(object.nameField);
          switch (object.history) {
            case "HISTORY_UNSPECIFIED":
            case 0:
              message.history = 0;
              break;
            case "ORIGINALLY_SINGLE_PATTERN":
            case 1:
              message.history = 1;
              break;
            case "FUTURE_MULTI_PATTERN":
            case 2:
              message.history = 2;
              break;
          }
          if (object.plural != null) message.plural = String(object.plural);
          if (object.singular != null)
            message.singular = String(object.singular);
          if (object.style) {
            if (!Array.isArray(object.style))
              throw TypeError(
                ".google.api.ResourceDescriptor.style: array expected"
              );
            message.style = [];
            for (var i = 0; i < object.style.length; ++i)
              switch (object.style[i]) {
                default:
                case "STYLE_UNSPECIFIED":
                case 0:
                  message.style[i] = 0;
                  break;
                case "DECLARATIVE_FRIENDLY":
                case 1:
                  message.style[i] = 1;
                  break;
              }
          }
          return message;
        };

        /**
         * Creates a plain object from a ResourceDescriptor message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.ResourceDescriptor
         * @static
         * @param {google.api.ResourceDescriptor} message ResourceDescriptor
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResourceDescriptor.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.pattern = [];
            object.style = [];
          }
          if (options.defaults) {
            object.type = "";
            object.nameField = "";
            object.history =
              options.enums === String ? "HISTORY_UNSPECIFIED" : 0;
            object.plural = "";
            object.singular = "";
          }
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          if (message.pattern && message.pattern.length) {
            object.pattern = [];
            for (var j = 0; j < message.pattern.length; ++j)
              object.pattern[j] = message.pattern[j];
          }
          if (message.nameField != null && message.hasOwnProperty("nameField"))
            object.nameField = message.nameField;
          if (message.history != null && message.hasOwnProperty("history"))
            object.history =
              options.enums === String
                ? $root.google.api.ResourceDescriptor.History[message.history]
                : message.history;
          if (message.plural != null && message.hasOwnProperty("plural"))
            object.plural = message.plural;
          if (message.singular != null && message.hasOwnProperty("singular"))
            object.singular = message.singular;
          if (message.style && message.style.length) {
            object.style = [];
            for (var j = 0; j < message.style.length; ++j)
              object.style[j] =
                options.enums === String
                  ? $root.google.api.ResourceDescriptor.Style[message.style[j]]
                  : message.style[j];
          }
          return object;
        };

        /**
         * Converts this ResourceDescriptor to JSON.
         * @function toJSON
         * @memberof google.api.ResourceDescriptor
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResourceDescriptor.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * History enum.
         * @name google.api.ResourceDescriptor.History
         * @enum {string}
         * @property {number} HISTORY_UNSPECIFIED=0 HISTORY_UNSPECIFIED value
         * @property {number} ORIGINALLY_SINGLE_PATTERN=1 ORIGINALLY_SINGLE_PATTERN value
         * @property {number} FUTURE_MULTI_PATTERN=2 FUTURE_MULTI_PATTERN value
         */
        ResourceDescriptor.History = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "HISTORY_UNSPECIFIED")] = 0;
          values[(valuesById[1] = "ORIGINALLY_SINGLE_PATTERN")] = 1;
          values[(valuesById[2] = "FUTURE_MULTI_PATTERN")] = 2;
          return values;
        })();

        /**
         * Style enum.
         * @name google.api.ResourceDescriptor.Style
         * @enum {string}
         * @property {number} STYLE_UNSPECIFIED=0 STYLE_UNSPECIFIED value
         * @property {number} DECLARATIVE_FRIENDLY=1 DECLARATIVE_FRIENDLY value
         */
        ResourceDescriptor.Style = (function () {
          var valuesById = {},
            values = Object.create(valuesById);
          values[(valuesById[0] = "STYLE_UNSPECIFIED")] = 0;
          values[(valuesById[1] = "DECLARATIVE_FRIENDLY")] = 1;
          return values;
        })();

        return ResourceDescriptor;
      })();

      api.ResourceReference = (function () {
        /**
         * Properties of a ResourceReference.
         * @memberof google.api
         * @interface IResourceReference
         * @property {string|null} [type] ResourceReference type
         * @property {string|null} [childType] ResourceReference childType
         */

        /**
         * Constructs a new ResourceReference.
         * @memberof google.api
         * @classdesc Represents a ResourceReference.
         * @implements IResourceReference
         * @constructor
         * @param {google.api.IResourceReference=} [properties] Properties to set
         */
        function ResourceReference(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResourceReference type.
         * @member {string} type
         * @memberof google.api.ResourceReference
         * @instance
         */
        ResourceReference.prototype.type = "";

        /**
         * ResourceReference childType.
         * @member {string} childType
         * @memberof google.api.ResourceReference
         * @instance
         */
        ResourceReference.prototype.childType = "";

        /**
         * Creates a new ResourceReference instance using the specified properties.
         * @function create
         * @memberof google.api.ResourceReference
         * @static
         * @param {google.api.IResourceReference=} [properties] Properties to set
         * @returns {google.api.ResourceReference} ResourceReference instance
         */
        ResourceReference.create = function create(properties) {
          return new ResourceReference(properties);
        };

        /**
         * Encodes the specified ResourceReference message. Does not implicitly {@link google.api.ResourceReference.verify|verify} messages.
         * @function encode
         * @memberof google.api.ResourceReference
         * @static
         * @param {google.api.IResourceReference} message ResourceReference message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResourceReference.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
          if (
            message.childType != null &&
            Object.hasOwnProperty.call(message, "childType")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.childType);
          return writer;
        };

        /**
         * Decodes a ResourceReference message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.ResourceReference
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.ResourceReference} ResourceReference
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResourceReference.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.ResourceReference();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.type = reader.string();
                break;
              case 2:
                message.childType = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ResourceReference message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.ResourceReference
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.ResourceReference} ResourceReference
         */
        ResourceReference.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.ResourceReference)
            return object;
          var message = new $root.google.api.ResourceReference();
          if (object.type != null) message.type = String(object.type);
          if (object.childType != null)
            message.childType = String(object.childType);
          return message;
        };

        /**
         * Creates a plain object from a ResourceReference message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.ResourceReference
         * @static
         * @param {google.api.ResourceReference} message ResourceReference
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResourceReference.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.type = "";
            object.childType = "";
          }
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          if (message.childType != null && message.hasOwnProperty("childType"))
            object.childType = message.childType;
          return object;
        };

        /**
         * Converts this ResourceReference to JSON.
         * @function toJSON
         * @memberof google.api.ResourceReference
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResourceReference.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResourceReference;
      })();

      api.Visibility = (function () {
        /**
         * Properties of a Visibility.
         * @memberof google.api
         * @interface IVisibility
         * @property {Array.<google.api.IVisibilityRule>|null} [rules] Visibility rules
         */

        /**
         * Constructs a new Visibility.
         * @memberof google.api
         * @classdesc Represents a Visibility.
         * @implements IVisibility
         * @constructor
         * @param {google.api.IVisibility=} [properties] Properties to set
         */
        function Visibility(properties) {
          this.rules = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Visibility rules.
         * @member {Array.<google.api.IVisibilityRule>} rules
         * @memberof google.api.Visibility
         * @instance
         */
        Visibility.prototype.rules = $util.emptyArray;

        /**
         * Creates a new Visibility instance using the specified properties.
         * @function create
         * @memberof google.api.Visibility
         * @static
         * @param {google.api.IVisibility=} [properties] Properties to set
         * @returns {google.api.Visibility} Visibility instance
         */
        Visibility.create = function create(properties) {
          return new Visibility(properties);
        };

        /**
         * Encodes the specified Visibility message. Does not implicitly {@link google.api.Visibility.verify|verify} messages.
         * @function encode
         * @memberof google.api.Visibility
         * @static
         * @param {google.api.IVisibility} message Visibility message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Visibility.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.rules != null && message.rules.length)
            for (var i = 0; i < message.rules.length; ++i)
              $root.google.api.VisibilityRule.encode(
                message.rules[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a Visibility message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.Visibility
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.Visibility} Visibility
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Visibility.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.Visibility();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.rules && message.rules.length))
                  message.rules = [];
                message.rules.push(
                  $root.google.api.VisibilityRule.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Visibility message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.Visibility
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.Visibility} Visibility
         */
        Visibility.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.Visibility) return object;
          var message = new $root.google.api.Visibility();
          if (object.rules) {
            if (!Array.isArray(object.rules))
              throw TypeError(".google.api.Visibility.rules: array expected");
            message.rules = [];
            for (var i = 0; i < object.rules.length; ++i) {
              if (typeof object.rules[i] !== "object")
                throw TypeError(
                  ".google.api.Visibility.rules: object expected"
                );
              message.rules[i] = $root.google.api.VisibilityRule.fromObject(
                object.rules[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Visibility message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.Visibility
         * @static
         * @param {google.api.Visibility} message Visibility
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Visibility.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.rules = [];
          if (message.rules && message.rules.length) {
            object.rules = [];
            for (var j = 0; j < message.rules.length; ++j)
              object.rules[j] = $root.google.api.VisibilityRule.toObject(
                message.rules[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Visibility to JSON.
         * @function toJSON
         * @memberof google.api.Visibility
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Visibility.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Visibility;
      })();

      api.VisibilityRule = (function () {
        /**
         * Properties of a VisibilityRule.
         * @memberof google.api
         * @interface IVisibilityRule
         * @property {string|null} [selector] VisibilityRule selector
         * @property {string|null} [restriction] VisibilityRule restriction
         */

        /**
         * Constructs a new VisibilityRule.
         * @memberof google.api
         * @classdesc Represents a VisibilityRule.
         * @implements IVisibilityRule
         * @constructor
         * @param {google.api.IVisibilityRule=} [properties] Properties to set
         */
        function VisibilityRule(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * VisibilityRule selector.
         * @member {string} selector
         * @memberof google.api.VisibilityRule
         * @instance
         */
        VisibilityRule.prototype.selector = "";

        /**
         * VisibilityRule restriction.
         * @member {string} restriction
         * @memberof google.api.VisibilityRule
         * @instance
         */
        VisibilityRule.prototype.restriction = "";

        /**
         * Creates a new VisibilityRule instance using the specified properties.
         * @function create
         * @memberof google.api.VisibilityRule
         * @static
         * @param {google.api.IVisibilityRule=} [properties] Properties to set
         * @returns {google.api.VisibilityRule} VisibilityRule instance
         */
        VisibilityRule.create = function create(properties) {
          return new VisibilityRule(properties);
        };

        /**
         * Encodes the specified VisibilityRule message. Does not implicitly {@link google.api.VisibilityRule.verify|verify} messages.
         * @function encode
         * @memberof google.api.VisibilityRule
         * @static
         * @param {google.api.IVisibilityRule} message VisibilityRule message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VisibilityRule.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.selector != null &&
            Object.hasOwnProperty.call(message, "selector")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.selector);
          if (
            message.restriction != null &&
            Object.hasOwnProperty.call(message, "restriction")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.restriction);
          return writer;
        };

        /**
         * Decodes a VisibilityRule message from the specified reader or buffer.
         * @function decode
         * @memberof google.api.VisibilityRule
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.api.VisibilityRule} VisibilityRule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VisibilityRule.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.api.VisibilityRule();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.selector = reader.string();
                break;
              case 2:
                message.restriction = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a VisibilityRule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.api.VisibilityRule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.api.VisibilityRule} VisibilityRule
         */
        VisibilityRule.fromObject = function fromObject(object) {
          if (object instanceof $root.google.api.VisibilityRule) return object;
          var message = new $root.google.api.VisibilityRule();
          if (object.selector != null)
            message.selector = String(object.selector);
          if (object.restriction != null)
            message.restriction = String(object.restriction);
          return message;
        };

        /**
         * Creates a plain object from a VisibilityRule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.api.VisibilityRule
         * @static
         * @param {google.api.VisibilityRule} message VisibilityRule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VisibilityRule.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.selector = "";
            object.restriction = "";
          }
          if (message.selector != null && message.hasOwnProperty("selector"))
            object.selector = message.selector;
          if (
            message.restriction != null &&
            message.hasOwnProperty("restriction")
          )
            object.restriction = message.restriction;
          return object;
        };

        /**
         * Converts this VisibilityRule to JSON.
         * @function toJSON
         * @memberof google.api.VisibilityRule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VisibilityRule.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VisibilityRule;
      })();

      return api;
    })();

    google.rpc = (function () {
      /**
       * Namespace rpc.
       * @memberof google
       * @namespace
       */
      var rpc = {};

      /**
       * Code enum.
       * @name google.rpc.Code
       * @enum {string}
       * @property {number} OK=0 OK value
       * @property {number} CANCELLED=1 CANCELLED value
       * @property {number} UNKNOWN=2 UNKNOWN value
       * @property {number} INVALID_ARGUMENT=3 INVALID_ARGUMENT value
       * @property {number} DEADLINE_EXCEEDED=4 DEADLINE_EXCEEDED value
       * @property {number} NOT_FOUND=5 NOT_FOUND value
       * @property {number} ALREADY_EXISTS=6 ALREADY_EXISTS value
       * @property {number} PERMISSION_DENIED=7 PERMISSION_DENIED value
       * @property {number} UNAUTHENTICATED=16 UNAUTHENTICATED value
       * @property {number} RESOURCE_EXHAUSTED=8 RESOURCE_EXHAUSTED value
       * @property {number} FAILED_PRECONDITION=9 FAILED_PRECONDITION value
       * @property {number} ABORTED=10 ABORTED value
       * @property {number} OUT_OF_RANGE=11 OUT_OF_RANGE value
       * @property {number} UNIMPLEMENTED=12 UNIMPLEMENTED value
       * @property {number} INTERNAL=13 INTERNAL value
       * @property {number} UNAVAILABLE=14 UNAVAILABLE value
       * @property {number} DATA_LOSS=15 DATA_LOSS value
       */
      rpc.Code = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "OK")] = 0;
        values[(valuesById[1] = "CANCELLED")] = 1;
        values[(valuesById[2] = "UNKNOWN")] = 2;
        values[(valuesById[3] = "INVALID_ARGUMENT")] = 3;
        values[(valuesById[4] = "DEADLINE_EXCEEDED")] = 4;
        values[(valuesById[5] = "NOT_FOUND")] = 5;
        values[(valuesById[6] = "ALREADY_EXISTS")] = 6;
        values[(valuesById[7] = "PERMISSION_DENIED")] = 7;
        values[(valuesById[16] = "UNAUTHENTICATED")] = 16;
        values[(valuesById[8] = "RESOURCE_EXHAUSTED")] = 8;
        values[(valuesById[9] = "FAILED_PRECONDITION")] = 9;
        values[(valuesById[10] = "ABORTED")] = 10;
        values[(valuesById[11] = "OUT_OF_RANGE")] = 11;
        values[(valuesById[12] = "UNIMPLEMENTED")] = 12;
        values[(valuesById[13] = "INTERNAL")] = 13;
        values[(valuesById[14] = "UNAVAILABLE")] = 14;
        values[(valuesById[15] = "DATA_LOSS")] = 15;
        return values;
      })();

      rpc.ErrorInfo = (function () {
        /**
         * Properties of an ErrorInfo.
         * @memberof google.rpc
         * @interface IErrorInfo
         * @property {string|null} [reason] ErrorInfo reason
         * @property {string|null} [domain] ErrorInfo domain
         * @property {Object.<string,string>|null} [metadata] ErrorInfo metadata
         */

        /**
         * Constructs a new ErrorInfo.
         * @memberof google.rpc
         * @classdesc Represents an ErrorInfo.
         * @implements IErrorInfo
         * @constructor
         * @param {google.rpc.IErrorInfo=} [properties] Properties to set
         */
        function ErrorInfo(properties) {
          this.metadata = {};
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ErrorInfo reason.
         * @member {string} reason
         * @memberof google.rpc.ErrorInfo
         * @instance
         */
        ErrorInfo.prototype.reason = "";

        /**
         * ErrorInfo domain.
         * @member {string} domain
         * @memberof google.rpc.ErrorInfo
         * @instance
         */
        ErrorInfo.prototype.domain = "";

        /**
         * ErrorInfo metadata.
         * @member {Object.<string,string>} metadata
         * @memberof google.rpc.ErrorInfo
         * @instance
         */
        ErrorInfo.prototype.metadata = $util.emptyObject;

        /**
         * Creates a new ErrorInfo instance using the specified properties.
         * @function create
         * @memberof google.rpc.ErrorInfo
         * @static
         * @param {google.rpc.IErrorInfo=} [properties] Properties to set
         * @returns {google.rpc.ErrorInfo} ErrorInfo instance
         */
        ErrorInfo.create = function create(properties) {
          return new ErrorInfo(properties);
        };

        /**
         * Encodes the specified ErrorInfo message. Does not implicitly {@link google.rpc.ErrorInfo.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.ErrorInfo
         * @static
         * @param {google.rpc.IErrorInfo} message ErrorInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.reason != null &&
            Object.hasOwnProperty.call(message, "reason")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.reason);
          if (
            message.domain != null &&
            Object.hasOwnProperty.call(message, "domain")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.domain);
          if (
            message.metadata != null &&
            Object.hasOwnProperty.call(message, "metadata")
          )
            for (
              var keys = Object.keys(message.metadata), i = 0;
              i < keys.length;
              ++i
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i])
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.metadata[keys[i]])
                .ldelim();
          return writer;
        };

        /**
         * Decodes an ErrorInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.ErrorInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.ErrorInfo} ErrorInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.ErrorInfo(),
            key;
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.reason = reader.string();
                break;
              case 2:
                message.domain = reader.string();
                break;
              case 3:
                reader.skip().pos++;
                if (message.metadata === $util.emptyObject)
                  message.metadata = {};
                key = reader.string();
                reader.pos++;
                message.metadata[key] = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates an ErrorInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.ErrorInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.ErrorInfo} ErrorInfo
         */
        ErrorInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.ErrorInfo) return object;
          var message = new $root.google.rpc.ErrorInfo();
          if (object.reason != null) message.reason = String(object.reason);
          if (object.domain != null) message.domain = String(object.domain);
          if (object.metadata) {
            if (typeof object.metadata !== "object")
              throw TypeError(
                ".google.rpc.ErrorInfo.metadata: object expected"
              );
            message.metadata = {};
            for (
              var keys = Object.keys(object.metadata), i = 0;
              i < keys.length;
              ++i
            )
              message.metadata[keys[i]] = String(object.metadata[keys[i]]);
          }
          return message;
        };

        /**
         * Creates a plain object from an ErrorInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.ErrorInfo
         * @static
         * @param {google.rpc.ErrorInfo} message ErrorInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ErrorInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.objects || options.defaults) object.metadata = {};
          if (options.defaults) {
            object.reason = "";
            object.domain = "";
          }
          if (message.reason != null && message.hasOwnProperty("reason"))
            object.reason = message.reason;
          if (message.domain != null && message.hasOwnProperty("domain"))
            object.domain = message.domain;
          var keys2;
          if (
            message.metadata &&
            (keys2 = Object.keys(message.metadata)).length
          ) {
            object.metadata = {};
            for (var j = 0; j < keys2.length; ++j)
              object.metadata[keys2[j]] = message.metadata[keys2[j]];
          }
          return object;
        };

        /**
         * Converts this ErrorInfo to JSON.
         * @function toJSON
         * @memberof google.rpc.ErrorInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ErrorInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ErrorInfo;
      })();

      rpc.RetryInfo = (function () {
        /**
         * Properties of a RetryInfo.
         * @memberof google.rpc
         * @interface IRetryInfo
         * @property {google.protobuf.IDuration|null} [retryDelay] RetryInfo retryDelay
         */

        /**
         * Constructs a new RetryInfo.
         * @memberof google.rpc
         * @classdesc Represents a RetryInfo.
         * @implements IRetryInfo
         * @constructor
         * @param {google.rpc.IRetryInfo=} [properties] Properties to set
         */
        function RetryInfo(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * RetryInfo retryDelay.
         * @member {google.protobuf.IDuration|null|undefined} retryDelay
         * @memberof google.rpc.RetryInfo
         * @instance
         */
        RetryInfo.prototype.retryDelay = null;

        /**
         * Creates a new RetryInfo instance using the specified properties.
         * @function create
         * @memberof google.rpc.RetryInfo
         * @static
         * @param {google.rpc.IRetryInfo=} [properties] Properties to set
         * @returns {google.rpc.RetryInfo} RetryInfo instance
         */
        RetryInfo.create = function create(properties) {
          return new RetryInfo(properties);
        };

        /**
         * Encodes the specified RetryInfo message. Does not implicitly {@link google.rpc.RetryInfo.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.RetryInfo
         * @static
         * @param {google.rpc.IRetryInfo} message RetryInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RetryInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.retryDelay != null &&
            Object.hasOwnProperty.call(message, "retryDelay")
          )
            $root.google.protobuf.Duration.encode(
              message.retryDelay,
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a RetryInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.RetryInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.RetryInfo} RetryInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RetryInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.RetryInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.retryDelay = $root.google.protobuf.Duration.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a RetryInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.RetryInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.RetryInfo} RetryInfo
         */
        RetryInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.RetryInfo) return object;
          var message = new $root.google.rpc.RetryInfo();
          if (object.retryDelay != null) {
            if (typeof object.retryDelay !== "object")
              throw TypeError(
                ".google.rpc.RetryInfo.retryDelay: object expected"
              );
            message.retryDelay = $root.google.protobuf.Duration.fromObject(
              object.retryDelay
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a RetryInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.RetryInfo
         * @static
         * @param {google.rpc.RetryInfo} message RetryInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RetryInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.retryDelay = null;
          if (
            message.retryDelay != null &&
            message.hasOwnProperty("retryDelay")
          )
            object.retryDelay = $root.google.protobuf.Duration.toObject(
              message.retryDelay,
              options
            );
          return object;
        };

        /**
         * Converts this RetryInfo to JSON.
         * @function toJSON
         * @memberof google.rpc.RetryInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RetryInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RetryInfo;
      })();

      rpc.DebugInfo = (function () {
        /**
         * Properties of a DebugInfo.
         * @memberof google.rpc
         * @interface IDebugInfo
         * @property {Array.<string>|null} [stackEntries] DebugInfo stackEntries
         * @property {string|null} [detail] DebugInfo detail
         */

        /**
         * Constructs a new DebugInfo.
         * @memberof google.rpc
         * @classdesc Represents a DebugInfo.
         * @implements IDebugInfo
         * @constructor
         * @param {google.rpc.IDebugInfo=} [properties] Properties to set
         */
        function DebugInfo(properties) {
          this.stackEntries = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * DebugInfo stackEntries.
         * @member {Array.<string>} stackEntries
         * @memberof google.rpc.DebugInfo
         * @instance
         */
        DebugInfo.prototype.stackEntries = $util.emptyArray;

        /**
         * DebugInfo detail.
         * @member {string} detail
         * @memberof google.rpc.DebugInfo
         * @instance
         */
        DebugInfo.prototype.detail = "";

        /**
         * Creates a new DebugInfo instance using the specified properties.
         * @function create
         * @memberof google.rpc.DebugInfo
         * @static
         * @param {google.rpc.IDebugInfo=} [properties] Properties to set
         * @returns {google.rpc.DebugInfo} DebugInfo instance
         */
        DebugInfo.create = function create(properties) {
          return new DebugInfo(properties);
        };

        /**
         * Encodes the specified DebugInfo message. Does not implicitly {@link google.rpc.DebugInfo.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.DebugInfo
         * @static
         * @param {google.rpc.IDebugInfo} message DebugInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DebugInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.stackEntries != null && message.stackEntries.length)
            for (var i = 0; i < message.stackEntries.length; ++i)
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.stackEntries[i]);
          if (
            message.detail != null &&
            Object.hasOwnProperty.call(message, "detail")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.detail);
          return writer;
        };

        /**
         * Decodes a DebugInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.DebugInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.DebugInfo} DebugInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DebugInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.DebugInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.stackEntries && message.stackEntries.length))
                  message.stackEntries = [];
                message.stackEntries.push(reader.string());
                break;
              case 2:
                message.detail = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a DebugInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.DebugInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.DebugInfo} DebugInfo
         */
        DebugInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.DebugInfo) return object;
          var message = new $root.google.rpc.DebugInfo();
          if (object.stackEntries) {
            if (!Array.isArray(object.stackEntries))
              throw TypeError(
                ".google.rpc.DebugInfo.stackEntries: array expected"
              );
            message.stackEntries = [];
            for (var i = 0; i < object.stackEntries.length; ++i)
              message.stackEntries[i] = String(object.stackEntries[i]);
          }
          if (object.detail != null) message.detail = String(object.detail);
          return message;
        };

        /**
         * Creates a plain object from a DebugInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.DebugInfo
         * @static
         * @param {google.rpc.DebugInfo} message DebugInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DebugInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.stackEntries = [];
          if (options.defaults) object.detail = "";
          if (message.stackEntries && message.stackEntries.length) {
            object.stackEntries = [];
            for (var j = 0; j < message.stackEntries.length; ++j)
              object.stackEntries[j] = message.stackEntries[j];
          }
          if (message.detail != null && message.hasOwnProperty("detail"))
            object.detail = message.detail;
          return object;
        };

        /**
         * Converts this DebugInfo to JSON.
         * @function toJSON
         * @memberof google.rpc.DebugInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DebugInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DebugInfo;
      })();

      rpc.QuotaFailure = (function () {
        /**
         * Properties of a QuotaFailure.
         * @memberof google.rpc
         * @interface IQuotaFailure
         * @property {Array.<google.rpc.QuotaFailure.IViolation>|null} [violations] QuotaFailure violations
         */

        /**
         * Constructs a new QuotaFailure.
         * @memberof google.rpc
         * @classdesc Represents a QuotaFailure.
         * @implements IQuotaFailure
         * @constructor
         * @param {google.rpc.IQuotaFailure=} [properties] Properties to set
         */
        function QuotaFailure(properties) {
          this.violations = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuotaFailure violations.
         * @member {Array.<google.rpc.QuotaFailure.IViolation>} violations
         * @memberof google.rpc.QuotaFailure
         * @instance
         */
        QuotaFailure.prototype.violations = $util.emptyArray;

        /**
         * Creates a new QuotaFailure instance using the specified properties.
         * @function create
         * @memberof google.rpc.QuotaFailure
         * @static
         * @param {google.rpc.IQuotaFailure=} [properties] Properties to set
         * @returns {google.rpc.QuotaFailure} QuotaFailure instance
         */
        QuotaFailure.create = function create(properties) {
          return new QuotaFailure(properties);
        };

        /**
         * Encodes the specified QuotaFailure message. Does not implicitly {@link google.rpc.QuotaFailure.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.QuotaFailure
         * @static
         * @param {google.rpc.IQuotaFailure} message QuotaFailure message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuotaFailure.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.violations != null && message.violations.length)
            for (var i = 0; i < message.violations.length; ++i)
              $root.google.rpc.QuotaFailure.Violation.encode(
                message.violations[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a QuotaFailure message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.QuotaFailure
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.QuotaFailure} QuotaFailure
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuotaFailure.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.QuotaFailure();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.violations && message.violations.length))
                  message.violations = [];
                message.violations.push(
                  $root.google.rpc.QuotaFailure.Violation.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a QuotaFailure message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.QuotaFailure
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.QuotaFailure} QuotaFailure
         */
        QuotaFailure.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.QuotaFailure) return object;
          var message = new $root.google.rpc.QuotaFailure();
          if (object.violations) {
            if (!Array.isArray(object.violations))
              throw TypeError(
                ".google.rpc.QuotaFailure.violations: array expected"
              );
            message.violations = [];
            for (var i = 0; i < object.violations.length; ++i) {
              if (typeof object.violations[i] !== "object")
                throw TypeError(
                  ".google.rpc.QuotaFailure.violations: object expected"
                );
              message.violations[i] =
                $root.google.rpc.QuotaFailure.Violation.fromObject(
                  object.violations[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a QuotaFailure message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.QuotaFailure
         * @static
         * @param {google.rpc.QuotaFailure} message QuotaFailure
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuotaFailure.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.violations = [];
          if (message.violations && message.violations.length) {
            object.violations = [];
            for (var j = 0; j < message.violations.length; ++j)
              object.violations[j] =
                $root.google.rpc.QuotaFailure.Violation.toObject(
                  message.violations[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this QuotaFailure to JSON.
         * @function toJSON
         * @memberof google.rpc.QuotaFailure
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuotaFailure.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        QuotaFailure.Violation = (function () {
          /**
           * Properties of a Violation.
           * @memberof google.rpc.QuotaFailure
           * @interface IViolation
           * @property {string|null} [subject] Violation subject
           * @property {string|null} [description] Violation description
           */

          /**
           * Constructs a new Violation.
           * @memberof google.rpc.QuotaFailure
           * @classdesc Represents a Violation.
           * @implements IViolation
           * @constructor
           * @param {google.rpc.QuotaFailure.IViolation=} [properties] Properties to set
           */
          function Violation(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Violation subject.
           * @member {string} subject
           * @memberof google.rpc.QuotaFailure.Violation
           * @instance
           */
          Violation.prototype.subject = "";

          /**
           * Violation description.
           * @member {string} description
           * @memberof google.rpc.QuotaFailure.Violation
           * @instance
           */
          Violation.prototype.description = "";

          /**
           * Creates a new Violation instance using the specified properties.
           * @function create
           * @memberof google.rpc.QuotaFailure.Violation
           * @static
           * @param {google.rpc.QuotaFailure.IViolation=} [properties] Properties to set
           * @returns {google.rpc.QuotaFailure.Violation} Violation instance
           */
          Violation.create = function create(properties) {
            return new Violation(properties);
          };

          /**
           * Encodes the specified Violation message. Does not implicitly {@link google.rpc.QuotaFailure.Violation.verify|verify} messages.
           * @function encode
           * @memberof google.rpc.QuotaFailure.Violation
           * @static
           * @param {google.rpc.QuotaFailure.IViolation} message Violation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Violation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.subject != null &&
              Object.hasOwnProperty.call(message, "subject")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.subject);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a Violation message from the specified reader or buffer.
           * @function decode
           * @memberof google.rpc.QuotaFailure.Violation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.rpc.QuotaFailure.Violation} Violation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Violation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.google.rpc.QuotaFailure.Violation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.subject = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Violation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.rpc.QuotaFailure.Violation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.rpc.QuotaFailure.Violation} Violation
           */
          Violation.fromObject = function fromObject(object) {
            if (object instanceof $root.google.rpc.QuotaFailure.Violation)
              return object;
            var message = new $root.google.rpc.QuotaFailure.Violation();
            if (object.subject != null)
              message.subject = String(object.subject);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a Violation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.rpc.QuotaFailure.Violation
           * @static
           * @param {google.rpc.QuotaFailure.Violation} message Violation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Violation.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.subject = "";
              object.description = "";
            }
            if (message.subject != null && message.hasOwnProperty("subject"))
              object.subject = message.subject;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this Violation to JSON.
           * @function toJSON
           * @memberof google.rpc.QuotaFailure.Violation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Violation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Violation;
        })();

        return QuotaFailure;
      })();

      rpc.PreconditionFailure = (function () {
        /**
         * Properties of a PreconditionFailure.
         * @memberof google.rpc
         * @interface IPreconditionFailure
         * @property {Array.<google.rpc.PreconditionFailure.IViolation>|null} [violations] PreconditionFailure violations
         */

        /**
         * Constructs a new PreconditionFailure.
         * @memberof google.rpc
         * @classdesc Represents a PreconditionFailure.
         * @implements IPreconditionFailure
         * @constructor
         * @param {google.rpc.IPreconditionFailure=} [properties] Properties to set
         */
        function PreconditionFailure(properties) {
          this.violations = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * PreconditionFailure violations.
         * @member {Array.<google.rpc.PreconditionFailure.IViolation>} violations
         * @memberof google.rpc.PreconditionFailure
         * @instance
         */
        PreconditionFailure.prototype.violations = $util.emptyArray;

        /**
         * Creates a new PreconditionFailure instance using the specified properties.
         * @function create
         * @memberof google.rpc.PreconditionFailure
         * @static
         * @param {google.rpc.IPreconditionFailure=} [properties] Properties to set
         * @returns {google.rpc.PreconditionFailure} PreconditionFailure instance
         */
        PreconditionFailure.create = function create(properties) {
          return new PreconditionFailure(properties);
        };

        /**
         * Encodes the specified PreconditionFailure message. Does not implicitly {@link google.rpc.PreconditionFailure.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.PreconditionFailure
         * @static
         * @param {google.rpc.IPreconditionFailure} message PreconditionFailure message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PreconditionFailure.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.violations != null && message.violations.length)
            for (var i = 0; i < message.violations.length; ++i)
              $root.google.rpc.PreconditionFailure.Violation.encode(
                message.violations[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a PreconditionFailure message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.PreconditionFailure
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.PreconditionFailure} PreconditionFailure
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PreconditionFailure.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.PreconditionFailure();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.violations && message.violations.length))
                  message.violations = [];
                message.violations.push(
                  $root.google.rpc.PreconditionFailure.Violation.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a PreconditionFailure message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.PreconditionFailure
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.PreconditionFailure} PreconditionFailure
         */
        PreconditionFailure.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.PreconditionFailure)
            return object;
          var message = new $root.google.rpc.PreconditionFailure();
          if (object.violations) {
            if (!Array.isArray(object.violations))
              throw TypeError(
                ".google.rpc.PreconditionFailure.violations: array expected"
              );
            message.violations = [];
            for (var i = 0; i < object.violations.length; ++i) {
              if (typeof object.violations[i] !== "object")
                throw TypeError(
                  ".google.rpc.PreconditionFailure.violations: object expected"
                );
              message.violations[i] =
                $root.google.rpc.PreconditionFailure.Violation.fromObject(
                  object.violations[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a PreconditionFailure message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.PreconditionFailure
         * @static
         * @param {google.rpc.PreconditionFailure} message PreconditionFailure
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PreconditionFailure.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.violations = [];
          if (message.violations && message.violations.length) {
            object.violations = [];
            for (var j = 0; j < message.violations.length; ++j)
              object.violations[j] =
                $root.google.rpc.PreconditionFailure.Violation.toObject(
                  message.violations[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this PreconditionFailure to JSON.
         * @function toJSON
         * @memberof google.rpc.PreconditionFailure
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PreconditionFailure.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        PreconditionFailure.Violation = (function () {
          /**
           * Properties of a Violation.
           * @memberof google.rpc.PreconditionFailure
           * @interface IViolation
           * @property {string|null} [type] Violation type
           * @property {string|null} [subject] Violation subject
           * @property {string|null} [description] Violation description
           */

          /**
           * Constructs a new Violation.
           * @memberof google.rpc.PreconditionFailure
           * @classdesc Represents a Violation.
           * @implements IViolation
           * @constructor
           * @param {google.rpc.PreconditionFailure.IViolation=} [properties] Properties to set
           */
          function Violation(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Violation type.
           * @member {string} type
           * @memberof google.rpc.PreconditionFailure.Violation
           * @instance
           */
          Violation.prototype.type = "";

          /**
           * Violation subject.
           * @member {string} subject
           * @memberof google.rpc.PreconditionFailure.Violation
           * @instance
           */
          Violation.prototype.subject = "";

          /**
           * Violation description.
           * @member {string} description
           * @memberof google.rpc.PreconditionFailure.Violation
           * @instance
           */
          Violation.prototype.description = "";

          /**
           * Creates a new Violation instance using the specified properties.
           * @function create
           * @memberof google.rpc.PreconditionFailure.Violation
           * @static
           * @param {google.rpc.PreconditionFailure.IViolation=} [properties] Properties to set
           * @returns {google.rpc.PreconditionFailure.Violation} Violation instance
           */
          Violation.create = function create(properties) {
            return new Violation(properties);
          };

          /**
           * Encodes the specified Violation message. Does not implicitly {@link google.rpc.PreconditionFailure.Violation.verify|verify} messages.
           * @function encode
           * @memberof google.rpc.PreconditionFailure.Violation
           * @static
           * @param {google.rpc.PreconditionFailure.IViolation} message Violation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Violation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.type != null &&
              Object.hasOwnProperty.call(message, "type")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
            if (
              message.subject != null &&
              Object.hasOwnProperty.call(message, "subject")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.subject);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 3, wireType 2 =*/ 26)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a Violation message from the specified reader or buffer.
           * @function decode
           * @memberof google.rpc.PreconditionFailure.Violation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.rpc.PreconditionFailure.Violation} Violation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Violation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.google.rpc.PreconditionFailure.Violation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.type = reader.string();
                  break;
                case 2:
                  message.subject = reader.string();
                  break;
                case 3:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Violation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.rpc.PreconditionFailure.Violation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.rpc.PreconditionFailure.Violation} Violation
           */
          Violation.fromObject = function fromObject(object) {
            if (
              object instanceof $root.google.rpc.PreconditionFailure.Violation
            )
              return object;
            var message = new $root.google.rpc.PreconditionFailure.Violation();
            if (object.type != null) message.type = String(object.type);
            if (object.subject != null)
              message.subject = String(object.subject);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a Violation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.rpc.PreconditionFailure.Violation
           * @static
           * @param {google.rpc.PreconditionFailure.Violation} message Violation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Violation.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.type = "";
              object.subject = "";
              object.description = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
              object.type = message.type;
            if (message.subject != null && message.hasOwnProperty("subject"))
              object.subject = message.subject;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this Violation to JSON.
           * @function toJSON
           * @memberof google.rpc.PreconditionFailure.Violation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Violation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Violation;
        })();

        return PreconditionFailure;
      })();

      rpc.BadRequest = (function () {
        /**
         * Properties of a BadRequest.
         * @memberof google.rpc
         * @interface IBadRequest
         * @property {Array.<google.rpc.BadRequest.IFieldViolation>|null} [fieldViolations] BadRequest fieldViolations
         */

        /**
         * Constructs a new BadRequest.
         * @memberof google.rpc
         * @classdesc Represents a BadRequest.
         * @implements IBadRequest
         * @constructor
         * @param {google.rpc.IBadRequest=} [properties] Properties to set
         */
        function BadRequest(properties) {
          this.fieldViolations = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * BadRequest fieldViolations.
         * @member {Array.<google.rpc.BadRequest.IFieldViolation>} fieldViolations
         * @memberof google.rpc.BadRequest
         * @instance
         */
        BadRequest.prototype.fieldViolations = $util.emptyArray;

        /**
         * Creates a new BadRequest instance using the specified properties.
         * @function create
         * @memberof google.rpc.BadRequest
         * @static
         * @param {google.rpc.IBadRequest=} [properties] Properties to set
         * @returns {google.rpc.BadRequest} BadRequest instance
         */
        BadRequest.create = function create(properties) {
          return new BadRequest(properties);
        };

        /**
         * Encodes the specified BadRequest message. Does not implicitly {@link google.rpc.BadRequest.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.BadRequest
         * @static
         * @param {google.rpc.IBadRequest} message BadRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BadRequest.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.fieldViolations != null && message.fieldViolations.length)
            for (var i = 0; i < message.fieldViolations.length; ++i)
              $root.google.rpc.BadRequest.FieldViolation.encode(
                message.fieldViolations[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a BadRequest message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.BadRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.BadRequest} BadRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BadRequest.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.BadRequest();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (
                  !(message.fieldViolations && message.fieldViolations.length)
                )
                  message.fieldViolations = [];
                message.fieldViolations.push(
                  $root.google.rpc.BadRequest.FieldViolation.decode(
                    reader,
                    reader.uint32()
                  )
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a BadRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.BadRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.BadRequest} BadRequest
         */
        BadRequest.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.BadRequest) return object;
          var message = new $root.google.rpc.BadRequest();
          if (object.fieldViolations) {
            if (!Array.isArray(object.fieldViolations))
              throw TypeError(
                ".google.rpc.BadRequest.fieldViolations: array expected"
              );
            message.fieldViolations = [];
            for (var i = 0; i < object.fieldViolations.length; ++i) {
              if (typeof object.fieldViolations[i] !== "object")
                throw TypeError(
                  ".google.rpc.BadRequest.fieldViolations: object expected"
                );
              message.fieldViolations[i] =
                $root.google.rpc.BadRequest.FieldViolation.fromObject(
                  object.fieldViolations[i]
                );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a BadRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.BadRequest
         * @static
         * @param {google.rpc.BadRequest} message BadRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BadRequest.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.fieldViolations = [];
          if (message.fieldViolations && message.fieldViolations.length) {
            object.fieldViolations = [];
            for (var j = 0; j < message.fieldViolations.length; ++j)
              object.fieldViolations[j] =
                $root.google.rpc.BadRequest.FieldViolation.toObject(
                  message.fieldViolations[j],
                  options
                );
          }
          return object;
        };

        /**
         * Converts this BadRequest to JSON.
         * @function toJSON
         * @memberof google.rpc.BadRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BadRequest.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        BadRequest.FieldViolation = (function () {
          /**
           * Properties of a FieldViolation.
           * @memberof google.rpc.BadRequest
           * @interface IFieldViolation
           * @property {string|null} [field] FieldViolation field
           * @property {string|null} [description] FieldViolation description
           */

          /**
           * Constructs a new FieldViolation.
           * @memberof google.rpc.BadRequest
           * @classdesc Represents a FieldViolation.
           * @implements IFieldViolation
           * @constructor
           * @param {google.rpc.BadRequest.IFieldViolation=} [properties] Properties to set
           */
          function FieldViolation(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * FieldViolation field.
           * @member {string} field
           * @memberof google.rpc.BadRequest.FieldViolation
           * @instance
           */
          FieldViolation.prototype.field = "";

          /**
           * FieldViolation description.
           * @member {string} description
           * @memberof google.rpc.BadRequest.FieldViolation
           * @instance
           */
          FieldViolation.prototype.description = "";

          /**
           * Creates a new FieldViolation instance using the specified properties.
           * @function create
           * @memberof google.rpc.BadRequest.FieldViolation
           * @static
           * @param {google.rpc.BadRequest.IFieldViolation=} [properties] Properties to set
           * @returns {google.rpc.BadRequest.FieldViolation} FieldViolation instance
           */
          FieldViolation.create = function create(properties) {
            return new FieldViolation(properties);
          };

          /**
           * Encodes the specified FieldViolation message. Does not implicitly {@link google.rpc.BadRequest.FieldViolation.verify|verify} messages.
           * @function encode
           * @memberof google.rpc.BadRequest.FieldViolation
           * @static
           * @param {google.rpc.BadRequest.IFieldViolation} message FieldViolation message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          FieldViolation.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.field != null &&
              Object.hasOwnProperty.call(message, "field")
            )
              writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.field);
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.description);
            return writer;
          };

          /**
           * Decodes a FieldViolation message from the specified reader or buffer.
           * @function decode
           * @memberof google.rpc.BadRequest.FieldViolation
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.rpc.BadRequest.FieldViolation} FieldViolation
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          FieldViolation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.google.rpc.BadRequest.FieldViolation();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.field = reader.string();
                  break;
                case 2:
                  message.description = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a FieldViolation message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.rpc.BadRequest.FieldViolation
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.rpc.BadRequest.FieldViolation} FieldViolation
           */
          FieldViolation.fromObject = function fromObject(object) {
            if (object instanceof $root.google.rpc.BadRequest.FieldViolation)
              return object;
            var message = new $root.google.rpc.BadRequest.FieldViolation();
            if (object.field != null) message.field = String(object.field);
            if (object.description != null)
              message.description = String(object.description);
            return message;
          };

          /**
           * Creates a plain object from a FieldViolation message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.rpc.BadRequest.FieldViolation
           * @static
           * @param {google.rpc.BadRequest.FieldViolation} message FieldViolation
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          FieldViolation.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.field = "";
              object.description = "";
            }
            if (message.field != null && message.hasOwnProperty("field"))
              object.field = message.field;
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            return object;
          };

          /**
           * Converts this FieldViolation to JSON.
           * @function toJSON
           * @memberof google.rpc.BadRequest.FieldViolation
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          FieldViolation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return FieldViolation;
        })();

        return BadRequest;
      })();

      rpc.RequestInfo = (function () {
        /**
         * Properties of a RequestInfo.
         * @memberof google.rpc
         * @interface IRequestInfo
         * @property {string|null} [requestId] RequestInfo requestId
         * @property {string|null} [servingData] RequestInfo servingData
         */

        /**
         * Constructs a new RequestInfo.
         * @memberof google.rpc
         * @classdesc Represents a RequestInfo.
         * @implements IRequestInfo
         * @constructor
         * @param {google.rpc.IRequestInfo=} [properties] Properties to set
         */
        function RequestInfo(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestInfo requestId.
         * @member {string} requestId
         * @memberof google.rpc.RequestInfo
         * @instance
         */
        RequestInfo.prototype.requestId = "";

        /**
         * RequestInfo servingData.
         * @member {string} servingData
         * @memberof google.rpc.RequestInfo
         * @instance
         */
        RequestInfo.prototype.servingData = "";

        /**
         * Creates a new RequestInfo instance using the specified properties.
         * @function create
         * @memberof google.rpc.RequestInfo
         * @static
         * @param {google.rpc.IRequestInfo=} [properties] Properties to set
         * @returns {google.rpc.RequestInfo} RequestInfo instance
         */
        RequestInfo.create = function create(properties) {
          return new RequestInfo(properties);
        };

        /**
         * Encodes the specified RequestInfo message. Does not implicitly {@link google.rpc.RequestInfo.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.RequestInfo
         * @static
         * @param {google.rpc.IRequestInfo} message RequestInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.requestId != null &&
            Object.hasOwnProperty.call(message, "requestId")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.requestId);
          if (
            message.servingData != null &&
            Object.hasOwnProperty.call(message, "servingData")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.servingData);
          return writer;
        };

        /**
         * Decodes a RequestInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.RequestInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.RequestInfo} RequestInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.RequestInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.requestId = reader.string();
                break;
              case 2:
                message.servingData = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a RequestInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.RequestInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.RequestInfo} RequestInfo
         */
        RequestInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.RequestInfo) return object;
          var message = new $root.google.rpc.RequestInfo();
          if (object.requestId != null)
            message.requestId = String(object.requestId);
          if (object.servingData != null)
            message.servingData = String(object.servingData);
          return message;
        };

        /**
         * Creates a plain object from a RequestInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.RequestInfo
         * @static
         * @param {google.rpc.RequestInfo} message RequestInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.requestId = "";
            object.servingData = "";
          }
          if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
          if (
            message.servingData != null &&
            message.hasOwnProperty("servingData")
          )
            object.servingData = message.servingData;
          return object;
        };

        /**
         * Converts this RequestInfo to JSON.
         * @function toJSON
         * @memberof google.rpc.RequestInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestInfo;
      })();

      rpc.ResourceInfo = (function () {
        /**
         * Properties of a ResourceInfo.
         * @memberof google.rpc
         * @interface IResourceInfo
         * @property {string|null} [resourceType] ResourceInfo resourceType
         * @property {string|null} [resourceName] ResourceInfo resourceName
         * @property {string|null} [owner] ResourceInfo owner
         * @property {string|null} [description] ResourceInfo description
         */

        /**
         * Constructs a new ResourceInfo.
         * @memberof google.rpc
         * @classdesc Represents a ResourceInfo.
         * @implements IResourceInfo
         * @constructor
         * @param {google.rpc.IResourceInfo=} [properties] Properties to set
         */
        function ResourceInfo(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResourceInfo resourceType.
         * @member {string} resourceType
         * @memberof google.rpc.ResourceInfo
         * @instance
         */
        ResourceInfo.prototype.resourceType = "";

        /**
         * ResourceInfo resourceName.
         * @member {string} resourceName
         * @memberof google.rpc.ResourceInfo
         * @instance
         */
        ResourceInfo.prototype.resourceName = "";

        /**
         * ResourceInfo owner.
         * @member {string} owner
         * @memberof google.rpc.ResourceInfo
         * @instance
         */
        ResourceInfo.prototype.owner = "";

        /**
         * ResourceInfo description.
         * @member {string} description
         * @memberof google.rpc.ResourceInfo
         * @instance
         */
        ResourceInfo.prototype.description = "";

        /**
         * Creates a new ResourceInfo instance using the specified properties.
         * @function create
         * @memberof google.rpc.ResourceInfo
         * @static
         * @param {google.rpc.IResourceInfo=} [properties] Properties to set
         * @returns {google.rpc.ResourceInfo} ResourceInfo instance
         */
        ResourceInfo.create = function create(properties) {
          return new ResourceInfo(properties);
        };

        /**
         * Encodes the specified ResourceInfo message. Does not implicitly {@link google.rpc.ResourceInfo.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.ResourceInfo
         * @static
         * @param {google.rpc.IResourceInfo} message ResourceInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResourceInfo.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.resourceType != null &&
            Object.hasOwnProperty.call(message, "resourceType")
          )
            writer
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(message.resourceType);
          if (
            message.resourceName != null &&
            Object.hasOwnProperty.call(message, "resourceName")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.resourceName);
          if (
            message.owner != null &&
            Object.hasOwnProperty.call(message, "owner")
          )
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.owner);
          if (
            message.description != null &&
            Object.hasOwnProperty.call(message, "description")
          )
            writer
              .uint32(/* id 4, wireType 2 =*/ 34)
              .string(message.description);
          return writer;
        };

        /**
         * Decodes a ResourceInfo message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.ResourceInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.ResourceInfo} ResourceInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResourceInfo.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.ResourceInfo();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.resourceType = reader.string();
                break;
              case 2:
                message.resourceName = reader.string();
                break;
              case 3:
                message.owner = reader.string();
                break;
              case 4:
                message.description = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a ResourceInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.ResourceInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.ResourceInfo} ResourceInfo
         */
        ResourceInfo.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.ResourceInfo) return object;
          var message = new $root.google.rpc.ResourceInfo();
          if (object.resourceType != null)
            message.resourceType = String(object.resourceType);
          if (object.resourceName != null)
            message.resourceName = String(object.resourceName);
          if (object.owner != null) message.owner = String(object.owner);
          if (object.description != null)
            message.description = String(object.description);
          return message;
        };

        /**
         * Creates a plain object from a ResourceInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.ResourceInfo
         * @static
         * @param {google.rpc.ResourceInfo} message ResourceInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResourceInfo.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.resourceType = "";
            object.resourceName = "";
            object.owner = "";
            object.description = "";
          }
          if (
            message.resourceType != null &&
            message.hasOwnProperty("resourceType")
          )
            object.resourceType = message.resourceType;
          if (
            message.resourceName != null &&
            message.hasOwnProperty("resourceName")
          )
            object.resourceName = message.resourceName;
          if (message.owner != null && message.hasOwnProperty("owner"))
            object.owner = message.owner;
          if (
            message.description != null &&
            message.hasOwnProperty("description")
          )
            object.description = message.description;
          return object;
        };

        /**
         * Converts this ResourceInfo to JSON.
         * @function toJSON
         * @memberof google.rpc.ResourceInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResourceInfo.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResourceInfo;
      })();

      rpc.Help = (function () {
        /**
         * Properties of a Help.
         * @memberof google.rpc
         * @interface IHelp
         * @property {Array.<google.rpc.Help.ILink>|null} [links] Help links
         */

        /**
         * Constructs a new Help.
         * @memberof google.rpc
         * @classdesc Represents a Help.
         * @implements IHelp
         * @constructor
         * @param {google.rpc.IHelp=} [properties] Properties to set
         */
        function Help(properties) {
          this.links = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Help links.
         * @member {Array.<google.rpc.Help.ILink>} links
         * @memberof google.rpc.Help
         * @instance
         */
        Help.prototype.links = $util.emptyArray;

        /**
         * Creates a new Help instance using the specified properties.
         * @function create
         * @memberof google.rpc.Help
         * @static
         * @param {google.rpc.IHelp=} [properties] Properties to set
         * @returns {google.rpc.Help} Help instance
         */
        Help.create = function create(properties) {
          return new Help(properties);
        };

        /**
         * Encodes the specified Help message. Does not implicitly {@link google.rpc.Help.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.Help
         * @static
         * @param {google.rpc.IHelp} message Help message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Help.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.links != null && message.links.length)
            for (var i = 0; i < message.links.length; ++i)
              $root.google.rpc.Help.Link.encode(
                message.links[i],
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a Help message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.Help
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.Help} Help
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Help.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.Help();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                if (!(message.links && message.links.length))
                  message.links = [];
                message.links.push(
                  $root.google.rpc.Help.Link.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Help message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.Help
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.Help} Help
         */
        Help.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.Help) return object;
          var message = new $root.google.rpc.Help();
          if (object.links) {
            if (!Array.isArray(object.links))
              throw TypeError(".google.rpc.Help.links: array expected");
            message.links = [];
            for (var i = 0; i < object.links.length; ++i) {
              if (typeof object.links[i] !== "object")
                throw TypeError(".google.rpc.Help.links: object expected");
              message.links[i] = $root.google.rpc.Help.Link.fromObject(
                object.links[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Help message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.Help
         * @static
         * @param {google.rpc.Help} message Help
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Help.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.links = [];
          if (message.links && message.links.length) {
            object.links = [];
            for (var j = 0; j < message.links.length; ++j)
              object.links[j] = $root.google.rpc.Help.Link.toObject(
                message.links[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Help to JSON.
         * @function toJSON
         * @memberof google.rpc.Help
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Help.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Help.Link = (function () {
          /**
           * Properties of a Link.
           * @memberof google.rpc.Help
           * @interface ILink
           * @property {string|null} [description] Link description
           * @property {string|null} [url] Link url
           */

          /**
           * Constructs a new Link.
           * @memberof google.rpc.Help
           * @classdesc Represents a Link.
           * @implements ILink
           * @constructor
           * @param {google.rpc.Help.ILink=} [properties] Properties to set
           */
          function Link(properties) {
            if (properties)
              for (
                var keys = Object.keys(properties), i = 0;
                i < keys.length;
                ++i
              )
                if (properties[keys[i]] != null)
                  this[keys[i]] = properties[keys[i]];
          }

          /**
           * Link description.
           * @member {string} description
           * @memberof google.rpc.Help.Link
           * @instance
           */
          Link.prototype.description = "";

          /**
           * Link url.
           * @member {string} url
           * @memberof google.rpc.Help.Link
           * @instance
           */
          Link.prototype.url = "";

          /**
           * Creates a new Link instance using the specified properties.
           * @function create
           * @memberof google.rpc.Help.Link
           * @static
           * @param {google.rpc.Help.ILink=} [properties] Properties to set
           * @returns {google.rpc.Help.Link} Link instance
           */
          Link.create = function create(properties) {
            return new Link(properties);
          };

          /**
           * Encodes the specified Link message. Does not implicitly {@link google.rpc.Help.Link.verify|verify} messages.
           * @function encode
           * @memberof google.rpc.Help.Link
           * @static
           * @param {google.rpc.Help.ILink} message Link message or plain object to encode
           * @param {$protobuf.Writer} [writer] Writer to encode to
           * @returns {$protobuf.Writer} Writer
           */
          Link.encode = function encode(message, writer) {
            if (!writer) writer = $Writer.create();
            if (
              message.description != null &&
              Object.hasOwnProperty.call(message, "description")
            )
              writer
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(message.description);
            if (
              message.url != null &&
              Object.hasOwnProperty.call(message, "url")
            )
              writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
            return writer;
          };

          /**
           * Decodes a Link message from the specified reader or buffer.
           * @function decode
           * @memberof google.rpc.Help.Link
           * @static
           * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
           * @param {number} [length] Message length if known beforehand
           * @returns {google.rpc.Help.Link} Link
           * @throws {Error} If the payload is not a reader or valid buffer
           * @throws {$protobuf.util.ProtocolError} If required fields are missing
           */
          Link.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length,
              message = new $root.google.rpc.Help.Link();
            while (reader.pos < end) {
              var tag = reader.uint32();
              switch (tag >>> 3) {
                case 1:
                  message.description = reader.string();
                  break;
                case 2:
                  message.url = reader.string();
                  break;
                default:
                  reader.skipType(tag & 7);
                  break;
              }
            }
            return message;
          };

          /**
           * Creates a Link message from a plain object. Also converts values to their respective internal types.
           * @function fromObject
           * @memberof google.rpc.Help.Link
           * @static
           * @param {Object.<string,*>} object Plain object
           * @returns {google.rpc.Help.Link} Link
           */
          Link.fromObject = function fromObject(object) {
            if (object instanceof $root.google.rpc.Help.Link) return object;
            var message = new $root.google.rpc.Help.Link();
            if (object.description != null)
              message.description = String(object.description);
            if (object.url != null) message.url = String(object.url);
            return message;
          };

          /**
           * Creates a plain object from a Link message. Also converts values to other types if specified.
           * @function toObject
           * @memberof google.rpc.Help.Link
           * @static
           * @param {google.rpc.Help.Link} message Link
           * @param {$protobuf.IConversionOptions} [options] Conversion options
           * @returns {Object.<string,*>} Plain object
           */
          Link.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
              object.description = "";
              object.url = "";
            }
            if (
              message.description != null &&
              message.hasOwnProperty("description")
            )
              object.description = message.description;
            if (message.url != null && message.hasOwnProperty("url"))
              object.url = message.url;
            return object;
          };

          /**
           * Converts this Link to JSON.
           * @function toJSON
           * @memberof google.rpc.Help.Link
           * @instance
           * @returns {Object.<string,*>} JSON object
           */
          Link.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(
              this,
              $protobuf.util.toJSONOptions
            );
          };

          return Link;
        })();

        return Help;
      })();

      rpc.LocalizedMessage = (function () {
        /**
         * Properties of a LocalizedMessage.
         * @memberof google.rpc
         * @interface ILocalizedMessage
         * @property {string|null} [locale] LocalizedMessage locale
         * @property {string|null} [message] LocalizedMessage message
         */

        /**
         * Constructs a new LocalizedMessage.
         * @memberof google.rpc
         * @classdesc Represents a LocalizedMessage.
         * @implements ILocalizedMessage
         * @constructor
         * @param {google.rpc.ILocalizedMessage=} [properties] Properties to set
         */
        function LocalizedMessage(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * LocalizedMessage locale.
         * @member {string} locale
         * @memberof google.rpc.LocalizedMessage
         * @instance
         */
        LocalizedMessage.prototype.locale = "";

        /**
         * LocalizedMessage message.
         * @member {string} message
         * @memberof google.rpc.LocalizedMessage
         * @instance
         */
        LocalizedMessage.prototype.message = "";

        /**
         * Creates a new LocalizedMessage instance using the specified properties.
         * @function create
         * @memberof google.rpc.LocalizedMessage
         * @static
         * @param {google.rpc.ILocalizedMessage=} [properties] Properties to set
         * @returns {google.rpc.LocalizedMessage} LocalizedMessage instance
         */
        LocalizedMessage.create = function create(properties) {
          return new LocalizedMessage(properties);
        };

        /**
         * Encodes the specified LocalizedMessage message. Does not implicitly {@link google.rpc.LocalizedMessage.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.LocalizedMessage
         * @static
         * @param {google.rpc.ILocalizedMessage} message LocalizedMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LocalizedMessage.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.locale != null &&
            Object.hasOwnProperty.call(message, "locale")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.locale);
          if (
            message.message != null &&
            Object.hasOwnProperty.call(message, "message")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
          return writer;
        };

        /**
         * Decodes a LocalizedMessage message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.LocalizedMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.LocalizedMessage} LocalizedMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LocalizedMessage.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.LocalizedMessage();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.locale = reader.string();
                break;
              case 2:
                message.message = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a LocalizedMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.LocalizedMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.LocalizedMessage} LocalizedMessage
         */
        LocalizedMessage.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.LocalizedMessage)
            return object;
          var message = new $root.google.rpc.LocalizedMessage();
          if (object.locale != null) message.locale = String(object.locale);
          if (object.message != null) message.message = String(object.message);
          return message;
        };

        /**
         * Creates a plain object from a LocalizedMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.LocalizedMessage
         * @static
         * @param {google.rpc.LocalizedMessage} message LocalizedMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LocalizedMessage.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.locale = "";
            object.message = "";
          }
          if (message.locale != null && message.hasOwnProperty("locale"))
            object.locale = message.locale;
          if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
          return object;
        };

        /**
         * Converts this LocalizedMessage to JSON.
         * @function toJSON
         * @memberof google.rpc.LocalizedMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LocalizedMessage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LocalizedMessage;
      })();

      rpc.Status = (function () {
        /**
         * Properties of a Status.
         * @memberof google.rpc
         * @interface IStatus
         * @property {number|null} [code] Status code
         * @property {string|null} [message] Status message
         * @property {Array.<google.protobuf.IAny>|null} [details] Status details
         */

        /**
         * Constructs a new Status.
         * @memberof google.rpc
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {google.rpc.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
          this.details = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Status code.
         * @member {number} code
         * @memberof google.rpc.Status
         * @instance
         */
        Status.prototype.code = 0;

        /**
         * Status message.
         * @member {string} message
         * @memberof google.rpc.Status
         * @instance
         */
        Status.prototype.message = "";

        /**
         * Status details.
         * @member {Array.<google.protobuf.IAny>} details
         * @memberof google.rpc.Status
         * @instance
         */
        Status.prototype.details = $util.emptyArray;

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof google.rpc.Status
         * @static
         * @param {google.rpc.IStatus=} [properties] Properties to set
         * @returns {google.rpc.Status} Status instance
         */
        Status.create = function create(properties) {
          return new Status(properties);
        };

        /**
         * Encodes the specified Status message. Does not implicitly {@link google.rpc.Status.verify|verify} messages.
         * @function encode
         * @memberof google.rpc.Status
         * @static
         * @param {google.rpc.IStatus} message Status message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Status.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.code != null &&
            Object.hasOwnProperty.call(message, "code")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.code);
          if (
            message.message != null &&
            Object.hasOwnProperty.call(message, "message")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
          if (message.details != null && message.details.length)
            for (var i = 0; i < message.details.length; ++i)
              $root.google.protobuf.Any.encode(
                message.details[i],
                writer.uint32(/* id 3, wireType 2 =*/ 26).fork()
              ).ldelim();
          return writer;
        };

        /**
         * Decodes a Status message from the specified reader or buffer.
         * @function decode
         * @memberof google.rpc.Status
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.rpc.Status} Status
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Status.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.rpc.Status();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.code = reader.int32();
                break;
              case 2:
                message.message = reader.string();
                break;
              case 3:
                if (!(message.details && message.details.length))
                  message.details = [];
                message.details.push(
                  $root.google.protobuf.Any.decode(reader, reader.uint32())
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.rpc.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.rpc.Status} Status
         */
        Status.fromObject = function fromObject(object) {
          if (object instanceof $root.google.rpc.Status) return object;
          var message = new $root.google.rpc.Status();
          if (object.code != null) message.code = object.code | 0;
          if (object.message != null) message.message = String(object.message);
          if (object.details) {
            if (!Array.isArray(object.details))
              throw TypeError(".google.rpc.Status.details: array expected");
            message.details = [];
            for (var i = 0; i < object.details.length; ++i) {
              if (typeof object.details[i] !== "object")
                throw TypeError(".google.rpc.Status.details: object expected");
              message.details[i] = $root.google.protobuf.Any.fromObject(
                object.details[i]
              );
            }
          }
          return message;
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.rpc.Status
         * @static
         * @param {google.rpc.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) object.details = [];
          if (options.defaults) {
            object.code = 0;
            object.message = "";
          }
          if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
          if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
          if (message.details && message.details.length) {
            object.details = [];
            for (var j = 0; j < message.details.length; ++j)
              object.details[j] = $root.google.protobuf.Any.toObject(
                message.details[j],
                options
              );
          }
          return object;
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof google.rpc.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Status;
      })();

      return rpc;
    })();

    google.type = (function () {
      /**
       * Namespace type.
       * @memberof google
       * @namespace
       */
      var type = {};

      type.Color = (function () {
        /**
         * Properties of a Color.
         * @memberof google.type
         * @interface IColor
         * @property {number|null} [red] Color red
         * @property {number|null} [green] Color green
         * @property {number|null} [blue] Color blue
         * @property {google.protobuf.IFloatValue|null} [alpha] Color alpha
         */

        /**
         * Constructs a new Color.
         * @memberof google.type
         * @classdesc Represents a Color.
         * @implements IColor
         * @constructor
         * @param {google.type.IColor=} [properties] Properties to set
         */
        function Color(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Color red.
         * @member {number} red
         * @memberof google.type.Color
         * @instance
         */
        Color.prototype.red = 0;

        /**
         * Color green.
         * @member {number} green
         * @memberof google.type.Color
         * @instance
         */
        Color.prototype.green = 0;

        /**
         * Color blue.
         * @member {number} blue
         * @memberof google.type.Color
         * @instance
         */
        Color.prototype.blue = 0;

        /**
         * Color alpha.
         * @member {google.protobuf.IFloatValue|null|undefined} alpha
         * @memberof google.type.Color
         * @instance
         */
        Color.prototype.alpha = null;

        /**
         * Creates a new Color instance using the specified properties.
         * @function create
         * @memberof google.type.Color
         * @static
         * @param {google.type.IColor=} [properties] Properties to set
         * @returns {google.type.Color} Color instance
         */
        Color.create = function create(properties) {
          return new Color(properties);
        };

        /**
         * Encodes the specified Color message. Does not implicitly {@link google.type.Color.verify|verify} messages.
         * @function encode
         * @memberof google.type.Color
         * @static
         * @param {google.type.IColor} message Color message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Color.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.red != null && Object.hasOwnProperty.call(message, "red"))
            writer.uint32(/* id 1, wireType 5 =*/ 13).float(message.red);
          if (
            message.green != null &&
            Object.hasOwnProperty.call(message, "green")
          )
            writer.uint32(/* id 2, wireType 5 =*/ 21).float(message.green);
          if (
            message.blue != null &&
            Object.hasOwnProperty.call(message, "blue")
          )
            writer.uint32(/* id 3, wireType 5 =*/ 29).float(message.blue);
          if (
            message.alpha != null &&
            Object.hasOwnProperty.call(message, "alpha")
          )
            $root.google.protobuf.FloatValue.encode(
              message.alpha,
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a Color message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.Color
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.Color} Color
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Color.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.Color();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.red = reader.float();
                break;
              case 2:
                message.green = reader.float();
                break;
              case 3:
                message.blue = reader.float();
                break;
              case 4:
                message.alpha = $root.google.protobuf.FloatValue.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Color message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.Color
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.Color} Color
         */
        Color.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.Color) return object;
          var message = new $root.google.type.Color();
          if (object.red != null) message.red = Number(object.red);
          if (object.green != null) message.green = Number(object.green);
          if (object.blue != null) message.blue = Number(object.blue);
          if (object.alpha != null) {
            if (typeof object.alpha !== "object")
              throw TypeError(".google.type.Color.alpha: object expected");
            message.alpha = $root.google.protobuf.FloatValue.fromObject(
              object.alpha
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a Color message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.Color
         * @static
         * @param {google.type.Color} message Color
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Color.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.red = 0;
            object.green = 0;
            object.blue = 0;
            object.alpha = null;
          }
          if (message.red != null && message.hasOwnProperty("red"))
            object.red =
              options.json && !isFinite(message.red)
                ? String(message.red)
                : message.red;
          if (message.green != null && message.hasOwnProperty("green"))
            object.green =
              options.json && !isFinite(message.green)
                ? String(message.green)
                : message.green;
          if (message.blue != null && message.hasOwnProperty("blue"))
            object.blue =
              options.json && !isFinite(message.blue)
                ? String(message.blue)
                : message.blue;
          if (message.alpha != null && message.hasOwnProperty("alpha"))
            object.alpha = $root.google.protobuf.FloatValue.toObject(
              message.alpha,
              options
            );
          return object;
        };

        /**
         * Converts this Color to JSON.
         * @function toJSON
         * @memberof google.type.Color
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Color.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Color;
      })();

      type.Date = (function () {
        /**
         * Properties of a Date.
         * @memberof google.type
         * @interface IDate
         * @property {number|null} [year] Date year
         * @property {number|null} [month] Date month
         * @property {number|null} [day] Date day
         */

        /**
         * Constructs a new Date.
         * @memberof google.type
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {google.type.IDate=} [properties] Properties to set
         */
        function Date(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Date year.
         * @member {number} year
         * @memberof google.type.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof google.type.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date day.
         * @member {number} day
         * @memberof google.type.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof google.type.Date
         * @static
         * @param {google.type.IDate=} [properties] Properties to set
         * @returns {google.type.Date} Date instance
         */
        Date.create = function create(properties) {
          return new Date(properties);
        };

        /**
         * Encodes the specified Date message. Does not implicitly {@link google.type.Date.verify|verify} messages.
         * @function encode
         * @memberof google.type.Date
         * @static
         * @param {google.type.IDate} message Date message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.year != null &&
            Object.hasOwnProperty.call(message, "year")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.year);
          if (
            message.month != null &&
            Object.hasOwnProperty.call(message, "month")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.month);
          if (message.day != null && Object.hasOwnProperty.call(message, "day"))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.day);
          return writer;
        };

        /**
         * Decodes a Date message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.Date();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.year = reader.int32();
                break;
              case 2:
                message.month = reader.int32();
                break;
              case 3:
                message.day = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Date message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.Date
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.Date} Date
         */
        Date.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.Date) return object;
          var message = new $root.google.type.Date();
          if (object.year != null) message.year = object.year | 0;
          if (object.month != null) message.month = object.month | 0;
          if (object.day != null) message.day = object.day | 0;
          return message;
        };

        /**
         * Creates a plain object from a Date message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.Date
         * @static
         * @param {google.type.Date} message Date
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Date.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.year = 0;
            object.month = 0;
            object.day = 0;
          }
          if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
          if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
          if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
          return object;
        };

        /**
         * Converts this Date to JSON.
         * @function toJSON
         * @memberof google.type.Date
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Date.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Date;
      })();

      type.DateTime = (function () {
        /**
         * Properties of a DateTime.
         * @memberof google.type
         * @interface IDateTime
         * @property {number|null} [year] DateTime year
         * @property {number|null} [month] DateTime month
         * @property {number|null} [day] DateTime day
         * @property {number|null} [hours] DateTime hours
         * @property {number|null} [minutes] DateTime minutes
         * @property {number|null} [seconds] DateTime seconds
         * @property {number|null} [nanos] DateTime nanos
         * @property {google.protobuf.IDuration|null} [utcOffset] DateTime utcOffset
         * @property {google.type.ITimeZone|null} [timeZone] DateTime timeZone
         */

        /**
         * Constructs a new DateTime.
         * @memberof google.type
         * @classdesc Represents a DateTime.
         * @implements IDateTime
         * @constructor
         * @param {google.type.IDateTime=} [properties] Properties to set
         */
        function DateTime(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * DateTime year.
         * @member {number} year
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.year = 0;

        /**
         * DateTime month.
         * @member {number} month
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.month = 0;

        /**
         * DateTime day.
         * @member {number} day
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.day = 0;

        /**
         * DateTime hours.
         * @member {number} hours
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.hours = 0;

        /**
         * DateTime minutes.
         * @member {number} minutes
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.minutes = 0;

        /**
         * DateTime seconds.
         * @member {number} seconds
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.seconds = 0;

        /**
         * DateTime nanos.
         * @member {number} nanos
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.nanos = 0;

        /**
         * DateTime utcOffset.
         * @member {google.protobuf.IDuration|null|undefined} utcOffset
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.utcOffset = null;

        /**
         * DateTime timeZone.
         * @member {google.type.ITimeZone|null|undefined} timeZone
         * @memberof google.type.DateTime
         * @instance
         */
        DateTime.prototype.timeZone = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * DateTime timeOffset.
         * @member {"utcOffset"|"timeZone"|undefined} timeOffset
         * @memberof google.type.DateTime
         * @instance
         */
        Object.defineProperty(DateTime.prototype, "timeOffset", {
          get: $util.oneOfGetter(($oneOfFields = ["utcOffset", "timeZone"])),
          set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new DateTime instance using the specified properties.
         * @function create
         * @memberof google.type.DateTime
         * @static
         * @param {google.type.IDateTime=} [properties] Properties to set
         * @returns {google.type.DateTime} DateTime instance
         */
        DateTime.create = function create(properties) {
          return new DateTime(properties);
        };

        /**
         * Encodes the specified DateTime message. Does not implicitly {@link google.type.DateTime.verify|verify} messages.
         * @function encode
         * @memberof google.type.DateTime
         * @static
         * @param {google.type.IDateTime} message DateTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateTime.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.year != null &&
            Object.hasOwnProperty.call(message, "year")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.year);
          if (
            message.month != null &&
            Object.hasOwnProperty.call(message, "month")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.month);
          if (message.day != null && Object.hasOwnProperty.call(message, "day"))
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.day);
          if (
            message.hours != null &&
            Object.hasOwnProperty.call(message, "hours")
          )
            writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.hours);
          if (
            message.minutes != null &&
            Object.hasOwnProperty.call(message, "minutes")
          )
            writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.minutes);
          if (
            message.seconds != null &&
            Object.hasOwnProperty.call(message, "seconds")
          )
            writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.seconds);
          if (
            message.nanos != null &&
            Object.hasOwnProperty.call(message, "nanos")
          )
            writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.nanos);
          if (
            message.utcOffset != null &&
            Object.hasOwnProperty.call(message, "utcOffset")
          )
            $root.google.protobuf.Duration.encode(
              message.utcOffset,
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
          if (
            message.timeZone != null &&
            Object.hasOwnProperty.call(message, "timeZone")
          )
            $root.google.type.TimeZone.encode(
              message.timeZone,
              writer.uint32(/* id 9, wireType 2 =*/ 74).fork()
            ).ldelim();
          return writer;
        };

        /**
         * Decodes a DateTime message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.DateTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.DateTime} DateTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateTime.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.DateTime();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.year = reader.int32();
                break;
              case 2:
                message.month = reader.int32();
                break;
              case 3:
                message.day = reader.int32();
                break;
              case 4:
                message.hours = reader.int32();
                break;
              case 5:
                message.minutes = reader.int32();
                break;
              case 6:
                message.seconds = reader.int32();
                break;
              case 7:
                message.nanos = reader.int32();
                break;
              case 8:
                message.utcOffset = $root.google.protobuf.Duration.decode(
                  reader,
                  reader.uint32()
                );
                break;
              case 9:
                message.timeZone = $root.google.type.TimeZone.decode(
                  reader,
                  reader.uint32()
                );
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a DateTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.DateTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.DateTime} DateTime
         */
        DateTime.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.DateTime) return object;
          var message = new $root.google.type.DateTime();
          if (object.year != null) message.year = object.year | 0;
          if (object.month != null) message.month = object.month | 0;
          if (object.day != null) message.day = object.day | 0;
          if (object.hours != null) message.hours = object.hours | 0;
          if (object.minutes != null) message.minutes = object.minutes | 0;
          if (object.seconds != null) message.seconds = object.seconds | 0;
          if (object.nanos != null) message.nanos = object.nanos | 0;
          if (object.utcOffset != null) {
            if (typeof object.utcOffset !== "object")
              throw TypeError(
                ".google.type.DateTime.utcOffset: object expected"
              );
            message.utcOffset = $root.google.protobuf.Duration.fromObject(
              object.utcOffset
            );
          }
          if (object.timeZone != null) {
            if (typeof object.timeZone !== "object")
              throw TypeError(
                ".google.type.DateTime.timeZone: object expected"
              );
            message.timeZone = $root.google.type.TimeZone.fromObject(
              object.timeZone
            );
          }
          return message;
        };

        /**
         * Creates a plain object from a DateTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.DateTime
         * @static
         * @param {google.type.DateTime} message DateTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DateTime.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.year = 0;
            object.month = 0;
            object.day = 0;
            object.hours = 0;
            object.minutes = 0;
            object.seconds = 0;
            object.nanos = 0;
          }
          if (message.year != null && message.hasOwnProperty("year"))
            object.year = message.year;
          if (message.month != null && message.hasOwnProperty("month"))
            object.month = message.month;
          if (message.day != null && message.hasOwnProperty("day"))
            object.day = message.day;
          if (message.hours != null && message.hasOwnProperty("hours"))
            object.hours = message.hours;
          if (message.minutes != null && message.hasOwnProperty("minutes"))
            object.minutes = message.minutes;
          if (message.seconds != null && message.hasOwnProperty("seconds"))
            object.seconds = message.seconds;
          if (message.nanos != null && message.hasOwnProperty("nanos"))
            object.nanos = message.nanos;
          if (
            message.utcOffset != null &&
            message.hasOwnProperty("utcOffset")
          ) {
            object.utcOffset = $root.google.protobuf.Duration.toObject(
              message.utcOffset,
              options
            );
            if (options.oneofs) object.timeOffset = "utcOffset";
          }
          if (message.timeZone != null && message.hasOwnProperty("timeZone")) {
            object.timeZone = $root.google.type.TimeZone.toObject(
              message.timeZone,
              options
            );
            if (options.oneofs) object.timeOffset = "timeZone";
          }
          return object;
        };

        /**
         * Converts this DateTime to JSON.
         * @function toJSON
         * @memberof google.type.DateTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DateTime.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DateTime;
      })();

      type.TimeZone = (function () {
        /**
         * Properties of a TimeZone.
         * @memberof google.type
         * @interface ITimeZone
         * @property {string|null} [id] TimeZone id
         * @property {string|null} [version] TimeZone version
         */

        /**
         * Constructs a new TimeZone.
         * @memberof google.type
         * @classdesc Represents a TimeZone.
         * @implements ITimeZone
         * @constructor
         * @param {google.type.ITimeZone=} [properties] Properties to set
         */
        function TimeZone(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeZone id.
         * @member {string} id
         * @memberof google.type.TimeZone
         * @instance
         */
        TimeZone.prototype.id = "";

        /**
         * TimeZone version.
         * @member {string} version
         * @memberof google.type.TimeZone
         * @instance
         */
        TimeZone.prototype.version = "";

        /**
         * Creates a new TimeZone instance using the specified properties.
         * @function create
         * @memberof google.type.TimeZone
         * @static
         * @param {google.type.ITimeZone=} [properties] Properties to set
         * @returns {google.type.TimeZone} TimeZone instance
         */
        TimeZone.create = function create(properties) {
          return new TimeZone(properties);
        };

        /**
         * Encodes the specified TimeZone message. Does not implicitly {@link google.type.TimeZone.verify|verify} messages.
         * @function encode
         * @memberof google.type.TimeZone
         * @static
         * @param {google.type.ITimeZone} message TimeZone message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeZone.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
          if (
            message.version != null &&
            Object.hasOwnProperty.call(message, "version")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.version);
          return writer;
        };

        /**
         * Decodes a TimeZone message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.TimeZone
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.TimeZone} TimeZone
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeZone.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.TimeZone();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.id = reader.string();
                break;
              case 2:
                message.version = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a TimeZone message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.TimeZone
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.TimeZone} TimeZone
         */
        TimeZone.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.TimeZone) return object;
          var message = new $root.google.type.TimeZone();
          if (object.id != null) message.id = String(object.id);
          if (object.version != null) message.version = String(object.version);
          return message;
        };

        /**
         * Creates a plain object from a TimeZone message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.TimeZone
         * @static
         * @param {google.type.TimeZone} message TimeZone
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeZone.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.id = "";
            object.version = "";
          }
          if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
          if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
          return object;
        };

        /**
         * Converts this TimeZone to JSON.
         * @function toJSON
         * @memberof google.type.TimeZone
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeZone.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeZone;
      })();

      /**
       * DayOfWeek enum.
       * @name google.type.DayOfWeek
       * @enum {string}
       * @property {number} DAY_OF_WEEK_UNSPECIFIED=0 DAY_OF_WEEK_UNSPECIFIED value
       * @property {number} MONDAY=1 MONDAY value
       * @property {number} TUESDAY=2 TUESDAY value
       * @property {number} WEDNESDAY=3 WEDNESDAY value
       * @property {number} THURSDAY=4 THURSDAY value
       * @property {number} FRIDAY=5 FRIDAY value
       * @property {number} SATURDAY=6 SATURDAY value
       * @property {number} SUNDAY=7 SUNDAY value
       */
      type.DayOfWeek = (function () {
        var valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = "DAY_OF_WEEK_UNSPECIFIED")] = 0;
        values[(valuesById[1] = "MONDAY")] = 1;
        values[(valuesById[2] = "TUESDAY")] = 2;
        values[(valuesById[3] = "WEDNESDAY")] = 3;
        values[(valuesById[4] = "THURSDAY")] = 4;
        values[(valuesById[5] = "FRIDAY")] = 5;
        values[(valuesById[6] = "SATURDAY")] = 6;
        values[(valuesById[7] = "SUNDAY")] = 7;
        return values;
      })();

      type.Decimal = (function () {
        /**
         * Properties of a Decimal.
         * @memberof google.type
         * @interface IDecimal
         * @property {string|null} [value] Decimal value
         */

        /**
         * Constructs a new Decimal.
         * @memberof google.type
         * @classdesc Represents a Decimal.
         * @implements IDecimal
         * @constructor
         * @param {google.type.IDecimal=} [properties] Properties to set
         */
        function Decimal(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Decimal value.
         * @member {string} value
         * @memberof google.type.Decimal
         * @instance
         */
        Decimal.prototype.value = "";

        /**
         * Creates a new Decimal instance using the specified properties.
         * @function create
         * @memberof google.type.Decimal
         * @static
         * @param {google.type.IDecimal=} [properties] Properties to set
         * @returns {google.type.Decimal} Decimal instance
         */
        Decimal.create = function create(properties) {
          return new Decimal(properties);
        };

        /**
         * Encodes the specified Decimal message. Does not implicitly {@link google.type.Decimal.verify|verify} messages.
         * @function encode
         * @memberof google.type.Decimal
         * @static
         * @param {google.type.IDecimal} message Decimal message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Decimal.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.value);
          return writer;
        };

        /**
         * Decodes a Decimal message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.Decimal
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.Decimal} Decimal
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Decimal.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.Decimal();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.value = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Decimal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.Decimal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.Decimal} Decimal
         */
        Decimal.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.Decimal) return object;
          var message = new $root.google.type.Decimal();
          if (object.value != null) message.value = String(object.value);
          return message;
        };

        /**
         * Creates a plain object from a Decimal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.Decimal
         * @static
         * @param {google.type.Decimal} message Decimal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Decimal.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) object.value = "";
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };

        /**
         * Converts this Decimal to JSON.
         * @function toJSON
         * @memberof google.type.Decimal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Decimal.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Decimal;
      })();

      type.Fraction = (function () {
        /**
         * Properties of a Fraction.
         * @memberof google.type
         * @interface IFraction
         * @property {number|Long|null} [numerator] Fraction numerator
         * @property {number|Long|null} [denominator] Fraction denominator
         */

        /**
         * Constructs a new Fraction.
         * @memberof google.type
         * @classdesc Represents a Fraction.
         * @implements IFraction
         * @constructor
         * @param {google.type.IFraction=} [properties] Properties to set
         */
        function Fraction(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Fraction numerator.
         * @member {number|Long} numerator
         * @memberof google.type.Fraction
         * @instance
         */
        Fraction.prototype.numerator = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * Fraction denominator.
         * @member {number|Long} denominator
         * @memberof google.type.Fraction
         * @instance
         */
        Fraction.prototype.denominator = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * Creates a new Fraction instance using the specified properties.
         * @function create
         * @memberof google.type.Fraction
         * @static
         * @param {google.type.IFraction=} [properties] Properties to set
         * @returns {google.type.Fraction} Fraction instance
         */
        Fraction.create = function create(properties) {
          return new Fraction(properties);
        };

        /**
         * Encodes the specified Fraction message. Does not implicitly {@link google.type.Fraction.verify|verify} messages.
         * @function encode
         * @memberof google.type.Fraction
         * @static
         * @param {google.type.IFraction} message Fraction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Fraction.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.numerator != null &&
            Object.hasOwnProperty.call(message, "numerator")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.numerator);
          if (
            message.denominator != null &&
            Object.hasOwnProperty.call(message, "denominator")
          )
            writer
              .uint32(/* id 2, wireType 0 =*/ 16)
              .int64(message.denominator);
          return writer;
        };

        /**
         * Decodes a Fraction message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.Fraction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.Fraction} Fraction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Fraction.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.Fraction();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.numerator = reader.int64();
                break;
              case 2:
                message.denominator = reader.int64();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Fraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.Fraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.Fraction} Fraction
         */
        Fraction.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.Fraction) return object;
          var message = new $root.google.type.Fraction();
          if (object.numerator != null)
            if ($util.Long)
              (message.numerator = $util.Long.fromValue(
                object.numerator
              )).unsigned = false;
            else if (typeof object.numerator === "string")
              message.numerator = parseInt(object.numerator, 10);
            else if (typeof object.numerator === "number")
              message.numerator = object.numerator;
            else if (typeof object.numerator === "object")
              message.numerator = new $util.LongBits(
                object.numerator.low >>> 0,
                object.numerator.high >>> 0
              ).toNumber();
          if (object.denominator != null)
            if ($util.Long)
              (message.denominator = $util.Long.fromValue(
                object.denominator
              )).unsigned = false;
            else if (typeof object.denominator === "string")
              message.denominator = parseInt(object.denominator, 10);
            else if (typeof object.denominator === "number")
              message.denominator = object.denominator;
            else if (typeof object.denominator === "object")
              message.denominator = new $util.LongBits(
                object.denominator.low >>> 0,
                object.denominator.high >>> 0
              ).toNumber();
          return message;
        };

        /**
         * Creates a plain object from a Fraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.Fraction
         * @static
         * @param {google.type.Fraction} message Fraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Fraction.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.numerator =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.numerator = options.longs === String ? "0" : 0;
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.denominator =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.denominator = options.longs === String ? "0" : 0;
          }
          if (message.numerator != null && message.hasOwnProperty("numerator"))
            if (typeof message.numerator === "number")
              object.numerator =
                options.longs === String
                  ? String(message.numerator)
                  : message.numerator;
            else
              object.numerator =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.numerator)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.numerator.low >>> 0,
                      message.numerator.high >>> 0
                    ).toNumber()
                  : message.numerator;
          if (
            message.denominator != null &&
            message.hasOwnProperty("denominator")
          )
            if (typeof message.denominator === "number")
              object.denominator =
                options.longs === String
                  ? String(message.denominator)
                  : message.denominator;
            else
              object.denominator =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.denominator)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.denominator.low >>> 0,
                      message.denominator.high >>> 0
                    ).toNumber()
                  : message.denominator;
          return object;
        };

        /**
         * Converts this Fraction to JSON.
         * @function toJSON
         * @memberof google.type.Fraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Fraction.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Fraction;
      })();

      type.LatLng = (function () {
        /**
         * Properties of a LatLng.
         * @memberof google.type
         * @interface ILatLng
         * @property {number|null} [latitude] LatLng latitude
         * @property {number|null} [longitude] LatLng longitude
         */

        /**
         * Constructs a new LatLng.
         * @memberof google.type
         * @classdesc Represents a LatLng.
         * @implements ILatLng
         * @constructor
         * @param {google.type.ILatLng=} [properties] Properties to set
         */
        function LatLng(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * LatLng latitude.
         * @member {number} latitude
         * @memberof google.type.LatLng
         * @instance
         */
        LatLng.prototype.latitude = 0;

        /**
         * LatLng longitude.
         * @member {number} longitude
         * @memberof google.type.LatLng
         * @instance
         */
        LatLng.prototype.longitude = 0;

        /**
         * Creates a new LatLng instance using the specified properties.
         * @function create
         * @memberof google.type.LatLng
         * @static
         * @param {google.type.ILatLng=} [properties] Properties to set
         * @returns {google.type.LatLng} LatLng instance
         */
        LatLng.create = function create(properties) {
          return new LatLng(properties);
        };

        /**
         * Encodes the specified LatLng message. Does not implicitly {@link google.type.LatLng.verify|verify} messages.
         * @function encode
         * @memberof google.type.LatLng
         * @static
         * @param {google.type.ILatLng} message LatLng message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LatLng.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.latitude != null &&
            Object.hasOwnProperty.call(message, "latitude")
          )
            writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.latitude);
          if (
            message.longitude != null &&
            Object.hasOwnProperty.call(message, "longitude")
          )
            writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.longitude);
          return writer;
        };

        /**
         * Decodes a LatLng message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.LatLng
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.LatLng} LatLng
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LatLng.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.LatLng();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.latitude = reader.double();
                break;
              case 2:
                message.longitude = reader.double();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a LatLng message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.LatLng
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.LatLng} LatLng
         */
        LatLng.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.LatLng) return object;
          var message = new $root.google.type.LatLng();
          if (object.latitude != null)
            message.latitude = Number(object.latitude);
          if (object.longitude != null)
            message.longitude = Number(object.longitude);
          return message;
        };

        /**
         * Creates a plain object from a LatLng message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.LatLng
         * @static
         * @param {google.type.LatLng} message LatLng
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LatLng.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.latitude = 0;
            object.longitude = 0;
          }
          if (message.latitude != null && message.hasOwnProperty("latitude"))
            object.latitude =
              options.json && !isFinite(message.latitude)
                ? String(message.latitude)
                : message.latitude;
          if (message.longitude != null && message.hasOwnProperty("longitude"))
            object.longitude =
              options.json && !isFinite(message.longitude)
                ? String(message.longitude)
                : message.longitude;
          return object;
        };

        /**
         * Converts this LatLng to JSON.
         * @function toJSON
         * @memberof google.type.LatLng
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LatLng.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LatLng;
      })();

      type.LocalizedText = (function () {
        /**
         * Properties of a LocalizedText.
         * @memberof google.type
         * @interface ILocalizedText
         * @property {string|null} [text] LocalizedText text
         * @property {string|null} [languageCode] LocalizedText languageCode
         */

        /**
         * Constructs a new LocalizedText.
         * @memberof google.type
         * @classdesc Represents a LocalizedText.
         * @implements ILocalizedText
         * @constructor
         * @param {google.type.ILocalizedText=} [properties] Properties to set
         */
        function LocalizedText(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * LocalizedText text.
         * @member {string} text
         * @memberof google.type.LocalizedText
         * @instance
         */
        LocalizedText.prototype.text = "";

        /**
         * LocalizedText languageCode.
         * @member {string} languageCode
         * @memberof google.type.LocalizedText
         * @instance
         */
        LocalizedText.prototype.languageCode = "";

        /**
         * Creates a new LocalizedText instance using the specified properties.
         * @function create
         * @memberof google.type.LocalizedText
         * @static
         * @param {google.type.ILocalizedText=} [properties] Properties to set
         * @returns {google.type.LocalizedText} LocalizedText instance
         */
        LocalizedText.create = function create(properties) {
          return new LocalizedText(properties);
        };

        /**
         * Encodes the specified LocalizedText message. Does not implicitly {@link google.type.LocalizedText.verify|verify} messages.
         * @function encode
         * @memberof google.type.LocalizedText
         * @static
         * @param {google.type.ILocalizedText} message LocalizedText message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LocalizedText.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.text != null &&
            Object.hasOwnProperty.call(message, "text")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.text);
          if (
            message.languageCode != null &&
            Object.hasOwnProperty.call(message, "languageCode")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.languageCode);
          return writer;
        };

        /**
         * Decodes a LocalizedText message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.LocalizedText
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.LocalizedText} LocalizedText
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LocalizedText.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.LocalizedText();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.text = reader.string();
                break;
              case 2:
                message.languageCode = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a LocalizedText message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.LocalizedText
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.LocalizedText} LocalizedText
         */
        LocalizedText.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.LocalizedText) return object;
          var message = new $root.google.type.LocalizedText();
          if (object.text != null) message.text = String(object.text);
          if (object.languageCode != null)
            message.languageCode = String(object.languageCode);
          return message;
        };

        /**
         * Creates a plain object from a LocalizedText message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.LocalizedText
         * @static
         * @param {google.type.LocalizedText} message LocalizedText
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LocalizedText.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.text = "";
            object.languageCode = "";
          }
          if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
          if (
            message.languageCode != null &&
            message.hasOwnProperty("languageCode")
          )
            object.languageCode = message.languageCode;
          return object;
        };

        /**
         * Converts this LocalizedText to JSON.
         * @function toJSON
         * @memberof google.type.LocalizedText
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LocalizedText.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LocalizedText;
      })();

      type.Money = (function () {
        /**
         * Properties of a Money.
         * @memberof google.type
         * @interface IMoney
         * @property {string|null} [currencyCode] Money currencyCode
         * @property {number|Long|null} [units] Money units
         * @property {number|null} [nanos] Money nanos
         */

        /**
         * Constructs a new Money.
         * @memberof google.type
         * @classdesc Represents a Money.
         * @implements IMoney
         * @constructor
         * @param {google.type.IMoney=} [properties] Properties to set
         */
        function Money(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Money currencyCode.
         * @member {string} currencyCode
         * @memberof google.type.Money
         * @instance
         */
        Money.prototype.currencyCode = "";

        /**
         * Money units.
         * @member {number|Long} units
         * @memberof google.type.Money
         * @instance
         */
        Money.prototype.units = $util.Long
          ? $util.Long.fromBits(0, 0, false)
          : 0;

        /**
         * Money nanos.
         * @member {number} nanos
         * @memberof google.type.Money
         * @instance
         */
        Money.prototype.nanos = 0;

        /**
         * Creates a new Money instance using the specified properties.
         * @function create
         * @memberof google.type.Money
         * @static
         * @param {google.type.IMoney=} [properties] Properties to set
         * @returns {google.type.Money} Money instance
         */
        Money.create = function create(properties) {
          return new Money(properties);
        };

        /**
         * Encodes the specified Money message. Does not implicitly {@link google.type.Money.verify|verify} messages.
         * @function encode
         * @memberof google.type.Money
         * @static
         * @param {google.type.IMoney} message Money message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Money.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.currencyCode != null &&
            Object.hasOwnProperty.call(message, "currencyCode")
          )
            writer
              .uint32(/* id 1, wireType 2 =*/ 10)
              .string(message.currencyCode);
          if (
            message.units != null &&
            Object.hasOwnProperty.call(message, "units")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.units);
          if (
            message.nanos != null &&
            Object.hasOwnProperty.call(message, "nanos")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.nanos);
          return writer;
        };

        /**
         * Decodes a Money message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.Money
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.Money} Money
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Money.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.Money();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.currencyCode = reader.string();
                break;
              case 2:
                message.units = reader.int64();
                break;
              case 3:
                message.nanos = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a Money message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.Money
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.Money} Money
         */
        Money.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.Money) return object;
          var message = new $root.google.type.Money();
          if (object.currencyCode != null)
            message.currencyCode = String(object.currencyCode);
          if (object.units != null)
            if ($util.Long)
              (message.units = $util.Long.fromValue(
                object.units
              )).unsigned = false;
            else if (typeof object.units === "string")
              message.units = parseInt(object.units, 10);
            else if (typeof object.units === "number")
              message.units = object.units;
            else if (typeof object.units === "object")
              message.units = new $util.LongBits(
                object.units.low >>> 0,
                object.units.high >>> 0
              ).toNumber();
          if (object.nanos != null) message.nanos = object.nanos | 0;
          return message;
        };

        /**
         * Creates a plain object from a Money message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.Money
         * @static
         * @param {google.type.Money} message Money
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Money.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.currencyCode = "";
            if ($util.Long) {
              var long = new $util.Long(0, 0, false);
              object.units =
                options.longs === String
                  ? long.toString()
                  : options.longs === Number
                  ? long.toNumber()
                  : long;
            } else object.units = options.longs === String ? "0" : 0;
            object.nanos = 0;
          }
          if (
            message.currencyCode != null &&
            message.hasOwnProperty("currencyCode")
          )
            object.currencyCode = message.currencyCode;
          if (message.units != null && message.hasOwnProperty("units"))
            if (typeof message.units === "number")
              object.units =
                options.longs === String
                  ? String(message.units)
                  : message.units;
            else
              object.units =
                options.longs === String
                  ? $util.Long.prototype.toString.call(message.units)
                  : options.longs === Number
                  ? new $util.LongBits(
                      message.units.low >>> 0,
                      message.units.high >>> 0
                    ).toNumber()
                  : message.units;
          if (message.nanos != null && message.hasOwnProperty("nanos"))
            object.nanos = message.nanos;
          return object;
        };

        /**
         * Converts this Money to JSON.
         * @function toJSON
         * @memberof google.type.Money
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Money.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Money;
      })();

      type.PostalAddress = (function () {
        /**
         * Properties of a PostalAddress.
         * @memberof google.type
         * @interface IPostalAddress
         * @property {number|null} [revision] PostalAddress revision
         * @property {string|null} [regionCode] PostalAddress regionCode
         * @property {string|null} [languageCode] PostalAddress languageCode
         * @property {string|null} [postalCode] PostalAddress postalCode
         * @property {string|null} [sortingCode] PostalAddress sortingCode
         * @property {string|null} [administrativeArea] PostalAddress administrativeArea
         * @property {string|null} [locality] PostalAddress locality
         * @property {string|null} [sublocality] PostalAddress sublocality
         * @property {Array.<string>|null} [addressLines] PostalAddress addressLines
         * @property {Array.<string>|null} [recipients] PostalAddress recipients
         * @property {string|null} [organization] PostalAddress organization
         */

        /**
         * Constructs a new PostalAddress.
         * @memberof google.type
         * @classdesc Represents a PostalAddress.
         * @implements IPostalAddress
         * @constructor
         * @param {google.type.IPostalAddress=} [properties] Properties to set
         */
        function PostalAddress(properties) {
          this.addressLines = [];
          this.recipients = [];
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * PostalAddress revision.
         * @member {number} revision
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.revision = 0;

        /**
         * PostalAddress regionCode.
         * @member {string} regionCode
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.regionCode = "";

        /**
         * PostalAddress languageCode.
         * @member {string} languageCode
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.languageCode = "";

        /**
         * PostalAddress postalCode.
         * @member {string} postalCode
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.postalCode = "";

        /**
         * PostalAddress sortingCode.
         * @member {string} sortingCode
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.sortingCode = "";

        /**
         * PostalAddress administrativeArea.
         * @member {string} administrativeArea
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.administrativeArea = "";

        /**
         * PostalAddress locality.
         * @member {string} locality
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.locality = "";

        /**
         * PostalAddress sublocality.
         * @member {string} sublocality
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.sublocality = "";

        /**
         * PostalAddress addressLines.
         * @member {Array.<string>} addressLines
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.addressLines = $util.emptyArray;

        /**
         * PostalAddress recipients.
         * @member {Array.<string>} recipients
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.recipients = $util.emptyArray;

        /**
         * PostalAddress organization.
         * @member {string} organization
         * @memberof google.type.PostalAddress
         * @instance
         */
        PostalAddress.prototype.organization = "";

        /**
         * Creates a new PostalAddress instance using the specified properties.
         * @function create
         * @memberof google.type.PostalAddress
         * @static
         * @param {google.type.IPostalAddress=} [properties] Properties to set
         * @returns {google.type.PostalAddress} PostalAddress instance
         */
        PostalAddress.create = function create(properties) {
          return new PostalAddress(properties);
        };

        /**
         * Encodes the specified PostalAddress message. Does not implicitly {@link google.type.PostalAddress.verify|verify} messages.
         * @function encode
         * @memberof google.type.PostalAddress
         * @static
         * @param {google.type.IPostalAddress} message PostalAddress message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostalAddress.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.revision != null &&
            Object.hasOwnProperty.call(message, "revision")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.revision);
          if (
            message.regionCode != null &&
            Object.hasOwnProperty.call(message, "regionCode")
          )
            writer
              .uint32(/* id 2, wireType 2 =*/ 18)
              .string(message.regionCode);
          if (
            message.languageCode != null &&
            Object.hasOwnProperty.call(message, "languageCode")
          )
            writer
              .uint32(/* id 3, wireType 2 =*/ 26)
              .string(message.languageCode);
          if (
            message.postalCode != null &&
            Object.hasOwnProperty.call(message, "postalCode")
          )
            writer
              .uint32(/* id 4, wireType 2 =*/ 34)
              .string(message.postalCode);
          if (
            message.sortingCode != null &&
            Object.hasOwnProperty.call(message, "sortingCode")
          )
            writer
              .uint32(/* id 5, wireType 2 =*/ 42)
              .string(message.sortingCode);
          if (
            message.administrativeArea != null &&
            Object.hasOwnProperty.call(message, "administrativeArea")
          )
            writer
              .uint32(/* id 6, wireType 2 =*/ 50)
              .string(message.administrativeArea);
          if (
            message.locality != null &&
            Object.hasOwnProperty.call(message, "locality")
          )
            writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.locality);
          if (
            message.sublocality != null &&
            Object.hasOwnProperty.call(message, "sublocality")
          )
            writer
              .uint32(/* id 8, wireType 2 =*/ 66)
              .string(message.sublocality);
          if (message.addressLines != null && message.addressLines.length)
            for (var i = 0; i < message.addressLines.length; ++i)
              writer
                .uint32(/* id 9, wireType 2 =*/ 74)
                .string(message.addressLines[i]);
          if (message.recipients != null && message.recipients.length)
            for (var i = 0; i < message.recipients.length; ++i)
              writer
                .uint32(/* id 10, wireType 2 =*/ 82)
                .string(message.recipients[i]);
          if (
            message.organization != null &&
            Object.hasOwnProperty.call(message, "organization")
          )
            writer
              .uint32(/* id 11, wireType 2 =*/ 90)
              .string(message.organization);
          return writer;
        };

        /**
         * Decodes a PostalAddress message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.PostalAddress
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.PostalAddress} PostalAddress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostalAddress.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.PostalAddress();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.revision = reader.int32();
                break;
              case 2:
                message.regionCode = reader.string();
                break;
              case 3:
                message.languageCode = reader.string();
                break;
              case 4:
                message.postalCode = reader.string();
                break;
              case 5:
                message.sortingCode = reader.string();
                break;
              case 6:
                message.administrativeArea = reader.string();
                break;
              case 7:
                message.locality = reader.string();
                break;
              case 8:
                message.sublocality = reader.string();
                break;
              case 9:
                if (!(message.addressLines && message.addressLines.length))
                  message.addressLines = [];
                message.addressLines.push(reader.string());
                break;
              case 10:
                if (!(message.recipients && message.recipients.length))
                  message.recipients = [];
                message.recipients.push(reader.string());
                break;
              case 11:
                message.organization = reader.string();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a PostalAddress message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.PostalAddress
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.PostalAddress} PostalAddress
         */
        PostalAddress.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.PostalAddress) return object;
          var message = new $root.google.type.PostalAddress();
          if (object.revision != null) message.revision = object.revision | 0;
          if (object.regionCode != null)
            message.regionCode = String(object.regionCode);
          if (object.languageCode != null)
            message.languageCode = String(object.languageCode);
          if (object.postalCode != null)
            message.postalCode = String(object.postalCode);
          if (object.sortingCode != null)
            message.sortingCode = String(object.sortingCode);
          if (object.administrativeArea != null)
            message.administrativeArea = String(object.administrativeArea);
          if (object.locality != null)
            message.locality = String(object.locality);
          if (object.sublocality != null)
            message.sublocality = String(object.sublocality);
          if (object.addressLines) {
            if (!Array.isArray(object.addressLines))
              throw TypeError(
                ".google.type.PostalAddress.addressLines: array expected"
              );
            message.addressLines = [];
            for (var i = 0; i < object.addressLines.length; ++i)
              message.addressLines[i] = String(object.addressLines[i]);
          }
          if (object.recipients) {
            if (!Array.isArray(object.recipients))
              throw TypeError(
                ".google.type.PostalAddress.recipients: array expected"
              );
            message.recipients = [];
            for (var i = 0; i < object.recipients.length; ++i)
              message.recipients[i] = String(object.recipients[i]);
          }
          if (object.organization != null)
            message.organization = String(object.organization);
          return message;
        };

        /**
         * Creates a plain object from a PostalAddress message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.PostalAddress
         * @static
         * @param {google.type.PostalAddress} message PostalAddress
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PostalAddress.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.arrays || options.defaults) {
            object.addressLines = [];
            object.recipients = [];
          }
          if (options.defaults) {
            object.revision = 0;
            object.regionCode = "";
            object.languageCode = "";
            object.postalCode = "";
            object.sortingCode = "";
            object.administrativeArea = "";
            object.locality = "";
            object.sublocality = "";
            object.organization = "";
          }
          if (message.revision != null && message.hasOwnProperty("revision"))
            object.revision = message.revision;
          if (
            message.regionCode != null &&
            message.hasOwnProperty("regionCode")
          )
            object.regionCode = message.regionCode;
          if (
            message.languageCode != null &&
            message.hasOwnProperty("languageCode")
          )
            object.languageCode = message.languageCode;
          if (
            message.postalCode != null &&
            message.hasOwnProperty("postalCode")
          )
            object.postalCode = message.postalCode;
          if (
            message.sortingCode != null &&
            message.hasOwnProperty("sortingCode")
          )
            object.sortingCode = message.sortingCode;
          if (
            message.administrativeArea != null &&
            message.hasOwnProperty("administrativeArea")
          )
            object.administrativeArea = message.administrativeArea;
          if (message.locality != null && message.hasOwnProperty("locality"))
            object.locality = message.locality;
          if (
            message.sublocality != null &&
            message.hasOwnProperty("sublocality")
          )
            object.sublocality = message.sublocality;
          if (message.addressLines && message.addressLines.length) {
            object.addressLines = [];
            for (var j = 0; j < message.addressLines.length; ++j)
              object.addressLines[j] = message.addressLines[j];
          }
          if (message.recipients && message.recipients.length) {
            object.recipients = [];
            for (var j = 0; j < message.recipients.length; ++j)
              object.recipients[j] = message.recipients[j];
          }
          if (
            message.organization != null &&
            message.hasOwnProperty("organization")
          )
            object.organization = message.organization;
          return object;
        };

        /**
         * Converts this PostalAddress to JSON.
         * @function toJSON
         * @memberof google.type.PostalAddress
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PostalAddress.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PostalAddress;
      })();

      type.TimeOfDay = (function () {
        /**
         * Properties of a TimeOfDay.
         * @memberof google.type
         * @interface ITimeOfDay
         * @property {number|null} [hours] TimeOfDay hours
         * @property {number|null} [minutes] TimeOfDay minutes
         * @property {number|null} [seconds] TimeOfDay seconds
         * @property {number|null} [nanos] TimeOfDay nanos
         */

        /**
         * Constructs a new TimeOfDay.
         * @memberof google.type
         * @classdesc Represents a TimeOfDay.
         * @implements ITimeOfDay
         * @constructor
         * @param {google.type.ITimeOfDay=} [properties] Properties to set
         */
        function TimeOfDay(properties) {
          if (properties)
            for (
              var keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeOfDay hours.
         * @member {number} hours
         * @memberof google.type.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.hours = 0;

        /**
         * TimeOfDay minutes.
         * @member {number} minutes
         * @memberof google.type.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.minutes = 0;

        /**
         * TimeOfDay seconds.
         * @member {number} seconds
         * @memberof google.type.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.seconds = 0;

        /**
         * TimeOfDay nanos.
         * @member {number} nanos
         * @memberof google.type.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.nanos = 0;

        /**
         * Creates a new TimeOfDay instance using the specified properties.
         * @function create
         * @memberof google.type.TimeOfDay
         * @static
         * @param {google.type.ITimeOfDay=} [properties] Properties to set
         * @returns {google.type.TimeOfDay} TimeOfDay instance
         */
        TimeOfDay.create = function create(properties) {
          return new TimeOfDay(properties);
        };

        /**
         * Encodes the specified TimeOfDay message. Does not implicitly {@link google.type.TimeOfDay.verify|verify} messages.
         * @function encode
         * @memberof google.type.TimeOfDay
         * @static
         * @param {google.type.ITimeOfDay} message TimeOfDay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeOfDay.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.hours != null &&
            Object.hasOwnProperty.call(message, "hours")
          )
            writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hours);
          if (
            message.minutes != null &&
            Object.hasOwnProperty.call(message, "minutes")
          )
            writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.minutes);
          if (
            message.seconds != null &&
            Object.hasOwnProperty.call(message, "seconds")
          )
            writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.seconds);
          if (
            message.nanos != null &&
            Object.hasOwnProperty.call(message, "nanos")
          )
            writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.nanos);
          return writer;
        };

        /**
         * Decodes a TimeOfDay message from the specified reader or buffer.
         * @function decode
         * @memberof google.type.TimeOfDay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {google.type.TimeOfDay} TimeOfDay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeOfDay.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          var end = length === undefined ? reader.len : reader.pos + length,
            message = new $root.google.type.TimeOfDay();
          while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
              case 1:
                message.hours = reader.int32();
                break;
              case 2:
                message.minutes = reader.int32();
                break;
              case 3:
                message.seconds = reader.int32();
                break;
              case 4:
                message.nanos = reader.int32();
                break;
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        /**
         * Creates a TimeOfDay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof google.type.TimeOfDay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {google.type.TimeOfDay} TimeOfDay
         */
        TimeOfDay.fromObject = function fromObject(object) {
          if (object instanceof $root.google.type.TimeOfDay) return object;
          var message = new $root.google.type.TimeOfDay();
          if (object.hours != null) message.hours = object.hours | 0;
          if (object.minutes != null) message.minutes = object.minutes | 0;
          if (object.seconds != null) message.seconds = object.seconds | 0;
          if (object.nanos != null) message.nanos = object.nanos | 0;
          return message;
        };

        /**
         * Creates a plain object from a TimeOfDay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof google.type.TimeOfDay
         * @static
         * @param {google.type.TimeOfDay} message TimeOfDay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeOfDay.toObject = function toObject(message, options) {
          if (!options) options = {};
          var object = {};
          if (options.defaults) {
            object.hours = 0;
            object.minutes = 0;
            object.seconds = 0;
            object.nanos = 0;
          }
          if (message.hours != null && message.hasOwnProperty("hours"))
            object.hours = message.hours;
          if (message.minutes != null && message.hasOwnProperty("minutes"))
            object.minutes = message.minutes;
          if (message.seconds != null && message.hasOwnProperty("seconds"))
            object.seconds = message.seconds;
          if (message.nanos != null && message.hasOwnProperty("nanos"))
            object.nanos = message.nanos;
          return object;
        };

        /**
         * Converts this TimeOfDay to JSON.
         * @function toJSON
         * @memberof google.type.TimeOfDay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeOfDay.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeOfDay;
      })();

      return type;
    })();

    return google;
  })();

  return $root;
});
